import "./tokens.css"; // s144 D fase 1 — tokens del sistema de diseño (D-62) + bloque prefers-reduced-motion
// s183 — hoja del catálogo. Primera pantalla del repo con className: los estilos
// inline de React no expresan media queries, :hover ni grillas que respondan al
// ancho, y el artboard del catálogo necesita las tres. El resto de App.jsx sigue
// inline y no se toca. Ver el encabezado de catalogo.css.
import "./catalogo.css";
import "./tarjeta.css";  // s196 — la tarjeta de oferta: la foto es la tarjeta, un solo titular, fila horizontal en teléfono
import "./merchant.css";
import QRCode from "qrcode";   // s215 · el código del cupón también en QR (Ali)
import "./encuadre.css";  // s200-D1 — encuadrar la foto antes de subirla: una sola proporcion para los cinco marcos
import "./nav.css";   // s183 — la navegación en sus dos formas (arriba en escritorio, abajo en teléfono)
import "./ficha.css";  // s183 — la ficha reparte contenido entre columna y riel (grid-areas)
import "./comercio.css";  // s183 — la pagina publica del comercio deja de ser un documento y pasa a ser vidriera
import "./directorio.css";  // s204 — /merchants: la foto del local es la tarjeta, con sus beneficios y guardar
import "./vitrina.css";   // s204 — /beneficios: la vitrina del socio sin plan, con tarjetas del catalogo
import "./pie.css";      // s183 — el pie: ninguna pantalla tenia uno
import "./cupones.css";
import "./alta.css";   // s185 — el alta de oferta: la unica pantalla donde el comercio ESCRIBE
import "./beta.css";   // s195 — la vitrina beta: un link con token, sin login, «así se vería tu negocio»
import "./propuestas.css"; // s189-C — las propuestas del asesor: la unica pantalla que quedo fuera de tokens v3
import "./fuentes.css";    // s189-D — «tu negocio»: lo que el comercio nos dice antes de que la IA lea
import "./tarjeta-socio.css";
import "./mi-lista.css";   // s202 — «Mi lista»: lo que el socio guardo (favoritos-miembro)  // s202 — la tarjeta de socio arriba de «Mi cuenta» (dos tonos + brillo, elegida por Ali)
import "./influencer.css";  // s218 — el panel de la influencer (prototipo /aliados/demo)
import InfluencerDemo from "./InfluencerDemo";
import AliadoPanel from "./AliadoPanel";   // s220 · /aliados real
import "./auth.css";    // s184 — la puerta: login, alta y recuperar clave  // s183 — Mis Cupones: el titulo dejaba de alinear con la lista
// s186 - el canal influencer: el codigo que viaja de la landing a la puerta, y el
// enganche que devuelve apply_access_code. Modulo aparte porque es estado que
// cruza pantallas y tiene una regla propia (la firma por usuario). Ver enganche.js.
import {
  normalizarCodigo,
  guardarCodigoInvitacion,
  leerCodigoInvitacion,
  limpiarCodigoInvitacion,
  guardarEngancheDesdeRespuesta,
  leerEnganche,
  limpiarEnganche,
  elegirPlanEnganche,
  MESES_ENGANCHE,
} from "./enganche";
import { useState, useEffect, useCallback, useRef, createContext, useContext, useSyncExternalStore } from "react";
import Cropper from "react-easy-crop";   // s200-D1 · MIT, 6.2.3, peer react >=16.4 — tacto, pellizco y rueda ya resueltos
import { Routes, Route, useNavigate, useParams, Navigate, Link, useSearchParams, useLocation } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, CardElement, ExpressCheckoutElement, useStripe, useElements } from "@stripe/react-stripe-js";

import {
  auth,
  loginUser,
  socialLogin,
  signupUser,
  getOffers,
  getOfferById,
  getOfertasSinConfirmar,
  getOfferByIdConSesion,
  getMyOfferById,
  getMerchantById,
  getMerchantOffers,
  getPublicMerchants,
  getMyCoupons,
  guardarItem,
  cambiarClave,
  misGuardados,
  API_BASE,
  BUBBLE_VERSION,
  getTechoDeCatalogo,
  getPagoDeMembresia,
  GALERIA_HABILITADA,
  // s223 · ATERRIZAJE_HABILITADO y FUENTES_HABILITADA ya no se importan: solo decidían a dónde iba el alta, que ahora
  // termina en el wizard de la primera oferta. Siguen en api.js (las rutas /merchant/bienvenida y /tu-negocio existen).
  DESCRIPCION_IA_HABILITADA,
  generateMerchantDescription,
  agregarFotoComercio,
  quitarFotoComercio,
  setGalleryCover,
  activateCoupon,
  redeemCoupon,
  setOfferStatus,
  updateOffer,
  suggestOfferImprovements,
  getOfferAdvice,
  ingestOfferIdeas,
  guardarWebSiFalta, campoDeLaWeb, serviciosDeIa, servicioEnTexto, momentoDeServicio, esperarDatosWeb,   // s255 · alta-datos-de-la-web
  guardarTextoNegocio,   // s241 · T1/T4: «No tengo web» y el texto del negocio en el alta
  advisorOfferToForm,
  mencionaDisponibilidad,
  getUserProfile,
  updateUserProfile,
  applyAccessCode,
  createConsumerWaitlist,
  deletePaymentMethod,
  getMerchantStats,
  getMerchantRedemptions,   // s218 · «Mi actividad» v3: canjes con piso, cuenta y quién validó
  getMerchantProfile,
  updateMerchantProfile,
  updateMerchantLogo,
  normalizeWebsiteUrl,
  getAdminStats,
  getPendingOffers,
  getAllOffers,
  getAllUsers,
  approveOffer,
  rejectOffer,
  adminSetOfferStatus,
  setOfferFeatured,
  blockUser,
  unblockUser,
  setUserRole,
  promoteToVip,
  createAccessCode,
  getMyAccessCodes,
  setOutcome,
  getAllAccessCodes,
  getInfluencerStats,
  getAllMerchants,
  getAllOffersAdmin,   // s223 · el admin: todas las ofertas, paginadas
  approveMerchant,
  adminChargeMerchant,
  rejectMerchant,
  getAllCoupons,
  createPaymentIntent,
  createMembershipPaymentIntent,
  confirmMembershipPurchase,
  confirmFixedPricePurchase,
  signupMerchant,
  placesAutocomplete,
  placeDetails,
  placeUbicacion,   // s216 · el lote trae dirección y pin del mapa por place_id
  placePrecio,      // s217 · «Completar con Google»: rango y nivel de precio
  sinPais,          // s218 · la dirección de Google sin «, EE. UU.»
  placeRating,
  placeReviews,
  placesEnabled,
  MIN_CLAVE, esClaveRechazada,   // s252-D1
  getFee,
  getMembershipPlans,
  getDiscountCodes,
  createDiscountCode,
  deactivateDiscountCode,
  validateDiscountCode,
  computeMembershipPrice,
  getAssistantConfig,
  updateAssistantConfig,
  getAssistantScenarios,
  createAssistantScenario,
  updateAssistantScenario,
  getMarginProfiles,
  createMarginProfile,
  updateMarginProfile,
  MOCK_OFFERS,
  // s195 · vitrina beta (contrato provisional; ver el bloque VITRINA BETA de api.js)
  getBetaCatalog,
  inviteMerchant,
  seedMerchant,
  suggestSeedOffer, logosDeLaWeb, TEXTO_NEGOCIO_MAX, placeVistaParaOtto,      // s233 · pedido a Cowork (suggest_seed_offer): hasta que exista, responde WF_NOT_DEPLOYED
  adoptMerchant,
  operatorUpdateOffer,   // s213 · lote B+C
  operatorAddOffer,      // s217 · otra franja (export 114, S3)
  sendEmailOtp, verifyEmailOtp,   // s227-D1 · el correo del dueño (OTP)
  changeRegistrationEmail,        // s228 · cambiar el correo de registro por el de la empresa
  operatorLogCall, operatorDiscardMerchant, getCallLog,   // s218 · mini CRM (export 117)
  checkPlaceId,   // s219 · ¿el lugar de Google ya está en la base? (antes de llenar)
  PLAZOS_COOLDOWN,
  getSeededMerchants, getSignupsToVerify, getCatalogoPreapertura,   // s227 · preinauguración (export 139)   // s227 · lista-por-verificar (export 137)
  adminRemoveMerchantPhoto,
  operatorAddPhoto,      // s216 · deploy A (S6)
  operatorAddLogo, operatorSetBetaState,   // s216 · deploy D (export 113)
  inviteStaff, listStaff, removeStaff, getStaffMerchantName, getStaffMerchantOffers,   // s216 · Ola 2 (deploy B)
  getMerchantGallery,
  confirmOffer,
  BETA_FIXTURES,
  BETA_FIXTURE_TOKEN,
  // s200-D1 · el recorte y el tope de peso viven con las demas utilidades de imagen
  recortarImagen,
  FOTO_PESO_MAX,
  GALERIA_TOPE,
  leerGalleryPick,
  paramsGalleryPick,
  fotosDeLaOferta,
  // s222 · lote 2a · la ficha del comercio (save_merchant_ficha, export 127)
  guardarFicha, leerFicha, tieneMenu, urlMenu, MENU_PDF_PESO_MAX,
  leerContacto, guardarContacto, contactoDe, nombreDeUsuario,   // s226 · contacto-responsable-alta
  // s223 · 2b · el wizard de la primera oferta lee la ficha y el place_id en una sola lectura
  leerFichaYLugar, contarOfertasDelComercio,
} from "./api";
// s169: persistencia de propuestas del asesor. Vive en su propio módulo a propósito —
// el flujo de alta sin fricción (SPEC_s148 CABLE 2) va a leer/escribir desde otro lado.
import {
  withKeys,
  readAdvisorDraft,
  persistAdvisorDraft,
  mergeGenerations,
  MAX_SAVED_PROPOSALS,
} from "./advisorDraft";
// s189-D: de las fuentes a las propuestas. Vive afuera porque lo van a compartir dos
// pantallas — ver el encabezado del módulo.
import { construirContexto, pedirPropuestas } from "./asesorFuentes";

import ForgotPasswordPage from "./ForgotPasswordPage";

const STRIPE_PK = "pk_live_51QoS6G2Mm1DESaizgHeZzTmrNyw3ZByjLyoOND2Nw7Sky7afwGNDdVpcRKGMTpScyJZUvW4pys1fKrDyU8PxCjIl00qGIlkjLI";
const stripePromise = loadStripe(STRIPE_PK);

// ============================================
// 🪂 s175-D6 / s176-B — INTERRUPTORES DEL ASESOR DE OFERTAS (IA).
//
// Son DOS superficies distintas, con DOS workflows distintos y DOS parseos OPUESTOS.
// Hasta s176 un solo flag apagaba las dos, y eso costaba caro: la que funciona es la
// mejor funcion del producto, y se apagaba de rebote por culpa de la otra.
//
//   ADVISOR_ENABLED              -> carril rapido  (offer_advisor)
//   SUGGEST_IMPROVEMENTS_ENABLED -> "Sugerir mejoras" (suggest_offer_improvements)
//
// Con un flag apagado su superficie NO se renderiza: nada de botones deshabilitados con
// cartel de "no disponible" — el comercio no tiene por que enterarse de que existe una
// funcion rota. El alta de oferta MANUAL queda intacta y completa en los dos casos.
//
// Por que constantes y no AssistantConfig.active: ese campo cuelga del registro que
// hoy se sospecha duplicado (hipotesis GENERATION_LIMIT), y un paracaidas que lee el
// registro equivocado falla justo el dia que se abre. Esto no toca red ni Bubble.
// Pendiente post-piloto: cablear AssistantConfig.active para encender/apagar sin deploy,
// recien despues del datafix de duplicados y del constraint en el Search.
//
// NO afectan la pantalla de admin del asesor (CRUD de AssistantConfig, margenes y
// escenarios): sirve para entrenarlo mientras esta oculto.
// ============================================

// 🟢 CARRIL RAPIDO — entry choice ("como quieres empezar?") -> wizard 3-4 preguntas o
// URL/menu -> offer_advisor -> tarjetas de propuestas -> borrador persistente (s169).
//
// FUNCIONA. Medido en s176: el `last_advisor_json` del fixture trae 12 ofertas completas
// y bien formadas, generadas con UNA sola llamada (ai_generations_used = 1). El WF
// devuelve `advisor_json` como TEXTO CRUDO del modelo y el parseo lo hace React
// (parseAdvisorRaw en api.js), que es por lo que este carril no sufre el bug del otro.
//
// Este flag ya NO gobierna "Sugerir mejoras" — desde s176 esa superficie tiene el suyo.
const ADVISOR_ENABLED = true;
// s241 · `generar-con-ia-12-propuestas-viejo` (red de seguridad, Ali): en `false` desaparece SOLO la opción «Generar con IA»
// de «¿Cómo quieres empezar?» (plantilla, en blanco y las propuestas ya guardadas siguen). Se apaga si el arreglo de
// `offer_advisor` en Bubble (thinking desactivado + Haiku con 4) no está verde en Live al publicar; se vuelve a prender
// cuando lo esté. Hoy: prendido.
const GENERAR_CON_IA = true;

// 🔴 "SUGERIR MEJORAS" — paso Detalles -> suggest_offer_improvements -> titulo,
// descripcion, destacados, que falta y consejos.
//
// APAGADO A PROPOSITO. El WF parsea el JSON DENTRO de Bubble con `split_by` +
// `specific_item` sobre los items 1-5, o sea lo trocea como si fuera una lista numerada.
// El modelo devuelve JSON, no una lista numerada, asi que el troceo no encuentra nada y
// los CINCO campos vuelven vacios. El comercio apretaba el boton y no pasaba nada.
//
// El arreglo es en Bubble, en ese step del workflow — NO en React. Este flag se
// enciende (pasa a true) el dia que ese step este arreglado y verificado, y hasta
// entonces el boton y su panel no se renderizan.
const SUGGEST_IMPROVEMENTS_ENABLED = false;

// ============================================
// s31/s143: error_code de create_coupon o create_payment_intent -> mensaje localizado
// (api.js tira un Error con .code cuando un guard rechaza la activación o el probe de cobro)
// ============================================
function activationErrorMessage(e, lang) {
  const en = lang === "en";
  const map = {
    VIP_MAX_ACTIVE_REACHED: en ? "You've reached your maximum active VIP coupons." : "Alcanzaste el máximo de cupones VIP activos.",
    PAYMENT_ALREADY_USED:   en ? "This payment was already used." : "Este pago ya fue utilizado.",
    COOLDOWN_ACTIVE:        en ? "You're in a waiting period for this merchant." : "Estás en período de espera para este comercio.",
    OFFER_LIMIT_REACHED:    en ? "This offer has no coupons left." : "Esta oferta ya no tiene cupones disponibles.",
    MEMBERSHIP_EXPIRED:     en ? "Your membership has expired. Renew it to keep activating coupons." : "Tu membresía venció. Renuévala para seguir activando cupones.",
    CLUB_CERRADO:           en ? "The club opens soon: we're not selling yet." : "El club abre pronto: todavía no estamos vendiendo.",
    PAYMENT_REQUIRED:       en ? "You've used your free activations. This coupon requires a payment to activate." : "Ya usaste tus activaciones gratis. Este cupón requiere pago para activarse.",
    PAYMENT_NOT_SUCCEEDED:  en ? "The payment didn't go through." : "El pago no se completó.",
    AMOUNT_MISMATCH:        en ? "The payment amount doesn't match this offer. Please try again." : "El monto del pago no coincide con esta oferta. Intenta de nuevo.",
    NO_FEE_REQUIRED:        en ? "No payment needed — try activating again." : "No se requiere pago — intenta activar de nuevo.",
    // s203-D6: salía crudo. El texto vive en PUERTA_SIN_PLAN (el día de la suscripción cambia ahí).
    SUBSCRIPTION_REQUIRED:  en ? PUERTA_SIN_PLAN.en : PUERTA_SIN_PLAN.es,
    // s203: el error lo agrega el deploy único (F4, create_coupon_and_cooldown); el texto va antes.
    ACTIVE_COUPON_EXISTS:   en ? "You already have an active coupon for this offer." : "Ya tienes un cupón activo de esta oferta.",
    // s216 · sala S10 (deploy C): una cuenta sin tier ni suscripción (empleado, dueño) no activa cupones.
    NOT_A_MEMBER:           en ? "This account isn't a membership, so it can't activate coupons." : "Esta cuenta no es una membresía, así que no puede activar cupones.",
  };
  return (e && e.code && map[e.code]) || (e && e.message) || (en ? "Error activating coupon" : "Error al activar");
}

// ============================================
// s203 (auditoría A3-11): errores de social_login -> mensaje. Llegaban crudos:
// ACCOUNT_BLOCKED viene en `error_code` (steps 3-4, export 88) y AUTH_INVALID en `error`
// (step 1), así que socialLogin los deja en e.code o en e.message. `usePassword` es el
// texto propio de cada pantalla (login y registro lo dicen distinto).
// ============================================
function googleErrorMessage(e, lang, usePassword) {
  const en = lang === "en";
  const es = (c) => e?.code === c || e?.message === c;
  if (es("USE_PASSWORD")) return usePassword;
  if (es("ACCOUNT_BLOCKED")) return en
    ? "This account is suspended. If you think it's a mistake, message us on WhatsApp."
    : "Esta cuenta está suspendida. Si crees que es un error, escríbenos por WhatsApp.";
  if (es("AUTH_INVALID")) return en
    ? "We couldn't verify your Google account. Try again, or sign in with your email and password."
    : "No pudimos verificar tu cuenta de Google. Intenta de nuevo, o entra con tu correo y contraseña.";
  return (e && e.message) || (en ? "Google sign-in error" : "Error al iniciar con Google");
}

// s204 · `login-comercio-error-de-bubble-en-ingles`: con correo o contraseña que no
// coinciden, /wf/login contesta 400 con el mensaje PROPIO de Bubble, en ingles («We didn't
// find an account with those login credentials»), y las dos puertas lo mostraban crudo en
// una pantalla en espanol. `loginUser` tambien tira «Credenciales incorrectas» si no llega
// token. Los dos casos dicen lo mismo; cualquier otro error pasa como estaba.
function loginErrorMessage(e, lang, fallback) {
  const en = lang === "en";
  const msg = String((e && e.message) || "");
  if (/login credentials|didn.t find an account|credenciales incorrectas/i.test(msg)) return en
    ? "That email and password don't match. Check them, or reset your password below."
    : "El correo y la contraseña no coinciden. Revísalos o recupera tu contraseña abajo.";
  if (/failed to fetch|networkerror/i.test(msg)) return en
    ? "We couldn't connect. Check your internet and try again."
    : "No pudimos conectarnos. Revisa tu internet e intenta de nuevo.";
  return msg || fallback;
}

// ============================================
// s176 FIX 1: error_code del asesor de ofertas -> mensaje localizado.
// Las tres superficies (suggest_offer_improvements, offer_advisor, ingest_offer_ideas)
// devuelven HTTP 200 + error_code; api.js lo deja en e.code. Antes TODAS caian al mismo
// texto generico y un cupo agotado se leia igual que "no podemos leer tu sitio".
// Codigo desconocido => generico + el codigo entre parentesis: el comercio entiende algo
// y la proxima prueba se autodiagnostica sin abrir la consola.
// ============================================
function advisorErrorMessage(e, lang) {
  const en = lang === "en";
  const map = {
    NOT_MERCHANT: en
      ? "Your merchant account isn't active yet. Once it's approved you'll be able to use the assistant."
      : "Tu cuenta de comercio todavía no está activa. Cuando se apruebe vas a poder usar el asistente.",
    NOT_APPROVED: en
      ? "Your account is still under review. The assistant turns on once it's approved."
      : "Tu cuenta sigue en revisión. El asistente se activa cuando se apruebe.",
    GENERATION_LIMIT: en
      ? "You've used all your AI generations. Write to us and we'll top them up."
      : "Ya usaste todas tus generaciones con IA. Escríbenos y te las reponemos.",
    QUOTA_EXCEEDED: en
      ? "You've used all your AI generations. Write to us and we'll top them up."
      : "Ya usaste todas tus generaciones con IA. Escríbenos y te las reponemos.",
    RATE_LIMITED: en
      ? "Too many requests in a row. Wait a minute and try again."
      : "Demasiadas solicitudes seguidas. Espera un minuto y vuelve a intentar.",
    INGEST_UNAVAILABLE: en
      ? "We can't read your site automatically yet — answer the quick questions below and we'll generate your offers."
      : "Todavía no podemos leer tu sitio automáticamente — responde las preguntas rápidas de abajo y generamos tus ofertas igual.",
    // s240: el corte a 50 s de ingestOfferIdeas. La lectura sigue en Bubble y queda guardada; no se ofrece «reintentar»
    // (cada intento paga Firecrawl + IA otra vez).
    INGEST_TIMEOUT: en
      ? "Reading your site is taking longer than usual. Answer the quick questions below and we'll generate your offers anyway."
      : "Leer tu sitio está tardando más de lo normal. Responde las preguntas rápidas de abajo y generamos tus ofertas igual.",
    // s241: el mismo corte en offer_advisor (sin URL). Sin «vuelve a intentar»: cada intento gasta una generación.
    ADVISOR_TIMEOUT: en
      ? "The advisor is taking longer than usual. You can build your offer with the steps below."
      : "El asesor está tardando más de lo normal. Puedes armar tu oferta con los pasos de abajo.",
    // s176 FIX 6: el WF contestó success:"yes" pero no salió ninguna oferta del parseo.
    // Sin este caso el comercio se quedaba mirando una pantalla en blanco (carril
    // preguntas) o la palabra "EMPTY" (carril URL) — el mismo síntoma mudo de siempre.
    ADVISOR_EMPTY: en
      ? "The advisor didn't return any suggestions this time. Try again — if it keeps happening, add a bit more detail about your business."
      : "El asesor no devolvió sugerencias esta vez. Vuelve a intentar — si se repite, agrega un poco más de detalle sobre tu negocio.",
    // s176 FIX 6: el scrape corrió y no encontró nada legible. Es el mismo callejón que
    // INGEST_UNAVAILABLE desde donde está parado el comercio, así que se le da la misma
    // salida — el wizard de preguntas — en vez de un "(código: SCRAPE_EMPTY)".
    // s240 · mensajes-codigos-ingest-v2 (textos de Cowork): los dos códigos nuevos de `ingest_offer_ideas` v2.1. En el
    // alta (W16) no se muestran: ahí todo fallo va en silencio.
    PAGE_MISMATCH: en
      ? "We read the link, but that page doesn't look like your business. Check it or paste another one: your website, your Booksy or your price list."
      : "Leímos el link, pero esa página no parece ser la de tu negocio. Revisa el link o pega otro: tu web, tu Booksy o tu lista de precios.",
    AI_FORMAT_ERROR: en
      ? "Your site was read, but we couldn't put the ideas together this time. Try again in a moment."
      : "Tu sitio quedó leído, pero no pudimos armar las ideas esta vez. Inténtalo de nuevo en un momento.",
    SCRAPE_EMPTY: en
      ? "We couldn't read anything usable from that link — answer the quick questions below and we'll generate your offers."
      : "No pudimos leer nada aprovechable de ese enlace — responde las preguntas rápidas de abajo y generamos tus ofertas igual.",
  };
  const code = e && e.code;
  if (code && map[code]) return map[code];
  const generico = en ? "We couldn't generate suggestions." : "No se pudieron generar sugerencias.";
  return code ? `${generico} (código: ${code})` : ((e && e.message) || generico);
}

// ============================================
// RESPONSIVE HOOK
// ============================================
// s182-A: cierre con Escape para modales SIN estado a medias.
// NO se usa en pago (Stripe / membresia), en la confirmacion de VIP, en el
// detalle de usuario (tiene campos editables) ni en el gate de activacion:
// ahi Escape descartaria algo que el usuario ya empezo o ya pago.
function useEscapeToClose(activo, alCerrar) {
  useEffect(() => {
    if (!activo) return;
    const alTeclear = (e) => { if (e.key === "Escape") alCerrar(); };
    window.addEventListener("keydown", alTeclear);
    return () => window.removeEventListener("keydown", alTeclear);
  }, [activo, alCerrar]);
}

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return isMobile;
}

// ============================================
// LANGUAGE CONTEXT
// ============================================

const LangContext = createContext("es");
const useLang = () => useContext(LangContext);

// s183 · el interruptor de idioma viaja en SU PROPIO contexto. LangContext queda
// intacto —useLang() sigue devolviendo el string y ningun llamador cambia.
// Expone un SETTER y no un toggle porque lo usan dos lugares con necesidades
// distintas: la franja alterna entre los dos idiomas, y Mi Cuenta elige uno
// concreto. Ese segundo caso importa: en telefono NO hay franja, asi que Mi Cuenta
// es el unico lugar donde se cambia el idioma — y hasta hoy ese selector guardaba
// `preferred_language` en el perfil SIN cambiar el idioma de la interfaz. Eran dos
// interruptores distintos para lo mismo.
const LangSetContext = createContext(() => {});
const useSetLang = () => useContext(LangSetContext);

// ============================================
// LOS CUPONES DEL MIEMBRO — una sola carga por sesión de app
// ============================================
// s183 · Nace porque DOS lugares necesitan lo mismo: Mis Cupones (la lista) y la
// franja superior (el ahorro acumulado). Sin esto, la franja —que se monta en las
// siete pantallas— haría su propio fetch en cada una.
//
// EL AHORRO se calcula sumando `benefit_value_usd` de los cupones `redeemed`, y NO
// se lee de `User.credits_redeemed_total`. Es deliberado, y la razón la dio Cowork:
// ese acumulado se escribe en un step de `redeem_coupon`, así que los canjes
// anteriores a ese step pueden no estar contados — la duda de «cobertura hacia
// atrás» de v182 sigue abierta. La suma canje por canje la esquiva: es la verdad
// del dato. (`get_user_savings` tampoco sirve: es admin-only, s182-D12.)
//
// ⚠️ `getMyCoupons` pide `limit=100` y no pagina: con más de 100 cupones la suma
// queda corta. Aceptable hoy — el miembro con más cupones tiene 2.
const CuponesContext = createContext({ cupones: [], cargando: true, ahorro: 0, techo: null, recargar: () => {} });
const useCupones = () => useContext(CuponesContext);

// s187 · QUIEN ESTA ADENTRO, COMO DATO DE REACT. `auth` vive en localStorage, que
// no es reactivo: por eso este proveedor cargaba UNA vez al montar y su estado
// sobrevivia al logout (el proveedor envuelve las rutas, asi que navegar a /login
// no lo desmonta). `auth.subscribe` avisa; `useSyncExternalStore` lo convierte en
// un valor de React que cambia con el login y con el logout, en la misma pestana
// y en las demas. Devuelve "" cuando no hay nadie.
function useSesion() {
  return useSyncExternalStore(auth.subscribe, auth.sessionKey, () => "");
}

function ProveedorCupones({ children }) {
  const sesion = useSesion();
  // s187 · LOS DATOS VIAJAN FIRMADOS CON SU DUENO — el mismo patron que
  // `enganche.js` (ver su encabezado). No alcanza con recargar al cambiar de
  // cuenta: entre que la sesion cambia y que la respuesta nueva llega hay un rato
  // en que el estado viejo sigue en memoria, y ese rato es exactamente la fuga.
  // Guardando de quien son los cupones, lo que no es de la sesion de ahora NO
  // EXISTE en el render, sin depender de que ningun efecto haya corrido todavia.
  const [datos, setDatos] = useState({ sesion: "", cupones: [] });
  const [cargandoCrudo, setCargando] = useState(true);
  // s184 · el techo viaja por el mismo proveedor que el ahorro: una sola lectura por
  // sesion para las siete pantallas donde vive la franja. HOY DEVUELVE null SIEMPRE
  // (`wallet_credits` esta vacio en los 4 planes y ademas fuera de la privacy rule),
  // asi que esto no dibuja nada hasta que Ali haga el datafix D17(a) + el tilde.
  const [techoDe, setTecho] = useState({ sesion: "", techo: null });

  const cargar = useCallback(async () => {
    if (!sesion) { setDatos({ sesion: "", cupones: [] }); setCargando(false); return; }
    setCargando(true);
    try { setDatos({ sesion, cupones: await getMyCoupons() }); }
    catch (e) { setDatos({ sesion, cupones: [] }); }   // sin cupones no hay franja de ahorro; nunca un error en pantalla
    finally { setCargando(false); }
  }, [sesion]);

  useEffect(() => { cargar(); }, [cargar]);

  useEffect(() => {
    let vivo = true;
    if (!sesion) { setTecho({ sesion: "", techo: null }); return; }
    getTechoDeCatalogo().then(t => { if (vivo) setTecho({ sesion, techo: t }); }).catch(() => {});
    return () => { vivo = false; };
  }, [sesion]);

  // LA FIRMA, aplicada en el render: si lo que hay en memoria no es de esta
  // sesion, para esta pantalla no hay nada. Vale para el logout (sesion "") y
  // para el cambio de cuenta (sesion distinta) sin esperar a ningun efecto.
  const cupones = datos.sesion === sesion ? datos.cupones : [];
  const techo = techoDe.sesion === sesion ? techoDe.techo : null;
  // Tener datos de OTRO no es "ya cargue": mientras la firma no coincida seguimos
  // cargando. Si no, Mis Cupones parpadea "no tienes cupones" al cambiar de cuenta.
  const cargando = sesion ? (datos.sesion !== sesion || cargandoCrudo) : false;

  const ahorro = cupones.reduce(
    (t, c) => (String(c.status || "").toLowerCase() === "redeemed" ? t + (Number(c.benefit_value_usd) || 0) : t),
    0,
  );

  return (
    <CuponesContext.Provider value={{ cupones, cargando, ahorro, techo, recargar: cargar }}>
      {children}
    </CuponesContext.Provider>
  );
}

// ============================================
// «MI LISTA» — lo que el socio guardó (s202 · favoritos-miembro, F1-F3 de s156)
// ============================================
// Una sola lectura por sesion, como los cupones, y FIRMADA con su dueno por la misma
// razon (s187): lo guardado de una cuenta no puede asomarse en la de otra mientras la
// respuesta nueva llega. `alternar` es optimista: el corazon cambia al toque y, si
// Bubble dice que no, vuelve a como estaba y avisa.
const GuardadosContext = createContext({
  ofertas: new Set(), comercios: new Set(), cargando: false,
  alternar: async () => false, recargar: () => {},
});
const useGuardados = () => useContext(GuardadosContext);

function ProveedorGuardados({ children }) {
  const sesion = useSesion();
  const [datos, setDatos] = useState({ sesion: "", ofertas: [], comercios: [] });
  const [cargandoCrudo, setCargando] = useState(false);

  const cargar = useCallback(async () => {
    if (!sesion) { setDatos({ sesion: "", ofertas: [], comercios: [] }); setCargando(false); return; }
    setCargando(true);
    try { const g = await misGuardados(); setDatos({ sesion, ...g }); }
    catch (e) { setDatos({ sesion, ofertas: [], comercios: [] }); }
    finally { setCargando(false); }
  }, [sesion]);
  useEffect(() => { cargar(); }, [cargar]);

  const propios = datos.sesion === sesion;
  const ofertas = new Set(propios ? datos.ofertas : []);
  const comercios = new Set(propios ? datos.comercios : []);
  const cargando = sesion ? (!propios || cargandoCrudo) : false;

  // Lo que se ve AHORA decide si el toque guarda o quita. Se lee de una referencia y no
  // de adentro de setDatos: en React 18 esa funcion corre en el render siguiente, y el
  // valor llegaria tarde a la llamada a Bubble.
  const vistoRef = useRef({ ofertas: [], comercios: [] });
  vistoRef.current = { ofertas: propios ? datos.ofertas : [], comercios: propios ? datos.comercios : [] };

  const alternar = useCallback(async (tipo, id) => {
    const clave = tipo === "merchant" ? "comercios" : "ofertas";
    const idTexto = String(id);
    const guardar = !vistoRef.current[clave].includes(idTexto);
    setDatos(d => {
      const lista = d[clave] || [];
      return { ...d, [clave]: guardar ? [...lista.filter(x => x !== idTexto), idTexto] : lista.filter(x => x !== idTexto) };
    });
    try {
      await guardarItem({ tipo, id: idTexto, guardar });
      return true;
    } catch (e) {
      setDatos(d => {
        const lista = d[clave] || [];
        return { ...d, [clave]: guardar ? lista.filter(x => x !== idTexto) : [...lista, idTexto] };
      });
      return false;
    }
  }, []);

  return (
    <GuardadosContext.Provider value={{ ofertas, comercios, cargando, alternar, recargar: cargar }}>
      {children}
    </GuardadosContext.Provider>
  );
}

// El boton de guardar, en sus tres lugares (tarjeta del catalogo, ficha de la oferta y
// pagina del comercio). Sin sesion manda al login y vuelve a esta misma pantalla (F2):
// nada anonimo, nada en el navegador. `pressed` le dice al lector de pantalla si ya esta.
function BotonGuardar({ tipo = "offer", id, className, style, tamano = 20, en, conCirculo = false }) {
  const { ofertas, comercios, alternar } = useGuardados();
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(false);
  if (!id) return null;
  const guardado = (tipo === "merchant" ? comercios : ofertas).has(String(id));
  const alTocar = async (e) => {
    e.preventDefault();
    e.stopPropagation();   // en el catalogo el boton vive dentro del enlace de la tarjeta
    if (!auth.isLoggedIn()) {
      navigate("/login", { state: { volver: location.pathname + location.search } });
      return;
    }
    setError(false);
    const ok = await alternar(tipo, id);
    if (!ok) setError(true);
  };
  const rotulo = guardado
    ? (en ? "Remove from My list" : "Quitar de Mi lista")
    : (en ? "Save to My list" : "Guardar en Mi lista");
  // El sprite trae `ico-guardar` e `ico-guardar-activo` con la MISMA silueta sin relleno
  // (y lo regenera el prebuild: no se toca). Lo guardado se rellena desde aca.
  const ico = <Ico name={guardado ? "ico-guardar-activo" : "ico-guardar"} size={tamano}
    style={guardado ? { fill: "currentColor" } : undefined} />;
  // Guardado se pinta en --accion (es un boton). Donde el color viene en linea (la ficha),
  // se pisa aca; donde viene de la hoja, lo hace [data-guardado] en tarjeta.css.
  const estilo = guardado && style ? { ...style, color: "var(--accion)" } : style;
  return (
    <button type="button" className={className} style={estilo} onClick={alTocar}
      aria-label={rotulo} aria-pressed={guardado} title={error ? (en ? "Couldn't save. Try again." : "No se pudo guardar. Prueba otra vez.") : rotulo}
      data-guardado={guardado ? "si" : "no"}>
      {conCirculo ? <span className="tarjeta__guardar-circulo">{ico}</span> : ico}
    </button>
  );
}

function t(es, en, lang) {
  return lang === "en" ? en : es;
}

// ============================================
// DESIGN TOKENS
// ============================================
// s144 D fase 1 — mapeo C → variables de tokens.css (sistema de diseño, D-62).
// S-15 fase 2 — el swap real: C ya no COPIA los valores, APUNTA a los tokens.
//
// Medido sobre este archivo antes de tocarlo: 1.327 usos de C.*, y cero de los
// cuatro patrones que romperían con var() — cero concatenaciones con alpha
// (`${C.red}22`), cero atributos SVG fill=/stroke= (var() no resuelve ahí),
// cero manipulación de string sobre el color, cero canvas. Los usos dentro de
// plantillas quedan como `1px solid var(--linea)`, que es CSS válido.
//
// Cinco de los ocho cambian de valor, y ese es justamente el punto: el archivo
// deja de tener paleta propia y pasa a leer la del sistema.
// s183 Tramo 0 · FE-D-s182 baja a tokens.css v3. Ninguna clave de aqui cambia:
// cambian los VALORES detras de las variables, asi que los ~1.300 usos de C.xxx
// se repintan solos. Los comentarios de al lado son el valor VIGENTE despues de
// v3 — antes decian el de la paleta crema y quedaron mintiendo.
const C = {
  red:    "var(--accion)",                // #C8460F  naranja (s212; era #BE3E1D coral)
  gold:   "var(--realce)",                // #FFB27A  melon (s212; era #C9A84C dorado). SOLO sobre fondo oscuro
  black:  "var(--tinta)",                 // #0F1B2A  azul noche (s212; era #0D0E12)
  gray:   "var(--tinta-suave)",           // #475467  (s212; era #54575C)
  muted:  "var(--tinta-tenue)",           // #667085  (s212; era #6B6E74)
  light:  "var(--superficie-hundida)",    // #F3F6FA  (s212; era #F3F4F7)
  border: "var(--linea)",                 // #E1E7EF  (s212; era #DEE0E3)
  white:  "var(--superficie-tarjeta)",    // #FFFFFF  sin cambio
  // v3: LA PAGINA ES BLANCA. La regla S-15 (pagina crema, tarjeta blanca, se
  // separan por diferencia de superficie) queda SUPERSEDED: ahora la foto ES la
  // tarjeta, y el filete de --linea aparece solo donde no hay foto.
  pagina: "var(--superficie-pagina)",     // #FFFFFF  (era #FBFAF7 crema)
  // v3 · roles que el sistema no tenia y las pantallas venian inventando a mano
  // con hex sueltos. Ver el bloque ESTADO de tokens.css.
  valor:       "var(--valor)",            // #1F4E79  azul (s212; era #5F6CD5 indigo)
  valorTinte:  "var(--valor-tinte)",      // #EEF4FA
  redTinte:    "var(--accion-tinte)",     // #FFF6F1
  exito:       "var(--exito)",            // #187C49
  exitoTinte:  "var(--exito-tinte)",      // #E8F5EE
  aviso:       "var(--aviso)",            // #9C5F00 (s212; era #A46400)
  avisoTinte:  "var(--aviso-tinte)",      // #FFF6E8
  error:       "var(--error)",            // #A3161C
  errorTinte:  "var(--error-tinte)",      // #F0D6D7
  apagada:     "var(--tinta-apagada)",    // #A9ADB3
};

const S = {
  // Layout
  page: { minHeight: "100vh", background: C.pagina, fontFamily: "'DM Sans', sans-serif" },
  container: { maxWidth: 1200, margin: "0 auto", padding: "0 20px" },
  // Typography
  display: { fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.03em" },
  // Cards
  // §1: sobre crema la tarjeta se separa POR DIFERENCIA DE SUPERFICIE, no por
  // borde ni por sombra. Se le quita el borde: los 13 usos que si necesitan uno
  // (paneles de admin y comercio sobre fondo blanco) ya lo declaran ellos mismos
  // despues del spread, asi que no se ven afectados.
  card: {
    background: C.white,
    borderRadius: 18,   // --radio-l
    overflow: "hidden",
  },
  // Buttons
  btnPrimary: {
    background: C.red,
    color: C.white,
    border: "none",
    borderRadius: 999,
    padding: "14px 24px",
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    width: "100%",
    letterSpacing: "0.01em",
    transition: "opacity 0.15s",
  },
  btnSecondary: {
    background: "transparent",
    color: C.red,
    border: `1.5px solid ${C.red}`,
    borderRadius: 999,
    padding: "13px 24px",
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    width: "100%",
    transition: "opacity 0.15s",
  },
  btnGold: {
    background: C.gold,
    color: C.black,
    border: "none",
    borderRadius: 999,
    padding: "14px 24px",
    fontSize: 15,
    fontWeight: 600,
    fontFamily: "'DM Sans', sans-serif",
    cursor: "pointer",
    width: "100%",
    transition: "opacity 0.15s",
  },
  input: {
    width: "100%",
    padding: "13px 16px",
    border: `1.5px solid ${C.border}`,
    borderRadius: 8,
    fontSize: 15,
    fontFamily: "'DM Sans', sans-serif",
    color: C.black,
    background: C.white,
    transition: "border-color 0.15s",
  },
};

// ============================================
// LOGO COMPONENT (Option C)
// ============================================
function Logo({ size = "md", tono = "claro" }) {
  const h = size === "lg" ? 48 : size === "sm" ? 28 : 36;
  // s191 — sobre banda oscura "NXT" iba en C.black (= --tinta), que es EL MISMO
  // #0D0E12 del fondo: la marca se leia "RESERVE" a secas. El tono oscuro lo pinta
  // con la superficie de pagina. El defecto no cambia, asi que los 12 usos claros
  // siguen igual.
  const colorNxt = tono === "oscuro" ? C.white : C.black;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ width: 4, height: h, background: C.red, borderRadius: 2, flexShrink: 0 }} />
      <div style={{ lineHeight: 1 }}>
        <div style={{ ...S.display, fontSize: h * 0.58, color: colorNxt, lineHeight: 1 }}>NXT</div>
        <div style={{ ...S.display, fontSize: h * 0.38, color: tono === "oscuro" ? C.gold : C.red, lineHeight: 1, letterSpacing: "0.15em" }}>RESERVE</div>
      </div>
    </div>
  );
}

// ============================================
// NAVBAR
// ============================================
// s183 — la navegación en sus dos formas. Hasta hoy era UNA barra fija abajo con
// tres pestañas: el patrón de una app de teléfono, que en escritorio dejaba la
// franja superior vacía y mandaba el menú al borde inferior de un monitor ancho.
// NXTReserve se usa en las dos superficies, así que en escritorio la navegación
// sube y en teléfono se queda abajo, donde llega el pulgar.
//
// Se dibujan las DOS y la media query de nav.css esconde la que no toca. No hay
// JavaScript midiendo la ventana: así no hay parpadeo al cargar ni estado que se
// desincronice al cambiar el tamaño (que es lo que le pasaba a ResponsiveGrid).
//
// «Comercios» es nueva en la navegación: el directorio existía pero solo se
// llegaba por un enlace suelto dentro del catálogo.
function Navbar({ activePage }) {
  const navigate = useNavigate();
  const lang = useLang();
  const en = lang === "en";
  const cambiarIdioma = useSetLang();
  const esMiembro = auth.isLoggedIn();

  // s183 · EL AHORRO sale del contexto de cupones: se suma `benefit_value_usd` de
  // los canjes reales del miembro, una sola vez por sesión de app. Ver el bloque
  // de ProveedorCupones para por qué se suma en vez de leer el acumulado.
  const { ahorro, techo } = useCupones();

  // Buscador global: manda a `/` con el término en la URL.
  const [q, setQ] = useState("");
  const buscar = (e) => {
    e.preventDefault();
    const t = q.trim();
    navigate(t ? `/?q=${encodeURIComponent(t)}` : "/");
  };
  // Dos estados: la barra entra alta y con aire, y se comprime cuando el lector
  // ya está leyendo. Es el patrón corriente en escritorio y lo que evita que un
  // menú de 84px se coma pantalla durante todo el scroll. El listener es pasivo
  // y coalesce con requestAnimationFrame: un solo cambio de estado por cuadro.
  // La transición la anula sola el bloque prefers-reduced-motion de tokens.css.
  const [comprimido, setComprimido] = useState(false);
  useEffect(() => {
    let pedido = 0;
    const alScrollear = () => {
      if (pedido) return;
      pedido = requestAnimationFrame(() => {
        setComprimido(window.scrollY > 80);
        pedido = 0;
      });
    };
    window.addEventListener("scroll", alScrollear, { passive: true });
    alScrollear();
    return () => {
      window.removeEventListener("scroll", alScrollear);
      if (pedido) cancelAnimationFrame(pedido);
    };
  }, []);
  const tabs = [
    // s215 · nota 12 (Ali): «Beneficios» + «Comercios» → una sola pestaña, «Explorar». Hoy un comercio tiene
    // una oferta: la tarjeta ya es el lugar con su beneficio (como Offline). /merchants sigue por URL.
    // El mapa (Lista / Mapa) entra cuando Bubble exponga lat/lng (hoy no salen por la API).
    { id: "home",    label: en ? "Explore" : "Explorar",       ico: "ico-ahorro",        path: "/" },
    { id: "coupons", label: en ? "My Coupons" : "Mis Cupones", ico: "ico-tarjeta",       path: "/my-coupons" },
    { id: "account", label: en ? "Account" : "Cuenta",         ico: "ico-cuenta",        path: "/account" },
  ];

  return (
    <>
      {/* ---------- LA FRANJA ----------
          Lo que no cabe en la navegación pero el visitante necesita a mano.
          Cambia según quién mira: al anónimo le habla de entrar al club —que es
          la conversión— y al miembro le da sus utilidades. */}
      <div className="franja">
        <div className="franja__ancho">
          <div className="franja__lado">
            {esMiembro ? (
              ahorro > 0 ? (
                <button className="franja__item" onClick={() => navigate("/my-coupons")}>
                  <Ico name="ico-ahorro" size={15} />
                  {en ? "You've saved" : "Has ahorrado"} <span className="franja__cifra">${fmtUsd(ahorro)}</span>
                  {/* s184 · el techo aparece SOLO si el dato existe. Sin el, la frase
                      queda exactamente como estaba: una cifra sin promesa de cuanto
                      mas hay. Nunca un «de $0» ni un techo inventado (CLAIMS §2). */}
                  {techo ? <span style={{ opacity: .8 }}> {en ? "of" : "de"} ${fmtUsd(techo)}</span> : null}
                  <span style={{ opacity: .8 }}>· {en ? "on menu prices" : "sobre precios de carta"}</span>
                </button>
              ) : (
                // CLAIMS §2: sin la cifra no se inventa un «has ahorrado $0».
                // Este renglón se va el día que el ahorro viaje en el payload.
                <span className="franja__item" style={{ cursor: "default" }}>
                  <Ico name="ico-ahorro" size={15} />
                  {en ? "Members save on every visit" : "Los miembros ahorran en cada visita"}
                </span>
              )
            ) : (
              <a className="franja__item" href="https://nxtreserve.com">
                {/* s232 · sin «club privado» (quienes-somos-miembro): las palabras son las del «¿Quiénes somos?» de Ali. */}
                {en ? "A benefits and discounts club — request an invitation" : "Club de beneficios y descuentos — solicita tu invitación"}
              </a>
            )}
          </div>

          <div className="franja__lado">
            <span className="franja__item" style={{ cursor: "default" }}>
              <Ico name="ico-mapa" size={14} />Miami, FL
            </span>
            {/* D-126: «Mi lista». s202 · se enciende (favoritos-miembro). Sin sesion,
                al login y de vuelta a la lista (F2). */}
            <button className="franja__item"
              onClick={() => navigate(auth.isLoggedIn() ? "/mi-lista" : "/login", auth.isLoggedIn() ? undefined : { state: { volver: "/mi-lista" } })}>
              <Ico name="ico-guardar" size={15} />{en ? "My list" : "Mi lista"}
            </button>
            <button className="franja__item" onClick={() => cambiarIdioma(en ? "es" : "en")}
              aria-label={en ? "Cambiar a español" : "Switch to English"}>
              🌐 {en ? "ES" : "EN"}
            </button>
          </div>
        </div>
      </div>

      {/* ---------- escritorio: arriba ---------- */}
      <nav className={`navsup${comprimido ? " navsup--min" : ""}`} aria-label={en ? "Main" : "Principal"}>
        <div className="navsup__ancho">
          <div className="navsup__marca"><Logo tono="oscuro" /></div>

          {/* s183 · el buscador sube al nav y se vuelve global: hasta hoy solo se
              podía buscar estando en el catálogo. Manda a `/` con el término en la
              URL, así que la búsqueda es compartible y sobrevive a un refresh —
              y no hace falta estado global. */}
          <form className="navsup__buscar" role="search" onSubmit={buscar}>
            <span className="navsup__buscar-ico"><Ico name="ico-buscar" size={17} /></span>
            <label htmlFor="nav-buscar" className="nxt-solo-lectores">
              {en ? "Search offers or businesses" : "Buscar ofertas o negocios"}
            </label>
            <input
              id="nav-buscar"
              type="search"
              value={q}
              onChange={e => setQ(e.target.value)}
              placeholder={en ? "Search offers or businesses..." : "Buscar ofertas o negocios..."}
            />
          </form>

          <div className="navsup__links">
            {tabs.map(t => (
              <button
                key={t.id}
                onClick={() => navigate(t.path)}
                className={`navsup__link${activePage === t.id ? " navsup__link--on" : ""}`}
                aria-current={activePage === t.id ? "page" : undefined}
              >
                <Ico name={t.ico} size={17} />
                {t.label}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* ---------- teléfono: abajo ---------- */}
      <nav className="navinf" aria-label={en ? "Main" : "Principal"}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => navigate(t.path)}
            className={`navinf__tab${activePage === t.id ? " navinf__tab--on" : ""}`}
            aria-current={activePage === t.id ? "page" : undefined}
          >
            <Ico name={t.ico} size={20} />
            <span className="navinf__rotulo">{t.label}</span>
          </button>
        ))}
      </nav>
    </>
  );
}

// s183 — EL PIE. Ninguna pantalla tenía uno: en una app de teléfono se perdona, en
// una web se nota, porque es donde la gente busca lo que no está en la navegación —
// los legales, el soporte, y la puerta para el que llegó de casualidad y tiene un
// negocio.
//
// Se monta donde vivía `.navinf-hueco` y ABSORBE ese hueco (ver pie.css), así que no
// quedan dos espaciadores peleando en teléfono.
//
// El WhatsApp de soporte usa WHATSAPP_NUMBER, que ya es el default documentado del
// sistema y lo sobrescribe `PricingConfig.support_whatsapp`. No se hace un fetch
// propio acá: el pie se monta en las siete pantallas y sería una llamada por
// pantalla para un enlace. Las pantallas que ya tienen el perfil cargado pueden
// pasar el número por `whatsapp`.
function Pie({ whatsapp }) {
  const navigate = useNavigate();
  const lang = useLang();
  const en = lang === "en";
  const wa = String(whatsapp || WHATSAPP_NUMBER).replace(/[^0-9]/g, "");

  const Enlace = ({ a, href, children }) => href
    ? <a className="pie__enlace" href={href} target="_blank" rel="noreferrer">{children}</a>
    : <button type="button" className="pie__enlace" onClick={() => navigate(a)}>{children}</button>;

  return (
    <footer className="pie">
      <div className="pie__ancho">
        <div className="pie__columnas">

          <div>
            <h2 className="pie__titulo">{en ? "The club" : "El club"}</h2>
            <div className="pie__lista">
              <Enlace a="/">{en ? "Explore" : "Explorar"}</Enlace>
              <Enlace a="/my-coupons">{en ? "My coupons" : "Mis cupones"}</Enlace>
              <Enlace a="/account">{en ? "My account" : "Mi cuenta"}</Enlace>
            </div>
          </div>

          <div>
            <h2 className="pie__titulo">{en ? "For businesses" : "Para negocios"}</h2>
            <div className="pie__lista">
              {/* La puerta del comercio YA existe y es la landing founding; no se
                  escribe una sección nueva para duplicarla. */}
              <Enlace href="https://nxtreserve.com/merchants">
                {en ? "Add my business" : "Sumar mi negocio"}
              </Enlace>
              <Enlace a="/merchant/login">{en ? "Merchant sign in" : "Ingresar como comercio"}</Enlace>
            </div>
          </div>

          <div>
            <h2 className="pie__titulo">{en ? "Support" : "Soporte"}</h2>
            <div className="pie__lista">
              <Enlace href={`https://wa.me/${wa}`}>WhatsApp</Enlace>
              <Enlace href="https://nxtreserve.com">
                {en ? "Request an invitation" : "Solicitar invitación"}
              </Enlace>
            </div>
          </div>

          <div>
            <h2 className="pie__titulo">{en ? "Legal" : "Legal"}</h2>
            <div className="pie__lista">
              <Enlace a="/terms">{en ? "Terms" : "Términos"}</Enlace>
              <Enlace a="/privacy">{en ? "Privacy" : "Privacidad"}</Enlace>
            </div>
          </div>
        </div>

        {/* EL DISCLAIMER DE PRECIOS — redactado por Cowork (s183).
            No es letra chica de relleno: es lo que sostiene que una oferta pueda
            mostrar el precio de carta tachado (CLAIMS §1). Dice «informado por el
            comercio» a propósito: el sustento contractual pleno llega con el ticket
            `atestacion-precio-carta-en-alta`. */}
        <p className="pie__legal">
          {en
            ? "Strikethrough reference prices are the menu or list price reported by each merchant for the offer's product or service — never a former NXT Reserve price. Savings shown are calculated against that list price. Each benefit is subject to its offer's terms and merchant availability."
            : "Los precios de referencia tachados son el precio de carta o de lista informado por cada comercio para el producto o servicio de la oferta — nunca un precio anterior de NXT Reserve. El ahorro mostrado se calcula contra ese precio de carta. Cada beneficio está sujeto a los términos de su oferta y a la disponibilidad del comercio."}
        </p>

        <div className="pie__cierre">
          <span>NXT Reserve · Miami, FL</span>
          {/* Las redes van a ir acá como constantes cuando existan las cuentas.
              Hoy no se linkean: un enlace a una cuenta que no existe es peor que
              no tener el enlace. */}
          <span>v3.1</span>
        </div>
      </div>
    </footer>
  );
}

// ============================================
// CATEGORY PILL
// ============================================
const CATEGORIES = ["Todos", "Restaurantes", "Salones/Spa", "Bares & Rooftops", "Experiencias", "Dulces & Heladerías", "Celebraciones"];   // s241 · antes «Hecho a pedido» (s237-D3) y «Regalos & Momentos»
const CAT_MAP = {
  "Restaurantes": "Restaurant",
  "Salones/Spa": "Salon_Spa",
  "Bares & Rooftops": "Bar_Rooftop",
  "Experiencias": "Experience",
  "Dulces & Heladerías": "Sweets",
  "Celebraciones": "Gift_Moments",
};
// s120: chip doctrinal (doctrina s100) — el RECOMENDADO del club como categoria destacada del catalogo.
// Cumplen: bogo, free, percent>=50, o fixed a mitad de precio.
// s227-D2 (Ali): se llama «Imperdibles» (antes «2×1 · 50%»: con el 2×1 fuera del primer wizard, el nombre confundía).
// Solo cambia el nombre; el criterio (isBestDealOffer) es el mismo. La categoria elegida vive solo en el estado del
// catalogo (no en la URL ni en storage), asi que no hay clave vieja que conservar.
const BOGO_CAT = "Imperdibles";
const BOGO_CAT_NOTA = { es: "50 % o más", en: "50% or more" };
// El nombre que se ve del chip: las categorias del catalogo se muestran en español; esta tiene su version EN.
const etiquetaCat = (cat, en) => (cat === BOGO_CAT && en ? "Can't-miss" : cat);
const isBestDealOffer = (o) => {
  const t = (o.offer_type || "").toLowerCase();
  if (t === "bogo" || t === "free") return true;
  if (t === "percent") return Number(o.discount_pct) >= 50;
  // s194 L1: una umbral L/XL/Destacada es 50 % nominal (el mínimo dobla al monto).
  if (t === "umbral") {
    const m = Number(o.benefit_value_usd), n = Number(o.min_consumption);
    return m > 0 && n >= 2 * m;
  }
  if (t === "fixed") {
    const rp = Number(o.regular_price);
    const cp = Number(o.coupon_price);
    return rp > 0 && cp > 0 && cp <= rp / 2;
  }
  return false;
};

const CAT_DISPLAY = {
  "Restaurant": "Restaurantes",
  "Salon_Spa": "Salones/Spa",
  "Bar_Rooftop": "Bares & Rooftops",
  "Experience": "Experiencias",
  "Sweets": "Dulces & Heladerías",
  "Nail_Lash": "Nail/Lash Studios",
  "Gift_Moments": "Celebraciones",
};

// s144 B — iconos de categoría del sistema de diseño. Markup copiado inline de
// https://nxtreserve.com/sistema/iconos.svg (<use href> no cruza dominios).
// Heredan currentColor y escalan con la tipografía (1em). La categoría legacy
// (fuera del canon pero viva en el Option Set de Bubble) usa el icono de belleza.
// s158 T4: los iconos de categoria viven en el sprite (/iconos.svg, mismo origen
// desde T1) — mapa en CATEGORY_ICON_ID. El bloque inline de s144 existia solo
// porque <use href> no cruzaba dominios; esa razon ya no aplica.
const CATEGORY_ICON_ID = {
  Restaurant:   "ico-restaurantes",
  Salon_Spa:    "ico-belleza-spa",
  Bar_Rooftop:  "ico-bares",
  Experience:   "ico-experiencias",
  Sweets:       "ico-dulces",
  Gift_Moments: "ico-regalos",
  Nail_Lash:    "ico-belleza-spa", // legacy → misma familia visual (igual que hoy)
};
// Se conserva el dimensionado en 1em: los llamadores fijan el tamano con fontSize
// y no hay que tocar ninguno. Categoria fuera del mapa: no se dibuja icono (antes
// caia a un emoji de tienda, que es justo lo que este lote retira).
function CategoryIcon({ category }) {
  const id = CATEGORY_ICON_ID[category];
  if (!id) return null;
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      style={{ width: "1em", height: "1em", flexShrink: 0 }}>
      <use href={`/iconos.svg#${id}`} />
    </svg>
  );
}

// s183 — CategoryPills se retiró: el sidebar del catálogo (CatalogoSidebar) lo
// reemplaza, y era su único llamador. En pantallas angostas las categorías del
// sidebar vuelven a verse como pastillas, pero por CSS (.cat dentro de la media
// query de catalogo.css), no por un componente aparte.

// ============================================
// OFFER CARD
// ============================================
// s158 T2 — resolverAhorro: ÚNICA fuente de la cifra que ve el miembro (S-19 §2.2).
// Helper puro: mismo offer + lang ⇒ misma salida. Devuelve SIEMPRE objeto, nunca null.
//
// REGLA DEL 100 (D-119): decide el TICKET, no el comercio. Con regular_price ≥ $100
// lidera el dólar ahorrado (a esa altura el número grande impresiona en dólares);
// por debajo lidera el porcentaje (un "$12" chico no vende, un "−40%" sí). Dos
// ofertas con el mismo ticket se ven igual: la elección no la hace quien carga.
//
// LÉXICO (S-19, innegociable): jamás "OFF" — el rótulo es AHORRO. Jamás "descuento"
// en copy público (D-52). El menos es U+2212 (−), NO el guion ASCII; la equis de 2×1
// es U+00D7 (×). Si alguien reescribe esto con "-" o "x", rompe la tipografía.
//
// SUPERSESIÓN 1 — MKT-24 regla 1 ("sin ahorro real no se dibuja, nunca un guion")
// queda superada por S-19 §2.4 para ESTE caso: el hueco ahora se DECLARA
// («Ahorro por confirmar») en vez de colapsar. Lo que sigue prohibido y no cambia:
// nunca un cero, nunca un número inventado.
//
// SUPERSESIÓN 2 — S-15 §2 regla 2 ("la cifra va en NEGRO") queda superada por la
// cadena D-62 (tokens.css es la verdad) → tokens v2 define --valor para "la cifra
// que lidera y la insignia" → S-19 §2.2 lo pide explícito (Bebas 44px, --valor).
// Aquella regla era contra el ROJO de supermercado; --valor es un token nuevo con su
// propia restricción (como texto solo ≥24px) y la cifra va a 44px: cumple.
//
// porConfirmar SOLO es alcanzable por datos legacy: desde s155-D6 ninguna oferta
// nueva se guarda con benefit_value_usd = 0. Hoy lo disparan Taikin, Otto y el
// catálogo demo. No es bug de este helper.
// s180 A3: el ahorro se mostraba con toFixed(0) — un beneficio de 13.5 decía «$14» en 3a
// y en el review, medio dólar que no existe. Entero → «45»; con decimales → «13.50».
// Se redondea a centavos antes de decidir, para que 0.1+0.2 no salga como «0.30000…».
//
// s184: vivía 5.000 líneas más abajo, entre los helpers del alta de oferta, y por eso
// el lado del MIEMBRO nunca lo usó: la franja decía «Has ahorrado $138.5» y la tarjeta
// de STATUS Hair «Ahorras $13.5». Un precio con un solo decimal no se lee como dinero.
// Sube acá, delante de su primer consumidor, para que el catálogo, la ficha, la franja
// y Mis Cupones formateen todos por la misma función.
const fmtUsd = (n) => {
  const c = Math.round((Number(n) || 0) * 100) / 100;
  return Number.isInteger(c) ? String(c) : c.toFixed(2);
};

// ---- s194 L1 · EL FORMATO ÚNICO DE OFERTA (s194-D1/D2/D4 · PLAN_tramo2_s194 §1 H1-H3) ----
// Una oferta «estándar» es `offer_type = "umbral"` + `benefit_value_usd` (lo que recibe el
// socio) + `min_consumption` (lo que tiene que gastar). Cinco tamaños, un solo formato: el
// socio lee siempre la misma frase. Destacada NO es un campo: es el tamaño más grande
// ($50 si gastas $100) y se deriva de los números acá y en el guard de Bubble (sala P1 de
// s194, create_coupon_and_cooldown). Los tres campos ya existen, ya son parámetros de
// create_offer/update_offer y ya son públicos: no hay campo nuevo ni migración (H1).
// `Offer.min_spend` queda como está — huérfano: ningún WF lo escribe y no es público.
const UMBRAL_TIPO = "umbral";
// s195 (s194-D13): la tabla sale de los datos crudos de Offline, por GASTO POR PERSONA. La
// Mediana pasa a llevar mínimo doble ($15 si gastas $30), como Offline; la Chica queda «sin
// mínimo», que acá se escribe mínimo = monto («$10 para gastar»): así `regular_price` sigue
// siendo > 0 y `approve_offer` no la rechaza (OFFER_PRICE_INVALID).
// s214 (Ali) · la Chica también lleva mínimo doble: $10 si gastas $20. «$10 para gastar» era un regalo y
// rompía «consume al menos el doble del beneficio», que dicen la vitrina y la landing (ronda 12, dulcería).
// Las ofertas ya guardadas con mínimo = monto se siguen leyendo como «$10 para gastar» (fraseUmbral).
const UMBRAL_TAMANOS = [
  { id: "S",  monto: 10, minimo: 20,  es: "Chica",      en: "Small",    rubros: "Dulcerías y cafés de mostrador" },
  { id: "M",  monto: 15, minimo: 30,  es: "Mediana",    en: "Medium",   rubros: "Fast casual, almuerzo, brunch" },
  { id: "L",  monto: 20, minimo: 40,  es: "Grande",     en: "Large",    rubros: "Restaurante casual, uñas, regalos" },
  // s199-D3 · el sexto tamaño. Sale del cruce con la oferta real de Offline: con la cuenta
  // dividida entre dos (inferido), la tabla de s194-D13 coincidía en 5 de sus 6 categorías de
  // restaurante, y la que fallaba era la coctelería ($47 por persona → Offline pone $25/$50).
  // El id es nuevo a propósito: S·M·L·XL·D no se renombran, y el id se muestra en la tarjeta.
  { id: "L+", monto: 25, minimo: 50,  es: "Grande+",    en: "Large+",   rubros: "Bares, coctelerías, cervecerías, casual" },
  { id: "XL", monto: 30, minimo: 60,  es: "Muy grande", en: "X-Large",  rubros: "Cena, spa, experiencias" },
  // s232 (Ali) · tamanos-70-y-80: el hueco entre $60 y $100. Salió del ejercicio del ticket en la invitación (s231): una
  // mesa de dos de $60-$70 sube al escalón siguiente y ese escalón no existía. Bubble no valida la lista (solo monto > 0).
  { id: "XL+", monto: 35, minimo: 70,  es: "Muy grande+", en: "X-Large+", rubros: "Cena para dos, spa, experiencias" },
  { id: "XXL", monto: 40, minimo: 80,  es: "Extra grande", en: "XX-Large", rubros: "Cena completa, spa premium, experiencias" },
  { id: "D",  monto: 50, minimo: 100, es: "Destacada",  en: "Featured", rubros: "Alta cocina, spa premium, degustaciones" },
];
// s199-D2 · La Destacada ($50/$100) queda BLOQUEADA en la siembra del operador mientras no
// exista la suscripción: `create_coupon_and_cooldown` le responde PREMIUM_REQUIRES_ACTIVE a
// todo socio que no esté `active`, y el React de producción no conoce ese código. El alta
// propia del comercio (`/merchant/offers/new`) NO se toca: esas ofertas pasan por la
// aprobación de Ali. Cuando la suscripción esté en Live, esto vuelve a `true`.
// s228 (Ali) · ABIERTA: «si el merchant quiere colocar 50 está bien; si llega el momento de usarla, ¿por qué la vamos
// a desaprovechar?». El guard de create_coupon_and_cooldown es del MIEMBRO, no del comercio: VIP, B2B o con suscripción
// activa la activan; un LITE sin suscripción recibe el error_message de Bubble («Esta oferta destacada es para socios
// con suscripción activa.»), que la app muestra tal cual.
const DESTACADA_HABILITADA = true;
// Mientras siga bloqueada, donde la tabla propone Destacada se propone la XL.
const sinDestacada = (t) => (t && t.id === "D" && !DESTACADA_HABILITADA ? UMBRAL_TAMANOS.find(x => x.id === "XXL") : t);
// s194-D13 · gasto por persona (sin propina) → tamaño. Límite superior EXCLUSIVO de cada franja.
// s224 (Ali) · HACIA ABAJO, la regla de Offline (INVESTIGACION_s194 §2): el mínimo es lo que gasta UNA persona,
// redondeado hacia abajo al escalón, y el monto la mitad. Una mesa de $100 ($50 por persona) → $25 si gastas $50.
// Hasta s223 la tabla redondeaba hacia arriba (<20 S · 20–29 M · 30–39 L · 40–49 L+ · 50–79 XL · 80+ D): con $50 por
// persona proponía $30/$60. El dueño que quiere dar más sube un paso con el +.
const UMBRAL_POR_PERSONA = [
  { hasta: 30, id: "S" },
  { hasta: 40, id: "M" },
  { hasta: 50, id: "L" },
  { hasta: 60, id: "L+" },
  { hasta: 70, id: "XL" },
  { hasta: 80, id: "XL+" },    // s232 · tamanos-70-y-80
  { hasta: 100, id: "XXL" },
  { hasta: Infinity, id: "D" },
];
// Dos tamaños por franja = DOS ofertas del mismo comercio con horario (H3): no hay campo
// `daypart`. Presets editables después desde «Mis ofertas».
const UMBRAL_FRANJAS = [
  { key: "almuerzo", es: "Almuerzo", en: "Lunch",  ini: "11:30", fin: "15:00" },
  { key: "cena",     es: "Cena",     en: "Dinner", ini: "18:00", fin: "23:00" },
];
// s242 · los atajos de horario del editor, por familia (Ali): almuerzo y cena solo en restaurantes y bares; en dulces mañana
// y tarde (la tarde = la «Merienda» del wizard); en salones, experiencias y encargos, ninguno (Desde/Hasta a mano).
const ATAJOS_HORARIO = {
  mesa: UMBRAL_FRANJAS,
  mostrador: [{ key: "manana", es: "Mañana", en: "Morning", ini: "08:00", fin: "12:00" }, { key: "tarde", es: "Tarde", en: "Afternoon", ini: "14:00", fin: "18:00" }],
};
const atajosHorario = (categoria) => ATAJOS_HORARIO[FAMILIA_POR_RUBRO[categoria] || "mesa"] || [];
// s242 · el ejemplo de «Cuándo conviene venir» del editor, por familia (decía «en la cena» en dulces y experiencias).
const CUANDO_IR_EJEMPLO = {
  mesa: { es: "Ej: martes a jueves en la cena", en: "Eg: Tuesday to Thursday at dinner" },
  cita: { es: "Ej: martes a jueves por la mañana", en: "Eg: Tuesday to Thursday mornings" },
  mostrador: { es: "Ej: martes a jueves por la tarde", en: "Eg: Tuesday to Thursday afternoons" },
  reserva: { es: "Ej: entre semana, en el primer horario", en: "Eg: weekdays, first slot of the day" },
  tienda: { es: "Ej: pedidos de lunes a jueves", en: "Eg: orders Monday to Thursday" },
};
// s194 L2 · EL ASESOR BÁSICO ES UNA REGLA, NO UN MODELO (SÍNTESIS §2.4, modo básico).
// s195 (s194-D13): manda el GASTO POR PERSONA que el comercio escribe, por la tabla de
// arriba. El rubro solo desempata: si la tabla cae fuera del rango típico del rubro
// (SÍNTESIS §2.1), se recorta al tamaño permitido más cercano (hacia abajo si lo hay);
// sin gasto cae al más chico del rubro. Antes la regla era «el tamaño más grande cuyo
// mínimo no supere la cuenta de la mesa»; Ali la cambió a por persona sobre los datos
// crudos de Offline. `MarginProfile` NO se lee: su privacy lo deja solo para Admin
// (PRIVACY_RULES_NXTR, marginprofile). Sin IA: no gasta cupo del asesor.
// s199-D3: el sexto tamaño entra en todos menos en Sweets (un café no vende $50 por persona).
const UMBRAL_TAMANOS_POR_RUBRO = {
  Restaurant:   ["M", "L", "L+", "XL", "XL+", "XXL", "D"],   // s232 · tamanos-70-y-80
  Salon_Spa:    ["L", "L+", "XL", "XL+", "XXL", "D"],
  Bar_Rooftop:  ["L", "L+", "XL"],      // mínimo en comida hasta legal-alcohol-descuentos-florida
  Experience:   ["L", "L+", "XL", "XL+", "XXL", "D"],
  Sweets:       ["S", "M", "L"],   // s236 · tabla B: dulces y heladerías llegan a $20/$40, como comida rápida
  Gift_Moments: ["L", "L+", "XL"],
};
const tamanoPorPersona = (gasto) => {
  const g = Number(gasto);
  if (!(g > 0)) return null;
  const fila = UMBRAL_POR_PERSONA.find(f => g < f.hasta);
  return fila ? fila.id : "D";
};
// s214 (Ali) · sin gasto, dulces empieza en la Mediana ($15 si gastas $30), como dice su landing
// («va bien con una torta, una caja de postres o un pedido para llevar»); la Chica es para el mostrador chico.
const TAMANO_DE_ENTRADA = { Sweets: "M" };
// s236 · REGLA 3 (Ali, 20/10; claude/INVESTIGACION_s236_regla_del_minimo.md): en los rubros de mesa el mínimo es el
// escalón SIGUIENTE a lo que gasta una persona (estrictamente por encima: quien va solo pide algo más, la mesa de dos lo
// pasa y el restaurante da ~30 % de la cuenta típica). Es lo que hace Offline en la práctica y lo que usa la invitación
// (nxt-landing `tamanoSiguiente`). Los demás rubros siguen con la de s224 (hacia abajo, UMBRAL_POR_PERSONA).
// s236 (Ali, 21/10) · dulces y heladerías pasan a la tabla B (como comida rápida): S/M/L con la regla 3.
const RUBROS_REGLA_3 = ["Restaurant", "Bar_Rooftop", "Sweets"];
// s236 · el recibo de ejemplo calcula DOS personas (restaurantes, bares, comida rápida, dulces): «el gasto de uno, ahora comen dos».
const RUBROS_RECIBO_DOS = ["Restaurant", "Bar_Rooftop", "Sweets"];
// s236 · siembra-comida-rapida-tamanos-chicos: `tipoNegocio` (comida rápida, café, pizza → TIPOS_POR_PERSONA) usa los
// tamaños chicos por persona (S/M/L), como el wizard del dueño. Sin él, los del rubro.
const idsDeTamano = (categoria, tipoNegocio) => (TIPOS_POR_PERSONA.includes(String(tipoNegocio || ""))
  ? TAMANOS_POR_PERSONA
  : (UMBRAL_TAMANOS_POR_RUBRO[categoria] || ["M", "L", "L+", "XL", "XL+", "XXL"]));
const sugerirTamanoUmbral = (categoria, gastoPorPersona, tipoNegocio) => {
  const ids = idsDeTamano(categoria, tipoNegocio);
  const permitidos = UMBRAL_TAMANOS.filter(t => ids.includes(t.id));
  const g = Number(gastoPorPersona);
  if (RUBROS_REGLA_3.includes(categoria) && g > 0) return permitidos.find(t => t.minimo > g) || permitidos[permitidos.length - 1] || null;
  const porTabla = tamanoPorPersona(gastoPorPersona);
  if (!porTabla) return permitidos.find(t => t.id === TAMANO_DE_ENTRADA[categoria]) || permitidos[0] || null;
  const orden = UMBRAL_TAMANOS.map(t => t.id);
  const i = orden.indexOf(porTabla);
  // Desempate por rubro: el permitido más cercano por debajo; si no hay, el más cercano por arriba.
  const abajo = permitidos.filter(t => orden.indexOf(t.id) <= i);
  if (abajo.length) return abajo[abajo.length - 1];
  return permitidos[0] || null;
};
// Con dos franjas la cena lleva el sugerido y el almuerzo un tamaño menos (si lo hay).
const unTamanoMenos = (id) => {
  const i = UMBRAL_TAMANOS.findIndex(t => t.id === id);
  return i > 0 ? UMBRAL_TAMANOS[i - 1] : UMBRAL_TAMANOS[0];
};
// Las reglas fijas del formato (s194-D2), tal cual, en alta, ficha y pantalla de canje. Se
// compilan a rules_text al guardar una oferta umbral: una condición por línea (A8, s180).
// s213 (Ali) · eran siete: «Repetible cada 90 días en el mismo local» SALE de la lista. Con el
// lote C cada oferta trae su plazo (`cooldown_days`: 1/7/15/30/60/90), y una línea fija en la base
// dejaba «90 días» en ofertas con otro plazo. La línea del plazo se ARMA siempre desde la oferta
// (`reglaPlazo`) y NO se guarda en rules_text. s214: la ficha las reparte por TEXTO, no por posición.
// s214 · LAS REGLAS VAN POR RUBRO (Ali, s214: «igualito que la landing de cada rubro»). Hasta s213 eran
// seis fijas para todos, escritas para restaurante: a un salón de uñas le decían «comida y bebidas sin
// alcohol» y «cada miembro más en la mesa» (ronda 12, 4/4). Ahora:
//   · las COMUNES valen para todos y son las únicas que se guardan en la oferta (rules_text);
//   · las del RUBRO se arman aquí con la categoría de la oferta, igual que la del plazo.
// Así, cambiar el texto de un rubro nunca obliga a tocar la base.
const REGLA_MINIMO = { es: "El mínimo se cuenta antes de impuestos y propina", en: "The minimum counts before tax and tip" };
// s212 · la regla de Ali: un beneficio por membresía (titular + acompañante = uno). s214: sin «en la mesa».
const REGLA_MEMBRESIA = {
  es: "Un beneficio por membresía: si van tú y tu acompañante, es uno para los dos. Cada miembro más tiene el suyo",
  en: "One benefit per membership: you and your companion share one. Each other member gets their own",
};
const REGLA_NO_COMBINABLE = { es: "No combinable con otras promociones", en: "Not combinable with other promotions" };
// s240 (recorrido B en Live) · en «Hecho a pedido» nadie «va» ni deja propina: las dos comunes que lo decían, en su versión de
// encargo. Se cambian al armar las reglas del rubro (reglasDelRubro / reglasPorcentaje).
const REGLA_MEMBRESIA_ENCARGO = { es: "Un beneficio por membresía y por pedido. Cada miembro tiene el suyo", en: "One benefit per membership and per order. Each member gets their own" };
const REGLA_MINIMO_ENCARGO = { es: "El mínimo se cuenta antes de impuestos", en: "The minimum counts before tax" };
const REGLAS_COMUNES = {
  es: [REGLA_MINIMO.es, REGLA_MEMBRESIA.es, REGLA_NO_COMBINABLE.es],
  en: [REGLA_MINIMO.en, REGLA_MEMBRESIA.en, REGLA_NO_COMBINABLE.en],
};
// Las tres de comida: solo restaurantes y bares (la landing de restaurantes las dice; las otras no).
const REGLA_ALCOHOL = {
  es: "Aplica a comida y bebidas sin alcohol; el alcohol suma al mínimo pero no lleva descuento",
  en: "Applies to food and non-alcoholic drinks; alcohol counts toward the minimum but isn't discounted",
};
const REGLA_SOLO_LOCAL = { es: "Solo en el local, salvo que la ficha diga otra cosa", en: "Dine-in only, unless the listing says otherwise" };
// s199-D5 · propina automática, como Offline: la queja de sus usuarios era la propina SORPRESA.
const REGLA_PROPINA = {
  es: "La propina se calcula sobre el total sin descuento, y el local puede incluirla en la cuenta",
  en: "Tip is calculated on the pre-discount total, and the venue may add it to the bill",
};
const REGLA_CITA = { es: "Reserva tu cita y avisa que vienes por NXT Reserve", en: "Book your appointment and mention you're coming with NXT Reserve" };
const REGLA_RESERVA = { es: "Reserva antes y avisa que vienes por NXT Reserve", en: "Book ahead and mention you're coming with NXT Reserve" };
const REGLA_LLEVAR = { es: "Vale en el local y para llevar", en: "Valid in store and to go" };
const REGLA_TIENDA = { es: "Vale en la tienda", en: "Valid in store" };
// s237-D3 · «Hecho a pedido» (Gift_Moments): tortas, arreglos y globos se encargan; al recoger ya no hay nada que
// descontar. La línea de «dónde vale» de la familia pasa a ser esta. REGLA_TIENDA queda en REGLAS_FIJAS_TODAS (ya guardada).
// La línea que acompaña al nombre «Hecho a pedido» (s237-D3, literal de Ali).
// s241 · «Celebraciones» (SPEC_s240 §3.1): la línea nombra la ocasión.
const LINEA_HECHO_A_PEDIDO = { es: "Tortas, arreglos, flores y globos para tus celebraciones, hechos por gente de Miami.", en: "Cakes, arrangements, flowers and balloons for your celebrations, made by people in Miami." };
const REGLA_PEDIDO = { es: "Dilo al hacer el pedido, no al recoger", en: "Mention NXT Reserve when you place the order, not at pickup" };
// s240 (Ali) · los encargos se recogen o se entregan: la oferta vale en los dos; el envío no lleva descuento.
const REGLA_ENTREGA = { es: "Vale con retiro en la tienda y con entrega; el envío no lleva descuento", en: "Valid for pickup and delivery; delivery fees aren't discounted" };
const REGLAS_POR_FAMILIA = {
  mesa: { es: [REGLA_ALCOHOL.es, REGLA_SOLO_LOCAL.es, REGLA_PROPINA.es], en: [REGLA_ALCOHOL.en, REGLA_SOLO_LOCAL.en, REGLA_PROPINA.en] },
  cita: { es: [REGLA_CITA.es], en: [REGLA_CITA.en] },
  reserva: { es: [REGLA_RESERVA.es], en: [REGLA_RESERVA.en] },
  mostrador: { es: [REGLA_LLEVAR.es], en: [REGLA_LLEVAR.en] },
  tienda: { es: [REGLA_PEDIDO.es, REGLA_ENTREGA.es], en: [REGLA_PEDIDO.en, REGLA_ENTREGA.en] },
};
// s241 · `Nail_Lash` (legacy, comercios viejos) es de la familia de los salones: hasta hoy no tenía familia y su ficha
// salía sin la línea de la cita.
const FAMILIA_POR_RUBRO = {
  Restaurant: "mesa", Bar_Rooftop: "mesa", Salon_Spa: "cita", Nail_Lash: "cita", Experience: "reserva", Sweets: "mostrador", Gift_Moments: "tienda",
};
// s241 · PERFIL POR RUBRO (`perfil-por-rubro`): lo que cada familia TIENE y CÓMO SE DICE, en un solo lugar. Una pantalla
// que depende del rubro le pregunta al perfil («¿hay alcohol?», «¿cómo se dice la cuenta?») en vez de escribir el texto
// suelto: así un texto de restaurante no se cuela en un salón ni en un encargo. La matriz (src/matriz/) lo vigila en
// todas las pantallas. Sin rubro conocido, el de restaurantes (el texto de siempre).
//   alcohol / propina: si la familia los tiene (el editor solo pregunta alcohol en restaurantes y bares; el validador solo nombra la
//   propina donde la hay) · cuenta: sobre qué se aplica el % («−25 % en tu cuenta» / «en tu pedido») · mismo: con quién
//   corre el plazo · paso2: el segundo paso de «Cómo usarla» · lleno: cuándo se reabren las ofertas pausadas ·
//   otroMomento: la invitación a «Agrega otra franja» (en encargos esa tarjeta no se muestra) · toda / la / antesDe: sobre
//   qué se calcula el % («toda la cuenta», «antes de impuestos y propina») · excluye: los chips de «¿Algo no entra?» del
//   wizard (EXCLUSIONES_WIZARD) · otraExclusion: su ejemplo · ticketAyuda: la ayuda del ticket cuando no es comida ·
//   objetivos: lo que cambia de OBJETIVOS_WIZARD en la familia (nota o nombre).
const VISITA = { visita: { es: "visita", en: "visit" }, visitas: { es: "visitas", en: "visits" } };
const ANTES_CON_PROPINA = { es: "antes de impuestos y propina", en: "before tax and tip" };
const LA_CUENTA = { toda: { es: "toda la cuenta", en: "the whole bill" }, la: { es: "la cuenta", en: "the bill" } };
const OBJ_SIN_MESA = { horas_flojas: { notaEs: "Días y horas en que te sobra cupo.", notaEn: "Days and hours when you have spare slots." } };
const PERFIL_POR_FAMILIA = {
  mesa: { alcohol: true, propina: true, ...LA_CUENTA, ...VISITA, antesDe: ANTES_CON_PROPINA,
    cuenta: { es: "en tu cuenta", en: "on your bill" },
    mismo: { es: "en el mismo local", en: "at the same venue" },
    paso2: { es: "Ve al negocio y pide tu beneficio", en: "Go to the business and ask for your benefit" },
    lleno: { es: "cuando vuelvas a tener mesas", en: "when you have tables again" },
    otroMomento: { es: "el almuerzo, la cena o cuando tengas mesas vacías", en: "lunch, dinner or whenever you have empty tables" },
    excluye: ["alcohol", "especiales", "combos", "happy_hour", "postres", "bebidas"],
    otraExclusion: { es: "Otra cosa: botellas, menú de degustación…", en: "Something else: bottles, tasting menu…" },
    ticketAyuda: null, objetivos: {}, fotosDe: { es: "el local, los platos, el ambiente", en: "the place, the dishes, the vibe" }, fotoProta: { es: "El plato o el servicio de protagonista, no todo el salón", en: "The dish or service front and center, not the whole room" } },
  cita: { alcohol: false, propina: true, ...LA_CUENTA, ...VISITA, antesDe: ANTES_CON_PROPINA,
    cuenta: { es: "en tu cuenta", en: "on your bill" },
    mismo: { es: "en el mismo local", en: "at the same venue" },
    paso2: { es: "Reserva tu cita y pide tu beneficio", en: "Book your appointment and ask for your benefit" },
    lleno: { es: "cuando vuelvas a tener espacio en la agenda", en: "when you have openings again" },
    otroMomento: { es: "entre semana, temprano o cuando tengas huecos en la agenda", en: "weekdays, early hours or whenever your calendar has gaps" },
    excluye: ["productos", "paquetes", "premium"],
    otraExclusion: { es: "Otra cosa: novias, tratamientos especiales…", en: "Something else: bridal, special treatments…" },
    ticketAyuda: { es: "Todo lo que paga un cliente en una visita normal, antes de impuestos y propina. Si suele llevar dos servicios (corte y tinte, por ejemplo), cuenta los dos.", en: "Everything one customer pays on a normal visit, before tax and tip. If they usually take two services (a cut and color, say), count both." },
    objetivos: { ...OBJ_SIN_MESA,
      algo_nuevo: { notaEs: "Un servicio nuevo que quieres que prueben.", notaEn: "A new service you want people to try." },
      grupos: { es: "Grupos", en: "Groups", notaEs: "Novias, cumpleaños, oficinas.", notaEn: "Bridal parties, birthdays, offices." } },
    fotosDe: { es: "el local, tu trabajo, el ambiente", en: "the place, your work, the vibe" }, fotoProta: { es: "Tu trabajo de protagonista: un corte, unas uñas, un antes y después", en: "Your work front and center: a cut, a set of nails, a before and after" } },
  reserva: { alcohol: false, propina: true, ...LA_CUENTA, ...VISITA, antesDe: ANTES_CON_PROPINA,
    cuenta: { es: "en tu cuenta", en: "on your bill" },
    mismo: { es: "con el mismo negocio", en: "with the same business" },
    paso2: { es: "Reserva y pide tu beneficio", en: "Book and ask for your benefit" },
    lleno: { es: "cuando vuelvas a tener cupo", en: "when you have spots again" },
    otroMomento: { es: "entre semana o en los horarios que menos se llenan", en: "weekdays or the times that fill up least" },
    excluye: ["paquetes", "extras"],
    otraExclusion: { es: "Otra cosa: eventos privados, temporada alta…", en: "Something else: private events, high season…" },
    ticketAyuda: { es: "Todo lo que paga un cliente por la experiencia, antes de impuestos y propina.", en: "Everything one customer pays for the experience, before tax and tip." },
    objetivos: { ...OBJ_SIN_MESA,
      algo_nuevo: { notaEs: "Una experiencia nueva que quieres que prueben.", notaEn: "A new experience you want people to try." },
      grupos: { es: "Grupos", en: "Groups", notaEs: "Celebraciones, oficinas, familias.", notaEn: "Celebrations, offices, families." } },
    fotosDe: { es: "el lugar, la experiencia, la gente disfrutando", en: "the place, the experience, people enjoying it" }, fotoProta: { es: "La experiencia de protagonista: la gente disfrutando, no un folleto", en: "The experience front and center: people enjoying it, not a brochure" } },
  // s242 · `dulces-sin-propina` (Ali): en el mostrador no hay propina ni cuenta: hay compra, antes de impuestos.
  mostrador: { alcohol: false, propina: false, ...VISITA,
    toda: { es: "toda tu compra", en: "your whole purchase" }, la: { es: "la compra", en: "the purchase" },
    antesDe: { es: "antes de impuestos", en: "before tax" },
    cuenta: { es: "en tu compra", en: "on your purchase" },
    mismo: { es: "en el mismo local", en: "at the same venue" },
    paso2: { es: "Ve al negocio y pide tu beneficio", en: "Go to the business and ask for your benefit" },
    lleno: { es: "cuando vuelvas a tener lugar", en: "when you have room again" },
    otroMomento: { es: "la mañana, la tarde o las horas más tranquilas", en: "mornings, afternoons or your quieter hours" },
    excluye: ["especiales", "combos", "bebidas"],
    otraExclusion: { es: "Otra cosa: tortas enteras, encargos…", en: "Something else: whole cakes, custom orders…" },
    ticketAyuda: null,
    objetivos: { ...OBJ_SIN_MESA,
      algo_nuevo: { notaEs: "Un sabor o producto nuevo que quieres que prueben.", notaEn: "A new flavor or product you want people to try." },
      grupos: { es: "Grupos y pedidos grandes", en: "Groups and big orders", notaEs: "Cumpleaños, oficinas, familias.", notaEn: "Birthdays, offices, families." } },
    fotosDe: { es: "el local, tus productos, el ambiente", en: "the place, your products, the vibe" }, fotoProta: { es: "Tu producto de protagonista: un helado, un postre, la vitrina llena", en: "Your product front and center: an ice cream, a dessert, a full display" } },
  tienda: { alcohol: false, propina: false,
    visita: { es: "pedido", en: "order" }, visitas: { es: "pedidos", en: "orders" },
    toda: { es: "todo el pedido", en: "the whole order" }, la: { es: "el pedido", en: "the order" },
    antesDe: { es: "antes de impuestos", en: "before tax" },
    cuenta: { es: "en tu pedido", en: "on your order" },
    mismo: { es: "con el mismo negocio", en: "with the same business" },
    paso2: { es: "Pide tu beneficio al hacer el pedido", en: "Ask for your benefit when you place the order" },
    lleno: { es: "cuando vuelvas a tomar pedidos", en: "when you're taking orders again" },
    otroMomento: { es: "", en: "" },
    excluye: ["extras", "paquetes"],
    otraExclusion: { es: "Otra cosa: pedidos para eventos, diseños especiales…", en: "Something else: event orders, custom designs…" },
    ticketAyuda: { es: "Lo que cuesta un pedido típico, antes de impuestos y sin el envío.", en: "What a typical order costs, before tax and without delivery." },
    objetivos: { ...OBJ_SIN_MESA,
      algo_nuevo: { notaEs: "Un producto nuevo que quieres que prueben.", notaEn: "A new product you want people to try." },
      grupos: { es: "Pedidos grandes", en: "Big orders", notaEs: "Celebraciones, oficinas, eventos.", notaEn: "Celebrations, offices, events." } },
    fotosDe: { es: "tus productos, tu taller, tus mejores encargos", en: "your products, your workshop, your best orders" }, fotoProta: { es: "Tu producto de protagonista: una torta, un arreglo, un bouquet de globos", en: "Your product front and center: a cake, an arrangement, a balloon bouquet" } },
};
const perfilDelRubro = (categoria) => PERFIL_POR_FAMILIA[FAMILIA_POR_RUBRO[categoria]] || PERFIL_POR_FAMILIA.mesa;
// Las formas de decir la cuenta y el plazo que alguna vez se generaron: un título o una regla guardados con cualquiera
// de ellas se reconoce como generado y se rearma con la del rubro (no se toca el dato).
const FRASES_CUENTA = [...new Set(Object.values(PERFIL_POR_FAMILIA).flatMap(p => [p.cuenta.es, p.cuenta.en]))];
const FRASES_MISMO = [...new Set(Object.values(PERFIL_POR_FAMILIA).flatMap(p => [p.mismo.es, p.mismo.en]))];
// s240 (Ali, recorrido B) · «Hecho a pedido» se encarga y se recoge o se entrega: no hay lugar ni momento del día que
// elegir. En ese rubro no se muestran «Dónde vale», las franjas ni «Otra franja»: la oferta vale todo el horario, con
// retiro y con entrega (REGLA_ENTREGA). El canal guardado se ignora al armar las reglas.
const esEncargo = (categoria) => FAMILIA_POR_RUBRO[categoria] === "tienda";
// s222 · lote 2a · EL CANAL DE CANJE (`Offer.redemption_channel`, export 127; s194-D2). Tres valores y nada más:
// Bubble devuelve REDEMPTION_CHANNEL_INVALID con cualquier otro, y la UI solo puede mandar estos.
// Vacío = como hasta hoy: el «dónde vale» sale del rubro (FAMILIA_POR_RUBRO).
const CANALES_CANJE = [
  { id: "dine_in", es: "Solo en el local", en: "Dine-in only" },
  { id: "takeout", es: "En el local y para llevar", en: "In store and to go" },
  { id: "appointment", es: "Con cita", en: "By appointment" },
];
const CANAL_POR_FAMILIA = { mesa: "dine_in", cita: "appointment", reserva: "appointment", mostrador: "takeout", tienda: "dine_in" };
const canalValido = (v) => (CANALES_CANJE.some(c => c.id === v) ? v : "");
const canalDelRubro = (categoria) => CANAL_POR_FAMILIA[FAMILIA_POR_RUBRO[categoria]] || "dine_in";
// La línea de «dónde vale» de cada familia: con canal guardado, esa línea se cambia por la del canal.
const DONDE_POR_FAMILIA = { mesa: REGLA_SOLO_LOCAL, cita: REGLA_CITA, reserva: REGLA_RESERVA, mostrador: REGLA_LLEVAR, tienda: REGLA_PEDIDO };
const reglaDelCanal = (canal, familia) => {
  if (canal === "takeout") return REGLA_LLEVAR;
  if (canal === "appointment") return familia === "reserva" ? REGLA_RESERVA : REGLA_CITA;
  if (canal === "dine_in") return familia === "tienda" ? REGLA_PEDIDO : REGLA_SOLO_LOCAL;
  return null;
};
// Las que se ven, en orden: comunes + las del rubro. Sin rubro conocido, solo las comunes.
// s222 · con `canal` (el guardado en la oferta), la línea de «dónde vale» sale del canal y no del rubro.
const reglasDelRubro = (categoria, en, canal) => {
  const familia = FAMILIA_POR_RUBRO[categoria];
  const f = REGLAS_POR_FAMILIA[familia];
  const l = en ? "en" : "es";
  const base = f ? f[l] : [];
  const rc = familia === "tienda" ? null : reglaDelCanal(canalValido(canal), familia);
  if (familia === "tienda") {
    const comunes = REGLAS_COMUNES[l].map(r => (r === REGLA_MEMBRESIA[l] ? REGLA_MEMBRESIA_ENCARGO[l] : r === REGLA_MINIMO[l] ? REGLA_MINIMO_ENCARGO[l] : r));
    return [...comunes, ...base];
  }
  // s242 · `dulces-sin-propina`: sin propina en el rubro, el mínimo se cuenta solo antes de impuestos (la misma línea de encargos).
  const comunesRubro = PERFIL_POR_FAMILIA[familia] && !PERFIL_POR_FAMILIA[familia].propina
    ? REGLAS_COMUNES[l].map(r => (r === REGLA_MINIMO[l] ? REGLA_MINIMO_ENCARGO[l] : r)) : REGLAS_COMUNES[l];
  if (!rc) return [...comunesRubro, ...base];
  const donde = DONDE_POR_FAMILIA[familia];
  const conCanal = donde && base.includes(donde[l]) ? base.map(x => (x === donde[l] ? rc[l] : x)) : [...base, rc[l]];
  // s237-D3 · en «Hecho a pedido» el «dilo al pedir» se queda aunque el canal sea «para llevar».
  if (familia === "tienda" && !conCanal.includes(REGLA_PEDIDO[l])) conCanal.push(REGLA_PEDIDO[l]);
  return [...comunesRubro, ...conCanal];
};
// Todas las líneas fijas que alguna vez se guardaron (las seis de s194-s213, con la «mesa», y las de hoy):
// al leer rules_text se descartan y se rearman con el rubro. Lo que queda es lo propio del comercio.
// s223 · LAS REGLAS DEL %. Hasta s223 el alta clásica guardaba en un % solo «Aplican condiciones generales de NXT
// Reserve» y la ficha mostraba eso y nada más (visto en Live con el % de ZZ Wizard Fotos). Ahora se arman como las de la
// estándar: las del club según rubro y canal, sin la del mínimo (el % no tiene) y, en mesa, la del alcohol para el %.
const REGLA_ALCOHOL_PCT = { es: "El descuento no se aplica a bebidas con alcohol", en: "The discount doesn't apply to alcoholic drinks" };
// Lo que el alta guardaba antes en los tipos no estándar (y su traducción automática): no es del comercio.
const REGLAS_GENERICAS_VIEJAS = ["Aplican condiciones generales de NXT Reserve", "Standard NXT Reserve conditions apply", "General conditions of NXT Reserve apply"];
// s224 (Ali) · todo se dice «sin propina y antes de impuestos»: el % no tiene la regla del mínimo, así que lleva la suya.
const REGLA_PCT_BASE = { es: "El descuento se calcula sobre la cuenta antes de impuestos y propina", en: "The discount is calculated on the bill before tax and tip" };
const REGLA_PCT_BASE_ENCARGO = { es: "El descuento se calcula sobre el pedido, antes de impuestos", en: "The discount is calculated on the order, before tax" };
const REGLA_PCT_BASE_COMPRA = { es: "El descuento se calcula sobre la compra, antes de impuestos", en: "The discount is calculated on the purchase, before tax" };   // s242 · dulces
const reglasPorcentaje = (categoria, en, canal) => {
  const l = en ? "en" : "es";
  const pctBase = esEncargo(categoria) ? REGLA_PCT_BASE_ENCARGO : FAMILIA_POR_RUBRO[categoria] === "mostrador" ? REGLA_PCT_BASE_COMPRA : REGLA_PCT_BASE;
  const base = [...reglasDelRubro(categoria, en, canal).filter(r => r !== REGLA_MINIMO[l] && r !== REGLA_MINIMO_ENCARGO[l] && r !== REGLA_ALCOHOL[l]), pctBase[l]];
  return FAMILIA_POR_RUBRO[categoria] === "mesa" ? [...base, REGLA_ALCOHOL_PCT[l]] : base;
};
// Lo que se guarda en un %: las comunes sin la del mínimo (el resto lo arma la ficha), más lo propio del comercio.
const reglasPctGuardadas = (en) => REGLAS_COMUNES[en ? "en" : "es"].filter(r => r !== REGLA_MINIMO[en ? "en" : "es"]);
const REGLAS_FIJAS_TODAS = new Set([
  ...Object.values(REGLAS_COMUNES).flat(),
  ...Object.values(REGLAS_POR_FAMILIA).flatMap(f => [...f.es, ...f.en]),
  REGLA_ALCOHOL_PCT.es, REGLA_ALCOHOL_PCT.en,
  REGLA_PCT_BASE.es, REGLA_PCT_BASE.en,
  REGLA_PCT_BASE_ENCARGO.es, REGLA_PCT_BASE_ENCARGO.en, REGLA_PCT_BASE_COMPRA.es, REGLA_PCT_BASE_COMPRA.en,
  REGLA_MEMBRESIA_ENCARGO.es, REGLA_MEMBRESIA_ENCARGO.en, REGLA_MINIMO_ENCARGO.es, REGLA_MINIMO_ENCARGO.en,
  // s224 · la que escribe operator_add_offer en los % (rules_text_es armado en Bubble, visto en version-test): con «Sin
  // tope» su «hasta el tope» engaña, y al lado de REGLA_PCT_BASE salía repetida. Se descarta y se rearma la nuestra.
  "El descuento se calcula sobre la cuenta antes de impuestos y propina, hasta el tope de la oferta",
  ...REGLAS_GENERICAS_VIEJAS,
  // las de «dónde vale» por canal (s222), por si quedaron guardadas
  REGLA_SOLO_LOCAL.es, REGLA_SOLO_LOCAL.en, REGLA_LLEVAR.es, REGLA_LLEVAR.en, REGLA_CITA.es, REGLA_CITA.en,
  REGLA_RESERVA.es, REGLA_RESERVA.en, REGLA_TIENDA.es, REGLA_TIENDA.en,
  "Un beneficio por membresía: si van tú y tu acompañante, es uno para los dos. Cada miembro más en la mesa tiene el suyo",
  "One benefit per membership: you and your companion share one. Each other member at the table gets their own",
  // s212 · la de antes de «miembro»
  "Una oferta por socio, sin límite de mesa: cada socio cumple su propio mínimo",
  "One offer per member, no table limit: each member meets their own minimum",
]);
const esReglaFija = (linea) => REGLAS_FIJAS_TODAS.has(linea);
// s213 · EL PLAZO, ARMADO. Default 30 (s212-D18: lo que `confirm_offer`/`create_offer` toman de
// PricingConfig cuando la oferta no trae `cooldown_days`). El plazo vence a la medianoche de Miami
// (s212-D19, `redeem_coupon` del lote C). «Todos los días» = 1 (D17).
const COOLDOWN_POR_DEFECTO = 30;
// s233 · `plazo-default-por-rubro` (Ali, 18/10): el plazo con el que NACE una oferta sale del rubro. Comida y bebida
// (restaurantes —con café, comida rápida y pizzería—, bares, dulces y heladerías) → 15: queremos que vuelvan. Belleza,
// experiencias y regalos → 30. Es la recomendación: el dueño (u Otto) lo cambia cuando quiera. No toca lo ya sembrado.
const RUBROS_PLAZO_15 = ["Restaurant", "Bar_Rooftop", "Sweets"];
const plazoDelRubro = (categoria) => (RUBROS_PLAZO_15.includes(categoria) ? 15 : COOLDOWN_POR_DEFECTO);
// s232 · terminos-condiciones-merchant: los Términos para negocios aliados (nxtreserve.com/terminos-aliados/).
// `exigir`: la casilla aparece y frena el envío en el alta propia y en «Confirmar mi oferta» (casilla sin marcar + enlace
// visible + frase de aceptación expresa, como pide la jurisprudencia de Florida). `enviarParam`: true desde s234
// (Cowork sumó `terms_version` a signup_merchant / confirm_offer / invite_merchant en Live, 19/10 01:46 UTC; SPEC_s232 §2).
// La versión es la misma que publica la página (data-terms-version) y la que Ali carga en PricingConfig.terms_current_version.
const TERMINOS_ALIADOS = { version: "2026-11", url: "https://nxtreserve.com/terminos-aliados/", exigir: true, enviarParam: true };
// s234-D1 · terminos-aceptacion-panel-para-invitados (Ali): la casilla de la invitación corre sin sesión (Otto puede
// marcarla por el dueño), así que `via = "invitacion"` es una pre-aceptación. El dueño la vuelve a ver en «Confirma tu
// oferta» y, al confirmar, Bubble guarda `via = panel` con su correo de sesión (guard bTJul/bTJum de confirm_offer).
const terminosAceptadosAlDia = (perfil) => !!(perfil?.terms_accepted_at
  && String(perfil?.terms_version || "") === TERMINOS_ALIADOS.version
  && String(perfil?.terms_accepted_via || "") !== "invitacion");
const diasPlazo = (o) => (Number(o?.cooldown_days) > 0 ? Number(o.cooldown_days) : COOLDOWN_POR_DEFECTO);
// s241 · con `categoria`, «en el mismo local» sale del perfil del rubro (en encargos, «con el mismo negocio»).
const reglaPlazo = (dias, en, categoria) => {
  const d = Number(dias) > 0 ? Number(dias) : COOLDOWN_POR_DEFECTO;
  const mismo = perfilDelRubro(categoria).mismo[en ? "en" : "es"];
  if (d === 1) return en ? `Once a day ${mismo}, renewed at midnight Miami time` : `Una vez al día ${mismo}, se renueva a la medianoche de Miami`;
  return en ? `Once every ${d} days ${mismo}, counted from midnight Miami time` : `Una vez cada ${d} días ${mismo}, contados desde la medianoche de Miami`;
};
// Las ofertas ya guardadas traen «Repetible cada 90 días…» en rules_text: se reconoce y se reemplaza
// por la línea armada con SU plazo (la de la base dice 90 aunque la oferta tenga otro).
// s213 · lote B+C · EL PLAN de la oferta (option set OfferPlan, export 95). El API manda y devuelve el
// Display (`cita`…); el texto visible es el `label_es` del option set, copiado acá igual. Ronda 10:
// «Con tu amiga» excluía (Héctor) → por eso son estos seis.
const PLANES_OFERTA = [
  { id: "cita",            es: "Para una cita",       en: "For a date" },
  { id: "pareja",          es: "En pareja",           en: "As a couple" },
  { id: "amigos",          es: "Con amigos",          en: "With friends" },
  { id: "familia",         es: "En familia",          en: "With family" },
  { id: "consentirte",     es: "Para consentirte",    en: "To treat yourself" },
  { id: "despues_trabajo", es: "Después del trabajo", en: "After work" },
  // s240 (Ali) · planes de «Hecho a pedido» (OfferPlan +2 en Bubble, pedido a Cowork).
  { id: "regalar",         es: "Para regalar",        en: "To give as a gift" },
  { id: "celebrar",        es: "Para celebrar",       en: "To celebrate" },
];
// Los planes que se ofrecen según el rubro: en «Hecho a pedido», los de regalo; en los demás, los de salida.
const PLANES_ENCARGO = ["regalar", "celebrar", "consentirte"];
const planesDelRubro = (categoria) => (esEncargo(categoria)
  ? PLANES_ENCARGO.map(id => PLANES_OFERTA.find(p => p.id === id))
  : PLANES_OFERTA.filter(p => p.id !== "regalar" && p.id !== "celebrar"));
// Tolera el Display o el label (por si un WF devuelve el texto): lo que no se reconoce no se pinta.
const etiquetaPlan = (plan, en) => {
  const v = String(plan || "").trim();
  const p = v && PLANES_OFERTA.find(x => x.id === v || x.es === v);
  return p ? (en ? p.en : p.es) : "";
};
// s213 · el selector de plazo (D16/D17): 1 = una vez por día.
// s235 · siembra-plazo-todos-los-dias-confunde (Ali): decía «Todos los días», que se leía como los días de la semana
// de «Cuándo vale» (que también tienen «Todos los días»). Ahora dice lo que es, como la regla de la ficha
// («Una vez al día en el mismo local» desde s239-D5).
const etiquetaPlazo = (d, en) => (Number(d) === 1 ? (en ? "Once a day" : "Una vez al día") : (en ? `Every ${d} days` : `Cada ${d} días`));
const esReglaPlazoGuardada = (linea) => /^Repetible cada \d+ d[ií]as en el mismo local$/.test(linea) || /^Repeatable every \d+ days at the same venue$/.test(linea);
// s223 · la línea que arma reglaPlazo, si quedó guardada en rules_text (las ofertas del wizard de s223 la guardaban):
// se reconoce para no mostrarla repetida ni con un plazo viejo. La que se ve se arma siempre desde cooldown_days.
const esReglaPlazoArmada = (linea) => FRASES_MISMO.some(m => new RegExp(`^(Una vez (cada \\d+ días|por día|al día)|Once (every \\d+ days|a day)) ${m}`).test(linea));
const esUmbral = (o) => String(o?.offer_type || "").toLowerCase() === UMBRAL_TIPO;
// s234 · las frases de alcance que arma el alta (wizard y estándar) cuando no hay más texto: ver OfferDetailPage.
const FRASES_ALCANCE = new Set(["Aplica a toda la cuenta.", "Aplica a tu servicio.", "Aplica a toda tu compra.",
  "Applies to the whole bill.", "Applies to your service.", "Applies to your whole purchase.",
  "Aplica a comida y bebidas sin alcohol.", "Applies to food and non-alcoholic drinks.",
  "Aplica a la comida.", "Applies to food."]);
// s239 · auditoría s237-D6: una sola forma de decir el alcohol, la de REGLA_ALCOHOL. En restaurantes y bares «Aplica a
// toda la cuenta.» era falso (el alcohol no lleva descuento): la frase corta de alcance dice lo mismo que la regla.
const ALCANCE_SIN_ALCOHOL = { es: "Aplica a comida y bebidas sin alcohol.", en: "Applies to food and non-alcoholic drinks." };
// s255 · `exclusiones-frase-contradictoria`: en restaurantes y bares, si el dueño marca «Bebidas», el miembro no puede leer «comida y bebidas».
const ALCANCE_SOLO_COMIDA = { es: "Aplica a la comida.", en: "Applies to food." };
const ALCANCE_TODA_LA_CUENTA = { es: "Aplica a toda la cuenta.", en: "Applies to the whole bill." };
const fraseAlcance = (categoria, en) => (RUBROS_TICKET_MESA.includes(categoria) ? ALCANCE_SIN_ALCOHOL[en ? "en" : "es"]
  : ["Salon_Spa", "Nail_Lash"].includes(categoria) ? (en ? "Applies to your service." : "Aplica a tu servicio.")
  : (en ? "Applies to your whole purchase." : "Aplica a toda tu compra."));
// Lo ya guardado con «Aplica a toda la cuenta.» en un restaurante o bar se lee con la frase correcta (no se toca el dato).
const corregirAlcance = (texto, categoria, en) => {
  const s = String(texto || "");
  if (!RUBROS_TICKET_MESA.includes(categoria)) return s;
  for (const l of ["es", "en"]) if (s.trim().startsWith(ALCANCE_TODA_LA_CUENTA[l])) return s.replace(ALCANCE_TODA_LA_CUENTA[l], ALCANCE_SIN_ALCOHOL[l]);
  return s;
};
// s256 · tarjeta-como-m-ejemplo: el alcance de UNA oferta para la frase de la tarjeta. Primero el que trae su descripción
// (empieza con «Aplica a …», ya corregido por rubro; respeta «Aplica a la comida.» cuando el dueño excluyó las bebidas, s255);
// si no lo trae, la regla del rubro. `resto` es lo que va después de «Aplica a» (sin el punto); `frase`, la oración entera.
const alcanceDeLaOferta = (offer, en) => {
  const o = offer || {};
  const desc = corregirAlcance((en ? (o.description_en || o.description_es) : (o.description_es || o.description_en)) || "", o.category, en).trim();
  const leer = (s) => { const m = String(s || "").match(/^(?:Aplica a|Applies to)\s+([^.]+)\./i); return m ? { resto: m[1].trim(), frase: m[0].trim() } : null; };
  return leer(desc) || (o.category ? leer(fraseAlcance(o.category, en)) : null);
};
// s251 · sin web, la IA de la siembra omitió la frase de alcance 7 de 7 veces, aun con el prompt v4.8. Se pone aquí, en el texto
// sugerido: si falta se agrega al inicio, y si trae la de otro rubro se cambia por la correcta.
const conFraseAlcance = (texto, categoria) => {
  const s = String(texto || "").trim();
  if (!s) return "";
  const frase = fraseAlcance(categoria, false);
  if (s.startsWith(frase)) return s;
  const otra = [...FRASES_ALCANCE].find(f => s.startsWith(f));
  return `${frase} ${otra ? s.slice(otra.length).trim() : s}`.trim();
};
const montoUmbral = (o) => Number(o?.benefit_value_usd ?? o?.benefit_value) || 0;
const minimoUmbral = (o) => Number(o?.min_consumption) || 0;
// s194-D4/D5: Destacada si y solo si es «$50 si gastas $100». El guard de Bubble usa esta
// misma condición (offer_type = "umbral" y benefit ≥ 50 y min_consumption ≥ 100): si
// cambia acá, cambia allá.
const esDestacada = (o) => esUmbral(o) && montoUmbral(o) >= 50 && minimoUmbral(o) >= 100;
// La frase que lee el socio, escrita UNA vez. Chica (mínimo = monto, s194-D13):
// «$10 para gastar». Las demás: «Ahorra $30 cuando gastas $60» (s212: era «Recibe $30 si gastas $60»;
// en la ronda 10, 4 de 4 leyeron «Recibe» como crédito o vale). La misma frase que la vitrina (s211-D7).
const fraseUmbral = (monto, minimo, en) => {
  const m = fmtUsd(monto), n = fmtUsd(minimo);
  if (!(Number(minimo) > Number(monto))) return en ? `$${m} to spend` : `$${m} para gastar`;
  return en ? `Save $${m} when you spend\u00A0$${n}` : `Ahorra $${m} cuando gastas\u00A0$${n}`;
};
// La frase de antes de s212: hay títulos guardados con ella y tienen que seguir reconociéndose como generados.
const fraseUmbralVieja = (monto, minimo, en) => {
  const m = fmtUsd(monto), n = fmtUsd(minimo);
  if (!(Number(minimo) > Number(monto))) return en ? `$${m} to spend` : `$${m} para gastar`;
  return en ? `Get $${m} when you spend $${n}` : `Recibe $${m} si gastas $${n}`;
};
// La regla del mínimo debajo de la tarjeta de valor (ficha, alta, canje).
// s212 · Ali: el mínimo es «desde» (≥). Antes decía «debe superar» (>).
// s242 · `dulces-sin-propina`: con la categoría, se dice con el rubro («en la compra, antes de impuestos» en dulces; «en el
// pedido» en encargos). Sin categoría, la de siempre.
const reglaMinimoUmbral = (minimo, en, categoria) => {
  const p = categoria ? perfilDelRubro(categoria) : null;
  if (p && !p.propina) return en ? `For ${p.la.en.replace(/^the /, "")}s of $${fmtUsd(minimo)} or more, ${p.antesDe.en}` : `Desde $${fmtUsd(minimo)} en ${p.la.es}, ${p.antesDe.es}`;
  return en ? `For bills of $${fmtUsd(minimo)} or more, before tax and tip` : `Desde $${fmtUsd(minimo)} en la cuenta, antes de impuestos y propina`;
};
// s201 · EL VEREDICTO DEL CANJE, CON EL NUMERO. Desde el export 87 `redeem_coupon` devuelve
// `benefit_amount`, `min_spend` y `offer_id` en sus dos Return de exito. Lo que NO devuelve
// es el tipo de oferta, y en Live siguen aprobadas ofertas del modelo viejo (2x1, 30%): ahi
// «Descuentale $X» seria falso. Por eso el monto solo se dice si `offer_id` es una de las
// umbral del comercio (`umbralIds`). Si esa lista no cargo, o el cupon no esta en ella
// (oferta de otro tipo, o pausada despues de activado), queda la frase de siempre.
// s221-D1 · ahora recibe las OFERTAS del comercio (no solo los ids umbral) y la cuenta: en un % el monto
// sale de min(cuenta × %, tope), igual que lo guarda `redeem_coupon` (export 125). El `benefit_amount` del
// Return es el tope de la oferta, no lo descontado: en un % no se usa.
const detalleCanje = (resp, ofertas, en, cuenta) => {
  const oferta = resp?.offer_id && Array.isArray(ofertas) ? ofertas.find(o => o._id === resp.offer_id) : null;
  if (oferta && esPorcentaje(oferta) && Number(oferta.discount_pct) > 0) {
    const f = fraseDescuentoCuenta(cuenta, Number(oferta.discount_pct), Number(oferta.benefit_value_usd) || 0, en);
    return f ? `${f}.` : (en ? "You can apply the benefit now." : "Ya puedes aplicar el beneficio.");
  }
  const umbralIds = Array.isArray(ofertas) ? ofertas.filter(esUmbral).map(o => o._id) : null;
  const esDeUmbral = !!(resp?.offer_id && Array.isArray(umbralIds) && umbralIds.includes(resp.offer_id));
  const monto = esDeUmbral ? Number(resp.benefit_amount) || 0 : 0;
  const minimo = esDeUmbral ? Number(resp.min_spend) || 0 : 0;
  if (!(monto > 0)) return en ? "You can apply the benefit now." : "Ya puedes aplicar el beneficio.";
  return (en ? `Take $${fmtUsd(monto)} off.` : `Descuéntale $${fmtUsd(monto)}.`)
    + (minimo > monto ? " " + reglaMinimoUmbral(minimo, en, oferta?.category) + "." : "");
};
// s221-D1 · LA OFERTA DE PORCENTAJE vuelve como segunda opción. Se guarda sin campos nuevos:
// `offer_type "percent"` + `discount_pct` (≥ 20, el piso del club) + `benefit_value_usd` = el TOPE
// por visita + `regular_price` derivado (la cuenta en la que se llega al tope). El canje (export 125,
// `redeem_coupon` pasos 10-11) guarda min(cuenta × %, tope); sin cuenta guarda $0. Por eso el
// miembro nunca ve «Ahorras $X» en un %: no hay cuenta supuesta, hay «−20 % en tu cuenta · hasta $25».
// «Sin tope» (3-bis) = un tope de $1.000 que no se dice: el canje suma la cuenta real × %.
const PCT_MINIMO = 20;
const TOPE_SIN_LIMITE = 1000;
// s221 (Ali, 00:09 UTC) · marcar «Sin tope» pide confirmación, en el alta y en la siembra de Otto.
const avisoSinTope = (en) => (en
  ? "With no cap, a big table can cost you more (for example, a table of 6 at $150 with 20% off is $30). Are you sure?"
  : "Sin tope, una mesa grande puede costarte más (por ejemplo, una mesa de 6 con $150 al 20 % son $30). ¿Seguro?");
const esPorcentaje = (o) => String(o?.offer_type || "").toLowerCase() === "percent";
// s238 · pct-barrido: «la oferta que prepara el club» (la que se siembra, se confirma y se edita como sembrada) es monto fijo
// O porcentaje — desde s236-D5/s237-D3 el % es el formato por defecto de salones y «Hecho a pedido». Usar ESTO, no
// esUmbral, para esas preguntas. Revisión: `grep -n "esUmbral(" src/App.jsx | grep -v "esPorcentaje\|esFormatoClub"`;
// cada resultado tiene que ser algo solo de monto fijo a propósito (Destacada, la frase «Ahorra $X cuando gastas $Y»).
const esFormatoClub = (o) => esUmbral(o) || esPorcentaje(o);
const esSinTope = (tope) => Number(tope) >= TOPE_SIN_LIMITE;
// La cuenta en la que se llega al tope: 20 % hasta $25 → 125.
const precioRegularDePct = (tope, pct) => (Number(pct) > 0 ? Math.round((Number(tope) * 100 / Number(pct)) * 100) / 100 : 0);
// s223 · EL PRECIO REGULAR DEL 2×1. `approve_offer` pide regular_price > 0 (OFFER_PRICE_INVALID) y que el beneficio
// no lo supere (OFFER_BENEFIT_EXCEEDS_PRICE). En un 2×1 el beneficio es un plato (unit_price) y el precio regular, los
// dos. El alta lo mandaba en 0 (PRICE_FIELDS_BY_TYPE.bogo no lo muestra y las plantillas no lo traen): un 2×1 creado
// desde el alta no se podía aprobar. Un precio guardado que ya cubre el plato se respeta.
// Sin unit_price (2×1 viejos: «2x1 en Cócteles Premium» de test tiene unit 0 y beneficio $30), el plato es el beneficio.
const precioRegularDe2x1 = (unit, guardado, beneficio) => {
  const u = Number(unit) || Number(beneficio) || 0, g = Number(guardado) || 0;
  return g > 0 && g >= u ? g : Math.round(u * 2 * 100) / 100;
};
const chipPorcentaje = (pct, en) => (en ? `−${pct}%` : `−${pct} %`);   // U+2212; en español, con espacio duro
// «hasta $25», o nada si no hay tope o es «Sin tope».
const hastaTope = (tope, en) => (Number(tope) > 0 && !esSinTope(tope) ? (en ? `up to $${fmtUsd(tope)}` : `hasta $${fmtUsd(tope)}`) : "");
// s241 · con `categoria`, la palabra sale del perfil del rubro: en encargos «en tu pedido» (perfil-por-rubro).
const enTuCuenta = (en, categoria) => perfilDelRubro(categoria).cuenta[en ? "en" : "es"];
// La frase entera, escrita UNA vez: tarjeta, ficha, botón, título sugerido.
const frasePorcentaje = (pct, tope, en, categoria) => {
  const h = hastaTope(tope, en);
  return `${chipPorcentaje(pct, en)} ${enTuCuenta(en, categoria)}${h ? ` · ${h}` : ""}`;
};
// El título sugerido del alta (el comercio lo puede cambiar): «20 % en tu cuenta · hasta $25».
const tituloPorcentaje = (pct, tope, en, categoria) => {
  const h = hastaTope(tope, en);
  return `${pct}${en ? "%" : " %"} ${enTuCuenta(en, categoria)}${h ? ` · ${h}` : ""}`;
};
// s253 · la galería del negocio tal como la trae get_merchant_profile (lista o una sola URL; «//cdn…» sin https).
const galeriaDelPerfil = (p) => [...new Set((Array.isArray(p?.gallery) ? p.gallery : (p?.gallery ? [p.gallery] : []))
  .map(u => (String(u || "").startsWith("//") ? "https:" + u : String(u || "").trim())).filter(Boolean))];
// s253 · lo que el bloque «¿Prefieres porcentaje?» deja escrito en el formulario (Ali: «aunque sea, los destacados del
// negocio»). Regla, sin IA, solo con datos que ya están en el perfil (get_merchant_profile): nombre, especialidad y el
// rating de Google. Todo queda editable. Sin un dato, la línea no lo nombra (no se inventa).
const textosDelPct = ({ pct, tope, en, categoria, perfil = {} }) => {
  const negocio = String(perfil.business_name || "").trim();
  const especialidad = String(perfil.specialty || "").trim();
  const rating = Number(perfil.rating) || 0;
  const corto = (s) => (s.length > 40 ? s.slice(0, 39).trimEnd() + "…" : s);
  const cuenta = enTuCuenta(en, categoria);
  const conTope = Number(tope) > 0 && !esSinTope(tope);
  const description = [
    en ? `${pct}% off ${cuenta.replace(/^on /, "")}${negocio ? ` at ${negocio}` : ""}, any day you come.`
      : `${pct} % de descuento ${cuenta}${negocio ? ` en ${negocio}` : ""}, cualquier día que vengas.`,
    especialidad ? (en ? `Their specialty: ${especialidad}.` : `Su especialidad: ${especialidad}.`) : "",
    fraseAlcance(categoria, en),
  ].filter(Boolean).join(" ");
  const h3 = rating > 0 ? (en ? `${rating.toFixed(1)} ★ on Google` : `${rating.toFixed(1)} ★ en Google`)
    : especialidad ? corto(especialidad) : (en ? "Any day" : "Cualquier día");
  return {
    description,
    highlight_1: conTope ? (en ? `Up to $${fmtUsd(tope)} per visit` : `Hasta $${fmtUsd(tope)} por visita`) : `${pct}${en ? "%" : " %"} ${cuenta}`,
    highlight_2: en ? "No minimum spend" : "Sin mínimo de consumo",
    highlight_3: h3,
  };
};
// La traducción automática (translate_offer_text) escribe «to your account» (medido en test, s221): también es generado.
// s223 · las ofertas por franja (wizard de la primera oferta, y las dos franjas del alta) guardan el título con « · Cena»
// al final. Esa cola no lo vuelve «escrito por el comercio»: la frase sigue siendo la generada. partirFranja la separa.
// s224 · más los momentos nuevos del wizard (brunch, happy hour, noche; mañana y tarde en los demás rubros).
const ETIQUETAS_FRANJA = ["Desayuno", "Almuerzo", "Merienda", "Cena", "Breakfast", "Lunch", "Afternoon snack", "Dinner",
  "Brunch", "Happy hour", "Noche", "Late night", "Mañana", "Morning", "Tarde", "Afternoon", "Evening"];
const partirFranja = (title) => {
  const s = String(title || "");
  for (const e of ETIQUETAS_FRANJA) {
    const sufijo = ` · ${e}`;
    if (s.endsWith(sufijo)) return { base: s.slice(0, -sufijo.length), franja: e, sufijo };
  }
  return { base: s, franja: "", sufijo: "" };
};
const esTituloPorcentajeGenerado = (title) => {
  const base = partirFranja(title).base;
  const frases = [...FRASES_CUENTA, "to your account", "on your account"].join("|");
  return !base || new RegExp(`^\\d+(\\u00A0| )?% (${frases})( · (hasta|up to) \\$[\\d.]+)?$`).test(base);
};
// s237-D5 · `invite_merchant` cambia `discount_pct` y `benefit_value_usd` cuando el dueño elige otro % en la invitación,
// pero NO el título (D5-A): «25 % en tu cuenta» quedaría con la oferta ya al 30 %. Un título generado se rearma con el %
// y el tope reales (con su « · Cena» si la tiene); el que escribió Otto o el comercio («Manicura en gel») queda igual.
const tituloOfertaVisible = (o, en) => {
  const t = (en ? (o?.title_en || o?.title_es) : (o?.title_es || o?.title_en)) || "";
  if (!t || !esPorcentaje(o) || !(Number(o?.discount_pct) > 0) || !esTituloPorcentajeGenerado(t)) return t;
  return tituloPorcentaje(Number(o.discount_pct), o.benefit_value_usd, en, o.category) + partirFranja(t).sufijo;
};
// Lo que se descuenta en un canje: min(cuenta × %, tope), a centavos. Lo mismo que hace Bubble.
const descuentoPorcentaje = (cuenta, pct, tope) => {
  const c = Number(cuenta), p = Number(pct), t = Number(tope);
  if (!(c > 0) || !(p > 0)) return { monto: 0, alTope: false };
  const bruto = Math.round(c * p) / 100;
  return t > 0 && bruto >= t ? { monto: t, alTope: !esSinTope(t) } : { monto: bruto, alTope: false };
};
// «Descuenta $16 (20 %)» / «Descuenta $25 (tope)». Con «Sin tope», nunca «(tope)».
const fraseDescuentoCuenta = (cuenta, pct, tope, en) => {
  const d = descuentoPorcentaje(cuenta, pct, tope);
  if (!(d.monto > 0)) return "";
  const detalle = d.alTope ? (en ? "cap" : "tope") : (en ? `${pct}%` : `${pct} %`);
  return en ? `Take $${fmtUsd(d.monto)} off (${detalle})` : `Descuenta $${fmtUsd(d.monto)} (${detalle})`;
};
// Para ordenar por valor: en un % el número es el tope (con «Sin tope», 0: no hay cifra que prometer).
const valorDeOferta = (o) => {
  const v = Number(o?.benefit_value_usd ?? o?.benefit_value) || 0;
  return esPorcentaje(o) && esSinTope(v) ? 0 : v;
};
// Una línea corta del valor, para listas (admin, mis ofertas, correos): nunca «$1000» por un «Sin tope».
const textoValorOferta = (o, en) => {
  if (esPorcentaje(o) && Number(o?.discount_pct) > 0) return frasePorcentaje(Number(o.discount_pct), Number(o.benefit_value_usd ?? o.benefit_value) || 0, en, o.category);
  if (esUmbral(o) && montoUmbral(o) > 0) return fraseUmbral(montoUmbral(o), minimoUmbral(o), en);
  const v = Number(o?.benefit_value_usd ?? o?.benefit_value) || 0;
  return v > 0 ? `$${fmtUsd(v)}` : "";
};
const tamanoDeUmbral = (monto, minimo) =>
  UMBRAL_TAMANOS.find(t => t.monto === Number(monto) && t.minimo === Number(minimo)) || null;
// Un título es «generado» si es exactamente la frase de algún tamaño, en cualquiera de los
// dos idiomas: ese se puede pisar al cambiar de tamaño; lo que escribió el comercio, no.
// s223 · con « · Cena» al final también (partirFranja): la tarjeta y la ficha repetían el monto en esas ofertas.
// Y con los espacios normalizados: fraseUmbral pone un espacio duro antes del mínimo, pero Bubble guarda el título con
// espacio común (medido en Live: «Ahorra $20 cuando gastas $40 · Cena», sin U+00A0). Sin esto, ningún título estándar
// guardado se reconocía como generado.
const ESPACIO_DURO = String.fromCharCode(160);
const sinEspacioDuro = (x) => String(x || "").split(ESPACIO_DURO).join(" ");
const esTituloUmbralGenerado = (title) => {
  const base = sinEspacioDuro(partirFranja(title).base);
  return !base
    || UMBRAL_TAMANOS.some(t => [false, true].some(en => base === sinEspacioDuro(fraseUmbral(t.monto, t.minimo, en)) || base === sinEspacioDuro(fraseUmbralVieja(t.monto, t.minimo, en))));
};
// s250 · el título dice un monto y el tamaño elegido otro: el dinero sale del tamaño (Ciao Bellissimi: $20/$60 y $30/$60).
// Vale para cualquier cifra en dólares del título («$20 de descuento», «Save $20…», «20 dólares»), no solo para la frase.
const MONTO_EN_TITULO = /\$\s?(\d+(?:\.\d+)?)|(\d+(?:\.\d+)?)\s?(?:d[oó]lares|usd)\b/gi;
const tituloContradiceMonto = (title, monto, minimo) => [...String(title || "").matchAll(MONTO_EN_TITULO)]
  .some(m => ![Number(monto), Number(minimo)].includes(Number(m[1] ?? m[2])));

// s215 · Ali (ensayo con Otto): en restaurantes y bares el dueño sabe su ticket POR MESA, no por persona
// (supersede la pregunta de s195/s194-D13 para esos dos rubros). Se pregunta la mesa de dos y, por dentro,
// se divide entre 2 para usar la MISMA tabla de tamaños (que es por persona). Los demás rubros: por persona,
// con su propia palabra. Lo usan el alta/edición (PreciosUmbral) y la consola de Otto.
// s236 (Ali, 21/10 · DECISIONES_s236_tablas_restaurantes_comida_rapida.md): POR PERSONA en todas las pantallas, también
// en restaurantes y bares (cambia s215). Es el número que da Google y el que dice Otto; la mesa de dos queda solo como
// explicación en el recibo de ejemplo. `divisor` queda siempre en 1 para no romper a quien lo lee.
const RUBROS_TICKET_MESA = ["Restaurant", "Bar_Rooftop"];
const preguntaTicket = (categoria, en) => {
  if (RUBROS_TICKET_MESA.includes(categoria)) return {
    divisor: 1, unidad: en ? "per person" : "por persona", ej: "35",
    texto: en ? "How much does one person spend on average?" : "¿Cuánto gasta una persona, en promedio?",
    pista: en ? "Food and drinks, before tax and tip. We use it only to suggest a size." : "Comida y bebida, sin impuestos ni propina. Solo sirve para sugerirte un tamaño.",
  };
  const porRubro = {
    Salon_Spa: [en ? "How much does a typical service cost?" : "¿Cuánto cuesta un servicio típico?", "45"],
    Nail_Lash: [en ? "How much does a typical service cost?" : "¿Cuánto cuesta un servicio típico?", "45"],
    Sweets: [en ? "How much does one person spend on average?" : "¿Cuánto gasta una persona, en promedio?", "12"],
    Gift_Moments: [en ? "How much is a typical purchase?" : "¿Cuánto cuesta una compra típica?", "40"],
    Experience: [en ? "How much does one person pay for the experience?" : "¿Cuánto paga una persona por la experiencia?", "60"],
  }[categoria] || [en ? "How much does one person spend, before tip?" : "¿Cuánto gasta una persona, sin propina?", "35"];
  return {
    divisor: 1, unidad: en ? "per person" : "por persona", ej: porRubro[1], texto: porRubro[0],
    pista: en ? "What one person pays. We use it only to suggest a size." : "Lo que paga una persona. Solo sirve para sugerirte un tamaño.",
  };
};
// El número que entra a la tabla de tamaños (por persona).
const ticketPorPersona = (categoria, valor) => {
  const n = Number(String(valor || "").replace(/[$\s]/g, "").replace(",", "."));
  return n > 0 ? n / preguntaTicket(categoria, false).divisor : 0;
};

// s184 · HORARIOS QUE EXISTEN Y NO SE VEÍAN. El comercio carga sus horarios en el
// editor del panel, que los guarda en `business_hours_json`; el texto plano
// `business_hours` solo lo escribe el alta con Places (lo redacta Google). Los dos
// consumidores públicos —la ficha de oferta y /m/:id— leían ÚNICAMENTE el texto, así
// que un comercio que cargó sus horarios a mano mostraba el bloque vacío. Medido en
// producción sobre los 13 approved: 4 tienen horario y DOS de ellos (Otto BBQ, Ali
// restaurante) lo tienen solo en json. La mitad de los horarios cargados, invisibles.
//
// Dos cuidados que el dato real impone:
//  · El json se guarda con los SIETE días siempre, vacíos incluidos (así lo serializa
//    el editor). Ali restaurante tiene los 7 en blanco: renderizarlo tal cual daría
//    siete renglones mudos, peor que no mostrar nada. Solo entran los días con dato.
//  · `closed` viaja aparte de los rangos: un día cerrado se DICE, no se omite —
//    «Mié cerrado» es información; una fila ausente es una duda.
// Devuelve el mismo shape que el parseo del texto: [{dia, valor}]. Sin días con dato
// devuelve [] y el bloque no se dibuja, igual que hoy.
function horarioDesdeJson(raw, en) {
  if (!raw) return [];
  let arr;
  try { arr = typeof raw === "string" ? JSON.parse(raw) : raw; } catch (e) { return []; }
  if (!Array.isArray(arr)) return [];
  const rango = (o, c) => (o && c ? `${o}–${c}` : "");   // U+2013, el mismo que usa Google
  return MERCHANT_DAYS.map(d => {
    const m = arr.find(x => x && x.day === d.key);
    if (!m) return null;
    if (m.closed === true) return { dia: en ? d.en : d.es, valor: en ? "Closed" : "Cerrado" };
    const valor = [rango(m.r1o, m.r1c), rango(m.r2o, m.r2c)].filter(Boolean).join(", ");
    return valor ? { dia: en ? d.en : d.es, valor } : null;
  }).filter(Boolean);
}

function resolverAhorro(offer, lang) {
  const en = lang === "en";
  const o = offer || {};
  const tipo = (o.offer_type || "").toLowerCase();
  const num = (v) => { const n = Number(v); return isFinite(n) && n > 0 ? n : 0; };

  const regular = num(o.regular_price);
  const coupon  = num(o.coupon_price);
  const unit    = num(o.unit_price);
  const pct     = num(o.discount_pct);
  const benefit = num(o.benefit_value_usd) || num(o.benefit_value);

  const AHORRAS   = en ? "You save" : "Ahorras";
  const TE_LLEVAS = en ? "You get" : "Te llevas";
  const chipAhorro = (n) => (en ? `You save $${fmtUsd(n)}` : `Ahorras $${fmtUsd(n)}`);
  const chipPct = (n) => `−${n}%`;                       // U+2212, no guion
  const vacio = { etiqueta: null, lidera: null, insignia: null, precios: null, porConfirmar: false, monto: 0, mecanica: null };
  // s196 · `monto` y `mecanica` son para la TARJETA, que pinta todos los tipos con UNA
  // sola estructura: «Ahorras $X · mecánica» (decisión de Ali). `monto` es el MISMO número
  // que ya sale en «Ahorras $X» en cada rama (una sola fuente, CLAIMS §2); `mecanica` es
  // lo que el socio se lleva dicho en corto. Los campos de siempre no cambian: la ficha
  // los sigue usando igual. La REGLA DEL 100 (D-119) queda solo para la ficha — en la
  // tarjeta el ahorro ya no es titular y el dólar va siempre primero.

  // umbral (s194 L1) — el formato único. `benefit_value_usd` es lo que recibe el socio y
  // `min_consumption` lo que tiene que gastar; la frase es siempre la misma (fraseUmbral).
  // `umbral` viaja en el resultado para que la tarjeta y la ficha pinten la píldora y la
  // regla del mínimo sin recalcular nada (una sola fuente de la cifra, CLAIMS §2).
  if (tipo === UMBRAL_TIPO && benefit > 0) {
    const minimo = num(o.min_consumption);
    const paraGastar = !(minimo > benefit);                  // S y M: mínimo = monto
    return { ...vacio,
      etiqueta: paraGastar ? TE_LLEVAS : (en ? "Save" : "Ahorra"),
      lidera: `$${fmtUsd(benefit)}`,
      insignia: paraGastar
        ? (en ? "to spend" : "para gastar")
        : (en ? `when you spend\u00A0$${fmtUsd(minimo)}` : `cuando gastas\u00A0$${fmtUsd(minimo)}`),
      umbral: { monto: benefit, minimo, paraGastar, frase: fraseUmbral(benefit, minimo, en), destacada: esDestacada(o) },
      monto: benefit,
      mecanica: paraGastar ? null : (en ? `when you spend\u00A0$${fmtUsd(minimo)}` : `cuando gastas\u00A0$${fmtUsd(minimo)}`),
    };
  }

  // fixed — el único tipo con línea de precios: el final no desaparece, baja.
  if (tipo === "fixed" && regular > 0 && coupon > 0) {
    const ahorro = regular - coupon;
    const p = Math.round((1 - coupon / regular) * 100);
    const precios = { lista: `$${fmtUsd(regular)}`, final: `$${fmtUsd(coupon)}` };
    const tarjeta = { monto: ahorro, mecanica: chipPct(p) };
    return regular >= 100
      ? { ...vacio, ...tarjeta, etiqueta: AHORRAS,   lidera: `$${fmtUsd(ahorro)}`, insignia: chipPct(p),   precios }
      : { ...vacio, ...tarjeta, etiqueta: TE_LLEVAS, lidera: chipPct(p),   insignia: chipAhorro(ahorro), precios };
  }

  // bogo — la mecánica ES el líder. El unit_price es lo que el miembro no paga.
  if (tipo === "bogo" && unit > 0) {
    return { ...vacio, etiqueta: TE_LLEVAS, lidera: "2×1", insignia: chipAhorro(unit), monto: unit, mecanica: "2×1" };
  }

  // percent — el ahorro sale del ticket (s156-D3); sin ticket cae al benefit guardado.
  //
  // s184: aca habia un Math.round que se comia los centavos, y con el formateo nuevo
  // quedo a la vista: «30% off en corte + barba» sobre un ticket de $45 mostraba
  // «Ahorras $14» mientras su `benefit_value_usd` guardado es 13.5 — de modo que la
  // tarjeta prometia una cifra y la franja de ahorro, que suma los canjes reales,
  // acumulaba otra. Un miembro que sume a mano encuentra la diferencia.
  // La cifra que promete la tarjeta y la que acumula el total tienen que ser la misma
  // (decision de Ali, s184). El redondeo a centavos lo hace fmtUsd al imprimir; el
  // porcentaje de al lado SI sigue redondeado, que es como se lee un porcentaje.
  // s184 (segunda pasada) - MANDA EL DATO GUARDADO, NO EL CALCULO. Iba al reves, y
  // el Math.round que saque hace unas horas lo tapaba: «Noche de Arepas para Dos»
  // tiene regular 52 con 23%, que da 11,96, mientras su `benefit_value_usd` es 12.
  // Redondeados se veian iguales; sin redondeo la tarjeta pasó a decir «Ahorras
  // $11.96» mientras la franja suma $12 al canjear — la misma grieta que el fix
  // venia a cerrar, abierta del otro lado. Lo detecto mirar la pagina despues de
  // deployar, no el build.
  //
  // `benefit_value_usd` es el numero que el comercio confirmo en el alta y el que
  // el canje acumula. Que la tarjeta prometa otra cosa es el error, aunque el otro
  // numero sea el correcto aritmeticamente. El calculo del ticket queda de reserva
  // para ofertas viejas sin el campo cargado: s156-D3 sigue valiendo como FALLBACK,
  // ya no como fuente. Medido en Live: 6 ofertas percent, 5 coinciden y esta no.
  //
  // s221-D1 · TODO LO DE ARRIBA QUEDA SUPERADO para el %. Desde el export 125 el canje guarda
  // min(cuenta × %, tope): `benefit_value_usd` ya no es «lo que ahorras», es el TOPE. La tarjeta
  // lidera siempre con «−20 %», dice «en tu cuenta» y lleva «hasta $25» como insignia. Nunca
  // «Ahorras $X» (`monto` 0): no hay cuenta supuesta. Sin tope (vieja sin dato, o «Sin tope»),
  // sin insignia. `porcentaje` viaja para que tarjeta, ficha y botón no recalculen nada.
  if (tipo === "percent" && pct > 0) {
    const hasta = hastaTope(benefit, en);
    return { ...vacio,
      etiqueta: (c => c.charAt(0).toUpperCase() + c.slice(1))(enTuCuenta(en, o.category)),
      lidera: chipPorcentaje(pct, en),
      insignia: hasta || null,
      porcentaje: { pct, tope: hasta ? benefit : 0, frase: frasePorcentaje(pct, benefit, en, o.category),
                    resto: `${enTuCuenta(en, o.category)}${hasta ? ` · ${hasta}` : ""}` },
      monto: 0,
      mecanica: null,
    };
  }

  // free — GRATIS es la mecánica; el valor sostiene la insignia si existe.
  if (tipo === "free") {
    return { ...vacio, etiqueta: TE_LLEVAS, lidera: en ? "FREE" : "GRATIS",
             insignia: benefit > 0 ? chipAhorro(benefit) : null,
             monto: benefit, mecanica: en ? "Free" : "Gratis" };
  }

  // Sin mecánica reconocible pero con ahorro cargado: el dólar manda solo.
  // s196: la tarjeta dice la mecánica aunque falte el dato que la rama necesitaba:
  // un bogo sin `unit_price` sigue siendo 2×1 («2×1 en Alitas BBQ» de Otto BBQ caía
  // acá y salía «Ahorras $15» a secas), y un porcentaje cargado se dice. Un `fixed`
  // sin precios ni porcentaje («50% en Costillas», también de Otto) no tiene de dónde
  // sacarla: queda «Ahorras $120» — es un hueco del dato, no del formato.
  if (benefit > 0) {
    return { ...vacio, etiqueta: AHORRAS, lidera: `$${fmtUsd(benefit)}`,
             monto: benefit, mecanica: tipo === "bogo" ? "2×1" : (pct > 0 ? chipPct(pct) : null) };
  }

  return { etiqueta: null, lidera: null, insignia: null, precios: null, porConfirmar: true };
}

// s196 · el monograma del hueco: las iniciales del comercio, sin artículos ni conectores
// («The Dessert Shop» → DS, «Noche de Arepas» → NA). Una sola palabra → una sola letra:
// dos letras de la misma palabra («OT» por Otto) se leen como sigla, no como el nombre.
const MONOGRAMA_VACIAS = new Set(["the", "la", "el", "los", "las", "le", "de", "del", "y", "and", "of", "&"]);
function monogramaDe(nombre) {
  const palabras = String(nombre || "")
    .split(/\s+/)
    .map(p => p.replace(/[^0-9A-Za-zÀ-ÿ]/g, ""))
    .filter(p => p && !MONOGRAMA_VACIAS.has(p.toLowerCase()));
  return palabras.slice(0, 2).map(p => p[0]).join("").toUpperCase();
}

// s195 · `etiqueta` (opcional): un rótulo arriba de la foto («Demo · sin confirmar»,
// «Coming soon») para la vitrina beta. Sin `onClick` la tarjeta no es un enlace: cursor
// normal y nada que tocar (canjear apagado, s194-D21) — tampoco el botón guardar.
//
// s196 · la tarjeta se rehace (estilos en tarjeta.css, ver su encabezado):
// - `variante="catalogo"`: la usa SOLO el catálogo. En teléfono pasa a fila horizontal.
// - `sinGuardar`: esconde el botón guardar (la página pública del comercio pone ahí
//   «Solo miembros» cuando quien mira no inició sesión).
// - `nombreComercio`: respaldo SOLO para el monograma. Hay ofertas sin `merchant_name`
//   (en /m/:id, 2 de 3 de Otto BBQ); sin él el monograma salía del título («5E» por
//   «50% en Costillas»). No cambia el encabezado: eso sigue como estaba.
// - Deja de ser un div con onClick: el nombre lleva un enlace real a /offer/:id que se
//   estira a toda la tarjeta. Se abre con teclado, se lee como enlace y el clic con
//   Ctrl/⌘ o el botón del medio abre una pestaña nueva como en cualquier enlace.
// - `inmediata`: la foto carga sin esperar al scroll. Solo la primera fila del catálogo:
//   con loading="lazy" en la foto que está a la vista el navegador la pide tarde (spec §9).
// s233 · catalogo-carrusel (Ali: «que la gente pueda correr las fotos, como un carrusel de Instagram»).
// Una foto del carrusel: se mide SOLA y aplica la regla de forma del catálogo (s198-D1): de 4:5 a 5:4 cubre el
// cuadro; flyers, logos y 3:2 van enteros sobre el gris. Hasta medir no se ve (mismo criterio que la foto única).
function FotoCarruselTarjeta({ src, alt, eager, onRota }) {
  const [llena, setLlena] = useState(null);
  const medir = (img) => {
    if (!img || !img.naturalWidth || !img.naturalHeight || llena !== null) return;
    const r = img.naturalWidth / img.naturalHeight;
    setLlena(r >= 0.78 && r <= 1.28);
  };
  return (
    <div className="tarjeta__slide" data-llena={llena === null ? "midiendo" : (llena ? "si" : "no")}>
      <img className="tarjeta__img" src={src} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async" draggable={false}
        ref={(el) => { if (el && el.complete) medir(el); }} onLoad={(e) => medir(e.currentTarget)} onError={onRota} />
    </div>
  );
}

// La pista del carrusel va ENCIMA del enlace estirado (z-index 2, como «guardar»): si no, el ::after del enlace se
// come el gesto y no se puede deslizar. Por eso un toque SIN deslizar abre la oferta desde aquí (`onAbrir`), igual
// que el resto de la tarjeta. Con el dedo desliza el scroll nativo (scroll-snap); con mouse, flechas.
const CARRUSEL_TARJETA_TOPE = 5;   // la tarjeta mide ~165 px en teléfono: más puntos no se leen. La ficha las muestra todas.
function CarruselTarjeta({ fotos, alt, onAbrir, inmediata, en }) {
  const pista = useRef(null);
  const toque = useRef(null);
  const [actual, setActual] = useState(0);
  const [rotas, setRotas] = useState([]);
  const visibles = fotos.filter(f => !rotas.includes(f));
  const irA = (i) => {
    const el = pista.current; if (!el) return;
    const j = Math.max(0, Math.min(visibles.length - 1, i));
    el.scrollTo({ left: j * el.clientWidth, behavior: "smooth" });
  };
  const alDeslizar = () => {
    const el = pista.current; if (!el) return;
    const i = Math.round(el.scrollLeft / Math.max(1, el.clientWidth));
    if (i !== actual) setActual(i);
  };
  const alTocar = (e) => {
    const t = toque.current;
    // 8 px: menos que eso es un toque (abrir); más, era un deslizamiento y no abre.
    if (t && Math.hypot(e.clientX - t.x, e.clientY - t.y) > 8) return;
    onAbrir && onAbrir(e);
  };
  if (!visibles.length) return null;
  return (
    <>
      <div className="tarjeta__pista" ref={pista} onScroll={alDeslizar}
        onPointerDown={(e) => { toque.current = { x: e.clientX, y: e.clientY }; }} onClick={alTocar}>
        {visibles.map((f, i) => (
          <FotoCarruselTarjeta key={f} src={f} alt={i === 0 ? alt : ""} eager={inmediata && i === 0}
            onRota={() => setRotas(r => (r.includes(f) ? r : [...r, f]))} />
        ))}
      </div>
      {visibles.length > 1 && (
        <>
          <button type="button" className="tarjeta__flecha tarjeta__flecha--izq" disabled={actual === 0}
            aria-label={en ? "Previous photo" : "Foto anterior"} onClick={() => irA(actual - 1)}>‹</button>
          <button type="button" className="tarjeta__flecha tarjeta__flecha--der" disabled={actual >= visibles.length - 1}
            aria-label={en ? "Next photo" : "Foto siguiente"} onClick={() => irA(actual + 1)}>›</button>
          <div className="tarjeta__puntos" aria-hidden="true">
            {visibles.map((f, i) => <span key={f} className={"tarjeta__punto" + (i === actual ? " tarjeta__punto--on" : "")} />)}
          </div>
        </>
      )}
    </>
  );
}

function OfferCard({ offer, onClick, etiqueta: etiquetaProp, variante, sinGuardar, nombreComercio, inmediata }) {
  const lang = useLang();
  const en = lang === "en";
  // s233 · catalogo-sembradas-admin: las Pending que solo ven Admin y Operator llevan su banda (getOfertasSinConfirmar).
  const etiqueta = etiquetaProp || (offer?.sin_confirmar === "sembrada"
    ? (en ? "Seeded · not confirmed" : "Sembrada · sin confirmar")
    : offer?.sin_confirmar === "pendiente" ? (en ? "Pending approval" : "Pendiente de aprobación") : "");

  // S-15 D-101: una foto de tarjeta es un reclamo — alguien puede presentarse
  // al local a pedir lo que ve. O es real del comercio, o no hay foto y se
  // DECLARA el hueco (D-87). Nunca banco de imágenes, nunca ambiente generado.
  // s196: si la foto no carga, también se declara el hueco (antes quedaba la caja vacía).
  const [fotoRota, setFotoRota] = useState(false);
  // s199 · Si la oferta no trae foto, la tarjeta cae al LOGO del comercio antes que al
  // monograma: `seed_merchant` guarda el logo en el comercio y la foto en su galería, y la
  // oferta que crea nace sin imagen — así, lo que Otto carga al sembrar se ve. `merchant_logo`
  // ya viene normalizado del canal (`api.js`, y `ofertaDesdeBeta` para la vista previa).
  const imagenTarjeta = offer.image || offer.merchant_logo || null;
  const foto = !fotoRota && imagenTarjeta ? imagenTarjeta : null;

  // s196 · LA FORMA DE LA FOTO. Los comercios suben flyers y logos (cuadrados o 4:5, que
  // es el formato de Instagram), no solo fotos horizontales de plato: de las 10 fotos del
  // catálogo al 18/09, 7 son cuadradas, 2 verticales y 1 horizontal. Recortarlas todas a
  // 3:2 cortaba el texto de los flyers (el «2026» de Fórmula 1, «Camión Articulado»).
  // Al cargar se mide la proporción REAL y tarjeta.css decide, para cada marco, si la
  // cubre (calza) o si la muestra entera sobre el gris del sistema (la mutilaría).
  // Mobbin: las apps con contenido subido por el usuario (Etsy, Faire, Nextdoor,
  // Partiful) usan marco cuadrado; los logos van enteros sobre fondo claro (Care.com).
  // Hasta medir, la foto no se muestra (opacity 0 en CSS): así no se ve el recorte
  // equivocado un instante antes de acomodarse.
  const [forma, setForma] = useState(null);
  // s198-D1 · el marco cuadrado del catálogo CUBRE de 4:5 a 5:4 (recorta como mucho un 10 %
  // por lado) y deja enteras solo las que se romperían: flyers anchos, logos, 3:2. Con
  // margen: una foto «4:5» real mide 1080×1356 = 0.796, y con el corte exacto en 0.8
  // quedaba con bandas. Mobbin (s198): Depop, Etsy, Faire y Vinted recortan; con bandas,
  // solo OpenSea, y se lee como un error.
  const [llenaCuadro, setLlenaCuadro] = useState(false);
  const medirForma = (img) => {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    const r = img.naturalWidth / img.naturalHeight;
    // cuadrada 0.9–1.1 · apaisada 1.1–1.35 (5:4, 4:3) · horizontal ≥ 1.35 (3:2, 16:9)
    setForma(r < 0.9 ? "vertical" : r <= 1.1 ? "cuadrada" : r < 1.35 ? "apaisada" : "horizontal");
    setLlenaCuadro(r >= 0.78 && r <= 1.28);
  };

  const titulo = en ? (offer.title_en || offer.title_es) : (offer.title_es || offer.title_en);
  // D-108 comercio-primero: manda el nombre del negocio. Sin nombre, el título
  // ocupa ese lugar — nunca un relleno geográfico («Miami» está prohibido).
  const encabezado = offer.merchant_name || titulo;
  const ahorro = resolverAhorro(offer, lang);

  // D-117: la zona sale del dato o no sale. Vacía COLAPSA, sin hueco ni fallback.
  const zona = offer.neighborhood || offer.city || "";
  const categoria = offer.category ? (CAT_DISPLAY[offer.category] || offer.category) : "";
  // s256 · tarjeta-como-m-ejemplo: la condición dice cuándo vale con días y horas (cuandoValeCorto, la misma frase corta del
  // panel), no solo el horario. Sin días ni horas cargados no se dibuja (no se inventa «todos los días» si no hay ningún dato).
  const hayCuando = !!(offer.valid_time_start || offer.valid_time_end || (Array.isArray(offer.valid_days) ? offer.valid_days.length : String(offer.valid_days || "").trim()));
  const horario = hayCuando ? cuandoValeCorto(offer, en) : "";
  // s161 F-4: cinturón numérico. El guard por truthiness alcanza con los datos de hoy
  // (Bubble manda null o 0 int, los dos falsy) pero el string "0" ES truthy: si el canal
  // alguna vez lo devuelve así, la tarjeta volvía a pintar «consumo mínimo $0».
  const minConsumo = Number(offer.min_consumption) > 0 ? offer.min_consumption : null;

  // s194 L1 · formato único (s194-D3): la píldora sobre la foto dice la frase completa y
  // la línea de condiciones no repite el mínimo. Destacada (s194-D4): tarjeta honda, la
  // cifra y la insignia en --realce (el token vive SOLO sobre --superficie-honda) y banda
  // «SOCIO DESTACADO».
  const umbral = ahorro.umbral || null;
  const destacada = !!(umbral && umbral.destacada);

  // Spec §4 · la línea de condiciones: horario y mínimo en UN renglón. En umbral el
  // mínimo ya está en la píldora y en la insignia: no se repite una tercera vez.
  // s194 L1: si el título ES la frase del formato único, ya está en la cifra — no se imprime otra vez. s196: tampoco si
  // es el mismo texto que el encabezado (oferta sin nombre de comercio), que antes salía dos veces.
  const tituloGeneradoAqui = (umbral && esTituloUmbralGenerado(titulo)) || (ahorro.porcentaje && esTituloPorcentajeGenerado(titulo));
  // s223 · si el título generado trae franja (« · Cena»), la franja va a la condición: el monto ya está en la cifra.
  const franjaTitulo = tituloGeneradoAqui ? partirFranja(titulo).franja : "";
  // s212 · el QUÉ (plato o servicio): el título escrito por el comercio, si no es la fórmula.
  const queOferta = titulo && titulo !== encabezado && !tituloGeneradoAqui ? titulo : "";

  // s256 · la condición en UN renglón: momento · días y horas · mínimo (el mínimo no se repite en umbral: ya va en la cifra).
  const condiciones = [
    franjaTitulo,
    horario,
    minConsumo && !umbral ? (en ? `Minimum spend $${minConsumo}` : `Consumo mínimo $${minConsumo}`) : "",
  ].filter(Boolean).join(" · ").replace(/^\p{Ll}/u, c => c.toUpperCase());   // «Todos los días», no «todos los días»

  // s256 · el beneficio en una frase (/m/ejemplo: «25 % de descuento en comida y bebidas sin alcohol.»). Manda el QUÉ del
  // comercio; si no hay, en % se arma con el alcance de la propia oferta (la 1.ª frase de su descripción, ya corregida) o, si
  // no la trae, con la regla del rubro (fraseAlcance). En monto fijo, el alcance tal cual. Nunca un dato inventado.
  const alcance = alcanceDeLaOferta(offer, en);
  const beneficio = queOferta
    || (ahorro.porcentaje && alcance ? (en ? `${ahorro.porcentaje.pct}% off ${alcance.resto}.` : `${ahorro.porcentaje.pct} % de descuento en ${alcance.resto}.`) : "")
    || (umbral && alcance ? alcance.frase : "");

  // s256 · el pie: rótulo chico arriba, la cifra grande y, si hay, la mecánica o el tope debajo. Una sola fuente (resolverAhorro).
  const trato = ahorro.porConfirmar ? null
    : ahorro.porcentaje ? { rotulo: ahorro.etiqueta, cifra: ahorro.lidera, extra: ahorro.insignia || "" }
    : ahorro.monto > 0 ? { rotulo: ahorro.umbral && !ahorro.umbral.paraGastar ? (en ? "Save" : "Ahorra") : (en ? "You save" : "Ahorras"),
                           cifra: `$${fmtUsd(ahorro.monto)}`, extra: ahorro.mecanica || "" }
    : ahorro.mecanica ? { rotulo: "", cifra: ahorro.mecanica, extra: "" }
    : null;

  const href = onClick ? `/offer/${offer._id}` : null;
  const abrir = (e) => {
    // Ctrl/⌘/Shift/botón del medio: que el navegador haga lo suyo (pestaña nueva).
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    onClick();
  };

  const enCatalogo = variante === "catalogo";
  // s233 · catalogo-carrusel: en el catálogo, la foto de la oferta y después la galería del comercio (D-101: todas
  // reales del comercio), sin repetidas, hasta CARRUSEL_TARJETA_TOPE. Con una sola foto, la tarjeta de siempre.
  // s253 · con `gallery_pick`, solo las fotos que el dueño eligió para esta oferta (api.js fotosDeLaOferta).
  const fotosCarrusel = enCatalogo && href
    ? fotosDeLaOferta(offer.image, offer.merchant_gallery || [], offer.gallery_pick).slice(0, CARRUSEL_TARJETA_TOPE)
    : [];
  const conCarrusel = fotosCarrusel.length > 1;
  const clases = [
    "tarjeta",
    enCatalogo && "tarjeta--catalogo",
    destacada && "tarjeta--destacada",
    href && "tarjeta--enlace",
  ].filter(Boolean).join(" ");

  // El monograma es del COMERCIO: con el título como fuente salían siglas sin sentido.
  // Sin nombre de comercio, el icono de la categoría; sin categoría, la cámara.
  const monograma = monogramaDe(offer.merchant_name || nombreComercio);

  // Categoría y zona (D-117: vacía colapsa). s256: arriba del nombre en TODAS las pantallas, con el ícono de la categoría
  // (/m/ejemplo). Reemplaza s198-D12 (en el catálogo iba al final).
  const metaEl = (categoria || zona) ? (
    <p className="tarjeta__meta">
      {CATEGORY_ICON_ID[offer.category] && <span className="tarjeta__meta-ico" aria-hidden="true"><CategoryIcon category={offer.category} /></span>}
      <span className="tarjeta__meta-texto">
        {categoria}
        {categoria && zona && <span aria-hidden="true"> · </span>}
        {zona}
      </span>
    </p>
  ) : null;

  return (
    <article className={clases}>
      {/* ---------- FOTOGRAFÍA — 3:2; en el catálogo, cuadrada (1:1) ---------- */}
      {conCarrusel ? (
        <div className="tarjeta__foto tarjeta__foto--carrusel">
          <CarruselTarjeta fotos={fotosCarrusel} inmediata={inmediata} en={en} onAbrir={abrir}
            alt={`${titulo}${offer.merchant_name ? ` — ${offer.merchant_name}` : ""}`} />
          {etiqueta && <span className="tarjeta__etiqueta">{etiqueta}</span>}
          {destacada && <span className="tarjeta__cinta">{en ? "Featured partner" : "Socio destacado"}</span>}
        </div>
      ) : (
      <div className="tarjeta__foto" data-forma={foto ? (forma || "midiendo") : undefined}
        data-llena={foto && llenaCuadro ? "si" : undefined}>
        {foto ? (
          <img
            className="tarjeta__img"
            src={foto}
            alt={`${titulo}${offer.merchant_name ? ` — ${offer.merchant_name}` : ""}`}
            loading={inmediata ? "eager" : "lazy"}
            // la foto en caché puede haber cargado antes de que exista el manejador
            ref={(el) => { if (el && el.complete && !forma) medirForma(el); }}
            onLoad={(e) => medirForma(e.currentTarget)}
            onError={() => setFotoRota(true)}
          />
        ) : (
          <div className="tarjeta__hueco" role="img"
            aria-label={en ? `${encabezado} — photos on the way` : `${encabezado} — fotos en camino`}>
            {monograma
              ? <span className="tarjeta__monograma" aria-hidden="true">{monograma}</span>
              : <span className="tarjeta__monograma tarjeta__monograma--icono" aria-hidden="true">
                  {CATEGORY_ICON_ID[offer.category] ? <CategoryIcon category={offer.category} /> : <Ico name="ico-camara" size={32} />}
                </span>}
            <span className="tarjeta__hueco-nota" aria-hidden="true">{en ? "Photos on the way" : "Fotos en camino"}</span>
          </div>
        )}
        {etiqueta && <span className="tarjeta__etiqueta">{etiqueta}</span>}
        {/* s256 · sobre la foto solo la cinta de la destacada (como «Selección de la semana» de /m/ejemplo) y guardar. La píldora
            del formato único se fue: la frase ya está en la cifra y la mecánica del pie. */}
        {destacada && <span className="tarjeta__cinta">{en ? "Featured partner" : "Socio destacado"}</span>}
      </div>
      )}

      {/* D-126: guardar. Solo donde la tarjeta es enlace: en la beta no hay nada que tocar.
          s202 · deja de ser inerte (favoritos-miembro): el backend existia y nadie lo
          llamaba. Sin sesion manda al login y vuelve (F2). */}
      {href && !sinGuardar && (
        <BotonGuardar tipo="offer" id={offer?._id} className="tarjeta__guardar" conCirculo tamano={20} en={en} />
      )}

      {/* ---------- CUERPO · s256 tarjeta-como-m-ejemplo (Ali: «tómalo como ejemplo, inclusive en la vitrina principal») ----------
          Un solo orden en todas las pantallas, el de /m/ejemplo: categoría y zona → nombre (el único titular, D-108) → el
          beneficio en una frase → la condición en un renglón → el pie (rótulo, cifra grande y el botón). Reemplaza
          s196-D2 (la foto es la tarjeta), s198-D12/D13 (trato arriba y cifra en Bebas índigo) y s196-D3. JAMÁS un contador de
          cupos (D-123). */}
      <div className="tarjeta__cuerpo">
        {metaEl}

        {/* s213 · lote B: el plan, justo arriba del nombre. */}
        {etiquetaPlan(offer.plan, en) && <span className="plan-pildora tarjeta__plan">{etiquetaPlan(offer.plan, en)}</span>}
        <h3 className="tarjeta__nombre">
          {href ? <a className="tarjeta__enlace" href={href} onClick={abrir}>{encabezado}</a> : encabezado}
        </h3>

        {beneficio && <p className="tarjeta__beneficio">{beneficio}</p>}

        {condiciones && (
          <p className="tarjeta__condiciones">
            <span className="tarjeta__condiciones-texto">{condiciones}</span>
          </p>
        )}

        <div className="tarjeta__pie">
          {ahorro.porConfirmar ? (
            <span className="tarjeta__por-confirmar">{en ? "Savings to be confirmed" : "Ahorro por confirmar"}</span>
          ) : trato ? (
            <p className="tarjeta__trato">
              {trato.rotulo && <span className="tarjeta__trato-rotulo">{trato.rotulo} </span>}
              <span className="tarjeta__trato-cifra">{trato.cifra}</span>
              {trato.extra && <span className="tarjeta__trato-mecanica"> {trato.extra}</span>}
            </p>
          ) : <span />}
          {/* Se ve como botón y es parte del enlace de la tarjeta (el nombre, estirado): no es un segundo control. */}
          <span className="tarjeta__boton" aria-hidden="true">{en ? "Activate offer" : "Activar oferta"}</span>
        </div>
        {/* s256 · Ali: «Sin costo con tu membresía activa» es un texto viejo de /m/ejemplo (MKT-03, 12/08) y no va. */}
      </div>
    </article>
  );
}


// ============================================
// COUPON CARD
// ============================================
// s215 · El QR del cupón: el mismo código (NXT-123456), dibujado aquí (sin servicios externos).
function CodigoQR({ codigo, en }) {
  const [svg, setSvg] = useState("");
  useEffect(() => {
    let vivo = true;
    QRCode.toString(String(codigo), { type: "svg", margin: 1, errorCorrectionLevel: "M", color: { dark: "#0F1B2A", light: "#FFFFFF" } })
      .then(x => { if (vivo) setSvg(x); }).catch(() => {});
    return () => { vivo = false; };
  }, [codigo]);
  if (!svg) return null;
  return <div className="cupon__qr" role="img" aria-label={en ? `QR code ${codigo}` : `Código QR ${codigo}`} dangerouslySetInnerHTML={{ __html: svg }} />;
}

// s215 · El escáner del comercio: cámara trasera + jsQR cuadro por cuadro. Acepta el QR del cupón
// (o cualquier texto con un código NXT-…). Sin permiso de cámara, avisa y queda el campo de texto.
function EscanerQR({ en, onLeer, onCerrar }) {
  const videoRef = useRef(null);
  const [error, setError] = useState("");
  const onLeerRef = useRef(onLeer);   // la cámara se abre una sola vez aunque el panel se redibuje
  onLeerRef.current = onLeer;
  useEffect(() => {
    let flujo = null, vivo = true, raf = 0, jsQR = null;
    const lienzo = document.createElement("canvas");
    const ctx = lienzo.getContext("2d", { willReadFrequently: true });
    const mirar = () => {
      if (!vivo) return;
      const v = videoRef.current;
      if (jsQR && v && v.readyState >= 2 && v.videoWidth) {
        lienzo.width = v.videoWidth; lienzo.height = v.videoHeight;
        ctx.drawImage(v, 0, 0);
        const img = ctx.getImageData(0, 0, lienzo.width, lienzo.height);
        const r = jsQR(img.data, img.width, img.height, { inversionAttempts: "dontInvert" });
        const m = r && String(r.data).toUpperCase().match(/NXT-?\d{4,8}/);
        if (m) { vivo = false; onLeerRef.current(m[0].includes("-") ? m[0] : m[0].replace("NXT", "NXT-")); return; }
      }
      raf = requestAnimationFrame(mirar);
    };
    (async () => {
      try {
        if (!navigator.mediaDevices?.getUserMedia) throw new Error("sin_camara");
        // s215 · jsQR se carga recién acá (no pesa en la app de todos; Safari no trae BarcodeDetector).
        jsQR = (await import("jsqr")).default;
        flujo = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" }, audio: false });
        if (!vivo) { flujo.getTracks().forEach(t => t.stop()); return; }
        const v = videoRef.current;
        if (v) { v.srcObject = flujo; v.setAttribute("playsinline", "true"); await v.play().catch(() => {}); }
        raf = requestAnimationFrame(mirar);
      } catch (e) {
        setError(en ? "We couldn't open the camera. Allow camera access, or type the code." : "No pudimos abrir la cámara. Permite el acceso a la cámara, o escribe el código.");
      }
    })();
    return () => { vivo = false; cancelAnimationFrame(raf); if (flujo) flujo.getTracks().forEach(t => t.stop()); };
  }, [en]);
  return (
    <div className="mrc-escaner" role="dialog" aria-modal="true" aria-label={en ? "Scan QR code" : "Escanear código QR"}>
      <div className="mrc-escaner__caja">
        <p className="mrc-escaner__titulo">{en ? "Point at the member's QR" : "Apunta al QR del miembro"}</p>
        {error ? <p className="mrc-escaner__error">{error}</p> : <video ref={videoRef} className="mrc-escaner__video" muted playsInline />}
        <button type="button" className="mrc-escaner__cerrar" onClick={onCerrar}>{en ? "Close" : "Cerrar"}</button>
      </div>
    </div>
  );
}

// s246-D5 · «honrar y avisar» (spec ciclo del cupón §5.3). Cuando el negocio pausa o retira la oferta, o deja el club, Bubble
// (avisar_cupon_vivo, B5) le escribe al cupón vivo `aviso_motivo` y le manda un correo al socio. Aquí, la misma noticia en
// la tarjeta. Solo los tres motivos del spec; cualquier otro valor no se muestra (no se inventa un aviso).
const MOTIVOS_AVISO_CUPON = ["pausada", "retirada", "comercio_salio"];
function avisoDelCupon(motivo, comercio, hasta, en) {
  const m = String(motivo || "").trim().toLowerCase();
  if (!MOTIVOS_AVISO_CUPON.includes(m)) return "";
  const negocio = comercio || (en ? "The business" : "El negocio");
  const que = {
    pausada: en ? `${negocio} paused this offer.` : `${negocio} pausó esta oferta.`,
    retirada: en ? "This offer left the catalog." : "Esta oferta salió del catálogo.",
    comercio_salio: en ? `${negocio} left the club.` : `${negocio} dejó el club.`,
  }[m];
  const sigue = hasta
    ? (en ? `Your coupon is still valid until ${hasta}.` : `Tu cupón sigue valiendo hasta el ${hasta}.`)
    : (en ? "Your coupon is still valid." : "Tu cupón sigue valiendo.");
  return `${que} ${sigue}`;
}

function CouponCard({ coupon }) {
  const lang = useLang();
  const en = lang === "en";
  const club = useClub();
  const [copied, setCopied] = useState(false);

  // s247 · `tarjeta-cupon-legible` (Ali: «yo no sé en este momento ni siquiera de qué es cada código»). Lo que la tarjeta dice
  // arriba del código: de quién es (logo o iniciales, nombre, barrio), qué te da en una línea (la frase del catálogo:
  // textoValorOferta, con los números que el cupón guardó al activarse) y cuándo vale (cuandoValeCorto). El título de la
  // oferta va abajo, en chico, solo si dice algo que la frase no dice. Todo lo que falte cae a lo de antes (cupones viejos).
  // Vive dentro de CouponCard porque es solo de ella (revisar trata toda función suelta en minúscula como regla compartida).
  function resumenDelCupon(c) {
    const titulo = (en ? (c.offer_title_en || c.offer_title) : (c.offer_title || c.offer_title_en)) || "";
    const tipo = String(c.offer_type || "").toLowerCase();
    const oferta = { offer_type: tipo, discount_pct: c.offer_discount_pct, benefit_value_usd: c.offer_benefit_value_usd,
      min_consumption: c.offer_min_consumption, category: c.offer_category };
    const beneficio = (esUmbral(oferta) || esPorcentaje(oferta)) ? textoValorOferta(oferta, en) : "";
    // Si el título ya trae la frase («Ahorra $20 cuando gastas $40 · Cena»), queda solo lo que agrega («Cena»).
    const sinLaFrase = (t, f) => {
      const i = sinEspacioDuro(t).toLowerCase().indexOf(sinEspacioDuro(f).toLowerCase());
      if (i < 0) return t;
      const s = sinEspacioDuro(t);
      return (s.slice(0, i) + " " + s.slice(i + sinEspacioDuro(f).length)).replace(/^[\s·:–-]+|[\s·:–-]+$/g, "").replace(/\s{2,}/g, " ");
    };
    const principal = beneficio || titulo || (en ? "NXT Reserve benefit" : "Beneficio NXT Reserve");
    // s247 · smoke en Live (§11.4): «$25 x $50» quedaba debajo de «Ahorra $25 cuando gastas $50». Si todo lo que dice el título
    // ya está en la frase (los mismos montos, más conectores como «x», «por», «de»), no agrega nada y no se muestra.
    const PUENTES = ["x", "por", "de", "en", "y", "con", "al", "a", "for", "of", "on", "and", "off", "the", "with"];
    const palabras = (s) => sinEspacioDuro(s).toLowerCase().match(/[\p{L}\d]+/gu) || [];
    const soloRepite = (t, f) => { const enLaFrase = new Set([...palabras(f), ...PUENTES]); return palabras(t).every(p => enLaFrase.has(p)); };
    const resto = beneficio && titulo ? sinLaFrase(titulo, beneficio) : "";
    const detalle = resto && !soloRepite(resto, beneficio) ? resto : "";
    const conFranja = c.offer_valid_days || (c.offer_valid_time_start && c.offer_valid_time_end);
    const cuando = conFranja ? cuandoValeCorto({ valid_days: c.offer_valid_days, valid_time_start: c.offer_valid_time_start,
      valid_time_end: c.offer_valid_time_end }, en) : "";
    const franja = cuando && !/^(todos los días|every day)$/i.test(cuando) ? cuando : "";
    const logo = c.merchant_logo ? (String(c.merchant_logo).startsWith("//") ? "https:" + c.merchant_logo : String(c.merchant_logo)) : "";
    const comercio = c.merchant_name || "";
    return { comercio, zona: c.merchant_neighborhood || "", logo, iniciales: comercio ? monogramaDe(comercio) : "", principal, detalle, franja };
  }

  // s246-D5 · el número de soporte que fija el admin (PricingConfig), el mismo de «Ayuda»; solo se pide si hay aviso.
  const [waSoporte, setWaSoporte] = useState(WHATSAPP_NUMBER);
  const conAviso = MOTIVOS_AVISO_CUPON.includes(String(coupon.aviso_motivo || "").trim().toLowerCase());
  useEffect(() => {
    if (!conAviso) return undefined;
    let vivo = true;
    numeroSoporte().then(wa => { if (vivo && wa) setWaSoporte(wa); });
    return () => { vivo = false; };
  }, [conAviso]);
  const estado = String(coupon.status || "active").toLowerCase();
  // s198 · un `active` con la fecha vencida se muestra como vencido (ver MyCouponsPage):
  // Bubble no siempre le cambia el estado a tiempo.
  const vencioPorFecha = estado === "active" && coupon.expires_at && new Date(coupon.expires_at).getTime() <= Date.now();
  const isActive = estado === "active" && !vencioPorFecha;
  const isRedeemed = estado === "redeemed";

  // Fechas del cupón, en el formato del socio. Sin dato o con dato roto, no se inventa.
  const fecha = (v) => {
    if (!v) return "";
    const d = new Date(v);
    return isNaN(d.getTime()) ? "" : d.toLocaleDateString(en ? "en-US" : "es-MX", { day: "numeric", month: "short", year: "numeric" });
  };
  const vence = fecha(coupon.expires_at);
  const { comercio, zona, logo, iniciales, principal, detalle, franja } = resumenDelCupon(coupon);
  const titulo = detalle ? `${principal} · ${detalle}` : principal;   // para compartir y para el lector de pantalla
  // «Ver la oferta» solo cuando la ficha abre para el socio (antes de la inauguración muestra «Se abre el día…»).
  const verOferta = club.abierto && coupon.offer ? `/offer/${coupon.offer}` : "";
  const direccion = coupon.merchant_address || "";
  const mapa = coupon.merchant_maps_url || "";
  const telefono = coupon.merchant_phone || "";
  const aviso = avisoDelCupon(coupon.aviso_motivo, comercio, vence, en);

  const copyCode = async () => {
    try {
      await navigator.clipboard.writeText(coupon.code || "");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) { /* sin permiso del navegador: el código sigue a la vista, en grande */ }
  };
  const compartir = () => {
    const text = `NXT Reserve\n${titulo}\n${en ? "Code" : "Código"}: ${coupon.code || ""}${comercio ? `\n${comercio}` : ""}`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  };

  // s198-D17 · canjeados y vencidos: una tarjeta compacta. Ya no sirven en el local, así que
  // no llevan el código grande; dicen qué fue y cuándo.
  if (!isActive) {
    const canjeado = fecha(coupon.redeemed_at);
    const linea = isRedeemed
      ? (canjeado ? (en ? `Redeemed ${canjeado}` : `Canjeado el ${canjeado}`) : (en ? "Redeemed" : "Canjeado"))
      : (vence ? (en ? `Expired ${vence}` : `Venció el ${vence}`) : (en ? "Expired" : "Vencido"));
    return (
      <article className={`cupon cupon--corto${isRedeemed ? "" : " cupon--vencido"}`}>
        <div className="cupon__cabeza">
          {comercio && <p className="cupon__comercio">{comercio}{zona && <span className="cupon__zona"> · {zona}</span>}</p>}
          <p className="cupon__oferta">{principal}</p>
        </div>
        <p className="cupon__estado">{linea}</p>
      </article>
    );
  }

  const marca = (comercio || logo) && (
    <div className="cupon__marca" aria-hidden="true">
      {logo ? <img className="cupon__logo" src={logo} alt="" loading="lazy" /> : <span className="cupon__iniciales">{iniciales}</span>}
    </div>
  );

  // s198-D17 + D6 · el cupón activo. Lo que importa en el mostrador es el CÓDIGO: grande, en
  // monoespaciada y con aire, para que el cajero lo lea desde el otro lado (Burger King en
  // Mobbin). Sin QR: el de antes era un dibujo al azar que no se podía escanear, y el canje lo
  // valida el comercio escribiendo el código (D6, se mantiene).
  return (
    <article className="cupon" aria-label={[comercio, titulo].filter(Boolean).join(" — ")}>
      {/* s247 · de quién es, arriba y grande: con varios cupones, es lo primero que el socio busca. */}
      {(comercio || logo) && (
        <div className="cupon__quien">
          {marca}
          <div className="cupon__quien-texto">
            {comercio && <p className="cupon__comercio">{comercio}</p>}
            {zona && <p className="cupon__barrio">{zona}</p>}
          </div>
        </div>
      )}
      {/* Qué te da, en una línea; cuándo vale; y el título solo si agrega algo. */}
      <div className="cupon__cabeza">
        <p className="cupon__beneficio">{principal}</p>
        {franja && <p className="cupon__franja">{en ? "Valid" : "Vale"} {franja}</p>}
        {detalle && <p className="cupon__oferta">{detalle}</p>}
      </div>

      {/* s246-D5 · solo en el cupón activo y sin vencer (los cortos de arriba ya no sirven en el local). */}
      {aviso && (
        <div className="cupon__aviso" role="status">
          <p className="cupon__aviso-texto">{aviso}</p>
          <a className="cupon__aviso-enlace" target="_blank" rel="noreferrer"
            href={`https://wa.me/${waSoporte}?text=${encodeURIComponent(en
              ? `Hi! I have an NXT Reserve coupon (${coupon.code || ""})${comercio ? ` for ${comercio}` : ""} and they didn't accept it.`
              : `¡Hola! Tengo un cupón de NXT Reserve (${coupon.code || ""})${comercio ? ` de ${comercio}` : ""} y no me lo aceptaron.`)}`}>
            <IcoFicha name="chat" size={16} /> {en ? "If they don't accept it, message us" : "Si no te lo aceptan, escríbenos"}
          </a>
        </div>
      )}

      <div className="cupon__codigo">
        <span className="cupon__codigo-rotulo">{en ? "Show this code when you pay" : "Muestra este código al pagar"}</span>
        <span className="cupon__codigo-valor">{coupon.code || "—"}</span>
        {/* s215 · Ali: también en QR (supersede s198-D6 «sin QR»): el comercio lo escanea desde su panel. */}
        {coupon.code && <CodigoQR codigo={coupon.code} en={en} />}
      </div>

      <div className="cupon__pie">
        <span className="cupon__vence">{vence ? (en ? `Expires ${vence}` : `Vence el ${vence}`) : ""}</span>
        <div className="cupon__acciones">
          <button type="button" className="cupon__icono" onClick={compartir} aria-label={en ? "Send by WhatsApp" : "Enviar por WhatsApp"}>
            <IcoFicha name="chat" size={20} />
          </button>
          <button type="button" className={`cupon__copiar${copied ? " cupon__copiar--ok" : ""}`} onClick={copyCode}>
            {copied ? (en ? "Copied" : "Copiado") : (en ? "Copy" : "Copiar")}
          </button>
        </div>
        <span className="nxt-solo-lectores" aria-live="polite">{copied ? (en ? "Code copied" : "Código copiado") : ""}</span>
      </div>

      {/* F1 s101: dónde queda y cómo llegar EN EL CUPÓN, que es lo que el socio necesita en la puerta. */}
      {(direccion || mapa || telefono || verOferta) && (
        <div className="cupon__lugar">
          {direccion && <p className="cupon__direccion">{direccion}</p>}
          {(mapa || telefono || verOferta) && (
            <div className="cupon__lugar-acciones">
              {verOferta && (
                <Link className="cupon__enlace" to={verOferta}>
                  <IcoFicha name="billete" size={16} /> {en ? "See the offer" : "Ver la oferta"}
                </Link>
              )}
              {mapa && (
                <a className="cupon__enlace" href={mapa} target="_blank" rel="noreferrer">
                  <IcoFicha name="mapa" size={16} /> {en ? "Directions" : "Cómo llegar"}
                </a>
              )}
              {telefono && (
                <a className="cupon__enlace" href={`tel:${telefono}`}>
                  <IcoFicha name="telefono" size={16} /> {telefono}
                </a>
              )}
            </div>
          )}
        </div>
      )}
    </article>
  );
}

// ============================================
// INPUT COMPONENT
// ============================================
function Input({ label, ...props }) {
  const [focused, setFocused] = useState(false);
  return (
    <div style={{ marginBottom: 16 }}>
      {label && <label htmlFor="nxt-f60" style={{ display: "block", fontSize: 12, fontWeight: 600, color: C.gray, marginBottom: 6, letterSpacing: "0.05em" }}>{label.toUpperCase()}</label>}
      <input id="nxt-f60"
        {...props}
        style={{ ...S.input, borderColor: focused ? C.red : C.border }}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
      />
    </div>
  );
}

// ============================================
// PAGE: LOGIN
// ============================================
// s184 - LO QUE ESTABA ESCRITO DOS VECES. `GOOGLE_CLIENT_ID` y la logica de a
// donde va cada rol despues de autenticarse vivian duplicados en LoginPage y en
// SignupPage, y ademas HABIAN DIVERGIDO: login ya usaba el helper `routeByRole`
// (fix R20) mientras signup conservaba los cuatro roles escritos a mano. Hoy hacen
// lo mismo; el dia que se agregue un rol o se mueva una ruta, no.
//
// Ademas `routeByRole` estaba declarado ADENTRO de LoginPage, asi que SignupPage no
// tenia forma de usarlo aunque quisiera. Suben las tres al modulo.
const GOOGLE_CLIENT_ID = "165006063797-nvciv6o4df0v69egobemhbljtphq0tqr.apps.googleusercontent.com";

function routeByRole(role) {
  if (role === "Admin") return "/admin";
  if (role === "Operator") return "/operator/negocios"; // s238 (Ali): Otto entra a «Negocios» (antes /operator, ETAPA-2 s99)
  // s220 (Ali): el aliado (rol Influencer) es un miembro con un panel extra — entra por el
  // onboarding y el catálogo como cualquiera y llega a /aliados desde el menú. Por eso NO
  // tiene línea propia aquí: cae en el "/" del final.
  if (role === "Merchant") return "/merchant/dashboard";
  if (role === "MerchantStaff") return "/merchant/validar";   // s216 · empleado: solo validar
  return "/";                                        // EndUser, Influencer, B2BPartner, o cualquier otro -> catalogo
}

// ONB-1: end-user logueado sin telefono -> gate de onboarding (captura phone + WhatsApp).
// Los roles con panel propio entran directo: a un comercio no se le pide el telefono
// de un miembro.
function routeAfterAuth(profile) {
  const role = profile?.role;
  if (role === "Admin" || role === "Merchant" || role === "MerchantStaff" || role === "Operator") return routeByRole(role);
  if (!profile?.phone) return "/onboarding";
  // s203-D6: el socio sin plan (LITE sin cupones) vuelve a la puerta del código cada vez
  // que entra, aunque ya haya dejado su teléfono. Antes pasaba al catálogo y chocaba al
  // activar con SUBSCRIPTION_REQUIRED.
  if (socioSinPlan(profile)) return "/onboarding";
  return routeByRole(role);
}

// ============================================
// s203-D6 · EL SOCIO SIN PLAN — un solo lugar para decidir quién es y qué se le dice.
// Mientras no exista la suscripción, a un socio LITE sin cupones se le pide un código
// de acceso (el que entra con Google nace con max_coupons 0, social_login step 5).
// 🔁 EL DÍA DE LA SUSCRIPCIÓN se cambia AQUÍ: `socioSinPlan` deja de mirar solo el
// código y PUERTA_SIN_PLAN pasa a ofrecer «Suscríbete». Lo usan routeAfterAuth,
// /onboarding, la puerta de la ficha (codeGate) y activationErrorMessage.
// get_user_profile omite las claves vacías: sin `max_coupons` es 0; sin `tier`, el que
// guardó el login en localStorage.
// ============================================
// s218 · SOLO CON INVITACIÓN (decisión de Ali): hasta un mes después del lanzamiento oficial —el día que lanza la
// primera influencer— se entra SOLO con código, aunque la persona ponga su tarjeta para la prueba de 7 días.
// Así cada miembro queda atribuido a quien lo invitó (influencer, Otto o NXTMIAMI, el código de la casa).
// `LANZAMIENTO` vacío = la ventana está abierta y sin fin; el día del lanzamiento se pone la fecha
// («2026-10-17») y a los DIAS_SOLO_INVITACION el código vuelve a ser opcional solo, sin otro deploy.
const LANZAMIENTO = null;
const DIAS_SOLO_INVITACION = 30;
function soloConInvitacion() {
  if (!LANZAMIENTO) return true;
  const fin = new Date(`${LANZAMIENTO}T00:00:00`).getTime() + DIAS_SOLO_INVITACION * 24 * 60 * 60 * 1000;
  return !(Date.now() >= fin);
}
function socioSinPlan(profile) {
  const sub = String(profile?.subscription_status || "").toLowerCase();
  // s218 · durante la ventana, una suscripción (la prueba con tarjeta) no alcanza: hace falta el código.
  // get_user_profile NO devuelve signup_code y omite las claves vacías: se lee `has_signup_code` (yes/no, pedido a
  // Cowork). Solo un «no» explícito bloquea; sin la clave (WF todavía sin ella) no se bloquea a nadie que pagó.
  if (sub === "active" || sub === "trialing") {
    const sinCodigo = profile?.has_signup_code === false || profile?.has_signup_code === "no";
    return soloConInvitacion() && sinCodigo;
  }
  let tier = profile?.tier;
  if (!tier) { try { tier = localStorage.getItem("nxt_tier"); } catch (e) { tier = ""; } }
  if (String(tier || "LITE").toUpperCase() !== "LITE") return false;
  return !(Number(profile?.max_coupons) > 0);
}
// s220 · EL PUENTE del código de aliado. Un código sin tier (el del aliado: solo atribución y descuento)
// deja al usuario con `has_signup_code` «yes» y SIN tier. Su camino es el Checkout con 7 días de prueba,
// que todavía no está en main (rama s193-tramo1-suscripcion). Hasta entonces, la puerta no le vuelve a
// pedir un código que ya aplicó: le dice que quedó guardado. Lee solo el perfil (get_user_profile omite
// `tier` vacío), nunca el `nxt_tier` de localStorage, que puede ser de otra cuenta del mismo navegador.
function codigoGuardadoSinPlan(profile) {
  const sub = String(profile?.subscription_status || "").toLowerCase();
  if (sub === "active" || sub === "trialing") return false;
  const conCodigo = profile?.has_signup_code === true || profile?.has_signup_code === "yes";
  return conCodigo && !profile?.tier;
}
const PUERTA_SIN_PLAN = {
  es: "Para activar beneficios necesitas un código de acceso.",
  en: "To activate benefits you need an access code.",
};

function LoginPage() {
  const lang = useLang();
  const cambiarIdioma = useSetLang();   // s184 - la puerta no ofrecia cambiar idioma, y se traduce entera
  const navigate = useNavigate();
  // s202 · F2 de favoritos-miembro: guardar sin sesion trae al login con `state.volver`,
  // y el socio vuelve a lo que estaba mirando. Solo a rutas internas, y solo cuando su
  // destino normal era el catalogo: el onboarding y los paneles por rol mandan primero.
  const location = useLocation();
  const volver = typeof location.state?.volver === "string" && /^\/(?!\/)/.test(location.state.volver) ? location.state.volver : "";
  const destino = (profile) => { const r = routeAfterAuth(profile); return r === "/" && volver ? volver : r; };
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // s195 · `?invite=1`: hoy reset_pw de Bubble vuelve a /login (X.48); si el comercio cae
  // acá, el saludo le dice qué hacer y routeAfterAuth lo lleva a su panel por el rol.
  const [spLogin] = useSearchParams();
  const vieneDeInvitacion = spLogin.get("invite") === "1";

  // AUTH-1 (s57): Google OAuth Client ID (público). Ver memoria auth1-google-oauth.

  useEffect(() => {
    const checkAuth = async () => {
      if (auth.isLoggedIn()) {
        try {
          const profile = await getUserProfile();
          // Sin `destino` a proposito: a esta rama solo llega quien YA tiene sesion, y a
          // ese nunca se lo manda al login con `volver` (BotonGuardar solo lo hace sin sesion).
          navigate(routeAfterAuth(profile), { replace: true });
        } catch {
          // si falla getUserProfile, fallback al home
          navigate("/", { replace: true });
        }
      }
    };
    checkAuth();
  }, [navigate]);

  const handleLogin = async () => {
    // s184 - estos dos mensajes estaban escritos en español a secas, en una
    // pantalla que se traduce entera. Un usuario en inglés recibia el error en
    // español sin ningun aviso de por que.
    if (!email || !password) {
      setError(lang === "en" ? "Fill in both fields" : "Completa los dos campos");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await loginUser(email, password);
      const profile = await getUserProfile();
      navigate(destino(profile));
    } catch (e) {
      setError(loginErrorMessage(e, lang, lang === "en" ? "Could not sign in" : "No se pudo iniciar sesión"));
    } finally {
      setLoading(false);
    }
  };

  // AUTH-1: callback de Google Identity → ID token → WF social_login → routea por role.
  const handleGoogleCredential = async (response) => {
    if (!response?.credential) {
      setError(lang === "en" ? "Google sign-in failed" : "Falló el acceso con Google");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await socialLogin(response.credential);
      const profile = await getUserProfile();
      navigate(destino(profile));
    } catch (e) {
      setError(googleErrorMessage(e, lang, lang === "en"
        ? "This account uses a password — sign in with your password below."
        : "Esta cuenta usa tu contraseña — inicia sesión con tu contraseña abajo."));
    } finally {
      setLoading(false);
    }
  };

  // AUTH-1: inicializa Google Identity Services y renderiza el botón (reintenta hasta que el script GIS cargue).
  useEffect(() => {
    let tries = 0;
    const init = () => {
      const g = window.google?.accounts?.id;
      if (!g) {
        if (tries++ < 40) setTimeout(init, 150);
        return;
      }
      try {
        g.initialize({ client_id: GOOGLE_CLIENT_ID, callback: handleGoogleCredential });
        const el = document.getElementById("googleSignInBtn");
        if (el) {
          el.innerHTML = "";
          g.renderButton(el, { theme: "outline", size: "large", text: "continue_with", width: 360 });
        }
      } catch (e) { /* GIS no disponible — el login por email/contraseña sigue funcionando */ }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="auth">

      {/* s184 - LA BARRA. Antes traia un segundo enlace al alta («¿Miembro nuevo?
          Registrate») que apuntaba al mismo lugar que el bloque del final. Dos
          llamados identicos en 400px de ancho: se queda el de abajo, que es el que
          llega con contexto. Aca solo la marca y el idioma — que hasta ahora esta
          pantalla no ofrecia, aunque se traduce entera. */}
      <div className="auth__barra">
        <Logo size="md" tono="oscuro" />
        <button className="auth__idioma" onClick={() => cambiarIdioma(lang === "en" ? "es" : "en")}>
          {lang === "en" ? "ES" : "EN"}
        </button>
      </div>

      <div className="auth__centro">
        <div className="auth__caja">

          {/* s184 - decia «BIENVENIDO DE NUEVO». Desde s183 la raiz redirige aca,
              asi que esta pantalla la ve TAMBIEN quien nunca entro: un comercio con
              el link, alguien que escribio la direccion. A esa persona se le estaba
              dando la bienvenida de vuelta a un lugar donde no habia estado.
              «BIENVENIDO» sirve para los dos, y la bajada dice que es esto para
              quien todavia no lo sabe. Se va tambien el circulo con la N: la marca
              ya esta arriba, y dos logos en la misma vista no son mas marca. */}
          <div className="auth__saludo">
            <h1 className="auth__titulo">{lang === "en" ? "WELCOME" : "BIENVENIDO"}</h1>
            {/* s232 · «¿Quiénes somos?», parte 1: decía «Club privado de beneficios · Miami».
                s236 · el texto en tres partes de Ali (antes: «…que une a la gente que sale con los lugares…»). */}
            <p className="auth__bajada">
              {vieneDeInvitacion
                ? (lang === "en" ? "Your password is set. Sign in to confirm your offer." : "Tu contraseña quedó creada. Entra para confirmar tu oferta.")
                : (lang === "en" ? "We're an exclusive benefits and discounts club in Miami. We connect our members with the city's local restaurants and businesses." : "Somos un club de beneficios y descuentos exclusivos en Miami. Conectamos a nuestros miembros con los restaurantes y negocios locales de la ciudad.")}
            </p>
          </div>

          <div className="auth__campo">
            <label className="auth__etiqueta" htmlFor="nxt-f59">EMAIL</label>
            <input className="auth__entrada" autoComplete="email" id="nxt-f59"
              type="email" value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleLogin()}
              placeholder="tu@email.com" />
          </div>

          <div className="auth__campo">
            <label className="auth__etiqueta" htmlFor="nxt-f58">
              {lang === "en" ? "PASSWORD" : "CONTRASEÑA"}
            </label>
            <input className="auth__entrada" autoComplete="current-password" id="nxt-f58"
              type="password" value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handleLogin()}
              placeholder="••••••••" />
          </div>

          {error && <div className="auth__error" role="alert">{error}</div>}

          <button className="auth__boton" onClick={handleLogin} disabled={loading}>
            {loading
              ? (lang === "en" ? "Signing in…" : "Iniciando sesión…")
              : (lang === "en" ? "Sign in" : "Iniciar sesión")}
          </button>

          <Link className="auth__menor" to="/forgot-password">
            {lang === "en" ? "Forgot your password?" : "¿Olvidaste tu contraseña?"}
          </Link>

          {/* s184 - los terminos se NOMBRABAN sin enlazarse. /terms y /privacy son
              rutas publicas que existen: si se pide aceptarlos, tienen que poder
              leerse antes. */}
          <p className="auth__legal">
            {lang === "en" ? "By signing in you accept our " : "Al iniciar sesión aceptas los "}
            <Link to="/terms">{lang === "en" ? "Terms of Service" : "Términos del Servicio"}</Link>
            {lang === "en" ? " and " : " y la "}
            <Link to="/privacy">{lang === "en" ? "Privacy Policy" : "Política de Privacidad"}</Link>.
          </p>

          <div className="auth__o"><span>{lang === "en" ? "OR" : "O"}</span></div>
          <div className="auth__google" id="googleSignInBtn" />

          <div className="auth__alta">
            {lang === "en" ? "Don't have an account yet? " : "¿Todavía no tienes cuenta? "}
            <Link to="/signup">{lang === "en" ? "Create one" : "Crear una"}</Link>
          </div>
          {/* s216 · bloque A: la puerta del comercio y su personal, también desde aquí (el portal ya tenía la vuelta). */}
          <div className="auth__alta">
            {lang === "en" ? "Have a business? " : "¿Tienes un negocio? "}
            <Link to="/merchant/login">{lang === "en" ? "Go to your panel" : "Entra a tu panel"}</Link>
          </div>

        </div>
      </div>

      <div className="auth__pie">
        NXT Reserve · Miami, FL
      </div>

    </div>
  );
}

// ============================================
// PAGE: SIGNUP
// ============================================
function SignupPage() {
  // ETAPA-0 (s97): el signup ya NO pide código de invitación — el código se pide
  // DESPUÉS del login, en la puerta /onboarding (teléfono + "¿tienes código?").
  // Pasos: 1=details, 2=success.
  const lang = useLang();
  const cambiarIdioma = useSetLang();   // s184 - las dos puertas ofrecen cambiar idioma
  const navigate = useNavigate();
  const [step, setStep] = useState(1); // 1=details, 2=success
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { if (auth.isLoggedIn()) navigate("/"); }, [navigate]);

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: e.target.value }));

  const handleSignup = async () => {
    if (!form.name || !form.email || !form.password) {
      setError(lang === "en" ? "Complete all fields" : "Completa todos los campos"); return;
    }
    if (form.password.length < MIN_CLAVE) {
      setError(lang === "en" ? `Password must be at least ${MIN_CLAVE} characters` : `La contraseña debe tener al menos ${MIN_CLAVE} caracteres`); return;
    }
    setLoading(true);
    setError("");
    try {
      await signupUser(form);
      setStep(2);
      setTimeout(() => navigate("/onboarding"), 2500);
    } catch (e) {
      // s203: el texto de Bubble para el correo repetido viene en voseo (signup_api step 6).
      if (e?.code === "EMAIL_TAKEN") {
        setError(lang === "en"
          ? "That email is already registered. Sign in with your password."
          : "Ese correo ya está registrado. Inicia sesión con tu contraseña.");
      } else if (esClaveRechazada(e?.message)) {   // s252-D1
        setError(lang === "en" ? `Password must be at least ${MIN_CLAVE} characters` : `La contraseña debe tener al menos ${MIN_CLAVE} caracteres`);
      } else {
        setError(e.message || (lang === "en" ? "Error creating account" : "Error al crear cuenta"));
      }
    } finally { setLoading(false); }
  };

  // AUTH-1 (s97): registro/ingreso con Google — social_login hace find-or-create.
  // Un usuario nuevo por Google se crea LITE y cae en la puerta (/onboarding) por no tener teléfono.
  const handleGoogleCredential = async (response) => {
    if (!response?.credential) {
      setError(lang === "en" ? "Google sign-in failed" : "Falló el acceso con Google");
      return;
    }
    setLoading(true); setError("");
    try {
      await socialLogin(response.credential);
      const profile = await getUserProfile();
      navigate(routeAfterAuth(profile));
    } catch (e) {
      setError(googleErrorMessage(e, lang, lang === "en"
        ? "This email already has an account — sign in with your password."
        : "Este email ya tiene cuenta — inicia sesión con tu contraseña."));
    } finally { setLoading(false); }
  };
  useEffect(() => {
    let tries = 0;
    const init = () => {
      const g = window.google?.accounts?.id;
      if (!g) { if (tries++ < 40) setTimeout(init, 150); return; }
      try {
        g.initialize({ client_id: GOOGLE_CLIENT_ID, callback: handleGoogleCredential });
        const el = document.getElementById("googleSignupBtn");
        if (el) { el.innerHTML = ""; g.renderButton(el, { theme: "outline", size: "large", text: "signup_with", width: 360 }); }
      } catch (e) { /* GIS no disponible — el registro por email sigue funcionando */ }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="auth">

      {/* s184 - se va el INDICADOR DE DOS PASOS. El segundo paso era «¡Bienvenido!»,
          que no es algo que la persona haga: es la confirmacion de haber terminado.
          Un stepper que cuenta la pantalla de exito como etapa le dice a alguien que
          va por la mitad cuando en realidad ya solo tiene que llenar un formulario.
          Con eso se va tambien la segunda barra fija: eran dos, sobre 480px de caja. */}
      <div className="auth__barra">
        <Logo size="md" tono="oscuro" />
        <button
          onClick={() => cambiarIdioma(lang === "en" ? "es" : "en")}
          style={{ background: "none", border: "1px solid var(--linea)", borderRadius: "var(--radio-boton)",
                   padding: "6px 12px", fontSize: 12, color: "var(--tinta-suave)", cursor: "pointer",
                   fontFamily: "var(--fuente-texto)" }}>
          {lang === "en" ? "ES" : "EN"}
        </button>
      </div>

      <div className="auth__centro">
        <div className="auth__caja">

          {step === 1 && (
            <>
              <div className="auth__saludo">
                <h1 className="auth__titulo">{lang === "en" ? "CREATE YOUR ACCOUNT" : "CREA TU CUENTA"}</h1>
                <p className="auth__bajada">
                  {lang === "en"
                    ? "Members club \u00b7 if you have an invite code, you'll enter it next"
                    : "Club de miembros \u00b7 si tienes c\u00f3digo de invitaci\u00f3n, lo ingresas despu\u00e9s"}
                </p>
              </div>

              <div className="auth__campo">
                <label className="auth__etiqueta" htmlFor="nxt-f57-name">
                  {lang === "en" ? "FULL NAME" : "NOMBRE COMPLETO"}
                </label>
                <input className="auth__entrada" id="nxt-f57-name" autoComplete="name"
                  value={form.name} onChange={set("name")}
                  onKeyDown={e => e.key === "Enter" && handleSignup()}
                  placeholder={lang === "en" ? "Your name" : "Tu nombre"} />
              </div>

              <div className="auth__campo">
                <label className="auth__etiqueta" htmlFor="nxt-f57-email">EMAIL</label>
                <input className="auth__entrada" id="nxt-f57-email" type="email" autoComplete="email"
                  value={form.email} onChange={set("email")}
                  onKeyDown={e => e.key === "Enter" && handleSignup()}
                  placeholder="tu@email.com" />
              </div>

              <div className="auth__campo">
                <label className="auth__etiqueta" htmlFor="nxt-f57-password">
                  {lang === "en" ? "PASSWORD" : "CONTRASE\u00d1A"}
                </label>
                <input className="auth__entrada" id="nxt-f57-password" type="password" autoComplete="new-password"
                  value={form.password} onChange={set("password")}
                  onKeyDown={e => e.key === "Enter" && handleSignup()}
                  placeholder={lang === "en" ? `At least ${MIN_CLAVE} characters` : `M\u00ednimo ${MIN_CLAVE} caracteres`} />
              </div>

              {error && <div className="auth__error" role="alert">{error}</div>}

              <button className="auth__boton" onClick={handleSignup} disabled={loading}>
                {loading
                  ? (lang === "en" ? "Creating\u2026" : "Creando\u2026")
                  : (lang === "en" ? "Create account" : "Crear cuenta")}
              </button>

              <p className="auth__legal">
                {lang === "en" ? "By creating an account you accept our " : "Al crear tu cuenta aceptas los "}
                <Link to="/terms">{lang === "en" ? "Terms of Service" : "T\u00e9rminos del Servicio"}</Link>
                {lang === "en" ? " and " : " y la "}
                <Link to="/privacy">{lang === "en" ? "Privacy Policy" : "Pol\u00edtica de Privacidad"}</Link>.
              </p>

              {/* Mismo orden que en login: el email primero, Google como alternativa.
                  Que las dos puertas se lean igual vale mas que optimizar una. */}
              <div className="auth__o"><span>{lang === "en" ? "OR" : "O"}</span></div>
              <div className="auth__google" id="googleSignupBtn" />

              <div className="auth__alta">
                {lang === "en" ? "Already a member? " : "\u00bfYa eres miembro? "}
                <Link to="/login">{lang === "en" ? "Sign in" : "Inicia sesi\u00f3n"}</Link>
              </div>
            </>
          )}

          {step === 2 && (
            <div className="auth__saludo" style={{ marginBottom: 0 }}>
              <h1 className="auth__titulo">
                {lang === "en" ? "YOUR ACCOUNT IS READY" : "TU CUENTA EST\u00c1 LISTA"}
              </h1>
              <p className="auth__bajada" style={{ marginBottom: 24 }}>
                {lang === "en"
                  ? "One more step: your phone."
                  : "Falta un paso: tu tel\u00e9fono."}
              </p>
              {/* s184 - antes esta pantalla mostraba un emoji de 64px y tres puntos
                  pulsando, y se iba sola a los 2,5 segundos. Quien queria seguir no
                  podia: el timeout mandaba. Ahora hay un boton, y el salto automatico
                  queda como red para el que no lo toca. */}
              <button className="auth__boton" onClick={() => navigate("/onboarding")}>
                {lang === "en" ? "Continue" : "Continuar"}
              </button>
            </div>
          )}

        </div>
      </div>

      <div className="auth__pie">
        NXT Reserve · Miami, FL
      </div>

    </div>
  );
}

function ResponsiveGrid({ offers, navigate }) {
  return (
    <div className="catalogo__tarjetas">
      {offers.map((offer, i) => (
        <OfferCard
          key={offer._id}
          offer={offer}
          variante="catalogo"
          inmediata={i < 5}
          onClick={() => navigate(`/offer/${offer._id}`, { state: { offer } })}
        />
      ))}
    </div>
  );
}

// s196 audit · el esqueleto de la carga (spec §9: «esqueleto con las medidas exactas de
// la versión que va a salir, para que nada salte»). Reemplaza al «NXT · Cargando
// beneficios…» centrado, que además iba en --tinta-tenue a 14px. Es la misma tarjeta
// (`tarjeta--catalogo`): en teléfono sale en filas, como la lista que va a llegar.
function TarjetasEsqueleto({ lang }) {
  return (
    <div className="catalogo__tarjetas" aria-busy="true">
      <span className="nxt-solo-lectores" role="status">
        {lang === "en" ? "Loading benefits…" : "Cargando beneficios…"}
      </span>
      {/* s198 · 8 (ticket esqueleto-8): dos filas de 4, o cuatro filas de 2 en teléfono.
          Misma forma que la tarjeta que llega (s198-D12): foto, trato, nombre, zona. */}
      {Array.from({ length: 8 }, (_, i) => (
        <div key={i} className="tarjeta tarjeta--catalogo" aria-hidden="true">
          <div className="tarjeta__foto" />
          <div className="tarjeta__cuerpo">
            <span className="esqueleto esqueleto--rotulo" />
            <span className="esqueleto esqueleto--cifra" />
            <span className="esqueleto esqueleto--nombre" />
            <span className="esqueleto esqueleto--meta" />
          </div>
        </div>
      ))}
    </div>
  );
}

// ============================================
// PAGE: HOME (Offer Grid)
// ============================================
function InviteUrgencyBanner() {
  const lang = useLang();
  const en = lang === "en";
  const [p, setP] = useState(null);
  useEffect(() => {
    let on = true;
    getUserProfile().then(r => { if (on) setP(r); }).catch(() => {});
    return () => { on = false; };
  }, []);
  if (!p) return null;
  const tier = (p.tier || "").toUpperCase();
  const isFreeAccess = tier === "LITE" || !!p.signup_code;
  const activated = p.has_activated === true || p.has_activated === "yes";
  // ETAPA-1 (s98, banner-24h-copyfix): la mecánica de 24h se RETIRÓ (decisión firme s97 —
  // deactivate_unactivated apagado; la urgencia vive en el CÓDIGO vía AccessCode.expires_at).
  // El banner ya NO lee activation_deadline (dato muerto) ni amenaza con perder el acceso
  // (mentía): ahora es un nudge de valor para el INVITADO real (max_coupons > 0) que
  // todavía no activó nada. El prospecto (0 cupones) no lo ve — su camino es /beneficios.
  const hasCoupons = Number(p.max_coupons ?? 0) > 0;
  if (!isFreeAccess || activated || !hasCoupons) return null;
  const value = Number(p.invite_value_usd) || 0;
  return (
    <div style={{ background: "var(--accion-tinte)", border: `1px solid ${C.red}`, padding: "12px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
      {/* s196 audit: era el emoji 🎁 — el sistema no usa emoji (spec regla 5); el
          regalo es el icono de la familia, que hereda el color del texto. */}
      <Ico name="ico-regalos" size={24} />
      <div style={{ flex: 1, minWidth: 220 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: C.black }}>
          {en ? "Your invitation was FREE" : "Tu invitación fue GRATIS"}
          {value > 0 && (<span style={{ color: C.red }}>{en ? ` — a membership valued at $${value}` : ` — una membresía valuada en $${value}`}</span>)}
        </div>
        <div style={{ fontSize: 12, color: C.gray, marginTop: 2 }}>
          {en ? "Activate your first coupon and start saving." : "Activa tu primer cupón y empieza a ahorrar."}
        </div>
      </div>
    </div>
  );
}

// A1b/A3 (s79) — filtros del feed: dia, destacadas, orden
const FEED_DAY_TOKENS = ["Lun", "Mar", "Mie", "Jue", "Vie", "Sab", "Dom"]; // valores de comparación contra valid_days — SIN tilde (así viven en la base)
const FEED_DAY_LABELS_EN = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
const FEED_DAY_LABELS_ES = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"]; // solo display (MKT-30 lote 1c)
const FEED_DAY_BY_GETDAY = ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"]; // index = Date.getDay()
function todayDayToken() { return FEED_DAY_BY_GETDAY[new Date().getDay()]; }
function offerMatchesDay(o, token) {
  if (!token) return true;
  const list = Array.isArray(o.valid_days_list) ? o.valid_days_list : [];
  if (list.length === 0) return true; // sin dias cargados = disponible siempre
  return list.includes(token);
}

// s183 — el sidebar del catálogo. Reemplaza al FeedFilters horizontal: mismos
// filtros, misma lógica, pero en la columna izquierda del artboard.
//
// Los CONTEOS salen del catálogo cargado, nunca del mockup: los 48/19/8 del
// lienzo son utilería. Se cuentan sobre `todas` (el catálogo completo) y no
// sobre lo ya filtrado, para que el número diga cuántas hay en esa categoría
// y no cuántas quedan después de los otros filtros.
//
// Las categorías son las REALES de la app (CATEGORIES + CAT_MAP, que mapean al
// Option Set de Bubble). El diseño no inventa taxonomía.
// s198 · la zona de una oferta: la MISMA regla que la tarjeta (D-117: sale del dato o no sale).
const zonaDe = (o) => o.neighborhood || o.city || "";

// Las zonas que existen en el catálogo, con su conteo: el filtro «Zona» (s198-D14/D15) se arma
// con lo que hay, no con una lista fija — una zona sin ofertas sería una promesa que la grilla
// no cumple (la misma regla que el chip «Imperdibles», s227-D2).
function zonasDe(ofertas) {
  const m = new Map();
  ofertas.forEach((o) => { const z = zonaDe(o); if (z) m.set(z, (m.get(z) || 0) + 1); });
  return [...m.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0])).map(([z, n]) => ({ z, n }));
}

// Las categorías del catálogo con su conteo. El chip doctrinal «Imperdibles» solo aparece si hay
// ofertas que lo cumplan. La usan la barra lateral (computadora) y la fila de teléfono.
function categoriasDe(todas) {
  const conteo = (cat) => {
    if (cat === "Todos") return todas.length;
    if (cat === BOGO_CAT) return todas.filter(isBestDealOffer).length;
    const real = CAT_MAP[cat] || cat;
    return todas.filter(o => (o.category || "").toLowerCase() === real.toLowerCase()).length;
  };
  const cats = [...CATEGORIES, ...(conteo(BOGO_CAT) > 0 ? [BOGO_CAT] : [])];
  return cats.map(cat => ({ cat, n: conteo(cat) }));
}

// s198-D14/D15 · los grupos de filtros que comparten la barra lateral (computadora) y la hoja
// (teléfono y tablet): Zona y Disponibilidad. No se quitó ningún filtro que ya existía: el
// código postal vive dentro de «Zona» y el día de la semana, dentro de «Disponibilidad».
// `idp` separa los id de la barra y de la hoja: las dos están en el DOM a la vez.
function FiltrosGrupos({
  en, idp, todas, cargando,
  zonaFilter, setZonaFilter, zipFilter, setZipFilter,
  dayFilter, setDayFilter, featuredOnly, setFeaturedOnly,
}) {
  const today = todayDayToken();
  const zonas = zonasDe(todas);
  return (
    <>
      <div className="filtros__grupo" role="group" aria-labelledby={`${idp}-zona`}>
        <div className="filtros__cabeza"><span className="filtros__titulo" id={`${idp}-zona`}>{en ? "Area" : "Zona"}</span></div>
        {zonas.length > 0 && (
          <button type="button" className={`cat${!zonaFilter ? " cat--on" : ""}`} aria-pressed={!zonaFilter}
            onClick={() => setZonaFilter("")}>
            <span>{en ? "All areas" : "Todas las zonas"}</span>
          </button>
        )}
        {zonas.map(({ z, n }) => (
          <button key={z} type="button" className={`cat${zonaFilter === z ? " cat--on" : ""}`}
            aria-pressed={zonaFilter === z} onClick={() => setZonaFilter(zonaFilter === z ? "" : z)}>
            <span>{z}</span>
            {!cargando && <span className="cat__conteo">{n}</span>}
          </button>
        ))}
        <label htmlFor={`${idp}-zip`} className="filtros__sub">{en ? "Or by ZIP code" : "O por código postal"}</label>
        <input
          id={`${idp}-zip`}
          className="campo campo--texto"
          value={zipFilter}
          onChange={e => setZipFilter(e.target.value.replace(/[^0-9]/g, "").slice(0, 5))}
          inputMode="numeric"
          autoComplete="postal-code"
          placeholder="33130"
        />
      </div>

      <div className="filtros__grupo" role="group" aria-labelledby={`${idp}-disp`}>
        <div className="filtros__cabeza"><span className="filtros__titulo" id={`${idp}-disp`}>{en ? "Availability" : "Disponibilidad"}</span></div>
        <button
          type="button"
          className={`check${dayFilter === today ? " check--on" : ""}`}
          aria-pressed={dayFilter === today}
          onClick={() => setDayFilter(dayFilter === today ? "" : today)}
        >
          <span className="caja"><Ico name="ico-ok" size={11} /></span>
          {en ? "Available today" : "Disponible hoy"}
        </button>
        <button
          type="button"
          className={`check${featuredOnly ? " check--on" : ""}`}
          aria-pressed={featuredOnly}
          onClick={() => setFeaturedOnly(v => !v)}
        >
          <span className="caja"><Ico name="ico-ok" size={11} /></span>
          <Ico name="ico-estrella" size={15} />
          {en ? "Featured" : "Destacadas"}
        </button>
        <label htmlFor={`${idp}-dia`} className="filtros__sub">{en ? "Another day" : "Otro día"}</label>
        <select id={`${idp}-dia`} className="campo" value={dayFilter} onChange={e => setDayFilter(e.target.value)}>
          <option value="">{en ? "Any day" : "Cualquier día"}</option>
          {FEED_DAY_TOKENS.map((tok, i) => (
            <option key={tok} value={tok}>{en ? FEED_DAY_LABELS_EN[i] : FEED_DAY_LABELS_ES[i]}</option>
          ))}
        </select>
      </div>
    </>
  );
}

// s198-D14 · la barra lateral de computadora, agrupada como Faire: Categoría (con conteos y
// «Limpiar todo»), Zona y Disponibilidad. Debajo de 1024px no se muestra: ahí manda la fila
// deslizable con «Filtros» (s198-D15). Ver catalogo.css.
function CatalogoSidebar({
  lang, todas, category, setCategory, onLimpiar, hayFiltros, cargando, ...filtros
}) {
  const en = lang === "en";
  return (
    <aside className="catalogo__sidebar" aria-label={en ? "Filters" : "Filtros"}>
      <div className="filtros__grupo catalogo__categorias" role="group" aria-labelledby="lat-cat">
        <div className="filtros__cabeza">
          <span className="filtros__titulo" id="lat-cat">{en ? "Category" : "Categoría"}</span>
          {hayFiltros && (
            <button type="button" className="boton-texto" onClick={onLimpiar}>
              {en ? "Clear all" : "Limpiar todo"}
            </button>
          )}
        </div>
        {categoriasDe(todas).map(({ cat, n }) => {
          const on = category === cat;
          return (
            <button key={cat} type="button" className={`cat${on ? " cat--on" : ""}`} aria-pressed={on}
              onClick={() => setCategory(cat)}>
              {cat === BOGO_CAT
                ? <span className="cat__nombre">{etiquetaCat(cat, en)}<span className="cat__nota">{BOGO_CAT_NOTA[en ? "en" : "es"]}</span></span>
                : <span>{cat}</span>}
              {/* s196 audit: sin conteo mientras carga — antes cada categoría decía 0 */}
              {!cargando && <span className="cat__conteo">{n}</span>}
            </button>
          );
        })}
      </div>
      <FiltrosGrupos en={en} idp="lat" todas={todas} cargando={cargando} {...filtros} />
    </aside>
  );
}

// s198-D15 · la hoja de filtros de teléfono y tablet. Mobbin (Zocdoc, Klarna, Beli, Best Buy):
// título y cerrar arriba, grupos con subtítulo y conteo, y abajo, fijos, «Limpiar» y el botón
// principal con el número de resultados que quedan. Los filtros se aplican mientras se tocan
// (el número del botón se mueve en vivo): «Ver N ofertas» solo cierra.
// <dialog> nativo con showModal(): el foco queda atrapado adentro, Esc cierra y el foco vuelve
// al botón «Filtros» sin código propio.
function HojaFiltros({ abierta, onCerrar, devolverFoco, onLimpiar, total, en, children }) {
  const ref = useRef(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (abierta && !d.open) {
      try { d.showModal(); } catch { d.setAttribute("open", ""); }
    }
    // Recién cerrado el <dialog> la página vuelve a aceptar el foco: ahí se devuelve al botón que
    // abrió la hoja. (Esc lo cierra el navegador y ya lo devuelve él: por teclado el botón tenía foco.)
    if (!abierta && d.open) {
      d.close();
      if (devolverFoco) devolverFoco();
    }
  }, [abierta, devolverFoco]);
  return (
    <dialog
      ref={ref}
      className="hoja"
      aria-labelledby="hoja-filtros-titulo"
      onClose={onCerrar}
      // un toque en el fondo oscuro (el ::backdrop cuenta como el propio <dialog>) cierra
      onClick={(e) => { if (e.target === ref.current) onCerrar(); }}
    >
      <div className="hoja__caja">
        <div className="hoja__cabeza">
          <h2 id="hoja-filtros-titulo" className="hoja__titulo">{en ? "Filters" : "Filtros"}</h2>
          <button type="button" className="hoja__cerrar" onClick={onCerrar} aria-label={en ? "Close filters" : "Cerrar filtros"}>
            <Ico name="ico-cerrar" size={20} />
          </button>
        </div>
        <div className="hoja__cuerpo">{children}</div>
        <div className="hoja__pie">
          <button type="button" className="boton-texto hoja__limpiar" onClick={onLimpiar}>
            {en ? "Clear" : "Limpiar"}
          </button>
          <button type="button" className="hoja__ver" onClick={onCerrar}>
            {en ? `Show ${total} ${total === 1 ? "offer" : "offers"}` : `Ver ${total} ${total === 1 ? "oferta" : "ofertas"}`}
          </button>
        </div>
      </div>
    </dialog>
  );
}

// ============================================================
// s200-D1 · ENCUADRAR LA FOTO ANTES DE SUBIRLA
// ------------------------------------------------------------
// El problema no era que las fotos fueran feas: era que cada una llegaba con una
// proporcion distinta y la app tiene CINCO marcos para mostrarlas. De ahi las bandas
// grises (s196), la tolerancia de 0.78-1.28 que hubo que inventar (s198-D1) y los
// flyers con el texto cortado. Si la foto se encuadra UNA vez, al elegirla, los cinco
// marcos reciben lo mismo y nada de eso hace falta.
//
// Que hace exactamente: abre la foto a pantalla completa en un marco de la proporcion
// pedida (4:5 para la galeria y las ofertas, 1:1 para el logo), deja moverla y
// acercarla con el dedo, y devuelve un File NUEVO ya recortado, de 1600px de lado
// mayor y JPEG 0.82. El original no se sube nunca.
//
// Las dos salidas malas se detectan ANTES de encuadrar y cada una dice que hacer:
//  · mas de 5 MB  -> el navegador no puede achicar lo que no logra decodificar.
//  · no decodifica -> casi siempre un HEIC de iPhone. Se dice donde se cambia.
// Un «error al subir la foto» generico dejaria al comercio probando tres veces la misma.
//
// s202 · `foto-resolucion-minima-aviso`. recortarImagen NO agranda: una foto de 299 px se
// guarda con 299 y el mosaico del comercio la estira a 820 (smoke s201). Por debajo del
// minimo se AVISA y se deja usar igual — a veces es la unica foto que hay (Otto sembrando
// desde Instagram). El aviso distingue la foto chica (no tiene arreglo aca: hay que elegir
// otra) del acercamiento de mas (se arregla alejando), porque el zoom tambien le quita
// pixeles al recorte.
const FOTO_LADO_MIN = 800;   // el marco mas grande de la galeria: el mosaico, ~820 px
const LOGO_LADO_MIN = 256;   // el logo mas grande: 104 px en /m/:id, x2 de densidad = 208
// s234 · siembra-logo-desde-web (Ali: «no puedo alejarlo más»): el encuadrador no deja achicar por debajo del lado corto,
// así que un logo apaisado (casi todos) salía cortado. Se pone primero en un lienzo cuadrado y transparente, centrado y
// con un margen, y sale PNG: en el encuadrador se ve entero y se puede acercar si sobra borde. No se agranda: si el
// logo es chico, el aviso de resolución sigue diciéndolo.
// s255 · alta-logo-desde-web: bajar el logo que trajo la lectura de la web (siembra de Otto y alta del dueño, mismo camino).
// Se baja en el navegador; si el sitio no lo deja (CORS) o no es PNG/JPG/WebP/GIF (un SVG), tira error y la pantalla lo dice.
// Sale ya en el lienzo cuadrado, listo para el encuadrador (regla s206: después sale en WebP/PNG con techo de peso).
async function bajarLogoDeLaWeb(u) {
  const res = await fetch(u, { mode: "cors" });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  if (!/^image\/(png|jpe?g|webp|gif)$/.test(blob.type)) throw new Error("no_imagen");
  const ext = (blob.type.split("/")[1] || "png").replace("jpeg", "jpg");
  return logoEnCuadrado(new File([blob], `logo-web.${ext}`, { type: blob.type }));
}
// s256 · logo-web-cors-no-ofrecer (prueba en version-test, Greenstreet): el alta ofrecía el logo de la web antes de saber si se
// podía bajar. Con CORS bloqueado, la muestra era el PNG blanco crudo sobre el círculo blanco (no se veía) y «Usar este logo»
// recién ahí decía que no. Ahora se baja ANTES de ofrecerlo: se ofrece el primero que baja, ya en el lienzo cuadrado (un logo
// claro, con su fondo oscuro), y la muestra es ese mismo archivo. Si ninguno baja, no se ofrece nada. `bajar` se pasa para probar.
async function primerLogoQueBaja(urls, bajar = bajarLogoDeLaWeb) {
  for (const url of (urls || []).filter(Boolean)) {
    try {
      const file = await bajar(url);
      if (file) return { url, file };
    } catch (_) { /* CORS, SVG o 404: se prueba el siguiente */ }
  }
  return null;
}
// s255 · logo-claro-sobre-blanco (Ali): un logo blanco o muy claro sobre fondo transparente (Versailles) desaparece en el
// círculo blanco de la ficha y de las ofertas. Si el PNG tiene transparencia de verdad y lo que se ve es claro, se le pone
// un fondo oscuro al encuadrarlo (el color de la tinta del sistema). Un logo de color u oscuro queda como estaba.
// `datos`: los RGBA de un canvas. Se mira 1 de cada `paso` píxeles.
const FONDO_LOGO_CLARO = "#0F1B2A";   // = --tinta (tokens.css)
function logoEsClaro(datos, paso = 4) {
  let total = 0, transparentes = 0, opacos = 0, luz = 0;
  for (let k = 0; k < datos.length; k += 4 * paso) {
    total++;
    const a = datos[k + 3];
    if (a < 32) { transparentes++; continue; }
    if (a < 200) continue;   // el borde suavizado no cuenta
    opacos++;
    luz += 0.2126 * datos[k] + 0.7152 * datos[k + 1] + 0.0722 * datos[k + 2];
  }
  if (!total || !opacos) return false;
  return transparentes / total >= 0.15 && luz / opacos >= 215;
}
async function logoEnCuadrado(file) {
  const u = URL.createObjectURL(file);
  try {
    const img = await new Promise((ok, mal) => { const i = new Image(); i.onload = () => ok(i); i.onerror = mal; i.src = u; });
    const w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h) return file;
    const lado = Math.round(Math.max(w, h) * 1.12);
    const c = document.createElement("canvas");
    c.width = lado; c.height = lado;
    const ctx = c.getContext("2d");
    let claro = false;
    try {
      const m = document.createElement("canvas"); m.width = w; m.height = h;
      const mc = m.getContext("2d"); mc.drawImage(img, 0, 0);
      claro = logoEsClaro(mc.getImageData(0, 0, w, h).data);
    } catch (_) { /* sin lectura de píxeles, queda como estaba */ }
    if (claro) { ctx.fillStyle = FONDO_LOGO_CLARO; ctx.fillRect(0, 0, lado, lado); }
    ctx.drawImage(img, Math.round((lado - w) / 2), Math.round((lado - h) / 2), w, h);
    const blob = await new Promise(ok => c.toBlob(ok, "image/png"));
    return blob ? new File([blob], "logo.png", { type: "image/png" }) : file;
  } catch (e) {
    return file;
  } finally {
    URL.revokeObjectURL(u);
  }
}

function EncuadrarFoto({ file, proporcion = 1, tipoSalida = "image/jpeg", ladoMax, ladoMin = FOTO_LADO_MIN, titulo, textoListo, onListo, onCancelar, en }) {
  const ref = useRef(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [giro, setGiro] = useState(0);
  const [area, setArea] = useState(null);
  const [natural, setNatural] = useState(null);     // { w, h } de la foto original
  const [trabajando, setTrabajando] = useState(false);
  const [problema, setProblema] = useState(null);   // "peso" | "formato" | "canvas"

  // s201 · LA URL SE CREA EN EL MISMO EFECTO QUE LA LIBERA. Antes salia de un useMemo y
  // la liberaba la limpieza de un efecto: el smoke de s201 abrio el encuadrador con el
  // marco NEGRO (img con naturalWidth 0, ERR_FILE_NOT_FOUND). StrictMode monta, limpia y
  // vuelve a montar; la limpieza revocaba la URL y el useMemo, con el mismo `file`, no
  // la volvia a crear. Asi cada montaje tiene la suya y la limpia al irse.
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!file) { setUrl(null); return; }
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);

  // Las dos revisiones previas. El peso se sabe sin abrir el archivo; el formato, solo
  // intentando decodificarlo — y eso conviene saberlo ACA y no cuando el marco queda negro.
  useEffect(() => {
    if (!file) return;
    if (file.size > FOTO_PESO_MAX) { setProblema("peso"); return; }
    let vivo = true;
    const img = new Image();
    img.onerror = () => { if (vivo) setProblema("formato"); };
    img.onload = () => { if (vivo) setNatural({ w: img.naturalWidth, h: img.naturalHeight }); };
    img.src = URL.createObjectURL(file);
    return () => { vivo = false; URL.revokeObjectURL(img.src); };
  }, [file]);

  // Lo que el marco puede sacar como mucho (zoom 1) y lo que saca ahora. Girar no cambia
  // ninguno de los dos: el lado corto sigue siendo el mismo.
  const ladoFuente = natural ? Math.min(natural.w, natural.h) : null;
  const ladoRecorte = area ? Math.round(Math.min(area.width, area.height)) : null;
  const resolucion = ladoFuente !== null && ladoFuente < ladoMin ? "chica"
    : (ladoRecorte !== null && ladoRecorte < ladoMin ? "cerca" : null);

  useEffect(() => {
    const d = ref.current;
    if (d && !d.open) { try { d.showModal(); } catch (e) { d.setAttribute("open", ""); } }
  }, []);

  const usar = async () => {
    if (!area || trabajando) return;
    setTrabajando(true);
    // `ladoMax` sin valor deja el de api.js (1600, el canonico de la galeria); el logo
    // pide 512, que es lo que cabe en el circulo mas grande donde se dibuja.
    const recortada = await recortarImagen(file, area, {
      rotacion: giro, tipo: tipoSalida, ...(ladoMax ? { ladoMax } : {}),
    });
    setTrabajando(false);
    if (!recortada) { setProblema("canvas"); return; }
    onListo(recortada);
  };

  const TEXTOS = {
    peso: en
      ? { t: "This photo is over 5 MB", d: "Choose another one or take it again. We can't shrink a file the browser cannot open." }
      : { t: "Esta foto pesa más de 5 MB", d: "Elige otra o tómala de nuevo. No podemos achicar un archivo que el navegador no logra abrir." },
    formato: en
      ? { t: "We couldn't open this photo", d: "If it comes from an iPhone, go to Settings › Camera › Formats and choose “Most Compatible”." }
      : { t: "No pudimos abrir esta foto", d: "Si viene de un iPhone, entra en Ajustes › Cámara › Formatos y elige «Más compatible»." },
    canvas: en
      ? { t: "We couldn't prepare this photo", d: "Try again, or choose a different one." }
      : { t: "No pudimos preparar esta foto", d: "Inténtalo otra vez, o elige otra." },
  };

  return (
    <dialog ref={ref} className="encuadre" aria-labelledby="encuadre-titulo" onClose={onCancelar}>
      <div className="encuadre__caja">
        <div className="encuadre__cabeza">
          <h2 id="encuadre-titulo" className="encuadre__titulo">
            {titulo || (en ? "Frame your photo" : "Encuadra tu foto")}
          </h2>
          <button type="button" className="encuadre__cerrar" onClick={onCancelar}
            aria-label={en ? "Cancel" : "Cancelar"}>×</button>
        </div>

        {problema ? (
          <>
            <div className="encuadre__problema">
              <p className="encuadre__problema-titulo">{TEXTOS[problema].t}</p>
              <p className="encuadre__problema-texto">{TEXTOS[problema].d}</p>
            </div>
            <div className="encuadre__pie">
              <div className="encuadre__acciones">
                <button type="button" className="encuadre__usar" onClick={onCancelar}>
                  {en ? "Choose another photo" : "Elegir otra foto"}
                </button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="encuadre__marco">
              {url && (
                <Cropper
                  image={url}
                  crop={crop}
                  zoom={zoom}
                  rotation={giro}
                  aspect={proporcion}
                  minZoom={1}
                  maxZoom={4}
                  restrictPosition
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={(_, px) => setArea(px)}
                />
              )}
            </div>
            <div className="encuadre__pie">
              <div role="status" aria-live="polite">
                {resolucion === "chica" && (
                  <p className="encuadre__aviso">
                    <strong>{en ? `This image is small: ${ladoFuente} px per side.` : `Esta imagen es chica: ${ladoFuente} px de lado.`}</strong>{" "}
                    {en ? "It will look blurry on the listing. If you have a bigger one, choose it; if not, you can still use it."
                        : "Se verá borrosa en la ficha. Si tienes una más grande, elígela; si no, puedes usarla igual."}
                  </p>
                )}
                {resolucion === "cerca" && (
                  <p className="encuadre__aviso">
                    <strong>{en ? `At this zoom only ${ladoRecorte} px per side remain.` : `Con este acercamiento quedan ${ladoRecorte} px de lado.`}</strong>{" "}
                    {en ? "It will look blurry on the listing. Zoom out a little." : "Se verá borrosa en la ficha. Aléjala un poco."}
                  </p>
                )}
              </div>
              <p className="encuadre__ayuda">
                {en ? "Drag and pinch to frame it" : "Mueve y acerca para encuadrar"}
              </p>
              {/* Con el dedo se pellizca y con el raton se usa la rueda; por teclado no
                  llega ninguna de las dos, y este control si. */}
              <input className="encuadre__zoom" type="range" min="1" max="4" step="0.05"
                value={zoom} onChange={(e) => setZoom(Number(e.target.value))}
                aria-label={en ? "Zoom" : "Acercar"} />
              <div className="encuadre__acciones">
                {/* Las fotos de telefono llegan giradas seguido: el EXIF las endereza al
                    abrirlas, pero una foto tomada de costado a proposito sigue de costado. */}
                <button type="button" className="encuadre__girar" onClick={() => setGiro((g) => (g + 90) % 360)}
                  aria-label={en ? "Rotate 90 degrees" : "Girar 90 grados"}>↻</button>
                <button type="button" className="encuadre__cancelar" onClick={onCancelar}>
                  {en ? "Cancel" : "Cancelar"}
                </button>
                <button type="button" className="encuadre__usar" onClick={usar} disabled={!area || trabajando}>
                  {trabajando ? (en ? "Preparing…" : "Preparando…") : (textoListo || (en ? "Use photo" : "Usar foto"))}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </dialog>
  );
}

function HomePage() {
  const navigate = useNavigate();
  const lang = useLang();
  const [offers, setOffers] = useState([]);
  const [allOffers, setAllOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("Todos");
  const [search, setSearch] = useState("");
  const [useMock, setUseMock] = useState(false);
  const [dayFilter, setDayFilter] = useState("");        // A1b: token de dia o ""
  const [featuredOnly, setFeaturedOnly] = useState(false); // A3: solo destacadas
  const [sortBy, setSortBy] = useState("relevance");       // A: orden del feed
  const [zipFilter, setZipFilter] = useState("");           // A2: zip del merchant (join)
  const [zonaFilter, setZonaFilter] = useState("");         // s198-D14/D15: zona (barrio o ciudad), del dato
  const [hojaAbierta, setHojaAbierta] = useState(false);    // s198-D15: la hoja de filtros de teléfono
  // Al cerrar la hoja, el foco vuelve a «Filtros» a mano: <dialog> solo lo devuelve si el botón
  // lo tenía, y Safari de iPhone no le da el foco a un botón al tocarlo. Lo hace HojaFiltros
  // justo después de cerrar el <dialog> (antes, la página de atrás está inerte y focus() no entra).
  const botonFiltrosRef = useRef(null);
  const cerrarHoja = useCallback(() => setHojaAbierta(false), []);
  const devolverFocoAFiltros = useCallback(() => {
    if (botonFiltrosRef.current) botonFiltrosRef.current.focus();
  }, []);

  // s183 · el término de búsqueda entra por la URL, porque el buscador se mudó al
  // nav y ahora es global. Que viva en la URL tiene dos ventajas sobre un estado
  // compartido: la búsqueda es compartible y sobrevive a un refresh.
  const [searchParams] = useSearchParams();
  useEffect(() => { setSearch(searchParams.get("q") || ""); }, [searchParams]);

  const loadOffers = useCallback(async () => {
    setLoading(true);
    try {
      // s233 · catalogo-sembradas-admin: Admin y Operator ven también las Pending (sembradas sin confirmar), al final.
      const [aprobadas, sinConfirmar] = await Promise.all([
        getOffers(null),
        rolDeLaSesion().then(r => (ROLES_VEN_TODO.includes(r) ? getOfertasSinConfirmar() : [])).catch(() => []),
      ]);
      const data = [...(aprobadas || []), ...(sinConfirmar || [])];
      if (data && data.length > 0) {
        setAllOffers(data);
        setUseMock(false);
      } else {
        setAllOffers(MOCK_OFFERS);
        setUseMock(true);
      }
    } catch {
      setAllOffers(MOCK_OFFERS);
      setUseMock(true);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadOffers(); }, [loadOffers]);

  useEffect(() => {
    const isBogoCat = category === BOGO_CAT;
    const cat = (category === "Todos" || isBogoCat) ? null : CAT_MAP[category] || category;
    const q = search.toLowerCase();
    let filtered = allOffers.filter(o => {
      const catMatch = isBogoCat ? isBestDealOffer(o) : (!cat || (o.category || "").toLowerCase() === cat.toLowerCase());
      const searchMatch = !search ||
        (o.title_es || "").toLowerCase().includes(q) ||
        (o.title_en || "").toLowerCase().includes(q) ||
        (o.merchant_name || "").toLowerCase().includes(q);
      const dayMatch = offerMatchesDay(o, dayFilter);
      const featMatch = !featuredOnly || o.featured === true;
      const zipMatch = !zipFilter || (o.zip || "").startsWith(zipFilter);
      const zonaMatch = !zonaFilter || zonaDe(o) === zonaFilter;
      return catMatch && searchMatch && dayMatch && featMatch && zipMatch && zonaMatch;
    });
    const savings = (o) => (esPorcentaje(o) ? valorDeOferta(o) : Number(o.typical_savings || o.benefit_value_usd || 0));   // s221-D1: el % ordena por su tope
    const created = (o) => new Date(o["Created Date"] || o.created_date || 0).getTime();
    filtered = [...filtered].sort((a, b) => {
      if (sortBy === "newest") return created(b) - created(a);
      if (sortBy === "savings") return savings(b) - savings(a);
      return (b.featured === true ? 1 : 0) - (a.featured === true ? 1 : 0); // relevancia: destacadas primero
    });
    setOffers(filtered);
  }, [allOffers, category, search, dayFilter, featuredOnly, sortBy, zipFilter, zonaFilter]);

  const limpiarTodo = () => {
    setSearch(""); setCategory("Todos"); setDayFilter("");
    setFeaturedOnly(false); setZipFilter(""); setZonaFilter("");
  };
  // s198 · «Limpiar» de la hoja limpia lo que está EN la hoja; la categoría vive afuera, en la fila.
  const limpiarHoja = () => {
    setDayFilter(""); setFeaturedOnly(false); setZipFilter(""); setZonaFilter("");
  };
  // Un filtro "puesto" es el que RECORTA el catálogo. El orden no cuenta: no
  // recorta nada, así que ni genera chip ni enciende «Limpiar filtros».
  const hayFiltros = !!(search || category !== "Todos" || dayFilter || featuredOnly || zipFilter || zonaFilter);
  // Cuántos filtros de la hoja están puestos: el número del botón «Filtros» de la fila.
  const filtrosEnHoja = [zonaFilter, zipFilter, dayFilter, featuredOnly].filter(Boolean).length;
  const filtrosCompartidos = {
    zonaFilter, setZonaFilter, zipFilter, setZipFilter,
    dayFilter, setDayFilter, featuredOnly, setFeaturedOnly,
  };
  const etiquetaDia = (tok) => {
    const i = FEED_DAY_TOKENS.indexOf(tok);
    if (i < 0) return tok;
    return lang === "en" ? FEED_DAY_LABELS_EN[i] : FEED_DAY_LABELS_ES[i];
  };
  // Cada chip muestra un filtro puesto y se quita solo a sí mismo.
  const chips = [
    search && { k: "q", txt: `“${search}”`, off: () => setSearch("") },
    category !== "Todos" && { k: "cat", txt: etiquetaCat(category, lang === "en"), off: () => setCategory("Todos") },
    dayFilter && {
      k: "dia",
      txt: dayFilter === todayDayToken()
        ? (lang === "en" ? "Available today" : "Disponible hoy")
        : etiquetaDia(dayFilter),
      off: () => setDayFilter(""),
    },
    featuredOnly && { k: "dest", txt: lang === "en" ? "Featured" : "Destacadas", off: () => setFeaturedOnly(false) },
    zipFilter && { k: "zip", txt: `ZIP ${zipFilter}`, off: () => setZipFilter("") },
    zonaFilter && { k: "zona", txt: zonaFilter, off: () => setZonaFilter("") },
  ].filter(Boolean);

  return (
    <div className="catalogo">
      {/* La barra superior propia del catálogo se retiró: el Navbar de escritorio
          ya trae logo, links y ciudad, y «Comercios» dejó de ser un enlace suelto
          acá adentro para ser un destino de la navegación. */}
      <Navbar activePage="home" />

      {/* s212 · la cabecera va en una banda azul de borde a borde, como el encabezado de la vitrina */}
      <div className="catalogo__banda"><div className="catalogo__ancho">
        {/* Cabecera: el título y el buscador, como en el artboard */}
        <div className="catalogo__cabecera">
          <div>
            <h1 className="catalogo__titulo">
              {lang === "en" ? <>Miami's <em>best</em></> : <>Lo mejor de <em>Miami</em></>}
            </h1>
            {/* s196 audit: mientras carga decía «0 beneficios elegidos a mano» — un cero
                que no es verdad. El número entra cuando existe. */}
            <div className="catalogo__bajada">
              {/* s215 · como en la bienvenida (Ali, B): con menos de 10 el número resta; se dice sin cifra. */}
              {!loading && allOffers.length >= LUGARES_PARA_MOSTRAR && <>{allOffers.length}{" "}</>}
              {lang === "en" ? "curated benefits · 6 categories" : "beneficios elegidos a mano · 6 categorías"}
            </div>
          </div>
          {/* s183 · el buscador de esta cabecera se retiró: ahora vive en el nav y
              es global — se puede buscar desde cualquier pantalla, no solo estando
              acá. El término llega por la URL (`/?q=…`) y el chip removible de la
              barra de resultados sigue siendo la forma de sacarlo. */}
        </div>
      </div></div>

      <div className="catalogo__ancho">
        {/* s215 · Ali: mientras la membresía esté cerrada, el que entra (sobre todo un comercio) tiene que
            saber que el club se está armando y crece cada semana, no ver un catálogo «vacío». */}
        {!MEMBRESIA_ABIERTA && <CatalogoConstruyendo en={lang === "en"} />}
        <InviteUrgencyBanner />

        <div className="catalogo__grid">
          <CatalogoSidebar
            lang={lang}
            todas={allOffers}
            category={category}
            setCategory={cat => { setCategory(cat); setSearch(""); }}
            onLimpiar={limpiarTodo}
            hayFiltros={hayFiltros}
            cargando={loading}
            {...filtrosCompartidos}
          />

          <div>
            {/* s198-D15 · teléfono y tablet: UNA fila que se desliza, con «Filtros» primero y
                las categorías después (Too Good To Go). Zona, disponibilidad, día y orden
                viven en la hoja. En computadora no se muestra (manda la barra lateral). */}
            <div className="filtros-fila" role="group" aria-label={lang === "en" ? "Categories" : "Categorías"}>
              <button
                ref={botonFiltrosRef}
                type="button"
                className={`filtros-fila__boton${filtrosEnHoja ? " filtros-fila__boton--on" : ""}`}
                aria-haspopup="dialog"
                onClick={() => setHojaAbierta(true)}
              >
                <Ico name="ico-controles" size={18} />
                {lang === "en" ? "Filters" : "Filtros"}
                {filtrosEnHoja > 0 && <span className="filtros-fila__n">{filtrosEnHoja}</span>}
              </button>
              {categoriasDe(allOffers).map(({ cat }) => {
                const on = category === cat;
                return (
                  <button key={cat} type="button" className={`filtros-fila__chip${on ? " filtros-fila__chip--on" : ""}`}
                    aria-pressed={on} onClick={() => { setCategory(cat); setSearch(""); }}
                    title={cat === BOGO_CAT ? BOGO_CAT_NOTA[lang === "en" ? "en" : "es"] : undefined}>
                    {etiquetaCat(cat, lang === "en")}
                  </button>
                );
              })}
            </div>

            <HojaFiltros
              abierta={hojaAbierta}
              onCerrar={cerrarHoja}
              devolverFoco={devolverFocoAFiltros}
              onLimpiar={limpiarHoja}
              total={offers.length}
              en={lang === "en"}
            >
              <FiltrosGrupos en={lang === "en"} idp="hoja" todas={allOffers} cargando={loading} {...filtrosCompartidos} />
              {/* Klarna y Beli ponen el orden dentro de la hoja: en teléfono, la barra de
                  resultados ya no carga un selector propio (catalogo.css lo esconde). */}
              <div className="filtros__grupo">
                <div className="filtros__cabeza">
                  <label htmlFor="hoja-orden" className="filtros__titulo">{lang === "en" ? "Sort by" : "Ordenar por"}</label>
                </div>
                <select id="hoja-orden" className="campo" value={sortBy} onChange={e => setSortBy(e.target.value)}>
                  <option value="relevance">{lang === "en" ? "Relevance" : "Relevancia"}</option>
                  <option value="newest">{lang === "en" ? "Newest" : "Más nuevas"}</option>
                  <option value="savings">{lang === "en" ? "Biggest savings" : "Mayor ahorro"}</option>
                </select>
              </div>
            </HojaFiltros>

            {/* s196: cada tarjeta es un <h3>; sin este h2 el catálogo saltaba de h1 a h3 */}
            <h2 className="nxt-solo-lectores">{lang === "en" ? "Benefits" : "Beneficios"}</h2>
            {/* Barra de resultados: qué está filtrado, cuántas quedan, en qué orden */}
            <div className="catalogo__barra">
              <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                {chips.map(c => (
                  <button key={c.k} type="button" className="chip chip--filtro" onClick={c.off}>
                    {c.txt}
                    <Ico name="ico-cerrar" size={12} />
                  </button>
                ))}
                {!loading && (
                  <span className="catalogo__conteo">
                    {offers.length}{" "}
                    {lang === "en"
                      ? (offers.length === 1 ? "result" : "results")
                      : (offers.length === 1 ? "resultado" : "resultados")}
                  </span>
                )}
              </div>
              <div className="catalogo__orden">
                <label htmlFor="cat-orden">{lang === "en" ? "Sort by" : "Ordenar por"}</label>
                <select id="cat-orden" className="campo" value={sortBy} onChange={e => setSortBy(e.target.value)} style={{ minHeight: 38, width: "auto" }}>
                  <option value="relevance">{lang === "en" ? "Relevance" : "Relevancia"}</option>
                  <option value="newest">{lang === "en" ? "Newest" : "Más nuevas"}</option>
                  <option value="savings">{lang === "en" ? "Biggest savings" : "Mayor ahorro"}</option>
                </select>
              </div>
            </div>

            {loading ? (
              <TarjetasEsqueleto lang={lang} />
            ) : offers.length === 0 ? (
              // s198-D18 · sin resultados, SIEMPRE con una salida (Tabby y otras cinco en
              // Mobbin). Con filtros puestos la salida es «Limpiar filtros»; con el catálogo
              // vacío y sin filtros no hay nada que limpiar, así que no se ofrece un botón inútil.
              <div className="catalogo__vacio" role="status">
                <span className="catalogo__vacio-icono" aria-hidden="true"><Ico name="ico-buscar" size={28} /></span>
                <p className="catalogo__vacio-titulo">
                  {hayFiltros
                    ? (lang === "en" ? "No offers match those filters" : "No hay ofertas con esos filtros")
                    : (lang === "en" ? "No offers yet" : "Todavía no hay ofertas")}
                </p>
                <p className="catalogo__vacio-texto">
                  {hayFiltros
                    ? (lang === "en" ? "Try another category or remove a filter." : "Prueba con otra categoría o quita un filtro.")
                    : (lang === "en" ? "We add new places every week." : "Sumamos comercios nuevos cada semana.")}
                </p>
                {hayFiltros && (
                  <button type="button" className="catalogo__vacio-boton" onClick={limpiarTodo}>
                    {lang === "en" ? "Clear filters" : "Limpiar filtros"}
                  </button>
                )}
              </div>
            ) : (
              <ResponsiveGrid offers={offers} navigate={navigate} />
            )}
          </div>
        </div>
      </div>

      {/* el hueco que la barra fija de teléfono le tapa al contenido */}
      <Pie />
    </div>
  );
}

// ============================================
// STRIPE: PAYMENT FORM
// ============================================
function PaymentForm({ fee, offerId, onSuccess, onCancel, lang }) {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  // X.42: ofrecer tarjetas guardadas en el checkout (no re-tipear)
  const [savedCards, setSavedCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(true);
  const [selectedPm, setSelectedPm] = useState("new"); // "new" o un pm_id guardado

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const token = localStorage.getItem("nxt_token");
        const res = await fetch(`${API_BASE}/wf/get_payment_methods`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        let cards = [];
        if (data?.response?.cards) {
          try { cards = JSON.parse(data.response.cards); } catch { cards = []; }
        }
        if (!active) return;
        cards = Array.isArray(cards) ? cards : [];
        setSavedCards(cards);
        if (cards.length > 0) {
          const def = cards.find(c => c.is_default) || cards[0];
          setSelectedPm(def.id);
        }
      } catch (e) {
        if (active) setSavedCards([]);
      } finally {
        if (active) setLoadingCards(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const handleSubmit = async () => {
    if (!stripe) return;
    const useNew = selectedPm === "new";
    let cardEl = null;
    if (useNew) {
      if (!elements) return;
      cardEl = elements.getElement(CardElement);
      if (!cardEl) { setError(lang === "en" ? "Enter card details" : "Ingresa los datos de tarjeta"); return; }
    }
    setProcessing(true);
    setError("");
    try {
      // 1. Create PaymentIntent in Bubble (backend ata el customer cuando existe → X.42).
      // s143: sin amount — el monto lo computa el server. Si respondiera NO_FEE_REQUIRED
      // (carrera: el user quedó exento entre el probe y el pago), activamos sin PI.
      const intentData = await createPaymentIntent({ offer_id: offerId });
      if (intentData?.no_fee_required) { onSuccess(null); return; }

      // 2. Confirm payment with Stripe — pm guardado (string) o tarjeta nueva (element)
      const result = await stripe.confirmCardPayment(intentData.client_secret, {
        payment_method: useNew ? { card: cardEl } : selectedPm,
      });

      if (result.error) {
        setError(result.error.message);
        setProcessing(false);
        return;
      }

      if (result.paymentIntent?.status === "succeeded") {
        onSuccess(result.paymentIntent.id);
      } else {
        setError("Pago no completado. Intenta de nuevo.");
        setProcessing(false);
      }
    } catch (e) {
      console.error("STRIPE ERROR:", e);
      setError(e.message || (lang === "en" ? "Payment error" : "Error en el pago"));
      setProcessing(false);
    }
  };

  return (
    <div>
      {/* X.42: tarjetas guardadas */}
      {!loadingCards && savedCards.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: C.muted, letterSpacing: "0.15em", marginBottom: 8, textTransform: "uppercase" }}>
            {lang === "en" ? "Payment Method" : "Método de Pago"}
          </div>
          {savedCards.map((card, i) => (
            <label key={card.id || i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", border: `1px solid ${selectedPm === card.id ? C.red : C.border}`, borderRadius: 8, marginBottom: 8, cursor: "pointer", background: selectedPm === card.id ? "var(--accion-tinte)" : C.white }}>
              <input type="radio" name="pm" checked={selectedPm === card.id} onChange={() => setSelectedPm(card.id)} />
              <span style={{ fontSize: 13, fontWeight: 500, color: C.black }}>💳 {card.brand ? card.brand.charAt(0).toUpperCase() + card.brand.slice(1) : "Card"}</span>
              <span style={{ fontSize: 13, color: C.black }}>•••• {card.last4}</span>
              <span style={{ fontSize: 11, color: C.muted, marginLeft: "auto" }}>{card.exp_month}/{card.exp_year}</span>
            </label>
          ))}
          <label style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", border: `1px solid ${selectedPm === "new" ? C.red : C.border}`, borderRadius: 8, cursor: "pointer", background: selectedPm === "new" ? "var(--accion-tinte)" : C.white }}>
            <input type="radio" name="pm" checked={selectedPm === "new"} onChange={() => setSelectedPm("new")} />
            <span style={{ fontSize: 13, color: C.black }}>{lang === "en" ? "Use a new card" : "Usar tarjeta nueva"}</span>
          </label>
        </div>
      )}

      {/* Datos de tarjeta nueva (cuando no hay guardadas o se elige "nueva") */}
      {(selectedPm === "new" || (!loadingCards && savedCards.length === 0)) && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, color: C.muted, letterSpacing: "0.15em", marginBottom: 8, textTransform: "uppercase" }}>
            {lang === "en" ? "Card Details" : "Datos de Tarjeta"}
          </div>
          <div style={{ border: `1px solid ${C.border}`, padding: "14px 16px", background: C.light }}>
            <CardElement options={{
              style: {
              // s184 · LOS HEX DE ACA NO SE TOKENIZAN, Y NO ES UN OLVIDO.
              // Este objeto no lo aplica React: se lo pasamos a Stripe, que lo
              // inyecta DENTRO DE SU IFRAME. Ese documento no carga tokens.css,
              // asi que `var(--lo-que-sea)` no resuelve a nada y el campo cae al
              // color por defecto de Stripe. Los valores tienen que viajar
              // literales. Van los mismos que --tinta y --tinta-apagada; si esos
              // cambian en tokens.css, estos se copian a mano (igual que el
              // bloque `:root` de public/index.html — L#591).
                base: {
                  fontSize: "15px",
                  color: "#0F1B2A",
                  fontFamily: "'DM Sans', sans-serif",
                  "::placeholder": { color: "#A9ADB3" },
                },
                invalid: { color: C.red },
              },
            }} />
          </div>
        </div>
      )}

      {error && (
        <div style={{ background: "var(--accion-tinte)", border: `1px solid ${C.red}`, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.red }}>
          {error}
        </div>
      )}

      <button onClick={handleSubmit} disabled={processing || !stripe} style={{
        ...S.btnPrimary, width: "100%", padding: "16px",
        opacity: processing || !stripe ? 0.7 : 1, marginBottom: 12,
      }}>
        {processing
          ? (lang === "en" ? "Processing..." : "Procesando...")
          : (lang === "en" ? `Pay $${fee.toFixed(2)}` : `Pagar $${fee.toFixed(2)}`)}
      </button>

      <button onClick={onCancel} disabled={processing} style={{
        background: "none", border: `1px solid ${C.border}`, color: C.gray,
        width: "100%", padding: "12px", fontSize: 13, cursor: "pointer",
        fontFamily: "'DM Sans', sans-serif",
      }}>
        {lang === "en" ? "Cancel" : "Cancelar"}
      </button>

      <p style={{ fontSize: 11, color: C.muted, textAlign: "center", marginTop: 12 }}>
        🔒 {lang === "en" ? "Secured by Stripe" : "Seguro con Stripe"}
      </p>
    </div>
  );
}

function StripePaymentModal({ fee, offerId, onSuccess, onCancel, lang }) {
  const [walletErr, setWalletErr] = useState("");
  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)",
      zIndex: 200, display: "flex", alignItems: "flex-end", justifyContent: "center",
    }}>
      <div role="dialog" aria-modal="true" aria-label={lang === "en" ? "Activate benefit" : "Activar beneficio"} style={{
        background: C.white, width: "100%", maxWidth: 480,
        padding: "32px 24px 40px", borderRadius: "12px 12px 0 0",
        maxHeight: "85vh", overflowY: "auto",
      }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <div style={{ ...S.display, fontSize: 24, color: C.black, marginBottom: 4 }}>
            {lang === "en" ? "ACTIVATE BENEFIT" : "ACTIVAR BENEFICIO"}
          </div>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, marginTop: 8 }}>
            <span style={{ fontSize: 28, fontWeight: 700, color: C.red, fontFamily: "'Bebas Neue', sans-serif" }}>
              ${fee.toFixed(2)}
            </span>
            <span style={{ fontSize: 12, color: C.muted }}>
              {lang === "en" ? "one-time activation fee" : "fee único de activación"}
            </span>
          </div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
            {lang === "en" ? "10% of benefit value · min $4.99 · max $9.99" : "10% del valor · mín $4.99 · máx $9.99"}
          </div>
        </div>

        {/* Divider */}
        <div style={{ height: 1, background: C.border, marginBottom: 24 }} />

        <WalletSection
          amountCents={Math.round(fee * 100)}
          createIntent={() => createPaymentIntent({ offer_id: offerId })}
          onPaid={(pi) => onSuccess(pi.id)}
          onError={setWalletErr}
          lang={lang}
        />
        {walletErr && (
          <div style={{ background: "var(--accion-tinte)", border: `1px solid ${C.red}`, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.red }}>{walletErr}</div>
        )}

        <Elements stripe={stripePromise}>
          <PaymentForm
            fee={fee}
            offerId={offerId}
            onSuccess={onSuccess}
            onCancel={onCancel}
            lang={lang}
          />
        </Elements>
      </div>
    </div>
  );
}

// ============ MEMBERSHIP PAYMENT (FIX-9a — compra de membresía in-app) ============
// Espejo de PaymentForm pero para membresía: el monto lo computa el WF server-side
// (plan + descuento). Flujo: create_membership_payment_intent → confirmCardPayment →
// confirm_membership_purchase (re-pasa discount_code → Step 10 marca el código usado).
function MembershipPaymentForm({ planId, finalPrice, discountCode, discountMode, onSuccess, onCancel, lang }) {
  const stripe = useStripe();
  const elements = useElements();
  const en = lang === "en";
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");
  const [savedCards, setSavedCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(true);
  const [selectedPm, setSelectedPm] = useState("new");

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const token = localStorage.getItem("nxt_token");
        const res = await fetch(`${API_BASE}/wf/get_payment_methods`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        let cards = [];
        if (data?.response?.cards) { try { cards = JSON.parse(data.response.cards); } catch { cards = []; } }
        if (!active) return;
        cards = Array.isArray(cards) ? cards : [];
        setSavedCards(cards);
        if (cards.length > 0) { const def = cards.find(c => c.is_default) || cards[0]; setSelectedPm(def.id); }
      } catch (e) { if (active) setSavedCards([]); }
      finally { if (active) setLoadingCards(false); }
    })();
    return () => { active = false; };
  }, []);

  const handleSubmit = async () => {
    if (!stripe) return;
    const useNew = selectedPm === "new";
    let cardEl = null;
    if (useNew) {
      if (!elements) return;
      cardEl = elements.getElement(CardElement);
      if (!cardEl) { setError(en ? "Enter card details" : "Ingresa los datos de tarjeta"); return; }
    }
    setProcessing(true); setError("");
    try {
      // 1. PaymentIntent de la membresía (monto server-side: plan − descuento)
      const intentData = await createMembershipPaymentIntent({ plan_id: planId, discount_code: discountCode });
      // 2. Confirmar el pago con Stripe
      const result = await stripe.confirmCardPayment(intentData.client_secret, {
        payment_method: useNew ? { card: cardEl } : selectedPm,
      });
      if (result.error) { setError(result.error.message); setProcessing(false); return; }
      if (result.paymentIntent?.status !== "succeeded") {
        setError(en ? "Payment not completed. Try again." : "Pago no completado. Inténtalo de nuevo."); setProcessing(false); return;
      }
      // 3. Confirmar la compra server-side (otorga VIP + marca el código usado).
      //    Anti-replay por membership_last_pi → reintentar es seguro si algo falla acá.
      const confirmFn = discountMode === "fixed_price" ? confirmFixedPricePurchase : confirmMembershipPurchase;
      const resp = await confirmFn({
        payment_intent: result.paymentIntent.id, plan_id: planId, discount_code: discountCode,
      });
      onSuccess(resp);
    } catch (e) {
      console.error("MEMBERSHIP PAYMENT ERROR:", e);
      setError(e.message || (en ? "Payment error" : "Error en el pago"));
      setProcessing(false);
    }
  };

  return (
    <div>
      {!loadingCards && savedCards.length > 0 && (
        <div style={{ marginBottom: 16 }}>
          <div style={{ fontSize: 11, color: C.muted, letterSpacing: "0.15em", marginBottom: 8, textTransform: "uppercase" }}>{en ? "Payment Method" : "Método de Pago"}</div>
          {savedCards.map((card, i) => (
            <label key={card.id || i} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", border: `1px solid ${selectedPm === card.id ? C.red : C.border}`, borderRadius: 8, marginBottom: 8, cursor: "pointer", background: selectedPm === card.id ? "var(--accion-tinte)" : C.white }}>
              <input type="radio" name="mpm" checked={selectedPm === card.id} onChange={() => setSelectedPm(card.id)} />
              <span style={{ fontSize: 13, fontWeight: 500, color: C.black }}>💳 {card.brand ? card.brand.charAt(0).toUpperCase() + card.brand.slice(1) : "Card"}</span>
              <span style={{ fontSize: 13, color: C.black }}>•••• {card.last4}</span>
              <span style={{ fontSize: 11, color: C.muted, marginLeft: "auto" }}>{card.exp_month}/{card.exp_year}</span>
            </label>
          ))}
          <label style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 14px", border: `1px solid ${selectedPm === "new" ? C.red : C.border}`, borderRadius: 8, cursor: "pointer", background: selectedPm === "new" ? "var(--accion-tinte)" : C.white }}>
            <input type="radio" name="mpm" checked={selectedPm === "new"} onChange={() => setSelectedPm("new")} />
            <span style={{ fontSize: 13, color: C.black }}>{en ? "Use a new card" : "Usar tarjeta nueva"}</span>
          </label>
        </div>
      )}
      {(selectedPm === "new" || (!loadingCards && savedCards.length === 0)) && (
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, color: C.muted, letterSpacing: "0.15em", marginBottom: 8, textTransform: "uppercase" }}>{en ? "Card Details" : "Datos de Tarjeta"}</div>
          <div style={{ border: `1px solid ${C.border}`, padding: "14px 16px", background: C.light }}>
            <CardElement options={{ style: { base: { fontSize: "15px", color: "#0F1B2A", fontFamily: "'DM Sans', sans-serif", "::placeholder": { color: "#A9ADB3" } }, invalid: { color: C.red } } }} />
          </div>
        </div>
      )}
      {error && (<div style={{ background: "var(--accion-tinte)", border: `1px solid ${C.red}`, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.red }}>{error}</div>)}
      <button onClick={handleSubmit} disabled={processing || !stripe} style={{ ...S.btnPrimary, width: "100%", padding: "16px", opacity: processing || !stripe ? 0.7 : 1, marginBottom: 12 }}>
        {processing ? (en ? "Processing..." : "Procesando...") : (en ? `Pay $${Number(finalPrice).toFixed(2)}` : `Pagar $${Number(finalPrice).toFixed(2)}`)}
      </button>
      <button onClick={onCancel} disabled={processing} style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, width: "100%", padding: "12px", fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>{en ? "Cancel" : "Cancelar"}</button>
      <p style={{ fontSize: 11, color: C.muted, textAlign: "center", marginTop: 12 }}>🔒 {en ? "Secured by Stripe" : "Seguro con Stripe"}</p>
    </div>
  );
}

function MembershipPaymentModal({ planId, planLabel, finalPrice, discountCode, discountMode, onSuccess, onCancel, lang }) {
  const en = lang === "en";
  const [walletErr, setWalletErr] = useState("");
  const onWalletPaid = async (pi) => {
    const confirmFn = discountMode === "fixed_price" ? confirmFixedPricePurchase : confirmMembershipPurchase;
    const resp = await confirmFn({ payment_intent: pi.id, plan_id: planId, discount_code: discountCode });
    onSuccess(resp);
  };
  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 1100, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div role="dialog" aria-modal="true" aria-label={en ? "VIP membership payment" : "Pago de membresia VIP"} style={{ background: C.white, width: "100%", maxWidth: 480, padding: "32px 24px 40px", borderRadius: "12px 12px 0 0", maxHeight: "85vh", overflowY: "auto" }}>
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ ...S.display, fontSize: 24, color: C.black, marginBottom: 4 }}>{en ? "GO VIP" : "HAZTE VIP"}</div>
          <div style={{ fontSize: 13, color: C.gray, marginBottom: 8 }}>{planLabel}</div>
          <div style={{ ...S.display, fontSize: 30, color: C.red }}>${Number(finalPrice).toFixed(2)}</div>
          {discountCode ? <div style={{ fontSize: 11, color: "var(--exito)", marginTop: 4 }}>{en ? "Discount code applied" : "Código de descuento aplicado"}</div> : null}
        </div>
        <div style={{ height: 1, background: C.border, marginBottom: 24 }} />
        <WalletSection
          amountCents={Math.round(Number(finalPrice) * 100)}
          createIntent={() => createMembershipPaymentIntent({ plan_id: planId, discount_code: discountCode })}
          onPaid={onWalletPaid}
          onError={setWalletErr}
          lang={lang}
        />
        {walletErr && (
          <div style={{ background: "var(--accion-tinte)", border: `1px solid ${C.red}`, padding: "10px 14px", marginBottom: 16, fontSize: 13, color: C.red }}>{walletErr}</div>
        )}
        <Elements stripe={stripePromise}>
          <MembershipPaymentForm planId={planId} finalPrice={finalPrice} discountCode={discountCode} discountMode={discountMode} onSuccess={onSuccess} onCancel={onCancel} lang={lang} />
        </Elements>
        <div style={{ marginTop: 14, fontSize: 11, color: C.muted, lineHeight: 1.5, textAlign: "center" }}>
          {en
            ? "When you confirm payment, your card is securely saved for renewals and future purchases. You can remove it anytime from My Account."
            : "Al confirmar el pago, tu tarjeta queda guardada de forma segura para renovaciones y futuras compras. Puedes eliminarla cuando quieras desde Mi cuenta."}
        </div>
      </div>
    </div>
  );
}

// ============================================
// EL MOMENTO DEL ENGANCHE (s186 · canal influencer)
// ============================================
// s185-D4: la persona que entró con el código de una influencer navega primero y
// paga al activar. Entra LITE con dos activaciones gratis; cuando se le acaban y
// va a activar un cupón PAGO, este es el único momento del producto donde la
// comparación es real y honesta:
//
//     este cupón, una vez        $X
//     seis meses, todos a $0     $4.99
//
// No es un paywall: es una bifurcación. El camino de hoy —pagar el fee del
// cupón— sigue estando, en el mismo lugar y a un toque. Si la persona dice que
// no, no se le vuelve a preguntar en esta pantalla.
//
// El cobro NO es nuevo: `confirm_fixed_price_purchase` ya cobra en producción, y
// el modal de membresía ya sabe rutear por `discount_mode`. Acá solo se le pasa
// el plan del enganche y el código que vino colgado del AccessCode.
function EngancheModal({ feeCupon, plan, precio, codigo, lang, onSoloCupon, onCancelar, onListo }) {
  const en = lang === "en";
  const [pagando, setPagando] = useState(false);
  const meses = Number(plan && plan.duration_months) || MESES_ENGANCHE;
  const lista = Number(plan && plan.price_usd) || 0;
  const etiqueta = (plan && plan.label) || (en ? `${meses}-month membership` : `Membresía ${meses} meses`);

  if (pagando) {
    return (
      <MembershipPaymentModal
        planId={plan._id}
        planLabel={etiqueta}
        finalPrice={precio}
        discountCode={codigo}
        discountMode="fixed_price"
        lang={lang}
        onCancel={() => setPagando(false)}
        onSuccess={onListo}
      />
    );
  }

  return (
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 200, display: "flex", alignItems: "flex-end", justifyContent: "center" }}>
      <div role="dialog" aria-modal="true"
        aria-label={en ? "Membership offer" : "Oferta de membresía"}
        style={{ background: C.white, width: "100%", maxWidth: 480, padding: "32px 24px 40px", borderRadius: "12px 12px 0 0", maxHeight: "85vh", overflowY: "auto" }}>

        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <div style={{ ...S.display, fontSize: 24, color: C.black }}>
            {en ? "BEFORE YOU PAY FOR THIS ONE" : "ANTES DE PAGAR ESTE CUPÓN"}
          </div>
          <div style={{ fontSize: 13, color: C.gray, marginTop: 6 }}>
            {en
              ? "You used your free activations. There are two ways from here."
              : "Ya usaste tus activaciones gratis. Desde aquí hay dos caminos."}
          </div>
        </div>

        {/* Camino 1 — el cupón suelto. Es el de hoy, y se muestra primero para que
            la comparación se lea en el orden en que la persona la está viviendo. */}
        <div style={{ border: `1px solid ${C.border}`, borderRadius: 12, padding: "16px 18px", marginBottom: 12 }}>
          <div style={{ fontSize: 12, color: C.muted, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 6 }}>
            {en ? "This coupon" : "Este cupón"}
          </div>
          <div style={{ ...S.display, fontSize: 30, color: C.black }}>${Number(feeCupon).toFixed(2)}</div>
          <div style={{ fontSize: 12, color: C.gray, marginTop: 4 }}>
            {en ? "one-time activation fee, this benefit only" : "fee de activación, solo por este beneficio"}
          </div>
        </div>

        {/* Camino 2 — el enganche. */}
        <div style={{ border: `2px solid ${C.valor}`, background: "var(--valor-tinte)", borderRadius: 12, padding: "16px 18px", marginBottom: 20 }}>
          <div style={{ fontSize: 12, color: C.valor, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 6 }}>
            {en ? `${meses} months, every coupon at $0` : `${meses} meses, todos los cupones a $0`}
          </div>
          <div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
            {lista > precio && (
              <span style={{ fontSize: 15, color: C.muted, textDecoration: "line-through" }}>${lista.toFixed(2)}</span>
            )}
            <span style={{ ...S.display, fontSize: 36, color: C.valor }}>${Number(precio).toFixed(2)}</span>
          </div>
          <div style={{ fontSize: 12, color: C.gray, marginTop: 4 }}>
            {en
              ? "one-time, with your invite · includes you + 1 companion"
              : "una sola vez, con tu invitación · te incluye a ti + 1 acompañante"}
          </div>
        </div>

        <button onClick={() => setPagando(true)} style={{ ...S.btnPrimary, width: "100%", padding: "16px", marginBottom: 10 }}>
          {en ? `Get ${meses} months for $${Number(precio).toFixed(2)}` : `Quiero los ${meses} meses por $${Number(precio).toFixed(2)}`}
        </button>

        <button onClick={onSoloCupon} style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, width: "100%", padding: "12px", fontSize: 13, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", borderRadius: 8, marginBottom: 10 }}>
          {en ? `Just this coupon — $${Number(feeCupon).toFixed(2)}` : `Solo este cupón — $${Number(feeCupon).toFixed(2)}`}
        </button>

        <button onClick={onCancelar} style={{ background: "none", border: "none", color: C.muted, width: "100%", padding: "6px", fontSize: 12, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
          {en ? "Not now" : "Ahora no"}
        </button>
      </div>
    </div>
  );
}

// ============================================
// WALLETS: Apple Pay / Google Pay (Express Checkout Element) - s114
// Fable D1-D6: deferred mode - componente compartido - colapsa si no hay wallet -
// in-page (redirect:'if_required') reutilizando los handlers de exito existentes.
// ============================================
function WalletExpressCheckout({ createIntent, onPaid, onError, lang }) {
  const stripe = useStripe();
  const elements = useElements();
  const [available, setAvailable] = useState(null);
  const [busy, setBusy] = useState(false);

  const onConfirm = async () => {
    if (!stripe || !elements || busy) return;
    setBusy(true);
    onError("");
    try {
      const { error: submitErr } = await elements.submit();
      if (submitErr) { onError(submitErr.message); setBusy(false); return; }
      const intent = await createIntent();
      if (!intent || !intent.client_secret) { onError(lang === "en" ? "Could not start payment" : "No se pudo iniciar el pago"); setBusy(false); return; }
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        clientSecret: intent.client_secret,
        confirmParams: { return_url: window.location.href },
        redirect: "if_required",
      });
      if (error) { onError(error.message); setBusy(false); return; }
      if (paymentIntent && paymentIntent.status === "succeeded") {
        await onPaid(paymentIntent);
      } else {
        onError(lang === "en" ? "Payment not completed." : "Pago no completado.");
        setBusy(false);
      }
    } catch (e) {
      onError((e && e.message) || (lang === "en" ? "Payment error" : "Error en el pago"));
      setBusy(false);
    }
  };

  if (available === false) return null;

  return (
    <div style={{ marginBottom: available ? 4 : 0 }}>
      <ExpressCheckoutElement
        options={{
          paymentMethods: { applePay: "auto", googlePay: "auto", link: "auto", amazonPay: "never", paypal: "never", klarna: "never" },
          buttonHeight: 48,
        }}
        onReady={(e) => setAvailable(!!(e && e.availablePaymentMethods))}
        onConfirm={onConfirm}
      />
      {available && (
        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "16px 0" }}>
          <div style={{ flex: 1, height: 1, background: C.border }} />
          <span style={{ fontSize: 11, color: C.muted, letterSpacing: "0.08em" }}>{lang === "en" ? "OR PAY WITH CARD" : "O PAGA CON TARJETA"}</span>
          <div style={{ flex: 1, height: 1, background: C.border }} />
        </div>
      )}
    </div>
  );
}

function WalletSection({ amountCents, createIntent, onPaid, onError, lang }) {
  if (!amountCents || amountCents < 50) return null;
  return (
    <Elements stripe={stripePromise} options={{ mode: "payment", amount: amountCents, currency: "usd" }}>
      <WalletExpressCheckout createIntent={createIntent} onPaid={onPaid} onError={onError} lang={lang} />
    </Elements>
  );
}

// ============================================
// PAGE: OFFER DETAIL
// ============================================
// ============================================
// ICONOS DE LA FICHA — familia del sistema (SISTEMA_DISENO_NXT §9)
// Caja 24x24 · trazo 1.5 · currentColor · fill none · remates redondos.
// S-15: reemplazan a los emoji de la ficha (prohibicion #1). Un icono
// nunca trae color propio: hereda del texto que lo acompana.
// ============================================
const ICO_FICHA = {
  calendario: "M7 3v3M17 3v3M3.5 9.5h17M5 6h14a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 19 20H5a1.5 1.5 0 0 1-1.5-1.5v-11A1.5 1.5 0 0 1 5 6z",
  reloj: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM12 7.5V12l3 2",
  regreso: "M20 12a8 8 0 1 1-2.6-5.9M20 4v4h-4",
  billete: "M3 7.5h18v9H3zM12 9.8a2.2 2.2 0 1 0 0 4.4 2.2 2.2 0 0 0 0-4.4M6.2 12h.01M17.8 12h.01",
  telefono: "M7.5 4h3l1.2 3.2-1.9 1.4a11 11 0 0 0 4.6 4.6l1.4-1.9L19 12.5v3a1.5 1.5 0 0 1-1.6 1.5A13.5 13.5 0 0 1 5 5.6 1.5 1.5 0 0 1 6.5 4z",
  chat: "M20.5 11.5a7.7 7.7 0 0 1-8.5 7.7L6 20.5l1.3-4.4A7.7 7.7 0 1 1 20.5 11.5z",
  camara: "M4.5 7.5h3l1.2-2h6.6l1.2 2h3A1.5 1.5 0 0 1 21 9v9a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18V9a1.5 1.5 0 0 1 1.5-1.5zM12 10.2a3.3 3.3 0 1 0 0 6.6 3.3 3.3 0 0 0 0-6.6z",
  globo: "M12 3.5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM3.5 12h17M12 3.5c2.2 2.3 3.3 5.1 3.3 8.5S14.2 18.2 12 20.5c-2.2-2.3-3.3-5.1-3.3-8.5S9.8 5.8 12 3.5z",
  mapa: "M12 21s6.5-5.6 6.5-10.2a6.5 6.5 0 1 0-13 0C5.5 15.4 12 21 12 21zM12 8.3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
  check: "M4.5 12.5l5 5 10-11",
  // s222 · la fila de enlaces de la ficha (Menú · Reservar)
  menu: "M7 3.5h7.5L18.5 7.5v12A1.5 1.5 0 0 1 17 21H7a1.5 1.5 0 0 1-1.5-1.5v-14.5A1.5 1.5 0 0 1 7 3.5zM14.5 3.5v4h4M9 12h6M9 15.5h6",
  reservar: "M7 3v3M17 3v3M3.5 9.5h17M5 6h14a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 19 20H5a1.5 1.5 0 0 1-1.5-1.5v-11A1.5 1.5 0 0 1 5 6zM9 14.5l2 2 4-4",
};

// s158 T1 — icono del sprite publicado, servido desde el origen (public/iconos.svg,
// copiado en cada build por scripts/fetch-sprite.js). Los atributos del host
// heredan al contenido del <use>; los dos "activos" rellenan por la regla <style>
// que viaja DENTRO del propio sprite. Familia: caja 24, trazo 1.5, currentColor.
// Convive con IcoFicha; la migración de IcoFicha al sprite es T4.
function Ico({ name, size = 24, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
      style={{ flexShrink: 0, display: "block", ...style }}
      fill="none" stroke="currentColor" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round">
      <use href={`/iconos.svg#${name}`} />
    </svg>
  );
}

// s158 T4 — migracion PARCIAL: lo que el sprite ya publica se sirve del sprite;
// el resto sigue con path local. La firma no cambia, ningun llamador se toca.
function IcoFicha({ name, size = 20, style }) {
  // check → ico-ok, NO ico-check: ico-check esta en retiro (S-19 §0.3) y queda
  // prohibido en lo nuevo, aunque el simbolo siga viviendo en el sprite publicado.
  const SPRITE_MAP = {
    check: "ico-ok",
    reloj: "ico-reloj",
    calendario: "ico-calendario",
    mapa: "ico-mapa",
    camara: "ico-camara",
  };
  // pendiente: pedir a marketing publicar estos 5 en el sprite (30 → 35):
  // regreso, billete, telefono, chat, globo. Hasta entonces salen del path local.
  const idSprite = SPRITE_MAP[name];
  const d = ICO_FICHA[name];
  if (!idSprite && !d) return null;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true"
      style={{ flexShrink: 0, display: "block", ...style }}
      fill="none" stroke="currentColor" strokeWidth="1.5"
      strokeLinecap="round" strokeLinejoin="round">
      {idSprite ? <use href={`/iconos.svg#${idSprite}`} /> : <path d={d} />}
    </svg>
  );
}

// s181 ficha v2 · estrellas del rating de Google. Relleno = --realce-tinta (dorado
// legible sobre crema, S-14); vacía = solo trazo. Redondeo al entero: media estrella
// es precisión que la cifra de al lado ya da.
function EstrellasGoogle({ valor, size = 16 }) {
  const n = Math.max(0, Math.min(5, Math.round(Number(valor) || 0)));
  return (
    <span role="img" aria-label={`${valor} / 5`} style={{ display: "inline-flex", gap: 2, flexShrink: 0 }}>
      {[0, 1, 2, 3, 4].map(i => (
        <svg key={i} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 2.8l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.7l-5.9 3.1 1.2-6.5L2.5 9.7l6.6-.9z"
            fill={i < n ? "var(--realce-tinta)" : "none"} stroke="var(--realce-tinta)" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
      ))}
    </span>
  );
}

// s181 ficha v2 · marca de Google para la atribución obligatoria de las reseñas. Es una
// marca de terceros: la única excepción a «un icono nunca trae color propio».
function MarcaGoogle({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" aria-label="Google" style={{ flexShrink: 0 }}>
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

// s202 · atribución de Places mostrado SIN mapa (sugerencias del autocompletado, la
// tarjeta «¿es tu negocio?»). Google Maps Platform, «Places API policies» (17/09/2026):
// el texto «Google Maps» tal cual — sin traducir, en una línea, peso 400, #5E5E5E o
// #1F1F1F, de 12 a 16 px — dentro del mismo recuadro que los resultados. El «G» de
// MarcaGoogle NO vale acá (es el de las reseñas). El color lo fija Google, no tokens.css.
function AtribucionGoogleMaps({ style }) {
  return (
    <span translate="no" style={{ fontFamily: "Roboto, Arial, sans-serif", fontWeight: 400, fontStyle: "normal",
      fontSize: 12, lineHeight: 1.4, color: "#5E5E5E", whiteSpace: "nowrap", ...style }}>Google Maps</span>
  );
}

// s233 · lo que ve el dueño en su propia ficha en lugar de «Activar oferta».
// s233 · va DEBAJO del botón «Activar oferta» apagado. `corto`: en la barra fija del teléfono, una sola línea.
// s233 · `sinAprobar`: Admin/Operator abren una oferta sembrada que el dueño todavía no confirmó.
function AvisoVistaDueno({ en, corto = false, sinAprobar = false }) {
  if (sinAprobar) {
    return (
      <div className={"ficha__aviso-dueno" + (corto ? " ficha__aviso-dueno--corto" : "")} role="note" id="ficha-aviso-dueno">
        <b>{en ? "Not confirmed yet" : "Todavía sin confirmar"}</b>
        {!corto && (
          <span>{en ? "Only Admin and Operator see this offer. Members will be able to activate it once it is approved."
                    : "Esta oferta solo la ven Admin y Operator. Los miembros podrán activarla cuando quede aprobada."}</span>
        )}
      </div>
    );
  }
  return (
    <div className={"ficha__aviso-dueno" + (corto ? " ficha__aviso-dueno--corto" : "")} role="note" id="ficha-aviso-dueno">
      <b>{en ? "This is how a member sees your offer" : "Así ve tu oferta un miembro"}</b>
      {!corto && (
        <span>{en ? "The member activates it with this button. From your business account it stays off."
                  : "El miembro la activa con este botón. Desde tu cuenta de negocio queda apagado."}</span>
      )}
    </div>
  );
}

function OfferDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { recargar: recargarCupones } = useCupones();   // s215 · que «Mis cupones» vea el código nuevo
  const [offer, setOffer] = useState(null);
  // s233 · dueno-ve-su-ficha (Ali: «el dueño tiene que poder ver su negocio, su ficha»): si quien mira es el dueño de
  // esta oferta (PuertaFicha ya lo dejó pasar con el club cerrado), no se le ofrece «Activar oferta» (es de miembros):
  // en su lugar, «Así ve tu oferta un miembro».
  const rolSesion = useRolSesion();
  const [miComercio, setMiComercio] = useState("");
  useEffect(() => {
    if (rolSesion !== "Merchant") return undefined;
    let vivo = true;
    getMerchantProfile().then(p => { if (vivo) setMiComercio(String(p?.merchant_id || "")); }).catch(() => {});
    return () => { vivo = false; };
  }, [rolSesion]);
  const vistaDueno = rolSesion === "Merchant" && !!miComercio && offer?.merchant_id === miComercio;
  // s233 · catalogo-sembradas-admin: una oferta todavía sin aprobar (Admin/Operator la abren desde el catálogo) se ve,
  // pero no se activa: mismo botón apagado que el dueño, con su aviso.
  const sinAprobar = !!offer && !!offer.status && String(offer.status).toLowerCase() !== "approved";
  const botonApagado = vistaDueno || sinAprobar;
  const [loading, setLoading] = useState(true);
  const [activating, setActivating] = useState(false);
  const [message, setMessage] = useState({ text: "", type: "" });
  const [showPayment, setShowPayment] = useState(false);
  // s186 · el momento del enganche (canal influencer). `null` = no hay oferta que
  // hacer. `ofrecido` se queda en true despues de la primera vez: quien dijo que no
  // no vuelve a ver la comparacion en esta misma pantalla.
  const [enganche, setEnganche] = useState(null);
  const [engancheOfrecido, setEngancheOfrecido] = useState(false);
  const [heroIdx, setHeroIdx] = useState(0); // F1 s101: índice de la galería
  const tocoEn = useRef(null);   // s200-D1 · donde empezo el dedo, para el deslizamiento del hero
  const heroRef = useRef(null);  // s200-D1 · la grilla de fotos lleva el ojo de vuelta al hero
  // s198-D18 · la oferta recién activada: { code, expira }. Abre la pantalla de éxito (antes:
  // «Listo. Disfrútalo.» y un salto a Mis Cupones a los 1,5 s, sin mostrar el código).
  const [activada, setActivada] = useState(null);
  const exitoRef = useRef(null);
  // s198 · la proporción real de la foto principal, para decidir si llena el marco (D1).
  const [heroForma, setHeroForma] = useState({ src: "", r: 0, marco: 0 });
  // ETAPA-0 (s97): gate de prospecto — sin cupones otorgados (max_coupons 0/vacío)
  // no hay autoservicio: se rutea a la puerta del código o al contacto (WhatsApp).
  const [codeGate, setCodeGate] = useState(null); // null | { wa: string }
  // s181 ficha v2 · F1: rating de Google EN VIVO (s172-D1 extendida a la oferta).
  // Vive en el estado de ESTA ficha y muere con ella: ni localStorage, ni campo de
  // Bubble, ni estado global (TOS de Google — INVESTIGACION_s172).
  const [gRating, setGRating] = useState(null);       // { rating, count, mapsUri } | null
  const [gReviews, setGReviews] = useState(null);     // null = no pedidas · [] = pedidas, vacías
  const [gReviewsLoading, setGReviewsLoading] = useState(false);
  // Baranda 2 de s172-D1: UNA llamada por carga de ficha. React.StrictMode (index.js)
  // dobla los efectos en dev; el ref sobrevive al doble montaje y frena la segunda
  // (precedente `pi-probe-doble`, que disparaba doble por esto mismo).
  const gRatingPedidoPara = useRef("");

  useEffect(() => {
    const load = async () => {
      try {
        // Try real API first
        if (!id.startsWith("m")) {
          // s233 · catalogo-sembradas-admin: una Pending no viaja por el canal público; Admin/Operator la leen con sesión.
          const data = (await getOfferById(id)) || (await getOfferByIdConSesion(id).catch(() => null));
          if (data) { setOffer(data); setLoading(false); return; }
        }
        // Fall back to mock
        const mock = MOCK_OFFERS.find(o => o._id === id);
        if (mock) setOffer(mock);
      } catch {
        const mock = MOCK_OFFERS.find(o => o._id === id);
        if (mock) setOffer(mock);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  // s186 · Devuelve true si dejo la comparacion en pantalla. CUALQUIER cosa que
  // falte hace que devuelva false y el flujo siga como siempre — no hay ni un
  // camino nuevo que pueda dejar a alguien sin poder activar su cupon:
  //   · sin enganche guardado (el 100% de los usuarios de hoy: el Return del WF
  //     todavia no devuelve el codigo — ver enganche.js);
  //   · sin plan de 6 meses legible;
  //   · sin `fixed_price` en el DiscountCode, o con el codigo ya quemado — que es
  //     precisamente lo que el multiuso de s185 viene a arreglar y todavia no esta
  //     deployado: hasta entonces la SEGUNDA persona que use el codigo cae aca y
  //     sigue al fee normal, sin ver un error;
  //   · si el enganche no sale mas barato que el cupon suelto. Una comparacion
  //     que no favorece a quien la lee no es una oferta, es una molestia.
  const ofrecerEnganche = async () => {
    if (!PLANES_VIP_VIEJOS || engancheOfrecido) return false;   // s252
    const eng = leerEnganche();
    if (!eng) return false;
    const feeCupon = getFee(offer);
    if (!(feeCupon > 0)) return false;
    try {
      const planes = await getMembershipPlans({ activeOnly: true });
      const plan = elegirPlanEnganche(planes, eng.planId);
      if (!plan || !plan._id) return false;
      const r = await validateDiscountCode({ plan_id: plan._id, code: eng.code });
      const precio = Number(r && r.fixed_price) || 0;
      if (!(precio > 0) || precio >= feeCupon) return false;
      setEngancheOfrecido(true);
      setEnganche({ feeCupon, plan, precio, codigo: eng.code });
      return true;
    } catch (e) {
      return false;   // codigo quemado, plan ilegible, red caida: al fee de siempre
    }
  };

  const handleActivate = async () => {
    if (botonApagado) return;   // s233 · dueño o sin aprobar: ningún camino (reintento, vuelta del pago) activa
    if (!auth.isLoggedIn()) { navigate("/login"); return; }
    // s198 · un reintento no arrastra el error anterior en pantalla.
    setMessage({ text: "", type: "" });
    // F4: safe fallback to LITE (never assume VIP without explicit confirmation)
    const tier = localStorage.getItem("nxt_tier") || "LITE";

    // ETAPA-0 (s97): puerta del prospecto — sin cupones otorgados (max_coupons 0/vacío)
    // no hay autoservicio: código de invitación o contacto. Se conserva como UX de la
    // invitación (s143): el signup orgánico ya nace con max_coupons desde config, así
    // que esto solo frena cuentas legacy/prospecto — sin esta puerta, un prospecto
    // caería al camino de PAGO del server (LITE con 0 gratis = "agotadas").
    if (tier === "LITE") {
      let sinPlan = true, supportWa = WHATSAPP_NUMBER, guardado = false;
      try {
        const profile = await getUserProfile();
        sinPlan = socioSinPlan(profile);   // s203-D6: la misma regla que el ruteo y /onboarding
        guardado = codigoGuardadoSinPlan(profile);   // s220 · ya aplicó un código de aliado: no se le pide otro
        if (profile?.support_whatsapp) supportWa = String(profile.support_whatsapp).replace(/[^0-9]/g, "");
      } catch (e) {
        // Si no podemos verificar, bloquear en vez de arriesgar mandar un prospecto al cobro
        setMessage({
          text: lang === "en" ? "Could not verify your plan. Please try again." : "No pudimos verificar tu plan. Intenta de nuevo.",
          type: "error"
        });
        return;
      }
      if (sinPlan || guardado) {
        setCodeGate({ wa: supportWa, guardado });
        return;
      }
    }

    // invertir-cobro-tiers (s142/s143): el SERVER decide quién paga — el cliente ya no
    // manda amount ni decide gratis vs cobro. Un solo probe a create_payment_intent:
    //   NO_FEE_REQUIRED → activar gratis (miembro vigente o LITE con gratis disponibles)
    //   client_secret   → modal Stripe (LITE con gratis agotadas; monto computado server-side)
    //   error_code      → mensaje del mapa (MEMBERSHIP_EXPIRED, etc.), sin modal
    setActivating(true);
    try {
      const intent = await createPaymentIntent({
        offer_id: id,
        offer_title: offer?.title_es || offer?.title_en || "",
      });
      if (intent?.no_fee_required) {
        const r = await activateCoupon({ offer_id: id });
        // s198-D18 · el momento de recompensa: qué activaste, el código y qué hacer después.
        setActivada({ code: r?.coupon_code || "", expira: r?.expires_at || "" });
        recargarCupones();
        return;
      }
      // s186 · LA BIFURCACION DEL ENGANCHE. Llegar aca significa exactamente una
      // cosa: esta persona es LITE y ya gasto sus activaciones gratis. Es el unico
      // momento en que la comparacion se puede hacer con los dos numeros reales
      // sobre la mesa. Si hay enganche guardado y se puede resolver su precio, se
      // ofrece; si algo falta o falla, se sigue al fee de siempre. El camino de hoy
      // no se rompe: se le agrega una salida.
      if (await ofrecerEnganche()) return;
      // client_secret presente → cobro: el modal crea su propio PI al confirmar el pago
      // (el PI del probe queda sin usar; Stripe lo deja expirar como incomplete).
      setShowPayment(true);
    } catch (e) {
      // s203-D6: si el server dice que falta plan, se abre la puerta del código (el mismo
      // lugar que ofrecerá «Suscríbete»), no un error con «Reintentar» que no lleva a nada.
      if (e?.code === "SUBSCRIPTION_REQUIRED") { setCodeGate({ wa: WHATSAPP_NUMBER }); return; }
      // s215 · no es un error: ya la tiene activa (el primer toque funcionó). Se le lleva a su código.
      if (e?.code === "ACTIVE_COUPON_EXISTS") { recargarCupones(); setMessage({ text: "", type: "ya" }); return; }
      setMessage({ text: activationErrorMessage(e, lang), type: "error" });
    } finally {
      setActivating(false);
    }
  };

  const handlePaymentSuccess = async (paymentIntentId) => {
    setShowPayment(false);
    setActivating(true);
    try {
      const r = await activateCoupon({ offer_id: id, payment_intent_id: paymentIntentId || undefined });
      setActivada({ code: r?.coupon_code || "", expira: r?.expires_at || "" });
      recargarCupones();
    } catch (e) {
      setMessage({ text: activationErrorMessage(e, lang), type: "error" });
    } finally {
      setActivating(false);
    }
  };

  const isMobile = useIsMobile();
  const lang = useLang();

  // s181 · rating en vivo. Las 3 barandas: sesión de miembro iniciada · place_id presente
  // · una llamada por carga. Sin place_id el bloque no existe: ni error, ni llamada.
  // s184: `place_id_text` YA está en la regla pública («Public sees approved», 26 campos)
  // y el canal anónimo lo devuelve — el bloque enciende. El límite ahora es el DATO:
  // 2 de los 13 comercios approved tienen place_id (STATUS Hair y el ZZ de prueba); las
  // altas anteriores guardaron `google_maps_url` sin él. Tener maps_url no implica rating.
  const placeId = offer?.merchant_public?.place_id ? String(offer.merchant_public.place_id) : "";
  useEffect(() => {
    if (!placeId || !auth.isLoggedIn()) return;
    if (gRatingPedidoPara.current === placeId) return;
    gRatingPedidoPara.current = placeId;
    setGRating(null); setGReviews(null);
    placeRating(placeId, lang)
      .then(r => { if (r && gRatingPedidoPara.current === placeId) setGRating(r); })
      .catch(() => { /* sin rating no hay bloque; nunca un error en la ficha */ });
  }, [placeId, lang]);

  // La barra de CTA móvil (bottom 68 + 76 de alto) convive con el selector de idioma global
  // (fijo en bottom 80, zIndex 200): la ficha lo levanta vía --pie-cta mientras está montada.
  useEffect(() => {
    if (!isMobile) return undefined;
    // s198-D16: la barra suma la frase del trato arriba del botón → 68 del nav + ~112 de barra.
    document.body.style.setProperty("--pie-cta", "192px");
    return () => { document.body.style.removeProperty("--pie-cta"); };
  }, [isMobile]);

  // s198-D18 · la pantalla de éxito es un <dialog>: se abre cuando llega el cupón.
  useEffect(() => {
    const d = exitoRef.current;
    if (!d || !activada || d.open) return;
    try { d.showModal(); } catch { d.setAttribute("open", ""); }
  }, [activada]);

  // «Ver reseñas»: la SEGUNDA llamada, solo al tocar el botón, y una sola vez por ficha.
  const pedirResenas = async () => {
    if (!placeId || gReviewsLoading || gReviews !== null) return;
    setGReviewsLoading(true);
    try {
      const r = await placeReviews(placeId, lang);
      setGReviews(Array.isArray(r?.reviews) ? r.reviews : []);
    } catch (e) {
      setGReviews([]);
    } finally {
      setGReviewsLoading(false);
    }
  };

  if (loading) return <div className="ficha__estado">{lang === "en" ? "Loading..." : "Cargando..."}</div>;
  if (!offer) return <div className="ficha__estado">{lang === "en" ? "Offer not found" : "Oferta no encontrada"}</div>;

  const en = lang === "en";
  // s178 L3: aquí vivía `const fee = getFee(offer)`, y su único consumidor era el texto
  // del botón de activar. Al pasar el botón a mostrar el ahorro quedó sin uso, así que se
  // va. El modal de pago sigue llamando a getFee(offer) por su cuenta (más abajo): ahí el
  // precio SÍ corresponde, porque es la pantalla donde se cobra.
  // s181 ficha v2: el registro PÚBLICO del comercio llega adjunto como `merchant_public`
  // (getOfferById). `offer.merchant` es el id (string) y sigue siéndolo: la ficha vieja
  // leía `offer.merchant?.google_maps_url` de un string, y por eso el bloque del comercio
  // nunca se dibujó en producción.
  const merchant = offer.merchant_public || (typeof offer.merchant === "object" && offer.merchant) || {};
  const merchantId = offer.merchant_id || (typeof offer.merchant === "object" ? offer.merchant?._id : offer.merchant) || "";
  const merchantName = merchant.business_name || offer.merchant_name || "";
  const neighborhood = merchant.neighborhood || offer.neighborhood || "";
  const norm = (u) => (u && String(u).startsWith("//")) ? "https:" + u : (u ? String(u) : "");
  // s200-D1 · LAS FOTOS SON DEL NEGOCIO, no de la oferta. Hasta hoy esta ficha leia SOLO
  // las de la oferta (image + image_2/3/4 + images[]) y la galeria del comercio entraba
  // apenas como respaldo, con UNA foto. La decision lo invierte: la oferta conserva una
  // foto opcional —la del plato— y el resto sale de la galeria que el comercio mantiene
  // en su panel. Es lo que hace Offline: las fotos son del restaurante, no del cupon.
  //
  // `image_2..4` e `images` DEJAN DE LEERSE. No se borran del canal ni de Bubble: siguen
  // llegando y algun comercio viejo puede tenerlas cargadas. Simplemente esta pantalla ya
  // no las mira, porque la galeria del negocio es la que se mantiene.
  //
  // Fallback: el logo. Y si tampoco: placeholder por categoria, DECLARADO (D-87). Nunca
  // una imagen de banco (D-101): una foto de la ficha es un reclamo, y todo lo de arriba
  // es real del comercio.
  const fotosComercio = (Array.isArray(merchant.gallery) ? merchant.gallery : []).map(norm).filter(Boolean);
  const logoComercio = norm(merchant.logo || offer.merchant_logo);
  // El tope es 1 + GALERIA_TOPE: la foto de la oferta mas las diez del negocio.
  // s253 · con `gallery_pick`, solo las que el dueño eligió para esta oferta (api.js fotosDeLaOferta); vacío = todas.
  const galeriaOferta = fotosDeLaOferta(norm(offer.image), fotosComercio, offer.gallery_pick).slice(0, 1 + GALERIA_TOPE);
  const gallery = galeriaOferta.length ? galeriaOferta : (logoComercio ? [logoComercio] : []);
  const heroEsLogo = !galeriaOferta.length && !!logoComercio;
  const sinFotos = gallery.length === 0;
  const heroSafe = Math.max(0, Math.min(heroIdx, gallery.length - 1));
  const imgSrc = gallery[heroSafe];
  const igUrl = (h) => String(h).startsWith("http") ? h : `https://instagram.com/${String(h).replace(/^@/, "")}`;
  const extUrl = (u) => String(u).startsWith("http") ? u : `https://${u}`;
  const title = en ? (offer.title_en || offer.title_es) : (offer.title_es || offer.title_en);
  // s213 · lo que siembra Otto (seed_merchant / adopt_merchant, export 94) guarda la descripción en el
  // COMERCIO y crea la oferta sin description ni rules_text: confirmada sin editar, la ficha salía sin
  // «Sobre esta oferta» y sin ninguna condición (recorrido s213, H1). En la estándar se cae a la
  // descripción del comercio y a las siete reglas del formato. El arreglo de fondo es del lote B (Bubble).
  const descripcionComercio = en ? (merchant.description_en || merchant.description_es) : (merchant.description_es || merchant.description_en);
  // s239 · D6: «Aplica a toda la cuenta.» guardado en un restaurante o bar se lee «Aplica a comida y bebidas sin alcohol.».
  const descripcionOferta = corregirAlcance((en ? (offer.description_en || offer.description_es) : (offer.description_es || offer.description_en)) || "", offer.category || merchant.category, en);
  // s234 · sobre-esta-oferta-alta-normal: el wizard del alta propia guardaba solo la frase de alcance («Aplica a toda la
  // cuenta.»). Si eso es todo lo que trae la oferta, se completa con la descripción del comercio (su Perfil).
  const soloAlcance = FRASES_ALCANCE.has(descripcionOferta.trim());
  const description = (soloAlcance && descripcionComercio ? `${descripcionOferta.trim()} ${descripcionComercio}` : descripcionOferta)
    || (esFormatoClub(offer) ? descripcionComercio : "");   // s238 · pct-barrido: la sembrada en % también
  const highlight1 = en ? (offer.highlight_1_en || offer.highlight_1_es) : (offer.highlight_1_es || offer.highlight_1_en);
  const highlight2 = en ? (offer.highlight_2_en || offer.highlight_2_es) : (offer.highlight_2_es || offer.highlight_2_en);
  const highlight3 = en ? (offer.highlight_3_en || offer.highlight_3_es) : (offer.highlight_3_es || offer.highlight_3_en);
  const rules = (en ? (offer.rules_text_en || offer.rules_text_es) : (offer.rules_text_es || offer.rules_text_en)) || "";
  // s180 A8 + s181: rules_text guarda una condición por línea → una viñeta por condición.
  // s213 · el plazo no se lee de rules_text (las viejas dicen «90 días» aunque la oferta tenga otro):
  // se saca la línea guardada y, en la estándar, se agrega la armada con SU cooldown_days.
  // s214 · en la estándar, las fijas tampoco se leen de rules_text: se arman con el rubro de la oferta
  // (las guardadas pueden ser las seis de restaurante) y de lo guardado queda solo lo propio del comercio.
  const cooldownDias = diasPlazo(offer);
  const lineaPlazo = reglaPlazo(cooldownDias, en, offer.category || merchant.category);
  const lineasGuardadas = String(rules || "").split(/\r?\n/).map(x => x.trim()).filter(l => l && !esReglaPlazoGuardada(l));
  // s223 · en los otros tipos el plazo también se dice, si la oferta lo tiene guardado (el alta lo manda desde s223;
  // antes de eso quedaba el de PricingConfig, que también es un dato guardado). Sin plazo guardado, no se inventa.
  const condicionesTexto = esUmbral(offer)
    ? [...reglasDelRubro(offer.category || merchant.category, en, offer.redemption_channel), ...lineasGuardadas.filter(l => !esReglaFija(l) && !esReglaPlazoArmada(l)), lineaPlazo]
    : esPorcentaje(offer)
    // s223 · el %: las del club armadas (como la estándar) + lo propio del comercio + el plazo guardado.
    ? [...reglasPorcentaje(offer.category || merchant.category, en, offer.redemption_channel), ...lineasGuardadas.filter(l => !esReglaFija(l) && !esReglaPlazoArmada(l)), ...(Number(offer?.cooldown_days) > 0 ? [lineaPlazo] : [])]
    : [...lineasGuardadas.filter(l => !esReglaPlazoArmada(l)), ...(Number(offer?.cooldown_days) > 0 ? [lineaPlazo] : [])];
  // s212 · si el título es la fórmula del tamaño («Ahorra $30 cuando gastas $60»), el H1 no la repite: va el
  // nombre del comercio (ronda 10: «el título repite la píldora y parece un error», 4/4).
  const tituloGenerico = (esUmbral(offer) && esTituloUmbralGenerado(title))
    || (esPorcentaje(offer) && esTituloPorcentajeGenerado(title));   // s237-D5 · el % sale del bloque de ahorro (discount_pct)
  const tituloFicha = tituloGenerico && merchantName ? merchantName : title;

  // Días: en la base es una LISTA de tokens sin acento (["Mie","Jue"]) — verificado s181.
  // Se muestran con su etiqueta (Mié/Sáb); los 7 son «Todos los días»; lo legacy que no
  // se reconoce sale tal cual. Sin dato el ítem no se dibuja (s158 T3).
  const strip = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
  const diasTokens = (Array.isArray(offer.valid_days) ? offer.valid_days : String(offer.valid_days || "").split(",")).map(t => String(t || "").trim()).filter(Boolean);
  const diasIdx = diasTokens.map(t => FEED_DAY_TOKENS.findIndex(tok => strip(tok) === strip(t))).filter(i => i >= 0);
  const diasTexto = diasIdx.length === 7
    ? (en ? "Every day" : "Todos los días")
    : (diasIdx.length ? diasIdx.map(i => (en ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES)[i]).join(" · ") : diasTokens.join(" · "));
  // Horas: "HH:MM" 24h de la base → "h:mm AM/PM" para el miembro (Miami). Otro formato, tal cual.
  const horaBonita = (h) => {
    const m = String(h || "").trim().match(/^(\d{1,2}):(\d{2})$/);
    if (!m) return String(h || "").trim();
    const H = parseInt(m[1], 10);
    if (H > 23) return String(h).trim();
    return `${H % 12 === 0 ? 12 : H % 12}:${m[2]} ${H >= 12 ? "PM" : "AM"}`;
  };
  const horarioTexto = [horaBonita(offer.valid_time_start), horaBonita(offer.valid_time_end)].filter(Boolean).join(" – ");
  const ahorro = resolverAhorro(offer, lang);

  // s178 L3: el botón de activar mostraba `getFee(offer)`, que es DISPLAY PURO
  // (api.js) — calcula min(max(10% × benefit, 4.99), 9.99) sin mirar la membresía.
  // Por eso a un VIP que paga $0 le decía "$5.00". Quién paga lo decide el server
  // (s142/s143), así que el botón no puede adelantar un precio: muestra el AHORRO,
  // que es lo que el miembro se lleva y no depende de su tier.
  // 🛑 Nunca una cifra inventada: sin dato de ahorro el botón va a secas.
  const ahorroBoton = (() => {
    if (!ahorro || ahorro.porConfirmar) return null;
    // s194 L1: en el formato único la frase entera ES el botón («Recibe $30 si gastas $60»).
    if (ahorro.umbral) return ahorro.umbral.frase;
    // s221-D1: el % se dice entero («−20 % en tu cuenta · hasta $25»), nunca «Ahorras $X».
    if (ahorro.porcentaje) return ahorro.porcentaje.frase;
    // Monto en dólares: lo más concreto. `etiqueta` ya es "Ahorras" / "You save".
    if (ahorro.lidera && ahorro.lidera.startsWith("$")) return `${ahorro.etiqueta} ${ahorro.lidera}`;
    // `lidera` es un chip de % o una mecánica → la insignia ya trae la frase con monto
    // ("Ahorras $18"), armada por chipAhorro. Se usa tal cual, sin volver a prefijar.
    if (ahorro.insignia && ahorro.insignia.includes("$")) return ahorro.insignia;
    // Mecánica sin monto (2×1 sin unit_price, GRATIS sin benefit): la mecánica alcanza.
    if (ahorro.lidera) return `${ahorro.etiqueta} ${ahorro.lidera}`;
    return null;
  })();
  // s198-D3 · el botón dice un verbo corto y la frase del trato va ENCIMA, como titular
  // (Mobbin: Chime, Too Good To Go, Groupon, Airbnb — ninguna mete la frase en el botón).
  // `ahorroBoton` sigue siendo la frase: en teléfono va arriba del botón en la barra fija
  // (s198-D16); en escritorio la dice el bloque de valor de la tarjeta de la derecha.
  const ctaLabel = activating
    ? (en ? "Activating…" : "Activando…")
    : (en ? "Activate offer" : "Activar oferta");

  // s198-D4 · las condiciones en tres grupos: «Cuándo vale» (días, horario, cada cuánto,
  // en el riel), «Cómo usarla» y «Restricciones». Las reglas fijas del formato se reparten
  // por su texto exacto; la del plazo no se repite porque «Cuándo vale» ya
  // dice cada cuánto se puede volver. Las condiciones que escribe cada comercio van a
  // «Restricciones»: clasificar texto libre sería adivinar.
  // s214 · por texto, no por posición: cada rubro trae otras. «Cómo usarla» = membresía + dónde vale
  // (solo en el local / cita / reserva / para llevar / tienda); a la vista en «Restricciones», alcohol y propina.
  // s212 · Ali: el mínimo ya está en el bloque de valor y «no combinable» queda en «Ver todas las condiciones».
  const REGLAS_COMO = new Set([
    REGLA_MEMBRESIA.es, REGLA_MEMBRESIA.en, REGLA_SOLO_LOCAL.es, REGLA_SOLO_LOCAL.en,
    ...["cita", "reserva", "mostrador", "tienda"].flatMap(f => [...REGLAS_POR_FAMILIA[f].es, ...REGLAS_POR_FAMILIA[f].en]),
  ]);
  const REGLAS_OCULTAS = new Set([REGLA_MINIMO.es, REGLA_MINIMO.en, REGLA_NO_COMBINABLE.es, REGLA_NO_COMBINABLE.en]);
  const reglasComo = [];
  const reglasRestricciones = [];
  let hayOcultas = false;
  condicionesTexto.forEach((c) => {
    if (c === lineaPlazo) return;
    if (REGLAS_OCULTAS.has(c)) { hayOcultas = true; return; }
    (REGLAS_COMO.has(c) ? reglasComo : reglasRestricciones).push(c);
  });

  // s198 · la foto principal, con la regla de s198-D1 medida contra SU marco: cuadrado en
  // teléfono (las fotos de los comercios llegan en formato Instagram) y, desde s235, también en escritorio.
  // Se CUBRE solo si calza (recorta como mucho un 10 % por lado); si no, va entera sobre
  // el gris, y un flyer no pierde el texto. Hasta medir, la foto no se muestra.
  // El marco se mide en el momento (no se deduce de isMobile, que corta en 768 mientras el
  // CSS pasa a cuadrado en 1023): cubre si la foto mide entre 0,78 y 1,28 veces el marco.
  const heroMedida = heroForma.src === imgSrc ? heroForma.r : 0;
  const heroLlena = heroMedida > 0 && heroForma.marco > 0
    && heroMedida >= heroForma.marco * 0.78 && heroMedida <= heroForma.marco * 1.28;
  const medirHero = (img) => {
    if (!img || !img.naturalWidth || !img.naturalHeight) return;
    const caja = img.parentElement;
    const marco = caja && caja.clientHeight ? caja.clientWidth / caja.clientHeight : 1;
    setHeroForma({ src: img.getAttribute("src"), r: img.naturalWidth / img.naturalHeight, marco });
  };

  // s198-D18 · la fecha de vencimiento del cupón recién activado, si el server la manda.
  const venceTexto = (() => {
    if (!activada || !activada.expira) return "";
    const d = new Date(activada.expira);
    return isNaN(d.getTime()) ? "" : d.toLocaleDateString(en ? "en-US" : "es-MX", { day: "numeric", month: "long", year: "numeric" });
  })();
  const compartirWhatsApp = () => {
    // s221-D1: en un % el benefit es el TOPE (o $1.000 si es «Sin tope»): se manda la frase, no «Ahorro: $X».
    const lineaValor = ahorro.porcentaje ? `${ahorro.porcentaje.frase}\n`
      : (offer.benefit_value_usd || offer.benefit_value) ? `Ahorro: $${fmtUsd(offer.benefit_value_usd || offer.benefit_value)}\n` : "";
    const text = `NXT Reserve — ${tituloFicha}\n${lineaValor}${merchantName}${neighborhood ? ` · ${neighborhood}` : ""}\n\n¿Quieres acceso? nxtreserve.com`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
  };

  // EL LUGAR: todo sale del registro público del comercio (25 campos de la regla).
  const direccion = merchant.address_full || merchant.address || merchant.address_text || "";
  // D-117: la zona sale del dato o no sale. Vacía COLAPSA, sin hueco ni fallback
  // geográfico («Miami» está prohibido como relleno). Hoy `neighborhood` está vacío
  // en toda la tabla, así que en la práctica esto no se dibuja todavía — mismo
  // patrón gateado que el filtro de ZONA del catálogo.
  const zonaComercio = merchant.neighborhood || offer.neighborhood || "";
  const mapsUrl = merchant.google_maps_url || "";
  const telefono = merchant.phone_public || "";
  const website = merchant.website || "";
  const instagram = merchant.instagram || "";
  // s222 · la fila de enlaces, como Offline (Menu · Website · Insta · Reserve). El menú: el link primero (es el
  // que el comercio mantiene al día); si no hay, el archivo (Bubble lo guarda «//…»: urlMenu le pone https:).
  const menuHref = String(merchant.menu_url || "").trim() || urlMenu(merchant.menu_file);
  const reservarHref = String(merchant.reservation_url || "").trim();
  // s238 · webs-de-terceros: si la «web» es su página en una plataforma, se dice lo que es — Booksy/Phorest… → «Reservar»,
  // Toast/tienda… → el menú, Instagram → «Instagram» —, salvo que ese lugar ya esté ocupado por su propio enlace.
  const platWeb = website ? plataformaDeWeb(website) : null;
  const webComo = !platWeb || platWeb.pelada ? "web"
    : platWeb.tipo === "reservas" && !reservarHref ? "reservar"
    : platWeb.tipo === "menu" && !menuHref ? "menu"
    : platWeb.n === "Instagram" && !instagram ? "ig" : "web";
  const enlacesFicha = [
    menuHref && { clave: "menu", href: menuHref, icono: "menu", texto: etiquetaMenu(merchant.category || offer.category, en) },
    website && webComo === "menu" && { clave: "menu", href: extUrl(website), icono: "menu", texto: etiquetaMenu(merchant.category || offer.category, en) },
    website && webComo === "web" && { clave: "web", href: extUrl(website), icono: "globo", texto: en ? "Website" : "Sitio web" },
    instagram && { clave: "ig", href: igUrl(instagram), icono: "camara", texto: "Instagram" },
    website && webComo === "ig" && { clave: "ig", href: extUrl(website), icono: "camara", texto: "Instagram" },
    reservarHref && { clave: "reservar", href: extUrl(reservarHref), icono: "reservar", texto: en ? "Book" : "Reservar" },
    website && webComo === "reservar" && { clave: "reservar", href: extUrl(website), icono: "reservar", texto: en ? "Book" : "Reservar" },
  ].filter(Boolean);
  // s184: mismo fallback que /m/:id — el texto de Google primero, el json que cargo el
  // comercio despues. Aca el bloque se pinta con `white-space: pre-line`, asi que las
  // filas del json se aplanan a «Lun 09:00-14:00, 18:00-23:00», un dia por renglon.
  const horarioComercio = merchant.business_hours
    || horarioDesdeJson(merchant.business_hours_json, en).map(h => h.dia + " " + h.valor).join("\n");
  const hayLugar = !!(merchantName || direccion || mapsUrl || telefono || website || instagram);

  // ---------- ESTILOS DE LA FICHA ----------
  // s204 · viven en ficha.css (.ficha__*). Jerarquia: H1 Bebas 40/52 · H2 de seccion
  // Bebas 24 + subtitulo DM Sans 14 · cuerpo 16. Antes eran cinco objetos en linea.

  // ---------- BLOQUE DE VALOR (misma anatomía que la tarjeta T2, en grande) ----------
  // Una sola fuente de la cifra: resolverAhorro. No se recalcula nada acá. La cifra va en
  // --valor a 48/56px (nunca por debajo de 24 como texto); la insignia es relleno --valor
  // con crema encima. Los precios: lista tachado → final (s155-D5). La palabra «descuento»
  // no existe en esta vista (s155-D4).
  const BloqueValor = ({ grande }) => (
    ahorro.porConfirmar ? (
      <div className="ficha__valor-porconfirmar">
        {en ? "Savings to be confirmed" : "Ahorro por confirmar"}
      </div>
    ) : (
      <div>
        <div className="ficha__valor-etiqueta">{ahorro.etiqueta}</div>
        <div className="ficha__valor-fila">
          <span className={"ficha__valor-cifra" + (grande ? " ficha__valor-cifra--grande" : "")}>{ahorro.lidera}</span>
          {ahorro.insignia && (
            <span className="ficha__valor-insignia">{ahorro.insignia}</span>
          )}
        </div>
        {/* s194 L1 (s194-D2, regla 1): la regla del mínimo va pegada a la cifra, no en el
            pie. Es la primera de las siete y la única que cambia con el tamaño. */}
        {ahorro.umbral && (
          <div className="ficha__valor-umbral">
            {reglaMinimoUmbral(ahorro.umbral.minimo, en, merchant.category || offer.category)}
          </div>
        )}
        {/* CLAIMS §1: la flecha `$180 → $108` está permitida y el tachado también —
            lo que está prohibido es el tachado PELADO, sin decir qué es ese $180.
            Hasta s183 "con cupón" rotulaba el precio FINAL, no la referencia, así
            que el tachado seguía implicando "antes/ahora". Ahora el rótulo «de
            carta» va pegado a la cifra tachada, que es lo que §1 pide. */}
        {ahorro.precios && (
          <div className="ficha__precios">
            <span className="ficha__precio-lista">{ahorro.precios.lista}</span>
            <span className="ficha__precio-rotulo">{en ? "menu price" : "de carta"}</span>
            <span aria-hidden="true" className="ficha__precio-flecha">→</span>
            <span className="ficha__precio-final">{ahorro.precios.final}</span>
            <span className="ficha__precio-rotulo ficha__precio-rotulo--final">{en ? "with coupon" : "con cupón"}</span>
          </div>
        )}
      </div>
    )
  );

  // ---------- ERROR AL ACTIVAR (s198-D18: siempre con salida) ----------
  // Dice qué pasó (el motivo sale de activationErrorMessage, como siempre) y ofrece dos
  // salidas: reintentar y escribirnos. NO dice «no se te cobró»: si el error llega después
  // de un pago con Stripe, eso no sería verdad.
  const ErrorActivar = () => message.type === "ya" ? (
    <div className="ficha__error" role="status" style={{ background: "var(--exito-tinte)", borderColor: "var(--exito)" }}>
      <p className="ficha__error-titulo" style={{ color: "var(--exito)" }}>{en ? "You already activated it" : "Ya la activaste"}</p>
      <p className="ficha__error-texto">{en ? "Your code is in My coupons. Show it when you pay." : "Tu código está en Mis cupones. Muéstralo al pagar."}</p>
      <div className="ficha__error-acciones">
        <button type="button" className="ficha__error-reintentar" style={{ background: "var(--exito)" }} onClick={() => navigate("/my-coupons")}>
          {en ? "See my code" : "Ver mi código"}
        </button>
      </div>
    </div>
  ) : (message.type === "error" && message.text) ? (
    <div className="ficha__error" role="alert">
      <p className="ficha__error-titulo">{en ? "We couldn't activate the offer" : "No pudimos activar la oferta"}</p>
      <p className="ficha__error-texto">{message.text}</p>
      <div className="ficha__error-acciones">
        <button type="button" className="ficha__error-reintentar" onClick={handleActivate} disabled={activating}>
          {en ? "Try again" : "Reintentar"}
        </button>
        <a className="ficha__error-escribenos" target="_blank" rel="noreferrer"
          href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(en ? `Hi! I couldn't activate an offer on NXT Reserve (${title}).` : `¡Hola! No pude activar una oferta en NXT Reserve (${title}).`)}`}>
          {en ? "Message us" : "Escríbenos"}
        </a>
      </div>
    </div>
  ) : null;

  // ---------- ACCIONES: el mismo onClick de siempre (D-128: la ruta probada no se toca) ----------
  // s233 · dueno-boton-apagado (Ali): el dueño ve el MISMO botón que el miembro, apagado, con el aviso debajo.
  const BotonActivar = ({ ancho }) => (
    <button
      className={"ficha__activar" + (ancho ? " ficha__activar--ancho" : "") + (botonApagado ? " ficha__activar--apagado" : "")}
      onClick={botonApagado ? undefined : handleActivate}
      disabled={activating || botonApagado}
      aria-describedby={botonApagado ? "ficha-aviso-dueno" : undefined}
    >{ctaLabel}</button>
  );

  return (
    <div className={"ficha" + (isMobile ? " ficha--movil" : "")}>
      <Navbar activePage="home" />

      <div className="ficha__ancho">
        <div className="ficha__grid">

          {/* ================= COLUMNA PRINCIPAL ================= */}
          <div className="ficha__a">

            {/* ---------- 1 · HERO ----------
                Con foto: grande, con degradado NEUTRO (§12: negro 0→55% desde abajo).
                Logo como último recurso real: contenido, no recortado, sobre hundida.
                Sin nada: placeholder por categoría, DECLARADO. Nunca banco (D-101). */}
            <div className="ficha__hero" ref={heroRef}
              // s200-D1 · DESLIZAR. Los puntos ya estaban, pero en un telefono nadie apunta
              // a un punto de 8px: se arrastra. 40px de umbral para no robarle el gesto al
              // scroll vertical, y solo si hay mas de una foto.
              onTouchStart={(e) => { tocoEn.current = e.touches[0].clientX; }}
              onTouchEnd={(e) => {
                if (gallery.length < 2 || tocoEn.current === null) return;
                const corrio = e.changedTouches[0].clientX - tocoEn.current;
                tocoEn.current = null;
                if (Math.abs(corrio) < 40) return;
                setHeroIdx((i) => {
                  const n2 = corrio < 0 ? i + 1 : i - 1;
                  return Math.max(0, Math.min(n2, gallery.length - 1));
                });
              }}
            >
              {sinFotos ? (
                <div className="ficha__sinfotos">
                  <span className="ficha__sinfotos-icono"><CategoryIcon category={offer.category} /></span>
                  <div className="ficha__sinfotos-texto">
                    {en
                      ? "This business hasn't sent its photos yet. We only publish real photos of the place — never stock images."
                      : "Este negocio todavía no envió sus fotos. Solo publicamos fotografías reales del lugar — nunca imágenes de banco."}
                  </div>
                </div>
              ) : (
                <>
                  {/* s198 · sin `lazy`: es la imagen más grande de la pantalla y la primera
                      que se ve. La forma (llena / entera / logo) la decide ficha.css. */}
                  <img key={imgSrc} src={imgSrc} alt={`${title}${merchantName ? ` — ${merchantName}` : ""}`}
                    className="ficha__hero-img"
                    data-forma={heroEsLogo ? "logo" : (heroMedida ? (heroLlena ? "llena" : "entera") : "midiendo")}
                    ref={(el) => { if (el && el.complete && heroForma.src !== imgSrc) medirHero(el); }}
                    onLoad={(e) => medirHero(e.currentTarget)}
                  />
                  {heroLlena && !heroEsLogo && <div className="ficha__hero-velo" aria-hidden="true" />}
                  {/* s204 · el logo firma la foto, como en el directorio (no si el hero ya es el logo) */}
                  {!heroEsLogo && logoComercio && (
                    <img className="ficha__logo-hero" src={logoComercio} alt="" loading="lazy"
                      onError={e => { e.target.style.display = "none"; }} />
                  )}
                </>
              )}
              <button onClick={() => navigate(-1)} aria-label={en ? "Back" : "Volver"}
                className={"ficha__volver" + (sinFotos || heroEsLogo ? " ficha__volver--claro" : "")}>&#8592;</button>
              {/* s200-D1 · en escritorio no hay dedo: flechas. Salen del flujo del teclado
                  (aria-hidden + tabIndex -1) porque los puntos ya son botones con nombre y
                  no hacen falta dos caminos de teclado para lo mismo. */}
              {gallery.length > 1 && !isMobile && [-1, 1].map((paso) => (
                <button key={paso} type="button" aria-hidden="true" tabIndex={-1}
                  onClick={() => setHeroIdx((i) => Math.max(0, Math.min(i + paso, gallery.length - 1)))}
                  disabled={paso < 0 ? heroSafe === 0 : heroSafe === gallery.length - 1}
                  className={"ficha__flecha " + (paso < 0 ? "ficha__flecha--izq" : "ficha__flecha--der")}>{paso < 0 ? "‹" : "›"}</button>
              ))}
              {gallery.length > 1 && (
                <div className="ficha__puntos">
                  {gallery.map((_, i) => (
                    <button key={i} type="button" aria-label={`${en ? "Photo" : "Foto"} ${i + 1}`} onClick={() => setHeroIdx(i)}
                      className={"ficha__punto" + (i === heroSafe ? " ficha__punto--activo" : "")} />
                  ))}
                </div>
              )}
            </div>
            {/* s200-D1 · las miniaturas en tira se fueron a la seccion «FOTOS», mas abajo:
                una grilla de tres columnas se lee de un vistazo y una tira que se desliza
                esconde la mitad. Los puntos del hero se quedan: son el mapa del carrusel. */}

            <div className="ficha__cuerpo">

              {/* ---------- 2 · ENCABEZADO ----------
                  Chip de categoría + chip de zona (D-117: sin dato, colapsa) · el TÍTULO
                  como título · el comercio como enlace a su vitrina (/m/:id). */}
              <div className="ficha__cabeza">
                <div className="ficha__cabeza-fila">
                  <div className="ficha__chips">
                    {offer.category && (
                      <span className="ficha__chip">
                        <span className="ficha__chip-icono"><CategoryIcon category={offer.category} /></span>
                        {CAT_DISPLAY[offer.category] || offer.category}
                      </span>
                    )}
                    {(neighborhood || offer.city) && (
                      <span className="ficha__chip">
                        <Ico name="ico-mapa" size={16} />
                        <span className="ficha__chip-texto">{neighborhood || offer.city}</span>
                      </span>
                    )}
                  </div>
                  <div className="ficha__iconos">
                    {/* s198-D16 · en teléfono la barra fija queda para el trato y el botón a todo
                        el ancho: compartir sube aquí, junto a guardar (Airbnb, Too Good To Go). */}
                    {isMobile && (
                      <button type="button" aria-label={en ? "Share on WhatsApp" : "Compartir por WhatsApp"} onClick={compartirWhatsApp}
                        className="ficha__icono-btn">
                        <IcoFicha name="chat" size={22} />
                      </button>
                    )}
                    {/* D-126: guardar. s202 · deja de ser inerte (favoritos-miembro). */}
                    <BotonGuardar tipo="offer" id={offer?._id} tamano={24} en={en} className="ficha__icono-btn" />
                  </div>
                </div>

                {/* s213 · lote B: el plan, arriba del título (ronda 10: foto + plan + plato deciden en 5 segundos). */}
                {etiquetaPlan(offer.plan, en) && <span className="plan-pildora ficha__plan">{etiquetaPlan(offer.plan, en)}</span>}
                <h1 className="ficha__titulo">{tituloFicha}</h1>
                {merchantName && (
                  merchantId ? (
                    <button type="button" onClick={() => navigate(`/m/${merchantId}`)} className="ficha__comercio">
                      {tituloFicha === merchantName ? (en ? "See the place" : "Ver el lugar") : merchantName} <span aria-hidden="true" className="ficha__comercio-flecha">→</span>
                    </button>
                  ) : tituloFicha !== merchantName ? (
                    <div className="ficha__comercio ficha__comercio--texto">{merchantName}</div>
                  ) : null
                )}
              </div>

              {/* ---------- 3 · VALOR (en móvil, en línea; en desktop vive en la tarjeta fija) ---------- */}
              {isMobile && (
                <div className="ficha__valor-movil">
                  <BloqueValor grande={false} />
                </div>
              )}

              {/* ---------- 3-bis · ENLACES (s222): Menú · Sitio web · Instagram · Reservar, en una fila.
                  Lo que no existe no ocupa lugar; sin ninguno, la fila no se pinta. ---------- */}
              {enlacesFicha.length > 0 && (
                <nav className="ficha__enlaces" aria-label={en ? "Links" : "Enlaces"}
                  style={{ gridTemplateColumns: `repeat(${enlacesFicha.length}, 1fr)` }}>
                  {enlacesFicha.map(l => (
                    <a key={l.clave} href={l.href} target="_blank" rel="noopener noreferrer" className="ficha__enlace">
                      <IcoFicha name={l.icono} size={22} />
                      <span>{l.texto}</span>
                    </a>
                  ))}
                </nav>
              )}

              {/* ---------- 4 · LO QUE INCLUYE ---------- */}
              {(highlight1 || highlight2 || highlight3) && (
                <section className="ficha__seccion ficha__seccion--primera">
                  <h2 className="ficha__h2">{en ? "WHAT'S INCLUDED" : "LO QUE INCLUYE"}</h2>
                  <div className="ficha__filas">
                    {[highlight1, highlight2, highlight3].filter(Boolean).map((h, i) => (
                      <div key={i} className="ficha__fila">
                        <span className="ficha__fila-icono ficha__fila-icono--ok"><IcoFicha name="check" size={20} /></span>
                        <span>{h}</span>
                      </div>
                    ))}
                  </div>
                </section>
              )}

              {/* s212 · SOBRE ESTA OFERTA sube a la columna principal: con la siembra nueva trae «Lo que más
                  piden» y «Más tranquilo», lo que la ronda 10 marcó como lo más útil de la ficha. */}
              {description && (
                <section className="ficha__seccion">
                  <h2 className="ficha__h2">{en ? "ABOUT THIS OFFER" : "SOBRE ESTA OFERTA"}</h2>
                  <p className="ficha__descripcion">{description}</p>
                </section>
              )}

              </div>
            </div>

            {/* ================= EL RIEL =================
                s183 — antes acá solo vivía el bloque de compra y el resto de la
                pantalla quedaba vacío debajo. Ahora suma DISPONIBILIDAD y EL LUGAR:
                datos de consulta, no de lectura corrida. En teléfono el CSS lo
                reubica entre A y B (ver ficha.css) para que «cuándo y dónde» no
                termine después de las condiciones. */}
            <aside className="ficha__riel">

              {/* la tarjeta de compra sigue siendo solo de escritorio: en teléfono
                  el CTA es la barra fija de abajo */}
              {!isMobile && (
              <div className="ficha__compra">
                <BloqueValor grande />
                <div className="ficha__compra-botones">
                  <BotonActivar />
                  {botonApagado && <AvisoVistaDueno en={en} sinAprobar={!vistaDueno} />}
                  <button type="button" onClick={compartirWhatsApp} className="ficha__compartir">
                    <IcoFicha name="chat" size={18} /> {en ? "Share on WhatsApp" : "Compartir por WhatsApp"}
                  </button>
                </div>
                {/* s204 · aca iba «Puedes volver en N dias», repetido: vive en «Cuando vale». */}
                <ErrorActivar />
              </div>
              )}

              {/* ---------- 5 · CUÁNDO VALE (s198-D4, primer grupo de las condiciones) ----------
                  Antes «Disponibilidad». Días, horario y cada cuánto se puede volver: datos
                  de consulta, por eso siguen en el riel y no en la columna de lectura. */}
              <section className="ficha__seccion">
                <h2 className="ficha__h2">{en ? "WHEN IT'S VALID" : "CUÁNDO VALE"}</h2>
                <div className="ficha__subtitulo">{en ? "Days, hours and how often you can come back" : "Días, horario y cada cuánto puedes volver"}</div>
                <div className="ficha__filas">
                  {diasTexto && (
                    <div className="ficha__fila"><span className="ficha__fila-icono"><IcoFicha name="calendario" size={20} /></span><span>{diasTexto}</span></div>
                  )}
                  {horarioTexto && (
                    <div className="ficha__fila"><span className="ficha__fila-icono"><IcoFicha name="reloj" size={20} /></span><span>{horarioTexto}</span></div>
                  )}
                  {Number(offer.min_consumption) > 0 && !ahorro.umbral && (
                    <div className="ficha__fila"><span className="ficha__fila-icono"><IcoFicha name="billete" size={20} /></span><span>{en ? `Minimum spend $${offer.min_consumption}` : `Consumo mínimo $${offer.min_consumption}`}</span></div>
                  )}
                  <div className="ficha__fila"><span className="ficha__fila-icono"><IcoFicha name="regreso" size={20} /></span><span>{lineaPlazo}</span></div>
                  {/* s204 · la auditoria (reglas del primer dia): el socio tiene que saber ANTES de
                      activar cuanto le dura el cupon. s246-D4: 7 o 14 dias segun el rubro de la oferta
                      (cuponDuraDias, espejo de create_coupon_and_cooldown + OfferCategory). */}
                  <div className="ficha__fila"><span className="ficha__fila-icono"><IcoFicha name="calendario" size={20} /></span><span>{en ? `Your coupon lasts ${cuponDuraDias(offer)} days from activation` : `Tu cupón dura ${cuponDuraDias(offer)} días desde que lo activas`}</span></div>
                </div>
              </section>

              {/* ---------- 5-bis · FOTOS (s200-D1) ----------
                  Como en Offline: una grilla, no una tira que se desliza. Tres columnas en
                  1:1 —la proporcion con la que el comercio las encuadro— y al tocar una, el
                  hero salta a esa foto. La primera no se repite aca: ya esta arriba. */}
              {gallery.length > 1 && !heroEsLogo && (
                <section className="ficha__seccion">
                  <h2 className="ficha__h2">{en ? "PHOTOS" : "FOTOS"}</h2>
                  <div className="ficha__subtitulo">
                    {en ? `${gallery.length} photos of the place` : `${gallery.length} fotos del lugar`}
                  </div>
                  <div className="ficha__galeria">
                    {gallery.map((g, i) => (
                      <button key={g + i} type="button" onClick={() => { setHeroIdx(i); heroRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }); }}
                        aria-label={`${en ? "Show photo" : "Ver foto"} ${i + 1}`}
                        className={"ficha__miniatura" + (i === heroSafe ? " ficha__miniatura--activa" : "")}>
                        <img src={g} alt="" loading="lazy"
                          onError={(e) => { e.target.style.display = "none"; }} />
                      </button>
                    ))}
                  </div>
                </section>
              )}

              {/* ---------- 6 · EL LUGAR (bloque comercio, s181) ----------
                  Tarjeta blanca sobre crema: se separa por superficie. Datos del registro
                  público; «Cómo llegar» reusa google_maps_url como el cupón. El rating de
                  Google es EN VIVO y solo si hay place_id y sesión (3 barandas s172-D1). */}
              {hayLugar && (
                <section className="ficha__seccion">
                  <h2 className="ficha__h2">{en ? "THE PLACE" : "EL LUGAR"}</h2>
                  <div className="ficha__subtitulo">{en ? "Where you redeem it" : "Dónde lo canjeas"}</div>
                  <div className="ficha__lugar">
                    <div className="ficha__lugar-fila">
                      {logoComercio && (
                        <img src={logoComercio} alt="" loading="lazy" width={56} height={56} className="ficha__lugar-logo"
                          onError={e => { e.target.style.display = "none"; }} />
                      )}
                      <div className="ficha__lugar-datos">
                        <div className="ficha__lugar-nombre">{merchantName}</div>
                        {/* s183 · la dirección con jerarquía propia (decisión de Cowork).
                            Antes era un renglón de 14px en tinta suave, indistinguible de
                            cualquier metadato: pero acá la dirección ES la tarea — el
                            miembro está averiguando dónde canjea. Sube a tinta plena y le
                            entra encima el rótulo de zona cuando el dato existe.
                            El MAPA EMBEBIDO no entra todavía: ticket `mapa-embed-ficha-oferta`
                            (🟡). Dato correcto para ese ticket, corregido por Cowork: la
                            Embed API de Google es $0 ilimitado con key restringida por
                            dominio — lo que falta decidir es gobernanza de claves post-s147,
                            NO es una cuestión de costo. */}
                        {zonaComercio && <div className="ficha__lugar-zona">{zonaComercio}</div>}
                        {direccion && <div className="ficha__lugar-dir">{direccion}</div>}
                        {gRating && (
                          <div className="ficha__rating">
                            <EstrellasGoogle valor={gRating.rating} size={16} />
                            <span className="ficha__rating-cifra">{Number(gRating.rating).toFixed(1)}</span>
                            <span className="ficha__rating-cuenta">({Number(gRating.count).toLocaleString(en ? "en-US" : "es")} {en ? "reviews" : "reseñas"})</span>
                            <span className="ficha__marca-google"><MarcaGoogle size={12} /> Google</span>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="ficha__contactos">
                      {mapsUrl && (
                        <a href={mapsUrl} target="_blank" rel="noreferrer" className="ficha__contacto ficha__contacto--llegar">
                          <IcoFicha name="mapa" size={18} /> {en ? "Get directions" : "Cómo llegar"}
                        </a>
                      )}
                      {telefono && (
                        <a href={`tel:${telefono}`} className="ficha__contacto">
                          <IcoFicha name="telefono" size={18} /> {telefono}
                        </a>
                      )}
                      {/* s222 · el sitio web y el Instagram suben a la fila de enlaces (arriba): aquí se repetían. */}
                    </div>

                    {horarioComercio && (
                      <details className="ficha__horario">
                        <summary className="ficha__horario-resumen">
                          <IcoFicha name="reloj" size={18} /> {en ? "Opening hours" : "Horario del lugar"}
                        </summary>
                        <div className="ficha__horario-texto">{horarioComercio}</div>
                      </details>
                    )}

                    {/* Reseñas: la segunda llamada a Places, SOLO al tocar «Ver reseñas». Se
                        muestran con atribución (marca Google, autor, enlace a Maps) y no se
                        guardan en ningún lado (TOS). */}
                    {gRating && (
                      <div className="ficha__resenas">
                        <div className="ficha__resenas-cabeza">
                          <div className="ficha__resenas-titulo">
                            <MarcaGoogle size={16} /> {en ? "Google reviews" : "Reseñas de Google"}
                          </div>
                          {gRating.mapsUri && (
                            <a href={gRating.mapsUri} target="_blank" rel="noreferrer" className="ficha__resenas-enlace">
                              {en ? "See all on Google Maps ↗" : "Ver todas en Google Maps ↗"}
                            </a>
                          )}
                        </div>
                        {gReviews === null ? (
                          <button type="button" onClick={pedirResenas} disabled={gReviewsLoading} className="ficha__contacto ficha__resenas-boton">
                            {gReviewsLoading ? (en ? "Loading…" : "Cargando…") : (en ? "See reviews" : "Ver reseñas")}
                          </button>
                        ) : gReviews.length === 0 ? (
                          <div className="ficha__resenas-vacio">{en ? "No reviews to show right now." : "No hay reseñas para mostrar ahora mismo."}</div>
                        ) : (
                          <div>
                            {gReviews.map((r, i) => (
                              <article key={i} className="ficha__resena">
                                <div className="ficha__resena-cabeza">
                                  {r.foto && <img src={r.foto} alt="" width={32} height={32} referrerPolicy="no-referrer" className="ficha__resena-foto" onError={e => { e.target.style.display = "none"; }} />}
                                  <div className="ficha__resena-quien">
                                    <a href={r.autorUri || r.uri || gRating.mapsUri} target="_blank" rel="noreferrer" className="ficha__resena-autor">{r.autor || (en ? "Google user" : "Usuario de Google")}</a>
                                    <div className="ficha__resena-meta">
                                      <EstrellasGoogle valor={r.rating} size={12} /> {r.cuando}
                                    </div>
                                  </div>
                                </div>
                                {r.texto && <p className="ficha__resena-texto">{r.texto}</p>}
                              </article>
                            ))}
                          </div>
                        )}
                      </div>
                    )}

                    {merchantId && (
                      <button type="button" onClick={() => navigate(`/m/${merchantId}`)} className="ficha__enlace-texto">
                        {en ? "View business profile →" : "Ver perfil del negocio →"}
                      </button>
                    )}
                  </div>
                </section>
              )}
              </aside>

            {/* ---------- COLUMNA B (bajo el riel en teléfono, bajo A en escritorio) ---------- */}
            <div className="ficha__b">
              <div className="ficha__cuerpo">

              {/* ---------- 7 · SOBRE ESTA OFERTA: subió a la columna principal (s212) ---------- */}

              {/* ---------- 8 · CÓMO USARLA (s198-D4, segundo grupo) ----------
                  Los cuatro pasos de siempre y, debajo, las reglas que dicen CÓMO se usa
                  (una por socio, solo en el local). Antes eran dos secciones sueltas:
                  «Condiciones» con todo mezclado y «Cómo usar tu cupón». */}
              <section className="ficha__seccion">
                <h2 className="ficha__h2">{en ? "HOW TO USE IT" : "CÓMO USARLA"}</h2>
                <ol className="ficha__pasos">
                  {/* s241 · el paso 2 sale del perfil del rubro (en encargos se pide al hacer el pedido). */}
                  {(en
                    ? ["Activate the offer here", perfilDelRubro(offer.category || merchant.category).paso2.en, "Show your code on screen", "The business validates it — done"]
                    : ["Activa la oferta aquí", perfilDelRubro(offer.category || merchant.category).paso2.es, "Muestra tu código en pantalla", "El negocio lo valida — listo"]
                  ).map((t, i) => (
                    <li key={i} className="ficha__paso">
                      <span className="ficha__paso-num">{i + 1}</span>
                      <span className="ficha__paso-texto">{t}</span>
                    </li>
                  ))}
                </ol>
                {reglasComo.length > 0 && (
                  <ul className="ficha__reglas">
                    {reglasComo.map((c, i) => <li key={i}>{c}</li>)}
                  </ul>
                )}
              </section>

              {/* ---------- 9 · RESTRICCIONES (s198-D4, tercer grupo) ----------
                  Lo que limita la oferta. Aquí caen también todas las condiciones que
                  escribe el comercio con sus palabras: no se adivina su grupo. */}
              {(reglasRestricciones.length > 0 || hayOcultas) && (
                <section className="ficha__seccion">
                  {/* s214 · fuera de restaurantes y bares puede no quedar ninguna restricción a la vista (no hay
                      alcohol ni propina): entonces el título no promete restricciones y queda el enlace a todas. */}
                  <h2 className="ficha__h2">{reglasRestricciones.length > 0 ? (en ? "RESTRICTIONS" : "RESTRICCIONES") : (en ? "CONDITIONS" : "CONDICIONES")}</h2>
                  {reglasRestricciones.length > 0 && (
                    <ul className="ficha__reglas">
                      {reglasRestricciones.map((c, i) => <li key={i}>{c}</li>)}
                    </ul>
                  )}
                  {/* s212 · las siete, completas, a un toque (ronda 10: con todas a la vista «parece contrato»). */}
                  {hayOcultas && (
                    <details className="ficha__condiciones-todas">
                      <summary>{en ? `See all ${condicionesTexto.length} conditions` : `Ver las ${condicionesTexto.length} condiciones`}</summary>
                      <ul className="ficha__reglas">
                        {condicionesTexto.map((c, i) => <li key={i}>{c}</li>)}
                      </ul>
                    </details>
                  )}
                </section>
              )}

              <div className="ficha__pie-volver">
                <button type="button" onClick={() => navigate(-1)} className="ficha__enlace-texto ficha__enlace-texto--suave">
                  {en ? "← Back to catalog" : "← Volver al catálogo"}
                </button>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* ================= 9 · CTA (móvil: barra fija sobre la barra de navegación) =================
          Lo único que de verdad flota: la única sombra del sistema. Va ENCIMA del Navbar
          fijo (≈68px), con el mismo onClick de siempre. */}
      {/* s198-D16 · la barra de Ali (capa 2, pieza 5, opción B): la frase del trato arriba,
          centrada, y «Activar oferta» a todo el ancho. Compartir subió a la cabecera. */}
      {isMobile && (
        <div className="ficha__barra">
          <ErrorActivar />
          {ahorroBoton && <p className="ficha__barra-frase">{ahorroBoton}</p>}
          <BotonActivar ancho />
          {botonApagado && <AvisoVistaDueno en={en} corto sinAprobar={!vistaDueno} />}
        </div>
      )}

      {/* s198-D18 · OFERTA ACTIVADA: el momento de recompensa. Qué activaste, el código en
          grande y qué hacer después. Antes: «Listo. Disfrútalo.» y un salto a Mis Cupones a
          los 1,5 s, sin ver el código. Esc o «Cerrar» dejan al socio en la ficha. */}
      {activada && (
        <dialog ref={exitoRef} className="ficha__exito" aria-labelledby="exito-titulo" onClose={() => setActivada(null)}>
          <div className="ficha__exito-caja">
            <span className="ficha__exito-icono" aria-hidden="true"><Ico name="ico-ok" size={28} /></span>
            <h2 id="exito-titulo" className="ficha__exito-titulo">{en ? "Your offer is active" : "Tu oferta está activa"}</h2>
            <p className="ficha__exito-texto">
              {ahorroBoton ? `${ahorroBoton}${merchantName ? (en ? ` at ${merchantName}` : ` en ${merchantName}`) : ""}. ` : ""}
              {en ? "Show this code when you pay." : "Muestra este código al pagar."}
            </p>
            {activada.code && (
              <div className="ficha__exito-codigo">
                <small>{en ? "Your code" : "Tu código"}</small>
                <b>{activada.code}</b>
              </div>
            )}
            {venceTexto && <p className="ficha__exito-vence">{en ? `Expires ${venceTexto}` : `Vence el ${venceTexto}`}</p>}
            <button type="button" className="ficha__exito-ver" onClick={() => navigate("/my-coupons")}>
              {en ? "See my coupons" : "Ver mis cupones"}
            </button>
            {/* cierra y limpia el estado a mano: no depende de que el evento `close` llegue */}
            <button type="button" className="boton-texto ficha__exito-cerrar" onClick={() => { if (exitoRef.current) exitoRef.current.close(); setActivada(null); }}>
              {en ? "Close" : "Cerrar"}
            </button>
          </div>
        </dialog>
      )}

      {/* s186 · la comparacion del enganche, antes del fee del cupon */}
      {enganche && (
        <EngancheModal
          feeCupon={enganche.feeCupon}
          plan={enganche.plan}
          precio={enganche.precio}
          codigo={enganche.codigo}
          lang={lang}
          onSoloCupon={() => { setEnganche(null); setShowPayment(true); }}
          onCancelar={() => setEnganche(null)}
          onListo={async () => {
            // Ya es miembro: el enganche se gasto y el cupon pasa a ser gratis. No
            // se activa a mano — se vuelve a preguntar al servidor, que es el unico
            // que sabe si esta persona paga o no (invertir-cobro-tiers, s142/s143).
            limpiarEnganche();
            setEnganche(null);
            // s186 · acá vivía la resincronización del tier. Se fue a `confirmFixedPricePurchase`
            // (api.js): el problema no era de esta pantalla sino de las cuatro que compran, y
            // resolverlo en cada una garantiza que alguna quede sin hacerlo.
            handleActivate();
          }}
        />
      )}

      {/* Stripe Payment Modal */}
      {showPayment && (
        <StripePaymentModal
          fee={getFee(offer)}
          offerId={id}
          onSuccess={handlePaymentSuccess}
          onCancel={() => setShowPayment(false)}
          lang={lang}
        />
      )}

      {/* ETAPA-0 (s97): gate de prospecto — activar requiere código de invitación */}
      {/* s220 · EL PUENTE: ya aplicó el código de un aliado (sin tier). No se le pide otro código:
          se le dice que quedó guardado y que la membresía con prueba abre pronto. */}
      {codeGate?.guardado && (
        <div className="comercio__velo" onClick={() => setCodeGate(null)}>
          <div role="dialog" aria-modal="true" aria-labelledby="ficha-guardado-titulo" className="comercio__dialogo" onClick={e => e.stopPropagation()}>
            <h2 id="ficha-guardado-titulo" className="comercio__dialogo-titulo">
              {lang === "en" ? "YOUR CODE IS SAVED" : "TU CÓDIGO QUEDÓ GUARDADO"}
            </h2>
            <p className="comercio__invitacion-texto">
              {lang === "en"
                ? "Your NXT partner's code is on your account. Very soon you'll be able to start your membership with a 7-day trial and activate this benefit — we'll let you know by WhatsApp."
                : "El código de tu aliado de NXT ya está en tu cuenta. Muy pronto vas a poder activar tu membresía con 7 días de prueba y usar este beneficio; te avisamos por WhatsApp."}
            </p>
            <button onClick={() => setCodeGate(null)} className="comercio__boton ficha__gate-principal">
              {lang === "en" ? "Keep browsing" : "Seguir mirando"}
            </button>
          </div>
        </div>
      )}
      {codeGate && !codeGate.guardado && (
        <div className="comercio__velo" onClick={() => setCodeGate(null)}>
          {/* s204 · la misma forma que «Solo miembros» de /m/:id (comercio.css) */}
          <div role="dialog" aria-modal="true" aria-labelledby="ficha-gate-titulo" className="comercio__dialogo" onClick={e => e.stopPropagation()}>
            <h2 id="ficha-gate-titulo" className="comercio__dialogo-titulo">
              {lang === "en" ? "ACCESS IS BY INVITATION" : "EL ACCESO ES POR INVITACIÓN"}
            </h2>
            <p className="comercio__invitacion-texto">
              {/* s203-D6: la primera frase es PUERTA_SIN_PLAN — cambia ahí, no acá. */}
              {lang === "en"
                ? `${PUERTA_SIN_PLAN.en} Got one? Enter it now — or message us and we'll get you yours.`
                : `${PUERTA_SIN_PLAN.es} ¿Tienes uno? Ingrésalo ahora — o escríbenos y te damos el tuyo.`}
            </p>
            <button onClick={() => navigate("/viajes")} className="comercio__boton ficha__gate-principal">
              {lang === "en" ? "I have a code →" : "Tengo un código →"}
            </button>
            <a
              href={`https://wa.me/${codeGate.wa}?text=${encodeURIComponent(lang === "en" ? "Hi! I'm browsing NXT Reserve and I'd like my invite code." : "¡Hola! Estoy viendo NXT Reserve y quiero mi código de invitación.")}`}
              target="_blank" rel="noreferrer"
              className="comercio__dialogo-secundario ficha__gate-wa"
            >
              <IcoFicha name="chat" size={18} /> {lang === "en" ? "Get my code on WhatsApp" : "Pedir mi código por WhatsApp"}
            </a>
            <button onClick={() => { setCodeGate(null); navigate("/beneficios"); }} className="comercio__dialogo-secundario">
              {lang === "en" ? "See everything the club includes →" : "Ver todo lo que incluye el club →"}
            </button>
            <button onClick={() => setCodeGate(null)} className="boton-texto ficha__gate-seguir">
              {lang === "en" ? "Keep browsing" : "Seguir mirando"}
            </button>
          </div>
        </div>
      )}

      {/* MKT-30 paso 5: la ficha es la única pantalla del miembro sin nav — se monta igual que Home/Cupones/Cuenta */}
      {/* el hueco que la barra fija de teléfono le tapa al contenido */}
      <Pie />
    </div>
  );
}

// ============================================
// PAGE: DIRECTORIO DE NEGOCIOS (/merchants) — F1 s119 (storefront)
// Lee el canal publico anonimo (getPublicMerchants) y linkea a /m/:id.
// Post-login por ahora (statu quo club cerrado); si se decide vitrina
// pre-login, basta mover la ruta fuera de ProtectedRoute.
// ============================================
function MerchantsDirectoryPage() {
  const navigate = useNavigate();
  const lang = useLang();
  const en = lang === "en";
  const [merchants, setMerchants] = useState([]);
  const [beneficios, setBeneficios] = useState({});   // merchant _id → ofertas aprobadas
  const [loading, setLoading] = useState(true);
  const [catFilter, setCatFilter] = useState("");
  const [busqueda, setBusqueda] = useState("");

  useEffect(() => {
    let alive = true;
    // s204 · dos lecturas publicas en paralelo: los comercios (como siempre) y las
    // ofertas aprobadas, la MISMA lectura del catalogo, para decir cuantos beneficios
    // tiene cada uno. Si la de ofertas falla, el directorio sale igual, sin la cuenta.
    Promise.all([getPublicMerchants(), getOffers().catch(() => null)]).then(([list, ofertas]) => {
      if (!alive) return;
      const norm = (u) => (u && String(u).startsWith("//")) ? "https:" + u : u;
      const clean = (Array.isArray(list) ? list : [])
        .filter(m => m.business_name)
        .map(m => ({ ...m, logo: norm(m.logo), gallery: Array.isArray(m.gallery) ? m.gallery.map(norm) : [] }))
        .sort((a, b) => String(a.business_name).localeCompare(String(b.business_name)));
      setMerchants(clean);
      if (Array.isArray(ofertas)) {
        const cuenta = {};
        ofertas.forEach(o => { if (o.merchant_id) cuenta[o.merchant_id] = (cuenta[o.merchant_id] || 0) + 1; });
        setBeneficios(cuenta);
      }
      setLoading(false);
    });
    return () => { alive = false; };
  }, []);

  // Sin tildes ni mayusculas: «cafe» encuentra «Café».
  const plano = (v) => String(v || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim();
  const q = plano(busqueda);
  const cats = [...new Set(merchants.map(m => m.category).filter(Boolean))];
  const shown = merchants
    .filter(m => !catFilter || m.category === catFilter)
    .filter(m => !q || plano(m.business_name).includes(q) || plano(m.neighborhood).includes(q));

  // Una categoria fuera del canon (hay comercios de prueba con «other») no se muestra cruda.
  const nombreCat = (c) => CAT_DISPLAY[c] || (c ? (en ? "Other" : "Otros") : "");
  const lineaBeneficios = (n) => n > 0
    ? (en ? `${n} active ${n === 1 ? "benefit" : "benefits"}` : `${n} ${n === 1 ? "beneficio activo" : "beneficios activos"}`)
    : (en ? "No active benefits right now" : "Sin beneficios activos por ahora");

  return (
    <div className="directorio">
      <Navbar activePage="home" />
      {/* s204 · la barra fija de «← NEGOCIOS DEL CLUB» se va: repetia el menu, que ya
          marca «Comercios». El titulo pasa a ser el de la pagina, como el catalogo. */}
      <main className="directorio__ancho">
        <header className="directorio__cabeza">
          <h1 className="directorio__titulo">{en ? "Member businesses" : "Negocios del club"}</h1>
          {/* decia «socios elegidos a mano»: en la app el socio es el miembro. */}
          <p className="directorio__bajada">
            {loading ? "" : `${merchants.length} ${en ? "hand-picked businesses" : "comercios elegidos a mano"}`}
          </p>
        </header>

        <div className="directorio__herramientas">
          <input type="search" className="directorio__buscar" value={busqueda}
            onChange={e => setBusqueda(e.target.value)}
            placeholder={en ? "Search a business or neighborhood..." : "Busca un negocio o un barrio..."}
            aria-label={en ? "Search businesses" : "Buscar negocios"} />
          {cats.length > 1 && (
            <div className="directorio__chips" role="group" aria-label={en ? "Categories" : "Categorías"}>
              <button type="button" aria-pressed={catFilter === ""}
                className={"directorio__chip" + (catFilter === "" ? " directorio__chip--activo" : "")}
                onClick={() => setCatFilter("")}>
                {en ? "All" : "Todos"}
              </button>
              {cats.map(c => (
                <button key={c} type="button" aria-pressed={catFilter === c}
                  className={"directorio__chip" + (catFilter === c ? " directorio__chip--activo" : "")}
                  onClick={() => setCatFilter(catFilter === c ? "" : c)}>
                  <CategoryIcon category={c} />
                  {nombreCat(c)}
                </button>
              ))}
            </div>
          )}
        </div>

        {loading ? (
          <div className="directorio__estado">{en ? "Loading..." : "Cargando..."}</div>
        ) : shown.length === 0 ? (
          <div className="directorio__estado">
            {merchants.length === 0
              ? (en ? "No businesses yet" : "Aún no hay negocios")
              : (en ? "No business matches your search." : "Ningún negocio coincide con tu búsqueda.")}
            {merchants.length > 0 && (
              <button type="button" className="boton-texto directorio__limpiar"
                onClick={() => { setBusqueda(""); setCatFilter(""); }}>
                {en ? "Clear search" : "Limpiar búsqueda"}
              </button>
            )}
          </div>
        ) : (
          <ul className="directorio__grilla">
            {shown.map(m => {
              // S-15 / FE-D-s182: la foto del LOCAL es la tarjeta. El logo nunca va de
              // portada: va chico encima de la foto, o solo sobre fondo neutro si no hay.
              const foto = m.gallery[0] || "";
              const n = beneficios[m._id] || 0;
              return (
                <li key={m._id} className="dir-tarjeta">
                  <div className={"dir-tarjeta__foto" + (foto ? "" : " dir-tarjeta__foto--sin")}>
                    {foto
                      ? <img className="dir-tarjeta__img" src={foto} alt="" loading="lazy"
                          onError={e => { e.target.style.display = "none"; }} />
                      : (m.logo
                          ? <img className="dir-tarjeta__logo-solo" src={m.logo} alt="" loading="lazy"
                              onError={e => { e.target.style.display = "none"; }} />
                          : <span className="dir-tarjeta__icono" aria-hidden="true"><CategoryIcon category={m.category} /></span>)}
                    {foto && m.logo && (
                      <img className="dir-tarjeta__logo" src={m.logo} alt="" loading="lazy"
                        onError={e => { e.target.style.display = "none"; }} />
                    )}
                  </div>
                  <BotonGuardar tipo="merchant" id={m._id} className="tarjeta__guardar" conCirculo tamano={20} en={en} />
                  <h2 className="dir-tarjeta__nombre">
                    <a className="dir-tarjeta__enlace" href={`/m/${m._id}`}
                      onClick={e => { e.preventDefault(); navigate(`/m/${m._id}`); }}>
                      {m.business_name}
                    </a>
                  </h2>
                  <p className="dir-tarjeta__meta">
                    {[nombreCat(m.category), m.neighborhood || m.city].filter(Boolean).join(" · ") || "Miami, FL"}
                  </p>
                  <p className={"dir-tarjeta__beneficios" + (n > 0 ? "" : " dir-tarjeta__beneficios--cero")}>
                    {lineaBeneficios(n)}
                  </p>
                </li>
              );
            })}
          </ul>
        )}
      </main>

      {/* s183 — estas dos paginas no tenian navegacion: se llegaba por un enlace
          suelto del catalogo y no habia forma de volver salvo el boton del navegador.
          Ahora «Comercios» es un destino del menu, asi que la barra viaja con ellas. */}
      <Pie />
    </div>
  );
}

// ============================================
// PAGE: MERCHANT PÚBLICO (/m/:id) — F1 s101
// ============================================
function MerchantPublicPage() {
  const { id } = useParams();
  // s120 F1 vitrina publica: visitante anonimo ve la vidriera; el canje queda tras login.
  const isMember = auth.isLoggedIn();
  const [showGate, setShowGate] = useState(false);
  useEscapeToClose(showGate && !isMember, () => setShowGate(false));
  const navigate = useNavigate();
  const [merchant, setMerchant] = useState(null);
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const lang = useLang();

  // s120 F1: noindex mientras dure la fase link-only (se levanta en fase 2 con el trigger de contenido)
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex";
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const [m, offs] = await Promise.all([getMerchantById(id), getMerchantOffers(id)]);
        if (!alive) return;
        setMerchant(m);
        setOffers(Array.isArray(offs) ? offs : []);
      } catch { /* noop */ } finally { if (alive) setLoading(false); }
    })();
    return () => { alive = false; };
  }, [id]);

  if (loading) return <div className="comercio__estado">{lang === "en" ? "Loading..." : "Cargando..."}</div>;
  if (!merchant) return <div className="comercio__estado">{lang === "en" ? "Business not found" : "Negocio no encontrado"}</div>;

  const name = merchant.business_name || "";
  const desc = lang === "en" ? (merchant.description_en || merchant.description_es) : (merchant.description_es || merchant.description_en);
  const norm = (u) => (u && String(u).startsWith("//")) ? "https:" + u : u;

  // S-15: el LOGO no es una fotografía del local. Antes se metía como primer
  // elemento de la galería y terminaba estirado a toda la portada con
  // objectFit cover — un 1:1 recortado a banda ancha (§12). Ahora van por
  // separado: el logo ocupa su sitio de logo y la portada solo admite
  // fotografía real del lugar (D-101). Si no hay, se DECLARA (D-87).
  const logo = norm(merchant.logo) || null;
  const fotos = (Array.isArray(merchant.gallery) ? merchant.gallery : []).map(norm).filter(Boolean);
  const sinFotos = fotos.length === 0;

  const igUrl = (h) => String(h).startsWith("http") ? h : `https://instagram.com/${String(h).replace(/^@/, "")}`;
  const extUrl = (u) => String(u).startsWith("http") ? u : `https://${u}`;
  const addr = merchant.address_full || merchant.address || merchant.address_text || "";


  // s183 — el horario dejaba de leerse porque venía como un bloque de texto crudo
  // con `white-space: pre-line`: siete renglones del mismo peso que el ojo no puede
  // recorrer. Se parte en día + valor para poder alinearlo en dos columnas. El
  // corte es en el primer «:» y SOLO si lo que queda a la izquierda no tiene
  // dígitos — así «lunes: 12:00–23:00» se parte bien y una línea suelta como
  // «Cerrado por vacaciones» se respeta entera en vez de romperse en el «:».
  const horarioDeTexto = String(merchant.business_hours || "")
    .split(/\r?\n/)
    .map(l => l.trim())
    .filter(Boolean)
    .map(l => {
      const i = l.indexOf(":");
      if (i > 0 && !/\d/.test(l.slice(0, i))) {
        return { dia: l.slice(0, i).trim(), valor: l.slice(i + 1).trim() };
      }
      return { dia: l, valor: "" };
    });

  // s184: el texto manda cuando existe —lo redacta Google y es mas rico—, pero si no
  // esta, el horario se arma del json que cargo el propio comercio. Ver horarioDesdeJson.
  const horario = horarioDeTexto.length
    ? horarioDeTexto
    : horarioDesdeJson(merchant.business_hours_json, lang === "en");

  const zona = [merchant.neighborhood, merchant.city].filter(Boolean).join(" · ");

  // s183 · dos datos que ya viajaban en el payload público y no los usaba nadie.
  // El RUBRO es el tipo fino («Café / brunch») contra la categoría gruesa con la
  // que se filtra el catálogo («Restaurantes»); el DELIVERY lo declara el propio
  // comercio en su perfil.
  const rubro = merchant.business_type || "";
  const hayDelivery = merchant.delivery_available === true || merchant.delivery_available === "yes";

  // s183 · el teléfono y el WhatsApp son campos distintos desde el alta, pero nada
  // impide que el comercio cargue el MISMO número en los dos — y entonces salían
  // dos filas con el mismo número y distinto icono. Se comparan por dígitos, que
  // es lo único estable: "(305) 577-0277" y "+13055770277" son el mismo teléfono
  // escrito de dos maneras. Si coinciden, gana WhatsApp: es la acción que más
  // sirve, y el número queda igual de visible.
  const soloDigitos = (v) => String(v || "").replace(/[^0-9]/g, "").replace(/^1(?=\d{10}$)/, "");
  const mismoNumero = !!merchant.phone_public && !!merchant.whatsapp &&
    soloDigitos(merchant.phone_public) === soloDigitos(merchant.whatsapp);
  const verTelefono = !!merchant.phone_public && !mismoNumero;

  const hayContacto = !!(merchant.phone_public || merchant.whatsapp || merchant.instagram || merchant.website);

  return (
    <div className="comercio">
      <Navbar activePage="home" />

      <div className="comercio__ancho">

        <button type="button" className="comercio__volver" onClick={() => navigate(-1)}>
          ← {lang === "en" ? "Back" : "Volver"}
        </button>

        {/* ---------- PORTADA — solo fotografía real del local (D-101) ----------
            s183: deja de ser una banda de punta a punta. A 1360 de ancho por 340
            de alto la portada era un 4:1, y ninguna foto de un local sobrevive a
            ese recorte: se come el plato y deja una franja de mantel. Peor aún,
            el ancho crece con el monitor y el alto no, así que cuanto más grande
            la pantalla, peor quedaba.
            Ahora es un mosaico dentro del ancho de contenido, y su forma depende
            de CUÁNTAS fotos mandó el comercio — 1, 2, o 3 y más. Cada pieza queda
            en una proporción que una cámara de teléfono produce de verdad. */}
        {!sinFotos && (
          <div className={`comercio__mosaico comercio__mosaico--${Math.min(fotos.length, 3)}`}>
            {fotos.slice(0, 3).map((f, i) => (
              <img key={i} src={f} loading="lazy"
                alt={i === 0
                  ? `${name} — ${lang === "en" ? "the place" : "el local"}`
                  : `${name} ${i + 1}`}
                onError={e => { e.target.style.display = "none"; }} />
            ))}
          </div>
        )}

        {/* ---------- IDENTIDAD ----------
            El logo va donde va un logo —cuadrado, a tamaño de logo— y pisa el
            borde del mosaico: eso lo ancla al lugar en vez de dejarlo flotando
            en una fila cualquiera. Nunca estirado como portada (S-15).
            Sin fotos no hay nada que pisar y el encabezado se para sobre blanco. */}
        <div className={`comercio__identidad${sinFotos ? " comercio__identidad--sinfoto" : ""}`}>
          {logo && (
            <img src={logo} alt="" loading="lazy" className="comercio__logo"
              onError={e => { e.target.style.display = "none"; }} />
          )}
          <div className="comercio__identidad-texto">
            <h1 className="comercio__nombre">{name}</h1>
            <div className="comercio__meta">
              {merchant.category && (
                <span className="chip comercio__chip">
                  <CategoryIcon category={merchant.category} />
                  {CAT_DISPLAY[merchant.category] || merchant.category}
                </span>
              )}
              {/* s183 · el RUBRO. Ya viajaba en el payload y no lo usaba nadie:
                  «Café / brunch» dice bastante más que «Restaurantes», que es la
                  categoría gruesa con la que se filtra el catálogo. */}
              {rubro && (
                <span className="chip comercio__chip">
                  {rubro}
                </span>
              )}
              {zona && (
                <span className="chip comercio__chip">
                  <IcoFicha name="mapa" size={13} />{zona}
                </span>
              )}
              {/* s183 · delivery. El comercio ya lo declara en su perfil y tampoco
                  se mostraba. Cuando además es gratis, eso es lo que se dice. */}
              {hayDelivery && (
                <span className="chip comercio__chip comercio__chip--delivery">
                  {merchant.delivery_free
                    ? (lang === "en" ? "Free delivery" : "Delivery gratis")
                    : (lang === "en" ? "Delivery" : "Con delivery")}
                </span>
              )}
            </div>
          </div>
          {/* s202 · F1 de favoritos-miembro: el comercio se guarda aparte de sus ofertas
              («el comercio favorito sobrevive a sus ofertas»). Al final de la fila del nombre. */}
          <BotonGuardar tipo="merchant" id={merchant._id} tamano={24} en={lang === "en"} className="comercio__guardar" />
        </div>

        {/* Sin una sola foto se DICE, no se rellena (D-87). Es el caso frecuente
            mientras los comercios no manden las suyas, así que tiene que ser un
            estado digno y no un hueco. */}
        {sinFotos && (
          <div className="comercio__sinfoto-aviso">
            <span className="comercio__sinfoto-ico"><IcoFicha name="camara" size={18} /></span>
            <span>
              {lang === "en"
                ? "This business hasn't sent its photos yet. We only publish real photos of the place — never stock images."
                : "Este negocio todavía no envió sus fotos. Solo publicamos fotografías reales del lugar — nunca imágenes de banco."}
            </span>
          </div>
        )}

        {/* ---------- GALERÍA — de la cuarta en adelante ----------
            Las tres primeras ya viven en el mosaico de arriba. */}
        {fotos.length > 3 && (
          <div className="comercio__tiras">
            {fotos.slice(3).map((g, i) => (
              <img key={i} src={g} alt={`${name} ${i + 4}`} loading="lazy"
                onError={e => { e.target.style.display = "none"; }} />
            ))}
          </div>
        )}

        <div className="comercio__grid">

          {/* ================= LO QUE EL CLUB CONSIGUE ACÁ ================= */}
          <div className="comercio__identidad-texto">

            <section className="comercio__seccion">
              <h2 className="comercio__titulo-seccion">
                {lang === "en" ? "Club benefits here" : "Beneficios del club aquí"}
              </h2>
              <div className="comercio__bajada">
                {offers.length === 0
                  ? (lang === "en" ? "No active benefits right now." : "Sin beneficios activos por ahora.")
                  : `${offers.length} ${offers.length === 1
                      ? (lang === "en" ? "active" : "activo")
                      : (lang === "en" ? "active" : "activos")}`}
              </div>
              {offers.length > 0 && (
                <div className="comercio__beneficios">
                  {offers.map((o) => (
                    <div key={o._id} className="comercio__beneficio">
                      <OfferCard offer={o} sinGuardar={!isMember} nombreComercio={merchant.business_name} onClick={() => isMember ? navigate(`/offer/${o._id}`) : setShowGate(true)} />
                      {!isMember && (
                        <div className="comercio__sello">
                          {lang === "en" ? "Members only" : "Solo miembros"}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </section>

            {desc && (
              <section className="comercio__seccion">
                <h2 className="comercio__titulo-seccion">{lang === "en" ? "About" : "Sobre el negocio"}</h2>
                <p className="comercio__descripcion">{desc}</p>
              </section>
            )}
          </div>

          {/* ================= EL RIEL: dónde, cuándo y cómo ================= */}
          <aside className="comercio__riel">

            {(addr || merchant.google_maps_url) && (
              <div className="comercio__bloque">
                <h2 className="comercio__rotulo">{lang === "en" ? "Where it is" : "Dónde queda"}</h2>
                {/* La dirección con jerarquía propia: en esta pantalla es una de las
                    cosas que la persona vino a buscar, no un metadato. El mapa
                    embebido queda para el ticket `mapa-embed-ficha-oferta` (la Embed
                    API es $0 con key restringida por dominio; lo que falta decidir es
                    gobernanza de claves, no presupuesto). */}
                {addr && <div className="ficha__lugar-dir">{addr}</div>}
                {merchant.google_maps_url && (
                  <a href={merchant.google_maps_url} target="_blank" rel="noreferrer" className="comercio__llegar">
                    <IcoFicha name="mapa" size={18} /> {lang === "en" ? "Get directions" : "Cómo llegar"}
                  </a>
                )}
              </div>
            )}

            {horario.length > 0 && (
              <div className="comercio__bloque">
                <h2 className="comercio__rotulo">{lang === "en" ? "Opening hours" : "Horario del lugar"}</h2>
                {horario.map((h, i) => (
                  <div key={i} className="comercio__hora">
                    <span className="comercio__hora-dia">{h.dia}</span>
                    {h.valor && <span className="comercio__hora-valor">{h.valor}</span>}
                  </div>
                ))}
              </div>
            )}

            {hayContacto && (
              <div className="comercio__bloque">
                <h2 className="comercio__rotulo">{lang === "en" ? "Contact" : "Contacto"}</h2>
                {verTelefono && (
                  <a href={`tel:${merchant.phone_public}`} className="comercio__fila">
                    <span className="comercio__fila-ico"><IcoFicha name="telefono" size={18} /></span>{merchant.phone_public}
                  </a>
                )}
                {merchant.whatsapp && (
                  <a href={`https://wa.me/${String(merchant.whatsapp).replace(/[^0-9]/g, "")}`} target="_blank" rel="noreferrer" className="comercio__fila">
                    <span className="comercio__fila-ico"><IcoFicha name="chat" size={18} /></span>
                    {/* Cuando es el mismo número que el teléfono, esta fila lo reemplaza
                        y muestra el número: si no, el dato desaparecía de la pantalla. */}
                    {mismoNumero ? `${merchant.phone_public} · WhatsApp` : "WhatsApp"}
                  </a>
                )}
                {merchant.website && (
                  <a href={extUrl(merchant.website)} target="_blank" rel="noreferrer" className="comercio__fila">
                    <span className="comercio__fila-ico"><IcoFicha name="globo" size={18} /></span>
                    <span className="comercio__web">
                      {String(merchant.website).replace(/^https?:\/\//, "").replace(/\/$/, "")}
                    </span>
                  </a>
                )}
                {merchant.instagram && (
                  <a href={igUrl(merchant.instagram)} target="_blank" rel="noreferrer" className="comercio__fila">
                    <span className="comercio__fila-ico"><IcoFicha name="camara" size={18} /></span>
                    {String(merchant.instagram).startsWith("@") ? merchant.instagram : `@${String(merchant.instagram).replace(/^https?:\/\/(www\.)?instagram\.com\//, "").replace(/\/$/, "")}`}
                  </a>
                )}
              </div>
            )}
          </aside>
        </div>

        {/* s120 F1: CTA de invitacion para visitantes anonimos (pitch a merchants / boca a boca) */}
        {!isMember && (
          <div className="comercio__invitacion">
            <h2 className="comercio__invitacion-titulo">
              {lang === "en" ? "AN INVITATION-ONLY CLUB" : "UN CLUB POR INVITACIÓN"}
            </h2>
            <p className="comercio__invitacion-texto">
              {lang === "en" ? "Members unlock these benefits with their code. Want in?" : "Los miembros desbloquean estos beneficios con su código. ¿Quieres entrar?"}
            </p>
            <a href="https://nxtreserve.com" className="comercio__boton">
              {lang === "en" ? "Request an invitation →" : "Solicitar invitación →"}
            </a>
            <button className="comercio__soy-socio" onClick={() => navigate("/login")}>
              {lang === "en" ? "I'm a member →" : "Ya soy miembro →"}
            </button>
          </div>
        )}
      </div>

      {/* s120 F1: gate al tocar un beneficio siendo anonimo — la vidriera se ve, el canje es del club */}
      {showGate && !isMember && (
        <div className="comercio__velo" onClick={() => setShowGate(false)}>
          <div role="dialog" aria-modal="true" aria-label={lang === "en" ? "Members only" : "Solo miembros"} onClick={(e) => e.stopPropagation()} className="comercio__dialogo">
            <h2 className="comercio__dialogo-titulo">{lang === "en" ? "MEMBERS ONLY" : "SOLO MIEMBROS"}</h2>
            <p className="comercio__invitacion-texto">
              {lang === "en" ? "This benefit is redeemed with a member code. The club is invitation-only." : "Este beneficio se canjea con código de miembro. El club es por invitación."}
            </p>
            <a href="https://nxtreserve.com" className="comercio__boton">
              {lang === "en" ? "Request an invitation →" : "Solicitar invitación →"}
            </a>
            <button className="comercio__dialogo-secundario" onClick={() => navigate("/login")}>
              {lang === "en" ? "I'm a member →" : "Ya soy miembro →"}
            </button>
          </div>
        </div>
      )}

      <Pie />
    </div>
  );
}

// ============================================
// PAGE: MY COUPONS
// ============================================
function MyCouponsPage() {
  const navigate = useNavigate();
  const lang = useLang();
  const en = lang === "en";
  // s183 · la carga se mudó al contexto: la comparte con la franja superior, que
  // necesita el mismo dato para el ahorro. Antes esta pantalla hacía su propio
  // fetch y la franja habría hecho otro en cada una de las siete.
  const { cupones, cargando, ahorro, recargar } = useCupones();
  const [filtro, setFiltro] = useState("activos");
  // s215 · la lista se cargaba una vez por sesión: lo activado después no aparecía hasta un F5.
  useEffect(() => { recargar(); }, [recargar]);

  useEffect(() => { if (!auth.isLoggedIn()) navigate("/login"); }, [navigate]);

  const estado = (c) => String(c.status || "").toLowerCase();
  const vence = (c) => (c.expires_at ? new Date(c.expires_at).getTime() : Infinity);

  // Tres grupos, que son los que el miembro distingue de verdad. `void` cae en
  // vencidos: para quien mira, un cupón anulado es uno que ya no sirve.
  // s198 · y también un `active` cuya fecha ya pasó: medido el 19/09 en la cuenta de Ali,
  // 3 de 5 «activos» habían vencido (3/8, 9/9 y 10/9) y Bubble no les cambió el estado.
  // Mostrarlos en «Activos» es darle al socio un código que ya no sirve en el mostrador.
  const vencioPorFecha = (c) => estado(c) === "active" && vence(c) <= Date.now();
  const grupos = {
    activos:   cupones.filter(c => estado(c) === "active" && !vencioPorFecha(c)).sort((a, b) => vence(a) - vence(b)),
    redimidos: cupones.filter(c => estado(c) === "redeemed").sort((a, b) => vence(b) - vence(a)),
    vencidos:  cupones.filter(c => ["expired", "void"].includes(estado(c)) || vencioPorFecha(c)).sort((a, b) => vence(b) - vence(a)),
  };

  // s198-D17 · «Canjeados» y no «Redimidos»: es la palabra que usa el resto de la app
  // (canje, canjear) y la que dice la decisión 6.
  const pestanas = [
    { id: "activos",   label: en ? "Active" : "Activos" },
    { id: "redimidos", label: en ? "Redeemed" : "Canjeados" },
    { id: "vencidos",  label: en ? "Expired" : "Vencidos" },
  ];

  const lista = grupos[filtro] || [];

  return (
    <div className="cupones">
      <Navbar activePage="coupons" />

      <div className="cupones__ancho">
        <div className="cupones__cabecera">
          <div>
            <h1 className="cupones__titulo">{en ? "My coupons" : "Mis cupones"}</h1>
            <div className="cupones__bajada">
              {en ? "Your active benefits" : "Tus beneficios activos"}
            </div>
          </div>

          {/* EL AHORRO ACUMULADO. Va acá y no escondido en la cuenta: esta es la
              pantalla donde el miembro comprueba si la membresía vale lo que paga.
              CLAIMS §2: solo se muestra si hay canjes con cifra — nunca un
              «has ahorrado $0» de relleno. El rótulo nombra la referencia (§1). */}
          {ahorro > 0 && (
            <div className="cupones__ahorro">
              <div className="cupones__ahorro-rotulo">{en ? "You've saved" : "Has ahorrado"}</div>
              <div className="cupones__ahorro-cifra">${fmtUsd(ahorro)}</div>
              <div className="cupones__ahorro-pie">
                {en ? "on menu prices" : "sobre precios de carta"}
              </div>
            </div>
          )}
        </div>

        <div className="cupones__filtros" role="tablist" aria-label={en ? "Coupons by status" : "Cupones por estado"}>
          {pestanas.map(p => (
            <button
              key={p.id}
              id={`cupones-tab-${p.id}`}
              role="tab"
              aria-selected={filtro === p.id}
              aria-controls="cupones-panel"
              className={`cupones__filtro${filtro === p.id ? " cupones__filtro--on" : ""}`}
              onClick={() => setFiltro(p.id)}
            >
              {p.label}
              <span className="cupones__conteo">{grupos[p.id].length}</span>
            </button>
          ))}
        </div>

        <div id="cupones-panel" role="tabpanel" aria-labelledby={`cupones-tab-${filtro}`}>
        {cargando ? (
          // s198 · la carga con la forma del cupón que va a llegar (como el catálogo), en vez
          // de un «Cargando cupones...» suelto en --tinta-tenue.
          <div className="cupones__grilla" aria-busy="true">
            <span className="nxt-solo-lectores" role="status">{en ? "Loading coupons…" : "Cargando cupones…"}</span>
            {[0, 1].map(i => (
              <div key={i} className="cupon" aria-hidden="true">
                <span className="esqueleto cupon__esq-comercio" />
                <span className="esqueleto cupon__esq-oferta" />
                <span className="esqueleto cupon__esq-codigo" />
                <span className="esqueleto cupon__esq-pie" />
              </div>
            ))}
          </div>
        ) : cupones.length === 0 ? (
          <div className="cupones__vacio">
            <div style={{ marginBottom: 12, color: C.border, display: "flex", justifyContent: "center" }}>
              <Ico name="ico-tarjeta" size={40} />
            </div>
            <div style={{ fontSize: 16, fontWeight: 600, color: C.black, marginBottom: 8 }}>
              {en ? "You don't have coupons yet" : "Todavía no tienes cupones"}
            </div>
            <div style={{ fontSize: 14, color: C.muted, marginBottom: 24 }}>
              {en ? "Activate your first benefit from the catalog" : "Activa tu primer beneficio desde el catálogo"}
            </div>
            <button style={{ ...S.btnPrimary, width: "auto", padding: "12px 28px" }} onClick={() => navigate("/")}>
              {en ? "See Benefits" : "Ver Beneficios"}
            </button>
          </div>
        ) : lista.length === 0 ? (
          // Hay cupones, pero ninguno en esta pestaña. Se dice cuál está vacía —
          // no se manda al catálogo a quien ya tiene beneficios activos.
          <div className="cupones__vacio">
            <div style={{ fontSize: 15, color: C.gray }}>
              {filtro === "activos" && (en ? "No active coupons right now." : "Ningún cupón activo por ahora.")}
              {filtro === "redimidos" && (en ? "You haven't redeemed any coupons yet." : "Todavía no has canjeado ningún cupón.")}
              {filtro === "vencidos" && (en ? "No expired coupons." : "Ningún cupón vencido.")}
            </div>
          </div>
        ) : (
          <div className="cupones__grilla">
            {lista.map((c, i) => <CouponCard key={c._id || i} coupon={c} />)}
          </div>
        )}
        </div>
      </div>

      <Pie />
    </div>
  );
}

// ============================================
// PAGE: ACCOUNT
// ============================================
// s252 · `socio-entra-con-tarjeta` (Ali, 02/11: «lo que sí tiene que desaparecer por completo son los planes viejos»):
// los planes VIP de 6, 12 y 24 meses ya no se venden en ninguna pantalla. Apaga «Actualizar a VIP» y «Renovar
// membresía» en Mi Cuenta, la oferta de 6 meses al activar un cupón (enganche del aliado), el precio tachado de
// /i/:codigo y la página /join/:token, que ahora lleva a /viajes. Stripe y los WF no se tocan. Para volver: true.
const PLANES_VIP_VIEJOS = false;

// ============ VIP PLANS MODAL (DECISIÓN-A / D74) ============
// Planes data-driven desde MembershipPlan + preview de código de descuento (validate_discount_code).
// El precio con descuento se computa en el front solo para mostrar; el cobro real lo recomputa
// server-side FIX-9 (lección 8.4). El pago in-app real depende de FIX-9 → botón = stub por ahora.
function VipPlansModal({ lang, onClose }) {
  const en = lang === "en";
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState("");
  const [discountPct, setDiscountPct] = useState(0);
  const [discountMode, setDiscountMode] = useState("percent"); // "percent" | "fixed_price"
  const [fixedPrice, setFixedPrice] = useState(0);
  const [codeMsg, setCodeMsg] = useState("");
  const [codeOk, setCodeOk] = useState(false);
  const [applying, setApplying] = useState(false);
  const [payPlan, setPayPlan] = useState(null); // { id, label, final } del plan elegido
  const [done, setDone] = useState(false);
  useEscapeToClose(true, onClose);

  useEffect(() => {
    getMembershipPlans({ activeOnly: true })
      .then((p) => setPlans(p || []))
      .catch(() => setPlans([]))
      .finally(() => setLoading(false));
  }, []);

  const applyCode = async () => {
    const c = code.trim();
    if (!c || plans.length === 0) return;
    setApplying(true); setCodeMsg(""); setCodeOk(false);
    try {
      // el % del código es independiente del plan → validamos contra cualquiera para obtener discount_percent
      const r = await validateDiscountCode({ plan_id: plans[0]._id, code: c });
      const pct = Number(r.discount_percent) || 0;
      const fp = Number(r.fixed_price) || 0;
      const isFixed = r.discount_mode === "fixed_price" || (r.discount_mode == null && fp > 0);
      setDiscountPct(pct);
      setDiscountMode(isFixed ? "fixed_price" : "percent");
      setFixedPrice(fp);
      setCodeOk(true);
      if (isFixed) {
        setCodeMsg(en ? `Code applied — fixed price $${fp.toFixed(2)}` : `Código aplicado — precio fijo $${fp.toFixed(2)}`);
      } else {
        setCodeMsg(en ? `Code applied — ${pct}% off` : `Código aplicado — ${pct}% de descuento`);
      }
    } catch (e) {
      setDiscountPct(0); setDiscountMode("percent"); setFixedPrice(0); setCodeOk(false);
      const map = {
        CODE_NOT_FOUND: en ? "Code not found" : "Código no encontrado",
        CODE_INACTIVE: en ? "Code inactive" : "Código inactivo",
        CODE_USED: en ? "Code already used" : "Código ya usado",
        CODE_EXPIRED: en ? "Code expired" : "Código vencido",
      };
      setCodeMsg(map[e.code] || (en ? "Invalid code" : "Código inválido"));
    } finally { setApplying(false); }
  };

  // FIX-9a: compra in-app real. discount_code va solo si hay uno aplicado (codeOk).
  const appliedCode = codeOk && code.trim() ? code.trim() : "";

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div role="dialog" aria-modal="true" aria-label={en ? "VIP plans" : "Planes VIP"} onClick={(e) => e.stopPropagation()} style={{ background: C.white, borderRadius: 16, maxWidth: 460, width: "100%", maxHeight: "90vh", overflowY: "auto", padding: "24px 20px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <div style={{ ...S.display, fontSize: 26, color: C.red }}>{en ? "GO VIP" : "HAZTE VIP"}</div>
          <button onClick={onClose} style={{ background: "none", border: "none", fontSize: 24, color: C.muted, cursor: "pointer", lineHeight: 1 }}>×</button>
        </div>
        <div style={{ fontSize: 13, color: C.gray, marginBottom: 18 }}>
          {en ? "Unlimited coupons, $0 activation per coupon, coverage for you + 1 companion." : "Cupones ilimitados, activación $0 por cupón, cobertura para ti + 1 acompañante."}
        </div>

        {loading ? (
          <div style={{ textAlign: "center", padding: 30, color: C.muted, fontSize: 14 }}>{en ? "Loading plans…" : "Cargando planes…"}</div>
        ) : plans.length === 0 ? (
          <div style={{ textAlign: "center", padding: 30, color: C.muted, fontSize: 14 }}>{en ? "Plans are not available right now." : "Los planes no están disponibles por ahora."}</div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {plans.map((p) => {
              const base = Number(p.price_usd) || 0;
              const final = discountMode === "fixed_price" ? fixedPrice : computeMembershipPrice(base, discountPct);
              const months = Number(p.duration_months) || 0;
              const perMonth = months ? final / months : 0;
              const isFeatured = p.featured === true || p.featured === "yes";
              return (
                <div key={p._id} style={{ border: `2px solid ${isFeatured ? C.red : C.border}`, borderRadius: 12, padding: "16px 18px", position: "relative", background: isFeatured ? "var(--accion-tinte)" : C.white }}>
                  {isFeatured && <div style={{ position: "absolute", top: -10, right: 14, background: C.red, color: C.white, fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", padding: "3px 10px", borderRadius: 20 }}>{en ? "BEST VALUE" : "MEJOR VALOR"}</div>}
                  <div style={{ fontSize: 15, fontWeight: 700, color: C.black, marginBottom: 6 }}>{p.label || `VIP ${months}m`}</div>
                  <div style={{ display: "flex", alignItems: "baseline", gap: 8 }}>
                    {codeOk && final < base && (
                      <span style={{ fontSize: 14, color: C.muted, textDecoration: "line-through" }}>${base.toFixed(2)}</span>
                    )}
                    <span style={{ ...S.display, fontSize: 30, color: isFeatured ? C.red : C.black }}>${final.toFixed(2)}</span>
                  </div>
                  {perMonth > 0 && <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>${perMonth.toFixed(2)}/{en ? "mo" : "mes"} · {months} {en ? "months" : "meses"}</div>}
                  <button onClick={() => setPayPlan({ id: p._id, label: p.label || `VIP ${months}m`, final })} style={{ ...S.btnPrimary, marginTop: 12, padding: "11px", fontSize: 13, background: isFeatured ? C.red : C.black }}>
                    {en ? "Choose plan" : "Elegir plan"}
                  </button>
                </div>
              );
            })}

            {/* Código de descuento */}
            <div style={{ marginTop: 4, padding: "14px 16px", background: C.light, borderRadius: 10 }}>
              <div style={{ fontSize: 11, color: C.muted, letterSpacing: "0.1em", marginBottom: 8 }}>{en ? "DISCOUNT CODE" : "CÓDIGO DE DESCUENTO"}</div>
              <div style={{ display: "flex", gap: 8 }}>
                <input value={code} onChange={(e) => setCode(e.target.value)} placeholder={en ? "Enter code" : "Ingresa el código"} style={{ flex: 1, padding: "10px 12px", border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, fontFamily: "'DM Sans', sans-serif", boxSizing: "border-box" }} />
                <button onClick={applyCode} disabled={applying || !code.trim()} style={{ ...S.btnSecondary, width: "auto", padding: "10px 18px", fontSize: 13, opacity: applying || !code.trim() ? 0.6 : 1 }}>
                  {applying ? "…" : (en ? "Apply" : "Aplicar")}
                </button>
              </div>
              {codeMsg && <div style={{ fontSize: 12, marginTop: 8, color: codeOk ? "var(--exito)" : C.red, fontWeight: 500 }}>{codeMsg}</div>}
            </div>

            <div style={{ fontSize: 10, color: C.muted, textAlign: "center", marginTop: 2 }}>
              {en ? "Membership includes $0 coupon activations." : "La membresía incluye activaciones de cupones a $0."}
            </div>
          </div>
        )}

        {payPlan && !done && (
          <MembershipPaymentModal
            planId={payPlan.id}
            planLabel={payPlan.label}
            finalPrice={payPlan.final}
            discountCode={appliedCode}
            discountMode={discountMode}
            lang={lang}
            onCancel={() => setPayPlan(null)}
            onSuccess={() => { setDone(true); setPayPlan(null); }}
          />
        )}
      </div>

      {done && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div role="dialog" aria-modal="true" aria-label={en ? "You are VIP" : "Ya eres VIP"} style={{ background: C.white, borderRadius: 16, maxWidth: 380, width: "100%", padding: "32px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 8 }}>🎉</div>
            <div style={{ ...S.display, fontSize: 22, color: C.red, marginBottom: 6 }}>{en ? "You're VIP!" : "¡Ya eres VIP!"}</div>
            <div style={{ fontSize: 13, color: C.gray, marginBottom: 18 }}>{en ? "Your membership is active. Enjoy unlimited coupons." : "Tu membresía está activa. Disfruta cupones ilimitados."}</div>
            <button onClick={onClose} style={{ ...S.btnPrimary, width: "100%", padding: "14px" }}>{en ? "Done" : "Listo"}</button>
          </div>
        </div>
      )}
    </div>
  );
}

// ============================================
// PAGE: PRIVATE MEMBERSHIP (invite link, NOT in public nav)
// ============================================
// Acceso por link de invitación (§2 discount_engine): la página de planes NO se
// expone públicamente (choca con el flujo 1888). La operadora/admin pasa el link
// + el código por fuera. Gateada por login (ProtectedRoute → /login si no hay sesión).
// El `token` del link es el gate de "no público" v1 (no se valida server-side todavía;
// si más adelante se quiere validar/atribuir, se cablea acá).
function MembershipJoinPage() {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  const { token } = useParams(); // eslint-disable-line no-unused-vars
  if (!PLANES_VIP_VIEJOS) return <Navigate to="/viajes" replace />;   // s252 · un enlace /join/ ya mandado no se rompe
  return (
    <div style={{ ...S.page, minHeight: "100vh", background: C.light }}>
      <Navbar activePage="account" />
      <div style={{ maxWidth: 480, margin: "0 auto", padding: "56px 20px 0", textAlign: "center" }}>
        <Logo size="md" />
        <div style={{ ...S.display, fontSize: 26, color: C.black, margin: "20px 0 8px" }}>{en ? "YOU'RE INVITED" : "ESTÁS INVITADO/A"}</div>
        <div style={{ fontSize: 14, color: C.muted }}>{en ? "Choose your membership and apply your invite code." : "Elige tu membresía y aplica tu código de invitación."}</div>
      </div>
      <VipPlansModal lang={lang} onClose={() => navigate("/account")} />
    </div>
  );
}

// s202 · `tarjeta-socio-v1` — LA TARJETA DE SOCIO. Hasta hoy el socio no tenia nada que
// dijera «soy de NXT»: un circulo con iniciales y una pildora. Los datos ya llegaban de
// get_user_profile (member_number, member_since) y nadie los usaba. Ali eligio entre tres
// versiones (rama s202-tarjeta-variantes): dos tonos + el brillo de la «Club».
// Sin numero de socio no se inventa uno: la celda no se dibuja.
// Formato de la SINTESIS Offline s193 §3.3 (Ali lo confirmo el 22/09): «#0001 · Miami».
const numeroSocio = (n) => { const v = Number(n); return v > 0 ? `#${String(Math.round(v)).padStart(4, "0")} · Miami` : ""; };
const fechaSocio = (iso, en, opciones) => {
  const d = iso ? new Date(iso) : null;
  return d && !isNaN(d.getTime()) ? d.toLocaleDateString(en ? "en-US" : "es-US", opciones) : "";
};

function TarjetaSocio({ name, tier, memberNumber, memberSince, vipExpires, vencida, en }) {
  const vip = tier === "VIP";
  const numero = numeroSocio(memberNumber);
  const desde = fechaSocio(memberSince, en, { month: "short", year: "numeric" });
  const vence = vip ? fechaSocio(vipExpires, en, { day: "numeric", month: "short", year: "numeric" }) : "";
  return (
    <section className={`tsocio${vip ? " tsocio--vip" : ""}`} aria-label={en ? "Member card" : "Tarjeta de miembro"}>
      <div className="tsocio__banda">
        <span className="tsocio__brillo" aria-hidden="true" />
        <div className="tsocio__cabeza">
          <Logo size="sm" tono="oscuro" />
          {tier && <span className="tsocio__nivel">{tier}</span>}
        </div>
        <span className="tsocio__nombre">{name}</span>
      </div>
      <div className="tsocio__abajo">
        {numero && (
          <div className="tsocio__socio">
            <span className="tsocio__rotulo">{en ? "Member" : "Socio"}</span>
            <span className="tsocio__numero">{numero}</span>
          </div>
        )}
        {desde && (
          <div>
            <span className="tsocio__rotulo">{en ? "Since" : "Desde"}</span>
            <span className="tsocio__dato">{desde}</span>
          </div>
        )}
        {vence && (
          <div>
            <span className="tsocio__rotulo">{vencida ? (en ? "Expired" : "Venció") : (en ? "Expires" : "Vence")}</span>
            <span className={`tsocio__dato${vencida ? " tsocio__dato--vencido" : ""}`}>{vence}</span>
          </div>
        )}
      </div>
    </section>
  );
}

// s202 · `cambiar-clave-en-la-app` — CAMBIAR LA CONTRASEÑA SIN SALIR DE LA APP.
// Hasta hoy la unica via era «¿Olvidaste tu contraseña?» (un correo), tambien para quien
// SI la sabe. `change_password` existia en Bubble sin ningun boton. Sirve al socio (en
// «Mi cuenta») y al comercio (en su perfil). Cerrado es el mismo boton de siempre.
// Quien entra con Google no tiene una contraseña que conozca: para eso queda el enlace
// al correo de siempre, dicho con ese ejemplo.
function CambiarClave({ en }) {
  const [abierto, setAbierto] = useState(false);
  const [actual, setActual] = useState("");
  const [nueva, setNueva] = useState("");
  const [repetida, setRepetida] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");
  const [listo, setListo] = useState(false);

  const cerrar = () => { setActual(""); setNueva(""); setRepetida(""); setError(""); setAbierto(false); };
  const guardar = async (e) => {
    e.preventDefault();
    if (!actual || !nueva || !repetida) { setError(en ? "Fill in the three fields." : "Completa los tres campos."); return; }
    if (nueva.length < MIN_CLAVE) { setError(en ? `The new password needs at least ${MIN_CLAVE} characters.` : `La nueva contraseña debe tener al menos ${MIN_CLAVE} caracteres.`); return; }
    if (nueva !== repetida) { setError(en ? "The two new passwords don't match." : "Las dos contraseñas nuevas no coinciden."); return; }
    if (nueva === actual) { setError(en ? "The new password is the same as the current one." : "La nueva contraseña es igual a la actual."); return; }
    setEnviando(true); setError("");
    try {
      await cambiarClave(actual, nueva);
      cerrar();
      setListo(true);
    } catch (err) {
      const c = err?.code;
      setError(
        c === "WRONG_PASSWORD" ? (en ? "Your current password isn't right." : "La contraseña actual no es correcta.")
        : c === "WEAK_PASSWORD" ? (en ? `The new password needs at least ${MIN_CLAVE} characters.` : `La nueva contraseña debe tener al menos ${MIN_CLAVE} caracteres.`)
        : c === "NO_SESSION" ? (en ? "Your session expired. Sign in again." : "Tu sesión venció. Entra de nuevo.")
        : (en ? "We couldn't change it. Try again." : "No se pudo cambiar. Prueba otra vez."));
    } finally {
      setEnviando(false);
    }
  };

  const botonSecundario = { width: "100%", padding: "13px", background: C.white, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, fontWeight: 600, color: C.gray, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" };

  if (!abierto) {
    return (
      <div>
        {listo && (
          <div role="status" style={{ marginBottom: 10, padding: "10px 12px", borderRadius: 8, background: "var(--exito-tinte)", color: "var(--exito)", fontSize: 13, fontWeight: 600 }}>
            {en ? "Done: your password changed." : "Listo: tu contraseña cambió."}
          </div>
        )}
        <button type="button" onClick={() => { setAbierto(true); setListo(false); }} style={botonSecundario}>
          🔒 {en ? "Change password" : "Cambiar contraseña"}
        </button>
      </div>
    );
  }

  const campo = (id, rotulo, valor, setValor, autoComplete, pista) => (
    <div className="alta-campo">
      <label className="alta-etiqueta" htmlFor={id}>{rotulo}</label>
      <input id={id} type="password" className="alta-input" value={valor} autoComplete={autoComplete}
        onChange={e => { setValor(e.target.value); setError(""); }} />
      {pista && <div className="alta-ayuda">{pista}</div>}
    </div>
  );
  return (
    <form onSubmit={guardar} noValidate style={{ display: "grid", gap: 14 }}>
      {campo("clave-actual", en ? "Current password" : "Contraseña actual", actual, setActual, "current-password")}
      {campo("clave-nueva", en ? "New password" : "Contraseña nueva", nueva, setNueva, "new-password", en ? `At least ${MIN_CLAVE} characters.` : `Al menos ${MIN_CLAVE} caracteres.`)}
      {campo("clave-repetida", en ? "Repeat the new password" : "Repite la contraseña nueva", repetida, setRepetida, "new-password")}
      {error && <div className="alta-aviso alta-aviso--error" role="alert">{error}</div>}
      <div style={{ display: "flex", gap: 10 }}>
        <button type="button" onClick={cerrar} disabled={enviando} style={{ ...botonSecundario, flex: 1, width: "auto" }}>
          {en ? "Cancel" : "Cancelar"}
        </button>
        <button type="submit" disabled={enviando} style={{ ...S.btnPrimary, flex: 1, width: "auto", padding: "13px", fontSize: 13, opacity: enviando ? 0.7 : 1 }}>
          {enviando ? "…" : (en ? "Save password" : "Guardar contraseña")}
        </button>
      </div>
      <p className="alta-ayuda" style={{ margin: 0 }}>
        {en ? "Don't know your current password — for example, if you sign in with Google? " : "¿No sabes tu contraseña actual, por ejemplo porque entras con Google? "}
        <Link to="/forgot-password" style={{ color: "var(--accion)", fontWeight: 600 }}>
          {en ? "We'll email you a link to create a new one." : "Te mandamos un correo para crear una nueva."}
        </Link>
      </p>
    </form>
  );
}

// s202 · «MI LISTA» (favoritos-miembro, F1-F3 de s156). Las ofertas con la misma tarjeta y
// la misma grilla del catalogo; los comercios, una fila cada uno. Lo guardado que ya no
// esta en el catalogo queda como una linea con su motivo (F3): no se puede mostrar su
// titulo porque el socio no puede leer una oferta que no este aprobada. «No disponible
// ahora» y no «ya no existe»: una oferta pausada («hoy estamos llenos») tambien sale del
// catalogo, y vuelve.
function MiListaPage() {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  const { ofertas, comercios, cargando, alternar } = useGuardados();
  const [catalogo, setCatalogo] = useState(null);
  const [directorio, setDirectorio] = useState(null);
  const [quitando, setQuitando] = useState("");

  useEffect(() => {
    let vivo = true;
    const norm = (u) => (u && String(u).startsWith("//")) ? "https:" + u : u;
    getOffers(null).then(o => { if (vivo) setCatalogo(Array.isArray(o) ? o : []); })
      .catch(() => { if (vivo) setCatalogo([]); });
    getPublicMerchants().then(l => {
      if (!vivo) return;
      setDirectorio((l || []).map(m => ({ ...m, logo: norm(m.logo), gallery: Array.isArray(m.gallery) ? m.gallery.map(norm) : [] })));
    }).catch(() => { if (vivo) setDirectorio([]); });
    return () => { vivo = false; };
  }, []);

  const listo = !cargando && catalogo !== null && directorio !== null;
  const hay = (lista, id) => lista.some(x => String(x._id) === id);
  const ofertasVivas = listo ? catalogo.filter(o => ofertas.has(String(o._id))) : [];
  const ofertasIdas = listo ? [...ofertas].filter(id => !hay(catalogo, id)) : [];
  const comerciosVivos = listo ? directorio.filter(m => comercios.has(String(m._id))) : [];
  const comerciosIdos = listo ? [...comercios].filter(id => !hay(directorio, id)) : [];
  const total = ofertas.size + comercios.size;

  const quitarTodos = async (tipo, ids) => {
    setQuitando(tipo);
    for (const id of ids) await alternar(tipo, id);   // de a uno: el WF guarda o quita uno por llamada
    setQuitando("");
  };
  const plural = (n, uno, varios) => (n === 1 ? uno : varios);

  return (
    <div style={S.page}>
      <Navbar activePage="list" />
      <div className="milista">
        <h1 className="milista__titulo">{en ? "My list" : "Mi lista"}</h1>
        <p className="milista__bajada">{en ? "What you saved to come back to." : "Lo que guardaste para volver."}</p>

        {!listo && <p className="milista__bajada">{en ? "Loading…" : "Cargando…"}</p>}

        {listo && total === 0 && (
          <div className="milista__vacia">
            <p className="milista__vacia-titulo">{en ? "You haven't saved anything yet" : "Todavía no has guardado nada"}</p>
            <p className="milista__vacia-texto">
              {en ? "Tap Save on an offer or on a business's page and it shows up here."
                  : "Toca Guardar en una oferta o en la página de un comercio y aparece aquí."}
            </p>
            <button type="button" style={{ ...S.btnPrimary, width: "auto", padding: "12px 24px" }} onClick={() => navigate("/")}>
              {en ? "See the benefits" : "Ver los beneficios"}
            </button>
          </div>
        )}

        {listo && ofertas.size > 0 && (
          <section className="milista__seccion" aria-labelledby="milista-ofertas">
            <h2 id="milista-ofertas" className="milista__subtitulo">
              {en ? "Offers" : "Ofertas"} <span className="milista__cuenta">({ofertas.size})</span>
            </h2>
            {ofertasVivas.length > 0 && <ResponsiveGrid offers={ofertasVivas} navigate={navigate} />}
            {ofertasIdas.length > 0 && (
              <div className="milista__ido">
                <span>
                  {en
                    ? `${ofertasIdas.length} ${plural(ofertasIdas.length, "offer you saved isn't", "offers you saved aren't")} available right now.`
                    : `${ofertasIdas.length} ${plural(ofertasIdas.length, "oferta que guardaste no está disponible", "ofertas que guardaste no están disponibles")} ahora.`}
                </span>
                <button type="button" className="milista__boton-texto" disabled={quitando === "offer"}
                  onClick={() => quitarTodos("offer", ofertasIdas)}>
                  {quitando === "offer" ? "…" : (en ? "Remove from my list" : "Quitar de mi lista")}
                </button>
              </div>
            )}
          </section>
        )}

        {listo && comercios.size > 0 && (
          <section className="milista__seccion" aria-labelledby="milista-comercios">
            <h2 id="milista-comercios" className="milista__subtitulo">
              {en ? "Businesses" : "Comercios"} <span className="milista__cuenta">({comercios.size})</span>
            </h2>
            <ul className="milista__comercios">
              {comerciosVivos.map(m => {
                const foto = m.gallery[0] || m.logo || "";
                const zona = m.neighborhood || m.zone || m.city || "";
                return (
                  <li key={m._id} className="milista__comercio">
                    <Link to={`/m/${m._id}`} className="milista__comercio-enlace">
                      {foto ? <img src={foto} alt="" loading="lazy" className="milista__comercio-foto" />
                            : <span className="milista__comercio-foto" aria-hidden="true" />}
                      <span style={{ minWidth: 0 }}>
                        <span className="milista__comercio-nombre">{m.business_name}</span>
                        {zona && <span className="milista__comercio-zona">{zona}</span>}
                      </span>
                    </Link>
                    <BotonGuardar tipo="merchant" id={m._id} className="milista__guardar" tamano={22} en={en} />
                  </li>
                );
              })}
            </ul>
            {comerciosIdos.length > 0 && (
              <div className="milista__ido">
                <span>
                  {en
                    ? `${comerciosIdos.length} ${plural(comerciosIdos.length, "business you saved isn't", "businesses you saved aren't")} in the club right now.`
                    : `${comerciosIdos.length} ${plural(comerciosIdos.length, "comercio que guardaste no está", "comercios que guardaste no están")} en el club ahora.`}
                </span>
                <button type="button" className="milista__boton-texto" disabled={quitando === "merchant"}
                  onClick={() => quitarTodos("merchant", comerciosIdos)}>
                  {quitando === "merchant" ? "…" : (en ? "Remove from my list" : "Quitar de mi lista")}
                </button>
              </div>
            )}
          </section>
        )}
      </div>
    </div>
  );
}

function AccountPage() {
  const navigate = useNavigate();
  const lang = useLang();
  const cambiarIdioma = useSetLang();
  const [profile, setProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [editName, setEditName] = useState("");
  const [editCompanion, setEditCompanion] = useState("");
  const [editLang, setEditLang] = useState("es");
  const [saving, setSaving] = useState(false);
  const [saveMsg, setSaveMsg] = useState("");
  // Payment methods
  const [cards, setCards] = useState([]);
  const [loadingCards, setLoadingCards] = useState(false);
  const [showAddCard, setShowAddCard] = useState(false);
  const [addingCard, setAddingCard] = useState(false);
  const [cardError, setCardError] = useState("");
  // Section collapse
  const [openSection, setOpenSection] = useState("account");
  // VIP plans modal (DECISIÓN-A / D74)
  const [showVipModal, setShowVipModal] = useState(false);
  // s184 - el ahorro sale del mismo contexto que alimenta la franja (suma de
  // `benefit_value_usd` de los canjes), y el pago de la fila propia del usuario.
  const { cupones, ahorro } = useCupones();
  const guardados = useGuardados();   // s202 · la fila «Mi lista» (en telefono no hay franja)
  const [pagoMembresia, setPagoMembresia] = useState(null);

  useEffect(() => {
    if (!auth.isLoggedIn()) { navigate("/login"); return; }
    getUserProfile().then(p => {
      setProfile(p);
      setEditName(p?.name || "");
      setEditCompanion(p?.beneficiary2_name || "");
      setEditLang(p?.preferred_language || "es");
      setLoadingProfile(false);
      // Load saved cards if stripe_customer_id exists
      if (p?.stripe_customer_id) {
        loadPaymentMethods(p.stripe_customer_id);
      }
    }).catch(() => setLoadingProfile(false));
    getPagoDeMembresia().then(setPagoMembresia).catch(() => {});
  }, [navigate]);

  const loadPaymentMethods = async (customerId) => {
    setLoadingCards(true);
    try {
      const token = localStorage.getItem("nxt_token");
      const res = await fetch(`${API_BASE}/wf/get_payment_methods`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        // Body vacío: el workflow get_payment_methods reescrito (v10) usa
        // Current User, no params. El customer_id es ignorado por Bubble.
      });
      const data = await res.json();
      // Bubble Arbitrary text serializa el array como STRING JSON.
      // Hay que parsear antes de pasarlo al state. (Ver REFERENCIAS §11
      // sobre Bubble Structured JSON flat-friendly, nested-hostile.)
      if (data?.response?.cards) {
        try {
          setCards(JSON.parse(data.response.cards));
        } catch (parseErr) {
          console.error("Error parsing cards JSON:", parseErr, data.response.cards);
          setCards([]);
        }
      }
    } catch (e) { console.log("No payment methods endpoint yet"); }
    finally { setLoadingCards(false); }
  };

  const handleSaveProfile = async () => {
    setSaving(true); setSaveMsg("");
    try {
      await updateUserProfile({
        name: editName,
        beneficiary2_name: editCompanion,
        preferred_language: editLang,
      });
      setProfile(p => ({ ...p, name: editName, beneficiary2_name: editCompanion, preferred_language: editLang }));
      // s183 · el idioma elegido acá ahora TAMBIÉN cambia la interfaz. Hasta hoy este
      // selector guardaba `preferred_language` en el perfil y la app seguía en el
      // idioma anterior: eran dos interruptores para lo mismo y ninguno movía al otro.
      // Importa sobre todo en teléfono, donde no hay franja superior y este es el
      // único lugar donde se puede cambiar.
      cambiarIdioma(editLang);
      setEditMode(false);
      setSaveMsg(lang === "en" ? "Profile updated!" : "¡Perfil actualizado!");
      setTimeout(() => setSaveMsg(""), 3000);
    } catch (e) { setSaveMsg(lang === "en" ? "Error saving" : "Error al guardar"); }
    finally { setSaving(false); }
  };

  const handleDeleteCard = async (cardId) => {
    if (!window.confirm(lang === "en" ? "Remove this card?" : "¿Eliminar esta tarjeta?")) return;
    setCardError("");
    try {
      await deletePaymentMethod(cardId);
      setCards(c => c.filter(card => card.id !== cardId));
    } catch (e) {
      setCardError(lang === "en" ? "Could not remove the card" : "No se pudo eliminar la tarjeta");
    }
  };

  const handleLogout = () => { auth.clear(); navigate("/login"); };

  if (loadingProfile) return (
    <div style={S.page}>
      <div style={{ padding: 60, textAlign: "center", color: C.muted }}>{lang === "en" ? "Loading..." : "Cargando..."}</div>
      {/* el hueco que la barra fija de teléfono le tapa al contenido */}
      <Pie />
    </div>
  );

  const name = profile?.name || (lang === "en" ? "Member" : "Miembro");
  // s220 · sin tier NO es VIP. Desde el 124 el alta sin código (correo o Google) queda sin tier, y la
  // tarjeta decía «VIP» por este fallback (visto por Ali en Live, 08/10). Vacío = sin plan.
  const tier = profile?.tier || "";
  // Lo que dice la tarjeta: el tier, o «Fundador en espera» si ya aplicó el código de un aliado y
  // espera el Checkout (codigoGuardadoSinPlan), o nada.
  const etiquetaNivel = tier || (codigoGuardadoSinPlan(profile) ? (lang === "en" ? "Founder, waiting" : "Fundador en espera") : "");
  const email = profile?.email || "";
  // ETAPA-0 (s97): sin fallback a 2 — vacío/0 = prospecto sin cupones otorgados.
  const maxCoupons = Number(profile?.max_coupons ?? 0) || 0;
  const vipMax = profile?.vip_max_active || 5;
  const isBlocked = profile?.is_blocked || false;
  const liteUsed = profile?.lite_activations_used || 0;
  const isVIP = tier === "VIP";
  const hasCompanion = profile?.has_companion || false;
  const companion = profile?.beneficiary2_name || "";
  const vipExpires = profile?.vip_expires_at;
  // s183 · dato REAL para el recuadro del medio, que antes mostraba un 90 inventado.
  // Solo se calcula si hay fecha de vencimiento y todavia no paso; si no, es null y
  // el recuadro no se dibuja (nada de rellenar con un numero de adorno).
  const diasDeMembresia = (() => {
    if (!vipExpires) return null;
    const t = new Date(vipExpires).getTime();
    if (!isFinite(t)) return null;
    const dias = Math.ceil((t - Date.now()) / 86400000);
    return dias > 0 ? dias : null;
  })();
  // Membresía vencida: VIP con vip_expires_at en el pasado (DECISIÓN-A — el usuario "no queda mudo")
  const vipExpired = isVIP && vipExpires && new Date(vipExpires).getTime() < Date.now();

  const inputStyle = { width: "100%", padding: "12px 14px", border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 14, fontFamily: "'DM Sans', sans-serif", background: C.white, boxSizing: "border-box" };
  const sectionHeaderStyle = (section) => ({
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: "16px 20px", cursor: "pointer", background: C.white,
    borderBottom: openSection === section ? `1px solid ${C.border}` : "none",
  });

  const cardBrandIcon = (brand) => {
    const brands = { visa: "💳 Visa", mastercard: "💳 Mastercard", amex: "💳 Amex", discover: "💳 Discover" };
    return brands[brand?.toLowerCase()] || "💳 " + (brand || "Card");
  };

  return (
    <div style={S.page}>
      <Navbar activePage="account" />
      {showVipModal && <VipPlansModal lang={lang} onClose={() => setShowVipModal(false)} />}
      {/* s202 · la tarjeta de socio (reemplaza al circulo con iniciales y la pildora). El
          ahorro va debajo con la regla de Mis Cupones (CLAIMS §2): solo si hay canjes con
          cifra, nunca un «$0» de relleno. */}
      <div style={{ background: C.white, borderBottom: `1px solid ${C.border}`, padding: "24px 20px" }}>
        <div className="tsocio-cuenta" style={{ maxWidth: 600, margin: "0 auto" }}>
          <TarjetaSocio name={name} tier={etiquetaNivel} memberNumber={profile?.member_number} memberSince={profile?.member_since}
            vipExpires={vipExpires} vencida={vipExpired} en={lang === "en"} />
          {email && <div className="tsocio-cuenta__correo">{email}</div>}
          {ahorro > 0 && (() => {
            const canjes = cupones.filter(c => String(c.status || "").toLowerCase() === "redeemed").length;
            return lang === "en"
              ? <p className="tsocio-cuenta__ahorro">You've saved <strong>${fmtUsd(ahorro)}</strong> in {canjes} {canjes === 1 ? "redemption" : "redemptions"}</p>
              : <p className="tsocio-cuenta__ahorro">Llevas <strong>${fmtUsd(ahorro)}</strong> ahorrados en {canjes} {canjes === 1 ? "canje" : "canjes"}</p>;
          })()}
          {isBlocked && <div style={{ fontSize: 12, color: C.red, fontWeight: 500 }}>⚠️ {lang === "en" ? "Account suspended" : "Cuenta suspendida"}</div>}
          {saveMsg && <div style={{ fontSize: 12, color: "var(--exito)", fontWeight: 500 }}>{saveMsg}</div>}
        </div>
      </div>

      <div style={{ maxWidth: 600, margin: "0 auto", padding: "16px 20px 100px" }}>

        {/* s220 · «MI PANEL DE ALIADO» (nombre de Ali). El aliado es un miembro con un panel
            extra: llega desde aquí, no lo mandan directo al entrar. Solo con rol Influencer. */}
        {profile?.role === "Influencer" && (
          <button type="button" onClick={() => navigate("/aliados")}
            style={{ ...S.card, width: "100%", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", cursor: "pointer", background: C.white, fontFamily: "'DM Sans', sans-serif", textAlign: "left" }}>
            <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <Ico name="ico-personas" size={18} />
              <span style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{lang === "en" ? "My partner panel" : "Mi panel de aliado"}</span>
            </span>
            <span style={{ fontSize: 13, color: C.muted }}>›</span>
          </button>
        )}

        {/* s202 · «MI LISTA». En escritorio vive en la franja de arriba; en telefono la franja
            no existe, y la cuenta es donde la SINTESIS s193 §3.5 pone los «Guardados». */}
        <button type="button" onClick={() => navigate("/mi-lista")}
          style={{ ...S.card, width: "100%", marginBottom: 12, display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 20px", cursor: "pointer", background: C.white, fontFamily: "'DM Sans', sans-serif", textAlign: "left" }}>
          <span style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Ico name="ico-guardar" size={18} />
            <span style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{lang === "en" ? "My list" : "Mi lista"}</span>
          </span>
          <span style={{ fontSize: 13, color: C.muted }}>
            {(() => { const n = guardados.ofertas.size + guardados.comercios.size;
              return lang === "en" ? `${n} saved ›` : `${n} ${n === 1 ? "guardado" : "guardados"} ›`; })()}
          </span>
        </button>

        {/* ============ SECTION 1: MY ACCOUNT ============ */}
        <div style={{ ...S.card, marginBottom: 12, overflow: "hidden" }}>
          <div style={sectionHeaderStyle("account")} onClick={() => setOpenSection(openSection === "account" ? "" : "account")}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18 }}>👤</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{lang === "en" ? "My Account" : "Mi Cuenta"}</span>
            </div>
            <span style={{ fontSize: 14, color: C.muted, transform: openSection === "account" ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>▼</span>
          </div>
          {openSection === "account" && (
            <div style={{ padding: "16px 20px" }}>
              {!editMode ? (
                <div>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                    <div style={{ fontSize: 12, color: C.muted, letterSpacing: "0.1em" }}>{lang === "en" ? "PERSONAL INFO" : "INFORMACIÓN PERSONAL"}</div>
                    <button onClick={() => setEditMode(true)} style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 6, padding: "4px 12px", fontSize: 12, color: C.gray, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
                      ✏️ {lang === "en" ? "Edit" : "Editar"}
                    </button>
                  </div>
                  {[
                    { label: lang === "en" ? "Name" : "Nombre", value: name },
                    { label: "Email", value: email },
                    { label: lang === "en" ? "Language" : "Idioma", value: (profile?.preferred_language || "es") === "es" ? "Español" : "English" },
                    { label: lang === "en" ? "Companion" : "Acompañante", value: companion || (lang === "en" ? "Not set" : "No asignado") },
                  ].map((item, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: i < 3 ? `1px solid ${C.light}` : "none" }}>
                      <span style={{ fontSize: 13, color: C.muted }}>{item.label}</span>
                      <span style={{ fontSize: 13, color: C.black, fontWeight: 500 }}>{item.value}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
                  <div>
                    <label htmlFor="nxt-f56" style={{ display: "block", fontSize: 12, color: C.muted, letterSpacing: "0.1em", marginBottom: 4 }}>{lang === "en" ? "NAME" : "NOMBRE"}</label>
                    <input id="nxt-f56" value={editName} onChange={e => setEditName(e.target.value)} style={inputStyle} />
                  </div>
                  <div>
                    <label htmlFor="nxt-f55" style={{ display: "block", fontSize: 12, color: C.muted, letterSpacing: "0.1em", marginBottom: 4 }}>EMAIL</label>
                    <input id="nxt-f55" autoComplete="email" value={email} disabled style={{ ...inputStyle, background: C.light, color: C.muted }} />
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{lang === "en" ? "Email cannot be changed" : "El email no se puede cambiar"}</div>
                  </div>
                  <div>
                    <label style={{ display: "block", fontSize: 12, color: C.muted, letterSpacing: "0.1em", marginBottom: 4 }}>{lang === "en" ? "PREFERRED LANGUAGE" : "IDIOMA PREFERIDO"}</label>
                    <div style={{ display: "flex", gap: 8 }}>
                      {[{ v: "es", l: "🇪🇸 Español" }, { v: "en", l: "🇺🇸 English" }].map(opt => (
                        <button key={opt.v} onClick={() => setEditLang(opt.v)} style={{ flex: 1, padding: "10px", border: `1px solid ${editLang === opt.v ? C.red : C.border}`, borderRadius: 8, background: editLang === opt.v ? "var(--accion-tinte)" : C.white, color: editLang === opt.v ? C.red : C.gray, fontSize: 13, fontWeight: 500, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
                          {opt.l}
                        </button>
                      ))}
                    </div>
                  </div>
                  <div>
                    <label htmlFor="nxt-f54" style={{ display: "block", fontSize: 12, color: C.muted, letterSpacing: "0.1em", marginBottom: 4 }}>
                      {lang === "en" ? "COMPANION / BENEFICIARY" : "ACOMPAÑANTE / BENEFICIARIO"}
                    </label>
                    <input id="nxt-f54" value={editCompanion} onChange={e => setEditCompanion(e.target.value)} placeholder={lang === "en" ? "Name of your companion" : "Nombre de tu acompañante"} style={inputStyle} />
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{lang === "en" ? "This person can also redeem your coupons" : "Esta persona también puede canjear tus cupones"}</div>
                  </div>
                  <div style={{ display: "flex", gap: 10, marginTop: 4 }}>
                    <button onClick={() => setEditMode(false)} style={{ flex: 1, padding: "12px", background: C.light, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, color: C.gray, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
                      {lang === "en" ? "Cancel" : "Cancelar"}
                    </button>
                    <button onClick={handleSaveProfile} disabled={saving} style={{ ...S.btnPrimary, flex: 1, padding: "12px", fontSize: 13, opacity: saving ? 0.7 : 1 }}>
                      {saving ? "..." : (lang === "en" ? "Save Changes" : "Guardar Cambios")}
                    </button>
                  </div>
                </div>
              )}
              {/* s202 · `cambiar-clave-en-la-app`: el socio no tenia donde cambiarla. */}
              <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px solid ${C.border}` }}>
                <CambiarClave en={lang === "en"} />
              </div>
            </div>
          )}
        </div>

        {/* ============ SECTION 2: MY MEMBERSHIP ============ */}
        <div style={{ ...S.card, marginBottom: 12, overflow: "hidden" }}>
          <div style={sectionHeaderStyle("membership")} onClick={() => setOpenSection(openSection === "membership" ? "" : "membership")}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18 }}>⭐</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{lang === "en" ? "My Membership" : "Mi Membresía"}</span>
            </div>
            <span style={{ fontSize: 14, color: C.muted, transform: openSection === "membership" ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>▼</span>
          </div>
          {openSection === "membership" && (
            <div style={{ padding: "16px 20px" }}>
              {/* Membresía vencida — el usuario no queda mudo (DECISIÓN-A) */}
              {vipExpired && (
                <div style={{ padding: "14px 16px", background: "var(--accion-tinte)", border: `1px solid var(--linea)`, borderRadius: 8, marginBottom: 16 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: C.red, marginBottom: 4 }}>⚠️ {lang === "en" ? "Your membership expired" : "Tu membresía venció"}</div>
                  <div style={{ fontSize: 12, color: C.gray, marginBottom: 10 }}>
                    {lang === "en"
                      ? `It expired on ${new Date(vipExpires).toLocaleDateString()}.${PLANES_VIP_VIEJOS ? " Renew to keep activating coupons." : ""}`
                      : `Venció el ${new Date(vipExpires).toLocaleDateString()}.${PLANES_VIP_VIEJOS ? " Renuévala para seguir activando cupones." : ""}`}
                  </div>
                  {PLANES_VIP_VIEJOS && <button onClick={() => setShowVipModal(true)} style={{ ...S.btnPrimary, width: "100%", padding: "12px", fontSize: 13, fontWeight: 700 }}>
                    {lang === "en" ? "Renew membership" : "Renovar membresía"}
                  </button>}
                </div>
              )}

              {/* s184 - LO QUE TE DEVOLVIO. Va PRIMERO en esta seccion, antes que
                  los contadores de cupones y los dias que quedan: quien entra aca
                  esta preguntandose si la membresia vale lo que paga, y esa
                  pregunta se contesta con una cifra, no con un inventario de
                  limites. Cierra s183-D16.
                  Solo aparece con canjes reales: sin ahorro no se inventa un
                  «llevas ahorrado $0», que ademas seria un reproche (CLAIMS §2). */}
              {ahorro > 0 && (() => {
                const canjes = cupones.filter(c => String(c.status || "").toLowerCase() === "redeemed").length;
                // D16: el payback se muestra solo cuando ya se pagó sola. Por debajo
                // de 1x queda oculto — decirle a alguien que recupero el 40% de lo
                // que pago es informacion correcta y sensacion de mal negocio.
                const sePago = pagoMembresia !== null && ahorro >= pagoMembresia;
                return (
                  <div className="cta-devuelto">
                    <div className="cta-devuelto-rotulo">
                      {lang === "en" ? "What it gave back" : "Lo que te devolvió"}
                    </div>
                    <div className="cta-devuelto-cifra">${fmtUsd(ahorro)}</div>
                    <div className="cta-devuelto-detalle">
                      {lang === "en"
                        ? `saved across ${canjes} visit${canjes === 1 ? "" : "s"}, on menu prices`
                        : `ahorrados en ${canjes} ${canjes === 1 ? "visita" : "visitas"}, sobre precios de carta`}
                    </div>
                    {sePago && (
                      <>
                        <div className="cta-devuelto-payback">
                          {lang === "en"
                            ? "Your membership already paid for itself."
                            : "Tu membresía ya se pagó sola."}
                        </div>
                        {/* Se dice QUE se pagó, no CUANTAS VECES. El multiplo sale de
                            dividir por lo que pago cada uno, y con montos de prueba da
                            cifras absurdas («102 veces») que desprestigian el dato bueno
                            que esta arriba. La cifra que importa ya esta a la vista. */}
                        <div className="cta-devuelto-nota">
                          {lang === "en"
                            ? "Compared with what you paid for it."
                            : "Comparado con lo que pagaste por ella."}
                        </div>
                      </>
                    )}
                  </div>
                );
              })()}

              {/* Tier badge + stats */}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(0, 1fr))", gap: 10, marginBottom: 20 }}>
                <div style={{ textAlign: "center", padding: 12, background: C.light, borderRadius: 8 }}>
                  <div style={{ ...S.display, fontSize: 28, color: isVIP ? C.red : C.valor }}>{isVIP ? vipMax : `${liteUsed}/${maxCoupons}`}</div>
                  <div style={{ fontSize: 12, color: C.muted, letterSpacing: "0.05em", marginTop: 2 }}>{isVIP ? (lang === "en" ? "MAX ACTIVE" : "MÁX ACTIVOS") : (lang === "en" ? "USED" : "USADOS")}</div>
                </div>
                {/* s183 · acá decía «90 · PRÓXIMA VISITA», y ese 90 estaba escrito a
                    mano: no salía de ningún dato. El cooldown NO es una regla del
                    club, lo define cada oferta en `cooldown_days` — si un comercio
                    pone 30, la app le mentía al miembro. En su lugar va un dato que
                    sí existe en el perfil: cuántos días le quedan de membresía. Sin
                    fecha de vencimiento el recuadro no se dibuja, y quedan dos. */}
                {diasDeMembresia !== null && (
                  <div style={{ textAlign: "center", padding: 12, background: C.light, borderRadius: 8 }}>
                    <div style={{ ...S.display, fontSize: 28, color: C.black }}>{diasDeMembresia}</div>
                    <div style={{ fontSize: 12, color: C.muted, letterSpacing: "0.05em", marginTop: 2 }}>{lang === "en" ? "DAYS LEFT" : "DÍAS QUE TE QUEDAN"}</div>
                  </div>
                )}
                <div style={{ textAlign: "center", padding: 12, background: C.light, borderRadius: 8 }}>
                  <div style={{ ...S.display, fontSize: 28, color: C.black }}>{hasCompanion ? "2" : "1"}</div>
                  <div style={{ fontSize: 12, color: C.muted, letterSpacing: "0.05em", marginTop: 2 }}>{lang === "en" ? "PEOPLE" : "PERSONAS"}</div>
                </div>
              </div>

              {/* Plan details */}
              <div style={{ padding: "14px 16px", background: isVIP ? "var(--accion-tinte)" : "var(--aviso-tinte)", borderRadius: 8, border: `1px solid ${isVIP ? "var(--linea)" : "var(--linea)"}`, marginBottom: 16 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: C.black, marginBottom: 8 }}>NXT Reserve{etiquetaNivel ? ` ${etiquetaNivel}` : ""}</div>
                {isVIP ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                    {[
                      lang === "en" ? `Up to ${vipMax} active coupons simultaneously` : `Hasta ${vipMax} cupones activos simultáneos`,
                      lang === "en" ? "Unlimited coupons — each business sets how soon you can return" : "Cupones ilimitados — cada negocio define cada cuánto puedes volver",
                      lang === "en" ? "$0 activation per coupon" : "Activación $0 por cupón",
                      lang === "en" ? "Coverage for you + 1 companion" : "Cobertura para ti + 1 acompañante",
                      vipExpires ? (lang === "en" ? `Your membership is valid until ${new Date(vipExpires).toLocaleDateString()}` : `Tu membresía vale hasta el ${new Date(vipExpires).toLocaleDateString()}`) : null,
                    ].filter(Boolean).map((f, i) => (
                      <div key={i} style={{ display: "flex", gap: 6, alignItems: "flex-start" }}>
                        <span style={{ color: "var(--exito)", fontWeight: 700, fontSize: 12 }}>✓</span>
                        <span style={{ fontSize: 12, color: C.gray }}>{f}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div>
                    {/* D-125: header y barra solo existen si hay cupo real. Con max_coupons 0
                        el prospecto veía "0 / 0" y un track vacío: dos adornos de un contador
                        que todavía no cuenta nada. El gate de la barra era de ancho, no de
                        render — por eso el track se dibujaba igual. Ahora es de render y cubre
                        a los dos; abajo queda solo el Estado 1. */}
                    {maxCoupons > 0 && (
                      <>
                        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                          <span style={{ fontSize: 12, color: C.muted }}>{lang === "en" ? "Coupons used" : "Cupones usados"}</span>
                          <span style={{ fontSize: 12, fontWeight: 700, color: C.black }}>{liteUsed} / {maxCoupons}</span>
                        </div>
                        <div style={{ height: 6, background: "var(--aviso-tinte)", borderRadius: 3 }}>
                          <div style={{ height: "100%", background: C.gold, borderRadius: 3, width: `${Math.min((Math.max(0, liteUsed) / maxCoupons) * 100, 100)}%`, transition: "width 0.3s" }} />
                        </div>
                      </>
                    )}
                    {/* D-125: tres estados excluyentes. El contador es ASCENDENTE ("usaste X
                        de Y") y ya no descendente: el resto obligaba a concordar con un número
                        que cambia solo, y en LITE (max 2) el estado roto "1 cupones restantes"
                        era la mitad de la vida de la cuenta. Ahora la concordancia se fija con
                        maxCoupons, que no se mueve. Gate > 0 + Math.max(0, ...) como en la 2188. */}
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>
                      {maxCoupons <= 0
                        ? (lang === "en" ? "You don't have coupons granted yet." : "Todavía no tienes cupones otorgados.")
                        : liteUsed >= maxCoupons
                          ? (PLANES_VIP_VIEJOS
                            ? (lang === "en" ? "You've reached your LITE limit. Upgrade to VIP for unlimited coupons!" : "Alcanzaste tu límite LITE. ¡Actualiza a VIP para cupones ilimitados!")
                            : (lang === "en" ? "You've used all your welcome coupons." : "Ya usaste todos tus cupones de bienvenida."))
                          : (lang === "en"
                            ? `You've used ${Math.max(0, liteUsed)} of ${maxCoupons} welcome coupon${maxCoupons === 1 ? "" : "s"}`
                            : `Usaste ${Math.max(0, liteUsed)} de ${maxCoupons} ${maxCoupons === 1 ? "cupón de bienvenida" : "cupones de bienvenida"}`)
                      }
                    </div>
                  </div>
                )}
              </div>

              {/* Upgrade button for LITE */}
              {!isVIP && PLANES_VIP_VIEJOS && (
                <button onClick={() => setShowVipModal(true)} style={{ ...S.btnPrimary, width: "100%", padding: "14px", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                  ⭐ {lang === "en" ? "Upgrade to VIP" : "Actualizar a VIP"}
                </button>
              )}

              {/* How it works */}
              <div style={{ marginTop: 16, padding: "14px 16px", background: C.light, borderRadius: 8 }}>
                <div style={{ fontSize: 12, color: C.muted, letterSpacing: "0.1em", marginBottom: 10 }}>{lang === "en" ? "HOW IT WORKS" : "CÓMO FUNCIONA"}</div>
                {[
                  { n: "1", t: lang === "en" ? "Browse offers in Benefits" : "Busca ofertas en Beneficios" },
                  { n: "2", t: lang === "en" ? "Activate your coupon ($0 for members)" : "Activa tu cupón ($0 para miembros)" },
                  { n: "3", t: lang === "en" ? "Visit the business, show your code" : "Ve al negocio, muestra tu código" },
                  { n: "4", t: lang === "en" ? "The business validates — enjoy!" : "El negocio valida — ¡disfruta!" },
                ].map(s => (
                  <div key={s.n} style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                    <div style={{ width: 20, height: 20, background: C.red, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <span style={{ color: "white", fontSize: 12, fontWeight: 700 }}>{s.n}</span>
                    </div>
                    <span style={{ fontSize: 12, color: C.gray }}>{s.t}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* ============ SECTION 3: PAYMENT METHODS ============ */}
        <div style={{ ...S.card, marginBottom: 12, overflow: "hidden" }}>
          <div style={sectionHeaderStyle("payment")} onClick={() => setOpenSection(openSection === "payment" ? "" : "payment")}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ fontSize: 18 }}>💳</span>
              <span style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{lang === "en" ? "Payment Methods" : "Métodos de Pago"}</span>
            </div>
            <span style={{ fontSize: 14, color: C.muted, transform: openSection === "payment" ? "rotate(180deg)" : "none", transition: "transform 0.2s" }}>▼</span>
          </div>
          {openSection === "payment" && (
            <div style={{ padding: "16px 20px" }}>
              {/* Apple Pay / Google Pay info */}
              <div style={{ padding: "10px 14px", background: "var(--info-tinte)", border: "1px solid var(--info-linea)", borderRadius: 8, marginBottom: 16, display: "flex", gap: 10, alignItems: "center" }}>
                <span style={{ fontSize: 20 }}>📱</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "var(--info)" }}>Apple Pay / Google Pay</div>
                  <div style={{ fontSize: 12, color: "var(--info)" }}>{lang === "en" ? "Automatically available if configured on your device" : "Disponible automáticamente si está configurado en tu dispositivo"}</div>
                </div>
              </div>

              {/* Saved cards list */}
              {cardError && (
                <div style={{ background: "var(--accion-tinte)", border: `1px solid ${C.red}`, color: C.red, padding: "10px 14px", borderRadius: 8, fontSize: 13, marginBottom: 12 }}>
                  {cardError}
                </div>
              )}
              {loadingCards ? (
                <div style={{ textAlign: "center", padding: 20, color: C.muted, fontSize: 13 }}>{lang === "en" ? "Loading cards..." : "Cargando tarjetas..."}</div>
              ) : cards.length === 0 ? (
                <div style={{ textAlign: "center", padding: "20px 16px", background: C.light, borderRadius: 8, marginBottom: 12 }}>
                  <div style={{ fontSize: 28, marginBottom: 6 }}>💳</div>
                  <div style={{ fontSize: 13, color: C.muted }}>{lang === "en" ? "No saved cards yet" : "No tienes tarjetas guardadas"}</div>
                  <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{lang === "en" ? "A card will be saved when you activate your first coupon" : "Se guardará una tarjeta cuando actives tu primer cupón"}</div>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 12 }}>
                  {cards.map((card, i) => (
                    <div key={card.id || i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 14px", border: `1px solid ${card.is_default ? C.red : C.border}`, borderRadius: 8, background: card.is_default ? "var(--accion-tinte)" : C.white }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <span style={{ fontSize: 13, fontWeight: 500, color: C.black }}>{cardBrandIcon(card.brand)}</span>
                        <div>
                          <div style={{ fontSize: 13, color: C.black, fontWeight: 500 }}>•••• {card.last4}</div>
                          <div style={{ fontSize: 12, color: C.muted }}>{lang === "en" ? "Expires" : "Vence"} {card.exp_month}/{card.exp_year}</div>
                        </div>
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        {card.is_default && (
                          <span style={{ fontSize: 12, background: C.red, color: C.white, padding: "2px 8px", borderRadius: 10, fontWeight: 700, letterSpacing: "0.05em" }}>{lang === "en" ? "DEFAULT" : "PREDETERMINADA"}</span>
                        )}
                        {!card.is_default && (
                          <button onClick={() => {/* TODO: set as default */}} style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 4, padding: "3px 8px", fontSize: 12, color: C.muted, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
                            {lang === "en" ? "Set default" : "Predeterminar"}
                          </button>
                        )}
                        <button onClick={() => handleDeleteCard(card.id)} style={{ background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 14, padding: "2px" }}>🗑️</button>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {/* Add card button */}
              {!showAddCard ? (
                <button onClick={() => setShowAddCard(true)} style={{ width: "100%", padding: "12px", border: `2px dashed ${C.border}`, borderRadius: 8, background: C.light, color: C.gray, fontSize: 13, fontWeight: 500, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}>
                  ➕ {lang === "en" ? "Add New Card" : "Agregar Nueva Tarjeta"}
                </button>
              ) : (
                <div style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "16px", background: C.white }}>
                  <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 12 }}>{lang === "en" ? "Add Card" : "Agregar Tarjeta"}</div>
                  <Elements stripe={stripePromise}>
                    <AddCardForm
                      lang={lang}
                      onSuccess={(card) => {
                        setCards(c => [...c, card]);
                        setShowAddCard(false);
                      }}
                      onCancel={() => setShowAddCard(false)}
                    />
                  </Elements>
                </div>
              )}

              <div style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 6, justifyContent: "center" }}>
                <span style={{ fontSize: 12, color: C.muted }}>🔒</span>
                <span style={{ fontSize: 12, color: C.muted }}>{lang === "en" ? "Payments secured by Stripe. We never store your card details." : "Pagos seguros con Stripe. Nunca almacenamos los datos de tu tarjeta."}</span>
              </div>
            </div>
          )}
        </div>

        {/* ============ ACTIONS ============ */}
        <div style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 8 }}>
          <button onClick={() => navigate("/my-coupons")} style={{ width: "100%", padding: "14px", background: C.white, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, fontWeight: 500, color: C.black, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>🎟️ {lang === "en" ? "My Coupons" : "Mis Cupones"}</span>
            <span style={{ color: C.muted }}>→</span>
          </button>
          <button onClick={() => window.open("mailto:hello@nxtreserve.com", "_blank")} style={{ width: "100%", padding: "14px", background: C.white, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 13, fontWeight: 500, color: C.black, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>📧 {lang === "en" ? "Contact Support" : "Contactar Soporte"}</span>
            <span style={{ color: C.muted }}>→</span>
          </button>
          <button onClick={handleLogout} style={{ width: "100%", padding: "14px", background: C.white, border: `1px solid ${C.red}`, borderRadius: 8, fontSize: 13, fontWeight: 500, color: C.red, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
            {lang === "en" ? "Sign Out" : "Cerrar Sesión"}
          </button>
        </div>

        <div style={{ textAlign: "center", marginTop: 24, fontSize: 12, color: C.muted }}>
          NXT Reserve · Miami, FL · v3.1
        </div>
      </div>

      {/* el hueco que la barra fija de teléfono le tapa al contenido */}
      <Pie />
    </div>
  );
}

// ---- ADD CARD FORM (Stripe Elements) ----
function AddCardForm({ lang, onSuccess, onCancel }) {
  const stripe = useStripe();
  const elements = useElements();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState("");

  const handleAddCard = async () => {
    if (!stripe || !elements) return;
    setProcessing(true); setError("");
    try {
      const cardEl = elements.getElement(CardElement);
      const token = localStorage.getItem("nxt_token");
      // Paso 1: pedir client_secret al backend (workflow create_setup_intent
      // lazy crea Customer si no existe — v9 B4.36b cerrado).
      const res = await fetch(`${API_BASE}/wf/create_setup_intent`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!data?.response?.client_secret) {
        throw new Error(lang === "en" ? "Setup intent failed" : "Error al iniciar el guardado de tarjeta");
      }
      // Paso 2: confirmar la tarjeta con Stripe.js.
      const result = await stripe.confirmCardSetup(data.response.client_secret, {
        payment_method: { card: cardEl },
      });
      if (result.error) throw new Error(result.error.message);
      if (result.setupIntent?.status !== "succeeded") {
        throw new Error(lang === "en" ? "Card setup did not succeed" : "La tarjeta no se pudo confirmar");
      }
      // Paso 3: persistir la tarjeta en Bubble (workflow save_payment_method
      // hace retrieve authoritative desde Stripe + Make changes Current User
      // — v10 B4.58 cerrado).
      const pmId = result.setupIntent.payment_method;
      const saveRes = await fetch(`${API_BASE}/wf/save_payment_method`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ payment_method_id: pmId }),
      });
      const saveData = await saveRes.json();
      if (!saveData?.response?.success || !saveData?.response?.card) {
        throw new Error(lang === "en" ? "Card saved in Stripe but failed to persist locally" : "La tarjeta se guardó en Stripe pero falló al persistir local");
      }
      // Bubble devuelve `card` como STRING JSON (Arbitrary text). Parsear.
      let cardParsed;
      try {
        cardParsed = JSON.parse(saveData.response.card);
      } catch (parseErr) {
        throw new Error("Card response malformed: " + parseErr.message);
      }
      onSuccess(cardParsed);
    } catch (e) {
      setError(e.message || (lang === "en" ? "Error adding card" : "Error al agregar tarjeta"));
    } finally { setProcessing(false); }
  };

  return (
    <div>
      <div style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "14px 12px", marginBottom: 12, background: C.light }}>
        {/* s184: hex literales a proposito — el style viaja al iframe de Stripe,
            que no ve tokens.css. Ver la nota extensa en el otro CardElement. */}
        <CardElement options={{
          style: {
            base: { fontSize: "15px", fontFamily: "'DM Sans', sans-serif", color: "#0F1B2A", "::placeholder": { color: "#A9ADB3" } },
            invalid: { color: "#A3161C" },
          },
        }} />
      </div>
      {error && <div style={{ fontSize: 12, color: C.red, marginBottom: 8 }}>{error}</div>}
      <div style={{ display: "flex", gap: 8 }}>
        <button onClick={onCancel} style={{ flex: 1, padding: "10px", background: C.light, border: `1px solid ${C.border}`, borderRadius: 8, fontSize: 12, color: C.gray, cursor: "pointer", fontFamily: "'DM Sans', sans-serif" }}>
          {lang === "en" ? "Cancel" : "Cancelar"}
        </button>
        <button onClick={handleAddCard} disabled={processing || !stripe} style={{ ...S.btnPrimary, flex: 2, padding: "10px", fontSize: 12, opacity: processing ? 0.7 : 1 }}>
          {processing ? "..." : (lang === "en" ? "Save Card" : "Guardar Tarjeta")}
        </button>
      </div>
    </div>
  );
}

// ============================================
// MERCHANT: PROTECTED ROUTE
// ============================================
function MerchantRoute({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!auth.isLoggedIn()) {
        navigate("/merchant/login", { replace: true });
        return;
      }
      try {
        // FIX s98 (rebote intermitente leg 7): mismo retry único que AdminRoute.
        let profile = null;
        try {
          profile = await getUserProfile();
        } catch (e1) {
          await new Promise(r => setTimeout(r, 900));
          profile = await getUserProfile();
        }
        // s175-D3 (FIX 4): SOLO el rol Merchant entra a /merchant/*. Antes el Admin tambien
        // pasaba, y era una trampa: la ruta lo dejaba entrar pero los WF de comercio miran el
        // ROL, no la ruta, asi que respondian 200 con {"success":"no","error_code":"NOT_MERCHANT"}
        // — dos sesiones dieron por roto el asesor por esto.
        if (profile.role === "Merchant") {
          setAuthorized(true);
        } else if (profile.role === "Admin") {
          // Al admin logueado lo mandamos a SU panel: rebotarlo a un login de comercio parece
          // un bug de sesion (s175-D3).
          navigate("/admin", { replace: true });
        } else if (profile.role === "MerchantStaff") {
          // s216 · el empleado solo valida: su pantalla, no el panel del dueño.
          navigate("/merchant/validar", { replace: true });
        } else {
          navigate("/merchant/login", { replace: true });
        }
      } catch {
        navigate("/merchant/login", { replace: true });
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [navigate]);

  if (checking) return (
    <div style={{ ...S.page, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ ...S.display, fontSize: 24, color: C.red }}>NXT RESERVE</div>
        <div style={{ color: C.muted, marginTop: 8, fontSize: 13 }}>Verificando acceso...</div>
      </div>
    </div>
  );
  if (!authorized) return null;
  return children;
}

// ============================================
// MERCHANT: HEADER COMPONENT
// ============================================
// s202 · `panel-contacto-nxt` — «AYUDA» EN EL PANEL DEL COMERCIO. Hasta hoy el comercio no
// tenia desde donde escribirnos (el guion de Otto le dice «sin llamar a nadie», pero igual
// tiene que poder hablar con NXT). Usa el MISMO numero de soporte que el socio: el que
// Ali fija en el admin (`PricingConfig.support_whatsapp`, lo devuelve get_user_profile a
// cualquier usuario) o el predeterminado. Cuando exista el numero de Otto, se cambia ahi,
// sin tocar codigo. Una lectura por sesion, no una por pantalla.
let soporteWaCache = { sesion: "", wa: "" };
async function numeroSoporte() {
  const sesion = auth.getToken() || "";
  if (soporteWaCache.wa && soporteWaCache.sesion === sesion) return soporteWaCache.wa;
  try {
    const p = await getUserProfile();
    const wa = p?.support_whatsapp ? String(p.support_whatsapp).replace(/[^0-9]/g, "") : "";
    soporteWaCache = { sesion, wa: wa || WHATSAPP_NUMBER };
  } catch (e) {
    return WHATSAPP_NUMBER;
  }
  return soporteWaCache.wa;
}

// s246-D4 · cuanto dura un cupon activado, POR RUBRO (spec claude/SPEC_s246_ciclo_cupon.md §5.1). Espejo del atributo
// `coupon_valid_days` del option set OfferCategory que lee create_coupon_and_cooldown (B2: `expires_at ← ahora + días
// del category_option de la oferta`, y si la oferta no tiene category_option, PricingConfig.coupon_valid_days = 7).
// s246 (pase Cowork §2): SOLO category_option, como B2. El texto `category` no cuenta: Bubble nunca lo mira, y con él una
// oferta vieja de salón diría 14 en la ficha y el cupón saldría con 7.
// Como FEE_RATE/FEE_FLOOR con PricingConfig: si cambia el option set en Bubble, cambia aca el mismo dia.
// (Hasta s245 era `CUPON_DURA_DIAS = 30` fijo.) Los cupones ya activados muestran su `expires_at`, no esto.
const CUPON_DIAS_POR_RUBRO = {
  Restaurant: 7, Bar_Rooftop: 7, Sweets: 7, Online: 7,                 // consumo
  Salon_Spa: 14, Nail_Lash: 14, Experience: 14, Gift_Moments: 14,      // cita o encargo (Gift_Moments 14: decisión de Ali s246)
};
const CUPON_DIAS_SIN_RUBRO = 7;   // = PricingConfig.coupon_valid_days (A1 del spec)
function cuponDuraDias(offer) {
  const o = offer || {};
  return CUPON_DIAS_POR_RUBRO[o.category_option] || CUPON_DIAS_SIN_RUBRO;
}

// s204 · EL TOPE DEL COMERCIO SABE QUIEN ES Y QUE LO ESPERA.
// El menu de cuenta necesita la ficha (id para «Ver mi ficha», logo, estado) y la
// insignia de «Mis Ofertas» cuantas ofertas piden algo (las rechazadas desde s239-E5; antes también las pausadas: el grupo
// «Te esperan» de esa pantalla). Se lee por el MISMO camino que ya usa Mis ofertas
// (getAllOffers + el filtro de misOfertasDelComercio), no por una consulta nueva a
// Bubble: una sola vez cada 2 minutos por sesion, y Mis ofertas la refresca al cargar o
// cuando el comercio pausa o reanuda (avisarPendientesDelComercio).
const TOPE_TTL_MS = 2 * 60 * 1000;
let topeComercioCache = { sesion: "", perfil: null, pendientes: null, hora: 0 };
const EVENTO_PENDIENTES = "nxt-pendientes-comercio";
const EVENTO_ABRIR_VALIDAR = "nxt-abrir-validar";

function misOfertasDelComercio(todas, perfil) {
  const merchantId = perfil?._id || perfil?.id || perfil?.merchant_id;
  const userId = auth.getUserId();
  return (todas || []).filter(o => {
    if (!merchantId) return o.Created_By === userId;
    const offMerchant = typeof o.merchant === "object" ? (o.merchant?._id || o.merchant?.id) : o.merchant;
    return offMerchant === merchantId || o.Created_By === userId;
  }).filter(o => (o.status || "").toLowerCase() !== "archived");
}
// s239 · E5: una pausada la pausó el dueño (no le pide nada): la insignia cuenta solo las rechazadas.
const contarPendientes = (ofertas) =>
  (ofertas || []).filter(o => (o.status || "").toLowerCase() === "rejected").length;

function avisarPendientesDelComercio(n) {
  topeComercioCache = { ...topeComercioCache, sesion: auth.getToken() || "", pendientes: n, hora: Date.now() };
  try { window.dispatchEvent(new CustomEvent(EVENTO_PENDIENTES, { detail: n })); } catch (_) {}
}

function irACambiarClave() {
  try {
    const el = document.getElementById("cambiar-clave");
    if (!el) return false;
    el.scrollIntoView({ block: "center" });
    el.querySelector("button")?.focus();
    return true;
  } catch (_) { return false; }
}

async function datosDelTope() {
  const sesion = auth.getToken() || "";
  const c = topeComercioCache;
  if (c.sesion === sesion && c.perfil && c.pendientes !== null && Date.now() - c.hora < TOPE_TTL_MS) return c;
  const perfil = c.sesion === sesion && c.perfil ? c.perfil : await getMerchantProfile().catch(() => null);
  let pendientes = null;
  try { pendientes = contarPendientes(misOfertasDelComercio(await getAllOffers(), perfil)); } catch (_) {}
  topeComercioCache = { sesion, perfil, pendientes, hora: Date.now() };
  return topeComercioCache;
}

function MerchantHeader({ businessName, activePage }) {
  const lang = useLang();
  const cambiarIdioma = useSetLang();
  const navigate = useNavigate();
  const [waSoporte, setWaSoporte] = useState(WHATSAPP_NUMBER);
  const [perfilTope, setPerfilTope] = useState(topeComercioCache.perfil);
  const [pendientes, setPendientes] = useState(topeComercioCache.pendientes);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => {
    let vivo = true;
    numeroSoporte().then(n => { if (vivo && n) setWaSoporte(n); });
    datosDelTope().then(d => { if (vivo) { setPerfilTope(d.perfil); setPendientes(d.pendientes); } });
    const alCambiar = (e) => { if (vivo) setPendientes(e.detail); };
    window.addEventListener(EVENTO_PENDIENTES, alCambiar);
    return () => { vivo = false; window.removeEventListener(EVENTO_PENDIENTES, alCambiar); };
  }, []);
  // El menu se cierra al tocar afuera o con Escape, y Escape devuelve el foco al boton.
  useEffect(() => {
    if (!menuAbierto) return;
    const fuera = (e) => { if (menuRef.current && !menuRef.current.contains(e.target)) setMenuAbierto(false); };
    const tecla = (e) => {
      if (e.key !== "Escape") return;
      setMenuAbierto(false);
      menuRef.current?.querySelector(".mrc-cuenta__boton")?.focus();
    };
    document.addEventListener("mousedown", fuera);
    document.addEventListener("keydown", tecla);
    return () => { document.removeEventListener("mousedown", fuera); document.removeEventListener("keydown", tecla); };
  }, [menuAbierto]);

  const nombre = businessName || perfilTope?.business_name || "";
  const logoTope = (() => { const l = perfilTope?.logo || ""; return String(l).startsWith("//") ? "https:" + l : l; })();
  const fichaId = perfilTope?.merchant_id || "";
  const fichaPublica = !!fichaId && String(perfilTope?.status || "").trim().toLowerCase() === "approved";
  // s214 · el Invitado todavía no tiene miembros que validar: hasta que confirme su oferta, Validar
  // no sale ni en el tope ni en la barra de abajo (ronda 12, 4/4: «¿validar qué, si no hay nadie?»).
  const sinValidar = String(perfilTope?.status || "").trim().toLowerCase() === "invitado";

  // En el panel el campo ya esta en la pantalla: se abre y se enfoca sin navegar
  // (la pantalla lee `?validar=1` solo al montarse). En las demas, se va al panel.
  const irAValidar = () => {
    if (activePage === "dashboard") {
      try { window.dispatchEvent(new Event(EVENTO_ABRIR_VALIDAR)); } catch (_) {}
    } else {
      navigate("/merchant/dashboard?validar=1");
    }
  };
  const textoAyuda = lang === "en"
    ? `Hi! This is ${businessName || "a business on NXT Reserve"} and I need help with my NXT Reserve panel.`
    : `¡Hola! Te escribo de ${businessName || "un comercio de NXT Reserve"} y necesito ayuda con mi panel de NXT Reserve.`;

  const handleLogout = () => {
    auth.logout();
    navigate("/merchant/login");
  };

  // s204 · cada pestaña con su icono (idea 5). En telefono las tres bajan a la barra de
  // abajo con Validar al centro (idea 6); `corto` es el rotulo que entra ahi.
  const navItems = [
    { key: "dashboard", label: lang === "en" ? "Dashboard" : "Inicio", corto: lang === "en" ? "Home" : "Inicio", ico: "ico-cupos", path: "/merchant/dashboard" },
    { key: "offers", label: lang === "en" ? "My Offers" : "Mis Ofertas", corto: lang === "en" ? "Offers" : "Ofertas", ico: "ico-destacado", path: "/merchant/offers" },
    { key: "profile", label: lang === "en" ? "Profile" : "Perfil", corto: lang === "en" ? "Profile" : "Perfil", ico: "ico-cuenta", path: "/merchant/profile" },
  ];
  const insignia = (item) => (item.key === "offers" && pendientes > 0 ? (
    <span className="mrc-tope__insignia"
      aria-label={lang === "en" ? `${pendientes} need you` : `${pendientes} te ${pendientes === 1 ? "espera" : "esperan"}`}>
      {pendientes}
    </span>
  ) : null);

  return (
    <div className="mrc-tope">
      <div className="mrc-tope__ancho">
        <div className="mrc-tope__fila">
          <div className="mrc-tope__marca">
            <Logo size="md" tono="oscuro" />
            {/* s204 · decia «MERCHANT», en ingles, sobre un panel en espanol. */}
            <div className="mrc-tope__rotulo">{lang === "en" ? "BUSINESS PANEL" : "PANEL DEL NEGOCIO"}</div>
          </div>
          <div className="mrc-tope__sesion">
            {/* s191 — VALIDAR, DESDE DONDE SEA. s204: pasa a ser LA accion del tope —coral,
                con icono y en todas las pantallas, tambien en el panel—: es lo que hace la
                recepcion con un socio parado enfrente. */}
            {!sinValidar && (
              <button onClick={irAValidar} className="mrc-tope__validar">
                <Ico name="ico-ok" size={16} />
                {lang === "en" ? "Validate" : "Validar"}
              </button>
            )}

            {/* s204 · EL MENU DE CUENTA. Ayuda y Salir eran dos botones sueltos al lado del
                nombre; ahora viven aca con lo que el comercio no tenia a mano: ver su ficha
                como la ve un socio, el idioma y la contrasena. */}
            <div className="mrc-cuenta" ref={menuRef}>
              <button type="button" className="mrc-cuenta__boton"
                aria-haspopup="menu" aria-expanded={menuAbierto}
                aria-label={lang === "en" ? `Account menu — ${nombre}` : `Menú de la cuenta — ${nombre}`}
                onClick={() => setMenuAbierto(v => !v)}>
                {logoTope
                  ? <img className="mrc-cuenta__logo" src={logoTope} alt="" onError={e => { e.target.style.display = "none"; }} />
                  : <span className="mrc-cuenta__inicial" aria-hidden="true">{(nombre || "N").trim().charAt(0).toUpperCase()}</span>}
                {nombre && <span className="mrc-tope__negocio">{nombre}</span>}
                <span className="mrc-cuenta__flecha" aria-hidden="true">▾</span>
              </button>
              {menuAbierto && (
                <div className="mrc-cuenta__menu" role="menu">
                  {nombre && <div className="mrc-cuenta__titulo">{nombre}</div>}
                  {fichaPublica && (
                    <a role="menuitem" className="mrc-cuenta__item" href={`/m/${fichaId}`} target="_blank" rel="noreferrer"
                      onClick={() => setMenuAbierto(false)}>
                      {lang === "en" ? "See my page" : "Ver mi ficha"}
                      <span className="mrc-cuenta__nota">{lang === "en" ? "As members see it" : "Como la ven los miembros"}</span>
                    </a>
                  )}
                  <button role="menuitem" type="button" className="mrc-cuenta__item"
                    onClick={() => { setMenuAbierto(false); cambiarIdioma(lang === "en" ? "es" : "en"); }}>
                    {lang === "en" ? "Español" : "English"}
                    <span className="mrc-cuenta__nota">{lang === "en" ? "Change language" : "Cambiar idioma"}</span>
                  </button>
                  <button role="menuitem" type="button" className="mrc-cuenta__item"
                    onClick={() => { setMenuAbierto(false); if (!(activePage === "profile" && irACambiarClave())) navigate("/merchant/profile#cambiar-clave"); }}>
                    {lang === "en" ? "Change password" : "Cambiar contraseña"}
                  </button>
                  <a role="menuitem" className="mrc-cuenta__item" href={`https://wa.me/${waSoporte}?text=${encodeURIComponent(textoAyuda)}`}
                    target="_blank" rel="noopener noreferrer" onClick={() => setMenuAbierto(false)}>
                    {lang === "en" ? "Help" : "Ayuda"}
                    <span className="mrc-cuenta__nota">{lang === "en" ? "Message NXT on WhatsApp" : "Escríbenos por WhatsApp"}</span>
                  </a>
                  <button role="menuitem" type="button" className="mrc-cuenta__item mrc-cuenta__item--salir" onClick={handleLogout}>
                    {lang === "en" ? "Log out" : "Salir"}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
        <nav className="mrc-tope__nav">
          {navItems.map(item => (
            <button
              key={item.key}
              onClick={() => navigate(item.path)}
              className={"mrc-tope__link" + (activePage === item.key ? " mrc-tope__link--activo" : "")}
              aria-current={activePage === item.key ? "page" : undefined}
            >
              <Ico name={item.ico} size={17} />
              {item.label}
              {/* s204 · lo que pide al comercio: rechazadas o pausadas. */}
              {insignia(item)}
            </button>
          ))}
        </nav>
      </div>

      {/* s204 · idea 6 · EN TELEFONO LA NAVEGACION BAJA. Donde llega el pulgar, como la
          app del socio (.navinf), con VALIDAR grande al centro: es lo que hace la recepcion
          con el socio enfrente. merchant.css la enciende bajo 560px y ahi esconde las
          pestañas y el Validar del tope. */}
      <nav className={"mrc-abajo" + (sinValidar ? " mrc-abajo--sin-validar" : "")} aria-label={lang === "en" ? "Business panel" : "Panel del negocio"}>
        {/* Cinco lugares para que Validar quede al CENTRO: Inicio · Ofertas · Validar ·
            Perfil · Ayuda. Ayuda es el mismo WhatsApp del menu de cuenta, a mano. */}
        {[navItems[0], navItems[1], ...(sinValidar ? [] : ["validar"]), navItems[2], "ayuda"].map(item => item === "validar" ? (
          <button key="validar" type="button" className="mrc-abajo__validar" onClick={irAValidar}>
            <span className="mrc-abajo__validar-circulo"><Ico name="ico-ok" size={24} /></span>
            <span className="mrc-abajo__rotulo">{lang === "en" ? "Validate" : "Validar"}</span>
          </button>
        ) : item === "ayuda" ? (
          <a key="ayuda" className="mrc-abajo__tab" href={`https://wa.me/${waSoporte}?text=${encodeURIComponent(textoAyuda)}`}
            target="_blank" rel="noopener noreferrer"
            aria-label={lang === "en" ? "Help: message NXT on WhatsApp" : "Ayuda: escríbele a NXT por WhatsApp"}>
            <span className="mrc-abajo__icono"><IcoFicha name="chat" size={20} /></span>
            <span className="mrc-abajo__rotulo">{lang === "en" ? "Help" : "Ayuda"}</span>
          </a>
        ) : (
          <button key={item.key} type="button"
            className={"mrc-abajo__tab" + (activePage === item.key ? " mrc-abajo__tab--on" : "")}
            aria-current={activePage === item.key ? "page" : undefined}
            onClick={() => navigate(item.path)}>
            <span className="mrc-abajo__icono"><Ico name={item.ico} size={20} />{insignia(item)}</span>
            <span className="mrc-abajo__rotulo">{item.corto}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

// ============================================
// MERCHANT: LOGIN PAGE
// ============================================
function MerchantLoginPage() {
  const lang = useLang();
  const cambiarIdioma = useSetLang();   // s204 - la puerta del socio lo ofrece desde s184; esta no
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  // s161 F-3: el rechazo del admin es su propio estado y no un string de error, porque
  // lleva un link y el banner de error es solo texto.
  const [adminBlocked, setAdminBlocked] = useState(false);
  // s195 · `?invite=1`: viene de crear la clave por el link de la vitrina beta (reset_pw
  // de Bubble con la sala pedida en PLAN_s195 §4). Solo cambia el saludo.
  const [spLogin] = useSearchParams();
  const vieneDeInvitacion = spLogin.get("invite") === "1";

  useEffect(() => {
    const checkAuth = async () => {
      if (auth.isLoggedIn()) {
        try {
          const profile = await getUserProfile();
          // s161 F-3: el admin ya NO auto-entra por la puerta del comercio. Se queda en
          // esta pantalla sin mensaje de error: sus credenciales estan bien, lo que esta
          // mal es la puerta. El error explicativo lo da handleSave cuando intenta entrar.
          if (profile.role === "Merchant") {
            navigate("/merchant/dashboard", { replace: true });
          }
        } catch {}
      }
    };
    checkAuth();
  }, [navigate]);

  const handleLogin = async () => {
    if (!email || !password) { setError(lang === "en" ? "Fill in all fields" : "Completa todos los campos"); return; }
    setLoading(true);
    setError("");
    try {
      await loginUser(email, password);
      const profile = await getUserProfile();
      // s161 F-3: tres ramas, no dos. El admin dejo de entrar por aca, pero decirle
      // "esta cuenta no es de negocio" seria mentira y lo dejaria sin salida: se le
      // nombra el caso y se le da la puerta correcta. El logout va en LAS DOS ramas de
      // rechazo — credenciales correctas en la puerta equivocada no dejan sesion abierta.
      if (profile.role === "Merchant") {
        navigate("/merchant/dashboard");
      } else if (profile.role === "MerchantStaff") {
        // s216 · Ola 2: el empleado entra por el portal de negocios y va directo a validar.
        try { localStorage.setItem("nxt_role", "MerchantStaff"); } catch (_) {}
        navigate("/merchant/validar");
      } else if (profile.role === "Admin") {
        auth.logout();
        setAdminBlocked(true);
        setError("");
      } else {
        auth.logout();
        setAdminBlocked(false);
        setError(lang === "en" ? "This account is not a merchant account" : "Esta cuenta no es una cuenta de negocio");
      }
    } catch (e) {
      setError(loginErrorMessage(e, lang, lang === "en" ? "Login error" : "Error al iniciar sesión"));
    } finally {
      setLoading(false);
    }
  };

  // s204 · el comercio entra por LA MISMA PUERTA que el socio (auth.css). Era la unica
  // pantalla del recorrido de la invitacion que seguia en la maqueta de telefono: el
  // comercio pasaba del correo a una caja con sombra y un circulo con la N, y de ahi al
  // panel nuevo. Mismo texto que antes (s203-D9: el copy del comercio espera a que su
  // lado este terminado); cambia la estructura.
  return (
    <div className="auth">

      <div className="auth__barra">
        <Logo size="md" tono="oscuro" />
        <button className="auth__idioma" onClick={() => cambiarIdioma(lang === "en" ? "es" : "en")}>
          {lang === "en" ? "ES" : "EN"}
        </button>
      </div>

      <div className="auth__centro">
        <div className="auth__caja">

          <div className="auth__saludo">
            <h1 className="auth__titulo">PORTAL DE NEGOCIOS</h1>
            <p className="auth__bajada">NXT Reserve · Miami</p>
          </div>

          {vieneDeInvitacion && (
            <div className="auth__aviso" role="status">
              {lang === "en"
                ? "Your password is set. Sign in with your email to confirm your offer."
                : "Tu contraseña quedó creada. Entra con tu correo para confirmar tu oferta."}
            </div>
          )}
          {adminBlocked && (
            <div className="auth__error" role="alert">
              <div className="auth__error-linea">
                {lang === "en"
                  ? "This is an administrator account. Sign in through the admin panel."
                  : "Esta es una cuenta de administrador. Entra por el panel de admin."}
              </div>
              <Link className="auth__error-enlace" to="/admin">
                {lang === "en" ? "Go to /admin" : "Ir a /admin"}
              </Link>
            </div>
          )}
          {error && <div className="auth__error" role="alert">{error}</div>}

          <div className="auth__campo">
            <label className="auth__etiqueta" htmlFor="nxt-f53">EMAIL</label>
            <input className="auth__entrada" autoComplete="email" id="nxt-f53"
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="tu@negocio.com"
              onKeyDown={e => e.key === "Enter" && handleLogin()}
            />
          </div>

          <div className="auth__campo">
            <label className="auth__etiqueta" htmlFor="nxt-f52">
              {lang === "en" ? "PASSWORD" : "CONTRASEÑA"}
            </label>
            <input className="auth__entrada" autoComplete="current-password" id="nxt-f52"
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              onKeyDown={e => e.key === "Enter" && handleLogin()}
            />
          </div>

          <button className="auth__boton" onClick={handleLogin} disabled={loading}>
            {loading ? "..." : (lang === "en" ? "Sign In →" : "Iniciar Sesión →")}
          </button>

          {/* B2.1f: reset de contraseña para merchants (misma ruta que miembros).
              s204 · `state.volver`: «Volver al login» de esa página trae de vuelta ACÁ. */}
          <Link className="auth__menor" to="/forgot-password" state={{ volver: "/merchant/login" }}>
            {lang === "en" ? "Forgot your password?" : "¿Olvidaste tu contraseña?"}
          </Link>

          <p className="auth__ayuda">
            {lang === "en" ? "Issues? Contact " : "¿Problemas? Contacta "}
            <a href="mailto:hello@nxtreserve.com">hello@nxtreserve.com</a>
          </p>

          <div className="auth__alta">
            {lang === "en" ? "Want your business on NXT Reserve? " : "¿Quieres sumar tu negocio? "}
            <a href="https://nxtreserve.com/merchants">
              {lang === "en" ? "Apply here" : "Aplica aquí"}
            </a>
          </div>

        </div>
      </div>

      <div className="auth__pie">
        <Link to="/login">
          {lang === "en" ? "← Back to member login" : "← Volver al login de miembros"}
        </Link>
      </div>

    </div>
  );
}

// ============================================
// MERCHANT: SIGNUP PAGE
// ============================================
// ============================================
// ALTA v2 — Places-first (s109, diseño s103) · taxonomía dos ejes (§4)
// ============================================
// business_type (14, ES snake_case) = eje de MARGEN del asesor.
// OfferCategory (6, slug EN) = eje de BROWSE del catálogo. NO fusionar (doctrina s104).
// Diccionario 14↔6 hardcodeado; si algún día cambia, actualizar también ADVISOR_RUBRO_MAP (api.js).
//
// s186 · CADA RUBRO LLEVA SU PISTA. El alta preselecciona el rubro con lo que dice
// Google, y un desplegable preseleccionado es gratis de aceptar: el comercio confirma
// sin mirar. No es cosmético — de esa elección sale el MARGEN con el que el asesor le
// propone descuentos. Un mantel largo cuyos tipos de Google no dicen `fine_dining`
// entra como `restaurante_casual`, y recibe consejo de descontar hasta 30% cuando su
// rubro real aguanta 25%. El default puede costarle dinero y no se entera.
// Las pistas son PALABRAS, no números: los porcentajes viven en MarginProfile (Bubble)
// y duplicarlos acá garantiza que un día digan cosas distintas.
//
// ⚠️ Las claves de acá son las que MarginProfile busca por igualdad de texto: si una no
// existe como fila, ese rubro se queda sin margen y el asesor razona a ciegas. Contra las
// 13 filas de Live (recon s185) el mapeo cierra 13/14 — la que falta del lado de Bubble es
// `heladeria_pasteleria` (ticket `advisor-rubro-map-sin-sweets`).
const BUSINESS_TYPES = [
  { key: "restaurante_casual",      cat: "Restaurant",   es: "Restaurante casual",      en: "Casual restaurant", pistaEs: "Carta fija, sin mantel, sin reserva obligatoria", pistaEn: "Set menu, no tablecloth, walk-ins welcome" },
  { key: "restaurante_fine_upscale", cat: "Restaurant",  es: "Fine dining / upscale",   en: "Fine dining / upscale", pistaEs: "Mantel, reserva, carta de vinos", pistaEn: "Tablecloth, reservations, wine list" },
  { key: "comida_rapida_qsr",       cat: "Restaurant",   es: "Comida rápida / QSR",     en: "Fast food / QSR", pistaEs: "Mostrador, entrega rápida, sin mesero", pistaEn: "Counter service, fast, no waiter" },
  { key: "pizza_delivery",          cat: "Restaurant",   es: "Pizzería / delivery",     en: "Pizza / delivery", pistaEs: "Pizza, delivery propio o para llevar", pistaEn: "Pizza, delivery or takeout" },
  { key: "cafe_brunch",             cat: "Restaurant",   es: "Café / brunch",           en: "Café / brunch", pistaEs: "Café, desayuno, brunch, repostería", pistaEn: "Coffee, breakfast, brunch, pastries" },
  { key: "bar_cocktails",           cat: "Bar_Rooftop",  es: "Bar / cocktails",         en: "Bar / cocktails", pistaEs: "Barra, coctelería, noche", pistaEn: "Bar, cocktails, nightlife" },
  { key: "heladeria_pasteleria",     cat: "Sweets",       es: "Heladería / pastelería",  en: "Ice cream / bakery", pistaEs: "Helados, postres, dulces para llevar", pistaEn: "Ice cream, desserts, sweets to go" },
  { key: "spa_masajes",             cat: "Salon_Spa",    es: "Spa / masajes",           en: "Spa / massage", pistaEs: "Masajes, faciales, tratamientos de cuerpo", pistaEn: "Massage, facials, body treatments" },
  { key: "unas_pelu_barberia",      cat: "Salon_Spa",    es: "Uñas / peluquería / barbería", en: "Nails / hair / barber", pistaEs: "Uñas, pestañas, cabello, barbería", pistaEn: "Nails, lashes, hair, barber" },
  { key: "tours_experiencias",      cat: "Experience",   es: "Tours / experiencias",    en: "Tours / experiences", pistaEs: "Tours, paseos, eventos, actividades", pistaEn: "Tours, outings, events, activities" },
  { key: "gym_fitness_clases",      cat: "Experience",   es: "Gym / fitness / clases",  en: "Gym / fitness / classes", pistaEs: "Gimnasio, clases, entrenamiento", pistaEn: "Gym, classes, training" },
  // s186 · la clave era "Hotel" y la fila de MarginProfile se llama `hotel_alojamiento`:
  // ningún hotel matcheaba nunca (`margen-hotel-clave-no-matchea`). Se renombra de este
  // lado —el de Bubble tiene 13 filas cargadas y 12 ya matchean— y el valor viejo queda
  // cubierto por el alias de ADVISOR_RUBRO_MAP para los comercios que ya lo tengan escrito.
  { key: "hotel_alojamiento",       cat: "Experience",   es: "Hotel / alojamiento",     en: "Hotel / lodging", pistaEs: "Hotel, resort, alojamiento", pistaEn: "Hotel, resort, lodging" },
  // s241 · Celebraciones (SPEC_s240): licorería y boutique salen de todo (§3.0: 0 comercios reales en Live con esas claves).
  { key: "tortas_reposteria",       cat: "Gift_Moments", es: "Tortas y repostería por encargo", en: "Cakes & pastry to order", pistaEs: "Tortas, cupcakes, postres para una ocasión", pistaEn: "Cakes, cupcakes, desserts for an occasion" },
  { key: "globos_arreglos_flores",  cat: "Gift_Moments", es: "Globos, arreglos y flores", en: "Balloons, arrangements & flowers", pistaEs: "Arreglos, decoración de fiestas, flores por encargo", pistaEn: "Arrangements, party decor, flowers to order" },
];
// ⚠️ s189-D · EL ALTA YA NO USA ESTE MAPA. Preseleccionar un rubro cuando el comercio
// cambia la categoría A MANO es pisarle la corrección: un barbero que corrige la categoría
// a Salón / Spa quedaba marcado `spa_masajes` sin haberlo pedido, y de ahí sale el margen
// con el que el asesor le propone descuentos. En el alta, cambiar la categoría ahora deja
// el rubro VACÍO y obligatorio.
// Sigue vivo en EDITAR PERFIL, donde el mismo defaulting sigue en pie: ahí el rubro no es
// obligatorio para guardar, así que vaciarlo escribiría `business_type` en blanco sin que
// nadie se entere — que es justo el otro ticket (`business-type-vacio-en-los-comercios`).
// Sacarlo de ahí necesita primero un guard de guardado: queda anotado, no se hace acá.
const DEFAULT_TYPE_BY_CAT = {
  Restaurant: "restaurante_casual", Bar_Rooftop: "bar_cocktails", Salon_Spa: "spa_masajes",
  Sweets: "heladeria_pasteleria", Experience: "tours_experiencias", Gift_Moments: "tortas_reposteria",
};

// s189-D · Las 6 categorías que ofrece EL ALTA = las 6 que tienen rubros en BUSINESS_TYPES.
// `Nail_Lash` no está: es legacy (vive en el Option Set de Bubble y en comercios viejos, y
// se sigue mostrando donde aparezca) pero NO tiene ni una fila en BUSINESS_TYPES. Con el
// rubro ahora obligatorio, elegirla dejaba el desplegable sin una sola opción — un callejón
// sin salida. Un nail studio elige Salón / Spa → «Uñas / peluquería / barbería», que es su
// rubro de margen real: es exactamente lo que ya dice `ADVISOR_RUBRO_MAP.Nail_Lash` (api.js).
const SIGNUP_CATEGORIES = ["Restaurant", "Salon_Spa", "Bar_Rooftop", "Experience", "Sweets", "Gift_Moments"];

// ---- s189-B/C/E · LA TAXONOMÍA DEL ALTA DEJA DE ADIVINAR ----------------------------
// Las reglas son las mismas de siempre. Lo que cambia es QUIÉN decide, y qué pasa cuando
// no lo sabe nadie.
//
// 1 · EL TIPO PRINCIPAL PRIMERO (s189-B). Google designa UN `primaryType` por lugar, y
//     desde este lote lo pedimos en el field mask (api.js `PLACES_FIELD_MASK`). Antes la
//     cascada corría solo sobre la lista `types` y ganaba la PRIMERA regla escrita:
//     `spa/massage/wellness_center` está ARRIBA de `nail_salon/hair_salon/barber_shop`, así
//     que un salón que en Google tenga las dos etiquetas caía en `spa_masajes` y nunca
//     llegaba a su regla. El orden de las líneas de este archivo decidía el margen de un
//     comercio. Ahora el tipo principal se evalúa contra las MISMAS reglas antes de la
//     cascada: si Google dice `hair_salon`, es peluquería, y no hay que decidir si spa le
//     gana a peluquería.
// 2 · EL FALLBACK DEJA DE MENTIR (s189-C). Sin coincidencia ya NO se devuelve
//     `restaurante_casual`: se devuelve la señal vacía y la pantalla lo trata como «no
//     sabemos». Un fallback que inventa un rubro no es una preselección informada, es una
//     rendición guardada como dato — y de ese dato sale el margen. Mismo patrón que ya se
//     corrigió en `destacados-placeholders-de-restaurante`.
// 3 · `priceLevel` DESEMPATA, Y SOLO ESO (s189-E). Únicamente casual → fine dining,
//     únicamente dentro de Restaurant, y como PROPUESTA que el comercio confirma.
//
// ⚠️ El orden de la tabla es EXACTAMENTE el de la cascada vieja, a propósito: para la
// segunda vuelta (la que corre sobre `types`) el resultado tiene que seguir siendo el de hoy.
const TAXONOMY_RULES = [
  { keys: ["ice_cream_shop", "bakery", "dessert_shop", "candy_store", "chocolate_shop", "donut_shop", "pastry_shop"], category: "Sweets", business_type: "heladeria_pasteleria" },   // s241 · + pastry_shop (la vitrina es Dulces)
  // s241 (Ali, banco de casos): la tienda de tortas (`cake_shop`) es de encargos → Celebraciones · tortas. Va DESPUÉS de Dulces:
  // con tipo principal `cake_shop` entra aquí; una panadería que además lista `cake_shop` en sus tipos se queda en Dulces.
  { keys: ["cake_shop"], category: "Gift_Moments", business_type: "tortas_reposteria" },
  { keys: ["cafe", "coffee_shop", "breakfast_restaurant", "brunch_restaurant"], category: "Restaurant", business_type: "cafe_brunch" },
  { keys: ["pizza_restaurant"], category: "Restaurant", business_type: "pizza_delivery" },
  { keys: ["fast_food_restaurant", "meal_takeaway", "hamburger_restaurant", "sandwich_shop"], category: "Restaurant", business_type: "comida_rapida_qsr" },
  { keys: ["fine_dining_restaurant"], category: "Restaurant", business_type: "restaurante_fine_upscale" },
  { keys: ["bar", "night_club", "pub", "wine_bar"], category: "Bar_Rooftop", business_type: "bar_cocktails" },
  { keys: ["spa", "massage", "wellness_center", "sauna"], category: "Salon_Spa", business_type: "spa_masajes" },
  { keys: ["nail_salon", "hair_salon", "beauty_salon", "barber_shop", "hair_care"], category: "Salon_Spa", business_type: "unas_pelu_barberia" },
  { keys: ["gym", "fitness_center", "yoga_studio", "sports_club", "sports_complex"], category: "Experience", business_type: "gym_fitness_clases" },
  { keys: ["lodging", "hotel", "resort_hotel", "motel", "bed_and_breakfast"], category: "Experience", business_type: "hotel_alojamiento" },
  { keys: ["tourist_attraction", "travel_agency", "amusement_park", "aquarium", "art_gallery", "museum", "event_venue"], category: "Experience", business_type: "tours_experiencias" },
  { keys: ["restaurant", "food"], category: "Restaurant", business_type: "restaurante_casual" },
  // s241 · Celebraciones: la florería es de globos y arreglos; tiendas de ropa, joyas, regalos y licores no son rubro del club
  // (entran «sin señal» y eligen a mano).
  { keys: ["florist"], category: "Gift_Moments", business_type: "globos_arreglos_flores" },
];

// Los dos `priceLevel` que Google considera caros. FREE / INEXPENSIVE / MODERATE no
// desempatan nada: casual se queda casual. Y `priceLevel` NO se guarda (TOS): entra, decide
// una propuesta, y muere en la pantalla.
const PRICE_LEVELS_CAROS = ["PRICE_LEVEL_EXPENSIVE", "PRICE_LEVEL_VERY_EXPENSIVE"];

// Devuelve SIEMPRE la misma forma:
//   { category, business_type, fuente, porPrecio, sinSenal }
// `fuente` ("primaryType" | "types" | "") la muestra la pantalla: una preselección que no
// dice de dónde salió se acepta sin mirar, y eso es la mitad del problema que abrió s186.
function guessTaxonomyFromPlaceTypes(types, primaryType, priceLevel) {
  const T = new Set(types || []);
  const principal = String(primaryType || "").trim();
  let regla = principal ? TAXONOMY_RULES.find(r => r.keys.includes(principal)) : null;
  let fuente = regla ? "primaryType" : "";
  if (!regla) {
    regla = TAXONOMY_RULES.find(r => r.keys.some(k => T.has(k))) || null;
    fuente = regla ? "types" : "";
  }
  if (!regla) return { category: "", business_type: "", fuente: "", porPrecio: false, sinSenal: true };
  let business_type = regla.business_type;
  let porPrecio = false;
  if (business_type === "restaurante_casual" && PRICE_LEVELS_CAROS.includes(String(priceLevel || ""))) {
    business_type = "restaurante_fine_upscale";
    porPrecio = true;
  }
  return { category: regla.category, business_type, fuente, porPrecio, sinSenal: false };
}

// ---- s189 adenda (Ali, 05/09) · EL TIPO DE GOOGLE, EN ESPAÑOL Y CON PALABRAS NUESTRAS
// La línea «Google lo clasifica como: …» de la tarjeta de confirmación mostraba el
// `primaryTypeDisplayName` crudo, que llega en inglés («Hair salon») dentro de un formulario
// en español.
// ⛔ LO QUE NO SE HACE: pedir `languageCode=es` en `placeDetails`. No aplica a un campo
// suelto — localizaría TODA la respuesta, incluidos `displayName` y `formattedAddress`, y
// esos DOS SÍ SE GUARDAN (`business_name`, `address_full`). El nombre de un comercio no se
// traduce nunca: cambiar el idioma de la respuesta para arreglar un rótulo sería mover un
// dato que se persiste.
// ✅ LO QUE SE HACE: un diccionario NUESTRO, acá, de los mismos tipos que ya nombra
// `TAXONOMY_RULES`. Traduce solo lo que se MUESTRA; no toca nada de lo que se guarda.
// Si el tipo no está en el mapa se muestra el `primaryTypeDisplayName` TAL COMO VIENE —no se
// inventa una traducción— y si tampoco viene, la línea no se dibuja.
const TIPO_GOOGLE_ES = {
  // Dulces
  ice_cream_shop: "Heladería", bakery: "Pastelería", dessert_shop: "Postres",
  candy_store: "Tienda de dulces", chocolate_shop: "Chocolatería", donut_shop: "Donas",
  // Café y desayuno
  cafe: "Café", coffee_shop: "Café", breakfast_restaurant: "Desayunos", brunch_restaurant: "Brunch",
  // Restaurantes
  pizza_restaurant: "Pizzería", fast_food_restaurant: "Comida rápida",
  meal_takeaway: "Comida para llevar", hamburger_restaurant: "Hamburguesería",
  sandwich_shop: "Sándwiches", fine_dining_restaurant: "Restaurante de alta cocina",
  restaurant: "Restaurante", food: "Comida",
  // Bares
  bar: "Bar", night_club: "Discoteca", pub: "Pub", wine_bar: "Bar de vinos",
  // Spa y belleza
  spa: "Spa", massage: "Masajes", wellness_center: "Centro de bienestar", sauna: "Sauna",
  nail_salon: "Salón de uñas", hair_salon: "Peluquería", beauty_salon: "Salón de belleza",
  barber_shop: "Barbería", hair_care: "Cuidado del cabello",
  // Fitness
  gym: "Gimnasio", fitness_center: "Gimnasio", yoga_studio: "Estudio de yoga",
  sports_club: "Club deportivo", sports_complex: "Complejo deportivo",
  // Alojamiento
  lodging: "Hotel", hotel: "Hotel", resort_hotel: "Resort", motel: "Motel",
  bed_and_breakfast: "Bed & breakfast",
  // Experiencias
  tourist_attraction: "Atracción turística", travel_agency: "Agencia de viajes",
  amusement_park: "Parque de diversiones", aquarium: "Acuario", art_gallery: "Galería de arte",
  museum: "Museo", event_venue: "Salón de eventos",
  // Tiendas
  liquor_store: "Licorería", clothing_store: "Tienda de ropa", jewelry_store: "Joyería",
  gift_shop: "Tienda de regalos", shoe_store: "Zapatería", florist: "Floristería",
  shopping_mall: "Centro comercial", store: "Tienda",
};
// Devuelve "" cuando no hay nada honesto que mostrar, y la pantalla omite la línea entera.
// En inglés no hay diccionario que aplicar: el `primaryTypeDisplayName` de Google ya viene en
// el idioma correcto y se usa tal cual.
function etiquetaTipoGoogle(primaryType, displayName, lang) {
  const crudo = String(displayName || "").trim();
  if (lang === "en") return crudo;
  const nuestra = TIPO_GOOGLE_ES[String(primaryType || "").trim()];
  return nuestra || crudo;
}

// ---- s189-F · LA INDUSTRIA QUE ELIGIÓ EN LA LANDING ---------------------------------
// La landing tiene seis tarjetas («¿CUÁL ES TU NEGOCIO?» → Restaurantes · Belleza & Spa ·
// Bares & Rooftops · Experiencias · Dulces & Heladerías · Regalos & Momentos) y el comercio
// elige la suya ANTES de registrarse. Esa elección no llegaba al alta: leía un pitch de
// belleza y entraba al formulario como restaurante.
//
// ⚠️ MEDIDO EL 05/09: los enlaces de esas tarjetas NO llevan parámetro —son
// `/merchants/belleza`, `/merchants/restaurantes`, `/merchants/dulces`, páginas de pitch— y
// el alta vive en OTRO dominio (`app.nxtreserve.com/merchant/signup`). O sea que HOY esto no
// recibe nada, y así tiene que ser: SIN parámetro el comportamiento es el de siempre.
// Se construye igual porque es aditivo y no rompe nada. La otra mitad —que los botones de la
// landing agreguen `?cat=`— es del repo de marketing (`spontaneous-lily-d6b4ff`): por R4 se
// anota y no se toca desde acá. Ticket cruzado: `alta-no-recibe-la-industria-de-la-landing`.
//
// Tolerante a propósito: acepta la key canónica (`Salon_Spa`), el slug de la landing
// (`belleza`) y variantes con acentos, mayúsculas, espacios o guiones. Lo que no reconoce lo
// IGNORA — un parámetro raro no puede dejar el alta en un estado inválido.
const LANDING_CAT_ALIASES = {
  restaurant: "Restaurant", restaurante: "Restaurant", restaurantes: "Restaurant", comida: "Restaurant",
  salonspa: "Salon_Spa", salon: "Salon_Spa", salones: "Salon_Spa", spa: "Salon_Spa",
  belleza: "Salon_Spa", bellezaspa: "Salon_Spa", bellezayspa: "Salon_Spa", naillash: "Salon_Spa",
  barrooftop: "Bar_Rooftop", bar: "Bar_Rooftop", bares: "Bar_Rooftop", rooftop: "Bar_Rooftop",
  rooftops: "Bar_Rooftop", baresrooftops: "Bar_Rooftop", baresyrooftops: "Bar_Rooftop",
  experience: "Experience", experiences: "Experience", experiencia: "Experience", experiencias: "Experience",
  sweets: "Sweets", dulces: "Sweets", heladerias: "Sweets", postres: "Sweets",
  dulcesheladerias: "Sweets", dulcesyheladerias: "Sweets",
  giftmoments: "Gift_Moments", gifts: "Gift_Moments", regalos: "Gift_Moments",
  momentos: "Gift_Moments", regalosmomentos: "Gift_Moments", regalosymomentos: "Gift_Moments",
};
// Minúsculas, sin acentos y sin nada que no sea letra o número: `Belleza & Spa`,
// `belleza-spa` y `Salon_Spa` tienen que caer todos en la misma llave.
function normalizarSlug(valor) {
  return String(valor || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]/g, "");
}
function catDesdeLanding(valor) {
  const k = normalizarSlug(valor);
  if (!k) return "";
  return LANDING_CAT_ALIASES[k] || "";
}
// `?bt=` es opcional y más fino que `?cat=`. Solo se acepta si es una clave REAL de
// BUSINESS_TYPES y además pertenece a la categoría que quedó: un rubro de otra categoría
// no es una señal, es una contradicción.
function btDesdeLanding(valor, categoria) {
  const k = String(valor || "").trim().toLowerCase();
  if (!k) return "";
  const b = BUSINESS_TYPES.find(x => x.key === k);
  if (!b) return "";
  if (categoria && b.cat !== categoria) return "";
  return b.key;
}

// s189-C/D/F · QUÉ QUEDA PUESTO cuando Places contesta. Vive afuera del componente porque
// es la parte sutil del lote y así se puede razonar (y probar) sin montar la pantalla.
// Jerarquía: la landing manda sobre Places — si el comercio dijo «Belleza & Spa», Places no
// lo puede mandar a Restaurante. Y si la categoría final NO es la que dedujo Places, el
// rubro de Places tampoco aplica: se devuelve vacío y lo elige el comercio. Vacío es mejor
// que de otra categoría — un campo vacío se ve y se pregunta; un rubro ajeno se acepta sin
// mirar, y de ahí sale el margen.
function resolverTaxonomiaDelAlta(guess, catLanding, btLanding) {
  const category = catLanding || guess.category;
  if (btLanding && BUSINESS_TYPES.some(b => b.key === btLanding && b.cat === category)) {
    return { category, business_type: btLanding, fuente: "landing" };
  }
  if (!guess.sinSenal && guess.category === category) {
    return { category, business_type: guess.business_type, fuente: guess.fuente };
  }
  return { category, business_type: "", fuente: "" };
}

// addressComponents (Places New) → {address, city, state, zip, neighborhood}
function parsePlaceAddress(place) {
  const comps = place?.addressComponents || [];
  const get = (type, useShort) => {
    const c = comps.find(x => (x.types || []).includes(type));
    return c ? (useShort ? (c.shortText || c.longText || "") : (c.longText || c.shortText || "")) : "";
  };
  const street = [get("street_number"), get("route")].filter(Boolean).join(" ");
  return {
    address: street || place?.formattedAddress || "",
    city: get("locality") || get("postal_town") || get("administrative_area_level_2"),
    state: get("administrative_area_level_1", true),
    zip: get("postal_code"),
    neighborhood: get("neighborhood") || get("sublocality_level_1") || get("sublocality"),
  };
}

// s256 · zona-en-tarjeta-alta-manual: con la dirección escrita a mano (sin Places) el alta no guardaba ciudad, estado ni ZIP,
// y la tarjeta del wizard (neighborhood || city) quedaba sin zona. Se leen del texto que escribió el dueño, solo con la forma
// de una dirección de EE. UU. que termina en el estado: «calle, Ciudad FL 33133» o «calle, Ciudad, FL». Si no tiene esa
// forma, no se adivina (D-117: la zona sale del dato o no sale; «Miami» no va de relleno). El barrio no se puede leer.
function ciudadDeDireccionEscrita(texto) {
  const s = String(texto || "").replace(/\s+/g, " ").trim().replace(/,?\s*(USA|U\.S\.A\.|EE\.?\s?UU\.?|United States)\.?$/i, "");
  const m = s.match(/,\s*([^,\d][^,]*?)\s*,?\s+(FL|Fla\.?|Florida)\.?(?:\s+(\d{5})(?:-\d{4})?)?$/i);
  if (!m) return null;
  let city = m[1].trim();
  if (city.length < 2 || city.length > 40) return null;
  if (city === city.toLowerCase() || city === city.toUpperCase()) city = city.toLowerCase().replace(/(^|[\s-])\p{L}/gu, c => c.toUpperCase());
  return { city, state: "FL", zip: m[3] || "" };
}

// s237 · horario-google-24-7: un lugar abierto siempre llega como UN período (domingo 00:00, sin `close`); se lee
// como los siete días abiertos 24 horas, no como «solo domingo».
function periodosDeGoogle(regular) {
  const periods = regular?.periods || [];
  if (periods.length === 1 && !periods[0]?.close && periods[0]?.open?.day === 0 && !periods[0].open.hour && !periods[0].open.minute)
    return [0, 1, 2, 3, 4, 5, 6].map(day => ({ open: { day, hour: 0, minute: 0 } }));
  return periods;
}

// regularOpeningHours.periods (Places: day 0=Dom) → formato hours de la app (mon..sun, r1/r2)
function placeHoursToAppHours(regular) {
  const periods = periodosDeGoogle(regular);
  if (!periods.length) return null;
  const dayKeys = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
  const fmt = (pt) => (pt == null) ? "" : `${String(pt.hour ?? 0).padStart(2, "0")}:${String(pt.minute ?? 0).padStart(2, "0")}`;
  const byDay = {};
  const poner = (k, o, c) => { (byDay[k] = byDay[k] || []).push({ o, c }); };
  periods.forEach(p => {
    const g = p?.open?.day;
    const k = dayKeys[g ?? -1];
    if (!k) return;
    // s243 · `horario-alta-tramo-que-cruza-dias` (diagnóstico s242 §4.11): el mismo criterio que horarioDeGoogle (s241). Un tramo
    // «viernes 11:30 → domingo 00:00» (Hibachi Miami: «sábado: Abierto las 24 horas») caía entero en el viernes y el sábado
    // quedaba cerrado en el alta y en la consola. Ahora el día de apertura va hasta 23:59, los del medio 00:00–23:59 y el de
    // cierre desde las 00:00 (si cierra a las 00:00, ese día no suma).
    const cruza = p.close && p.close.day != null ? (p.close.day - g + 7) % 7 : 0;
    if (cruza >= 2) {
      poner(k, fmt(p.open), "23:59");
      for (let n = 1; n < cruza; n++) poner(dayKeys[(g + n) % 7], "00:00", "23:59");
      if ((p.close.hour ?? 0) || (p.close.minute ?? 0)) poner(dayKeys[(g + cruza) % 7], "00:00", fmt(p.close));
      return;
    }
    poner(k, fmt(p.open), p.close ? fmt(p.close) : "23:59");   // sin cierre = 24 horas
  });
  return m2BaseHours().map(d => {
    const ranges = byDay[d.day] || [];
    if (!ranges.length) return { ...d, closed: true };
    return { ...d, closed: false, r1o: ranges[0].o, r1c: ranges[0].c, r2o: ranges[1]?.o || "", r2c: ranges[1]?.c || "" };
  });
}

// s241 · `verificacion-correo-web-de-plataforma` (SPEC_s240): Booksy, Instagram, Linktree… no son «web propia». Si la web
// que trae Google es una de estas, nadie tiene correo con ese dominio: el alta la trata como «sin web» (vale cualquier
// correo que no sea gratuito) y la pantalla del código no promete verificación por dominio. Bubble ya hace lo correcto
// (`verify_email_otp` step 15 no se cumple → llamada); esto es solo lo que se le dice al dueño.
// La lista de plataformas es PLATAFORMAS_WEB (s238, la usa la ficha). Aquí se suma lo que solo importa para el correo:
// plataformas que la ficha todavía no nombra y los constructores de páginas gratis, que en la ficha SÍ son la web del
// negocio (`minegocio.wixsite.com`) pero no dan correo con dominio propio.
const SIN_DOMINIO_PROPIO = [
  { d: "setmore.com", n: "Setmore" }, { d: "acuityscheduling.com", n: "Acuity" }, { d: "as.me", n: "Acuity" },
  { d: "doordash.com", n: "DoorDash" }, { d: "ubereats.com", n: "Uber Eats" }, { d: "grubhub.com", n: "Grubhub" },
  { d: "yelp.com", n: "Yelp" }, { d: "bio.site", n: "Bio.site" }, { d: "fb.com", n: "Facebook" }, { d: "wa.me", n: "WhatsApp" },
  { d: "business.site", n: "Google" }, { d: "wixsite.com", n: "Wix" }, { d: "godaddysites.com", n: "GoDaddy" },
  { d: "weebly.com", n: "Weebly" }, { d: "squarespace.com", n: "Squarespace" },
];
const CORREOS_GRATIS = ["gmail.com", "googlemail.com", "yahoo.com", "hotmail.com", "outlook.com", "live.com", "msn.com", "icloud.com", "me.com", "aol.com", "proton.me", "protonmail.com"];
// El host de una web (con o sin esquema, sin «www.»), o "" si no se puede leer.
const hostDeWeb = (url) => {
  try { const u = String(url || "").trim(); return u ? new URL(/^https?:/i.test(u) ? u : `https://${u}`).hostname.replace(/^www\./i, "").toLowerCase() : ""; }
  catch (e) { return ""; }
};
// El nombre de la plataforma de una web («igual o termina en .host»), o "" si es web propia.
const plataformaDelCorreo = (url) => {
  const p = plataformaDeWeb(url);
  if (p) return p.n;
  const h = hostDeWeb(url);
  const x = h && SIN_DOMINIO_PROPIO.find(y => h === y.d || h.endsWith(`.${y.d}`));
  return x ? x.n : "";
};
const esPlataforma = (url) => !!plataformaDelCorreo(url);
const nombrePlataforma = (url) => plataformaDelCorreo(url) || hostDeWeb(url);
// s215 · correo corporativo: mismo dominio que la web de Google; sin web —o con web de plataforma (s241)—, que no sea gratuito.
const correoEsCorporativoDe = (email, webGoogle) => {
  const dominioCorreo = String(email || "").trim().toLowerCase().split("@")[1] || "";
  const dominioWeb = esPlataforma(webGoogle) ? "" : hostDeWeb(webGoogle);
  return !!dominioCorreo && (dominioWeb ? (dominioCorreo === dominioWeb || dominioCorreo.endsWith(`.${dominioWeb}`)) : !CORREOS_GRATIS.includes(dominioCorreo));
};

function MerchantSignupPage() {
  const lang = useLang();
  const navigate = useNavigate();
  // s189-F · La industria que el comercio eligió en la landing. HOY NO VIENE (medido el
  // 05/09: los enlaces de las seis tarjetas no llevan parámetro, y el alta está en otro
  // dominio) — sin parámetro esto queda en "" y el alta se comporta como siempre. Ver
  // `catDesdeLanding` para por qué se construye igual.
  const [searchParams] = useSearchParams();
  const catLanding = catDesdeLanding(searchParams.get("cat"));
  const btLanding = btDesdeLanding(searchParams.get("bt"), catLanding);

  // Flujo s103 §2: Paso 1 "Tu negocio" (Places-first, fallback manual) → Paso 2 "Tu cuenta".
  const [step, setStep] = useState(1);
  const [mode, setMode] = useState(placesEnabled() ? "search" : "manual"); // search | confirm | manual
  const [query, setQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [searching, setSearching] = useState(false);
  const [place, setPlace] = useState(null); // Place Details crudo. TOS: NO se piden ni guardan rating/reviews/fotos.
  const [placeErr, setPlaceErr] = useState("");
  const sessionTokenRef = useRef("");
  // s189-C/D/F · EL ALTA YA NO ARRANCA EN `Restaurant / restaurante_casual`. Arranca en lo
  // que dijo la landing y, si la landing no dijo nada, VACÍO: un rubro preseleccionado que
  // nadie eligió es lo que hacía entrar a un salón como restaurante casual, y de ese dato
  // sale el margen con el que el asesor propone descuentos.
  const [form, setForm] = useState(() => ({
    name: '', email: '', password: '', confirmPassword: '',
    business_name: '', category: catLanding || '', business_type: btLanding || '', address: '', phone: '', referral_code: ''
  }));
  // s189-D · De dónde salió el rubro que está puesto, para poder DECIRLO en pantalla:
  //   fuente: "landing" | "primaryType" | "types" | ""   ("" = lo eligió el comercio a mano)
  //   googleTipo / googleDice: `primaryType` y `primaryTypeDisplayName` — contenido de
  //     Places: se muestran (traducidos por TIPO_GOOGLE_ES) y NO se guardan
  //   porPrecio: el rubro subió a fine dining por `priceLevel` (s189-E), hay que avisarlo
  //   googleSinSenal: Places no alcanzó para deducirlo → el aviso cambia de texto
  const [senal, setSenal] = useState(() => ({
    fuente: btLanding ? "landing" : "", googleTipo: "", googleDice: "", porPrecio: false, googleSinSenal: false,
  }));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [aceptaTerminos, setAceptaTerminos] = useState(false);   // s232 · Términos para negocios aliados
  // s215 · Ali: el alta pide CORREO CORPORATIVO (del dominio de la web del negocio). Si el negocio es
  // nuevo o no tiene web, marca «No tengo correo corporativo» y el registro sigue, sabiendo que hay que
  // revisarlo con más cuidado. (Guardar esa marca en la base es un campo de Bubble: pendiente, Cowork.)
  const [sinCorporativo, setSinCorporativo] = useState(false);
  // s175 FIX 2: la 2a llamada del alta (update_merchant_profile con el payload de Places)
  // puede fallar sin abortar el alta. Cuando falla mostramos un aviso no bloqueante en vez
  // de navegar solos al dashboard — el comercio se entera de que le faltan datos.
  const [profileWarn, setProfileWarn] = useState(false);
  // s230 · absorber (s229-D2, export 142): la 2ª llamada del alta tiene dos salidas nuevas.
  //   absorbida   → Bubble apuntó esta cuenta a una siembra sin dueño (el merchant_id cambió): «seguimos con esa ficha».
  //   placeTomado → PLACE_ID_TAKEN: la siembra ya tiene dueño y Bubble no escribió nada; el camino es WhatsApp.
  //                 { mensaje: el error_message literal del WF, wa: el número de soporte }.
  const [absorbida, setAbsorbida] = useState(false);
  const [placeTomado, setPlaceTomado] = useState(null);

  useEffect(() => {
    if (auth.isLoggedIn()) {
      getUserProfile().then(p => {
        if (p.role === "Merchant" || p.role === "Admin") navigate("/merchant/dashboard", { replace: true });
      }).catch(() => {});
    }
  }, [navigate]);

  // Autocomplete con debounce + session token (facturación por sesión → centavos por alta)
  useEffect(() => {
    if (mode !== "search") return;
    const q = query.trim();
    if (q.length < 3) { setSuggestions([]); return; }
    const h = setTimeout(async () => {
      try {
        if (!sessionTokenRef.current) {
          sessionTokenRef.current = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        }
        setSearching(true);
        setSuggestions(await placesAutocomplete(q, sessionTokenRef.current));
      } catch (e) { setSuggestions([]); }
      finally { setSearching(false); }
    }, 300);
    return () => clearTimeout(h);
  }, [query, mode]);

  const t = lang === 'es' ? {
    title: 'REGISTRO DE NEGOCIO',
    subtitle: 'NXT Reserve · Miami',
    step1: 'TU NEGOCIO', step2: 'TU CUENTA',
    searchLabel: 'BUSCA TU NEGOCIO EN GOOGLE',
    searchPh: 'Ej: Brickell Kitchen, Miami…',
    searching: 'Buscando…',
    notInGoogle: 'Mi negocio no está en Google →',
    backToSearch: '← Volver a buscar en Google',
    confirmQ: '¿Es tu negocio?',
    confirmYes: 'Sí, continuar →',
    searchOther: 'Buscar otro',
    hoursImported: 'Horarios importados de Google ✓',
    mapsLink: 'Ver en Google Maps ↗',
    businessName: 'NOMBRE DEL NEGOCIO',
    category: 'CATEGORÍA',
    businessType: 'RUBRO',
    name: 'NOMBRE DEL RESPONSABLE',
    phone: 'TELÉFONO',
    // s226 · el teléfono del alta es el del NEGOCIO: signup_merchant lo guarda en phone_public y la
    // página del comercio lo publica. Al lado del nombre del responsable se leía como «tu teléfono».
    phoneBiz: 'TELÉFONO DEL NEGOCIO',
    phoneBizNota: 'Lo ven los miembros. No pongas tu celular personal.',
    address: 'DIRECCIÓN',
    email: 'EMAIL',
    password: 'CONTRASEÑA',
    confirmPw: 'CONFIRMAR CONTRASEÑA',
    continue: 'Continuar →',
    back: '← Volver',
    submit: 'Registrar mi Negocio →',
    loading: 'Registrando...',
    loginLink: '¿Ya tienes cuenta?',
    loginBtn: 'Inicia sesión',
    mismatch: 'Las contraseñas no coinciden',
    minPw: 'Mínimo 8 caracteres',
    needBiz: 'Cuéntanos el nombre de tu negocio',
    referral: 'CÓDIGO DE REFERIDO (OPCIONAL)',
    // s189-D · El rubro pasa a ser obligatorio y ahora PUEDE estar vacío: hacen falta las
    // palabras para pedirlo, y para decir de dónde salió cuando no lo está. Un desplegable
    // preseleccionado que no dice quién lo eligió se acepta sin mirar.
    needCat: 'Elige la categoría de tu negocio',
    needType: 'Elige tu rubro: con él armamos la oferta que te recomendamos.',   // s238 · ayudas A8
    catPick: 'Elige una…',
    btPick: 'Elige tu rubro…',
    btPickCat: 'Elige primero la categoría',
    loDijoGoogle: 'Lo dijo Google',
    deLaLanding: 'Lo elegiste en nuestra web',
    googleClasifica: 'Google lo clasifica como',
    rubroSinSenal: 'Google no nos dijo qué tipo de negocio eres. Elígelo tú: con el rubro armamos la oferta que te recomendamos.',
    rubroElige: 'Elige tu rubro: con él armamos la oferta que te recomendamos y el ejemplo que vas a ver.',
    rubroDeGoogle: 'Lo tomamos de Google. Si no es exactamente lo tuyo, cámbialo: con el rubro armamos la oferta que te recomendamos.',
    rubroDeLanding: 'Lo trajimos de la industria que elegiste en nuestra web. Si no es exactamente lo tuyo, cámbialo: con el rubro armamos la oferta que te recomendamos.',
    rubroPorPrecio: 'Google marca este negocio como caro, así que proponemos «Fine dining / upscale» en vez de casual. Si no es tu caso, cámbialo.',
    // s203 (auditoría s203 🔴 #4): se fue «🏆 Founding Partners — los primeros 50 comercios»
    // y la línea del «lugar de fundador». Sin cuota ni comisión (s193-D1) un fundador no
    // tiene nada distinto, y el «50» contradecía el «100» de la landing. Queda lo que es
    // verdad y repite el guion de Otto. (El contador `founding_partner_cap_number` sigue en
    // Bubble; su historia estaba en este comentario hasta `00b913b`.)
    sinCosto: 'Sin costo y sin permanencia: pausas o quitas tu oferta cuando quieras.',
    // Lo que pasa después de tocar el botón. Hasta hoy no lo decía nada, y es la
    // pregunta que cualquiera se hace antes de dejar sus datos.
    trasEnviar: 'Al enviar, tu negocio queda registrado y pasa por nuestra revisión: te llamamos al teléfono del negocio o te escribimos para confirmar que estás autorizado por el negocio. Mientras tanto ya puedes preparar tus ofertas: no se publican hasta que confirmemos y las aprobemos.',
    detailsErr: 'No pudimos traer los datos de Google. Prueba de nuevo o cárgalo a mano.',
    nombreDeGoogle: 'ASÍ TE VERÁN LOS MIEMBROS',
    nombreAyuda: 'Lo trajimos de Google. Si está mal escrito o desactualizado, corrígelo aquí.',
    backMembers: '← Volver al login de miembros',
    partialTitle: '✅ Tu cuenta se creó',
    partialBody: 'Algunos datos de tu negocio no se pudieron importar — complétalos en Editar Perfil.',
    partialCta: 'Ir a mi panel →',
    // s230 · absorber (s229-D2): las dos salidas nuevas de la 2ª llamada del alta.
    absorbTitle: 'Tu negocio ya estaba en NXT',
    absorbBody: 'Tu negocio ya estaba en NXT con tu asesor: seguimos con esa ficha. Lo que ya tenía se conserva y lo que acabas de escribir queda guardado.',
    absorbCta: 'Ir a mi panel →',
    takenTitle: 'Ese negocio ya tiene dueño en NXT',
    takenBody: 'Ese negocio ya tiene dueño en NXT. Escríbenos por WhatsApp y lo revisamos.',
    takenWa: 'Escribirnos por WhatsApp',
    takenPanel: 'Ir a mi panel →',
    takenWaMsg: (nombre, negocio) => `Hola, soy ${nombre} de ${negocio}. Al registrarme en NXT Reserve dice que mi negocio ya tiene dueño. ¿Lo revisan?`
  } : {
    title: 'BUSINESS REGISTRATION',
    subtitle: 'NXT Reserve · Miami',
    step1: 'YOUR BUSINESS', step2: 'YOUR ACCOUNT',
    searchLabel: 'FIND YOUR BUSINESS ON GOOGLE',
    searchPh: 'E.g.: Brickell Kitchen, Miami…',
    searching: 'Searching…',
    notInGoogle: 'My business is not on Google →',
    backToSearch: '← Back to Google search',
    confirmQ: 'Is this your business?',
    confirmYes: 'Yes, continue →',
    searchOther: 'Search again',
    hoursImported: 'Hours imported from Google ✓',
    mapsLink: 'View on Google Maps ↗',
    businessName: 'BUSINESS NAME',
    category: 'CATEGORY',
    businessType: 'TYPE',
    name: 'CONTACT PERSON',
    phone: 'PHONE',
    phoneBiz: 'BUSINESS PHONE',
    phoneBizNota: "Members can see it. Don't use your personal cell.",
    address: 'ADDRESS',
    email: 'EMAIL',
    password: 'PASSWORD',
    confirmPw: 'CONFIRM PASSWORD',
    continue: 'Continue →',
    back: '← Back',
    submit: 'Register my Business →',
    loading: 'Registering...',
    loginLink: 'Already have an account?',
    loginBtn: 'Log in',
    mismatch: 'Passwords do not match',
    minPw: 'Minimum 8 characters',
    needBiz: 'Tell us your business name',
    referral: 'REFERRAL CODE (OPTIONAL)',
    needCat: 'Pick your business category',
    needType: 'Pick your type of business: we use it to build the offer we recommend.',
    catPick: 'Pick one…',
    btPick: 'Pick your type…',
    btPickCat: 'Pick the category first',
    loDijoGoogle: 'Google said so',
    deLaLanding: 'You picked it on our site',
    googleClasifica: 'Google classifies it as',
    rubroSinSenal: "Google didn't tell us what kind of business you are. Pick it yourself: we use it to build the offer we recommend.",
    rubroElige: "Pick your type of business: we use it to build the offer we recommend and the example you'll see.",
    rubroDeGoogle: "We took it from Google. If it's not quite you, change it: we use it to build the offer we recommend.",
    rubroDeLanding: "We brought it from the industry you picked on our site. If it's not quite you, change it: we use it to build the offer we recommend.",
    rubroPorPrecio: 'Google marks this place as expensive, so we are proposing "Fine dining / upscale" instead of casual. If that is not you, change it.',
    sinCosto: 'No cost and no lock-in: pause or pull your offer whenever you want.',
    trasEnviar: 'When you submit, your business is registered and goes through our review: we call the business phone or email you to confirm you are authorized by the business. Meanwhile you can start preparing your offers: nothing goes live until we confirm and approve it.',
    detailsErr: "Couldn't fetch details from Google. Try again or enter manually.",
    nombreDeGoogle: 'HOW MEMBERS WILL SEE YOU',
    nombreAyuda: 'We pulled this from Google. If it is misspelled or out of date, fix it here.',
    backMembers: '← Back to member login',
    partialTitle: '✅ Your account was created',
    partialBody: "Some of your business details couldn't be imported — complete them in Edit Profile.",
    partialCta: 'Go to my dashboard →',
    absorbTitle: 'Your business was already on NXT',
    absorbBody: 'Your business was already on NXT with your advisor: we continue with that listing. What it already had is kept, and what you just entered is saved.',
    absorbCta: 'Go to my dashboard →',
    takenTitle: 'That business already has an owner on NXT',
    takenBody: 'That business already has an owner on NXT. Message us on WhatsApp and we will look into it.',
    takenWa: 'Message us on WhatsApp',
    takenPanel: 'Go to my dashboard →',
    takenWaMsg: (nombre, negocio) => `Hi, I am ${nombre} from ${negocio}. When signing up on NXT Reserve it says my business already has an owner. Can you check?`
  };
  const CATEGORY_LABELS = lang === 'es'
    ? { Restaurant: 'Restaurante', Salon_Spa: 'Salón / Spa', Bar_Rooftop: 'Bar / Rooftop', Experience: 'Experiencia', Nail_Lash: 'Nail / Lash Studio', Sweets: 'Dulces y heladerías · con vitrina', Gift_Moments: 'Celebraciones · tortas, arreglos, flores, globos' }
    : { Restaurant: 'Restaurant', Salon_Spa: 'Salon / Spa', Bar_Rooftop: 'Bar / Rooftop', Experience: 'Experience', Nail_Lash: 'Nail / Lash Studio', Sweets: 'Sweets & ice cream · walk-in', Gift_Moments: 'Celebrations · cakes, arrangements, flowers, balloons' };

  const handleChange = e => { setForm(f => ({ ...f, [e.target.name]: e.target.value })); setError(''); };
  const onCategory = e => {
    const cat = e.target.value;
    // s189-D · Sin `DEFAULT_TYPE_BY_CAT`. Preseleccionar acá era pisar la corrección del
    // comercio: un barbero que cambiaba la categoría a Salón / Spa salía marcado
    // `spa_masajes` sin pedirlo. Ahora el rubro queda vacío y no deja continuar.
    setForm(f => ({ ...f, category: cat, business_type: '' }));
    setSenal(sn => ({ ...sn, fuente: "", porPrecio: false, googleSinSenal: false }));
    setError('');
  };
  const typeOptions = BUSINESS_TYPES.filter(b => b.cat === form.category);

  const pickSuggestion = async (s) => {
    setSearching(true); setPlaceErr("");
    try {
      const det = await placeDetails(s.place_id, sessionTokenRef.current);
      sessionTokenRef.current = ""; // el details cierra la sesión de Places
      if (!det) throw new Error("no_details");
      const guess = guessTaxonomyFromPlaceTypes(det.types, det.primaryType, det.priceLevel);
      const parsed = parsePlaceAddress(det);
      const { category: categoria, business_type: rubro, fuente } = resolverTaxonomiaDelAlta(guess, catLanding, btLanding);
      setSenal({
        // `primaryType` y `primaryTypeDisplayName` son contenido de Places: se MUESTRAN
        // (atribuidos, en la tarjeta de Google) y no se guardan. Igual que el rating desde
        // s172-D1. El tipo crudo se guarda EN EL ESTADO porque es la llave de TIPO_GOOGLE_ES.
        fuente,
        googleTipo: String(det.primaryType || ""),
        googleDice: (det.primaryTypeDisplayName && det.primaryTypeDisplayName.text) || "",
        porPrecio: (fuente === "primaryType" || fuente === "types") && guess.porPrecio,
        googleSinSenal: !rubro,
      });
      setPlace(det);
      setForm(f => ({
        ...f,
        business_name: (det.displayName && det.displayName.text) || s.main || f.business_name,
        category: categoria,
        business_type: rubro,
        address: parsed.address,
        phone: det.nationalPhoneNumber || f.phone,
      }));
      setMode("confirm");
      setSuggestions([]);
    } catch (e) {
      setPlaceErr(t.detailsErr);
    } finally { setSearching(false); }
  };

  const resetSearch = () => { setPlace(null); setMode("search"); setQuery(""); setSuggestions([]); setPlaceErr(""); };

  const goStep2 = () => {
    if (!form.business_name.trim()) { setError(t.needBiz); return; }
    // s189-D · SIN RUBRO NO SE SIGUE. Antes este guard no hacía falta porque siempre había
    // uno puesto — y el problema era exactamente ese: el que estaba puesto podía ser
    // inventado por el fallback. Ahora, cuando no hay señal, el campo está vacío y se pide.
    if (!form.category) { setError(t.needCat); return; }
    if (!form.business_type) { setError(t.needType); return; }
    setError(''); setStep(2);
  };

  // s215 · correo corporativo (ver correoEsCorporativoDe). s241 · una web de plataforma (Booksy, Instagram…) cuenta como «sin web».
  const dominioWeb = esPlataforma(place?.websiteUri) ? "" : hostDeWeb(place?.websiteUri);
  const dominioCorreo = (String(form.email || "").trim().toLowerCase().split("@")[1] || "");
  const correoEsCorporativo = correoEsCorporativoDe(form.email, place?.websiteUri);
  const nombreNegocio = String(form.business_name || "").trim();

  const handleSubmit = async () => {
    if (!form.business_name || !form.name || !form.email || !form.password) {
      setError(lang === 'es' ? 'Completa todos los campos requeridos' : 'Fill in all required fields');
      return;
    }
    if (form.password.length < MIN_CLAVE) { setError(t.minPw); return; }
    if (form.password !== form.confirmPassword) { setError(t.mismatch); return; }
    if (!correoEsCorporativo && !sinCorporativo) {
      setError(lang === 'es'
        ? `Usa un correo corporativo${dominioWeb ? ` de @${dominioWeb}` : " de tu negocio"}, o marca «No tengo correo corporativo».`
        : `Use a business email${dominioWeb ? ` on @${dominioWeb}` : ""}, or check “I don't have a business email”.`);
      return;
    }
    // s189-D · Red de seguridad: al paso 2 solo se llega por `goStep2`, que ya lo exige,
    // pero un alta sin rubro es un comercio sin margen y no se manda igual. Vuelve al paso 1
    // en vez de fallar en un campo que no está en pantalla.
    if (!form.category || !form.business_type) { setStep(1); setError(t.needType); return; }
    // s232 · terminos-condiciones-merchant: sin la casilla no se crea la cuenta.
    if (TERMINOS_ALIADOS.exigir && !aceptaTerminos) {
      setError(lang === 'es' ? "Para crear tu cuenta, marca que aceptas los Términos para negocios aliados." : "To create your account, check that you accept the Terms for partner businesses.");
      return;
    }

    setLoading(true); setError('');
    let profileImportFailed = false; // s175 FIX 2
    let absorbioSiembra = false;     // s230 · el merchant_id cambió tras la 2ª llamada (absorber)
    let placeTomadoMsg = null;       // s230 · PLACE_ID_TAKEN: el error_message literal de Bubble
    try {
      await signupMerchant({
        email: form.email.trim().toLowerCase(),
        password: form.password,
        name: form.name.trim(),
        business_name: form.business_name.trim(),
        category: form.category,
        address: form.address.trim(),
        phone: form.phone.trim(),
        business_type: form.business_type,
        referral_code: form.referral_code.trim(),
        terms_version: TERMINOS_ALIADOS.enviarParam ? TERMINOS_ALIADOS.version : "",
      });
      if (place) {
        // 2ª llamada encadenada (s103 §2): el payload Places restante via update_merchant_profile
        // (auth: el token quedó guardado por el auto-login de signupMerchant). Si falla NO
        // bloquea el alta: el perfil se completa después desde EDITAR PERFIL.
        // s230 · absorber (s229-D2): si el place_id elegido es de una siembra SIN dueño, Bubble apunta esta cuenta
        // a esa ficha y la vacía del alta queda Rejected. El Return del WF no lo dice: React lo sabe comparando el
        // merchant_id antes y después. Si la siembra YA tiene dueño, Bubble frena con PLACE_ID_TAKEN sin escribir nada.
        let idAntes = "";
        try { idAntes = String((await getMerchantProfile())?.merchant_id || ""); } catch (e) { idAntes = ""; }
        try {
          const parsed = parsePlaceAddress(place);
          const appHours = placeHoursToAppHours(place.regularOpeningHours);
          await updateMerchantProfile({
            phone: form.phone.trim(),
            address: parsed.address,
            business_hours: ((place.regularOpeningHours && place.regularOpeningHours.weekdayDescriptions) || []).join("\n"),
            business_hours_json: appHours ? serializeHours(appHours) : "",
            city: parsed.city,
            state: parsed.state,
            zip: parsed.zip,
            neighborhood: parsed.neighborhood,
            address_full: place.formattedAddress || "",
            category: form.category,
            business_type: form.business_type,
            website: place.websiteUri || "",
            google_maps_url: place.googleMapsUri || "",
            place_id: place.id || "",
            lat: place.location ? place.location.latitude : 0,
            lng: place.location ? place.location.longitude : 0,
          });
          if (idAntes) {
            const despues = await getMerchantProfile().catch(() => null);
            const idDespues = String(despues?.merchant_id || "");
            if (idDespues && idDespues !== idAntes) absorbioSiembra = true;
          }
        } catch (e) {
          if (e && e.code === "PLACE_ID_TAKEN") {
            // s230 · no es un fallo de importación: es una decisión de Bubble (la siembra tiene dueño). Se muestra
            // el texto literal del WF con el camino real (WhatsApp); el aviso «faltan datos» sería mentira.
            console.warn("[signup] update_merchant_profile → PLACE_ID_TAKEN:", e.message);
            placeTomadoMsg = String(e.message || "");
          } else {
            // s175 FIX 2: NO bloquea el alta (el User y el MerchantPartner ya existen y no se
            // deben abortar por esto), pero deja de ser silencioso: queda en la consola para
            // los smokes y levanta el aviso al comercio antes de entrar al panel.
            console.error("[signup] updateMerchantProfile (2a llamada Places) falló:", e);
            profileImportFailed = true;
          }
        }
      } else {
        // s256 · zona-en-tarjeta-alta-manual: sin Places, la ciudad sale de la dirección escrita. Se lee el perfil y se reenvía
        // entero (updateMerchantProfile reescribe todos los campos). No bloquea el alta: si falla, la tarjeta queda sin zona.
        const lugar = ciudadDeDireccionEscrita(form.address);
        if (lugar) {
          try {
            const p = await getMerchantProfile();
            if (p && !String(p.city || "").trim()) await updateMerchantProfile({ ...p, ...lugar });
          } catch (e) { console.warn("[signup] la ciudad de la dirección escrita no quedó en el perfil", e?.message); }
        }
      }
      // ⛔ s189-D · ACÁ VIVÍA EL AUTO-DISPARO DEL ASESOR, Y SE FUE.
      //
      // Desde s129 el alta llamaba a `ingestOfferIdeas` fire-and-forget con la URL que
      // hubiera dado Google, y mandaba al comercio a esperar. Nadie confirmaba nada. Si el
      // sitio no tenía precios —el caso NORMAL en peluquería y spa— se pagaba Firecrawl, se
      // gastaba 1 de las 10 generaciones, y salían doce ideas genéricas que eran lo primero
      // que ese comercio veía de nosotros. Y el alta manual, sin `place`, no disparaba nada:
      // ese comercio no recibía absolutamente ninguna ayuda.
      //
      // Ahora el disparo vive en `/merchant/tu-negocio`, DESPUÉS de que el comercio diga de
      // dónde salen sus precios y qué días quiere ofrecer. De paso desaparece el problema
      // que el comentario viejo describía con todas las letras: el único guard contra el
      // doble cobro era un `useRef` de este componente, que no cubre ni un F5
      // (`ingest-sin-idempotencia`). Un disparo que el comercio ordena con un botón no
      // necesita ese guard.
      //
      // s175 FIX 2 (punto 3): si el payload de Places no se persistió, el aviso sigue
      // reemplazando a la navegación automática — pero ahora el botón del aviso lleva a la
      // pantalla nueva, que es justamente donde puede arreglar la URL que no se guardó.
      // s230 · PLACE_ID_TAKEN manda sobre todo: el número de soporte sale de PricingConfig (numeroSoporte, s202).
      if (placeTomadoMsg !== null) { setPlaceTomado({ mensaje: placeTomadoMsg, wa: await numeroSoporte() }); return; }
      if (profileImportFailed) { setProfileWarn(true); return; }
      // s230 · absorbida: al panel, no al wizard. La siembra ya trae la oferta de Otto; el wizard es para empezar de cero.
      if (absorbioSiembra) { setAbsorbida(true); return; }
      // s223 · el alta termina en el WIZARD DE LA PRIMERA OFERTA (s221-D2 §0.2: reemplaza la entrada del registro).
      // Antes iba a /merchant/tu-negocio (las preguntas del asesor): si el comercio generaba propuestas ahí, el wizard
      // ya no le aparecía nunca (MerchantCreateOffer lo salta cuando hay borrador del asesor). Visto en Live, s223.
      // Un comercio recién creado no tiene ofertas: /merchant/offers/new le abre el wizard. Tu negocio sigue en su ruta.
      navigate('/merchant/offers/new');
    } catch (e) {
      setError(esClaveRechazada(e?.message) ? t.minPw : (e.message || (lang === 'es' ? 'Error al registrar' : 'Registration error')));   // s252-D1
    } finally { setLoading(false); }
  };

  const labelSt = { display: "block", fontSize: 10, color: C.muted, letterSpacing: "0.15em", marginBottom: 6, textTransform: "uppercase" };
  const inputSt = { width: "100%", padding: "14px 16px", background: C.light, border: `1px solid ${C.border}`, borderRadius: 8, color: C.black, fontSize: 15, fontFamily: "'DM Sans', sans-serif", boxSizing: "border-box" };
  const stepChip = (n, label, active) => (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <span style={{ width: 22, height: 22, borderRadius: "50%", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 700, background: active ? C.red : C.light, color: active ? C.white : C.muted, border: `1px solid ${active ? C.red : C.border}` }}>{n}</span>
      <span style={{ fontSize: 10, letterSpacing: "0.12em", color: active ? C.black : C.muted, fontWeight: active ? 700 : 400 }}>{label}</span>
    </div>
  );

  // s189-D · Tres estados, y cada uno DICE en pantalla de dónde salió lo que está puesto:
  //   · vacío            → aviso ámbar y no deja continuar (no es un error: falta elegirlo)
  //   · puesto por señal → chip «Lo dijo Google» / «Lo elegiste en nuestra web» + la pista
  //   · puesto a mano    → solo la pista, sin atribuírselo a nadie
  // El chip es el mismo recurso que ya usa el campo del nombre («Lo trajimos de Google»):
  // lo que viene de afuera se rotula como lo que es, y lo que el comercio eligió, también.
  const rubroElegido = BUSINESS_TYPES.find(x => x.key === form.business_type);
  const chipSenalSt = {
    display: "inline-block", fontSize: 10, letterSpacing: "0.08em", textTransform: "uppercase",
    fontWeight: 700, color: "var(--realce-tinta)", background: "rgba(201,168,76,0.12)",
    border: "1px solid rgba(201,168,76,0.35)", borderRadius: 999, padding: "2px 8px", marginRight: 6,
  };
  const taxonomySelectors = (
    <>
      <div style={{ marginBottom: 16 }}>
        {/* s240 · ayuda A7: la categoría decide dónde te buscan, los rubros y la oferta recomendada (COPY_s240). */}
        <div className="alta-etiqueta-con-pista">
        <label htmlFor="nxt-f51" style={{ ...labelSt, marginBottom: 0 }}>{t.category} *</label>
        <AltaPista izq texto={lang === "en" ? "It's the section where members look for you: Restaurants, Bars, Salons & spa, Experiences, Sweets or Celebrations. It sets the types in the next field and the kind of offer we recommend. Bar and restaurant at once? Pick where you want to be found: the discount covers food and non-alcoholic drinks in both. Barbershop? Salon / Spa." : "Es el cajón donde te buscan los miembros: Restaurantes, Bares, Salones y spa, Experiencias, Dulces o Celebraciones. De ella salen los rubros del siguiente campo y el tipo de oferta que te recomendamos. ¿Bar y restaurante a la vez? Elige por dónde quieres que te encuentren: el descuento aplica a comida y bebidas sin alcohol en los dos. ¿Barbería? Salón / Spa."} />
        </div>
        <select id="nxt-f51" name="category" value={form.category} onChange={onCategory} style={{ ...inputSt, cursor: "pointer" }}>
          <option value="">{t.catPick}</option>
          {SIGNUP_CATEGORIES.map(key => (
            <option key={key} value={key}>{CATEGORY_LABELS[key] || key}</option>
          ))}
          {/* Categoría fuera del canon de 6 (un `Nail_Lash` heredado, o un `?cat=` que mapeó
              a algo que después se saca de la lista): se muestra para no perderla callada. */}
          {form.category && !SIGNUP_CATEGORIES.includes(form.category) && (
            <option value={form.category}>{CATEGORY_LABELS[form.category] || form.category}</option>
          )}
        </select>
        {form.category === "Gift_Moments" && (
          <div style={{ fontSize: 12, color: C.muted, marginTop: 6, lineHeight: 1.5 }}>{LINEA_HECHO_A_PEDIDO[lang === "en" ? "en" : "es"]}</div>
        )}
      </div>
      <div style={{ marginBottom: 16 }}>
        <label htmlFor="nxt-f50" style={labelSt}>{t.businessType} *</label>
        <select id="nxt-f50" name="business_type" value={form.business_type} disabled={!form.category}
          onChange={e => { handleChange(e); setSenal(sn => ({ ...sn, fuente: "", porPrecio: false, googleSinSenal: false })); }}
          style={{ ...inputSt, cursor: form.category ? "pointer" : "not-allowed", opacity: form.category ? 1 : 0.6 }}
          aria-describedby="nxt-f50-pista">
          <option value="">{form.category ? t.btPick : t.btPickCat}</option>
          {typeOptions.map(b => (
            <option key={b.key} value={b.key}>{lang === 'es' ? b.es : b.en}</option>
          ))}
        </select>
        {/* s186 · Que la elección signifique algo. Ver el comentario de BUSINESS_TYPES:
            de este desplegable sale el margen con el que el asesor va a proponer.
            s189 · Y que se sepa quién la hizo. */}
        <div id="nxt-f50-pista" style={{ marginTop: 6, fontSize: 12, color: C.gray, lineHeight: 1.45 }}>
          {!form.business_type ? (
            <span style={{ fontSize: 13, color: C.aviso }}>{senal.googleSinSenal ? t.rubroSinSenal : t.rubroElige}</span>
          ) : (
            <>
              {senal.fuente === "landing" && <span style={chipSenalSt}>{t.deLaLanding}</span>}
              {(senal.fuente === "primaryType" || senal.fuente === "types") && <span style={chipSenalSt}>{t.loDijoGoogle}</span>}
              {rubroElegido && <span style={{ color: C.black }}>{lang === 'es' ? rubroElegido.pistaEs : rubroElegido.pistaEn}.</span>}{" "}
              {senal.fuente === "landing"
                ? t.rubroDeLanding
                : (senal.fuente === "primaryType" || senal.fuente === "types")
                  ? t.rubroDeGoogle
                  : t.rubroElige}
              {senal.porPrecio && (
                <div style={{ marginTop: 6, color: "var(--realce-tinta)" }}>{t.rubroPorPrecio}</div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );

  // s175 FIX 2 (punto 3): aviso NO bloqueante cuando la 2a llamada del alta (Places →
  // update_merchant_profile) fallo. El alta ya esta hecha y la sesion iniciada; esto solo
  // le dice al comercio que le faltan datos y lo deja entrar al panel con un click.
  // Reusa el estilo del banner dorado que ya usa el dashboard para el estado Lead —
  // sin libreria de toasts y sin tocar otro componente.
  // s230 · las salidas del alta que no van al wizard comparten la tarjeta de cierre (era solo la del aviso parcial):
  // PLACE_ID_TAKEN (WhatsApp + panel) · absorbida (panel) · importación parcial (panel, s175 FIX 2).
  const botonPanel = (texto, secundario = false) => (
    <button onClick={() => navigate('/merchant/dashboard')}
      style={{ ...(secundario ? S.btnSecondary : S.btnPrimary), width: "100%", padding: "16px", fontSize: 15, fontWeight: 700, letterSpacing: "0.05em" }}>{texto}</button>
  );
  const tarjetaCierre = (titulo, cuerpo, botones) => (
    <div style={{ background: "var(--superficie-panel)", minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 480, textAlign: "center" }}>
        <div style={{ width: 56, height: 56, background: C.red, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
          <span style={{ ...S.display, color: C.white, fontSize: 28, lineHeight: 1 }}>N</span>
        </div>
        <div style={{ background: C.white, borderRadius: 12, padding: 32, border: `1px solid ${C.border}`, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
          <div style={{ ...S.display, fontSize: 20, color: C.black, letterSpacing: "0.05em" }}>{titulo}</div>
          <div style={{ background: "rgba(201,168,76,0.10)", border: "1px solid rgba(201,168,76,0.35)", borderRadius: 10, padding: "14px 16px", margin: "20px 0 24px" }}>
            <span style={{ color: "var(--realce-tinta)", fontSize: 13, fontWeight: 500, lineHeight: 1.5 }}>{cuerpo}</span>
          </div>
          {botones}
        </div>
      </div>
    </div>
  );
  if (placeTomado) {
    const enlaceWa = `https://wa.me/${placeTomado.wa}?text=${encodeURIComponent(t.takenWaMsg(form.name.trim(), form.business_name.trim()))}`;
    return tarjetaCierre(t.takenTitle, placeTomado.mensaje || t.takenBody, (
      <>
        <a href={enlaceWa} target="_blank" rel="noopener noreferrer"
          style={{ ...S.btnPrimary, display: "block", boxSizing: "border-box", width: "100%", padding: "16px", fontSize: 15, fontWeight: 700, letterSpacing: "0.05em", textDecoration: "none", textAlign: "center", marginBottom: 12 }}>{t.takenWa}</a>
        {botonPanel(t.takenPanel, true)}
      </>
    ));
  }
  if (absorbida) return tarjetaCierre(t.absorbTitle, t.absorbBody, botonPanel(t.absorbCta));
  if (profileWarn) {
    // s223 · el botón dice «Ir a mi panel»: va al panel (antes, a tu-negocio). Desde ahí, «Nueva oferta» abre el wizard.
    return tarjetaCierre(t.partialTitle, t.partialBody, botonPanel(t.partialCta));
  }

  return (
    <div style={{ background: "var(--superficie-panel)", minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
        <div style={{ width: "100%", maxWidth: 480 }}>
          {/* Header */}
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <div style={{ width: 56, height: 56, background: C.red, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 20px" }}>
              <span style={{ ...S.display, color: C.white, fontSize: 28, lineHeight: 1 }}>N</span>
            </div>
            <div style={{ ...S.display, fontSize: 28, color: C.black, letterSpacing: "0.05em" }}>{t.title}</div>
            <div style={{ fontSize: 13, color: C.muted, marginTop: 8 }}>{t.subtitle}</div>
          </div>

          {/* s203: antes, el recuadro dorado «Founding Partners». Queda solo lo que es verdad. */}
          <div style={{ color: C.gray, fontSize: 13, lineHeight: 1.5, marginBottom: 16, textAlign: "center" }}>{t.sinCosto}</div>

          {/* Pasos */}
          <div style={{ display: "flex", justifyContent: "center", gap: 24, marginBottom: 16 }}>
            {stepChip(1, t.step1, step === 1)}
            {stepChip(2, t.step2, step === 2)}
          </div>

          <div style={{ background: C.white, borderRadius: 12, padding: 32, border: `1px solid ${C.border}`, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
            {error && (
              <div style={{ background: "rgba(200,0,30,0.08)", border: `1px solid ${C.red}`, borderRadius: 8, padding: "12px 16px", marginBottom: 20, fontSize: 13, color: C.red }}>{error}</div>
            )}

            {step === 1 && mode === "search" && (
              <>
                <div style={{ marginBottom: 6 }}>
                  <label htmlFor="nxt-f49" style={labelSt}>{t.searchLabel}</label>
                  <input id="nxt-f49" value={query} onChange={e => { setQuery(e.target.value); setPlaceErr(""); }} placeholder={t.searchPh} style={inputSt} autoFocus />
                </div>
                {searching && <div style={{ fontSize: 12, color: C.muted, padding: "6px 2px" }}>{t.searching}</div>}
                {placeErr && <div style={{ fontSize: 12, color: C.red, padding: "6px 2px" }}>{placeErr}</div>}
                {suggestions.length > 0 && (
                  <div style={{ border: `1px solid ${C.border}`, borderRadius: 8, overflow: "hidden", marginTop: 4 }}>
                    {suggestions.slice(0, 5).map(s => (
                      <div key={s.place_id} onClick={() => pickSuggestion(s)}
                        style={{ padding: "12px 14px", cursor: "pointer", borderBottom: `1px solid ${C.border}`, background: C.white }}
                        onMouseEnter={e => e.currentTarget.style.background = C.light}
                        onMouseLeave={e => e.currentTarget.style.background = C.white}>
                        <div style={{ fontSize: 14, fontWeight: 600, color: C.black }}>📍 {s.main}</div>
                        {s.secondary && <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{s.secondary}</div>}
                      </div>
                    ))}
                    <div style={{ padding: "6px 14px", textAlign: "right", background: C.white }}><AtribucionGoogleMaps /></div>
                  </div>
                )}
                <div style={{ textAlign: "center", marginTop: 20 }}>
                  <span onClick={() => { setMode("manual"); setPlace(null); setError(''); }} style={{ fontSize: 13, color: C.gray, cursor: "pointer", textDecoration: "underline" }}>{t.notInGoogle}</span>
                </div>
              </>
            )}

            {step === 1 && mode === "confirm" && place && (
              <>
                <div style={{ border: `1px solid ${C.border}`, borderRadius: 10, padding: "16px 18px", marginBottom: 16, background: C.light }}>
                  <div style={{ fontSize: 11, color: C.muted, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 8 }}>{t.confirmQ}</div>
                  <div style={{ fontSize: 17, fontWeight: 700, color: C.black }}>{(place.displayName && place.displayName.text) || form.business_name}</div>
                  {place.formattedAddress && <div style={{ fontSize: 13, color: C.gray, marginTop: 6 }}>📍 {place.formattedAddress}</div>}
                  {place.nationalPhoneNumber && <div style={{ fontSize: 13, color: C.gray, marginTop: 4 }}>📞 {place.nationalPhoneNumber}</div>}
                  {/* s189-G · Se muestra la URL YA NORMALIZADA: lo que el comercio ve en
                      esta tarjeta tiene que ser lo que se va a guardar. La cruda venía con
                      `utm_source` de Places y quedaba guardada así. */}
                  {place.websiteUri && <div style={{ fontSize: 13, color: C.gray, marginTop: 4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>🌐 {normalizeWebsiteUrl(place.websiteUri)}</div>}
                  {/* s189-B · El tipo PRINCIPAL que designa Google, el mismo que decidió el
                      rubro de abajo. Está acá para que el comercio pueda confirmar mirando en
                      vez de por inercia. En español con NUESTRO diccionario (adenda 05/09):
                      ver TIPO_GOOGLE_ES para por qué no se pide `languageCode`.
                      TOS: es contenido de Places — se muestra en vivo y no se guarda. */}
                  {etiquetaTipoGoogle(senal.googleTipo, senal.googleDice, lang) && (
                    <div style={{ fontSize: 13, color: C.gray, marginTop: 4 }}>🏷️ {t.googleClasifica}: <strong style={{ color: C.black }}>{etiquetaTipoGoogle(senal.googleTipo, senal.googleDice, lang)}</strong></div>
                  )}
                  {place.regularOpeningHours && Array.isArray(place.regularOpeningHours.weekdayDescriptions) && place.regularOpeningHours.weekdayDescriptions.length > 0 && (
                    <div style={{ fontSize: 12, color: "var(--exito)", marginTop: 6 }}>🕐 {t.hoursImported}</div>
                  )}
                  {place.googleMapsUri && (
                    <div style={{ marginTop: 8 }}>
                      <a href={place.googleMapsUri} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12, color: C.red, textDecoration: "none", fontWeight: 600 }}>{t.mapsLink}</a>
                    </div>
                  )}
                  <div style={{ marginTop: 10, textAlign: "right" }}><AtribucionGoogleMaps /></div>
                </div>

                {/* s188 - ticket `alta-con-places-no-deja-editar-el-nombre`. Hasta hoy el
                    nombre por esta ruta lo fijaba Places y no habia donde tocarlo: la unica
                    forma de tener nombre propio era la ruta manual, que NO pide sitio web.
                    Un comercio cuyo nombre en Google este viejo o mal escrito no lo podia
                    corregir al darse de alta, y es lo primero que ve de si mismo.
                    NO es limite del backend: `signup_merchant` toma `business_name` (param
                    #4) y `update_merchant_profile` lo reescribe (param #24, Step 5). Lo
                    bloqueaba esta pantalla.
                    La tarjeta de arriba se queda como esta A PROPOSITO: es el registro de
                    GOOGLE, la prueba de que el negocio es el correcto. Este campo es otra
                    cosa -- el nombre que NXT va a mostrar -- y por eso va rotulado como lo
                    que es. Si los dos difieren, es porque el comercio lo quiso.
                    El guard ya existia: `goStep2` rechaza el nombre vacio (`t.needBiz`), asi
                    que hacerlo editable no abre la puerta a un alta sin nombre. Y la 2a
                    llamada de Places NO manda `business_name`, o sea que la edicion no se
                    pisa sola. */}
                <div style={{ marginBottom: 16 }}>
                  <label htmlFor="nxt-f61" style={labelSt}>{t.nombreDeGoogle}</label>
                  <input id="nxt-f61" autoComplete="organization" name="business_name"
                    value={form.business_name} onChange={handleChange} style={inputSt} />
                  <div style={{ fontSize: 12, color: C.muted, marginTop: 6, lineHeight: 1.4 }}>{t.nombreAyuda}</div>
                </div>

                {taxonomySelectors}

                <button onClick={goStep2} style={{ ...S.btnPrimary, width: "100%", padding: "16px", fontSize: 15, fontWeight: 700, letterSpacing: "0.05em" }}>{t.confirmYes}</button>
                <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14 }}>
                  <span onClick={resetSearch} style={{ fontSize: 13, color: C.gray, cursor: "pointer", textDecoration: "underline" }}>{t.searchOther}</span>
                  <span onClick={() => { setMode("manual"); setPlace(null); }} style={{ fontSize: 13, color: C.gray, cursor: "pointer", textDecoration: "underline" }}>{t.notInGoogle}</span>
                </div>
              </>
            )}

            {step === 1 && mode === "manual" && (
              <>
                <div style={{ marginBottom: 16 }}>
                  <label htmlFor="nxt-f48" style={labelSt}>{t.businessName} *</label>
                  <input id="nxt-f48" autoComplete="organization" name="business_name" value={form.business_name} onChange={handleChange} placeholder="Ej: Brickell Kitchen" style={inputSt} />
                </div>

                {taxonomySelectors}

                <div style={{ marginBottom: 16 }}>
                  <label htmlFor="nxt-f47" style={labelSt}>{t.address}</label>
                  <input id="nxt-f47" autoComplete="street-address" name="address" value={form.address} onChange={handleChange} placeholder="1234 Brickell Ave, Miami FL" style={inputSt} />
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label htmlFor="nxt-f46" style={labelSt}>{t.phoneBiz}</label>
                  <input id="nxt-f46" autoComplete="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="305-555-1234" type="tel" style={inputSt} />
                </div>

                <button onClick={goStep2} style={{ ...S.btnPrimary, width: "100%", padding: "16px", fontSize: 15, fontWeight: 700, letterSpacing: "0.05em" }}>{t.continue}</button>
                {placesEnabled() && (
                  <div style={{ textAlign: "center", marginTop: 14 }}>
                    <span onClick={resetSearch} style={{ fontSize: 13, color: C.gray, cursor: "pointer", textDecoration: "underline" }}>{t.backToSearch}</span>
                  </div>
                )}
              </>
            )}

            {step === 2 && (
              <>
                {/* Resumen del negocio elegido */}
                <div style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "10px 14px", marginBottom: 20, background: C.light, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 700, color: C.black }}>{form.business_name}</div>
                    <div style={{ fontSize: 11, color: C.muted }}>{CATEGORY_LABELS[form.category] || form.category}</div>
                  </div>
                  <span onClick={() => setStep(1)} style={{ fontSize: 12, color: C.gray, cursor: "pointer", textDecoration: "underline" }}>{t.back}</span>
                </div>

                {/* Name + Phone */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
                  <div>
                    {/* s238 · ayudas A13: la cuenta la maneja cualquiera del negocio; se publica con el sí de quien decide (s237-D2). */}
                    <div className="alta-etiqueta-con-pista">
                    <label htmlFor="nxt-f45" style={{ ...labelSt, marginBottom: 0 }}>{t.name} *</label>
                    <AltaPista izq texto={lang === "en" ? "Whoever will run the account: the owner, the manager or whoever handles social media. Before publishing we confirm with the decision-maker." : "Quien va a manejar la cuenta: puede ser el dueño, el gerente o quien lleva las redes. Antes de publicar confirmamos con quien decide en el negocio."} />
                    </div>
                    <input id="nxt-f45" name="name" value={form.name} onChange={handleChange} placeholder="Juan Pérez" style={inputSt} />
                  </div>
                  <div>
                    <label htmlFor="nxt-f44" style={labelSt}>{t.phoneBiz}</label>
                    <input id="nxt-f44" autoComplete="tel" name="phone" value={form.phone} onChange={handleChange} placeholder="305-555-1234" type="tel" style={inputSt} aria-describedby="nxt-f44-nota" />
                    <div id="nxt-f44-nota" style={{ fontSize: 11, color: C.muted, marginTop: 4, lineHeight: 1.35 }}>{t.phoneBizNota}</div>
                  </div>
                </div>

                {/* s215 · Ali: comercios falsos o a nombre de otro. Se avisa ANTES de enviar que se verifica
                    llamando al teléfono del negocio (el que figura en Google, no el que se escribe acá) o
                    respondiendo desde el correo del negocio. */}
                <div role="note" style={{ background: "var(--aviso-tinte)", border: "1px solid var(--linea)", borderRadius: 8, padding: "12px 14px", marginBottom: 16, fontSize: 13, color: "var(--aviso-tinta)", lineHeight: 1.55 }}>
                  <b>{lang === 'es'
                    ? `Verificamos que estás autorizado por ${nombreNegocio || "el negocio"}.`
                    : `We verify that you're authorized by ${nombreNegocio || "the business"}.`}</b>{" "}
                  {lang === 'es'
                    // s227-D1 · la última frase la da la spec §10 (pase s227): con web, el correo de su dominio se aprueba
                    // solo al confirmar el código de la 1.ª oferta; sin web, no se muestra.
                    ? `Para proteger el negocio, antes de publicarlo te vamos a llamar al teléfono que aparece en Google o te vamos a escribir.${dominioWeb ? ` Si usas un correo @${dominioWeb}, tu negocio queda aprobado en cuanto confirmes el código que te enviamos al enviar tu primera oferta.` : ""}`
                    : `To protect the business, before publishing it we'll call the phone listed on Google or email you.${dominioWeb ? ` If you use an @${dominioWeb} email, your business is approved as soon as you confirm the code we send you when you submit your first offer.` : ""}`}
                </div>

                {/* Email */}
                <div style={{ marginBottom: 16 }}>
                  <label htmlFor="nxt-f43" style={labelSt}>{lang === 'es' ? "EMAIL CORPORATIVO" : "BUSINESS EMAIL"} *</label>
                  <input id="nxt-f43" autoComplete="email" name="email" value={form.email} onChange={handleChange} placeholder={`info@${dominioWeb || (lang === 'es' ? "tunegocio.com" : "yourbusiness.com")}`} type="email" style={inputSt} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
                  {dominioCorreo && !correoEsCorporativo && !sinCorporativo && (
                    <div style={{ fontSize: 12, color: "var(--aviso-tinta)", marginTop: 6 }}>
                      {lang === 'es'
                        ? (dominioWeb ? `Ese correo no es de @${dominioWeb}.` : "Ese es un correo personal, no del negocio.")
                        : (dominioWeb ? `That email isn't on @${dominioWeb}.` : "That's a personal email, not a business one.")}
                    </div>
                  )}
                  <label style={{ display: "flex", gap: 8, alignItems: "flex-start", marginTop: 10, fontSize: 13, color: C.gray, cursor: "pointer", lineHeight: 1.45 }}>
                    <input type="checkbox" checked={sinCorporativo} onChange={e => setSinCorporativo(e.target.checked)} style={{ marginTop: 2 }} />
                    <span>{lang === 'es'
                      ? "No tengo correo corporativo (mi negocio es nuevo o no tiene página web)."
                      : "I don't have a business email (my business is new or has no website)."}</span>
                  </label>
                  {sinCorporativo && (
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 4, marginLeft: 24 }}>
                      {lang === 'es' ? "Está bien: te llamamos para confirmar antes de aprobar tu negocio." : "That's fine: we'll call to confirm before approving your business."}
                    </div>
                  )}
                </div>

                {/* Password row */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 24 }}>
                  <div>
                    <label htmlFor="nxt-f42" style={labelSt}>{t.password} *</label>
                    <div style={{ position: "relative" }}>
                      <input autoComplete="new-password" id="nxt-f42" name="password" value={form.password} onChange={handleChange} type={showPw ? "text" : "password"} placeholder={lang === 'es' ? "Mín. 8" : "Min. 8"} style={inputSt} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
                      <button type="button" onClick={() => setShowPw(!showPw)} style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", color: C.muted, cursor: "pointer", fontSize: 14 }}>
                        {showPw ? "🙈" : "👁️"}
                      </button>
                    </div>
                    <div style={{ fontSize: 11, color: C.muted, marginTop: 4, lineHeight: 1.35 }}>{t.minPw}</div>
                  </div>
                  <div>
                    <label htmlFor="nxt-f41" style={labelSt}>{t.confirmPw} *</label>
                    <input autoComplete="new-password" id="nxt-f41" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} type={showPw ? "text" : "password"} placeholder="Repetir" style={inputSt} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
                  </div>
                </div>

                {/* Código de referido — T5a s129 (funnel influencers C-1 v2) */}
                <div style={{ marginBottom: 24 }}>
                  <label htmlFor="nxt-f40" style={labelSt}>{t.referral}</label>
                  <input id="nxt-f40" name="referral_code" value={form.referral_code} onChange={handleChange} placeholder={lang === 'es' ? "Ej: comercio001 — si un aliado te lo dio" : "E.g.: comercio001 — if a partner gave you one"} style={inputSt} onKeyDown={e => e.key === "Enter" && handleSubmit()} />
                </div>

                {/* s186 · Qué pasa después. Va ARRIBA del botón a propósito: es una
                    respuesta que se necesita antes de tocarlo, no después. */}
                <div style={{ background: C.light, borderRadius: 8, padding: "12px 14px", marginBottom: 16, fontSize: 12, color: C.gray, lineHeight: 1.55 }}>
                  {t.trasEnviar}
                </div>

                {/* s232 · terminos-condiciones-merchant: casilla sin marcar + enlace visible + frase expresa. */}
                {TERMINOS_ALIADOS.exigir && (
                  <label style={{ display: "flex", gap: 10, alignItems: "flex-start", margin: "4px 0 14px", fontSize: 14, color: C.black, cursor: "pointer", lineHeight: 1.45 }}>
                    <input type="checkbox" checked={aceptaTerminos} onChange={e => setAceptaTerminos(e.target.checked)} style={{ marginTop: 3, width: 18, height: 18 }} />
                    <span>
                      {lang === 'es' ? "Acepto los " : "I accept the "}
                      <a href={TERMINOS_ALIADOS.url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--accion)", fontWeight: 700 }}>
                        {lang === 'es' ? "Términos para negocios aliados" : "Terms for partner businesses"}
                      </a>
                      {lang === 'es' ? " de NXT Reserve. Al crear mi cuenta los acepto en nombre de mi negocio." : " of NXT Reserve. By creating my account I accept them on behalf of my business."}
                    </span>
                  </label>
                )}
                {/* Submit */}
                <button onClick={handleSubmit} disabled={loading || (TERMINOS_ALIADOS.exigir && !aceptaTerminos)} style={{ ...S.btnPrimary, width: "100%", padding: "16px", fontSize: 15, fontWeight: 700, letterSpacing: "0.05em", opacity: (loading || (TERMINOS_ALIADOS.exigir && !aceptaTerminos)) ? 0.7 : 1 }}>
                  {loading ? t.loading : t.submit}
                </button>
              </>
            )}
          </div>

          {/* Login link */}
          <div style={{ textAlign: "center", marginTop: 24 }}>
            <span style={{ fontSize: 13, color: C.gray }}>{t.loginLink}{" "}</span>
            <span onClick={() => navigate("/merchant/login")} style={{ fontSize: 13, color: C.red, cursor: "pointer", fontWeight: 600 }}>{t.loginBtn}</span>
          </div>

          {/* Back to members */}
          <div style={{ textAlign: "center", marginTop: 32 }}>
            <Link to="/login" style={{ fontSize: 11, color: C.muted, textDecoration: "none" }}>{t.backMembers}</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

// ============================================
// MERCHANT: TU NEGOCIO — lo que nos dice antes de que la IA lea
// s189-D · ticket `la-pantalla-de-fuentes-antes-de-generar`
// ============================================
//
// POR QUÉ EXISTE. Hasta hoy el alta disparaba el asesor SOLA, con la URL que hubiera
// dado Google, y mandaba al comercio a esperar sesenta segundos. Nadie confirmaba
// nada. Si el sitio no tenía precios —el caso normal en una peluquería o un spa— se
// pagaba el scrape, se gastaba 1 de las 10 generaciones, y salían doce ideas
// genéricas: lo primero que ese comercio veía de nosotros. Y el alta manual, sin
// Places, no disparaba nada y no recibía ninguna ayuda.
//
// LA REGLA QUE ELIGE LAS PREGUNTAS: no preguntar lo que una página web puede decir.
// Una carta dice QUÉ vende y a cuánto. No dice qué días quiere ofrecer ni qué no
// quiere tocar. Por eso son esas dos y no otras.
//
// LOS DOS CARRILES DEJAN DE SER ALTERNATIVAS. En el alta de oferta, «usa lo que ya
// tienes» y «responde unas preguntas» son un o/o. Acá son una secuencia: la carta
// dice qué vende, las respuestas dicen cuándo y con qué límites. El backend ya lo
// soportaba —`generateFromUrl` concatena las dos cosas desde s186—; lo que las
// presentaba como excluyentes era la pantalla.
//
// CERO BUBBLE. Todo viaja en `user_context`, que el WF ya declara REQUIRED.
function MerchantTuNegocio() {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();

  const [perfil, setPerfil] = useState(null);
  const [cargando, setCargando] = useState(true);

  const [sitio, setSitio] = useState("");
  const [fuente, setFuente] = useState("");          // mismo_sitio | otra_pagina | archivo | pegado | ninguna
  const [otraUrl, setOtraUrl] = useState("");
  const [archivo, setArchivo] = useState(null);
  const [pegado, setPegado] = useState("");
  const [dias, setDias] = useState([]);              // tokens sin tilde, como viven en la base
  const [todosLosDias, setTodosLosDias] = useState(false);
  const [franja, setFranja] = useState("");          // "" = cualquiera
  const [objetivo, setObjetivo] = useState("");
  const [noDescontar, setNoDescontar] = useState("");
  const [masVende, setMasVende] = useState("");
  const [precioTipico, setPrecioTipico] = useState("");
  const [ticketTN, setTicketTN] = useState("");             // s244-D7 · el ticket por persona (obligatorio)
  const [fuenteTicketTN, setFuenteTicketTN] = useState(""); // dueno | google | tipico | escrito

  const [generando, setGenerando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let vivo = true;
    getMerchantProfile()
      .then(p => { if (vivo) { setPerfil(p); setSitio(p?.website || ""); } })
      .catch(() => {})
      .finally(() => { if (vivo) setCargando(false); });
    return () => { vivo = false; };
  }, []);

  // Los días que el comercio ABRE, sacados de sus horarios reales. `parseHoursJson`
  // (el mismo de Editar Perfil) devuelve SIEMPRE los 7 con `closed` aparte de los
  // rangos, así que «día cerrado» y «día sin dato» son cosas distintas: se ofrece el
  // día si no está cerrado Y tiene alguna hora cargada. Si no queda ninguno —perfil
  // sin horarios, que es la mayoría hoy— se ofrecen los siete y listo.
  const diasQueAbre = (() => {
    const horas = parseHoursJson(perfil?.business_hours_json);
    const abiertos = horas
      .map((h, i) => ({ tok: FEED_DAY_TOKENS[i], abre: !h.closed && !!(h.r1o || h.r2o) }))
      .filter(d => d.abre)
      .map(d => d.tok);
    return abiertos.length ? abiertos : FEED_DAY_TOKENS;
  })();

  const chipDias = (on, fuerte) => ["alta-chip", on && "alta-chip--on", fuerte && "alta-chip--fuerte"].filter(Boolean).join(" ");
  const toggleDia = (tok) => {
    setTodosLosDias(false);
    setDias(d => d.includes(tok) ? d.filter(x => x !== tok) : [...d, tok]);
  };
  const toggleTodos = () => {
    setTodosLosDias(v => !v);
    setDias([]);
  };

  const t = en ? {
    titulo: "YOU'RE IN",
    entrada: "Three questions so the assistant doesn't have to guess. It takes fifteen seconds, and it's the difference between offers that sound like your business and offers that sound like anyone's.",
    p1: "Where are your prices?",
    p1nota: "This is the one that matters. If we can read your real prices, the offers come out with your numbers instead of invented ones.",
    tuSitio: "Is this your website?",
    tuSitioNota: "We brought it from Google. If it's wrong or out of date, fix it here.",
    fuenteSitio: "They're on that site",
    fuenteSitioNota: "We read it and pull out your services with their prices.",
    fuenteOtra: "They're on another page",
    fuenteOtraNota: "Your QR menu, your booking page, your Instagram — wherever the prices actually live.",
    fuenteArchivo: "I'll upload them",
    fuenteArchivoNota: "A PDF with your menu or your list of services.",
    fuentePegado: "I'll type them here",
    fuentePegadoNota: "Paste or write your services with their prices, one per line.",
    fuenteNinguna: "They're not published anywhere",
    fuenteNingunaNota: "No problem — two quick questions and we work with that.",
    phOtra: "yoursite.com/menu",
    phPegado: "Cut & style — 45.00\nGel manicure — 38.00",
    p2: "Which days do you want your offers to run?",
    p2nota: "You can change it on each offer.",
    todos: "Every day",
    p2hora: "At what time?",
    cualquierHora: "Any time",
    manana: "Morning", tarde: "Afternoon", noche: "Evening",
    p3: "What do you want out of this?",
    obj1: "Bring in new people", obj2: "Get them coming back",
    obj3: "Higher spend per visit", obj4: "Show off something new",
    p4: "Anything else we should know?",
    p4nota: "Whatever would change the offers: something you'd rather not discount, a season when you're already full, a service with room to spare.",
    masVende: "What sells best?",
    precioTipico: "What does your most requested service cost?",
    opcional: "Optional",
    generar: "Generate my offers",
    faltaFuente: "Pick where your prices are — «they're not published» counts.",
    faltaDias: "Pick the days. «Every day» is one tap.",
    leyendo: "We're reading what you gave us and drafting your offers. It usually takes about a minute.",
    aliento: "The first businesses are the ones that give a club its character. Thank you for being one.",
    calma: "Nothing gets published. You'll pick the ones you like and edit them.",
    saltar: "Skip and go to my panel",
  } : {
    titulo: "YA ESTÁS ADENTRO",
    entrada: "Tres preguntas para que el asistente no tenga que adivinar. Toma quince segundos, y es la diferencia entre ofertas que suenan a tu negocio y ofertas que suenan a cualquiera.",
    p1: "¿Dónde están tus precios?",
    p1nota: "Esta es la que importa. Si podemos leer tus precios de verdad, las ofertas salen con tus números en vez de con números inventados.",
    tuSitio: "¿Es este tu sitio?",
    tuSitioNota: "Lo trajimos de Google. Si está mal o desactualizado, corrígelo aquí.",
    fuenteSitio: "Están en ese sitio",
    fuenteSitioNota: "Lo leemos y sacamos tus servicios con sus precios.",
    fuenteOtra: "Están en otra página",
    fuenteOtraNota: "Tu menú QR, tu página de reservas, tu Instagram — donde vivan los precios de verdad.",
    fuenteArchivo: "Los subo",
    fuenteArchivoNota: "Un PDF con tu carta o tu lista de servicios.",
    fuentePegado: "Los escribo aquí",
    fuentePegadoNota: "Pega o escribe tus servicios con su precio, uno por línea.",
    fuenteNinguna: "No los tengo publicados",
    fuenteNingunaNota: "No hay problema — dos preguntas rápidas y trabajamos con eso.",
    phOtra: "tunegocio.com/carta",
    phPegado: "Corte y peinado — 45.00\nManicura semipermanente — 38.00",
    p2: "¿Qué días quieres que valgan tus ofertas?",
    p2nota: "Puedes cambiarlo en cada oferta.",
    todos: "Todos los días",
    p2hora: "¿A qué hora?",
    cualquierHora: "A cualquier hora",
    manana: "Mañana", tarde: "Tarde", noche: "Noche",
    p3: "¿Qué quieres lograr?",
    obj1: "Traer gente nueva", obj2: "Que vuelvan más seguido",
    obj3: "Que gasten más por visita", obj4: "Dar a conocer algo nuevo",
    // s189-D bis · ERA «¿hay algo que NO quieras descontar?», y esa pregunta presuponía
    // la forma de la respuesta: solo recogía prohibiciones. Un comercio tiene más para
    // decir que eso —«en verano me lleno solo», «los martes está mi mejor estilista»,
    // «me sobra cupo en pedicura»— y todo eso cambia las ofertas. Abierta recoge lo que
    // no se nos ocurrió preguntar, y la nota enseña qué sirve sin cerrarle la puerta a
    // nada. El caso de «no descontar» sigue cubierto: es uno de los tres ejemplos.
    p4: "¿Algo más que debamos saber?",
    p4nota: "Lo que sea que cambie las ofertas: algo que prefieras no descontar, una temporada en la que ya te llenas, un servicio al que le sobra cupo.",
    masVende: "¿Qué es lo que más vendes?",
    precioTipico: "¿Cuánto sale tu servicio más pedido?",
    opcional: "Opcional",
    generar: "Generar mis ofertas",
    faltaFuente: "Elige dónde están tus precios — «no los tengo publicados» también vale.",
    faltaDias: "Elige los días. «Todos los días» es un solo toque.",
    leyendo: "Estamos leyendo lo que nos diste y armando tus ofertas. Suele tardar cerca de un minuto.",
    // El minuto de espera es el único rato en que esta pantalla no le pide nada al
    // comercio. Es el lugar donde una línea cálida no interrumpe nada — y es cierta:
    // los que entran primero son los que le dan carácter a un club. Sin números, sin
    // promesas de resultado (CLAIMS_NXTR): gratitud, que es lo único que no hay que
    // demostrar después.
    aliento: "Los primeros negocios son los que le dan carácter a un club. Gracias por ser uno.",
    calma: "No se publica nada. Vas a elegir las que te gusten y editarlas.",
    saltar: "Saltar e ir a mi panel",
  };

  // El ejemplo sigue al rubro, con la misma división que ya usa el alta de oferta
  // (`SIN_CARTA`): un salón no tiene platos. Dos ejemplos y no uno, para que se vea que
  // el campo acepta cualquier cosa y no solo una prohibición.
  const phNoDescontar = SIN_CARTA.includes(perfil?.category)
    ? (en ? "Eg: don't touch the balayage · December fills up on its own" : "Ej: no toques el balayage · en diciembre me lleno solo")
    : (en ? "Eg: don't touch the ribeye · weekends fill up on their own" : "Ej: no toques el churrasco · los fines de semana se llenan solos");

  const OBJETIVOS = [
    { id: "nueva", texto: t.obj1 }, { id: "vuelvan", texto: t.obj2 },
    { id: "gasten", texto: t.obj3 }, { id: "nuevo", texto: t.obj4 },
  ];
  const FUENTES_UI = [
    { id: "mismo_sitio", icono: "🌐", nombre: t.fuenteSitio, nota: t.fuenteSitioNota, soloConSitio: true },
    { id: "otra_pagina", icono: "🔗", nombre: t.fuenteOtra, nota: t.fuenteOtraNota },
    { id: "archivo", icono: "📄", nombre: t.fuenteArchivo, nota: t.fuenteArchivoNota },
    { id: "pegado", icono: "✍️", nombre: t.fuentePegado, nota: t.fuentePegadoNota },
    { id: "ninguna", icono: "🤷", nombre: t.fuenteNinguna, nota: t.fuenteNingunaNota },
  ].filter(f => !f.soloConSitio || !!sitio.trim());

  // s244-D7 · el ticket por persona decide los tamaños (tamanosDelAsesor). Sin él no se llama a la IA.
  const ticketNumTN = parseFloat(String(ticketTN || "").replace(",", ".")) || 0;
  const tamanosTN = ticketNumTN > 0
    ? tamanosDelAsesor({ categoria: perfil?.category || "Restaurant", tipoNegocio: perfil?.business_type, porPersona: ticketNumTN, lang })
    : null;
  const listo = !!fuente && (todosLosDias || dias.length > 0) && !!tamanosTN;

  const generar = async () => {
    if (!fuente) { setError(t.faltaFuente); return; }
    if (!todosLosDias && dias.length === 0) { setError(t.faltaDias); return; }
    if (!tamanosTN) {
      setError(en ? "Write how much one person spends on average: the offer sizes come from that number."
        : "Escribe cuánto gasta una persona en promedio: de ese número salen los tamaños de las ofertas.");
      return;
    }
    setGenerando(true); setError("");
    try {
      // El PDF se lee ACÁ, en el navegador, igual que en el alta de oferta: el WF no
      // recibe archivos. Su propio chunk, bajado solo si eligió subir uno.
      let textoPrecios = pegado.trim();
      if (fuente === "archivo" && archivo) {
        const { extraerTextoPdf } = await import("./leerPdf");
        const leido = await extraerTextoPdf(archivo);
        if (leido.ok) textoPrecios = leido.texto;
        else { setError(mensajePdf(leido.motivo, en)); setGenerando(false); return; }
      }
      const rubro = perfil?.business_type || perfil?.category || "Restaurant";
      const contexto = construirContexto({
        diasValidos: todosLosDias ? [] : dias,
        franja,
        objetivo: (OBJETIVOS.find(o => o.id === objetivo) || {}).texto || "",
        extra: noDescontar.trim(),
        masVende: masVende.trim(),
        precioTipico: precioTipico.trim(),
        textoPrecios: textoPrecios.slice(0, 6000),
        lang,
      });
      const r = await pedirPropuestas({
        fuente,
        url: fuente === "otra_pagina" ? otraUrl : sitio,
        rubro,
        contexto,
        lang,
        perfil: perfil || undefined,   // s244 · texto del negocio y horario al asesor
        tamanos: tamanosTN,            // s244-D7 · los números de las cuatro tarjetas
      });
      // Se guarda el borrador y se entra A VERLO. s191: el alta ya no adivina si el
      // comercio viene a mirar su borrador o a empezar algo nuevo — lo dice la puerta.
      await persistAdvisorDraft({
        merchantId: perfil?.merchant_id || "",
        offers: withKeys(r.offers),
        selectedKeys: [],
        generatedAt: new Date().toISOString(),
      });
      navigate("/merchant/offers/new?ver=propuestas");
    } catch (e) {
      // El fallo se resuelve ACÁ, con el formulario todavía lleno: el comercio corrige
      // la fuente y reintenta. Antes esto terminaba en una pantalla vacía a los sesenta
      // segundos, sin decir qué pasó. Los textos de `advisorErrorMessage` ya mandaban a
      // «las preguntas rápidas de abajo» — recién ahora eso es cierto.
      setError(advisorErrorMessage(e, lang));
      setGenerando(false);
    }
  };

  const rotuloOpcional = <span className="fue-pregunta__opcional">{t.opcional}</span>;

  return (
    <div style={{ minHeight: "100vh", background: C.pagina, fontFamily: "var(--fuente-texto)" }}>
      <div style={{ display: "flex", alignItems: "center", padding: "16px 24px", borderBottom: `1px solid ${C.border}` }}>
        <Logo size="md" />
      </div>

      <div className="fue-cuerpo">
        {generando ? (
          <div className="fue-espera" aria-live="polite">
            <div className="fue-espera__texto">{t.leyendo}</div>
            <div className="fue-espera__barras" aria-label={en ? "Working" : "Trabajando"}>
              <div className="fue-espera__barra" /><div className="fue-espera__barra" /><div className="fue-espera__barra" />
            </div>
            <p className="fue-aliento">{t.aliento}</p>
          </div>
        ) : (
          <>
            {/* El saludo va acá y no en una pantalla aparte: esta ES la primera pantalla
                después del alta. La línea es la misma que usaba el aterrizaje. */}
            <h1 className="fue-titulo">{t.titulo}{perfil?.business_name ? <span style={{ color: C.red }}>, {perfil.business_name}</span> : null}</h1>
            <p className="fue-entrada">{t.entrada}</p>

            {/* ---- 1 · DE DÓNDE SALEN LOS PRECIOS ---- */}
            <section className="fue-pregunta">
              <h2 className="fue-pregunta__titulo"><span className="fue-pregunta__n">1</span>{t.p1}</h2>
              <p className="fue-pregunta__nota">{t.p1nota}</p>

              {!cargando && (
                <div style={{ marginBottom: 16 }}>
                  <label className="alta-etiqueta" htmlFor="fue-sitio">{t.tuSitio}</label>
                  <input id="fue-sitio" className="alta-input" inputMode="url" value={sitio}
                    onChange={e => { setSitio(e.target.value); setError(""); }} placeholder="tunegocio.com" />
                  <div className="alta-ayuda">{t.tuSitioNota}</div>
                </div>
              )}

              <div className="alta-opciones">
                {FUENTES_UI.map(f => (
                  <div key={f.id}>
                    <button type="button"
                      className={fuente === f.id ? "alta-opcion alta-opcion--elegida" : "alta-opcion"}
                      aria-pressed={fuente === f.id}
                      onClick={() => { setFuente(f.id); setError(""); }}>
                      <div className="alta-opcion__icono">{f.icono}</div>
                      <div className="alta-opcion__texto">
                        <div className="alta-opcion__nombre">{f.nombre}</div>
                        <div className="alta-opcion__nota">{f.nota}</div>
                      </div>
                    </button>
                    {/* El campo cuelga DE la opción elegida, no debajo de la lista:
                        así se ve de cuál es. */}
                    {fuente === "otra_pagina" && f.id === "otra_pagina" && (
                      <div className="fue-colgado">
                        <input className="alta-input" inputMode="url" value={otraUrl} autoFocus
                          onChange={e => { setOtraUrl(e.target.value); setError(""); }} placeholder={t.phOtra} />
                      </div>
                    )}
                    {fuente === "archivo" && f.id === "archivo" && (
                      <div className="fue-colgado">
                        <input type="file" accept=".pdf,application/pdf" style={{ fontSize: 13 }}
                          onChange={e => { setArchivo(e.target.files?.[0] || null); setError(""); }} />
                        {archivo && <div className="fue-colgado__nota" style={{ color: "var(--exito)" }}>✓ {archivo.name}</div>}
                      </div>
                    )}
                    {fuente === "pegado" && f.id === "pegado" && (
                      <div className="fue-colgado">
                        <textarea className="alta-textarea" rows={4} value={pegado} autoFocus
                          onChange={e => { setPegado(e.target.value); setError(""); }} placeholder={t.phPegado} />
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Los dos del wizard, solo cuando no hay precios de ningún lado. */}
              {fuente === "ninguna" && (
                <div className="fue-colgado" style={{ marginTop: 16 }}>
                  <div className="alta-campo">
                    <label className="alta-etiqueta" htmlFor="fue-vende">{t.masVende}</label>
                    <input id="fue-vende" className="alta-input" value={masVende}
                      onChange={e => setMasVende(e.target.value)} placeholder={en ? "Eg: cut and color" : "Ej: corte y color"} />
                  </div>
                  <div className="alta-campo" style={{ marginTop: 12 }}>
                    <label className="alta-etiqueta" htmlFor="fue-precio">{t.precioTipico}</label>
                    <input id="fue-precio" className="alta-input" inputMode="decimal" value={precioTipico}
                      onChange={e => setPrecioTipico(e.target.value)} placeholder="45" />
                  </div>
                </div>
              )}
            </section>

            {/* ---- 2 · CUÁNDO ---- */}
            <section className="fue-pregunta">
              <h2 className="fue-pregunta__titulo" id="fue-dias-rotulo"><span className="fue-pregunta__n">2</span>{t.p2}</h2>
              <p className="fue-pregunta__nota">{t.p2nota}</p>
              {/* «Todos los días» NO viene preseleccionado. Es un solo toque, así que
                  exigirlo no cuesta nada — pero tiene que ser un toque de verdad: una
                  preselección que nadie eligió no es información (s189, la misma lección
                  que sacó el rubro inventado del alta). Y dicho a propósito es una
                  respuesta útil: le avisa al asesor que tiene libertad. */}
              <div className="alta-chips" role="group" aria-labelledby="fue-dias-rotulo">
                <button type="button" aria-pressed={todosLosDias} onClick={() => { toggleTodos(); setError(""); }} className={chipDias(todosLosDias, true)}>{t.todos}</button>
                <span className="alta-chips__corte" />
                {diasQueAbre.map(tok => {
                  const i = FEED_DAY_TOKENS.indexOf(tok);
                  const etiqueta = (en ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES)[i];
                  return (
                    <button type="button" key={tok} aria-pressed={dias.includes(tok)}
                      onClick={() => { toggleDia(tok); setError(""); }} className={chipDias(dias.includes(tok))}>{etiqueta}</button>
                  );
                })}
              </div>

              <div style={{ marginTop: 14 }}>
                <div className="fue-pregunta__nota" style={{ marginBottom: 4 }} id="fue-hora-rotulo">{t.p2hora} {rotuloOpcional}</div>
                <div className="alta-chips" role="group" aria-labelledby="fue-hora-rotulo">
                  <button type="button" aria-pressed={!franja} onClick={() => setFranja("")} className={chipDias(!franja, true)}>{t.cualquierHora}</button>
                  <span className="alta-chips__corte" />
                  {[["manana", t.manana], ["tarde", t.tarde], ["noche", t.noche]].map(([id, txt]) => (
                    <button type="button" key={id} aria-pressed={franja === id} onClick={() => setFranja(franja === id ? "" : id)} className={chipDias(franja === id)}>{txt}</button>
                  ))}
                </div>
              </div>
            </section>

            {/* ---- 3 · QUÉ QUIERE, Y QUÉ NO TOCAR ---- */}
            <section className="fue-pregunta">
              <h2 className="fue-pregunta__titulo" id="fue-obj-rotulo"><span className="fue-pregunta__n">3</span>{t.p3} {rotuloOpcional}</h2>
              <div className="alta-chips" role="group" aria-labelledby="fue-obj-rotulo">
                {OBJETIVOS.map(o => (
                  <button type="button" key={o.id} aria-pressed={objetivo === o.id}
                    onClick={() => setObjetivo(objetivo === o.id ? "" : o.id)} className={chipDias(objetivo === o.id)}>{o.texto}</button>
                ))}
              </div>

              <div style={{ marginTop: 18 }}>
                <label className="alta-etiqueta" htmlFor="fue-algomas">{t.p4} {rotuloOpcional}</label>
                <textarea id="fue-algomas" className="alta-textarea" rows={2} value={noDescontar}
                  onChange={e => setNoDescontar(e.target.value)} placeholder={phNoDescontar} />
                <div className="alta-ayuda">{t.p4nota}</div>
              </div>

              {/* s244-D7 · obligatorio: los tamaños de las propuestas salen de este número, no de la IA. */}
              <div style={{ marginTop: 18 }}>
                <CampoTicketAsesor id="fue-ticket" perfil={perfil} categoria={perfil?.category || "Restaurant"}
                  tipoNegocio={perfil?.business_type} valor={ticketTN} fuente={fuenteTicketTN} en={en}
                  onCambio={(v, f) => { setTicketTN(v); setFuenteTicketTN(f); }} />
              </div>
            </section>

            {error && <div className="alta-aviso alta-aviso--error" style={{ marginBottom: 16 }}>{error}</div>}

            <div className="fue-pie">
              <button type="button" onClick={generar} disabled={!listo}
                style={{ ...S.btnPrimary, width: "100%", padding: "16px", fontSize: 15, fontWeight: 700, letterSpacing: "0.05em", opacity: listo ? 1 : 0.5, cursor: listo ? "pointer" : "default" }}>
                {t.generar}
              </button>
              <div className="fue-calma">{t.calma}</div>
              <div style={{ textAlign: "center" }}>
                <span onClick={() => navigate("/merchant/dashboard")}
                  style={{ fontSize: 13, color: C.gray, cursor: "pointer", textDecoration: "underline" }}>{t.saltar}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

// Los motivos por los que un PDF no se deja leer, en palabras del comercio. Mismo
// criterio que el alta de oferta (s186): un «no se pudo» genérico hace que lo intente
// tres veces con el mismo archivo.
function mensajePdf(motivo, en) {
  if (motivo === "NO_ES_PDF") return en
    ? "For now we can only read PDFs. If you have a photo of your list, type the prices in the option below."
    : "Por ahora solo podemos leer PDF. Si tienes una foto de tu lista, escribe los precios en la opción de abajo.";
  if (motivo === "MUY_GRANDE") return en ? "That file is too large (12 MB max)." : "Ese archivo es muy grande (máximo 12 MB).";
  return en
    ? "We couldn't read the text in that PDF — that usually means it's a scan. Type the prices in the option below and we'll draft your offers anyway."
    : "No pudimos leer el texto de ese PDF — suele pasar cuando es un escaneo. Escribe los precios en la opción de abajo y te armamos las ofertas igual.";
}

// ============================================
// MERCHANT: DASHBOARD
// ============================================

// s175 FIX 3 — clave de idempotencia del canje: ALEATORIA POR INTENTO.
// No derivarla del coupon_code: el Search del step 0 de redeem_coupon es global y el código del
// cupón lo genera React sin guard de unicidad, así que dos cupones con el mismo código harían que
// el 2º canje devolviera el cupón ajeno. El detalle completo está en redeemCoupon (api.js).
function newRedeemIdemKey() {
  return (window.crypto && window.crypto.randomUUID)
    ? `redeem-${window.crypto.randomUUID()}`
    : `redeem-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

// ============================================
// s176 FIX 2 — el alta de oferta se corta en el FRONT cuando el comercio esta bloqueado.
// Perfil todavia sin cargar (null) => NO se bloquea: un timeout de red no puede apagarle
// el alta a un comercio aprobado.
//
// 🔴 s179 L1 — LA LISTA BLANCA ESTABA AL REVES Y APAGABA A TODOS LOS COMERCIOS NUEVOS.
// `signup_merchant` escribe status = Lead (export 68), y "lead" no es "" ni "approved",
// asi que TODO comercio recien dado de alta caia en el dashboard con "Nueva Oferta"
// apagado y el cartel de "tu cuenta esta en revision". Contradecia s177-D1: un comercio
// en Lead SI puede crear ofertas — el control vive en la APROBACION, no en la creacion,
// y approve_offer Steps 6/7 ya lo imponen con MERCHANT_NOT_APPROVED.
//
// Se invierte a lista NEGRA. Por que negra y no blanca: get_merchant_profile devuelve el
// `display` de la option set, no el db_value, asi que una lista blanca se rompe callada
// el dia que alguien renombra un display.
//
// Verificado contra BUBBLE_SCHEMA (option set MerchantOnboardingStatus, 4 valores, cero
// mismatch display/db_value):  Lead · PendingReview · Approved · Rejected.
// De la lista de abajo, HOY solo existe "rejected". "blocked" y "suspended" NO estan en
// la option set: quedan como red por si se agregan, no porque existan. Si alguien busca
// esos estados en App Data y no los encuentra, es esto — no es un bug.
// ============================================
const MERCHANT_STATUS_BLOQUEADOS = ["rejected", "blocked", "suspended"];

// s179 L6.2 — PLAZO DE REVISION DE OFERTAS, en horas. Se muestra en la pantalla de
// Revisar, que hoy no contesta la pregunta "¿y ahora qué?".
// 🛑 Queda en `null` A PROPOSITO. No hay ningun SLA comprometido en ningun lado del repo
// (buscado en App.jsx, api.js y el registro de workflows), y escribir un numero aca lo
// convierte en una promesa al comercio que nadie hizo — de las que despues generan un
// reclamo. En null la frase se omite y el resto del mensaje sigue igual.
// Para encenderlo: poner las horas (p. ej. 48) y no hace falta tocar nada mas.
const REVIEW_SLA_HORAS = null;

function merchantCanCreateOffers(profile) {
  if (!profile) return true;
  const st = String(profile.status || "").trim().toLowerCase();
  return !MERCHANT_STATUS_BLOQUEADOS.includes(st);
}

// Nota al lado del CTA apagado. NO es un error: es un estado normal del onboarding, por
// eso reusa el dorado del banner Lead del dashboard y no el rojo de error.
// s179 L1: ya NO se muestra en Lead ni en PendingReview — solo en los estados bloqueados,
// donde el mensaje de "en revision" no aplica. Por eso el texto pasa a hablar de cuenta
// no habilitada, que es lo que de verdad pasa cuando esta nota aparece.
function OfferGateNote({ lang, style }) {
  return (
    <div className="mrc-candado" style={style}>
      {lang === "en"
        ? "🕐 Your account isn't enabled to publish offers. Write to us and we'll sort it out."
        : "🕐 Tu cuenta no está habilitada para publicar ofertas. Escríbenos y lo resolvemos."}
    </div>
  );
}

// ============================================
// PAGE: /merchant/bienvenida — EL ATERRIZAJE POST-ALTA (s186)
// ============================================
// Ticket `aterrizaje-post-alta-del-comercio`. Un comercio que terminaba de registrarse
// caía en el dashboard, cuyo elemento más grande le pide **validar un cupón** — lo único
// que todavía no puede hacer, porque ni siquiera publicó una oferta. Y mientras tanto
// las propuestas del asesor YA ESTÁN ESCRITAS: el alta guarda el `website` de Places,
// dispara el ingest, el WF escribe `last_advisor_json` y `get_merchant_profile` lo
// devuelve. Estaban a tres clics, detrás de «¿Cómo quieres empezar?».
//
// 🔑 ESTA PANTALLA NO LLAMA A NINGÚN WORKFLOW QUE CUESTE DINERO. Solo lee el perfil.
// Es una decisión de diseño, no una limitación:
//
//   · El guard de idempotencia del ingest (s186-D1) matchea sobre `last_advisor_json is
//     not empty`, o sea que solo cubre desde que la PRIMERA corrida terminó. Esta
//     pantalla monta segundos después de que el alta disparó el ingest, con Firecrawl y
//     Claude todavía en vuelo: justo en la ventana que el guard no cubre. Una pantalla
//     que llame acá puede pagar dos veces las dos APIs, y ese es el caso NORMAL, no el
//     raro (ticket `ingest-cached-no-cubre-la-carrera`).
//   · Sin llamada no hay doble cobro posible. Por eso esta pantalla **no depende del
//     deploy de Bubble**: se puede encender hoy.
//
// Lo que hace, entonces: espera leyendo `get_merchant_profile` a que aparezca el JSON
// que el alta ya mandó a escribir. Si no aparece, ofrece el camino manual — que es el
// wizard de tres preguntas, y funciona igual de bien.
//
// Y NO ESPERA CUANDO NO HAY NADA QUE ESPERAR: si el comercio no tiene `website`, el alta
// no pudo disparar el ingest (la `url` es su param REQUIRED), así que no hay JSON en
// camino y hacerlo mirar una barra treinta segundos sería mentirle.
const ESPERA_PASOS = 20;      // hasta 20 intentos…
const ESPERA_MS = 3000;       // …cada 3 s → ~60 s de espera máxima
const SALIDA_TRAS = 5;        // a los ~15 s ya se le ofrece no esperar

function MerchantBienvenida() {
  const lang = useLang();
  const navigate = useNavigate();
  const en = lang === "en";
  const [estado, setEstado] = useState("esperando");   // esperando | listo | vacio
  const [propuestas, setPropuestas] = useState([]);
  const [nombre, setNombre] = useState("");
  const [salida, setSalida] = useState(false);         // el «no quiero esperar»

  useEffect(() => {
    let vivo = true;
    const dormir = (ms) => new Promise((r) => setTimeout(r, ms));
    const leerPerfil = async () => {
      try { return await getMerchantProfile(); } catch (e) { return null; }
    };
    const aplicar = (draft) => {
      const lista = (draft && draft.offers) || [];
      setPropuestas(lista.slice(0, 3));
      setEstado(lista.length ? "listo" : "vacio");
    };

    (async () => {
      let perfil = await leerPerfil();
      if (!vivo) return;
      if (perfil && perfil.business_name) setNombre(perfil.business_name);

      // ¿Ya está escrito? (el ingest del alta pudo haber terminado antes que esto monte)
      let draft = readAdvisorDraft(perfil, lang);
      if (draft) { aplicar(draft); return; }

      // Sin web no hay ingest posible: no se hace esperar a nadie de gusto.
      if (!perfil || !perfil.website) { setEstado("vacio"); return; }

      for (let i = 0; i < ESPERA_PASOS && vivo; i++) {
        if (i === SALIDA_TRAS) setSalida(true);
        await dormir(ESPERA_MS);
        if (!vivo) return;
        perfil = await leerPerfil();
        if (!vivo) return;
        draft = readAdvisorDraft(perfil, lang);
        if (draft) { aplicar(draft); return; }
      }
      if (vivo) setEstado("vacio");
    })();

    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const irAlAlta = () => navigate("/merchant/offers/new?ver=propuestas");

  return (
    <div style={{ minHeight: "100vh", background: C.pagina, fontFamily: "var(--fuente-texto)", display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 24px", borderBottom: `1px solid ${C.border}` }}>
        <Logo size="md" />
      </div>

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "48px 0" }}>
        <div style={{ maxWidth: 560, margin: "0 auto", padding: "0 20px", width: "100%", boxSizing: "border-box" }}>

          <div style={{ ...S.display, fontSize: 34, color: C.black, lineHeight: 1.05, marginBottom: 10 }}>
            {en ? "YOU'RE IN" : "YA ESTÁS ADENTRO"}
            {nombre ? <span style={{ color: C.red }}>, {nombre}</span> : null}
          </div>

          {estado === "esperando" && (
            <>
              <p style={{ fontSize: 15, color: C.gray, lineHeight: 1.6, marginBottom: 28 }}>
                {en
                  ? "We're reading your website to draft your first offers. It usually takes about a minute."
                  : "Estamos leyendo tu sitio para armarte las primeras ofertas. Suele tardar cerca de un minuto."}
              </p>
              {/* Tres barras que respiran. Una barra de progreso sería mentira: no sabemos
                  cuánto tarda el scrape. Esto dice «trabajando», no «vas por el 60 %». */}
              <div style={{ display: "flex", gap: 8 }} aria-live="polite" aria-label={en ? "Working" : "Trabajando"}>
                {[0, 1, 2].map((i) => (
                  <div key={i} style={{ flex: 1, height: 6, borderRadius: 3, background: C.light, overflow: "hidden" }}>
                    <div style={{ height: "100%", width: "40%", background: C.red, borderRadius: 3, animation: `nxtLatido 1.2s ease-in-out ${i * 0.18}s infinite` }} />
                  </div>
                ))}
              </div>
              {/* La salida aparece recién cuando la espera ya se hizo larga. Ofrecerla
                  desde el segundo cero sería empujar a irse de una pantalla que estaba
                  por darle lo que vino a buscar. */}
              {salida && (
                <button onClick={irAlAlta}
                  style={{ background: "none", border: `1px solid ${C.border}`, borderRadius: 8, color: C.gray, width: "100%", padding: 12, marginTop: 20, fontSize: 13, cursor: "pointer", fontFamily: "var(--fuente-texto)" }}>
                  {en ? "I'd rather not wait — build my offer now" : "Prefiero no esperar — armar mi oferta ahora"}
                </button>
              )}
            </>
          )}

          {estado === "listo" && (
            <>
              <p style={{ fontSize: 15, color: C.gray, lineHeight: 1.6, marginBottom: 24 }}>
                {en
                  ? "We read your site and drafted these. Nothing is published — you edit and decide."
                  : "Leímos tu sitio y armamos estas. No hay nada publicado — tú las editas y decides."}
              </p>
              <div style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 24 }}>
                {propuestas.map((o, i) => (
                  <div key={o._key || i} style={{ border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px 16px", background: C.white }}>
                    <div style={{ fontSize: 15, fontWeight: 600, color: C.black, lineHeight: 1.4 }}>
                      {o.title || (en ? "Untitled draft" : "Propuesta sin título")}
                    </div>
                    {Number(o.coupon_price) > 0 || Number(o.regular_price) > 0 ? (
                      <div style={{ fontSize: 13, color: C.gray, marginTop: 4 }}>
                        {Number(o.regular_price) > 0 ? <span style={{ textDecoration: "line-through", color: C.muted }}>${Number(o.regular_price).toFixed(2)}</span> : null}
                        {Number(o.coupon_price) > 0 ? <b style={{ marginLeft: 8, color: C.black }}>${Number(o.coupon_price).toFixed(2)}</b> : null}
                      </div>
                    ) : null}
                  </div>
                ))}
              </div>
              <button onClick={irAlAlta} style={{ ...S.btnPrimary, width: "100%", padding: 16 }}>
                {en ? "Review my offers" : "Ver mis propuestas"}
              </button>
            </>
          )}

          {estado === "vacio" && (
            <>
              <p style={{ fontSize: 15, color: C.gray, lineHeight: 1.6, marginBottom: 24 }}>
                {en
                  ? "Let's build your first offer. Three quick questions and we draft it with you."
                  : "Vamos a armar tu primera oferta. Tres preguntas rápidas y la redactamos contigo."}
              </p>
              <button onClick={irAlAlta} style={{ ...S.btnPrimary, width: "100%", padding: 16 }}>
                {en ? "Create my first offer" : "Crear mi primera oferta"}
              </button>
            </>
          )}

          {/* La salida al panel siempre existe, y nunca compite con lo de arriba. */}
          <button onClick={() => navigate("/merchant/dashboard")}
            style={{ background: "none", border: "none", color: C.gray, width: "100%", padding: "14px 0 0", fontSize: 13, cursor: "pointer", fontFamily: "var(--fuente-texto)", textDecoration: "underline" }}>
            {en ? "Go to my dashboard" : "Ir a mi panel"}
          </button>

        </div>
      </div>
    </div>
  );
}

// ============================================
// LA FICHA DEL COMERCIO — los seis campos, en UN solo sitio
// ============================================
// s191. La lista nacio dentro de `MerchantProfileEdit` (s189-F). El recorrido del
// dashboard necesita EL MISMO conteo, y dos listas paralelas se desincronizan a la
// primera que alguien toque una: el comercio veria «3 de 6» en una pantalla y
// «4 de 6» en la otra, sin forma de saber cual miente.
//
// Recibe los seis booleanos ya resueltos y NO los calcula, porque los dos que
// llaman miran fuentes distintas a proposito: Perfil mira el formulario EN VIVO
// (marcar el logo apenas se sube, sin guardar) y el dashboard mira el perfil
// GUARDADO, que es lo unico que tiene.
function itemsDeFicha(ok, en) {
  return [
    { id: "nxt-f36", ok: !!ok.descripcion,
      nombre: en ? "Description" : "Descripción",
      porque: en ? "It's the first thing a member reads when they open your page."
                 : "Es lo primero que lee un miembro cuando abre tu ficha." },
    { id: "nxt-f27", ok: !!ok.logo,
      nombre: en ? "Logo" : "Logo",
      porque: en ? "Without one your business shows an empty square in the catalog."
                 : "Sin logo tu negocio sale con un recuadro vacío en el catálogo." },
    { id: "prf-horarios", ok: !!ok.horarios,
      nombre: en ? "Hours" : "Horarios",
      porque: en ? "A member who doesn't know whether you're open won't come."
                 : "Un miembro que no sabe si estás abierto no va." },
    { id: "nxt-f30", ok: !!ok.telefono,
      nombre: en ? "Phone" : "Teléfono",
      porque: en ? "It's how they call you to book." : "Es por donde te llaman para reservar." },
    { id: "nxt-f26", ok: !!ok.website,
      nombre: en ? "Website" : "Sitio web",
      porque: en ? "The assistant reads it to draft offers using your prices."
                 : "El asesor lo lee para proponerte ofertas con tus precios." },
    { id: "nxt-f25", ok: !!ok.instagram,
      nombre: en ? "Instagram" : "Instagram",
      porque: en ? "It's where members look at your photos before deciding."
                 : "Es donde el miembro mira tus fotos antes de decidir." },
  ];
}

// Los seis, leidos del perfil GUARDADO. `parseHoursJson` vive mas abajo en este
// mismo archivo: es una declaracion de funcion, asi que esta izada y se puede usar
// desde aca (igual que ya la usa `construirContexto` mas arriba).
function oksDeFichaDesdePerfil(p) {
  if (!p) return null;
  return {
    descripcion: !!(p.description_es || p.description_en),
    logo: !!p.logo,
    horarios: parseHoursJson(p.business_hours_json).some(d => d.r1o && d.r1c),
    telefono: !!p.phone,
    website: !!p.website,
    instagram: !!p.instagram,
  };
}

// ============================================
// LOS PASOS DE PUESTA EN MARCHA
// ============================================
// s191. Cuatro pasos, y los cuatro salen de datos que el dashboard YA tiene: no
// agrega una sola llamada. El de las ofertas mide PROPUESTAS GUARDADAS y se llama
// asi — contar ofertas enviadas necesitaria `getAllOffers()`, que trae el catalogo
// entero para filtrarlo en el cliente, y eso no se le carga al panel que el
// comercio abre con un cliente esperando.
//
// El ultimo paso NO es un boton: la aprobacion no depende del comercio. Ofrecerle
// una accion que no puede tomar es peor que no ofrecerle ninguna.
function MerchantPasos({ perfil, lang }) {
  const navigate = useNavigate();
  const en = lang === "en";
  if (!perfil) return null;

  const oks = oksDeFichaDesdePerfil(perfil);
  const items = itemsDeFicha(oks, en);
  const hechos = items.filter(i => i.ok).length;
  const fichaOk = hechos === items.length;

  const estado = String(perfil.status || "").trim().toLowerCase();
  const aprobado = estado === "approved";
  const rechazado = MERCHANT_STATUS_BLOQUEADOS.includes(estado);

  const hayPropuestas = !!readAdvisorDraft(perfil, lang);

  const pasos = [
    { clave: "negocio", estado: "hecho",
      nombre: en ? "Your business" : "Tu negocio",
      detalle: perfil.business_name
        ? (en ? `Registered as ${perfil.business_name}` : `Registrado como ${perfil.business_name}`)
        : (en ? "Registered" : "Registrado") },

    { clave: "ficha", estado: fichaOk ? "hecho" : "pendiente",
      nombre: en ? "Your page" : "Tu ficha",
      detalle: fichaOk
        ? (en ? "Complete" : "Completa")
        : (en ? `${hechos} of ${items.length} done` : `${hechos} de ${items.length} listos`),
      barra: Math.round((hechos / items.length) * 100),
      ir: "/merchant/profile" },

    { clave: "propuestas", estado: hayPropuestas ? "hecho" : "pendiente",
      nombre: en ? "Your offers" : "Tus propuestas",
      detalle: hayPropuestas
        ? (en ? "Saved and ready to edit" : "Guardadas y listas para editar")
        : (en ? "The assistant drafts offers using your own prices"
              : "El asesor te propone ofertas con tus propios precios"),
      ir: "/merchant/offers/new?ver=propuestas" },

    { clave: "aprobacion",
      estado: aprobado ? "hecho" : rechazado ? "atencion" : estado === "invitado" ? "pendiente" : "bloqueado",
      nombre: en ? "Approval" : "Aprobación",
      detalle: aprobado
        ? (en ? "Approved — your page is published" : "Aprobado: tu ficha está publicada")
        : rechazado
          ? (en ? "Your application was not approved. Write to us."
                : "Tu solicitud no quedó aprobada. Escríbenos.")
          // s195 · Invitado (s194-D22): la aprobación depende de él, no de nosotros.
          : estado === "invitado"
          ? (en ? "Confirm your offer above and your page goes live."
                : "Confirma tu oferta arriba y tu ficha se publica.")
          // s179 L1: en Lead y en PendingReview el comercio SI puede seguir —
          // el control vive en la aprobacion, no en la creacion. El candado dice
          // «no depende de ti», y el texto tiene que decir «segui igual».
          : (en ? "We review it and email you. Meanwhile you can keep getting everything ready."
                : "Lo revisamos y te avisamos por correo. Mientras tanto puedes seguir preparando todo.") },
  ];

  // Recorrido terminado: el bloque se va. Ver merchant.css.
  if (pasos.every(p => p.estado === "hecho")) return null;

  const MARCA = { hecho: "✓", pendiente: "○", bloqueado: "🔒", atencion: "!" };

  return (
    <section className="mrc-pasos" aria-label={en ? "Setup steps" : "Pasos de puesta en marcha"}>
      <h2 className="mrc-pasos__titulo">{en ? "GETTING SET UP" : "PARA EMPEZAR"}</h2>
      <p className="mrc-pasos__nota">
        {en ? "Nothing goes live until you send it and we approve it."
            : "No se publica nada hasta que tú lo envíes y nosotros lo aprobemos."}
      </p>

      <div className="mrc-pasos__lista">
        {pasos.map(p => {
          const clases = `mrc-paso mrc-paso--${p.estado}`;
          const dentro = (
            <>
              <span className={"mrc-paso__marca"} aria-hidden="true">{MARCA[p.estado]}</span>
              <span className="mrc-paso__texto">
                <span className="mrc-paso__nombre">{p.nombre}</span>
                <span className="mrc-paso__detalle">{p.detalle}</span>
                {p.barra != null && (
                  <span className="mrc-paso__barra">
                    <span className="mrc-paso__barra-relleno" style={{ width: `${p.barra}%` }} />
                  </span>
                )}
              </span>
              {p.ir && <span className="mrc-paso__flecha" aria-hidden="true">{"→"}</span>}
            </>
          );
          // El nombre accesible lleva el estado adentro: la marca es aria-hidden y
          // sin esto el lector anuncia «Tu ficha» sin decir que esta a medias.
          return p.ir ? (
            <button key={p.clave} type="button" className={clases}
              aria-label={`${p.nombre}: ${p.detalle}`}
              onClick={() => navigate(p.ir)}>
              {dentro}
            </button>
          ) : (
            <div key={p.clave} className={clases}>{dentro}</div>
          );
        })}
      </div>
    </section>
  );
}

// ============================================
// s216 · EL VALIDADOR, una sola pieza para el dueño (panel) y el empleado (/merchant/validar).
// Campo + «Escanear código QR» + veredicto. Lo de antes, sin cambios: la clave de idempotencia
// se crea al montar y se REGENERA después de cada canje exitoso (s175 FIX 3; sin eso el 2º canje
// reusaría la clave del anterior y el step 0 devolvería el cupón viejo), el campo recupera el foco
// (s200-B1) y el monto sale de la respuesta del canje (s201, `detalleCanje`).
// s221-D1 · `ofertas`: las aprobadas del comercio (dueño y empleado, por el canal público; null = no
// cargaron). Antes eran `umbralIds` + `montoSiempre` («todas las de hoy son umbral»): con el % eso deja de
// ser cierto, y el Return del canje trae el TOPE de un %, no lo descontado.
// EL MONTO DE LA CUENTA, OBLIGATORIO SI EL COMERCIO TIENE UN %: desde el export 125, un canje de % sin
// `bill_usd` guarda $0 (decisión de Ali). El código no dice su oferta antes de canjear (no hay WF que lo
// lea sin canjearlo), así que se pide siempre que el comercio tenga alguna oferta % aprobada.
// ============================================
const CUENTA_CONFIRMAR_DESDE = 500;   // s221 · una cuenta mayor pide confirmación (un cero de más)
// s242 · `categoria`: la del comercio (perfil), para decir «la compra» / «el pedido» aunque todavía no haya ofertas aprobadas.
function ValidadorCodigo({ en, ofertas = null, onCanje, categoria = "" }) {
  const [code, setCode] = useState("");
  const [cuenta, setCuenta] = useState("");               // s217 · monto real de la cuenta (bill_usd)
  const [confirmarCuenta, setConfirmarCuenta] = useState(null);   // s221 · el código que espera el «sí» (> $500)
  const [escaneando, setEscaneando] = useState(false);   // s215 · el escáner QR
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const redeemIdemRef = useRef(null);
  if (redeemIdemRef.current === null) redeemIdemRef.current = newRedeemIdemKey();

  // s221-D1 · los % del comercio y, si hay uno solo (o todos iguales), el cálculo en vivo.
  const pctOfertas = Array.isArray(ofertas) ? ofertas.filter(o => esPorcentaje(o) && Number(o.discount_pct) > 0) : [];
  const cuentaObligatoria = pctOfertas.length > 0;
  const soloPct = cuentaObligatoria && pctOfertas.length === ofertas.length;
  // s221 (pase 23:50 UTC) · en Restaurantes y Bares el % no se aplica al alcohol (s194-D2): la etiqueta lo dice.
  const cuentaSinAlcohol = pctOfertas.some(o => RUBROS_TICKET_MESA.includes(o.category));
  // s241 · `validar-propina`: donde no hay propina (encargos, perfil del rubro) la etiqueta no la nombra.
  const cuentaSinPropina = pctOfertas.length > 0 && pctOfertas.every(o => !perfilDelRubro(o.category).propina);
  // s241 · sin % (monto opcional): en encargos se pregunta por el pedido, no por la cuenta.
  // s242 · `dulces-sin-propina`: «sin propina» ya no quiere decir «encargo» (dulces tampoco tiene propina): se pregunta por
  // lo que diga el perfil del rubro cuando todas las ofertas lo dicen igual («el pedido», «la compra»); si no, «la cuenta».
  const todasEncargo = Array.isArray(ofertas) && ofertas.length > 0 && ofertas.every(o => esEncargo(o.category));
  const lasDelRubro = Array.isArray(ofertas) ? [...new Set(ofertas.map(o => perfilDelRubro(o.category).la.es))] : [];
  const laCuenta = lasDelRubro.length === 1 ? perfilDelRubro(ofertas[0].category).la
    : !lasDelRubro.length && categoria ? perfilDelRubro(categoria).la : { es: "la cuenta", en: "the bill" };
  const combos = [...new Map(pctOfertas.map(o => {
    const pct = Number(o.discount_pct), tope = Number(o.benefit_value_usd) || 0;
    return [`${pct}|${tope}`, { pct, tope }];
  })).values()];
  const montoCuenta = Number(String(cuenta).replace(/[$\s]/g, "").replace(",", "."));
  const calculos = montoCuenta > 0
    ? combos.map(c => ({ ...c, frase: fraseDescuentoCuenta(montoCuenta, c.pct, c.tope, en) })).filter(c => c.frase)
    : [];

  const handleRedeem = async (leido, confirmado) => {
    // s215 · el escáner QR pasa el código leído; el botón y Enter usan el del campo.
    const codigo = String(typeof leido === "string" ? leido : code).trim();
    if (!codigo) return;
    // s221-D1 · sin la cuenta no se canjea si el comercio tiene un %: Bubble guardaría $0.
    if (cuentaObligatoria && !(montoCuenta > 0)) {
      setResult({ ok: false,
        titulo: en ? "Enter the bill total" : "Escribe el total de la cuenta",
        detalle: en ? "Before tax and tip. We need it to calculate the percentage." : "Antes de impuestos y propina. Lo necesitamos para calcular el porcentaje." });
      try { const c = document.querySelector(".mrc-validar__cuenta-campo input"); if (c) c.focus(); } catch (_) { /* nada */ }
      return;
    }
    if (montoCuenta > CUENTA_CONFIRMAR_DESDE && confirmado !== true) { setConfirmarCuenta(codigo); setResult(null); return; }
    setConfirmarCuenta(null);
    setLoading(true);
    setResult(null);
    try {
      // La MISMA clave viaja en todos los reintentos de ESTE intento (doble-click, fallo de red).
      // s217 · la cuenta viaja en el MISMO canje (redeem_coupon guarda bill_usd, export 114). Vacía o 0: no viaja.
      const canje = await redeemCoupon(codigo.toUpperCase(), redeemIdemRef.current, montoCuenta > 0 ? montoCuenta : undefined);
      // Canje cerrado → clave nueva para el próximo. Si falló NO se regenera: el reintento es el mismo intento.
      redeemIdemRef.current = newRedeemIdemKey();
      setCuenta("");
      setResult({ ok: true,
        titulo: en ? "Coupon validated" : "Cupón validado",
        detalle: detalleCanje(canje, ofertas, en, montoCuenta) });
      setCode("");
      // s200-B1 · el siguiente cliente no espera un click: el campo, vacío, recupera el foco.
      try { const campo = document.querySelector(".mrc-validar__input"); if (campo) campo.focus(); }
      catch (_) { /* si no se pudo enfocar, se hace click y listo */ }
      if (onCanje) onCanje(canje);
    } catch (e) {
      const friendly = {
        COUPON_NOT_FOUND_OR_EXPIRED: en
          ? { titulo: "We couldn't validate this code",
              detalle: "It doesn't exist, was already used, expired, or belongs to another business. Ask the customer to open it again in the app." }
          : { titulo: "No pudimos validar este código",
              detalle: "No existe, ya se usó, venció, o es de otro comercio. Pide al cliente que lo abra otra vez en la app." },
        MISSING_DATA: en
          ? { titulo: "We couldn't process the code", detalle: "Check the code and try again." }
          : { titulo: "No se pudo procesar el código", detalle: "Revisa el código e inténtalo otra vez." },
        // s216 · Ola 2: el dueño le quitó el acceso al empleado.
        STAFF_DISABLED: en
          ? { titulo: "Your access is turned off", detalle: "The owner turned off your access to validate codes. Ask them to invite you again." }
          : { titulo: "Tu acceso está desactivado", detalle: "El dueño desactivó tu acceso para validar códigos. Pídele que te invite otra vez." },
        NOT_MERCHANT: en
          ? { titulo: "This account can't validate codes", detalle: "Only the business owner or their staff can validate codes." }
          : { titulo: "Esta cuenta no valida códigos", detalle: "Solo el dueño del negocio o su personal pueden validar códigos." },
      };
      setResult({ ok: false, ...(friendly[e.code] || (en
        ? { titulo: "We couldn't validate this code", detalle: "It may be invalid or already used. Ask the customer to open it again in the app." }
        : { titulo: "No pudimos validar este código", detalle: "Puede ser inválido o ya usado. Pide al cliente que lo abra otra vez en la app." })) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mrc-validar">
      <div className="mrc-validar__ancho">
        <p className="mrc-validar__rotulo">{en ? "VALIDATE" : "VALIDAR"}</p>
        <h1 className="mrc-validar__titulo">
          {en ? "Enter the customer code" : "Ingresa el código del cliente"}
        </h1>

        <div className="mrc-validar__caja">
          <input
            className="mrc-validar__input"
            value={code}
            onChange={e => setCode(e.target.value.toUpperCase())}
            onKeyDown={e => { if (e.key === "Enter" && code.trim() && !loading) handleRedeem(); }}
            placeholder="NXT-000000"
            aria-label={en ? "Customer code" : "Código del cliente"}
            autoCapitalize="characters"
            autoCorrect="off"
            spellCheck="false"
          />
          <button className="mrc-validar__boton" onClick={() => handleRedeem()} disabled={loading || !code.trim()}>
            {loading ? (en ? "Checking…" : "Validando…") : (en ? "Validate" : "Validar")}
          </button>
        </div>
        {/* s217 · Ali: el comercio quiere ver cuánto le facturaron los miembros, no cuánto regaló. El monto
            es opcional: si no se escribe, el canje es el de siempre. Va antes de validar (y vale con el QR). */}
        {/* s221-D1 · con un % aprobado el monto pasa a OBLIGATORIO, con su etiqueta y el cálculo en vivo. */}
        <label className="mrc-validar__cuenta">
          <span>{cuentaObligatoria
            ? (cuentaSinAlcohol
              ? (en ? "Food and non-alcoholic drinks total, before tax and tip" : "Total de comida y bebidas sin alcohol, antes de impuestos y propina")
              : cuentaSinPropina ? (en ? `${laCuenta.en.replace(/^the ./, c => c.slice(-1).toUpperCase())} total, before tax` : `Total ${laCuenta.es.replace(/^el /, "del ").replace(/^la /, "de la ")}, antes de impuestos`)
              : (en ? "Total before tax and tip" : "Total antes de impuestos y propina"))
            : todasEncargo ? (en ? "Order total (optional)" : "¿De cuánto fue el pedido? (opcional)")
            : laCuenta.es === "la cuenta" ? (en ? "Total bill (optional)" : "¿De cuánto fue la cuenta? (opcional)")
            : (en ? `${laCuenta.en.replace(/^the ./, c => c.slice(-1).toUpperCase())} total (optional)` : `¿De cuánto fue ${laCuenta.es}? (opcional)`)}</span>
          <span className="mrc-validar__cuenta-campo">
            <span aria-hidden="true">$</span>
            <input inputMode="decimal" value={cuenta} disabled={loading}
              required={cuentaObligatoria} aria-required={cuentaObligatoria ? "true" : undefined}
              onChange={e => { setCuenta(e.target.value.replace(/[^0-9.,]/g, "")); setConfirmarCuenta(null); }}
              onKeyDown={e => { if (e.key === "Enter" && code.trim() && !loading) handleRedeem(); }}
              placeholder="0" aria-label={en ? `Total of ${laCuenta.en} in dollars` : `Total de ${laCuenta.es} en dólares`} />
          </span>
        </label>
        {cuentaObligatoria && (
          <p className="mrc-validar__calculo" aria-live="polite">
            {calculos.length === 1 && combos.length === 1
              ? calculos[0].frase
              : calculos.length > 0
                ? calculos.map(c => `${frasePorcentaje(c.pct, c.tope, en)}: ${c.frase}`).join(" · ")
                : soloPct
                  ? (en ? `Required: write ${laCuenta.en} to calculate the discount.` : `Obligatorio: escribe ${laCuenta.es} para calcular el descuento.`)
                  : (en ? "Required for the percentage offer." : "Obligatorio para la oferta de porcentaje.")}
          </p>
        )}
        {confirmarCuenta && (
          <div className="mrc-validar__confirmar" role="alertdialog" aria-live="assertive">
            <p>{en ? `${laCuenta.en.charAt(0).toUpperCase() + laCuenta.en.slice(1)} is $${fmtUsd(montoCuenta)}. Is that right?` : `${laCuenta.es.charAt(0).toUpperCase() + laCuenta.es.slice(1)} es de $${fmtUsd(montoCuenta)}. ¿Es correcto?`}</p>
            <div className="mrc-validar__confirmar-botones">
              <button type="button" className="mrc-validar__boton" onClick={() => handleRedeem(confirmarCuenta, true)} disabled={loading}>
                {en ? "Yes, validate" : "Sí, validar"}
              </button>
              <button type="button" className="mrc-validar__corregir" onClick={() => {
                setConfirmarCuenta(null);
                try { const c = document.querySelector(".mrc-validar__cuenta-campo input"); if (c) c.focus(); } catch (_) { /* nada */ }
              }}>
                {en ? "Fix the amount" : "Corregir el monto"}
              </button>
            </div>
          </div>
        )}
        {/* s215 · Ali: canjear con QR. La cámara lee el código del cupón y valida con el mismo canje. */}
        <button type="button" className="mrc-validar__qr" onClick={() => setEscaneando(true)} disabled={loading}>
          {en ? "📷 Scan QR code" : "📷 Escanear código QR"}
        </button>
        {escaneando && (
          <EscanerQR en={en} onCerrar={() => setEscaneando(false)}
            onLeer={(c) => { setEscaneando(false); setCode(c); handleRedeem(c); }} />
        )}

        {result && (
          <div className={`mrc-validar__veredicto mrc-validar__veredicto--${result.ok ? "ok" : "error"}`} role="status">
            <span className="mrc-validar__marca" aria-hidden="true">{result.ok ? "✓" : "!"}</span>
            <div>
              <p className="mrc-validar__titulo-veredicto">{result.titulo}</p>
              <p className="mrc-validar__detalle">{result.detalle}</p>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}

// ============================================
// s216 · LA PANTALLA DEL EMPLEADO (rol MerchantStaff): solo validar. Sin panel, sin cifras, sin
// ofertas (los WFs de dueño lo rechazan igual). El nombre del comercio, si la ficha es pública.
// ============================================
function StaffValidarPage() {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  const [negocio, setNegocio] = useState(null);
  const [ofertasStaff, setOfertasStaff] = useState(null);   // s221-D1 · para saber si hay un % (cuenta obligatoria)
  useEffect(() => {
    getStaffMerchantName().then(setNegocio).catch(() => {});
    getStaffMerchantOffers().then(setOfertasStaff).catch(() => {});
  }, []);
  const salir = () => { auth.logout(); navigate("/merchant/login", { replace: true }); };
  return (
    <div style={S.page}>
      <div style={{ background: "var(--marca)", padding: "14px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12 }}>
        <Logo size="md" tono="oscuro" />
        <button type="button" onClick={salir}
          style={{ background: "none", border: "1px solid rgba(255,255,255,0.4)", color: "#fff", padding: "6px 12px", fontSize: 13, cursor: "pointer", borderRadius: 4 }}>
          {en ? "Log out" : "Salir"}
        </button>
      </div>
      {/* s227 · antes de la inauguración el nombre puede no llegar (candado de privacy): texto fijo. */}
      <p style={{ textAlign: "center", fontSize: 14, color: C.gray, margin: "18px 16px 0" }}>
        {negocio
          ? (en ? <>You validate codes for <b>{negocio}</b></> : <>Validas códigos de <b>{negocio}</b></>)
          : (en ? "You validate your business's codes." : "Validas los códigos de tu negocio.")}
      </p>
      <ValidadorCodigo en={en} ofertas={ofertasStaff} />
    </div>
  );
}

// s216 · la ruta del empleado: sesión + rol MerchantStaff. El dueño va a su panel; el resto, al login.
function StaffRoute({ children }) {
  const navigate = useNavigate();
  const [ok, setOk] = useState(false);
  useEffect(() => {
    if (!auth.isLoggedIn()) { navigate("/merchant/login", { replace: true }); return; }
    getUserProfile().then(p => {
      if (p?.role === "MerchantStaff") { try { localStorage.setItem("nxt_role", "MerchantStaff"); } catch (e) {} setOk(true); }
      else navigate(routeByRole(p?.role), { replace: true });
    }).catch(() => navigate("/merchant/login", { replace: true }));
  }, [navigate]);
  return ok ? children : null;
}

function MerchantDashboard() {
  const lang = useLang();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [canjesTick, setCanjesTick] = useState(0);   // s218 · sube con cada canje: «Mi actividad» se refresca
  // s216 · el campo, el QR y el veredicto viven en <ValidadorCodigo> (lo comparte el empleado).
  // UX del Lead (alta v2 s109, diseño s103 §2): status viaja por get_merchant_profile
  const [profile, setProfile] = useState(null);
  // s201 · LAS UMBRAL DEL COMERCIO, por id. s200 guardaba solo «la oferta unica» porque
  // `redeem_coupon` no decia a que oferta pertenecia el cupon; con el export 87 lo dice
  // (`offer_id`), asi que el veredicto funciona con cualquier cantidad. La lista sigue
  // haciendo falta para saber el TIPO: ver `detalleCanje`. null = todavia no cargo.
  const [ofertasComercio, setOfertasComercio] = useState(null);   // s221-D1 · todas, no solo los ids umbral
  const [hayOfertasTodas, setHayOfertasTodas] = useState(false);   // s227-D1 · para el aviso del correo
  // s201 · C2: para el Invitado el canje baja a una franja que se abre con un toque. Nace
  // abierta si viene del atajo «Validar» del encabezado (`?validar=1`): ese atajo existe
  // para llegar al campo y no puede aterrizar en una franja cerrada.
  const [validarAbierto, setValidarAbierto] = useState(() => {
    try { return window.location.search.indexOf("validar=1") !== -1; } catch (_) { return false; }
  });

  // s204 · «Validar» del tope ahora se dibuja tambien aca. Como esta pantalla ya esta
  // montada, no navega: avisa, y el panel abre la franja (si estaba cerrada) y lleva el
  // cursor al campo.
  useEffect(() => {
    const abrir = () => {
      setValidarAbierto(true);
      setTimeout(() => {
        try {
          const campo = document.querySelector(".mrc-validar__input");
          if (campo) { campo.scrollIntoView({ block: "center" }); campo.focus(); }
        } catch (_) { /* un atajo jamas puede romper el panel */ }
      }, 0);
    };
    window.addEventListener(EVENTO_ABRIR_VALIDAR, abrir);
    return () => window.removeEventListener(EVENTO_ABRIR_VALIDAR, abrir);
  }, []);

  useEffect(() => {
    getMerchantStats().then(s => setStats(s)).catch(() => {});
    getMerchantProfile().then(p => {
      setProfile(p);
      // Una llamada con constraints (merchant + status Approved), no el catalogo entero:
      // MerchantOffers trae getAllOffers() y filtra en el cliente, y eso en el tablero
      // seria pagar todo el catalogo para escribir una linea del veredicto.
      if (p?.merchant_id) {
        getMerchantOffers(p.merchant_id)
          .then(offs => setOfertasComercio((offs || []).filter(o => o && o._id)))
          .catch(() => {});  // sin esto el veredicto dice la frase generica, que es la de hoy
        // s227-D1 · el aviso del correo necesita saber si hay ofertas en CUALQUIER estado (las de arriba son solo las
        // Approved, y la del que falta verificar está Pending). Se cuenta solo cuando falta verificar.
        if (correoSinVerificar(p)) contarOfertasDelComercio(p.merchant_id).then(n => setHayOfertasTodas(n > 0)).catch(() => {});
      }
    }).catch(() => {});
    // s191 — el foco que pide «Validar» del tope. Va DENTRO del efecto que ya existia
    // y se lee de `window.location`: sumar un hook (useSearchParams/useRef) a una
    // pantalla que funciona es superficie nueva, y en s191 eso ya costo un revert.
    // Un efecto es el lugar donde React permite tocar el DOM, y el campo se renderiza
    // siempre, asi que para cuando esto corre ya existe.
    try {
      if (window.location.search.indexOf("validar=1") !== -1) {
        const campo = document.querySelector(".mrc-validar__input");
        if (campo) campo.focus();
      }
    } catch (_) { /* un atajo jamas puede romper el panel */ }
  }, []);
  // s192 — ESTO ERA `isLead`, y el nombre es lo que escondió el bug: decía «es Lead» y se
  // usaba como «está en revisión». La option set tiene CUATRO valores (Lead · PendingReview
  // · Approved · Rejected, ver MERCHANT_STATUS_BLOQUEADOS), así que un comercio en
  // PendingReview —el estado donde MÁS sentido tiene el aviso— no veía el banner. Y el
  // mismo dashboard ya se contradecía: MerchantPasos sí trata Lead y PendingReview igual
  // (s179 L1) y le dice «lo revisamos y te avisamos» mientras el banner desaparecía.
  //
  // Se invierte a lista NEGRA por la misma razón que la de s179: get_merchant_profile
  // devuelve el `display` de la option set, no el db_value, así que una lista blanca se
  // rompe callada el día que alguien renombra un display. Ahora las dos superficies de
  // esta pantalla comparten condición, y un `status` vacío cae del lado de «en revisión»
  // en vez de quedarse sin ningún aviso.
  //
  // 🛑 EL `!!profile` NO ES DECORATIVO (#674): `profile` nace `null` (useState de arriba) y
  // se llena async. Sin ese guard, una lista negra pura da `true` en el PRIMER render y le
  // pinta «estamos revisando tu negocio» a TODO el mundo mientras carga — incluido un
  // comercio aprobado. La pregunta no es si el bloque es render puro: es qué vale la
  // condición antes de que conteste la API.
  const estadoComercio = String(profile?.status || "").trim().toLowerCase();
  // s195 · `Invitado` (s194-D22): el comercio entró por el link de la vitrina y creó su
  // clave. No está «en revisión»: le falta CONFIRMAR su oferta, y eso lo hace acá arriba.
  // El valor lo crea la sala beta_datos; hasta que se deploye, en Live no existe.
  const esInvitado = estadoComercio === "invitado";
  const enRevision = !!profile
    && estadoComercio !== "approved"
    && !esInvitado
    && !MERCHANT_STATUS_BLOQUEADOS.includes(estadoComercio);
  // s176 FIX 2: mismo dato, pregunta distinta — enRevision pinta el banner, esto apaga el alta.
  const puedeCrearOfertas = merchantCanCreateOffers(profile);

  // s216 · el validador avisa cada canje cerrado: +1 optimista y refresco de las cifras.
  // s178 L4: el fetch pisa el optimismo con lo que dice el server; si falla, queda el +1.
  const alCanjear = () => {
    setStats(prev => (prev ? { ...prev, redeemed_30d: (Number(prev.redeemed_30d) || 0) + 1 } : prev));
    getMerchantStats().then(s => { if (s) setStats(s); }).catch(() => {});
    setCanjesTick(n => n + 1);   // s218 · «Mi actividad» v3 se vuelve a pedir con su período
  };

  // --- MI ACTIVIDAD (stats v2 s105, UI s108) ---------------------------------
  // Keys nuevas del WF get_merchant_stats v2 (YA en Live): activated_30d,
  // redeemed_30d, benefit_delivered_30d, take_charged_30d, take_pending,
  // take_rate_pct. Tolerante a keys ausentes (WF viejo / merchant nuevo => 0).
  // Derivados SIEMPRE client-side (contrato s104 §1): % de canje.
  // s203 (s193-D1, auditoría s203 🔴 #4): al comercio no se le cobra. El panel ya no lee
  // take_charged_30d / take_pending / take_rate_pct ni calcula un neto: mostraba «Tarifa NXT
  // ~X%» y «Te costó» contra el «sin comisión» del guion de Otto (GUION_OTTO_s201.md:48,97).
  // s218 · las cifras de «Mi actividad» viven ahora en <MiActividad> (stats v3 + canjes). `stats` queda para
  // el nombre del comercio en la cabecera.
  const en = lang === "en";

  return (
    <div style={S.page}>
      <MerchantHeader businessName={stats?.business_name} activePage="dashboard" />

      {/* La solicitud en revision. El panel queda navegable (s103 §2): el comercio
          puede completar su perfil mientras espera, y el aviso dice exactamente eso. */}
      {enRevision && (
        <div className="mrc-aviso">
          {en
            ? <>We received your application and we are reviewing your business. <b>Keep an eye on the business phone:</b> we'll call to confirm you're authorized by the business (or email you — reply from the business email). You can complete your profile in the meantime; we'll email you when it's approved.</>
            : <>Recibimos tu solicitud y estamos revisando tu negocio. <b>Atento al teléfono del negocio:</b> te vamos a llamar para confirmar que estás autorizado por el negocio (o te escribimos: respóndenos desde el correo corporativo). Mientras tanto puedes completar tu perfil; te avisamos por correo cuando quede aprobado.</>}
        </div>
      )}

      {/* s215 · notas 8 + 6: el aprobado, con la membresía cerrada, ve dónde está y qué sigue. */}
      {!MEMBRESIA_ABIERTA && estadoComercio === "approved" && (
        <div className="mrc-cuerpo" style={{ paddingBottom: 0 }}>
          <MerchantBienvenidaClub />
        </div>
      )}

      {/* s201 · C2 — EL INVITADO VE SU TAREA PRIMERO. Todavia no tiene nada que validar:
          lo unico que le falta es confirmar la oferta que le sembro Otto. Ver merchant.css. */}
      {esInvitado && (
        <div className="mrc-cuerpo" style={{ paddingBottom: 0 }}>
          {/* s214 · se fue la franja «¿Llegó un miembro? Valida su código.»: el Invitado todavía no tiene
              miembros (ronda 12, 4/4). Validar aparece cuando confirma (tope y barra de abajo). */}
          <MerchantConfirmarOferta profile={profile} esInvitado={esInvitado} />
        </div>
      )}

      {/* ---------- EL VALIDADOR ----------
          Abre la pantalla, y antes estaba ULTIMO: debajo de ocho tiles de
          estadisticas. Es la unica cosa que este panel hace todos los dias, con
          un cliente esperando del otro lado del mostrador. Ver merchant.css.
          s201: para el Invitado aparece cuando abre la franja de arriba. */}
      {/* s227-D1 · falta confirmar el correo (con al menos una oferta). */}
      {!esInvitado && (
        <div className="mrc-cuerpo" style={{ paddingBottom: 0 }}>
          <AvisoConfirmarCorreo perfil={profile} hayOfertas={hayOfertasTodas} en={en}
            onVerificado={() => setProfile(p => (p ? { ...p, email_verified: true } : p))} />
        </div>
      )}

      {(!esInvitado || validarAbierto) && (
      <ValidadorCodigo en={en} ofertas={ofertasComercio} onCanje={alCanjear} categoria={profile?.category} />
      )}

      <div className="mrc-cuerpo">

        {/* s191 — el recorrido, antes que las cifras: un comercio a medio configurar
            no tiene actividad que mirar todavia. Se dibuja solo si falta algo. */}
        {/* s195 · Invitado: confirma su oferta sembrada y queda activo (s194-D22). Un comercio
            Approved solo ve el bloque si tiene una umbral Pending sembrada por un operador. */}
        {/* s201: el Invitado ya lo tiene arriba del canje; aca queda el Approved con una umbral sembrada. */}
        {!esInvitado && estadoComercio === "approved" && <MerchantConfirmarOferta profile={profile} esInvitado={false} />}
        {/* s214 · «Para empezar» es el camino del alta propia («no se publica nada hasta que nosotros lo
            aprobemos», «el asesor te propone ofertas»): al Invitado le contradecía el «Un toque y queda
            lista» de arriba (ronda 12, 4/4). Para él, el único paso es confirmar. */}
        {!esInvitado && <MerchantPasos perfil={profile} lang={lang} />}

        {/* ---------- MI ACTIVIDAD ----------
            s218 · v3: lo que te trajo NXT (clientes, ventas, en camino), con período. Ver <MiActividad>. */}
        <MiActividad en={en} refrescar={canjesTick} />

        {/* ---------- LOS DOS ACCESOS ---------- */}
        <section className="mrc-seccion">
          <div className="mrc-accesos">
            <button className="mrc-acceso" onClick={() => navigate("/merchant/offers")}>
              <span className="mrc-acceso__nombre">{en ? "My offers" : "Mis ofertas"}</span>
              <span className="mrc-acceso__nota">
                {en ? "See what is published and edit it" : "Ver lo que está publicado y editarlo"}
              </span>
            </button>
            <button className="mrc-acceso" onClick={() => navigate("/merchant/offers/new")} disabled={!puedeCrearOfertas}>
              <span className={`mrc-acceso__nombre${puedeCrearOfertas ? " mrc-acceso__nombre--accion" : ""}`}>
                {en ? "Create an offer" : "Crear una oferta"}
              </span>
              <span className="mrc-acceso__nota">
                {en ? "Publish a new benefit for members" : "Publicar un beneficio nuevo para los miembros"}
              </span>
            </button>
            {/* s216 · bloque A (nota 6 de Otto): el comercio entra al club como lo ve un miembro. */}
            <button className="mrc-acceso" onClick={() => navigate("/")}>
              <span className="mrc-acceso__nombre">{en ? "See the club" : "Ver el club"}</span>
              <span className="mrc-acceso__nota">
                {en ? "The places as members see them" : "Los lugares como los ve un miembro"}
              </span>
            </button>
          </div>
          {!puedeCrearOfertas && <OfferGateNote lang={lang} style={{ marginTop: 16 }} />}
        </section>

        {/* s216 · Ola 2: el dueño invita a su personal para que valide códigos. Solo aprobado. */}
        {!esInvitado && estadoComercio === "approved" && <MerchantEquipo en={en} />}

      </div>
    </div>
  );
}

// ============================================
// s218 · «MI ACTIVIDAD» v3 — lo que te trajo NXT (ticket `panel-merchant-lo-que-te-trajo-nxt`, s217).
// La cifra grande deja de ser «Entregaste en beneficios» (se leía como «cuánto regalé») y pasa a ser los
// clientes que trajo el club. Datos: get_merchant_stats v3 (período con since/prev_since) + los canjes de
// get_merchant_redemptions v2, de donde React saca el piso de ventas (Σ min_spend) y los días fuertes (`at`).
// Los miembros DISTINTOS salen solo de stats: en los canjes `member` es el nombre de pila y dos «Ana» se confunden.
// El período lo arma el navegador del dueño (Miami): un backend workflow no sabe su zona horaria.
// ============================================
const PERIODOS_ACTIVIDAD = [
  { id: "semana", es: "Esta semana", en: "This week", antes_es: "la semana pasada", antes_en: "last week" },
  { id: "mes", es: "Este mes", en: "This month", antes_es: "el mes pasado", antes_en: "last month" },
  { id: "todo", es: "Desde que entraste", en: "Since you joined" },
];
function rangoActividad(id) {
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
  if (id === "semana") {
    const lunes = new Date(hoy); lunes.setDate(hoy.getDate() - ((hoy.getDay() + 6) % 7));   // la semana empieza el lunes
    const antes = new Date(lunes); antes.setDate(lunes.getDate() - 7);
    return { since: lunes.toISOString(), prev_since: antes.toISOString(), desde: lunes.getTime() };
  }
  if (id === "mes") {
    const uno = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
    const antes = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
    return { since: uno.toISOString(), prev_since: antes.toISOString(), desde: uno.getTime() };
  }
  return { since: "", prev_since: "", desde: 0 };
}
const DIAS_SEMANA_ES = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
const DIAS_SEMANA_EN = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function MiActividad({ en, refrescar = 0 }) {
  const [periodo, setPeriodo] = useState("mes");
  const [stats, setStats] = useState(undefined);      // undefined = cargando · null = no se pudo
  const [canjes, setCanjes] = useState([]);
  useEffect(() => {
    let vivo = true;
    const r = rangoActividad(periodo);
    setStats(undefined);
    Promise.all([
      getMerchantStats(periodo === "todo" ? null : r).catch(() => null),
      getMerchantRedemptions(1, 100).catch(() => ({ filas: [] })),
    ]).then(([s, c]) => { if (vivo) { setStats(s || null); setCanjes(c?.filas || []); } });
    return () => { vivo = false; };
  }, [periodo, refrescar]);

  const nv = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
  const usd = (v) => `$${nv(v).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
  const p = PERIODOS_ACTIVIDAD.find(x => x.id === periodo);
  const desde = rangoActividad(periodo).desde;
  const delPeriodo = canjes.filter(c => c.at >= desde);
  const visitas = nv(stats?.visits);
  const unicos = nv(stats?.unique_members);
  const volvieron = nv(stats?.returning_members);
  // Piso honesto: la cuenta real donde el dueño la anotó y, donde no, el mínimo de la oferta (lo que por lo menos gastó).
  const piso = delPeriodo.reduce((s, c) => s + (c.bill > 0 ? c.bill : c.min_spend), 0);
  const estimado = nv(stats?.sales_estimate_usd);
  const real = nv(stats?.sales_real_usd), realN = nv(stats?.sales_real_count);
  const descuento = nv(stats?.discount_usd);
  const enCamino = nv(stats?.active_now);
  const diferencia = periodo !== "todo" ? visitas - nv(stats?.prev_visits) : null;
  // Antes del primer canje (membresía cerrada) no se muestran ceros gigantes: se dice qué va a pasar.
  const sinCanjesNunca = stats && nv(stats.total_coupons_redeemed) === 0 && enCamino === 0;

  // Día fuerte: solo si dice algo — con 4 canjes o más en el período (Ali, s218), un día con 2 o más que gana solo
  // (o empatado con uno). Pocos canjes, o repartidos uno por día, no son un patrón.
  const porDia = [0, 0, 0, 0, 0, 0, 0];
  delPeriodo.forEach(c => { porDia[new Date(c.at).getDay()]++; });
  const maxDia = Math.max(...porDia);
  const empatados = porDia.map((n, i) => (n === maxDia ? i : -1)).filter(i => i >= 0);
  const diasFuertes = delPeriodo.length >= 4 && maxDia >= 2 && empatados.length <= 2 ? empatados : [];
  const nombresDias = (en ? DIAS_SEMANA_EN : DIAS_SEMANA_ES);

  return (
    <section className="mrc-seccion" aria-labelledby="mrc-act-titulo">
      <div className="mrc-seccion__encabezado">
        <h2 id="mrc-act-titulo" className="mrc-seccion__titulo">{en ? "MY ACTIVITY" : "MI ACTIVIDAD"}</h2>
        {!sinCanjesNunca && (
          <div className="mrc-act__periodos" role="group" aria-label={en ? "Period" : "Período"}>
            {PERIODOS_ACTIVIDAD.map(x => (
              <button key={x.id} type="button" aria-pressed={periodo === x.id} onClick={() => setPeriodo(x.id)}>{en ? x.en : x.es}</button>
            ))}
          </div>
        )}
      </div>

      {stats === undefined && <p className="mrc-seccion__nota">{en ? "Loading…" : "Cargando…"}</p>}
      {stats === null && <p className="mrc-seccion__nota">{en ? "We couldn't load your activity. Reload the page." : "No pudimos cargar tu actividad. Recarga la página."}</p>}

      {stats && sinCanjesNunca && (
        <div className="mrc-act__espera">
          <b>{en ? "Your first members are on their way." : "Tus primeros miembros vienen en camino."}</b>
          {MEMBRESIA_ABIERTA
            ? (en ? " When a member redeems here, you'll see how many came, what they spent and which days are strongest." : " Cuando un miembro canjee aquí, vas a ver cuántos vinieron, cuánto gastaron y qué días son los fuertes.")
            : (en ? " Members will see you the day we open the membership, and we'll let you know before. From then on, here you'll see how many came and what they spent." : " Los miembros te van a ver el día que abramos la membresía, y te avisamos antes. Desde ahí, aquí vas a ver cuántos vinieron y cuánto gastaron.")}
        </div>
      )}

      {stats && !sinCanjesNunca && (
        <>
          <div className="mrc-act__principal">
            <div className="mrc-act__cifra">{visitas}</div>
            <div className="mrc-act__que">
              <b>{en ? (visitas === 1 ? "client NXT brought you" : "clients NXT brought you") : (visitas === 1 ? "cliente te trajo NXT" : "clientes te trajo NXT")}</b>
              <span>
                {en ? `${unicos} different ${unicos === 1 ? "member" : "members"} · ${volvieron} came back` : `${unicos} ${unicos === 1 ? "miembro distinto" : "miembros distintos"} · ${volvieron} ${volvieron === 1 ? "volvió" : "volvieron"}`}
              </span>
              {diferencia !== null && (
                <span className={diferencia > 0 ? "mrc-act__sube" : ""}>
                  {diferencia === 0 ? (en ? `Same as ${p.antes_en}` : `Igual que ${p.antes_es}`)
                    : `${diferencia > 0 ? "+" : "−"}${Math.abs(diferencia)} ${en ? `vs ${p.antes_en}` : `vs ${p.antes_es}`}`}
                </span>
              )}
            </div>
          </div>

          <dl className="mrc-act__datos">
            <div>
              <dt>{en ? "Sales with NXT members" : "Ventas con miembros NXT"}</dt>
              <dd>
                {realN > 0 && realN >= visitas
                  ? <>{usd(real)} <small>{en ? "what members spent, as you recorded it" : "lo que gastaron, según lo que anotaste"}</small></>
                  : <>{en ? "At least " : "Al menos "}{usd(piso)} <small>{realN > 0
                      ? (en ? `${usd(real)} recorded in ${realN} of ${visitas} visits; the rest, the offer's minimum` : `${usd(real)} anotados en ${realN} de ${visitas} visitas; el resto, el mínimo de la oferta`)
                      : (en ? "each member spent at least the offer's minimum" : "cada miembro gastó por lo menos el mínimo de la oferta")}</small></>}
                {/* s237 · tu-mesa-promedio: sales_estimate_usd = visitas × avg_ticket_usd, que desde s236 es por persona. */}
                {realN < visitas && estimado > piso && <small className="mrc-act__linea">{en ? `≈ ${usd(estimado)} if each visit spent your average per person` : `≈ ${usd(estimado)} si cada visita gastó tu ticket promedio por persona`}</small>}
              </dd>
            </div>
            <div>
              <dt>{en ? "On their way" : "En camino"}</dt>
              <dd>{enCamino} <small>{en ? (enCamino === 1 ? "member has your coupon active" : "members have your coupon active") : (enCamino === 1 ? "miembro tiene tu cupón activo" : "miembros tienen tu cupón activo")}</small></dd>
            </div>
            {diasFuertes.length > 0 && (
              <div>
                <dt>{en ? "Your strongest day" : "Tu día fuerte"}</dt>
                <dd>{diasFuertes.map(i => nombresDias[i]).join(en ? " and " : " y ")}</dd>
              </div>
            )}
          </dl>

          <p className="mrc-act__descuento">
            {en ? `Invested in discounts: ${usd(descuento)}.` : `Inversión en descuentos: ${usd(descuento)}.`}
            {descuento > 0 && piso > 0 && (en
              ? ` For every $1 of discount, ${realN >= visitas ? "" : "at least "}$${(piso / descuento).toFixed(1)} in sales.`
              : ` Por cada $1 de descuento, ${realN >= visitas ? "" : "al menos "}$${(piso / descuento).toFixed(1)} en ventas.`)}
          </p>

          {delPeriodo.length > 0 && (
            <div className="mrc-act__canjes">
              <h3>{en ? "Latest visits" : "Últimas visitas"}</h3>
              <ul>
                {delPeriodo.slice(0, 5).map((c, i) => (
                  <li key={`${c.code}-${i}`}>
                    <span className="mrc-act__canje-quien">{c.member || (en ? "A member" : "Un miembro")}</span>
                    <span className="mrc-act__canje-cuando">
                      {new Date(c.at).toLocaleString(en ? "en-US" : "es-US", { weekday: "short", day: "numeric", month: "short", hour: "numeric", minute: "2-digit" })}
                      {c.by_name ? ` · ${en ? "validated by" : "validó"} ${c.by_name}${c.by_role === "staff" ? (en ? " (staff)" : " (empleado)") : ""}` : ""}
                    </span>
                    <span className="mrc-act__canje-monto">{c.bill > 0 ? usd(c.bill) : `${en ? "min." : "mín."} ${usd(c.min_spend)}`}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}

      <p className="mrc-tarifa">
        {en
          ? "No monthly fee and no commission: your only cost is the discount, and only when a member comes."
          : "Sin mensualidad y sin comisión: tu único costo es el descuento, y solo cuando viene un miembro."}
      </p>
    </section>
  );
}

// ============================================
// s216 · «TU EQUIPO» — empleados que solo validan (Ola 2, deploy B). Invitar por correo, ver
// quién está activo, quitar el acceso (no borra: staff_active = no) y reactivar (reinvitar al
// mismo correo reactiva y reenvía el enlace). Tope: 10 activos (TOO_MANY_STAFF).
// ============================================
const STAFF_TOPE = 10;
function MerchantEquipo({ en }) {
  const [lista, setLista] = useState(null);      // null = cargando
  const [correo, setCorreo] = useState("");
  const [nombre, setNombre] = useState("");
  const [ocupado, setOcupado] = useState("");    // "invitar" | id del empleado
  const [msg, setMsg] = useState(null);          // { ok, texto }

  const cargar = useCallback(async () => {
    try { setLista(await listStaff()); } catch (e) { setLista([]); }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const errores = {
    NOT_OWNER: en ? "Only the business owner can manage staff." : "Solo el dueño del negocio puede manejar su equipo.",
    INVALID_EMAIL: en ? "Check the email." : "Revisa el correo.",
    TOO_MANY_STAFF: en ? `You already have ${STAFF_TOPE} active people. Turn someone off first.` : `Ya tienes ${STAFF_TOPE} personas activas. Desactiva a alguien primero.`,
    STAFF_NOT_FOUND: en ? "We couldn't find that person. Reload the page." : "No encontramos a esa persona. Recarga la página.",
  };
  // EMAIL_ALREADY_EXISTS trae su propio error_message (el correo ya es de otra cuenta).
  const textoError = (e) => errores[e.code] || e.message || (en ? "It didn't work. Try again." : "No funcionó. Inténtalo otra vez.");

  const invitar = async (email, name, id) => {
    setOcupado(id || "invitar"); setMsg(null);
    try {
      await inviteStaff(email, name);
      setMsg({ ok: true, texto: id
        ? (en ? `✅ ${email} can validate again. We re-sent the link.` : `✅ ${email} puede validar otra vez. Le reenviamos el enlace.`)
        : (en ? `✅ Invitation sent to ${email}. The link expires in 24 hours.` : `✅ Invitación enviada a ${email}. El enlace vence en 24 horas.`) });
      if (!id) { setCorreo(""); setNombre(""); }
      await cargar();
    } catch (e) {
      setMsg({ ok: false, texto: "⚠️ " + textoError(e) });
    } finally { setOcupado(""); }
  };
  const quitar = async (p) => {
    const pregunta = en
      ? `Turn off ${p.name || p.email}? They won't be able to validate codes until you invite them again.`
      : `¿Desactivar a ${p.name || p.email}? No podrá validar códigos hasta que lo invites otra vez.`;
    if (!window.confirm(pregunta)) return;
    setOcupado(p.id); setMsg(null);
    try {
      await removeStaff(p.id);
      setMsg({ ok: true, texto: en ? `✅ ${p.email} can no longer validate codes.` : `✅ ${p.email} ya no puede validar códigos.` });
      await cargar();
    } catch (e) {
      setMsg({ ok: false, texto: "⚠️ " + textoError(e) });
    } finally { setOcupado(""); }
  };

  const activos = (lista || []).filter(p => p.active === true || p.active === "yes").length;
  const lleno = activos >= STAFF_TOPE;
  const enviar = (ev) => { ev.preventDefault(); if (correo.trim() && !ocupado && !lleno) invitar(correo, nombre); };

  return (
    <section className="mrc-seccion" aria-label={en ? "Your team" : "Tu equipo"}>
      <div className="mrc-seccion__encabezado">
        <h2 className="mrc-seccion__titulo">{en ? "YOUR TEAM" : "TU EQUIPO"}</h2>
        <span className="mrc-seccion__nota">{en ? `${activos} of ${STAFF_TOPE} active` : `${activos} de ${STAFF_TOPE} activos`}</span>
      </div>
      <p style={{ fontSize: 14, color: C.gray, lineHeight: 1.5, margin: "0 0 14px" }}>
        {en ? "Invite the people who serve members. They can only validate codes: they don't see your activity or your offers."
            : "Invita a quienes atienden a los miembros. Solo pueden validar códigos: no ven tu actividad ni tus ofertas."}
      </p>
      <form onSubmit={enviar} style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 12 }}>
        <input className="alta-input" type="email" value={correo} onChange={e => setCorreo(e.target.value)}
          placeholder={en ? "their@email.com" : "su@correo.com"} aria-label={en ? "Email" : "Correo"} style={{ flex: "2 1 200px" }} />
        <input className="alta-input" type="text" value={nombre} onChange={e => setNombre(e.target.value)}
          placeholder={en ? "Name (optional)" : "Nombre (opcional)"} aria-label={en ? "Name" : "Nombre"} style={{ flex: "1 1 140px" }} />
        <button type="submit" disabled={!correo.trim() || !!ocupado || lleno}
          style={{ ...S.btnPrimary, width: "auto", padding: "10px 16px", fontSize: 14 }}>
          {ocupado === "invitar" ? (en ? "Sending…" : "Enviando…") : (en ? "Invite" : "Invitar")}
        </button>
      </form>
      {msg && <div role="status" style={{ fontSize: 13, marginBottom: 12, fontWeight: 500, color: msg.ok ? "var(--exito)" : "var(--error)" }}>{msg.texto}</div>}
      {lista === null ? (
        <div style={{ fontSize: 13, color: C.muted }}>{en ? "Loading…" : "Cargando…"}</div>
      ) : lista.length === 0 ? (
        <div style={{ fontSize: 13, color: C.muted }}>{en ? "No one yet." : "Todavía no hay nadie."}</div>
      ) : (
        <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 8 }}>
          {lista.map(p => {
            const activo = p.active === true || p.active === "yes";
            return (
              <li key={p.id} style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", border: `1px solid ${C.border}`, borderRadius: 6, padding: "10px 12px", background: C.white }}>
                <div style={{ flex: "1 1 180px", minWidth: 0, overflowWrap: "anywhere" }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{p.name || p.email}</div>
                  {p.name && <div style={{ fontSize: 12, color: C.muted }}>{p.email}</div>}
                </div>
                <span style={{ fontSize: 12, fontWeight: 600, color: activo ? "var(--exito)" : C.muted }}>
                  {activo ? (en ? "Active" : "Activo") : (en ? "Off" : "Desactivado")}
                </span>
                {activo ? (
                  <button type="button" onClick={() => quitar(p)} disabled={!!ocupado}
                    style={{ background: "none", border: "1px solid var(--error)", color: "var(--error)", padding: "6px 10px", fontSize: 12, fontWeight: 600, cursor: ocupado ? "default" : "pointer", borderRadius: 4 }}>
                    {ocupado === p.id ? "…" : (en ? "Turn off" : "Desactivar")}
                  </button>
                ) : (
                  <button type="button" onClick={() => invitar(p.email, p.name, p.id)} disabled={!!ocupado || lleno}
                    style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, fontWeight: 600, cursor: ocupado ? "default" : "pointer", borderRadius: 4 }}>
                    {ocupado === p.id ? "…" : (en ? "Reactivate" : "Reactivar")}
                  </button>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

// ============================================
// MERCHANT: EDIT PROFILE (B4.39 — 8.14/8.15 + 8.15-C)
// ============================================
const MAX_LOGO_BYTES = 2 * 1024 * 1024; // 2 MB
const OK_LOGO_TYPES = ["image/jpeg", "image/png", "image/webp"];

// M2 (s79) — categorías del merchant (keys = option set backend offercategory)
const MERCHANT_CATEGORIES = [
  { key: "Restaurant", es: "Restaurante", en: "Restaurant" },
  { key: "Salon_Spa", es: "Salón / Spa", en: "Salon / Spa" },
  { key: "Bar_Rooftop", es: "Bar / Rooftop", en: "Bar / Rooftop" },
  { key: "Experience", es: "Experiencia", en: "Experience" },
  { key: "Sweets", es: "Dulces y heladerías · con vitrina", en: "Sweets & ice cream · walk-in" },   // s241 · el cajón es la vitrina
  // s109 fix: la key era "Gifts" pero el slug real del option set OfferCategory es "Gift_Moments"
  // (el alta y el backend usan Gift_Moments; con "Gifts" el mapeo a category_option fallaba silencioso).
  { key: "Gift_Moments", es: "Celebraciones · tortas, arreglos, flores, globos", en: "Celebrations · cakes, arrangements, flowers, balloons" },   // s241 · antes «Hecho a pedido» (s237-D3)
];
// ---- s179 L4.1 · DESTACADOS: EJEMPLOS POR RUBRO -------------------------------
// Ticket `destacados-placeholders-de-restaurante`. Los tres placeholders eran
// "Chef premiado" / "Vista al mar" / "Solo 20 cupos" en CUALQUIER rubro — verificado en
// pantalla en una peluquería, donde no significan nada y el comercio no sabe qué escribir.
// El fallback es GENÉRICO a propósito, no Restaurant: caer en ejemplos de restaurante es
// exactamente el bug que se está arreglando.
const HIGHLIGHT_PLACEHOLDERS_BY_CAT = {
  Restaurant:   { es: ["Chef premiado", "Vista al mar", "Solo 20 cupos"],
                  en: ["Award-winning chef", "Ocean view", "Only 20 spots"] },
  Salon_Spa:    { es: ["Productos premium", "Cabina privada", "Incluye masaje de cuero cabelludo"],
                  en: ["Premium products", "Private room", "Includes scalp massage"] },
  Bar_Rooftop:  { es: ["Vista panorámica", "DJ en vivo", "Coctelería de autor"],
                  en: ["Panoramic view", "Live DJ", "Signature cocktails"] },
  Experience:   { es: ["Guía bilingüe", "Grupos reducidos", "Fotos incluidas"],
                  en: ["Bilingual guide", "Small groups", "Photos included"] },
  Sweets:       { es: ["Receta artesanal", "Opciones sin azúcar", "Recién hecho cada día"],
                  en: ["Artisan recipe", "Sugar-free options", "Made fresh daily"] },
  Gift_Moments: { es: ["Empaque de regalo", "Personalización gratis", "Listo para entregar"],
                  en: ["Gift wrapping", "Free personalization", "Ready to give"] },
};
const HIGHLIGHT_PLACEHOLDERS_FALLBACK = {
  es: ["Lo que te hace distinto", "Algo que se incluye", "Por qué conviene ahora"],
  en: ["What makes you different", "Something that's included", "Why it's worth it now"],
};
function highlightPlaceholders(categoria, lang) {
  const set = HIGHLIGHT_PLACEHOLDERS_BY_CAT[categoria] || HIGHLIGHT_PLACEHOLDERS_FALLBACK;
  return (lang === "en" ? set.en : set.es) || HIGHLIGHT_PLACEHOLDERS_FALLBACK.es;
}

// ---- s188 L4.3 - EL COPY DEL ALTA TAMBIEN SIGUE AL RUBRO ----------------------
// Ticket `copy-de-restaurante-en-rubros-no-gastronomicos` (+ su gemelo
// `etiqueta-de-subida-no-distingue-rubro`). Medido en produccion logueado como
// STATUS Hair (`unas_pelu_barberia`): el ORDEN de los dos carriles ya distinguia
// rubro desde s186, pero los TEXTOS de adentro no - el intro decia bien "tus
// servicios no viven en una carta" y tres lineas mas abajo los ejemplos eran
// "menu degustacion, cocteles de autor" y "evitar descuento en alcohol".
// Es L#638 exacta: la decision aterrizo en el orden y sus dependientes no se
// enteraron.
//
// UNA SOLA LISTA DE RUBROS, DOS CONSUMIDORES. `SIN_CARTA` sube aca desde adentro
// del componente para que el copy pueda leerla, y sigue siendo LA MISMA que
// decide el orden - no hay un segundo mapa que pueda desincronizarse, que es
// justo como nacio este bug. Si manana un rubro cambia de lado, cambia en un
// solo lugar y el orden Y el texto se mueven juntos.
//
// El eje es binario A PROPOSITO y es el que `SIN_CARTA` ya codificaba: "este
// rubro tiene carta?". No es el eje de los destacados de s179 (ese es por
// categoria, seis ramas) porque aca la pregunta no es "que ejemplo te sirve?"
// sino "como se llama el papel donde tienes tus precios?".
//
// LIMITE CONOCIDO Y DECLARADO: `Experience` comparte rama con `Salon_Spa`, asi
// que un tour lee ejemplos de spa. Es mejor que leer "cocteles de autor", pero
// no es correcto. Afinarlo pide mover ESTA rama al mapa por categoria de s179 -
// una decision, no un olvido.
const COPY_ALTA = {
  // Gastronomia: Restaurant, Bar_Rooftop. Los textos son
  // los que ya estaban en pantalla: para estos rubros el lote no cambia nada.
  // (s242: Gift_Moments y Sweets salieron de aca, ver `encargos` y `dulces` abajo.)
  carta: {
    es: {
      intro: "Comparte tu web o menú (o responde 3 preguntas rápidas) y te armamos 3-4 ofertas.",
      notaArchivo: "Tu web, el link de tu menú QR, un PDF, o simplemente pega tu lista de precios. Lo que tengas — lo leemos y te proponemos ofertas.",
      labelUrl: "Tu web o el link de tu menú QR",
      phUrl: "tunegocio.com — o el link que abre tu QR",
      labelPdf: "...o sube tu menú (PDF)",
      labelPegar: "...o pega tu carta o lista de precios",
      phPegar: "Ej:  Churrasco — 32.00 · Flan de la casa — 9.00\n     Copa de vino — 12.00 · Café espresso — 4.00",
      botonLeer: "Leer mi carta",
      phObjetivo: "Ej: llenar mesas entre semana",
      phMasVende: "Ej: churrasco, arroz con pollo",
      phAlgoMas: "Ej: no aplica en feriados",
      ayudaTitulo: "Lo que más te piden, con nombre. No pongas el monto: la tarjeta ya dice «Ahorra $X cuando gastas $Y».",
      phTitulo: "Ej: Churrasco con chimichurri para dos",
      phDescripcion: "Ej: Disfruta nuestro exclusivo menú degustación de 4 tiempos con maridaje...",
      ejemploBogo: "2 entradas por el precio de 1",
      phPrecioUnitario: "18",
      ayudaBogo: "Ej: Cada entrada cuesta $18 → cliente paga $18, recibe 2 entradas",
    },
    en: {
      intro: "Share your website or menu (or answer 3 quick questions) and we'll draft 3-4 offers for you.",
      notaArchivo: "Your website, the link behind your QR menu, a PDF, or just paste your price list. Whatever you have — we read it and propose offers.",
      labelUrl: "Your website or QR menu link",
      phUrl: "yoursite.com — or the link your QR opens",
      labelPdf: "...or upload your menu (PDF)",
      labelPegar: "...or paste your menu / price list",
      phPegar: "Eg:  Grilled ribs — 32.00 · House flan — 9.00\n     Glass of wine — 12.00 · Espresso — 4.00",
      botonLeer: "Read my menu",
      phObjetivo: "Eg: fill tables on weeknights",
      phMasVende: "Eg: churrasco, chicken with rice",
      phAlgoMas: "Eg: not valid on holidays",
      ayudaTitulo: "What people order most, by name. Don't add the amount: the card already says «Save $X when you spend $Y».",
      phTitulo: "Eg: Churrasco with chimichurri for two",
      phDescripcion: "Eg: Enjoy our exclusive 4-course tasting menu with wine pairing...",
      ejemploBogo: "2 appetizers for the price of 1",
      phPrecioUnitario: "18",
      ayudaBogo: "Eg: Each appetizer costs $18 → customer pays $18, gets 2 appetizers",
    },
  },
  // Sin carta: Salon_Spa y Experience. Un salon no tiene menu ni menu QR: tiene
  // lista de precios y un link donde le reservan.
  servicios: {
    es: {
      intro: "Comparte tu web o tu lista de precios (o responde 3 preguntas rápidas) y te armamos 3-4 ofertas.",
      notaArchivo: "Tu web, el link donde te reservan, un PDF, o simplemente pega tu lista de servicios y precios. Lo que tengas — lo leemos y te proponemos ofertas.",
      labelUrl: "Tu web o el link donde te reservan",
      phUrl: "tunegocio.com — o el link donde te reservan",
      notaPreguntas: "El camino más rápido para un salón, un spa o un estudio: tus servicios no viven en una carta. Tres preguntas y te las armamos.",
      labelPdf: "...o sube tu lista de precios (PDF)",
      labelPegar: "...o pega tu lista de servicios y precios",
      phPegar: "Ej:  Corte y peinado — 45.00 · Manicura semipermanente — 38.00\n     Masaje relajante 60 min — 90.00 · Facial profundo — 75.00",
      botonLeer: "Leer mi lista",
      phObjetivo: "Ej: llenar la agenda entre semana",
      phMasVende: "Ej: masaje de 60 min, paquete de 3 sesiones",
      phAlgoMas: "Ej: no hacer descuento los fines de semana",
      ayudaTitulo: "Lo que más te piden, con nombre. No pongas el monto: la tarjeta ya dice «Ahorra $X cuando gastas $Y».",
      phTitulo: "Ej: Mani-pedi en gel",
      phDescripcion: "Ej: Disfruta nuestro facial profundo de 60 minutos con productos premium...",
      ejemploBogo: "2 masajes por el precio de 1",
      phPrecioUnitario: "90",
      ayudaBogo: "Ej: Cada masaje cuesta $90 → cliente paga $90, recibe 2 masajes",
    },
    en: {
      intro: "Share your website or your price list (or answer 3 quick questions) and we'll draft 3-4 offers for you.",
      notaArchivo: "Your website, your booking link, a PDF, or just paste your list of services and prices. Whatever you have — we read it and propose offers.",
      labelUrl: "Your website or booking link",
      phUrl: "yoursite.com — or the link where people book you",
      notaPreguntas: "The fastest way for a salon, spa or studio: your services don't live in a menu. Three questions and we draft them.",
      labelPdf: "...or upload your price list (PDF)",
      labelPegar: "...or paste your services and prices",
      phPegar: "Eg:  Cut & style — 45.00 · Gel manicure — 38.00\n     60-min relaxing massage — 90.00 · Deep facial — 75.00",
      botonLeer: "Read my price list",
      phObjetivo: "Eg: fill the calendar on weekdays",
      phMasVende: "Eg: 60-min massage, 3-session package",
      phAlgoMas: "Eg: no discounts on weekends",
      ayudaTitulo: "What people order most, by name. Don't add the amount: the card already says «Save $X when you spend $Y».",
      phTitulo: "Eg: Gel mani-pedi",
      phDescripcion: "Eg: Enjoy our 60-minute deep facial with premium products...",
      ejemploBogo: "2 massages for the price of 1",
      phPrecioUnitario: "90",
      ayudaBogo: "Eg: Each massage costs $90 → customer pays $90, gets 2 massages",
    },
  },
  // s242 · `copy-alta-celebraciones-ejemplos-de-restaurante` (humo de «Generar con IA» en Live con un ZZ de globos): Gift_Moments
  // caia en `carta` y veia los ejemplos de restaurante («cócteles de autor», «evitar descuento en alcohol», «Churrasco…»).
  // Celebraciones (globos, flores, tortas) tiene catalogo y tienda en linea: sigue del lado del archivo en el ORDEN
  // (`SIN_CARTA` no cambia), solo cambian los textos. Vocabulario de la familia `tienda` (src/matriz/vocabulario.js).
  encargos: {
    es: {
      intro: "Comparte tu web o tu catálogo (o responde 3 preguntas rápidas) y te armamos 3-4 ofertas.",
      notaArchivo: "Tu web, tu tienda en línea, un PDF, o simplemente pega tu lista de productos y precios. Lo que tengas — lo leemos y te proponemos ofertas.",
      labelUrl: "Tu web o tu tienda en línea",
      phUrl: "tunegocio.com — o el link de tu tienda en línea",
      labelPdf: "...o sube tu catálogo (PDF)",
      labelPegar: "...o pega tu lista de productos y precios",
      phPegar: "Ej:  Arreglo de 12 globos — 45.00 · Torta de cumpleaños — 60.00\n     Ramo de rosas — 35.00 · Caja sorpresa — 50.00",
      botonLeer: "Leer mi catálogo",
      phObjetivo: "Ej: más pedidos entre semana",
      phMasVende: "Ej: arreglos de globos para cumpleaños, tortas por encargo",
      phAlgoMas: "Ej: los pedidos se hacen con 48 horas de anticipación",
      ayudaTitulo: "Lo que más te piden, con nombre. No pongas el monto: la tarjeta ya dice «Ahorra $X cuando gastas $Y».",
      phTitulo: "Ej: Arreglo de globos para cumpleaños",
      phDescripcion: "Ej: Arreglo de 12 globos con el nombre del festejado, para recoger o con entrega...",
      ejemploBogo: "2 globos metálicos por el precio de 1",
      phPrecioUnitario: "15",
      ayudaBogo: "Ej: Cada globo cuesta $15 → cliente paga $15, recibe 2 globos",
    },
    en: {
      intro: "Share your website or your catalog (or answer 3 quick questions) and we'll draft 3-4 offers for you.",
      notaArchivo: "Your website, your online store, a PDF, or just paste your list of products and prices. Whatever you have — we read it and propose offers.",
      labelUrl: "Your website or online store",
      phUrl: "yoursite.com — or your online store link",
      labelPdf: "...or upload your catalog (PDF)",
      labelPegar: "...or paste your products and prices",
      phPegar: "Eg:  12-balloon arrangement — 45.00 · Birthday cake — 60.00\n     Bouquet of roses — 35.00 · Surprise box — 50.00",
      botonLeer: "Read my catalog",
      phObjetivo: "Eg: more orders on weekdays",
      phMasVende: "Eg: birthday balloon arrangements, custom cakes",
      phAlgoMas: "Eg: orders need 48 hours' notice",
      ayudaTitulo: "What people order most, by name. Don't add the amount: the card already says «Save $X when you spend $Y».",
      phTitulo: "Eg: Birthday balloon arrangement",
      phDescripcion: "Eg: 12-balloon arrangement with the guest of honor's name, for pickup or delivery...",
      ejemploBogo: "2 foil balloons for the price of 1",
      phPrecioUnitario: "15",
      ayudaBogo: "Eg: Each balloon costs $15 → customer pays $15, gets 2 balloons",
    },
  },
  // s242 · `copy-alta-dulces-ejemplos-de-restaurante` (lo encontró la pantalla `generarIa` de la matriz): una heladería
  // leía «cócteles de autor» y «evitar descuento en alcohol». Dulces tiene menú y mostrador: sigue del lado del archivo.
  dulces: {
    es: {
      intro: "Comparte tu web o tu menú (o responde 3 preguntas rápidas) y te armamos 3-4 ofertas.",
      notaArchivo: "Tu web, el link de tu menú QR, un PDF, o simplemente pega tu lista de precios. Lo que tengas — lo leemos y te proponemos ofertas.",
      labelUrl: "Tu web o el link de tu menú QR",
      phUrl: "tunegocio.com — o el link que abre tu QR",
      labelPdf: "...o sube tu menú (PDF)",
      labelPegar: "...o pega tu menú o lista de precios",
      phPegar: "Ej:  Helado de 2 bolas — 6.50 · Pastelito de guayaba — 1.75\n     Tres leches (porción) — 5.00 · Café con leche — 3.50",
      botonLeer: "Leer mi menú",
      phObjetivo: "Ej: más clientes entre semana por la tarde",
      phMasVende: "Ej: helado artesanal, pastelitos, tortas",
      phAlgoMas: "Ej: no hacer descuento en las tortas por encargo",
      ayudaTitulo: "Lo que más te piden, con nombre. No pongas el monto: la tarjeta ya dice «Ahorra $X cuando gastas $Y».",
      phTitulo: "Ej: Copa de helado de dos sabores",
      phDescripcion: "Ej: Helado artesanal hecho en casa con frutas de temporada...",
      ejemploBogo: "2 helados por el precio de 1",
      phPrecioUnitario: "6",
      ayudaBogo: "Ej: Cada helado cuesta $6 → cliente paga $6, recibe 2 helados",
    },
    en: {
      intro: "Share your website or menu (or answer 3 quick questions) and we'll draft 3-4 offers for you.",
      notaArchivo: "Your website, the link behind your QR menu, a PDF, or just paste your price list. Whatever you have — we read it and propose offers.",
      labelUrl: "Your website or QR menu link",
      phUrl: "yoursite.com — or the link your QR opens",
      labelPdf: "...or upload your menu (PDF)",
      labelPegar: "...or paste your menu / price list",
      phPegar: "Eg:  2-scoop ice cream — 6.50 · Guava pastry — 1.75\n     Tres leches (slice) — 5.00 · Café con leche — 3.50",
      botonLeer: "Read my menu",
      phObjetivo: "Eg: more customers on weekday afternoons",
      phMasVende: "Eg: artisan ice cream, pastries, cakes",
      phAlgoMas: "Eg: no discounts on custom cakes",
      ayudaTitulo: "What people order most, by name. Don't add the amount: the card already says «Save $X when you spend $Y».",
      phTitulo: "Eg: Two-flavor ice cream cup",
      phDescripcion: "Eg: Homemade artisan ice cream with seasonal fruit...",
      ejemploBogo: "2 ice creams for the price of 1",
      phPrecioUnitario: "6",
      ayudaBogo: "Eg: Each ice cream costs $6 → customer pays $6, gets 2 ice creams",
    },
  },
  // s242 · inventario de textos de otros rubros: Experiencias compartía `servicios` con los salones (límite declarado en s188)
  // y leía «un salón, un spa», «masaje», «manicura». Mismo orden (preguntas primero, SIN_CARTA), textos propios.
  experiencias: {
    es: {
      intro: "Comparte tu web o tu lista de precios (o responde 3 preguntas rápidas) y te armamos 3-4 ofertas.",
      notaArchivo: "Tu web, el link donde te reservan, un PDF, o simplemente pega tus experiencias y precios. Lo que tengas — lo leemos y te proponemos ofertas.",
      labelUrl: "Tu web o el link donde te reservan",
      phUrl: "tunegocio.com — o el link donde te reservan",
      notaPreguntas: "El camino más rápido para un tour o una actividad: tus experiencias no viven en una carta. Tres preguntas y te las armamos.",
      labelPdf: "...o sube tu lista de precios (PDF)",
      labelPegar: "...o pega tus experiencias y precios",
      phPegar: "Ej:  Tour en lancha 1 h — 45.00 · Clase de cocina para dos — 120.00\n     Entrada general — 30.00 · Tour al atardecer — 65.00",
      botonLeer: "Leer mi lista",
      phObjetivo: "Ej: llenar los cupos entre semana",
      phMasVende: "Ej: tour de 1 hora, entrada para dos",
      phAlgoMas: "Ej: no hacer descuento en temporada alta",
      ayudaTitulo: "Lo que más te piden, con nombre. No pongas el monto: la tarjeta ya dice «Ahorra $X cuando gastas $Y».",
      phTitulo: "Ej: Tour en lancha al atardecer",
      phDescripcion: "Ej: Recorrido de 1 hora por la bahía con guía, ideal para ver el atardecer...",
      ejemploBogo: "2 entradas por el precio de 1",
      phPrecioUnitario: "45",
      ayudaBogo: "Ej: Cada entrada cuesta $45 → cliente paga $45, recibe 2 entradas",
    },
    en: {
      intro: "Share your website or your price list (or answer 3 quick questions) and we'll draft 3-4 offers for you.",
      notaArchivo: "Your website, your booking link, a PDF, or just paste your experiences and prices. Whatever you have — we read it and propose offers.",
      labelUrl: "Your website or booking link",
      phUrl: "yoursite.com — or the link where people book you",
      notaPreguntas: "The fastest way for a tour or an activity: your experiences don't live in a menu. Three questions and we draft them.",
      labelPdf: "...or upload your price list (PDF)",
      labelPegar: "...or paste your experiences and prices",
      phPegar: "Eg:  1-hour boat tour — 45.00 · Cooking class for two — 120.00\n     General admission — 30.00 · Sunset tour — 65.00",
      botonLeer: "Read my price list",
      phObjetivo: "Eg: fill weekday spots",
      phMasVende: "Eg: 1-hour tour, admission for two",
      phAlgoMas: "Eg: no discounts in high season",
      ayudaTitulo: "What people order most, by name. Don't add the amount: the card already says «Save $X when you spend $Y».",
      phTitulo: "Eg: Sunset boat tour",
      phDescripcion: "Eg: 1-hour guided ride around the bay, perfect for the sunset...",
      ejemploBogo: "2 tickets for the price of 1",
      phPrecioUnitario: "45",
      ayudaBogo: "Eg: Each ticket costs $45 → customer pays $45, gets 2 tickets",
    },
  },
};

// s186 - Peluquerias, spas y experiencias no tienen carta que leer, asi que para
// ellos el wizard de preguntas NO es el plan de repuesto: es el unico camino.
// Retail/regalos quedan del lado del archivo: una boutique suele tener catalogo
// en la web. ESTA lista decide el orden de los carriles Y el copy de adentro.
// s242 · `copy-alta-nail-lash-rama-carta`: Nail_Lash (legacy) es de la familia de los salones (s241) y caia en `carta`.
const SIN_CARTA = ["Salon_Spa", "Nail_Lash", "Experience"];
// s242 · los rubros con carta que tienen sus propios ejemplos (el orden de los carriles no cambia).
const COPY_ALTA_POR_RUBRO = { Gift_Moments: "encargos", Sweets: "dulces", Experience: "experiencias" };

function copyDelAlta(categoria, lang) {
  // s242 · el mapa por rubro manda (Experiencias sigue en SIN_CARTA para el ORDEN, pero con sus propios textos).
  const rama = COPY_ALTA[COPY_ALTA_POR_RUBRO[categoria] || (SIN_CARTA.includes(categoria) ? "servicios" : "carta")];
  return lang === "en" ? rama.en : rama.es;
}

// ---- s179 L4.2 · REGLAS: TOGGLES EN VEZ DE TEXTAREA VACÍO (T4 del diseño s99) ----
// El textarea libre no le dice al comercio qué escribir. Estos toggles COMPILAN a
// `rules_text`, que ya es param de create_offer — cero Bubble. El textarea queda para lo
// que no esté en la lista.
const SALTO_LINEA = "\n"; // rules_text guarda una condición por línea

// s180 A9: el reloj del <input type="time"> está pegado a la derecha y nadie descubre que
// ahí hay un menú — el usuario intenta escribir. Al enfocar se abre el selector nativo.
// showPicker() exige gesto de usuario y no existe en todos los navegadores: try/catch.
const abrirPicker = (e) => { try { e.target.showPicker?.(); } catch (_) { /* sin picker nativo: queda el input */ } };
const OFFER_RULE_PRESETS = [
  { key: "reserva",     es: "Requiere reserva previa",                 en: "Reservation required" },
  { key: "no_combina",  es: "No combinable con otras promociones",     en: "Not combinable with other promotions" },
  { key: "no_feriados", es: "No válido en feriados",                   en: "Not valid on holidays" },
  { key: "un_uso",      es: "Un uso por persona",                      en: "One use per person" },
  { key: "sin_alcohol", es: "No incluye bebidas alcohólicas",          en: "Alcoholic drinks not included" },
  { key: "en_local",    es: "Válido solo para consumo en el local",    en: "Dine-in only" },
];

const MERCHANT_DAYS = [
  { key: "mon", es: "Lun", en: "Mon" }, { key: "tue", es: "Mar", en: "Tue" },
  { key: "wed", es: "Mié", en: "Wed" }, { key: "thu", es: "Jue", en: "Thu" },
  { key: "fri", es: "Vie", en: "Fri" }, { key: "sat", es: "Sáb", en: "Sat" },
  { key: "sun", es: "Dom", en: "Sun" },
];
function m2BaseHours() {
  return MERCHANT_DAYS.map(d => ({ day: d.key, closed: false, r1o: "", r1c: "", r2o: "", r2c: "" }));
}
function parseHoursJson(raw) {
  const base = m2BaseHours();
  if (!raw) return base;
  try {
    const arr = typeof raw === "string" ? JSON.parse(raw) : raw;
    if (!Array.isArray(arr)) return base;
    return base.map(b => {
      const m = arr.find(x => x && x.day === b.day) || {};
      return { day: b.day, closed: m.closed === true, r1o: m.r1o || "", r1c: m.r1c || "", r2o: m.r2o || "", r2c: m.r2c || "" };
    });
  } catch (e) { return base; }
}
function serializeHours(hours) {
  return JSON.stringify(hours.map(d => ({
    day: d.day, closed: d.closed,
    r1o: d.closed ? "" : d.r1o, r1c: d.closed ? "" : d.r1c,
    r2o: d.closed ? "" : d.r2o, r2c: d.closed ? "" : d.r2c,
  })));
}

function MerchantProfileEdit() {
  const lang = useLang();
  const [form, setForm] = useState({
    description_es: "", description_en: "", phone: "", address: "", business_hours: "",
    category: "", city: "", state: "", zip: "", zone: "", whatsapp: "",
    delivery_available: false, delivery_free: false, delivery_min_amount: "",
    // Pass-through Places (alta v2 s109): el WF update_merchant_profile SOBRESCRIBE todo
    // en el Step 0 — si no re-mandamos estos campos, guardar el perfil BLANQUEA los datos
    // del alta Places. Se cargan de get_merchant_profile y viajan en {...form} al guardar.
    google_maps_url: "", website: "", instagram: "", lat: "", lng: "",
    neighborhood: "", address_full: "", business_type: "",
    // s109: editables nuevos (backend tanda s109: +param business_name, +Return business_type)
    business_name: "",
  });
  const [hours, setHours] = useState(m2BaseHours);
  // s235 · perfil-horario-pisa-google (P1) y perfil-direccion-completa (P2): lo que el comercio tenía al abrir Perfil.
  // La ficha muestra el texto de Google (`business_hours`, `address_full`) antes que lo que edita aquí (el json de horas,
  // la dirección por partes): si cambia algo, al guardar se reescribe también el texto, para que gane lo suyo.
  const alAbrir = useRef({ horas: "", direccion: "" });
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState("");
  // s184 - el id del propio comercio, para enlazar «ver mi ficha». Viaja en el
  // Return de get_merchant_profile como `merchant_id` desde siempre y no lo
  // usaba nadie: el comercio no tenia forma de llegar a su propia pagina.
  const [merchantId, setMerchantId] = useState("");
  // s189-F · el estado del comercio. Viajaba en el Return de get_merchant_profile desde
  // siempre y esta pantalla lo tiraba. Lo necesita el enlace «ver mi ficha»: la pagina
  // publica la sirve la privacy rule «Public sees approved» (PRIVACY_RULES_NXTR:355), que
  // es la UNICA que le da lectura anonima a merchantpartner. getMerchantById va por canal
  // anonimo (apiGetPublic, api.js:404), asi que a un comercio en Lead su propia ficha le
  // contesta «Negocio no encontrado» — sobre su propio negocio.
  const [estado, setEstado] = useState("");
  // s189-F · a que campo acaba de saltar el comercio desde el panel de lo que falta.
  // Sin esto el salto lo deja mirando un formulario identico a si mismo.
  const [llamado, setLlamado] = useState("");
  // s189-H · que dias tienen el segundo turno ABIERTO A MANO en esta sesion. No es el
  // estado de «hay segundo turno» —ese sale del dato, mirando si r2 tiene algo— sino el de
  // «el comercio pidio verlo». Los dos juntos deciden si se dibuja, y por eso la hidratacion
  // no tiene que sincronizar nada: un dia que YA venia con dos turnos se abre solo.
  const [turno2, setTurno2] = useState({});
  // s189-G · el pedido de la descripcion al asistente.
  const [escribiendo, setEscribiendo] = useState(false);
  const [errorIA, setErrorIA] = useState(null);   // { texto, saltarA } | null
  const [iaEscribio, setIaEscribio] = useState(false);
  // s184 - galeria del local. `fotos` son las URLs ya guardadas; `subiendo` es
  // cuantas quedan en la cola, para poder decirlo en vez de dejar la pantalla muda.
  const [fotos, setFotos] = useState([]);
  const [subiendo, setSubiendo] = useState(0);
  const [errorFoto, setErrorFoto] = useState("");
  const [portadaEn, setPortadaEn] = useState("");   // s203 · la foto que se esta llevando a portada
  // s200-D1 · LA COLA DEL ENCUADRE. El comercio elige varias de una vez (eso no cambia:
  // pedirle seis viajes al selector de archivos es maltrato), pero encuadrar es una
  // decision por foto. Se abre el encuadrador de a uno; al confirmar, esa foto sale a
  // subir y entra la siguiente. «Cancelar» saltea SOLO esa y sigue con el resto.
  const [cola, setCola] = useState([]);
  // El logo pasa por el mismo componente, pero en 1:1.
  const [logoPorEncuadrar, setLogoPorEncuadrar] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [ok, setOk] = useState("");
  const [businessName, setBusinessName] = useState("");
  // s161 F-6: la hidratacion falla CERRADO. Antes, un fallo de get_merchant_profile caia
  // en .catch(() => {}) y el formulario quedaba en su estado inicial VACIO; guardar desde
  // ahi pisaba cada campo mapeado del perfil (el WF sobrescribe todo en el Step 0) y el
  // comercio perdia su ficha entera por un timeout. El estado ahora es explicito y NO se
  // infiere de si los campos estan vacios: sin "ok" no hay Guardar.
  const [hidratacion, setHidratacion] = useState("cargando"); // "cargando" | "ok" | "error"

  // s204 · «Cambiar contraseña» del menu de cuenta llega con `#cambiar-clave`: cuando el
  // formulario ya esta dibujado, se baja hasta el boton y se le da el foco.
  useEffect(() => {
    if (hidratacion !== "ok" || window.location.hash !== "#cambiar-clave") return;
    irACambiarClave();
  }, [hidratacion]);

  const cargarPerfil = useCallback(() => {
    setHidratacion("cargando");
    getMerchantProfile().then(p => {
      // Dos caminos de fallo, no uno: la promesa puede rechazar (red/timeout) o
      // resolver vacia (sin perfil / canal capado). Los dos son "error".
      if (!p) { setHidratacion("error"); return; }
      setBusinessName(p.business_name || "");
      setForm({
        description_es: p.description_es || "",
        description_en: p.description_en || "",
        phone: p.phone || "",
        address: p.address || "",
        business_hours: p.business_hours || "",
        category: p.category || "",
        city: p.city || "",
        state: p.state || "",
        zip: p.zip || "",
        zone: p.zone || "",
        whatsapp: p.whatsapp || "",
        delivery_available: p.delivery_available === true,
        delivery_free: p.delivery_free === true,
        delivery_min_amount: (p.delivery_min_amount != null && p.delivery_min_amount !== "") ? String(p.delivery_min_amount) : "",
        google_maps_url: p.google_maps_url || "",
        website: p.website || "",
        instagram: p.instagram || "",
        lat: (p.lat != null && p.lat !== "") ? p.lat : "",
        lng: (p.lng != null && p.lng !== "") ? p.lng : "",
        neighborhood: p.neighborhood || "",
        address_full: p.address_full || "",
        business_type: p.business_type || "",
        business_name: p.business_name || "",
      });
      setHours(parseHoursJson(p.business_hours_json));
      alAbrir.current = { horas: serializeHours(parseHoursJson(p.business_hours_json)), direccion: [p.address, p.city, p.state, p.zip].map(v => String(v || "").trim()).join("|") };
      if (p.logo) setLogoPreview(String(p.logo).startsWith("//") ? "https:" + p.logo : p.logo);
      setMerchantId(p.merchant_id || p._id || p.id || "");
      setEstado(String(p.status || "").trim().toLowerCase());
      // `gallery` puede llegar como lista o como una sola URL segun cuantas haya.
      const g = p.gallery;
      setFotos((Array.isArray(g) ? g : (g ? [g] : [])).map(u => String(u).startsWith("//") ? "https:" + u : u));
      setHidratacion("ok");
    }).catch(() => setHidratacion("error"));
  }, []);

  useEffect(() => { cargarPerfil(); }, [cargarPerfil]);

  // s189-F · la marca dura lo que dura la animacion y se limpia sola. Si el comercio
  // salta a otro campo antes, el timer viejo se cancela y no apaga el nuevo.
  useEffect(() => {
    if (!llamado) return undefined;
    const tid = window.setTimeout(() => setLlamado(""), 3400);
    return () => window.clearTimeout(tid);
  }, [llamado]);

  // Llevar al campo Y enfocarlo. Las dos cosas: llevarlo sin enfocar lo deja teniendo que
  // buscar donde escribir, y enfocarlo sin llevarlo salta de golpe sin que se entienda.
  const irAlCampo = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const quieto = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    el.scrollIntoView({ behavior: quieto ? "auto" : "smooth", block: "center" });
    setLlamado(id);
    // El foco va DESPUES del scroll: enfocar primero lo cancela en Chrome y Safari.
    window.setTimeout(() => { try { el.focus({ preventScroll: true }); } catch (_) { el.focus(); } }, quieto ? 0 : 320);
  }, []);
  const marca = (id) => (llamado === id ? "prf-llamado" : undefined);

  // s189-G · «escríbela con lo que ya leímos de mi sitio».
  //
  // Cada codigo del WF sale como una frase que dice QUE HACER, no como un codigo. Y el
  // caso importante —`NO_INGESTED`, el comercio del que todavia no leimos nada— no termina
  // en un cartel: termina en un boton que lo lleva al campo de sitio web. Llena la web,
  // guarda, y el pedido funciona. Es el circulo que el panel de lo que falta ya sabe cerrar.
  const pedirDescripcion = useCallback(async () => {
    if (!merchantId || escribiendo) return;
    const en = lang === "en";
    setEscribiendo(true);
    setErrorIA(null);
    setIaEscribio(false);
    try {
      const r = await generateMerchantDescription(merchantId);
      const dEs = String(r?.description_es || "").trim();
      const dEn = String(r?.description_en || "").trim();
      // Una respuesta «exitosa» y vacia no es un exito: es el peor de los fallos, porque
      // deja la pantalla igual que antes y sin explicacion (la leccion del s189-E).
      if (!dEs && !dEn) {
        setErrorIA({ texto: en
          ? "The assistant came back empty. Try again, or write it yourself — it's your business, you say it better."
          : "El asistente volvió sin nada. Prueba otra vez, o escríbela tú — es tu negocio, lo dices mejor." });
        return;
      }
      setForm(f => ({
        ...f,
        description_es: dEs || f.description_es,
        description_en: dEn || f.description_en,
      }));
      setIaEscribio(true);
      setError("");
      setOk("");
      irAlCampo("nxt-f36");
    } catch (e) {
      const code = e && e.code;
      if (code === "NO_INGESTED") {
        setErrorIA({
          texto: en
            ? "We haven't read your site yet. Add your website, save, and try again."
            : "Todavía no leímos tu sitio. Agrega tu sitio web, guarda, y vuelve a intentarlo.",
          saltarA: "nxt-f26",
        });
      } else if (code === "NOT_ADMIN") {
        // Mientras la guarda del step 1 siga pidiendo Admin, este es el codigo que recibe
        // TODO comercio. Con el flag apagado nadie deberia llegar aca — pero si llega, no
        // se le muestra un codigo: se le dice quien lo resuelve.
        setErrorIA({ texto: en
          ? "This isn't available for your account yet. Tell us and we'll write it for you."
          : "Esto todavía no está habilitado para tu cuenta. Avísanos y la escribimos nosotros." });
      } else if (code === "NOT_FOUND") {
        setErrorIA({ texto: en
          ? "We couldn't find your business. Reload the page and try again."
          : "No encontramos tu negocio. Recarga la página e intenta de nuevo." });
      } else {
        setErrorIA({ texto: en
          ? "We couldn't write it right now. Try again in a moment."
          : "No pudimos escribirla ahora. Intenta de nuevo en un momento." });
      }
    } finally {
      setEscribiendo(false);
    }
  }, [merchantId, escribiendo, lang, irAlCampo]);

  const t = lang === "en"
    ? { title: "EDIT PROFILE", section_info: "BUSINESS INFO", section_loc: "LOCATION", section_contact: "CONTACT",
        section_delivery: "DELIVERY", section_hours: "BUSINESS HOURS", section_account: "ACCOUNT",
        descEs: "DESCRIPTION (ES)", descEn: "DESCRIPTION (EN)", category: "CATEGORY", categoryPick: "Select a category…",
        businessName: "BUSINESS NAME", businessType: "TYPE",
        phone: "PHONE", whatsapp: "WHATSAPP", address: "ADDRESS (LINE 1)", city: "CITY", state: "STATE", zip: "ZIP CODE",
        deliveryAvail: "Offers delivery", deliveryFree: "Free delivery", deliveryMin: "FREE FROM ($)",
        closed: "Closed", hoursHint: "One shift per day. If you close midday, add a second shift on that day.",
        turno2: "+ Second shift", quitarTurno2: "Remove second shift",
        logo: "LOGO", save: "Save changes", saving: "Saving...", saved: "✅ Profile updated",
        changePw: "Change password", badType: "Format not allowed (JPG/PNG/WebP).", badSize: "Image exceeds 2 MB.",
        days: MERCHANT_DAYS.map(d => d.en) }
    : { title: "EDITAR PERFIL", section_info: "INFO DEL NEGOCIO", section_loc: "UBICACIÓN", section_contact: "CONTACTO",
        section_delivery: "DELIVERY", section_hours: "HORARIOS", section_account: "CUENTA",
        descEs: "DESCRIPCIÓN (ES)", descEn: "DESCRIPCIÓN (EN)", category: "CATEGORÍA", categoryPick: "Elige una categoría…",
        businessName: "NOMBRE DEL NEGOCIO", businessType: "RUBRO",
        phone: "TELÉFONO", whatsapp: "WHATSAPP", address: "DIRECCIÓN (LÍNEA 1)", city: "CIUDAD", state: "ESTADO", zip: "CÓDIGO ZIP",
        deliveryAvail: "Ofrece delivery", deliveryFree: "Delivery gratis", deliveryMin: "GRATIS DESDE ($)",
        closed: "Cerrado", hoursHint: "Un turno por día. Si cierras al mediodía, agrega un segundo turno en ese día.",
        turno2: "+ Segundo turno", quitarTurno2: "Quitar el segundo turno",
        logo: "LOGO", save: "Guardar cambios", saving: "Guardando...", saved: "✅ Perfil actualizado",
        changePw: "Cambiar contraseña", badType: "Formato no permitido (JPG/PNG/WebP).", badSize: "La imagen supera 2 MB.",
        days: MERCHANT_DAYS.map(d => d.es) };

  // s204 · las etiquetas, campos y secciones viven en merchant.css (.prf-*). `conMarca`
  // suma el resaltado de «lo que falta» (.prf-llamado) a la clase del campo.
  const conMarca = (base, id) => (marca(id) ? base + " " + marca(id) : base);

  const onField = (k) => (e) => { setForm(f => ({ ...f, [k]: e.target.value })); setError(""); setOk(""); };
  const onCheck = (k) => (e) => { setForm(f => ({ ...f, [k]: e.target.checked })); setError(""); setOk(""); };
  const setDay = (idx, patch) => { setHours(hs => hs.map((d, i) => i === idx ? { ...d, ...patch } : d)); setError(""); setOk(""); };

  // El mensaje del tope, uno solo: lo dicen la ayuda debajo del selector, el rechazo al
  // elegir de mas, y el error que devuelve Bubble. Tres bocas, una frase.
  const lleno = lang === "en"
    ? `You already have ${GALERIA_TOPE} photos. Remove one to upload another.`
    : `Ya tienes ${GALERIA_TOPE} fotos. Quita una para subir otra.`;

  // Una sola foto, ya encuadrada. La vista previa es optimista como siempre; si el WF la
  // rechaza, se avisa con SU mensaje (GALLERY_FULL tiene el suyo) y no queda nada dibujado.
  const subirUna = async (f) => {
    setSubiendo(n => n + 1);
    try {
      const r = await agregarFotoComercio(f);
      const urls = r?.gallery_urls || r?.gallery;
      if (Array.isArray(urls)) setFotos(urls);
      else setFotos(prev => [...prev, URL.createObjectURL(f)]);   // sin lista de vuelta: optimista
    } catch (err) {
      setErrorFoto(err?.code === "GALLERY_FULL"
        ? lleno
        : (lang === "en" ? "That photo could not be uploaded. Try again."
                         : "Esa foto no se pudo subir. Intenta de nuevo."));
    } finally {
      setSubiendo(n => n - 1);
    }
  };

  // s184 - SUBIDA DE A UNA, AUNQUE ELIJA VARIAS. El input acepta multiple porque pedirle a
  // alguien que suba seis fotos de a una es maltrato; pero el envio es secuencial: si la
  // cuarta falla, las tres primeras ya estan guardadas y se reintenta esa sola. Un lote
  // atomico obliga a repetir todo desde el telefono.
  // s200 suma el encuadre antes de cada subida: por eso esto ya no sube nada, encola.
  const onFotos = (e) => {
    const elegidas = Array.from(e.target.files || []);
    e.target.value = "";                       // permite volver a elegir el mismo archivo
    if (!elegidas.length) return;
    setErrorFoto("");
    // El hueco se cuenta contra lo que YA esta y lo que ya esta en la cola: elegir 8 dos
    // veces seguidas no puede meter 16.
    const hueco = GALERIA_TOPE - fotos.length - cola.length;
    if (hueco <= 0) { setErrorFoto(lleno); return; }
    const entran = elegidas.slice(0, hueco);
    if (entran.length < elegidas.length) {
      setErrorFoto(lang === "en"
        ? `Only ${entran.length} fit: the gallery holds ${GALERIA_TOPE} photos.`
        : `Solo entran ${entran.length}: la galería es de ${GALERIA_TOPE} fotos.`);
    }
    setCola(c => [...c, ...entran]);
  };

  const quitarFoto = async (url) => {
    setErrorFoto("");
    const antes = fotos;
    setFotos(prev => prev.filter(u => u !== url));      // optimista: la foto se va al toque
    try {
      const r = await quitarFotoComercio(url);
      const urls = r?.gallery_urls || r?.gallery;
      if (Array.isArray(urls)) setFotos(urls);
    } catch (e) {
      setFotos(antes);                                  // no se pudo: vuelve donde estaba
      setErrorFoto(lang === "en" ? "Could not remove the photo." : "No se pudo quitar la foto.");
    }
  };

  // s203 · «HACER PORTADA» (set_gallery_cover, export 90, smoke F1). Optimista como quitar:
  // la foto salta al frente al toque y vuelve si falla. La pantalla guarda las URL con
  // «https:» adelante y la base las tiene como «//…»: el WF compara la URL tal cual, así que
  // se le manda la forma de la base. Y la respuesta se CUENTA: si Bubble devolviera otra
  // cantidad de fotos (lo que pasó con el export 88, que borraba la elegida), se avisa en vez
  // de dar por buena la portada.
  const crudaDe = (u) => (/^https:\/\/[^/]*cdn\.bubble\.io\//.test(String(u)) ? String(u).slice(6) : String(u));
  const hacerPortada = async (url) => {
    if (portadaEn) return;
    setErrorFoto("");
    const antes = fotos;
    setPortadaEn(url);
    setFotos(prev => [url, ...prev.filter(u => u !== url)]);
    try {
      const r = await setGalleryCover(crudaDe(url));
      const urls = Array.isArray(r?.gallery_urls) ? r.gallery_urls : null;
      if (urls) {
        const norm = urls.map(u => (String(u).startsWith("//") ? "https:" + u : u));
        setFotos(norm);
        if (norm.length !== antes.length) {
          setErrorFoto(lang === "en"
            ? "The gallery changed in an unexpected way. Reload the page and tell us if a photo is missing."
            : "La galería cambió de una forma que no esperábamos. Recarga la página y avísanos si falta una foto.");
        }
      }
    } catch (e) {
      setFotos(antes);
      setErrorFoto(e?.code === "PHOTO_NOT_FOUND"
        ? (lang === "en" ? "That photo is no longer in your gallery. Reload the page." : "Esa foto ya no está en tu galería. Recarga la página.")
        : (lang === "en" ? "Could not set the cover. Try again." : "No se pudo cambiar la portada. Inténtalo de nuevo."));
    } finally {
      setPortadaEn("");
    }
  };

  // s235 · alta-logo-lienzo-cuadrado: como en la siembra (s234), el logo va primero a un lienzo cuadrado (logoEnCuadrado):
  // si no, un logo apaisado no entra entero en el encuadrador 1:1.
  const onLogo = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!OK_LOGO_TYPES.includes(file.type)) { setError(t.badType); return; }
    if (file.size > MAX_LOGO_BYTES) { setError(t.badSize); return; }
    setError(""); setOk("");
    setLogoPorEncuadrar(await logoEnCuadrado(file));   // s200-D1: el logo entra por el mismo encuadrador, en 1:1
  };

  // s200-D1 · el logo sale CUADRADO y de 512px. El tipo se decide ANTES de encuadrar, por
  // la fuente: un PNG puede traer transparencia y en un logo eso importa; cualquier otra
  // cosa sale JPEG. Si el PNG resultante se pasara del tope de 2 MB —una fotografia usada
  // de logo— se avisa con el mismo mensaje de tamano que ya existe, en vez de subirlo.
  const tipoDelLogo = (f) => (f && f.type === "image/png" ? "image/png" : "image/jpeg");

  const logoEncuadrado = (recortada) => {
    setLogoPorEncuadrar(null);
    if (recortada.size > MAX_LOGO_BYTES) { setError(t.badSize); return; }
    setLogoFile(recortada);
    setLogoPreview(URL.createObjectURL(recortada));
  };

  const handleSave = async () => {
    // s161 F-6: sin hidratacion confirmada no se guarda. Un form que no sabe que habia
    // no puede escribir: el WF pisa todo lo mapeado y blanquearia el perfil.
    if (hidratacion !== "ok") return;
    setLoading(true); setError(""); setOk("");
    try {
      const horasJson = serializeHours(hours);
      const cambios = {};
      // P1 · cambió el horario: el texto pasa a ser el de sus horas («Lun: 11:00–22:00», un día por renglón, como lo
      // arma la ficha). Si borró todas, no se manda vacío (Bubble lo ignora y quedaría el de Google): queda como estaba.
      if (horasJson !== alAbrir.current.horas) {
        const texto = horarioDesdeJson(horasJson, false).map(h => `${h.dia}: ${h.valor}`).join("\n");
        if (texto) cambios.business_hours = texto;
      }
      // P2 · cambió la dirección: `address_full` se arma con lo que escribió (calle, ciudad, estado y ZIP).
      const dir = [form.address, form.city, form.state, form.zip].map(v => String(v || "").trim());
      if (dir.join("|") !== alAbrir.current.direccion && dir[0]) {
        cambios.address_full = [dir[0], dir[1], [dir[2], dir[3]].filter(Boolean).join(" ")].filter(Boolean).join(", ");
      }
      await updateMerchantProfile({ ...form, ...cambios, business_hours_json: horasJson });
      if (cambios.business_hours || cambios.address_full) setForm(f => ({ ...f, ...cambios }));
      alAbrir.current = { horas: horasJson, direccion: dir.join("|") };
      if (logoFile) await updateMerchantLogo(logoFile);
      setOk(t.saved);
      setLogoFile(null);
      if (form.business_name && form.business_name.trim()) setBusinessName(form.business_name.trim());
    } catch (e) {
      setError(e.message || "Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mrc-pagina">
      <MerchantHeader businessName={businessName} activePage="profile" />
      {/* s186 · 640 no alcanzaba: con los dos rangos horarios completos la fila no
          entraba y rompia. 760 es el ancho en que entra todo sin apretarse.
          s189-F · Arriba de 1080 el FORMULARIO sigue en una columna —partirlo en dos hace
          que la gente zigzaguee y se saltee campos— pero la PANTALLA no: el espacio que
          sobraba se lo lleva el panel de lo que falta, pegajoso al lado. Debajo de 1080 el
          panel se va arriba del formulario, no abajo. Ver `.prf-lienzo` en merchant.css. */}
      <div className="prf-lienzo">
        <h1 className="prf-lienzo__titulo">{t.title}</h1>
        <div className="prf-formulario">
          {/* s161 F-6: el estado de la hidratacion se DECLARA. Si no cargo, el usuario
              ve por que y Guardar queda deshabilitado — nunca un form vacio que parece
              editable. */}
          {hidratacion === "error" && (
            <div className="prf-error" role="alert">
              <div className="prf-error__titulo">
                {lang === "en" ? "We couldn't load your profile" : "No pudimos cargar tu perfil"}
              </div>
              <div className="prf-error__texto">
                {lang === "en"
                  ? "Saving is disabled so we don't overwrite your data with an empty form. Try again."
                  : "Guardar esta deshabilitado para no sobrescribir tus datos con un formulario vacio. Intenta de nuevo."}
              </div>
              <button className="prf-reintentar" onClick={cargarPerfil}>
                {lang === "en" ? "Retry" : "Reintentar"}
              </button>
            </div>
          )}
          {error && (<div className="prf-error" role="alert">{error}</div>)}
          {ok && (<div className="prf-exito" role="status">{ok}</div>)}

          <div className="prf-seccion">{t.section_info}</div>
          <div className="prf-campo">
            <label htmlFor="nxt-f39" className="prf-etiqueta">{t.businessName}</label>
            <input id="nxt-f39" autoComplete="organization" value={form.business_name} onChange={onField("business_name")} className="prf-entrada" />
          </div>
          <div className="prf-campo">
            <label htmlFor="nxt-f38" className="prf-etiqueta">{t.category}</label>
            <select id="nxt-f38" value={form.category} onChange={e => { const cat = e.target.value; setForm(f => ({ ...f, category: cat, business_type: DEFAULT_TYPE_BY_CAT[cat] || "" })); setError(""); setOk(""); }} className="prf-entrada">
              <option value="">{t.categoryPick}</option>
              {MERCHANT_CATEGORIES.map(c => <option key={c.key} value={c.key}>{lang === "en" ? c.en : c.es}</option>)}
              {form.category && !MERCHANT_CATEGORIES.some(c => c.key === form.category) && (
                <option value={form.category}>{form.category}</option>
              )}
            </select>
          </div>
          <div className="prf-campo">
            <label htmlFor="nxt-f37" className="prf-etiqueta">{t.businessType}</label>
            <select id="nxt-f37" value={form.business_type} onChange={onField("business_type")} className="prf-entrada">
              <option value="">—</option>
              {(form.category ? BUSINESS_TYPES.filter(b => b.cat === form.category) : BUSINESS_TYPES).map(b => (
                <option key={b.key} value={b.key}>{lang === "en" ? b.en : b.es}</option>
              ))}
              {form.business_type && !BUSINESS_TYPES.some(b => b.key === form.business_type) && (
                <option value={form.business_type}>{form.business_type}</option>
              )}
            </select>
            {/* s186 · la otra mitad de `business-type-vacio-en-los-comercios`. El alta SÍ
                escribe este campo desde s109, pero los comercios que nacieron antes lo
                tienen vacío —17 de 26 fichas leídas en Live— y con el campo vacío el
                asesor no matchea ninguna fila de MarginProfile: propone descuentos sin
                saber el margen del rubro. Acá el comercio lo puede completar solo, y se
                le dice para qué sirve en vez de dejarlo como un campo más. */}
            {/* s186 · la misma pista que el alta, para el que viene a corregirlo */}
            {form.business_type && BUSINESS_TYPES.some(b => b.key === form.business_type) && (
              <div className="prf-pista">
                {(() => {
                  const b = BUSINESS_TYPES.find(x => x.key === form.business_type);
                  return lang === "en" ? b.pistaEn : b.pistaEs;
                })()}.
              </div>
            )}
            {!form.business_type && (
              <div className="prf-pista prf-pista--falta">
                {lang === "en"
                  ? "Pick your type of business: the assistant uses it to know your margin before suggesting a discount."
                  : "Elige tu tipo de negocio: el asesor lo usa para saber tu margen antes de proponerte un descuento."}
              </div>
            )}
          </div>
          {/* s189-G · la nota va acá, pegada al campo, y NO en el panel: para cuando el
              comercio lee esto ya saltó, el pendiente desapareció de la lista y el panel
              no tiene nada que decir. Y dice que YA QUEDÓ GUARDADA porque es la verdad —
              el step 9 del WF escribe solo. Prometerle que decide él sobre un texto que
              ya está en su ficha sería mentirle sobre lo único que importa acá. */}
          {iaEscribio && (
            <div className="prf-ia-nota" role="status">
              {lang === "en"
                ? "The assistant wrote this from your website, and it's already saved. Read it and change anything you want \u2014 you know your business better than the text does."
                : "La escribió el asistente con el texto de tu sitio, y ya quedó guardada. Léela y cambia lo que quieras \u2014 tú conoces tu negocio mejor que ese texto."}
            </div>
          )}
          {/* s189-F · son el MISMO texto en dos idiomas y estaban uno debajo del otro,
              ocupando el doble de pantalla y sin dejar compararlos. */}
          <div className="prf-descripciones prf-bloque">
            <div>
              <label htmlFor="nxt-f36" className="prf-etiqueta">{t.descEs}</label>
              <textarea id="nxt-f36" className={conMarca("prf-entrada", "nxt-f36")} value={form.description_es} onChange={onField("description_es")} rows={3} />
            </div>
            <div>
              <label htmlFor="nxt-f35" className="prf-etiqueta">{t.descEn}</label>
              <textarea id="nxt-f35" value={form.description_en} onChange={onField("description_en")} rows={3} className="prf-entrada" />
            </div>
          </div>

          <div className="prf-seccion">{t.section_loc}</div>
          <div className="prf-campo">
            <label htmlFor="nxt-f34" className="prf-etiqueta">{t.address}</label>
            <input id="nxt-f34" autoComplete="street-address" value={form.address} onChange={onField("address")} className="prf-entrada" />
          </div>
          <div className="prf-fila3">
            <div><label htmlFor="nxt-f33" className="prf-etiqueta">{t.city}</label><input id="nxt-f33" autoComplete="address-level2" value={form.city} onChange={onField("city")} className="prf-entrada" /></div>
            <div><label htmlFor="nxt-f32" className="prf-etiqueta">{t.state}</label><input id="nxt-f32" value={form.state} onChange={onField("state")} className="prf-entrada" /></div>
            <div><label htmlFor="nxt-f31" className="prf-etiqueta">{t.zip}</label><input id="nxt-f31" autoComplete="postal-code" value={form.zip} onChange={onField("zip")} className="prf-entrada" /></div>
          </div>

          <div className="prf-seccion">{t.section_contact}</div>
          <div className="prf-fila2">
            <div><label htmlFor="nxt-f30" className="prf-etiqueta">{t.phone}</label><input id="nxt-f30" className={conMarca("prf-entrada", "nxt-f30")} autoComplete="tel" value={form.phone} onChange={onField("phone")} type="tel" /></div>
            <div><label htmlFor="nxt-f29" className="prf-etiqueta">{t.whatsapp}</label><input id="nxt-f29" autoComplete="tel" value={form.whatsapp} onChange={onField("whatsapp")} type="tel" placeholder="+1..." className="prf-entrada" /></div>
          </div>

          {/* s184 - `website` e `instagram` viajaban en el formulario como
              pass-through invisible: el WF update_merchant_profile los escribe
              (`website_text`, `instagram_text`) pero no habia control para
              cargarlos. Por eso Instagram esta en 0 de 13 comercios — no es que
              no lo tengan, es que nunca hubo donde ponerlo. La web la llenaba
              sola el alta con Places; el Instagram no lo da Places. */}
          <div className="prf-fila2">
            <div>
              <label htmlFor="nxt-f26" className="prf-etiqueta">{lang === "en" ? "WEBSITE" : "SITIO WEB"}</label>
              <input id="nxt-f26" className={conMarca("prf-entrada", "nxt-f26")} inputMode="url" value={form.website} onChange={onField("website")}
                placeholder="tunegocio.com" />
              {/* s238 · webs-de-terceros: sin web propia, su página de Booksy/Toast también sirve aquí. */}
              {String(form.website || "").trim()
                ? <AvisoPlataforma url={form.website} en={lang === "en"} />
                : <div style={{ fontSize: 12, marginTop: 6, color: C.gray }}>{lang === "en"
                  ? "No website? Your page on Booksy, Vagaro, Fresha, Phorest, Toast or your online store works too."
                  : "¿Sin web propia? También sirve tu página de Booksy, Vagaro, Fresha, Phorest, Toast o tu tienda online."}</div>}
            </div>
            <div>
              <label htmlFor="nxt-f25" className="prf-etiqueta">INSTAGRAM</label>
              <input id="nxt-f25" className={conMarca("prf-entrada", "nxt-f25")} value={form.instagram} onChange={onField("instagram")}
                placeholder="@tunegocio" />
            </div>
          </div>

          <div className="prf-seccion">{t.section_delivery}</div>
          <div className="prf-bloque">
            <label className="prf-check"><input type="checkbox" checked={form.delivery_available} onChange={onCheck("delivery_available")} /> {t.deliveryAvail}</label>
            {form.delivery_available && (
              <div className="prf-delivery">
                <label className="prf-check"><input type="checkbox" checked={form.delivery_free} onChange={onCheck("delivery_free")} /> {t.deliveryFree}</label>
                {!form.delivery_free && (
                  <div>
                    <label htmlFor="nxt-f28" className="prf-etiqueta">{t.deliveryMin}</label>
                    <input id="nxt-f28" type="number" min="0" step="0.01" value={form.delivery_min_amount} onChange={onField("delivery_min_amount")} className="prf-entrada prf-entrada--monto" />
                  </div>
                )}
              </div>
            )}
          </div>

          <div className="prf-seccion">{t.section_hours}</div>
          <div id="prf-horarios" tabIndex={-1} className={conMarca("prf-bloque", "prf-horarios")}
            role="group" aria-label={t.section_hours}>
            {/* 🔴 s189-H · EL SEGUNDO TURNO DEJA DE ESTAR SIEMPRE ABIERTO.
                Esta es la pantalla más larga que ve el comercio, y dibujaba los DOS rangos de
                los siete días pasara lo que pasara: 28 casillas de hora, de las cuales 14 son
                para un caso —cerrar al mediodía y reabrir— que la mayoría no tiene. El que
                abre de corrido tenía que entender que esas catorce se dejan vacías, y eso hay
                que explicarlo con una nota al pie, que es la señal de que el formulario está
                pidiendo algo raro.
                Ahora aparecen cuando hacen falta, y de dos maneras: si el día YA tiene un
                segundo turno guardado se dibuja solo —la condición mira el dato, no un estado
                que haya que sincronizar en la hidratación— y si no, hay un botón que lo abre.
                Quitarlo BORRA las dos horas: dejar el control cerrado con datos adentro
                escondería un horario que igual se guarda. */}
            {hours.map((d, idx) => {
              const conTurno2 = !!(d.r2o || d.r2c) || !!turno2[d.day];
              return (
              // s186 · cada RANGO es un grupo indivisible. Antes los nueve hijos colgaban
              // sueltos del mismo flex y el wrap partía un rango al medio, dejando el
              // «hasta» huérfano en la línea de abajo. Ver el bloque de merchant.css.
              <div key={d.day} className="perfil-dia">
                <span className="perfil-dia__nombre">{t.days[idx]}</span>
                <label className="perfil-dia__cerrado">
                  <input type="checkbox" checked={d.closed} onChange={e => setDay(idx, { closed: e.target.checked })} /> {t.closed}
                </label>
                {!d.closed && (
                  <div className="perfil-rangos">
                    {/* s180 A9: step=600 → el selector va de 10 en 10 minutos; onFocus lo abre. */}
                    <div className="perfil-rango">
                      <input type="time" step={600} onFocus={abrirPicker} value={d.r1o} onChange={e => setDay(idx, { r1o: e.target.value })} className="prf-entrada prf-entrada--hora" aria-label={`${t.days[idx]} — 1`} />
                      <span className="perfil-rango__guion">–</span>
                      <input type="time" step={600} onFocus={abrirPicker} value={d.r1c} onChange={e => setDay(idx, { r1c: e.target.value })} className="prf-entrada prf-entrada--hora" />
                    </div>
                    {conTurno2 ? (
                      <div className="perfil-rango">
                        <input type="time" step={600} onFocus={abrirPicker} value={d.r2o} onChange={e => setDay(idx, { r2o: e.target.value })} className="prf-entrada prf-entrada--hora" aria-label={`${t.days[idx]} — 2`} />
                        <span className="perfil-rango__guion">–</span>
                        <input type="time" step={600} onFocus={abrirPicker} value={d.r2c} onChange={e => setDay(idx, { r2c: e.target.value })} className="prf-entrada prf-entrada--hora" />
                        <button type="button" className="perfil-turno2__quitar"
                          aria-label={`${t.quitarTurno2} — ${t.days[idx]}`}
                          onClick={() => { setDay(idx, { r2o: "", r2c: "" }); setTurno2(v => ({ ...v, [d.day]: false })); }}>
                          ×
                        </button>
                      </div>
                    ) : (
                      <button type="button" className="perfil-turno2"
                        aria-label={`${t.turno2} — ${t.days[idx]}`}
                        onClick={() => setTurno2(v => ({ ...v, [d.day]: true }))}>
                        {t.turno2}
                      </button>
                    )}
                  </div>
                )}
              </div>
              );
            })}
            <div className="prf-horas-nota">{t.hoursHint}</div>
          </div>

          {/* s184 - LAS FOTOS DEL LOCAL. Distintas del logo (la marca) y de la foto
              de cada oferta (el plato). Son las que arman el mosaico de /m/:id, que
              existe desde s183 y no pudo dibujar nada hasta s186 porque no habia
              forma de subirlas. s187: el WF esta en Live y arreglado — GALERIA_HABILITADA
              quedo en true (066e88d) y hay fotos reales cargadas por pantalla. El flag
              sigue existiendo por lo mismo de siempre: un control que no guarda es peor
              que no tenerlo, y apagarlo devuelve la pantalla al estado honesto (la nota
              de fotos del checklist tambien sigue al flag). */}
          {GALERIA_HABILITADA && (
            <div className="prf-bloque--ancho">
              {/* s200-D1 · «de tu NEGOCIO», no «de tu local»: la misma galeria lleva el
                  salon y los platos. Son las fotos del negocio, no las de cada oferta. */}
              <label htmlFor="nxt-f24" className="prf-etiqueta">
                {lang === "en" ? "PHOTOS OF YOUR BUSINESS" : "FOTOS DE TU NEGOCIO"}
                <span className="prf-etiqueta__cuenta">
                  {fotos.length} {lang === "en" ? "of" : "de"} {GALERIA_TOPE}
                </span>
              </label>
              {fotos.length > 0 ? (
                <div className="gal-grilla">
                  {fotos.map((u, i) => (
                    <div key={u + i} className={i === 0 ? "gal-pieza gal-pieza--principal" : "gal-pieza"}>
                      <img src={u} alt="" loading="lazy" />
                      <button type="button" className="gal-quitar" disabled={subiendo > 0 || !!portadaEn}
                        onClick={() => quitarFoto(u)}
                        aria-label={lang === "en" ? "Remove photo" : "Quitar foto"}>×</button>
                      {/* s203 · la primera ya dice PORTADA (::after); las demás ofrecen serlo. */}
                      {i > 0 && (
                        <button type="button" className="gal-portada" disabled={subiendo > 0 || !!portadaEn}
                          onClick={() => hacerPortada(u)}
                          aria-label={lang === "en" ? `Make photo ${i + 1} the cover` : `Hacer portada la foto ${i + 1}`}>
                          {portadaEn === u ? "…" : (lang === "en" ? "Make cover" : "Hacer portada")}
                        </button>
                      )}
                    </div>
                  ))}
                  {subiendo > 0 && (
                    <div className="gal-pieza">
                      <div className="gal-estado">
                        {lang === "en" ? `Uploading ${subiendo}…` : `Subiendo ${subiendo}…`}
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <div className="gal-vacia">
                  {subiendo > 0
                    ? (lang === "en" ? `Uploading ${subiendo}…` : `Subiendo ${subiendo}…`)
                    : (lang === "en"
                      ? "Members see these on your page. Real photos of the place — the room, the bar, the front."
                      : "Los miembros las ven en tu ficha. Fotos reales del lugar: el salón, la barra, la fachada.")}
                </div>
              )}
              <input id="nxt-f24" type="file" multiple accept="image/jpeg,image/png,image/webp"
                onChange={onFotos} disabled={subiendo > 0 || fotos.length >= GALERIA_TOPE}
                className="prf-archivo" />
              <div className="gal-ayuda">
                {fotos.length >= GALERIA_TOPE
                  ? lleno
                  : (lang === "en"
                    ? `The room, the bar, the front and your dishes. You frame each one before it goes up. The first is the cover. Up to ${GALERIA_TOPE}.`
                    : `El local, la barra, la fachada y tus platos. Cada una la encuadras tú antes de subirla. La primera es la portada. Hasta ${GALERIA_TOPE}.`)}
              </div>
              {errorFoto && (
                <div className="prf-foto-error" role="alert">{errorFoto}</div>
              )}

              {/* s200-D1 · el encuadre, de a una. La `key` es lo que hace que el <dialog>
                  se monte de nuevo con cada foto: sin ella, la segunda heredaria el zoom
                  y la posicion de la primera. */}
              {cola[0] && (
                <EncuadrarFoto
                  key={`${cola[0].name}-${cola[0].size}-${cola.length}`}
                  file={cola[0]}
                  proporcion={1}
                  en={lang === "en"}
                  titulo={lang === "en" ? "Frame this photo" : "Encuadra esta foto"}
                  onListo={(f) => { setCola(c => c.slice(1)); subirUna(f); }}
                  onCancelar={() => setCola(c => c.slice(1))}
                />
              )}
            </div>
          )}

          <div className="prf-bloque--ancho">
            <label htmlFor="nxt-f27" className="prf-etiqueta">{t.logo}</label>
            {logoPreview && (<img src={logoPreview} alt="logo" className="prf-logo-muestra" />)}
            <input id="nxt-f27" className={conMarca("prf-archivo", "nxt-f27")} type="file" accept="image/jpeg,image/png,image/webp" onChange={onLogo} />
            {logoPorEncuadrar && (
              <EncuadrarFoto
                key={`logo-${logoPorEncuadrar.name}-${logoPorEncuadrar.size}`}
                file={logoPorEncuadrar}
                proporcion={1}
                ladoMax={512}
                ladoMin={LOGO_LADO_MIN}
                tipoSalida={tipoDelLogo(logoPorEncuadrar)}
                en={lang === "en"}
                titulo={lang === "en" ? "Frame your logo" : "Encuadra tu logo"}
                onListo={logoEncuadrado}
                onCancelar={() => setLogoPorEncuadrar(null)}
              />
            )}
          </div>

          <button className="mrc-boton prf-guardar" onClick={handleSave} disabled={loading || hidratacion !== "ok"}>
            {loading ? t.saving : hidratacion === "cargando" ? (lang === "en" ? "Loading..." : "Cargando...") : t.save}
          </button>
          {/* s226 · contacto-responsable-alta: se guarda aparte (su propio botón) y no lo toca «Guardar cambios». */}
          {hidratacion === "ok" && <ContactoPerfil merchantId={merchantId} en={lang === "en"} />}
          {/* s202 · `cambiar-clave-en-la-app`: antes este boton mandaba a «¿Olvidaste tu
              contraseña?» (un correo) tambien a quien la sabe. */}
          <div className="prf-clave" id="cambiar-clave"><CambiarClave en={lang === "en"} /></div>
        </div>

        {/* ============================================================
            s189-F · EL PANEL DE LO QUE FALTA.
            Objetivo de Ali (05/09): «que el comercio complete. Google Place ayuda a
            completar lo maximo que pueda; lo que haga falta lo pone el dueno, pero
            tenemos que avisarle lo que falta.»

            Y lo que falta NO es casual — es siempre lo mismo, y lo sabemos:
              · descripcion → Places la tiene (editorialSummary) pero la dejamos afuera
                a proposito, sube el SKU de toda la llamada
              · logo        → Places tiene fotos y guardarlas cruza el TOS (s99/s103)
              · Instagram   → Places sencillamente no lo tiene
            Places llena los otros tres (horarios, telefono, sitio web), asi que TODO
            comercio nuevo aterriza en 50% con esos tres pendientes. Un checklist que
            solo informa no mueve a nadie: aca cada pendiente es un BOTON que lleva al
            campo, y dice para que sirve. El «para que» es la mitad que faltaba.
            ============================================================ */}
        {hidratacion === "ok" && (() => {
          const en = lang === "en";
          // s191 — la lista vive en `itemsDeFicha`, arriba, porque el recorrido del
          // dashboard cuenta LOS MISMOS seis. Aca los booleanos salen del formulario
          // EN VIVO y no del perfil guardado: el logo se marca apenas se sube.
          const items = itemsDeFicha({
            descripcion: form.description_es || form.description_en,
            logo: logoPreview,
            horarios: hours.some(d => d.r1o && d.r1c),
            telefono: form.phone,
            website: form.website,
            instagram: form.instagram,
          }, en);
          const faltan = items.filter(i => !i.ok);
          const hechos = items.filter(i => i.ok);
          const pct = Math.round((hechos.length / items.length) * 100);
          // Solo «approved». La ficha publica la sirve una privacy rule que pide
          // exactamente ese estado; con cualquier otro el enlace lleva a una pantalla
          // que dice «Negocio no encontrado» sobre el negocio propio.
          const aprobado = estado === "approved";
          return (
            <aside className="prf-riel">
              <div className="prf-falta">
                <div className="prf-falta__titulo">
                  {faltan.length
                    ? (en ? "WHAT'S MISSING ON YOUR PAGE" : "LO QUE FALTA EN TU FICHA")
                    : (en ? "YOUR PAGE IS COMPLETE" : "TU FICHA ESTÁ COMPLETA")}
                </div>
                <div className="prf-barra">
                  <div className="prf-barra-relleno" style={{ width: `${pct}%` }} />
                </div>
                <p className="prf-falta__cuenta">
                  {en
                    ? <><strong>{hechos.length} of {items.length}</strong> done.</>
                    : <><strong>{hechos.length} de {items.length}</strong> listos.</>}
                </p>

                {faltan.map(i => (
                  <div key={i.id} className="prf-pendiente-caja">
                    {/* El nombre accesible dice lo que el boton HACE. Sin el, el arbol de
                        accesibilidad lo lee como un boton sin nombre: el texto vive en dos
                        spans anidados y no todos los lectores lo componen. */}
                    <button type="button" className="prf-pendiente"
                      aria-label={en ? `Fill in ${i.nombre}` : `Completar ${i.nombre}`}
                      onClick={() => irAlCampo(i.id)}>
                      <span className="prf-pendiente__marca" aria-hidden="true">{"\u25cb"}</span>
                      <span>
                        <span className="prf-pendiente__nombre">{i.nombre}</span>
                        <span className="prf-pendiente__porque">{i.porque}</span>
                      </span>
                    </button>

                    {/* s189-G · el unico pendiente que alguien mas puede empezar por el
                        comercio. Va como una SEGUNDA accion y no reemplaza al salto: el
                        comercio que la quiere escribir el mismo no tiene que pasar por acá. */}
                    {i.id === "nxt-f36" && DESCRIPCION_IA_HABILITADA && merchantId && (
                      <button type="button" className="prf-pendiente__accion"
                        onClick={pedirDescripcion} disabled={escribiendo}>
                        {escribiendo
                          ? (en ? "Writing it\u2026" : "Escribiéndola\u2026")
                          : (en ? "Write it from my website" : "Escríbela con lo que leímos de mi sitio")}
                      </button>
                    )}
                    {i.id === "nxt-f36" && errorIA && (
                      <p className="prf-pendiente__error" role="status">
                        {errorIA.texto}
                        {errorIA.saltarA && (
                          <button type="button" className="prf-pendiente__enlace"
                            onClick={() => irAlCampo(errorIA.saltarA)}>
                            {en ? "Go to Website \u2192" : "Ir a Sitio web \u2192"}
                          </button>
                        )}
                      </p>
                    )}
                  </div>
                ))}

                {faltan.length === 0 && (
                  <p className="prf-falta__listo">
                    {en
                      ? "Your page has everything a member needs to decide."
                      : "Tu ficha tiene todo lo que un miembro necesita para decidir."}
                  </p>
                )}

                {hechos.map(i => (
                  <div key={i.id} className="prf-hecho">
                    <span className="prf-hecho__marca" aria-hidden="true">{"\u2713"}</span>
                    {/* s204 \u00b7 decia `en ? i.en : i.es`, campos que itemsDeFicha no tiene:
                        la lista de lo hecho eran \u2713 sin nombre. El nombre ya viene traducido. */}
                    {i.nombre}
                  </div>
                ))}

                {aprobado && merchantId ? (
                  <a className="prf-ficha-ver" href={`/m/${merchantId}`} target="_blank" rel="noreferrer">
                    {en ? "See my page \u2192" : "Ver mi ficha \u2192"}
                  </a>
                ) : (
                  <p className="prf-falta__aun-no">
                    {en
                      ? "Your page goes live once we approve your business. Everything you fill in now is already waiting for it."
                      : "Tu ficha se publica cuando aprobemos tu negocio. Todo lo que completes ahora ya la está esperando."}
                  </p>
                )}

                {/* s187 - ticket `copy-fotos-dice-que-las-sube-nxt`. Esta nota decia que
                    las fotos las cargaba el equipo de NXT. Era cierto hasta s186: ningun
                    workflow escribia la galeria porque `add_merchant_photo` agregaba el
                    TEXTO literal "photo" en vez del token (L#629) y toda subida colapsaba
                    en una entrada rota. Arreglado y con galerias reales en produccion. El
                    texto sigue al flag: si la galeria se apagara, la frase vieja vuelve a
                    ser la verdadera y nadie tiene que acordarse de restaurarla. */}
                <div className="prf-nota-fotos">
                  {GALERIA_HABILITADA
                    ? (en
                      ? "Photos of your place aren't on this list \u2014 you upload them yourself, further down the form."
                      : "Las fotos de tu local no están en esta lista \u2014 las subes tú, más abajo en el formulario.")
                    : (en
                      ? "Photos of your place are still loaded by the NXT team \u2014 send them over and they go up on your page."
                      : "Las fotos de tu local todavía las carga el equipo de NXT \u2014 envíalas y las subimos a tu ficha.")}
                </div>
              </div>
            </aside>
          );
        })()}
      </div>
    </div>
  );
}
// ============================================
// MERCHANT: OFFERS LIST
// ============================================
// s148 stopgap: editar puede corromper ofertas sanas de TODO el catálogo si la hidratación
// no trae los campos de valor (percent pierde typical_savings → benefit 0; bogo con datos
// históricos recomputa benefit y mueve su tarifa). true = botón Editar deshabilitado + save
// de edición bloqueado con cartel de mantenimiento.
// ANTES DE APAGAR este flag deben cumplirse las DOS condiciones:
//   1. El edit hidrata por canal AUTENTICADO (getMyOfferById, punto 1 s148) que valida
//      completitud por presencia de clave: typical_savings, unit_price e image — no basta
//      "tiene título" (una Approved percent por canal público hidrata título y offer_type
//      pero SIN typical_savings, y guardar escribiría benefit_value_usd = 0).
//   2. Smoke con sesión merchant real: abrir edit de una oferta propia y verificar que
//      Ahorro Típico / precio / foto llegan cargados antes de habilitar el save.
const OFFER_EDIT_MAINTENANCE = false;

// s156: campos de precio que cada tipo de oferta MUESTRA en el wizard. Todo lo que no
// esté acá para el tipo elegido se limpia al cambiar de tipo (ver chooseOfferType).
const PRICE_FIELDS_BY_TYPE = {
  // s194 L1: umbral escribe regular_price = mínimo (para approve_offer); el monto y el
  // mínimo viven en benefit_value_usd / min_consumption y los limpia chooseOfferType.
  umbral: ["regular_price"],
  fixed: ["regular_price", "coupon_price"],
  bogo: ["unit_price"],
  free: ["regular_price"],
  percent: ["regular_price", "discount_pct"],
};
const ALL_PRICE_FIELDS = ["regular_price", "coupon_price", "unit_price", "discount_pct", "typical_savings"];

// ============================================
// s226 · EL CONTACTO DEL RESPONSABLE (contacto-responsable-alta · decisión de Ali)
// ============================================
// El alta NO pide esto: es fricción al empezar. Se pide DESPUÉS de la primera oferta, opcional: una tarjeta en
// «Mis ofertas» (TarjetaContacto) y la misma sección en Perfil. Lo que se llene lo ve el Admin en la ficha del
// comercio (ContactoAdmin) y Otto en su lista (get_seeded_merchants). Nada de esto se publica.
// Maqueta aprobada: claude/maquetas_s226/contacto_despues_de_oferta.html.
const CONTACTO_ROLES = [["dueno", "Dueño", "Owner"], ["gerente", "Gerente", "Manager"], ["encargado", "Encargado", "Supervisor"], ["empleado", "Empleado", "Employee"], ["otro", "Otro", "Other"]];
const CONTACTO_HORAS = [["manana", "Mañana · 9–12", "Morning · 9–12"], ["tarde", "Tarde · 12–5", "Afternoon · 12–5"], ["noche", "Noche · 5–8", "Evening · 5–8"]];
const CONTACTO_CANALES = [["llamada", "Llamada", "Phone call"], ["whatsapp", "WhatsApp", "WhatsApp"]];
const etiquetaDe = (lista, v, en) => { const x = lista.find(o => o[0] === v); return x ? (en ? x[2] : x[1]) : ""; };
// «manana,tarde» → «Mañana · 9–12, Tarde · 12–5», en el orden del día.
const horasDe = (txt, en) => CONTACTO_HORAS.filter(h => String(txt || "").split(",").map(s => s.trim()).includes(h[0])).map(h => en ? h[2] : h[1]).join(", ");

// s254 · P11 (Ali): en la verificación el «Guardar» suelto confundía y «Seguir» no guardaba (lo marcado se perdía).
// `guardarRef`: el padre llama a guardar desde su propio botón; `sinBoton` esconde el «Guardar» de acá.
function FormContacto({ inicial, en, onGuardado, onCancelar, idBase = "contacto", guardarRef = null, sinBoton = false }) {
  const c0 = inicial || {};
  const [telefono, setTelefono] = useState(c0.contact_phone || "");
  const [rol, setRol] = useState(c0.contact_role || "");
  // Sin llenar, `contact_decides` llega como false: solo cuenta como «No» si el contacto ya se guardó alguna vez.
  const [decide, setDecide] = useState(c0.lleno ? (c0.contact_decides ? "si" : "no") : "");
  const [quien, setQuien] = useState(c0.decision_maker_name || "");
  const [quienTel, setQuienTel] = useState(c0.decision_maker_phone || "");
  const [horas, setHoras] = useState(() => String(c0.contact_best_time || "").split(",").map(s => s.trim()).filter(Boolean));
  const [canal, setCanal] = useState(c0.contact_channel || "");
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  const chip = (on, texto, onClick, key) => (
    <button key={key} type="button" className={on ? "alta-chip alta-chip--on" : "alta-chip"} aria-pressed={on} onClick={onClick}>{texto}</button>
  );
  // Devuelve true si guardó (o no había nada que guardar) y false si falló, para que el padre sepa si puede seguir.
  const guardar = async () => {
    const vacio = !telefono.trim() && !rol && !decide && !horas.length && !canal;
    if (sinBoton && vacio) return true;
    setGuardando(true); setError("");
    const contacto = {
      contact_phone: telefono, contact_role: rol, contact_decides: decide === "si",
      decision_maker_name: decide === "no" ? quien : "", decision_maker_phone: decide === "no" ? quienTel : "",
      contact_best_time: CONTACTO_HORAS.map(h => h[0]).filter(h => horas.includes(h)).join(","),
      contact_channel: canal,
    };
    try {
      const releido = await guardarContacto(contacto);
      onGuardado && onGuardado(releido || { ...contacto, lleno: true, contact_updated_at: new Date().toISOString() });
      return true;
    } catch (e) {
      setError(e.code === "PERFIL_NO_LEIDO"
        ? (en ? "We couldn't read your profile, so nothing was saved. Reload the page and try again." : "No pudimos leer tu perfil, así que no guardamos nada. Recarga la página e intenta de nuevo.")
        : (en ? "We couldn't save it. Try again in a moment." : "No se pudo guardar. Intenta de nuevo en un momento."));
      return false;
    } finally { setGuardando(false); }
  };
  if (guardarRef) guardarRef.current = guardar;

  return (
    <div className="ctc-form">
      <p className="ctc-form__intro">
        {en ? "Only the NXT Reserve team sees this. Nothing here is published. You can change it anytime in Profile."
            : "Solo los ve el equipo de NXT Reserve. Nada de esto se publica. Puedes cambiarlo cuando quieras en Perfil."}
      </p>

      <div className="alta-campo ctc-form__campo">
        <label htmlFor={`${idBase}-tel`} className="alta-etiqueta">{en ? "Your direct phone" : "Tu teléfono directo"}</label>
        <input id={`${idBase}-tel`} className="alta-input" type="tel" autoComplete="tel" placeholder="305-555-1234" value={telefono} onChange={e => setTelefono(e.target.value)} />
        <div className="ctc-form__nota">🔒 {en ? "Only NXT sees it." : "Solo lo ve NXT."}</div>
      </div>

      <div className="ctc-form__campo" role="group" aria-labelledby={`${idBase}-rol`}>
        <div id={`${idBase}-rol`} className="alta-etiqueta">{en ? "Your role" : "Tu cargo"}</div>
        <div className="alta-chips">{CONTACTO_ROLES.map(([v, es, enT]) => chip(rol === v, en ? enT : es, () => setRol(rol === v ? "" : v), v))}</div>
      </div>

      <div className="ctc-form__campo" role="group" aria-labelledby={`${idBase}-decide`}>
        <div id={`${idBase}-decide`} className="alta-etiqueta">{en ? "Do you decide on promotions?" : "¿Tú decides las promociones?"}</div>
        <div className="alta-chips">
          {chip(decide === "si", en ? "Yes" : "Sí", () => setDecide(decide === "si" ? "" : "si"), "si")}
          {chip(decide === "no", en ? "No, someone else" : "No, otra persona", () => setDecide(decide === "no" ? "" : "no"), "no")}
        </div>
        {decide === "no" && (
          <div className="ctc-form__quien">
            <div className="alta-campo">
              <label htmlFor={`${idBase}-quien`} className="alta-etiqueta">{en ? "Who decides" : "Nombre de quien decide"}</label>
              <input id={`${idBase}-quien`} className="alta-input" type="text" placeholder={en ? "E.g.: María, the owner" : "Ej.: María, la dueña"} value={quien} onChange={e => setQuien(e.target.value)} />
            </div>
            <div className="alta-campo">
              <label htmlFor={`${idBase}-quien-tel`} className="alta-etiqueta">{en ? "Their phone" : "Su teléfono"}</label>
              <input id={`${idBase}-quien-tel`} className="alta-input" type="tel" placeholder="305-555-1234" value={quienTel} onChange={e => setQuienTel(e.target.value)} />
            </div>
          </div>
        )}
      </div>

      <div className="ctc-form__campo" role="group" aria-labelledby={`${idBase}-horas`}>
        <div id={`${idBase}-horas`} className="alta-etiqueta">{en ? "When should we call you?" : "¿Cuándo te llamamos?"}</div>
        <div className="alta-chips">{CONTACTO_HORAS.map(([v, es, enT]) => chip(horas.includes(v), en ? enT : es, () => setHoras(h => h.includes(v) ? h.filter(x => x !== v) : [...h, v]), v))}</div>
      </div>

      <div className="ctc-form__campo" role="group" aria-labelledby={`${idBase}-canal`}>
        <div id={`${idBase}-canal`} className="alta-etiqueta">{en ? "How do you prefer?" : "¿Cómo prefieres?"}</div>
        <div className="alta-chips">{CONTACTO_CANALES.map(([v, es, enT]) => chip(canal === v, en ? enT : es, () => setCanal(canal === v ? "" : v), v))}</div>
      </div>

      {error && <div className="mrc-aviso mrc-aviso--error ctc-form__error" role="alert">{error}</div>}
      {!sinBoton && (
        <div className="ctc-form__botones">
          <button type="button" className="mrc-boton" onClick={guardar} disabled={guardando}>
            {guardando ? (en ? "Saving..." : "Guardando...") : (en ? "Save" : "Guardar")}
          </button>
          {onCancelar && <button type="button" className="ctc-link" onClick={onCancelar} disabled={guardando}>{en ? "Cancel" : "Cancelar"}</button>}
        </div>
      )}
    </div>
  );
}

// ============================================================================================
// s227-D1 · VERIFICAR EL CORREO DEL DUEÑO (OTP) · claude/SPEC_s227_verificacion_correo_otp.md + pase s227 (RESPUESTA
// `verificacion-correo-otp-momento`). El dueño crea y envía su oferta sin trabas; confirmar el correo es lo que deja
// que salga (`approve_offer` corta con OWNER_EMAIL_NOT_VERIFIED). React sabe si falta por `email_verified` de
// get_merchant_profile (export 137): se mira `=== false`, así que sin ese campo (antes del deploy) no aparece nada.
// ============================================================================================
const OTP_ESPERA_REENVIO = 60;   // s · send_email_otp responde OTP_TOO_SOON antes de 60 s
const correoSinVerificar = (perfil) => !!perfil && perfil.email_verified === false
  && String(perfil.status || "").trim().toLowerCase() !== "invitado";   // el invitado lo sella confirm_offer

// ============================================================================================
// s228 · DESPUÉS DEL CÓDIGO: «correo confirmado» (maqueta aprobada por Ali: claude/maquetas_s228/
// pantalla_correo_confirmado.html). Dos versiones:
// · A · verificado (auto_approved de verify_email_otp: el dominio del correo = la web en Google; o el comercio ya
//   estaba aprobado): qué sigue, sin llamadas.
// · B · hay que llamar: por qué verificamos, a qué teléfono llamamos y en cuánto, el contacto (FormContacto, opcional),
//   WhatsApp para hacerlo ya, y cambiar el correo de registro por el de la empresa (change_registration_email).
// ============================================================================================
const WA_VERIFICACION = "17864616536";               // Ali, s228: el WhatsApp de verificación
const WA_VERIFICACION_TEXTO = "+1 (786) 461-6536";
const primerNombre = (n) => String(n || "").trim().split(/\s+/)[0] || "";

// s228 · cambiar el correo de registro (change_registration_email, export 140). Se usa en «correo confirmado» y en la
// pantalla del código («¿Está mal? Cámbialo», por si se escribió mal). Después, VerificarCorreo pide el código nuevo.
function CambioCorreo({ en, textoBoton, onCambiado }) {
  const t = (es, ing) => (en ? ing : es);
  const [abierto, setAbierto] = useState(false);
  const [nuevo, setNuevo] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const [aviso, setAviso] = useState("");
  const cambiar = async (e) => {
    if (e) e.preventDefault();
    const c = nuevo.trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c)) { setAviso(t("Revisa el correo: parece incompleto.", "Check the email: it looks incomplete.")); return; }
    setOcupado(true); setAviso("");
    try {
      const r = await changeRegistrationEmail(c);
      if (r.ok) { setAbierto(false); setNuevo(""); onCambiado && onCambiado(String(r.email || c)); return; }
      setAviso({
        INVALID_EMAIL: t("Revisa el correo: parece incompleto.", "Check the email: it looks incomplete."),
        SAME_EMAIL: t("Ese ya es tu correo de registro.", "That's already your sign-in email."),
        EMAIL_ALREADY_EXISTS: t("Ese correo ya es de otra cuenta. Si es tuyo, escríbenos por WhatsApp.", "That email belongs to another account. If it's yours, message us on WhatsApp."),
        CHANGE_RATE_LIMIT: t("Cambiaste el correo varias veces seguidas. Espera un rato o escríbenos por WhatsApp.", "You changed your email several times in a row. Wait a while or message us on WhatsApp."),
        ALREADY_APPROVED: t("Tu negocio ya está aprobado: para cambiar el correo, escríbenos por WhatsApp.", "Your business is already approved: to change the email, message us on WhatsApp."),
      }[r.error_code] || t("No pudimos cambiar el correo. Inténtalo de nuevo.", "We couldn't change the email. Try again."));
    } catch (err) {
      setAviso(err.code === "WF_NOT_DEPLOYED"
        ? t("Por ahora, escríbenos por WhatsApp y lo cambiamos nosotros.", "For now, message us on WhatsApp and we'll change it for you.")
        : t("No pudimos cambiar el correo. Inténtalo de nuevo.", "We couldn't change the email. Try again."));
    } finally { setOcupado(false); }
  };
  if (!abierto) return (
    <button type="button" className="ctc-link cc-link" onClick={() => { setAbierto(true); setAviso(""); }}>{textoBoton}</button>
  );
  return (
    <form className="cc-cambio" onSubmit={cambiar}>
      <label htmlFor="cc-correo-nuevo" className="alta-etiqueta">{t("Tu correo de empresa", "Your business email")}</label>
      <input id="cc-correo-nuevo" className="alta-input" type="email" autoComplete="email" placeholder={t("tu@tunegocio.com", "you@yourbusiness.com")}
        value={nuevo} disabled={ocupado} onChange={e => { setNuevo(e.target.value); setAviso(""); }} />
      <p className="cc-nota">{t("Te mandamos un código nuevo a ese correo. Con ese correo vas a entrar a tu panel desde ahora.",
        "We'll send a new code to that email. From now on you'll sign in with it.")}</p>
      {aviso && <p className="otp__aviso" role="alert">{aviso}</p>}
      <div className="otp__botones">
        <button type="submit" className="mrc-boton" disabled={ocupado || !nuevo.trim()}>{ocupado ? "…" : t("Enviarme el código", "Send me the code")}</button>
        <button type="button" className="ctc-link" disabled={ocupado} onClick={() => { setAbierto(false); setAviso(""); }}>{t("Cancelar", "Cancel")}</button>
      </div>
    </form>
  );
}

function CorreoConfirmado({ correo, en, auto, comercioAprobado, motivo = "", webGoogle = "", onListo, onCorreoCambiado }) {
  const t = (es, ing) => (en ? ing : es);
  const [nombre, setNombre] = useState("");
  const [perfil, setPerfil] = useState(null);         // get_merchant_profile (teléfono, nombre del negocio)
  const [contacto, setContacto] = useState(undefined); // undefined cargando · null no se pudo leer
  const [contactoGuardado, setContactoGuardado] = useState(false);
  const guardarContactoRef = useRef(null);   // s254 · P11
  const [siguiendo, setSiguiendo] = useState(false);
  const verificado = auto || comercioAprobado;

  useEffect(() => {
    let vivo = true;
    getUserProfile().then(u => { if (vivo) setNombre(primerNombre(u?.name)); }).catch(() => {});
    getMerchantProfile().then(async p => {
      if (!vivo) return;
      setPerfil(p || null);
      const mid = String(p?.merchant_id || "").trim();
      const c = mid ? await leerContacto(mid).catch(() => null) : null;
      if (vivo) setContacto(c);
    }).catch(() => { if (vivo) { setPerfil(null); setContacto(null); } });
    return () => { vivo = false; };
  }, []);

  const negocio = String(perfil?.business_name || "").trim();
  const telefono = String(perfil?.phone || "").trim();
  const saludo = nombre ? t(`¡Listo, ${nombre}!`, `Done, ${nombre}!`) : t("¡Listo!", "Done!");
  const textoWa = encodeURIComponent(t(
    `Hola, soy ${nombre || "el dueño"}${negocio ? ` de ${negocio}` : ""}. Acabo de confirmar mi correo en NXT Reserve y quiero verificar mi negocio.`,
    `Hi, I'm ${nombre || "the owner"}${negocio ? ` from ${negocio}` : ""}. I just confirmed my email on NXT Reserve and want to verify my business.`));
  const enlaceWa = `https://wa.me/${WA_VERIFICACION}?text=${textoWa}`;

  // ---- A · verificado ----
  if (verificado) return (
    <div className="cc">
      <div className="otp otp--listo cc-cabeza" role="status">
        <span className="cc-sello">✓ {auto ? t("Negocio verificado", "Business verified") : t("Correo confirmado", "Email confirmed")}</span>
        <strong className="cc-titulo">{auto ? `${saludo} ${t("Tu negocio quedó verificado.", "Your business is verified.")}` : `${saludo} ${t("Confirmamos tu correo.", "We confirmed your email.")}`}</strong>
        {auto
          ? <span>{t("Tu correo ", "Your email ")}<b>{correo}</b>{t(" coincide con la web de tu negocio en Google: así confirmamos que el negocio es real y que tienes autorización para crear sus ofertas. Sin llamadas.",
              " matches your business website on Google: that's how we confirm the business is real and that you're authorized to create its offers. No calls needed.")}</span>
          : <span>{t("Tu negocio ya está verificado.", "Your business is already verified.")}</span>}
      </div>
      <div className="cc-bloque cc-bloque--panel">
        <b>{t("Qué sigue", "What's next")}</b>
        <ol className="cc-pasos">
          <li className="cc-pasos__hecho">{t("Confirmaste tu correo y verificamos tu negocio.", "You confirmed your email and we verified your business.")}</li>
          <li>{t("Revisamos tu oferta ", "We review your offer ")}<b>{t("en menos de 24 horas", "within 24 hours")}</b>.</li>
          <li>{t("Te avisamos a ", "We'll email ")}<b>{correo}</b>{t(" cuando quede lista para el día que abramos la membresía.", " when it's ready for the day the membership opens.")}</li>
        </ol>
      </div>
      <p className="cc-nota">{t("Protegemos tu negocio: cada oferta de NXT Reserve es de un negocio real y la publica alguien autorizado.",
        "We protect your business: every NXT Reserve offer comes from a real business and is published by someone authorized.")}</p>
      <div className="otp__botones"><button type="button" className="mrc-boton" onClick={onListo}>{t("Seguir", "Continue")}</button></div>
    </div>
  );

  // ---- B · hay que llamar ----
  return (
    <div className="cc">
      <div className="otp otp--listo cc-cabeza" role="status">
        <span className="cc-sello">✓ {t("Correo confirmado", "Email confirmed")}</span>
        <strong className="cc-titulo">{nombre ? t(`Listo, ${nombre}: confirmamos tu correo.`, `Done, ${nombre}: we confirmed your email.`) : t("Listo: confirmamos tu correo.", "Done: we confirmed your email.")}</strong>
        {correo && <span className="cc-correo">{correo}</span>}
      </div>

      <section className="cc-bloque cc-bloque--borde" aria-labelledby="cc-verificar">
        {/* s254 · P10 (maqueta «Verificación»): titular grande, una línea de por qué, y DOS opciones: WhatsApp primero (la
            principal, en el momento) y la llamada como alternativa, con su motivo y el teléfono. */}
        <h2 id="cc-verificar" className="cc-titular">{t("Ahora confirmamos que el negocio es tuyo", "Now we confirm the business is yours")}</h2>
        <p className="otp__texto">{t("Así nadie más puede crear ofertas a tu nombre. Elige cómo:", "That way nobody else can create offers in your name. Choose how:")}</p>
        <a className="cc-opcion cc-opcion--wa" href={enlaceWa} target="_blank" rel="noopener noreferrer">
          <span className="cc-opcion__icono" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 20l1.3-3.9A8 8 0 1 1 8 19z" /></svg></span>
          <span className="cc-opcion__texto"><b>{t("Escríbenos por WhatsApp", "Message us on WhatsApp")}</b>
            <span>{t("Lo hacemos en el momento · 9 a. m. a 9 p. m., hora del este", "We do it right away · 9 a.m. to 9 p.m. Eastern")}</span>
            <span>{WA_VERIFICACION_TEXTO}</span></span>
          <span className="cc-opcion__flecha" aria-hidden="true">→</span>
        </a>
        <div className="cc-opcion cc-opcion--llamada">
          <span className="cc-opcion__icono" aria-hidden="true"><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2" /></svg></span>
          <span className="cc-opcion__texto"><b>{t("O te llamamos en menos de 24 h", "Or we call you within 24 h")}</b>
        <span>{{
          dominio_distinto: t(`Tu correo no coincide con la web de tu negocio en Google${webGoogle ? ` (${webGoogle})` : ""}, así que te llamamos `, `Your email doesn't match your business website on Google${webGoogle ? ` (${webGoogle})` : ""}, so we'll call you `),
          sin_web: t("Tu negocio no tiene una web en Google con la que comparar tu correo, así que te llamamos ", "Your business has no website on Google to compare your email with, so we'll call you "),
          web_plataforma: t(`En Google tu negocio aparece en ${nombrePlataforma(webGoogle)}, no en una web propia, así que te llamamos `, `On Google your business points to ${nombrePlataforma(webGoogle)}, not your own website, so we'll call you `),
          sin_place_id: t("Tu negocio no está vinculado a Google, así que te llamamos ", "Your business isn't linked to Google, so we'll call you "),
        }[motivo] || t("Como tu correo es personal, te llamamos ", "Since your email is personal, we'll call you ")}{telefono
          ? t("al teléfono de tu negocio:", "at your business phone:")
          : t("al teléfono de tu negocio.", "at your business phone.")}</span>
            {telefono && <span className="cc-tel">{telefono}</span>}
            <span>{t("¿Otro número? Ponlo abajo en «Tu teléfono directo».", "A different number? Add it below in “Your direct phone”.")}</span>
          </span>
        </div>

        <div className="cc-separador" />
        <h3 className="otp__titulo">{t("Para que la llamada sea rápida", "To make the call quick")} <span className="cc-suave cc-opcional">{t("(opcional)", "(optional)")}</span></h3>
        {contacto === undefined && <p className="cc-nota">{t("Cargando…", "Loading…")}</p>}
        {contacto !== undefined && contactoGuardado && <p className="otp__texto" role="status">✅ {t("Guardado. Te llamamos en el horario que elegiste.", "Saved. We'll call you at the time you chose.")}</p>}
        {contacto !== undefined && !contactoGuardado && (
          <FormContacto idBase="cc-contacto" en={en} inicial={contacto || undefined} guardarRef={guardarContactoRef} sinBoton
            onGuardado={(c) => { setContacto(c); setContactoGuardado(true); }} />
        )}
      </section>

      {/* s228 · con correo de empresa la aprobación es al instante solo si el negocio tiene place_id y web en Google. */}
      {motivo !== "sin_place_id" && motivo !== "sin_web" && motivo !== "web_plataforma" && (
        <section className="cc-bloque cc-bloque--panel" aria-labelledby="cc-dominio">
          <h2 id="cc-dominio" className="otp__titulo">{t("¿Tienes un correo con el dominio de tu negocio?", "Do you have an email with your business domain?")}</h2>
          <p className="otp__texto cc-suave">{t("Por ejemplo, tu@tunegocio.com. Si coincide con tu web en Google, te verificamos al instante, sin llamada.",
            "For example, you@yourbusiness.com. If it matches your website on Google, we verify you instantly, no call needed.")}</p>
          <CambioCorreo en={en} textoBoton={t("Cambiar mi correo de registro", "Change my sign-in email")} onCambiado={onCorreoCambiado} />
        </section>
      )}

      {/* s254 · P11: «Seguir» guarda lo que el dueño marcó en «Para que la llamada sea rápida» y, si falla, no sigue. */}
      <div className="otp__botones"><button type="button" className="mrc-boton" disabled={siguiendo} onClick={async () => {
        setSiguiendo(true);
        const ok = !contactoGuardado && guardarContactoRef.current ? await guardarContactoRef.current() : true;
        setSiguiendo(false);
        if (ok) onListo();
      }}>{siguiendo ? t("Guardando…", "Saving…") : t("Seguir a mis ofertas", "Go to my offers")}</button></div>
    </div>
  );
}

// La pantalla del código. `despuesDeEnviar`: viene de enviar la 1.ª oferta (cambia el titular). Pide el código al
// montarse; OTP_TOO_SOON = ya salió uno hace menos de 60 s → se muestra igual, sin error.
function VerificarCorreo({ correo, en, despuesDeEnviar = false, comercioAprobado = false, onListo, onDespues }) {
  const [fase, setFase] = useState("enviando");       // enviando · codigo · listo · error
  const [codigo, setCodigo] = useState("");
  const [enfocado, setEnfocado] = useState(false);   // s254 · I7: qué casilla se ve activa
  const [aviso, setAviso] = useState("");
  const [ocupado, setOcupado] = useState(false);
  const [espera, setEspera] = useState(0);
  const [auto, setAuto] = useState(false);
  // s228 · el correo puede cambiar en esta misma pantalla (CorreoConfirmado → «Cambiar mi correo de registro»).
  const [correoActual, setCorreoActual] = useState(correo || "");
  const [motivo, setMotivo] = useState({ clave: "", web: "" });   // s228 · por qué no se aprobó solo (export 140)
  const [cambiado, setCambiado] = useState(false);                 // s228 · ya cambió el correo: «¿Está mal? Cámbialo»
  const [sinEnviar, setSinEnviar] = useState(false);               // s228 · OTP_TOO_SOON tras el cambio: el código aún no salió
  useEffect(() => { if (correo) setCorreoActual(c => c || correo); }, [correo]);
  const t = (es, ing) => (en ? ing : es);
  const quien = correoActual ? <b>{correoActual}</b> : t("tu correo", "your email");

  useEffect(() => {
    if (espera <= 0) return undefined;
    const id = setTimeout(() => setEspera(s => s - 1), 1000);
    return () => clearTimeout(id);
  }, [espera]);

  const pedir = async (motivo = "", siMuyPronto = "") => {
    setOcupado(true);
    try {
      const r = await sendEmailOtp();
      if (r.error_code === "ALREADY_VERIFIED") { setAuto(false); setFase("listo"); return; }
      // s228 · tras cambiar el correo, OTP_TOO_SOON = el código NO salió al correo nuevo (hubo uno hace <60 s): se dice.
      if (r.ok || r.error_code === "OTP_TOO_SOON") { setFase("codigo"); setEspera(OTP_ESPERA_REENVIO); setSinEnviar(!r.ok && !!siMuyPronto); setAviso(!r.ok && siMuyPronto ? siMuyPronto : motivo); return; }
      setFase(f => (f === "enviando" ? "error" : f));
      setAviso(r.error_code === "OTP_RATE_LIMIT"
        ? t("Pediste varios códigos seguidos. Espera un rato y vuelve a intentarlo.", "You asked for several codes in a row. Wait a while and try again.")
        : t("No pudimos enviarte el código. Inténtalo de nuevo en un momento.", "We couldn't send you the code. Try again in a moment."));
    } catch (_) {
      setFase(f => (f === "enviando" ? "error" : f));
      setAviso(t("No pudimos enviarte el código. Inténtalo de nuevo en un momento.", "We couldn't send you the code. Try again in a moment."));
    } finally { setOcupado(false); }
  };
  // Una sola vez por pantalla: en desarrollo, StrictMode corre el efecto dos veces (el ref sobrevive) y salían dos
  // send_email_otp (el 2.º daría OTP_TOO_SOON en Bubble).
  const pedido = useRef(false);
  useEffect(() => { if (pedido.current) return; pedido.current = true; pedir(); }, []);   // eslint-disable-line react-hooks/exhaustive-deps

  const verificar = async (e) => {
    if (e) e.preventDefault();
    if (codigo.length !== 6 || ocupado) return;
    setOcupado(true); setAviso("");
    try {
      const r = await verifyEmailOtp(codigo);
      if ((r.ok && r.verified) || r.error_code === "ALREADY_VERIFIED") {
        // Precedencia de Cowork (pase s228): sin place_id → correo personal → sin web → dominio distinto. Sin los campos, "".
        const clave = r.tiene_place_id === false ? "sin_place_id" : r.correo_personal === true ? "correo_personal"
          : r.tiene_place_id === null && r.correo_personal === null ? "" : !r.web_google ? "sin_web"
          : esPlataforma(r.web_google) ? "web_plataforma" : "dominio_distinto";   // s241 · Booksy, Instagram… no son web propia
        setMotivo({ clave, web: r.web_google || "" });
        setAuto(!!r.auto_approved); setFase("listo"); return;
      }
      setCodigo("");
      if (r.error_code === "OTP_EXPIRED") { await pedir(t("El código venció. Te enviamos uno nuevo.", "The code expired. We sent you a new one.")); return; }
      if (r.error_code === "OTP_LOCKED" || (r.error_code === "OTP_INVALID" && r.attempts_left !== null && r.attempts_left <= 0)) {
        setEspera(0); setAviso(t("Demasiados intentos. Pide un código nuevo.", "Too many attempts. Ask for a new code.")); return;
      }
      if (r.error_code === "OTP_INVALID") {
        const n = r.attempts_left;
        setAviso(n === null ? t("Código incorrecto.", "Wrong code.")
          : n === 1 ? t("Código incorrecto. Te queda 1 intento.", "Wrong code. You have 1 attempt left.")
          : t(`Código incorrecto. Te quedan ${n} intentos.`, `Wrong code. You have ${n} attempts left.`));
        return;
      }
      setAviso(t("No pudimos revisar el código. Inténtalo de nuevo.", "We couldn't check the code. Try again."));
    } catch (_) {
      setAviso(t("No pudimos revisar el código. Inténtalo de nuevo.", "We couldn't check the code. Try again."));
    } finally { setOcupado(false); }
  };

  if (fase === "listo") return (
    <CorreoConfirmado correo={correoActual} en={en} auto={auto} comercioAprobado={comercioAprobado}
      onListo={() => onListo && onListo(auto)}
      motivo={motivo.clave} webGoogle={motivo.web}
      onCorreoCambiado={(nuevo) => { setCorreoActual(nuevo); setCambiado(true); setCodigo(""); setAuto(false); setFase("enviando"); pedir("", t("Todavía no salió el código al correo nuevo: espera unos segundos y toca «Reenviar código».", "The code hasn't gone to the new email yet: wait a few seconds and tap “Resend code”.")); }} />
  );

  return (
    <section className="otp" aria-labelledby="otp-titulo">
      <h2 id="otp-titulo" className="otp__titulo">
        {despuesDeEnviar ? t("¡Listo! Tu oferta quedó guardada.", "Done! Your offer is saved.") : t("Confirma tu correo", "Confirm your email")}
      </h2>
      {fase === "enviando" && <p className="otp__texto">{t("Te estamos enviando el código…", "Sending you the code…")}</p>}
      {fase === "error" && (
        <>
          <p className="otp__texto" role="alert">{aviso}</p>
          <div className="otp__botones">
            <button type="button" className="mrc-boton" disabled={ocupado} onClick={() => pedir()}>{t("Intentar de nuevo", "Try again")}</button>
            {onDespues && <button type="button" className="ctc-link" onClick={onDespues}>{t("Lo hago después", "I'll do it later")}</button>}
          </div>
        </>
      )}
      {fase === "codigo" && (
        <form onSubmit={verificar}>
          <p className="otp__texto">
            {despuesDeEnviar
              ? <>{sinEnviar
                ? t("Para que pueda publicarse, confirma tu correo: vamos a enviarte un código de 6 dígitos a ", "For it to go live, confirm your email: we'll send a 6-digit code to ")
                : t("Para que pueda publicarse, confirma tu correo: te enviamos un código de 6 dígitos a ", "For it to go live, confirm your email: we sent a 6-digit code to ")}{quien}.</>
              : sinEnviar
              ? <>{t("Vamos a enviarte un código de 6 dígitos a ", "We'll send a 6-digit code to ")}{quien}.</>
              : <>{t("Te enviamos un código de 6 dígitos a ", "We sent a 6-digit code to ")}{quien}{t(". Escríbelo para que tus ofertas puedan publicarse.", ". Enter it so your offers can go live.")}</>}
          </p>
          <label htmlFor="otp-codigo" className="alta-etiqueta">{t("Código", "Code")}</label>
          {/* s254 · I7 (Uber, maqueta del rediseño): el código se ve en 6 casillas. Sigue siendo UN campo real, invisible
              encima de las casillas: así el teléfono lo completa solo (one-time-code) y pegarlo funciona igual. */}
          <div className="otp__casillas">
            {Array.from({ length: 6 }, (_, i) => (
              <span key={i} aria-hidden="true" className={["otp__casilla", codigo[i] && "otp__casilla--llena",
                enfocado && i === Math.min(codigo.length, 5) && "otp__casilla--activa"].filter(Boolean).join(" ")}>{codigo[i] || ""}</span>
            ))}
            <input id="otp-codigo" className="otp__campo-real" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]*"
              maxLength={6} value={codigo} autoFocus disabled={ocupado}
              onFocus={() => setEnfocado(true)} onBlur={() => setEnfocado(false)}
              onChange={e => { setCodigo(e.target.value.replace(/\D/g, "").slice(0, 6)); setAviso(""); }} />
          </div>
          <button type="submit" className="mrc-boton otp__confirmar" disabled={ocupado || codigo.length !== 6}>
            {ocupado ? "…" : t("Confirmar", "Confirm")}
          </button>
          {aviso && <p className="otp__aviso" role="alert">{aviso}</p>}
          <p className="otp__nota otp__nota--fuerte">{t("¿No te llegó? Mira en Promociones o en spam: Gmail a veces lo manda ahí.", "Didn't get it? Check Promotions or spam: Gmail sometimes puts it there.")}</p>
          <div className="otp__botones">
            <button type="button" className="ctc-link" disabled={ocupado || espera > 0} onClick={() => pedir()}>
              {espera > 0 ? t(`Reenviar código (${espera} s)`, `Resend code (${espera}s)`) : t("Reenviar código", "Resend code")}
            </button>
            {onDespues && <button type="button" className="ctc-link" onClick={onDespues}>{t("Lo hago después", "I'll do it later")}</button>}
          </div>
        </form>
      )}
      {/* s228 · después de cambiar el correo: si se escribió mal, se corrige aquí mismo (Cowork, spec §3.4). FUERA del
          <form> del código: CambioCorreo es otro <form>, y anidado enviaba el de afuera (recargaba la página). */}
      {fase === "codigo" && cambiado && <div className="otp__nota"><CambioCorreo en={en} textoBoton={t("¿Está mal? Cámbialo", "Is it wrong? Change it")}
        onCambiado={(nuevo) => { setCorreoActual(nuevo); setCodigo(""); setFase("enviando"); pedir("", t("Todavía no salió el código al correo nuevo: espera unos segundos y toca «Reenviar código».", "The code hasn't gone to the new email yet: wait a few seconds and tap “Resend code”.")); }} /></div>}
    </section>
  );
}

// El aviso fijo de Mis ofertas e Inicio, mientras falte confirmar el correo y haya al menos una oferta (el dueño
// primero crea; el aviso no se adelanta). El botón abre la pantalla del código ahí mismo.
function AvisoConfirmarCorreo({ perfil, hayOfertas, en, onVerificado, onAbierto }) {
  const [abierto, setAbiertoEstado] = useState(false);
  // s228 · Mis ofertas oculta su TarjetaContacto mientras esto está abierto: «correo confirmado» ya trae el formulario.
  const setAbierto = (v) => { setAbiertoEstado(v); if (onAbierto) onAbierto(v); };
  if (!hayOfertas || !correoSinVerificar(perfil)) return null;
  const aprobado = String(perfil.status || "").trim().toLowerCase() === "approved";
  if (abierto) return (
    <VerificarCorreo correo={perfil.email} en={en} comercioAprobado={aprobado}
      onListo={(auto) => { setAbierto(false); if (onVerificado) onVerificado(auto); }}
      onDespues={() => setAbierto(false)} />
  );
  return (
    <div className="otp otp--aviso" role="status">
      <p className="otp__texto">
        <b>{en ? "One step left:" : "Falta un paso:"}</b>{" "}
        {en ? "confirm your email so your offers can go live." : "confirma tu correo para que tus ofertas puedan publicarse."}
      </p>
      <div className="otp__botones">
        <button type="button" className="mrc-boton" onClick={() => setAbierto(true)}>{en ? "Confirm my email" : "Confirmar mi correo"}</button>
      </div>
    </div>
  );
}

// La tarjeta de «Mis ofertas»: sale con al menos una oferta enviada y el contacto sin llenar. «Ahora no» la
// esconde hasta que se cierre la pestaña (sessionStorage): en la próxima visita vuelve a salir hasta que lo llene.
// s239 · W19: `hayPublicada` — con una oferta ya publicada no se le dice «para aprobar tu oferta te vamos a llamar».
function TarjetaContacto({ merchantId, hayOfertas, hayPublicada = false, en }) {
  const clave = `nxt_contacto_ahora_no_${merchantId || ""}`;
  const [contacto, setContacto] = useState(undefined);   // undefined = leyendo · null = no se pudo leer
  const [abierta, setAbierta] = useState(false);
  const [gracias, setGracias] = useState(false);
  const [ahoraNo, setAhoraNo] = useState(() => { try { return sessionStorage.getItem(clave) === "1"; } catch (_) { return false; } });
  useEffect(() => {
    if (!merchantId || !hayOfertas) return;
    let vivo = true;
    leerContacto(merchantId).then(c => { if (vivo) setContacto(c); }).catch(() => { if (vivo) setContacto(null); });
    return () => { vivo = false; };
  }, [merchantId, hayOfertas]);

  if (gracias) return (
    <div className="ctc-tarjeta ctc-tarjeta--listo" role="status">
      <strong>{en ? "Thanks! We'll call the right person." : "¡Gracias! Así llamamos a la persona correcta."}</strong>
      <span>{en ? "You can change it anytime in Profile." : "Puedes cambiarlo cuando quieras en Perfil."}</span>
    </div>
  );
  if (!merchantId || !hayOfertas || !contacto || contacto.lleno || ahoraNo) return null;
  const cerrar = () => { try { sessionStorage.setItem(clave, "1"); } catch (_) {} setAhoraNo(true); };
  return (
    <section className="ctc-tarjeta" aria-labelledby="ctc-tarjeta-titulo">
      <h2 id="ctc-tarjeta-titulo" className="ctc-tarjeta__titulo">{en ? "Help us reach you" : "Ayúdanos a contactarte"}</h2>
      {!abierta ? (
        <>
          <p className="ctc-tarjeta__texto">
            {hayPublicada
              ? (en ? "If we ever need something about your offer, we'll call you. Tell us who to talk to and when works best. It's optional and takes 30 seconds."
                : "Si necesitamos algo de tu oferta, te llamamos. Dinos con quién hablamos y a qué hora te queda mejor. Es opcional y toma 30 segundos.")
              : (en ? "To approve your offer we'll give you a call. Tell us who to talk to and when works best. It's optional and takes 30 seconds."
                : "Para aprobar tu oferta te vamos a llamar. Dinos con quién hablamos y a qué hora te queda mejor. Es opcional y toma 30 segundos.")}
          </p>
          <div className="ctc-tarjeta__botones">
            <button type="button" className="mrc-boton" onClick={() => setAbierta(true)}>{en ? "Fill in my details" : "Completar mis datos"}</button>
            <button type="button" className="ctc-link" onClick={cerrar}>{en ? "Not now" : "Ahora no"}</button>
          </div>
        </>
      ) : (
        <FormContacto inicial={contacto} en={en} idBase="ctc-tarjeta"
          onGuardado={() => { setGracias(true); setAbierta(false); }}
          onCancelar={() => setAbierta(false)} />
      )}
    </section>
  );
}

// Perfil: la misma sección, siempre visible, para llenarla o corregirla.
function ContactoPerfil({ merchantId, en }) {
  const [contacto, setContacto] = useState(undefined);
  const [ok, setOk] = useState(false);
  const [vuelta, setVuelta] = useState(0);   // remonta el formulario con lo releído
  useEffect(() => {
    if (!merchantId) return;
    let vivo = true;
    leerContacto(merchantId).then(c => { if (vivo) setContacto(c); }).catch(() => { if (vivo) setContacto(null); });
    return () => { vivo = false; };
  }, [merchantId]);
  return (
    <div className="prf-bloque--ancho ctc-perfil" id="contacto">
      <div className="prf-seccion">{en ? "Your contact details" : "Tus datos de contacto"}</div>
      {contacto === undefined && <div className="ctc-form__nota">{en ? "Loading..." : "Cargando..."}</div>}
      {contacto === null && <div className="mrc-aviso mrc-aviso--error">{en ? "We couldn't load your contact details. Reload the page." : "No pudimos cargar tus datos de contacto. Recarga la página."}</div>}
      {contacto && (
        <>
          {ok && <div className="ctc-ok" role="status">✅ {en ? "Contact details saved" : "Datos de contacto guardados"}</div>}
          <FormContacto key={vuelta} inicial={contacto} en={en} idBase="ctc-perfil"
            onGuardado={(c) => { setContacto(c); setOk(true); setVuelta(v => v + 1); }} />
        </>
      )}
    </div>
  );
}

// Admin → Merchants → Detalles: lo que llenó el comercio, el nombre del responsable (del alta) y, aparte, lo que
// anotó Otto en sus llamadas (`decision_maker`, de operator_log_call).
const soloDigitos10 = (t) => { const d = String(t || "").replace(/\D/g, ""); return d.length === 10 ? "1" + d : d; };
function ContactoAdmin({ merchant, en }) {
  const [responsable, setResponsable] = useState(undefined);
  useEffect(() => {
    let vivo = true;
    nombreDeUsuario(merchant?.owner_user).then(n => { if (vivo) setResponsable(n); });
    return () => { vivo = false; };
  }, [merchant?.owner_user]);
  const c = contactoDe(merchant || {});
  const anotadoOtto = String(merchant?.decision_maker || "").trim();
  const fecha = c.lleno ? new Date(c.contact_updated_at).toLocaleDateString(en ? "en-US" : "es-US", { timeZone: "America/New_York", day: "2-digit", month: "2-digit", year: "2-digit" }) : "";
  const dato = (label, valor) => (
    <div className="ctc-admin__dato"><span>{label}</span><b>{valor || "—"}</b></div>
  );
  const nombreResp = responsable === undefined ? "…" : (responsable || "");
  return (
    <div className="ctc-admin">
      <div className="ctc-admin__titulo">
        {en ? "Contact" : "Contacto"}
        {c.lleno && <span> · {en ? `filled in by the merchant on ${fecha}` : `lo llenó el comercio el ${fecha}`}</span>}
      </div>
      {c.lleno ? (
        <>
          <div className="ctc-admin__grilla">
            {dato(en ? "Responsible" : "Responsable", [nombreResp, etiquetaDe(CONTACTO_ROLES, c.contact_role, en)].filter(Boolean).join(" · "))}
            {dato(en ? "Direct phone" : "Teléfono directo", c.contact_phone)}
            {dato(en ? "Decides?" : "¿Decide?", c.contact_decides ? (en ? "Yes" : "Sí") : ["No", c.decision_maker_name && (en ? `decides: ${c.decision_maker_name}` : `decide ${c.decision_maker_name}`)].filter(Boolean).join(" · "))}
            {dato(en ? "Decision maker's phone" : "Tel. de quien decide", c.contact_decides ? "" : c.decision_maker_phone)}
            {dato(en ? "Best time" : "Mejor horario", horasDe(c.contact_best_time, en))}
            {dato(en ? "Prefers" : "Prefiere", etiquetaDe(CONTACTO_CANALES, c.contact_channel, en))}
          </div>
          <div className="ctc-admin__acciones">
            {c.contact_phone && <a href={`tel:${c.contact_phone}`}>📞 {en ? "Call" : "Llamar"}{responsable ? (en ? " " : " a ") + responsable.split(" ")[0] : ""}</a>}
            {c.contact_phone && <a href={`https://wa.me/${soloDigitos10(c.contact_phone)}`} target="_blank" rel="noopener noreferrer">💬 WhatsApp</a>}
            {!c.contact_decides && c.decision_maker_phone && <a href={`tel:${c.decision_maker_phone}`}>📞 {en ? "Call" : "Llamar a"} {c.decision_maker_name || (en ? "decision maker" : "quien decide")}</a>}
          </div>
        </>
      ) : (
        <div className="ctc-admin__vacio">
          {en ? "No contact details yet." : "Sin datos de contacto todavía."}
          {nombreResp && <> {en ? "Responsible:" : "Responsable:"} {nombreResp} {en ? "(from sign-up)." : "(del alta)."}</>}
        </div>
      )}
      {anotadoOtto && (
        <div className="ctc-admin__otto"><span>{en ? "Noted by Otto" : "Anotado por Otto"}</span> {en ? "Decides:" : "Decide:"} {anotadoOtto}</div>
      )}
    </div>
  );
}

// s254 · I5/I6 (Airbnb «Your next steps», Square «Complete your setup 80 %»): lo que le falta al comercio, en UNA lista
// con avance, en vez de avisos sueltos. Sale del perfil que «Mis ofertas» ya pide (ni una llamada más); el menú no
// viene en get_merchant_profile y queda fuera. Desaparece cuando está todo. Los avisos de siempre siguen debajo.
function PasosDelNegocio({ profile, hayOfertas, en }) {
  const navigate = useNavigate();
  if (!profile || !hayOfertas) return null;
  const t = (es, ing) => (en ? ing : es);
  const galeria = Array.isArray(profile.gallery) ? profile.gallery.filter(Boolean) : profile.gallery ? [profile.gallery] : [];
  const pasos = [
    { id: "oferta", hecho: true, titulo: t("Oferta enviada", "Offer sent") },
    { id: "correo", hecho: !!profile.email_verified, titulo: t("Confirma tu correo", "Confirm your email"), tituloHecho: t("Correo confirmado", "Email confirmed"),
      nota: t("El código está en tu correo (mira también en Promociones)", "The code is in your email (check Promotions too)") },
    { id: "foto", hecho: galeria.length > 0, titulo: t("Sube una foto", "Upload a photo"), tituloHecho: t("Foto subida", "Photo uploaded"),
      nota: t("Sin foto no sales en el catálogo", "Without a photo you're not in the catalog"),
      accion: { texto: t("Subir", "Upload"), ir: () => navigate("/merchant/tu-negocio") } },
    { id: "verificado", hecho: String(profile.status || "").toLowerCase() === "approved", titulo: t("Verifica tu negocio", "Verify your business"), tituloHecho: t("Negocio verificado", "Business verified"),
      nota: t("Por WhatsApp, en el momento", "On WhatsApp, right away"),
      accion: { texto: t("Verificar", "Verify"), href: `https://wa.me/${WA_VERIFICACION}` } },
  ];
  const hechos = pasos.filter(p => p.hecho).length;
  if (hechos === pasos.length) return null;
  const pct = Math.round((hechos / pasos.length) * 100);
  return (
    <section className="pasos" aria-labelledby="pasos-titulo">
      <div className="pasos__cabeza">
        <h2 id="pasos-titulo" className="pasos__titulo">{t("Tus próximos pasos", "Your next steps")}</h2>
        <div className="pasos__avance"><span>{t("Tu negocio está al", "Your business is at")}</span> <b>{pct} %</b></div>
        <div className="pasos__pista" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
          <div className="pasos__lleno" style={{ width: `${pct}%` }} />
        </div>
      </div>
      <ul className="pasos__lista">
        {pasos.map(p => (
          <li key={p.id} className={p.hecho ? "pasos__item pasos__item--hecho" : "pasos__item"}>
            <span className="pasos__marca" aria-hidden="true">{p.hecho ? "✓" : ""}</span>
            <span className="pasos__texto"><b>{p.hecho && p.tituloHecho ? p.tituloHecho : p.titulo}</b>{!p.hecho && p.nota && <small>{p.nota}</small>}</span>
            {!p.hecho && p.accion && (p.accion.href
              ? <a className="pasos__boton" href={p.accion.href} target="_blank" rel="noopener noreferrer">{p.accion.texto}</a>
              : <button type="button" className="pasos__boton" onClick={p.accion.ir}>{p.accion.texto}</button>)}
          </li>
        ))}
      </ul>
    </section>
  );
}

function MerchantOffers() {
  const lang = useLang();
  const en = lang === 'en';
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState(null);
  const [actioningId, setActioningId] = useState(null);   // X.43: oferta en proceso de pausar/borrar
  const [verificandoCorreo, setVerificandoCorreo] = useState(false);   // s228 · oculta TarjetaContacto (no se repite)
  const [actionError, setActionError] = useState("");
  const [bulk, setBulk] = useState("");                    // s194 L2: "pause" | "resume" mientras corre «todas»
  // s176 FIX 2: el perfil ya se pedia aca (para el merchantId); ahora tambien se guarda
  // para saber si el comercio puede crear ofertas.
  const [profile, setProfile] = useState(null);

  // X.43: las ofertas Archived (borradas por el merchant) no se muestran — ver
  // misOfertasDelComercio (s204).

  // s191 — EL PUENTE A LAS PROPUESTAS GUARDADAS. Esta pantalla contaba OFERTAS, y una
  // propuesta guardada todavia no es una Offer: el comercio que acababa de guardar tres
  // entraba a «Mis Ofertas» y leia «TODAVIA NO HAY OFERTAS». Tecnicamente cierto y en la
  // practica desconcertante — lo suyo estaba ahi, pero solo aparecia entrando por
  // «Nueva oferta», que es el boton que suena a empezar de cero.
  // Sale del perfil que esta pantalla YA pedia: ni una llamada mas.
  const borrador = (() => {
    try { return readAdvisorDraft(profile, lang); } catch (_) { return null; }
  })();
  // s240 (Ali, opción 2): solo las propuestas que el dueño ya vio y trabajó. Las crudas (las escribe el servidor: la
  // lectura del alta, o una generación cuya respuesta no llegó) son ofertas del asesor viejo —2x1, upsell, precios de la
  // IA— que el dueño nunca pidió ver aquí. Siguen a mano en «Nueva oferta».
  const nBorrador = borradorTrabajado(borrador) ? borrador.offers.length : 0;

  useEffect(() => {
    const load = async () => {
      try {
        getMerchantStats().then(s => setStats(s)).catch(() => {});
        const allOff = await getAllOffers();
        const merchantProfile = await getMerchantProfile();
        setProfile(merchantProfile);
        // s204 · el filtro (por comercio, o por quien la creo si no hay id; sin las
        // Archived) vive en misOfertasDelComercio: la insignia del tope cuenta sobre
        // la misma lista que esta pantalla muestra.
        setOffers(misOfertasDelComercio(allOff, merchantProfile));
      } catch (e) {
        console.error("Error loading offers:", e);
        setOffers([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  // s204 · cada vez que la lista cambia (al cargar, al pausar o reanudar) la insignia
  // de «Mis Ofertas» del tope se pone al dia sin esperar su propia lectura.
  useEffect(() => {
    if (!loading) avisarPendientesDelComercio(contarPendientes(offers));
  }, [offers, loading]);

  // X.43: pausar / reanudar / borrar (archivar) una oferta propia.
  const runAction = async (offer, op) => {
    const id = offer._id || offer.id;
    if (!id) return;
    if (op === "delete") {
      const msg = lang === "en"
        ? "Delete this offer? It will be hidden from members. You can recreate it later."
        : "¿Borrar esta oferta? Se ocultará de los miembros. Puedes volver a crearla luego.";
      if (!window.confirm(msg)) return;
    }
    setActionError("");
    setActioningId(id);
    try {
      const resp = await setOfferStatus(id, op);
      const newStatus = resp?.status || (op === "pause" ? "Paused" : op === "resume" ? "Approved" : "Archived");
      setOffers(prev =>
        op === "delete"
          ? prev.filter(o => (o._id || o.id) !== id)
          : prev.map(o => ((o._id || o.id) === id ? { ...o, status: newStatus } : o))
      );
    } catch (e) {
      const friendly = {
        NOT_OWNER: lang === "en" ? "This offer isn't yours." : "Esta oferta no es tuya.",
        INVALID_TRANSITION: lang === "en" ? "That action isn't allowed for this offer's state." : "Esa acción no aplica al estado actual de la oferta.",
      };
      setActionError(friendly[e.code] || (lang === "en" ? "Could not update the offer." : "No se pudo actualizar la oferta."));
    } finally {
      setActioningId(null);
    }
  };

  const statusBadge = (status) => {
    const s = (status || "").toLowerCase();
    // s204 · los colores viven en merchant.css (.ofr-estado--*); la etiqueta iba en 10px.
    const estados = {
      approved: { mod: "ofr-estado--aprobada", label: lang === "en" ? "Approved" : "Aprobada" },
      pending: { mod: "", label: lang === "en" ? "Pending" : "Pendiente" },
      rejected: { mod: "ofr-estado--rechazada", label: lang === "en" ? "Rejected" : "Rechazada" },
      paused: { mod: "ofr-estado--pausada", label: lang === "en" ? "Paused" : "Pausada" },
    };
    const c = estados[s] || estados.pending;
    return (<span className={("ofr-estado " + c.mod).trim()}>{c.label}</span>);
  };

  // s176 FIX 2: mismo criterio que el dashboard, una sola funcion para los dos.
  const puedeCrearOfertas = merchantCanCreateOffers(profile);

  // s184 - EL ORDEN LO DECIDE EL TRABAJO, NO LA FECHA DE CARGA.
  // La lista venia como llegaba del canal: rechazadas, activas y pendientes
  // mezcladas. Para el comercio son tres situaciones distintas -una le pide que
  // haga algo, otra le informa como le va, la tercera solo espera- y meterlas en
  // una sola columna obliga a leerlas todas para encontrar la que importa.
  // Dentro de las publicadas manda el USO: la que mas gente activo, arriba.
  const usos = (o) => Number(o.coupons_activated) || 0;
  const grupo = (nombres) => offers
    .filter(o => nombres.includes((o.status || "").toLowerCase()))
    .sort((a, b) => usos(b) - usos(a));
  // s239 · auditoría s237 (E5): las pausadas iban en «Te esperan» como si tuvieran un problema; tienen su grupo.
  const atencion = grupo(["rejected"]);
  const publicadas = grupo(["approved"]);
  const enRevision = grupo(["pending"]);
  const pausadas = grupo(["paused"]);

  // s194 L2 · «¿Hoy estás lleno?» (SÍNTESIS §3.6): un toque pausa TODAS las publicadas y
  // otro las reabre. Mismo WF de siempre (set_offer_status, una llamada por oferta, en
  // orden); si una falla, las anteriores ya cambiaron y el aviso dice cuántas.
  const cambiarTodas = async (op) => {
    const lista = op === "pause" ? publicadas : pausadas;
    if (!lista.length) return;
    setActionError(""); setBulk(op);
    let hechas = 0;
    try {
      for (const o of lista) {
        const id = o._id || o.id;
        const resp = await setOfferStatus(id, op);
        const nuevo = resp?.status || (op === "pause" ? "Paused" : "Approved");
        setOffers(prev => prev.map(x => ((x._id || x.id) === id ? { ...x, status: nuevo } : x)));
        hechas += 1;
      }
    } catch (e) {
      setActionError((en ? `${hechas} of ${lista.length} updated. ` : `${hechas} de ${lista.length} actualizadas. `)
        + (e?.message || (en ? "Could not update the rest." : "No se pudo actualizar el resto.")));
    } finally { setBulk(""); }
  };

  const Fila = ({ offer }) => {
    const id = offer._id || offer.id;
    const st = (offer.status || "").toLowerCase();
    const busy = actioningId === id;
    const n = usos(offer);
    const tope = Number(offer.max_coupons) || 0;   // 0 = sin tope
    const valor = Number(offer.benefit_value_usd || offer.benefit_value) || 0;
    return (
      <div className="ofr-fila">
        {/* s184 - LA CIFRA. Es lo unico de esta pantalla que el comercio no puede
            saber por su cuenta: todo lo demas lo cargo el. */}
        <div className={n === 0 ? "ofr-uso ofr-uso--cero" : "ofr-uso"}>
          <div className="ofr-uso-cifra">
            {n}{tope > 0 ? <span className="ofr-uso-tope">/{tope}</span> : null}
          </div>
          <div className="ofr-uso-rotulo">
            {n === 1 ? (en ? "activation" : "activación") : (en ? "activations" : "activaciones")}
          </div>
        </div>

        <div className="ofr-fila__cuerpo">
          <div className="ofr-titulo">
            {tituloOfertaVisible(offer, en) || (en ? "Untitled" : "Sin título")}
            {statusBadge(offer.status)}
            {/* s227-D1 · la Pending no puede salir hasta que el dueño confirme su correo */}
            {st === "pending" && correoSinVerificar(profile) && (
              <span className="ofr-estado otp-etiqueta">{en ? "Confirm your email" : "Falta confirmar tu correo"}</span>
            )}
          </div>
          <div className="ofr-meta">
            {/* s199 (H1 del smoke §1): en una umbral, «Ahorra $30» engaña — el socio recibe
                $30 SI GASTA $60. Se dice la frase entera, la misma del alta y del catálogo. */}
            {/* s239 · W17: si el título ya es la frase generada («Ahorra $20 cuando gastas $40 · Almuerzo»), no se repite aquí. */}
            {(esUmbral(offer) && esTituloUmbralGenerado(offer.title_es || offer.title_en)) || (esPorcentaje(offer) && esTituloPorcentajeGenerado(offer.title_es || offer.title_en))
              ? null
              : esUmbral(offer) || (esPorcentaje(offer) && Number(offer.discount_pct) > 0)
              ? <span>{textoValorOferta(offer, en)}</span>
              : (valor > 0 && <span>{en ? "Saves" : "Ahorra"} ${fmtUsd(valor)}</span>)}
            <span>{CAT_DISPLAY[offer.category] || offer.category || "\u2014"}</span>
          </div>
          {/* s239 · auditoría s237 🔴 #2 (E4): «Mis ofertas» no decía cuándo vale. Los días y la hora ya vienen en la oferta;
              mismo formato corto que la consola de Otto (diasCortos) y la hora en 24 h, como el alta. */}
          <div className="ofr-repite">{en ? "Valid " : "Vale "}{cuandoValeCorto(offer, en)}</div>
          {/* "cooldown" es jerga nuestra. El comercio necesita saber cada cuanto un
              mismo miembro puede volver a usarla, y eso se dice con palabras. */}
          {/* s213 · el plazo de ESTA oferta (default 30, s212-D18), con «todos los días» para el 1. */}
          <div className="ofr-repite">
            {diasPlazo(offer) === 1
              ? (en ? "A member can use it once a day" : "Un miembro puede usarla una vez al día")
              : (en ? `A member can use it again after ${diasPlazo(offer)} days` : `Un miembro puede repetirla cada ${diasPlazo(offer)} días`)}
          </div>
        </div>

        <div className="ofr-acciones">
          <button className="ofr-btn" disabled={busy || OFFER_EDIT_MAINTENANCE}
            onClick={() => navigate("/merchant/offers/edit/" + id)}>
            {en ? "Edit" : "Editar"}
          </button>
          {st === "approved" && (
            <button className="ofr-btn" disabled={busy} onClick={() => runAction(offer, "pause")}
              title={en ? "Hide it from members" : "Ocultarla de los miembros"}>
              {busy ? "\u2026" : (en ? "Pause" : "Pausar")}
            </button>
          )}
          {st === "paused" && (
            <button className="ofr-btn ofr-btn--reanudar" disabled={busy} onClick={() => runAction(offer, "resume")}>
              {busy ? "\u2026" : (en ? "Resume" : "Reanudar")}
            </button>
          )}
          <button className="ofr-btn ofr-btn--borrar" disabled={busy} onClick={() => runAction(offer, "delete")}>
            {busy ? "\u2026" : (en ? "Delete" : "Borrar")}
          </button>
        </div>
      </div>
    );
  };

  const Grupo = ({ titulo, lista, pideAccion }) => lista.length === 0 ? null : (
    <section className={pideAccion ? "ofr-grupo ofr-grupo--atencion" : "ofr-grupo"}>
      <h2 className="ofr-grupo-titulo">{titulo}</h2>
      {lista.map((o, i) => <Fila key={o._id || o.id || i} offer={o} />)}
    </section>
  );

  const resumen = [
    publicadas.length > 0 && (publicadas.length + " " + (en ? "published" : (publicadas.length === 1 ? "publicada" : "publicadas"))),
    enRevision.length > 0 && (enRevision.length + " " + (en ? "in review" : "en revisión")),
    pausadas.length > 0 && (pausadas.length + " " + (en ? "paused" : (pausadas.length === 1 ? "pausada" : "pausadas"))),
    atencion.length > 0 && (atencion.length + " " + (en ? "need you" : (atencion.length === 1 ? "te espera" : "te esperan"))),
  ].filter(Boolean).join(" \u00b7 ");

  return (
    <div className="mrc-pagina">
      <MerchantHeader businessName={stats?.business_name} activePage="offers" />
      <div className="mrc-cuerpo">
        <div className="ofr-cabeza">
          <div>
            <h1 className="ofr-cabeza__titulo">{en ? "MY OFFERS" : "MIS OFERTAS"}</h1>
            {/* El conteo dice el estado real y no un total que no significa nada:
                "7 ofertas" no le sirve a nadie; saber cuantas estan publicadas si. */}
            <div className="ofr-cabeza__resumen">{loading ? "" : resumen}</div>
          </div>
          <button className="mrc-boton" onClick={() => navigate("/merchant/offers/new")} disabled={!puedeCrearOfertas}>
            {en ? "New offer" : "Nueva oferta"}
          </button>
        </div>

        {!loading && <PasosDelNegocio profile={profile} hayOfertas={offers.length > 0} en={en} />}
        {/* s194 L2 · «Hoy estamos llenos»: solo aparece cuando hay algo que pausar o reabrir. */}
        {!loading && (publicadas.length > 0 || pausadas.length > 0) && (
          <div className="mrc-aviso ofr-lleno">
            <div className="ofr-lleno__texto">
              <div className="ofr-lleno__titulo">{en ? "Full today?" : "¿Hoy estás lleno?"}</div>
              <div className="ofr-lleno__nota">
                {/* s241 · cuándo se reabren, según el rubro (perfil-por-rubro): las del local solo en restaurantes y bares. */}
                {en ? `Pause all your offers with one tap and reopen them ${perfilDelRubro(profile?.category).lleno.en}.` : `Pausa todas tus ofertas con un toque y reábrelas ${perfilDelRubro(profile?.category).lleno.es}.`}
              </div>
            </div>
            <div className="ofr-lleno__botones">
              {publicadas.length > 0 && (
                <button className="ofr-btn" disabled={!!bulk} onClick={() => cambiarTodas("pause")}>
                  {bulk === "pause" ? "…" : (en ? `Pause all (${publicadas.length})` : `Pausar todas (${publicadas.length})`)}
                </button>
              )}
              {pausadas.length > 0 && (
                <button className="ofr-btn ofr-btn--reanudar" disabled={!!bulk} onClick={() => cambiarTodas("resume")}>
                  {bulk === "resume" ? "…" : (en ? `Reopen all (${pausadas.length})` : `Reabrir todas (${pausadas.length})`)}
                </button>
              )}
            </div>
          </div>
        )}
        {!puedeCrearOfertas && <OfferGateNote lang={lang} />}
        {actionError && (
          <div className="mrc-aviso mrc-aviso--error" role="alert">{actionError}</div>
        )}
        {/* s227-D1 · falta confirmar el correo: el aviso fijo, con al menos una oferta */}
        {!loading && <AvisoConfirmarCorreo perfil={profile} hayOfertas={offers.length > 0} en={en} onAbierto={setVerificandoCorreo}
          onVerificado={() => setProfile(p => (p ? { ...p, email_verified: true } : p))} />}
        {/* s239 · auditoría s237 (E5): con 4 ofertas las tarjetas de abajo desaparecían sin aviso. Se dice el máximo. */}
        {!loading && puedeCrearOfertas && publicadas.length + pausadas.length > 0
          && offers.filter(o => (o.status || "").toLowerCase() !== "rejected").length >= 4 && (
          <div className="mrc-aviso" role="status">{en
            ? "You have 4 offers, the most a business can have. To add another one (another time slot, for example), delete one first."
            : "Tienes 4 ofertas, el máximo por negocio. Para agregar otra (otro horario, por ejemplo), primero borra una."}</div>
        )}
        {/* s235 · agrega-otra-franja: con ≥1 aprobada y cupo, la misma oferta en otro momento del día (wizard ?franja=1). */}
        {!loading && puedeCrearOfertas && publicadas.length + pausadas.length > 0 && !esEncargo(profile?.category)
          && offers.filter(o => (o.status || "").toLowerCase() !== "rejected").length < 4 && (
          <section className="imp-tarjeta" aria-labelledby="franja-tarjeta-titulo">
            <div>
              <h2 id="franja-tarjeta-titulo" className="imp-tarjeta__titulo">{en ? "Add another time slot" : "Agrega otra franja"}</h2>
              <p className="imp-tarjeta__texto">{en ? `Bring members in at another time too: ${perfilDelRubro(profile?.category).otroMomento.en}.` : `Recibe miembros también en otro momento: ${perfilDelRubro(profile?.category).otroMomento.es}.`}</p>
            </div>
            <button type="button" className="mrc-boton" onClick={() => navigate("/merchant/offers/new?franja=1")}>{en ? "Add it" : "Agregarla"}</button>
          </section>
        )}
        {/* s239 · auditoría s237-D7: si una publicada ya cuenta como Imperdible (todo monto fijo: el mínimo dobla al descuento,
            isBestDealOffer), se le dice eso en vez de invitarlo a crear otra y gastar un cupo de 4. Con una pausada que
            cuenta, no se dice nada (no está en el catálogo, pero tampoco hace falta otra). */}
        {!loading && publicadas.some(isBestDealOffer) && (
          <section className="imp-tarjeta" aria-labelledby="imp-tarjeta-titulo">
            <div>
              <h2 id="imp-tarjeta-titulo" className="imp-tarjeta__titulo">{en ? "Your offer is already in Can't-miss" : "Tu oferta ya está en Imperdibles"}</h2>
              <p className="imp-tarjeta__texto">{en
                ? `«${textoValorOferta(publicadas.find(isBestDealOffer), true)}» already counts as Can't-miss: it shows in that section of the catalog. You don't need to create another one.`
                : `«${textoValorOferta(publicadas.find(isBestDealOffer), false)}» ya cuenta como Imperdible: sale en esa sección del catálogo. No hace falta crear otra.`}</p>
            </div>
          </section>
        )}
        {/* s227-D4 · la invitación a una oferta Imperdible: con ≥1 aprobada y cupo (< 4 sin archivar ni rechazar). */}
        {!loading && puedeCrearOfertas && publicadas.length + pausadas.length > 0
          && ![...publicadas, ...pausadas].some(isBestDealOffer)
          && offers.filter(o => (o.status || "").toLowerCase() !== "rejected").length < 4 && (
          <section className="imp-tarjeta" aria-labelledby="imp-tarjeta-titulo">
            <div>
              <h2 id="imp-tarjeta-titulo" className="imp-tarjeta__titulo">{en ? "Create a Can't-miss offer" : "Crea una oferta Imperdible"}</h2>
              <p className="imp-tarjeta__texto">{en ? "2-for-1 or 50% or more: it goes into the catalog's Can't-miss section." : "2×1 o 50 % o más: entra en la sección Imperdibles del catálogo."}</p>
            </div>
            <button type="button" className="mrc-boton" onClick={() => navigate("/merchant/offers/new?imperdible=1")}>{en ? "Create it" : "Crearla"}</button>
          </section>
        )}
        {/* s226 · contacto-responsable-alta: opcional, después de la primera oferta */}
        {/* s228 · con la pantalla del correo abierta no se repite: «correo confirmado» ya trae el mismo formulario. */}
        {!loading && !verificandoCorreo && <TarjetaContacto merchantId={profile?.merchant_id} hayOfertas={offers.length > 0} hayPublicada={publicadas.length + pausadas.length > 0} en={en} />}
        {loading && (
          <div className="ofr-cargando">
            {en ? "Loading offers..." : "Cargando ofertas..."}
          </div>
        )}

        {!loading && nBorrador > 0 && (
          <button type="button" className="ofr-borrador" onClick={() => navigate("/merchant/offers/new?ver=propuestas")}>
            <span className="ofr-borrador__texto">
              <span className="ofr-borrador__titulo">
                {en
                  ? `You have ${nBorrador} saved ${nBorrador === 1 ? "proposal" : "proposals"}`
                  : `Tienes ${nBorrador} ${nBorrador === 1 ? "propuesta guardada" : "propuestas guardadas"}`}
              </span>
              <span className="ofr-borrador__nota">
                {en
                  ? "They are not published yet. Pick up where you left off and edit them."
                  : "Todavía no están publicadas. Retómalas donde las dejaste y edítalas."}
              </span>
            </span>
            <span className="ofr-borrador__flecha" aria-hidden="true">{"→"}</span>
          </button>
        )}

        {!loading && offers.length === 0 && (
          <div className="ofr-vacio">
            <div className="ofr-vacio-titulo">{en ? "NO OFFERS YET" : "TODAVÍA NO HAY OFERTAS"}</div>
            <div className="ofr-vacio-texto">
              {en
                ? "An offer is what members see and activate. Create the first one and it will show up here with how many people used it."
                : "Una oferta es lo que los miembros ven y activan. Crea la primera y aparecerá aquí con cuánta gente la usó."}
            </div>
            <button className="mrc-boton" onClick={() => navigate("/merchant/offers/new")} disabled={!puedeCrearOfertas}>
              {en ? "Create my first offer" : "Crear mi primera oferta"}
            </button>
            {!puedeCrearOfertas && <OfferGateNote lang={lang} />}
          </div>
        )}

        <Grupo titulo={en ? "Need your attention" : "Te esperan"} lista={atencion} pideAccion />
        <Grupo titulo={en ? "Published" : "Publicadas"} lista={publicadas} />
        <Grupo titulo={en ? "Paused" : "Pausadas"} lista={pausadas} />
        <Grupo titulo={en ? "In review" : "En revisión"} lista={enRevision} />
      </div>
    </div>
  );
}

// ============================================
// MERCHANT: CREATE OFFER (v2 — 4 Offer Types)
// ============================================
// s154 lote D — valid_days/valid_time_* llegan sucios de la era texto-libre (días pre-s78,
// horas pre-s154). Al hidratar el form de edición se normalizan al vocabulario controlado:
// días → tokens FEED_DAY_TOKENS sin tilde (así viven en la base), horas → "HH:MM" 24h
// (el formato de <input type="time">, mismo que serializeHours en el perfil). Lo que no se
// puede interpretar queda vacío y el merchant lo re-elige; la DB no se toca hasta guardar.
// s181 HOTFIX · hidratación de valid_days en Editar (solo LECTURA — el envío no cambia).
// Shape REAL del canal, verificado el 26/08 contra GET /obj/offer (público, 18 ofertas):
// `valid_days` es un CAMPO LISTA de textos (`valid_days_list_text`) y llega como ARRAY de
// tokens sin acento — ["Vie","Sab"], ["Lun","Mar","Mie","Jue"] — a veces con basura de la
// era texto-libre (["Lun - Jue"], ["Martes tu Juevez "]) o []. El wizard trabaja con el
// string "Lun,Mar" y así lo MANDA a create_offer/update_offer: ese contrato no se toca.
// Acá se aceptan las DOS formas (array o string por comas) y se normaliza POR TOKEN:
// trim → minúsculas → sin acentos → {lun, mar, mie, jue, vie, sab, dom}; también el nombre
// completo y la abreviatura en inglés. Token no reconocido: se ignora sin romper, con
// console.warn. Si llegó algo y no se reconoció NINGÚN día, se imprime el valor crudo —
// es la evidencia que hace falta la próxima vez que un Editar abra con los chips apagados.
const DAY_ALIASES = {
  lun: 0, lunes: 0, mon: 0, monday: 0,
  mar: 1, martes: 1, tue: 1, tues: 1, tuesday: 1,
  mie: 2, mier: 2, miercoles: 2, wed: 2, wednesday: 2,
  jue: 3, jueves: 3, thu: 3, thur: 3, thurs: 3, thursday: 3,
  vie: 4, viernes: 4, fri: 4, friday: 4,
  sab: 5, sabado: 5, sat: 5, saturday: 5,
  dom: 6, domingo: 6, sun: 6, sunday: 6,
};
// Conectores de la era texto-libre: no son días, pero tampoco basura — no se reportan.
// Solo los de RANGO ("Lun a Vie", "Mar al Jue", "Mon to Fri") expanden; "lunes y viernes"
// es una conjunción, son dos días sueltos.
const DAY_RANGE_WORDS = new Set(["a", "al", "to", "tu", "hasta"]);
const DAY_FILLER_WORDS = new Set(["y", "and", "e", "los", "las", "the", "dias", "days", "dia", "day"]);
// "Todos los días" / "Every day" / "Daily" también vivió en texto libre: son los 7.
const DAY_ALL_WORDS = new Set(["todos", "todo", "every", "everyday", "all", "daily", "diario", "diaria", "siempre"]);
function normalizeValidDays(raw) {
  const items = (Array.isArray(raw) ? raw : [raw]).filter(x => x !== null && x !== undefined && String(x).trim() !== "");
  const strip = (s) => String(s).normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim();
  const keep = new Set();
  const noReconocidos = [];
  items.forEach(item => {
    const words = strip(item).split(/[^a-z]+/).filter(Boolean);
    if (words.some(w => DAY_ALL_WORDS.has(w))) { FEED_DAY_TOKENS.forEach((_, i) => keep.add(i)); return; }
    const idxs = [];
    words.forEach(w => {
      if (DAY_ALIASES[w] !== undefined) idxs.push(DAY_ALIASES[w]);
      else if (!DAY_RANGE_WORDS.has(w) && !DAY_FILLER_WORDS.has(w)) noReconocidos.push(w);
    });
    // "Jue – Sáb" / "Lun a Vie" eran RANGOS en la era texto-libre: dos días unidos por guion
    // o conector de rango se expanden inclusivo (misma regla que s154 lote D).
    const hayUnion = /[–—-]/.test(String(item)) || words.some(w => DAY_RANGE_WORDS.has(w));
    const esRango = idxs.length === 2 && hayUnion && idxs[0] < idxs[1];
    (esRango ? FEED_DAY_TOKENS.map((_, i) => i).slice(idxs[0], idxs[1] + 1) : idxs).forEach(i => keep.add(i));
  });
  if (noReconocidos.length) console.warn("[valid_days] tokens no reconocidos, ignorados:", noReconocidos, "· raw:", JSON.stringify(raw));
  if (!keep.size && items.length) console.warn("[valid_days] llegó un valor y no se reconoció ningún día · tipo:", Array.isArray(raw) ? "array" : typeof raw, "· raw:", JSON.stringify(raw));
  return FEED_DAY_TOKENS.filter((_, i) => keep.has(i)).join(",");
}
function normalizeValidTime(raw) {
  const m = String(raw || "").trim().match(/^(\d{1,2})(?::(\d{2}))?\s*(a\.?m\.?|p\.?m\.?)?$/i);
  if (!m) return "";
  let h = parseInt(m[1], 10);
  const min = m[2] || "00";
  const ap = (m[3] || "").toLowerCase();
  if (ap.startsWith("p") && h < 12) h += 12;
  if (ap.startsWith("a") && h === 12) h = 0;
  if (h > 23 || parseInt(min, 10) > 59) return "";
  return `${String(h).padStart(2, "0")}:${min}`;
}

// ---- LAS PIEZAS DE LA FORMA (s185) -----------------------------------------
// Las cinco vivian DENTRO del cuerpo de MerchantCreateOffer, declaradas con
// `const X = () => ...`. Eso las convertia en un TIPO de componente NUEVO en
// cada render: React no tiene forma de saber que son la misma, asi que
// desmontaba el arbol y montaba otro — y con el, los <input> de adentro.
//
// 🔴 MEDIDO EN EL NAVEGADOR el 29/08, sobre esta misma pantalla, paso 3:
//     Titulo          (escrito directo en el JSX)   -> 14 teclas, 14 quedaron, foco intacto
//     Precio regular  (dentro de <PricingFields />) -> 1 tecla y el foco se fue al <body>
//     Valor beneficio (escrito directo en el JSX)   -> 2 teclas, 2 quedaron, foco intacto
// Mismo render, mismo `set()`, misma pantalla: lo unico distinto es el anidado.
// O sea que el comercio no podia escribir "120" sin volver a hacer clic tres
// veces — y los unicos campos rotos eran los del DINERO, que son justo los que
// deciden si la oferta se aprueba. Subirlas a nivel de modulo es todo el
// arreglo: el tipo pasa a ser estable y el <input> deja de morir en cada tecla.
//
// 🛑 NO volver a declarar un componente dentro del cuerpo de otro.
// Ni el build ni el lint lo veian. Se vio tecleando.

// La ayuda en globo. Tiene estado propio, asi que ademas era la que peor lo
// pasaba: una tecla en cualquier campo se lo reseteaba.
// s240: `izq` para el «?» pegado al borde izquierdo de un campo (A7, A13): el globo abre hacia la derecha.
function AltaPista({ texto, izq }) {
  const [abierto, setAbierto] = useState(false);
  return (
    <span className={izq ? "alta-pista alta-pista--izq" : "alta-pista"}
      onMouseEnter={() => setAbierto(true)}
      onMouseLeave={() => setAbierto(false)}>
      <button type="button" className="alta-pista__marca"
        aria-expanded={abierto} aria-label={texto}
        onClick={() => setAbierto(v => !v)}>?</button>
      {abierto && <span className="alta-pista__globo" role="tooltip">{texto}</span>}
    </span>
  );
}

// La etiqueta. `para` la ata al campo (htmlFor/id): antes era un <label> suelto,
// que para un lector de pantalla no nombra nada. Y la pista sale FUERA del
// <label> — un boton dentro de una etiqueta se dispara al tocar la etiqueta.
//
// `grupo` es para los rotulos que NO mandan sobre un solo control: «Días» son
// siete chips, «Horario» son dos, el idioma son dos botones. Ahi un <label
// htmlFor> es peor que nada: le roba el nombre al primer control del grupo.
// Verificado en el arbol de accesibilidad — con htmlFor, el boton «Español»
// se anunciaba como «¿En qué idioma estás escribiendo la oferta?». En modo
// grupo el rotulo es un <div> con id, y el contenedor lo referencia con
// role="group" + aria-labelledby.
function AltaEtiqueta({ para, grupo, texto, pista, requerido }) {
  return (
    <div className="alta-rotulo">
      {grupo
        ? <div className="alta-etiqueta" id={grupo}>{texto}{requerido && " *"}</div>
        : <label className="alta-etiqueta" htmlFor={para}>{texto}{requerido && " *"}</label>}
      {pista && <AltaPista texto={pista} />}
    </div>
  );
}

function AltaAyuda({ id, texto }) {
  return <div className="alta-ayuda" id={id}>{texto}</div>;
}

function AltaPasos({ paso, lang }) {
  const en = lang === "en";
  // s179 L2: el wizard es de CINCO pasos, no de cuatro. El corte entre 3 y 4 cae
  // donde cae por una razon dura: TODO lo que puede hacer que approve_offer
  // rechace la oferta vive en 3. Nada de 4 puede tumbarla.
  const pasos = [
    { n: 1, nombre: en ? "Type" : "Tipo" },
    { n: 2, nombre: en ? "Template" : "Plantilla" },
    { n: 3, nombre: en ? "Your offer" : "Tu oferta" },
    { n: 4, nombre: en ? "The details" : "Los detalles" },
    { n: 5, nombre: en ? "Review" : "Revisar" },
  ];
  return (
    <div className="alta-pasos">
      {pasos.map(p => (
        <div key={p.n} className={paso >= p.n ? "alta-paso alta-paso--hecho" : "alta-paso"}>
          <div className="alta-paso__marca">{p.n}</div>
          <div className="alta-paso__nombre">{p.nombre}</div>
        </div>
      ))}
    </div>
  );
}

// Los campos de precio, que cambian con el tipo de oferta. ESTOS eran los que
// perdian el foco a cada tecla.
// s186 · EL DINERO, PREGUNTADO EN EL IDIOMA DEL COMERCIO.
// Antes eran dos campos uno al lado del otro —«Precio regular ($)» y «Precio con cupón
// ($)»— rotulados como los llama la base de datos. Un dueño de negocio no piensa «voy a
// definir el precio con cupón»: piensa «el churrasco vale 32, lo dejo en 22», o piensa
// «les hago 20% off». Son las dos formas, y solo le ofrecíamos una.
//
// Ahora se pregunta, y el comercio elige con qué mano lo escribe. Por detrás son LOS
// MISMOS DOS CAMPOS de siempre —`regular_price` y `coupon_price`—: el porcentaje no se
// guarda en ningún lado, es una forma de escribir el segundo precio. Por eso esto no
// toca el guardado, ni las validaciones, ni lo que ve el admin.
//
// Y el número que NO escribió se le muestra igual, calculado: escriba el precio final o
// escriba el porcentaje, siempre ve los dos. Que es justo lo que necesita para decidir.
function PreciosFixed({ form, set, setVal, lang }) {
  const en = lang === "en";
  const dos = (n) => Math.round(n * 100) / 100;
  const regular = Number(form.regular_price) || 0;
  const cupon = Number(form.coupon_price);
  const hayCupon = String(form.coupon_price).trim() !== "" && !isNaN(cupon);

  // El % que se desprende de los dos precios. Null cuando no se puede afirmar:
  // sin precio normal, o con un cupón que no es menor (ahí el invariante ya está roto
  // y de eso avisa el paso, no este cartel).
  const pctDerivado = regular > 0 && hayCupon && cupon >= 0 && cupon < regular
    ? Math.round(((regular - cupon) / regular) * 100)
    : null;

  // Arranca en «precio final» a propósito: es lo que ya venía haciendo la pantalla, y
  // lo que traen llenas las plantillas y las propuestas del asesor. El porcentaje está
  // a un toque para quien piensa así.
  const [modo, setModo] = useState("precio");
  const [pct, setPct] = useState("");

  const irAPct = () => {
    setModo("pct");
    if (pctDerivado != null) setPct(String(pctDerivado));   // no se pierde lo ya escrito
  };

  const aplicarPct = (valor) => {
    setPct(valor);
    const p = Number(valor);
    if (regular > 0 && valor !== "" && !isNaN(p) && p >= 0 && p <= 100) {
      setVal("coupon_price", String(dos(regular * (1 - p / 100))));
    }
  };

  // Cambiar el precio normal con el % puesto tiene que recalcular el otro: si no, el
  // comercio sube el precio de lista y el descuento que ve deja de ser el que pidió.
  const onRegular = (e) => {
    const v = e.target.value;
    setVal("regular_price", v);
    const r = Number(v);
    const p = Number(pct);
    if (modo === "pct" && r > 0 && pct !== "" && !isNaN(p)) {
      setVal("coupon_price", String(dos(r * (1 - p / 100))));
    }
  };

  const chipSt = { flex: 1, borderRadius: "var(--radio-boton)", padding: "12px 14px", fontSize: 14 };

  return (
    <>
      <div className="alta-campo">
        <AltaEtiqueta para="alta-precio-regular" requerido
          texto={en ? "What's the normal price of what you're offering?" : "¿Cuál es el precio normal de lo que vas a ofrecer?"}
          pista={en ? "The price your customer pays today, without any coupon" : "El precio que tu cliente paga hoy, sin ningún cupón"} />
        <input id="alta-precio-regular" className="alta-input" type="number" min="0" inputMode="decimal"
          aria-describedby="alta-precio-regular-ayuda"
          value={form.regular_price} onChange={onRegular} placeholder="120" />
        <AltaAyuda id="alta-precio-regular-ayuda"
          texto={en ? "Eg: if a dinner for two costs $120, write 120" : "Ej: si una cena para dos cuesta $120, escribe 120"} />
      </div>

      <div className="alta-campo">
        <AltaEtiqueta grupo="alta-modo-rotulo"
          texto={en ? "How do you want to build the discount?" : "¿Cómo quieres armar el descuento?"} />
        <div style={{ display: "flex", gap: 8 }} role="group" aria-labelledby="alta-modo-rotulo">
          <button type="button" aria-pressed={modo === "pct"} onClick={irAPct}
            className={modo === "pct" ? "alta-chip alta-chip--on alta-chip--fuerte" : "alta-chip"}
            style={chipSt}>
            {en ? "I take a % off" : "Le bajo un %"}
          </button>
          <button type="button" aria-pressed={modo === "precio"} onClick={() => setModo("precio")}
            className={modo === "precio" ? "alta-chip alta-chip--on alta-chip--fuerte" : "alta-chip"}
            style={chipSt}>
            {en ? "I set the final price" : "Pongo el precio final"}
          </button>
        </div>
      </div>

      {modo === "pct" ? (
        <div className="alta-campo">
          <AltaEtiqueta para="alta-baja-pct" requerido
            texto={en ? "How much do you take off?" : "¿Cuánto le bajas?"} />
          <input id="alta-baja-pct" className="alta-input" type="number" min="0" max="100" inputMode="decimal"
            aria-describedby="alta-baja-pct-ayuda"
            value={pct} onChange={(e) => aplicarPct(e.target.value)} placeholder="30" />
          <AltaAyuda id="alta-baja-pct-ayuda" texto={
            regular <= 0
              ? (en ? "Write the normal price first and we'll do the math." : "Escribe primero el precio normal y hacemos la cuenta.")
              : pct === ""
                ? (en ? "Eg: 30 means 30% off" : "Ej: 30 significa 30% de descuento")
                : (en ? `With your coupon the member pays $${dos(Number(form.coupon_price) || 0).toFixed(2)}` : `Con tu cupón el miembro paga $${dos(Number(form.coupon_price) || 0).toFixed(2)}`)
          } />
        </div>
      ) : (
        <div className="alta-campo">
          <AltaEtiqueta para="alta-precio-cupon" requerido
            texto={en ? "How much does the member pay with the coupon?" : "¿Cuánto paga el miembro con el cupón?"} />
          <input id="alta-precio-cupon" className="alta-input" type="number" min="0" inputMode="decimal"
            aria-describedby="alta-precio-cupon-ayuda"
            value={form.coupon_price} onChange={set("coupon_price")} placeholder="75" />
          <AltaAyuda id="alta-precio-cupon-ayuda" texto={
            pctDerivado != null
              ? (en ? `You're taking ${pctDerivado}% off` : `Le estás bajando un ${pctDerivado}%`)
              : (en ? "Eg: with the coupon they pay $75" : "Ej: con el cupón pagan $75")
          } />
        </div>
      )}
    </>
  );
}

// s194 L1 · LA OFERTA ESTÁNDAR: se elige un tamaño, no se escriben precios. Cada tamaño
// fija los tres campos que ya existen (benefit_value_usd = monto · min_consumption =
// mínimo · regular_price = mínimo, para pasar approve_offer: benefit ≤ regular > 0).
// «Dos franjas» crea DOS ofertas al enviar (almuerzo / cena), cada una con su tamaño y su
// horario preset (H3): no hay campo `daypart`. El selector es una función, no un
// componente anidado, para no remontar en cada tecla (misma lección que PreciosFixed).
function PreciosUmbral({ form, setForm, lang, esEdicion, categoria, sinD }) {
  const en = lang === "en";
  // s194 L2 · el gasto por persona vive solo acá (no es dato de la oferta) y la sugerencia
  // se muestra hasta que el comercio toque otro tamaño. s195 (s194-D13): se pregunta POR
  // PERSONA y sin propina, que es la unidad de la tabla; antes era la cuenta de la mesa.
  const [ticket, setTicket] = useState("");
  const [sugerido, setSugerido] = useState(null);
  const pregunta = preguntaTicket(categoria, en);   // s215 · mesa de dos en restaurantes y bares
  const elegir = (campo, id) => setForm(f => {
    const t = UMBRAL_TAMANOS.find(x => x.id === id);
    if (!t) return f;
    const next = { ...f, [campo]: id };
    if (campo === "umbral_tamano") {
      next.benefit_value_usd = String(t.monto);
      next.min_consumption = String(t.minimo);
      next.regular_price = String(t.minimo);
      // El título nace de la frase y se puede reescribir. Solo se pisa si estaba vacío o
      // si todavía era una frase generada — nunca lo que el comercio escribió a mano.
      // s212 · ya no se escribe la fórmula como título: el título es el qué. Si había una fórmula, se vacía.
      // s223 · si trae franja (« · Cena»), queda solo la cola: el título se rearma con el tamaño nuevo al guardar.
      if (esTituloUmbralGenerado(f.title)) next.title = partirFranja(f.title).sufijo;
    }
    return next;
  });
  const selector = (campo, rotulo) => (
    <div className="alta-campo">
      <AltaEtiqueta grupo={`alta-umbral-${campo}`} requerido texto={rotulo} />
      <div className="alta-opciones" role="group" aria-labelledby={`alta-umbral-${campo}`}>
        {/* s199-D9: en la oferta sembrada, la Destacada no se ofrece (la elige Ali, no el
            dueño). s203 (auditoría A3-03): en el alta propia TAMPOCO mientras esté bloqueada
            (DESTACADA_HABILITADA, s199-D2): se ofrecía y nadie la podía activar. */}
        {/* s250 · solo los tamaños del rubro (al editar, el que la oferta ya tiene se sigue viendo). */}
        {UMBRAL_TAMANOS.filter(t => (tamanosDelRubro(categoria).some(x => x.id === t.id) && !(sinD && t.id === "D")) || form[campo] === t.id).map(t => {
          const on = form[campo] === t.id;
          return (
            <button key={t.id} type="button" aria-pressed={on}
              className={on ? "alta-opcion alta-opcion--elegida" : "alta-opcion"}
              onClick={() => elegir(campo, t.id)}>
              <div className="alta-opcion__icono">{t.id === "D" ? "★" : t.id}</div>
              <div className="alta-opcion__texto">
                <div className="alta-opcion__nombre">{fraseUmbral(t.monto, t.minimo, en)}</div>
                {/* s242 · inventario de textos de otros rubros (Ali): la línea de rubros de cada tamaño («Bares, coctelerías…»,
                    «Cena, spa…») era una tabla única y una heladería leía la guía de un restaurante. Queda solo el nombre del tamaño. */}
                <div className="alta-opcion__nota">{en ? t.en : t.es}</div>
                {t.id === "D" && (
                  <div className="alta-opcion__ej">{en ? "Only for members with an active subscription" : "Solo para miembros con suscripción activa"}</div>
                )}
              </div>
              <div className="alta-opcion__flecha">{on ? "✓" : "→"}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
  const sugerir = () => {
    // s203: la sugerencia tampoco propone la Destacada bloqueada (igual que la siembra).
    const s = sinDestacada(sugerirTamanoUmbral(categoria, ticketPorPersona(categoria, ticket)));
    if (!s) return;
    if (form.umbral_franjas) {
      const a = unTamanoMenos(s.id);
      elegir("umbral_tamano", a.id);
      elegir("umbral_tamano_cena", s.id);
      setSugerido({ almuerzo: a, cena: s });
    } else {
      elegir("umbral_tamano", s.id);
      setSugerido({ solo: s });
    }
  };
  const textoSugerido = !sugerido ? "" : sugerido.solo
    ? fraseUmbral(sugerido.solo.monto, sugerido.solo.minimo, en)
    : `${en ? UMBRAL_FRANJAS[0].en : UMBRAL_FRANJAS[0].es}: ${fraseUmbral(sugerido.almuerzo.monto, sugerido.almuerzo.minimo, en)} · ${en ? UMBRAL_FRANJAS[1].en : UMBRAL_FRANJAS[1].es}: ${fraseUmbral(sugerido.cena.monto, sugerido.cena.minimo, en)}`;
  return (
    <>
      {/* s194 L2 · «Te sugerimos»: una pregunta, un botón, cero IA. El comercio confirma. */}
      <div className="alta-campo">
        <AltaEtiqueta para="alta-umbral-ticket" texto={pregunta.texto} pista={pregunta.pista} />
        <div style={{ display: "flex", gap: 8, alignItems: "stretch", flexWrap: "wrap" }}>
          <input id="alta-umbral-ticket" className="alta-input" type="number" min="0" inputMode="decimal" style={{ flex: 1, minWidth: 120 }}
            value={ticket} onChange={e => setTicket(e.target.value)} placeholder={`${en ? "E.g.:" : "Ej:"} ${pregunta.ej}`} />
          <button type="button" className="alta-chip alta-chip--fuerte" onClick={sugerir} style={{ borderRadius: "var(--radio-boton)", padding: "12px 16px", fontSize: 14 }}>
            {en ? "Suggest a size" : "Sugerir tamaño"}
          </button>
        </div>
        {textoSugerido && (
          <AltaAyuda texto={(en
            ? `For your category${Number(ticket) > 0 ? ` and $${fmtUsd(ticket)} ${pregunta.unidad}` : ""} we suggest: `
            : `Para tu rubro${Number(ticket) > 0 ? ` y $${fmtUsd(ticket)} ${pregunta.unidad}` : ""} te sugerimos: `) + textoSugerido} />
        )}
      </div>
      {selector("umbral_tamano", form.umbral_franjas
        ? (en ? "Lunch size" : "Tamaño para el almuerzo")
        : (en ? "Pick the size" : "Elige el tamaño"))}
      {!esEdicion && (
        <div className="alta-campo">
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14, color: "var(--tinta)", fontWeight: 600 }}>
            <input type="checkbox" checked={!!form.umbral_franjas}
              onChange={e => setForm(f => ({ ...f, umbral_franjas: e.target.checked, umbral_tamano_cena: e.target.checked ? f.umbral_tamano_cena : "" }))} />
            {en ? "Two sizes by daypart (lunch / dinner)" : "Dos tamaños por franja (almuerzo / cena)"}
          </label>
          <AltaAyuda texto={en
            ? "Creates two offers: lunch 11:30–15:00 and dinner 18:00–23:00. You can adjust the hours later from My Offers."
            : "Crea dos ofertas: almuerzo 11:30–15:00 y cena 18:00–23:00. Los horarios se ajustan después desde Mis Ofertas."} />
        </div>
      )}
      {form.umbral_franjas && selector("umbral_tamano_cena", en ? "Dinner size" : "Tamaño para la cena")}
    </>
  );
}

function AltaPrecios({ form, set, setVal, setForm, lang, categoria, esEdicion, sinD }) {
  // s221 · «Sin tope» espera el «sí» del comercio antes de marcarse (Ali, 00:09 UTC).
  const [pidiendoSinTope, setPidiendoSinTope] = useState(false);
  // s188 - el 2x1 se explicaba SIEMPRE con cocteles. `categoria` entra como prop
  // porque este componente no ve `categoriaOferta`; se le pasa ya resuelta para
  // no duplicar la cadena de fallbacks del padre.
  const txt = copyDelAlta(categoria, lang);
  const en = lang === "en";
  switch (form.offer_type) {
    case UMBRAL_TIPO: return <PreciosUmbral form={form} setForm={setForm} lang={lang} esEdicion={esEdicion} categoria={categoria} sinD={sinD} />;
    case "fixed": return <PreciosFixed form={form} set={set} setVal={setVal} lang={lang} />;
    case "bogo": return (
      <div className="alta-campo">
        <AltaEtiqueta para="alta-precio-unitario" requerido
          texto={en ? "Unit price ($)" : "Precio unitario ($)"}
          pista={en ? "The price of one unit. The customer pays for 1 and gets 2" : "El precio de una unidad. El cliente paga 1 y recibe 2"} />
        <input id="alta-precio-unitario" className="alta-input" type="number" min="0" inputMode="decimal"
          aria-describedby="alta-precio-unitario-ayuda"
          value={form.unit_price} onChange={set("unit_price")} placeholder={txt.phPrecioUnitario} />
        <AltaAyuda id="alta-precio-unitario-ayuda" texto={txt.ayudaBogo} />
      </div>
    );
    case "free": return (
      <div className="alta-campo">
        <AltaEtiqueta para="alta-precio-cortesia" requerido
          texto={en ? "Regular price ($)" : "Precio regular ($)"}
          pista={en ? "What would this item/experience normally cost? The customer gets it 100% free with their coupon" : "¿Cuánto costaría normalmente este artículo/experiencia? El cliente lo recibe 100% gratis con su cupón"} />
        <input id="alta-precio-cortesia" className="alta-input" type="number" min="0" inputMode="decimal"
          aria-describedby="alta-precio-cortesia-ayuda"
          value={form.regular_price} onChange={set("regular_price")} placeholder="15" />
        <AltaAyuda id="alta-precio-cortesia-ayuda"
          texto={en ? "Eg: A dessert worth $15 → free with coupon" : "Ej: Un postre de $15 → gratis con cupón"} />
      </div>
    );
    // s221-D1 §3.2 · el % y el TOPE por visita (o «Sin tope», 3-bis). Supera s155-D3: ya no se pide una
    // «cuenta típica» — el precio regular se deriva del tope al guardar (precioRegularDePct).
    case "percent": return (
      <div className="alta-par">
        <div className="alta-campo">
          <AltaEtiqueta para="alta-descuento" requerido
            texto={en ? "% off" : "% de descuento"}
            pista={esEncargo(categoria)
              ? (en ? `Off the whole order. The club minimum is ${PCT_MINIMO}%.` : `Sobre todo el pedido. El mínimo del club es ${PCT_MINIMO} %.`)
              : (en ? `Off the whole bill. The club minimum is ${PCT_MINIMO}%.` : `Sobre toda la cuenta. El mínimo del club es ${PCT_MINIMO} %.`)} />
          <input id="alta-descuento" className="alta-input" type="number" min={PCT_MINIMO} max="100" step="1" inputMode="numeric"
            aria-describedby="alta-descuento-ayuda"
            value={form.discount_pct} onChange={set("discount_pct")} placeholder="20" />
          <AltaAyuda id="alta-descuento-ayuda" texto={esEncargo(categoria)
            ? (en ? "Eg: 20 = 20% off the order" : "Ej.: 20 = 20 % de descuento en el pedido")
            : (en ? "Eg: 20 = 20% off the bill" : "Ej.: 20 = 20 % de descuento en la cuenta")} />
        </div>
        <div className="alta-campo">
          {!form.pct_sin_tope && (<>
            <AltaEtiqueta para="alta-tope" requerido texto={en ? `Cap per ${perfilDelRubro(categoria).visita.en} ($)` : `Tope por ${perfilDelRubro(categoria).visita.es} ($)`} />
            <input id="alta-tope" className="alta-input" type="number" min="1" inputMode="decimal"
              aria-describedby="alta-tope-ayuda"
              value={form.benefit_value_usd} onChange={set("benefit_value_usd")} placeholder="25" />
            <AltaAyuda id="alta-tope-ayuda" texto={en
              ? "The most you take off in one visit. Example: 20% up to $25 → on an $80 bill you take off $16; on a $200 bill, $25."
              : "Lo máximo que descuentas en una visita. Ejemplo: 20 % hasta $25 → en una cuenta de $80 descuentas $16; en una de $200, $25."} />
          </>)}
          <label className="alta-check" style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14, color: "var(--tinta)", fontWeight: 600, marginTop: form.pct_sin_tope ? 0 : 10 }}>
            <input type="checkbox" checked={!!form.pct_sin_tope}
              onChange={e => {
                if (e.target.checked) { setPidiendoSinTope(true); return; }
                setPidiendoSinTope(false);
                setForm(f => ({ ...f, pct_sin_tope: false }));
              }} />
            {en ? "No cap" : "Sin tope"}
          </label>
          {pidiendoSinTope && !form.pct_sin_tope && (
            <div className="alta-aviso alta-aviso--campo" role="alertdialog" aria-live="assertive">
              <div style={{ marginBottom: 8 }}>{avisoSinTope(en)}</div>
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <button type="button" className="alta-chip alta-chip--on"
                  onClick={() => { setPidiendoSinTope(false); setForm(f => ({ ...f, pct_sin_tope: true, benefit_value_usd: "" })); }}>
                  {en ? "Yes" : "Sí"}
                </button>
                <button type="button" className="alta-chip" onClick={() => setPidiendoSinTope(false)}>
                  {en ? "I'll set a cap" : "Mejor pongo un tope"}
                </button>
              </div>
            </div>
          )}
          {form.pct_sin_tope && (
            <AltaAyuda texto={esEncargo(categoria)
              ? (en ? "The discount applies to the whole order, with no maximum." : "El descuento aplica a todo el pedido, sin máximo.")
              : (en ? "The discount applies to the whole bill, with no maximum." : "El descuento aplica a toda la cuenta, sin máximo.")} />
          )}
        </div>
      </div>
    );
    default: return null;
  }
}

// El recuadro del ahorro.
// s179 L6.1: la cifra es `valor` (= effectiveBenefitValue, lo que viaja en el
// payload y lo que ve el admin), NO savings.amount — para Cortesia ese es
// siempre el precio entero, y la pantalla decia $15 donde el admin veia $14.
// s185: ademas NO se dibuja con el invariante roto. Con beneficio $45 sobre
// precio $1, la pantalla mostraba una debajo de la otra el error rojo «el ahorro
// no puede ser mayor al precio de lista» y un recuadro verde felicitando por
// «MIEMBRO AHORRA $45 (4500% off)». Verificado en pantalla el 29/08.
// s194 L1 (s193-D1/D17): el fee al comercio murió como decisión. Acá vivía la línea
// «Tarifa NXT: $X / 0 % fundadores» (s179 L3.3 + L8), que prometía un cobro que ya no
// existe. `umbral` = { monto, minimo } cuando la oferta es del formato único: la cifra se
// lee como «recibe $30 si gasta $60», no como «ahorra $30 (50% off)».
function AltaAhorro({ lang, valor, pct, umbral, porcentaje, categoria }) {
  const en = lang === "en";
  if (!(valor > 0)) return null;
  // s221-D1 · el % se muestra como lo verá el miembro: «−20 % en tu cuenta · hasta $25». Nunca «ahorra $X».
  if (porcentaje && porcentaje.pct > 0) {
    const ej = descuentoPorcentaje(80, porcentaje.pct, porcentaje.tope);
    return (
      <div className="alta-ahorro">
        <div className="alta-ahorro__rotulo">{en ? "The member sees" : "El miembro ve"}</div>
        <div className="alta-ahorro__cifra">{frasePorcentaje(porcentaje.pct, porcentaje.tope, en, categoria)}</div>
        <div className="alta-ahorro__tarifa">
          {en
            ? `On an $80 bill you take off $${fmtUsd(ej.monto)}. No fee for being listed, ever.`
            : `En una cuenta de $80 descuentas $${fmtUsd(ej.monto)}. Sin costo por estar, nunca.`}
        </div>
      </div>
    );
  }
  const esUmbralAqui = !!(umbral && umbral.monto > 0);
  return (
    <div className="alta-ahorro">
      <div className="alta-ahorro__rotulo">
        {esUmbralAqui ? (en ? "The member saves" : "El miembro ahorra") : (en ? "Member Saves" : "Miembro Ahorra")}
      </div>
      <div className="alta-ahorro__cifra">
        ${fmtUsd(valor)}{" "}
        <span className="alta-ahorro__pct">
          {esUmbralAqui
            ? (umbral.minimo > valor
                ? (en ? `when they spend $${fmtUsd(umbral.minimo)}` : `si gasta $${fmtUsd(umbral.minimo)}`)
                : (en ? "to spend" : "para gastar"))
            : `(${chipPorcentaje(pct, en)})`}
        </span>
      </div>
      <div className="alta-ahorro__tarifa">
        {en
          ? "No fee for being listed, ever. NXT charges the business nothing."
          : "Sin costo por estar, nunca. NXT no le cobra nada al comercio."}
      </div>
    </div>
  );
}

// ---- create_offer, una oferta. Lo usan el alta clásica (handleSubmit) y el wizard de la primera oferta ----
// s214 · L#83: un rechazo lógico vuelve con HTTP 200 y `success: false` (INVALID_COOLDOWN de la S6, NOT_MERCHANT).
// Sin mirar eso, la pantalla decía «¡Oferta enviada!» de una oferta que no se creó.
async function crearOfertaWf(p) {
  const token = localStorage.getItem("nxt_token");
  const res = await fetch(`${API_BASE}/wf/create_offer`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
    body: JSON.stringify(p),
  });
  const data = await res.json();
  console.log("[CreateOffer] response:", res.status, data);
  if (!res.ok) throw new Error(data?.body?.message || data?.message || "Error " + res.status);
  if (data?.status === "error") throw new Error(data?.response?.message || data?.message || "Error");
  const r = data?.response;
  if (r && (r.success === false || r.success === "no" || r.error_code)) {
    const err = new Error(r.error_message || r.error_code || "create_offer failed");
    err.code = r.error_code || "OPERATION_FAILED";
    throw err;
  }
  return data;
}
// La foto ya encuadrada (EncuadrarFoto → recortarImagen, regla s206) al sobre del parámetro `image`.
async function imagenParaCrearOferta(file) {
  if (!file) return null;
  const contents = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => { const r = String(reader.result || ""); const c = r.indexOf(","); resolve(c >= 0 ? r.slice(c + 1) : r); };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
  return { filename: file.name || "foto.webp", contents, private: false };
}

// ============================================================================================
// s223 · 2b · EL WIZARD DE LA PRIMERA OFERTA (claude/PLAN_s221_wizard_oferta.md §0-§3, s221-D2)
// s224 · REHECHO con Ali y Otto, pantalla por pantalla: claude/RESUMEN_s224_wizard_revision_para_cowork.md
// ============================================================================================
// Reemplaza la entrada del alta cuando el comercio todavía no tiene NINGUNA oferta, y es la misma pieza que usa la
// consola de Otto (`operador`). Cinco preguntas y una vista previa:
//   1 ¿tuviste ofertas antes? · 2 qué quieres lograr (hasta 2) · 3 cuándo recibes miembros (momentos + días)
//   4 EL DINERO (ticket → monto fijo o %, con los números de su mesa) · 5 cada cuánto vuelve · vista previa.
// Sin IA: las reglas deciden los números. Las ofertas salen con el create_offer del alta (dueño) o con
// operator_add_offer (consola); las respuestas van a la ficha (wizard_json, business_goals, avg_ticket_usd).

// §2 · los objetivos y su «cada cuánto vuelve» por defecto. s224: hasta 2, y dos nuevos.
// s230 · wizard-objetivos-icono-y-nota: cada objetivo con su ícono del sprite (línea 1.5, 24 px) y una nota de una
// línea que dice qué significa para la oferta. Las tarjetas eran texto solo; `.alta-opcion__icono` y `__nota` ya existían.
const OBJETIVOS_WIZARD = [
  { id: "nuevos", es: "Clientes nuevos", en: "New customers", plazo: 30, icono: "ico-personas",
    notaEs: "Gente que nunca te ha visitado.", notaEn: "People who have never visited you." },
  { id: "horas_flojas", es: "Llenar horas flojas", en: "Fill slow hours", plazo: 15, icono: "ico-reloj",
    notaEs: "Días y horas en que te sobra mesa o cupo.", notaEn: "Days and hours when you have spare tables or slots." },
  { id: "gasten_mas", es: "Que gasten más por visita", en: "Bigger bills per visit", plazo: 30, icono: "ico-tarjeta",
    notaEs: "Un beneficio que empuja el ticket.", notaEn: "A benefit that lifts the bill." },
  { id: "vuelvan", es: "Que vuelvan más seguido", en: "More frequent visits", plazo: 15, icono: "ico-calendario",
    notaEs: "Un motivo para repetir seguido.", notaEn: "A reason to come back often." },
  { id: "algo_nuevo", es: "Promocionar algo nuevo", en: "Promote something new", plazo: 30, icono: "ico-destacado",
    notaEs: "Un plato, servicio o local que quieres que prueben.", notaEn: "A dish, service or location you want people to try." },
  { id: "grupos", es: "Grupos y mesas grandes", en: "Groups and big tables", plazo: 30, icono: "ico-cupos",
    notaEs: "Celebraciones, oficinas, familias.", notaEn: "Celebrations, offices, families." },
  // s239 · W10 (Ali): lo que no está en la lista. Se escribe y se guarda (wizard_json `objetivo_otro`, para Otto, Admin y la
  // IA); NO mueve la recomendación del formato ni el plazo (plazo del rubro): con texto libre no hay regla segura.
  { id: "otro", es: "Otra", en: "Other", plazo: COOLDOWN_POR_DEFECTO, icono: "ico-avisos",
    notaEs: "Algo que no está en la lista: cuéntanos cuál.", notaEn: "Something that isn't listed: tell us what." },
];
const OBJETIVOS_MAX = 2;
// s254 · P3 (Ali, recorrido Loulou con Otto): «mínimo 2». Con el tope en 2, el dueño elige exactamente dos.
const OBJETIVOS_MIN = 2;
// §2 pantalla 1a · dónde tuvo ofertas antes.
const DONDE_OFERTAS_ANTES = [
  { id: "groupon", es: "Groupon", en: "Groupon" },
  { id: "yelp", es: "Yelp", en: "Yelp" },
  { id: "delivery", es: "Apps de delivery", en: "Delivery apps" },
  { id: "empleados", es: "Descuento a empleados", en: "Employee discount" },
  { id: "propias", es: "Promos propias", en: "Our own promos" },
];
// §2-ter · el 2×1 sale en los rubros que venden un plato o un producto.
const RUBROS_2X1 = ["Restaurant", "Bar_Rooftop", "Sweets"];
// s227 · s226-D2 (`wizard-primera-oferta-sin-2x1`): en la PRIMERA oferta quedan monto fijo y porcentaje; al lado de esos
// dos, el 2×1 confundía al que recién empieza. Va a una etapa para el comercio que ya tiene ofertas (nombre y lugar: Cowork
// con Ali). Se apaga aquí y no se borra: con `false`, `hay2x1` nunca es verdad, la tarjeta no sale, «horas flojas» deja de
// recomendarlo (cae en la estándar) y un `formato` "bogo" que quedara guardado vuelve al recomendado. Vale para el alta
// del dueño y para la consola de Otto (el mismo WizardPrimeraOferta).
const WIZARD_CON_2X1 = false;
// s255 (Ali, Otto, Surima, prueba con Rusty Pelican) · `primera-oferta-solo-porcentaje`: el monto fijo («Ahorra $50 cuando
// gastas $100») se lee como un 2×1 y es un choque demasiado grande para quien recién llega. En la PRIMERA oferta (alta del
// dueño y siembra de Otto) queda solo el porcentaje, desde 20 % y sin tope (el dueño agrega el tope si quiere). El monto
// fijo sigue en el panel (Nueva oferta, Otra franja) para el comercio con experiencia. Se apaga aquí y no se borra: con
// `true` vuelve todo como estaba en s254.
const PRIMERA_CON_MONTO_FIJO = false;
// El % con el que arranca la primera oferta (Ali, s255: 25 %; el dueño puede bajarlo hasta PCT_MINIMO = 20).
const PCT_PRIMERA = 25;   // s255 (Ali) · 25 % por defecto; el piso sigue en 20 (PCT_MINIMO)
// La recomendación del wizard sin monto fijo: lo que iba a monto fijo pasa a porcentaje; lo demás no cambia.
const formatoPrimeraOferta = (recomendado, conMontoFijo) => (!conMontoFijo && recomendado === "std" ? "pct" : recomendado);

// s224 · los tipos de negocio (`business_type`) que se comen de a uno o para llevar: el ticket se pregunta POR PERSONA,
// los tamaños son los chicos y el canal arranca en «para llevar». Comida rápida y café, además, pueden ofrecer
// «Todos los días» en el plazo.
const TIPOS_POR_PERSONA = ["comida_rapida_qsr", "cafe_brunch", "pizza_delivery"];
// s252-D2 (Ali, 02/11) · «una vez al día» solo en la tabla B: café, comida rápida y pizza, en el asistente y en Nueva oferta.
const TIPOS_DIARIOS = ["comida_rapida_qsr", "cafe_brunch", "pizza_delivery"];
const TAMANOS_POR_PERSONA = ["S", "M", "L"];
// El gasto por persona «típico» cuando Google no lo sabe. Es nuestro (lo puso Code en s224): solo es el punto de partida
// de «Recomiéndame con lo típico», y se dice así.
const TICKET_TIPICO_POR_PERSONA = {
  Restaurant: 40, Bar_Rooftop: 35, Sweets: 12, Salon_Spa: 60, Nail_Lash: 45, Experience: 50, Gift_Moments: 50,
  comida_rapida_qsr: 15, cafe_brunch: 15, pizza_delivery: 18,
};

// s224 · §3 · LOS MOMENTOS del día, por rubro (Ali). Cada uno trae su hora sugerida, que se puede cambiar. Una oferta
// por momento (una Offer tiene un solo horario). `fuerte`: con dos o más momentos, los demás llevan un tamaño menos que
// este (como el almuerzo de Offline frente a la cena). La noche termina 23:59: un horario que cruza la medianoche no
// se puede guardar en una sola oferta.
const M_DESAYUNO = { key: "desayuno", es: "Desayuno", en: "Breakfast", ini: "07:00", fin: "11:00" };
const M_BRUNCH = { key: "brunch", es: "Brunch", en: "Brunch", ini: "10:00", fin: "14:00", finde: true };
const M_ALMUERZO = { key: "almuerzo", es: "Almuerzo", en: "Lunch", ini: "11:30", fin: "15:00" };
const M_MERIENDA = { key: "merienda", es: "Merienda", en: "Afternoon snack", ini: "14:00", fin: "18:00" };
const M_CENA = { key: "cena", es: "Cena", en: "Dinner", ini: "18:00", fin: "23:00", fuerte: true };
const MOMENTOS_POR_RUBRO = {
  Restaurant: [M_DESAYUNO, M_BRUNCH, M_ALMUERZO, M_MERIENDA, M_CENA],
  // s239 · auditoría s237-D4: sin «Happy hour» como momento. El happy hour es alcohol y el descuento del club no toca el
  // alcohol: ofrecerlo prometía lo que la oferta no da. Sigue como chip de «no entra» (EXCLUSIONES_WIZARD).
  Bar_Rooftop: [M_ALMUERZO, M_CENA,
    { key: "noche", es: "Noche", en: "Late night", ini: "21:00", fin: "23:59", fuerte: true, titulo_es: "En la noche", titulo_en: "At night" }],
  Sweets: [M_DESAYUNO, M_MERIENDA, { key: "tarde", es: "Tarde", en: "Evening", ini: "18:00", fin: "21:00", titulo_es: "En la tarde", titulo_en: "In the afternoon" }],
};
const MOMENTOS_OTROS = [
  { key: "manana", es: "Mañana", en: "Morning", ini: "09:00", fin: "13:00", titulo_es: "En la mañana", titulo_en: "In the morning" },
  { key: "tarde", es: "Tarde", en: "Afternoon", ini: "13:00", fin: "18:00", titulo_es: "En la tarde", titulo_en: "In the afternoon" },
  { key: "noche", es: "Noche", en: "Evening", ini: "18:00", fin: "21:00", titulo_es: "En la noche", titulo_en: "At night" },
];
const momentosDelRubro = (categoria) => MOMENTOS_POR_RUBRO[categoria] || MOMENTOS_OTROS;
// s252 · `momento-manana-titulo` (Ali, «Sí, renómbrala»): en el TÍTULO de la oferta «Mañana», «Tarde» y «Noche» solos se
// leían como días («25 % en tu cuenta · Mañana» y la traducción de create_offer dio «… · Tomorrow»). El título lleva
// `titulo_es`/`titulo_en` («En la mañana»); la tarjeta del momento y los avisos siguen con el nombre corto.
const momentoEnTitulo = (m, en) => (en ? m.titulo_en : m.titulo_es) || (en ? m.en : m.es);
const DIAS_SEMANA = FEED_DAY_TOKENS.slice(0, 5);
const DIAS_FINDE = FEED_DAY_TOKENS.slice(5);
const OFERTAS_VIVAS_MAX = 4;   // TOO_MANY_OFFERS en operator_add_offer (export 131) y en create_offer (export 133)
// s224 · «ni comisión ni mensualidad» quedó apagado mientras Bubble seguía armado para cobrar comisión.
// s225 · ENCENDIDO: Ali confirmó s193-D1 («comercio sin fee, permanente, sin comisión») y Cowork desarmó Bubble en Live
// (export 134): charge_merchant_take termina siempre, approve_merchant ya no escribe take_rate_pct y su default es 0.
const COPY_SIN_COMISION = true;
// s224 · el tope de ofertas vivas dicho al DUEÑO (create_offer, export 133). La consola tiene el suyo en mensajeLoteBC.
const mensajeTopeDueno = (en) => (en
  ? `You already have ${OFERTAS_VIVAS_MAX} active or pending offers, the maximum. Archive one in My offers to create another.`
  : `Ya tienes ${OFERTAS_VIVAS_MAX} ofertas activas o en revisión, el máximo. Archiva una en Mis ofertas para crear otra.`);

const minutosDe = (hhmm) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || "").trim());
  return m ? Number(m[1]) * 60 + Number(m[2]) : null;
};
// Los rangos de un día del horario guardado, en minutos. Un cierre a la 01:00 cuenta como 25:00.
const rangosDelDia = (d) => (d.closed ? [] : [[d.r1o, d.r1c], [d.r2o, d.r2c]]
  .map(([o, c]) => [minutosDe(o), minutosDe(c)])
  .filter(([o, c]) => o !== null && c !== null)
  .map(([o, c]) => [o, c <= o ? c + 1440 : c]));
// Lo que se puede saber del horario (business_hours_json). Desayuno si abre antes de las 10:00; almuerzo si está abierto
// a las 13:00; merienda si es de dulces o abre entre las 14:00 y las 16:59; cena si cierra a las 21:00 o después.
// Sin horario cargado no se marca nada. Es solo la marca inicial: el dueño confirma o cambia.
const prellenarFranjas = (hoursJson, categoria) => {
  const dias = parseHoursJson(hoursJson).map(rangosDelDia);
  const todos = dias.flat();
  const sel = new Set();
  if (todos.some(([o]) => o < 600)) sel.add("desayuno");
  if (todos.some(([o, c]) => o <= 780 && c >= 780)) sel.add("almuerzo");
  if (categoria === "Sweets" || todos.some(([o]) => o >= 840 && o < 1020)) sel.add("merienda");
  if (todos.some(([, c]) => c >= 1260)) sel.add("cena");
  const hayHorario = todos.length > 0;
  const cerrados = hayHorario
    ? parseHoursJson(hoursJson).map((d, i) => (d.closed || !rangosDelDia(d).length ? FEED_DAY_TOKENS[i] : null)).filter(Boolean)
    : [];
  return { franjas: sel, cerrados, hayHorario };
};

// s252 · LA FRANJA CABE EN EL HORARIO: empieza cuando abren todos los días que lleva y termina cuando cierra el primero
// (Esquina: «Cena» 18:00–23:00 con cierre a las 20:00; un salón: «Mañana» 09:00 con apertura a las 09:30). `null` si no
// cabe en ninguna hora. Sin horario cargado, la franja queda como está. Con dos turnos cuenta el día entero, de la
// primera apertura al último cierre. Un día marcado que el horario dice cerrado tampoco cabe.
const franjaEnHorario = (ini, fin, hoursJson, dias) => {
  const horario = parseHoursJson(hoursJson).map(rangosDelDia);
  if (!horario.flat().length) return { ini, fin };
  const rangos = FEED_DAY_TOKENS.map((d, i) => (dias.includes(d) ? horario[i] : null)).filter(Boolean);
  if (!rangos.length || rangos.some(r => !r.length)) return null;
  const hhmm = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
  const desde = Math.max(minutosDe(ini), ...rangos.map(r => Math.min(...r.map(([o]) => o))));
  const hasta = Math.min(minutosDe(fin), 1439, ...rangos.map(r => Math.max(...r.map(([, c]) => c))));
  return hasta > desde ? { ini: hhmm(desde), fin: hhmm(hasta) } : null;
};

// s255 · alta-datos-de-la-web (Cowork: «el prompt no se toca más; los servicios se validan en el front»). Un servicio que trajo
// la IA de la web se usa solo si pasa dos chequeos:
//   a) no está inventado: algún renglón de la web tiene su nombre (inglés o español) Y su hora de inicio escrita;
//   b) cabe en el horario de Google: sin los días que cierra y recortado con franjaEnHorario (cierre a medianoche = 24:00).
// La franja sugerida queda solo si su servicio pasó. Sin servicios, el wizard sigue con el horario de Google como siempre.
const serviciosDeLaWeb = (datos, texto, hoursJson) => {
  if (!datos) return { servicios: [], sugerida: "" };
  const cerrados = prellenarFranjas(hoursJson, "").cerrados;
  const servicios = serviciosDeIa(datos.servicios, datos.franja_sugerida).map((s) => {
    if (!servicioEnTexto(s, texto)) return null;
    const dias = (s.dias ? s.dias.split(",") : FEED_DAY_TOKENS).filter(d => FEED_DAY_TOKENS.includes(d) && !cerrados.includes(d));
    if (!dias.length) return null;
    // Una franja que cruza la medianoche no se guarda en una oferta: termina 23:59.
    const fin = minutosDe(s.fin) <= minutosDe(s.ini) ? "23:59" : s.fin;
    const cabe = franjaEnHorario(s.ini, fin, hoursJson, dias);
    return cabe ? { nombre: s.nombre, key: momentoDeServicio(s.nombre), ini: cabe.ini, fin: cabe.fin, dias, sugerida: s.sugerida } : null;
  }).filter(Boolean);
  const sug = servicios.find(s => s.sugerida);
  return { servicios, sugerida: sug ? sug.nombre : "" };
};

// s252 · «Recomienda mi oferta» no pisa lo que el dueño escribió: el número solo se pone cuando el campo está vacío.
const ticketAlRecomendar = (escrito, recomendado) => {
  const n = parseFloat(String(escrito).replace(/[$\s]/g, "").replace(",", ".")) || 0;
  return n > 0 ? null : String(Math.round(recomendado));
};

// La lista de tamaños que se recorre con − / + (sin la Destacada mientras siga bloqueada).
const tamanosWizard =(categoria, porPersonaTipo) => {
  const ids = porPersonaTipo ? TAMANOS_POR_PERSONA : (UMBRAL_TAMANOS_POR_RUBRO[categoria] || ["M", "L", "L+", "XL", "XL+", "XXL"]);
  return UMBRAL_TAMANOS.filter(t => ids.includes(t.id) && (t.id !== "D" || DESTACADA_HABILITADA));
};
// s224 · HACIA ABAJO (la misma regla que UMBRAL_POR_PERSONA): el más grande cuyo mínimo no pase lo que gasta una persona;
// si ninguno entra, el más chico. Con «gasten más», un escalón arriba.
// s236 · en los rubros de mesa (RUBROS_REGLA_3), la regla 3: el primero cuyo mínimo pasa lo que gasta una persona.
const indiceTamanoWizard = (lista, porPersona, objetivos, categoria) => {
  if (!lista.length) return -1;
  let i = 0;
  if (RUBROS_REGLA_3.includes(categoria) && porPersona > 0) {
    i = lista.findIndex(t => t.minimo > porPersona);
    if (i < 0) i = lista.length - 1;
  } else lista.forEach((t, j) => { if (porPersona > 0 && t.minimo <= porPersona) i = j; });
  if (objetivos.includes("gasten_mas") && i < lista.length - 1) i += 1;
  return i;
};
// §3 · qué formato se recomienda. Regla, no IA. El ticket alto y el % que ya da gratis mandan sobre el objetivo.
// s236 (Ali, 20/10) · salones, spa y barberías: el porcentaje con tope es lo recomendado (una clienta ocupa una silla y
// el servicio tiene precio fijo: «gasta el doble» no aplica). El monto fijo queda como opción. Plazo: el de salones (30).
// s237-D3 (Ali, 21/10) · el porcentaje recomendado va SIN tope también en salones («por default, sin tope; si el dueño
// quiere tope, lo pone él, nosotros no lo sugerimos»). Y «Hecho a pedido» (Gift_Moments) entra al porcentaje siempre:
// un encargo es de un solo comprador, la regla 3 no aplica. `tope` es solo el número que aparece si el dueño elige «Con tope».
const RUBROS_PCT_RECOMENDADO = ["Salon_Spa", "Nail_Lash", "Gift_Moments"];
const PCT_SALON = { pct: 25, tope: 30 };
// s236 (Ali, 21/10) · fuera de salones el porcentaje arranca en 25 % SIN tope; el dueño (u Otto) agrega un tope si quiere.
const PCT_DEFECTO = 25;

// ---- s244-D7 · LOS NÚMEROS DEL ASESOR LOS DECIDE REACT (pase s244 §8.9) --------------------------------------------
// El asesor del dueño ya no estima costo ni margen: los cuatro tamaños salen de las MISMAS funciones de la consola de
// Otto (sugerirTamanoUmbral, la lista de tamaños del rubro, el % por defecto) y la IA solo escribe el texto. La línea
// TAMAÑOS viaja en el contexto (api.js buildAdvisorContext / ingestOfferIdeas) y el parser vuelve a poner estos números si
// la IA los cambió (api.js aplicarTamanos). Mapa: 1 = el recomendado · 2 = un escalón menos (o el mismo si la 1 ya es el
// menor) · 3 = 2x1 si la fuente trae ítem con precio; si no, un escalón más · 4 = el de la 2 (la de franja con HORARIO).
// En los rubros de porcentaje (salones, uñas, Hecho a pedido, tiendas): 25 % y 20 % sin tope. Café y dulces van con umbral.
const TIPOS_PCT_ASESOR = ["tortas_reposteria", "globos_arreglos_flores", "tienda_online"];
const esRubroPctAsesor = (categoria, tipoNegocio) =>
  RUBROS_PCT_RECOMENDADO.includes(categoria) || categoria === "Online" || TIPOS_PCT_ASESOR.includes(String(tipoNegocio || ""));
// s245 · la frase que la IA copia va en el idioma de salida (corrida 5: con lang=en y la frase en español, #15 salía con
// «Recibe $15 if you spend $30» o entera en español). Mismo texto que tituloConTamano (api.js) pone al corregir.
const tamanoUmbralAsesor = (t, en) => ({ offer_type: UMBRAL_TIPO, benefit_value_usd: t.monto, min_consumption: t.minimo, discount_pct: 0,
  texto: `umbral: ${fraseUmbralVieja(t.monto, t.minimo, en)}` });
const tamanoPctAsesor = (pct, en) => ({ offer_type: "percent", benefit_value_usd: TOPE_SIN_LIMITE, min_consumption: 0, discount_pct: pct,
  texto: en ? `percent: ${pct}% off your bill, no cap` : `percent: ${pct} % en tu cuenta, sin tope` });
function tamanosDelAsesor({ categoria, tipoNegocio, porPersona, lang = "es" }) {
  const en = lang === "en";
  const lista = tamanosWizard(categoria, TIPOS_POR_PERSONA.includes(String(tipoNegocio || "")));
  const base = sinDestacada(sugerirTamanoUmbral(categoria, porPersona, tipoNegocio));
  if (!lista.length || !base) return null;
  const i = Math.max(0, lista.findIndex(t => t.id === base.id));
  const menor = tamanoUmbralAsesor(lista[Math.max(0, i - 1)], en);
  const mayor = tamanoUmbralAsesor(lista[Math.min(lista.length - 1, i + 1)], en);
  const pct = esRubroPctAsesor(categoria, tipoNegocio);
  const t1 = pct ? tamanoPctAsesor(PCT_DEFECTO, en) : tamanoUmbralAsesor(lista[i], en);
  const t2 = pct ? tamanoPctAsesor(PCT_MINIMO, en) : menor;
  const t3 = { ...mayor, bogoOpcional: true, texto: `bogo si hay ítem con precio escrito en la fuente; si no, ${mayor.texto}` };
  const tarjetas = [t1, t2, t3, { ...t2 }];
  // s245 · categoría, ticket e idioma viajan con los tamaños: api.js conBogoDeLaFuente elige el 2x1 de la tarjeta 3 con ellos.
  return { tarjetas, linea: "TAMAÑOS: " + tarjetas.map((t, k) => `tarjeta_${k + 1} = ${t.texto}`).join(" · "),
    categoria, porPersona, lang };
}
// s244-D7 · el ticket por persona, con la cascada del wizard de la primera oferta: lo que el dueño ya escribió (la ficha,
// avg_ticket_usd) → Google por el place_id del alta (precioDeGoogle, punto medio por persona) → lo típico del rubro, que
// se dice como sugerencia para que el dueño lo confirme o lo cambie. La web NO se usa para el ticket (D7).
async function ticketEnCascada(perfil, categoria, tipoNegocio) {
  const tipico = { valor: Math.round(TICKET_TIPICO_POR_PERSONA[tipoNegocio] || TICKET_TIPICO_POR_PERSONA[categoria] || 35), fuente: "tipico" };
  const mid = perfil?.merchant_id || "";
  if (!mid) return tipico;
  try {
    const { ficha, place_id } = await leerFichaYLugar(mid);
    const propio = Number(ficha?.avg_ticket_usd);
    if (propio > 0) return { valor: Math.round(propio), fuente: "dueno" };
    const g = place_id ? precioDeGoogle(await placePrecio(place_id).catch(() => null)) : null;
    if (g && g.porPersona > 0) return { valor: Math.round(g.porPersona), fuente: "google", rango: g.rangoTexto || "" };
  } catch (_) { /* sin ficha ni Google: lo típico */ }
  return tipico;
}
// El campo del ticket de las pantallas del asesor. Obligatorio: sin número no se llama a la IA (los tamaños salen de acá).
function CampoTicketAsesor({ id, perfil, categoria, tipoNegocio, valor, fuente, onCambio, en }) {
  const pregunta = preguntaTicket(categoria, en);
  useEffect(() => {
    if (String(valor || "").trim() || !perfil) return undefined;
    let on = true;
    ticketEnCascada(perfil, categoria, tipoNegocio).then(r => { if (on) onCambio(String(r.valor), r.fuente, r.rango || ""); });
    return () => { on = false; };
  }, [perfil, categoria, tipoNegocio]); // eslint-disable-line react-hooks/exhaustive-deps
  const nota = fuente === "google"
    ? (en ? "From Google. Change it if it isn't right." : "Según Google. Cámbialo si no es así.")
    : fuente === "tipico"
      ? (en ? "This is typical for your category: confirm it or change it." : "Es lo típico de tu rubro: confírmalo o cámbialo.")
      : fuente === "dueno"
        ? (en ? "It's the one you wrote before." : "Es el que escribiste antes.")
        : "";
  return (
    <div className="alta-campo">
      <label htmlFor={id} className="alta-etiqueta">{pregunta.texto} *</label>
      <input id={id} className="alta-input" value={valor} inputMode="decimal" placeholder={pregunta.ej}
        onChange={(e) => onCambio(e.target.value, "escrito", "")} />
      {nota && <div className="alta-bloque__nota" style={{ marginTop: 6 }}>{nota}</div>}
    </div>
  );
}
// s239 · W16/W7 · un link listo para leer: sin parámetros de seguimiento (normalizeWebsiteUrl, la misma clave de caché del
// WF) y con esquema («frudeco.com» → «https://frudeco.com»). Lo que no parece un link (sin punto, con espacios) → "".
// s240 · W16 en pantalla. En el lote D estuvo apagado: lo que mostraba eran PROPUESTAS de `offer_advisor` («Dos Cuban
// Sandwiches al precio de uno», «Ahorras $14»), no la presentación del negocio. W16 v2 llena «Cómo te presentamos» con la
// DESCRIPCIÓN del negocio que el asistente escribe con lo leído (`generate_merchant_description`); ver el efecto de la
// lectura en WizardPrimeraOferta. En `false`, la lectura sale igual y solo se guarda.
const LECTURA_EN_PANTALLA = true;
// s240: propuestas guardadas que sacan al dueño del wizard de la primera oferta. Solo las que el dueño trabajó (el sobre
// del front); las que escribió el servidor solo —la lectura del alta, W16— no: si no, recargar en medio del wizard
// lo mandaba a «Nueva oferta» con «Ya tienes 12 propuestas guardadas».
const borradorTrabajado = (b) => !!(b && b.source === "envelope" && b.offers && b.offers.length);
const linkLeible = (raw) => {
  const s = normalizeWebsiteUrl(String(raw || "").trim());
  if (!s || /\s/.test(s) || !s.includes(".")) return "";
  return /^https?:\/\//i.test(s) ? s : `https://${s.replace(/^\/+/, "")}`;
};
// s239 · W1 · la oferta de la tarjeta de la intro del wizard: la que se va a recomendar. Porcentaje en los rubros de %
// (25 % sin tope, s237-D3); monto fijo con la regla del rubro (sugerirTamanoUmbral) y lo que gasta una persona si se sabe
// (Google); sin dato, el tamaño de entrada del rubro (la tarjeta dice «Ejemplo»).
const ofertaDeIntro = (categoria, porPersona, tipoNegocio) => {
  // s255 · `primera-oferta-solo-porcentaje`: sin monto fijo, la tarjeta de la intro es el % con el que arranca el wizard.
  const salon = RUBROS_PCT_RECOMENDADO.includes(categoria);
  if (salon || !PRIMERA_CON_MONTO_FIJO) {
    const p = salon || PRIMERA_CON_MONTO_FIJO ? PCT_DEFECTO : PCT_PRIMERA;
    return {
      offer_type: "percent", discount_pct: p, benefit_value_usd: TOPE_SIN_LIMITE, min_consumption: 0, regular_price: 0,
      title_es: tituloPorcentaje(p, TOPE_SIN_LIMITE, false, categoria), title_en: tituloPorcentaje(p, TOPE_SIN_LIMITE, true, categoria),
    };
  }
  const tam = sugerirTamanoUmbral(categoria, porPersona, tipoNegocio) || UMBRAL_TAMANOS.find(x => x.id === "M");
  return {
    offer_type: UMBRAL_TIPO, discount_pct: 0, benefit_value_usd: tam.monto, min_consumption: tam.minimo, regular_price: tam.minimo,
    title_es: fraseUmbral(tam.monto, tam.minimo, false), title_en: fraseUmbral(tam.monto, tam.minimo, true),
  };
};
// s239 · auditoría s237-D2 (Ali, 23/10): en restaurantes y bares se recomienda SIEMPRE monto fijo (es la oferta del club en
// esos rubros). «Que vuelvan más seguido» y «ya di descuento a empleados» ya no mandan a porcentaje con «Va con lo que
// quieres»; el porcentaje sigue como opción que el dueño elige. Dulces y los demás rubros, como antes.
const RUBROS_MONTO_FIJO_SIEMPRE = ["Restaurant", "Bar_Rooftop"];
const recomendarFormato = ({ porPersona, yaDaDescuento, objetivos, hay2x1, categoria }) => {
  if (RUBROS_PCT_RECOMENDADO.includes(categoria)) return "pct";
  if (RUBROS_MONTO_FIJO_SIEMPRE.includes(categoria)) return "std";
  // s236 (Ali, 21/10) · en restaurantes y bares el ticket alto ya no manda a porcentaje: con la regla 3 un restaurante de
  // $80+ por persona lleva monto fijo $50/$100 (la Destacada). El porcentaje queda como opción. Los demás rubros, como s224.
  if (porPersona >= 80 && !RUBROS_REGLA_3.includes(categoria)) return "pct";
  if (yaDaDescuento) return "pct";
  if (objetivos.includes("vuelvan")) return "pct";
  if (objetivos.includes("horas_flojas") && hay2x1) return "bogo";   // s227 · apagado en la primera oferta (WIZARD_CON_2X1)
  return "std";
};
// Las reglas que se guardan en rules_text. La estándar guarda solo las comunes (la ficha arma el resto, s214). El % y
// el 2×1 guardan las suyas, sin la del mínimo. La del plazo NO se guarda (la ficha la arma desde cooldown_days).
// s224 · más la línea de lo que no entra, si el comercio marcó algo: es suya, la ficha la conserva tal cual.
const reglasWizard = (tipo, categoria, en, canal, exclusion) => {
  const l = en ? "en" : "es";
  let base;
  if (tipo === "std") base = REGLAS_COMUNES[l];
  else if (tipo === "pct") base = reglasPorcentaje(categoria, en, canal);
  // s224 · el 2×1 abre con su mecánica: es la línea que arma operator_add_offer, y rules_text_es la reemplaza entera.
  else base = [REGLA_2X1[l], ...reglasDelRubro(categoria, en, canal).filter(r => r !== REGLA_MINIMO[l] && r !== REGLA_ALCOHOL[l])];
  return [...base, ...(exclusion ? [exclusion] : [])].join(SALTO_LINEA);
};

const REGLA_2X1 = { es: "Pides dos del plato de la oferta y pagas uno", en: "Order two of the offer's dish and pay for one" };
// s224 · «¿Hay algo que no entra en la oferta?» (opción C). En los rubros de mesa el alcohol ya está en las reglas del
// club: el chip sale marcado y no se puede quitar, y no se repite en la línea.
const EXCLUSIONES_WIZARD = [
  { id: "alcohol", es: "Alcohol", en: "Alcohol" },
  { id: "especiales", es: "Especiales del día", en: "Daily specials" },
  { id: "combos", es: "Combos", en: "Combos" },
  { id: "happy_hour", es: "Happy hour", en: "Happy hour" },
  { id: "postres", es: "Postres", en: "Desserts" },
  { id: "bebidas", es: "Bebidas", en: "Drinks" },
  // s241 · los de los otros rubros: cada familia muestra los suyos (PERFIL_POR_FAMILIA.excluye).
  { id: "productos", es: "Productos que vendes", en: "Products you sell" },
  { id: "paquetes", es: "Paquetes y combos", en: "Packages and bundles" },
  { id: "premium", es: "Servicios premium", en: "Premium services" },
  { id: "extras", es: "Extras y adicionales", en: "Extras and add-ons" },
];
const lineaExclusion = (ids, otro, alcoholEnReglas, en) => {
  const nombres = EXCLUSIONES_WIZARD
    .filter(x => ids.includes(x.id) && !(x.id === "alcohol" && alcoholEnReglas))
    .map(x => (en ? x.en : x.es).toLowerCase());
  const o = String(otro || "").trim();
  if (o) nombres.push(o);
  if (!nombres.length) return "";
  return en ? `Doesn't apply to: ${nombres.join(", ")}` : `No aplica a: ${nombres.join(", ")}`;
};

// s224 · `wizard-guardar-respuestas`: lo que se respondió, para saber después por qué salió esa oferta. Va a la ficha
// con guardarFicha (save_merchant_ficha). `business_goals` = los objetivos separados por coma; `avg_ticket_usd` = el
// gasto POR PERSONA, la misma unidad que la siembra y el lote. La forma de wizard_json está en el RESUMEN s224.
const respuestasWizard = (r) => {
  const json = {
    v: 2, origen: r.origen, lang: r.en ? "en" : "es", at: new Date().toISOString(), tipo_negocio: r.tipoNegocio || "",
    antes: { tuvo: r.tuvoAntes, donde: r.tuvoAntes === "si" ? r.dondeAntes : [], sabe: r.tuvoAntes === "si" ? r.sabeOferta : "", idea: r.tuvoAntes === "si" && r.sabeOferta === "si" ? r.idea.trim() : "" },
    objetivos: r.objetivos,
    ...(r.objetivos.includes("otro") ? { objetivo_otro: String(r.objetivoOtro || "").trim() } : {}),   // s239 · W10
    // s239 · W16/W7: los links que dio y si la lectura volvió (lo leído queda en el comercio: ingested_text / ingested_url).
    web: String(r.webNegocio || "").trim(), link_oferta: String(r.linkOferta || "").trim(),
    lectura: { web: !!r.lectura?.web, oferta: !!r.lectura?.oferta, de_la_web: r.deLaWeb || {} },
    igual_semana: r.igualSemana,
    momentos: r.ofertas.map(o => ({ key: o.momento.key, ini: o.ini, fin: o.fin, dias: o.dias })),
    ticket: { valor: r.ticketNum, unidad: "persona", por_persona: r.porPersona, fuente: r.fuenteTicket || "dueno" },   // s236 · siempre por persona
    google: r.precioG ? { desde: Number(r.precioG.desde) || 0, hasta: Number(r.precioG.hasta) || 0, nivel: r.precioG.nivel || "" } : null,
    formato: { elegido: r.elegido, recomendado: r.recomendado },
    ...(r.elegido === "std" && r.tamano ? { tamano: { monto: r.tamano.monto, minimo: r.tamano.minimo, sugerido: r.tamanoSugerido?.id || "" } } : {}),
    ...(r.elegido === "pct" ? { pct: r.pctNum, con_tope: !!r.conTope, tope: r.conTope ? r.tope : null } : {}),
    ...(r.elegido === "bogo" ? { plato: r.plato.trim(), precio_plato: r.precioNum, plato_alcohol: !!r.platoAlcohol } : {}),
    plazo: { elegido: r.plazoFinal, sugerido: r.plazoObjetivo },
    canal: r.canalFinal,
    exclusiones: { ids: r.exclusiones, otro: String(r.exclusionOtro || "").trim(), todo_entra: !!r.todoEntra },
    ofertas: r.ofertas.length,
  };
  const out = { wizard_json: JSON.stringify(json), business_goals: r.objetivos.join(",") };
  if (r.porPersona > 0) out.avg_ticket_usd = Math.round(r.porPersona);
  return out;
};

// s254 · P12 (Ali + Otto, maqueta del rediseño): el paso va en una franja naranja, como «Muy pronto en Miami» de la
// vitrina, con una frase corta; la barra se llena en el azul de la marca (naranja junto a azul, no naranja con naranja)
// y «¿Dudas?» abre el WhatsApp de soporte en cada paso (Airbnb: la ayuda a un toque).
const FRASES_PASO = [
  ["Empecemos por lo básico.", "Let's start with the basics."],
  ["Tu oferta va tomando forma.", "Your offer is taking shape."],
  ["Tú decides cuándo vale.", "You decide when it's valid."],
  ["Ya casi está lista.", "It's almost ready."],
  ["Último detalle.", "One last detail."],
];
function BarraWizard({ n, en }) {
  const [wa, setWa] = useState(WHATSAPP_NUMBER);
  useEffect(() => { let vivo = true; numeroSoporte().then(x => { if (vivo && x) setWa(x); }); return () => { vivo = false; }; }, []);
  const frase = FRASES_PASO[n - 1] || ["", ""];
  const textoAyuda = en ? "Hi! I'm setting up my first offer on NXT Reserve and I have a question." : "¡Hola! Estoy armando mi primera oferta en NXT Reserve y tengo una duda.";
  return (
    <div className="alta-wiz__cabeza">
      <div className="alta-wiz__franja">
        <span className="alta-wiz__franja-paso">{en ? `Step ${n} of 5` : `Paso ${n} de 5`}</span>
        <span className="alta-wiz__franja-frase">{en ? frase[1] : frase[0]}</span>
      </div>
      <div className="alta-wiz__barra" aria-label={en ? `Question ${n} of 5` : `Pregunta ${n} de 5`}>
        <div className="alta-wiz__barra-pista"><div className="alta-wiz__barra-lleno alta-wiz__barra-lleno--marca" style={{ width: `${(n / 5) * 100}%` }} /></div>
        <a className="alta-wiz__dudas" href={`https://wa.me/${wa}?text=${encodeURIComponent(textoAyuda)}`} target="_blank" rel="noopener noreferrer">
          {en ? "Questions? Message us" : "¿Dudas? Escríbenos"}
        </a>
      </div>
    </div>
  );
}
function TipWizard({ children }) {
  return <div className="alta-wiz__tip">{children}</div>;
}

// s223 · una foto elegida en el wizard: la miniatura (URL creada y liberada en el mismo efecto, s201), «Portada» en la
// primera, y quitar / hacer portada. s224 · `fija`: en la consola, ya sembrado, el orden es el de la cadena.
function MiniaturaFotoWizard({ file, portada, en, onQuitar, onPortada, fija = false }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    const u = URL.createObjectURL(file);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [file]);
  return (
    <div className={["alta-wiz__foto", portada && "alta-wiz__foto--portada"].filter(Boolean).join(" ")}>
      {url && <img src={url} alt="" />}
      {portada
        ? <span className="alta-wiz__foto-marca">{en ? "Cover" : "Portada"}</span>
        : !fija && <button type="button" className="alta-wiz__foto-accion" onClick={onPortada}>{en ? "Make cover" : "Hacer portada"}</button>}
      {!fija && <button type="button" className="alta-wiz__foto-accion" onClick={onQuitar} aria-label={en ? "Remove photo" : "Quitar foto"}>{en ? "Remove" : "Quitar"}</button>}
    </div>
  );
}

// Una línea del checklist final: hecha (✓) o lo que falta (•). s224 · con «Cambiar», que vuelve a esa pantalla.
// s228 · `opcional`: lo que falta pero no frena el envío (el logo) se ve neutro, no como pendiente.
// `marcar`: «Enviar» con algo pendiente lleva hasta aquí y lo resalta (`id` es el ancla).
// s239 · W4 · `etiquetaOpcional`: el estado de un bloque opcional que igual se pide antes de publicar (el menú) no es
// «Opcional» (se leía como «no hace falta»): se dice «Puede ir después».
function ItemChecklist({ ok, opcional = false, etiquetaOpcional = null, marcar = false, id, titulo, icono, children, onCambiar, en, estilo }) {
  const clase = ok ? "alta-wiz__check--ok" : opcional ? "alta-wiz__check--opcional" : "alta-wiz__check--falta";
  // s230 · wizard-checklist-iconos-y-subida: ✓ • ○ no se entendían solos (• y ○ eran «obligatorio» y «opcional»). Cada
  // bloque lleva su ícono del sprite (hecho = ico-ok) y el título una etiqueta que dice el estado: Listo · Falta · Opcional.
  const estado = ok ? (en ? "Done" : "Listo") : opcional ? (etiquetaOpcional || (en ? "Optional" : "Opcional")) : (en ? "Missing" : "Falta");
  return (
    <li id={id} style={estilo} className={["alta-wiz__check", clase, marcar && !ok ? "alta-wiz__check--marcar" : ""].filter(Boolean).join(" ")}>
      <span className="alta-wiz__check-marca" aria-hidden="true"><Ico name={ok ? "ico-ok" : (icono || "ico-avisos")} size={20} /></span>
      <div className="alta-wiz__check-cuerpo">
        {titulo && <b>{titulo}<span className="alta-wiz__check-estado">{estado}</span></b>}
        {children}
      </div>
      {onCambiar && <button type="button" className="alta-wiz__cambiar" onClick={onCambiar}>{en ? "Change" : "Cambiar"}</button>}
    </li>
  );
}
// s235 · wizard-ejercicio-como-invitacion (Ali): la cuenta del ejercicio era una lista de texto («Tu mesa de dos ($25) ·
// sube a $30 · cobras $15»). Ahora es el recibo de la invitación de la siembra: «Mesa de dos», el consumo, el descuento
// fijo, «Cobras», la barra descuento/cobras y «¿Y si piden más?» con extras que suben la cuenta. `cuenta(x)` es la de la
// forma elegida (monto fijo o porcentaje): { da, cobra, sube } para una cuenta de $x.
// s236 · wizard-extras-segun-ticket (Ali): los extras eran fijos (+$15 / +$30 / +$50) para cualquier ticket. Como en la
// invitación (nxt-landing `PARTE_EXTRA`), salen de lo que gasta UNA persona: ⅓, ⅔ y el ticket entero, al dólar. El primer
// número de cada fila es la parte; los textos no cambian.
// s254 · P7 (Ali + Otto, recorrido Loulou): el recibo con «¿Y si piden más?» distrae en vez de ayudar. Se apaga en el
// wizard; el componente queda para volver a prenderlo.
const RECIBO_EN_WIZARD = false;
const EXTRAS_RECIBO = {
  mesa: [[1 / 3, "Un postre", "A dessert"], [2 / 3, "Postre y dos tragos", "Dessert and two drinks"], [1, "Un plato más", "One more dish"]],
  otro: [[1 / 3, "Un extra", "An extra"], [2 / 3, "Algo más grande", "Something bigger"], [1, "Un pedido grande", "A big order"]],
};
// s242 · `la`: cómo se dice la cuenta en el rubro (perfil: «la cuenta», «el pedido», «la compra»); el título y «… de dos» salen de ahí.
function ReciboWizard({ en, mesa, dos, base, porPersona, cuenta, notaDescuento, sinPropina = false, la = { es: "la cuenta", en: "the bill" } }) {
  const t = (es, enTxt) => (en ? enTxt : es);
  const [iExtra, setIExtra] = useState(-1);
  const extras = EXTRAS_RECIBO[mesa ? "mesa" : "otro"].map(([parte, es, enTxt]) => [Math.max(1, Math.round((porPersona || base) * parte)), es, enTxt]);
  const x = iExtra >= 0 ? extras[iExtra] : null;
  const extra = x ? x[0] : 0;
  const c = cuenta(base + extra);
  if (!c) return null;
  const consumo = c.cobra + c.da;
  const piso = consumo - extra;
  const pctDa = consumo > 0 ? Math.round((c.da / consumo) * 100) : 0;
  const usd = (n) => `$${fmtUsd(n)}`;
  return (
    <div className="alta-recibo-bloque">
      <div className="alta-wiz__pregunta" style={{ fontSize: 16 }}>{t(la.es.charAt(0).toUpperCase() + la.es.slice(1), la.en.charAt(0).toUpperCase() + la.en.slice(1))}</div>
      <div className="alta-ayuda">{mesa ? t("¿Y si piden más? Prueba:", "And if they order more? Try:") : t("¿Y si gastan más? Prueba:", "And if they spend more? Try:")}</div>
      <div className="alta-chips" role="group" aria-label={t("Consumo de ejemplo", "Example spend")}>
        <button type="button" className={["alta-chip", iExtra < 0 && "alta-chip--on"].filter(Boolean).join(" ")} aria-pressed={iExtra < 0} onClick={() => setIExtra(-1)}>{t("Lo de siempre", "The usual")}</button>
        {extras.map(([v, es, enTxt], i) => (
          <button key={es} type="button" className={["alta-chip", iExtra === i && "alta-chip--on"].filter(Boolean).join(" ")} aria-pressed={iExtra === i} onClick={() => setIExtra(i)}>
            + {en ? enTxt.toLowerCase() : es.toLowerCase()} <small>+{usd(v)}</small>
          </button>
        ))}
      </div>
      <div className="alta-recibo" aria-label={t("Recibo de ejemplo", "Example receipt")}>
        <div className="alta-recibo__t">{mesa ? t("Mesa de dos", "Table of two") : dos ? t("Dos personas", "Two people") : t("Una visita", "One visit")}</div>
        <table><tbody>
          <tr><td>{extra ? t("Lo de siempre", "The usual") : t("Consumo", "Spend")}</td><td>{usd(piso)}</td></tr>
          {extra > 0 && <tr><td>+ {x ? (en ? x[2] : x[1]).toLowerCase() : ""}</td><td>+{usd(extra)}</td></tr>}
          {extra > 0 && <tr className="alta-recibo__sub"><td>{t("Consumo", "Spend")}</td><td>{usd(consumo)}</td></tr>}
          <tr><td>{t("Descuento NXT Reserve", "NXT Reserve discount")}<span className="alta-recibo__nota-fila">{notaDescuento}</span></td><td className="alta-recibo__da">−{usd(c.da)}</td></tr>
          <tr className="alta-recibo__total"><td>{t("Cobras", "You charge")}</td><td className="alta-recibo__cobras">{usd(c.cobra)}</td></tr>
        </tbody></table>
        <div className="alta-recibo__barra" aria-hidden="true"><span className="alta-recibo__barra-da" style={{ width: `${pctDa}%` }} /><span className="alta-recibo__barra-cobras" style={{ width: `${100 - pctDa}%` }} /></div>
        <div className="alta-recibo__leyenda"><span><i className="alta-recibo__barra-da" />{t("Descuento", "Discount")}</span><span><i className="alta-recibo__barra-cobras" />{t("Lo que cobras", "What you charge")}</span></div>
        <div className="alta-recibo__nota">{extra
          ? (c.da === cuenta(base)?.da
            ? t(`Pidieron ${usd(extra)} más: ${c.sube ? "" : "esa parte es tuya. "}El descuento queda en ${usd(c.da)}.`, `They ordered ${usd(extra)} more: ${c.sube ? "" : "that part is yours. "}The discount stays at ${usd(c.da)}.`)
            // Porcentaje sin tope (o sin llegar al tope): el descuento crece con la cuenta.
            : t(`Pidieron ${usd(extra)} más: con porcentaje el descuento también sube, a ${usd(c.da)}. Con tope, deja de crecer.`, `They ordered ${usd(extra)} more: with a percentage the discount goes up too, to ${usd(c.da)}. With a cap, it stops growing.`))
          : c.sube
            ? t(`Para usarla, ${mesa ? "la mesa" : dos ? `${la.es} de dos` : "el cliente"} pasa de ${usd(base)} a ${usd(consumo)}: son ${usd(c.sube)} más en tu caja.`, `To use it, ${mesa ? "the table" : dos ? `${la.en} for two` : "the customer"} goes from ${usd(base)} to ${usd(consumo)}: that's ${usd(c.sube)} more in your till.`)
            // s242 · wizard de dulces: el ejemplo nombra el primer chip que de verdad está (antes «+ un postre» fijo, y en
            // dulces, salones o encargos el chip dice «+ un extra»).
            : t(`Toca «+ ${extras[0][1].toLowerCase()}» y mira qué pasa con lo que cobras.`, `Tap “+ ${extras[0][2].toLowerCase()}” and see what happens to what you charge.`)}</div>
        <div className="alta-recibo__nota">{sinPropina ? t("Los impuestos van aparte.", "Tax is separate.") : t("Impuestos y propina van aparte.", "Tax and tip are separate.")}</div>
      </div>
    </div>
  );
}
// s230 · wizard-preguntas-tarjetas-con-icono: una pregunta de UNA elección va en tarjetas de ancho completo (ícono del
// sprite + título + ejemplo), con el mismo patrón de la pregunta 2. Los chips quedan para las de varias elecciones («¿Dónde?»,
// los momentos): son filtros. Para un sí/no eran chicos para el pulgar y parecían filtros, no una decisión.
function OpcionesBinarias({ valor, onCambio, opciones, etiqueta }) {
  return (
    <div className="alta-opciones" role="group" aria-label={etiqueta}>
      {opciones.map(o => {
        const on = valor === o.id;
        return (
          <button key={o.id} type="button" aria-pressed={on} onClick={() => onCambio(o.id)}
            className={["alta-opcion", on && "alta-opcion--elegida"].filter(Boolean).join(" ")}>
            <span className="alta-opcion__icono alta-opcion__icono--linea" aria-hidden="true"><Ico name={o.icono} size={24} /></span>
            <div className="alta-opcion__texto">
              <div className="alta-opcion__nombre">{o.titulo}</div>
              {o.nota && <div className="alta-opcion__nota">{o.nota}</div>}
            </div>
            <div className="alta-opcion__flecha">{on ? "✓" : ""}</div>
          </button>
        );
      })}
    </div>
  );
}
// s230 · wizard-checklist-iconos-y-subida: el `input type=file` nativo («Seleccionar archivo · Sin archivos seleccionados»,
// cortado en teléfono) era lo más básico del wizard, justo en el bloque que decide si la oferta sale en el catálogo. Un
// botón-zona con ícono, texto propio y nota (el contador «3 de 10»). El input sigue en el DOM con su `id` (los anclajes
// y `elegirFotos` / `elegirLogo` no cambian), oculto pero enfocable: el <label> le pasa el clic y el teclado lo alcanza.
function ZonaSubida({ id, texto, nota, icono = "ico-camara", accept, multiple = false, disabled = false, onChange, ariaLabel }) {
  return (
    <label htmlFor={id} className={["alta-wiz__zona", disabled && "alta-wiz__zona--off"].filter(Boolean).join(" ")}>
      <input id={id} className="alta-wiz__zona-input" type="file" accept={accept} multiple={multiple} disabled={disabled}
        onChange={onChange} aria-label={ariaLabel || texto} />
      <Ico name={icono} size={22} />
      <span className="alta-wiz__zona-texto"><b>{texto}</b>{nota && <span className="alta-wiz__zona-nota">{nota}</span>}</span>
    </label>
  );
}
// s230 · wizard-barra-accion-pegada: el pie con «Atrás / Seguir» va pegado abajo (`.alta-wiz__pie`, sticky). En
// la pregunta 3 con todo abierto la página medía 1278 px y «Seguir» arrancaba en el 1071 de 884 de pantalla; en la
// vista previa, 3279 y 3018. El dueño escribía y no veía cómo continuar. En teléfono el pie se asienta encima de la
// barra del panel (`.mrc-abajo`, 88 px); el aviso de error viaja dentro del pie para que se lea junto al botón.
function AccionesWizard({ aviso, en, onAtras, onSeguir, textoSeguir }) {
  return (
    <div className="alta-wiz__pie">
      {aviso && <div className="alta-aviso alta-aviso--error alta-aviso--campo" role="alert">{aviso}</div>}
      <div className="alta-acciones">
        <button type="button" className="alta-btn alta-btn--atras" onClick={onAtras}>← {en ? "Back" : "Atrás"}</button>
        <button type="button" className="alta-btn alta-btn--seguir" onClick={onSeguir}>{textoSeguir || (en ? "Next →" : "Seguir →")}</button>
      </div>
    </div>
  );
}
// s224 · el medidor Tibia · Buena · Fuerte de cada tarjeta de «El dinero». Dice solo lo que el catálogo hace de verdad:
// «Imperdibles» (isBestDealOffer, s227-D2), «Mayor ahorro» (ordena por el monto) y nada que no podamos cumplir.
function MedidorWizard({ nivel, texto, rojo, en }) {
  const nombres = en ? ["Weak", "Good", "Strong"] : ["Tibia", "Buena", "Fuerte"];
  const clase = rojo ? "alta-wiz__medidor--rojo" : `alta-wiz__medidor--${nivel}`;
  return (
    <div className={["alta-wiz__medidor", clase].join(" ")}>
      <div className="alta-wiz__medidor-barras" aria-hidden="true">
        {[0, 1, 2].map(i => <span key={i} className={i <= nivel ? "alta-wiz__medidor-on" : ""} />)}
      </div>
      <div className="alta-wiz__medidor-texto"><b>{nombres[nivel]}.</b> {texto}</div>
    </div>
  );
}
// s228 · `puedeMenos`/`puedeMas`: en el extremo el botón se apaga (antes el + en el tope no hacía nada y no lo decía).
function StepperWizard({ etiqueta, valor, onMenos, onMas, en, puedeMenos = true, puedeMas = true }) {
  return (
    <div className="alta-wiz__stepper">
      {etiqueta && <span className="alta-wiz__stepper-etiqueta">{etiqueta}</span>}
      <button type="button" className="alta-wiz__stepper-btn" onClick={onMenos} disabled={!puedeMenos} aria-label={en ? `Lower ${etiqueta || ""}` : `Bajar ${etiqueta || ""}`}>−</button>
      <span className="alta-wiz__stepper-valor">{valor}</span>
      <button type="button" className="alta-wiz__stepper-btn" onClick={onMas} disabled={!puedeMas} aria-label={en ? `Raise ${etiqueta || ""}` : `Subir ${etiqueta || ""}`}>+</button>
    </div>
  );
}

// s224 · `wizard-en-consola-otto`: la misma pieza, montada en «Sembrar un comercio» con `operador`:
//   { placeId, visible, fotosExternas, businessType, sembrar(resumen) → { merchant_id, beta_token, offer_id }, alTerminar(info) }.
// Ahí no hay comercio todavía: Otto hace las preguntas en la llamada y, al final, la cadena es seed_merchant SIN oferta
// (operador.sembrar) → una operatorAddOffer por momento → guardarFicha con merchant_id (respuestas y menú) → las fotos
// con operatorAddPhoto (la portada primero: el WF la pone de foto en las ofertas que no tienen) → Visible, si se pidió.
// Si un paso falla, lo hecho queda en `avance` y «Reintentar» sigue desde ahí: NUNCA se siembra dos veces
// (seed_merchant rechaza el place_id repetido). Sin `operador`, es el alta del dueño.
// s254 (Ali, prueba con Otto): el dueño lee las horas en AM/PM, no en hora militar. Solo se MUESTRAN así: por dentro
// (valid_time_start/end, momentos, Bubble) siguen siendo "HH:MM" de 24 h. «00:00» → «12:00 AM»; «12:00» → «12:00 PM».
// AM/PM también en español, igual que la ficha del miembro (horaBonita en OfferDetailPage).
const hora12 = (hhmm) => {
  const m = /^(\d{1,2}):(\d{2})$/.exec(String(hhmm || "").trim());
  if (!m) return String(hhmm || "");
  const h = Number(m[1]) % 24;
  return `${h % 12 || 12}:${m[2]} ${h >= 12 ? "PM" : "AM"}`;
};
const rango12 = (ini, fin, en = false) => `${hora12(ini, en)} – ${hora12(fin, en)}`;
// Un texto con horas «HH:MM» adentro (el horario de Google ya armado) pasa entero a AM/PM.
const horas12EnTexto = (txt, en = false) => String(txt || "").replace(/\b(\d{1,2}):(\d{2})\b/g, (x) => hora12(x, en)).replace(/\s*–\s*/g, " – ");
// s254 · P4 (Ali): las horas de la franja van cada 30 minutos. El <input type="time"> ofrecía todos los minutos
// (30, 31, 32…). Un valor que no cae en :00/:30 (horario de Google, borrador viejo) se muestra igual, como opción propia.
const HORAS_CADA_30 = Array.from({ length: 48 }, (_, i) => `${String(Math.floor(i / 2)).padStart(2, "0")}:${i % 2 ? "30" : "00"}`);
function HoraCada30({ value, onChange, en = false, ...rest }) {
  const v = String(value || "");
  const opciones = v && !HORAS_CADA_30.includes(v) ? [...HORAS_CADA_30, v].sort() : HORAS_CADA_30;
  return (
    <select className="alta-input" value={v} onChange={e => onChange(e.target.value)} {...rest}>
      {opciones.map(h => <option key={h} value={h}>{hora12(h, en)}</option>)}
    </select>
  );
}
function WizardPrimeraOferta({ perfil, lang, onEnviada, operador = null, ofertasVivas = 0, otraFranja = false, onSalir = null }) {
  const en = lang === "en";
  const t = (es, enTxt) => (en ? enTxt : es);
  const categoria = perfil?.category || "Restaurant";
  const negocio = perfil?.business_name || "";
  const tipoNegocio = String((operador ? operador.businessType : perfil?.business_type) || "").trim();
  const porPersonaTipo = TIPOS_POR_PERSONA.includes(tipoNegocio);
  const divisor = porPersonaTipo ? 1 : preguntaTicket(categoria, en).divisor;   // s236 · siempre 1: se pregunta por persona
  // s236 · `mesa` = restaurante o bar sentado (los textos de «mesas»); `dos` = el recibo de ejemplo es de dos personas
  // (también comida rápida y dulces). La cuenta del ejercicio sale de lo que gasta una persona × 2.
  const mesa = RUBROS_TICKET_MESA.includes(categoria) && !porPersonaTipo;
  const dos = RUBROS_RECIBO_DOS.includes(categoria);
  const familia = FAMILIA_POR_RUBRO[categoria];
  const perfilRubro = perfilDelRubro(categoria);   // s241 · lo que el rubro tiene y cómo se dice
  const antesDe = (p) => (en ? p.en : p.es).charAt(0).toUpperCase() + (en ? p.en : p.es).slice(1) + ".";
  const momentosRubro = momentosDelRubro(categoria);
  // s224 · las ofertas que todavía caben (TOO_MANY_OFFERS en create_offer y operator_add_offer).
  const cupo = Math.max(0, OFERTAS_VIVAS_MAX - (Number(ofertasVivas) || 0));

  // 0 = arranque · 1-5 = las preguntas · 6 = vista previa y checklist. En la consola no hay saludo: Otto ya habla.
  const [pantalla, setPantalla] = useState(operador || otraFranja ? 1 : 0);
  const [tuvoAntes, setTuvoAntes] = useState("");          // "si" | "no"
  const [dondeAntes, setDondeAntes] = useState([]);
  const [sabeOferta, setSabeOferta] = useState("");        // "si" | "no"
  const [idea, setIdea] = useState("");
  const [objetivoOtro, setObjetivoOtro] = useState("");   // s239 · W10
  // s239 · W16/W7 (Ali): la web del negocio (pantalla 7) y el link de la oferta que ya da (pantalla 1) se leen con
  // `ingest_offer_ideas` en segundo plano mientras responde; el resumen llega con descripción y destacados «De tu web».
  // Montos, %, mínimo, días y horario NO salen de aquí: siguen las reglas. Si la lectura falla, nada se traba.
  const [webNegocio, setWebNegocio] = useState(String(perfil?.website || "").trim());
  // s241 · T1/T4 (export 157): sin web, el dueño marca «No tengo web» y/o pega lo que tenga (menú, servicios, su Instagram).
  // Si ya estaba marcado (lo sembró Otto así), no se le vuelve a exigir la web (D1): solo se le ofrece cargarla.
  const [sinWeb, setSinWeb] = useState(perfil?.sin_web === true || perfil?.sin_web === "true");
  const [textoNegocio, setTextoNegocio] = useState(String(perfil?.texto_negocio || ""));
  const [linkOferta, setLinkOferta] = useState("");
  const [lectura, setLectura] = useState({ estado: "", web: null, oferta: null });   // estado: "" | leyendo | lista
  const lecturaLanzada = useRef("");
  // s240: la lectura dura más que una pantalla. Su resultado se descarta solo si el dueño sale del wizard, no al pasar
  // de pregunta (antes el efecto, atado a `pantalla`, lo tiraba en el primer «Seguir» y el resumen quedaba «leyendo»).
  const wizardMontado = useRef(true);
  useEffect(() => { wizardMontado.current = true; return () => { wizardMontado.current = false; }; }, []);
  const [destacados, setDestacados] = useState(["", "", ""]);
  const [deLaWeb, setDeLaWeb] = useState({ esencial: false, destacados: false });
  const [objetivos, setObjetivos] = useState([]);           // hasta OBJETIVOS_MAX
  const [momentos, setMomentos] = useState(null);           // { key: { on, ini, fin } }; null = sin prellenar
  const [dias, setDias] = useState([...FEED_DAY_TOKENS]);   // los días abiertos del negocio (prellenado de Google): el punto de partida de cada momento
  // s230 · wizard-momentos-tarjeta-por-momento: los días van POR MOMENTO (siete círculos en cada tarjeta). Antes era
  // «¿es igual toda la semana?» + dos grupos (entre semana / finde) con chips. { key: [tokens] }; sin entrada = diasBase(m).
  const [diasPorMomento, setDiasPorMomento] = useState({});
  const [ticket, setTicket] = useState("");                 // lo que escribe: la mesa de dos o una persona
  const [fuenteTicket, setFuenteTicket] = useState("");     // google | tipico | "" (lo escribió él)
  const [tamanoId, setTamanoId] = useState("");             // "" = el que sale del ticket
  const [formato, setFormato] = useState("");               // std | pct | bogo; "" = el recomendado
  // s236 (Ali) · en salones, spa y barberías el porcentaje es lo recomendado, en toda la cuenta; s237-D3 · sin tope.
  const esSalonPct = RUBROS_PCT_RECOMENDADO.includes(categoria);
  // s255 · `primera-oferta-solo-porcentaje`: en la primera oferta no hay monto fijo (Otra franja sí lo conserva).
  const conMontoFijo = PRIMERA_CON_MONTO_FIJO || otraFranja;
  const [pct, setPct] = useState(esSalonPct ? PCT_SALON.pct : conMontoFijo ? PCT_DEFECTO : PCT_PRIMERA);   // s224 arrancaba en 35; s236 (Ali) · 25 % sin tope; s255 · 20 % en la primera
  const [conTope, setConTope] = useState(false);            // s224 · el % arranca SIN tope (Ali); s237-D3 · salones también
  // s237 · el ticket y «Recomienda» vuelven al tope de arranque. Desde s237-D3 no hay tope sugerido en ningún rubro:
  // si el dueño elige «Con tope», arranca en el del tamaño de su ticket, como en todos los rubros.
  const topeInicial = "";
  const [topeId, setTopeId] = useState(topeInicial);
  const [plato, setPlato] = useState("");
  const [precioPlato, setPrecioPlato] = useState("");
  const [platoAlcohol, setPlatoAlcohol] = useState(false);
  const [plazo, setPlazo] = useState("");                   // "" = el de los objetivos
  const [canal, setCanal] = useState("");
  const [exclusiones, setExclusiones] = useState(familia === "mesa" ? ["alcohol"] : []);
  const [exclusionOtro, setExclusionOtro] = useState("");
  const [todoEntra, setTodoEntra] = useState(false);
  // s234 · sobre-esta-oferta-alta-normal: «Sobre esta oferta» del alta propia era solo «Aplica a toda la cuenta.» (la
  // siembra trae «Lo esencial»). El dueño lo escribe aquí; nace con la descripción de su Perfil si ya la tenía.
  const [esencial, setEsencial] = useState(String(perfil?.description_es || "").trim());
  // s223 · FOTOS DE TU NEGOCIO: la primera es la portada de la oferta (`image`); las demás van a la galería del
  // comercio. Cada una pasa por EncuadrarFoto, una por vez (cola), igual que la galería de Perfil (regla s206).
  const [cola, setCola] = useState([]);
  const [fotos, setFotos] = useState([]);
  const [galeriaActual, setGaleriaActual] = useState(0);
  const [avisoFotos, setAvisoFotos] = useState("");
  // s228 · el logo, solo en el alta del dueño (s215: en la consola Otto siembra sin logo; lo sube el dueño). Pasa por el
  // mismo encuadrador que Perfil (1:1, 512 px, el PNG queda PNG) y se guarda apenas se encuadra (update_merchant_logo),
  // para que la vista previa lo muestre. Es opcional: no cuenta en «N de 7 listos» ni frena el envío.
  const [logoUrl, setLogoUrl] = useState(perfil?.logo || "");
  const [logoPorEncuadrar, setLogoPorEncuadrar] = useState(null);
  const [subiendoLogo, setSubiendoLogo] = useState(false);
  const [avisoLogo, setAvisoLogo] = useState("");
  // s255 · alta-logo-desde-web: los logos que trajo la lectura de la web (pase s255 a Cowork). Se ofrecen, no se ponen solos.
  // s256 · logo-web-cors-no-ofrecer: solo el primero que se pudo bajar, ya preparado. `muestra` es la URL local de ese archivo.
  const [logoWeb, setLogoWeb] = useState(null);   // null | { url, file, muestra }
  useEffect(() => () => { if (logoWeb?.muestra) URL.revokeObjectURL(logoWeb.muestra); }, [logoWeb]);
  // s255 · alta-datos-de-la-web: lo que la IA sacó de la web (datos_web_json), con los servicios ya validados y recortados.
  const [datosWeb, setDatosWeb] = useState(null);   // null | { datos, servicios, sugerida }
  const vistaRef = useRef(null);
  const [vistaActiva, setVistaActiva] = useState(0);   // s230 · wizard-previa-carrusel: qué tarjeta de la vista previa está a la vista
  const [enCamino, setEnCamino] = useState(0);         // s230 · wizard-intro-enamorar: comercios en camino (get_catalogo_preapertura)
  // s228 · el id de la tarjeta pendiente a la que llevó «Enviar» (antes el botón quedaba apagado sin decir por qué).
  const [marcarFalta, setMarcarFalta] = useState("");
  const [ficha, setFicha] = useState(undefined);           // undefined cargando · null no se pudo leer
  const [precioG, setPrecioG] = useState(null);             // lo que devolvió placePrecio: { desde, hasta, nivel }
  const [nombreDueno, setNombreDueno] = useState("");
  const [aviso, setAviso] = useState("");
  const [confirmaTicket, setConfirmaTicket] = useState(false);   // s254 · P6: la ventana «¿Es lo de una persona?»
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");
  // s224 · consola: el menú se guarda DESPUÉS de sembrar (antes no hay comercio), y lo hecho de la cadena.
  const [menuLink, setMenuLink] = useState("");
  const [menuArchivo, setMenuArchivo] = useState(null);
  const avance = useRef({ merchant: null, creadas: 0, fichaOk: false, fotos: 0, estadoOk: false, bloqueado: false });
  const [sembrado, setSembrado] = useState(null);

  const pre = prellenarFranjas(perfil?.business_hours_json, categoria);
  const horarioTexto = horarioDesdeJson(perfil?.business_hours_json, en).map(d => `${d.dia} ${d.valor}`).join(" · ");
  const portada = fotos[0] || null;
  // s227 · `wizard-foto-por-oferta`: una URL por foto (misma posición que `fotos`), creadas y liberadas en el mismo
  // efecto (s201). Antes había una sola, la de la portada, y todas las ofertas salían con ella.
  const [fotoUrls, setFotoUrls] = useState([]);
  useEffect(() => {
    const us = fotos.map(f => URL.createObjectURL(f));
    setFotoUrls(us);
    return () => us.forEach(u => URL.revokeObjectURL(u));
  }, [fotos]);
  // La foto de cada oferta, por `momento.key` → el File elegido. Se guarda el File y no la posición: si el dueño quita
  // una foto o cambia la portada, la elección no salta a otra. Si la elegida ya no está, vale la portada.
  const [fotoDeOferta, setFotoDeOferta] = useState({});
  const fotoDe = (o) => { const f = fotoDeOferta[o.momento.key]; return f && fotos.includes(f) ? f : portada; };
  const urlDe = (f) => { const i = f ? fotos.indexOf(f) : -1; return i >= 0 ? fotoUrls[i] || "" : ""; };
  // Caben: la portada + lo que le queda a la galería. En la consola la portada también entra a la galería
  // (operator_add_photo, Step 6): caben las de la galería y nada más.
  // s228 · `wizard-portada-tambien-a-galeria`: en el alta del dueño la portada también entra a la galería (antes solo
  // las demás), así la ficha /m/:id no sale «sin fotos» cuando sube una sola. Caben las que le quedan a la galería; con
  // la galería llena, igual entra una (la portada de la oferta), que ya no se suma a la galería.
  const cabenGaleria = Math.max(0, GALERIA_TOPE - galeriaActual);
  const maxFotos = operador ? GALERIA_TOPE : Math.max(1, cabenGaleria);
  // s224 · consola: la foto pegada (Ctrl+V), arrastrada o traída por enlace en el formulario entra aquí, adelante.
  // s233 · Ali: «solo puedo subir una foto». Antes llegaba una (`fotoExterna`), que reemplazaba a la anterior y se ponía
  // de portada. Ahora llega la lista del formulario: entran al final y solo las nuevas (`vistasExternas`), así una
  // que se quitó aquí no vuelve cuando se agrega otra arriba.
  const fotosExternas = operador?.fotosExternas;
  const vistasExternas = useRef(new Set());
  useEffect(() => {
    const nuevas = (fotosExternas || []).filter(f => !vistasExternas.current.has(f));
    nuevas.forEach(f => vistasExternas.current.add(f));
    if (nuevas.length && !avance.current.merchant) setFotos(fs => [...fs, ...nuevas.filter(f => !fs.includes(f))].slice(0, GALERIA_TOPE));
  }, [fotosExternas]);
  // s233 · Ali: «hizo falta un botón de hacer portada» arriba. El orden vive aquí; el formulario lo recibe
  // (`alCambiarFotos`) para mostrar la lista real, y sus botones piden el cambio (`pedidoFotos` = { tipo, file, n }).
  const alCambiarFotos = useRef(null);
  alCambiarFotos.current = operador?.alCambiarFotos || null;
  useEffect(() => { if (alCambiarFotos.current) alCambiarFotos.current(fotos); }, [fotos]);
  const pedidoFotos = operador?.pedidoFotos;
  useEffect(() => {
    if (!pedidoFotos || avance.current.merchant) return;
    const { tipo, file } = pedidoFotos;
    if (tipo === "portada") setFotos(fs => (fs.includes(file) ? [file, ...fs.filter(f => f !== file)] : fs));
    else if (tipo === "quitar") setFotos(fs => fs.filter(f => f !== file));
  }, [pedidoFotos]);
  const elegirFotos = (e) => {
    const elegidas = Array.from(e.target.files || []);
    e.target.value = "";
    if (!elegidas.length) return;
    const hueco = maxFotos - fotos.length - cola.length;
    const entran = elegidas.slice(0, Math.max(0, hueco));
    setAvisoFotos(entran.length < elegidas.length
      ? t(`Solo entran ${maxFotos} fotos.`, `Only ${maxFotos} photos fit.`)
      : "");
    if (entran.length) setCola(c => [...c, ...entran]);
  };
  useEffect(() => { if (perfil?.logo) setLogoUrl(u => u || perfil.logo); }, [perfil?.logo]);
  // s235 · alta-logo-lienzo-cuadrado (Ali, «BRASAS BBQ» salía cortado): el logo pasa por el lienzo cuadrado de la siembra.
  const elegirLogo = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!OK_LOGO_TYPES.includes(f.type)) { setAvisoLogo(t("⚠️ El logo tiene que ser JPG, PNG o WebP.", "⚠️ The logo must be JPG, PNG or WebP.")); return; }
    if (f.size > MAX_LOGO_BYTES) { setAvisoLogo(t("⚠️ El logo pesa más de 2 MB.", "⚠️ The logo is over 2 MB.")); return; }
    setAvisoLogo("");
    setLogoPorEncuadrar(await logoEnCuadrado(f));
  };
  const subirLogo = async (f) => {
    setLogoPorEncuadrar(null);
    if (f.size > MAX_LOGO_BYTES) { setAvisoLogo(t("⚠️ El logo pesa más de 2 MB.", "⚠️ The logo is over 2 MB.")); return; }
    setSubiendoLogo(true); setAvisoLogo("");
    try {
      const r = await updateMerchantLogo(f);
      const url = String(r?.logo_url || "");
      if (url) setLogoUrl(url);
      setAvisoLogo(url ? t("✅ Logo guardado.", "✅ Logo saved.")
                       : t("⚠️ No vimos el logo guardado. Revísalo en Perfil.", "⚠️ We couldn't confirm the logo. Check it in Profile."));
    } catch (e) {
      setAvisoLogo(t("⚠️ No pudimos guardar el logo. Prueba otra vez, o súbelo después desde Perfil.", "⚠️ We couldn't save the logo. Try again, or upload it later from Profile."));
    } finally {
      setSubiendoLogo(false);
    }
  };
  // s256 · el archivo ya está bajado y preparado (primerLogoQueBaja): va directo al encuadrador.
  const usarLogoDeLaWeb = () => {
    if (!logoWeb?.file) return;
    setAvisoLogo("");
    setLogoPorEncuadrar(logoWeb.file);
  };
  const irAFotoDeOferta = () => {
    const el = vistaRef.current && vistaRef.current.querySelector(".alta-wiz__foto-oferta");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
  };
  const placeOperador = operador ? String(operador.placeId || "").trim() : null;
  // Consola: todavía no hay comercio que leer; el precio de Google sale del place_id elegido. Va aparte porque ahí
  // `perfil` se arma en cada render: con él en las dependencias, esto correría sin parar.
  useEffect(() => {
    if (placeOperador === null) return undefined;
    let on = true;
    setFicha({}); setGaleriaActual(0); setPrecioG(null);
    if (placeOperador) placePrecio(placeOperador).then(p => { if (on) setPrecioG(p || null); }).catch(() => {});
    return () => { on = false; };
  }, [placeOperador]);
  useEffect(() => {
    if (placeOperador !== null) return undefined;
    let on = true;
    getUserProfile().then(u => { if (on) setNombreDueno(String(u?.name || "").trim().split(/\s+/)[0] || ""); }).catch(() => {});
    const mid = perfil?.merchant_id || "";
    if (!mid) { setFicha(null); return () => { on = false; }; }
    leerFichaYLugar(mid)
      .then(async ({ ficha: f, place_id, galeria }) => {
        if (!on) return;
        setFicha(f);
        setGaleriaActual(Number(galeria) || 0);
        if (!place_id) return;
        const p = await placePrecio(place_id).catch(() => null);
        if (on) setPrecioG(p || null);
      })
      .catch(() => { if (on) setFicha(null); });
    return () => { on = false; };
  }, [perfil, placeOperador]);
  // Los momentos se prellenan una sola vez, al llegar a la pantalla 3 (después el dueño manda).
  useEffect(() => {
    if (pantalla !== 3 || momentos !== null) return;
    const p = prellenarFranjas(perfil?.business_hours_json, categoria);
    // s235 · wizard-primera-oferta-una-sola (Ali): se arranca con UNA oferta. Viene marcado un solo momento: de los que
    // abre según su horario, el flojo si quiere llenar horas flojas, si no el fuerte (la cena, la noche); sin horario, el
    // primero del rubro. Después agrega otra franja desde «Mis ofertas».
    const abiertos = momentosRubro.filter(x => p.franjas.has(x.key));
    const diasAbiertos = FEED_DAY_TOKENS.filter(d => !p.cerrados.includes(d));
    const caben = (lista) => lista.filter(x => franjaEnHorario(x.ini, x.fin, perfil?.business_hours_json, diasAbiertos));   // s252
    const candidatos = caben(abiertos).length ? caben(abiertos) : caben(momentosRubro).length ? caben(momentosRubro) : momentosRubro;
    // Horas flojas: la tarde antes que la mañana (sin horario, el desayuno no es lo típico de un restaurante).
    const FLOJOS = ["almuerzo", "merienda", "brunch", "desayuno"];
    const flojo = FLOJOS.map(k => candidatos.find(x => x.key === k)).find(Boolean) || candidatos.find(x => !x.fuerte);
    const recomendado = (objetivos.includes("horas_flojas") ? flojo : candidatos.find(x => x.fuerte)) || candidatos[0];
    const m = {};
    momentosRubro.forEach(x => { m[x.key] = { on: !!recomendado && x.key === recomendado.key, ...(franjaEnHorario(x.ini, x.fin, perfil?.business_hours_json, diasAbiertos) || { ini: x.ini, fin: x.fin }) }; });
    // s255 · alta-datos-de-la-web: los servicios de la web que pasaron el chequeo ponen su hora y sus días en el momento del
    // mismo nombre; la franja sugerida (si pasó) es la marcada. Lo demás, como siempre.
    const deLaWeb = (datosWeb?.servicios || []).filter(sv => sv.key && m[sv.key]);
    if (deLaWeb.length) {
      deLaWeb.forEach(sv => { m[sv.key] = { ...m[sv.key], ini: sv.ini, fin: sv.fin, web: true }; });
      setDiasPorMomento(x => ({ ...Object.fromEntries(deLaWeb.map(sv => [sv.key, sv.dias])), ...x }));
      const sug = deLaWeb.find(sv => sv.sugerida);
      if (sug) Object.keys(m).forEach(k => { m[k] = { ...m[k], on: k === sug.key }; });
    }
    setMomentos(m);
    if (p.hayHorario) {
      const abiertos = FEED_DAY_TOKENS.filter(d => !p.cerrados.includes(d));
      if (abiertos.length) setDias(abiertos);
    }
  }, [pantalla, momentos, perfil, categoria, momentosRubro, objetivos, datosWeb]);

  // ---- §3 · las ofertas: una por momento elegido, con sus días ----
  const etiquetaMomento = (m) => (en ? m.en : m.es);
  const elegidos = momentosRubro.filter(m => momentos && momentos[m.key]?.on);
  // s230 · el punto de partida de un momento: los días abiertos del negocio; el brunch, solo el fin de semana (como antes
  // en el grupo «finde»). Lo que el dueño toque en los círculos manda (`diasPorMomento`).
  const diasBase = (m) => (m.finde ? dias.filter(d => DIAS_FINDE.includes(d)) : dias);
  const diasDe = (m) => FEED_DAY_TOKENS.filter(d => (diasPorMomento[m.key] || diasBase(m)).includes(d));
  const toggleDia = (m, d) => setDiasPorMomento(x => ({ ...x, [m.key]: toggleEn(x[m.key] || diasBase(m), d) }));
  // Para wizard_json (`igual_semana`): «sí» cuando todos los momentos elegidos tienen los mismos días.
  const igualSemana = elegidos.length ? (new Set(elegidos.map(m => diasDe(m).join(","))).size === 1 ? "si" : "no") : "";
  const textoDias = (lista) => (lista.length === 7
    ? t("Todos los días", "Every day")
    : FEED_DAY_TOKENS.map((d, i) => (lista.includes(d) ? (en ? MERCHANT_DAYS[i].en : MERCHANT_DAYS[i].es) : null)).filter(Boolean).join(", "));
  const franjasConDias = elegidos.map(m => ({ momento: m, ini: momentos[m.key].ini, fin: momentos[m.key].fin, dias: diasDe(m) }))
    .filter(f => f.dias.length);

  // ---- §4 · el dinero ----
  // s255 (Ali, «dale, quítala») · `primera-oferta-sin-ticket`: con solo porcentaje, «¿Cuánto gasta UNA PERSONA?» no decide
  // nada (era para el tamaño del monto fijo). En la primera oferta no se pregunta: el ejemplo de la cuenta y el tope de
  // «Con tope» salen del precio de Google o, sin Google, de lo típico del rubro (y se dice que es un ejemplo). No se
  // guarda en la ficha como si lo hubiera dicho el dueño. Otra franja (con monto fijo) la sigue preguntando.
  const conPreguntaTicket = conMontoFijo;
  const gTicket = precioDeGoogle(precioG);
  const ppEjemplo = gTicket ? gTicket.porPersona : (TICKET_TIPICO_POR_PERSONA[tipoNegocio] || TICKET_TIPICO_POR_PERSONA[categoria] || 35);
  const ticketEscrito = parseFloat(String(ticket).replace(/[$\s]/g, "").replace(",", ".")) || 0;
  const ticketNum = conPreguntaTicket ? ticketEscrito : ppEjemplo * divisor;
  const porPersona = ticketNum > 0 ? ticketNum / divisor : 0;
  // s236 · la cuenta del ejemplo: dos personas en restaurantes, bares, comida rápida y dulces; una en los demás rubros.
  const cuentaBase = porPersona * (dos ? 2 : 1);
  const lista = tamanosWizard(categoria, porPersonaTipo);
  const iAuto = indiceTamanoWizard(lista, porPersona, objetivos, categoria);
  const iElegido = tamanoId ? Math.max(0, lista.findIndex(x => x.id === tamanoId)) : iAuto;
  const tamano = iElegido >= 0 ? lista[iElegido] : null;
  const tamanoSugerido = iAuto >= 0 ? lista[iAuto] : null;
  const topes = lista.map(x => x.monto);
  const tope = topeId ? Number(topeId) : (tamano ? tamano.monto : 0);
  // s233 · los objetivos que traían el 30 fijo toman el del rubro (15 en comida y bebida); «horas flojas» y «que vuelvan»
  // siguen en 15. Salones y barberías nunca se recomiendan por debajo de 30 (guion de Otto, s233).
  const plazoRubro = plazoDelRubro(categoria);
  const plazoObjetivo = porPersona >= 80 ? 30 : Math.max(categoria === "Salon_Spa" ? 30 : 1, Math.min(...(objetivos.length
    ? objetivos.map(id => { const p = (OBJETIVOS_WIZARD.find(o => o.id === id) || {}).plazo || COOLDOWN_POR_DEFECTO; return p === COOLDOWN_POR_DEFECTO ? plazoRubro : p; })
    : [plazoRubro])));
  const plazoFinal = Number(plazo) || plazoObjetivo;
  const hay2x1 = WIZARD_CON_2X1 && RUBROS_2X1.includes(categoria) && objetivos.some(id => ["nuevos", "horas_flojas"].includes(id));
  const yaDaDescuento = tuvoAntes === "si" && dondeAntes.includes("empleados");
  const recomendado = formatoPrimeraOferta(recomendarFormato({ porPersona, yaDaDescuento, objetivos, hay2x1, categoria }), conMontoFijo);
  const elegido = formato && (formato !== "bogo" || hay2x1) && (formato !== "std" || conMontoFijo) ? formato : recomendado;
  const pctNum = Number(pct) || 0;
  const precioNum = parseFloat(String(precioPlato).replace(",", ".")) || 0;
  const canalFinal = canalValido(canal) || (porPersonaTipo ? "takeout" : canalDelRubro(categoria));
  const alcoholEnReglas = familia === "mesa";
  const exclusion = todoEntra ? "" : lineaExclusion(exclusiones, exclusionOtro, alcoholEnReglas, en);
  const exclusionEs = todoEntra ? "" : lineaExclusion(exclusiones, exclusionOtro, alcoholEnReglas, false);
  // s239 · W15 (Ali): la pregunta ya no traba el envío. Sin nada propio marcado, vale «Todo lo demás entra» (el botón se ve
  // marcado y el miembro lee la frase de alcance); antes había que tocarlo sí o sí (s228).
  const hayExclusionPropia = exclusiones.some(id => !(id === "alcohol" && alcoholEnReglas)) || !!exclusionOtro.trim();
  const todoEntraVisto = todoEntra || !hayExclusionPropia;
  // s255 · `exclusiones-frase-contradictoria`: con «Bebidas» marcado en restaurantes y bares, la frase de alcance dice solo la comida.
  const alcanceWizard = alcoholEnReglas && !todoEntra && exclusiones.includes("bebidas") ? ALCANCE_SOLO_COMIDA[en ? "en" : "es"] : fraseAlcance(categoria, en);
  const exclusionRespondida = true;

  // Con dos o más momentos, los que no son el fuerte (la cena, la noche) llevan un tamaño menos, si lo hay.
  const hayFuerte = franjasConDias.length > 1 && franjasConDias.some(f => f.momento.fuerte);
  const tamanoDe = (f) => {
    if (!tamano || !hayFuerte || f.momento.fuerte) return tamano;
    return iElegido > 0 ? lista[iElegido - 1] : tamano;
  };
  const ofertas = franjasConDias.map(f => {
    const fr = momentoEnTitulo(f.momento, en);   // s252
    if (elegido === "pct") {
      const tp = conTope ? tope : TOPE_SIN_LIMITE;
      return { ...f, tipo: "pct", titulo: `${tituloPorcentaje(pctNum, tp, en, categoria)} · ${fr}`, frase: frasePorcentaje(pctNum, tp, en, categoria), tope: tp };
    }
    if (elegido === "bogo") {
      return { ...f, tipo: "bogo", titulo: `2×1 ${en ? "on" : "en"} ${plato.trim()} · ${fr}`, frase: `2×1 ${en ? "on" : "en"} ${plato.trim()}` };
    }
    const tm = tamanoDe(f);
    return { ...f, tipo: "std", tamano: tm, titulo: tm ? `${fraseUmbral(tm.monto, tm.minimo, en)} · ${fr}` : "", frase: tm ? fraseUmbral(tm.monto, tm.minimo, en) : "" };
  });

  // El aviso de «qué falta» se va en cuanto el dueño responde algo.
  useEffect(() => { setAviso(""); }, [tuvoAntes, sabeOferta, objetivos, momentos, dias, diasPorMomento, ticket, formato, pct, conTope, plato, precioPlato, plazo]);
  // s230 · wizard-intro-enamorar: la prueba social de la intro es el mismo contador del catálogo cerrado («N comercios en
  // camino», s229-D3). Una lectura pública al abrir, solo para el dueño; se muestra desde 3 y nunca con el club abierto.
  useEffect(() => {
    if (operador) return undefined;
    let vivo = true;
    getCatalogoPreapertura().then(r => { if (vivo && r && !r.abierto) setEnCamino(Number(r.count) || 0); }).catch(() => {});
    return () => { vivo = false; };
  }, [operador]);
  // s230 · wizard-previa-carrusel: con 2+ ofertas la vista previa es un carrusel horizontal (CSS scroll-snap); esto solo
  // sigue qué tarjeta está a la vista para encender su píldora. Sin carrusel (1 oferta) no observa nada.
  useEffect(() => {
    const cont = vistaRef.current;
    if (pantalla !== 6 || ofertas.length < 2 || !cont || typeof IntersectionObserver === "undefined") return undefined;
    const tarjetas = [...cont.children];
    const io = new IntersectionObserver(entradas => {
      entradas.forEach(e => { if (e.isIntersecting) setVistaActiva(tarjetas.indexOf(e.target)); });
    }, { root: cont, threshold: 0.6 });
    tarjetas.forEach(x => io.observe(x));
    return () => io.disconnect();
  }, [pantalla, ofertas.length]);
  const ir = (n) => { setAviso(""); setPantalla(n); };
  const siguiente = () => ir(pantalla + 1);
  // s235 · el dueño pasa por «Tu negocio en el club» (pantalla 7) entre el arranque y la pregunta 1.
  // s237 · otra-franja-atras-muerto: en la pregunta 1 de «Otra franja» no hay pantalla anterior; «Atrás» sale a la lista.
  const atras = () => {
    if (pantalla === 1 && (operador || otraFranja)) { if (onSalir) onSalir(); return; }
    ir(pantalla === 1 ? 7 : pantalla === 7 ? 0 : Math.max(0, pantalla - 1));
  };
  const chip = (on) => ["alta-chip", on && "alta-chip--on"].filter(Boolean).join(" ");
  const toggleEn = (arr, v) => (arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v]);

  // s239 · W16 · la lectura de la web sale al pasar la pregunta 1, una vez por link.
  // s240 · W16 v2 (pase s240 §2, 17:0x UTC; `SPEC_s240_ingest_offer_ideas_v2`):
  //   1. la web va al Perfil si ahí no hay nada (`guardarWebSiFalta`; antes de leer, para no cruzarse con la descripción);
  //   2. se LEE con `solo_leer` (Firecrawl + guardar, sin IA ni cupo: 5–11 s medido);
  //   3. con lo leído, el asistente escribe la descripción del negocio (`generate_merchant_description`, 3–7 s) y esa
  //      llena «Cómo te presentamos · De tu web». Si el comercio ya tiene descripción, se usa la suya y no se pide otra.
  // Cualquier fallo (`PAGE_MISMATCH`, `SCRAPE_EMPTY`, red, corte de 50 s…): silencio, el resumen queda como sin web.
  // El link de la oferta que ya da (W7) se guarda en `wizard_json` pero no se lee (Ali, opción 2).
  useEffect(() => {
    if (operador || otraFranja) return undefined;
    const web = linkLeible(webNegocio);
    // s255 · alta-logo-desde-web: si la web ya está (vino de Google al registrarse), se lee desde la intro y «Tu negocio»,
    // para que el logo de la web llegue a la pantalla del logo. Sin web, se espera a la pregunta 1, como antes.
    const temprano = pantalla < 2 || pantalla === 7;
    if (temprano && !web) return undefined;
    // s241 · T1/T4: sin web, lo que dio el dueño se guarda (antes de la descripción, que lo lee del comercio) y la descripción
    // sale de ese texto. Una vez por texto; cualquier fallo, silencio, como la lectura de la web.
    const texto = textoNegocio.trim();
    if (!web && !temprano && (texto || sinWeb)) {
      const clave = `texto:${sinWeb ? 1 : 0}:${texto}`;
      if (lecturaLanzada.current === clave) return undefined;
      lecturaLanzada.current = clave;
      if (texto) setLectura(l => ({ ...l, estado: "leyendo" }));
      (async () => {
        let leida = null;
        try {
          await guardarTextoNegocio({ sin_web: sinWeb, texto_negocio: texto });
          let desc = String((en ? perfil?.description_en : perfil?.description_es) || "").trim();
          if (!desc && texto && perfil?.merchant_id) {
            const d = await generateMerchantDescription(perfil.merchant_id);
            desc = String((en ? d?.description_en : d?.description_es) || "").trim();
          }
          if (desc && texto) leida = { description: desc };
        } catch (e) { console.warn("[lectura] el texto del negocio no se pudo usar", e?.code || e?.message); }
        if (wizardMontado.current && texto) setLectura({ estado: "lista", web: leida, oferta: null });
      })();
      return undefined;
    }
    if (!web || lecturaLanzada.current === web) return undefined;
    lecturaLanzada.current = web;
    const rubro = perfil?.business_type || categoria;
    setLectura(l => ({ ...l, estado: "leyendo" }));
    (async () => {
      let leida = null;
      try {
        await guardarWebSiFalta(web).catch(e => console.warn("[lectura] la web no quedó en el Perfil", e?.message));
        const r = await ingestOfferIdeas({ business_type: rubro, url: web, lang: en ? "en" : "es", solo_leer: true });
        // s256 · se baja antes de ofrecerlo (no se espera: la lectura sigue mientras tanto).
        primerLogoQueBaja(logosDeLaWeb(r)).then(x => {
          if (wizardMontado.current) setLogoWeb(x ? { ...x, muestra: URL.createObjectURL(x.file) } : null);
        });
        // s255 · alta-datos-de-la-web: la lectura programa tag_merchant_from_text (20–50 s). Se espera aparte, sin trabar el wizard.
        // Con CACHED (link ya leído) no se programa nada: lo que haya guardado se lee una vez, sin esperar.
        if (r && (r.success === "yes" || r.success === true) && perfil?.merchant_id) {
          const yaLeida = r.code === "CACHED";
          esperarDatosWeb(perfil.merchant_id, { sigue: () => wizardMontado.current, ...(yaLeida ? { primeraEspera: 0, maxMs: 0 } : {}) })
            .then((d) => {
              if (!d || !wizardMontado.current) return;
              const v = serviciosDeLaWeb(d.datos, d.texto, perfil?.business_hours_json || d.horario);
              setDatosWeb({ datos: d.datos, ...v });
            })
            .catch((e) => console.warn("[datos web] no llegaron", e?.message));
        }
        if (r && (r.success === "yes" || r.success === true)) {
          let texto = String((en ? perfil?.description_en : perfil?.description_es) || "").trim();
          if (!texto && perfil?.merchant_id) {
            const d = await generateMerchantDescription(perfil.merchant_id);
            texto = String((en ? d?.description_en : d?.description_es) || "").trim();
          }
          if (texto) leida = { description: texto };
        }
      } catch (e) { console.warn("[lectura] no se pudo leer", web, e?.code || e?.message); }
      if (wizardMontado.current) setLectura({ estado: "lista", web: leida, oferta: null });
    })();
    return undefined;
  }, [pantalla]);   // eslint-disable-line react-hooks/exhaustive-deps
  // s255 · alta-datos-de-la-web: «lo que más piden» va al primer destacado, solo si no hay ninguno (lo del dueño manda).
  useEffect(() => {
    const q = String(datosWeb?.datos?.que_pedir_es || "").trim();
    if (!q || destacados.some(x => x.trim())) return;
    setDestacados([t(`Lo que más piden: ${q.charAt(0).toLowerCase()}${q.slice(1)}`, `Most ordered: ${q}`).slice(0, 80), "", ""]);
    setDeLaWeb(d => ({ ...d, destacados: true }));
  }, [datosWeb]);   // eslint-disable-line react-hooks/exhaustive-deps
  // Lo leído llena el resumen solo si el dueño no escribió nada ahí (lo suyo manda).
  useEffect(() => {
    const p = lectura.web;
    if (!p || !LECTURA_EN_PANTALLA) return;
    if (!esencial.trim() && String(p.description || "").trim()) { setEsencial(String(p.description).trim()); setDeLaWeb(d => ({ ...d, esencial: true })); }
    const hl = [p.highlight_1, p.highlight_2, p.highlight_3].map(x => String(x || "").trim());
    if (hl.some(Boolean) && !destacados.some(x => x.trim())) { setDestacados(hl); setDeLaWeb(d => ({ ...d, destacados: true })); }
  }, [lectura.web]);   // eslint-disable-line react-hooks/exhaustive-deps

  const faltaEn = (n) => {
    if (n === 1) {
      if (!tuvoAntes) return t("Elige Sí o No.", "Pick Yes or No.");
      if (tuvoAntes === "si" && !sabeOferta) return t("Dinos si ya sabes qué oferta quieres.", "Tell us if you already know what offer you want.");
    }
    if (n === 2 && objetivos.length < OBJETIVOS_MIN) return objetivos.length
      ? t("Elige uno más: son dos.", "Pick one more: it's two.")
      : t("Elige dos cosas que quieres lograr.", "Pick two things you want to achieve.");
    if (n === 3) {
      if (!elegidos.length) return t("Elige al menos un momento.", "Pick at least one time of day.");
      if (elegidos.some(m => !(minutosDe(momentos[m.key].ini) < minutosDe(momentos[m.key].fin)))) return t("Revisa las horas: la de inicio va antes que la de fin.", "Check the times: the start goes before the end.");
      if (elegidos.some(m => !diasDe(m).length)) return t("Cada momento necesita al menos un día. Si ese día no abres, apaga el momento.", "Each time of day needs at least one day. If you're closed that day, switch the time of day off.");
      if (franjasConDias.length > cupo) return t(`Son ${franjasConDias.length} ofertas y te ${cupo === 1 ? "queda" : "quedan"} ${cupo}. Quita un momento.`, `That's ${franjasConDias.length} offers and you have ${cupo} left. Remove one.`);
    }
    if (n === 4) {
      if (conPreguntaTicket && !(ticketNum > 0)) return t("Escribe tu ticket promedio, o toca «Recomienda mi oferta».", "Write your average bill, or tap “Recommend my offer”.");
      if (elegido === "pct" && (pctNum < PCT_MINIMO || pctNum > 100)) return t(`El mínimo del club es ${PCT_MINIMO} %.`, `The club minimum is ${PCT_MINIMO}%.`);
      if (elegido === "bogo" && (!plato.trim() || !(precioNum > 0))) return t("Escribe el plato y su precio de carta.", "Write the dish and its menu price.");
      if (elegido === "std" && !tamano) return t("No pudimos calcular el monto. Revisa tu ticket.", "We couldn't work out the amount. Check your bill.");
    }
    return "";
  };
  // s254 · P6: en el paso 4, antes de seguir, una ventana confirma que el ticket es de UNA persona (confirmaTicket).
  const seguir = (n) => { const f = faltaEn(n); if (f) { setAviso(f); return; } if (n === 4 && !operador && conPreguntaTicket) { setConfirmaTicket(true); return; } siguiente(); };
  const acciones = (n, textoSeguir) => (
    <AccionesWizard aviso={aviso} en={en} onAtras={atras} onSeguir={() => seguir(n)} textoSeguir={textoSeguir} />
  );

  // «Recomienda mi oferta»: con Google, el punto medio del rango por persona; sin Google, lo típico del rubro (dicho así).
  const g = precioDeGoogle(precioG);
  const recomendar = () => {
    const pp = g ? g.porPersona : (TICKET_TIPICO_POR_PERSONA[tipoNegocio] || TICKET_TIPICO_POR_PERSONA[categoria] || 35);
    const puesto = ticketAlRecomendar(ticket, pp * divisor);
    if (puesto === null) return;   // s252 · con su número ya escrito, la oferta ya está a la vista
    setTicket(puesto);
    setFuenteTicket(g ? "google" : "tipico");
    setTamanoId(""); setTopeId(topeInicial);
  };
  const lineaGoogle = () => {
    if (!g) return t("Google no tiene el precio de tu negocio. Escribe tu ticket, o te recomendamos lo típico de tu rubro.",
      "Google doesn't have your price. Write your bill, or we'll recommend what's typical for your category.");
    if (g.fuente === "google_rango") {
      const d = Number(precioG.desde) || 0, h = Number(precioG.hasta) || 0;
      const rango = h > d ? `$${d}–${h}` : `$${d}+`;
      // s236 · la pregunta es por persona: ya no hace falta traducir el rango a la mesa de dos.
      return t(`Según Google, una persona gasta en tu negocio ${rango}. ¿Es así? Si no, escribe el tuyo.`, `According to Google, one person spends ${rango} at your place. Is that right? If not, enter yours.`);
    }
    return t("Google solo muestra el nivel de precio de tu negocio: lo usamos como punto de partida aproximado.",
      "Google only shows your price level: we use it as a rough starting point.");
  };

  // ---- s224 · las respuestas (las dos ramas guardan lo mismo) ----
  const respuestas = (origen) => respuestasWizard({
    origen, en, tipoNegocio, tuvoAntes, dondeAntes, sabeOferta, idea, objetivos, objetivoOtro, webNegocio, linkOferta, lectura, deLaWeb, igualSemana, ofertas, mesa,
    // s255 · sin la pregunta, el número del ejemplo no es del dueño: no va a avg_ticket_usd.
    ticketNum: conPreguntaTicket ? ticketNum : 0, porPersona: conPreguntaTicket ? porPersona : 0,
    fuenteTicket: conPreguntaTicket ? fuenteTicket : "no_se_pregunta", precioG, elegido, recomendado, tamano, tamanoSugerido, pctNum, conTope, tope, plato, precioNum, platoAlcohol,
    plazoFinal, plazoObjetivo, canalFinal, exclusiones, exclusionOtro, todoEntra: todoEntraVisto,   // s239 · W15
  });

  // ---- enviar ----
  // En la consola, la foto solo se exige si el comercio va a quedar Visible (como en la siembra clásica), y el menú es
  // opcional: Otto siembra antes de que el dueño diga que sí.
  // s235 (Ali) · la foto solo frena en la consola cuando Otto siembra «Visible». El dueño puede enviar sin fotos: se piden
  // antes de publicar (decisión de la propuesta del wizard, 20/10).
  const faltaFoto = !portada && !!operador && !!operador.visible;
  const faltaMenu = operador ? false : !tieneMenu(ficha);
  const faltaExclusion = !exclusionRespondida;
  // s235 · wizard-antes-de-enviar-orden-y-diseno (Ali): en «Antes de enviar» lo que falta va ARRIBA y lo listo debajo
  // (antes era al revés: logo, fotos y menú quedaban al final). El orden se fija al LLEGAR a la pantalla: si se
  // recalculara en cada tecla, una tarjeta saltaría de lugar mientras el dueño la llena.
  const [faltabaAlLlegar, setFaltabaAlLlegar] = useState(null);
  useEffect(() => {
    if (pantalla !== 6) { setFaltabaAlLlegar(null); return; }
    setFaltabaAlLlegar(f => f || new Set([
      !operador && !logoUrl && "logo", !portada && "fotos", faltaMenu && "menu", !esencial.trim() && "esencial", faltaExclusion && "excl",
    ].filter(Boolean)));
  }, [pantalla, operador, logoUrl, portada, faltaMenu, esencial, faltaExclusion]);
  // `order` en la lista (flex en columna): -2 = lo obligatorio que falta, primero · -1 = lo opcional que falta · 1 = abajo
  // con lo listo. El orden del HTML no cambia.
  const ordenItem = (clave) => ({ order: !(faltabaAlLlegar && faltabaAlLlegar.has(clave)) ? 1
    : clave === "excl" || (clave === "fotos" && faltaFoto) ? -2 : -1 });
  const menuLinkLimpio = menuLink.trim() ? (/^https?:\/\//i.test(menuLink.trim()) ? menuLink.trim().replace(/^http:\/\//i, "https://") : `https://${menuLink.trim()}`) : "";   // s233 · http → https

  const enviarOperador = async () => {
    const a = avance.current;
    if (faltaFoto || faltaExclusion || enviando || cola.length || a.bloqueado) return;
    setEnviando(true); setError("");
    const imagenesOperador = new Map();   // s227 · cada foto se lee una vez
    let paso = "seed";
    try {
      if (!a.merchant) {
        const primera = ofertas[0];
        const r = await operador.sembrar({
          offer_title_es: primera ? primera.titulo : "",
          benefit_value_usd: primera ? (primera.tipo === "std" ? primera.tamano?.monto : primera.tipo === "pct" ? primera.tope : precioNum) : 0,
          min_consumption: primera && primera.tipo === "std" ? primera.tamano?.minimo : 0,
        });
        a.merchant = r;
        setSembrado(r);
        // Si Bubble igual creó una oferta, el cambio de seed_merchant no está en esta versión: se para aquí para no
        // dejar una estándar de más al lado de las del wizard.
        if (r && r.offer_id) { paso = "seed_con_oferta"; a.bloqueado = true; throw Object.assign(new Error("SEED_CON_OFERTA"), { code: "SEED_CON_OFERTA" }); }
      }
      const mid = a.merchant.merchant_id;
      paso = "ofertas";
      for (let i = a.creadas; i < ofertas.length; i += 1) {
        const o = ofertas[i];
        const p = {
          merchant_id: mid, offer_title_es: o.titulo,
          valid_days: o.dias.join(","), valid_time_start: o.ini, valid_time_end: o.fin,
          cooldown_days: plazoFinal, redemption_channel: canalFinal,
        };
        if (o.tipo === "std") Object.assign(p, { benefit_value_usd: o.tamano.monto, min_consumption: o.tamano.minimo });
        else if (o.tipo === "pct") Object.assign(p, { offer_type: "percent", discount_pct: pctNum, benefit_value_usd: o.tope });
        // s236 · el 2×1 vuelve a su lugar: desde s227 el `else` quedó pegado a `if (foto)` y toda oferta SIN foto (estándar
        // o porcentaje) viajaba como bogo. El wizard de la consola está apagado (SIEMBRA_CON_WIZARD), por eso no se vio.
        else Object.assign(p, { offer_type: "bogo", unit_price: precioNum, is_alcohol: !!platoAlcohol });
        // s227 · `wizard-foto-por-oferta-consola` (export 138): la foto de ESTA oferta (la elegida, o la portada), en el
        // mismo formato que create_offer. Las fotos ya pasaron por el encuadre (WebP, s206). Sin foto no viaja.
        const foto = fotoDe(o);
        if (foto) {
          if (!imagenesOperador.has(foto)) imagenesOperador.set(foto, await imagenParaCrearOferta(foto).catch(() => null));
          const image = imagenesOperador.get(foto);
          if (image) p.image = image;
        }
        // s224 · export 133: las reglas, las mismas que manda el alta del dueño a create_offer (con lo que no entra).
        // Van en español: es el campo `rules_text_es`.
        p.rules_text_es = reglasWizard(elegido, categoria, false, canalFinal, exclusionEs);
        await operatorAddOffer(p);
        a.creadas = i + 1;
      }
      paso = "ficha";
      if (!a.fichaOk) {
        const cambios = { ...respuestas("operador") };
        if (menuLinkLimpio) cambios.menu_url = menuLinkLimpio;
        if (menuArchivo) cambios.menu_file = menuArchivo;
        await guardarFicha(cambios, mid, { recienSembrado: true });
        a.fichaOk = true;
      }
      paso = "fotos";
      for (let i = a.fotos; i < fotos.length; i += 1) {
        await operatorAddPhoto(mid, fotos[i]);
        a.fotos = i + 1;
      }
      paso = "estado";
      if (operador.visible && !a.estadoOk) {
        await operatorSetBetaState(mid, "visible");
        a.estadoOk = true;
      }
      operador.alTerminar({ merchant: a.merchant, creadas: a.creadas, fotos: a.fotos });
    } catch (e) {
      const base = e.mensaje || mensajeMenu(e.code, en) || mensajeLoteBC(e.code, en) || e.message || t("Algo falló.", "Something failed.");
      const nombre = negocio || t("el comercio", "the business");
      const texto = !a.merchant
        ? base
        : paso === "seed_con_oferta"
        ? t(`Se sembró «${nombre}», pero Bubble le creó una oferta estándar: seed_merchant todavía exige la oferta en esta versión. No se crearon las del wizard. Corrígela desde la lista o descártala.`,
            `«${nombre}» was seeded, but Bubble created a standard offer for it: seed_merchant still requires the offer in this version. The wizard offers weren't created. Fix it from the list or discard it.`)
        : paso === "ofertas"
        ? t(`Se sembró «${nombre}» y salieron ${a.creadas} de ${ofertas.length} ofertas. Falló la de ${etiquetaMomento(ofertas[a.creadas].momento).toLowerCase()}: ${base} «Reintentar» sigue desde ahí, sin volver a sembrar.`,
            `«${nombre}» was seeded and ${a.creadas} of ${ofertas.length} offers went out. The ${etiquetaMomento(ofertas[a.creadas].momento).toLowerCase()} one failed: ${base} «Retry» picks up from there, without seeding again.`)
        : paso === "ficha"
        ? t(`Se sembró «${nombre}» con sus ofertas, pero no se guardaron las respuestas ni el menú: ${base} «Reintentar» sigue desde ahí.`,
            `«${nombre}» was seeded with its offers, but the answers and the menu weren't saved: ${base} «Retry» picks up from there.`)
        : paso === "fotos"
        ? t(`Se sembró «${nombre}» con sus ofertas; subieron ${a.fotos} de ${fotos.length} fotos: ${base} «Reintentar» sigue con las que faltan.`,
            `«${nombre}» was seeded with its offers; ${a.fotos} of ${fotos.length} photos went up: ${base} «Retry» goes on with the rest.`)
        : t(`Se sembró «${nombre}» completo, pero no quedó Visible: ${base} «Reintentar» lo intenta otra vez.`,
            `«${nombre}» was fully seeded, but it isn't Visible: ${base} «Retry» tries again.`);
      setError(texto);
    } finally {
      setEnviando(false);
    }
  };

  const enviar = async () => {
    if (operador) { await enviarOperador(); return; }
    // s228 · el menú ya no frena el envío. s235 (Ali) · las fotos tampoco: se piden antes de publicar (sin foto la oferta no
    // sale en el catálogo, y el panel muestra «Fotos en camino»). `image` es opcional en create_offer.
    if (faltaExclusion || enviando || cola.length) return;
    setEnviando(true); setError("");
    // s227 · cada oferta con su foto (create_offer recibe `image` en cada llamada). Se lee una vez por foto distinta.
    const imagenes = new Map();
    for (const f of new Set(ofertas.map(fotoDe))) if (f) imagenes.set(f, await imagenParaCrearOferta(f).catch(() => null));
    if ([...imagenes.values()].some(im => !im)) { setEnviando(false); setError(t("No pudimos leer una de las fotos. Elige otra.", "We couldn't read one of the photos. Pick another one.")); return; }
    const aplicaA = alcanceWizard;   // s239 · D6 · s255 · sin bebidas, «Aplica a la comida.»
    const reglas = reglasWizard(elegido, categoria, en, canalFinal, exclusion);
    let creadas = 0;
    try {
      for (const o of ofertas) {
        const base = o.tipo === "bogo"
          // s223 · el plato lo escribe el dueño en singular o plural: la frase no puede depender de eso.
          ? t(`2×1 en ${plato.trim()}: pides dos y pagas uno.`, `2-for-1 on ${plato.trim()}: order two, pay for one.`)
          : aplicaA;
        const descripcion = esencial.trim() ? `${base} ${esencial.trim()}` : base;   // s234 · sobre-esta-oferta-alta-normal
        const p = {
          title: o.titulo, title_es: o.titulo, title_en: o.titulo,
          description: descripcion, description_es: descripcion, description_en: descripcion,
          rules_text: reglas, rules_text_es: reglas, rules_text_en: reglas,
          source_lang: en ? "en" : "es",
          created_by_ai: "no",
          category: categoria,
          coupon_price: 0, typical_savings: 0,
          valid_days: o.dias.join(","), valid_time_start: o.ini, valid_time_end: o.fin,
          // s239 · W16: los destacados del resumen (los trae la lectura de la web; el dueño los puede cambiar). Antes, vacíos.
          highlight_1: destacados[0].trim(), highlight_2: destacados[1].trim(), highlight_3: destacados[2].trim(),
          cooldown_days: plazoFinal,
          redemption_channel: canalFinal,
          image: fotoDe(o) ? imagenes.get(fotoDe(o)) : undefined,   // sin foto: no viaja (JSON.stringify la quita)
        };
        if (o.tipo === "std") Object.assign(p, {
          offer_type: UMBRAL_TIPO, is_alcohol: false, unit_price: 0, discount_pct: 0,
          benefit_value_usd: o.tamano.monto, min_consumption: o.tamano.minimo, regular_price: o.tamano.minimo,
        });
        else if (o.tipo === "pct") Object.assign(p, {
          offer_type: "percent", is_alcohol: false, unit_price: 0, discount_pct: pctNum, min_consumption: 0,
          benefit_value_usd: o.tope, regular_price: precioRegularDePct(o.tope, pctNum),
        });
        // 2×1: el miembro paga uno y se lleva dos. regular_price = los dos platos (approve_offer pide > 0 y que el
        // beneficio no lo supere); el beneficio = un plato.
        else Object.assign(p, {
          offer_type: "bogo", is_alcohol: !!platoAlcohol, discount_pct: 0, min_consumption: 0,
          unit_price: precioNum, benefit_value_usd: precioNum, regular_price: precioRegularDe2x1(precioNum),
        });
        await crearOfertaWf(p);
        creadas += 1;
      }
      // s224 · `wizard-guardar-respuestas`: las respuestas a la ficha, con guardarFicha sin merchant_id (lee la ficha y
      // manda el juego completo: el menú recién cargado no se borra). Las ofertas ya salieron: si esto falla, no se le
      // dice nada al dueño (no es suyo resolverlo); queda en la consola del navegador.
      try { await guardarFicha(respuestas("dueno")); } catch (e) { console.warn("wizard_json no guardado", e?.code || e?.message); }
      let fallidas = 0;
      for (const f of fotos.slice(0, cabenGaleria)) {
        try { await agregarFotoComercio(f); } catch (e) { fallidas += 1; }
      }
      onEnviada(creadas, fallidas
        ? t(`${fallidas === 1 ? "Una foto no se pudo" : `${fallidas} fotos no se pudieron`} agregar a tu galería. Súbelas desde Perfil.`,
            `${fallidas === 1 ? "One photo" : `${fallidas} photos`} couldn't be added to your gallery. Upload them from Profile.`)
        : "");
    } catch (e) {
      const base = (e.code === "TOO_MANY_OFFERS" ? mensajeTopeDueno(en) : mensajeLoteBC(e.code, en)) || e.message || t("No pudimos enviar tu oferta.", "We couldn't send your offer.");
      setError(creadas > 0
        ? t(`Se enviaron ${creadas} de ${ofertas.length} ofertas. La de ${etiquetaMomento(ofertas[creadas].momento).toLowerCase()} falló: ${base} No vuelvas a enviar las que ya salieron: las ves en Mis ofertas.`,
            `${creadas} of ${ofertas.length} offers were sent. The ${etiquetaMomento(ofertas[creadas].momento).toLowerCase()} one failed: ${base} Don't resend the ones that went out: you'll see them in My offers.`)
        : base);
    } finally {
      setEnviando(false);
    }
  };

  // ---------------- PANTALLA 0 · EL ARRANQUE (§1) ----------------
  // s230 · wizard-intro-enamorar: la intro era tres párrafos y un botón. Ahora enseña el resultado antes de pedir el
  // esfuerzo (la tarjeta del catálogo del propio negocio, con una oferta de ejemplo), un titular con la promesa, la
  // prueba social del catálogo cerrado y «qué vas a necesitar». Referencias: Monzo, Zopa, Airbnb (UX_s230).
  // s227 · con 2+ ofertas y 2+ fotos se elige la foto de cada una: el dueño (create_offer) y, desde el export 138,
  // también Otto en la consola (operator_add_offer, param `image`).
  const eligeFoto = ofertas.length > 1 && fotos.length > 1;
  // s235 · wizard «Tu negocio en el club» (propuesta s235, fase 1): logo, fotos, menú y «Cómo te presentamos» se piden
  // AL PRINCIPIO (pantalla 7, solo el dueño) y se repiten en «Antes de enviar» (pantalla 6) para revisarlos. Una sola
  // copia del JSX para las dos pantallas.
  // s239 · W6: «Cómo te presentamos» sale de la pantalla 7 (la llena la lectura de la web, W16) y queda en el resumen.
  // s255 · menu-desde-la-web (Ali: «le acabas de pedir la página web… aquí vuelves a pedírsela»): el menú pregunta por la web
  // que el dueño ya dio en el wizard (antes solo miraba la del Perfil al abrir, y una web escrita aquí no llegaba). Instagram
  // no cuenta como web del menú.
  const webEscrita = linkLeible(webNegocio);
  // s255 · alta-datos-de-la-web: si la IA encontró la página del menú, se pregunta por esa (no por la home).
  const webParaMenu = datosWeb?.datos?.menu_url
    || (webEscrita && campoDeLaWeb(webEscrita) === "website" ? webEscrita : (perfil?.website || ""));
  const bloquesContenido = ({ conEsencial = true } = {}) => (
    <>
      {!operador && (
        <ItemChecklist ok={!!logoUrl} opcional estilo={ordenItem("logo")} icono="ico-cuenta" en={en} titulo={t("Tu logo (opcional)", "Your logo (optional)")}>
          <div className="alta-ayuda">
            {t("Va en el círculo de tu ficha y de tus ofertas. Súbelo aquí, no como foto del negocio. Si no lo tienes a mano, puedes enviar sin logo y subirlo después en Perfil.",
               "It goes in the circle on your page and your offers. Upload it here, not as a business photo. If you don't have it handy, you can send without it and add it later in Profile.")}
          </div>
          <div className="alta-wiz__logo">
            {logoUrl && <img src={String(logoUrl).startsWith("//") ? `https:${logoUrl}` : logoUrl} alt={t("Tu logo", "Your logo")} className="alta-wiz__logo-muestra" />}
            {!sembrado && (
              <ZonaSubida id="wiz-logo" icono="ico-cuenta" accept="image/jpeg,image/png,image/webp" disabled={subiendoLogo} onChange={elegirLogo}
                texto={logoUrl ? t("Cambiar el logo", "Change the logo") : t("Subir el logo", "Upload the logo")}
                nota={t("PNG, JPG o WebP, cuadrado", "PNG, JPG or WebP, square")} />
            )}
          </div>
          {/* s255 · alta-logo-desde-web: el logo que trajo la lectura de la web, solo si todavía no hay logo. Se ofrece, no se
              pone solo (como en la siembra): el dueño revisa que sea su logo y no una foto. */}
          {!logoUrl && !sembrado && !logoPorEncuadrar && logoWeb && (
            <div className="alta-wiz__logo-web">
              <img src={logoWeb.muestra} alt={t("Logo de tu web", "Logo from your website")} className="alta-wiz__logo-muestra" />
              <div className="alta-wiz__logo-web-texto">
                <strong>{t("Encontramos este logo en tu web", "We found this logo on your website")}</strong>
                <span>{t("Revisa que sea tu logo y no una foto.", "Check it's your logo and not a photo.")}</span>
              </div>
              <button type="button" className="alta-wiz__logo-web-usar" disabled={subiendoLogo} onClick={usarLogoDeLaWeb}>
                {t("Usar este logo", "Use this logo")}
              </button>
            </div>
          )}
          {subiendoLogo && <div className="alta-ayuda" role="status">{t("Guardando el logo…", "Saving the logo…")}</div>}
          {avisoLogo && !subiendoLogo && <div className="alta-ayuda" role="status">{avisoLogo}</div>}
          {logoPorEncuadrar && (
            <EncuadrarFoto key={`wiz-logo-${logoPorEncuadrar.name}-${logoPorEncuadrar.size}`} file={logoPorEncuadrar}
              proporcion={1} ladoMax={512} ladoMin={LOGO_LADO_MIN} en={en}
              tipoSalida={logoPorEncuadrar.type === "image/png" ? "image/png" : "image/jpeg"}
              titulo={t("Encuadra tu logo", "Frame your logo")}
              onListo={subirLogo} onCancelar={() => setLogoPorEncuadrar(null)} />
          )}
        </ItemChecklist>
      )}
      <ItemChecklist id="wiz-chk-fotos" marcar={marcarFalta === "wiz-chk-fotos"} ok={!!portada} opcional={!faltaFoto} estilo={ordenItem("fotos")} icono="ico-camara" en={en} titulo={t("Fotos de tu negocio", "Photos of your business")}>
        <div className="alta-ayuda">
          {/* s239 · W5: un flyer con texto queda debajo de la frase de la oferta en la tarjeta y se pisan (prueba local s239). */}
          {t(`Sube hasta ${maxFotos} fotos de tu negocio: ${perfilRubro.fotosDe.es}. Mejor fotos reales, sin texto ni promociones encima: la tarjeta ya pone tu oferta.`,
             `Upload up to ${maxFotos} photos of your business: ${perfilRubro.fotosDe.en}. Real photos work best, with no text or promos on top: the card already shows your offer.`)}
          {!operador && <> {t("El logo no va aquí: va en «Tu logo».", "The logo doesn't go here: it goes in “Your logo”.")}</>}
          {ofertas.length > 1
            ? <> {t("Todas van a la galería de tu ficha; después eliges qué foto lleva cada oferta.", "They all go to your page's gallery; then you pick which photo each offer gets.")}</>
            : <> {t("Todas van a la galería de tu ficha; la primera es la portada de tu oferta.", "They all go to your page's gallery; the first is your offer's cover.")}</>}
          {!portada && (operador
            ? <> {t("Sin foto, la oferta no sale en el catálogo.", "Without a photo, the offer doesn't show in the catalog.")}</>
            : <> {t("Puedes enviar sin fotos: las necesitamos antes de publicar tu oferta (sin foto no sale en el catálogo).", "You can send without photos: we need them before publishing your offer (without a photo it doesn't show in the catalog).")}</>)}
          {operador && <> {t("También vale la que pegas arriba con Ctrl+V. Para dejarlo Visible hace falta al menos una.", "The one you paste above with Ctrl+V counts too. To make it Visible you need at least one.")}</>}
          {/* s228 · la consola siembra sin logo (s215); el logo va después, desde la lista. Se dice aquí para que no
              lo suba como foto del negocio. */}
          {operador && <> {t("El logo no va aquí: después de sembrar, en la lista, «Fotos» → «+ Agregar logo». O lo sube el dueño desde su panel.",
                             "The logo doesn't go here: after seeding, in the list, “Photos” → “+ Add logo”. Or the owner uploads it from their panel.")}</>}
        </div>
        {fotos.length > 0 && (
          <div className="alta-wiz__fotos">
            {fotos.map((f, i) => (
              <MiniaturaFotoWizard key={`${f.name}-${f.size}-${i}`} file={f} portada={i === 0} en={en} fija={!!sembrado}
                onQuitar={() => setFotos(fs => fs.filter((_, j) => j !== i))}
                onPortada={() => setFotos(fs => [fs[i], ...fs.filter((_, j) => j !== i)])} />
            ))}
          </div>
        )}
        {fotos.length + cola.length < maxFotos && !sembrado && (
          <ZonaSubida id="wiz-foto" icono="ico-camara" accept="image/*" multiple onChange={elegirFotos}
            ariaLabel={t("Fotos de tu negocio", "Photos of your business")}
            texto={fotos.length ? t("Agregar más fotos", "Add more photos") : t("Agregar fotos", "Add photos")}
            nota={t(`${fotos.length + cola.length} de ${maxFotos} · puedes elegir varias a la vez`, `${fotos.length + cola.length} of ${maxFotos} · you can pick several at once`)} />
        )}
        {avisoFotos && <div className="alta-ayuda" role="status">{avisoFotos}</div>}
        {eligeFoto && !cola.length && (
          <div className="alta-wiz__siguiente" role="status">
            <span>{t("Ahora elige la foto de cada oferta: arriba, debajo de cada vista previa.", "Now pick the photo for each offer: above, under each preview.")}</span>
            <button type="button" className="alta-wiz__cambiar" onClick={irAFotoDeOferta}>{t("Elegir fotos ↑", "Pick photos ↑")}</button>
          </div>
        )}
        {cola.length > 0 && (
          <EncuadrarFoto key={`wiz-${cola[0].name}-${cola[0].size}-${cola.length}`} file={cola[0]} proporcion={1} en={en}
            titulo={cola.length > 1 ? t(`Encuadra la foto (quedan ${cola.length})`, `Frame the photo (${cola.length} left)`) : t("Encuadra la foto", "Frame the photo")}
            onListo={(f) => { setFotos(fs => [...fs, f]); setCola(c => c.slice(1)); }}
            onCancelar={() => setCola(c => c.slice(1))} />
        )}
      </ItemChecklist>
      {operador ? (
        <ItemChecklist id="wiz-chk-menu" ok icono="ico-tarjeta" en={en} titulo={etiquetaMenu(categoria, en)}>
          <div className="alta-ayuda">{t("Opcional aquí: se guarda al sembrar. Si no lo tienes, lo carga el dueño cuando confirme.", "Optional here: it's saved when seeding. If you don't have it, the owner adds it when confirming.")}</div>
          <label htmlFor="wiz-menu-link" className="alta-etiqueta" style={{ display: "block", marginTop: 6 }}>Link</label>
          <input id="wiz-menu-link" className="alta-input" type="url" inputMode="url" placeholder="https://"
            value={menuLink} onChange={e => setMenuLink(e.target.value)} disabled={!!sembrado} />
          {(() => { const sitio = sitioDelComercio(perfil?.website); return sitio && menuLink.trim() !== sitio.url && !sembrado
            ? <BotonUsarMiPagina sitio={sitio} en={en} onUsar={setMenuLink} /> : null; })()}
          <label htmlFor="wiz-menu-archivo" className="alta-etiqueta" style={{ display: "block", marginTop: 8 }}>{t("O una foto / PDF", "Or a photo / PDF")}</label>
          <ZonaSubida id="wiz-menu-archivo" icono="ico-tarjeta" accept="image/*,application/pdf" disabled={!!sembrado}
            onChange={e => setMenuArchivo((e.target.files && e.target.files[0]) || null)}
            texto={menuArchivo ? menuArchivo.name : t("Subir foto o PDF del menú", "Upload a photo or PDF of the menu")}
            nota={menuArchivo ? t("Toca para cambiarlo", "Tap to change it") : t("Una foto con el celular alcanza", "A phone photo is enough")} />
        </ItemChecklist>
      ) : (
        <ItemChecklist id="wiz-chk-menu" ok={!faltaMenu} opcional etiquetaOpcional={t("Puede ir después", "Can wait")} estilo={ordenItem("menu")} icono="ico-tarjeta" en={en} titulo={etiquetaMenu(categoria, en)}>
          {ficha === undefined && <div className="alta-ayuda">{t("Cargando…", "Loading…")}</div>}
          {ficha !== undefined && faltaMenu && <div className="alta-ayuda">{t("Puedes enviar sin él: lo necesitamos antes de publicar tu oferta. Sirve un link o una foto con el celular.",
            "You can send without it: we need it before publishing your offer. A link or a phone photo works.")}</div>}
          {ficha !== undefined && !faltaMenu && <div className="alta-ayuda">{t("Ya lo tienes cargado.", "It's already uploaded.")}</div>}
          {ficha !== undefined && faltaMenu && (
            <>
              {/* MenuDelComercio ya trae su «El miembro lo mira antes de ir»: no se repite. */}
              <MenuDelComercio idBase="wiz-menu" en={en} categoria={categoria} ficha={ficha || {}} sitioWeb={webParaMenu}
                onGuardado={async (nueva) => { if (nueva) setFicha(nueva); else if (perfil?.merchant_id) setFicha(await leerFicha(perfil.merchant_id).catch(() => null)); }} />
            </>
          )}
        </ItemChecklist>
      )}
      {/* s234 · sobre-esta-oferta-alta-normal: lo que lee el miembro en «Sobre esta oferta». Opcional: sin texto queda la
          frase de siempre («Aplica a toda la cuenta.»). */}
      {conEsencial && LECTURA_EN_PANTALLA && lectura.estado === "leyendo" && (
        <div className="alta-ayuda" role="status">{t("Todavía estamos leyendo tu web. Si termina antes de que envíes, lo que encontremos aparece aquí; si no, envía igual.",
          "We're still reading your website. If it finishes before you send, what we find shows up here; if not, send anyway.")}</div>
      )}
      {conEsencial && <ItemChecklist id="wiz-chk-esencial" ok={!!esencial.trim()} opcional estilo={ordenItem("esencial")} icono="ico-tarjeta" en={en} titulo={t("Cómo te presentamos (opcional)", "How we introduce you (optional)")}>
        {deLaWeb.esencial && <div className="alta-wiz__de-la-web">{t("De tu web · cámbialo si quieres", "From your website · change it if you like")}</div>}
        <div className="alta-ayuda">{t("Dos o tres frases: qué es tu lugar y qué no se pueden perder. Es lo que lee el miembro en tu oferta.", "Two or three sentences: what your place is and what members shouldn't miss. It's what members read on your offer.")}</div>
        <textarea id="wiz-esencial" className="alta-textarea" rows={3} value={esencial} disabled={!!sembrado}
          onChange={e => { setEsencial(e.target.value); setDeLaWeb(d => ({ ...d, esencial: false })); }} style={{ marginTop: 8 }}
          placeholder={t("Ej: Cocina peruana de mar en Doral. Pide el ceviche clásico y el lomo saltado.", "E.g.: Peruvian seafood in Doral. Order the classic ceviche and the lomo saltado.")}
          aria-label={t("Cómo te presentamos", "How we introduce you")} />
      </ItemChecklist>}
      {/* s239 · W16: los destacados que trajo la lectura de la web (create_offer los recibe; antes iban vacíos). */}
      {conEsencial && destacados.some(x => x.trim()) && (
        <ItemChecklist id="wiz-chk-destacados" ok opcional icono="ico-destacado" en={en} titulo={t("Lo que destacamos", "What we highlight")}>
          {deLaWeb.destacados && <div className="alta-wiz__de-la-web">{t("De tu web · cámbialo si quieres", "From your website · change it if you like")}</div>}
          {destacados.map((d, i) => (
            <input key={i} className="alta-input" style={{ marginTop: 6 }} maxLength={80} value={d} disabled={!!sembrado}
              aria-label={t(`Destacado ${i + 1}`, `Highlight ${i + 1}`)}
              onChange={e => { const v = e.target.value; setDestacados(a => a.map((x, j) => (j === i ? v : x))); setDeLaWeb(w => ({ ...w, destacados: false })); }} />
          ))}
        </ItemChecklist>
      )}
    </>
  );

  // s254 · P8 (Ali + Otto, maqueta «Bienvenida»): el saludo va en una banda azul con letras fuertes (no tenue sobre
  // tenue); debajo, la tarjeta «Así te verán» y lo que va a hacer, con íconos de color.
  if (pantalla === 0) return (
    <div className="alta-forma alta-wiz alta-wiz--intro">
      <div className="alta-wiz__banda">
        {!operador && nombreDueno && <div className="alta-wiz__banda-ojo">{t(`Hola, ${nombreDueno}`, `Hi, ${nombreDueno}`)}{negocio ? ` · ${negocio}` : ""}</div>}
        <div className="alta-wiz__saludo alta-wiz__saludo--banda">{t("Tu primera oferta, lista en 3 minutos", "Your first offer, ready in 3 minutes")}</div>
        <p className="alta-wiz__texto alta-wiz__texto--banda">
          {/* s239 · W2/W3: se saluda a la persona; una sola promesa: la envía el dueño y la revisa el equipo. */}
          {!operador && !nombreDueno && negocio ? t(`Hola, ${negocio}. `, `Hi, ${negocio}. `) : ""}
          {pre.hayHorario || precioG
            ? t("Cinco preguntas cortas. Muchas ya las respondimos con lo que sabemos de tu negocio. ", "Five short questions. We already answered many with what we know about your business. ")
            : t("Cinco preguntas cortas y la ves tal como la verá el miembro. ", "Five short questions and you see it just as members will. ")}
          {operador
            ? t("No se publica hasta que el dueño la confirme.", "Nothing goes live until the owner confirms it.")
            : t("No se publica hasta que la envíes y la revisemos.", "Nothing goes live until you send it and we review it.")}
        </p>
        {enCamino >= 3 && (
          <div className="alta-wiz__prueba alta-wiz__prueba--banda" role="status">
            <Ico name="ico-personas" size={18} />
            <span>{t(`${enCamino} comercios de Miami ya están en camino`, `${enCamino} Miami businesses are on their way`)}</span>
          </div>
        )}
      </div>
      <div className="alta-wiz__hero" aria-hidden="true">
        <div className="alta-wiz__hero-tarjeta">
          {/* s239 · W1: la tarjeta decía «Ahorra $15 cuando gastas $30» para todos. Ahora es la oferta que el wizard va a
              recomendar (ofertaDeIntro): con el precio de Google, el tamaño de la regla 3; en salones y «Hecho a pedido», el
              porcentaje; sin datos, el tamaño de entrada del rubro, y la etiqueta dice que es un ejemplo. */}
          {/* s255 (Ali) · la vista previa es la tarjeta de la vitrina (variante «catalogo»): nombre, el %, qué y zona. */}
          <OfferCard sinGuardar variante="catalogo" nombreComercio={negocio}
            etiqueta={g ||RUBROS_PCT_RECOMENDADO.includes(categoria) || !PRIMERA_CON_MONTO_FIJO ? t("Así te verán", "How they'll see you") : t("Ejemplo · así te verán", "Example · how they'll see you")}
            offer={{ _id: "wiz-intro", merchant_name: negocio, category: categoria,
              neighborhood: perfil?.neighborhood || perfil?.city || "", image: perfil?.cover_url || "", merchant_logo: logoUrl || "",
              unit_price: 0, valid_days: FEED_DAY_TOKENS.join(","), valid_time_start: "", valid_time_end: "", cooldown_days: 15,
              ...ofertaDeIntro(categoria, g ? g.porPersona : 0, tipoNegocio) }} />
        </div>
      </div>
      <div className="alta-wiz__necesitas-titulo">{t("Lo que vas a hacer", "What you'll do")}</div>
      <ul className="alta-wiz__necesitas" aria-label={t("Lo que vas a hacer", "What you'll do")}>
        {/* s255 · `primera-oferta-sin-ticket`: la pregunta del ticket ya no está en la primera oferta. */}
        {PRIMERA_CON_MONTO_FIJO && <li>
          <span className="alta-wiz__necesitas-icono alta-wiz__necesitas-icono--naranja" aria-hidden="true"><Ico name="ico-tarjeta" size={22} /></span>
          <span><b>{t("Cuánto gasta una persona", "What one person spends")}</b><span>{t("Con eso armamos el tamaño de tu oferta.", "We size your offer with it.")}</span></span>
        </li>}
        <li>
          <span className="alta-wiz__necesitas-icono alta-wiz__necesitas-icono--azul" aria-hidden="true"><Ico name="ico-calendario" size={22} /></span>
          <span><b>{t("Qué días y a qué hora", "Which days and times")}</b><span>{t("Cuándo quieres más clientes.", "When you want more customers.")}</span></span>
        </li>
        <li>
          <span className="alta-wiz__necesitas-icono alta-wiz__necesitas-icono--verde" aria-hidden="true"><Ico name="ico-camara" size={22} /></span>
          <span><b>{t("Una foto de tu local", "A photo of your place")}</b><span>{t("Si no la tienes a mano, la subes después.", "If you don't have one handy, add it later.")}</span></span>
        </li>
      </ul>
      {/* El hero empuja el botón bajo el pliegue en teléfono (1122 px): va en el pie pegado como el resto del wizard. */}
      <div className="alta-wiz__pie">
        <div className="alta-acciones">
          <span />
          <button type="button" className="alta-btn alta-btn--seguir" onClick={() => setPantalla(operador ? 1 : 7)}>{t("Comienza aquí →", "Start here →")}</button>{/* s254 · P1 */}
        </div>
      </div>
    </div>
  );

  // ---------------- PANTALLA 7 · TU NEGOCIO EN EL CLUB (s235, solo el dueño) ----------------
  // Propuesta s235 (research: Airbnb pide las fotos en el paso 2 de 3; DoorDash arranca por la web y el menú): lo que hace
  // que un miembro elija el lugar va primero, con la tarjeta llenándose arriba. Nada es obligatorio aquí: fotos y menú se
  // piden antes de publicar (decisión de Ali, 20/10). La IA para el dueño es la fase 2.
  if (pantalla === 7) return (
    <div className="alta-forma alta-wiz">
      <div className="alta-wiz__pregunta">{t("Tu negocio en el club", "Your business in the club")}</div>
      <div className="alta-ayuda">{t("Lo que hace que un miembro te elija: tus fotos, tu logo y tu menú. Súbelo ahora o después: no se publica hasta que la envíes y la revisemos.",
        "What makes a member pick you: your photos, your logo and your menu. Upload it now or later: nothing goes live until you send it and we review it.")}</div>
      {/* s239 · W16 (Ali): la web primero, para que la lectura corra mientras responde las cinco preguntas. */}
      <div className="alta-campo" style={{ marginTop: 12 }}>
        <label htmlFor="wiz-web" className="alta-etiqueta">{t("¿Dónde te encontramos en internet?", "Where can we find you online?")}</label>
        <input id="wiz-web" className="alta-input" type="url" inputMode="url" value={webNegocio} disabled={!!sembrado}
          onChange={e => setWebNegocio(e.target.value)} placeholder={t("Tu web, Instagram, Booksy, Toast…", "Your website, Instagram, Booksy, Toast…")} />
        <div className="alta-ayuda">{webNegocio.trim() && !LECTURA_EN_PANTALLA
          ? t("La guardamos con tu ficha para conocer tu negocio. Tu oferta la armas con las preguntas que siguen.", "We save it with your profile to get to know your business. You build your offer with the questions that follow.")
          : webNegocio.trim()
          ? t("La leemos mientras respondes las preguntas: al final te proponemos cómo presentar tu negocio, y lo cambias si quieres.", "We read it while you answer the questions: at the end we suggest how to introduce your business, and you can change it.")
          : sinWeb
          ? t("Marcaste que no tienes web. Si ahora tienes una, pégala arriba.", "You said you don't have a website. If you have one now, paste it above.")
          : t("Si no tienes, déjalo vacío: lo completas tú al final.", "If you don't have one, leave it blank: you fill it in at the end.")}</div>
        {!webNegocio.trim() && !sembrado && (
          <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer", marginTop: 8 }}>
            <input type="checkbox" checked={sinWeb} onChange={e => setSinWeb(e.target.checked)} />
            {t("No tengo web", "I don't have a website")}
          </label>
        )}
      </div>
      {/* s241 · T4 · sin web, lo que tenga: vale como la web para la descripción (y para la siembra si la hace Otto). */}
      {!webNegocio.trim() && !sembrado && (
        <div className="alta-campo">
          <label htmlFor="wiz-texto-negocio" className="alta-etiqueta">{t("Cuéntanos de tu negocio", "Tell us about your business")}</label>
          <textarea id="wiz-texto-negocio" className="alta-input" rows={4} maxLength={TEXTO_NEGOCIO_MAX} value={textoNegocio}
            onChange={e => setTextoNegocio(e.target.value)}
            placeholder={t("Copia y pega tu menú, tu lista de servicios o lo que pones en Instagram", "Copy and paste your menu, your list of services or what you post on Instagram")} />
        </div>
      )}
      <div className="alta-wiz__hero alta-wiz__hero--negocio" aria-hidden="true">
        <div className="alta-wiz__hero-tarjeta">
          {/* s239 · W1 también aquí: la oferta que se va a recomendar, no $15/$30 fijo. */}
          <OfferCard sinGuardar variante="catalogo" etiqueta={g ||RUBROS_PCT_RECOMENDADO.includes(categoria) || !PRIMERA_CON_MONTO_FIJO ? t("Así te verán", "How they'll see you") : t("Ejemplo · así te verán", "Example · how they'll see you")} nombreComercio={negocio}
            offer={{ _id: "wiz-negocio", merchant_name: negocio, category: categoria,
              neighborhood: perfil?.neighborhood || perfil?.city || "", image: urlDe(portada) || perfil?.cover_url || "", merchant_logo: logoUrl || "",
              unit_price: 0, valid_days: FEED_DAY_TOKENS.join(","), valid_time_start: "", valid_time_end: "", cooldown_days: 15,
              ...ofertaDeIntro(categoria, g ? g.porPersona : 0, tipoNegocio) }} />
        </div>
      </div>
      <ul className="alta-wiz__checklist">
        {bloquesContenido({ conEsencial: false })}
      </ul>
      <div className="alta-wiz__pie">
        <div className="alta-acciones">
          <button type="button" className="alta-btn alta-btn--atras" onClick={atras}>← {t("Atrás", "Back")}</button>
          <button type="button" className="alta-btn alta-btn--seguir" onClick={() => ir(1)} disabled={cola.length > 0}>
            {portada || logoUrl || !faltaMenu || esencial.trim() || webNegocio.trim() ? t("Seguir →", "Next →") : t("Lo subo después →", "I'll add it later →")}
          </button>
        </div>
      </div>
    </div>
  );

  // ---------------- PANTALLA 6 · VISTA PREVIA Y CHECKLIST ----------------
  if (pantalla === 6) {
    // s228 · revisión con Fable: el menú frena la PUBLICACIÓN (approve_offer → MENU_REQUIRED), no el envío. Sale de la cuenta
    // y de lo que falta; su tarjeta queda como opcional con aviso. En la consola ya era opcional.
    // s235 · las fotos cuentan en el avance, pero solo frenan el envío en la consola con «Visible» (`faltaFoto`).
    const listos = [true, true, true, true, !!portada, !faltaExclusion];
    const hechos = listos.filter(Boolean).length;
    const faltan = [faltaFoto && t("las fotos", "the photos"),
      faltaExclusion && (alcoholEnReglas
        ? t("decir si algo más no entra (o «Todo lo demás entra»)", "saying if anything else is excluded (or “Everything else counts”)")
        : t("qué no entra (o «Todo entra»)", "what's excluded (or “Everything counts”)"))].filter(Boolean);
    // «las fotos, el menú y qué no entra»
    const listaFaltan = faltan.length > 1 ? `${faltan.slice(0, -1).join(", ")} ${t("y", "and")} ${faltan[faltan.length - 1]}` : (faltan[0] || "");
    const listo = !faltan.length && !cola.length;
    // s228 · «Enviar» con algo pendiente: baja a la primera tarjeta que falta y la resalta.
    const intentarEnviar = () => {
      if (listo) { setMarcarFalta(""); enviar(); return; }
      const id = faltaFoto || cola.length ? "wiz-chk-fotos" : faltaExclusion ? "wiz-chk-excl" : "";
      setMarcarFalta(id);
      const el = id && document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    };
    return (
      <div className="alta-forma alta-wiz">
        <div className="alta-wiz__pregunta">{ofertas.length > 1 ? t("Así verán tus ofertas los miembros", "This is how members will see your offers") : t("Así verán tu oferta los miembros", "This is how members will see your offer")}</div>
        <div className="alta-ayuda">{t("Revisa que todo esté bien. Nada se publica hasta que lo revisemos.", "Check that everything looks right. Nothing goes live until we review it.")}</div>
        <div className={["alta-wiz__vista", ofertas.length > 1 && "alta-wiz__vista--carrusel"].filter(Boolean).join(" ")} ref={vistaRef}>
          {ofertas.map(o => (
            <div key={o.momento.key} className="alta-wiz__vista-oferta">
            <OfferCard sinGuardar variante="catalogo" etiqueta={t("Vista previa", "Preview")} nombreComercio={negocio}
              offer={{ _id: `wiz-${o.momento.key}`, title_es: o.titulo, title_en: o.titulo, merchant_name: negocio, category: categoria,
                neighborhood: perfil?.neighborhood || perfil?.city || "", image: urlDe(fotoDe(o)), merchant_logo: logoUrl || "",
                offer_type: o.tipo === "std" ? UMBRAL_TIPO : o.tipo === "pct" ? "percent" : "bogo",
                benefit_value_usd: o.tipo === "std" ? o.tamano?.monto : o.tipo === "pct" ? o.tope : precioNum,
                min_consumption: o.tipo === "std" ? o.tamano?.minimo : 0, discount_pct: o.tipo === "pct" ? pctNum : 0,
                unit_price: o.tipo === "bogo" ? precioNum : 0, regular_price: o.tipo === "std" ? o.tamano?.minimo : 0,
                valid_days: o.dias.join(","), valid_time_start: o.ini, valid_time_end: o.fin, cooldown_days: plazoFinal }} />
            {eligeFoto && (
              <div className="alta-wiz__foto-oferta" role="group" aria-label={t(`Foto de la oferta de ${etiquetaMomento(o.momento).toLowerCase()}`, `Photo for the ${etiquetaMomento(o.momento).toLowerCase()} offer`)}>
                <div className="alta-wiz__foto-oferta-titulo">{t("Elige la foto de esta oferta", "Pick the photo for this offer")}</div>
                <div className="alta-wiz__foto-oferta-lista">
                  {fotos.map((f, i) => (
                    <button key={`${f.name}-${f.size}-${i}`} type="button" className="alta-wiz__foto-oferta-opcion"
                      aria-pressed={fotoDe(o) === f} aria-label={t(`Foto ${i + 1}`, `Photo ${i + 1}`)}
                      onClick={() => setFotoDeOferta(m => ({ ...m, [o.momento.key]: f }))}>
                      {fotoUrls[i] && <img src={fotoUrls[i]} alt="" />}
                    </button>
                  ))}
                </div>
              </div>
            )}
            </div>
          ))}
        </div>
        {/* s230 · wizard-previa-carrusel: una píldora por momento; dice cuál se ve y lleva a la otra. En escritorio las
            tarjetas van lado a lado y las píldoras no hacen falta (alta.css las esconde). */}
        {ofertas.length > 1 && (
          <div className="alta-wiz__vista-puntos" role="group" aria-label={t("Vista previa de cada oferta", "Preview of each offer")}>
            {ofertas.map((o, i) => (
              <button key={o.momento.key} type="button" aria-pressed={i === vistaActiva}
                className={["alta-wiz__vista-punto", i === vistaActiva && "alta-wiz__vista-punto--on"].filter(Boolean).join(" ")}
                onClick={() => vistaRef.current?.children[i]?.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" })}>
                {etiquetaMomento(o.momento)}
              </button>
            ))}
          </div>
        )}
        <div className="alta-wiz__avance">
          <div className="alta-wiz__pregunta" style={{ fontSize: 16 }}>{t("Antes de enviar", "Before sending")}</div>
          <div className="alta-ayuda">{t(`${hechos} de ${listos.length} listos`, `${hechos} of ${listos.length} done`)}</div>
        </div>
        <div className="alta-wiz__barra-pista"><div className="alta-wiz__barra-lleno alta-wiz__barra-lleno--exito" style={{ width: `${(hechos / listos.length) * 100}%` }} /></div>
        <ul className="alta-wiz__checklist">
          {/* s235 · lo que falta va arriba (order -1); este rótulo separa lo listo (order 0 y 1). */}
          {faltabaAlLlegar && faltabaAlLlegar.size > 0 && (
            <li className="alta-wiz__check-sep" style={{ order: 0 }} aria-hidden="true">{t("Ya está listo", "Already done")}</li>
          )}
          <ItemChecklist ok icono="ico-ahorro" en={en} titulo={ofertas.length > 1 ? t("Tus ofertas", "Your offers") : t("Tu oferta", "Your offer")} onCambiar={sembrado ? null : () => ir(4)}>
            {ofertas.map(o => <div key={o.momento.key}>{etiquetaMomento(o.momento)}: {o.frase}</div>)}
            <div className="alta-ayuda">{antesDe(perfilRubro.antesDe)}</div>
          </ItemChecklist>
          <ItemChecklist ok icono="ico-calendario" en={en} titulo={t("Días y horarios", "Days and times")} onCambiar={sembrado ? null : () => ir(3)}>
            {ofertas.map(o => <div key={o.momento.key}>{etiquetaMomento(o.momento)} {rango12(o.ini, o.fin, en)} · {textoDias(o.dias)}</div>)}
          </ItemChecklist>
          <ItemChecklist ok icono="ico-reloj" en={en} titulo={t("Cada cuánto vuelve", "How often they can come back")} onCambiar={sembrado ? null : () => ir(5)}>
            <div>{reglaPlazo(plazoFinal, en, categoria)}</div>
            <div className="alta-ayuda">{plazoFinal === 1 ? t(`Hasta 365 ${perfilRubro.visitas.es} al año del mismo miembro.`, `Up to 365 ${perfilRubro.visitas.en} a year from the same member.`)
              : t(`Hasta ${Math.floor(365 / plazoFinal)} ${perfilRubro.visitas.es} al año del mismo miembro.`, `Up to ${Math.floor(365 / plazoFinal)} ${perfilRubro.visitas.en} a year from the same member.`)}</div>
          </ItemChecklist>
          <ItemChecklist ok icono="ico-mapa" en={en}>
            {!esEncargo(categoria) && <SelectorCanal id="wiz-canal" en={en} valor={canalFinal} onCambio={setCanal} />}
          </ItemChecklist>
          {bloquesContenido()}
          <ItemChecklist id="wiz-chk-excl" marcar={marcarFalta === "wiz-chk-excl"} ok={!faltaExclusion} estilo={ordenItem("excl")} icono="ico-no" en={en} titulo={t("¿Hay algo que no entra en la oferta?", "Is anything excluded from the offer?")}>
            {/* s228 · con el alcohol fijo (marcado y sin tocar) parecía respondida: se dice qué falta y el botón dice «lo demás». */}
            {/* s254 · P9 (Ali, opción a): el alcohol es regla del club, no una opción del dueño. Ya no es un chip marcado y
                bloqueado (parecía elegido por defecto): es una línea fija. Por dentro sigue en `exclusiones`. */}
            {/* s255 · `exclusiones-frase-contradictoria`: en un % no hay mínimo, así que la línea no lo nombra; y el 🍷 se veía
                distinto en cada equipo (en el de Otto, otra figura): va el ícono del sprite. */}
            {alcoholEnReglas && <div className="alta-wiz__regla-fija"><Ico name="ico-bares" size={16} /> {elegido === "std"
              ? t("El alcohol suma al mínimo, pero no lleva descuento: es regla del club.", "Alcohol counts toward the minimum but isn't discounted: it's a club rule.")
              : t("El alcohol no lleva descuento: es regla del club.", "Alcohol isn't discounted: it's a club rule.")}</div>}
            <div className="alta-ayuda">{alcoholEnReglas
              ? t("¿Algo más no entra? Márcalo; si no, déjalo así.", "Is anything else excluded? Mark it; if not, leave it as is.")
              : t("Marca lo que no se puede pagar con el beneficio. Si todo entra, déjalo así.", "Mark what can't be paid with the benefit. If everything counts, leave it as is.")}</div>
            <div className="alta-chips" role="group" style={{ marginTop: 6 }}>
              <button type="button" className={chip(todoEntraVisto)} aria-pressed={todoEntraVisto} disabled={!!sembrado}
                onClick={() => { setTodoEntra(true); setExclusiones(alcoholEnReglas ? ["alcohol"] : []); setExclusionOtro(""); }}>
                {alcoholEnReglas ? t("Todo lo demás entra", "Everything else counts") : t("Todo entra", "Everything counts")}
              </button>
              {EXCLUSIONES_WIZARD.filter(x => perfilRubro.excluye.includes(x.id) && !(x.id === "alcohol" && alcoholEnReglas)).map(x => {
                const on = exclusiones.includes(x.id);
                return (
                  <button key={x.id} type="button" className={chip(on)} aria-pressed={on} disabled={!!sembrado}
                    onClick={() => { setTodoEntra(false); setExclusiones(a => toggleEn(a, x.id)); }}>
                    {en ? x.en : x.es}
                  </button>
                );
              })}
            </div>
            <input className="alta-input" style={{ marginTop: 8 }} value={exclusionOtro} disabled={!!sembrado}
              onChange={e => { setTodoEntra(false); setExclusionOtro(e.target.value); }}
              placeholder={en ? perfilRubro.otraExclusion.en : perfilRubro.otraExclusion.es}
              aria-label={t("Otra cosa que no entra", "Something else that's excluded")} />
            {(exclusion || todoEntraVisto) && <div className="alta-ayuda">{t("El miembro leerá: ", "Members will read: ")}«{exclusion ? `${alcanceWizard} ${exclusion}` : alcanceWizard.replace(/\.$/, "")}»</div>}
          </ItemChecklist>
        </ul>
        <ReglasWizardLista categoria={categoria} en={en} canal={canalFinal} plazo={plazoFinal} tipo={elegido} exclusion={exclusion} />
        {/* s230 · wizard-barra-accion-pegada, también aquí (la pantalla más larga: 3279 px con el botón en el 3018): el pie
            lleva el error, lo que falta y los botones, pegado abajo. */}
        <div className="alta-wiz__pie">
        {error && <div className="alta-aviso alta-aviso--error" role="alert">{error}</div>}
        {!listo && <div className="alta-aviso alta-aviso--campo" role="status">{t(`Para enviar falta: ${listaFaltan}.`, `Still needed to send: ${listaFaltan}.`)}</div>}
        <div className="alta-acciones">
          <button type="button" className="alta-btn alta-btn--atras" onClick={() => ir(5)} disabled={enviando || !!sembrado}>← {t("Atrás", "Back")}</button>
          <button type="button" className={["alta-btn alta-btn--seguir", listo ? "" : "alta-btn--incompleto"].filter(Boolean).join(" ")}
            onClick={intentarEnviar} aria-disabled={!listo} disabled={enviando || avance.current.bloqueado}>
            {operador
              ? (enviando ? t("Sembrando…", "Seeding…") : sembrado ? t("Reintentar lo que falta", "Retry what's left")
                : ofertas.length > 1 ? t(`Sembrar con ${ofertas.length} ofertas`, `Seed with ${ofertas.length} offers`) : t("Sembrar con esta oferta", "Seed with this offer"))
              : (enviando ? t("Enviando…", "Sending…") : ofertas.length > 1 ? t(`Enviar mis ${ofertas.length} ofertas`, `Send my ${ofertas.length} offers`) : t("Enviar mi oferta", "Send my offer"))}
          </button>
        </div>
        </div>
        <div className="alta-ayuda" style={{ marginTop: 6 }}>{operador
          ? t("Las ofertas nacen pendientes: el dueño las confirma desde el link.", "Offers start pending: the owner confirms them from the link.")
          : t("Quedan pendientes: las revisamos y te avisamos cuando estén publicadas.", "They stay pending: we review them and let you know when they're live.")}</div>
      </div>
    );
  }

  // ---------------- PANTALLA 4 · EL DINERO ----------------
  const cuentaFijo = (x) => (tamano ? (x >= tamano.minimo ? { da: tamano.monto, cobra: x - tamano.monto, sube: 0 } : { da: tamano.monto, cobra: tamano.minimo - tamano.monto, sube: tamano.minimo - x }) : null);
  const cuentaPct = (x) => { const bruto = (x * pctNum) / 100; const da = conTope ? Math.min(bruto, tope) : bruto; return { da, cobra: x - da, sube: 0 }; };
  const fijoTuyo = cuentaFijo(cuentaBase);
  const brecha = fijoTuyo && fijoTuyo.sube ? fijoTuyo.sube / cuentaBase : 0;
  const nivelFijo = iElegido < iAuto ? 0 : iElegido === iAuto ? 1 : 2;
  const textoFijo = brecha > 0.5
    ? t("Muy lejos de lo que gasta hoy: es probable que no la usen. Baja un paso con el −.", "Too far from what they spend today: they probably won't use it. Go down a step with −.")
    : fijoTuyo && fijoTuyo.sube
    ? [t("Por debajo de lo que tu ticket aguanta.", "Below what your bill can take."),
       t(`Sube tu ticket en $${fmtUsd(fijoTuyo.sube)} por ${perfilRubro.visita.es}.`, `Raises your bill by $${fmtUsd(fijoTuyo.sube)} per ${perfilRubro.visita.en}.`),
       t(`Sube tu ticket en $${fmtUsd(fijoTuyo.sube)} y sube en «Mayor ahorro».`, `Raises your bill by $${fmtUsd(fijoTuyo.sube)} and moves up in “Biggest savings”.`)][nivelFijo]
    : [t("Por debajo de lo que tu ticket aguanta. Súbela un paso con el +.", "Below what your bill can take. Go up a step with +."),
       t("Tu oferta entra en Imperdibles, la sección de las mejores ofertas del catálogo.", "Your offer goes into Can't-miss, the catalog's best-deals section."),
       t("Entra en Imperdibles y sube en «Mayor ahorro».", "It goes into Can't-miss and moves up in “Biggest savings”.")][nivelFijo];
  // El 35 lo puso Code (s224): no salía de una regla del catálogo. El 50 sí (isBestDealOffer).
  // s237 · medidor-pct-35-con-25: el umbral es el porcentaje recomendado (PCT_DEFECTO, 25 %, s236 Ali), no 35 —
  // con 35 el medidor llamaba «Tibia» a la misma oferta que el wizard recomienda.
  // s255 · en la primera oferta el recomendado es 20 % (PCT_PRIMERA): el medidor no puede llamar «tibia» a lo que recomendamos.
  const pctRecomendado = conMontoFijo ? PCT_DEFECTO : PCT_PRIMERA;
  const nivelPct = pctNum < pctRecomendado ? 0 : pctNum < 50 ? 1 : 2;
  const textoPct = [t(`Con menos de ${pctRecomendado} % casi no se nota.`, `Below ${pctRecomendado}% it's barely noticed.`),
    t(`Un descuento que se nota en ${perfilRubro.la.es}.`, `A discount people notice on ${perfilRubro.la.en}.`),   // s242 · «el pedido» en encargos
    t("Desde 50 % entra en Imperdibles, la sección de las mejores ofertas.", "From 50% it goes into Can't-miss, the best-deals section.")][nivelPct]
    + (conTope ? "" : t(" Sin tope suma: el miembro sabe que no hay techo.", " No cap helps: members know there's no ceiling."));
  const cuentaElegida = elegido === "pct" ? cuentaPct(cuentaBase) : elegido === "std" ? fijoTuyo : null;
  const nombreTitulo = operador ? negocio : (nombreDueno || negocio);
  // s239 · W10: «Otra» se dice con lo que escribió el dueño (o no se dice).
  const objetivosTexto = objetivos.map(id => { if (id === "otro") return objetivoOtro.trim(); const o = OBJETIVOS_WIZARD.find(x => x.id === id); return o ? (en ? o.en : o.es).toLowerCase() : ""; }).filter(Boolean).join(t(" y ", " and "));
  const moverTamano = (d) => { if (!lista.length) return; const i = Math.max(0, Math.min(lista.length - 1, iElegido + d)); setTamanoId(lista[i].id); };
  // s237 · un tope fuera de la lista (los $30 de salones) sube al siguiente de la lista o baja al anterior, no salta al primero.
  const moverTope = (d) => {
    if (!topes.length) return;
    const k = topes.indexOf(tope);
    const i = k >= 0 ? k + d : d > 0 ? topes.findIndex(x => x > tope) : topes.length - 1 - [...topes].reverse().findIndex(x => x < tope);
    const j = i < 0 || i >= topes.length ? (d > 0 ? topes.length - 1 : 0) : i;
    setTopeId(String(topes[j]));
  };

  // ---------------- PANTALLA 5 · CADA CUÁNTO VUELVE ----------------
  const plazos = PLAZOS_COOLDOWN.filter(d => d !== 1 || TIPOS_DIARIOS.includes(tipoNegocio));
  const EXPLICA_PLAZO = {
    1: t("Una vez al día: el mismo miembro puede volver cada día con la oferta. Sirve para un café o un almuerzo diario, no para una cena.", "Once a day: the same member can come back every day with the offer. Good for a daily coffee or lunch, not for dinner."),
    7: t("Una vez por semana. Bueno para negocios de todos los días.", "Once a week. Good for everyday businesses."),
    15: t("Dos veces al mes. Lo justo para que se vuelva costumbre sin que la oferta pese en tu caja.", "Twice a month. Enough to build a habit without the offer weighing on your till."),
    30: t("Una vez al mes. El equilibrio: el miembro vuelve y tú controlas cuánto das.", "Once a month. The balance: members come back and you control how much you give."),
    60: t("Cada dos meses. Más para probarte que para volver.", "Every two months. More for trying you than for coming back."),
    90: t("Cuatro veces al año. La oferta casi no sirve para volver: sirve para conocerte.", "Four times a year. It barely brings people back: it's for discovering you."),
  };

  // s230 · wizard-oferta-recomendada-primero: la forma que no está elegida se pliega a una fila (lo que da + «Ver →»);
  // tocarla la abre y pliega la anterior (`elegido` es una sola). Una sola tabla y un solo regulador a la vista.
  const resumenTarjeta = (key, texto) => (
    <button type="button" className="alta-wiz__tarjeta-resumen" onClick={() => setFormato(key)}>
      <span>{texto}</span>
      <span className="alta-wiz__tarjeta-ver">{t("Ver", "See")} →</span>
    </button>
  );

  // ---------------- PANTALLAS 1-5 ----------------
  return (
    <div className="alta-forma alta-wiz">
      <BarraWizard n={pantalla} en={en} />

      {pantalla === 1 && (
        <>
          <div className="alta-wiz__pregunta">{t("¿Tu negocio ha tenido antes descuentos u ofertas?", "Has your business had discounts or offers before?")}</div>
          <OpcionesBinarias valor={tuvoAntes} onCambio={setTuvoAntes} etiqueta={t("¿Tu negocio ha tenido antes descuentos u ofertas?", "Has your business had discounts or offers before?")}
            opciones={[
              { id: "si", icono: "ico-ahorro", titulo: t("Sí, ya hice ofertas", "Yes, I've run offers"),
                nota: t("Groupon, Yelp, apps de delivery, descuento a empleados, promos propias.", "Groupon, Yelp, delivery apps, employee discount, your own promos.") },
              { id: "no", icono: "ico-destacado", titulo: t("No, esta sería la primera", "No, this would be the first"),
                nota: t("Perfecto: la armamos desde cero contigo.", "Perfect: we'll build it from scratch with you.") },
            ]} />
          {tuvoAntes === "si" && (
            <>
              <div className="alta-etiqueta" style={{ marginTop: 16 }}>{t("¿Dónde?", "Where?")}</div>
              <div className="alta-chips" role="group">
                {DONDE_OFERTAS_ANTES.map(d => (
                  <button key={d.id} type="button" className={chip(dondeAntes.includes(d.id))} aria-pressed={dondeAntes.includes(d.id)}
                    onClick={() => setDondeAntes(a => toggleEn(a, d.id))}>{en ? d.en : d.es}</button>
                ))}
              </div>
              {/* s239 · W7 (Ali): el link de esa oferta se lee en segundo plano (ingest_offer_ideas) y vuelve en el paso del dinero. */}
              <label htmlFor="wiz-link-oferta" className="alta-etiqueta" style={{ display: "block", marginTop: 12 }}>{t("Link de esa oferta (opcional)", "Link to that offer (optional)")}</label>
              <input id="wiz-link-oferta" className="alta-input" type="url" inputMode="url" value={linkOferta} onChange={e => setLinkOferta(e.target.value)}
                placeholder={t("Pega el link de Groupon, Yelp o tu Instagram", "Paste the Groupon, Yelp or Instagram link")} />
              <div className="alta-etiqueta" style={{ marginTop: 16 }}>{t("¿Ya sabes qué oferta quieres?", "Do you already know what offer you want?")}</div>
              <OpcionesBinarias valor={sabeOferta} onCambio={setSabeOferta} etiqueta={t("¿Ya sabes qué oferta quieres?", "Do you already know what offer you want?")}
                opciones={[
                  { id: "si", icono: "ico-ok", titulo: t("Sí, ya sé cuál", "Yes, I know which one"),
                    nota: t("Cuéntanosla: la guardamos con tu ficha para tenerla en cuenta. La oferta que publicas sale de los pasos que siguen.", "Tell us: we keep it with your profile. The offer you publish comes from the next steps.") },   // s238 · ayudas W11: `idea` solo viaja en wizard_json
                  { id: "no", icono: "ico-ia", titulo: t("No, propónganme una", "No, suggest one"),
                    nota: t("Te la recomendamos según tu negocio y tus objetivos.", "We'll recommend one based on your business and goals.") },
                ]} />
              {sabeOferta === "si" && (
                <>
                  <label htmlFor="wiz-idea" className="alta-etiqueta" style={{ display: "block", marginTop: 12 }}>{t("Cuéntanos cuál", "Tell us which one")}</label>
                  <textarea id="wiz-idea" className="alta-textarea" rows={2} value={idea} onChange={e => setIdea(e.target.value)}
                    placeholder={t("Ej.: $10 de descuento si gastas $50, de lunes a jueves", "E.g.: $10 off when you spend $50, Monday to Thursday")} />
                  <div className="alta-ayuda">{t("Si tu idea es un monto o un porcentaje, vas a poder elegirlo en el paso del dinero.", "If your idea is an amount or a percentage, you'll be able to pick it in the money step.")}</div>
                </>
              )}
              {/* s239 · W8 (Ali): decirle lo que gana él, según dónde dio ofertas. Sin cifras de Groupon ni de las apps (no
                  verificadas, cambian por contrato). Detrás de COPY_SIN_COMISION, como el aviso de «No le pagas nada». */}
              <TipWizard>{!COPY_SIN_COMISION
                ? t("En NXT tu oferta tiene que ser mejor que la que das gratis: el miembro paga por estar.", "On NXT your offer has to beat the one you give for free: members pay to be here.")
                : dondeAntes.includes("groupon")
                ? t("Groupon se queda con una parte de lo que cobras. Nosotros no te cobramos nada: por eso aquí puedes dar una oferta mejor, solo para miembros.", "Groupon keeps part of what you charge. We charge you nothing: that's why you can give a better offer here, just for members.")
                : dondeAntes.includes("delivery")
                ? t("Las apps te cobran comisión en cada pedido. Aquí no: todo lo que el miembro paga es tuyo, y por eso puedes darle una oferta mejor.", "Apps charge you a fee on every order. Not here: everything the member pays is yours, so you can give them a better offer.")
                : t("NXT no te cobra comisión: puedes dar aquí una oferta mejor que en cualquier otro lado, solo para miembros.", "NXT charges you no fee: you can give a better offer here than anywhere else, just for members.")}</TipWizard>
            </>
          )}
          {/* s224 · la misma promesa que «ni comisión ni mensualidad»: espera a `take-rate-comision-decidir`.
              s230 · wizard-una-caja-por-paso: una sola caja a la vista. Con «Sí» abierto ya está el consejo del paso
              («tu oferta tiene que ser mejor que la que das gratis») y las dos juntas eran un bloque de texto al final. */}
          {COPY_SIN_COMISION && tuvoAntes !== "si" && <TipWizard>{t("No le pagas nada a NXT Reserve: tu único costo es el descuento cuando alguien canjea.", "You pay NXT Reserve nothing: your only cost is the discount when someone redeems.")}</TipWizard>}
          {acciones(1)}
        </>
      )}

      {pantalla === 2 && (
        <>
          {/* s254 · P3: «elige dos» va en el título, no en la ayuda chica. */}
          <div className="alta-wiz__pregunta">{t("¿Qué quieres lograr? Elige dos", "What do you want to achieve? Pick two")}</div>
          <div className="alta-ayuda">{t(`${Math.min(objetivos.length, OBJETIVOS_MAX)} de ${OBJETIVOS_MAX} elegidos.`, `${Math.min(objetivos.length, OBJETIVOS_MAX)} of ${OBJETIVOS_MAX} picked.`)}</div>
          <div className="alta-opciones">
            {OBJETIVOS_WIZARD.map(o0 => ({ ...o0, ...(perfilRubro.objetivos[o0.id] || {}) })).map(o => {
              const on = objetivos.includes(o.id);
              const lleno = !on && objetivos.length >= OBJETIVOS_MAX;
              return (
                <button key={o.id} type="button" aria-pressed={on} disabled={lleno}
                  className={["alta-opcion", on && "alta-opcion--elegida"].filter(Boolean).join(" ")}
                  onClick={() => { setObjetivos(a => (a.includes(o.id) ? a.filter(x => x !== o.id) : [...a, o.id].slice(0, OBJETIVOS_MAX))); setFormato(""); setPlazo(""); setTamanoId(""); }}>
                  <span className="alta-opcion__icono alta-opcion__icono--linea" aria-hidden="true"><Ico name={o.icono} size={24} /></span>
                  <div className="alta-opcion__texto">
                    <div className="alta-opcion__nombre">{en ? o.en : o.es}</div>
                    <div className="alta-opcion__nota">{en ? o.notaEn : o.notaEs}</div>
                  </div>
                  <div className="alta-opcion__flecha">{on ? "✓" : ""}</div>
                </button>
              );
            })}
          </div>
          {objetivos.includes("otro") && (
            <>
              <label htmlFor="wiz-objetivo-otro" className="alta-etiqueta" style={{ display: "block", marginTop: 12 }}>{t("Cuéntanos cuál", "Tell us which")}</label>
              <input id="wiz-objetivo-otro" className="alta-input" maxLength={120} value={objetivoOtro} onChange={e => setObjetivoOtro(e.target.value)}
                placeholder={t("Ej.: que prueben el menú nuevo de los domingos", "E.g.: get people to try our new Sunday menu")} />
            </>
          )}
          {acciones(2)}
        </>
      )}

      {pantalla === 3 && momentos && (
        <>
          {/* s235 · wizard-primera-oferta-una-sola (Ali): un solo momento, una oferta. Antes se marcaban varios y salía una
              oferta por cada uno, con el mismo monto (confundía al dueño nuevo). Las otras franjas, después. */}
          <div className="alta-wiz__pregunta">{t("¿Cuándo quieres más clientes?", "When do you want more customers?")}</div>
          <div className="alta-ayuda">{operador
            ? t("Elige un momento: sale una oferta. Las otras franjas, después de sembrar, con «+ Otra franja».", "Pick one time of day: it makes one offer. Other time slots after seeding, with “+ Another slot”.")
            : otraFranja
            ? t("Elige el momento de esta nueva oferta: uno distinto del que ya tienes.", "Pick the time of day for this new offer: a different one from the one you already have.")
            : t("Elige un momento para tu primera oferta. Cuando esté publicada, puedes agregar otra franja desde «Mis ofertas».", "Pick one time of day for your first offer. Once it's live, you can add another slot from “My offers”.")}</div>
          {pre.hayHorario && horarioTexto && <div className="alta-ayuda">{t("Tu horario: ", "Your hours: ")}{horas12EnTexto(horarioTexto, en)}. {t("Marcamos el que te recomendamos: confirma o cambia.", "We marked the one we recommend: confirm or change it.")}</div>}
          {/* s230 · wizard-momentos-tarjeta-por-momento: una tarjeta por momento (ícono + nombre + horario y días como nota);
              elegida se abre con «Desde / Hasta» en una fila y los siete días del momento. La pregunta «¿es igual toda la
              semana?» y los grupos entre semana / finde se van: el dueño apaga, en cada momento, el día que no abre. */}
          <div className="alta-opciones" role="radiogroup" aria-label={t("Momento de la oferta", "Time of day for the offer")}>
            {momentosRubro.map(m => {
              const on = !!momentos[m.key]?.on;
              const d = on ? diasDe(m) : [];
              return (
                <div key={m.key} className={["alta-wiz__momento", on && "alta-wiz__momento--on"].filter(Boolean).join(" ")}>
                  <button type="button" className="alta-wiz__momento-cabeza" role="radio" aria-checked={on}
                    onClick={() => setMomentos(x => Object.fromEntries(Object.entries(x).map(([k, v]) => [k, { ...v, on: k === m.key }])))}>
                    <span className="alta-opcion__icono alta-opcion__icono--linea" aria-hidden="true"><Ico name="ico-reloj" size={24} /></span>
                    <div className="alta-opcion__texto">
                      <div className="alta-opcion__nombre">{etiquetaMomento(m)}</div>
                      <div className="alta-opcion__nota">{on ? `${rango12(momentos[m.key].ini, momentos[m.key].fin, en)} · ${d.length ? textoDias(d) : t("sin días", "no days")}` : rango12(momentos[m.key].ini, momentos[m.key].fin, en)}
                        {momentos[m.key].web && <span className="alta-wiz__de-la-web alta-wiz__de-la-web--linea">{t("Horario de tu web", "From your website")}</span>}</div>
                    </div>
                    <div className="alta-opcion__flecha">{on ? "✓" : ""}</div>
                  </button>
                  {on && (
                    <div className="alta-wiz__momento-detalle">
                      <div className="alta-wiz__momento-horas">
                        <label>{t("Desde", "From")}
                          <HoraCada30 en={en} value={momentos[m.key].ini} aria-label={t(`${etiquetaMomento(m)}: desde`, `${etiquetaMomento(m)}: from`)}
                            onChange={v => setMomentos(x => ({ ...x, [m.key]: { ...x[m.key], ini: v } }))} />
                        </label>
                        <label>{t("Hasta", "Until")}
                          <HoraCada30 en={en} value={momentos[m.key].fin} aria-label={t(`${etiquetaMomento(m)}: hasta`, `${etiquetaMomento(m)}: until`)}
                            onChange={v => setMomentos(x => ({ ...x, [m.key]: { ...x[m.key], fin: v } }))} />
                        </label>
                      </div>
                      {/* s252 · avisa y no frena: el dueño puede saber algo que Google no. */}
                      {(() => {
                        const cabe = d.length ? franjaEnHorario(momentos[m.key].ini, momentos[m.key].fin, perfil?.business_hours_json, d) : { ...momentos[m.key] };
                        return (!cabe || cabe.ini !== momentos[m.key].ini || cabe.fin !== momentos[m.key].fin) && (
                          <div className="alta-aviso alta-aviso--error alta-aviso--campo">{t("Esta franja se sale de tu horario. Ajusta las horas o apaga los días que no abren a esa hora.", "This time slot falls outside your hours. Adjust the times or turn off the days you aren't open then.")}</div>
                        );
                      })()}
                      {/* s254 · P5 (Ali, maqueta «Días y horario»): los días en filas, con tres letras (la «X» de miércoles no se
                          entendía) y el horario del momento al lado; la fila entera prende o apaga el día. */}
                      <div className="alta-wiz__dias alta-wiz__dias--filas" role="group" aria-label={t(`Días de ${etiquetaMomento(m).toLowerCase()}`, `${etiquetaMomento(m)} days`)}>
                        {FEED_DAY_TOKENS.map((tok, i) => {
                          const onD = d.includes(tok);
                          return (
                            <button key={tok} type="button" aria-pressed={onD} aria-label={en ? MERCHANT_DAYS[i].en : MERCHANT_DAYS[i].es}
                              className={["alta-wiz__dia-fila", onD && "alta-wiz__dia-fila--on"].filter(Boolean).join(" ")} onClick={() => toggleDia(m, tok)}>
                              <span className="alta-wiz__dia-nombre">{en ? FEED_DAY_LABELS_EN[i] : FEED_DAY_LABELS_ES[i]}</span>
                              <span className="alta-wiz__dia-horas">{onD ? rango12(momentos[m.key].ini, momentos[m.key].fin, en) : t("Sin oferta · toca para activar", "No offer · tap to turn on")}</span>
                              <span className="alta-wiz__dia-marca" aria-hidden="true">{onD ? "✓" : ""}</span>
                            </button>
                          );
                        })}
                      </div>
                      {!d.length && <div className="alta-ayuda alta-wiz__ambar">{t("Sin días este momento no arma oferta: enciende al menos uno o apágalo.", "With no days this time of day makes no offer: switch on at least one, or switch it off.")}</div>}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {pre.cerrados.length > 0 && <div className="alta-ayuda">{t("Dejamos apagados los días que tu horario dice cerrado.", "We switched off the days your hours say you're closed.")}</div>}
          {franjasConDias.length > cupo && (
            <div className="alta-aviso alta-aviso--error alta-aviso--campo" role="status">
              {t(`Ya tienes ${OFERTAS_VIVAS_MAX} ofertas activas o en revisión, el máximo. Archiva una en «Mis ofertas» para crear otra.`, `You already have ${OFERTAS_VIVAS_MAX} active or pending offers, the maximum. Archive one in “My offers” to create another.`)}
            </div>
          )}
          {/* s238 · ayudas W18: no hay cupos ni tope diario (D-123); se pausa desde el panel. */}
          <TipWizard>{t("Si un día te llenas, pausa la oferta desde tu panel y vuelve a activarla cuando quieras.", "If you fill up one day, pause the offer from your panel and turn it back on whenever you want.")}</TipWizard>
          {acciones(3)}
        </>
      )}

      {pantalla === 4 && (
        <>
          <div className="alta-wiz__saludo alta-wiz__saludo--chico">
            {mesa
              ? (nombreTitulo ? t(`${nombreTitulo}, armemos la oferta que te va a llenar mesas`, `${nombreTitulo}, let's build the offer that fills your tables`) : t("Armemos la oferta que te va a llenar mesas", "Let's build the offer that fills your tables"))
              : (nombreTitulo ? t(`${nombreTitulo}, armemos la oferta que te va a traer clientes`, `${nombreTitulo}, let's build the offer that brings you customers`) : t("Armemos la oferta que te va a traer clientes", "Let's build the offer that brings you customers"))}
          </div>
          <div className="alta-wiz__texto">{mesa ? t("Una mesa vacía no te deja un dólar. Nuestros miembros, sí.", "An empty table doesn't make you a dollar. Our members do.")
            : t("Un mostrador sin clientes no te deja un dólar. Nuestros miembros, sí.", "A counter with no customers doesn't make you a dollar. Our members do.")}</div>
          {/* s239 · W9: lo que leímos de la oferta que ya da (W7), para que la propuesta de abajo no salga de la nada. */}
          {LECTURA_EN_PANTALLA && lectura.oferta && String(lectura.oferta.title || "").trim() && (
            <TipWizard>{t(`Leímos la oferta que ya das: «${String(lectura.oferta.title).trim()}». La de NXT tiene que ser mejor, y puede serlo: aquí no te cobramos comisión.`,
              `We read the offer you already run: “${String(lectura.oferta.title).trim()}”. The NXT one has to be better, and it can be: we charge you no fee here.`)}</TipWizard>
          )}

          {conPreguntaTicket && <div className="alta-wiz__ejercicio">
            <div className="alta-wiz__pregunta" style={{ fontSize: 16 }}>{t("Hagamos un ejercicio", "Let's run the numbers")}</div>
            {/* s254 · P6 (Ali + Otto): los dueños piensan en el grupo; la pregunta sigue siendo por persona (el motor de la
                oferta trabaja así) y se dice en GRANDE, con «una persona» resaltado y un aviso que se mueve para que se lea
                bien. Al seguir, una ventana lo confirma (confirmaTicket). */}
            <div className="alta-wiz__leebien" aria-hidden="true">{t("👀 Lee bien: es la respuesta más importante", "👀 Read carefully: this is the most important answer")}</div>
            <label htmlFor="wiz-ticket" className="alta-wiz__ticket-pregunta alta-wiz__ticket-pregunta--grande">
              {/* s236 · por persona en todos los rubros (antes: «por mesa» en restaurantes y bares) */}
              {en
                ? <>How much does <span className="alta-wiz__resalte">ONE PERSON</span> spend on average?</>
                : <>¿Cuánto gasta <span className="alta-wiz__resalte">UNA PERSONA</span> en promedio?</>}
            </label>
            {mesa && <div className="alta-wiz__ejemplo-par">{t("Si una mesa de dos paga $60, escribe $30.", "If a table of two pays $60, write $30.")}</div>}
            {/* s238 · ayudas W19 (COPY_s238_ayudas_top10 §2): por persona en todos los rubros; el alcohol se excluye en el paso siguiente. */}
            {/* s239 · W12: el texto viejo dejaba el alcohol como opción del dueño («lo marcas en el siguiente paso»); en D6 es regla. */}
            <div className="alta-ayuda">{dos ? t(`Todo lo que paga una persona en una visita normal: comida y bebida, ${perfilRubro.antesDe.es}. Si vienen dos, cuenta solo a uno.`, `Everything one person pays on a normal visit: food and drinks, ${perfilRubro.antesDe.en}. If two come in, count just one.`) + (alcoholEnReglas ? t(" El alcohol suma a la cuenta, pero no lleva descuento: es regla del club.", " Alcohol counts toward the bill but isn't discounted: it's a club rule.") : "") : (en ? (perfilRubro.ticketAyuda || PERFIL_POR_FAMILIA.cita.ticketAyuda).en : (perfilRubro.ticketAyuda || PERFIL_POR_FAMILIA.cita.ticketAyuda).es)}</div>
            <div className="alta-wiz__ticket">
              <span className="alta-wiz__ticket-signo">$</span>
              <input id="wiz-ticket" className="alta-input" type="number" inputMode="decimal" min={1} value={ticket}
                onChange={e => { setTicket(e.target.value); setFuenteTicket(""); setTamanoId(""); setTopeId(topeInicial); }} style={{ maxWidth: 140 }} />
              <button type="button" className="alta-btn alta-btn--seguir alta-wiz__recomendar" onClick={recomendar}>
                {g ? t("Recomienda mi oferta", "Recommend my offer") : t("Recomiéndame con lo típico", "Recommend what's typical")}
              </button>
            </div>
            <div className="alta-ayuda">{lineaGoogle()}</div>
          </div>}

          <div className="alta-wiz__fuerte">
            <b>{t("Una oferta tibia no la usa nadie. Las mejores venden más.", "A weak offer gets no takers. The best ones sell more.")}</b>
            <div>{COPY_SIN_COMISION
              ? t("Nosotros te traemos el cliente y no te cobramos nada por hacerlo: ni comisión ni mensualidad. Tú te encargas de que vuelva y consuma más.",
                  "We bring you the customer and charge you nothing for it: no commission, no monthly fee. You make sure they come back and spend more.")
              : t("Nosotros te traemos el cliente. Tú te encargas de que vuelva y consuma más.",
                  "We bring you the customer. You make sure they come back and spend more.")}</div>
          </div>

          {ticketNum > 0 && (
            <>
              {objetivosTexto && <div className="alta-wiz__texto">{t(`Querías ${objetivosTexto}. Según eso, armemos una oferta que destaque.`, `You wanted ${objetivosTexto}. With that in mind, let's build an offer that stands out.`)}</div>}
              {/* s255 · sin la pregunta, los números del ejemplo se dicen de dónde salen. */}
              {!conPreguntaTicket && <div className="alta-ayuda">{gTicket
                ? t(`Los números de ejemplo usan lo que dice Google: unos $${fmtUsd(ppEjemplo)} por persona.`, `The example uses what Google says: about $${fmtUsd(ppEjemplo)} per person.`)
                : t(`Los números de ejemplo usan lo típico de tu rubro: unos $${fmtUsd(ppEjemplo)} por persona.`, `The example uses what's typical for your category: about $${fmtUsd(ppEjemplo)} per person.`)}</div>}
              {conMontoFijo && fuenteTicket && tamanoSugerido && (
                <div className="alta-wiz__idea">
                  {fuenteTicket === "google" ? t("Con lo que dice Google", "Based on Google") : t("Con lo típico de tu rubro", "Based on what's typical for your category")}
                  {/* s237 · alta-recomendacion-mesa-de-dos: la recomendación habla en la misma unidad que el campo de arriba
                      (por persona); la mesa de dos queda solo en el recibo de ejemplo. */}
                  {` ($${fmtUsd(porPersona)} ${t("por persona", "per person")}), `}
                  {t("te recomendamos ", "we recommend ")}<b>{fraseUmbral(tamanoSugerido.monto, tamanoSugerido.minimo, en)}</b>. {t("Si tu ticket es otro, cámbialo arriba.", "If your bill is different, change it above.")}
                </div>
              )}
              {/* s255 · con una sola forma (solo porcentaje) no hay «otra» que tocar. */}
              {(conMontoFijo || hay2x1) && <div className="alta-ayuda">{mesa ? t("La forma que te recomendamos viene abierta, con el ejemplo de tu mesa. Toca otra para compararla.", "The format we recommend comes open, with your table as the example. Tap another to compare.")
                : t("La forma que te recomendamos viene abierta, con el ejemplo de tu cliente. Toca otra para compararla.", "The format we recommend comes open, with your customer as the example. Tap another to compare.")}</div>}
              <div className="alta-wiz__tarjetas">
                {conMontoFijo && (
                <div className={["alta-wiz__tarjeta", elegido === "std" && "alta-wiz__tarjeta--elegida"].filter(Boolean).join(" ")}>
                  <button type="button" className="alta-wiz__tarjeta-cabeza" aria-pressed={elegido === "std"} onClick={() => setFormato("std")}>
                    <span className="alta-wiz__tarjeta-titulo"><span className="alta-wiz__tarjeta-icono" aria-hidden="true"><Ico name="ico-ahorro" size={20} /></span>{t("Monto fijo", "Fixed amount")}</span>
                    {/* s239 · W14: en restaurantes y bares el monto fijo sale por la regla del rubro (D2), no por los objetivos. */}
                    {recomendado === "std" && <span className="alta-wiz__recomendada"><Ico name="ico-destacado" size={12} />{RUBROS_MONTO_FIJO_SIEMPRE.includes(categoria)
                      ? (categoria === "Bar_Rooftop" ? t("Lo que recomendamos para bares", "What we recommend for bars") : t("Lo que recomendamos para restaurantes", "What we recommend for restaurants"))
                      : t("Va con lo que quieres", "Fits your goals")}</span>}
                  </button>
                  {elegido !== "std" && resumenTarjeta("std", tamano ? fraseUmbral(tamano.monto, tamano.minimo, en) : "")}
                  {elegido === "std" && (<>
                  {tamano && <div className="alta-wiz__oferta-grande">{fraseUmbral(tamano.monto, tamano.minimo, en)}</div>}
                  <div className="alta-ayuda">{antesDe(perfilRubro.antesDe)}</div>
                  <div className="alta-ayuda">{fijoTuyo && fijoTuyo.sube
                    ? t(`Sube tu ticket: para usarla, ${mesa ? "la mesa" : dos ? `${perfilRubro.la.es} de dos` : "el cliente"} pasa de $${fmtUsd(cuentaBase)} a $${fmtUsd(tamano.minimo)}. Son $${fmtUsd(fijoTuyo.sube)} más en tu caja.`,
                        `Raise your bill: to use it, ${mesa ? "the table" : dos ? `${perfilRubro.la.en} for two` : "the customer"} goes from $${fmtUsd(cuentaBase)} to $${fmtUsd(tamano.minimo)}. That's $${fmtUsd(fijoTuyo.sube)} more in your till.`)
                    : RUBROS_REGLA_3.includes(categoria)
                      // s236 · regla 3: el mínimo queda un escalón arriba de lo que gasta una persona.
                      // s242 · wizard de dulces: Dulces también tiene regla 3, pero se pide en el mostrador.
                      ? (mesa ? t("Pensada para que quien viene solo pida algo más. Si en la mesa son dos, la cuenta pasa el mínimo y tú cobras más.", "Built so a solo guest orders a bit more. With two at the table, the bill clears the minimum and you charge more.")
                        : t(`Pensada para que quien viene solo pida algo más. Si vienen dos, ${perfilRubro.la.es} pasa el mínimo y tú cobras más.`, `Built so a solo customer orders a bit more. If two come in, ${perfilRubro.la.en} clears the minimum and you charge more.`))
                      // s238 · ayudas W21: el mínimo es por cuenta. Esta rama es la de los rubros SIN regla 3 (salones, experiencias,
                      // «Hecho a pedido»): ahí no hay «mesa», así que el texto de COPY §3 se dice con servicios y visitas (#1106).
                      : t("El mínimo es por cuenta, no por persona: una oferta por visita. Está pensado un escalón arriba de lo que gasta un cliente, así quien suma un servicio o viene acompañado lo pasa sin esfuerzo y tú cobras más.", "The minimum is per bill, not per person: one offer per visit. It sits one step above what one customer spends, so anyone who adds a service or brings someone clears it easily and you make more.")}</div>
                  {/* s238 · ayudas W22: el regulador mueve el par descuento/mínimo de la tabla (regla 3, s236-D4). */}
                  <StepperWizard en={en} etiqueta={t("Tamaño de la oferta", "Offer size")} valor={tamano ? `$${fmtUsd(tamano.monto)}` : "—"} onMenos={() => { setFormato("std"); moverTamano(-1); }} onMas={() => { setFormato("std"); moverTamano(1); }}
                    puedeMenos={iElegido > 0} puedeMas={iElegido < lista.length - 1} />
                  <div className="alta-ayuda">{t("Cada paso sube el descuento y el mínimo a la vez: siempre das la mitad de lo que pides.", "Each step raises the discount and the minimum together: you always give back half of what you ask for.")}</div>
                  <MedidorWizard en={en} nivel={brecha > 0.5 ? 0 : nivelFijo} rojo={brecha > 0.5} texto={textoFijo} />
                  </>)}
                </div>
                )}

                <div className={["alta-wiz__tarjeta", elegido === "pct" && "alta-wiz__tarjeta--elegida"].filter(Boolean).join(" ")}>
                  <button type="button" className="alta-wiz__tarjeta-cabeza" aria-pressed={elegido === "pct"} onClick={() => setFormato("pct")}>
                    <span className="alta-wiz__tarjeta-titulo">{t("Porcentaje", "Percentage")}</span>
                    {recomendado === "pct" && (conMontoFijo || hay2x1) && <span className="alta-wiz__recomendada"><Ico name="ico-destacado" size={12} />{t("Va con lo que quieres", "Fits your goals")}</span>}
                  </button>
                  {elegido !== "pct" && resumenTarjeta("pct", conTope ? t(`${pctNum} % de descuento, hasta $${fmtUsd(tope)}`, `${pctNum}% off, up to $${fmtUsd(tope)}`) : (alcoholEnReglas ? t(`${pctNum} % de descuento en comida y bebidas sin alcohol`, `${pctNum}% off food and non-alcoholic drinks`) : t(`${pctNum} % de descuento en ${perfilRubro.toda.es}`, `${pctNum}% off ${perfilRubro.toda.en}`)))}
                  {elegido === "pct" && (<>
                  <div className="alta-wiz__oferta-grande">{conTope ? t(`${pctNum} % de descuento, hasta $${fmtUsd(tope)}`, `${pctNum}% off, up to $${fmtUsd(tope)}`) : (alcoholEnReglas ? t(`${pctNum} % de descuento en comida y bebidas sin alcohol`, `${pctNum}% off food and non-alcoholic drinks`) : t(`${pctNum} % de descuento en ${perfilRubro.toda.es}`, `${pctNum}% off ${perfilRubro.toda.en}`))}</div>
                  <div className="alta-ayuda">{t(`Sobre ${perfilRubro.la.es}, ${perfilRubro.antesDe.es}.`, `On ${perfilRubro.la.en}, ${perfilRubro.antesDe.en}.`)}</div>
                  <div className="alta-chips" role="group" aria-label={t(`Tope por ${perfilRubro.visita.es}`, `Cap per ${perfilRubro.visita.en}`)}>
                    <button type="button" className={chip(!conTope)} aria-pressed={!conTope} onClick={() => { setFormato("pct"); setConTope(false); }}>{t("Sin tope", "No cap")}</button>
                    <button type="button" className={chip(conTope)} aria-pressed={conTope} onClick={() => { setFormato("pct"); setConTope(true); }}>{t("Con tope", "With a cap")}</button>
                  </div>
                  <div className={conTope ? "alta-ayuda" : "alta-ayuda alta-wiz__ambar"}>{conTope
                    // s242 · la cuenta / el pedido según el rubro (en encargos «el pedido»: lo vio la matriz al leer el paso 4 contestado).
                    ? t(`Tu red de seguridad: aunque ${perfilRubro.la.es} sea de $${fmtUsd(cuentaBase * 3)}, nunca das más de $${fmtUsd(tope)}.`, `Your safety net: even on a $${fmtUsd(cuentaBase * 3)} ${perfilRubro.la.en.replace(/^the /, "")}, you never give more than $${fmtUsd(tope)}.`)
                    : t(`Sin tope, el descuento crece con ${perfilRubro.la.es}: con $${fmtUsd(cuentaBase * 3)} das $${fmtUsd((cuentaBase * 3 * pctNum) / 100)}. Para el miembro es más atractivo; si prefieres un límite, elige «Con tope».`,
                        `With no cap, the discount grows with ${perfilRubro.la.en}: on $${fmtUsd(cuentaBase * 3)} you give $${fmtUsd((cuentaBase * 3 * pctNum) / 100)}. Members love it; if you'd rather have a limit, pick “With a cap”.`)}</div>
                  <StepperWizard en={en} valor={en ? `${pctNum}%` : `${pctNum} %`} onMenos={() => { setFormato("pct"); setPct(p => Math.max(PCT_MINIMO, p - 5)); }} onMas={() => { setFormato("pct"); setPct(p => Math.min(100, p + 5)); }} />
                  {conTope && <StepperWizard en={en} etiqueta={t("Tope", "Cap")} valor={`$${fmtUsd(tope)}`} onMenos={() => moverTope(-1)} onMas={() => moverTope(1)} />}
                  <MedidorWizard en={en} nivel={nivelPct} texto={textoPct} />
                  </>)}
                </div>

                {hay2x1 && (
                  <div className={["alta-wiz__tarjeta", elegido === "bogo" && "alta-wiz__tarjeta--elegida"].filter(Boolean).join(" ")}>
                    <button type="button" className="alta-wiz__tarjeta-cabeza" aria-pressed={elegido === "bogo"} onClick={() => setFormato("bogo")}>
                      <span className="alta-wiz__tarjeta-titulo">2×1</span>
                      {recomendado === "bogo" && <span className="alta-wiz__recomendada"><Ico name="ico-destacado" size={12} />{t("Va con lo que quieres", "Fits your goals")}</span>}
                    </button>
                    {elegido !== "bogo" && resumenTarjeta("bogo", plato.trim() ? `2×1 ${en ? "on" : "en"} ${plato.trim()}` : t("2×1 en el plato que elijas", "2-for-1 on the dish you pick"))}
                    {elegido === "bogo" && (<>
                    <div className="alta-wiz__oferta-grande">{plato.trim() ? `2×1 ${en ? "on" : "en"} ${plato.trim()}` : t("2×1 en el plato que elijas", "2-for-1 on the dish you pick")}</div>
                    <div className="alta-ayuda">{t("Pide dos, paga uno. Tu costo real no es el precio de carta, sino lo que te cuesta prepararlo.", "Order two, pay for one. Your real cost isn't the menu price, but what it costs you to make it.")}</div>
                    {elegido === "bogo" && (
                      <div className="alta-wiz__ajuste">
                        <label htmlFor="wiz-plato" className="alta-etiqueta">{t("¿En qué plato?", "Which dish?")}</label>
                        <input id="wiz-plato" className="alta-input" value={plato} onChange={e => setPlato(e.target.value)} placeholder={t("Ej.: hamburguesa de pollo", "E.g.: chicken burger")} />
                        <label htmlFor="wiz-precio" className="alta-etiqueta" style={{ marginTop: 8 }}>{t("Precio de carta de uno", "Menu price of one")}</label>
                        <input id="wiz-precio" className="alta-input" type="number" inputMode="decimal" min={1} value={precioPlato}
                          onChange={e => setPrecioPlato(e.target.value)} placeholder="17" style={{ maxWidth: 120 }} />
                        {/* s224 · export 133: operator_add_offer también recibe is_alcohol. */}
                        <label className="alta-wiz__casilla">
                          <input type="checkbox" checked={platoAlcohol} onChange={e => setPlatoAlcohol(e.target.checked)} />
                          {t("Es una bebida con alcohol", "It's an alcoholic drink")}
                        </label>
                      </div>
                    )}
                    </>)}
                  </div>
                )}
              </div>

              {/* s235 · wizard-ejercicio-como-invitacion: el recibo de la invitación, con la forma elegida.
                  s254 · P7: apagado (RECIBO_EN_WIZARD). */}
              {RECIBO_EN_WIZARD && cuentaElegida && (
                <ReciboWizard key={elegido} en={en} mesa={mesa} dos={dos} sinPropina={!perfilRubro.propina} la={perfilRubro.la} base={cuentaBase} porPersona={porPersona}
                  cuenta={elegido === "pct" ? cuentaPct : cuentaFijo}
                  notaDescuento={elegido === "pct"
                    ? (conTope ? t(`solo miembros · ${pctNum} %, hasta $${fmtUsd(tope)}`, `members only · ${pctNum}%, up to $${fmtUsd(tope)}`) : t(`solo miembros · ${pctNum} %`, `members only · ${pctNum}%`))
                    : t("solo miembros · monto fijo", "members only · fixed amount")} />
              )}
            </>
          )}
          {acciones(4, ticketNum > 0 ? t("Elijo esta oferta →", "I choose this offer →") : t("Escribe tu ticket para ver tu oferta", "Enter your bill to see your offer"))}
          {/* s254 · P6 (Ali): «después que le dé continuar, un pop-up reafirmando esa decisión». Si el monto pasa del doble
              de lo típico del rubro, avisa que puede ser lo de varias personas (avisa, no frena). */}
          {confirmaTicket && (() => {
            const tipicoPP = Math.round(TICKET_TIPICO_POR_PERSONA[tipoNegocio] || TICKET_TIPICO_POR_PERSONA[categoria] || 35);
            const alto = porPersona > tipicoPP * 2;
            const cerrar = () => { setConfirmaTicket(false); setTimeout(() => { const i = document.getElementById("wiz-ticket"); if (i) i.focus(); }, 0); };
            return (
              <div className="alta-wiz__velo" onClick={cerrar}>
                <div className="alta-wiz__dialogo" role="dialog" aria-modal="true" aria-labelledby="wiz-confirma-titulo" onClick={e => e.stopPropagation()}>
                  <div id="wiz-confirma-titulo" className="alta-wiz__dialogo-titulo">{t("¿Es lo que gasta UNA persona?", "Is that what ONE person spends?")}</div>
                  <div className="alta-wiz__dialogo-cifra">${fmtUsd(porPersona)}</div>
                  <div className="alta-wiz__dialogo-texto">{t("Esto gasta una persona promedio en tu negocio.", "This is what an average person spends at your place.")}</div>
                  {mesa && <div className="alta-wiz__dialogo-par">{t(`Entonces una mesa de dos gasta unos $${fmtUsd(porPersona * 2)}.`, `So a table of two spends about $${fmtUsd(porPersona * 2)}.`)}</div>}
                  {alto && <div className="alta-wiz__dialogo-ojo" role="status">{t(`Ojo: es más del doble de lo típico de tu rubro ($${tipicoPP} por persona). ${mesa ? "¿No será lo de toda la mesa?" : "¿No será lo de varias personas?"}`, `Heads up: that's more than double what's typical for your category ($${tipicoPP} per person). ${mesa ? "Could it be the whole table?" : "Could it be for several people?"}`)}</div>}
                  <div className="alta-wiz__dialogo-botones">
                    <button type="button" className="alta-btn alta-btn--seguir" onClick={() => { setConfirmaTicket(false); siguiente(); }}>{t("Sí, es por persona →", "Yes, it's per person →")}</button>
                    <button type="button" className="alta-btn" onClick={cerrar}>{t("Corregir el monto", "Fix the amount")}</button>
                  </div>
                </div>
              </div>
            );
          })()}
        </>
      )}

      {pantalla === 5 && (
        <>
          <div className="alta-wiz__pregunta">{t("¿Cada cuánto puede volver el mismo miembro por tu oferta?", "How often can the same member come back for your offer?")}</div>
          {objetivosTexto && <div className="alta-ayuda">{t(`Querías ${objetivosTexto}. Para eso recomendamos ${plazoObjetivo === 1 ? "una vez al día" : `${plazoObjetivo} días`}.`, `You wanted ${objetivosTexto}. For that we recommend ${plazoObjetivo === 1 ? "once a day" : `${plazoObjetivo} days`}.`)}</div>}
          {/* s230 · wizard-frecuencia-segmentada: cinco valores ordenados van en una fila (control segmentado), no en chips
              sueltos. El recomendado lleva la estrella del sprite; el número grande de abajo reacciona al tocar. */}
          <div className="alta-wiz__segmentos" role="group" aria-label={t("Cada cuánto puede volver", "How often they can come back")}>
            {plazos.map(d => (
              <button key={d} type="button" aria-pressed={plazoFinal === d}
                aria-label={etiquetaPlazo(d, en) + (d === plazoObjetivo ? (en ? ", recommended" : ", recomendado") : "")}
                className={["alta-wiz__segmento", plazoFinal === d && "alta-wiz__segmento--on"].filter(Boolean).join(" ")}
                onClick={() => setPlazo(String(d))}>
                {/* s239 · D5: el 1 se lee «1 · vez al día», con el mismo molde que «7 · días» (decía «Diario»; el texto
                    entero no cabe en una columna de ~56 px a 375 px). El aria-label dice «Una vez al día». */}
                <span className="alta-wiz__segmento-num">{d}</span>
                <span className="alta-wiz__segmento-u">{d === 1 ? t("vez al día", "per day") : t("días", "days")}</span>
                {d === plazoObjetivo && <span className="alta-wiz__segmento-reco" aria-hidden="true"><Ico name="ico-destacado" size={12} /></span>}
              </button>
            ))}
          </div>
          <div className="alta-ayuda">{t("Se cuenta desde la medianoche de Miami; si vuelve antes, paga el precio completo. Puedes cambiarlo cuando quieras.", "It counts from midnight Miami time; if they come back sooner, they pay full price. You can change it anytime.")}</div>
          {/* s238 · ayudas W18: «¿y si me llegan 50?» — el límite es el plazo, no un cupo. */}
          <div className="alta-ayuda">{t("No hay un máximo de canjes por día: lo que limita es el plazo. Cada miembro puede usar la oferta una vez por plazo, y tú puedes pausarla cuando quieras.", "There's no daily cap on redemptions: the waiting period is the limit. Each member can use the offer once per period, and you can pause it whenever you want.")}</div>
          <div className="alta-wiz__plazo">
            <div className="alta-wiz__plazo-cifra">
              <span className="alta-wiz__plazo-icono" aria-hidden="true"><Ico name="ico-calendario" size={26} /></span>
              <div><div className="alta-wiz__plazo-numero">{plazoFinal === 1 ? 365 : Math.floor(365 / plazoFinal)}</div>
                <div className="alta-ayuda">{t(`${perfilRubro.visitas.es} al año del mismo miembro, como máximo`, `${perfilRubro.visitas.en} a year from the same member, at most`)}</div></div>
            </div>
            <div className="alta-wiz__texto">{EXPLICA_PLAZO[plazoFinal]}</div>
          </div>
          {plazoFinal === 1 && <div className="alta-aviso alta-aviso--error alta-aviso--campo">{t("Cuidado: con «Una vez al día», el mismo miembro podría usarla cada día que venga. Elígelo solo si tu oferta es chica y tu cliente viene a diario.", "Careful: with “Once a day”, the same member could use it every day they come. Pick it only if your offer is small and your customers come daily.")}</div>}
          {plazoFinal >= 60 && <div className="alta-aviso alta-aviso--campo">{t(`Con ${plazoFinal} días la oferta pierde atractivo: el miembro la ve poco útil y elige otra. Para traer gente nueva, 30 días suele ser suficiente.`, `With ${plazoFinal} days the offer loses appeal: members see little use in it and pick another. To bring new people, 30 days is usually enough.`)}</div>}
          <div className="alta-wiz__ejercicio">
            <b>{t("¿Y tus clientes de siempre?", "What about your regulars?")}</b>
            <div className="alta-ayuda">{plazoFinal === 1
              ? t("Con «Una vez al día», un cliente de siempre que se haga miembro la puede usar cada vez que venga.", "With “once a day”, a regular who becomes a member can use it every time they come.")
              : t(`Si un cliente de siempre se hace miembro, la usa como máximo una vez cada ${plazoFinal} días. Las demás veces paga completo: tu oferta no se vuelve tu precio de siempre.`,
                  `If a regular becomes a member, they use it at most once every ${plazoFinal} days. The other times they pay in full: your offer doesn't become your everyday price.`)}</div>
          </div>
          {acciones(5, t("Ver cómo queda →", "See how it looks →"))}
        </>
      )}
    </div>
  );
}

// Las reglas que va a leer el miembro, antes de enviar (las mismas que arma la ficha).
function ReglasWizardLista({ categoria, en, canal, plazo, tipo, exclusion }) {
  const lineas = tipo === "std"
    ? [...reglasDelRubro(categoria, en, canal), ...(exclusion ? [exclusion] : []), reglaPlazo(plazo, en, categoria)]
    : [...reglasWizard(tipo, categoria, en, canal, exclusion).split(SALTO_LINEA), reglaPlazo(plazo, en, categoria)];
  return (
    <details className="alta-wiz__reglas">
      <summary>{en ? `See the ${lineas.length} rules members will read` : `Ver las ${lineas.length} reglas que leerá el miembro`}</summary>
      <ul>{lineas.map((r, i) => <li key={i}>{r}</li>)}</ul>
    </details>
  );
}

function MerchantCreateOffer() {
  const lang = useLang();
  const navigate = useNavigate();
  const { id: editId } = useParams();        // X.43-bis: si hay :id estamos editando una oferta existente
  const isEdit = !!editId;
  const [stats, setStats] = useState(null);
  const [merchantProfile, setMerchantProfile] = useState(null);
  // s191 — «RESUELTO», que no es lo mismo que «hay perfil». El menu «¿Como quieres
  // empezar?» se pintaba en el primer render y el efecto de rehidratacion lo cambiaba
  // a «ai» un tick despues: el comercio con borrador veia el menu PARPADEAR y no
  // llegaba a leerlo. No alcanza con mirar `merchantProfile`, porque null significa
  // las dos cosas — todavia cargando, o cargo y no hay. Esto separa las dos.
  const [perfilListo, setPerfilListo] = useState(false);
  // s191 — POR QUE PUERTA ENTRO. Con borrador guardado TODAS las puertas caian en las
  // propuestas: «Nueva oferta» no creaba nada nuevo, devolvia lo viejo, y quien queria
  // una promo de temporada no tenia camino. Ahora la puerta lo dice.
  //
  // Se lee de `window.location` y NO con useSearchParams: el intento anterior
  // (7b3527f) sumaba ese hook aca y dejo la pantalla en negro. No esta probado que
  // fuera la causa —falta el error de consola— pero la version que SI funciono
  // («Validar», e06e779) usa este camino, asi que este lo copia. No es un hook: es
  // una lectura, y se recalcula en cada render, que es justo lo que hace falta si
  // Router reusa el componente al cambiar la query.
  const verPropuestas = (() => {
    try { return window.location.search.indexOf("ver=propuestas") !== -1; } catch (_) { return false; }
  })();
  // s227-D4 · `boton-oferta-imperdible`: «Crea una oferta Imperdible» (Mis ofertas) abre el alta con ?imperdible=1.
  // Dos caminos: 2×1 o porcentaje (arranca en 50 %). Formulario en blanco, sin el wizard ni el asesor; nace Pending.
  const modoImperdible = (() => {
    try { return new URLSearchParams(window.location.search).get("imperdible") === "1"; } catch (_) { return false; }
  })();
  // s235 · agrega-otra-franja (propuesta del wizard, Ali): «Agrega otra franja» en Mis ofertas abre el mismo wizard de la
  // primera oferta con ?franja=1, desde la pregunta 1 (sin el arranque ni «Tu negocio en el club»): una oferta más, en
  // otro momento del día.
  const modoFranja = (() => {
    try { return new URLSearchParams(window.location.search).get("franja") === "1"; } catch (_) { return false; }
  })();
  // 1=Tipo · 2=Plantilla · 3=Tu oferta · 4=Los detalles · 5=Revisar.
  // (Decia «4=Review» desde antes de s179 L2, cuando el wizard tenia cuatro pasos.)
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  // s185: aca vivia `editStatus`, que guardaba el status original de la oferta en
  // edicion «solo informativo». Nunca se leyo: era estado muerto, y el lint lo venia
  // avisando. Si alguna vez hay que MOSTRAR el estado en el repaso («esta Aprobada;
  // al guardar lo conserva»), se vuelve a leer de la oferta — no hace falta guardarlo.
  // s148 stopgap: en modo edición solo se puede guardar si la carga trajo datos reales.
  // Si getOfferById vuelve null/capado (privacy: oferta Pending por canal público), el form
  // queda virgen y guardarlo sobrescribiría la oferta con vacíos (update_offer escribe todos
  // los campos sin gates). Este flag bloquea ese save hasta que la hidratación sea confiable.
  const [editHydrated, setEditHydrated] = useState(false);
  // s199-D9 · La oferta que un operador le sembró al comercio y que sigue Pending se edita
  // LIMITADA: tamaño estándar sin Destacada, título y fotos. Y al guardar se vuelve al panel,
  // que es donde está «Confirmar mi oferta». Las ofertas que el comercio crea por su cuenta no
  // pasan por acá. ⚠️ Es un límite de pantalla: `update_offer` sigue abierta por API, y el
  // guard de backend es el ticket `confirm-offer-guard-umbral`.
  // s199, medido en Live: el canal del comercio **NO expone «Created By»** (sí lo expone el de
  // `getAllOffers` que usa el panel), así que acá la señal que queda es el estado del comercio:
  // `Invitado` es, por definición, el que entró por el link de una oferta que le sembraron.
  // Para un comercio ya `Approved` que un operador adopta, el límite no se puede derivar desde
  // esta pantalla: lo cubre el guard de backend (`confirm-offer-guard-umbral`).
  const [ofertaBase, setOfertaBase] = useState(null);   // {delClub, pendiente, creadaPorOtro}
  // s181 B3: «Sin límite de horario» es un ACTO (s180-D4), no la ausencia de horas. Vive
  // solo en la UI: en la base «sin límite» sigue siendo valid_time_start/end vacíos — el
  // contrato con los WFs no cambia. En edición nace activo si la oferta ya vivía sin horas.
  const [sinLimiteHorario, setSinLimiteHorario] = useState(true);   // s215: nace activo (ver valid_days)
  // s181 B2: antes del primer intento de «Revisar →» los avisos de disponibilidad son guía
  // (ámbar); después del intento, son error (rojo). Mismo texto, distinto tono.
  const [intentoRevisar, setIntentoRevisar] = useState(false);
  // s185: el mismo criterio un paso antes. Una oferta sin ahorro no se podía guardar,
  // pero el aviso salía recién al enviar — dos pasos después del campo que lo causa.
  const [intentoContinuar, setIntentoContinuar] = useState(false);
  // s148 P2f: true cuando la oferta nace del asesor IA → payload manda created_by_ai:"yes".
  // ✅ s169, contra el export 59: el param YA ESTÁ EN LIVE en los dos WFs — `create_offer`
  // #27 y `update_offer` #31, ambos `boolean`. Las líneas de "OJO" y el ⏳ de s152 que
  // decían "no lo definen / sin deployar" quedaron vencidas y se borraron.
  //
  // ✅ MEDIDO el 21/08/2026 (censo de las 27 ofertas de Live): la más reciente quedó con
  // el campo en `yes`. Mandar el texto "yes" contra un param declarado `boolean` FUNCIONA
  // — Bubble lo convierte antes del `· is_true`. El sellado es correcto.
  // 🔴 NO cambiar a `true`/`false`. No es una deuda pendiente: es un comportamiento
  // verificado en producción. Tocarlo sería arreglar algo que no está roto.
  const [fromAdvisor, setFromAdvisor] = useState(false);
  // B5.1 (s55): asistente IA de ofertas (read-only, no guarda hasta aplicar+enviar)
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState("");
  const [aiResult, setAiResult] = useState(null);
  // B5.1 carril rápido (s64): entry choice + generación de ofertas con IA.
  // mode: "choose" (elegir método) | "manual" (wizard clásico) | "ai" (carril rápido)
  // s175-D6: con el asesor apagado no hay eleccion que ofrecer — se entra directo al
  // wizard manual y la pantalla de "como quieres empezar?" no existe.
  const [mode, setMode] = useState(ADVISOR_ENABLED && !modoImperdible ? "choose" : "manual");
  const [ingestUrl, setIngestUrl] = useState("");
  const [ingestFile, setIngestFile] = useState(null);
  // s186 · la carta pegada a mano. Cubre lo que ni la URL ni el PDF alcanzan: el
  // comercio que tiene sus precios en Instagram, en su plataforma de reservas o en las
  // notas del teléfono — que es el caso NORMAL de peluquerías, spas y gimnasios, donde
  // no existe una «carta» que leer.
  const [ingestTexto, setIngestTexto] = useState("");
  const [q, setQ] = useState({ goal: "", best: "", ticket: "", extra: "" }); // respuestas del wizard 3-4
  const [fuenteTicket, setFuenteTicket] = useState("");   // s244-D7 · de dónde salió q.ticket: dueno | google | tipico | escrito
  // s186 · el que sabe lo que quiere no tiene que pasar por las plantillas. Con esto en
  // true, elegir el tipo salta directo al formulario vacío.
  const [directoEnBlanco, setDirectoEnBlanco] = useState(modoImperdible);
  const [genLoading, setGenLoading] = useState(false);
  const [genError, setGenError] = useState("");
  const [genOffers, setGenOffers] = useState(null);   // array de ofertas (formShape + _key) o null
  // s253 · el bloque «¿Prefieres porcentaje?» debajo de las propuestas: regla, sin IA. 0 = sin tope.
  const [pctProp, setPctProp] = useState(PCT_DEFECTO);
  const [topeProp, setTopeProp] = useState(0);
  const [genDisclaimer, setGenDisclaimer] = useState("");
  // s169 (s159-D3): selección múltiple + borrador persistente. El asesor tiene cupo
  // (10 generaciones por comercio) y hasta acá lo generado se tiraba: 3 propuestas,
  // 1 usada, 2 perdidas con el cupo gastado igual.
  const [genSelected, setGenSelected] = useState([]);      // _key[] de las marcadas
  const [genDraftAt, setGenDraftAt] = useState("");        // ISO de la generación rehidratada
  const [genDraftLoaded, setGenDraftLoaded] = useState(false); // la rehidratación corre una sola vez
  const [genSaving, setGenSaving] = useState(false);
  // s179 L5.8: se muestran unas pocas tarjetas y el resto detrás de un «ver más». Ocultar
  // NO descarta: genOffers y genSelected quedan intactos, esto solo deja de dibujar.
  // s189-C: el tope sube de 3 a 6. Con el razonamiento plegado cada tarjeta mide un tercio
  // de lo que medía, y en la grilla de escritorio 6 son dos filas — se comparan de un vistazo,
  // que es justamente lo que L5.8 quería y una columna de 3 no daba.
  const [genVerTodas, setGenVerTodas] = useState(false);
  // s189-C: «muéstrame solo las seguras». El nivel de riesgo YA era una clasificación real
  // (ordena la lista desde s179); lo que faltaba era poder pedirla.
  const [genFiltro, setGenFiltro] = useState("todas");   // todas | seguro | audaz | otras
  // s189-C (arreglo C): de dónde salieron estas propuestas, para poder DECIRLO. El rótulo
  // viejo («estas son ideas de ejemplo») tiraba el único argumento que las hace creíbles.
  // "" = no lo sabemos (borrador rehidratado) y el texto se queda en lo que sí es cierto.
  const [genOrigen, setGenOrigen] = useState("");        // sitio | material | respuestas | ""
  const [genNote, setGenNote] = useState("");              // aviso al comercio (guardado / descarte)

  const [form, setForm] = useState({
    offer_type: "", // fixed, bogo, free, percent
    is_alcohol: false, // s143-D3: gatea accrual de cuota de servicio en redeem_coupon (compliance licencia alcohol)
    // FIX-18R (D72): 1 idioma + source_lang; backend auto-traduce al guardar
    title: "",
    description: "",
    cuando_ir: "",      // s212 · solo arma la descripción; no viaja a Bubble
    foto_actual: "",    // s212 · la foto que la oferta ya tiene (edición): cuenta para «foto obligatoria»
    // s253 · fotos por oferta (api.js paramsGalleryPick). null = no tocó la selección (no viaja nada); si no, las URLs de la
    // galería marcadas para mostrar. `principal_galeria` = la de la galería que se usó como principal ("" si la subió).
    galeria_marcadas: null,
    principal_galeria: "",
    rules_text: "",
    source_lang: lang === "en" ? "en" : "es",
    benefit_value_usd: "",
    category: "",
    regular_price: "", coupon_price: "",
    unit_price: "", discount_pct: "", typical_savings: "",
    pct_sin_tope: false,  // s221-D1 3-bis · «Sin tope»: solo UI; viaja como benefit_value_usd = TOPE_SIN_LIMITE
    // s215 · Ali (ensayo con Otto): los horarios eran difíciles de llenar. Una oferta nueva nace
    // «todos los días, sin límite» y el dueño solo toca si quiere menos (supersede s181 B1/B3).
    valid_days: FEED_DAY_TOKENS.join(","), valid_time_start: "", valid_time_end: "",
    min_consumption: "", // s154 lote C: consumo mínimo en USD, opcional (0/vacío = sin mínimo)
    highlight_1: "", highlight_2: "", highlight_3: "",
    // s194 L1 · formato único. Solo UI: no viajan en el payload (que nombra sus keys).
    umbral_tamano: "",        // id de UMBRAL_TAMANOS (S · M · L · XL · D)
    umbral_tamano_cena: "",   // el segundo tamaño cuando hay dos franjas
    umbral_franjas: false,    // «dos tamaños por franja» = dos ofertas al enviar
    cooldown_days: "",        // s213 · el plazo (lote C): lo leen las reglas y, al editar, el selector y update_offer
    plan: "",                 // s213 · el plan (lote B): solo al editar, viaja en update_offer
    redemption_channel: "",   // s222 · el canal elegido; vacío = el del rubro (preseleccionado, ver canalForm)
  });
  const [imageFile, setImageFile] = useState(null);
  // s212 · la foto pasa por el encuadre (regla permanente s206: nunca un archivo crudo al WF).
  const [fotoPorEncuadrar, setFotoPorEncuadrar] = useState(null);
  // s253 · «Elegir de mi galería» (Ali): la foto de la oferta puede salir de la galería del negocio. `galeriaAbierta`
  // muestra las miniaturas; `bajandoDeGaleria` es la URL que se está bajando para pasarla por el encuadre.
  const [galeriaAbierta, setGaleriaAbierta] = useState(false);
  // La foto de la galería que está en el encuadre: pasa a `principal_galeria` recién cuando el dueño la confirma.
  const principalPendiente = useRef("");
  // s253 · la foto nueva (todavía un archivo) vista en «Revisar»; la URL se libera al cambiarla o al salir.
  const [vistaPreviaFoto, setVistaPreviaFoto] = useState("");
  useEffect(() => {
    if (!imageFile) { setVistaPreviaFoto(""); return undefined; }
    const u = URL.createObjectURL(imageFile);
    setVistaPreviaFoto(u);
    return () => URL.revokeObjectURL(u);
  }, [imageFile]);
  const [bajandoDeGaleria, setBajandoDeGaleria] = useState("");
  const [errorGaleria, setErrorGaleria] = useState(false);
  const [faltaFoto, setFaltaFoto] = useState(false);
  // s194 L1 (s193-D13): los cuatro tipos de siempre viven detrás de «avanzado».
  const [verAvanzado, setVerAvanzado] = useState(false);

  useEffect(() => {
    getMerchantStats().then(s => setStats(s)).catch(() => {});
    getMerchantProfile().then(p => {
      setMerchantProfile(p);
      // En modo crear, heredamos la categoría del perfil. En modo editar, la oferta manda (no pisar).
      if (p?.category && !isEdit) setForm(f => ({ ...f, category: f.category || p.category }));
    }).catch(() => {}).finally(() => setPerfilListo(true));
  }, [isEdit]);

  // s223 · 2b · LA PRIMERA OFERTA ENTRA POR EL WIZARD (s221-D2 §0.2). Sin ninguna oferta (en ningún estado) y sin
  // propuestas del asesor guardadas, el alta es el wizard; con alguna, el menú de siempre (plantillas, en blanco).
  // undefined = todavía no se sabe (no se pinta ni el menú ni el wizard, para que no parpadee). Si la cuenta falla,
  // false: el alta sigue como antes.
  const [esPrimera, setEsPrimera] = useState(isEdit ? false : undefined);
  const [wizardEnviadas, setWizardEnviadas] = useState(0);
  // s227-D1 · después de enviar la 1.ª oferta, si falta confirmar el correo: la pantalla del código (una sola, aunque
  // el wizard haya creado varias). «Lo hago después» o «Seguir» van a Mis ofertas.
  const [pideCorreo, setPideCorreo] = useState(false);
  const [wizardAvisoFotos, setWizardAvisoFotos] = useState("");   // s223 · fotos que no entraron a la galería
  useEffect(() => {
    if (isEdit) { setEsPrimera(false); return undefined; }
    if (!perfilListo) return undefined;
    const mid = merchantProfile?.merchant_id || "";
    let borrador = null;
    try { borrador = ADVISOR_ENABLED ? readAdvisorDraft(merchantProfile, "es") : null; } catch (_) { borrador = null; }
    if (!mid || borradorTrabajado(borrador)) { setEsPrimera(false); return undefined; }
    let on = true;
    contarOfertasDelComercio(mid)
      .then(n => { if (on) setEsPrimera(n === 0); })
      .catch(() => { if (on) setEsPrimera(false); });
    return () => { on = false; };
  }, [isEdit, perfilListo, merchantProfile]);

  // s169 REHIDRATACIÓN — las propuestas guardadas vuelven solas, SIN volver a generar.
  // Esto NO consume cupo: es lectura del perfil que el efecto de arriba ya trajo.
  // Degradación limpia: mientras last_advisor_json no exista (ni el campo, ni su
  // línea en la whitelist de get_merchant_profile), readAdvisorDraft devuelve null
  // y esto es un no-op silencioso. El día que exista, hidrata sin tocar React.
  useEffect(() => {
    if (!ADVISOR_ENABLED || isEdit || genDraftLoaded || !perfilListo) return;
    setGenDraftLoaded(true);
    let d = null;
    try { d = readAdvisorDraft(merchantProfile, form.source_lang); } catch (_) { /* nunca romper por el borrador */ }
    if (!d || !d.offers.length) return;
    setGenOffers(d.offers);
    setGenSelected(d.selectedKeys);
    setGenDraftAt(d.generatedAt || "");
    // El menu tambien necesita el borrador CARGADO para poder ofrecerlo con su
    // numero; lo que depende de la puerta es el salto, no la carga.
    if (!verPropuestas) return;
    // s189-C (arreglo A) · SI HAY BORRADOR, ESTA PANTALLA ES EL BORRADOR.
    // Los tres botones de la bienvenida traen acá, y acá se caía siempre en «¿Cómo quieres
    // empezar?», cuya primera opción es «Generar con IA»: al comercio que YA tiene doce
    // propuestas pagadas el flujo lo empujaba a gastar otra generación y a pisar su propio
    // borrador con el merge. Con propuestas guardadas se entra directo a verlas.
    // No es una puerta cerrada: «← Atrás» vuelve al menú en un click (mode !== "choose").
    setMode("ai");
  }, [merchantProfile, perfilListo, isEdit, genDraftLoaded, form.source_lang, verPropuestas]);

  // s213 · una oferta sembrada llega sin descripción (seed_merchant la guarda en el comercio): al
  // editarla, el campo nace con la del comercio, que trae «lo que más piden» y «cuándo conviene»
  // que anotó Otto. Una sola vez, y solo si sigue vacío: nunca pisa lo que escribió el dueño.
  const descripcionDelComercioPuesta = useRef(false);
  useEffect(() => {
    if (!isEdit || !editHydrated || !ofertaBase?.delClub || descripcionDelComercioPuesta.current || !merchantProfile) return;
    descripcionDelComercioPuesta.current = true;
    setForm(f => {
      if (f.description) return f;
      const d = f.source_lang === "en"
        ? (merchantProfile.description_en || merchantProfile.description_es)
        : (merchantProfile.description_es || merchantProfile.description_en);
      return d ? { ...f, description: d } : f;
    });
  }, [isEdit, editHydrated, ofertaBase, merchantProfile]);

  // X.43-bis: en modo edición, cargar la oferta y pre-poblar el form, saltando al paso de Detalles.
  useEffect(() => {
    if (!isEdit) return;
    let cancelled = false;
    setLoading(true);
    setEditHydrated(false);
    // s148 P1: canal AUTENTICADO (regla "Merchant sees own offers"). getMyOfferById valida
    // completitud (typical_savings/unit_price/image presentes) y devuelve null si la lectura
    // cayó a un canal capado — acá eso se traduce en error visible + save bloqueado.
    getMyOfferById(editId).then(o => {
      if (cancelled) return;
      // s148 stopgap: una oferta real siempre tiene offer_type + algún título. Si no vinieron,
      // la carga vino vacía o capada (privacy/404/ownership) — no hidratar, save bloqueado.
      if (!o || !o.offer_type || !(o.title_es || o.title_en)) {
        setError(lang === "en"
          ? "Could not load this offer's data. Editing is disabled to protect it — please try again later."
          : "No se pudieron cargar los datos de la oferta. La edición está deshabilitada para protegerla — inténtalo más tarde.");
        return;
      }
      const num = (v) => (v === 0 || v ? String(v) : "");
      // FIX-18R: pre-poblar desde el idioma fuente guardado, o ES por default.
      const srcLang = o.source_lang === "en" ? "en" : "es";
      setForm(f => ({
        ...f,
        offer_type: o.offer_type || "",
        is_alcohol: o.is_alcohol === true || o.is_alcohol === "yes", // Data API da booleano, algunos WFs dan texto (mismo criterio que featured en normalizeOffer)
        title: (srcLang === "en" ? (o.title_en || o.title_es) : (o.title_es || o.title_en)) || "",
        description: (srcLang === "en" ? (o.description_en || o.description_es) : (o.description_es || o.description_en)) || "",
        // s213 · en la estándar, «Condiciones extra» muestra solo lo propio del comercio: las reglas del
        // club (y la vieja del plazo) se agregan solas al guardar (compilarReglasUmbral). Antes el campo
        // traía las siete del club como si las hubiera escrito él.
        rules_text: (() => {
          const r = (srcLang === "en" ? (o.rules_text_en || o.rules_text_es) : (o.rules_text_es || o.rules_text_en)) || "";
          // s223 · la línea del plazo armada no es del comercio: se arma desde cooldown_days (y se cambia con el selector).
          // s223 · en el %, como en la estándar: lo del club y lo genérico no son del comercio.
          if (esPorcentaje(o)) return r.split(SALTO_LINEA).map(x => x.trim()).filter(l => l && !esReglaFija(l) && !esReglaPlazoGuardada(l) && !esReglaPlazoArmada(l)).join(SALTO_LINEA);
          if (!esUmbral(o)) return r.split(/\r?\n/).filter(l => !esReglaPlazoArmada(l.trim())).join(SALTO_LINEA);
          return r.split(/\r?\n/).map(x => x.trim())
            .filter(l => l && !esReglaFija(l) && !esReglaPlazoGuardada(l)).join(SALTO_LINEA);
        })(),
        foto_actual: o.image || (Array.isArray(o.images) && o.images[0]) || "",
        // s253 · la selección guardada (null si la oferta muestra la galería entera: nace todo marcado).
        ...(() => { const p = leerGalleryPick(o.gallery_pick);
          return p ? { galeria_marcadas: p.extras, principal_galeria: p.principal } : { galeria_marcadas: null, principal_galeria: "" }; })(),
        source_lang: srcLang,
        // s156: un 0 guardado NO es un valor elegido, es un campo que nunca se pudo calcular.
        // Hidratarlo como "0" dejaba effectiveBenefitValue clavado en 0 para siempre:
        // la oferta no se podia aprobar ni volviendo a guardarla.
        // s221-D1: en un % es el TOPE; un «Sin tope» ($1.000) no se muestra como número: marca la casilla.
        benefit_value_usd: (() => {
          const n = Number(o.benefit_value_usd ?? o.benefit_value);
          if (esPorcentaje(o) && esSinTope(n)) return "";
          return Number.isFinite(n) && n > 0 ? String(n) : "";
        })(),
        pct_sin_tope: esPorcentaje(o) && esSinTope(o.benefit_value_usd ?? o.benefit_value),
        category: o.category || f.category || "",
        regular_price: num(o.regular_price),
        coupon_price: num(o.coupon_price),
        unit_price: num(o.unit_price),
        discount_pct: num(o.discount_pct),
        typical_savings: num(o.typical_savings),
        // s154 lote D: se hidrata ya normalizado al vocabulario controlado — al guardar,
        // la oferta vieja queda limpia (migración suave, sin backfill).
        // s213 · una oferta guardada SIN días (toda la que siembra Otto: seed_merchant no escribe
        // valid_days) ya se sirve los siete días; al editarla, «Todos los días» nace marcado — el
        // mismo criterio que s181 B3 con «Sin límite de horario». Antes el paso 4 trababa al dueño
        // con «Selecciona al menos un día» (recorrido s213, H6). Solo si la base no trae NADA: un
        // valor que no se reconoce sigue vacío, para que el comercio lo vea y lo arregle.
        valid_days: normalizeValidDays(o.valid_days)
          || ((Array.isArray(o.valid_days) ? o.valid_days.some(x => String(x ?? "").trim()) : String(o.valid_days ?? "").trim())
            ? "" : FEED_DAY_TOKENS.join(",")),
        valid_time_start: normalizeValidTime(o.valid_time_start),
        valid_time_end: normalizeValidTime(o.valid_time_end),
        min_consumption: num(o.min_consumption),
        highlight_1: o.highlight_1_es || o.highlight_1 || "",
        highlight_2: o.highlight_2_es || o.highlight_2 || "",
        highlight_3: o.highlight_3_es || o.highlight_3 || "",
        // s194 L1: el tamaño se deriva de los dos números guardados ("" si no calza con ninguno).
        umbral_tamano: tamanoDeUmbral(o.benefit_value_usd ?? o.benefit_value, o.min_consumption)?.id || "",
        cooldown_days: num(o.cooldown_days),
        plan: PLANES_OFERTA.find(p => p.id === o.plan || p.es === o.plan)?.id || "",
        redemption_channel: canalValido(o.redemption_channel),
      }));
      // s181 B3: una oferta vieja sin horas ya se sirve «todo el día» — el toggle nace activo
      // y el comercio lo ve como lo que es: un acto, que puede revertir.
      setSinLimiteHorario(!normalizeValidTime(o.valid_time_start) && !normalizeValidTime(o.valid_time_end));
      setFromAdvisor(o.created_by_ai === "yes" || o.created_by_ai === true); // preservar origen al editar
      setEditHydrated(true); // s148 stopgap: recién ahora el save es seguro
      // s179 L2: el edit arranca en 3a «Tu oferta» (ya tiene tipo + datos). Sigue siendo
      // el paso 3, así que el piso del botón Atrás (`isEdit ? 3 : 1`) no cambia: en modo
      // edición no se puede bajar de 3a, que es donde empieza el formulario.
      setStep(3);
      // s199-D9 · mismo criterio que el bloque del panel (`MerchantConfirmarOferta`): umbral,
      // todavía Pending, y la creó OTRO. «Created By» (con espacio) solo viene en el canal del
      // panel; acá suele faltar, y por eso el estado del comercio decide (ver el useState).
      setOfertaBase({
        delClub: esFormatoClub(o),   // s238 · pct-barrido: antes `umbral: esUmbral(o)` (la sembrada en % no se reconocía)
        pendiente: String(o.status || "").toLowerCase() === "pending",
        creadaPorOtro: !!o["Created By"] && o["Created By"] !== auth.getUserId(),
      });
    }).catch(() => {
      if (!cancelled) setError(lang === "en" ? "Could not load the offer." : "No se pudo cargar la oferta.");
    }).finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [isEdit, editId, lang]);

  const set = (key) => (e) => setForm(f => ({ ...f, [key]: typeof e === "string" ? e : e.target.value }));
  const setVal = (key, val) => setForm(f => ({ ...f, [key]: val }));

  // s156: elegir tipo limpia los precios que el tipo nuevo NO muestra en pantalla.
  // Sin esto una percent viaja con el regular_price/coupon_price que el comercio cargó
  // como fixed y después nadie volvió a ver — la causa raíz de Taikin/Otto. Solo en ALTA:
  // en edición los precios vienen hidratados de la base y son el dato real de la oferta.
  const chooseOfferType = (typeId) => setForm(f => {
    const next = { ...f, offer_type: typeId };
    if (!isEdit) {
      const keep = PRICE_FIELDS_BY_TYPE[typeId] || [];
      ALL_PRICE_FIELDS.forEach(k => { if (!keep.includes(k)) next[k] = ""; });
      // s194 L1: el beneficio y el mínimo los fija el tamaño en umbral y los escribe el
      // comercio en los otros tipos. Al entrar o salir de umbral no puede quedar un
      // residuo de ninguno de los dos (mismo criterio que los precios, s156).
      if (typeId === UMBRAL_TIPO || f.offer_type === UMBRAL_TIPO) {
        next.benefit_value_usd = ""; next.min_consumption = "";
        next.umbral_tamano = ""; next.umbral_tamano_cena = ""; next.umbral_franjas = false;
      }
      // s221-D1: en el % el benefit es el tope que escribe el comercio; no puede heredarse de otro tipo.
      if (typeId === "percent" || f.offer_type === "percent") {
        next.benefit_value_usd = ""; next.min_consumption = ""; next.pct_sin_tope = false;
        if (typeId === "percent" && esTituloPorcentajeGenerado(f.title)) next.title = "";
      }
    }
    return next;
  });

  // B5.1: pide sugerencias de IA sobre el borrador actual (WF read-only suggest_offer_improvements).
  const suggestAI = async () => {
    if (!form.title) { setAiError(lang === "en" ? "Add a title first" : "Agrega un título primero"); return; }
    setAiLoading(true); setAiError(""); setAiResult(null);
    try {
      const r = await suggestOfferImprovements({ title: form.title, description: form.description, lang: form.source_lang });
      setAiResult(r);
    } catch (e) {
      // s176 FIX 1: cada error_code con su texto (antes: siempre el generico).
      setAiError(advisorErrorMessage(e, lang));
    } finally {
      setAiLoading(false);
    }
  };
  // Reparte un texto de destacados sugeridos en highlight_1/2/3 (separa por salto, ;, |, • o coma).
  const applyHighlights = (text) => {
    const parts = String(text || "").split(/\n|;|\||•|•|,/).map(s => s.trim()).filter(Boolean).slice(0, 3);
    setForm(f => ({
      ...f,
      highlight_1: parts[0] || f.highlight_1,
      highlight_2: parts[1] || f.highlight_2,
      highlight_3: parts[2] || f.highlight_3,
    }));
  };

  // ===== B5.1 CARRIL RÁPIDO (s64) =====
  // Rubro del merchant → margen rubro-específico (B5.1-D15 en el WF offer_advisor).
  //
  // s186 · `asesor-recibe-categoria-no-subcategoria`. Acá salían DOS cosas distintas de
  // la misma variable, y por eso el asesor cobraba el margen equivocado:
  //   • el RUBRO (`business_type`, 14 claves finas) es el eje con el que MarginProfile
  //     busca su fila — es lo que va al asesor;
  //   • la CATEGORÍA (`OfferCategory`, 6 slugs) es el eje de browse del catálogo — es
  //     lo que se escribe en la oferta.
  // Mandando la categoría al asesor, fine dining, pizzería y QSR colapsaban los tres a
  // `restaurante_casual` (ADVISOR_RUBRO_MAP, api.js): 25/35/32 en vez de 40/45/25.
  // El dato fino ya viaja en `get_merchant_profile` — se usa cuando existe.
  //
  // ⚠️ Esto NO alcanza solo: `MerchantPartner.business_type` está vacío en 16/16 de dev
  // y en 17 de 26 fichas leídas de Live. Con el campo vacío cae al fallback por categoría
  // y el resultado es el mismo de antes. El eslabón que manda es el backfill del campo
  // (ticket `business-type-vacio-en-los-comercios`); esta línea es la que lo aprovecha.
  const advisorRubro = merchantProfile?.business_type || form.category || merchantProfile?.category || "Restaurant";
  // La categoría del catálogo sigue siendo la que rellena la oferta (applyGeneratedOffer).
  // NO fusionar con la de arriba: escribiría `cafe_brunch` en un campo que espera `Restaurant`.
  // s199-D9 · «Quiero cambiar algo»: la oferta sembrada, todavía sin confirmar. El perfil
  // manda cuando el canal de la oferta no trae quién la creó (lo normal en esta pantalla).
  const ofertaSembrada = !!ofertaBase && ofertaBase.delClub && ofertaBase.pendiente
    && (ofertaBase.creadaPorOtro || String(merchantProfile?.status || "").trim().toLowerCase() === "invitado");
  const categoriaOferta = form.category || merchantProfile?.category || "Restaurant";
  // s244-D7 · el ticket es obligatorio para la IA: de él salen los cuatro tamaños (tamanosDelAsesor). Sin número, no se llama.
  const ticketIA = parseFloat(String(q.ticket || "").replace(",", ".")) || 0;
  const tamanosIA = ticketIA > 0 ? tamanosDelAsesor({ categoria: categoriaOferta, tipoNegocio: merchantProfile?.business_type, porPersona: ticketIA, lang: form.source_lang }) : null;
  const avisoFaltaTicket = lang === "en"
    ? "Write how much one person spends on average: the offer sizes come from that number."
    : "Escribe cuánto gasta una persona en promedio: de ese número salen los tamaños de las ofertas.";
  // s233 · plazo-default-por-rubro: una oferta NUEVA nace con el del rubro (15 en comida y bebida). Al editar, una
  // oferta vieja sin plazo guardado tiene el de Bubble (30): se sigue mostrando ese, no se le cambia.
  const plazoNace = isEdit ? COOLDOWN_POR_DEFECTO : plazoDelRubro(categoriaOferta);

  // s186 · NO TODOS TIENEN UNA CARTA, y le estábamos ofreciendo a todos el archivo
  // primero. Un restaurante, un bar o una heladería tienen menú; una peluquería, un
  // spa o un gimnasio tienen lista de servicios — y muchas veces vive solo en su
  // Instagram o en su plataforma de reservas, no en un archivo ni en una URL.
  // Para esos, el wizard de tres preguntas NO es el plan de repuesto: es el único
  // camino que tienen, y se lo mostrábamos abajo, rotulado como «Opción B».
  // No se esconde nada: se invierte el ORDEN, y los rótulos A/B siguen a la posición
  // para que no queden mintiendo. Retail queda del lado del archivo: una boutique o una
  // licorería suelen tener su catálogo en la web.
  // s188 - `SIN_CARTA` vive ahora a nivel de modulo (junto a COPY_ALTA) para que
  // el copy lea LA MISMA lista que el orden. Los dos consumidores se nombran por
  // lo que hacen, no por la lista - L#621: una variable con dos consumidores se
  // parte en dos NOMBRES, no en dos fuentes.
  const preguntasPrimero = SIN_CARTA.includes(categoriaOferta);
  // `txt` es lo que lee el COMERCIO (su idioma de interfaz). `txtOferta` son los
  // ejemplos del texto que ESCRIBE, que va en el idioma de la oferta - dos ejes
  // distintos que ya existian por separado en esta pantalla.
  const txt = copyDelAlta(categoriaOferta, lang);
  const txtOferta = copyDelAlta(categoriaOferta, form.source_lang);
  const rotuloArchivo = preguntasPrimero ? (lang === "en" ? "Option B" : "Opción B") : (lang === "en" ? "Option A" : "Opción A");
  const rotuloPreguntas = preguntasPrimero ? (lang === "en" ? "Option A" : "Opción A") : (lang === "en" ? "Option B" : "Opción B");

  // Arma el contexto libre que va al asesor con las respuestas del wizard.
  const buildUserContext = () => {
    const L = [];
    if (q.goal) L.push((lang === "en" ? "Goal: " : "Objetivo: ") + q.goal);
    if (q.best) L.push((lang === "en" ? "Best-seller: " : "Lo que más vende: ") + q.best);
    // s215 · nota 5: el ticket se pregunta como en el resto (mesa de dos en restaurantes y bares) y la IA
    // recibe la unidad explícita; antes «Ticket promedio: $60» no decía si era por persona o por mesa.
    if (q.ticket) L.push((lang === "en" ? `Avg ticket ${preguntaTicket(categoriaOferta, true).unidad}: $` : `Ticket promedio ${preguntaTicket(categoriaOferta, false).unidad}: $`) + q.ticket);
    if (q.extra) L.push((lang === "en" ? "Notes: " : "Notas: ") + q.extra);
    return L.join(" || ");
  };

  // s169: guarda el estado actual de propuestas + selección en last_advisor_json.
  // Silencioso si el backend todavía no existe — persistAdvisorDraft nunca lanza.
  const persistDraft = async (offers, selectedKeys, generatedAt) => {
    return persistAdvisorDraft({
      merchantId: merchantProfile?.merchant_id || "",
      offers,
      selectedKeys,
      generatedAt: generatedAt || genDraftAt,
    });
  };

  // s169 GUARD ANTI-PISADA: una generación nueva NO puede borrar lo que el comercio
  // marcó. Se fusiona — lo marcado se conserva, lo no marcado se descarta (regla de
  // Ali en s169: sin esto la lista crece sin techo), lo nuevo se agrega sin marcar.
  const absorbGeneration = async (r) => {
    const prev = genOffers || [];
    const merged = mergeGenerations(prev, genSelected, withKeys(r.offers));
    const at = new Date().toISOString();
    setGenOffers(merged.offers);
    setGenSelected(merged.selectedKeys);
    // s186 · NO se pisa con vacío. El guard de idempotencia del ingest (s186-D1)
    // devuelve `CACHED` con success/code/advisor_json y SIN `disclaimer`: la segunda
    // corrida sobre la misma URL traía las propuestas y borraba el texto legal que
    // ya estaba en pantalla. Un dato que la respuesta no trae no es un dato vacío.
    setGenDisclaimer((prev) => r.disclaimer || prev);
    setGenDraftAt(at);
    // Punto 5 de s159-D3: el descarte se avisa, no pasa solo. Y si hubo rebalse por
    // el techo, también — el comercio tiene que entender por qué no ve todo lo nuevo.
    const parts = [];
    if (merged.added > 0) parts.push(lang === "en" ? `${merged.added} new` : `${merged.added} nuevas`);
    if (merged.kept > 0) parts.push(lang === "en" ? `${merged.kept} kept` : `${merged.kept} conservadas`);
    if (merged.discarded > 0) parts.push(lang === "en" ? `${merged.discarded} unmarked discarded` : `${merged.discarded} sin marcar descartadas`);
    if (merged.overflowed > 0) {
      // s189-C (arreglo D) · «desmarca alguna para hacer lugar» es un consejo imposible
      // cuando no hay NADA marcado, que es exactamente el caso de la primera generación:
      // el comercio leía que tenía que desmarcar algo y no había una sola casilla tildada.
      // Con selección previa vacía, el rebalse no lo causó su elección — lo causó el techo.
      const habiaMarcadas = genSelected.length > 0;
      parts.push(lang === "en"
        ? (habiaMarcadas
          ? `${merged.overflowed} didn't fit (max ${MAX_SAVED_PROPOSALS} saved — unmark some to make room)`
          : `${merged.overflowed} didn't fit: we keep up to ${MAX_SAVED_PROPOSALS} per business`)
        : (habiaMarcadas
          ? `${merged.overflowed} no entraron (máximo ${MAX_SAVED_PROPOSALS} guardadas — desmarca alguna para hacer lugar)`
          : `${merged.overflowed} no entraron: guardamos hasta ${MAX_SAVED_PROPOSALS} por comercio`));
    }
    // 🔴 s189-E · UNA GENERACIÓN QUE NO AGREGA NADA NO PUEDE PASAR EN SILENCIO.
    // Medido en producción el 05/09: el comercio pegó su URL, tocó «Generar desde mi
    // sitio», y no pasó absolutamente nada en pantalla. No falló — el WF tiene guard de
    // idempotencia (`ingested_url is url`, s186-D1) y devolvió CACHED, o sea las mismas
    // propuestas que ya estaban. El merge las dedupe por `_key`, así que added=0,
    // discarded=0, overflowed=0… y el aviso quedaba vacío.
    // Desde donde está parado el comercio, «no pasó nada» y «se rompió» son lo mismo. Y
    // esto es EXACTAMENTE lo que va a tocar cualquiera que quiera «más ideas».
    // El mensaje además dice la parte buena, que es real: no se gastó una generación.
    const sinNovedad = merged.added === 0 && merged.discarded === 0 && merged.overflowed === 0;
    setGenNote(
      sinNovedad
        ? (lang === "en"
          ? "These are the same ideas we already had for that source — no new generation was used. To get different ones, change the source or add your prices."
          : "Son las mismas ideas que ya teníamos de esa fuente — no se gastó una generación nueva. Para tener otras, cambia la fuente o agrega tus precios.")
        : (merged.discarded > 0 || merged.overflowed > 0) ? parts.join(" · ") : ""
    );
    // s189-C: una generación nueva no puede quedar escondida detrás de un filtro puesto
    // para la anterior.
    setGenFiltro("todas");
    await persistDraft(merged.offers, merged.selectedKeys, at);
  };

  const runAdvisor = async (fn) => {
    // s169 FIX: NO se limpia genOffers acá. Antes se ponía en null antes de llamar y
    // el catch solo escribía genError → una regeneración fallida destruía una
    // generación buena, con el cupo ya gastado. Se limpia solo al tener respuesta.
    setGenLoading(true); setGenError("");
    try {
      const r = await fn();
      // s176 FIX 6: success:"yes" con cero ofertas parseadas. Se tira con CÓDIGO, no con
      // un mensaje suelto, para que el texto viva en advisorErrorMessage junto al resto y
      // los dos carriles digan lo mismo. Antes cada uno improvisaba el suyo.
      if (!r.offers || r.offers.length === 0) {
        const empty = new Error("ADVISOR_EMPTY");
        empty.code = "ADVISOR_EMPTY";
        throw empty;
      }
      await absorbGeneration(r);
    } catch (e) {
      // s176 FIX 1: idem — NOT_MERCHANT y GENERATION_LIMIT dejan de verse iguales.
      setGenError(advisorErrorMessage(e, lang));
    } finally {
      setGenLoading(false);
    }
  };

  // Carril preguntas (DESBLOQUEADO): wizard 3-4 → offer_advisor.
  const generateFromQuestions = () => {
    if (!tamanosIA) { setGenError(avisoFaltaTicket); return; }
    setGenOrigen("respuestas");   // s189-C (arreglo C)
    // s244 · el perfil ya cargado lleva al asesor el texto del negocio y el horario (api.js bloquesDelPerfil).
    return runAdvisor(() => getOfferAdvice({ business_type: advisorRubro, user_context: buildUserContext(), lang: form.source_lang, perfil: merchantProfile || undefined, tamanos: tamanosIA }));
  };

  // Carril URL/menú: intenta ingest; si no está disponible (Firecrawl/D10 pendiente)
  // o falla, cae automáticamente al wizard de preguntas (sin trabar al merchant).
  // s186 · Por qué falla cada PDF, en palabras del comercio. Un «no se pudo» genérico hace
  // que lo intente tres veces con el mismo archivo.
  const mensajeMenu = (motivo) => {
    const en = lang === "en";
    if (motivo === "NO_ES_PDF") return en
      ? "For now we can only read PDFs. If you have a photo of your menu, use the three questions below — they work just as well."
      : "Por ahora solo podemos leer PDF. Si tienes una foto del menú, usa las tres preguntas de abajo — funcionan igual de bien.";
    if (motivo === "MUY_GRANDE") return en
      ? "That file is too large (12 MB max)."
      : "Ese archivo es muy grande (máximo 12 MB).";
    return en
      ? "We couldn't read the text in that PDF — that usually means it's a scan or a photo inside a PDF. Answer the three questions below and we'll draft your offers anyway."
      : "No pudimos leer el texto de ese PDF — suele pasar cuando es un escaneo o una foto dentro del PDF. Responde las tres preguntas de abajo y te armamos las ofertas igual.";
  };

  const generateFromUrl = async () => {
    const pegado = (ingestTexto || "").trim();
    if (!ingestUrl && !ingestFile && !pegado) { setGenError(lang === "en" ? "Add a link, a PDF or paste your menu first" : "Agrega un link, un PDF o pega tu carta primero"); return; }
    if (!tamanosIA) { setGenError(avisoFaltaTicket); return; }
    // s169 FIX: mismo caso que runAdvisor — no limpiar hasta tener respuesta. Este
    // carril cae al wizard de preguntas cuando el ingest falla, y limpiar antes hacía
    // que ese fallback llegara con la pantalla vacía.
    setGenLoading(true); setGenError("");
    try {
      // s186 · EL MENÚ NO PASA POR EL INGEST. Antes se serializaba a data URL y se mandaba
      // como `doc`, un param que ese WF no declara: Bubble lo descartaba en silencio y el
      // comercio veía «no pudimos leer tu sitio» sin entender por qué (`ingest-doc-param-ausente`).
      // Ahora el texto se extrae acá y viaja por `offer_advisor` — el carril del wizard, que
      // declara `user_context` REQUIRED y lo usa. Sin tocar Bubble y sin gastar Firecrawl.
      // El lector se carga con import() dinámico: es su propio chunk y no lo baja nadie
      // hasta que elige un archivo.
      let textoCarta = "";
      if (ingestFile) {
        const { extraerTextoPdf } = await import("./leerPdf");
        const leido = await extraerTextoPdf(ingestFile);
        if (leido.ok) textoCarta = leido.texto;
        // s186 · si el PDF no se dejó leer PERO además pegó la carta, se sigue con lo
        // pegado en vez de mandarlo de vuelta con un error. Un escaneo que falla no
        // tiene por qué tirar abajo el trabajo que la persona ya hizo a mano.
        else if (!pegado) { setGenError(mensajeMenu(leido.motivo)); return; }
      }
      if (!textoCarta && pegado) textoCarta = pegado.slice(0, 6000);
      setGenOrigen(textoCarta ? "material" : "sitio");   // s189-C (arreglo C)
      if (textoCarta) {
        // Si además respondió las preguntas, las dos cosas van juntas: la carta dice QUÉ
        // vende y las respuestas dicen QUÉ QUIERE lograr.
        const contexto = [
          lang === "en" ? "MENU / PRICE LIST:" : "CARTA / LISTA DE PRECIOS:",
          textoCarta,
          buildUserContext(),
        ].filter(Boolean).join("\n");
        const rMenu = await getOfferAdvice({ business_type: advisorRubro, user_context: contexto, lang: form.source_lang, perfil: merchantProfile || undefined, tamanos: tamanosIA });
        if (!rMenu.offers || rMenu.offers.length === 0) {
          const vacio = new Error("ADVISOR_EMPTY"); vacio.code = "ADVISOR_EMPTY"; throw vacio;
        }
        await absorbGeneration(rMenu);
        return;
      }
      const r = await ingestOfferIdeas({ business_type: advisorRubro, url: ingestUrl, lang: form.source_lang, perfil: merchantProfile || undefined, tamanos: tamanosIA });
      // s176 FIX 6: esto tiraba `new Error("EMPTY")` sin código, y advisorErrorMessage,
      // al no encontrar código, devolvía e.message — o sea que el comercio veía en
      // pantalla la palabra "EMPTY". Ahora va con código y mensaje de verdad.
      if (!r.offers || r.offers.length === 0) {
        const empty = new Error("ADVISOR_EMPTY");
        empty.code = "ADVISOR_EMPTY";
        throw empty;
      }
      await absorbGeneration(r);
    } catch (e) {
      // s176 FIX 1: el fallback "no podemos leer tu sitio" es correcto SOLO cuando el
      // ingest no esta disponible. Si el WF rechazo con un codigo real (cupo agotado,
      // no-merchant), ese es el mensaje que tiene que ver el comercio — si no,
      // reintenta contra una puerta cerrada con el cupo ya gastado.
      setGenError(advisorErrorMessage(e, lang));
    } finally {
      setGenLoading(false);
    }
  };

  // s169: marcar/desmarcar una propuesta. Solo estado local — el guardado es explícito
  // (botón «Guardar las marcadas»), para que el comercio sepa qué quedó guardado.
  // s189-C (arreglo B) · EL TECHO SE APLICA AL MARCAR, NO AL GUARDAR.
  // Hasta acá se podían marcar 12, `buildDraftPayload` recortaba a 8 POR ORDEN DE LISTA —
  // sin mirar la selección— y el mensaje decía «Guardaste 10 ofertas». Dos de las que el
  // comercio eligió a mano desaparecían en silencio, y eso contradice s188-D4: lo marcado
  // es intocable, el techo recorta lo NUEVO. Ahora el tope se ve antes de marcar, la casilla
  // 9 no se puede tildar, y lo que se guarda es exactamente lo que quedó marcado.
  const topeAlcanzado = genSelected.length >= MAX_SAVED_PROPOSALS;
  const toggleGenSelected = (key) => {
    setGenNote("");
    setGenSelected(sel => {
      if (sel.includes(key)) return sel.filter(k => k !== key);
      if (sel.length >= MAX_SAVED_PROPOSALS) return sel;   // red de seguridad: la casilla ya está deshabilitada
      return [...sel, key];
    });
  };

  // s169: acción en lote. Guarda las marcadas y descarta explícitamente las que no
  // lo están (punto 5 de s159-D3) — el comercio ve el descarte, no desaparecen solas.
  const saveSelectedGenOffers = async () => {
    if (!genOffers || genSelected.length === 0) return;
    setGenSaving(true);
    const marcadas = genOffers.filter(o => genSelected.includes(o._key));
    // s189-C (arreglo B) · el MISMO techo que aplica `buildDraftPayload` al escribir, aplicado
    // acá para poder contarlo. Con el guard de `toggleGenSelected` esto no debería recortar
    // nunca; si alguna vez recorta (un borrador viejo, una ruta futura), el comercio se entera
    // en vez de que le desaparezcan dos ofertas sin aviso.
    const kept = marcadas.slice(0, MAX_SAVED_PROPOSALS);
    const noEntraron = marcadas.length - kept.length;
    const keptKeys = kept.map(o => o._key);
    const dropped = genOffers.length - marcadas.length;
    const at = genDraftAt || new Date().toISOString();
    const res = await persistDraft(kept, keptKeys, at);
    setGenOffers(kept);
    setGenSelected(keptKeys);   // el estado de React y lo guardado dicen lo mismo
    setGenDraftAt(at);
    setGenSaving(false);
    const rebalse = noEntraron
      ? (lang === "en"
        ? ` · ${noEntraron} didn't fit (max ${MAX_SAVED_PROPOSALS})`
        : ` · ${noEntraron} no entraron (máximo ${MAX_SAVED_PROPOSALS})`)
      : "";
    if (res.remote) {
      setGenNote((lang === "en"
        ? `Saved ${kept.length} offer${kept.length === 1 ? "" : "s"}${dropped ? ` · ${dropped} discarded` : ""}. They'll be here next time.`
        : `Guardaste ${kept.length} oferta${kept.length === 1 ? "" : "s"}${dropped ? ` · descartaste ${dropped}` : ""}. Van a estar aquí la próxima vez.`) + rebalse);
    } else {
      // El WF todavía no existe: no se le miente al comercio diciendo "guardado".
      setGenNote((lang === "en"
        ? `${kept.length} kept for this session${dropped ? ` · ${dropped} discarded` : ""}. Saving across devices isn't on yet.`
        : `${kept.length} conservada${kept.length === 1 ? "" : "s"} en esta sesión${dropped ? ` · descartaste ${dropped}` : ""}. Guardar entre dispositivos todavía no está activo.`) + rebalse);
    }
    return kept;
  };

  // s179 L5.2 — GUARDAR Y EMPEZAR A EDITAR.
  // El problema medido el 25/08: 9 botones rojos grandes que se llevaban UNA sola oferta
  // al wizard, contra 1 botón rosa pálido al fondo, después de nueve tarjetas largas, que
  // era el que preservaba el trabajo. El pie de esa corrida decía «8 nuevas · 12 sin marcar
  // descartadas · 4 no entraron»: doce propuestas pagadas, tiradas.
  // Ahora el camino es uno solo: se guardan TODAS las marcadas y se entra a editar la
  // primera. El orden que ve el comercio es el de la lista, así que «la primera» es la
  // primera marcada de arriba hacia abajo, no la primera que tildó.
  const guardarYEditar = async () => {
    if (!genOffers || genSelected.length === 0) return;
    const kept = await saveSelectedGenOffers();
    const primera = (kept && kept.length) ? kept[0] : null;
    if (primera) applyGeneratedOffer(primera);   // deja el form cargado y va a 3a
  };

  // "Usar esta oferta": ya viene en el shape del form → mergear + ir a Detalles.
  // _adv son campos de display del asesor (no van al form) → se descartan.
  const applyGeneratedOffer = (o) => {
    const { _adv, ...formOffer } = o;
    // s244 · asesor-umbral-v4-al-form: el umbral de v4.0 entra con su tamaño de la tabla (el form no deja seguir sin él).
    // Si el par monto/mínimo no está en UMBRAL_TAMANOS queda vacío y el comercio lo elige, como en el alta.
    const umbral = formOffer.offer_type === UMBRAL_TIPO
      ? { umbral_tamano: tamanoDeUmbral(formOffer.benefit_value_usd, formOffer.min_consumption)?.id || "", umbral_tamano_cena: "", umbral_franjas: false }
      : {};
    // s253 · un % «sin tope» llega con el tope de convención ($1.000): como al editar una guardada, marca la casilla y el
    // número no se muestra (Ali: el formulario decía «Tope por visita: 1000»).
    const sinTope = esPorcentaje(formOffer) && esSinTope(formOffer.benefit_value_usd)
      ? { pct_sin_tope: true, benefit_value_usd: "" } : {};
    // s253 · una propuesta permanente (sin días) entra con «Todos los días» y sin límite de horario, como al editar una
    // sembrada (s213): antes el formulario trababa con «Selecciona al menos un día».
    const dias = String(formOffer.valid_days || "").trim() ? {} : { valid_days: FEED_DAY_TOKENS.join(","), valid_time_start: "", valid_time_end: "" };
    setForm(f => ({
      ...f,
      ...formOffer,
      ...umbral,
      ...sinTope,
      ...dias,
      category: formOffer.category || f.category || categoriaOferta,
      source_lang: formOffer.source_lang || f.source_lang,
    }));
    setFromAdvisor(true); // s148 P2f: la oferta nace del asesor
    setStep(3);
  };

  // ---- OFFER TYPES ----
  const offerTypes = [
    // s194 L1 (s193-D13): la estándar es el default; los cuatro de siempre pasan a «avanzado».
    { id: UMBRAL_TIPO, icon: "💵", estandar: true,
      label: lang === "en" ? "Standard offer" : "Oferta estándar",
      desc: lang === "en" ? "The club format: pick a size and we do the rest" : "El formato del club: eliges un tamaño y nosotros hacemos el resto",
      example: fraseUmbral(30, 60, lang === "en") },
    // s221-D1 · el % vuelve como SEGUNDA opción visible (no tras «avanzado»): desde 20 %, con tope o sin tope.
    // El ícono es texto, no un emoji nuevo (s157-D2).
    { id: "percent", icon: "%", visible: true,
      label: lang === "en" ? "Percentage" : "Porcentaje",
      desc: lang === "en" ? `From ${PCT_MINIMO}% off the bill, with a cap per visit that you set` : `Desde ${PCT_MINIMO} % sobre la cuenta, con el tope por visita que pongas tú`,
      example: tituloPorcentaje(20, 25, lang === "en", categoriaOferta) },
    { id: "fixed", icon: "🏷️", label: lang === "en" ? "Reduced Price" : "Precio Reducido", desc: lang === "en" ? "Regular price → special coupon price" : "Precio regular → precio especial con cupón", example: "$120 → $75" },
    { id: "bogo", icon: "🎉", label: "2×1", desc: lang === "en" ? "Buy one, get one free" : "Compra uno, llévate otro gratis", example: txt.ejemploBogo },
    { id: "free", icon: "🎁", label: lang === "en" ? "Complimentary" : "Cortesía", desc: lang === "en" ? "100% free item or experience" : "Artículo o experiencia 100% gratis", example: lang === "en" ? "Free dessert with dinner" : "Postre gratis con la cena" },
  ];

  // ---- TEMPLATES BY CATEGORY ----
  const templates = {
    Restaurant: [
      { title_es: "Menú Degustación para 2", type: "fixed", is_alcohol: true, regular_price: 120, coupon_price: 75, highlight_1: "4 tiempos + postre", highlight_2: "Copa de vino incluida", highlight_3: "Reserva anticipada" },
      { title_es: "2×1 en Cócteles Premium", type: "bogo", is_alcohol: true, unit_price: 18, highlight_1: "Cócteles de autor", highlight_2: "Válido en barra", highlight_3: "Ambiente exclusivo" },
      { title_es: "Postre Cortesía", type: "free", regular_price: 15, highlight_1: "Con cualquier plato principal", highlight_2: "Selección del chef", highlight_3: "Presentación especial" },
      { title_es: "20 % en tu cuenta · hasta $25", type: "percent", is_alcohol: true, discount_pct: 20, tope: 25, highlight_1: "Comida y bebidas sin alcohol", highlight_2: "Sin mínimo de consumo", highlight_3: "Tope por visita" },
    ],
    Salon_Spa: [
      { title_es: "Tratamiento Facial Premium", type: "fixed", regular_price: 150, coupon_price: 89, highlight_1: "60 minutos de relajación", highlight_2: "Productos premium", highlight_3: "Consulta personalizada" },
      { title_es: "2×1 en Masajes Relajantes", type: "bogo", unit_price: 80, highlight_1: "Ideal para parejas", highlight_2: "Aromaterapia incluida", highlight_3: "50 minutos cada uno" },
      { title_es: "30 % en Tratamiento Facial", type: "percent", discount_pct: 30, tope: 45, highlight_1: "Limpieza profunda", highlight_2: "Productos importados", highlight_3: "Resultado inmediato" },
      { title_es: "Manicure + Pedicure Gel", type: "fixed", regular_price: 85, coupon_price: 55, highlight_1: "Gel de larga duración", highlight_2: "Diseño a elegir", highlight_3: "Spa de manos incluido" },
      { title_es: "2×1 en Extensiones de Pestañas", type: "bogo", unit_price: 70, highlight_1: "Efecto natural", highlight_2: "Duración 3-4 semanas", highlight_3: "Retoque incluido" },
      { title_es: "25 % en Nail Art", type: "percent", discount_pct: 25, tope: 20, highlight_1: "Diseños exclusivos", highlight_2: "Cristales Swarovski", highlight_3: "Acabado premium" },
    ],
    Bar_Rooftop: [
      { title_es: "2×1 en Cócteles Signature", type: "bogo", is_alcohol: true, unit_price: 22, highlight_1: "Cócteles de autor", highlight_2: "Vista panorámica", highlight_3: "Horario happy hour" },
      { title_es: "Botella Premium con Descuento", type: "fixed", is_alcohol: true, regular_price: 200, coupon_price: 140, highlight_1: "Selección premium", highlight_2: "Mesa VIP incluida", highlight_3: "Mixers incluidos" },
      { title_es: "25 % en toda la carta", type: "percent", is_alcohol: true, discount_pct: 25, tope: 20, highlight_1: "Aplica a cócteles y shots", highlight_2: "Ambiente exclusivo", highlight_3: "DJ en vivo" },
    ],
    Experience: [
      { title_es: "25 % en el City Tour", type: "percent", discount_pct: 25, tope: 30, highlight_1: "Tour guiado bilingüe", highlight_2: "3 horas de recorrido", highlight_3: "Fotos profesionales incluidas" },
      { title_es: "Sesión de Tatuaje Personalizado", type: "fixed", regular_price: 200, coupon_price: 150, highlight_1: "Diseño personalizado", highlight_2: "Artista premiado", highlight_3: "Materiales premium" },
      { title_es: "Clase de Cocina para 2", type: "fixed", regular_price: 160, coupon_price: 99, highlight_1: "Chef profesional", highlight_2: "Incluye ingredientes", highlight_3: "Te llevas lo que cocinas" },
    ],
    Sweets: [
      { title_es: "2×1 en Helados Artesanales", type: "bogo", unit_price: 9, highlight_1: "Sabores artesanales del día", highlight_2: "Elige cono o copa", highlight_3: "Toppings incluidos" },
      { title_es: "20 % en Pastelería", type: "percent", discount_pct: 20, tope: 12, highlight_1: "Repostería fresca del día", highlight_2: "Tortas por encargo", highlight_3: "Opciones sin azúcar" },
    ],
    Gift_Moments: [
      { title_es: "20 % en Gift Box Premium", type: "percent", discount_pct: 20, tope: 15, highlight_1: "Productos artesanales", highlight_2: "Empaque de lujo", highlight_3: "Personalización gratis" },
      { title_es: "Experiencia Regalo para 2", type: "fixed", regular_price: 120, coupon_price: 79, highlight_1: "Incluye actividad + cena", highlight_2: "Tarjeta personalizada", highlight_3: "Válido 60 días" },
    ],
  };

  // ---- COMPUTED VALUES ----
  // s155-D3: en percent el beneficio se deriva de los precios, como en fixed.
  // typical_savings queda fuera de la ruta del dinero: estaba poblado en 3 de 26 ofertas
  // (0 de las aprobadas), no lo expone la regla publica, y era el unico numero que el
  // comercio podia inflar sabiendo que lo paga el miembro.
  // s221-D1 (§3.3): SUPERADO lo de arriba para el %. El beneficio del % ES el tope que escribe el
  // comercio (`form.benefit_value_usd`, que manda en effectiveBenefitValue); con «Sin tope», el campo
  // queda vacío y este valor da TOPE_SIN_LIMITE. Ya no se calcula «cuenta × %».
  const percentBenefit = form.pct_sin_tope ? TOPE_SIN_LIMITE : 0;
  const esPctForm = form.offer_type === "percent";
  const pctForm = parseFloat(form.discount_pct) || 0;
  // El piso del club (s221-D1) y el 100 de cordura. Mismo texto que OFFER_PCT_TOO_LOW de Bubble.
  const mensajePct = !esPctForm ? "" : pctForm < PCT_MINIMO
    ? (lang === "en" ? `The club minimum is ${PCT_MINIMO}%.` : `El mínimo del club es ${PCT_MINIMO} %.`)
    : pctForm > 100 ? (lang === "en" ? "The percentage can't be more than 100." : "El porcentaje no puede pasar de 100.") : "";
  const faltaTope = esPctForm && !form.pct_sin_tope && !(parseFloat(form.benefit_value_usd) > 0);
  const mensajeTope = lang === "en"
    ? "Write the cap per visit, or tick “No cap”."
    : "Escribe el tope por visita, o marca «Sin tope».";
  const pctBloquea = !!(mensajePct || faltaTope);
  // §3.6 · el título sugerido sigue al % y al tope mientras sea el generado (el comercio lo puede cambiar).
  useEffect(() => {
    if (!esPctForm || !(pctForm > 0)) return;
    const tope = form.pct_sin_tope ? TOPE_SIN_LIMITE : (parseFloat(form.benefit_value_usd) || 0);
    const sugerido = tituloPorcentaje(pctForm, tope, form.source_lang === "en", categoriaOferta);
    // s223 · la franja (« · Cena») se conserva.
    setForm(f => {
      const conFranja = sugerido + partirFranja(f.title).sufijo;
      return esTituloPorcentajeGenerado(f.title) && f.title !== conFranja ? { ...f, title: conFranja } : f;
    });
  }, [esPctForm, pctForm, form.pct_sin_tope, form.benefit_value_usd, form.source_lang]);

  const savings = (() => {
    const rp = parseFloat(form.regular_price) || 0;
    const cp = parseFloat(form.coupon_price) || 0;
    const up = parseFloat(form.unit_price) || 0;
    const dp = parseFloat(form.discount_pct) || 0;
    switch (form.offer_type) {
      case "fixed": return { amount: rp - cp, pct: rp > 0 ? Math.round(((rp - cp) / rp) * 100) : 0 };
      case "bogo": return { amount: up, pct: 50 };
      case "free": return { amount: rp, pct: 100 };
      case "percent": return { amount: percentBenefit, pct: dp || (rp > 0 ? Math.round((percentBenefit / rp) * 100) : 0) };
      default: return { amount: 0, pct: 0 };
    }
  })();

  const computedBenefitValue = (() => {
    if (form.offer_type === "percent") return percentBenefit;
    return savings.amount;
  })();

  // s148 P2a/P2b: el valor del beneficio ahora es visible y editable. Prioridad:
  // 1) form.benefit_value_usd (lo trajo el asesor, lo hidrató el edit desde la DB, o lo
  //    escribió el merchant en el input) — se RESPETA, no se recomputa;
  // 2) vacío → computedBenefitValue (derivado de los precios, comportamiento clásico).
  // Preservar el valor hidratado en edits evita recomputar benefit de ofertas viejas
  // cuyo criterio era otro (movería la cuota de servicio sin querer).
  const effectiveBenefitValue = (form.benefit_value_usd !== "" && !isNaN(parseFloat(form.benefit_value_usd)))
    ? Math.max(0, parseFloat(form.benefit_value_usd))
    : computedBenefitValue;

  // s155-D3: en percent el benefit YA NO es el ahorro típico — se deriva de la cuenta típica
  // × el porcentaje (o de regular−coupon al editar una oferta con los dos precios cargados),
  // igual que en fixed. typical_savings quedó fuera de la ruta del dinero.
  //
  // s179 L8: acá vivía `const fee = getFee(...)`. Se fue con la columna «Cuota VIP»: este
  // componente es el del COMERCIO y getFee es la cuota del MIEMBRO. getFee sigue vivo
  // donde corresponde — el modal de pago del miembro (StripePaymentModal).

  // ---- s179 L8 · LO QUE NXT LE COBRA AL COMERCIO -----------------------------
  // 🔴 El L3.3 de este mismo lote uso getFee para la "Tarifa NXT", y getFee es OTRA COSA:
  // es la cuota de ACTIVACION QUE PAGA EL MIEMBRO (min(max(10% x benefit, 4.99), 9.99),
  // api.js), y solo la pagan las cuentas LITE — una membresia activa paga $0. No tiene
  // nada que ver con lo que NXT le factura al comercio.
  // El resultado eran dos pantallas con las MISMAS PALABRAS y seis veces de diferencia:
  //   3a (SavingsPreview) decia "Tarifa NXT: $4.99"   <- getFee, piso
  //   el dashboard decia  "Tarifa NXT: ~5%"           <- take_rate_pct  => $0.75
  // Con Stripe en LIVE, eso es una promesa de precio equivocada justo en la pantalla
  // donde el comercio decide. El dashboard tenia razon; 3a estaba mal.
  //
  // ⚠️ TRAMPA DE NOMBRES, verificada en el registro: MerchantPartner tiene DOS campos
  // founding — `is_founding` y `is_founding_partner` — y get_merchant_stats devuelve
  // `is_founding_partner` leyendo de `is_founding_boolean`. O sea que el flag de la API
  // NO sale del campo homonimo de App Data. Hay que leer stats.is_founding_partner y
  // nada mas; mirar el campo del mismo nombre en App Data da la respuesta equivocada.
  // s194 L1 (s193-D1/D17): el take al comercio murió como decisión. Acá vivían
  // takeRatePct / esFounding / takeComercio (s179 L8, s180 A1), que alimentaban la línea
  // «Tarifa NXT» del recuadro del ahorro; esa línea prometía un cobro que ya no existe.

  // ---- s194 L1 · EL FORMATO ÚNICO EN EL FORM ---------------------------------
  const esUmbralForm = form.offer_type === UMBRAL_TIPO;
  const umbralForm = esUmbralForm
    ? { monto: parseFloat(form.benefit_value_usd) || 0, minimo: parseFloat(form.min_consumption) || 0 }
    : null;
  const tamanoAlmuerzo = UMBRAL_TAMANOS.find(t => t.id === form.umbral_tamano) || null;
  const tamanoCena = UMBRAL_TAMANOS.find(t => t.id === form.umbral_tamano_cena) || null;
  const faltaTamano = esUmbralForm && (!tamanoAlmuerzo || (form.umbral_franjas && !tamanoCena));
  const mensajeTamano = lang === "en"
    ? "Pick a size for each daypart before continuing."
    : "Elige un tamaño para cada franja antes de continuar.";
  const enForm = form.source_lang === "en";
  // s222 · el canal que se ve y se manda: el elegido o, si no hay, el del rubro.
  const canalForm = canalValido(form.redemption_channel) || canalDelRubro(categoriaOferta);
  // Lo que se lee en el repaso: una frase, o dos con su franja.
  const resumenUmbral = !esUmbralForm ? "" : (form.umbral_franjas && tamanoAlmuerzo && tamanoCena)
    ? `${enForm ? UMBRAL_FRANJAS[0].en : UMBRAL_FRANJAS[0].es}: ${fraseUmbral(tamanoAlmuerzo.monto, tamanoAlmuerzo.minimo, enForm)} · ${enForm ? UMBRAL_FRANJAS[1].en : UMBRAL_FRANJAS[1].es}: ${fraseUmbral(tamanoCena.monto, tamanoCena.minimo, enForm)}`
    : (umbralForm && umbralForm.monto > 0 ? fraseUmbral(umbralForm.monto, umbralForm.minimo, enForm) : "");
  // Las reglas fijas van primero (s194-D2); lo que el comercio agregó a mano, después, sin duplicar.
  // s213 · lo que viene de una oferta guardada se lee como la ficha: la regla vieja de «socio» se
  // reconoce como la de membresía (antes se re-guardaba como propia, duplicada), y la del plazo
  // («Repetible cada 90 días…») ya no se guarda: se arma desde cooldown_days (Ali, s213).
  // s214 · cualquier línea fija (vieja o de hoy, de cualquier rubro) se reconoce y no se guarda como propia.
  const extrasDeReglas = (texto) => String(texto || "").split(/\r?\n/)
    .map(x => x.trim())
    .filter(l => l && !esReglaFija(l) && !esReglaPlazoGuardada(l) && !esReglaPlazoArmada(l));
  // s214 · se guardan las COMUNES + lo del comercio. Las del rubro y la del plazo las arma la ficha.
  const compilarReglasUmbral = (extras) => [...REGLAS_COMUNES[enForm ? "en" : "es"], ...extrasDeReglas(extras)].join(SALTO_LINEA);
  // Las reglas del club, solo lectura (paso 4 y repaso): las de su rubro, más la del plazo armada con el
  // de esta oferta (en una nueva, el default: 30).
  const ReglasUmbralLista = () => (
    <div className="alta-repaso__reglas" style={{ marginBottom: 10 }}>
      <div className="alta-ayuda" style={{ marginBottom: 6 }}>
        {lang === "en" ? "The club rules for your type of business:" : "Las reglas del club para tu tipo de negocio:"}
      </div>
      {[...reglasDelRubro(categoriaOferta, enForm, canalForm), reglaPlazo(form.cooldown_days || plazoNace, enForm, categoriaOferta)].map((r, i) => <div key={i}>📋 {r}</div>)}
    </div>
  );

  // s223 · las del %, solo lectura: las que arma la ficha (rubro, canal, alcohol en mesa) + el plazo de esta oferta.
  const ReglasPctLista = () => (
    <div className="alta-repaso__reglas" style={{ marginBottom: 10 }}>
      <div className="alta-ayuda" style={{ marginBottom: 6 }}>
        {lang === "en" ? "The club rules for your type of business:" : "Las reglas del club para tu tipo de negocio:"}
      </div>
      {[...reglasPorcentaje(categoriaOferta, enForm, canalForm), reglaPlazo(form.cooldown_days || plazoNace, enForm, categoriaOferta)].map((r, i) => <div key={i}>📋 {r}</div>)}
    </div>
  );

  // ---- s179 L3.1 · EL INVARIANTE DEL BENEFICIO -------------------------------
  // Verificado en runtime el 25/08: una Cortesía se crea con benefit == regular_price,
  // se guarda SIN una queja, y recién muere al aprobar con OFFER_BENEFIT_EXCEEDS_PRICE.
  // Contraprueba hecha: con benefit $14 sobre $15 aprueba. El front no validaba nada.
  //
  // ⚠️ `>`, no `>=`: espeja EXACTAMENTE el guard de approve_offer Steps 10 y 11.
  // s180 A2: Bubble Live pasó a `>` el 26/08 (verificado: $15/$15 aprueba, $16/$15
  // rechaza) y el front se cambia en el MISMO lote — un front más permisivo que el
  // backend devuelve el bug, y uno más estricto bloquea de más (bloqueaba Cortesía).
  const benefitBloquea = (() => {
    if (esPctForm) return false;   // s221-D1: en el % el precio regular se deriva del tope; no hay invariante que romper
    const rp = parseFloat(form.regular_price) || 0;
    return rp > 0 && effectiveBenefitValue > rp;
  })();

  // s180 A2: Cortesía (benefit == regular_price) ya pasa el invariante y se publica.
  // Fuera las coletillas que decían lo contrario; queda solo el mensaje general, que
  // ahora dice «mayor» y no «igual ni mayor» — con `>` el igual es válido.
  const mensajeBenefit = !benefitBloquea ? "" : (lang === "en"
    ? "The savings can't exceed the list price. Lower the savings or raise the price."
    : "El ahorro no puede ser mayor al precio de lista. Baja el ahorro o sube el precio.");

  // ---- s185 · EL AHORRO, UNA SOLA VEZ ----------------------------------------
  // El porcentaje que se muestra sale del MISMO numero que viaja en el payload
  // (effectiveBenefitValue), no de savings.amount — para Cortesia ese es siempre
  // el precio entero (s179 L6.1). Sin precio de lista (bogo) se conserva el pct
  // de savings, que ahi si es la mecanica del 2x1.
  const pctAhorro = (() => {
    const rp = parseFloat(form.regular_price) || 0;
    return rp > 0 ? Math.round((effectiveBenefitValue / rp) * 100) : savings.pct;
  })();

  // s155-D6: una oferta sin ahorro para el miembro no se guarda. benefit_value_usd = 0
  // deja la oferta inaprobable (approve_offer Step 2/3: OFFER_BENEFIT_INVALID) y sin
  // nada que mostrarle al miembro. Los 4 tipos tienen un input que lo alimenta.
  // s185: el chequeo existia solo en handleSubmit — o sea en el paso 5, con el campo
  // que lo causa dos pantallas atras. Ahora vive tambien al salir del paso 3, que es
  // donde esta el dinero. El de handleSubmit se queda: es la ultima red.
  const sinAhorro = !(effectiveBenefitValue > 0);
  const mensajeSinAhorro = lang === "en"
    ? "This offer has no member savings yet. Complete the prices so we can calculate it."
    : "Esta oferta todavía no tiene ahorro para el miembro. Completa los precios para poder calcularlo.";

  // s185-b: el titulo se valida como los otros dos bloqueos del paso 3 — junto al campo y
  // despues del primer intento. Vivia en el banner de arriba, que nadie limpiaba.
  // s215 · Ali: en la oferta estándar (nivel 1) «¿Qué es lo que más te piden?» ya no es obligatorio:
  // elegir el tamaño basta y el título es la frase del tamaño (la tarjeta no la repite: OfferCard
  // esconde un título generado). El plato/servicio pasa al paso 4, opcional (nivel 2).
  const sinTitulo = !esUmbralForm && !form.title;
  const mensajeSinTitulo = esUmbralForm
    ? (lang === "en" ? "Write what people order most — the amount shows up on its own." : "Escribe qué es lo que más te piden — el monto ya sale solo.")
    : (lang === "en" ? "Give the offer a title — it's the first thing a member reads." : "Ponle un título a la oferta — es lo primero que lee el miembro.");

  // ---- s181 lote B · DISPONIBILIDAD: un estado ambiguo no se guarda (s180-D4) ----------
  // Verificado en Live el 26/08: se podía guardar con cero días, y DESDE/HASTA vacíos no
  // decían si era «todo el día» o un olvido. Tres reglas, y las tres avisan en el momento:
  //   días    -> al menos uno («Todos los días» es un acto, no un default);
  //   horario -> o «Sin límite» explícito, o DESDE y HASTA completos con DESDE < HASTA.
  //              Un horario a medias (solo una de las dos) tampoco pasa.
  // Contrato con la base intacto: valid_days sigue siendo tokens por coma y «sin límite»
  // sigue siendo valid_time_start/end vacíos. Esto es UI + validación, no un cambio de datos.
  // ⚠️ Horarios que cruzan medianoche (20:00–02:00, un rooftop) NO pasan por diseño de este
  // lote (DESDE < HASTA). Hoy el comercio elige «Sin límite»; si duele, es ticket aparte.
  const diasSel = (form.valid_days || "").split(",").map(x => x.trim()).filter(Boolean);
  const todosLosDias = FEED_DAY_TOKENS.every(t => diasSel.includes(t));
  const mensajeDias = diasSel.length > 0 ? "" : (lang === "en"
    ? "Pick at least one day — or tap “Every day”."
    : "Selecciona al menos un día — o toca «Todos los días».");
  const mensajeHorario = (() => {
    if (sinLimiteHorario || form.umbral_franjas) return "";   // s194 L1: las franjas traen su horario
    const ini = form.valid_time_start, fin = form.valid_time_end;
    if (!ini || !fin) return lang === "en"
      ? "Fill in “From” and “Until” — or tap “No time limit”."
      : "Completa «Desde» y «Hasta» — o toca «Sin límite de horario».";
    // "HH:MM" 24h con cero a la izquierda (lo garantiza <input type="time"> y normalizeValidTime):
    // comparar los strings es comparar las horas.
    if (fin <= ini) return lang === "en"
      ? "“Until” has to be later than “From”."
      : "«Hasta» tiene que ser más tarde que «Desde».";
    return "";
  })();
  const disponibilidadBloquea = !!(mensajeDias || mensajeHorario);
  const toggleSinLimite = () => {
    const next = !sinLimiteHorario;
    setSinLimiteHorario(next);
    if (next) setForm(f => ({ ...f, valid_time_start: "", valid_time_end: "" }));
  };
  // Chips de disponibilidad (días, «Todos los días», «Sin límite»): un solo molde.
  const chipDisp = (on, fuerte) => ["alta-chip", on && "alta-chip--on", fuerte && "alta-chip--fuerte"].filter(Boolean).join(" ");
  // Guía (ámbar) hasta el primer intento de «Revisar →»; error (rojo) después. Mismo texto.
  const avisoDisp = intentoRevisar
    ? "alta-aviso alta-aviso--error alta-aviso--campo"
    : "alta-aviso alta-aviso--campo";

  // ---- APPLY TEMPLATE ----
  // Templates literales en español → source_lang="es"; backend traduce al guardar.
  const applyTemplate = (t) => {
    setForm(f => ({
      ...f,
      offer_type: t.type,
      title: t.title_es,
      source_lang: "es",
      regular_price: t.regular_price || "",
      coupon_price: t.coupon_price || "",
      unit_price: t.unit_price || "",
      discount_pct: t.discount_pct || "",
      typical_savings: t.typical_savings || "",
      // s221-D1: las plantillas del % traen un tope, no una cuenta típica.
      benefit_value_usd: t.type === "percent" && t.tope ? String(t.tope) : f.benefit_value_usd,
      pct_sin_tope: false,
      highlight_1: t.highlight_1 || "",
      highlight_2: t.highlight_2 || "",
      highlight_3: t.highlight_3 || "",
      // s178 L2: seis plantillas venden alcohol (copa de vino, cocteles, botella, "incluye
      // bebidas") y applyTemplate no mencionaba is_alcohol: ni lo ponia ni lo limpiaba.
      // Elegir plantilla dejaba el flag pegado de la anterior, en los dos sentidos: una
      // plantilla sin alcohol heredaba el true de "2x1 en Cocteles", y viceversa.
      // Se propaga EXPLICITO, no con `||`: `t.is_alcohol === true` limpia tanto como marca.
      is_alcohol: t.is_alcohol === true,
    }));
    setFromAdvisor(false); // s148 P2f: template manual, no asesor
    setStep(3);
  };

  // ---- SUBMIT ----
  const handleSubmit = async () => {
    // s148 stopgap: edición en mantenimiento — el canal de lectura actual no trae los campos
    // de valor y guardar corrompería la oferta (ver OFFER_EDIT_MAINTENANCE).
    if (isEdit && OFFER_EDIT_MAINTENANCE) {
      setError(lang === "en"
        ? "Offer editing is temporarily under maintenance. Your offer was NOT modified."
        : "La edición de ofertas está temporalmente en mantenimiento. Tu oferta NO fue modificada.");
      return;
    }
    // s148 stopgap: nunca guardar una edición cuyo form no se hidrató desde la oferta real.
    // update_offer sobrescribe TODOS los campos: un form vacío arrasaría la oferta.
    if (isEdit && !editHydrated) {
      setError(lang === "en"
        ? "This offer's data did not load, so saving is disabled to protect it. Reload the page and try again."
        : "Los datos de la oferta no se cargaron, así que guardar está deshabilitado para protegerla. Recarga la página e inténtalo de nuevo.");
      return;
    }
    if (!form.title) { setError(lang === "en" ? "Title is required" : "El título es obligatorio"); return; }
    if (!form.offer_type) { setError(lang === "en" ? "Offer type is required" : "El tipo de oferta es obligatorio"); return; }
    // s250 · el mismo control de la siembra: el dinero sale del tamaño. Con dos franjas, el título vale para los dos tamaños.
    if (esUmbralForm && (tituloContradiceMonto(form.title, form.benefit_value_usd, form.min_consumption)
      || (form.umbral_franjas && tamanoCena && tituloContradiceMonto(form.title, tamanoCena.monto, tamanoCena.minimo)))) {
      setError(lang === "en" ? "The title shows a different amount than the size. Remove the amount: the card already shows it." : "El título dice un monto distinto al del tamaño. Quita el monto: la tarjeta ya lo muestra.");
      return;
    }
    // s155-D6: una oferta sin ahorro para el miembro no se guarda. benefit_value_usd = 0
    // deja la oferta inaprobable (approve_offer Step 2/3: OFFER_BENEFIT_INVALID) y sin
    // nada que mostrarle al miembro. Los 4 tipos tienen un input required que lo alimenta:
    // fixed regular−coupon · bogo unit_price · free regular_price · percent cuenta×porcentaje.
    // s185: el mismo texto que el aviso del paso 3, de una sola fuente. Este chequeo
    // se queda igual: es la ultima red antes de escribir en la base.
    if (sinAhorro) { setError(mensajeSinAhorro); return; }
    // s221-D1 §3.5: también al editar una % vieja (menos de 20 % o sin tope): las reglas nuevas para guardar.
    if (pctBloquea) { setError(mensajePct || mensajeTope); return; }
    setLoading(true); setError("");
    try {
      const imagePayload = await imagenParaCrearOferta(imageFile);
      // FIX-18R (D72): 1 idioma + source_lang. Backend autotraduce al guardar (translate_offer_text).
      // s215 · sin «qué piden» (o con la frase vieja), el título es la frase del tamaño elegido.
      // s223 · con su franja, si la tenía (« · Cena»): al editar una oferta del wizard no se pierde.
      const srcTitle = esUmbralForm && esTituloUmbralGenerado(form.title)
        ? fraseUmbral(form.benefit_value_usd, form.min_consumption, form.source_lang === "en") + partirFranja(form.title).sufijo
        : form.title;
      // s212 · en la estándar, sin descripción se arma como en la siembra (qué + cuándo).
      // s215 · sin «qué piden» también se arma: si no, la descripción se guardaba vacía.
      const enDesc = form.source_lang === "en";
      const aplicaA = fraseAlcance(categoriaOferta, enDesc);   // s239 · D6
      const descripcionArmada = esUmbralForm
        ? [aplicaA,
           form.title && !esTituloUmbralGenerado(form.title) ? (form.source_lang === "en" ? `What people order most: ${form.title}.` : `Lo que más piden: ${form.title}.`) : "",
           form.cuando_ir.trim() ? (form.source_lang === "en" ? `If you can choose: ${form.cuando_ir.trim()}.` : `Si puedes elegir: ${form.cuando_ir.trim()}.`) : ""]
            .filter(Boolean).join(" ")
        : "";
      const srcDescription = form.description || descripcionArmada || form.title;
      // s194 L1 (s194-D2): en umbral las siete reglas van siempre, y lo del comercio después.
      const srcRules = esUmbralForm
        ? compilarReglasUmbral(form.rules_text)
        : esPctForm
        // s223 · en el %: las comunes sin la del mínimo + lo propio del comercio (la ficha arma rubro, canal y plazo).
        ? [...reglasPctGuardadas(form.source_lang === "en"), ...extrasDeReglas(form.rules_text)].join(SALTO_LINEA)
        : (form.rules_text || (form.source_lang === "en" ? "Standard NXT Reserve conditions apply" : "Aplican condiciones generales de NXT Reserve"));
      const payload = {
        title: srcTitle,
        description: srcDescription,
        rules_text: srcRules,
        source_lang: form.source_lang || "es",
        // s148 red anti-H4: los campos bilingües de create_offer/update_offer se escriben
        // desde el split (|~|) de translate_offer_text con defaulting_to ESTOS params legacy.
        // Si la traducción falla (API caída / rotación de clave / migración de proveedor),
        // sin esto los títulos y descripciones se guardan VACÍOS en una oferta viva; con
        // esto degradan a "texto fuente sin traducir", que es recuperable. Los highlights
        // EN ya defaultean a highlight_1/2/3, que este payload siempre manda.
        title_es: srcTitle,
        title_en: srcTitle,
        description_es: srcDescription,
        description_en: srcDescription,
        rules_text_es: srcRules,
        rules_text_en: srcRules,
        // s148 P2b: se respeta el valor explícito (asesor/edit/input); vacío → derivado de precios
        benefit_value_usd: effectiveBenefitValue,
        // s148 P2f · CORREGIDO s169 contra el export 59 (el comentario anterior era falso
        // en las dos afirmaciones): el param SÍ existe — `create_offer` #27 y `update_offer`
        // #31, los dos declarados `boolean` — y el campo en DB NO es texto yes/no, es
        // `created_by_ai_boolean`; el step hace `param:created_by_ai · is_true`.
        // ✅ MEDIDO el 21/08/2026 (censo de las 27 ofertas de Live): la más reciente quedó
        // con el campo en `yes`. El texto "yes"/"no" contra el param `boolean` SELLA BIEN —
        // Bubble lo convierte antes del `· is_true`. 🔴 NO cambiar a true/false: no hay nada
        // roto que arreglar acá, y tocarlo es arriesgar un camino que está verificado.
        created_by_ai: fromAdvisor ? "yes" : "no",
        category: form.category || merchantProfile?.category || "Restaurant",
        offer_type: form.offer_type,
        // s194-D2 regla 2: la estándar aplica a comida y bebidas sin alcohol; nunca lleva la marca.
        is_alcohol: esUmbralForm ? false : !!form.is_alcohol,
        // s221-D1 §2: en el % el precio regular se DERIVA (la cuenta en la que se llega al tope: 20 % hasta $25 → 125).
        // s223 · en el 2×1 se deriva de unit_price (ver precioRegularDe2x1).
        regular_price: esPctForm ? precioRegularDePct(effectiveBenefitValue, pctForm)
          : form.offer_type === "bogo" ? precioRegularDe2x1(form.unit_price, form.regular_price, effectiveBenefitValue)
          : (parseFloat(form.regular_price) || 0),
        coupon_price: esPctForm ? 0 : (parseFloat(form.coupon_price) || 0),
        unit_price: parseFloat(form.unit_price) || 0,
        // s148 P2: discount_pct solo viaja con percent — un residuo de "cambié de tipo en el
        // wizard" no debe mover la tarifa. PENDIENTE s155-D1: hasta que se deploye
        // fee-percent-sin-excepcion, el server (create_payment_intent) todavía clava la cuota
        // al piso si discount_pct > 0 sin mirar offer_type. Cuando D1 esté en Live deja de
        // ser cierto y la cuota de percent pasa a salir del benefit como cualquier otro tipo.
        discount_pct: form.offer_type === "percent" ? (parseFloat(form.discount_pct) || 0) : 0,
        typical_savings: esPctForm ? 0 : (parseFloat(form.typical_savings) || 0),
        valid_days: form.valid_days,
        valid_time_start: form.valid_time_start,
        valid_time_end: form.valid_time_end,
        // s154 lote C · CORREGIDO s169 contra el export 59: `create_offer` SÍ define el param
        // (#28, number) y su step escribe `min_consumption_number`. En `update_offer` es el
        // #32, gateado por `param:min_consumption · is_not_empty`. Los dos lo reciben.
        min_consumption: esPctForm ? 0 : (parseFloat(form.min_consumption) || 0),   // s221-D1: el % no tiene mínimo
        highlight_1: form.highlight_1,
        highlight_2: form.highlight_2,
        highlight_3: form.highlight_3,
        ...(imagePayload ? { image: imagePayload } : {}),
        // s253 · fotos por oferta: gallery_pick o, con «Todas» al editar, clear_gallery_pick. Sin tocar la selección, nada.
        ...paramsGalleryPick({ marcadas: form.galeria_marcadas, principal: form.principal_galeria, galeria: galeriaDelPerfil(merchantProfile), isEdit }),
      };
      // s213 · lote B+C: plan y plazo, solo en la estándar. s214: también en el alta nueva — `create_offer`
      // los recibe desde la S6 (deploy del 03/10, export 97). El plan vacío no viaja (en update_offer,
      // `:defaulting to` lo deja como estaba; en create_offer, la oferta nace sin plan).
      // s222 · el canal (create_offer / update_offer, export 127). En el alta viaja siempre (el elegido o el del
      // rubro); al editar, solo si hay uno elegido o guardado: sin la clave, update_offer no lo cambia (T8).
      if (!isEdit) payload.redemption_channel = canalForm;
      else if (canalValido(form.redemption_channel)) payload.redemption_channel = canalValido(form.redemption_channel);
      if (esUmbralForm && form.plan) payload.plan = form.plan;
      // s223 · el plazo viaja en TODOS los tipos. Hasta s223 solo en la estándar, y en los demás create_offer lo
      // llenaba con PricingConfig.cooldown_days (en Live, 90: medido en la prueba del wizard con un 2×1 de
      // plantilla), mientras la pantalla daba 30 por defecto y la ficha no mostraba el plazo.
      {
        const plazo = Number(form.cooldown_days) || plazoNace;
        if (PLAZOS_COOLDOWN.includes(plazo)) payload.cooldown_days = plazo;
      }
      if (isEdit) {
        // X.43-bis: editar — el helper chequea response.success (L#83) y mapea NOT_OWNER.
        // La imagen solo va en payload si se subió una nueva → el WF conserva la foto original.
        await updateOffer(editId, payload);
        console.log("[UpdateOffer] ok", editId);
        setSuccess(true);
        // s199-D9: si es la oferta sembrada, el camino sigue en el panel, donde está
        // «Confirmar mi oferta»; si no, en Mis Ofertas, como siempre.
        setTimeout(() => navigate(ofertaSembrada ? "/merchant/dashboard" : "/merchant/offers"), 2000);
      } else {
        // s223 · el POST vive en crearOfertaWf (lo comparte el wizard de la primera oferta).
        const crear = crearOfertaWf;
        // s194 L1 (H3): «dos franjas» = DOS ofertas, una por franja, cada una con su tamaño,
        // su horario preset y su título. Se crean en orden; si la segunda falla, la primera
        // ya existe y el error lo dice, para que el comercio no la duplique al reintentar.
        const lotes = (esUmbralForm && form.umbral_franjas && tamanoAlmuerzo && tamanoCena)
          ? [[UMBRAL_FRANJAS[0], tamanoAlmuerzo], [UMBRAL_FRANJAS[1], tamanoCena]].map(([fr, t]) => {
              const franja = enForm ? fr.en : fr.es;
              const titulo = `${esTituloUmbralGenerado(form.title) ? fraseUmbral(t.monto, t.minimo, enForm) : form.title} · ${franja}`;
              return {
                ...payload,
                title: titulo, title_es: titulo, title_en: titulo,
                benefit_value_usd: t.monto, min_consumption: t.minimo, regular_price: t.minimo,
                valid_time_start: fr.ini, valid_time_end: fr.fin,
              };
            })
          : [payload];
        let creadas = 0;
        try {
          for (const p of lotes) { await crear(p); creadas += 1; }
        } catch (e) {
          if (creadas > 0) {
            const [primera, segunda] = UMBRAL_FRANJAS.map(fr => (lang === "en" ? fr.en : fr.es).toLowerCase());
            e.message = (lang === "en"
              ? `The ${primera} offer was created; the ${segunda} one failed: `
              : `La oferta de ${primera} se creó; la de ${segunda} falló: `) + (e.message || "");
          }
          throw e;
        }
        setSuccess(true);
        setTimeout(() => navigate("/merchant/offers"), 3000);
      }
    } catch (e) {
      const friendly = {
        NOT_OWNER: lang === "en" ? "This offer isn't yours." : "Esta oferta no es tuya.",
        TOO_MANY_OFFERS: mensajeTopeDueno(lang === "en"),   // s224 · export 133
      };
      setError(friendly[e.code] || mensajeLoteBC(e.code, lang === "en") || e.message || (lang === "en" ? "Error saving the offer" : "Error al guardar la oferta"));
    }
    finally { setLoading(false); }
  };

  // ---- s227-D1 · CONFIRMAR EL CORREO, DESPUÉS DE ENVIAR LA 1.ª OFERTA ----
  if (pideCorreo) return (
    <div style={S.page}>
      <MerchantHeader businessName={stats?.business_name} activePage="offers" />
      <div className="alta-cuerpo">
        <VerificarCorreo correo={merchantProfile?.email} en={lang === "en"} despuesDeEnviar
          comercioAprobado={String(merchantProfile?.status || "").trim().toLowerCase() === "approved"}
          onListo={() => navigate("/merchant/offers")} onDespues={() => navigate("/merchant/offers")} />
        {wizardAvisoFotos && <div className="alta-aviso alta-aviso--campo" role="status" style={{ marginTop: 16 }}>{wizardAvisoFotos}</div>}
      </div>
    </div>
  );

  // ---- LA PANTALLA DE ENVIADO ----
  if (success) return (
    <div style={S.page}>
      <MerchantHeader businessName={stats?.business_name} activePage="offers" />
      <div className="alta-listo">
        <div className="alta-listo__marca">✅</div>
        <div className="alta-listo__titulo">
          {isEdit ? (lang === "en" ? "OFFER UPDATED!" : "¡OFERTA ACTUALIZADA!") : (lang === "en" ? "OFFER SUBMITTED!" : "¡OFERTA ENVIADA!")}
        </div>
        <div className="alta-listo__nota">
          {ofertaSembrada
            ? (lang === "en" ? "Your changes were saved. Now confirm it in your panel." : "Tus cambios se guardaron. Ahora confírmala en tu panel.")
            : isEdit
            ? (ofertaBase && !ofertaBase.pendiente   // s239 · D1: sin re-aprobación, lo guardado ya está publicado
              ? (lang === "en" ? "Your changes were saved and are already live. If the offer is active, members see it this way." : "Tus cambios se guardaron y ya están publicados. Si la oferta está activa, los miembros la ven así.")
              : (lang === "en" ? "Your changes were saved. The offer keeps its current status." : "Tus cambios se guardaron. La oferta conserva su estado actual."))
            : wizardEnviadas > 1
            ? (lang === "en" ? `Your ${wizardEnviadas} offers are pending approval` : `Tus ${wizardEnviadas} ofertas están pendientes de aprobación`)
            : (lang === "en" ? "Your offer is pending admin approval" : "Tu oferta está pendiente de aprobación")}
        </div>
        {wizardAvisoFotos && <div className="alta-aviso alta-aviso--campo" role="status" style={{ marginTop: 16 }}>{wizardAvisoFotos}</div>}
      </div>
    </div>
  );

  // s223 · 2b · mientras se sabe si es la primera, ni menú ni wizard; si lo es, el wizard ocupa la pantalla.
  if (!isEdit && !modoImperdible && (esPrimera !== false || modoFranja)) return (
    <div style={S.page}>
      <MerchantHeader businessName={stats?.business_name} activePage="offers" />
      <div className="alta-cuerpo">
        <button className="alta-volver" onClick={() => navigate("/merchant/offers")}>
          ← {lang === "en" ? "Back to offers" : "Volver a ofertas"}
        </button>
        <div className="alta-titulo">{modoFranja && esPrimera === false ? (lang === "en" ? "ANOTHER TIME SLOT" : "OTRA FRANJA") : (lang === "en" ? "YOUR FIRST OFFER" : "TU PRIMERA OFERTA")}</div>
        {esPrimera === undefined
          ? <div className="alta-ayuda">{lang === "en" ? "Loading…" : "Cargando…"}</div>
          : <WizardPrimeraOferta perfil={merchantProfile} lang={lang} otraFranja={modoFranja && esPrimera === false}
              onSalir={() => navigate("/merchant/offers")}
              onEnviada={(n, avisoFotos) => {
                setWizardEnviadas(n); setWizardAvisoFotos(avisoFotos || "");
                if (correoSinVerificar(merchantProfile)) { setPideCorreo(true); return; }
                setSuccess(true);
                setTimeout(() => navigate("/merchant/offers"), avisoFotos ? 6000 : 3000);
              }} />}
      </div>
    </div>
  );

  return (
    <div style={S.page}>
      <MerchantHeader businessName={stats?.business_name} activePage="offers" />
      <div className="alta-cuerpo">
        <button className="alta-volver" onClick={() => {
          if (step > (isEdit ? 3 : 1)) setStep(modoImperdible && step === 3 ? 1 : step - 1);   // s227-D4 · sin plantillas
          // s169: volver al menú YA NO descarta lo generado. Era el punto de descarte #3
          // y tiraba propuestas con el cupo gastado. El carril IA las vuelve a mostrar.
          else if (ADVISOR_ENABLED && !isEdit && !modoImperdible && mode !== "choose") { setMode("choose"); setGenError(""); }
          else navigate("/merchant/offers");
        }}>
          {/* s191 — decia «Atrás» en los dos casos, y los dos casos son distintos: uno
              baja un paso del formulario y el otro devuelve al menu de arranque. Al
              comercio con borrador, ESTE es su unico camino a «Empiezo en blanco» —
              y con el rotulo viejo parecia que lo sacaba de la pantalla. */}
          ← {step > (isEdit ? 3 : 1)
              ? (lang === "en" ? "Back" : "Atrás")
              : (ADVISOR_ENABLED && !isEdit && !modoImperdible && mode !== "choose")
                ? (lang === "en" ? "How do you want to start?" : "¿Cómo quieres empezar?")
                : (lang === "en" ? "Back to offers" : "Volver a ofertas")}
        </button>
        <div className="alta-titulo">{isEdit ? (lang === "en" ? "EDIT OFFER" : "EDITAR OFERTA")
          : modoImperdible ? (lang === "en" ? "CAN'T-MISS OFFER" : "OFERTA IMPERDIBLE") : (lang === "en" ? "NEW OFFER" : "NUEVA OFERTA")}</div>
        {(isEdit || mode === "manual") && <AltaPasos paso={step} lang={lang} />}
        {modoImperdible && !isEdit && step >= 3 && (form.offer_type === "bogo" || form.offer_type === "percent") && (() => {
          // El medidor del modo: dice si con lo que lleva escrito entra en Imperdibles (mismo criterio que isBestDealOffer).
          const entra = form.offer_type === "bogo" || (parseFloat(form.discount_pct) || 0) >= 50;
          return (
            <div className={entra ? "imp-medidor imp-medidor--entra" : "imp-medidor"} role="status">
              {entra
                ? (lang === "en" ? "Your offer goes into Can't-miss, the catalog's best-deals section." : "Tu oferta entra en Imperdibles, la sección de las mejores ofertas del catálogo.")
                : (lang === "en" ? "Below 50% it doesn't go into Can't-miss. You can still send it as a regular offer." : "Por debajo de 50 % no entra en Imperdibles. Igual puedes enviarla como una oferta normal.")}
            </div>
          );
        })()}
        {isEdit && OFFER_EDIT_MAINTENANCE && (
          <div className="alta-aviso" style={{ marginBottom: 20 }}>
            🛠 {lang === "en"
              ? "Offer editing is temporarily under maintenance. You can review your offer, but changes cannot be saved."
              : "La edición de ofertas está temporalmente en mantenimiento. Puedes revisar tu oferta, pero los cambios no se pueden guardar."}
          </div>
        )}
        {error && (<div className="alta-aviso alta-aviso--error" style={{ marginBottom: 20 }}>{error}</div>)}

        {/* STEP 0: ENTRY CHOICE — carril rápido (IA) vs manual. Solo modo crear. */}
        {ADVISOR_ENABLED && !isEdit && step === 1 && mode === "choose" && perfilListo && (
          <div className="alta-opciones">
            <div style={{ fontSize: 15, fontWeight: 600, color: "var(--tinta)" }}>{lang === "en" ? "How do you want to start?" : "¿Cómo quieres empezar?"}</div>
            {GENERAR_CON_IA && (
            <button className="alta-opcion alta-opcion--destacada" onClick={() => setMode("ai")}>
              <div className="alta-opcion__icono">✨</div>
              <div className="alta-opcion__texto">
                <div className="alta-opcion__nombre">{lang === "en" ? "Generate with AI" : "Generar con IA"}</div>
                <div className="alta-opcion__nota">{txt.intro}</div>
              </div>
              <div className="alta-opcion__flecha" style={{ color: "var(--accion)" }}>→</div>
            </button>
            )}
            <button className="alta-opcion" onClick={() => { setDirectoEnBlanco(false); setMode("manual"); }}>
              <div className="alta-opcion__icono">✏️</div>
              <div className="alta-opcion__texto">
                <div className="alta-opcion__nombre">{lang === "en" ? "Start from a template" : "Empiezo con una plantilla"}</div>
                <div className="alta-opcion__nota">{lang === "en" ? "Pick a type and a ready-made template. The fastest way if you've never written one." : "Eliges un tipo y una plantilla ya escrita. Lo más rápido si nunca armaste una."}</div>
              </div>
              <div className="alta-opcion__flecha">→</div>
            </button>
            {/* s186 · LA HOJA EN BLANCO, EN LA PRIMERA PANTALLA. Existía — pero enterrada
                dos pasos adentro, después de elegir el tipo Y de mirar una lista de
                plantillas que el comercio no pidió. El que ya sabe qué oferta quiere hacer
                no tiene por qué pasar por ahí. Sigue eligiendo el tipo, porque el tipo ES
                la oferta; lo que se salta son las plantillas. */}
            <button className="alta-opcion" onClick={() => { setDirectoEnBlanco(true); setMode("manual"); }}>
              <div className="alta-opcion__icono">◻️</div>
              <div className="alta-opcion__texto">
                <div className="alta-opcion__nombre">{lang === "en" ? "Start from blank" : "Empiezo en blanco"}</div>
                <div className="alta-opcion__nota">{lang === "en" ? "You already know what you want to offer. Pick the type and write it your way." : "Ya sabes qué quieres ofrecer. Eliges el tipo y la escribes a tu manera."}</div>
              </div>
              <div className="alta-opcion__flecha">→</div>
            </button>

            {/* s191 · EL BORRADOR, OFRECIDO EN EL MENU. Esto es lo que permite que
                «Nueva oferta» vuelva a caer aca sin reabrir lo que s189-C cerraba: el
                salto existia para que el comercio con propuestas pagadas no fuera
                empujado a «Generar con IA» y gastara otra generacion encima de lo suyo.
                Ahora no lo empuja nadie —lo suyo esta aca, cuarto y aparte— y ademas
                puede elegir empezar en blanco. */}
            {/* `genOffers` NACE null (ver su useState), no []. Todo el archivo lo
                respeta —`genOffers || []`, `if (!genOffers ...)`, y el mismo guard de
                mas abajo— y esta linea fue la unica que lo desreferencio derecho: el
                menu se pinta en el PRIMER render, antes de cualquier efecto, o sea con
                null puesto. Eso dejo /merchant/offers/new en negro dos veces (7b3527f
                y 3148d6d). */}
            {genOffers && genOffers.length > 0 && (
              <button type="button" className="ofr-borrador" onClick={() => setMode("ai")}>
                <span className="ofr-borrador__texto">
                  <span className="ofr-borrador__titulo">
                    {lang === "en"
                      ? `You already have ${genOffers.length} saved ${genOffers.length === 1 ? "proposal" : "proposals"}`
                      : `Ya tienes ${genOffers.length} ${genOffers.length === 1 ? "propuesta guardada" : "propuestas guardadas"}`}
                  </span>
                  <span className="ofr-borrador__nota">
                    {lang === "en"
                      ? "No need to generate again — open them and pick which ones to edit."
                      : "No hace falta generar de nuevo: ábrelas y elige cuáles editar."}
                  </span>
                </span>
                <span className="ofr-borrador__flecha" aria-hidden="true">{"→"}</span>
              </button>
            )}
          </div>
        )}

        {/* CARRIL RÁPIDO: generación con IA (URL/menú con fallback + wizard de preguntas) */}
        {ADVISOR_ENABLED && !isEdit && step === 1 && mode === "ai" && (
          <div className="alta-carriles">
            {/* s187 - ticket `orden-dom-invertido-en-el-alta`. Los dos carriles
                salian del DOM SIEMPRE en el orden archivo -> preguntas, y el orden
                visual lo invertia `style={{ order: preguntasPrimero ? ... }}`.
                `order` mueve lo que se VE, no lo que se LEE: en peluqueria, spa y
                experiencias el tabulador y el lector de pantalla llegaban primero al
                camino SECUNDARIO, y si el CSS no cargaba, el salon veia primero el
                camino de la carta. Verificado en runtime por sala: el DOM traia
                Opcion B antes que Opcion A. Ahora el rubro decide el orden de RENDER
                y el DOM dice lo mismo que la pantalla.
                Las `key` no son decorativas: son lo que hace que invertir el orden
                sea un REORDENAMIENTO y no un remontaje — el texto que el comercio ya
                escribio en los campos sobrevive al cambio. Y siguen siendo hijos
                directos de `.alta-carriles`: un array no crea envoltorio, asi que la
                grilla de dos columnas de >=900px no se toca. */}
            {(() => {
              // Opcion A - URL / menu (el rotulo A/B lo pone `rotuloArchivo`, que
              // sigue a la POSICION, no a este nombre de variable).
              const bloqueArchivo = (
                <div key="archivo" className="alta-bloque">
                  {/* s186 · este bloque hablaba solo de «menú», y la mitad de las categorías no
                      tiene menú: una peluquería tiene lista de servicios, un gimnasio tiene
                      planes. También invita el link del MENÚ QR — que en EE.UU. usan entre el
                      55 y el 60% de los restaurantes y es una página web como cualquier otra,
                      o sea que el carril de la URL ya la sabe leer. Lo que faltaba era
                      pedírselo: con «https://turestaurante.com» de ejemplo, el comercio pega
                      su home, donde la carta no está. */}
                  <div className="alta-bloque__titulo">{rotuloArchivo} {lang === "en" ? "— Use what you already have" : "— Usa lo que ya tienes"}</div>
                  <div className="alta-bloque__nota">{txt.notaArchivo}</div>
                  <label className="alta-etiqueta" htmlFor="nxt-f27">{txt.labelUrl}</label>
                  <input id="nxt-f27" className="alta-input" value={ingestUrl} onChange={(e) => setIngestUrl(e.target.value)} placeholder={txt.phUrl} />
                  {/* s238 · webs-de-terceros: sin web propia, el enlace de su Booksy/Toast sirve (y el dominio pelado no). */}
                  {ingestUrl.trim()
                    ? <AvisoPlataforma url={ingestUrl} en={lang === "en"} />
                    : <div style={{ fontSize: 12, marginTop: 6, color: C.gray }}>{lang === "en"
                      ? "No website of your own? Paste your page on Booksy, Vagaro, Fresha, Phorest, Toast or your online store."
                      : "¿No tienes web propia? Pega tu página de Booksy, Vagaro, Fresha, Phorest, Toast o tu tienda online."}</div>}
                  <div style={{ marginTop: 12 }}>
                    <label htmlFor="nxt-f26" className="alta-etiqueta">{txt.labelPdf}</label>
                    {/* s186 · solo PDF: la foto de un menú necesitaría OCR, y prometerla para
                        tragarse el archivo en silencio es lo que hacía esta pantalla hasta hoy. */}
                    <input id="nxt-f26" type="file" accept=".pdf,application/pdf" onChange={(e) => { setIngestFile(e.target.files?.[0] || null); setGenError(""); }} style={{ fontSize: 13 }} />
                    {ingestFile && (
                      <div style={{ fontSize: 12, color: "var(--exito)", marginTop: 6 }}>
                        ✓ {ingestFile.name}
                      </div>
                    )}
                  </div>
                  {/* s186 · EL CAMINO QUE COMPLETA A LOS OTROS DOS. La URL no sirve si la carta
                      es una imagen; el PDF no sirve si es un escaneo; y ninguno de los dos
                      existe para una peluquería, cuyos precios viven en Instagram o en su
                      plataforma de reservas. Pegar texto cubre los tres casos y no puede
                      fallar: es lo que la persona escribió con sus manos.
                      s191 — EL EJEMPLO YA NO SE MEZCLA. Mezclaba comida y servicios a
                      proposito: con un ejemplo solo de platos, una manicurista no se daba
                      cuenta de que esto era para ella. Ese argumento caduco cuando COPY_ALTA
                      partio el copy por rubro — la etiqueta de aca arriba ya dice «pega tu
                      lista de servicios y precios», asi que la manicurista ya sabe que es
                      para ella, y encima le mostrabamos churrasco. El placeholder era lo
                      unico de este panel que seguia hardcodeado: ahora sale de `txt`, igual
                      que sus tres etiquetas. */}
                  <div style={{ marginTop: 12 }}>
                    <label htmlFor="nxt-f28" className="alta-etiqueta">{txt.labelPegar}</label>
                    <textarea id="nxt-f28" className="alta-textarea" rows={4}
                      value={ingestTexto}
                      onChange={(e) => { setIngestTexto(e.target.value); setGenError(""); }}
                      placeholder={txt.phPegar} />
                  </div>
                  <button type="button" onClick={generateFromUrl} disabled={genLoading || !tamanosIA} style={{ ...S.btnPrimary, marginTop: 14, opacity: (genLoading || !tamanosIA) ? 0.6 : 1 }}>
                    {genLoading
                      ? (lang === "en" ? "Reading…" : "Leyendo…")
                      : (ingestFile || ingestTexto.trim())
                        ? txt.botonLeer
                        : (lang === "en" ? "Generate from my site" : "Generar desde mi sitio")}
                  </button>
                </div>
              );

              // Opcion B - preguntas (fallback desbloqueado)
              const bloquePreguntas = (
                <div key="preguntas" className="alta-bloque alta-bloque--claro">
                  <div className="alta-bloque__titulo">{rotuloPreguntas} {lang === "en" ? "— Answer a few quick questions" : "— Responde unas preguntas rápidas"}</div>
                  <div className="alta-bloque__nota">
                    {preguntasPrimero
                      ? txt.notaPreguntas   // s242 · por rubro (COPY_ALTA): Experiencias leía «un salón, un spa o un estudio»
                      : (lang === "en"
                          ? "No website needed. The more detail, the better the offers."
                          : "No hace falta sitio web. Cuanto más detalle, mejores las ofertas.")}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                    <div className="alta-campo">
                      <label htmlFor="nxt-f25" className="alta-etiqueta">{lang === "en" ? "What do you want to achieve?" : "¿Qué quieres lograr?"}</label>
                      <input id="nxt-f25" className="alta-input" value={q.goal} onChange={(e) => setQ({ ...q, goal: e.target.value })} placeholder={txt.phObjetivo} />
                    </div>
                    <div className="alta-campo">
                      <label htmlFor="nxt-f24" className="alta-etiqueta">{lang === "en" ? "What sells best?" : "¿Qué es lo que más vendes?"}</label>
                      <input id="nxt-f24" className="alta-input" value={q.best} onChange={(e) => setQ({ ...q, best: e.target.value })} placeholder={txt.phMasVende} />
                    </div>
                    <div className="alta-campo">
                      <label htmlFor="nxt-f22" className="alta-etiqueta">{lang === "en" ? "Anything else? (optional)" : "¿Algo más? (opcional)"}</label>
                      <input id="nxt-f22" className="alta-input" value={q.extra} onChange={(e) => setQ({ ...q, extra: e.target.value })} placeholder={txt.phAlgoMas} />
                    </div>
                  </div>
                  <button type="button" onClick={generateFromQuestions} disabled={genLoading || !q.goal || !tamanosIA} style={{ ...S.btnPrimary, marginTop: 14, opacity: (genLoading || !q.goal || !tamanosIA) ? 0.6 : 1 }}>
                    {genLoading ? (lang === "en" ? "Generating…" : "Generando…") : (lang === "en" ? "Generate offers" : "Generar ofertas")}
                  </button>
                </div>
              );

              // s244-D7 · el ticket va primero y vale para los dos caminos: de él salen los tamaños de las cuatro propuestas.
              const bloqueTicket = (
                <div key="ticket" className="alta-bloque alta-bloque--claro">
                  <CampoTicketAsesor id="nxt-f23" perfil={merchantProfile} categoria={categoriaOferta}
                    tipoNegocio={merchantProfile?.business_type} valor={q.ticket} fuente={fuenteTicket} en={lang === "en"}
                    onCambio={(v, f) => { setQ(prev => ({ ...prev, ticket: v })); setFuenteTicket(f); }} />
                  {!tamanosIA && <div className="alta-bloque__nota" style={{ marginTop: 6 }}>{avisoFaltaTicket}</div>}
                </div>
              );
              return preguntasPrimero
                ? [bloqueTicket, bloquePreguntas, bloqueArchivo]
                : [bloqueTicket, bloqueArchivo, bloquePreguntas];
            })()}

            {/* s191 · LA ESPERA, DICHA. Hasta hoy la unica senal de que algo pasaba era
                el texto del boton («Generando…»), y la espera real ronda el minuto: el
                comercio se queda mirando una pantalla quieta sin saber si se colgo. Esto
                dice las tres cosas que calman: QUE estamos haciendo, CUANTO tarda —el
                numero honesto, no «unos segundos»— y que no se publica nada.
                `role="status"` + `aria-live` para que un lector de pantalla lo anuncie
                cuando aparece: el boton deshabilitado no avisa nada por si solo. */}
            {genLoading && (
              <div className="alta-espera" role="status" aria-live="polite">
                <div className="alta-espera__barra"><div className="alta-espera__pulso" /></div>
                <div className="alta-espera__titulo">
                  {lang === "en" ? "Building your offers" : "Estamos armando tus ofertas"}
                </div>
                <div className="alta-espera__detalle">
                  {lang === "en"
                    ? "We read what you gave us, cross it with your industry's margins and write the proposals. It usually takes about a minute — you can stay on this screen."
                    : "Leemos lo que nos diste, lo cruzamos con los márgenes de tu rubro y escribimos las propuestas. Suele tardar cerca de un minuto — puedes quedarte en esta pantalla."}
                </div>
                <div className="alta-espera__calma">
                  {lang === "en"
                    ? "Nothing gets published: you choose which ones to keep."
                    : "No se publica nada: tú eliges cuáles guardar."}
                </div>
              </div>
            )}

            {genError && <div className="alta-aviso">{genError}</div>}

            {/* ============================================================
                LAS PROPUESTAS — s189-C
                Es el primer minuto del comercio adentro: espera cincuenta y nueve
                segundos y lo que recibe decide si se queda. Hasta hoy recibia doce
                tarjetas apiladas en una columna de 370px, pintadas con estilos en
                linea de la etapa app-first — la unica pantalla del producto que no
                habia migrado a tokens.css v3.
                El contenido no se toco: cambia quien manda dentro de la tarjeta.
                Ver el encabezado de propuestas.css para las tres decisiones.
                ============================================================ */}
            {genOffers && genOffers.length > 0 && (() => {
              const en = lang === "en";
              const pt = en ? {
                titulo: "Ideas for your offers",
                origen: {
                  sitio: "We drafted these by reading your site.",
                  material: "We drafted these by reading what you sent us.",
                  respuestas: "We drafted these from what you told us about your business.",
                  "": "We drafted these from your business details.",
                },
                nadaCerrada: "None of them is set in stone.",
                paso1: `Mark the ones you like. You can mark several — up to ${MAX_SAVED_PROPOSALS}.`,
                paso2: "On the next screen you edit them: price, name, days, hours. Everything can be changed.",
                paso3: "Nothing goes live until you submit it and we approve it.",
                recomendadas: "Recommended",
                topeAlcanzado: `That is the maximum we save. Unmark one to pick another.`,
                itemSinFuente: (item) => `This 2-for-1 uses “${item}”, which doesn't appear in what you told us about your business. Change it to something you sell, or pick another proposal.`,
                generadoEl: "Generated on ",
                sinCredito: " · showing them again uses no credit",
                filtrar: "Filter by risk level",
                todas: "All",
                audaz: "Bold", notaAudaz: "The ones that bring the most people. You give up more per sale, and in exchange you get customers who don't know you yet.",
                seguro: "Safe", notaSeguro: "Smaller discount: you give up less per sale, and they move fewer people.",
                // «Otras ideas» no lleva nota: la que tenía —«el asistente no las clasificó por
                // riesgo»— hablaba de nuestra maquinaria, no del negocio del comercio.
                otras: "Other ideas", notaOtras: "",
                clientePaga: "The customer pays",
                verCalculo: "See the details",
                ocultar: "Hide the details",
                verOtras: (n) => `See the other ${n} ideas`,
                marcaLas: "Mark the ones you like",
              } : {
                titulo: "Ideas para tus ofertas",
                origen: {
                  sitio: "Las armamos leyendo tu sitio.",
                  material: "Las armamos leyendo lo que nos pasaste.",
                  respuestas: "Las armamos con lo que nos contaste de tu negocio.",
                  "": "Las armamos con los datos de tu negocio.",
                },
                nadaCerrada: "Ninguna está cerrada.",
                paso1: `Marca las que te gusten. Puedes marcar varias — hasta ${MAX_SAVED_PROPOSALS}.`,
                paso2: "En la pantalla siguiente las editas: precio, nombre, días, horarios. Todo se puede cambiar.",
                paso3: "No se publica nada hasta que tú la envíes y nosotros la aprobemos.",
                recomendadas: "Recomendadas",
                topeAlcanzado: `Es el máximo que se guarda. Desmarca una para elegir otra.`,
                itemSinFuente: (item) => `Este 2x1 usa «${item}», que no aparece en lo que nos contaste de tu negocio. Cámbialo por algo que sí vendas o elige otra propuesta.`,
                generadoEl: "Generado el ",
                sinCredito: " · volver a verlas no gasta generaciones",
                filtrar: "Filtrar por nivel de riesgo",
                todas: "Todas",
                audaz: "Audaces", notaAudaz: "Las que más gente traen. Resignas más por venta, y a cambio entra clientela que hoy no te conoce.",
                seguro: "Seguras", notaSeguro: "Descuento más chico: resignas menos por venta, y también mueven menos gente.",
                otras: "Otras ideas", notaOtras: "",
                clientePaga: "El cliente paga",
                // s189-C · «Ver el cálculo» dejó de ser cierto cuando se fue el margen: detrás
                // no hay ninguna cuenta, hay el porqué completo, los días y la descripción.
                verCalculo: "Ver el detalle",
                ocultar: "Ocultar el detalle",
                verOtras: (n) => `Ver las otras ${n} ideas`,
                marcaLas: "Marca las que te gustaron",
              };

              // s179 L5.8 · el orden por riesgo ya existía. Lo que no existía era MOSTRARLO.
              // s189-C ter · Y AHORA LAS AUDACES VAN PRIMERO, decisión de Ali del 05/09.
              // El motivo es de negocio y conviene tenerlo escrito: un club de beneficios sin
              // beneficios que valgan la pena no tiene razón de existir. Al miembro le sirve el
              // descuento grande, y al comercio le decide igual — pero lo que ve primero pesa.
              // Ojo con la separación: `idDe` dice QUÉ ES una propuesta (semántica del asesor) y
              // `ORDEN` dice DÓNDE VA (decisión de producto). Estaban fundidas en un índice, y
              // así cambiar el orden de la pantalla cambiaba la clasificación.
              const idDe = (o) => {
                const r = (o._adv || {}).risk_level;
                if (r === "seguro" || r === "safe") return "seguro";
                if (r === "audaz" || r === "bold") return "audaz";
                return "otras";
              };
              const ORDEN = { audaz: 0, seguro: 1, otras: 2 };
              const GRUPOS_IDS = ["audaz", "seguro", "otras"];
              const ordenadas = genOffers.map((o, i) => ({ o, i }))
                .sort((x, y) => ORDEN[idDe(x.o)] - ORDEN[idDe(y.o)] || x.i - y.i);

              const cuentas = { seguro: 0, audaz: 0, otras: 0 };
              ordenadas.forEach(({ o }) => { cuentas[idDe(o)] += 1; });
              // Un filtro que se quedó apuntando a un grupo que ya no existe (después de
              // guardar, la lista se queda solo con las marcadas) no puede dejar la pantalla
              // en blanco. Se deriva, no se corrige con un setState en pleno render.
              const filtro = cuentas[genFiltro] ? genFiltro : "todas";

              // s179 L5.8 seguía vigente —doce tarjetas de una no se comparan, se scrollean— pero
              // su recorte era por LISTA: se mostraban las 3 primeras del orden, y como el orden
              // es por riesgo, eso dejaba fuera de la primera pantalla a TODAS las audaces. El
              // recorte pasa a ser POR GRUPO: las tres primeras de cada nivel. Así la primera
              // pantalla muestra la clasificación entera, que es justamente lo que el grupo vino
              // a hacer visible. Con un filtro puesto no se recorta nada: pedir «solo las
              // seguras» y que te muestre la mitad de las seguras no tiene defensa.
              // 3 por grupo cuando hay varios; 6 cuando hay uno solo. El recorte por grupo
              // existe para que la primera pantalla muestre la CLASIFICACIÓN entera — con un
              // solo grupo no hay clasificación que mostrar, y 3 de 12 sería tacaño justo
              // donde la grilla podría lucir. El total visible queda parejo (9 contra 6) en
              // vez de saltar de 9 a 3 según algo que el comercio no controla.
              const gruposPresentes = GRUPOS_IDS.filter(id => cuentas[id] > 0).length;
              const POR_GRUPO = gruposPresentes > 1 ? 3 : 6;
              const recorta = filtro === "todas" && !genVerTodas
                && GRUPOS_IDS.some(id => cuentas[id] > POR_GRUPO);
              const vistos = { seguro: 0, audaz: 0, otras: 0 };
              const enPantalla = !recorta ? ordenadas : ordenadas.filter(({ o }) => {
                const id = idDe(o);
                vistos[id] += 1;
                return vistos[id] <= POR_GRUPO;
              });

              const GRUPOS = [
                { id: "audaz", titulo: pt.audaz, nota: pt.notaAudaz, recomendada: true },
                { id: "seguro", titulo: pt.seguro, nota: pt.notaSeguro },
                { id: "otras", titulo: pt.otras, nota: pt.notaOtras },
              ];
              const grupos = GRUPOS
                .filter(g => filtro === "todas" || filtro === g.id)
                .map(g => ({ ...g, items: enPantalla.filter(({ o }) => idDe(o) === g.id) }))
                .filter(g => g.items.length > 0);
              // 🔴 SI EL ASESOR NO CLASIFICÓ NADA, NO HAY GRUPOS QUE MOSTRAR.
              // Todo el espinazo de esta pantalla —secciones, filetes, filtros, la insignia
              // de recomendadas— cuelga de `risk_level`, un campo que llena el asesor y que
              // NUNCA medimos: puede no venir. Si viene vacío en las doce, el único
              // encabezado de la pantalla sería «OTRAS IDEAS · el asistente no las clasificó
              // por riesgo» — un texto sobre nuestra maquinaria interna, en la cara del
              // comercio, y encima el título contrasta con unas ideas «principales» que no
              // existen. En ese caso la grilla va sola: «Ideas para tus ofertas», que es el
              // título de la sección, ya las nombra.
              // Con DOS grupos o más, «Otras ideas» sí significa algo (contrasta con las
              // clasificadas) y se muestra.
              const sinClasificar = grupos.length === 1 && grupos[0].id === "otras";
              const filtros = [{ id: "todas", etiqueta: pt.todas, cuenta: ordenadas.length }]
                .concat(GRUPOS.filter(g => cuentas[g.id] > 0).map(g => ({ id: g.id, etiqueta: g.titulo, cuenta: cuentas[g.id] })));

              return (
                <section className="prop" aria-labelledby="prop-titulo">
                  <header className="prop__cabecera">
                    <h2 className="prop__titulo" id="prop-titulo">{pt.titulo}</h2>
                    {/* s189-C (arreglo C) · «Estas son ideas de ejemplo» tiraba el único
                        argumento que las hace creíbles: salieron de lo que el comercio nos
                        dio. Ahora dice de dónde, según el carril por el que salieron. */}
                    <p className="prop__nota">{pt.origen[genOrigen] || pt.origen[""]} {pt.nadaCerrada}</p>
                    {/* s189-C ter · TRES PASOS, NO UNA CLÁUSULA DESPUÉS DE UN GUION.
                        Que todo es editable se decía en tres lugares y ninguno servía: en una
                        subordinada acá arriba, en el botón, y en letra chica al final de todo
                        —debajo de doce tarjetas—. Un comercio que no es hábil con esto no
                        deduce nada: hay que decírselo, en orden, y contestarle la pregunta
                        que se hace antes de tocar algo, que es «¿esto se publica solo?».
                        El techo de 8 (arreglo B) se mudó ACÁ ADENTRO: era un aviso ámbar
                        suelto y ahora es parte de la instrucción. Se sigue viendo antes de
                        marcar, que es lo que el arreglo pedía, y ya no parece una advertencia.
                        La barra sigue avisando cuando se llega. */}
                    <ol className="prop__pasos">
                      <li className="prop__paso">{pt.paso1}</li>
                      <li className="prop__paso">{pt.paso2}</li>
                      <li className="prop__paso prop__paso--calma">{pt.paso3}</li>
                    </ol>
                    {genDraftAt && (
                      <p className="prop__meta">
                        {pt.generadoEl}
                        {new Date(genDraftAt).toLocaleDateString(en ? "en-US" : "es-ES", { day: "numeric", month: "short" })}
                        {pt.sinCredito}
                      </p>
                    )}
                  </header>

                  {filtros.length > 2 && (
                    <div className="prop__filtros" role="group" aria-label={pt.filtrar}>
                      {filtros.map(f => (
                        <button key={f.id} type="button"
                          className={filtro === f.id ? "prop__filtro prop__filtro--activo" : "prop__filtro"}
                          aria-pressed={filtro === f.id}
                          onClick={() => setGenFiltro(f.id)}>
                          {f.etiqueta}<span className="prop__filtro-cuenta">{f.cuenta}</span>
                        </button>
                      ))}
                    </div>
                  )}

                  {grupos.map(g => (
                    <section className="prop__grupo" key={g.id}>
                      {!sinClasificar && (
                        <>
                          <h3 className="prop__grupo-titulo">
                            <span className={`prop__marca prop__marca--${g.id}`} aria-hidden="true" />
                            {g.titulo}<span className="prop__grupo-cuenta">{g.items.length}</span>
                            {g.recomendada && <span className="prop__recomendada">{pt.recomendadas}</span>}
                          </h3>
                          {g.nota && <p className="prop__grupo-nota">{g.nota}</p>}
                        </>
                      )}
                      <ul className="prop__grilla">
                        {g.items.map(({ o, i }) => {
                          const a = o._adv || {};
                          const key = o._key;
                          const picked = genSelected.includes(key);
                          const bloqueada = !picked && topeAlcanzado;
                          const hls = [o.highlight_1, o.highlight_2, o.highlight_3].filter(Boolean);
                          // El precio deja de ser una cadena y pasa a ser estructura: el de
                          // lista tachado, el del cupón firme, el porcentaje como insignia.
                          const antes = a.regular_price || (o.offer_type === "fixed" ? o.regular_price : 0);
                          const ahora = a.coupon_price || (o.offer_type === "fixed" ? o.coupon_price : 0);
                          const parDePrecios = !!(antes && ahora);
                          const precioSuelto = parDePrecios ? ""
                            // s244 · sin precio (la fuente no lo trae y el asesor no lo estimó) se dice «2×1», nunca «2×1 ($0)»: el precio lo pide el form.
                            : o.offer_type === "bogo" ? (Number(o.unit_price) > 0 ? `2×1 ($${o.unit_price})` : "2×1")
                            : o.offer_type === "free" ? (en ? `Free ($${o.regular_price} value)` : `Gratis ($${o.regular_price} de valor)`)
                            : o.offer_type === "percent" ? chipPorcentaje(o.discount_pct, en) : "";   // s221-D1: nada de «OFF»
                          const hayCuerpo = !!(a.why_it_works || a.when || o.description || hls.length);
                          const clases = ["prop-tarjeta", `prop-tarjeta--${idDe(o)}`];
                          if (picked) clases.push("prop-tarjeta--marcada");
                          if (bloqueada) clases.push("prop-tarjeta--tope");
                          return (
                            <li key={key || i} className={clases.join(" ")}>
                              <label className="prop-tarjeta__marca" title={bloqueada ? pt.topeAlcanzado : undefined}>
                                <input
                                  type="checkbox"
                                  className="prop-tarjeta__check"
                                  checked={picked}
                                  disabled={bloqueada}
                                  onChange={() => toggleGenSelected(key)}
                                />
                                <span className="prop-tarjeta__titulo">{o.title}</span>
                              </label>

                              {/* LA CIFRA QUE LIDERA ES LA OFERTA, Y NADA MÁS.
                                  Acá vivió medio día «Tu margen: $28 (88%)», y se fue por
                                  decisión de Ali del 05/09 después de mirar a la competencia:
                                  ese número era una afirmación sobre el bolsillo de OTRO,
                                  armada con un costo que estima un LLM. Ver el encabezado de
                                  propuestas.css. Lo que queda es lo único que sabemos con
                                  certeza porque es nuestro: cuánto va a pagar el cliente. */}
                              <div className="prop-tarjeta__cifras">
                                {parDePrecios ? (
                                  <p className="prop-tarjeta__precio">
                                    <span className="prop-tarjeta__rotulo">{pt.clientePaga}</span>
                                    <span className="prop-tarjeta__ahora">${ahora}</span>
                                    <s className="prop-tarjeta__antes">${antes}</s>
                                    {a.discount_pct ? <span className="prop-tarjeta__desc">-{a.discount_pct}%</span> : null}
                                  </p>
                                ) : precioSuelto ? (
                                  /* 2×1, gratis o un % suelto: el rótulo «el cliente paga» no
                                     aplica (en «gratis» no paga nada), así que la frase se
                                     defiende sola y va sin rótulo. */
                                  <p className="prop-tarjeta__precio">
                                    <span className="prop-tarjeta__ahora prop-tarjeta__ahora--frase">{precioSuelto}</span>
                                  </p>
                                ) : null}
                              </div>

                              {/* s244 · bogo-sin-fuente: el asesor propuso un 2x1 sobre un ítem que no está en lo que el
                                  dueño cargó (api.js marcarItemsSinFuente). A la vista, sin abrir «ver cálculo»: no se
                                  borra la propuesta, se avisa antes de «Usar esta oferta». */}
                              {a.item_sin_fuente && (
                                <p className="prop-tarjeta__aviso-item" role="note">{pt.itemSinFuente(a.item || o.title)}</p>
                              )}

                              {hayCuerpo && (
                                <details className="prop-tarjeta__mas">
                                  <summary className="prop-tarjeta__resumen">
                                    {a.why_it_works && <span className="prop-tarjeta__gancho">{a.why_it_works}</span>}
                                    <span className="prop-tarjeta__ver">
                                      <span className="prop-tarjeta__ver--abrir">{pt.verCalculo}</span>
                                      <span className="prop-tarjeta__ver--cerrar">{pt.ocultar}</span>
                                    </span>
                                  </summary>
                                  <div className="prop-tarjeta__cuerpo">
                                    {a.when && <p className="prop-tarjeta__cuando">🕑 {a.when}</p>}
                                    {o.description && <p className="prop-tarjeta__desc-larga">{o.description}</p>}
                                    {hls.length > 0 && (
                                      <div className="prop-tarjeta__sellos">
                                        {hls.map((h, j) => <span key={j} className="prop-tarjeta__sello">{h}</span>)}
                                      </div>
                                    )}
                                  </div>
                                </details>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </section>
                  ))}

                  {/* s179 L5.8: el «ver más» no descarta nada — solo deja de dibujar. */}
                  {recorta && (
                    <button type="button" className="prop__mas-tarjetas" onClick={() => setGenVerTodas(true)}>
                      {pt.verOtras(ordenadas.length - enPantalla.length)}
                    </button>
                  )}

                  {/* s253 · ¿PREFIERES PORCENTAJE? (Ali, 02/11). Las propuestas de arriba son monto fijo por la tabla del ticket;
                      aquí el dueño arma un % con o sin tope, como el bloque de la invitación (nxt-landing merchants/invitacion.js
                      «Si prefieres porcentaje»). Regla, sin IA: no gasta generaciones. Mínimo PCT_MINIMO (20), recomendado
                      PCT_DEFECTO (25). Los tips dicen solo lo que el catálogo hace: un % entra en Imperdibles desde 50
                      (isBestDealOffer); por eso aquí no se promete «más visibilidad» con 30 %. */}
                  {(() => {
                    const PCTS = [20, 25, 30, 35, 40, 50];
                    const TOPES = [0, 20, 30, 40, 50];
                    const topeNum = topeProp > 0 ? topeProp : TOPE_SIN_LIMITE;
                    const consumo = ticketIA > 0 ? ticketIA * (RUBROS_RECIBO_DOS.includes(categoriaOferta) ? 2 : 1) : 0;
                    const desc = Math.round(Math.min(consumo * pctProp / 100, topeNum) * 100) / 100;
                    const usarPct = () => {
                      const shape = advisorOfferToForm({ offer_type: "percent", title: tituloPorcentaje(pctProp, topeNum, en, categoriaOferta),
                        discount_pct: pctProp, benefit_value_usd: topeNum, regular_price: precioRegularDePct(topeNum, pctProp),
                        ...textosDelPct({ pct: pctProp, tope: topeNum, en, categoria: categoriaOferta, perfil: merchantProfile || {} }) }, form.source_lang);
                      applyGeneratedOffer({ ...shape, _adv: {} });
                    };
                    const tips = en ? [
                      `${PCT_DEFECTO}% is what we recommend: it shows on the bill and protects your margin.`,
                      "A percentage is clear at a glance, and the member doesn't have to reach a minimum.",
                      "With a cap you know the most you give per visit. With no cap the discount grows with the bill.",
                      "50% or more goes into Can't-miss, the catalog's featured section.",
                    ] : [
                      `${PCT_DEFECTO} % es lo que recomendamos: se nota en la cuenta y cuida tu margen.`,
                      "Un porcentaje se entiende de un vistazo y el miembro no tiene que llegar a un mínimo.",
                      "Con tope sabes lo máximo que das por visita. Sin tope, el descuento crece con la cuenta.",
                      "Con 50 % o más entra en Imperdibles, la sección destacada del catálogo.",
                    ];
                    return (
                      <section className="prop-pct" aria-labelledby="prop-pct-titulo">
                        <h3 className="prop-pct__titulo" id="prop-pct-titulo">{en ? "Prefer a percentage?" : "¿Prefieres porcentaje?"}</h3>
                        <p className="prop-pct__nota">{en
                          ? "The ideas above are a fixed amount, sized to your average ticket. You can also give a percentage of the bill, with or without a cap per visit. You choose."
                          : "Las ideas de arriba son de monto fijo, según tu ticket promedio. También puedes dar un porcentaje de la cuenta, con o sin tope por visita. Tú eliges."}</p>
                        <div className="prop-pct__campos">
                          <div className="prop-pct__campo">
                            <span className="prop-pct__rotulo" id="prop-pct-l">{en ? "Percentage" : "Porcentaje"}</span>
                            <div className="prop-pct__chips" role="group" aria-labelledby="prop-pct-l">
                              {PCTS.map(p => (
                                <button key={p} type="button" className="prop-pct__chip" aria-pressed={pctProp === p} onClick={() => setPctProp(p)}>
                                  {p}{en ? "%" : " %"}{p === PCT_DEFECTO && <small>{en ? "recommended" : "recomendado"}</small>}
                                </button>
                              ))}
                            </div>
                          </div>
                          <div className="prop-pct__campo">
                            <span className="prop-pct__rotulo" id="prop-tope-l">{en ? "Cap per visit" : "Tope por visita"} <small>{en ? "optional" : "opcional"}</small></span>
                            <div className="prop-pct__chips" role="group" aria-labelledby="prop-tope-l">
                              {TOPES.map(c => (
                                <button key={c} type="button" className="prop-pct__chip" aria-pressed={topeProp === c} onClick={() => setTopeProp(c)}>
                                  {c ? (en ? `up to $${c}` : `hasta $${c}`) : (en ? "No cap" : "Sin tope")}
                                </button>
                              ))}
                            </div>
                          </div>
                        </div>
                        <p className="prop-pct__lee">{en ? "This is what members read:" : "Esto es lo que leen los miembros:"} <strong>{frasePorcentaje(pctProp, topeNum, en, categoriaOferta)}</strong></p>
                        {consumo > 0 && (
                          <table className="prop-pct__recibo" aria-label={en ? "Example bill" : "Cuenta de ejemplo"}>
                            <tbody>
                              <tr><td>{RUBROS_RECIBO_DOS.includes(categoriaOferta) ? (en ? "Two people" : "Dos personas") : (en ? "One visit" : "Una visita")}</td><td>${fmtUsd(consumo)}</td></tr>
                              <tr><td>{en ? "NXT Reserve discount" : "Descuento NXT Reserve"}</td><td className="prop-pct__desc">−${fmtUsd(desc)}</td></tr>
                              <tr className="prop-pct__total"><td>{en ? "You charge" : "Cobras"}</td><td>${fmtUsd(Math.round((consumo - desc) * 100) / 100)}</td></tr>
                            </tbody>
                          </table>
                        )}
                        {topeProp === 0 && <p className="prop-pct__aviso" role="note">{avisoSinTope(en)}</p>}
                        <ul className="prop-pct__tips">{tips.map((t, k) => <li key={k}>{t}</li>)}</ul>
                        <button type="button" className="prop-pct__usar" onClick={usarPct}>
                          {en ? `Use ${pctProp}% and edit it` : `Usar ${pctProp} % y editarla`}
                        </button>
                      </section>
                    );
                  })()}

                  {/* s179 L5.2 · LA BARRA CON EL CONTADOR. Era el único camino que preservaba
                      el trabajo y vivía al fondo, después de nueve tarjetas largas. Sigue
                      pegada abajo; ahora además avisa cuando se llegó al techo. */}
                  <div className={genSelected.length ? "alta-barra alta-barra--activa" : "alta-barra"}>
                    <div className="alta-barra__cuenta" aria-live="polite">
                      {genSelected.length === 0
                        ? pt.marcaLas
                        : (en
                          ? `${genSelected.length} marked${genOffers.length - genSelected.length ? ` · ${genOffers.length - genSelected.length} will be discarded` : ""}`
                          : `${genSelected.length} marcada${genSelected.length === 1 ? "" : "s"}${genOffers.length - genSelected.length ? ` · se descartan ${genOffers.length - genSelected.length}` : ""}`)}
                      {topeAlcanzado && <span className="prop-barra__tope">{pt.topeAlcanzado}</span>}
                    </div>
                    <button
                      type="button"
                      onClick={guardarYEditar}
                      disabled={genSelected.length === 0 || genSaving}
                      style={{ ...S.btnPrimary, padding: "12px 18px", fontSize: 14, fontWeight: 700, opacity: (genSelected.length === 0 || genSaving) ? 0.5 : 1, cursor: (genSelected.length === 0 || genSaving) ? "default" : "pointer" }}
                    >
                      {genSaving
                        ? (en ? "Saving…" : "Guardando…")
                        : genSelected.length === 0
                          ? (en ? "Save and start editing" : "Guardar y empezar a editar")
                          : (en
                            ? `Save the ${genSelected.length} you marked and start editing`
                            : `Guardar ${genSelected.length === 1 ? "la que marcaste" : `las ${genSelected.length} que marcaste`} y empezar a editar`)}
                    </button>
                  </div>

                  {genNote && <div className="alta-aviso prop__aviso-ok" aria-live="polite">{genNote}</div>}
                  {genDisclaimer && <div className="alta-ayuda">{genDisclaimer}</div>}
                  <div className="alta-ayuda">{en ? "These are AI suggestions — you can edit everything in the next step." : "Son sugerencias de IA — puedes editar todo en el paso siguiente."}</div>
                </section>
              );
            })()}
          </div>
        )}

        {/* PASO 1 · EL TIPO DE BENEFICIO */}
        {step === 1 && mode === "manual" && (
          <div className="alta-opciones">
            <div style={{ fontSize: 15, fontWeight: 600, color: "var(--tinta)" }}>
              {modoImperdible ? (lang === "en" ? "Pick how to make it a can't-miss" : "Elige cómo hacerla imperdible") : (lang === "en" ? "What type of benefit?" : "¿Qué tipo de beneficio?")}
            </div>
            {modoImperdible && (
              <div className="alta-ayuda">{lang === "en" ? "2-for-1 or 50% or more: it goes into the catalog's Can't-miss section. It's reviewed like any other offer before it goes live."
                : "2×1 o 50 % o más: entra en la sección Imperdibles del catálogo. La revisamos como cualquier otra antes de publicarla."}</div>
            )}
            {(modoImperdible ? ["bogo", "percent"].map(id => offerTypes.find(t => t.id === id)) : offerTypes.filter(t => t.estandar || t.visible || verAvanzado)).map(t => (
              <button key={t.id} className={form.offer_type === t.id ? "alta-opcion alta-opcion--elegida" : (t.estandar ? "alta-opcion alta-opcion--destacada" : "alta-opcion")}
                // s194 L1: la estándar no tiene plantillas — sus «plantillas» son los tamaños del paso 3.
                // s227-D4: en el modo Imperdible el % arranca en 50 (el comercio lo puede cambiar; el medidor avisa).
                onClick={() => {
                  chooseOfferType(t.id);
                  if (modoImperdible && t.id === "percent") setForm(f => ({ ...f, discount_pct: f.discount_pct || "50" }));
                  setStep((directoEnBlanco || t.id === UMBRAL_TIPO) ? 3 : 2);
                }}>
                <div className="alta-opcion__icono">{t.icon}</div>
                <div className="alta-opcion__texto">
                  <div className="alta-opcion__nombre">{t.label}</div>
                  <div className="alta-opcion__nota">{t.desc}</div>
                  <div className="alta-opcion__ej">{t.example}</div>
                </div>
                <div className="alta-opcion__flecha">→</div>
              </button>
            ))}
            {!verAvanzado && !modoImperdible && (
              <button type="button" className="alta-chip" onClick={() => setVerAvanzado(true)} style={{ alignSelf: "flex-start" }}>
                {lang === "en"
                  ? "I need a specific offer (advanced: 2×1, fixed price, complimentary)"
                  : "Necesito una oferta específica (avanzado: 2×1, precio fijo, cortesía)"}
              </button>
            )}
          </div>
        )}

        {/* PASO 2 · LA PLANTILLA */}
        {step === 2 && (() => {
          const delRubro = (templates[form.category || merchantProfile?.category] || templates.Restaurant)
            .filter(t => t.type === form.offer_type);
          return (
          <div className="alta-opciones">
            <div style={{ fontSize: 15, fontWeight: 600, color: "var(--tinta)" }}>{lang === "en" ? "Start from a template or blank" : "Empieza con una plantilla o en blanco"}</div>
            <button className="alta-opcion alta-opcion--blanco" onClick={() => setStep(3)}>
              <div style={{ fontSize: 24, marginBottom: 4 }}>✏️</div>
              <div className="alta-opcion__nombre">{lang === "en" ? "Start from Scratch" : "Empezar en Blanco"}</div>
              <div className="alta-opcion__nota">{lang === "en" ? "Create your custom offer" : "Crea tu oferta personalizada"}</div>
            </button>
            {/* s185: las plantillas estan escritas en espanol y NO hay version en ingles.
                Antes se mostraba el titulo espanol tal cual dentro de una pantalla
                traducida, y applyTemplate ademas clavaba source_lang:"es" — un comercio
                que trabaja en ingles elegia una plantilla y se llevaba la oferta escrita
                en espanol sin enterarse. Se avisa que estan en espanol y que el titulo se
                puede reescribir en el paso siguiente. La traduccion de las plantillas es
                ticket aparte: inventarles un titulo en ingles aca seria contenido nuevo
                sin que nadie lo haya escrito. */}
            {lang === "en" && delRubro.length > 0 && (
              <div className="alta-ayuda">Templates are written in Spanish — you can rewrite the title in the next step, and we translate on save.</div>
            )}
            {delRubro.map((t, i) => (
              <button key={i} className="alta-opcion" onClick={() => applyTemplate(t)}>
                <div className="alta-opcion__texto">
                  <div className="alta-opcion__nombre">{t.title_es}</div>
                  <div className="alta-opcion__ej">
                    {t.type === "fixed" && `$${t.regular_price} → $${t.coupon_price}`}
                    {t.type === "bogo" && `2×1 ($${t.unit_price})`}
                    {/* s185: decia «Gratis ($15 value)» — mitad espanol, mitad ingles, en
                        los dos idiomas. Ahora cada idioma dice su frase entera. */}
                    {t.type === "free" && (lang === "en" ? `Free ($${t.regular_price} value)` : `Gratis (valor $${t.regular_price})`)}
                    {t.type === "percent" && tituloPorcentaje(t.discount_pct, t.tope, lang === "en", categoriaOferta)}
                  </div>
                </div>
                <div className="alta-opcion__flecha">→</div>
              </button>
            ))}
            {delRubro.length === 0 && (
              <div style={{ textAlign: "center", padding: 20, color: "var(--tinta-suave)", fontSize: 13 }}>{lang === "en" ? "No templates for this type yet. Start from scratch!" : "No hay plantillas para este tipo. ¡Empieza en blanco!"}</div>
            )}
          </div>
          );
        })()}

        {/* ---------- PASO 3 · TU OFERTA ----------
            s179 L2: aca vive TODO lo que puede hacer que approve_offer rechace la
            oferta — el tipo, los precios y el beneficio. Nada del paso 4 puede
            tumbar una aprobacion. Por eso el dinero va primero y va solo. */}
        {step === 3 && (
          <div className="alta-forma">
            {/* s215 · Ali: la pregunta del idioma se oculta («English» no funciona bien todavía).
                Queda el idioma de la interfaz (source_lang inicial). Ticket ingles-reactivar ~18/10. */}
            {/* s215 · en la estándar el «qué» baja al paso 4 (opcional); acá queda solo para los tipos viejos. */}
            {!esUmbralForm && (
            <div className="alta-campo">
              {/* s212 · el título es EL QUÉ (ronda 10): la cifra ya la dice la tarjeta. */}
              <AltaEtiqueta para="alta-titulo" requerido
                texto={esUmbralForm ? (lang === "en" ? "What do people order most?" : "¿Qué es lo que más te piden?") : (lang === "en" ? "Title" : "Título")}
                pista={lang === "en" ? "Members see it under your business name. It becomes the offer title." : "Los miembros lo ven debajo del nombre de tu negocio. Pasa a ser el título de la oferta."} />
              <input id="alta-titulo" className="alta-input" aria-describedby="alta-titulo-ayuda"
                value={esUmbralForm && esTituloUmbralGenerado(form.title) ? "" : form.title} onChange={set("title")} placeholder={txtOferta.phTitulo} />
              {/* s223 · la ayuda de la estándar («la tarjeta ya dice “Ahorra $X…”») salía también en el 2×1, el precio fijo
                  y la cortesía, donde la tarjeta no dice eso. */}
              <AltaAyuda id="alta-titulo-ayuda" texto={esPctForm
                ? (lang === "en" ? "We suggest one from your % and cap. You can change it: say what it applies to." : "Te sugerimos uno con tu % y tu tope. Lo puedes cambiar: di sobre qué aplica.")
                : esUmbralForm ? txt.ayudaTitulo
                : (lang === "en" ? "Say what the member gets, by name. E.g.: «2-for-1 house burgers»." : "Di qué recibe el miembro, con nombre. Ej.: «2×1 en hamburguesas de la casa».")} />
              {sinTitulo && intentoContinuar && (
                <div className="alta-aviso alta-aviso--error alta-aviso--campo">{mensajeSinTitulo}</div>
              )}
            </div>
            )}
            <AltaPrecios form={form} set={set} setVal={setVal} setForm={setForm} lang={lang} categoria={categoriaOferta} esEdicion={isEdit} sinD={ofertaSembrada} />
            {/* s148 P2a: valor del beneficio visible y editable — es lo que ve el miembro en la tarjeta.
                s237 · editor-cuota-de-servicio: la ayuda ya no habla de cuota de servicio (el club no cobra comisión,
                COPY_SIN_COMISION; la misma limpieza que s193-D1 hizo más abajo). */}
            {/* s194 L1: en umbral el beneficio lo fija el tamaño; el campo libre no se muestra.
                s221-D1: en el % tampoco — el beneficio ES el tope de arriba. */}
            {esPctForm && pctBloquea && intentoContinuar && (
              <div className="alta-aviso alta-aviso--error alta-aviso--campo">{mensajePct || mensajeTope}</div>
            )}
            {!esUmbralForm && !esPctForm && (
            <div className="alta-campo">
              <AltaEtiqueta para="alta-beneficio"
                texto={lang === "en" ? "Benefit Value $" : "Valor del Beneficio $"}
                pista={lang === "en"
                  ? "The dollar value a member gets from this offer. It's shown on the member card. Leave empty to calculate it from your prices."
                  : "El valor en dólares que recibe el miembro con esta oferta. Se muestra en su tarjeta. Déjalo vacío para calcularlo desde tus precios."} />
              <input
                id="alta-beneficio"
                className="alta-input"
                type="number"
                min="0"
                inputMode="decimal"
                aria-describedby="alta-beneficio-ayuda"
                value={form.benefit_value_usd}
                onChange={set("benefit_value_usd")}
                placeholder={computedBenefitValue ? String(computedBenefitValue) : "50"}
              />
              {/* s179 L3.2: «Valor Regular» y «Valor del Beneficio» convivían sin decir
                  cuál manda. El hint ahora dice quién calcula y cuándo tocarlo. */}
              <AltaAyuda id="alta-beneficio-ayuda" texto={(lang === "en"
                ? `It's what your customer saves. We calculate it from your prices — only touch it if your number is different. Suggested: $${fmtUsd(computedBenefitValue || 0)}.`
                : `Es lo que tu cliente ahorra. Lo calculamos solo desde tus precios — solo tócalo si tu número es otro. Sugerido: $${fmtUsd(computedBenefitValue || 0)}.`)} />
              {/* s179 L3.1: el motivo, junto al campo que hay que corregir. El botón
                  «Continuar →» de más abajo también queda bloqueado. */}
              {benefitBloquea && (
                <div className="alta-aviso alta-aviso--error alta-aviso--campo">{mensajeBenefit}</div>
              )}
              {/* s185: y el otro motivo por el que esta oferta no se puede guardar. Antes
                  este aviso salia recien al tocar «Enviar Oferta», DOS pasos mas adelante,
                  lejos del campo que lo causa. Aparece despues del primer intento, no
                  antes: en un formulario recien abierto todavia no es un error. */}
              {!benefitBloquea && sinAhorro && intentoContinuar && (
                <div className="alta-aviso alta-aviso--error alta-aviso--campo">{mensajeSinAhorro}</div>
              )}
            </div>
            )}
            {/* s194 L1: el motivo del tamaño, junto a su selector, tras el primer intento. */}
            {faltaTamano && intentoContinuar && (
              <div className="alta-aviso alta-aviso--error alta-aviso--campo">{mensajeTamano}</div>
            )}
            {/* s185: con el invariante roto NO se dibuja. Antes convivian el error rojo
                («el ahorro no puede ser mayor al precio de lista») y un recuadro verde
                felicitando por «MIEMBRO AHORRA $45 (4500% off)». */}
            {/* s221-D1 · un % bloqueado (menos de 20, sin tope) no se dibuja: caería al formato viejo «ahorra $X». */}
            {!benefitBloquea && !(esPctForm && pctBloquea) && (
              <AltaAhorro lang={lang} valor={effectiveBenefitValue} pct={pctAhorro} umbral={umbralForm} categoria={categoriaOferta}
                porcentaje={esPctForm ? { pct: pctForm, tope: effectiveBenefitValue } : null} />
            )}
            {/* s144 alcohol-cero-oferta: marca compliance de licencia (s143-D3), no preferencia.
                s194 L1: la estándar aplica a comida y bebidas sin alcohol (s194-D2, regla 2):
                no se pregunta. Y la ayuda ya no habla de cuota de servicio (s193-D1). */}
            {/* s241 · solo donde hay alcohol (perfil del rubro: restaurantes y bares). Un salón no tiene licencia que marcar. */}
            {!esUmbralForm && perfilDelRubro(categoriaOferta).alcohol && (
            <div className="alta-campo">
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14, color: "var(--tinta)", fontWeight: 600 }}>
                <input type="checkbox" checked={!!form.is_alcohol} onChange={e => setForm(f => ({ ...f, is_alcohol: e.target.checked }))} />
                {lang === "en" ? "This offer includes alcoholic beverages" : "Esta oferta incluye bebidas alcohólicas"}
              </label>
              <AltaAyuda texto={lang === "en" ? "Alcohol licensing compliance flag." : "Marca de cumplimiento de la licencia de alcohol."} />
            </div>
            )}

            {/* s179 L2 — FIN DEL PASO 3 «Tu oferta». Todo lo de arriba es lo que el asesor
                llena (6 de 6) y lo único que puede tumbar una aprobación. */}
            <div className="alta-acciones">
              {/* s185-b · EN EDICION ESTE BOTON NO PUEDE BAJAR AL PASO 2. El de arriba ya
                  tenia el piso (`step > (isEdit ? 3 : 1)`) y este no: en una oferta ya
                  publicada te dejaba en el selector de plantillas, donde un toque en
                  cualquier plantilla PISA los datos cargados. El comentario de s179 L2 ya
                  decia «en modo edicion no se puede bajar de 3a» — el codigo no lo cumplia.
                  Encontrado verificando en produccion, no leyendo. */}
              <button className="alta-btn alta-btn--atras"
                onClick={() => { if (isEdit) navigate("/merchant/offers"); else setStep(esUmbralForm ? 1 : 2); }}>
                ← {isEdit
                  ? (lang === "en" ? "Back to offers" : "Volver a ofertas")
                  : (lang === "en" ? "Back" : "Atrás")}
              </button>
              {/* s179 L3.1: no se puede avanzar con el invariante roto. El motivo ya está
                  en pantalla junto al campo del beneficio, así que el botón solo frena.
                  s185: y tampoco sin ahorro — el mismo criterio, en el mismo paso.
                  s185-b: el banner de arriba se limpia SIEMPRE al entrar. Antes «Título
                  requerido» se escribia y ya no se borraba: escribias el titulo, llenabas
                  los precios, y el aviso seguia arriba contradiciendo al recuadro verde
                  que ya calculaba el ahorro. Es el mismo defecto que este lote vino a
                  cerrar —dos avisos de la misma pantalla diciendo cosas distintas—, del
                  otro lado. Y el motivo del titulo baja junto al campo, como los otros dos:
                  el banner de arriba es para errores del servidor, no para campos. */}
              <button
                className="alta-btn alta-btn--seguir"
                disabled={benefitBloquea}
                onClick={() => {
                  setError("");
                  if (faltaTamano) { setIntentoContinuar(true); return; }
                  if (benefitBloquea) { setError(mensajeBenefit); return; }
                  if (sinTitulo || sinAhorro || pctBloquea) { setIntentoContinuar(true); return; }
                  setStep(4);
                }}>
                {lang === "en" ? "Continue →" : "Continuar →"}
              </button>
            </div>
          </div>
        )}

        {/* ---------- PASO 3b · LOS DETALLES ----------
            s179 L2: el contenido que el asesor NO llena (1 de 7). Nada de acá puede
            tumbar una aprobación, por eso vive después de la pantalla del dinero. */}
        {step === 4 && (
          <div className="alta-forma">
            {/* s215 · nivel 2, opcional: el plato o servicio con nombre. Vacío = la oferta es por toda la cuenta. */}
            {esUmbralForm && (
              <div className="alta-campo">
                <AltaEtiqueta para="alta-titulo"
                  texto={lang === "en" ? "What do people order most? (optional)" : "¿Qué es lo que más te piden? (opcional)"}
                  pista={lang === "en" ? "If you write it, members see it under your business name. Empty is fine: the offer applies to the whole bill." : "Si lo escribes, los miembros lo ven debajo del nombre de tu negocio. Vacío está bien: la oferta vale para toda la cuenta."} />
                <input id="alta-titulo" className="alta-input"
                  value={esTituloUmbralGenerado(form.title) ? "" : form.title} onChange={set("title")} placeholder={txtOferta.phTitulo} />
              </div>
            )}
            <div className="alta-campo">
              <AltaEtiqueta para="alta-descripcion"
                texto={lang === "en" ? "Description" : "Descripción"}
                pista={lang === "en" ? "Tell members what makes this offer special. Include what's included, any conditions, and why they should try it" : "Cuéntale a los miembros qué hace especial esta oferta. Incluye qué está incluido, condiciones y por qué deberían probarla"} />
              <textarea id="alta-descripcion" className="alta-textarea" aria-describedby="alta-descripcion-ayuda"
                value={form.description} onChange={set("description")} placeholder={txtOferta.phDescripcion} rows={3} />
              {esUmbralForm && !form.description.trim() && !esTituloUmbralGenerado(form.title) && (
                <AltaAyuda texto={lang === "en" ? `Leave it empty and we write it from your answers: «${fraseAlcance(categoriaOferta, true)} What people order most: …»` : `Si lo dejas vacío, lo armamos con tus respuestas: «${fraseAlcance(categoriaOferta, false)} Lo que más piden: …»`} />
              )}
              <AltaAyuda id="alta-descripcion-ayuda" texto={lang === "en" ? "2-3 sentences work best. Focus on the experience, not just the discount" : "2-3 oraciones funcionan mejor. Enfócate en la experiencia, no solo en el descuento"} />
            </div>
            {esUmbralForm && (
              <div className="alta-campo">
                <AltaEtiqueta para="alta-cuando" texto={lang === "en" ? "Best time to come (optional)" : "Cuándo conviene venir (opcional)"}
                  pista={lang === "en" ? "When you want more people. It is advice for the member, not a restriction." : "Cuándo quieres más gente. Es un consejo para el miembro, no una restricción."} />
                <input id="alta-cuando" className="alta-input" value={form.cuando_ir} onChange={set("cuando_ir")} placeholder={(CUANDO_IR_EJEMPLO[FAMILIA_POR_RUBRO[categoriaOferta]] || CUANDO_IR_EJEMPLO.mesa)[lang === "en" ? "en" : "es"]} />
              </div>
            )}
            <div className="alta-campo">
              <AltaEtiqueta grupo="alta-destacados-rotulo"
                texto={lang === "en" ? "Highlights" : "Destacados"}
                pista={lang === "en" ? "3 short phrases that appear as tags on your offer card. Think: what makes your offer stand out?" : "3 frases cortas que aparecen como etiquetas en tu tarjeta de oferta. Piensa: ¿qué hace especial tu oferta?"} />
              {/* s185: eran tres columnas fijas. A 375px eso da campos de 110px donde el
                  marcador sale cortado a la mitad («Ej: Lo que t»). Se apilan en telefono. */}
              <div className="alta-trio" role="group" aria-labelledby="alta-destacados-rotulo">
                {/* s179 L4.1: los ejemplos salen del rubro del comercio, no de un restaurante.
                    form.category se hereda del perfil al entrar al wizard. */}
                {(() => {
                  const ph = highlightPlaceholders(form.category, lang);
                  const pref = lang === "en" ? "Eg: " : "Ej: ";
                  return [1, 2, 3].map((i) => (
                    <div key={i}>
                      <label htmlFor={`nxt-f21-${i}`} className="alta-etiqueta">✨ {i}</label>
                      <input id={`nxt-f21-${i}`} className="alta-input" value={form["highlight_" + i]} onChange={set("highlight_" + i)} placeholder={pref + ph[i - 1]} />
                    </div>
                  ));
                })()}
              </div>
            </div>

            {/* B5.1: Asistente IA de ofertas (read-only; aplica al borrador, no guarda) */}
            {/* s176-B: superficie 2 del asesor — flag PROPIO (SUGGEST_IMPROVEMENTS_ENABLED, top
                del archivo). Apagada porque suggest_offer_improvements trocea el JSON del modelo
                como lista numerada y devuelve los 5 campos vacios. El carril rapido NO comparte
                este bug y sigue encendido con ADVISOR_ENABLED. */}
            {SUGGEST_IMPROVEMENTS_ENABLED && (
            <div style={{ border: `1px dashed ${C.border}`, borderRadius: 8, padding: 16, background: "var(--superficie-panel)" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: C.black }}>
                  {lang === "en" ? "✨ Improve with AI" : "✨ Mejorar con IA"}
                </div>
                <button type="button" onClick={suggestAI} disabled={aiLoading || !form.title}
                  style={{ padding: "8px 16px", borderRadius: 6, border: `1px solid ${C.red}`, background: aiLoading ? C.light : C.red, color: aiLoading ? C.muted : C.white, fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 13, cursor: (aiLoading || !form.title) ? "default" : "pointer", opacity: !form.title ? 0.6 : 1 }}>
                  {aiLoading ? (lang === "en" ? "Thinking…" : "Pensando…") : (lang === "en" ? "Suggest improvements" : "Sugerir mejoras")}
                </button>
              </div>
              <div style={{ fontSize: 11, color: C.muted, marginTop: 6 }}>
                {lang === "en"
                  ? "AI reviews your draft and suggests a better title, description and highlights. Nothing is saved until you apply and submit."
                  : "La IA revisa tu borrador y sugiere mejor título, descripción y destacados. No se guarda nada hasta que apliques y envíes."}
              </div>
              {aiError && <div style={{ marginTop: 10, fontSize: 12, color: C.red }}>{aiError}</div>}
              {aiResult && (
                <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 12 }}>
                  {aiResult.improved_title && (
                    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 6, padding: 12 }}>
                      <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>{lang === "en" ? "Suggested title" : "Título sugerido"}</div>
                      <div style={{ fontSize: 14, color: C.black, marginBottom: 8 }}>{aiResult.improved_title}</div>
                      <button type="button" onClick={() => setVal("title", aiResult.improved_title)} className="alta-chip">{lang === "en" ? "Use" : "Usar"}</button>
                    </div>
                  )}
                  {aiResult.improved_description && (
                    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 6, padding: 12 }}>
                      <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>{lang === "en" ? "Suggested description" : "Descripción sugerida"}</div>
                      <div style={{ fontSize: 14, color: C.black, marginBottom: 8, whiteSpace: "pre-line" }}>{aiResult.improved_description}</div>
                      <button type="button" onClick={() => setVal("description", aiResult.improved_description)} className="alta-chip">{lang === "en" ? "Use" : "Usar"}</button>
                    </div>
                  )}
                  {aiResult.suggested_highlights && (
                    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 6, padding: 12 }}>
                      <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>{lang === "en" ? "Suggested highlights" : "Destacados sugeridos"}</div>
                      <div style={{ fontSize: 14, color: C.black, marginBottom: 8, whiteSpace: "pre-line" }}>{aiResult.suggested_highlights}</div>
                      <button type="button" onClick={() => applyHighlights(aiResult.suggested_highlights)} className="alta-chip">{lang === "en" ? "Use" : "Usar"}</button>
                    </div>
                  )}
                  {aiResult.whats_missing && (
                    <div style={{ background: "var(--aviso-tinte)", border: "1px solid var(--linea)", borderRadius: 6, padding: 12 }}>
                      <div style={{ fontSize: 10, color: "var(--aviso)", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>{lang === "en" ? "What's missing" : "Qué falta"}</div>
                      <div style={{ fontSize: 13, color: "var(--aviso)", whiteSpace: "pre-line" }}>{aiResult.whats_missing}</div>
                    </div>
                  )}
                  {aiResult.tips && (
                    <div style={{ background: "var(--info-tinte)", border: "1px solid var(--info-linea)", borderRadius: 6, padding: 12 }}>
                      <div style={{ fontSize: 10, color: "var(--info)", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: 4 }}>{lang === "en" ? "Tips" : "Consejos"}</div>
                      <div style={{ fontSize: 13, color: "var(--info)", whiteSpace: "pre-line" }}>{aiResult.tips}</div>
                    </div>
                  )}
                </div>
              )}
            </div>
            )}
            <div>
              <AltaEtiqueta grupo="alta-disponibilidad-rotulo" texto={lang === "en" ? "Availability" : "Disponibilidad"}
                pista={lang === "en" ? "When can members use this offer? These are for display only — you validate at redemption" : "¿Cuándo pueden usar los miembros esta oferta? Son solo informativos — tú validas al canjear"} />
            </div>
            {/* s179 L9-B · RED DE SEGURIDAD.
                El problema real no era que los días no se tildaran: era que la oferta DECÍA
                una cosa y HACÍA otra EN SILENCIO. El 25/08 la descripción decía
                "Válido mar-mié 12-3pm" y la oferta quedaba disponible los siete días.
                🛑 NO se tilda nada automáticamente desde el texto: un día de más es una
                promesa que el comercio no quiere. Esto solo rompe el silencio; decide él. */}
            {(() => {
              const texto = `${form.title || ""} ${form.description || ""}`;
              const faltanDias = !String(form.valid_days || "").trim();
              // s213 · «Sin límite de horario» es un acto (s180-D4), no un olvido: no cuenta como horas
              // que faltan. Antes el aviso saltaba con todo elegido si el texto nombraba un día.
              const faltanHoras = !form.umbral_franjas && !sinLimiteHorario && !form.valid_time_start && !form.valid_time_end;
              if (!(faltanDias || faltanHoras)) return null;
              if (!mencionaDisponibilidad(texto)) return null;
              return (
                <div style={{ background: "var(--aviso-tinte)", border: "1px solid var(--linea)", borderRadius: 8, padding: "10px 12px", fontSize: 12, color: "var(--aviso)", lineHeight: 1.5 }}>
                  ⚠️ {lang === "en"
                    ? "Your description mentions days or hours, but you haven't marked any. Mark them here or take them out of the text — otherwise the offer promises something it can't deliver."
                    : "Tu descripción menciona días u horarios, pero no marcaste ninguno. Márcalos aquí o quítalos del texto — si no, la oferta promete algo que no puede cumplir."}
                </div>
              );
            })()}
            <div>
              <div className="alta-etiqueta" id="alta-dias-rotulo">{lang === "en" ? "Days" : "Días"}</div>
              {(() => {
                // s154 lote D: mismo vocabulario que el feed (FEED_DAY_TOKENS, sin tilde en la base);
                // el label sí lleva tilde (Mié/Sáb) — display y valor son capas distintas.
                const DAY_TOKENS = FEED_DAY_TOKENS;
                const DAY_LABELS = lang === "en" ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES;
                const sel = new Set(diasSel);
                const toggleDay = (tok) => { const n = new Set(sel); n.has(tok) ? n.delete(tok) : n.add(tok); setForm(f => ({ ...f, valid_days: DAY_TOKENS.filter(t => n.has(t)).join(",") })); };
                // s181 B1: «Todos los días» es un ACTO explícito, no un default — ninguna oferta
                // nace con los 7 marcados. Se deriva de la selección: activo solo con los 7,
                // y destildar un día lo apaga solo. Tocarlo estando activo vuelve a cero días.
                const toggleTodos = () => setVal("valid_days", todosLosDias ? "" : DAY_TOKENS.join(","));
                return (
                  <div className="alta-chips" role="group" aria-labelledby="alta-dias-rotulo">
                    <button type="button" aria-pressed={todosLosDias} onClick={toggleTodos} className={chipDisp(todosLosDias, true)}>{lang === "en" ? "Every day" : "Todos los días"}</button>
                    {/* s215 · Ali: atajos para el dueño que no quiere tildar día por día. */}
                    {[
                      { dias: ["Lun", "Mar", "Mie", "Jue"], es: "Lunes a jueves", en: "Mon to Thu" },
                      { dias: ["Vie", "Sab", "Dom"], es: "Viernes a domingo", en: "Fri to Sun" },
                    ].map(a => {
                      const on = diasSel.length === a.dias.length && a.dias.every(d => sel.has(d));
                      return (
                        <button type="button" key={a.es} aria-pressed={on} className={chipDisp(on, true)}
                          onClick={() => setVal("valid_days", on ? "" : DAY_TOKENS.filter(t => a.dias.includes(t)).join(","))}>
                          {lang === "en" ? a.en : a.es}
                        </button>
                      );
                    })}
                    <span className="alta-chips__corte" />
                    {DAY_TOKENS.map((tok, i) => {
                      const on = sel.has(tok);
                      return (
                        <button type="button" key={tok} aria-pressed={on} onClick={() => toggleDay(tok)} className={chipDisp(on)}>{DAY_LABELS[i]}</button>
                      );
                    })}
                  </div>
                );
              })()}
              {/* s181 B2: con cero días no se pasa al Revisar. El motivo, junto al campo. */}
              {mensajeDias && <div className={avisoDisp}>{mensajeDias}</div>}
            </div>
            {/* s194 L1: con «dos franjas» el horario lo ponen los presets (H3); acá solo se dice. */}
            {form.umbral_franjas ? (
              <div>
                <div className="alta-etiqueta">{lang === "en" ? "Hours" : "Horario"}</div>
                <div className="alta-ayuda">
                  {UMBRAL_FRANJAS.map(fr => `${lang === "en" ? fr.en : fr.es} ${rango12(fr.ini, fr.fin, lang === "en")}`).join(" · ")}
                  {lang === "en" ? " — set by the dayparts; adjust later from My Offers." : " — los fijan las franjas; se ajustan después desde Mis Ofertas."}
                </div>
              </div>
            ) : esEncargo(categoriaOferta) ? null : (
            <div>
              <div className="alta-etiqueta" id="alta-horario-rotulo">{lang === "en" ? "Hours" : "Horario"}</div>
              {/* s181 B3: «Sin límite de horario» es un acto. Activo => DESDE/HASTA se vacían y se
                  deshabilitan (en la base «sin límite» ya era horas vacías: el contrato no cambia).
                  Inactivo => las dos horas son obligatorias y DESDE tiene que ser antes que HASTA. */}
              <div className="alta-chips" role="group" aria-labelledby="alta-horario-rotulo" style={{ marginBottom: 10 }}>
                <button type="button" aria-pressed={sinLimiteHorario} onClick={toggleSinLimite} className={chipDisp(sinLimiteHorario, true)}>{lang === "en" ? "No time limit" : "Sin límite de horario"}</button>
                {/* s215 · atajos de horario: llenan Desde/Hasta y se ajustan a mano si hace falta.
                    s239 · auditoría s237 (E1): con las horas de las franjas del alta y de Otto (UMBRAL_FRANJAS: 11:30–15:00 y
                    18:00–23:00); decían 11:00–15:00 y 17:00–22:00, y la misma «cena» tenía dos horarios según la pantalla. */}
                {atajosHorario(categoriaOferta).map(f => ({ ini: f.ini, fin: f.fin, es: `Solo ${f.es.toLowerCase()}`, en: `${f.en} only` })).map(h => {
                  const on = !sinLimiteHorario && form.valid_time_start === h.ini && form.valid_time_end === h.fin;
                  return (
                    <button type="button" key={h.es} aria-pressed={on} className={chipDisp(on, true)}
                      onClick={() => { setSinLimiteHorario(false); setForm(f => ({ ...f, valid_time_start: h.ini, valid_time_end: h.fin })); }}>
                      {lang === "en" ? h.en : h.es} <span style={{ opacity: 0.7, fontWeight: 400 }}>{rango12(h.ini, h.fin, lang === "en")}</span>
                    </button>
                  );
                })}
              </div>
              {/* s154 lote D: <input type="time"> (molde del bloque de horarios del perfil) —
                  guarda "HH:MM" 24h, el mismo vocabulario que serializeHours. Se acabó el texto libre.
                  s180 A9: step=600 (minutos de 10 en 10) + onFocus abre el selector, igual que el perfil. */}
              <div className="alta-par" style={{ opacity: sinLimiteHorario ? 0.45 : 1 }}>
                <div><label htmlFor="nxt-f20" className="alta-etiqueta">{lang === "en" ? "From" : "Desde"}</label><input id="nxt-f20" type="time" step={600} className="alta-input" onFocus={abrirPicker} disabled={sinLimiteHorario} value={form.valid_time_start} onChange={set("valid_time_start")} /></div>
                <div><label htmlFor="nxt-f19" className="alta-etiqueta">{lang === "en" ? "Until" : "Hasta"}</label><input id="nxt-f19" type="time" step={600} className="alta-input" onFocus={abrirPicker} disabled={sinLimiteHorario} value={form.valid_time_end} onChange={set("valid_time_end")} /></div>
              </div>
              {mensajeHorario && <div className={avisoDisp}>{mensajeHorario}</div>}
            </div>
            )}
            {/* s213 · lote B+C: plazo y plan. s214: también en el alta nueva (`create_offer` los recibe
                desde la S6, deployada el 03/10). En una nueva el plazo nace en 30 y el plan en «Ninguno». */}
            {/* s223 · el plazo, en todos los tipos (antes solo en la estándar: los demás quedaban con el de PricingConfig). */}
            <SelectorPlazo id="alta-cooldown" en={lang === "en"} valor={form.cooldown_days || String(plazoNace)}
              tipoNegocio={merchantProfile?.business_type || ""}
              onCambio={v => setForm(f => ({ ...f, cooldown_days: v }))} />
            {esUmbralForm && (
              <>
                <SelectorPlan id="alta-plan" en={lang === "en"} categoria={categoriaOferta} valor={form.plan} vacio={lang === "en" ? "None" : "Ninguno"}
                  onCambio={v => setForm(f => ({ ...f, plan: v }))} />
              </>
            )}
            {/* s222 · lote 2a · dónde vale la oferta. Nace con el del rubro marcado. */}
            {!esEncargo(categoriaOferta) && <SelectorCanal id="alta-canal" en={lang === "en"} valor={canalForm}
              onCambio={v => setForm(f => ({ ...f, redemption_channel: v }))} />}
            {/* s194 L1: en umbral el mínimo lo fija el tamaño; el campo libre no se muestra.
                s221-D1: en el % tampoco — no tiene mínimo (el tope protege al comercio). */}
            {!esUmbralForm && !esPctForm && (
            <div>
              <AltaEtiqueta para="alta-consumo-minimo" texto={lang === "en" ? "Minimum spend (optional)" : "Consumo mínimo (opcional)"}
                pista={lang === "en" ? "Minimum amount in USD the member must spend to use the offer. Leave blank if there's no minimum." : "Monto mínimo en USD que el miembro debe consumir para usar la oferta. Déjalo vacío si no hay mínimo."} />
              <input id="alta-consumo-minimo" className="alta-input" type="number" min="0" step="1" inputMode="decimal" value={form.min_consumption} onChange={set("min_consumption")} placeholder={lang === "en" ? "E.g.: 25" : "Ej: 25"} />
            </div>
            )}
            <div>
              <AltaEtiqueta para="alta-reglas" texto={(esUmbralForm || esPctForm) ? (lang === "en" ? "Extra conditions (optional)" : "Condiciones extra (opcional)") : (lang === "en" ? "Rules / Conditions" : "Reglas / Condiciones")}
                pista={lang === "en" ? "Any restrictions members should know: 'Not valid on holidays', 'Minimum 2 guests', 'Reservation required', etc." : "Restricciones que los miembros deben saber: 'No válido en feriados', 'Mínimo 2 personas', 'Requiere reserva', etc."} />
              {/* s179 L4.2 (T4 del diseño s99): el textarea vacío no le dice al comercio qué
                  escribir. Estos toggles COMPILAN a rules_text, que ya es param de
                  create_offer — cero Bubble. Se anteponen a lo que el comercio haya escrito
                  a mano, y destildar quita solo esa línea sin tocar el resto. */}
              {/* s194 L1: en umbral las siete reglas ya están (solo lectura); los presets
                  sueltos las duplicarían. El textarea queda para lo que no esté en la lista. */}
              {esUmbralForm ? <ReglasUmbralLista /> : esPctForm ? <ReglasPctLista /> : (() => {
                const lineas = (form.rules_text || "").split(/\r?\n/).map(x => x.trim()).filter(Boolean);
                const textoDe = (r) => (form.source_lang === "en" ? r.en : r.es);
                const activa = (r) => lineas.includes(textoDe(r));
                const toggle = (r) => {
                  const t = textoDe(r);
                  const resto = lineas.filter(l => l !== t);
                  const siguientes = activa(r) ? resto : [...resto, t];
                  // se reordena según OFFER_RULE_PRESETS para que la lista no baile al tildar
                  const presets = OFFER_RULE_PRESETS.map(textoDe);
                  const ordenadas = [
                    ...presets.filter(pp => siguientes.includes(pp)),
                    ...siguientes.filter(l => !presets.includes(l)),
                  ];
                  setVal("rules_text", ordenadas.join(SALTO_LINEA));
                };
                const marcadas = OFFER_RULE_PRESETS.filter(activa).length;
                return (
                  <div style={{ marginBottom: 10 }}>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {OFFER_RULE_PRESETS.map(r => {
                        const on = activa(r);
                        return (
                          <button key={r.key} type="button" onClick={() => toggle(r)}
                            style={{ padding: "7px 12px", borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", border: `1px solid ${on ? C.red : C.border}`, background: on ? C.red : C.white, color: on ? C.white : C.gray }}>
                            {on ? "✓ " : "+ "}{textoDe(r)}
                          </button>
                        );
                      })}
                    </div>
                    {/* Warning anti-fricción de Groupon (§T4 s99). Aparece recién cuando ya
                        hay condiciones puestas: antes de eso no aplica y sería ruido. */}
                    {marcadas >= 2 && (
                      <div style={{ marginTop: 8, fontSize: 11, color: "var(--aviso)", background: "var(--aviso-tinte)", border: "1px solid var(--linea)", borderRadius: 6, padding: "8px 10px" }}>
                        {lang === "en"
                          ? `${marcadas} conditions. Each extra condition lowers the chances that members pick you.`
                          : `${marcadas} condiciones. Cada condición extra baja las chances de que te elijan.`}
                      </div>
                    )}
                  </div>
                );
              })()}
              <textarea id="alta-reglas" className="alta-textarea" value={form.rules_text} onChange={set("rules_text")} placeholder={form.source_lang === "en" ? "Eg: Valid Mon-Fri only. Reservation required 24h in advance. Not combinable with other promotions." : "Ej: Válido solo Lun-Vie. Requiere reserva con 24h de anticipación. No combinable con otras promociones."} rows={2} />
            </div>
            <div>
              <AltaEtiqueta para="alta-imagen" requerido={esUmbralForm} texto={lang === "en" ? "Offer image" : "Imagen de la oferta"}
                pista={lang === "en" ? "A photo of your offer or venue. Shown on the offer card on the home." : "Una foto de tu oferta o local. Se muestra en la tarjeta de la oferta en el home."} />
              <input id="alta-imagen" className="alta-input alta-input--archivo" type="file" accept="image/*"
                onChange={e => { const f = e.target.files?.[0]; e.target.value = ""; if (f) { principalPendiente.current = ""; setFotoPorEncuadrar(f); setFaltaFoto(false); } }} />
              {/* s253 · LAS FOTOS DE ESTA OFERTA (Ali). Casillas sobre la galería del negocio: el dueño marca cuáles se
                  muestran (api.js paramsGalleryPick → gallery_pick; «Todas» → clear_gallery_pick al editar). «Principal» baja
                  esa foto del CDN (CORS abierto) y la pasa por el MISMO encuadre que una subida (EncuadrarFoto →
                  recortarImagen, regla s206): Offer.image es su copia. Sin tocar nada, la oferta muestra la galería entera. */}
              {(() => {
                const fotosGaleria = galeriaDelPerfil(merchantProfile);
                if (!fotosGaleria.length) return null;
                const en = lang === "en";
                const marcadas = Array.isArray(form.galeria_marcadas) ? form.galeria_marcadas : fotosGaleria;
                const principal = form.principal_galeria;
                const visibles = fotosGaleria.filter(u => u === principal || marcadas.includes(u));
                const marcar = (lista) => setForm(prev => ({ ...prev, galeria_marcadas: fotosGaleria.filter(u => lista.includes(u)) }));
                const alternar = (url) => marcar(marcadas.includes(url) ? marcadas.filter(u => u !== url) : [...marcadas, url]);
                const hacerPrincipal = async (url, i) => {
                  setErrorGaleria(false);
                  setBajandoDeGaleria(url);
                  try {
                    // Sin caché: la miniatura (<img>) ya la guardó SIN cabecera CORS y fetch reusaba esa copia → bloqueado
                    // (medido en localhost, 02/11). Pedida de nuevo, el CDN responde con Access-Control-Allow-Origin: *.
                    const res = await fetch(url, { cache: "no-store" });
                    if (!res.ok) throw new Error(String(res.status));
                    const blob = await res.blob();
                    const ext = (blob.type.split("/")[1] || "jpg").replace("jpeg", "jpg");
                    principalPendiente.current = url;
                    if (!marcadas.includes(url)) marcar([...marcadas, url]);
                    setFotoPorEncuadrar(new File([blob], `galeria-${i + 1}.${ext}`, { type: blob.type || "image/jpeg" }));
                    setFaltaFoto(false);
                  } catch (e) {
                    setErrorGaleria(true);
                  } finally {
                    setBajandoDeGaleria("");
                  }
                };
                return (
                  <div className="alta-galeria-elegir">
                    <p className="alta-galeria-elegir__nota">{en
                      ? `Photos shown in this offer: ${visibles.length} of the ${fotosGaleria.length} in your gallery. Tick the ones you want; «Main» puts one first.`
                      : `Fotos que muestra esta oferta: ${visibles.length} de las ${fotosGaleria.length} de tu galería. Marca las que quieres mostrar; «Principal» pone una primero.`}</p>
                    <button type="button" className="alta-galeria-elegir__abrir" aria-expanded={galeriaAbierta}
                      onClick={() => setGaleriaAbierta(v => !v)}>
                      {galeriaAbierta ? (en ? "Hide my gallery" : "Ocultar mi galería") : (en ? "Choose photos from my gallery" : "Elegir fotos de mi galería")}
                    </button>
                    {galeriaAbierta && (<>
                      <div className="alta-galeria-elegir__atajos">
                        <button type="button" className="alta-galeria-elegir__atajo" onClick={() => marcar(fotosGaleria)}>{en ? "All" : "Todas"}</button>
                        <button type="button" className="alta-galeria-elegir__atajo" onClick={() => marcar([])}>{en ? "None" : "Ninguna"}</button>
                      </div>
                      <ul className="alta-galeria-elegir__grilla" aria-label={en ? "Photos in your gallery" : "Fotos de tu galería"}>
                        {fotosGaleria.map((url, i) => {
                          const esPrincipal = url === principal;
                          const marcada = esPrincipal || marcadas.includes(url);
                          return (
                            <li key={url} className={marcada ? "alta-galeria-elegir__item alta-galeria-elegir__item--marcada" : "alta-galeria-elegir__item"}>
                              <label className="alta-galeria-elegir__foto">
                                <input type="checkbox" className="alta-galeria-elegir__check" checked={marcada} disabled={esPrincipal}
                                  aria-label={en ? `Show photo ${i + 1}` : `Mostrar la foto ${i + 1}`} onChange={() => alternar(url)} />
                                <img src={url} alt="" loading="lazy" />
                                {esPrincipal && <span className="alta-galeria-elegir__sello">{en ? "★ Main" : "★ Principal"}</span>}
                                {bajandoDeGaleria === url && <span className="alta-galeria-elegir__cargando">{en ? "Loading…" : "Cargando…"}</span>}
                              </label>
                              {!esPrincipal && (
                                <button type="button" className="alta-galeria-elegir__principal" disabled={!!bajandoDeGaleria}
                                  onClick={() => hacerPrincipal(url, i)}>{en ? "Main" : "Principal"}</button>
                              )}
                            </li>
                          );
                        })}
                      </ul>
                    </>)}
                    {errorGaleria && <div className="alta-aviso alta-aviso--error alta-aviso--campo" role="alert">{en
                      ? "We couldn't open that photo. Try another one or upload it from your device."
                      : "No pudimos abrir esa foto. Prueba con otra o súbela desde tu equipo."}</div>}
                  </div>
                );
              })()}
              {fotoPorEncuadrar && (
                <EncuadrarFoto
                  key={`oferta-${fotoPorEncuadrar.name}-${fotoPorEncuadrar.size}`}
                  file={fotoPorEncuadrar}
                  proporcion={1}
                  en={lang === "en"}
                  titulo={lang === "en" ? "Frame the photo" : "Encuadra la foto"}
                  onListo={(f) => {
                    setImageFile(f); setFotoPorEncuadrar(null);
                    // s253 · la principal sale de la galería (o de un archivo: ""); si había selección, la principal queda en ella.
                    const p = principalPendiente.current;
                    setForm(prev => ({ ...prev, principal_galeria: p }));
                  }}
                  onCancelar={() => { principalPendiente.current = ""; setFotoPorEncuadrar(null); }}
                />
              )}
              {imageFile && <div className="alta-ayuda">📷 {imageFile.name}</div>}
              {!imageFile && form.foto_actual && <div className="alta-ayuda">{lang === "en" ? "📷 Your offer already has a photo. Upload another only to replace it." : "📷 Tu oferta ya tiene foto. Sube otra solo si quieres cambiarla."}</div>}
              {faltaFoto && <div className="alta-aviso alta-aviso--error alta-aviso--campo">{lang === "en" ? "Add a photo: without it, the offer doesn't show in the catalog." : "Sube una foto: sin foto, la oferta no sale en el catálogo."}</div>}
              {/* s179 L4.3 (T5 del diseño s99): la foto es el reclamo más fuerte de la ficha
                  y el comercio sube lo que tiene a mano. Cuatro reglas, no un manual. */}
              <div className="alta-reglas-foto">
                {(lang === "en"
                  ? ["Natural light — next to a window works best", "No flash: it flattens and changes the colors", perfilDelRubro(categoriaOferta).fotoProta.en, "Horizontal: that's how it's shown on the card"]
                  : ["Luz natural — al lado de una ventana funciona mejor", "Sin flash: aplana y cambia los colores", perfilDelRubro(categoriaOferta).fotoProta.es, "Horizontal: así se muestra en la tarjeta"]
                ).map((t, i) => <div key={i}>· {t}</div>)}
              </div>
            </div>
            {/* s181 B2/B3: el motivo vive junto al campo, pero el dedo está acá abajo — se
                repite al lado del botón una vez que hubo un intento. */}
            {intentoRevisar && disponibilidadBloquea && (
              <div className={avisoDisp}>{mensajeDias || mensajeHorario}</div>
            )}
            <div className="alta-acciones">
              <button className="alta-btn alta-btn--atras" onClick={() => setStep(3)}>← {lang === "en" ? "Back" : "Atrás"}</button>
              {/* s179 L2: el título ya se valida al salir de 3a — acá no se revalida.
                  s181 B2/B3: la disponibilidad SÍ — con cero días o un horario a medias no se
                  pasa al Revisar (s180-D4: un estado ambiguo no se guarda). El botón solo frena. */}
              <button
                onClick={() => {
                  if (disponibilidadBloquea) { setIntentoRevisar(true); return; }
                  // s212 · Ali: sin foto no sale en el catálogo (estándar). Vale la que ya tiene en edición.
                  if (esUmbralForm && !imageFile && !form.foto_actual) { setFaltaFoto(true); return; }
                  setError(""); setStep(5);
                }}
                className="alta-btn alta-btn--seguir">
                {lang === "en" ? "Review →" : "Revisar →"}
              </button>
            </div>
          </div>
        )}

        {/* ---------- PASO 5 · REVISAR (era el paso 4 antes de s179 L2) ---------- */}
        {step === 5 && (
          <div className="alta-forma">
            <div className="alta-repaso">
              <div className="alta-repaso__alto">
                <div>
                  <div className="alta-repaso__tipo">{offerTypes.find(t => t.id === form.offer_type)?.label}</div>
                  {/* s215 · sin «qué piden», el título es la frase del tamaño (la línea 💵 de abajo ya la dice). */}
                  {!(esUmbralForm && esTituloUmbralGenerado(form.title)) && <div className="alta-repaso__titulo">{form.title}</div>}
                  {/* s215 · se ocultó la pregunta del idioma: el repaso tampoco lo menciona (ingles-reactivar). */}
                </div>
                <div className="alta-repaso__icono">{offerTypes.find(t => t.id === form.offer_type)?.icon}</div>
              </div>
              {form.description && <div className="alta-repaso__desc">{form.description}</div>}
              {resumenUmbral && <div className="alta-repaso__linea">💵 {resumenUmbral}</div>}
              {!(esPctForm && pctBloquea) && (
                <AltaAhorro lang={lang} valor={effectiveBenefitValue} pct={pctAhorro} umbral={umbralForm} categoria={categoriaOferta}
                  porcentaje={esPctForm ? { pct: pctForm, tope: effectiveBenefitValue } : null} />
              )}
              {(form.highlight_1 || form.highlight_2 || form.highlight_3) && (
                <div className="alta-destacados">
                  {[form.highlight_1, form.highlight_2, form.highlight_3].filter(Boolean).map((h, i) => (
                    <span key={i} className="alta-destacado">✨ {h}</span>
                  ))}
                </div>
              )}
              {/* s253 (Ali) · las fotos que va a mostrar la oferta, antes de enviarla: la principal (la nueva o la que ya
                  tiene) y detrás las de la galería que marcó; sin tocar la selección, la galería entera. */}
              {(() => {
                const galeria = galeriaDelPerfil(merchantProfile);
                const fotoActual = String(form.foto_actual || "").startsWith("//") ? "https:" + form.foto_actual : String(form.foto_actual || "");
                const principal = vistaPreviaFoto || fotoActual;
                const detras = Array.isArray(form.galeria_marcadas)
                  ? galeria.filter(u => u !== form.principal_galeria && form.galeria_marcadas.includes(u))
                  : galeria;
                const fotos = [principal, ...detras].filter(Boolean);
                if (!fotos.length) return null;
                const en = lang === "en";
                return (
                  <div className="alta-repaso__fotos">
                    <div className="alta-repaso__linea">📷 {en ? `Photos in this offer (${fotos.length})` : `Fotos de esta oferta (${fotos.length})`}</div>
                    <ul className="alta-repaso__fotos-fila">
                      {fotos.map((u, i) => (
                        <li key={u + i}>
                          <img src={u} alt="" loading="lazy" />
                          {i === 0 && principal && <span className="alta-galeria-elegir__sello">{en ? "★ Main" : "★ Principal"}</span>}
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })()}
              {/* s181 B1/B3: el review dice lo que el comercio ELIGIÓ — «Todos los días» y
                  «Sin límite de horario» se leen como actos, no como vacíos. Los días salen
                  con su etiqueta (Mié/Sáb), no con el token de la base. */}
              {(diasSel.length > 0 || form.valid_time_start || sinLimiteHorario) && (
                <div className="alta-repaso__linea">
                  📅 {todosLosDias
                    ? (lang === "en" ? "Every day" : "Todos los días")
                    : diasSel.map(t => (lang === "en" ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES)[FEED_DAY_TOKENS.indexOf(t)] || t).join(" · ")}
                  {" · "}
                  {(sinLimiteHorario || (!form.valid_time_start && !form.valid_time_end))
                    ? (lang === "en" ? "No time limit" : "Sin límite de horario")
                    : `${form.valid_time_start} - ${form.valid_time_end}`}
                </div>
              )}
              {parseFloat(form.min_consumption) > 0 && (
                <div className="alta-repaso__linea">
                  💵 {lang === "en" ? "Minimum spend" : "Consumo mínimo"}: ${form.min_consumption}
                </div>
              )}
              {/* s180 A8: rules_text guarda una condición por línea (SALTO_LINEA) y en un solo
                  nodo HTML se comía los saltos: «Requiere reserva previa No combinable…».
                  Una viñeta por condición. s194 L1: en umbral, primero las siete del club. */}
              {esUmbralForm && <ReglasUmbralLista />}
              {/* s199 (H3 del smoke §1): al EDITAR una umbral, `rules_text` ya trae las siete
                  del club y el repaso las imprimía dos veces. Se muestran solo los extras,
                  con el mismo filtro con el que `compilarReglasUmbral` las guarda. */}
              {(() => {
                const extras = esUmbralForm
                  ? extrasDeReglas(form.rules_text)
                  : (form.rules_text || "").split(/\r?\n/).map(x => x.trim()).filter(Boolean);
                return extras.length ? (
                  <div className="alta-repaso__reglas">
                    {extras.map((r, i) => <div key={i}>📋 {r}</div>)}
                  </div>
                ) : null;
              })()}
            </div>
            <div className="alta-cierre">
              {/* s179 L6.2: "¿y ahora qué?" no tenía respuesta — ni plazo, ni que se puede
                  editar. Lo segundo es un hecho verificable (Mis Ofertas tiene el botón) y
                  se agrega. El plazo NO: no existe ningún SLA comprometido en el repo, y
                  escribir "en 48 horas" acá lo convierte en una promesa que nadie hizo.
                  Queda en REVIEW_SLA_HORAS (arriba del archivo): Ali pone el número y la
                  frase aparece sola. En null, se omite. */}
              {/* s214 · la sembrada no pasa por revisión: `update_offer` no le cambia el estado (sigue Pendiente,
                  export 96) y la confirma el dueño en su panel. «Será revisada» contradecía el «un toque». */}
              {/* s239 · auditoría s237-D1: editar una oferta ya aprobada NO la re-aprueba (`update_offer` no toca el estado,
                  api.js) y sale al instante. Decía «será revisada»: falso. La que sigue Pendiente sí espera revisión. */}
              {ofertaSembrada
                ? (lang === "en"
                  ? "When you save, you go back to your panel and confirm it there. Nobody sees it until you confirm."
                  : "Al guardar vuelves a tu panel y la confirmas ahí. Nadie la ve hasta que la confirmes.")
                : isEdit && ofertaBase && !ofertaBase.pendiente
                ? (lang === "en"
                  ? "Your changes go live as soon as you save: they are not reviewed again. If the offer is active, members see it this way right away."
                  : "Tus cambios se publican en cuanto guardas: no vuelven a revisión. Si la oferta está activa, los miembros la ven así al momento.")
                : lang === "en"
                ? `Your offer will be reviewed by our team before going live${REVIEW_SLA_HORAS ? ` — usually within ${REVIEW_SLA_HORAS} hours` : ""}. You can edit it any time from My Offers.`
                : `Tu oferta será revisada por nuestro equipo antes de publicarse${REVIEW_SLA_HORAS ? ` — normalmente en menos de ${REVIEW_SLA_HORAS} horas` : ""}. Puedes editarla cuando quieras desde Mis Ofertas.`}
            </div>
            <div className="alta-acciones">
              {/* s185: «Editar» vuelve al paso 3 y no al 4. Es a proposito: el 3 es donde
                  vive lo que puede hacer que la oferta se rechace, y desde ahi el 4 esta a
                  un clic. Al reves no: desde el 4 no se ve el dinero. */}
              <button className="alta-btn alta-btn--atras" onClick={() => setStep(3)}>← {lang === "en" ? "Edit" : "Editar"}</button>
              <button className="alta-btn alta-btn--seguir" onClick={handleSubmit} disabled={loading || (isEdit && (OFFER_EDIT_MAINTENANCE || !editHydrated))}>
                {/* s239 · W20: al editar se guardan cambios (D1: salen al instante); «Enviar» era del alta. */}
                {loading ? "..." : ofertaSembrada || isEdit
                  ? (lang === "en" ? "Save changes ✓" : "Guardar cambios ✓")
                  : (lang === "en" ? "Submit Offer ✓" : "Enviar Oferta ✓")}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


// ============================================
// ADMIN: PROTECTED ROUTE
// ============================================
// ============================================
// ADMIN: B5.1 AI ASSISTANT (config / margins / scenarios)
// ============================================
function AdminAssistant() {
  const lang = useLang();
  const en = lang === "en";
  const [section, setSection] = useState("config");

  // ---- CONFIG ----
  const [cfg, setCfg] = useState({});
  const [cfgLoading, setCfgLoading] = useState(true);
  const [cfgSaving, setCfgSaving] = useState(false);
  const [cfgMsg, setCfgMsg] = useState("");
  // ---- MARGINS ----
  const [margins, setMargins] = useState([]);
  const [mLoading, setMLoading] = useState(true);
  const [mForm, setMForm] = useState({ business_type: "", typical_cost_pct: "", target_margin_pct: "", max_discount_pct: "", notes: "", active: true });
  const [mEditId, setMEditId] = useState(null);
  const [mSaving, setMSaving] = useState(false);
  const [mMsg, setMMsg] = useState("");
  // ---- SCENARIOS ----
  const [scenarios, setScenarios] = useState([]);
  const [sLoading, setSLoading] = useState(true);
  const [sForm, setSForm] = useState({ business_type: "", situation: "", example_input: "", example_offer_suggestions: "", notes: "", priority: "", active: true });
  const [sEditId, setSEditId] = useState(null);
  const [sSaving, setSSaving] = useState(false);
  const [sMsg, setSMsg] = useState("");

  useEffect(() => {
    getAssistantConfig().then(c => setCfg(c || {})).catch(() => setCfg({})).finally(() => setCfgLoading(false));
    getMarginProfiles().then(r => setMargins(r || [])).catch(() => setMargins([])).finally(() => setMLoading(false));
    getAssistantScenarios().then(r => setScenarios(r || [])).catch(() => setScenarios([])).finally(() => setSLoading(false));
  }, []);

  const isYes = (v) => v === true || v === "yes";
  const lbl = { display: "block", fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em", textTransform: "uppercase" };
  const inp = { ...S.input, width: "100%", boxSizing: "border-box" };
  const ta = { ...inp, minHeight: 90, resize: "vertical", fontFamily: "'DM Sans', sans-serif" };

  // CONFIG save
  const cf = (k) => (e) => setCfg(c => ({ ...c, [k]: e?.target ? e.target.value : e }));
  const saveCfg = async () => {
    setCfgSaving(true); setCfgMsg("");
    try {
      await updateAssistantConfig({
        system_instructions: cfg.system_instructions || "",
        model: cfg.model || "claude-sonnet-4-6",
        max_tokens: Number(cfg.max_tokens) || 1500,
        temperature: Number(cfg.temperature) || 0.7,
        num_suggestions: Number(cfg.num_suggestions) || 3,
        output_contract: cfg.output_contract || "",
        disclaimer_text: cfg.disclaimer_text || "",
        active: isYes(cfg.active),
      });
      setCfgMsg(en ? "Saved ✓" : "Guardado ✓"); setTimeout(() => setCfgMsg(""), 3000);
    } catch (e) { setCfgMsg(e.message || (en ? "Error saving" : "Error al guardar")); }
    finally { setCfgSaving(false); }
  };

  // MARGINS
  const resetM = () => { setMForm({ business_type: "", typical_cost_pct: "", target_margin_pct: "", max_discount_pct: "", notes: "", active: true }); setMEditId(null); };
  const editM = (r) => { setMForm({ business_type: r.business_type || "", typical_cost_pct: r.typical_cost_pct ?? "", target_margin_pct: r.target_margin_pct ?? "", max_discount_pct: r.max_discount_pct ?? "", notes: r.notes || "", active: isYes(r.active) }); setMEditId(r._id); setMMsg(""); };
  const saveM = async () => {
    if (!mForm.business_type.trim()) { setMMsg(en ? "Business type required" : "Falta el rubro"); return; }
    setMSaving(true); setMMsg("");
    try {
      const p = { business_type: mForm.business_type.trim(), typical_cost_pct: Number(mForm.typical_cost_pct) || 0, target_margin_pct: Number(mForm.target_margin_pct) || 0, max_discount_pct: Number(mForm.max_discount_pct) || 0, notes: mForm.notes || "", active: !!mForm.active };
      if (mEditId) { await updateMarginProfile({ margin_id: mEditId, ...p }); setMargins(prev => prev.map(r => r._id === mEditId ? { ...r, ...p } : r)); }
      else { const res = await createMarginProfile(p); setMargins(prev => [{ _id: res?.margin_id, ...p }, ...prev]); }
      setMMsg(en ? "Saved ✓" : "Guardado ✓"); resetM(); setTimeout(() => setMMsg(""), 3000);
    } catch (e) { setMMsg(e.message || "Error"); }
    finally { setMSaving(false); }
  };

  // SCENARIOS
  const resetS = () => { setSForm({ business_type: "", situation: "", example_input: "", example_offer_suggestions: "", notes: "", priority: "", active: true }); setSEditId(null); };
  const editS = (r) => { setSForm({ business_type: r.business_type || "", situation: r.situation || "", example_input: r.example_input || "", example_offer_suggestions: r.example_offer_suggestions || "", notes: r.notes || "", priority: r.priority ?? "", active: isYes(r.active) }); setSEditId(r._id); setSMsg(""); };
  const saveS = async () => {
    if (!sForm.business_type.trim()) { setSMsg(en ? "Business type required" : "Falta el rubro"); return; }
    setSSaving(true); setSMsg("");
    try {
      const p = { business_type: sForm.business_type.trim(), situation: sForm.situation || "", example_input: sForm.example_input || "", example_offer_suggestions: sForm.example_offer_suggestions || "", notes: sForm.notes || "", priority: Number(sForm.priority) || 0, active: !!sForm.active };
      if (sEditId) { await updateAssistantScenario({ scenario_id: sEditId, ...p }); setScenarios(prev => prev.map(r => r._id === sEditId ? { ...r, ...p } : r)); }
      else { const res = await createAssistantScenario(p); setScenarios(prev => [{ _id: res?.scenario_id, ...p }, ...prev]); }
      setSMsg(en ? "Saved ✓" : "Guardado ✓"); resetS(); setTimeout(() => setSMsg(""), 3000);
    } catch (e) { setSMsg(e.message || "Error"); }
    finally { setSSaving(false); }
  };

  const subTab = (id, label) => (
    <button onClick={() => setSection(id)} style={{ padding: "8px 16px", fontSize: 12, letterSpacing: "0.08em", textTransform: "uppercase", cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 600, border: "none", borderBottom: section === id ? `2px solid ${C.red}` : "2px solid transparent", background: "none", color: section === id ? C.black : C.muted }}>{label}</button>
  );
  const saveBtn = (onClick, saving, label) => (
    <button onClick={onClick} disabled={saving} style={{ ...S.btnPrimary, padding: "11px 22px", fontSize: 13, opacity: saving ? 0.6 : 1 }}>{saving ? (en ? "Saving…" : "Guardando…") : label}</button>
  );
  const msgBox = (m) => m ? <div style={{ fontSize: 12, color: m.startsWith("Error") || m.includes("Falta") ? C.red : "var(--exito)", marginTop: 10, fontWeight: 500 }}>{m}</div> : null;

  const mCols = [
    { label: en ? "Type" : "Rubro", width: "1.4fr", render: r => <span style={{ fontSize: 13, fontWeight: 600, color: C.black }}>{r.business_type || "—"}</span> },
    { label: en ? "Cost %" : "Costo %", width: "1fr", render: r => <span style={{ fontSize: 13, color: C.gray }}>{r.typical_cost_pct ?? "—"}</span> },
    { label: en ? "Target %" : "Margen %", width: "1fr", render: r => <span style={{ fontSize: 13, color: C.gray }}>{r.target_margin_pct ?? "—"}</span> },
    { label: en ? "Max disc %" : "Tope desc %", width: "1fr", render: r => <span style={{ fontSize: 13, color: C.gray }}>{r.max_discount_pct ?? "—"}</span> },
    { label: en ? "Active" : "Activo", width: "1fr", render: r => <AdminBadge label={isYes(r.active) ? (en ? "Yes" : "Sí") : "No"} type={isYes(r.active) ? "unused" : "used"} /> },
    { label: "", width: "0.7fr", render: r => <button onClick={() => editM(r)} style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "4px 12px", fontSize: 11, cursor: "pointer", borderRadius: 2 }}>{en ? "Edit" : "Editar"}</button> },
  ];
  const sCols = [
    { label: en ? "Type" : "Rubro", width: "1.2fr", render: r => <span style={{ fontSize: 13, fontWeight: 600, color: C.black }}>{r.business_type || "—"}</span> },
    { label: en ? "Situation" : "Situación", width: "2fr", render: r => <span style={{ fontSize: 12, color: C.gray }}>{r.situation || "—"}</span> },
    { label: en ? "Prio" : "Prio", width: "0.6fr", render: r => <span style={{ fontSize: 12, color: C.muted }}>{r.priority ?? "—"}</span> },
    { label: en ? "Active" : "Activo", width: "0.8fr", render: r => <AdminBadge label={isYes(r.active) ? (en ? "Yes" : "Sí") : "No"} type={isYes(r.active) ? "unused" : "used"} /> },
    { label: "", width: "0.7fr", render: r => <button onClick={() => editS(r)} style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "4px 12px", fontSize: 11, cursor: "pointer", borderRadius: 2 }}>{en ? "Edit" : "Editar"}</button> },
  ];

  return (
    <AdminLayout active="assistant">
      <div style={{ marginBottom: 20 }}>
        <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>{en ? "AI ASSISTANT" : "ASISTENTE IA"}</div>
        <p style={{ fontSize: 13, color: C.muted }}>{en ? "Train the offer advisor: prompt, margins by business type, and few-shot scenarios." : "Entrena al asesor de ofertas: prompt, márgenes por rubro y escenarios de ejemplo."}</p>
      </div>
      <div style={{ display: "flex", gap: 4, borderBottom: `1px solid ${C.border}`, marginBottom: 24 }}>
        {subTab("config", en ? "Config" : "Config")}
        {subTab("margins", en ? "Margins" : "Márgenes")}
        {subTab("scenarios", en ? "Scenarios" : "Escenarios")}
      </div>

      {section === "config" && (
        cfgLoading ? <div style={{ padding: 40, textAlign: "center", color: C.muted }}>{en ? "Loading…" : "Cargando…"}</div> : (
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}`, padding: 24, maxWidth: 760 }}>
          <div style={{ marginBottom: 16 }}>
            <label htmlFor="nxt-f18" style={lbl}>{en ? "System instructions (the assistant's brain)" : "Instrucciones del sistema (el cerebro del asesor)"}</label>
            <textarea id="nxt-f18" value={cfg.system_instructions || ""} onChange={cf("system_instructions")} style={{ ...ta, minHeight: 180 }} placeholder={en ? "Persona, rules, and the healthy-margin goal…" : "Persona, reglas, y el objetivo de margen sano…"} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 12, marginBottom: 16 }}>
            <div><label htmlFor="nxt-f17" style={lbl}>{en ? "Model" : "Modelo"}</label><input id="nxt-f17" value={cfg.model || ""} onChange={cf("model")} placeholder="claude-sonnet-4-6" style={inp} /></div>
            <div><label htmlFor="nxt-f16" style={lbl}>Max tokens</label><input id="nxt-f16" value={cfg.max_tokens ?? ""} onChange={cf("max_tokens")} placeholder="1500" style={inp} /></div>
            <div><label htmlFor="nxt-f15" style={lbl}>Temp</label><input id="nxt-f15" value={cfg.temperature ?? ""} onChange={cf("temperature")} placeholder="0.7" style={inp} /></div>
            <div><label htmlFor="nxt-f14" style={lbl}>{en ? "# offers" : "# ofertas"}</label><input id="nxt-f14" value={cfg.num_suggestions ?? ""} onChange={cf("num_suggestions")} placeholder="3" style={inp} /></div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label htmlFor="nxt-f13" style={lbl}>{en ? "Output contract (strict JSON format expected)" : "Contrato de salida (formato JSON estricto esperado)"}</label>
            <textarea id="nxt-f13" value={cfg.output_contract || ""} onChange={cf("output_contract")} style={ta} placeholder='[{"offer_type":"...","title":"...","description":"...","regular_price":0,"coupon_price":0,"discount_pct":0,"highlights":["..."]}]' />
          </div>
          <div style={{ marginBottom: 16 }}>
            <label htmlFor="nxt-f12" style={lbl}>{en ? "Disclaimer (bilingual)" : "Disclaimer (bilingüe)"}</label>
            <textarea id="nxt-f12" value={cfg.disclaimer_text || ""} onChange={cf("disclaimer_text")} style={{ ...ta, minHeight: 70 }} placeholder={en ? "These are suggestions, not financial advice…" : "Son sugerencias, no asesoría financiera…"} />
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: C.black, marginBottom: 18, cursor: "pointer" }}>
            <input type="checkbox" checked={isYes(cfg.active)} onChange={(e) => setCfg(c => ({ ...c, active: e.target.checked }))} /> {en ? "Assistant active" : "Asesor activo"}
          </label>
          <div>{saveBtn(saveCfg, cfgSaving, en ? "Save config" : "Guardar config")}{msgBox(cfgMsg)}</div>
        </div>
      ))}

      {section === "margins" && (
        <div>
          <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}`, padding: 24, marginBottom: 24, maxWidth: 760 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 16 }}>{mEditId ? (en ? "Edit margin profile" : "Editar perfil de margen") : (en ? "New margin profile" : "Nuevo perfil de margen")}</div>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
              <div><label htmlFor="nxt-f11" style={lbl}>{en ? "Business type" : "Rubro"}</label><input id="nxt-f11" value={mForm.business_type} onChange={e => setMForm(f => ({ ...f, business_type: e.target.value }))} placeholder="Restaurant" style={inp} /></div>
              <div><label htmlFor="nxt-f10" style={lbl}>{en ? "Cost %" : "Costo %"}</label><input id="nxt-f10" value={mForm.typical_cost_pct} onChange={e => setMForm(f => ({ ...f, typical_cost_pct: e.target.value }))} placeholder="30" style={inp} /></div>
              <div><label htmlFor="nxt-f9" style={lbl}>{en ? "Target %" : "Margen %"}</label><input id="nxt-f9" value={mForm.target_margin_pct} onChange={e => setMForm(f => ({ ...f, target_margin_pct: e.target.value }))} placeholder="20" style={inp} /></div>
              <div><label htmlFor="nxt-f8" style={lbl}>{en ? "Max disc %" : "Tope desc %"}</label><input id="nxt-f8" value={mForm.max_discount_pct} onChange={e => setMForm(f => ({ ...f, max_discount_pct: e.target.value }))} placeholder="35" style={inp} /></div>
            </div>
            <div style={{ marginBottom: 12 }}><label htmlFor="nxt-f7" style={lbl}>{en ? "Notes" : "Notas"}</label><input id="nxt-f7" value={mForm.notes} onChange={e => setMForm(f => ({ ...f, notes: e.target.value }))} style={inp} /></div>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: C.black, marginBottom: 16, cursor: "pointer" }}>
              <input type="checkbox" checked={!!mForm.active} onChange={e => setMForm(f => ({ ...f, active: e.target.checked }))} /> {en ? "Active" : "Activo"}
            </label>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {saveBtn(saveM, mSaving, mEditId ? (en ? "Update" : "Actualizar") : (en ? "Create" : "Crear"))}
              {mEditId && <button onClick={resetM} style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "10px 18px", fontSize: 13, cursor: "pointer", borderRadius: 2 }}>{en ? "Cancel" : "Cancelar"}</button>}
              {msgBox(mMsg)}
            </div>
          </div>
          <AdminTable columns={mCols} rows={margins} loading={mLoading} empty={en ? "No margin profiles yet" : "Sin perfiles de margen"} />
        </div>
      )}

      {section === "scenarios" && (
        <div>
          <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}`, padding: 24, marginBottom: 24, maxWidth: 760 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 16 }}>{sEditId ? (en ? "Edit scenario" : "Editar escenario") : (en ? "New scenario (few-shot example)" : "Nuevo escenario (ejemplo few-shot)")}</div>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 12, marginBottom: 12 }}>
              <div><label htmlFor="nxt-f6" style={lbl}>{en ? "Business type" : "Rubro"}</label><input id="nxt-f6" value={sForm.business_type} onChange={e => setSForm(f => ({ ...f, business_type: e.target.value }))} placeholder="Restaurant" style={inp} /></div>
              <div><label htmlFor="nxt-f5" style={lbl}>{en ? "Priority" : "Prioridad"}</label><input id="nxt-f5" value={sForm.priority} onChange={e => setSForm(f => ({ ...f, priority: e.target.value }))} placeholder="1" style={inp} /></div>
            </div>
            <div style={{ marginBottom: 12 }}><label htmlFor="nxt-f4" style={lbl}>{en ? "Situation" : "Situación"}</label><input id="nxt-f4" value={sForm.situation} onChange={e => setSForm(f => ({ ...f, situation: e.target.value }))} placeholder={en ? "Eg: slow Tue/Wed nights" : "Ej: martes/miércoles flojos"} style={inp} /></div>
            <div style={{ marginBottom: 12 }}><label htmlFor="nxt-f3" style={lbl}>{en ? "Example input (context)" : "Input de ejemplo (contexto)"}</label><textarea id="nxt-f3" value={sForm.example_input} onChange={e => setSForm(f => ({ ...f, example_input: e.target.value }))} style={ta} /></div>
            <div style={{ marginBottom: 12 }}><label htmlFor="nxt-f2" style={lbl}>{en ? "Ideal offer suggestions (the answer that teaches)" : "Ofertas ideales (la respuesta que enseña)"}</label><textarea id="nxt-f2" value={sForm.example_offer_suggestions} onChange={e => setSForm(f => ({ ...f, example_offer_suggestions: e.target.value }))} style={{ ...ta, minHeight: 120 }} /></div>
            <div style={{ marginBottom: 12 }}><label htmlFor="nxt-f1" style={lbl}>{en ? "Notes" : "Notas"}</label><input id="nxt-f1" value={sForm.notes} onChange={e => setSForm(f => ({ ...f, notes: e.target.value }))} style={inp} /></div>
            <label style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: C.black, marginBottom: 16, cursor: "pointer" }}>
              <input type="checkbox" checked={!!sForm.active} onChange={e => setSForm(f => ({ ...f, active: e.target.checked }))} /> {en ? "Active" : "Activo"}
            </label>
            <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
              {saveBtn(saveS, sSaving, sEditId ? (en ? "Update" : "Actualizar") : (en ? "Create" : "Crear"))}
              {sEditId && <button onClick={resetS} style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "10px 18px", fontSize: 13, cursor: "pointer", borderRadius: 2 }}>{en ? "Cancel" : "Cancelar"}</button>}
              {msgBox(sMsg)}
            </div>
          </div>
          <AdminTable columns={sCols} rows={scenarios} loading={sLoading} empty={en ? "No scenarios yet" : "Sin escenarios"} />
        </div>
      )}
    </AdminLayout>
  );
}

function AdminRoute({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!auth.isLoggedIn()) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        // FIX s98 (rebote intermitente leg 7): un fallo TRANSITORIO de get_user_profile
        // (red/429/5xx) tiraba al login aunque la sesión fuera válida. Retry único
        // con backoff corto antes de redirigir; el rol equivocado sigue saliendo directo.
        let profile = null;
        try {
          profile = await getUserProfile();
        } catch (e1) {
          await new Promise(r => setTimeout(r, 900));
          profile = await getUserProfile();
        }
        if (profile.role === "Admin") {
          setAuthorized(true);
        } else {
          navigate("/", { replace: true });
        }
      } catch {
        navigate("/login", { replace: true });
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [navigate]);

  if (checking) return (
    <div style={{ ...S.page, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ ...S.display, fontSize: 24, color: C.red }}>NXT RESERVE</div>
        <div style={{ color: C.muted, marginTop: 8, fontSize: 13 }}>Verificando acceso...</div>
      </div>
    </div>
  );
  if (!authorized) return null;
  return children;
}


// ETAPA-2 (s99): ruta de la consola de operadora — pasa rol Operator o Admin (D1).
// Mismo retry unico anti-rebote que AdminRoute (FIX s98 leg 7).
function OperatorRoute({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!auth.isLoggedIn()) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        let profile = null;
        try {
          profile = await getUserProfile();
        } catch (e1) {
          await new Promise(r => setTimeout(r, 900));
          profile = await getUserProfile();
        }
        if (profile.role === "Operator" || profile.role === "Admin") {
          setAuthorized(true);
        } else {
          navigate("/", { replace: true });
        }
      } catch {
        navigate("/login", { replace: true });
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [navigate]);

  if (checking) return (
    <div style={{ ...S.page, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ ...S.display, fontSize: 24, color: C.red }}>NXT RESERVE</div>
        <div style={{ color: C.muted, marginTop: 8, fontSize: 13 }}>Verificando acceso...</div>
      </div>
    </div>
  );
  if (!authorized) return null;
  return children;
}

// C-2½ (s113): ruta del PANEL SELF-SERVE del influencer (/influencer) — pasa rol Influencer o Admin.
// Mismo retry único anti-rebote que OperatorRoute/AdminRoute (FIX s98 leg 7).
function InfluencerRoute({ children }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [authorized, setAuthorized] = useState(false);

  useEffect(() => {
    const check = async () => {
      if (!auth.isLoggedIn()) {
        navigate("/login", { replace: true });
        return;
      }
      try {
        let profile = null;
        try {
          profile = await getUserProfile();
        } catch (e1) {
          await new Promise(r => setTimeout(r, 900));
          profile = await getUserProfile();
        }
        if (profile.role === "Influencer" || profile.role === "Admin") {
          setAuthorized(true);
        } else {
          navigate("/", { replace: true });
        }
      } catch {
        navigate("/login", { replace: true });
      } finally {
        setChecking(false);
      }
    };
    check();
  }, [navigate]);

  if (checking) return (
    <div style={{ ...S.page, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ ...S.display, fontSize: 24, color: C.red }}>NXT RESERVE</div>
        <div style={{ color: C.muted, marginTop: 8, fontSize: 13 }}>Verificando acceso...</div>
      </div>
    </div>
  );
  if (!authorized) return null;
  return children;
}

// ============================================
// ADMIN: GENERIC COMPONENTS
// ============================================
function AdminBadge({ label, type }) {
  const colors = {
    // s184 · TIER, no estado. VIP es distincion: dorado. LITE es el escalon
    // base y no necesita color propio — el ambar de aviso decia «cuidado» de un
    // usuario que no tiene nada de malo.
    VIP: { bg: "var(--tier-vip-tinte)", color: "var(--tier-vip)" },
    LITE: { bg: "var(--superficie-hundida)", color: "var(--tinta-suave)" },
    approved: { bg: "var(--exito-tinte)", color: "var(--exito)" },
    Approved: { bg: "var(--exito-tinte)", color: "var(--exito)" },
    pending: { bg: "var(--aviso-tinte)", color: "var(--aviso)" },
    rejected: { bg: "var(--accion-tinte)", color: C.red },
    Rejected: { bg: "var(--accion-tinte)", color: C.red },
    active: { bg: "var(--exito-tinte)", color: "var(--exito)" },
    blocked: { bg: "var(--accion-tinte)", color: C.red },
    used: { bg: C.light, color: C.muted },
    unused: { bg: "var(--exito-tinte)", color: "var(--exito)" },
    Merchant: { bg: "var(--rol-merchant-tinte)", color: "var(--rol-merchant)" },
    Admin: { bg: "var(--rol-admin-tinte)", color: "var(--rol-admin)" },
    // Es un ROL, y estaba pintado con el verde de «salio bien» — el mismo que
    // approved y active. En /admin/users eso ponia un badge de rol en verde al
    // lado de un badge de estado en verde, diciendo cosas distintas.
    B2BPartner: { bg: "var(--superficie-hundida)", color: "var(--tinta)" },
  };
  const c = colors[type || label] || { bg: C.light, color: C.muted };
  return (
    <span style={{ fontSize: 10, background: c.bg, color: c.color, padding: "3px 10px", borderRadius: 2, letterSpacing: "0.08em", fontWeight: 500 }}>
      {(label || "—").toUpperCase()}
    </span>
  );
}

// s216 · `debajo(row)` (opcional): lo que se abre DEBAJO de esa fila (paneles «Fotos» y «Corregir oferta» de la
// consola de Otto). Antes iban al final de la tabla y, con la lista larga, se abrían lejos de la tarjeta tocada.
function AdminTable({ columns, rows, loading, empty, apilarEnTelefono = false, debajo }) {
  const lang = useLang();
  const isMobile = useIsMobile();
  const gridTemplate = columns.map(c => c.width || "1fr").join(" ");
  if (loading) return <div style={{ padding: 40, textAlign: "center", color: C.muted }}>{lang === "en" ? "Loading..." : "Cargando..."}</div>;
  // s214 · en el teléfono, las seis columnas de la consola de Otto medían 454 px en una pantalla de 375 y las
  // acciones («Aprobó», «Reenviar», «Fotos», «Corregir oferta») quedaban fuera, a la derecha. Apilada: una
  // tarjeta por fila, cada columna con su rótulo arriba. Solo donde se pide (las tablas del admin no cambian).
  if (apilarEnTelefono && isMobile) return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      {rows.length === 0 ? (
        <div style={{ padding: 24, textAlign: "center", color: C.muted, background: C.white, border: `1px solid ${C.border}` }}>{empty || (lang === "en" ? "No records found" : "Sin registros")}</div>
      ) : rows.map((row, i) => (
        <div key={i} style={{ background: C.white, border: `1px solid ${C.border}`, padding: "12px 14px", display: "flex", flexDirection: "column", gap: 10, minWidth: 0 }}>
          {columns.map((col, j) => (
            <div key={j} style={{ minWidth: 0, overflowWrap: "anywhere" }}>
              {j > 0 && <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 500, marginBottom: 4 }}>{col.label}</div>}
              {col.render ? col.render(row) : <span style={{ fontSize: 13, color: C.gray }}>{row[col.key] || "—"}</span>}
            </div>
          ))}
          {debajo && debajo(row)}
        </div>
      ))}
    </div>
  );
  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}` }}>
      <div style={{ display: "grid", gridTemplateColumns: gridTemplate, padding: "10px 20px", background: C.light, borderBottom: `1px solid ${C.border}` }}>
        {columns.map((col, i) => (
          <div key={i} style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 500 }}>{col.label}</div>
        ))}
      </div>
      {rows.length === 0 ? (
        <div style={{ padding: 40, textAlign: "center", color: C.muted }}>{empty || (lang === "en" ? "No records found" : "Sin registros")}</div>
      ) : rows.map((row, i) => (
        <div key={i} style={{ borderBottom: `1px solid ${C.border}` }}>
          <div style={{ display: "grid", gridTemplateColumns: gridTemplate, padding: "13px 20px", alignItems: "center" }}>
            {columns.map((col, j) => (
              <div key={j}>{col.render ? col.render(row) : <span style={{ fontSize: 13, color: C.gray }}>{row[col.key] || "—"}</span>}</div>
            ))}
          </div>
          {debajo && (() => { const d = debajo(row); return d ? <div style={{ padding: "0 20px 16px" }}>{d}</div> : null; })()}
        </div>
      ))}
    </div>
  );
}

// ============================================
// ADMIN: LAYOUT
// ============================================
function AdminLayout({ children, active }) {
  const navigate = useNavigate();
  const lang = useLang();
  const tabs = [
    { id: "dashboard", label: "Dashboard", path: "/admin" },
    { id: "offers", label: lang === "en" ? "Offers" : "Ofertas", path: "/admin/offers" },
    { id: "users", label: lang === "en" ? "Users" : "Usuarios", path: "/admin/users" },
    { id: "merchants", label: "Merchants", path: "/admin/merchants" },
    { id: "codes", label: lang === "en" ? "Codes" : "Códigos", path: "/admin/codes" },
    { id: "influencers", label: "Influencers", path: "/admin/influencers" },
    { id: "coupons", label: lang === "en" ? "Coupons" : "Cupones", path: "/admin/coupons" },
    { id: "discounts", label: lang === "en" ? "Discounts" : "Descuentos", path: "/admin/descuentos" },
    { id: "assistant", label: lang === "en" ? "AI Assistant" : "Asistente IA", path: "/admin/assistant" },
    { id: "tools", label: lang === "en" ? "Tools" : "Herram.", path: "/admin/tools" },
  ];
  return (
    <div style={{ minHeight: "100vh", background: C.light }}>
      <div style={{ background: "var(--marca)", padding: "0 24px" }}>
        <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 32 }}>
            <Logo size="md" tono="oscuro" />
            <div style={{ display: "flex" }}>
              {tabs.map(t => (
                <button key={t.id} onClick={() => navigate(t.path)} style={{
                  background: "none", border: "none", color: active === t.id ? C.gold : "rgba(255,255,255,0.45)",
                  padding: "18px 16px", fontSize: 12, letterSpacing: "0.1em", textTransform: "uppercase",
                  cursor: "pointer", fontFamily: "'DM Sans', sans-serif", fontWeight: 500,
                  borderBottom: active === t.id ? `2px solid ${C.gold}` : "2px solid transparent",
                }}>
                  {t.label}
                </button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <span style={{ fontSize: 11, color: "rgba(255,255,255,0.3)", letterSpacing: "0.1em" }}>ADMIN PANEL</span>
            <button onClick={() => { auth.clear(); navigate("/login"); }} style={{
              background: "none", border: "1px solid rgba(255,255,255,0.2)", color: "rgba(255,255,255,0.4)",
              padding: "6px 12px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif",
            }}>
              {lang === "en" ? "Sign Out" : "Salir"}
            </button>
          </div>
        </div>
      </div>
      <div style={{ maxWidth: 1100, margin: "0 auto", padding: "32px 24px 60px" }}>
        {children}
      </div>
    </div>
  );
}

// ============================================
// ADMIN: STAT CARD
// ============================================
function StatCard({ label, value, color }) {
  return (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: "24px 28px", borderTop: `3px solid ${color || C.red}` }}>
      <div style={{ ...S.display, fontSize: 48, color: color || C.red, lineHeight: 1 }}>{value ?? "—"}</div>
      <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", marginTop: 6 }}>{label}</div>
    </div>
  );
}

// ============================================
// ADMIN: DASHBOARD
// ============================================
function AdminDashboard() {
  const lang = useLang();
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [pending, setPending] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [users, setUsers] = useState([]);
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    getAdminStats().then(setStats);
    getPendingOffers().then(setPending);
    getAllCoupons().then(c => setCoupons(c || []));
    getAllUsers().then(u => setUsers(u || []));
    getAllOffers().then(o => setOffers(o || []));
  }, []);

  // Revenue calculations from coupons data
  const activeCoupons = coupons.filter(c => (c.status || "").toLowerCase() === "active");
  const redeemedCoupons = coupons.filter(c => (c.status || "").toLowerCase() === "redeemed");
  const expiredCoupons = coupons.filter(c => (c.status || "").toLowerCase() === "expired");
  const redemptionRate = coupons.length > 0 ? Math.round((redeemedCoupons.length / coupons.length) * 100) : 0;

  // Estimate revenue: each activation = avg $1.50 fee
  const estimatedRevenue = coupons.length * 1.50;
  const thisMonthCoupons = coupons.filter(c => {
    if (!c.activated_at) return false;
    const d = new Date(c.activated_at);
    const now = new Date();
    return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
  });
  const monthlyRevenue = thisMonthCoupons.length * 1.50;

  // User tier breakdown
  const vipUsers = users.filter(u => (u.tier || "").toUpperCase() === "VIP");
  const liteUsers = users.filter(u => (u.tier || "").toUpperCase() === "LITE");
  const merchantUsers = users.filter(u => (u.role || "").toLowerCase() === "merchant");

  // Offers breakdown
  const approvedOffers = offers.filter(o => (o.status || "").toLowerCase() === "approved");

  const en = lang === "en";

  return (
    <AdminLayout active="dashboard">
      <div style={{ marginBottom: 28 }}>
        <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>DASHBOARD</div>
        <p style={{ fontSize: 13, color: C.muted }}>NXT Reserve — {en ? "System overview" : "Vista general del sistema"}</p>
      </div>

      {/* Row 1: Primary Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 16 }}>
        <StatCard label={en ? "Total Users" : "Usuarios"} value={stats?.total_users || users.length} color={C.red} />
        <StatCard label={en ? "Active Offers" : "Ofertas Activas"} value={approvedOffers.length || stats?.total_offers} color={C.valor} />
        <StatCard label={en ? "Total Coupons" : "Cupones Totales"} value={coupons.length || stats?.total_coupons} color={C.black} />
        <StatCard label="Merchants" value={stats?.total_merchants || merchantUsers.length} color="var(--rol-merchant)" />
      </div>

      {/* Row 2: Revenue & Performance */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 16, marginBottom: 24 }}>
        <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: "20px 24px", borderTop: `3px solid var(--exito)` }}>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: 6 }}>{en ? "EST. REVENUE" : "INGRESOS EST."}</div>
          <div style={{ ...S.display, fontSize: 36, color: "var(--exito)", lineHeight: 1 }}>${estimatedRevenue.toFixed(0)}</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>${monthlyRevenue.toFixed(0)} {en ? "this month" : "este mes"}</div>
        </div>
        <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: "20px 24px", borderTop: `3px solid ${C.gold}` }}>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: 6 }}>{en ? "REDEMPTION RATE" : "TASA REDENCIÓN"}</div>
          <div style={{ ...S.display, fontSize: 36, color: C.valor, lineHeight: 1 }}>{redemptionRate}%</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>{redeemedCoupons.length}/{coupons.length} {en ? "redeemed" : "redimidos"}</div>
        </div>
        <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: "20px 24px", borderTop: `3px solid var(--tier-vip)` }}>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: 6 }}>{en ? "VIP MEMBERS" : "MIEMBROS VIP"}</div>
          <div style={{ ...S.display, fontSize: 36, color: "var(--tier-vip)", lineHeight: 1 }}>{vipUsers.length}</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>{liteUsers.length} LITE · {vipUsers.length} VIP</div>
        </div>
        <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: "20px 24px", borderTop: `3px solid ${C.red}` }}>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", marginBottom: 6 }}>{en ? "COUPON STATUS" : "ESTADO CUPONES"}</div>
          <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
            <div><div style={{ ...S.display, fontSize: 20, color: "var(--exito)" }}>{activeCoupons.length}</div><div style={{ fontSize: 9, color: C.muted }}>{en ? "ACTIVE" : "ACTIVOS"}</div></div>
            <div><div style={{ ...S.display, fontSize: 20, color: C.valor }}>{redeemedCoupons.length}</div><div style={{ fontSize: 9, color: C.muted }}>{en ? "USED" : "USADOS"}</div></div>
            <div><div style={{ ...S.display, fontSize: 20, color: C.muted }}>{expiredCoupons.length}</div><div style={{ fontSize: 9, color: C.muted }}>{en ? "EXPIRED" : "EXPIR."}</div></div>
          </div>
        </div>
      </div>

      {/* Row 3: Pending + Quick Actions */}
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 16 }}>
        {/* Pending Offers */}
        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}` }}>
          <div style={{ padding: "16px 20px", borderBottom: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div style={{ fontSize: 13, fontWeight: 600, color: C.black }}>{en ? "Pending Approval" : "Pendientes de Aprobación"}</div>
              <div style={{ fontSize: 11, color: C.muted }}>{pending.length} {en ? "offers waiting" : "ofertas esperando"}</div>
            </div>
            {pending.length > 0 && (
              <button onClick={() => navigate("/admin/offers")} style={{ ...S.btnPrimary, padding: "6px 14px", fontSize: 10 }}>
                {en ? "Review →" : "Revisar →"}
              </button>
            )}
          </div>
          {pending.length === 0 ? (
            <div style={{ padding: "32px 20px", textAlign: "center" }}>
              <div style={{ fontSize: 24, marginBottom: 4 }}>✅</div>
              <div style={{ fontSize: 12, color: C.muted }}>{en ? "All offers approved" : "Todo aprobado"}</div>
            </div>
          ) : pending.slice(0, 5).map((offer, i) => (
            <div key={offer._id || i} style={{ padding: "12px 20px", borderBottom: `1px solid ${C.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 12, fontWeight: 500, color: C.black }}>{tituloOfertaVisible(offer, false)}</div>
                <div style={{ fontSize: 10, color: C.muted }}>{offer.merchant_name} · {textoValorOferta(offer, en)}</div>
              </div>
              <span style={{ fontSize: 9, background: "var(--aviso-tinte)", color: "var(--aviso)", padding: "2px 8px", borderRadius: 2, letterSpacing: "0.1em" }}>PENDING</span>
            </div>
          ))}
        </div>

        {/* Quick Actions */}
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 500 }}>{en ? "QUICK ACTIONS" : "ACCIONES RÁPIDAS"}</div>
          {[
            { icon: "🎟️", label: en ? "Create Access Code" : "Crear Código de Acceso", path: "/admin/codes", color: C.red },
            { icon: "👥", label: en ? "Manage Users" : "Gestionar Usuarios", path: "/admin/users", color: C.black },
            { icon: "🏪", label: en ? "Review Merchants" : "Revisar Merchants", path: "/admin/merchants", color: "var(--rol-merchant)" },
            { icon: "📋", label: en ? "View All Coupons" : "Ver Todos los Cupones", path: "/admin/coupons", color: C.gold },
          ].map((action, i) => (
            <button key={i} onClick={() => navigate(action.path)} style={{
              background: C.white, border: `1px solid ${C.border}`, borderLeft: `3px solid ${action.color}`,
              padding: "14px 16px", textAlign: "left", cursor: "pointer", display: "flex", alignItems: "center",
              gap: 10, fontFamily: "'DM Sans', sans-serif",
            }}>
              <span style={{ fontSize: 18 }}>{action.icon}</span>
              <span style={{ fontSize: 12, color: C.black, fontWeight: 500 }}>{action.label}</span>
              <span style={{ marginLeft: "auto", fontSize: 12, color: C.muted }}>→</span>
            </button>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}

// ============================================
// ADMIN: OFFERS
// ============================================
// s195 · admin-offers-etiqueta-tipo-umbral. La fila de /admin/offers no decía de qué tipo era
// la oferta: una umbral y una de precio fijo se veían iguales (título · rubro · $). Una etiqueta
// corta por tipo; para las umbral, la frase del formato único (misma fuente que la tarjeta).
// El ticket nació diciendo «muestra offer_type crudo»: no era así, no mostraba nada. Se corrige
// la premisa y se entrega lo que el ticket quería: que el tipo se lea.
function etiquetaTipoOferta(o, en) {
  const t = String(o?.offer_type || "").toLowerCase();
  if (t === UMBRAL_TIPO) return `${en ? "Standard" : "Estándar"} · ${fraseUmbral(montoUmbral(o), minimoUmbral(o), en)}`;
  if (t === "fixed") return en ? "Fixed price" : "Precio fijo";
  if (t === "bogo") return "2×1";
  if (t === "percent") return `${en ? "Percentage" : "Porcentaje"} · ${frasePorcentaje(Number(o?.discount_pct) || 0, Number(o?.benefit_value_usd) || 0, en, o?.category)}`;
  if (t === "free") return en ? "Free" : "Gratis";
  return t;
}

function AdminOffers() {
  const lang = useLang();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("pending");
  const [actioning, setActioning] = useState(null);
  const [message, setMessage] = useState("");
  // s222 · lote 2a · los comercios (para la marca «falta menú») y el paso del menú que abre MENU_REQUIRED.
  const [comercios, setComercios] = useState({});
  const [menuPara, setMenuPara] = useState(null);   // { offer_id, merchant_id, categoria, nombre, mensaje }
  useEscapeToClose(!!menuPara, () => setMenuPara(null));

  // s223 · buscador y filtros. `fComercio`: las ofertas de comercios aprobados van primero (son las que se pueden
  // publicar); las de comercios todavía no aprobados, aparte (Ali: «deberían estar en otro lado»).
  const navigateAdm = useNavigate();
  const [q, setQ] = useState("");
  const [fComercio, setFComercio] = useState("aprobado");
  const [fTipo, setFTipo] = useState("all");
  const [fCat, setFCat] = useState("all");
  const [fMenuO, setFMenuO] = useState("all");
  const [fDesdeO, setFDesdeO] = useState("");
  const [fHastaO, setFHastaO] = useState("");
  const [ordenO, setOrdenO] = useState("nuevas");
  useEffect(() => {
    getAllOffersAdmin().then(o => { setOffers(o); setLoading(false); });
    getAllMerchants().then(ms => {
      const mapa = {};
      (ms || []).forEach(m => { if (m && m._id) mapa[m._id] = m; });
      setComercios(mapa);
    }).catch(() => {});
  }, []);
  // Sin el comercio cargado no se marca nada (no se sabe).
  const faltaMenu = (o) => { const m = comercios[o.merchant_id]; return !!m && !tieneMenu(m); };

  // s223 · ¿el comercio de la oferta está aprobado? Sin el comercio cargado, «pendiente» (no se puede publicar igual).
  const comercioAprobado = (o) => claveEstadoComercio(comercios[o.merchant_id]) === "approved";
  const nombreComercio = (o) => o.merchant_name || comercios[o.merchant_id]?.business_name || "";
  const tipoDe = (o) => (esUmbral(o) ? "umbral" : esPorcentaje(o) ? "percent" : String(o.offer_type || "otro").toLowerCase());
  const ETIQUETA_TIPO = { umbral: lang === "en" ? "Standard" : "Estándar", percent: lang === "en" ? "Percentage" : "Porcentaje", bogo: "2×1", fixed: lang === "en" ? "Fixed price" : "Precio fijo", free: lang === "en" ? "Free item" : "Cortesía" };
  const qo = normaBusqueda(q.trim());
  const porEstado = offers.filter(o => filter === "all" || (o.status || "").toLowerCase() === filter);
  const pasaO = (o, salvo) => {
    if (qo && ![o.title_es, o.title_en, nombreComercio(o)].some(v => normaBusqueda(v).includes(qo))) return false;
    if (salvo !== "tipo" && fTipo !== "all" && tipoDe(o) !== fTipo) return false;
    if (salvo !== "cat" && fCat !== "all" && oSinDato(o.category) !== fCat) return false;
    if (salvo !== "menu" && fMenuO !== "all" && (fMenuO === "falta") !== faltaMenu(o)) return false;
    const f = fechaMiami(o["Created Date"]);
    if (fDesdeO && (!f || f < fDesdeO)) return false;
    if (fHastaO && (!f || f > fHastaO)) return false;
    return true;
  };
  const sinComercio = porEstado.filter(o => pasaO(o));
  const cuentaAprobado = sinComercio.filter(comercioAprobado).length;
  const cuentaPendiente = sinComercio.length - cuentaAprobado;
  const filtered = sinComercio
    .filter(o => fComercio === "todos" || (fComercio === "aprobado") === comercioAprobado(o))
    .sort((a, b) => {
      if (ordenO === "comercio") return nombreComercio(a).localeCompare(nombreComercio(b), "es");
      const da = new Date(a["Created Date"] || 0).getTime(), db = new Date(b["Created Date"] || 0).getTime();
      return ordenO === "viejas" ? da - db : db - da;
    });
  const opcionesO = (salvo, clave, etiqueta, sinDato) => {
    const cuenta = contarPor(porEstado.filter(o => pasaO(o, salvo)), o => oSinDato(clave(o)));
    const conVacio = sinDato && cuenta[SIN_DATO] ? [{ v: SIN_DATO, l: `${sinDato} (${cuenta[SIN_DATO]})` }] : [];
    return [{ v: "all", l: lang === "en" ? "All" : "Todos" },
      ...Object.keys(cuenta).filter(k => k !== SIN_DATO).sort().map(v => ({ v, l: `${etiqueta(v)} (${cuenta[v]})` })), ...conVacio];
  };
  const hayFiltrosO = !!(q.trim() || fTipo !== "all" || fCat !== "all" || fMenuO !== "all" || fDesdeO || fHastaO);

  const handleAction = async (offer_id, action) => {
    setActioning(offer_id);
    try {
      if (action === "approve") await approveOffer(offer_id);
      else await rejectOffer(offer_id);
      setOffers(prev => prev.map(o => o._id === offer_id
        ? { ...o, status: action === "approve" ? "Approved" : "Rejected", is_active: action === "approve" }
        : o
      ));
      setMessage(action === "approve"
        ? (lang === "en" ? "✅ Offer approved" : "✅ Oferta aprobada")
        : (lang === "en" ? "✗ Offer rejected" : "✗ Oferta rechazada")
      );
      setTimeout(() => setMessage(""), 3000);
    } catch (e) {
      // s222 · lote 2a · MENU_REQUIRED (export 127, con PricingConfig.menu_required encendido): no es un error suelto,
      // abre el paso del menú de ESE comercio; al guardarlo se vuelve a aprobar.
      if (action === "approve" && e.code === "MENU_REQUIRED") {
        const o = offers.find(x => x._id === offer_id) || {};
        const m = comercios[o.merchant_id] || {};
        setMenuPara({ offer_id, merchant_id: o.merchant_id, categoria: o.category || m.category, nombre: m.business_name || o.merchant_name || "",
          mensaje: e.message && !/^\/wf\/.+ failed$/.test(e.message) && e.message !== "MENU_REQUIRED" ? e.message : "" });
        return;
      }
      // s154 lote E: approve_offer devuelve HTTP 200 con success:false + error_code +
      // error_message en español; apiPostGuarded ya lo convierte en throw con e.code/e.message.
      // Acá se muestra ese mensaje. Fallback por código porque error_message puede venir
      // vacío (a NOT_ADMIN se le está agregando en Bubble esta misma sesión).
      const fallbackByCode = lang === "en"
        ? { NOT_ADMIN: "Your session doesn't have admin permissions.",
            OFFER_BENEFIT_INVALID: "The offer's benefit value is invalid.",
            OFFER_SIZE_INVALID: "The savings and the minimum don't match the size table (the minimum has to be double the savings).",
            OFFER_PRICE_INVALID: "The offer's price is invalid.",
            MERCHANT_NOT_APPROVED: "The merchant isn't approved yet.",
            OWNER_EMAIL_NOT_VERIFIED: "The owner hasn't confirmed their email (6-digit code). The offer can't go live until they do.",
            MENU_REQUIRED: "The business has no menu yet. Upload it from the merchant's details." }
        : { NOT_ADMIN: "Tu sesión no tiene permisos de admin.",
            OFFER_BENEFIT_INVALID: "El valor de beneficio de la oferta es inválido.",
            OFFER_SIZE_INVALID: "El ahorro y el mínimo no coinciden con la tabla de tamaños (el mínimo tiene que ser el doble del ahorro).",
            OFFER_PRICE_INVALID: "El precio de la oferta es inválido.",
            MERCHANT_NOT_APPROVED: "El comercio todavía no está aprobado.",
            OWNER_EMAIL_NOT_VERIFIED: "El dueño no ha confirmado su correo (código de 6 dígitos). La oferta no puede salir hasta que lo haga.",
            MENU_REQUIRED: "El comercio todavía no tiene menú. Súbelo desde el detalle del comercio." };
      // e.message sintético de apiPostGuarded cuando error_message vino vacío: "/wf/... failed"
      const realMsg = e.message && !/^\/wf\/.+ failed$/.test(e.message) ? e.message : "";
      const msg = realMsg || fallbackByCode[e.code] || (lang === "en" ? "Error — try again" : "Error — intenta de nuevo");
      setMessage(`⚠️ ${msg}`);
      setTimeout(() => setMessage(""), 6000);
    } finally {
      setActioning(null);
    }
  };

  // C.2/F-16: moderar oferta YA Approved (despublicar → Pending, rechazar → Rejected + email).
  const handleAdminModerate = async (offer_id, action) => {
    if (action === "unpublish") {
      const ok = window.confirm(lang === "en"
        ? "Unpublish this offer? It will return to Pending."
        : "¿Despublicar esta oferta? Vuelve a Pendiente.");
      if (!ok) return;
    }
    let reason = "";
    if (action === "reject") {
      const r = window.prompt(lang === "en"
        ? "Reason for rejection (optional):"
        : "Motivo del rechazo (opcional):", "");
      if (r === null) return; // user cancelled
      reason = r;
    }
    setActioning(offer_id);
    try {
      await adminSetOfferStatus(offer_id, action, reason);
      setOffers(prev => prev.map(o => o._id === offer_id
        ? { ...o, status: action === "unpublish" ? "Pending" : "Rejected", is_active: false }
        : o
      ));
      setMessage(action === "unpublish"
        ? (lang === "en" ? "✅ Offer unpublished" : "✅ Oferta despublicada")
        : (lang === "en" ? "✗ Offer rejected" : "✗ Oferta rechazada")
      );
      setTimeout(() => setMessage(""), 3000);
    } catch (e) {
      setMessage("✗ " + (e?.message || (lang === "en" ? "Error — try again" : "Error — intenta de nuevo")));
      setTimeout(() => setMessage(""), 4000);
    } finally {
      setActioning(null);
    }
  };

  // A3 (s79): destacar/quitar destacada (solo ofertas Approved). WF set_offer_featured es admin-only.
  const handleFeatured = async (offer) => {
    setActioning(offer._id);
    try {
      const next = !(offer.featured === true);
      await setOfferFeatured(offer._id, next);
      setOffers(prev => prev.map(o => o._id === offer._id ? { ...o, featured: next } : o));
      setMessage(next
        ? (lang === "en" ? "✅ ★ Offer featured" : "✅ ★ Oferta destacada")
        : (lang === "en" ? "✅ ☆ Removed from featured" : "✅ ☆ Quitada de destacadas"));
      setTimeout(() => setMessage(""), 3000);
    } catch (e) {
      setMessage("✗ " + (e?.message || (lang === "en" ? "Error — try again" : "Error — intenta de nuevo")));
      setTimeout(() => setMessage(""), 4000);
    } finally {
      setActioning(null);
    }
  };

  const filters = [
    { key: "pending", label: lang === "en" ? "Pending" : "Pendientes" },
    // s180 A4: `filtered` compara `(o.status||"").toLowerCase() === filter`; con las keys
    // "Approved"/"Rejected" en mayúscula esos dos filtros devolvían vacío SIEMPRE.
    { key: "approved", label: lang === "en" ? "Approved" : "Aprobadas" },
    { key: "rejected", label: lang === "en" ? "Rejected" : "Rechazadas" },
    { key: "archived", label: lang === "en" ? "Archived" : "Archivadas" },   // s223
    { key: "all", label: lang === "en" ? "All" : "Todas" },
  ];

  const statusColor = (s) => {
    const st = (s || "").toLowerCase();
    if (st === "approved") return { bg: "var(--exito-tinte)", color: "var(--exito)" };
    if (st === "rejected") return { bg: "var(--accion-tinte)", color: C.red };
    return { bg: "var(--aviso-tinte)", color: "var(--aviso)" };
  };

  return (
    <AdminLayout active="offers">
      <div style={{ marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>
            {lang === "en" ? "OFFERS" : "OFERTAS"}
          </div>
          <p style={{ fontSize: 13, color: C.muted }}>
            {plural(filtered.length, lang === "en" ? "offer" : "oferta", lang === "en" ? "offers" : "ofertas")} · {(() => { const n = offers.filter(o => (o.status || "").toLowerCase() === "pending").length; return plural(n, lang === "en" ? "pending" : "pendiente", lang === "en" ? "pending" : "pendientes"); })()}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {filters.map(f => (
            <button key={f.key} onClick={() => setFilter(f.key)} style={{
              background: filter === f.key ? C.black : C.white,
              color: filter === f.key ? C.white : C.gray,
              border: `1px solid ${filter === f.key ? C.black : C.border}`,
              padding: "6px 14px", fontSize: 11, letterSpacing: "0.08em", cursor: "pointer",
              fontFamily: "'DM Sans', sans-serif", borderRadius: 2,
            }}>
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {/* s223 · las dos bandejas: primero lo que se puede publicar (comercio aprobado). */}
      <div role="tablist" aria-label={lang === "en" ? "Merchant status" : "Estado del comercio"} style={{ display: "flex", gap: 0, marginBottom: 12, flexWrap: "wrap", border: `1px solid ${C.border}`, borderRadius: 4, overflow: "hidden", width: "fit-content", maxWidth: "100%" }}>
        {[
          { k: "aprobado", l: lang === "en" ? `Approved merchants (${cuentaAprobado})` : `Comercios aprobados (${cuentaAprobado})` },
          { k: "pendiente", l: lang === "en" ? `Merchants not approved yet (${cuentaPendiente})` : `Comercios sin aprobar (${cuentaPendiente})` },
          { k: "todos", l: lang === "en" ? `All (${cuentaAprobado + cuentaPendiente})` : `Todos (${cuentaAprobado + cuentaPendiente})` },
        ].map(t => (
          <button key={t.k} type="button" role="tab" aria-selected={fComercio === t.k} onClick={() => setFComercio(t.k)} style={{
            background: fComercio === t.k ? "var(--accion-tinte)" : C.white, color: fComercio === t.k ? C.black : C.gray,
            border: "none", borderRight: `1px solid ${C.border}`, padding: "8px 14px", fontSize: 12, fontWeight: fComercio === t.k ? 700 : 500,
            cursor: "pointer", fontFamily: "'DM Sans', sans-serif",
          }}>{t.l}</button>
        ))}
      </div>

      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 16, padding: 12, background: C.white, border: `1px solid ${C.border}`, borderRadius: 4 }}>
        <label htmlFor="fo-q" style={{ display: "flex", flexDirection: "column", gap: 4, flex: "2 1 220px" }}>
          <span style={{ fontSize: 9, color: C.muted, letterSpacing: "0.12em", textTransform: "uppercase", fontWeight: 600 }}>{lang === "en" ? "Search" : "Buscar"}</span>
          <input id="fo-q" value={q} onChange={e => setQ(e.target.value)} placeholder={lang === "en" ? "Offer or merchant…" : "Oferta o comercio…"}
            style={{ ...S.input, fontSize: 12, padding: "7px 10px" }} />
        </label>
        <AdminFiltroSelect id="fo-tipo" etiqueta={lang === "en" ? "Type" : "Tipo"} valor={fTipo} onCambio={setFTipo}
          opciones={opcionesO("tipo", tipoDe, k => ETIQUETA_TIPO[k] || k)} />
        <AdminFiltroSelect id="fo-cat" etiqueta={lang === "en" ? "Category" : "Categoría"} valor={fCat} onCambio={setFCat}
          opciones={opcionesO("cat", o => o.category || "", k => CAT_DISPLAY[k] || k, lang === "en" ? "No category" : "Sin categoría")} />
        <AdminFiltroSelect id="fo-menu" etiqueta={lang === "en" ? "Menu" : "Menú"} valor={fMenuO} onCambio={setFMenuO}
          opciones={opcionesO("menu", o => (faltaMenu(o) ? "falta" : "ok"), k => (k === "falta" ? (lang === "en" ? "Missing menu or price list" : "Falta menú o lista de precios") : (lang === "en" ? "Has menu or price list" : "Con menú o lista de precios")))} />
        <AdminFiltroFecha id="fo-desde" etiqueta={lang === "en" ? "Created from" : "Creada desde"} valor={fDesdeO} onCambio={setFDesdeO} />
        <AdminFiltroFecha id="fo-hasta" etiqueta={lang === "en" ? "Created until" : "Creada hasta"} valor={fHastaO} onCambio={setFHastaO} />
        <AdminFiltroSelect id="fo-orden" etiqueta={lang === "en" ? "Sort" : "Orden"} valor={ordenO} onCambio={setOrdenO}
          opciones={[{ v: "nuevas", l: lang === "en" ? "Newest first" : "Más nuevas primero" }, { v: "viejas", l: lang === "en" ? "Oldest first" : "Más viejas primero" }, { v: "comercio", l: lang === "en" ? "By merchant" : "Por comercio" }]} />
        {hayFiltrosO && (
          <button type="button" onClick={() => { setQ(""); setFTipo("all"); setFCat("all"); setFMenuO("all"); setFDesdeO(""); setFHastaO(""); }}
            style={{ background: C.white, color: C.gray, border: `1px solid ${C.border}`, padding: "7px 12px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
            {lang === "en" ? "Clear filters" : "Limpiar filtros"}
          </button>
        )}
      </div>

      {fComercio === "pendiente" && filtered.length > 0 && (
        <div style={{ background: "var(--aviso-tinte)", border: "1px solid var(--linea)", padding: "10px 14px", marginBottom: 12, fontSize: 12, color: "var(--aviso-tinta)" }}>
          {lang === "en"
            ? "These merchants aren't approved yet: their offers can't go live. Approve the merchant first (Merchants), then the offer."
            : "Estos comercios todavía no están aprobados: sus ofertas no se pueden publicar. Primero se aprueba el comercio (en Merchants) y después la oferta."}
        </div>
      )}

      {message && (
        <div style={{ background: message.includes("✅") ? "var(--exito-tinte)" : "var(--accion-tinte)", border: `1px solid ${message.includes("✅") ? "var(--exito)" : C.red}`, padding: "12px 16px", marginBottom: 16, fontSize: 13, color: message.includes("✅") ? "var(--exito)" : C.red }}>
          {message}
        </div>
      )}

      {loading ? (
        <div style={{ padding: 40, textAlign: "center", color: C.muted }}>
          {lang === "en" ? "Loading..." : "Cargando..."}
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: 40, textAlign: "center", color: C.muted }}>
          {hayFiltrosO
            ? (lang === "en" ? "No offers match these filters" : "Ninguna oferta coincide con estos filtros")
            : (lang === "en" ? "No offers in this category" : "No hay ofertas en esta categoría")}
        </div>
      ) : (
        <div style={{ background: C.white, border: `1px solid ${C.border}` }}>
          {/* Header */}
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", gap: 0, padding: "10px 20px", background: C.light, borderBottom: `1px solid ${C.border}` }}>
            {[lang === "en" ? "Offer" : "Oferta", lang === "en" ? "Merchant" : "Negocio", lang === "en" ? "Value" : "Valor", "Status", lang === "en" ? "Actions" : "Acciones"].map((h, i) => (
              <div key={i} style={{ fontSize: 10, color: C.muted, letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 500 }}>{h}</div>
            ))}
          </div>
          {/* Rows */}
          {filtered.map((offer, i) => {
            const sc = statusColor(offer.status);
            const st = (offer.status || "").toLowerCase();
            const isPending = st === "pending";
            const isApproved = st === "approved";
            return (
              <div key={offer._id || i} style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 1fr", gap: 0, padding: "14px 20px", borderBottom: `1px solid ${C.border}`, alignItems: "center" }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500, color: C.black }}>{tituloOfertaVisible(offer, false)}</div>
                  <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>
                    {/* s239 · W18: la categoría con su nombre (salía «Restaurant», «Salon_Spa»; s238 lo arregló en Merchants). */}
                    {[CAT_DISPLAY[offer.category] || offer.category, etiquetaTipoOferta(offer, lang === "en"),
                      offer["Created Date"] ? `${lang === "en" ? "Created" : "Creada"} ${fechaCortaMiami(offer["Created Date"], lang === "en")}` : ""].filter(Boolean).join(" · ")}
                  </div>
                </div>
                <div style={{ fontSize: 12, color: C.gray }}>
                  {offer.merchant_name || comercios[offer.merchant_id]?.business_name || "—"}
                  {(isPending || isApproved) && faltaMenu(offer) && <MarcaFaltaMenu en={lang === "en"} categoria={offer.category || comercios[offer.merchant_id]?.category} />}
                </div>
                <div style={{ fontSize: 13, fontWeight: 500, color: C.black }}>{textoValorOferta(offer, lang === "en") || "—"}</div>
                <div>
                  <span style={{ fontSize: 10, background: sc.bg, color: sc.color, padding: "3px 10px", borderRadius: 2, letterSpacing: "0.08em" }}>
                    {(offer.status || "pending").toUpperCase()}
                  </span>
                </div>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {/* s223 · comercio sin aprobar: approve_offer devolvería MERCHANT_NOT_APPROVED. Se dice antes y se lleva
                      al comercio (Merchants, ya filtrado por su nombre). Rechazar sigue disponible. */}
                  {isPending && !comercioAprobado(offer) && (
                    <>
                      <span style={{ fontSize: 10, color: "var(--aviso-tinta)", width: "100%" }}>
                        {lang === "en" ? "Merchant not approved" : "Comercio sin aprobar"}
                      </span>
                      <button type="button" onClick={() => navigateAdm(`/admin/merchants?q=${encodeURIComponent(nombreComercio(offer))}`)}
                        style={{ background: C.white, color: C.black, border: `1px solid ${C.border}`, padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
                        {lang === "en" ? "See merchant →" : "Ver comercio →"}
                      </button>
                      <button
                        onClick={() => handleAction(offer._id, "reject")}
                        disabled={actioning === offer._id}
                        style={{ background: C.red, color: C.white, border: "none", padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === offer._id ? 0.6 : 1 }}
                      >✗ {lang === "en" ? "Reject" : "Rechazar"}</button>
                    </>
                  )}
                  {isPending && comercioAprobado(offer) && (
                    <>
                      <button
                        onClick={() => handleAction(offer._id, "approve")}
                        disabled={actioning === offer._id}
                        style={{ background: "var(--exito)", color: C.white, border: "none", padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === offer._id ? 0.6 : 1 }}
                      >✓ {lang === "en" ? "Approve" : "Aprobar"}</button>
                      <button
                        onClick={() => handleAction(offer._id, "reject")}
                        disabled={actioning === offer._id}
                        style={{ background: C.red, color: C.white, border: "none", padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === offer._id ? 0.6 : 1 }}
                      >✗ {lang === "en" ? "Reject" : "Rechazar"}</button>
                    </>
                  )}
                  {isApproved && (
                    <>
                      <button
                        onClick={() => handleFeatured(offer)}
                        disabled={actioning === offer._id}
                        style={{ background: offer.featured ? C.gold : C.white, color: offer.featured ? C.black : C.gray, border: `1px solid ${offer.featured ? C.gold : C.border}`, padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === offer._id ? 0.6 : 1 }}
                      >{offer.featured ? "★" : "☆"} {lang === "en" ? "Featured" : "Destacada"}</button>
                      <button
                        onClick={() => handleAdminModerate(offer._id, "unpublish")}
                        disabled={actioning === offer._id}
                        style={{ background: C.white, color: C.black, border: `1px solid ${C.border}`, padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === offer._id ? 0.6 : 1 }}
                      >↩ {lang === "en" ? "Unpublish" : "Despublicar"}</button>
                      <button
                        onClick={() => handleAdminModerate(offer._id, "reject")}
                        disabled={actioning === offer._id}
                        style={{ background: C.red, color: C.white, border: "none", padding: "5px 10px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === offer._id ? 0.6 : 1 }}
                      >✗ {lang === "en" ? "Reject" : "Rechazar"}</button>
                    </>
                  )}
                  {!isPending && !isApproved && (
                    <span style={{ fontSize: 11, color: C.muted }}>—</span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* s222 · lote 2a · MENU_REQUIRED al aprobar: el paso del menú de ese comercio y, guardado, se aprueba de nuevo. */}
      {menuPara && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }} onClick={() => setMenuPara(null)}>
          <div role="dialog" aria-modal="true" aria-label={lang === "en" ? "Upload the menu" : "Subir el menú"} style={{ background: C.white, width: "100%", maxWidth: 480, borderRadius: 8, padding: "24px 20px", maxHeight: "85vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 10 }}>
              <div style={{ ...S.display, fontSize: 18, color: C.black }}>{menuPara.nombre || (lang === "en" ? "Merchant" : "Comercio")}</div>
              <button type="button" onClick={() => setMenuPara(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: C.muted }} aria-label={lang === "en" ? "Close" : "Cerrar"}>✕</button>
            </div>
            <MenuDelComercio idBase="admin-aprobar-menu" en={lang === "en"} comoAdmin merchantId={menuPara.merchant_id}
              categoria={menuPara.categoria} ficha={comercios[menuPara.merchant_id]}
              mensaje={menuPara.mensaje || (lang === "en" ? "Before publishing, the business needs its menu (photo or PDF) or the link." : "Antes de publicar, el comercio necesita su menú (foto o PDF) o el link.")}
              onGuardado={async (nueva) => {
                const { offer_id, merchant_id } = menuPara;
                if (nueva) setComercios(prev => ({ ...prev, [merchant_id]: { ...(prev[merchant_id] || {}), ...nueva } }));
                setMenuPara(null);
                await handleAction(offer_id, "approve");
              }} />
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

// s222 · lote 2a · decisión 1.2-a (SPEC 127): lo publicado sin menú sigue publicado; el admin lo ve marcado para pedirlo.
// s238 · «Falta menú» solo en restaurantes y bares (la misma regla que `etiquetaMenu`); el resto, «Falta lista de precios».
function MarcaFaltaMenu({ en, categoria }) {
  const conMenu = ["Restaurant", "Bar_Rooftop"].includes(categoria);
  return (
    <span style={{ display: "inline-block", marginLeft: 6, fontSize: 9, fontWeight: 700, letterSpacing: "0.06em", background: "var(--aviso-tinte)", color: "var(--aviso)", padding: "2px 6px", borderRadius: 2, verticalAlign: "middle" }}>
      {conMenu ? (en ? "NO MENU" : "FALTA MENÚ") : (en ? "NO PRICE LIST" : "FALTA LISTA DE PRECIOS")}
    </span>
  );
}

// ============================================
// ADMIN: USERS
// ============================================
// s220-D6 · los nombres del plan VIP que acepta promote_to_vip (export 125; otro → PLAN_NAME_INVALID).
// Sin elegir, Bubble pone «Travel Guest».
const PLANES_VIP = ["Travel Guest", "Invitado VIP", "Aliado NXT"];
const PLAN_VIP_POR_DEFECTO = "Travel Guest";
function AdminUsers() {
  const lang = useLang();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filterTier, setFilterTier] = useState("all");
  const [filterRole, setFilterRole] = useState("all");
  const [filterCode, setFilterCode] = useState("all");   // s121: filtro por signup_code (influencers)
  const [actioning, setActioning] = useState(null);
  const [msg, setMsg] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [promoMonths, setPromoMonths] = useState(12);   // M-9: meses de la promoción VIP
  const [promoDate, setPromoDate] = useState("");        // M-9: event_date (opcional)
  const [promoPlan, setPromoPlan] = useState(PLAN_VIP_POR_DEFECTO);   // s220-D6 · el nombre del plan (export 125)

  useEffect(() => { getAllUsers().then(u => { setUsers(u); setLoading(false); }); }, []);

  const en = lang === "en";

  // ETAPA-2 prep (s98, recon promote_vip): la operadora cierra por WhatsApp y muchas veces
  // solo tiene el TELEFONO del lead → el buscador tambien matchea User.phone por digitos
  // (se normalizan ambos lados: "+1 (786) 548..." encuentra "786548").
  const searchDigits = search.replace(/[^0-9]/g, "");
  const filtered = users.filter(u => {
    const phoneDigits = String(u.phone || "").replace(/[^0-9]/g, "");
    const phoneHit = searchDigits.length >= 4 && phoneDigits.includes(searchDigits);
    const codeHit = !!search && (u.signup_code || "").toLowerCase().includes(search.toLowerCase());   // s121
    if (search && !((u.email || u.authentication?.email?.email || "").toLowerCase().includes(search.toLowerCase())) && !(u.name || "").toLowerCase().includes(search.toLowerCase()) && !phoneHit && !codeHit) return false;
    if (filterTier !== "all" && (u.tier || "").toUpperCase() !== filterTier) return false;
    if (filterRole !== "all" && (u.role || "EndUser").toLowerCase() !== filterRole.toLowerCase()) return false;
    if (filterCode !== "all" && (u.signup_code || "") !== filterCode) return false;   // s121
    return true;
  });

  // s121: codigos de alta distintos presentes en la tabla (para el dropdown del filtro).
  // Depende de que signup_code este tildado en View de la regla de privacy del Admin
  // sobre User (familia L#299/#316/#322) — si no viaja, el dropdown queda vacio.
  const signupCodes = [...new Set(users.map(u => u.signup_code).filter(Boolean))].sort();

  const handleBlock = async (user) => {
    setActioning(user._id);
    try {
      if (user.is_blocked) await unblockUser(user._id);
      else await blockUser(user._id);
      setUsers(prev => prev.map(u => u._id === user._id ? { ...u, is_blocked: !u.is_blocked } : u));
      setMsg(user.is_blocked ? (en ? "✅ User unblocked" : "✅ Usuario desbloqueado") : (en ? "⛔ User blocked" : "⛔ Usuario bloqueado"));
      setTimeout(() => setMsg(""), 3000);
    } catch(e) { setMsg(en ? "Error — try again" : "Error — intenta de nuevo"); }
    finally { setActioning(null); }
  };

  // s52: promover/degradar admins (modelo "admins iguales"). Acción privilegiada →
  // confirmación + el guard server-side CANNOT_DEMOTE_SELF protege contra lockout.
  // ETAPA-2 (s99): promover/quitar Operadora (equipo de ventas). set_user_role acepta
  // "Operator" desde la tanda s99 (B3). Toggle Operator ↔ EndUser.
  const handleOperator = async (user) => {
    const makeOp = (user.role || "EndUser") !== "Operator";
    const new_role = makeOp ? "Operator" : "EndUser";
    const confirmMsg = makeOp
      ? (en ? `Make "${user.name || user.email || "this user"}" an OPERATOR? They get the sales console (/operator): create codes and tag outcomes.`
            : `¿Hacer OPERADORA a "${user.name || user.email || "este usuario"}"? Tendrá la consola de ventas (/operator): generar códigos y etiquetar resultados.`)
      : (en ? `Remove OPERATOR from "${user.name || user.email || "this user"}"? They become a regular user.`
            : `¿Quitarle OPERADORA a "${user.name || user.email || "este usuario"}"? Pasa a usuario normal.`);
    if (!window.confirm(confirmMsg)) return;
    setActioning(user._id);
    try {
      await setUserRole(user._id, new_role);
      setUsers(prev => prev.map(u => u._id === user._id ? { ...u, role: new_role } : u));
      setSelectedUser(prev => prev && prev._id === user._id ? { ...prev, role: new_role } : prev);
      setMsg(makeOp ? (en ? "✅ User is now Operator" : "✅ Usuaria ahora es Operadora")
                    : (en ? "✅ Operator removed" : "✅ Operadora removida"));
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      const code = e?.code || e?.message || "";
      setMsg(`❌ ${code || "Error"}`);
      setTimeout(() => setMsg(""), 4000);
    } finally { setActioning(null); }
  };

  const handleRole = async (user) => {
    const makeAdmin = (user.role || "EndUser") !== "Admin";
    const new_role = makeAdmin ? "Admin" : "EndUser";
    const confirmMsg = makeAdmin
      ? (en ? `Make "${user.name || user.email || "this user"}" an ADMIN? They will get full admin access.`
            : `¿Hacer ADMIN a "${user.name || user.email || "este usuario"}"? Tendrá acceso total de admin.`)
      : (en ? `Remove ADMIN from "${user.name || user.email || "this user"}"? They become a regular user.`
            : `¿Quitarle el ADMIN a "${user.name || user.email || "este usuario"}"? Pasa a usuario normal.`);
    if (!window.confirm(confirmMsg)) return;
    setActioning(user._id);
    try {
      await setUserRole(user._id, new_role);
      setUsers(prev => prev.map(u => u._id === user._id ? { ...u, role: new_role } : u));
      setSelectedUser(prev => prev && prev._id === user._id ? { ...prev, role: new_role } : prev);
      setMsg(makeAdmin ? (en ? "✅ User is now Admin" : "✅ Usuario ahora es Admin")
                       : (en ? "✅ Admin removed" : "✅ Admin removido"));
      setTimeout(() => setMsg(""), 3000);
    } catch(e) {
      const code = e?.code || e?.message || "";
      const map = {
        CANNOT_DEMOTE_SELF: en ? "You can't remove your own admin role." : "No puedes quitarte el admin a ti mismo.",
        NOT_ADMIN:          en ? "Only admins can change roles." : "Solo un admin puede cambiar roles.",
        USER_NOT_FOUND:     en ? "User not found." : "Usuario no encontrado.",
        INVALID_ROLE:       en ? "Invalid role." : "Rol inválido.",
      };
      const hit = Object.keys(map).find(k => String(code).includes(k));
      setMsg(hit ? map[hit] : (en ? "Error — try again" : "Error — intenta de nuevo"));
      setTimeout(() => setMsg(""), 4000);
    } finally { setActioning(null); }
  };

  // s220 · ALIADO (rol Influencer). El aliado es un miembro con panel extra: el rol solo le abre
  // /aliados y «Mi panel de aliado». Toggle Influencer ↔ EndUser con el mismo set_user_role.
  // ⚠️ apply_access_code (step 18) le pone EndUser a cualquiera que aplique un código: si al aliado
  // se le da un código de acceso, va ANTES de este botón. El VIP (promote_to_vip) no toca el rol.
  const handleInfluencer = async (user) => {
    const makeInf = (user.role || "EndUser") !== "Influencer";
    const new_role = makeInf ? "Influencer" : "EndUser";
    const label = user.name || user.email || (en ? "this user" : "este usuario");
    const confirmMsg = makeInf
      ? (en ? `Make "${label}" a PARTNER? They keep their membership and get "My partner panel". If they still have to apply an access code, do it first: applying a code resets the role to member.`
            : `¿Hacer ALIADO a "${label}"? Sigue siendo miembro y tendrá «Mi panel de aliado». Si todavía tiene que aplicar un código de acceso, que lo haga antes: aplicar un código le devuelve el rol de miembro.`)
      : (en ? `Remove PARTNER from "${label}"? They stay a regular member.` : `¿Quitarle ALIADO a "${label}"? Queda como miembro normal.`);
    if (!window.confirm(confirmMsg)) return;
    setActioning(user._id);
    try {
      await setUserRole(user._id, new_role);
      setUsers(prev => prev.map(u => u._id === user._id ? { ...u, role: new_role } : u));
      setSelectedUser(prev => prev && prev._id === user._id ? { ...prev, role: new_role } : prev);
      setMsg(makeInf ? (en ? "✅ User is now a partner" : "✅ Ahora es aliado") : (en ? "✅ Partner removed" : "✅ Ya no es aliado"));
      setTimeout(() => setMsg(""), 3000);
    } catch (e) {
      setMsg(`❌ ${e?.code || e?.message || "Error"}`);
      setTimeout(() => setMsg(""), 4000);
    } finally { setActioning(null); }
  };

  // M-9: promover/extender VIP (promote_to_vip). meses + event_date opcional.
  const handlePromote = async (user) => {
    const months = parseInt(promoMonths, 10);
    if (!months || months < 1) { setMsg(en ? "Enter a valid number of months." : "Ingresa un número de meses válido."); return; }
    const label = user.name || user.email || (en ? "this user" : "este usuario");
    if (!window.confirm(en ? `Grant VIP to "${label}" for ${months} month(s), plan "${promoPlan}"?` : `¿Otorgar VIP a "${label}" por ${months} mes(es), plan «${promoPlan}»?`)) return;
    setActioning(user._id);
    try {
      const r = await promoteToVip({ user_id: user._id, duration_months: months, event_date: promoDate || undefined, plan_name: promoPlan });
      const plan = r?.membership_plan || promoPlan;
      setUsers(prev => prev.map(u => u._id === user._id ? { ...u, tier: "VIP", membership_plan: plan } : u));
      setSelectedUser(prev => prev && prev._id === user._id ? { ...prev, tier: "VIP", membership_plan: plan } : prev);
      setMsg(en ? `✅ VIP granted (${months} mo · ${plan})` : `✅ VIP otorgado (${months} m · ${plan})`);
      setTimeout(() => setMsg(""), 3000);
    } catch(e) {
      const code = e?.code || e?.message || "";
      const map = {
        NOT_ADMIN:      en ? "Only admins can grant VIP." : "Solo un admin puede otorgar VIP.",
        USER_NOT_FOUND: en ? "User not found." : "Usuario no encontrado.",
        PLAN_NAME_INVALID: mensajeLoteBC("PLAN_NAME_INVALID", en),
      };
      const hit = Object.keys(map).find(k => String(code).includes(k));
      setMsg(hit ? map[hit] : (en ? "Error — try again" : "Error — intenta de nuevo"));
      setTimeout(() => setMsg(""), 4000);
    } finally { setActioning(null); }
  };

  // Stats
  const vipCount = users.filter(u => (u.tier || "").toUpperCase() === "VIP").length;
  const liteCount = users.filter(u => (u.tier || "").toUpperCase() === "LITE").length;
  const blockedCount = users.filter(u => u.is_blocked).length;
  const merchantCount = users.filter(u => (u.role || "").toLowerCase() === "merchant").length;

  const cols = [
    { label: en ? "User" : "Usuario", width: "2.5fr", render: u => (
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 32, height: 32, borderRadius: "50%", background: (u.tier || "").toUpperCase() === "VIP" ? C.red : C.valor, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
          <span style={{ color: C.white, fontSize: 11, fontWeight: 700 }}>{(u.name || "?")[0]?.toUpperCase()}</span>
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, color: C.black }}>{u.name || "—"}</div>
          <div style={{ fontSize: 11, color: C.muted }}>{u.email || u.authentication?.email?.email || (u._id ? u._id.slice(0, 16) + "..." : "—")}</div>
        </div>
      </div>
    )},
    { label: "Tier", width: "0.8fr", render: u => <AdminBadge label={u.tier || "—"} type={u.tier} /> },
    { label: en ? "Role" : "Rol", width: "0.8fr", render: u => <AdminBadge label={u.role || "EndUser"} type={u.role || "EndUser"} /> },
    { label: en ? "Code" : "Código", width: "0.9fr", render: u => u.signup_code ? (
      <span style={{ fontFamily: "monospace", fontSize: 11, background: C.light, border: `1px solid ${C.border}`, padding: "2px 6px", borderRadius: 2, color: C.black }}>{u.signup_code}</span>
    ) : <span style={{ fontSize: 11, color: C.muted }}>—</span> },
    { label: en ? "Coupons" : "Cupones", width: "0.8fr", render: u => (
      <div style={{ textAlign: "center" }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: C.black }}>{u.lite_activations_used ?? 0}</div>
        <div style={{ fontSize: 9, color: C.muted }}>{en ? "activated" : "activados"}</div>
      </div>
    )},
    { label: en ? "Status" : "Estado", width: "0.8fr", render: u => (
      <AdminBadge label={u.is_blocked ? (en ? "Blocked" : "Bloqueado") : (en ? "Active" : "Activo")} type={u.is_blocked ? "blocked" : "active"} />
    )},
    { label: en ? "Actions" : "Acciones", width: "1.2fr", render: u => (
      <div style={{ display: "flex", gap: 4 }}>
        <button onClick={() => setSelectedUser(selectedUser?._id === u._id ? null : u)} style={{
          background: C.light, color: C.gray, border: `1px solid ${C.border}`, padding: "4px 8px",
          fontSize: 10, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif"
        }}>
          {en ? "Details" : "Detalles"}
        </button>
        <button onClick={() => handleBlock(u)} disabled={actioning === u._id} style={{
          background: u.is_blocked ? "var(--exito)" : C.red, color: C.white,
          border: "none", padding: "4px 8px", fontSize: 10, cursor: "pointer",
          borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === u._id ? 0.6 : 1
        }}>
          {u.is_blocked ? (en ? "Unblock" : "Desbloquear") : (en ? "Block" : "Bloquear")}
        </button>
      </div>
    )},
  ];

  return (
    <AdminLayout active="users">
      <div style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>{en ? "USERS" : "USUARIOS"}</div>
          <p style={{ fontSize: 13, color: C.muted }}>
            {filtered.length} {en ? "members" : "miembros"} · {vipCount} VIP · {liteCount} LITE · {merchantCount} Merchants
            {blockedCount > 0 && ` · ${blockedCount} ${en ? "blocked" : "bloqueados"}`}
          </p>
        </div>
        <input value={search} onChange={e => setSearch(e.target.value)}
          placeholder={en ? "Search by name, email or phone..." : "Buscar por nombre, email o teléfono..."}
          style={{ ...S.input, width: 260, fontSize: 12, padding: "8px 12px" }} />
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
        <span style={{ fontSize: 10, color: C.muted, alignSelf: "center", marginRight: 4 }}>TIER:</span>
        {["all", "VIP", "LITE"].map(t => (
          <button key={t} onClick={() => setFilterTier(t)} style={{
            background: filterTier === t ? C.black : C.white, color: filterTier === t ? C.white : C.gray,
            border: `1px solid ${filterTier === t ? C.black : C.border}`,
            padding: "4px 10px", fontSize: 10, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", borderRadius: 2,
          }}>{t === "all" ? (en ? "All" : "Todos") : t}</button>
        ))}
        <span style={{ fontSize: 10, color: C.muted, alignSelf: "center", marginLeft: 12, marginRight: 4 }}>{en ? "ROLE" : "ROL"}:</span>
        {["all", "EndUser", "Merchant", "Admin"].map(r => (
          <button key={r} onClick={() => setFilterRole(r)} style={{
            background: filterRole === r ? C.black : C.white, color: filterRole === r ? C.white : C.gray,
            border: `1px solid ${filterRole === r ? C.black : C.border}`,
            padding: "4px 10px", fontSize: 10, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", borderRadius: 2,
          }}>{r === "all" ? (en ? "All" : "Todos") : r}</button>
        ))}
        {signupCodes.length > 0 && (<>
          <span style={{ fontSize: 10, color: C.muted, alignSelf: "center", marginLeft: 12, marginRight: 4 }}>{en ? "CODE" : "CÓDIGO"}:</span>
          <select value={filterCode} onChange={e => setFilterCode(e.target.value)} style={{ ...S.input, width: "auto", fontSize: 11, padding: "5px 8px" }}>
            <option value="all">{en ? "All" : "Todos"}</option>
            {signupCodes.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </>)}
      </div>

      {msg && <div style={{ background: msg.includes("✅") ? "var(--exito-tinte)" : "var(--accion-tinte)", border: `1px solid ${msg.includes("✅") ? "var(--exito)" : C.red}`, padding: "10px 16px", marginBottom: 16, fontSize: 13, color: msg.includes("✅") ? "var(--exito)" : C.red }}>{msg}</div>}

      <AdminTable columns={cols} rows={filtered} loading={loading} />

      {/* User Detail Panel */}
      {selectedUser && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setSelectedUser(null)}>
          <div role="dialog" aria-modal="true" aria-label={en ? "User detail" : "Detalle del usuario"} style={{ background: C.white, width: "100%", maxWidth: 480, borderRadius: 8, padding: "28px 24px", maxHeight: "80vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
              <div>
                <div style={{ ...S.display, fontSize: 22, color: C.black }}>{selectedUser.name || "—"}</div>
                <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{selectedUser.email || selectedUser.authentication?.email?.email}</div>
              </div>
              <button onClick={() => setSelectedUser(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: C.muted }}>✕</button>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
              {[
                { label: "Tier", value: selectedUser.tier || "—" },
                { label: en ? "Role" : "Rol", value: selectedUser.role || "EndUser" },
                { label: en ? "Phone" : "Teléfono", value: selectedUser.phone || "—" },
                { label: en ? "Signup code" : "Código de alta", value: selectedUser.signup_code || "—" },
                { label: en ? "Coupons Activated" : "Cupones Activados", value: selectedUser.lite_activations_used ?? 0 },
                { label: en ? "Max Coupons" : "Máx Cupones", value: selectedUser.max_coupons || "—" },
                { label: en ? "Blocked" : "Bloqueado", value: selectedUser.is_blocked ? (en ? "Yes" : "Sí") : "No" },
                { label: en ? "Stripe Customer" : "Cliente Stripe", value: selectedUser.stripe_customer_id ? "✅" : "❌" },
              ].map((item, i) => (
                <div key={i} style={{ padding: "10px 12px", background: C.light, borderRadius: 6 }}>
                  <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", marginBottom: 2 }}>{item.label.toUpperCase()}</div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: C.black }}>{item.value}</div>
                </div>
              ))}
            </div>
            {/* M-9 s52: otorgar / extender VIP (promote_to_vip) */}
            <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", marginBottom: 8 }}>{en ? "GRANT / EXTEND VIP" : "OTORGAR / EXTENDER VIP"}</div>
              <div style={{ display: "flex", gap: 8, alignItems: "flex-end", flexWrap: "wrap" }}>
                <div>
                  <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>{en ? "Months" : "Meses"}</div>
                  <input type="number" min="1" value={promoMonths} onChange={e => setPromoMonths(e.target.value)}
                    style={{ ...S.input, width: 80, fontSize: 12, padding: "6px 8px" }} />
                </div>
                <div>
                  <div style={{ fontSize: 10, color: C.muted, marginBottom: 2 }}>{en ? "Event date (optional)" : "Fecha evento (opcional)"}</div>
                  <input type="date" value={promoDate} onChange={e => setPromoDate(e.target.value)}
                    style={{ ...S.input, width: 150, fontSize: 12, padding: "6px 8px" }} />
                </div>
                {/* s220-D6 · el nombre del plan, elegible al darlo (promote_to_vip `plan_name`, export 125). */}
                <div>
                  <label htmlFor="promo-plan" style={{ display: "block", fontSize: 10, color: C.muted, marginBottom: 2 }}>{en ? "Plan name" : "Nombre del plan"}</label>
                  <select id="promo-plan" value={promoPlan} onChange={e => setPromoPlan(e.target.value)}
                    style={{ ...S.input, width: 160, fontSize: 12, padding: "6px 8px" }}>
                    {PLANES_VIP.map(p => <option key={p} value={p}>{p}</option>)}
                  </select>
                </div>
                <button onClick={() => handlePromote(selectedUser)} disabled={actioning === selectedUser._id} style={{
                  background: C.red, color: C.white, border: "none", padding: "8px 14px", fontSize: 12,
                  cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif", opacity: actioning === selectedUser._id ? 0.6 : 1,
                }}>
                  {(selectedUser.tier || "").toUpperCase() === "VIP" ? (en ? "Extend VIP" : "Extender VIP") : (en ? "Grant VIP" : "Otorgar VIP")}
                </button>
              </div>
              <p style={{ fontSize: 10, color: C.muted, marginTop: 8 }}>
                {en ? "Sets tier VIP and expiry = now + months. Use the access-code flow for event invites."
                    : "Setea tier VIP y vencimiento = ahora + meses. Para invitados de evento, usa el flujo de código de acceso."}
              </p>
            </div>

            {/* s52: gestión de admin (modelo "admins iguales") */}
            <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 16, marginBottom: 4 }}>
              <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", marginBottom: 8 }}>{en ? "ADMIN ACCESS" : "ACCESO ADMIN"}</div>
              <button onClick={() => handleRole(selectedUser)} disabled={actioning === selectedUser._id} style={{
                background: (selectedUser.role || "EndUser") === "Admin" ? C.white : C.black,
                color: (selectedUser.role || "EndUser") === "Admin" ? C.red : C.white,
                border: (selectedUser.role || "EndUser") === "Admin" ? `1px solid ${C.red}` : "none",
                padding: "8px 14px", fontSize: 12, cursor: "pointer", borderRadius: 2,
                fontFamily: "'DM Sans', sans-serif", opacity: actioning === selectedUser._id ? 0.6 : 1,
              }}>
                {(selectedUser.role || "EndUser") === "Admin"
                  ? (en ? "Remove admin" : "Quitar admin")
                  : (en ? "Make admin" : "Hacer admin")}
              </button>
              <p style={{ fontSize: 10, color: C.muted, marginTop: 8 }}>
                {en ? "All admins have equal, full access. You can't remove your own admin role."
                    : "Todos los admins tienen acceso total e igual. No puedes quitarte el admin a ti mismo."}
              </p>
            </div>

            {/* ETAPA-2 (s99): equipo de ventas — rol Operadora */}
            <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 16, marginBottom: 4 }}>
              <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", marginBottom: 8 }}>{en ? "SALES TEAM" : "EQUIPO DE VENTAS"}</div>
              <button onClick={() => handleOperator(selectedUser)} disabled={actioning === selectedUser._id} style={{
                background: (selectedUser.role || "EndUser") === "Operator" ? C.white : C.black,
                color: (selectedUser.role || "EndUser") === "Operator" ? C.red : C.white,
                border: (selectedUser.role || "EndUser") === "Operator" ? `1px solid ${C.red}` : "none",
                padding: "8px 14px", fontSize: 12, cursor: "pointer", borderRadius: 2,
                fontFamily: "'DM Sans', sans-serif", opacity: actioning === selectedUser._id ? 0.6 : 1,
              }}>
                {(selectedUser.role || "EndUser") === "Operator"
                  ? (en ? "Remove operator" : "Quitar Operadora")
                  : (en ? "Make operator" : "Hacer Operadora")}
              </button>
              <p style={{ fontSize: 10, color: C.muted, marginTop: 8 }}>
                {en ? "Operators use the sales console at /operator: they create codes (LITE & VIP) and tag outcomes. No admin panel access."
                    : "La Operadora usa la consola de ventas en /operator: genera códigos (LITE y VIP) y etiqueta resultados. No accede al panel admin."}
              </p>
            </div>

            {/* s220 · aliados (rol Influencer) — miembro con «Mi panel de aliado» */}
            <div style={{ borderTop: `1px solid ${C.border}`, paddingTop: 16, marginBottom: 4 }}>
              <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em", marginBottom: 8 }}>{en ? "PARTNERS" : "ALIADOS"}</div>
              <button onClick={() => handleInfluencer(selectedUser)} disabled={actioning === selectedUser._id} style={{
                background: (selectedUser.role || "EndUser") === "Influencer" ? C.white : C.black,
                color: (selectedUser.role || "EndUser") === "Influencer" ? C.red : C.white,
                border: (selectedUser.role || "EndUser") === "Influencer" ? `1px solid ${C.red}` : "none",
                padding: "8px 14px", fontSize: 12, cursor: "pointer", borderRadius: 2,
                fontFamily: "'DM Sans', sans-serif", opacity: actioning === selectedUser._id ? 0.6 : 1,
              }}>
                {(selectedUser.role || "EndUser") === "Influencer"
                  ? (en ? "Remove partner" : "Quitar aliado")
                  : (en ? "Make partner" : "Hacer aliado")}
              </button>
              <p style={{ fontSize: 10, color: C.muted, marginTop: 8 }}>
                {en ? "Order for a new partner: 1) Grant VIP above · 2) Make partner · 3) Create their code in Codes with owner and commission."
                    : "Orden para un aliado nuevo: 1) Otorgar VIP (arriba) · 2) Hacer aliado · 3) Crear su código en Códigos, con dueño y comisión."}
              </p>
            </div>
            {selectedUser._id && (
              <div style={{ fontSize: 10, color: C.muted, fontFamily: "monospace", padding: "8px 0", borderTop: `1px solid ${C.border}` }}>
                ID: {selectedUser._id}
              </div>
            )}
          </div>
        </div>
      )}</AdminLayout>
  );
}

// ============================================
// ADMIN: MERCHANTS
// ============================================
// ============================================
// s203 · «QUITAR FOTO» DEL OPERADOR — la mitad verificada de
// `boton-hacer-portada-y-quitar-foto-operador`. Admin y Operator quitan una foto de la
// galería de CUALQUIER comercio (una persona sin permiso, una marca ajena, una foto de
// Google). Va en /admin/merchants (el detalle) y en /operator/vitrina (la fila del sembrado).
// «Hacer portada» NO está: set_gallery_cover borra la foto elegida (smoke s203 §3-1) y
// espera el deploy único (F1).
// Carga la galería al abrir, confirma antes de quitar y relee la base después: la
// respuesta «Photo removed» no se toma como prueba (lección del §3-1).
// ============================================
// s216 · paneles «Fotos» abiertos ahora. Mientras haya uno, Ctrl+V es suyo: la siembra de la consola
// (que también escucha el pegado en toda la página) lo ignora, para no abrir dos encuadradores.
let panelesFotosAbiertos = 0;

// s216 · `gallery_urls` de operator_add_photo / admin_remove_merchant_photo: lista (o texto con comas) de
// URLs «//…cdn.bubble.io/…». null si el WF no la mandó.
function galeriaDeRespuesta(r) {
  const g = r && r.gallery_urls;
  if (Array.isArray(g)) return g.filter(Boolean).map(String);
  if (typeof g === "string") return g.split(",").map(s => s.trim()).filter(Boolean);
  return null;
}

// s216 · deploy D: `galeriaInicial` y `logoInicial` salen de get_seeded_merchants (la consola), que ignora
// privacy: un Operator no lee por la Data API la ficha de un comercio en Lead (solo llega el _id).
// `conLogo`: la consola muestra «Logo» (operator_add_logo); el detalle del admin, no (tiene su propio flujo).
// s217 · los enlaces del panel «Fotos» de la consola. get_seeded_merchants (export 113) todavía NO trae
// place_id, google_maps_url ni instagram (pedido a Cowork, PARA_COWORK_s217_bubble.md): mientras tanto, una
// búsqueda en Maps por nombre + barrio. Cuando lleguen esos campos, el enlace pasa solo a ser el exacto.
function enlacesDeSembrado(r) {
  if (!r) return null;
  const ig = String(r.instagram || "").trim();
  const instagram = !ig ? "" : /^https?:\/\//i.test(ig) ? ig : `https://www.instagram.com/${ig.replace(/^@/, "")}`;
  if (r.google_maps_url) return { maps: r.google_maps_url, exacto: true, instagram };
  const lugar = [r.business_name, r.neighborhood || r.zone, "Miami FL"].filter(Boolean).join(" ");
  const maps = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(lugar)}`
    + (r.place_id ? `&query_place_id=${encodeURIComponent(r.place_id)}` : "");
  return { maps, exacto: !!r.place_id, instagram };
}

// s235 · admin-detalle-comercio-ficha (P8 de la auditoría del alta normal): el detalle del comercio en Admin no mostraba
// descripción, Instagram, web, horario ni logo, y la galería quedaba plegada: se aprobaba sin ver la ficha. Aquí va lo
// que verá el miembro, con lo que el comercio cargó (o lo de Google si no lo cambió). Solo lectura.
function FichaComercioAdmin({ m, en }) {
  const t = (es, enTxt) => (en ? enTxt : es);
  const src = (u) => (String(u || "").startsWith("//") ? "https:" + u : String(u || ""));
  const ext = (u) => (/^https?:\/\//i.test(String(u)) ? String(u) : `https://${u}`);
  const ig = (h) => (String(h).startsWith("http") ? h : `https://instagram.com/${String(h).replace(/^@/, "")}`);
  const descEs = String(m.description_es || "").trim(), descEn = String(m.description_en || "").trim();
  const horario = String(m.business_hours || "").trim()
    || horarioDesdeJson(m.business_hours_json, en).map(h => `${h.dia} ${h.valor}`).join("\n");
  const direccion = m.address_full || m.address || "";
  const zona = m.neighborhood || m.zone || "";
  const fila = (etiqueta, contenido) => (
    <div style={{ padding: "8px 0", borderTop: `1px solid ${C.border}` }}>
      <div style={{ fontSize: 9, color: C.muted, letterSpacing: "0.1em", marginBottom: 2 }}>{etiqueta.toUpperCase()}</div>
      <div style={{ fontSize: 13, color: contenido ? C.black : C.muted, whiteSpace: "pre-line" }}>{contenido || t("— no cargado", "— not set")}</div>
    </div>
  );
  return (
    <div style={{ marginBottom: 16, padding: "12px 14px", border: `1px solid ${C.border}`, borderRadius: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 8 }}>
        {m.logo
          ? <img src={src(m.logo)} alt={t("Logo", "Logo")} style={{ width: 56, height: 56, borderRadius: "50%", objectFit: "cover", border: `1px solid ${C.border}`, background: "#fff" }} />
          : <div style={{ width: 56, height: 56, borderRadius: "50%", background: C.light, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: C.muted, textAlign: "center" }}>{t("Sin logo", "No logo")}</div>}
        <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: "0.08em", color: C.gray }}>{t("LA FICHA QUE VE EL MIEMBRO", "THE PAGE MEMBERS SEE")}</div>
      </div>
      {fila(t("Descripción", "Description"), descEs || descEn)}
      {descEs && descEn && fila(t("Descripción (EN)", "Description (EN)"), descEn)}
      {fila(t("Dirección", "Address"), [direccion, zona].filter(Boolean).join(" · "))}
      {fila(t("Horario", "Hours"), horario)}
      {fila(t("Sitio web", "Website"), m.website ? <a href={ext(m.website)} target="_blank" rel="noreferrer">{m.website}</a> : "")}
      {fila("Instagram", m.instagram ? <a href={ig(m.instagram)} target="_blank" rel="noreferrer">{m.instagram}</a> : "")}
      {m.google_maps_url && fila("Google Maps", <a href={ext(m.google_maps_url)} target="_blank" rel="noreferrer">{t("Ver en Google Maps", "Open in Google Maps")}</a>)}
    </div>
  );
}

function QuitarFotosComercio({ merchantId, nombre, en, abrir = false, onCerrar, galeriaInicial = null, logoInicial = "", conLogo = false, onCambio, enlaces = null }) {
  const [abierto, setAbierto] = useState(abrir);
  const [fotos, setFotos] = useState(null);       // null = cargando / sin cargar
  const [quitando, setQuitando] = useState("");
  const [msg, setMsg] = useState("");
  const [porEncuadrar, setPorEncuadrar] = useState(null);   // s216 · File elegido, antes de encuadrar
  const [agregando, setAgregando] = useState(false);
  const [logo, setLogo] = useState(logoInicial || "");      // s216 · deploy D
  const [logoPorEncuadrar, setLogoPorEncuadrar] = useState(null);
  const [subiendoLogo, setSubiendoLogo] = useState(false);
  const vigente = useRef(merchantId);             // descarta respuestas de un comercio anterior
  const srcDe = (u) => (String(u).startsWith("//") ? "https:" + u : String(u));

  const cargar = useCallback(async () => {
    const id = merchantId;
    vigente.current = id;
    setFotos(null);
    let g = [];
    try { g = await getMerchantGallery(id); } catch (e) { g = []; }
    // s216 · deploy D: si la Data API no deja ver la galería a este rol, vale la de get_seeded_merchants.
    if (g.length === 0 && Array.isArray(galeriaInicial) && galeriaInicial.length) g = galeriaInicial;
    if (vigente.current === id) setFotos(g);
  }, [merchantId, galeriaInicial]);

  useEffect(() => { setMsg(""); setQuitando(""); if (abierto) cargar(); }, [abierto, cargar]);

  const errores = {
    NOT_OPERATOR: en ? "Only an operator or an admin can remove photos." : "Solo un operador o un admin puede quitar fotos.",
    MERCHANT_NOT_FOUND: en ? "We couldn't find this merchant. Reload the page." : "No encontramos este comercio. Recarga la página.",
    PHOTO_NOT_FOUND: en ? "That photo is no longer in the gallery." : "Esa foto ya no está en la galería.",
    NO_MERCHANT: en ? "This account has no merchant." : "Esta cuenta no tiene comercio.",
    GALLERY_FULL: en ? "This merchant already has 10 photos. Remove one first." : "Este comercio ya tiene 10 fotos. Quita una primero.",
  };

  // s216 · «Agregar foto»: la foto ya encuadrada (WebP) va a operator_add_photo. Como al quitar,
  // la prueba es releer la galería, no la respuesta: tiene que haber una foto más que antes.
  const agregar = async (file) => {
    const id = merchantId;
    const antes = Array.isArray(fotos) ? fotos.length : 0;
    setAgregando(true); setMsg("");
    try {
      const r = await operatorAddPhoto(id, file);
      const g = await getMerchantGallery(id);
      if (vigente.current !== id) return;
      // s216 · un Operator no lee por la Data API la ficha de un comercio en Lead/Invitado (solo llega el
      // `_id`; probado en Live). Ahí la galería que vale es la que devuelve el WF (sale del Step 6 ya guardado).
      const delWf = galeriaDeRespuesta(r);
      const vista = g.length > antes ? g : (delWf && delWf.length > antes ? delWf : g);
      setFotos(vista);
      if (onCambio) onCambio();
      setMsg(vista.length > antes
        ? (en ? `✅ Photo added · ${vista.length} in total` : `✅ Foto agregada · ${vista.length} en total`)
        : "⚠️ " + (en ? "Bubble said it was added, but we don't see it yet. Reload in a moment." : "Bubble dijo que la agregó, pero todavía no la vemos. Recarga en un momento."));
    } catch (e) {
      if (vigente.current === id) setMsg("⚠️ " + (errores[e.code] || e.message || (en ? "It couldn't be added." : "No se pudo agregar.")));
    } finally {
      if (vigente.current === id) setAgregando(false);
    }
  };
  const llena = Array.isArray(fotos) && fotos.length >= 10;

  // s216 · deploy D · el logo del sembrado (operator_add_logo). La URL que vuelve es la prueba.
  const subirLogo = async (file) => {
    const id = merchantId;
    setSubiendoLogo(true); setMsg("");
    try {
      const r = await operatorAddLogo(id, file);
      if (vigente.current !== id) return;
      const url = String(r?.logo_url || "");
      if (url) setLogo(url);
      setMsg(url ? (en ? "✅ Logo saved" : "✅ Logo guardado")
                 : "⚠️ " + (en ? "Bubble didn't return the logo. Reload in a moment." : "Bubble no devolvió el logo. Recarga en un momento."));
      if (onCambio) onCambio();
    } catch (e) {
      if (vigente.current === id) setMsg("⚠️ " + (errores[e.code] || e.message || (en ? "The logo couldn't be saved." : "No se pudo guardar el logo.")));
    } finally {
      if (vigente.current === id) setSubiendoLogo(false);
    }
  };

  // s216 · pegar (Ctrl+V) o soltar la foto, como en la siembra: Otto la copia en Maps y la pega aquí.
  const tomarImagen = (f) => {
    if (!f || !/^image\//.test(f.type) || agregando || llena || fotos === null) return;
    const ext = (f.type.split("/")[1] || "png").replace("jpeg", "jpg");
    setPorEncuadrar(new File([f], f.name && f.name !== "image.png" ? f.name : `foto-pegada.${ext}`, { type: f.type }));
  };
  const tomarRef = useRef(tomarImagen);
  tomarRef.current = tomarImagen;
  useEffect(() => {
    if (!abierto) return undefined;
    panelesFotosAbiertos += 1;
    const alPegar = (e) => {
      const it = Array.from(e.clipboardData?.items || []).find(x => x.kind === "file" && /^image\//.test(x.type));
      const f = it && it.getAsFile();
      if (!f) return;
      e.preventDefault();
      tomarRef.current(f);
    };
    window.addEventListener("paste", alPegar);
    return () => { panelesFotosAbiertos -= 1; window.removeEventListener("paste", alPegar); };
  }, [abierto]);
  const soltar = (e) => {
    e.preventDefault();
    tomarImagen(Array.from(e.dataTransfer?.files || []).find(x => /^image\//.test(x.type)));
  };

  const quitar = async (url, i) => {
    const pregunta = en
      ? `Remove photo ${i + 1} from ${nombre || "this merchant"}? It disappears from the public page. It can't be undone from here.`
      : `¿Quitar la foto ${i + 1} de ${nombre || "este comercio"}? Deja de verse en la ficha pública. Desde aquí no se puede deshacer.`;
    if (!window.confirm(pregunta)) return;
    const id = merchantId;
    setQuitando(url); setMsg("");
    try {
      const r = await adminRemoveMerchantPhoto(id, url);
      const leida = await getMerchantGallery(id);
      if (vigente.current !== id) return;
      // s216 · si la Data API no le muestra la galería a este rol (Operator con comercio en Lead), vale la del WF.
      const delWf = galeriaDeRespuesta(r);
      const g = leida.length === 0 && delWf ? delWf : leida;
      setFotos(g);
      const sigue = g.some(u => u === url);
      setMsg(sigue
        ? "⚠️ " + (en ? "Bubble said it was removed, but the photo is still there. Tell Ali." : "Bubble dijo que la quitó, pero la foto sigue ahí. Avísale a Ali.")
        : (en ? `✅ Photo removed · ${Number(r?.remaining ?? g.length)} left` : `✅ Foto quitada · quedan ${Number(r?.remaining ?? g.length)}`));
    } catch (e) {
      if (vigente.current === id) setMsg("⚠️ " + (errores[e.code] || e.message || (en ? "It couldn't be removed." : "No se pudo quitar.")));
    } finally {
      if (vigente.current === id) setQuitando("");
    }
  };

  if (!abierto) {
    return (
      <button type="button" onClick={() => setAbierto(true)}
        style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "8px 12px", fontSize: 13, cursor: "pointer", borderRadius: 4, marginBottom: 16 }}>
        {en ? "Photos · add or remove" : "Fotos · agregar o quitar"}
      </button>
    );
  }

  return (
    <section aria-label={en ? "Merchant photos" : "Fotos del comercio"} onDragOver={e => e.preventDefault()} onDrop={soltar} style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: "14px 16px", marginBottom: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8, marginBottom: 10 }}>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.black }}>
          {en ? "Photos" : "Fotos"}{nombre ? ` · ${nombre}` : ""}{Array.isArray(fotos) ? ` (${fotos.length})` : ""}
        </div>
        <button type="button" onClick={() => { setAbierto(false); if (onCerrar) onCerrar(); }}
          style={{ background: "none", border: "none", color: C.muted, fontSize: 13, cursor: "pointer", textDecoration: "underline" }}>
          {en ? "Close" : "Cerrar"}
        </button>
      </div>
      <p style={{ fontSize: 13, color: C.gray, lineHeight: 1.5, margin: "0 0 12px" }}>
        {en ? "The first one is the cover. Removing a photo takes it off the public page."
            : "La primera es la portada. Quitar una foto la saca de la ficha pública."}
      </p>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 12 }}>
        <label htmlFor={`foto-op-${merchantId}`}
          style={{ display: "inline-block", background: C.black, color: "#fff", padding: "8px 14px", fontSize: 13, fontWeight: 600, borderRadius: 4,
                   cursor: agregando || llena || fotos === null ? "default" : "pointer", opacity: agregando || llena || fotos === null ? 0.5 : 1 }}>
          {agregando ? (en ? "Adding…" : "Agregando…") : (en ? "+ Add photo" : "+ Agregar foto")}
        </label>
        <input id={`foto-op-${merchantId}`} type="file" accept="image/*" disabled={agregando || llena || fotos === null || !!quitando}
          style={{ position: "absolute", width: 1, height: 1, opacity: 0, pointerEvents: "none" }}
          onChange={e => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setPorEncuadrar(f); }} />
        <span style={{ fontSize: 12, color: C.muted }}>
          {llena ? (en ? "10 of 10: remove one to add another." : "10 de 10: quita una para agregar otra.")
                 : (en ? "Or paste it with Ctrl+V, or drop it here. If the offer has no photo, this one goes on it too."
                       : "O pégala con Ctrl+V, o suéltala aquí. Si la oferta no tiene foto, esta también va en la oferta.")}
        </span>
      </div>
      {/* s217 (Ali) · de dónde sacar la foto sin salir de la consola. Instagram o la web del negocio primero:
          las fotos de Google Maps son del dueño o de clientes, y Google no permite copiarlas como propias. */}
      {enlaces && (enlaces.maps || enlaces.instagram) && (
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center", marginBottom: 12, fontSize: 12 }}>
          <span style={{ color: C.muted }}>{en ? "Find a photo:" : "Buscar una foto:"}</span>
          {enlaces.instagram && (
            <a href={enlaces.instagram} target="_blank" rel="noreferrer" style={{ color: C.black, fontWeight: 600 }}>
              {en ? "Instagram ↗" : "Instagram ↗"}
            </a>
          )}
          {enlaces.maps && (
            <a href={enlaces.maps} target="_blank" rel="noreferrer" style={{ color: C.black, fontWeight: 600 }}>
              {enlaces.exacto ? (en ? "Google Maps ↗" : "Google Maps ↗") : (en ? "Search on Google Maps ↗" : "Buscar en Google Maps ↗")}
            </a>
          )}
          <span style={{ color: C.muted, fontSize: 11 }}>
            {en ? "Prefer the business's own Instagram or website photos." : "Mejor una foto del Instagram o la web del propio negocio."}
          </span>
        </div>
      )}
      {porEncuadrar && (
        <EncuadrarFoto
          key={`op-${porEncuadrar.name}-${porEncuadrar.size}`}
          file={porEncuadrar}
          proporcion={1}
          en={en}
          titulo={en ? "Frame the photo" : "Encuadra la foto"}
          onListo={(f) => { setPorEncuadrar(null); agregar(f); }}
          onCancelar={() => setPorEncuadrar(null)}
        />
      )}
      {conLogo && (
        <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginBottom: 12, paddingTop: 10, borderTop: `1px solid ${C.border}` }}>
          {logo
            ? <img src={srcDe(logo)} alt="Logo" style={{ width: 48, height: 48, objectFit: "contain", borderRadius: 6, background: C.light, border: `1px solid ${C.border}` }} />
            : <span style={{ width: 48, height: 48, borderRadius: 6, background: C.light, border: `1px dashed ${C.border}`, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 11, color: C.muted }}>{en ? "No logo" : "Sin logo"}</span>}
          <label htmlFor={`logo-op-${merchantId}`}
            style={{ display: "inline-block", background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "8px 14px", fontSize: 13, fontWeight: 600, borderRadius: 4, cursor: subiendoLogo ? "default" : "pointer", opacity: subiendoLogo ? 0.5 : 1 }}>
            {subiendoLogo ? (en ? "Saving…" : "Guardando…") : (logo ? (en ? "Change logo" : "Cambiar logo") : (en ? "+ Add logo" : "+ Agregar logo"))}
          </label>
          <input id={`logo-op-${merchantId}`} type="file" accept="image/*" disabled={subiendoLogo}
            style={{ position: "absolute", width: 1, height: 1, opacity: 0, pointerEvents: "none" }}
            onChange={async e => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setLogoPorEncuadrar(await logoEnCuadrado(f)); }} />
        </div>
      )}
      {logoPorEncuadrar && (
        <EncuadrarFoto
          key={`logo-op-${logoPorEncuadrar.name}-${logoPorEncuadrar.size}`}
          file={logoPorEncuadrar}
          proporcion={1}
          ladoMax={512}
          ladoMin={LOGO_LADO_MIN}
          tipoSalida={logoPorEncuadrar.type === "image/png" ? "image/png" : "image/jpeg"}
          en={en}
          titulo={en ? "Frame the logo" : "Encuadra el logo"}
          onListo={(f) => { setLogoPorEncuadrar(null); subirLogo(f); }}
          onCancelar={() => setLogoPorEncuadrar(null)}
        />
      )}
      {msg &&<div role="status" style={{ fontSize: 13, marginBottom: 10, fontWeight: 500, color: msg.startsWith("⚠️") ? "var(--error)" : "var(--exito)" }}>{msg}</div>}
      {fotos === null ? (
        <div style={{ fontSize: 13, color: C.muted }}>{en ? "Loading photos…" : "Cargando fotos…"}</div>
      ) : fotos.length === 0 ? (
        <div style={{ fontSize: 13, color: C.muted }}>{en ? "This merchant has no photos we can see." : "Este comercio no tiene fotos que podamos ver."}</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))", gap: 10 }}>
          {fotos.map((u, i) => (
            <figure key={u} style={{ margin: 0 }}>
              <img src={srcDe(u)} alt={en ? `Photo ${i + 1}` : `Foto ${i + 1}`} loading="lazy"
                style={{ width: "100%", aspectRatio: "1 / 1", objectFit: "cover", borderRadius: 6, background: C.light, display: "block" }} />
              <figcaption style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 6, marginTop: 6 }}>
                <span style={{ fontSize: 12, color: C.muted }}>{i === 0 ? (en ? "Cover" : "Portada") : `#${i + 1}`}</span>
                <button type="button" onClick={() => quitar(u, i)} disabled={!!quitando || agregando}
                  style={{ background: "none", border: "1px solid var(--error)", color: "var(--error)", padding: "4px 8px", fontSize: 12, fontWeight: 600, cursor: quitando ? "default" : "pointer", borderRadius: 4, opacity: quitando && quitando !== u ? 0.5 : 1 }}>
                  {quitando === u ? "…" : (en ? "Remove" : "Quitar")}
                </button>
              </figcaption>
            </figure>
          ))}
        </div>
      )}
    </section>
  );
}

// ============================================================================================
// s223 · FILTROS DEL ADMIN (Ali: «cuando haya 300 restaurantes va a ser imposible buscarlos; ya con cien es difícil»)
// ============================================================================================
// Todo en el cliente, sobre las filas que ya trae la Data API (ahora todas, paginadas: apiGetTodo). Las fechas, en
// hora de Miami (regla de zona horaria): «entró el 10/10» es el 10/10 de Miami, no de UTC.
const fechaMiami = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-CA", { timeZone: "America/New_York" });   // AAAA-MM-DD
};
const fechaCortaMiami = (iso, en) => {
  const f = fechaMiami(iso);
  if (!f) return "";
  const [y, m, d] = f.split("-");
  return en ? `${m}/${d}/${y.slice(2)}` : `${d}/${m}/${y.slice(2)}`;
};
// Para buscar sin que importen mayúsculas ni acentos («cafe» encuentra «Café»).
const DIACRITICOS = new RegExp("[" + String.fromCharCode(0x300) + "-" + String.fromCharCode(0x36f) + "]", "g");
const normaBusqueda = (s) => String(s || "").toLowerCase().normalize("NFD").replace(DIACRITICOS, "");
// El estado del comercio, como clave (la Data API manda el Display: «PendingReview», «Approved»…).
const claveEstadoComercio = (m) => String(m?.status || "").toLowerCase().replace(/\s+/g, "");
const ESTADOS_COMERCIO = {
  lead: { es: "Lead (recién registrado)", en: "Lead (just signed up)" },
  pendingreview: { es: "En revisión", en: "In review" },
  invitado: { es: "Invitado (oferta sembrada)", en: "Invited (seeded offer)" },
  approved: { es: "Aprobado", en: "Approved" },
  rejected: { es: "Rechazado", en: "Rejected" },
  blocked: { es: "Bloqueado", en: "Blocked" },
  suspended: { es: "Suspendido", en: "Suspended" },
};
const etiquetaEstadoComercio = (clave, en) => (ESTADOS_COMERCIO[clave] ? (en ? ESTADOS_COMERCIO[clave].en : ESTADOS_COMERCIO[clave].es) : (clave || (en ? "No status" : "Sin estado")));
const etiquetaRubro = (key, en) => {
  const r = BUSINESS_TYPES.find(b => b.key === key);
  return r ? (en ? r.en : r.es) : String(key || "").replace(/_/g, " ");
};
// Un selector del admin: etiqueta arriba, opciones con su cuenta.
function AdminFiltroSelect({ id, etiqueta, valor, onCambio, opciones }) {
  return (
    <label htmlFor={id} style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 150, flex: "1 1 150px" }}>
      <span style={{ fontSize: 9, color: C.muted, letterSpacing: "0.12em", textTransform: "uppercase", fontWeight: 600 }}>{etiqueta}</span>
      <select id={id} value={valor} onChange={e => onCambio(e.target.value)}
        style={{ ...S.input, fontSize: 12, padding: "7px 10px", background: valor !== "all" && valor !== "" ? "var(--accion-tinte)" : C.white }}>
        {opciones.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
      </select>
    </label>
  );
}
function AdminFiltroFecha({ id, etiqueta, valor, onCambio }) {
  return (
    <label htmlFor={id} style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 140, flex: "1 1 140px" }}>
      <span style={{ fontSize: 9, color: C.muted, letterSpacing: "0.12em", textTransform: "uppercase", fontWeight: 600 }}>{etiqueta}</span>
      <input id={id} type="date" value={valor} onChange={e => onCambio(e.target.value)}
        style={{ ...S.input, fontSize: 12, padding: "6px 10px", background: valor ? "var(--accion-tinte)" : C.white }} />
    </label>
  );
}
// s223 · el valor de «sin dato» en un selector (comercio sin estado, sin rubro, sin zona; oferta sin categoría). No puede
// ser "" ni "all": "all" es «sin filtro». En Live: 3 comercios sin estado y 39 sin rubro no tenían cómo filtrarse.
const SIN_DATO = "__sin_dato__";
const oSinDato = (v) => (v ? v : SIN_DATO);
// «1 oferta», «2 ofertas».
const plural = (n, uno, varios) => `${n} ${n === 1 ? uno : varios}`;
// Cuenta por valor, para mostrar «Aprobado (12)» en el selector.
const contarPor = (filas, f) => filas.reduce((acc, x) => { const k = f(x); acc[k] = (acc[k] || 0) + 1; return acc; }, {});
// Lo que se escribe en el buscador viaja en la URL (?q=): desde Ofertas, «Ver comercio» abre Comercios ya filtrado.
const leerQ = () => { try { return new URLSearchParams(window.location.search).get("q") || ""; } catch (_) { return ""; } };

function AdminMerchants() {
  const lang = useLang();
  const [merchants, setMerchants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState(leerQ);
  const [filterCat, setFilterCat] = useState("all");
  // s223 · los filtros nuevos. "all" = sin filtro.
  const [fEstado, setFEstado] = useState("all");
  const [fRubro, setFRubro] = useState("all");
  const [fZona, setFZona] = useState("all");
  const [fFundador, setFFundador] = useState("all");
  const [fMenu, setFMenu] = useState("all");
  const [fOfertas, setFOfertas] = useState("all");
  const [fDesde, setFDesde] = useState("");
  const [fHasta, setFHasta] = useState("");
  const [orden, setOrden] = useState("nuevos");
  const [ofertasPorComercio, setOfertasPorComercio] = useState(null);   // { merchant_id: { total, approved, pending } } · null = cargando
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const [acting, setActing] = useState(false);
  const [actionMsg, setActionMsg] = useState("");
  useEscapeToClose(!!selectedMerchant, () => setSelectedMerchant(null));

  useEffect(() => {
    getAllMerchants().then(m => { setMerchants(m); setLoading(false); });
    // s223 · las ofertas de cada comercio, para «con / sin oferta» y la cuenta en la fila.
    getAllOffersAdmin().then(ofs => {
      const mapa = {};
      (ofs || []).forEach(o => {
        const id = o.merchant_id; if (!id) return;
        const st = String(o.status || "").toLowerCase();
        const x = mapa[id] || (mapa[id] = { total: 0, approved: 0, pending: 0 });
        // s223 · solo cuentan las vivas: aprobadas y pendientes. Las rechazadas y archivadas no son «tiene oferta»
        // (un comercio rechazado mostraba «2 ofertas» con las dos rechazadas).
        if (st === "approved") { x.approved += 1; x.total += 1; }
        if (st === "pending") { x.pending += 1; x.total += 1; }
      });
      setOfertasPorComercio(mapa);
    }).catch(() => setOfertasPorComercio({}));
  }, []);

  const en = lang === "en";

  // X.38: admin approves/rejects a merchant. op ∈ "approve" | "reject".
  const handleModerate = async (merchant, op) => {
    if (!merchant?._id || acting) return;
    // s232 · admin-rechazar-comercio-boton: el botón ya existía; lo que faltaba era la confirmación. reject_merchant
    // rechaza también todas sus ofertas (is_active = no) y no manda correo: se confirma con el nombre, como el cobro de cuota.
    if (op === "reject") {
      const nombre = merchant.business_name || (en ? "this merchant" : "este comercio");
      const ok = window.confirm(en
        ? `Reject ${nombre}? Its offers are rejected too and stop showing. No email is sent.`
        : `¿Rechazar a ${nombre}? Sus ofertas también quedan rechazadas y dejan de verse. No se envía ningún correo.`);
      if (!ok) return;
    }
    setActing(true); setActionMsg("");
    try {
      const resp = await (op === "approve" ? approveMerchant : rejectMerchant)(merchant._id);
      const newStatus = resp?.new_status || (op === "approve" ? "Approved" : "Rejected");
      setMerchants(prev => prev.map(m => m._id === merchant._id ? { ...m, status: newStatus } : m));
      setSelectedMerchant(prev => (prev && prev._id === merchant._id ? { ...prev, status: newStatus } : prev));
      // s238 · reject_merchant rechaza también sus ofertas: la cuenta de la fila no puede seguir diciendo «1 pend.».
      if (op === "reject") setOfertasPorComercio(prev => (prev ? { ...prev, [merchant._id]: { total: 0, approved: 0, pending: 0 } } : prev));
      setActionMsg(op === "approve"
        ? (en ? "✅ Merchant approved" : "✅ Merchant aprobado")
        : (en ? "✅ Merchant rejected" : "✅ Merchant rechazado"));
    } catch (e) {
      const map = {
        NOT_ADMIN: en ? "Not authorized" : "No autorizado",
        MERCHANT_NOT_FOUND: en ? "Merchant not found" : "Merchant no encontrado",
      };
      setActionMsg("⚠️ " + (map[e.code] || e.message || (en ? "Action failed" : "La acción falló")));
    } finally { setActing(false); }
  };

  // s126 Fase C: agenda el cobro de la cuota de programa acumulada (5% del valor
  // de la oferta, solo al canjearse). Guards silenciosos en el WF de cobro:
  // billing_active=yes + ≥$15 + tarjeta guardada + sin cobro en 24h.
  const handleCharge = async (merchant) => {
    if (!merchant?._id || acting) return;
    const ok = window.confirm(en
      ? "Schedule the program fee charge for this merchant? It only charges if eligible (billing active, ≥$15 accrued, card on file, no charge in the last 24h)."
      : "¿Agendar el cobro de la cuota de programa de este merchant? Solo cobra si es elegible (billing activo, ≥$15 acumulados, tarjeta guardada, sin cobro en las últimas 24h).");
    if (!ok) return;
    setActing(true); setActionMsg("");
    try {
      await adminChargeMerchant(merchant._id);
      setActionMsg(en
        ? "✅ Charge scheduled — result will appear in MerchantCharges (no charge unless eligible)"
        : "✅ Cobro agendado — el resultado queda en MerchantCharges (solo cobra si es elegible)");
    } catch (e) {
      const map2 = { NOT_ADMIN: en ? "Not authorized" : "No autorizado" };
      setActionMsg("⚠️ " + (map2[e.code] || e.message || (en ? "Action failed" : "La acción falló")));
    } finally { setActing(false); }
  };
  const categories = ["all", ...new Set(merchants.map(m => m.category).filter(Boolean))];

  // s223 · el buscador mira nombre, correo, teléfono, barrio, zona y dirección, sin mayúsculas ni acentos.
  // `phone_public` es el teléfono de verdad (la fila cruda de la Data API no trae `phone`: por eso la columna decía «—»).
  const esFounding = (m) => m?.is_founding === true || m?.is_founding_partner === true;
  const telefonoDe = (m) => m.phone_public || m.phone || "";
  const zonaDe = (m) => m.neighborhood || m.zone || "";
  const ofertasDe = (m) => (ofertasPorComercio && ofertasPorComercio[m._id]) || { total: 0, approved: 0, pending: 0 };
  const q = normaBusqueda(search.trim());
  const pasa = (m, salvo) => {
    if (q && ![m.business_name, m.email, telefonoDe(m), m.neighborhood, m.zone, m.address, m.address_full, m.city]
      .some(v => normaBusqueda(v).includes(q))) return false;
    if (salvo !== "cat" && filterCat !== "all" && m.category !== filterCat) return false;
    if (salvo !== "estado" && fEstado !== "all" && oSinDato(claveEstadoComercio(m)) !== fEstado) return false;
    if (salvo !== "rubro" && fRubro !== "all" && oSinDato(m.business_type) !== fRubro) return false;
    if (salvo !== "zona" && fZona !== "all" && oSinDato(zonaDe(m)) !== fZona) return false;
    if (salvo !== "fundador" && fFundador !== "all" && (fFundador === "si") !== esFounding(m)) return false;
    if (salvo !== "menu" && fMenu !== "all" && (fMenu === "con") !== tieneMenu(m)) return false;
    if (salvo !== "ofertas" && fOfertas !== "all" && ofertasPorComercio) {
      const o = ofertasDe(m);
      if (fOfertas === "aprobada" && !(o.approved > 0)) return false;
      if (fOfertas === "pendiente" && !(o.pending > 0)) return false;
      if (fOfertas === "ninguna" && o.total > 0) return false;
    }
    const alta = fechaMiami(m["Created Date"]);
    if (fDesde && (!alta || alta < fDesde)) return false;
    if (fHasta && (!alta || alta > fHasta)) return false;
    return true;
  };
  const filtered = merchants.filter(m => pasa(m)).sort((a, b) => {
    if (orden === "az") return String(a.business_name || "").localeCompare(String(b.business_name || ""), "es");
    const da = new Date(a["Created Date"] || 0).getTime(), db = new Date(b["Created Date"] || 0).getTime();
    return orden === "viejos" ? da - db : db - da;
  });
  // Las opciones de cada selector, con cuántos quedarían si se elige (contando los demás filtros, no el propio).
  // s223 · `sinDato`: la etiqueta de la opción «sin dato» (va al final, solo si hay alguno).
  const opcionesDe = (salvo, clave, etiqueta, todas, sinDato) => {
    const cuenta = contarPor(merchants.filter(m => pasa(m, salvo)), m => oSinDato(clave(m)));
    const valores = todas || Object.keys(cuenta).filter(k => k !== SIN_DATO).sort((a, b) => etiqueta(a).localeCompare(etiqueta(b), "es"));
    const conVacio = !todas && sinDato && cuenta[SIN_DATO] ? [{ v: SIN_DATO, l: `${sinDato} (${cuenta[SIN_DATO]})` }] : [];
    return [{ v: "all", l: en ? "All" : "Todos" }, ...valores.map(v => ({ v, l: `${etiqueta(v)} (${cuenta[v] || 0})` })), ...conVacio];
  };
  const hayFiltros = !!(search.trim() || filterCat !== "all" || fEstado !== "all" || fRubro !== "all" || fZona !== "all"
    || fFundador !== "all" || fMenu !== "all" || fOfertas !== "all" || fDesde || fHasta);
  const limpiarFiltros = () => {
    setSearch(""); setFilterCat("all"); setFEstado("all"); setFRubro("all"); setFZona("all");
    setFFundador("all"); setFMenu("all"); setFOfertas("all"); setFDesde(""); setFHasta("");
  };

  // s186 · EL CONTADOR DABA SIEMPRE CERO, y nadie lo iba a notar hasta tener
  // fundadores de verdad. `MerchantPartner` tiene DOS campos booleanos parecidos:
  //   `is_founding`          ← el real: lo escribe approve_merchant, lo leen
  //                            charge_merchant_take (para perdonar el cobro) y redeem_coupon
  //   `is_founding_partner`  ← existe en el esquema y NINGÚN workflow lo escribe
  // Los dos WF que lo devuelven a React —get_merchant_profile y get_merchant_stats—
  // exponen el alias `is_founding_partner` LEYENDO de `is_founding_boolean`, y por eso
  // el panel DEL COMERCIO funciona (ver la nota de s179 en MerchantOffers). Pero esta
  // pantalla no pasa por un WF: lee la fila cruda de la Data API, donde el alias no
  // existe y el campo homónimo está muerto. Se lee el real, con el alias de respaldo
  // por si algún día alguien empieza a escribirlo.
  // (esFounding se declara más arriba, antes de los filtros: s223)
  // s188 - el contador se contaba sobre `merchants` (TODOS) y se mostraba al lado de
  // `filtered.length` (los que pasan el buscador y el filtro de categoria). Con un
  // filtro puesto la linea decia cosas como "3 socios - 12 Founding Partners": dos
  // numeros de dos poblaciones distintas, pegados con un punto. Sin filtros
  // `filtered` es `merchants`, asi que la vista por defecto no cambia.
  const foundingCount = filtered.filter(esFounding).length;

  const cols = [
    { label: en ? "Business" : "Negocio", width: "2.5fr", render: m => (
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div style={{ width: 36, height: 36, borderRadius: 6, background: C.light, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 16 }}>
          <CategoryIcon category={m.category} />
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: C.black }}>{m.business_name || "—"}</div>
          <div style={{ fontSize: 10, color: C.muted }}>{m.address || m.neighborhood || "Miami"}</div>
          {/* s223 · cuándo entró (hora de Miami) y su rubro */}
          <div style={{ fontSize: 10, color: C.muted }}>
            {[m["Created Date"] ? `${en ? "Joined" : "Alta"} ${fechaCortaMiami(m["Created Date"], en)}` : "", m.business_type ? etiquetaRubro(m.business_type, en) : ""].filter(Boolean).join(" · ")}
          </div>
        </div>
      </div>
    )},
    { label: en ? "Category" : "Categoría", width: "1fr", render: m => (
      <span style={{ fontSize: 11, color: C.gray }}>{CAT_DISPLAY[m.category] || m.category || "—"}</span>
    )},
    { label: en ? "Contact" : "Contacto", width: "1.5fr", render: m => (
      <div>
        <div style={{ fontSize: 11, color: C.gray }}>{m.email || "—"}</div>
        <div style={{ fontSize: 10, color: C.muted }}>{telefonoDe(m) || "—"}</div>
      </div>
    )},
    { label: "Status", width: "0.8fr", render: m => (
      <div>
        <AdminBadge label={m.status || "approved"} type={m.status || "approved"} />
        {/* s222 · lote 2a · decisión 1.2-a: marca para pedir el menú (no se despublica nada). */}
        {!tieneMenu(m) && String(m.status || "").toLowerCase() !== "rejected" && <div style={{ marginTop: 4 }}><MarcaFaltaMenu en={en} categoria={m.category} /></div>}
        {esFounding(m) && (
          <div style={{ marginTop: 4 }}>
            <span style={{ fontSize: 8, background: "var(--aviso-tinte)", color: "var(--aviso)", padding: "2px 6px", borderRadius: 2, fontWeight: 700 }}>★ FOUNDING</span>
          </div>
        )}
      </div>
    )},
    { label: en ? "Stats" : "Estadísticas", width: "0.8fr", render: m => (
      <div>
        <div style={{ fontSize: 12, fontWeight: 600, color: C.valor }}>★ {m.rating || "—"}</div>
        <div style={{ fontSize: 9, color: C.muted }}>{m.total_reviews || 0} {en ? "reviews" : "reseñas"}</div>
        {/* s223 · sus ofertas vivas (aprobadas y pendientes) */}
        {ofertasPorComercio && (() => {
          const o = ofertasDe(m);
          return (
            <div style={{ fontSize: 9, color: o.total ? C.gray : C.muted, marginTop: 2 }}>
              {o.total
                ? `${o.total} ${en ? (o.total === 1 ? "offer" : "offers") : (o.total === 1 ? "oferta" : "ofertas")} · ${o.approved} ${en ? "live" : "aprob."}${o.pending ? ` · ${o.pending} ${en ? "pend." : "pend."}` : ""}`
                : (en ? "No active offers" : "Sin ofertas activas")}
            </div>
          );
        })()}
      </div>
    )},
    { label: en ? "Actions" : "Acciones", width: "1fr", render: m => (
      <div style={{ display: "flex", gap: 4 }}>
        <button onClick={() => { setActionMsg(""); setSelectedMerchant(selectedMerchant?._id === m._id ? null : m); }} style={{
          background: C.light, color: C.gray, border: `1px solid ${C.border}`, padding: "4px 8px",
          fontSize: 10, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif"
        }}>
          {en ? "Details" : "Detalles"}
        </button>
      </div>
    )},
  ];

  return (
    <AdminLayout active="merchants">
      <div style={{ marginBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>MERCHANTS</div>
          <p style={{ fontSize: 13, color: C.muted }}>
            {hayFiltros ? `${filtered.length} ${en ? "of" : "de"} ${merchants.length} ${en ? "partners" : "socios"}` : plural(filtered.length, en ? "partner" : "socio", en ? "partners" : "socios")} · {plural(foundingCount, "Founding Partner", "Founding Partners")}
          </p>
        </div>
        <input value={search} onChange={e => setSearch(e.target.value)} aria-label={en ? "Search merchants" : "Buscar comercios"}
          placeholder={en ? "Name, email, phone, area…" : "Nombre, correo, teléfono, zona…"}
          style={{ ...S.input, width: 280, maxWidth: "100%", fontSize: 12, padding: "8px 12px" }} />
      </div>

      {/* s223 · los filtros. Cada opción dice cuántos quedarían. */}
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end", marginBottom: 12, padding: 12, background: C.white, border: `1px solid ${C.border}`, borderRadius: 4 }}>
        <AdminFiltroSelect id="fm-estado" etiqueta={en ? "Status" : "Estado"} valor={fEstado} onCambio={setFEstado}
          opciones={opcionesDe("estado", claveEstadoComercio, k => etiquetaEstadoComercio(k, en), null, en ? "No status" : "Sin estado")} />
        <AdminFiltroSelect id="fm-rubro" etiqueta={en ? "Type" : "Rubro"} valor={fRubro} onCambio={setFRubro}
          opciones={opcionesDe("rubro", m => m.business_type || "", k => etiquetaRubro(k, en), null, en ? "No type" : "Sin rubro")} />
        <AdminFiltroSelect id="fm-zona" etiqueta={en ? "Area" : "Zona / barrio"} valor={fZona} onCambio={setFZona}
          opciones={opcionesDe("zona", zonaDe, k => k, null, en ? "No area" : "Sin zona")} />
        <AdminFiltroSelect id="fm-fundador" etiqueta={en ? "Founding" : "Fundador"} valor={fFundador} onCambio={setFFundador}
          opciones={opcionesDe("fundador", m => (esFounding(m) ? "si" : "no"), k => (k === "si" ? (en ? "Founding" : "Fundador") : (en ? "Not founding" : "No fundador")), ["si", "no"])} />
        <AdminFiltroSelect id="fm-menu" etiqueta={en ? "Menu" : "Menú"} valor={fMenu} onCambio={setFMenu}
          opciones={opcionesDe("menu", m => (tieneMenu(m) ? "con" : "sin"), k => (k === "con" ? (en ? "Has menu or price list" : "Con menú o lista de precios") : (en ? "Missing menu or price list" : "Falta menú o lista de precios")), ["con", "sin"])} />
        <AdminFiltroSelect id="fm-ofertas" etiqueta={en ? "Offers" : "Ofertas"} valor={fOfertas} onCambio={setFOfertas}
          opciones={ofertasPorComercio
            ? opcionesDe("ofertas", m => { const o = ofertasDe(m); return o.approved ? "aprobada" : o.pending ? "pendiente" : o.total ? "otra" : "ninguna"; },
                k => ({ aprobada: en ? "With a live offer" : "Con oferta aprobada", pendiente: en ? "Only pending" : "Solo pendientes", ninguna: en ? "No active offers" : "Sin ofertas activas", otra: en ? "Other" : "Otras" }[k] || k),
                ["aprobada", "pendiente", "ninguna"])
            : [{ v: "all", l: en ? "Loading…" : "Cargando…" }]} />
        <AdminFiltroFecha id="fm-desde" etiqueta={en ? "Joined from" : "Alta desde"} valor={fDesde} onCambio={setFDesde} />
        <AdminFiltroFecha id="fm-hasta" etiqueta={en ? "Joined until" : "Alta hasta"} valor={fHasta} onCambio={setFHasta} />
        <AdminFiltroSelect id="fm-orden" etiqueta={en ? "Sort" : "Orden"} valor={orden} onCambio={setOrden}
          opciones={[{ v: "nuevos", l: en ? "Newest first" : "Más nuevos primero" }, { v: "viejos", l: en ? "Oldest first" : "Más viejos primero" }, { v: "az", l: "A–Z" }]} />
        {hayFiltros && (
          <button type="button" onClick={limpiarFiltros} style={{ background: C.white, color: C.gray, border: `1px solid ${C.border}`, padding: "7px 12px", fontSize: 11, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
            {en ? "Clear filters" : "Limpiar filtros"}
          </button>
        )}
      </div>

      {/* Category filters */}
      <div style={{ display: "flex", gap: 6, marginBottom: 16, flexWrap: "wrap" }}>
        {categories.map(cat => (
          <button key={cat} onClick={() => setFilterCat(cat)} style={{
            background: filterCat === cat ? C.black : C.white, color: filterCat === cat ? C.white : C.gray,
            border: `1px solid ${filterCat === cat ? C.black : C.border}`,
            padding: "4px 10px", fontSize: 10, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", borderRadius: 2,
          }}>{cat === "all" ? (en ? "All" : "Todos") : (CAT_DISPLAY[cat] || cat)}</button>
        ))}
      </div>

      <AdminTable columns={cols} rows={filtered} loading={loading} />

      {/* Merchant Detail Modal */}
      {selectedMerchant && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center" }} onClick={() => setSelectedMerchant(null)}>
          <div role="dialog" aria-modal="true" aria-label={en ? "Merchant detail" : "Detalle del comercio"} style={{ background: C.white, width: "100%", maxWidth: 520, borderRadius: 8, padding: "28px 24px", maxHeight: "80vh", overflowY: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 48, height: 48, borderRadius: 8, background: C.light, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
                  <CategoryIcon category={selectedMerchant.category} />
                </div>
                <div>
                  <div style={{ ...S.display, fontSize: 20, color: C.black }}>{selectedMerchant.business_name}</div>
                  <div style={{ fontSize: 12, color: C.muted }}>{CAT_DISPLAY[selectedMerchant.category] || selectedMerchant.category}</div>
                </div>
              </div>
              <button onClick={() => setSelectedMerchant(null)} style={{ background: "none", border: "none", fontSize: 18, cursor: "pointer", color: C.muted }}>✕</button>
            </div>

            {esFounding(selectedMerchant) && (
              <div style={{ background: "var(--aviso-tinte)", border: "1px solid var(--linea)", borderRadius: 6, padding: "10px 14px", marginBottom: 16, display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontSize: 16 }}>⭐</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "var(--aviso)" }}>Founding Partner</div>
                  {/* s199 (s193-D1): no hay cuota que descontar. El distintivo dice quién es,
                      no qué se le cobra. */}
                </div>
              </div>
            )}

            {/* s235 · admin-detalle-comercio-ficha (P8): logo, descripción, dirección, horario, web e Instagram. */}
            <FichaComercioAdmin key={`ficha-${selectedMerchant._id}`} m={selectedMerchant} en={en} />

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 16 }}>
              {[
                { label: "Email", value: selectedMerchant.email || "—" },
                { label: en ? "Phone" : "Teléfono", value: selectedMerchant.phone_public || selectedMerchant.phone || "—" },   // s223 · el campo es phone_public
                { label: en ? "Address" : "Dirección", value: selectedMerchant.address || "—" },
                { label: "Status", value: (selectedMerchant.status || "approved").toUpperCase() },
                { label: "Rating", value: `★ ${selectedMerchant.rating || "—"} (${selectedMerchant.total_reviews || 0})` },
                { label: en ? "Coupons Redeemed" : "Cupones Redimidos", value: selectedMerchant.total_redeemed || 0 },
              ].map((item, i) => (
                <div key={i} style={{ padding: "10px 12px", background: C.light, borderRadius: 6 }}>
                  <div style={{ fontSize: 9, color: C.muted, letterSpacing: "0.1em", marginBottom: 2 }}>{item.label.toUpperCase()}</div>
                  <div style={{ fontSize: 13, fontWeight: 500, color: C.black }}>{item.value}</div>
                </div>
              ))}
            </div>

            {/* s226 · contacto-responsable-alta: lo que llenó el comercio + lo que anotó Otto. */}
            <ContactoAdmin key={`ctc-${selectedMerchant._id}`} merchant={selectedMerchant} en={en} />

            {/* s232 · terminos-condiciones-merchant: qué versión aceptó y cuándo (campos de SPEC_s232 §1; sin ellos, «sin aceptar»). */}
            <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>
              {en ? "Terms: " : "Términos: "}
              {selectedMerchant.terms_accepted_at
                ? `v${selectedMerchant.terms_version || "?"} · ${new Date(selectedMerchant.terms_accepted_at).toLocaleDateString(en ? "en-US" : "es-US")}${selectedMerchant.terms_accepted_via ? ` · ${selectedMerchant.terms_accepted_via}` : ""}`
                : (en ? "not accepted" : "sin aceptar")}
            </div>

            {/* s203 · «Quitar foto» (admin_remove_merchant_photo). key = el comercio: al cambiar
                de comercio el panel nace de cero y no arrastra la galería del anterior. */}
            {/* s235 · P8: la galería abierta de entrada (antes plegada: se aprobaba sin ver las fotos). */}
            <QuitarFotosComercio key={selectedMerchant._id} merchantId={selectedMerchant._id} nombre={selectedMerchant.business_name} en={en} abrir />

            {/* s222 · lote 2a · el menú del comercio (save_merchant_ficha con merchant_id): antes de aprobar sus ofertas. */}
            <MenuDelComercio key={`menu-${selectedMerchant._id}`} idBase="admin-comercio-menu" en={en} comoAdmin
              merchantId={selectedMerchant._id} categoria={selectedMerchant.category} ficha={selectedMerchant}
              onGuardado={(nueva) => {
                if (!nueva) return;
                setMerchants(prev => prev.map(m => m._id === selectedMerchant._id ? { ...m, ...nueva } : m));
                setSelectedMerchant(prev => (prev ? { ...prev, ...nueva } : prev));
              }} />

            {/* X.38: merchant moderation (Lead → Approved/Rejected) */}
            {(() => {
              const st = (selectedMerchant.status || "").toLowerCase();
              return (
                <div style={{ borderTop: `1px solid ${C.border}`, marginTop: 4, paddingTop: 16 }}>
                  {actionMsg && (
                    <div style={{ fontSize: 12, marginBottom: 10, fontWeight: 500, color: actionMsg.startsWith("⚠️") ? "var(--error)" : "var(--exito)" }}>{actionMsg}</div>
                  )}
                  <div style={{ display: "flex", gap: 8 }}>
                    <button disabled={acting || st === "approved"} onClick={() => handleModerate(selectedMerchant, "approve")} style={{
                      flex: 1, background: st === "approved" ? C.light : "var(--exito)", color: st === "approved" ? C.muted : C.white,
                      border: "none", padding: "10px 12px", fontSize: 12, fontWeight: 600, borderRadius: 4,
                      cursor: acting || st === "approved" ? "default" : "pointer", fontFamily: "'DM Sans', sans-serif", opacity: acting ? 0.6 : 1,
                    }}>{en ? "Approve" : "Aprobar"}</button>
                    <button disabled={acting || st === "rejected"} onClick={() => handleModerate(selectedMerchant, "reject")} style={{
                      flex: 1, background: C.white, color: st === "rejected" ? C.muted : "var(--error)",
                      border: `1px solid ${st === "rejected" ? C.border : "var(--error)"}`, padding: "10px 12px", fontSize: 12, fontWeight: 600, borderRadius: 4,
                      cursor: acting || st === "rejected" ? "default" : "pointer", fontFamily: "'DM Sans', sans-serif", opacity: acting ? 0.6 : 1,
                    }}>{en ? "Reject" : "Rechazar"}</button>
                  </div>
                </div>
              );
            })()}

            {/* s126 Fase C: cobro manual de la cuota de programa (wrapper admin) */}
            <div style={{ borderTop: `1px solid ${C.border}`, marginTop: 16, paddingTop: 16 }}>
              <div style={{ fontSize: 9, color: C.muted, letterSpacing: "0.1em", marginBottom: 8 }}>
                {en ? "PROGRAM FEE" : "CUOTA DE PROGRAMA"}
              </div>
              <button disabled={acting} onClick={() => handleCharge(selectedMerchant)} style={{
                width: "100%", background: C.black, color: C.gold, border: `1px solid ${C.gold}`,
                padding: "10px 12px", fontSize: 12, fontWeight: 600, borderRadius: 4,
                cursor: acting ? "default" : "pointer", fontFamily: "'DM Sans', sans-serif", opacity: acting ? 0.6 : 1,
              }}>{en ? "💳 Charge now" : "💳 Cobrar ahora"}</button>
              <div style={{ fontSize: 9, color: C.muted, marginTop: 6, lineHeight: 1.4 }}>
                {en
                  ? "Only charges if eligible: billing active · ≥$15 accrued · card on file · no charge in last 24h."
                  : "Solo cobra si es elegible: billing activo · ≥$15 acumulados · tarjeta guardada · sin cobro en 24h."}
              </div>
            </div>

            {selectedMerchant._id && (
              <div style={{ fontSize: 10, color: C.muted, fontFamily: "monospace", padding: "8px 0", borderTop: `1px solid ${C.border}` }}>
                ID: {selectedMerchant._id}
              </div>
            )}
          </div>
        </div>
      )}
    </AdminLayout>
  );
}

// ============================================
// ADMIN: ACCESS CODES
// ============================================

// ETAPA-2 (s99): outcome comercial de un codigo (option set CodeOutcome, 5 valores fijos).
const OUTCOME_OPTIONS = ["pending", "sold", "invited", "discount", "free_close"];
const outcomeLabel = (v, en) => ({
  pending: en ? "Pending" : "Pendiente",
  sold: en ? "Sold" : "Vendido",
  invited: en ? "Invited" : "Invitada",
  discount: en ? "Discount" : "Descuento",
  free_close: en ? "Free close" : "Cierre gratis",
}[v] || v || "—");
// Preset de vencimiento → ISO date (expires_at de create_access_code). "none" → undefined.
const presetToExpiresAt = (p) => {
  const h = { "24h": 24, "48h": 48, "7d": 168 }[p];
  return h ? new Date(Date.now() + h * 3600 * 1000).toISOString() : undefined;
};

// ETAPA-2 (s99): CONSOLA DE VENTAS de la Operadora (/operator). D1-D4:
// - crea codigos con SU token (Created By = ella → atribucion gratis);
// - lista SOLO los suyos via privacy rule "Creator" (getMyAccessCodes);
// - etiqueta el resultado via WF set_outcome (gateado server-side);
// - contadores client-side (D3: sin get_operator_stats);
// - expires_at expuesto con presets (D4: urgencia-por-codigo).
function OperatorConsole() {
  const lang = useLang();
  const navigate = useNavigate();
  const en = lang === "en";
  const [profile, setProfile] = useState(null);
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [msg, setMsg] = useState("");
  const [copied, setCopied] = useState(null);
  const [savingOutcome, setSavingOutcome] = useState(null);
  const [form, setForm] = useState({ code: "", tier: "LITE", notes: "", max_coupons: 2, vip_max_active: 5, duration_months: 12, expires_preset: "none" });

  useEffect(() => {
    getUserProfile().then(setProfile).catch(() => {});
    getMyAccessCodes().then(c => { setCodes(c); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const generateCode = (tier) => `${tier === "VIP" ? "VIP" : "LITE"}${String(Math.floor(Math.random() * 9000) + 1000)}`;
  const copyCode = (code) => { navigator.clipboard?.writeText(code); setCopied(code); setTimeout(() => setCopied(null), 1500); };
  const fmtD = (v) => { if (!v) return "—"; const d = new Date(v); return isNaN(d.getTime()) ? "—" : d.toLocaleDateString(); };

  const handleCreate = async () => {
    if (!form.code.trim()) { setMsg(en ? "Enter a code" : "Ingresa un código"); return; }
    setCreating(true); setMsg("");
    try {
      const mc = Number(form.max_coupons) || 2;
      const vma = Number(form.vip_max_active) || 5;
      const dm = form.tier === "VIP" ? (Number(form.duration_months) || 12) : undefined;
      const expires_at = presetToExpiresAt(form.expires_preset);
      const code = form.code.trim().toUpperCase();
      const result = await createAccessCode({ code, tier_to_assign: form.tier, notes: form.notes, max_coupons: mc, vip_max_active: vma, duration_months: dm, expires_at });
      setCodes(prev => [{ code, tier_to_assign: form.tier, is_used: false, notes: form.notes, max_coupons: mc, outcome: "pending", expires_at: expires_at || null, "Created Date": new Date().toISOString(), _id: result?.access_code_id }, ...prev]);
      setMsg(`✅ ${en ? "Code created:" : "Código creado:"} ${code}`);
      setForm(f => ({ ...f, code: "", notes: "" }));
      setTimeout(() => setMsg(""), 4000);
    } catch (e) {
      const ec = String(e?.code || e?.message || "");
      setMsg(ec.includes("NOT_AUTHORIZED")
        ? (en ? "❌ Not authorized to create codes." : "❌ No autorizada para crear códigos.")
        : ec.includes("code_already_exists")
          ? (en ? "❌ That code already exists — tap AUTO for another." : "❌ Ese código ya existe — toca AUTO para otro.")
          : (en ? "❌ Error creating code" : "❌ Error al crear el código"));
    } finally { setCreating(false); }
  };

  const handleOutcome = async (c, outcome) => {
    const prev = c.outcome || "pending";
    if (outcome === prev) return;
    setSavingOutcome(c._id);
    setCodes(list => list.map(x => x._id === c._id ? { ...x, outcome } : x));
    try {
      await setOutcome(c._id, outcome);
    } catch (e) {
      setCodes(list => list.map(x => x._id === c._id ? { ...x, outcome: prev } : x));
      setMsg(en ? "❌ Couldn't save the outcome — try again." : "❌ No se pudo guardar el resultado — prueba de nuevo.");
      setTimeout(() => setMsg(""), 4000);
    } finally { setSavingOutcome(null); }
  };

  const used = codes.filter(c => c.is_used).length;
  const byOutcome = OUTCOME_OPTIONS.reduce((acc, o) => { acc[o] = codes.filter(c => (c.outcome || "pending") === o).length; return acc; }, {});
  const StatBox = ({ label, value }) => (
    <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 4, padding: "10px 16px", minWidth: 92 }}>
      <div style={{ ...S.display, fontSize: 22, color: C.black }}>{value}</div>
      <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em" }}>{label}</div>
    </div>
  );

  const cols = [
    { label: en ? "Code" : "Código", width: "2fr", render: c => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ ...S.display, fontSize: 16, color: C.black, letterSpacing: "0.1em" }}>{c.code || "—"}</span>
        <button onClick={() => copyCode(c.code)} style={{ background: "none", border: `1px solid ${C.border}`, color: copied === c.code ? "var(--exito)" : C.muted, padding: "2px 8px", fontSize: 10, cursor: "pointer", borderRadius: 2 }}>
          {copied === c.code ? "✓" : en ? "Copy" : "Copiar"}
        </button>
      </div>
    )},
    { label: "Tier", width: "0.8fr", render: c => <AdminBadge label={c.tier_to_assign || "—"} /> },
    { label: en ? "Created" : "Creado", width: "1fr", render: c => <span style={{ fontSize: 12, color: C.muted }}>{fmtD(c["Created Date"])}</span> },
    { label: en ? "Expires" : "Vence", width: "1fr", render: c => <span style={{ fontSize: 12, color: (c.expires_at && new Date(c.expires_at) < new Date()) ? C.red : C.muted }}>{fmtD(c.expires_at)}</span> },
    { label: en ? "Status" : "Estado", width: "1fr", render: c => <AdminBadge label={c.is_used ? (en ? "Used" : "Usado") : (en ? "Available" : "Disponible")} type={c.is_used ? "used" : "unused"} /> },
    { label: en ? "Outcome" : "Resultado", width: "1.3fr", render: c => (
      <select value={c.outcome || "pending"} disabled={savingOutcome === c._id} onChange={e => handleOutcome(c, e.target.value)} style={{ ...S.input, padding: "4px 6px", fontSize: 11, cursor: "pointer", opacity: savingOutcome === c._id ? 0.5 : 1 }}>
        {OUTCOME_OPTIONS.map(o => <option key={o} value={o}>{outcomeLabel(o, en)}</option>)}
      </select>
    )},
  ];

  return (
    <div style={{ ...S.page, minHeight: "100vh", padding: "24px 16px" }}>
      <div style={{ maxWidth: 980, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div style={{ ...S.display, fontSize: 26, color: C.black }}>{en ? "SALES CONSOLE" : "CONSOLA DE VENTAS"}</div>
            <div style={{ fontSize: 12, color: C.muted }}>{profile?.name || profile?.email || ""} · {en ? "Operator" : "Operadora"}</div>
            {/* s195 · el panel de siembra de la vitrina beta vive en su propia ruta. s238 · partido en Negocios y Sembrar. */}
            <button onClick={() => navigate("/operator/negocios")} style={{ marginTop: 8, background: "none", border: `1px solid ${C.red}`, color: C.red, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
              {en ? "Businesses →" : "Negocios →"}
            </button>
            <button onClick={() => navigate("/operator/vitrina")} style={{ marginTop: 8, marginLeft: 8, background: "none", border: `1px solid ${C.red}`, color: C.red, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
              {en ? "Seed →" : "Sembrar →"}
            </button>
            {/* s216 · bloque A: un operador que también es socio llega a sus cupones (antes, solo por URL). */}
            <button onClick={() => navigate("/my-coupons")} style={{ marginTop: 8, marginLeft: 8, background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
              {en ? "My coupons" : "Mis cupones"}
            </button>
          </div>
          <button onClick={() => { auth.logout(); navigate("/login"); }} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "8px 14px", fontSize: 12, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
            {en ? "Log out" : "Salir"}
          </button>
        </div>

        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", marginBottom: 20 }}>
          <StatBox label={en ? "TOTAL" : "TOTAL"} value={codes.length} />
          <StatBox label={en ? "AVAILABLE" : "DISPONIBLES"} value={codes.length - used} />
          <StatBox label={en ? "USED" : "USADOS"} value={used} />
          <StatBox label={en ? "SOLD" : "VENDIDOS"} value={byOutcome.sold} />
          <StatBox label={en ? "PENDING" : "PENDIENTES"} value={byOutcome.pending} />
        </div>

        {msg && <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 4, padding: "10px 14px", fontSize: 13, color: C.black, marginBottom: 14 }}>{msg}</div>}

        <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 4, padding: 20, marginBottom: 20 }}>
          <div style={{ ...S.display, fontSize: 16, color: C.black, marginBottom: 14 }}>{en ? "GENERATE CODE" : "GENERAR CÓDIGO"}</div>
          <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-end" }}>
            <div style={{ flex: "2 1 200px" }}>
              {/* s238 · ayudas C4/C5/C6 (COPY_s238_ayudas_top10 §6): códigos de MIEMBRO, de un solo uso; LITE/VIP y el máximo. */}
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "CODE" : "CÓDIGO"}
                <AltaPista texto={en ? "It's for a person, not a business. It works once: give it to whoever is joining as a member."
                  : "Es para una persona, no para un comercio. Se usa una sola vez: dáselo a quien va a entrar como miembro."} /></div>
              <div style={{ display: "flex", gap: 6 }}>
                <input value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value.toUpperCase() }))}
                  placeholder={en ? "TYPE OR TAP AUTO →" : "ESCRIBE O TOCA AUTO →"} style={{ ...S.input, fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, letterSpacing: "0.1em", flex: 1 }} />
                <button onClick={() => setForm(f => ({ ...f, code: generateCode(f.tier) }))} style={{ ...S.btnPrimary, padding: "10px 14px", whiteSpace: "nowrap" }}>AUTO</button>
              </div>
            </div>
            <div style={{ flex: "0 1 110px" }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>TIER
                <AltaPista texto={en ? "LITE: free entry with a few trial activations; when they run out, we offer the subscription. VIP: full membership for the time you choose, at no charge."
                  : "LITE: entra gratis con unas pocas activaciones de prueba; cuando se le acaban, le ofrecemos la suscripción. VIP: membresía completa por el tiempo que elijas, sin pagar."} /></div>
              <select value={form.tier} onChange={e => setForm(f => ({ ...f, tier: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                <option value="LITE">LITE</option>
                <option value="VIP">VIP</option>
              </select>
            </div>
            <div style={{ flex: "0 1 120px" }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>
                {form.tier === "LITE" ? (en ? "MAX COUPONS" : "MÁX CUPONES") : (en ? "VIP MAX ACTIVE" : "VIP MÁX ACTIVOS")}
                <AltaPista texto={form.tier === "LITE"
                  ? (en ? "How many offers they can activate for free before we ask them to subscribe. Usual: 2."
                    : "Cuántas ofertas puede activar gratis antes de que le pidamos la suscripción. Normal: 2.")
                  : (en ? "How many offers they can hold active at the same time. Not a total: using one frees the slot. Usual: 5."
                    : "Cuántas ofertas puede tener activas al mismo tiempo. No es un total: cuando usa una, libera el lugar. Normal: 5.")} />
              </div>
              <input type="number" min="1"
                value={form.tier === "LITE" ? form.max_coupons : form.vip_max_active}
                onChange={e => { const v = e.target.value; setForm(f => f.tier === "LITE" ? { ...f, max_coupons: v } : { ...f, vip_max_active: v }); }}
                style={{ ...S.input }} />
            </div>
            {form.tier === "VIP" && (
              <div style={{ flex: "0 1 110px" }}>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "MONTHS" : "MESES"}</div>
                <input type="number" min="1" value={form.duration_months} onChange={e => setForm(f => ({ ...f, duration_months: e.target.value }))} style={{ ...S.input }} />
              </div>
            )}
            <div style={{ flex: "0 1 130px" }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "EXPIRES" : "VENCE"}</div>
              <select value={form.expires_preset} onChange={e => setForm(f => ({ ...f, expires_preset: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                <option value="none">{en ? "No expiry" : "No vence"}</option>
                <option value="24h">24h</option>
                <option value="48h">48h</option>
                <option value="7d">{en ? "7 days" : "7 días"}</option>
              </select>
            </div>
            <div style={{ flex: "2 1 180px" }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "NOTES" : "NOTAS"}</div>
              <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder={en ? "e.g. Maria — hotel lobby" : "ej. María — lobby del hotel"} style={{ ...S.input }} />
            </div>
            <div>
              <button onClick={handleCreate} disabled={creating} style={{ ...S.btnPrimary, padding: "10px 20px", opacity: creating ? 0.7 : 1, whiteSpace: "nowrap" }}>
                {creating ? "..." : "+ " + (en ? "Create" : "Crear")}
              </button>
            </div>
          </div>
          <p style={{ fontSize: 10, color: C.muted, marginTop: 10 }}>
            {en ? "The code is attributed to you automatically. Tag the outcome in the list below after each close."
                : "El código queda atribuido a ti automáticamente. Etiqueta el resultado en la lista de abajo después de cada cierre."}
          </p>
        </div>

        <div style={{ ...S.display, fontSize: 16, color: C.black, margin: "8px 0" }}>{en ? "MY CODES" : "MIS CÓDIGOS"} ({codes.length})</div>
        <AdminTable columns={cols} rows={codes} loading={loading} empty={en ? "No codes yet — create your first one above." : "Todavía no hay códigos — genera el primero arriba."} />
      </div>
    </div>
  );
}

// ============================================
// ADMIN: INFLUENCERS (s111) — panel de referidos por código INF: (F1-admin)
// ============================================
// Lista los AccessCodes cuyo label empieza con "INF:" y, por cada uno, llama al WF
// admin-only get_influencer_stats -> tarjeta con AGREGADOS (registros, primeras
// activaciones, conversion, $ fees). NUNCA muestra identidad de referidos (agregados-only).
// Deal = alta + PRIMERA activacion; el sello no es retroactivo (deployado s111).
function AdminInfluencers() {
  const lang = useLang();
  const en = lang === "en";
  const [rows, setRows] = useState([]);
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);
  const [copied, setCopied] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      const codes = await getAllAccessCodes().catch(() => []);
      const inf = (codes || []).filter(c => c.is_multiuse);
      if (!alive) return;
      setRows(inf);
      setLoading(false);
      for (const c of inf) {
        getInfluencerStats(c.code).then(s => {
          if (alive && s && s.success !== "no") setStats(prev => ({ ...prev, [c.code]: s }));
        }).catch(() => {});
      }
    })();
    return () => { alive = false; };
  }, []);

  const infName = (label) => (label || "").replace(/^INF:\s*/i, "").trim() || "—";
  const money = (cents) => `$${((Number(cents) || 0) / 100).toFixed(2)}`;
  const convPct = (s) => {
    const r = Number(s?.registered) || 0;
    const a = Number(s?.first_activations) || 0;
    return r > 0 ? Math.round((a / r) * 100) : 0;
  };

  const copySummary = (c) => {
    const s = stats[c.code] || {};
    const r = Number(s.registered) || 0;
    const a = Number(s.first_activations) || 0;
    const txt = `${c.code} · ${en ? "summary as of" : "resumen al"} ${new Date().toLocaleDateString()}: ${r} ${en ? "signups" : "registros"} · ${a} ${en ? "first activations" : "primeras activaciones"} (${convPct(s)}%) · ${money(s.first_fees_cents)} ${en ? "in activations" : "en activaciones"}`;
    if (navigator.clipboard) navigator.clipboard.writeText(txt);
    setCopied(c.code);
    setTimeout(() => setCopied(""), 1500);
  };

  return (
    <AdminLayout active="influencers">
      <div style={{ marginBottom: 24 }}>
        <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>
          {en ? "INFLUENCERS" : "INFLUENCERS"}
        </div>
        <p style={{ fontSize: 13, color: C.muted }}>
          {en
            ? "Aggregated referral stats per influencer (multi-use) code — signups and first activations. No referred-user identities are shown."
            : "Estadísticas agregadas por código de influencer (multiuso) — registros y primeras activaciones. No se muestra la identidad de los referidos."}
        </p>
      </div>

      {loading ? (
        <div style={{ padding: 40, textAlign: "center", color: C.muted }}>{en ? "Loading..." : "Cargando..."}</div>
      ) : rows.length === 0 ? (
        <div style={{ background: C.white, border: `1px solid ${C.border}`, padding: 40, textAlign: "center", color: C.muted }}>
          {en
            ? 'No influencer codes yet. Create a multi-use "Influencer code" in the Codes tab.'
            : 'Todavía no hay códigos de influencer. Crea un código multiuso ("Código de influencer") en la pestaña Códigos.'}
        </div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 16 }}>
          {rows.map((c) => {
            const s = stats[c.code];
            const loaded = !!s;
            const reg = Number(s?.registered) || 0;
            const acts = Number(s?.first_activations) || 0;
            const cap = c.max_signups || s?.max_signups;
            const exp = c.expires_at || s?.expires_at;
            const expired = exp && new Date(exp) < new Date();
            return (
              <div key={c.code} style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.gold}`, padding: "20px 22px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 14 }}>
                  <div>
                    <div style={{ ...S.display, fontSize: 20, color: C.black }}>{c.code}</div>
                    <div style={{ fontSize: 12, color: C.muted, marginTop: 2 }}>{infName(c.label)}</div>
                  </div>
                  <span style={{ fontSize: 11, color: expired ? C.red : C.muted }}>
                    {exp ? `${en ? "exp" : "vence"} ${new Date(exp).toLocaleDateString()}` : (en ? "no expiry" : "sin vencer")}
                  </span>
                </div>

                {!loaded ? (
                  <div style={{ padding: "12px 0", color: C.muted, fontSize: 12 }}>{en ? "Loading stats…" : "Cargando…"}</div>
                ) : (
                  <>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
                      <div>
                        <div style={{ ...S.display, fontSize: 30, color: C.black, lineHeight: 1 }}>{reg}{cap ? <span style={{ fontSize: 16, color: C.muted }}>/{cap}</span> : null}</div>
                        <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.12em", textTransform: "uppercase", marginTop: 4 }}>{en ? "Signups" : "Registros"}</div>
                      </div>
                      <div>
                        <div style={{ ...S.display, fontSize: 30, color: C.red, lineHeight: 1 }}>{acts}</div>
                        <div style={{ fontSize: 10, color: C.muted, letterSpacing: "0.12em", textTransform: "uppercase", marginTop: 4 }}>{en ? "1st activations" : "1ª activaciones"}</div>
                      </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${C.border}`, paddingTop: 12 }}>
                      <span style={{ fontSize: 12, color: C.muted }}>{en ? "Conversion" : "Conversión"}: <b style={{ color: C.black }}>{convPct(s)}%</b></span>
                      <span style={{ fontSize: 12, color: C.muted }}>{en ? "Activations $" : "$ activaciones"}: <b style={{ color: C.black }}>{money(s.first_fees_cents)}</b></span>
                    </div>
                    {typeof s.signups_counter !== "undefined" && Number(s.signups_counter) !== reg && (
                      <div style={{ fontSize: 10, color: C.red, marginTop: 8 }}>
                        {en ? "counter" : "contador"} AccessCode = {s.signups_counter} ≠ {reg} ({en ? "data check" : "revisar datos"})
                      </div>
                    )}
                    <button onClick={() => copySummary(c)} style={{ ...S.btnPrimary, width: "100%", marginTop: 14, padding: "8px", fontSize: 12, background: copied === c.code ? "var(--exito)" : C.black }}>
                      {copied === c.code ? (en ? "Copied ✓" : "Copiado ✓") : (en ? "Copy summary" : "Copiar resumen")}
                    </button>
                  </>
                )}
              </div>
            );
          })}
        </div>
      )}
    </AdminLayout>
  );
}

// s220 · el panel del aliado (/aliados) vive en AliadoPanel.jsx, sobre get_my_influencer_panel +
// get_my_influencer_payouts. El InfluencerPanel de s113 (get_my_influencer_stats) se retiró.
function AdminCodes() {
  const lang = useLang();
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  // ETAPA-2 quick-win (s97): tier arranca en LITE — el caso más común de la operadora en venta viva
  // es un código LITE de prueba (1-2 cupones). Los VIP/influencer se generan en lote aparte.
  const [form, setForm] = useState({ code: "", tier: "LITE", notes: "", qty: 1, max_coupons: 2, vip_max_active: 5, duration_months: 12, is_multiuse: false, max_signups: "", label: "", enganche_code: "", plan_to_grant: "", grant_credits_override: "", expires_preset: "none", owner_user_id: "", commission_pct: "", hold_days: "15", audience: "member" });
  const [plans, setPlans] = useState([]); // s82: planes para gifting (plan_to_grant)
  const [msg, setMsg] = useState("");
  const [copied, setCopied] = useState(null);
  const [bulkMode, setBulkMode] = useState(false);
  const [bulkQty, setBulkQty] = useState(5);
  const [bulkPrefix, setBulkPrefix] = useState("MIAMI");
  const [bulkProgress, setBulkProgress] = useState(0);
  // ETAPA-2 (s99): rollup — quien creo cada codigo (operadoras), filtro y outcome editable.
  const [userMap, setUserMap] = useState({});
  const [creatorFilter, setCreatorFilter] = useState("all");
  const [savingOutcome, setSavingOutcome] = useState(null);
  const [aliados, setAliados] = useState([]);   // s220 · Users con rol Influencer, para el dueño del código

  const en = lang === "en";

  useEffect(() => { getAllAccessCodes().then(c => { setCodes(c); setLoading(false); }); getMembershipPlans({ activeOnly: false }).then(setPlans).catch(() => {}); getAllUsers().then(us => { setUserMap(Object.fromEntries(us.map(u => [u._id, u.name || u.email || (u._id || "").slice(0, 8)]))); setAliados(us.filter(u => u.role === "Influencer")); }).catch(() => {}); }, []);

  const generateCode = (tier) => {
    const prefix = tier === "VIP" ? "VIP" : tier === "NONE" ? "ALIADO" : "LITE";
    const num = String(Math.floor(Math.random() * 9000) + 1000);
    return `${prefix}${num}`;
  };

  const handleCreate = async () => {
    if (!form.code.trim()) { setMsg(en ? "Enter a code" : "Ingresa un código"); return; }
    // s220 · un multiuso sin cupo nace roto: apply_access_code lo rechaza con CODE_MISCONFIGURED (step 9).
    if (form.is_multiuse && !(Number(form.max_signups) > 0)) { setMsg(en ? "A multi-use code needs a signup cap" : "Un código multiuso necesita cupo (máx. registros)"); return; }
    if (form.tier === "NONE" && !form.is_multiuse) { setMsg(en ? "A no-tier code is a partner code: mark it multi-use" : "Un código sin tier es de aliado: márcalo como multiuso"); return; }
    setCreating(true);
    try {
      const sinTier = form.tier === "NONE";   // s220 · solo atribución y descuento: no manda cupones
      const mc = sinTier ? undefined : (Number(form.max_coupons) || 2);
      const vma = sinTier ? undefined : (Number(form.vip_max_active) || 5);
      const dm = form.tier === "VIP" ? (Number(form.duration_months) || 12) : undefined; // M-10: meses del VIP por código
      const expires_at = presetToExpiresAt(form.expires_preset); // ETAPA-2 (s99): urgencia-por-código
      const result = await createAccessCode({ code: form.code.trim().toUpperCase(), tier_to_assign: form.tier, notes: form.notes, max_coupons: mc, vip_max_active: vma, duration_months: dm, is_multiuse: form.is_multiuse, max_signups: form.is_multiuse ? (Number(form.max_signups) || undefined) : undefined, label: form.is_multiuse ? form.label : undefined, enganche_code: form.is_multiuse ? (normalizarCodigo(form.enganche_code) || undefined) : undefined, plan_to_grant: form.plan_to_grant || undefined, grant_credits_override: form.plan_to_grant ? (form.grant_credits_override || undefined) : undefined, expires_at, owner_user_id: form.is_multiuse ? (form.owner_user_id || undefined) : undefined, commission_pct: form.is_multiuse && form.owner_user_id ? form.commission_pct : undefined, hold_days: form.is_multiuse && form.owner_user_id ? form.hold_days : undefined, audience: form.audience });
      setCodes(prev => [{ code: form.code.toUpperCase(), tier_to_assign: form.tier, is_used: false, notes: form.notes, max_coupons: mc, vip_max_active: vma, is_multiuse: form.is_multiuse, max_signups: form.is_multiuse ? (Number(form.max_signups) || null) : null, signups_count: 0, label: form.is_multiuse ? form.label : "", outcome: "pending", expires_at: expires_at || null, "Created Date": new Date().toISOString(), _id: result?.access_code_id }, ...prev]);
      setMsg(`✅ ${en ? "Code created:" : "Código creado:"} ${form.code.toUpperCase()}`);
      setForm({ code: "", tier: "LITE", notes: "", qty: 1, max_coupons: 2, vip_max_active: 5, duration_months: 12, is_multiuse: false, max_signups: "", label: "", enganche_code: "", plan_to_grant: "", grant_credits_override: "", expires_preset: "none", owner_user_id: "", commission_pct: "", hold_days: "15", audience: "member" });
      setTimeout(() => setMsg(""), 4000);
    } catch(e) { setMsg(en ? "Error creating code" : "Error al crear código"); }
    finally { setCreating(false); }
  };

  const handleBulkCreate = async () => {
    setCreating(true); setBulkProgress(0);
    const prefix = bulkPrefix.toUpperCase();
    const created = [];
    for (let i = 1; i <= bulkQty; i++) {
      const code = `${prefix}${String(i).padStart(3, "0")}`;
      try {
        const result = await createAccessCode({ code, tier_to_assign: form.tier, notes: `Bulk: ${prefix} batch`, max_coupons: Number(form.max_coupons) || 2, vip_max_active: Number(form.vip_max_active) || 5, duration_months: form.tier === "VIP" ? (Number(form.duration_months) || 12) : undefined });
        created.push({ code, tier_to_assign: form.tier, is_used: false, notes: `Bulk: ${prefix} batch`, max_coupons: Number(form.max_coupons) || 2, vip_max_active: Number(form.vip_max_active) || 5, _id: result?.access_code_id });
        setBulkProgress(i);
      } catch(e) { /* skip duplicates */ }
    }
    setCodes(prev => [...created, ...prev]);
    setMsg(`✅ ${created.length}/${bulkQty} ${en ? "codes created" : "códigos creados"} (${prefix}001-${prefix}${String(bulkQty).padStart(3, "0")})`);
    setBulkMode(false); setBulkProgress(0);
    setCreating(false);
    setTimeout(() => setMsg(""), 6000);
  };

  const copyCode = (code) => {
    navigator.clipboard.writeText(code);
    setCopied(code);
    // ETAPA-2 quick-win (s97): confirmación visible arriba (además del ✓ del botón) —
    // en medio de un chat de venta la operadora necesita certeza de que copió el código nuevo.
    setMsg(`✅ ${en ? "Copied:" : "Copiado:"} ${code}`);
    setTimeout(() => { setCopied(null); setMsg(""); }, 2000);
  };

  const copyAllAvailable = () => {
    const available = codes.filter(c => !c.is_used).map(c => c.code).join("\n");
    navigator.clipboard.writeText(available);
    setMsg(`✅ ${en ? "All available codes copied!" : "¡Todos los códigos disponibles copiados!"}`);
    setTimeout(() => setMsg(""), 3000);
  };

  // ETAPA-2 (s99): el admin etiqueta el outcome de CUALQUIER codigo (set_outcome sin NOT_YOURS para Admin).
  const handleOutcome = async (c, outcome) => {
    const prev = c.outcome || "pending";
    if (outcome === prev) return;
    setSavingOutcome(c._id);
    setCodes(list => list.map(x => x._id === c._id ? { ...x, outcome } : x));
    try {
      await setOutcome(c._id, outcome);
    } catch (e) {
      setCodes(list => list.map(x => x._id === c._id ? { ...x, outcome: prev } : x));
      setMsg(en ? "❌ Couldn't save the outcome" : "❌ No se pudo guardar el resultado");
      setTimeout(() => setMsg(""), 4000);
    } finally { setSavingOutcome(null); }
  };

  const creators = [...new Set(codes.map(c => c["Created By"]).filter(Boolean))];
  const filteredCodes = creatorFilter === "all" ? codes : codes.filter(c => c["Created By"] === creatorFilter);

  const unused = codes.filter(c => !c.is_used);
  const used = codes.filter(c => c.is_used);

  const cols = [
    { label: en ? "Code" : "Código", width: "2fr", render: c => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ ...S.display, fontSize: 16, color: C.black, letterSpacing: "0.1em" }}>{c.code || "—"}</span>
        <button onClick={() => copyCode(c.code)} style={{ background: "none", border: `1px solid ${C.border}`, color: copied === c.code ? "var(--exito)" : C.muted, padding: "2px 8px", fontSize: 10, cursor: "pointer", borderRadius: 2 }}>
          {copied === c.code ? "✓" : en ? "Copy" : "Copiar"}
        </button>
      </div>
    )},
    { label: "Tier", width: "1fr", render: c => <AdminBadge label={c.tier_to_assign || "VIP"} /> },
    { label: en ? "Limit" : "Límite", width: "1fr", render: c => <span style={{ fontSize: 12, color: C.muted }}>{(c.tier_to_assign === "LITE" ? c.max_coupons : c.vip_max_active) ?? "—"}</span> },
    { label: en ? "Status" : "Estado", width: "1fr", render: c => <AdminBadge label={c.is_used ? (en ? "Used" : "Usado") : (en ? "Available" : "Disponible")} type={c.is_used ? "used" : "unused"} /> },
    { label: en ? "Outcome" : "Resultado", width: "1.3fr", render: c => (
      <select value={c.outcome || "pending"} disabled={savingOutcome === c._id} onChange={e => handleOutcome(c, e.target.value)} style={{ ...S.input, padding: "4px 6px", fontSize: 11, cursor: "pointer", opacity: savingOutcome === c._id ? 0.5 : 1 }}>
        {OUTCOME_OPTIONS.map(o => <option key={o} value={o}>{outcomeLabel(o, en)}</option>)}
      </select>
    )},
    { label: en ? "Created by" : "Creado por", width: "1.2fr", render: c => <span style={{ fontSize: 11, color: C.muted }}>{userMap[c["Created By"]] || "—"}</span> },
    { label: en ? "Expires" : "Vence", width: "0.9fr", render: c => <span style={{ fontSize: 11, color: (c.expires_at && new Date(c.expires_at) < new Date()) ? C.red : C.muted }}>{c.expires_at ? new Date(c.expires_at).toLocaleDateString() : "—"}</span> },
    { label: en ? "Notes" : "Notas", width: "2fr", render: c => <span style={{ fontSize: 12, color: C.muted }}>{c.notes || "—"}</span> },
    { label: "Influencer", width: "2fr", render: c => c.is_multiuse
        ? <span style={{ fontSize: 12, color: C.black }}>{c.label || "—"} · <b>{(c.signups_count ?? 0)}{c.max_signups ? `/${c.max_signups}` : ""}</b></span>
        : <span style={{ fontSize: 12, color: C.muted }}>—</span> },
  ];

  return (
    <AdminLayout active="codes">
      <div style={{ marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>
            {en ? "ACCESS CODES" : "CÓDIGOS DE ACCESO"}
          </div>
          <p style={{ fontSize: 13, color: C.muted }}>
            {unused.length} {en ? "available" : "disponibles"} · {used.length} {en ? "used" : "usados"}
          </p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={copyAllAvailable} style={{ background: C.light, border: `1px solid ${C.border}`, color: C.gray, padding: "6px 14px", fontSize: 11, cursor: "pointer", fontFamily: "'DM Sans', sans-serif", borderRadius: 2 }}>
            📋 {en ? "Copy All Available" : "Copiar Todos"}
          </button>
          <button onClick={() => setBulkMode(!bulkMode)} style={{ ...S.btnPrimary, padding: "6px 14px", fontSize: 11, background: bulkMode ? C.black : C.red }}>
            {bulkMode ? (en ? "Single Mode" : "Modo Individual") : (en ? "Bulk Create" : "Crear en Lote")}
          </button>
        </div>
      </div>

      {/* Create form */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}`, padding: "24px", marginBottom: 24 }}>
        {!bulkMode ? (
          <>
            <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 16 }}>
              {en ? "Generate New Code" : "Generar Nuevo Código"}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 2fr auto", gap: 12, alignItems: "end" }}>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "CODE" : "CÓDIGO"}</div>
                <div style={{ display: "flex", gap: 8 }}>
                  <input value={form.code} onChange={e => setForm(f => ({ ...f, code: e.target.value.toUpperCase() }))}
                    placeholder={en ? "TYPE OR TAP AUTO →" : "ESCRIBE O TOCA AUTO →"} style={{ ...S.input, fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, letterSpacing: "0.1em", flex: 1 }} />
                  <button onClick={() => setForm(f => ({ ...f, code: generateCode(f.tier) }))} style={{
                    background: C.light, border: `1px solid ${C.border}`, color: C.gray,
                    padding: "0 12px", fontSize: 11, cursor: "pointer", borderRadius: 0, whiteSpace: "nowrap"
                  }}>Auto</button>
                </div>
              </div>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>TIER</div>
                <select value={form.tier} onChange={e => { const t = e.target.value; setForm(f => ({ ...f, tier: t, ...(t === "NONE" ? { is_multiuse: true } : {}) })); }} style={{ ...S.input, cursor: "pointer" }}>
                  <option value="VIP">VIP</option>
                  <option value="LITE">LITE</option>
                  {/* s220 · el código del aliado: no da tier (create_access_code lo deja vacío con "NONE") */}
                  <option value="NONE">{en ? "No tier (partner)" : "Sin tier (aliado)"}</option>
                </select>
              </div>
              {form.tier !== "NONE" && (
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>
                  {form.tier === "LITE" ? (en ? "MAX COUPONS" : "MÁX CUPONES") : (en ? "VIP MAX ACTIVE" : "VIP MÁX ACTIVOS")}
                </div>
                <input type="number" min="1"
                  value={form.tier === "LITE" ? form.max_coupons : form.vip_max_active}
                  onChange={e => { const v = e.target.value; setForm(f => f.tier === "LITE" ? { ...f, max_coupons: v } : { ...f, vip_max_active: v }); }}
                  style={{ ...S.input }} />
              </div>
              )}
              {form.tier === "VIP" && (
                <div>
                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "VIP MONTHS" : "MESES VIP"}</div>
                  <input type="number" min="1"
                    value={form.duration_months}
                    onChange={e => setForm(f => ({ ...f, duration_months: e.target.value }))}
                    style={{ ...S.input }} />
                </div>
              )}
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "NOTES" : "NOTAS"}</div>
                <input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} placeholder={en ? "e.g. For client Juan" : "ej. Para cliente Juan"} style={{ ...S.input }} />
              </div>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "EXPIRES" : "VENCE"}</div>
                <select value={form.expires_preset} onChange={e => setForm(f => ({ ...f, expires_preset: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                  <option value="none">{en ? "No expiry" : "No vence"}</option>
                  <option value="24h">24h</option>
                  <option value="48h">48h</option>
                  <option value="7d">{en ? "7 days" : "7 días"}</option>
                </select>
              </div>
              {/* s220 · PARA QUIÉN (audience). apply_access_code rechaza en el registro de miembros un código
                  «merchant» (CODE_AUDIENCE_MISMATCH); signup_merchant solo le atribuye el comercio al aliado con
                  «merchant». Un aliado que trae miembros y comercios necesita un código de cada uno. */}
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "FOR" : "PARA"}</div>
                <select value={form.audience} onChange={e => setForm(f => ({ ...f, audience: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                  <option value="member">{en ? "Members" : "Miembros"}</option>
                  <option value="merchant">{en ? "Businesses" : "Comercios"}</option>
                </select>
              </div>
              <div style={{ paddingTop: 22 }}>
                <button onClick={handleCreate} disabled={creating} style={{ ...S.btnPrimary, padding: "10px 20px", opacity: creating ? 0.7 : 1, whiteSpace: "nowrap" }}>
                  {creating ? "..." : "+ " + (en ? "Create" : "Crear")}
                </button>
              </div>
            </div>

            {/* INF-3: código de influencer multiuso (cupo + label + atribución) */}
            <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px dashed ${C.border}` }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13, color: C.black, fontWeight: 600 }}>
                <input type="checkbox" checked={form.is_multiuse} onChange={e => setForm(f => ({ ...f, is_multiuse: e.target.checked }))} />
                {en ? "Influencer code (multi-use, with cap)" : "Código de influencer (multiuso, con cupo)"}
              </label>
              {form.is_multiuse && (
                <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr", gap: 12, marginTop: 12 }}>
                  <div>
                    <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "SIGNUP CAP *" : "CUPO (MÁX REGISTROS) *"}</div>
                    <input type="number" min="1" value={form.max_signups} onChange={e => setForm(f => ({ ...f, max_signups: e.target.value }))} placeholder="4000" style={{ ...S.input }} />
                  </div>
                  <div>
                    <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "LABEL (INFLUENCER)" : "ETIQUETA (INFLUENCER)"}</div>
                    <input value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))} placeholder={en ? "e.g. INFLUENCER001 — Juana" : "ej. INFLUENCER001 — Juana"} style={{ ...S.input }} />
                  </div>
                  {/* s220 · EL DUEÑO Y SUS TÉRMINOS. Los términos son por aliado, por contrato (Ali):
                      todos sus códigos llevan los mismos, y el panel muestra los del más reciente. */}
                  <div>
                    <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "OWNER (PARTNER)" : "DUEÑO (ALIADO)"}</div>
                    <select value={form.owner_user_id} onChange={e => setForm(f => ({ ...f, owner_user_id: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                      <option value="">{en ? "- No owner -" : "- Sin dueño -"}</option>
                      {aliados.map(u => <option key={u._id} value={u._id}>{u.name || u.email || u._id}</option>)}
                    </select>
                    {aliados.length === 0 && (
                      <div style={{ fontSize: 11, color: C.muted, marginTop: 6 }}>
                        {en ? "No partners yet: make the user a partner in Users first." : "Todavía no hay aliados: primero hazlo aliado en Usuarios."}
                      </div>
                    )}
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <div>
                      <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "COMMISSION %" : "COMISIÓN %"}</div>
                      <input type="number" min="0" max="100" disabled={!form.owner_user_id} value={form.commission_pct} onChange={e => setForm(f => ({ ...f, commission_pct: e.target.value }))} placeholder="20" style={{ ...S.input }} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "HOLD DAYS" : "DÍAS DE RETENCIÓN"}</div>
                      <input type="number" min="0" disabled={!form.owner_user_id} value={form.hold_days} onChange={e => setForm(f => ({ ...f, hold_days: e.target.value }))} placeholder="15" style={{ ...S.input }} />
                    </div>
                  </div>
                  {/* s186 · el ENGANCHE. El segundo objeto de la cadena: el codigo de
                      DESCUENTO de precio fijo que esta persona va a recibir cuando se
                      le acaben las activaciones gratis. La persona nunca lo escribe
                      — viaja colgado de este AccessCode. Se arma la campana de una
                      influencer entera desde aca, sin tocar la base. */}
                  <div style={{ gridColumn: "1 / -1" }}>
                    <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "ENGANCHE CODE (FIXED-PRICE DISCOUNT)" : "CÓDIGO DE ENGANCHE (DESCUENTO DE PRECIO FIJO)"}</div>
                    <input value={form.enganche_code} onChange={e => setForm(f => ({ ...f, enganche_code: e.target.value }))} placeholder={en ? "e.g. ENG-JUANA" : "ej. ENG-JUANA"} style={{ ...S.input }} />
                    <div style={{ fontSize: 11, color: C.muted, marginTop: 6, lineHeight: 1.5 }}>
                      {en
                        ? "Optional. Create it first in Discounts, as fixed_price + multi-use, scoped to the 6-month plan. Applying this access code hands it to the front, which only uses it at checkout."
                        : "Opcional. Créalo antes en Descuentos, como precio fijo + multiuso, amarrado al plan de 6 meses. Al aplicar este código de acceso se lo entrega al front, que lo usa solo en el checkout."}
                    </div>
                  </div>
                </div>
              )}
              <div style={{ fontSize: 11, color: C.muted, marginTop: 8 }}>
                {en ? "Multi-use codes are never marked 'used'; they count signups up to the cap." : "Los códigos multiuso nunca se marcan 'usado'; cuentan registros hasta el cupo."}
              </div>
            </div>
            {/* s82: Plan de regalo (gifting) - carga wallet al aplicar el codigo */}
            <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px dashed ${C.border}` }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 4 }}>
                🎁 {en ? "Gift plan (loads wallet)" : "Plan de regalo (carga wallet)"}
              </div>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 12 }}>
                {en ? "Optional. If set, applying this code grants the plan and full member access — no charge." : "Opcional. Si lo eliges, aplicar el código otorga el plan y el acceso completo de miembro — sin cobro."}
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "PLAN TO GRANT" : "PLAN A REGALAR"}</div>
                  <select value={form.plan_to_grant} onChange={e => setForm(f => ({ ...f, plan_to_grant: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                    <option value="">{en ? "- None (access only) -" : "- Ninguno (solo acceso) -"}</option>
                    {plans.map(p => { const id = p._id || p.id; return <option key={id} value={id}>{(p.label || `${p.duration_months || "?"}m`)}{(p.is_gift === true || p.is_gift === "yes") ? " · 🎁" : ""}</option>; })}
                  </select>
                </div>
                <div>
                  <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "PLAN OVERRIDE" : "AJUSTE DE PLAN (OVERRIDE)"}</div>
                  <input type="number" min="0" value={form.grant_credits_override} disabled={!form.plan_to_grant} onChange={e => setForm(f => ({ ...f, grant_credits_override: e.target.value }))} placeholder={en ? "plan default" : "default del plan"} style={{ ...S.input, opacity: form.plan_to_grant ? 1 : 0.5 }} />
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 16 }}>
              🚀 {en ? "Bulk Create Codes" : "Crear Códigos en Lote"}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr auto", gap: 12, alignItems: "end" }}>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "PREFIX" : "PREFIJO"}</div>
                <input value={bulkPrefix} onChange={e => setBulkPrefix(e.target.value.toUpperCase())} placeholder="MIAMI" style={{ ...S.input, fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, letterSpacing: "0.1em" }} />
              </div>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "QUANTITY" : "CANTIDAD"}</div>
                <select value={bulkQty} onChange={e => setBulkQty(Number(e.target.value))} style={{ ...S.input, cursor: "pointer" }}>
                  {[3, 5, 10, 15, 20, 25, 50].map(n => <option key={n} value={n}>{n} {en ? "codes" : "códigos"}</option>)}
                </select>
              </div>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>TIER</div>
                <select value={form.tier} onChange={e => setForm(f => ({ ...f, tier: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
                  <option value="VIP">VIP</option>
                  <option value="LITE">LITE</option>
                </select>
              </div>
              <div>
                <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>
                  {form.tier === "LITE" ? (en ? "MAX COUPONS" : "MÁX CUPONES") : (en ? "VIP MAX ACTIVE" : "VIP MÁX ACTIVOS")}
                </div>
                <input type="number" min="1"
                  value={form.tier === "LITE" ? form.max_coupons : form.vip_max_active}
                  onChange={e => { const v = e.target.value; setForm(f => f.tier === "LITE" ? { ...f, max_coupons: v } : { ...f, vip_max_active: v }); }}
                  style={{ ...S.input }} />
              </div>
              <div style={{ paddingTop: 22 }}>
                <button onClick={handleBulkCreate} disabled={creating} style={{ ...S.btnPrimary, padding: "10px 20px", opacity: creating ? 0.7 : 1, whiteSpace: "nowrap" }}>
                  {creating ? `${bulkProgress}/${bulkQty}...` : `🚀 ${en ? "Create" : "Crear"} ${bulkQty}`}
                </button>
              </div>
            </div>
            <div style={{ fontSize: 11, color: C.muted, marginTop: 8 }}>
              {en ? "Will create:" : "Creará:"} {bulkPrefix}001 → {bulkPrefix}{String(bulkQty).padStart(3, "0")} ({form.tier})
            </div>
          </>
        )}
        {msg && <div style={{ marginTop: 12, fontSize: 13, color: msg.includes("✅") ? "var(--exito)" : C.red }}>{msg}</div>}
      </div>

      {/* ETAPA-2 (s99): rollup — filtro por creador (operadoras) */}
      {creators.length > 1 && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, margin: "16px 0 8px" }}>
          <span style={{ fontSize: 10, color: C.muted, letterSpacing: "0.1em" }}>{en ? "CREATED BY" : "CREADO POR"}</span>
          <select value={creatorFilter} onChange={e => setCreatorFilter(e.target.value)} style={{ ...S.input, width: "auto", padding: "6px 10px", fontSize: 12, cursor: "pointer" }}>
            <option value="all">{en ? "Everyone" : "Todos"}</option>
            {creators.map(id => <option key={id} value={id}>{userMap[id] || id.slice(0, 8)}</option>)}
          </select>
          <span style={{ fontSize: 11, color: C.muted }}>{filteredCodes.length} {en ? "codes" : "códigos"}</span>
        </div>
      )}
      <AdminTable columns={cols} rows={filteredCodes} loading={loading} />
    </AdminLayout>
  );
}

// ============================================
// ADMIN: DISCOUNT CODES (motor de descuentos de membresía · s73)
// ============================================
function AdminDiscounts() {
  const lang = useLang();
  const en = lang === "en";
  const [codes, setCodes] = useState([]);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [busyId, setBusyId] = useState(null);
  const [msg, setMsg] = useState("");
  const [copied, setCopied] = useState(null);

  const todayPlus = (days) => { const d = new Date(); d.setDate(d.getDate() + days); return d.toISOString().slice(0, 10); };
  const [form, setForm] = useState({
    code: "", mode: "fixed_price", discount_percent: 20, fixed_price: 199,
    expires: todayPlus(3), no_expiry: false, audience: "both", campaign: "", scope: [],
    is_multiuse: false, max_redemptions: "",
  });

  const load = () => {
    setLoading(true);
    Promise.all([getDiscountCodes(), getMembershipPlans({ activeOnly: false })])
      .then(([c, pl]) => { setCodes(Array.isArray(c) ? c : []); setPlans(pl || []); })
      .catch(() => setMsg(en ? "Could not load codes" : "No se pudieron cargar los códigos"))
      .finally(() => setLoading(false));
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  const pid = (x) => (typeof x === "string" ? x : (x && (x._id || x.id))) || "";
  const rowId = (c) => c._id || c.discount_code_id || c.id || "";
  const planLabel = (id) => { const pl = plans.find((x) => (x._id || x.id) === id); return pl ? (pl.label || `${pl.duration_months || "?"}m`) : id; };
  const scopeLabels = (c) => {
    const sc = c.plan_scope || c.plan_scope_list || [];
    if (!Array.isArray(sc) || sc.length === 0) return en ? "All plans" : "Todos";
    return sc.map((x) => planLabel(pid(x))).join(", ");
  };
  const isActive = (c) => c.active === true || c.active === "yes";
  const isUsed = (c) => c.is_used === true || c.is_used === "yes";
  const fmtDate = (v) => { if (v == null || v === "") return "—"; const d = new Date(typeof v === "number" ? v : v); return isNaN(d.getTime()) ? "—" : d.toLocaleDateString(); };
  const generateCode = () => `PROMO${String(Math.floor(Math.random() * 9000) + 1000)}`;
  const copyCode = (code) => { navigator.clipboard.writeText(code); setCopied(code); setTimeout(() => setCopied(null), 2000); };

  const toggleScope = (id) => setForm((f) => ({ ...f, scope: f.scope.includes(id) ? f.scope.filter((x) => x !== id) : [...f.scope, id] }));

  const handleCreate = async () => {
    if (!form.code.trim()) { setMsg(en ? "Enter a code" : "Ingresa un código"); return; }
    if (form.mode === "percent" && !(Number(form.discount_percent) > 0)) { setMsg(en ? "Enter a valid %" : "Ingresa un % válido"); return; }
    if (form.mode === "fixed_price" && !(Number(form.fixed_price) > 0)) { setMsg(en ? "Enter a valid price" : "Ingresa un precio válido"); return; }
    if (!form.no_expiry && !form.expires) { setMsg(en ? "Pick an expiry date" : "Elige fecha de vencimiento"); return; }
    setCreating(true);
    try {
      // expires_at = epoch ms (fin del día elegido). Bubble date param via API.
      const expires_at = form.no_expiry ? undefined : new Date(`${form.expires}T23:59:59`).getTime();
      await createDiscountCode({
        code: form.code.trim().toUpperCase(),
        discount_mode: form.mode,
        discount_percent: form.mode === "percent" ? Number(form.discount_percent) : 0,
        fixed_price: form.mode === "fixed_price" ? Number(form.fixed_price) : undefined,
        expires_at,
        no_expiry: form.no_expiry,
        audience: form.audience,
        campaign: form.campaign,
        plan_scope: form.scope, // [] = global
        is_multiuse: form.is_multiuse,
        // s188 - el tope SOLO tiene sentido en un codigo multiuso: el Step 17 de
        // validate_discount_code exige `is_multiuse is TRUE` antes de comparar. En un
        // codigo de un solo uso se manda vacio a proposito.
        max_redemptions: form.is_multiuse ? form.max_redemptions : "",
      });
      setMsg(`✅ ${en ? "Code created:" : "Código creado:"} ${form.code.toUpperCase()}`);
      setForm((f) => ({ ...f, code: "", campaign: "", scope: [], is_multiuse: false, max_redemptions: "" }));
      load(); // refrescar del server para tener el _id real (deactivate lo necesita)
      setTimeout(() => setMsg(""), 4000);
    } catch (e) {
      setMsg(`${en ? "Error:" : "Error:"} ${e.code || e.message || "create failed"}`);
    } finally { setCreating(false); }
  };

  const handleDeactivate = async (c) => {
    const id = rowId(c);
    if (!id) { setMsg(en ? "Row has no id (check get_discount_codes return)" : "La fila no tiene id (revisar el Return de get_discount_codes)"); return; }
    if (!window.confirm(en ? `Deactivate ${c.code}?` : `¿Desactivar ${c.code}?`)) return;
    setBusyId(id);
    try {
      await deactivateDiscountCode(id);
      setCodes((prev) => prev.map((x) => (rowId(x) === id ? { ...x, active: false } : x)));
      setMsg(`✅ ${c.code} ${en ? "deactivated" : "desactivado"}`);
      setTimeout(() => setMsg(""), 3000);
    } catch (e) { setMsg(`${en ? "Error:" : "Error:"} ${e.code || e.message}`); }
    finally { setBusyId(null); }
  };

  const activeCodes = codes.filter((c) => isActive(c) && !isUsed(c));
  const inactiveCodes = codes.filter((c) => !isActive(c) || isUsed(c));

  const cols = [
    { label: en ? "Code" : "Código", width: "2fr", render: (c) => (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ ...S.display, fontSize: 16, color: C.black, letterSpacing: "0.1em" }}>{c.code || "—"}</span>
        <button onClick={() => copyCode(c.code)} style={{ background: "none", border: `1px solid ${C.border}`, color: copied === c.code ? "var(--exito)" : C.muted, padding: "2px 8px", fontSize: 10, cursor: "pointer", borderRadius: 2 }}>
          {copied === c.code ? "✓" : en ? "Copy" : "Copiar"}
        </button>
      </div>
    ) },
    { label: en ? "Type" : "Tipo", width: "1fr", render: (c) => {
      const mode = c.discount_mode || (Number(c.fixed_price) > 0 ? "fixed_price" : "percent");
      return <AdminBadge label={mode === "fixed_price" ? (en ? "Fixed" : "Precio") : "%"} />;
    } },
    { label: en ? "Value" : "Valor", width: "1fr", render: (c) => {
      const mode = c.discount_mode || (Number(c.fixed_price) > 0 ? "fixed_price" : "percent");
      return <span style={{ fontSize: 13, color: C.black, fontWeight: 600 }}>{mode === "fixed_price" ? `$${c.fixed_price ?? "—"}` : `${c.discount_percent ?? "—"}%`}</span>;
    } },
    { label: en ? "Scope" : "Alcance", width: "1.5fr", render: (c) => <span style={{ fontSize: 12, color: C.muted }}>{scopeLabels(c)}</span> },
    // s186 · un código multiuso y uno normal se veían IGUAL en esta tabla, y son
    // cosas distintas: uno muere en el primer canje y el otro no. La cuenta de
    // canjes es la única señal de que el multiuso está funcionando de verdad.
    // s188 - con el tope ya cargable desde el formulario, el ♾︎ pasaba a ser mentira
    // en los codigos que SI tienen cupo. Se muestra "usados / tope" cuando hay tope y
    // se deja el infinito solo para los que de verdad no lo tienen.
    { label: en ? "Uses" : "Canjes", width: "1fr", render: (c) => {
      if (!(c.is_multiuse === true || c.is_multiuse === "yes")) return <span style={{ fontSize: 12, color: C.muted }}>—</span>;
      const tope = Number(c.max_redemptions) > 0 ? Number(c.max_redemptions) : null;
      const usados = Number(c.redemptions_count) || 0;
      return tope
        ? <span style={{ fontSize: 12, color: usados >= tope ? "var(--aviso-tinta)" : C.black }}><b>{usados}</b> / {tope}</span>
        : <span style={{ fontSize: 12, color: C.black }}>♾︎ <b>{usados}</b></span>;
    } },
    { label: en ? "Expires" : "Vence", width: "1fr", render: (c) => <span style={{ fontSize: 12, color: C.muted }}>{(c.no_expiry === true || c.no_expiry === "yes") ? (en ? "Never" : "No vence") : fmtDate(c.expires_at)}</span> },
    { label: en ? "Status" : "Estado", width: "1fr", render: (c) => (
      isUsed(c) ? <AdminBadge label={en ? "Used" : "Usado"} type="used" />
        : isActive(c) ? <AdminBadge label={en ? "Active" : "Activo"} type="unused" />
        : <AdminBadge label={en ? "Inactive" : "Inactivo"} type="used" />
    ) },
    { label: "", width: "1fr", render: (c) => (
      isActive(c) && !isUsed(c)
        ? <button onClick={() => handleDeactivate(c)} disabled={busyId === rowId(c)} style={{ background: C.white, border: `1px solid ${C.red}`, color: C.red, padding: "4px 10px", fontSize: 10, cursor: "pointer", borderRadius: 2, opacity: busyId === rowId(c) ? 0.6 : 1 }}>
            {busyId === rowId(c) ? "..." : (en ? "Deactivate" : "Desactivar")}
          </button>
        : <span style={{ fontSize: 11, color: C.muted }}>—</span>
    ) },
  ];

  return (
    <AdminLayout active="discounts">
      <div style={{ marginBottom: 24 }}>
        <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>
          {en ? "DISCOUNT CODES" : "CÓDIGOS DE DESCUENTO"}
        </div>
        <p style={{ fontSize: 13, color: C.muted }}>
          {activeCodes.length} {en ? "active" : "activos"} · {inactiveCodes.length} {en ? "inactive/used" : "inactivos/usados"} · {en ? "membership discounts" : "descuentos de membresía"}
        </p>
      </div>

      {/* Create form */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}`, padding: "24px", marginBottom: 24 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 16 }}>
          {en ? "Generate New Discount Code" : "Generar Nuevo Código de Descuento"}
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "2fr 1.2fr 1.2fr 1.4fr auto", gap: 12, alignItems: "end" }}>
          <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "CODE" : "CÓDIGO"}</div>
            <div style={{ display: "flex", gap: 8 }}>
              <input value={form.code} onChange={(e) => setForm((f) => ({ ...f, code: e.target.value.toUpperCase() }))}
                placeholder="PROMO2026" style={{ ...S.input, fontFamily: "'Bebas Neue', sans-serif", fontSize: 16, letterSpacing: "0.1em", flex: 1 }} />
              <button onClick={() => setForm((f) => ({ ...f, code: generateCode() }))} style={{ background: C.light, border: `1px solid ${C.border}`, color: C.gray, padding: "0 12px", fontSize: 11, cursor: "pointer", borderRadius: 0, whiteSpace: "nowrap" }}>Auto</button>
            </div>
          </div>
          <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "MODE" : "MODO"}</div>
            <select value={form.mode} onChange={(e) => setForm((f) => ({ ...f, mode: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
              <option value="fixed_price">{en ? "Fixed price" : "Precio fijo"}</option>
              <option value="percent">{en ? "% off" : "% descuento"}</option>
            </select>
          </div>
          <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{form.mode === "fixed_price" ? (en ? "FINAL PRICE ($)" : "PRECIO FINAL ($)") : (en ? "PERCENT (%)" : "PORCENTAJE (%)")}</div>
            {form.mode === "fixed_price"
              ? <input type="number" min="1" value={form.fixed_price} onChange={(e) => setForm((f) => ({ ...f, fixed_price: e.target.value }))} style={{ ...S.input }} />
              : <input type="number" min="1" max="100" value={form.discount_percent} onChange={(e) => setForm((f) => ({ ...f, discount_percent: e.target.value }))} style={{ ...S.input }} />}
          </div>
          <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "EXPIRES" : "VENCE"}</div>
            <input type="date" value={form.expires} disabled={form.no_expiry} onChange={(e) => setForm((f) => ({ ...f, expires: e.target.value }))} style={{ ...S.input, opacity: form.no_expiry ? 0.5 : 1 }} />
          </div>
          <div style={{ paddingTop: 22 }}>
            <button onClick={handleCreate} disabled={creating} style={{ ...S.btnPrimary, padding: "10px 20px", opacity: creating ? 0.7 : 1, whiteSpace: "nowrap" }}>
              {creating ? "..." : "+ " + (en ? "Create" : "Crear")}
            </button>
          </div>
        </div>

        {/* Fila 2: audiencia, no-vence, campaña */}
        <div style={{ display: "grid", gridTemplateColumns: "1.2fr auto 2fr", gap: 12, alignItems: "end", marginTop: 14 }}>
          <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "AUDIENCE" : "AUDIENCIA"}</div>
            <select value={form.audience} onChange={(e) => setForm((f) => ({ ...f, audience: e.target.value }))} style={{ ...S.input, cursor: "pointer" }}>
              <option value="both">{en ? "Both" : "Ambas"}</option>
              <option value="new">{en ? "New" : "Nueva"}</option>
              <option value="renewal">{en ? "Renewal" : "Renovación"}</option>
            </select>
          </div>
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 12, color: C.black, paddingBottom: 10 }}>
            <input type="checkbox" checked={form.no_expiry} onChange={(e) => setForm((f) => ({ ...f, no_expiry: e.target.checked }))} />
            {en ? "No expiry" : "No vence"}
          </label>
          <div>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>{en ? "CAMPAIGN (optional)" : "CAMPAÑA (opcional)"}</div>
            <input value={form.campaign} onChange={(e) => setForm((f) => ({ ...f, campaign: e.target.value }))} placeholder={en ? "e.g. phone-sale-oct" : "ej. venta-telefonica-oct"} style={{ ...S.input }} />
          </div>
        </div>

        {/* s186 · MULTIUSO. La bandera que destraba el canal influencer: sin ella el
            código se quema en el primer canje (`is_used = true`) y la segunda persona
            que lo aplica ya no encuentra la rama de precio fijo. Va en su propia fila
            porque no es un detalle del código: cambia quién lo puede usar. */}
        <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px dashed ${C.border}` }}>
          <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 13, color: C.black, fontWeight: 600 }}>
            <input type="checkbox" checked={form.is_multiuse} onChange={(e) => setForm((f) => ({ ...f, is_multiuse: e.target.checked }))} />
            {en ? "Multi-use (influencer / enganche code)" : "Multiuso (código de influencer / enganche)"}
          </label>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 8, lineHeight: 1.5 }}>
            {en
              ? "Off: the code burns on the first redemption — the normal one-off promo. On: it survives and counts redemptions, so a whole influencer wave shares one code. For the enganche, pair it with fixed price + the 6-month plan in Scope."
              : "Apagado: el código se quema en el primer canje — la promo suelta de siempre. Encendido: sobrevive y cuenta canjes, así una ola entera de una influencer comparte un solo código. Para el enganche, combinarlo con precio fijo + el plan de 6 meses en Alcance."}
          </div>
          {/* s188 - ticket `panel-descuentos-sin-input-de-cupo`. `create_discount_code`
              declara `max_redemptions` como param #6 y `api.js` lo manda cuando trae
              valor, pero el formulario nunca lo pedía: 11 de los 12 códigos de Live lo
              tienen vacío. Sin ese número el guard de tope que se deployó el 03/09 no
              tiene contra qué comparar.
              Va DENTRO del bloque multiuso porque el Step 17 de `validate_discount_code`
              exige `is_multiuse is TRUE` antes de mirar el tope: en un código de un solo
              uso el campo no significa nada. */}
          {form.is_multiuse && (
            <div style={{ marginTop: 14 }}>
              <div style={{ fontSize: 11, color: C.muted, marginBottom: 6, letterSpacing: "0.1em" }}>
                {en ? "REDEMPTION CAP (optional)" : "TOPE DE CANJES (opcional)"}
              </div>
              <input type="number" min="1" inputMode="numeric"
                value={form.max_redemptions}
                onChange={(e) => setForm((f) => ({ ...f, max_redemptions: e.target.value }))}
                placeholder={en ? "no cap" : "sin tope"}
                style={{ ...S.input, width: 160 }} />
              <div style={{ fontSize: 11, color: C.muted, marginTop: 8, lineHeight: 1.5 }}>
                {en
                  ? "Empty = no cap. The guard only fires with a number greater than zero, so leaving it blank behaves exactly like before."
                  : "Vacío = sin tope. El guard solo dispara con un número mayor que cero, así que dejarlo en blanco se comporta igual que siempre."}
              </div>
              {form.mode === "percent" && (
                <div style={{ fontSize: 11, color: "var(--aviso-tinta)", marginTop: 6, lineHeight: 1.5 }}>
                  {en
                    ? "⚠️ On a % code the cap does NOT stop anything yet: the counter only goes up on the fixed-price route. Ticket `el-tope-no-cuenta-en-la-ruta-de-membresia` (a Bubble step, not React)."
                    : "⚠️ En un código % el tope todavía NO frena nada: el contador solo sube por la ruta de precio fijo. Ticket `el-tope-no-cuenta-en-la-ruta-de-membresia` (es un step de Bubble, no React)."}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Scope de planes (vacío = todos) */}
        <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px dashed ${C.border}` }}>
          <div style={{ fontSize: 11, color: C.muted, marginBottom: 8, letterSpacing: "0.1em" }}>
            {en ? "PLAN SCOPE (none selected = all plans / global)" : "ALCANCE DE PLANES (ninguno = todos / global)"}
          </div>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {plans.length === 0 && <span style={{ fontSize: 12, color: C.muted }}>{en ? "No plans loaded." : "Sin planes cargados."}</span>}
            {plans.map((pl) => {
              const id = pl._id || pl.id;
              const on = form.scope.includes(id);
              return (
                <button key={id} onClick={() => toggleScope(id)} style={{
                  background: on ? C.black : C.white, color: on ? C.white : C.gray,
                  border: `1px solid ${on ? C.black : C.border}`, padding: "6px 12px",
                  fontSize: 12, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif",
                }}>
                  {pl.label || `${pl.duration_months || "?"}m`}{pl.price_usd ? ` · $${pl.price_usd}` : ""}
                </button>
              );
            })}
          </div>
        </div>

        {msg && <div style={{ marginTop: 12, fontSize: 13, color: msg.includes("✅") ? "var(--exito)" : C.red }}>{msg}</div>}
      </div>

      <AdminTable columns={cols} rows={codes} loading={loading} />
    </AdminLayout>
  );
}

// ============================================
// ADMIN: COUPONS
// ============================================
function AdminCoupons() {
  const lang = useLang();
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");

  useEffect(() => { getAllCoupons().then(c => { setCoupons(c); setLoading(false); }); }, []);

  const filtered = coupons.filter(c => {
    if (filter === "all") return true;
    const s = (c.status || "").toLowerCase();
    return s === filter.toLowerCase();
  });

  const cols = [
    { label: lang === "en" ? "Code" : "Código", width: "1.5fr", render: c => (
      <span style={{ ...S.display, fontSize: 14, color: C.black, letterSpacing: "0.1em" }}>{c.code || "—"}</span>
    )},
    { label: lang === "en" ? "User" : "Usuario", width: "1.5fr", render: c => {
      const uid = c.end_user || "";
      return <span style={{ fontSize: 11, color: C.gray, fontFamily: "monospace" }} title={uid}>{uid ? uid.slice(0, 12) + "..." : "—"}</span>;
    }},
    { label: lang === "en" ? "Merchant" : "Negocio", width: "1.5fr", render: c => {
      const mid = c.merchant || "";
      return <span style={{ fontSize: 11, color: C.gray, fontFamily: "monospace" }} title={mid}>{mid ? mid.slice(0, 12) + "..." : "—"}</span>;
    }},
    { label: "Status", width: "1fr", render: c => <AdminBadge label={c.status || "active"} type={(c.status || "active").toLowerCase()} /> },
    { label: lang === "en" ? "Activated" : "Activado", width: "1fr", render: c => <span style={{ fontSize: 11, color: C.muted }}>{c.activated_at ? new Date(c.activated_at).toLocaleDateString() : "—"}</span> },
    { label: lang === "en" ? "Redeemed" : "Redimido", width: "1fr", render: c => <span style={{ fontSize: 11, color: C.muted }}>{c.redeemed_at ? new Date(c.redeemed_at).toLocaleDateString() : "—"}</span> },
  ];

  const filters = ["all", "Active", "Redeemed", "Expired"];

  return (
    <AdminLayout active="coupons">
      <div style={{ marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "flex-end", flexWrap: "wrap", gap: 16 }}>
        <div>
          <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>
            {lang === "en" ? "COUPONS" : "CUPONES"}
          </div>
          <p style={{ fontSize: 13, color: C.muted }}>{coupons.length} {lang === "en" ? "total coupons" : "cupones totales"}</p>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {filters.map(f => (
            <button key={f} onClick={() => setFilter(f)} style={{
              background: filter === f ? C.black : C.white,
              color: filter === f ? C.white : C.gray,
              border: `1px solid ${filter === f ? C.black : C.border}`,
              padding: "6px 14px", fontSize: 11, letterSpacing: "0.08em",
              cursor: "pointer", fontFamily: "'DM Sans', sans-serif", borderRadius: 2,
            }}>
              {f === "all" ? (lang === "en" ? "All" : "Todos") : f}
            </button>
          ))}
        </div>
      </div>
      <AdminTable columns={cols} rows={filtered} loading={loading} />
    </AdminLayout>
  );
}

// ============================================
// ADMIN: TOOLS (Export, Email Blast, Staff)
// ============================================
function AdminTools() {
  const lang = useLang();
  const [users, setUsers] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [offers, setOffers] = useState([]);
  const [codes, setCodes] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [msg, setMsg] = useState("");
  // Email blast
  const [selectedOffers, setSelectedOffers] = useState([]);
  const [emailList, setEmailList] = useState("");
  const [emailSubject, setEmailSubject] = useState("");
  const [sending, setSending] = useState(false);

  const en = lang === "en";

  useEffect(() => {
    Promise.all([
      getAllUsers().then(setUsers),
      getAllMerchants().then(setMerchants),
      getAllCoupons().then(setCoupons),
      getAllOffers().then(setOffers),
      getAllAccessCodes().then(setCodes),
    ]).then(() => setLoadingData(false));
  }, []);

  // ---- EXPORT CSV ----
  const exportCSV = (data, filename, columns) => {
    const header = columns.map(c => c.label).join(",");
    const rows = data.map(row => columns.map(c => {
      let val = c.key ? row[c.key] : (c.render ? c.render(row) : "");
      val = String(val ?? "").replace(/,/g, ";").replace(/\n/g, " ");
      return `"${val}"`;
    }).join(","));
    const csv = [header, ...rows].join("\n");
    const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `${filename}_${new Date().toISOString().slice(0, 10)}.csv`;
    a.click(); URL.revokeObjectURL(url);
    setMsg(`✅ ${en ? "Exported" : "Exportado"}: ${filename}.csv (${data.length} ${en ? "rows" : "filas"})`);
    setTimeout(() => setMsg(""), 4000);
  };

  const exportUsers = () => exportCSV(users, "nxt_users", [
    { label: "Name", key: "name" }, { label: "Email", key: "email" },
    { label: "Tier", key: "tier" }, { label: "Role", key: "role" },
    { label: "Coupons Used", key: "lite_activations_used" },
    { label: "Blocked", render: u => u.is_blocked ? "Yes" : "No" },
    { label: "ID", key: "_id" },
  ]);

  const exportMerchants = () => exportCSV(merchants, "nxt_merchants", [
    { label: "Business", key: "business_name" }, { label: "Category", key: "category" },
    { label: "Email", key: "email" }, { label: "Phone", key: "phone" },
    { label: "Address", key: "address" }, { label: "Rating", key: "rating" },
    { label: "Reviews", key: "total_reviews" }, { label: "Status", key: "status" },
    // s192 — ESTA COLUMNA DABA "No" PARA TODOS, y es el mismo bug que s186 arregló en el
    // contador de /admin/merchants sin llegar hasta acá. `MerchantPartner` tiene dos
    // booleanos parecidos: `is_founding` (el real, lo escribe approve_merchant) e
    // `is_founding_partner` (existe en el esquema y NINGÚN workflow lo escribe). Los WF
    // get_merchant_profile / get_merchant_stats exponen el alias leyendo de
    // `is_founding_boolean`, pero esta pantalla NO pasa por un WF: `exportMerchants` recorre
    // las filas crudas de la Data API (`getAllMerchants` → /obj/merchantpartner), donde el
    // alias no existe y el campo homónimo está muerto. Mismo predicado que AdminMerchants.
    { label: "Founding", render: m => (m?.is_founding === true || m?.is_founding_partner === true) ? "Yes" : "No" },
  ]);

  const exportCoupons = () => exportCSV(coupons, "nxt_coupons", [
    { label: "Code", key: "code" }, { label: "Status", key: "status" },
    { label: "User", key: "end_user" }, { label: "Merchant", key: "merchant" },
    { label: "Activated", key: "activated_at" }, { label: "Redeemed", key: "redeemed_at" },
    { label: "Expires", key: "expires_at" },
  ]);

  const exportCodes = () => exportCSV(codes, "nxt_access_codes", [
    { label: "Code", key: "code" }, { label: "Tier", key: "tier_to_assign" },
    { label: "Used", render: c => c.is_used ? "Yes" : "No" },
    { label: "Notes", key: "notes" },
  ]);

  const exportOffers = () => exportCSV(offers, "nxt_offers", [
    { label: "Title", key: "title_es" }, { label: "Merchant", key: "merchant_name" },
    { label: "Category", key: "category" }, { label: "Type", key: "offer_type" },
    { label: "Value", key: "benefit_value_usd" }, { label: "Status", key: "status" },
    { label: "Regular Price", key: "regular_price" }, { label: "Coupon Price", key: "coupon_price" },
  ]);

  // ---- EMAIL BLAST ----
  const toggleOffer = (offerId) => {
    setSelectedOffers(prev => prev.includes(offerId) ? prev.filter(id => id !== offerId) : [...prev, offerId]);
  };

  const handleEmailBlast = () => {
    if (selectedOffers.length === 0) { setMsg(en ? "Select at least one offer" : "Selecciona al menos una oferta"); return; }
    const emails = emailList.split(/[,\n]/).map(e => e.trim()).filter(Boolean);
    if (emails.length === 0) { setMsg(en ? "Enter at least one email" : "Ingresa al menos un email"); return; }
    const selectedOfferData = offers.filter(o => selectedOffers.includes(o._id));
    const offerNames = selectedOfferData.map(o => o.title_es).join(", ");
    const subject = emailSubject || `🔴 NXT Reserve — ${en ? "New benefits for you" : "Nuevos beneficios para ti"}`;
    const body = `${en ? "Hi! Check out these exclusive NXT Reserve benefits" : "¡Hola! Mira estos beneficios exclusivos de NXT Reserve"}:\n\n${selectedOfferData.map(o => `• ${o.title_es} — ${textoValorOferta(o, en) || "?"} (${o.merchant_name || ""})`).join("\n")}\n\n${en ? "Activate yours at" : "Activa el tuyo en"}: https://app.nxtreserve.com`;
    const mailtoLink = `mailto:${emails[0]}?bcc=${emails.slice(1).join(",")}&subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.open(mailtoLink, "_blank");
    setMsg(`✅ ${en ? "Email draft opened for" : "Borrador de email abierto para"} ${emails.length} ${en ? "recipients" : "destinatarios"} · ${selectedOffers.length} ${en ? "offers" : "ofertas"}`);
    setTimeout(() => setMsg(""), 5000);
  };

  return (
    <AdminLayout active="tools">
      <div style={{ marginBottom: 28 }}>
        <div style={{ ...S.display, fontSize: 32, color: C.black, marginBottom: 4 }}>
          {en ? "ADMIN TOOLS" : "HERRAMIENTAS"}
        </div>
        <p style={{ fontSize: 13, color: C.muted }}>{en ? "Export data, send promotions, manage staff" : "Exportar datos, enviar promociones, gestionar staff"}</p>
      </div>

      {msg && <div style={{ background: msg.includes("✅") ? "var(--exito-tinte)" : "var(--accion-tinte)", border: `1px solid ${msg.includes("✅") ? "var(--exito)" : C.red}`, padding: "10px 16px", marginBottom: 16, fontSize: 13, color: msg.includes("✅") ? "var(--exito)" : C.red }}>{msg}</div>}

      {/* ---- SECTION 1: EXPORT CSV ---- */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.black}`, marginBottom: 24 }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${C.border}` }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: C.black }}>📊 {en ? "Export Data (CSV)" : "Exportar Datos (CSV)"}</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>{en ? "Download data as spreadsheets" : "Descarga datos como hojas de cálculo"}</div>
        </div>
        <div style={{ padding: "16px 20px", display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 10 }}>
          {[
            { label: en ? "Users" : "Usuarios", count: users.length, icon: "👥", fn: exportUsers },
            { label: "Merchants", count: merchants.length, icon: "🏪", fn: exportMerchants },
            { label: en ? "Offers" : "Ofertas", count: offers.length, icon: "🎟️", fn: exportOffers },
            { label: en ? "Coupons" : "Cupones", count: coupons.length, icon: "🔖", fn: exportCoupons },
            { label: en ? "Access Codes" : "Códigos", count: codes.length, icon: "🔑", fn: exportCodes },
          ].map((item, i) => (
            <button key={i} onClick={item.fn} disabled={loadingData} style={{
              background: C.light, border: `1px solid ${C.border}`, borderRadius: 6, padding: "16px 12px",
              cursor: loadingData ? "wait" : "pointer", textAlign: "center", fontFamily: "'DM Sans', sans-serif",
            }}>
              <div style={{ fontSize: 24, marginBottom: 4 }}>{item.icon}</div>
              <div style={{ fontSize: 12, fontWeight: 600, color: C.black }}>{item.label}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: C.red, margin: "4px 0" }}>{loadingData ? "..." : item.count}</div>
              <div style={{ fontSize: 10, color: C.muted }}>⬇ CSV</div>
            </button>
          ))}
        </div>
      </div>

      {/* ---- SECTION 2: EMAIL BLAST ---- */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.red}`, marginBottom: 24 }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${C.border}` }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: C.black }}>📧 {en ? "Send Offer Promotions" : "Enviar Promociones de Ofertas"}</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>{en ? "Select offers and send by email" : "Selecciona ofertas y envía por email"}</div>
        </div>
        <div style={{ padding: "16px 20px" }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: C.black, marginBottom: 10 }}>{en ? "Select offers to promote:" : "Selecciona ofertas a promover:"}</div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: 8, marginBottom: 16 }}>
            {offers.filter(o => (o.status || "").toLowerCase() === "approved").map(o => (
              <button key={o._id} onClick={() => toggleOffer(o._id)} style={{
                background: selectedOffers.includes(o._id) ? "var(--accion-tinte)" : C.light,
                border: `1px solid ${selectedOffers.includes(o._id) ? C.red : C.border}`,
                borderRadius: 6, padding: "10px 12px", textAlign: "left", cursor: "pointer",
                fontFamily: "'DM Sans', sans-serif", display: "flex", gap: 8, alignItems: "center",
              }}>
                <span style={{ fontSize: 16, flexShrink: 0 }}>{selectedOffers.includes(o._id) ? "☑️" : "⬜"}</span>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 500, color: C.black }}>{o.title_es}</div>
                  <div style={{ fontSize: 10, color: C.muted }}>{o.merchant_name} · {textoValorOferta(o, en) || "?"}</div>
                </div>
              </button>
            ))}
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 4, letterSpacing: "0.1em" }}>{en ? "RECIPIENTS (one email per line or comma-separated)" : "DESTINATARIOS (un email por línea o separados por coma)"}</div>
            <textarea value={emailList} onChange={e => setEmailList(e.target.value)}
              placeholder={en ? "john@example.com\njane@example.com" : "juan@ejemplo.com\nmaria@ejemplo.com"}
              rows={3} style={{ ...S.input, resize: "vertical", fontFamily: "'DM Sans', sans-serif", fontSize: 12 }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ fontSize: 11, color: C.muted, marginBottom: 4, letterSpacing: "0.1em" }}>{en ? "SUBJECT (optional)" : "ASUNTO (opcional)"}</div>
            <input value={emailSubject} onChange={e => setEmailSubject(e.target.value)}
              placeholder={en ? "New benefits for you!" : "¡Nuevos beneficios para ti!"}
              style={{ ...S.input, fontSize: 12 }} />
          </div>
          <button onClick={handleEmailBlast} disabled={sending} style={{ ...S.btnPrimary, padding: "12px 24px", fontSize: 13, display: "flex", alignItems: "center", gap: 8 }}>
            📧 {en ? `Send to ${emailList.split(/[,\n]/).filter(Boolean).length || 0} recipients` : `Enviar a ${emailList.split(/[,\n]/).filter(Boolean).length || 0} destinatarios`}
          </button>
          <div style={{ fontSize: 10, color: C.muted, marginTop: 6 }}>{en ? "Opens your email client with a draft. For bulk email, consider SendGrid integration." : "Abre tu cliente de email con un borrador. Para envío masivo, considera integración con SendGrid."}</div>
        </div>
      </div>

      {/* ---- SECTION 3: STAFF MANAGEMENT ---- */}
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderTop: `3px solid ${C.gold}`, marginBottom: 24 }}>
        <div style={{ padding: "16px 20px", borderBottom: `1px solid ${C.border}` }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: C.black }}>👥 {en ? "Staff & Permissions" : "Staff y Permisos"}</div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 2 }}>{en ? "Manage who can access the admin panel" : "Gestiona quién puede acceder al panel admin"}</div>
        </div>
        <div style={{ padding: "16px 20px" }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 16 }}>
            {[
              { role: "Admin", desc: en ? "Full access to everything" : "Acceso total a todo", icon: "🔴", count: users.filter(u => (u.role || "").toLowerCase() === "admin").length },
              { role: "Merchant", desc: en ? "Manage own offers & coupons" : "Gestionar ofertas y cupones propios", icon: "🏪", count: users.filter(u => (u.role || "").toLowerCase() === "merchant").length },
              { role: "EndUser", desc: en ? "Browse & activate coupons" : "Ver y activar cupones", icon: "👤", count: users.filter(u => !u.role || (u.role || "").toLowerCase() === "enduser").length },
            ].map((r, i) => (
              <div key={i} style={{ padding: "16px", background: C.light, borderRadius: 6, textAlign: "center" }}>
                <div style={{ fontSize: 24, marginBottom: 4 }}>{r.icon}</div>
                <div style={{ ...S.display, fontSize: 24, color: C.black }}>{r.count}</div>
                <div style={{ fontSize: 12, fontWeight: 600, color: C.black, marginTop: 2 }}>{r.role}</div>
                <div style={{ fontSize: 10, color: C.muted, marginTop: 2 }}>{r.desc}</div>
              </div>
            ))}
          </div>
          <div style={{ padding: "14px 16px", background: "var(--aviso-tinte)", border: "1px solid var(--linea)", borderRadius: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--aviso)" }}>🔒 {en ? "Staff Permissions (Coming Soon)" : "Permisos de Staff (Próximamente)"}</div>
            <div style={{ fontSize: 11, color: "var(--aviso)", marginTop: 4 }}>
              {en
                ? "Soon you'll be able to create sub-admin accounts with specific permissions: view-only, approve offers, manage codes, etc."
                : "Pronto podrás crear cuentas sub-admin con permisos específicos: solo lectura, aprobar ofertas, gestionar códigos, etc."}
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

// ============================================
// PAGE: PRIVACY POLICY
// ============================================
function PrivacyPage() {
  const lang = useLang();
  return (
    <div style={{ ...S.page, minHeight: "100vh", background: C.white }}>
      <div style={{ background: C.black, padding: "20px 20px 16px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Logo size="md" />
          <a href="/" style={{ color: C.muted, fontSize: 12, textDecoration: "none" }}>← {lang === "en" ? "Back" : "Volver"}</a>
        </div>
      </div>
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "48px 20px 80px" }}>
        <div style={{ ...S.display, fontSize: 36, color: C.black, marginBottom: 8 }}>
          {lang === "en" ? "PRIVACY POLICY" : "POLÍTICA DE PRIVACIDAD"}
        </div>
        <p style={{ fontSize: 12, color: C.muted, marginBottom: 40 }}>
          {lang === "en" ? "Last updated: March 2026" : "Última actualización: Marzo 2026"}
        </p>
        {[
          {
            title: lang === "en" ? "Information We Collect" : "Información que Recolectamos",
            body: lang === "en"
              ? "We collect your name, email address, and password when you register. We also collect information about the benefits you activate and basic device/browser information."
              : "Recolectamos tu nombre, correo electrónico y contraseña cuando te registras. También recolectamos información sobre los beneficios que activas e información básica de tu dispositivo y navegador."
          },
          {
            title: lang === "en" ? "How We Use Your Information" : "Cómo Usamos Tu Información",
            body: lang === "en"
              ? "We use your information to operate your NXT Reserve membership, send you activation confirmations, improve our services, and communicate important updates."
              : "Usamos tu información para operar tu membresía NXT Reserve, enviarte confirmaciones de activación, mejorar nuestros servicios y comunicar actualizaciones importantes."
          },
          {
            title: lang === "en" ? "Data Sharing" : "Compartir Datos",
            body: lang === "en"
              ? "We do not sell your personal information to third parties. We share limited information with merchant partners only to validate coupon redemptions. We may share data with service providers who help us operate our platform."
              : "No vendemos tu información personal a terceros. Compartimos información limitada con negocios socios solo para validar redenciones de cupones. Podemos compartir datos con proveedores que nos ayudan a operar nuestra plataforma."
          },
          {
            title: lang === "en" ? "Your Rights" : "Tus Derechos",
            body: lang === "en"
              ? "You may request access to, correction of, or deletion of your personal data at any time by contacting us at hello@nxtreserve.com."
              : "Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento contactándonos en hello@nxtreserve.com."
          },
          {
            title: lang === "en" ? "Contact" : "Contacto",
            // s214 · la empresa es NXT Reserve USA Corp (s213-D6). Solo el nombre: el texto lo revisa el abogado (v2).
            body: "hello@nxtreserve.com · NXT Reserve USA Corp · Miami, FL"
          },
        ].map((s, i) => (
          <div key={i} style={{ marginBottom: 32, paddingBottom: 32, borderBottom: i < 4 ? `1px solid ${C.border}` : "none" }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 10, letterSpacing: "0.05em" }}>{s.title}</div>
            <p style={{ fontSize: 14, color: C.gray, lineHeight: 1.8 }}>{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

// ============================================
// PAGE: TERMS OF SERVICE
// ============================================
// s246-D4/D5 · §2 de los términos del socio (spec ciclo del cupón §5.2). Los días salen del mismo mapa que la ficha
// (CUPON_DIAS_POR_RUBRO), para que los términos y la ficha no digan cosas distintas. Hasta s245 decía «30 días».
const TERMINOS_SOCIO_CUPONES = {
  es: `Los cupones valen ${CUPON_DIAS_POR_RUBRO.Restaurant} días desde que los activas (${CUPON_DIAS_POR_RUBRO.Salon_Spa} en salones, uñas, experiencias y regalos). `
    + "Si el negocio pausa su oferta o sale del club, tu cupón sigue valiendo hasta esa fecha y te avisamos. "
    + "Los beneficios están sujetos a disponibilidad y discreción del negocio. Cada negocio define cada cuánto puedes volver a usar el mismo beneficio; el plazo aparece en cada oferta.",
  en: `Coupons are valid for ${CUPON_DIAS_POR_RUBRO.Restaurant} days from activation (${CUPON_DIAS_POR_RUBRO.Salon_Spa} for salons, nails, experiences and gifts). `
    + "If the business pauses its offer or leaves the club, your coupon stays valid until that date and we let you know. "
    + "Benefits are subject to availability and merchant discretion. Each business sets how soon you can use the same benefit again; the waiting period is shown on every offer.",
};
function TermsPage() {
  const lang = useLang();
  return (
    <div style={{ ...S.page, minHeight: "100vh", background: C.white }}>
      <div style={{ background: C.black, padding: "20px 20px 16px" }}>
        <div style={{ maxWidth: 720, margin: "0 auto", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Logo size="md" />
          <a href="/" style={{ color: C.muted, fontSize: 12, textDecoration: "none" }}>← {lang === "en" ? "Back" : "Volver"}</a>
        </div>
      </div>
      <div style={{ maxWidth: 720, margin: "0 auto", padding: "48px 20px 80px" }}>
        <div style={{ ...S.display, fontSize: 36, color: C.black, marginBottom: 8 }}>
          {lang === "en" ? "TERMS OF SERVICE" : "TÉRMINOS DE SERVICIO"}
        </div>
        <p style={{ fontSize: 12, color: C.muted, marginBottom: 40 }}>
          {lang === "en" ? "Last updated: October 2026" : "Última actualización: octubre de 2026"}
        </p>
        {[
          {
            num: "1",
            title: lang === "en" ? "Membership" : "Membresía",
            body: lang === "en"
              ? "Access to NXT Reserve is by invitation only. Access codes are personal and non-transferable. NXT Reserve reserves the right to revoke access for violation of these terms."
              : "El acceso a NXT Reserve es solo por invitación. Los códigos de acceso son personales y no transferibles. NXT Reserve se reserva el derecho de revocar el acceso por violación de estos términos."
          },
          {
            num: "2",
            title: lang === "en" ? "Benefits & Coupons" : "Beneficios y Cupones",
            // s183 · decía «cooldown de 90 días por negocio», y 90 no es la regla:
            // cada oferta trae su propio `cooldown_days`. En unos Términos, afirmar
            // un plazo que el producto no cumple es peor que en cualquier otra
            // pantalla, porque es el texto al que se remite una queja.
            body: lang === "en" ? TERMINOS_SOCIO_CUPONES.en : TERMINOS_SOCIO_CUPONES.es   // s246-D4/D5
          },
          {
            num: "3",
            title: lang === "en" ? "Payments" : "Pagos",
            body: lang === "en"
              ? "Activation fees are non-refundable once a coupon is generated. Members with an active membership pay no activation fee ($0 per coupon). LITE accounts include up to 2 free activations; once these are used, each additional activation carries a fee of 10% of the benefit value of the offer, with a minimum of $4.99 and a maximum of $9.99 per coupon. The applicable fee is calculated and charged at the time of activation."
              : "Las tarifas de activación no son reembolsables una vez que se genera el cupón. Los miembros con membresía vigente no pagan tarifa de activación ($0 por cupón). Las cuentas LITE incluyen hasta 2 activaciones gratuitas; una vez utilizadas, cada activación adicional tiene una tarifa del 10% del valor del beneficio de la oferta, con un mínimo de $4.99 y un máximo de $9.99 por cupón. La tarifa aplicable se calcula y se cobra al momento de la activación."
          },
          {
            num: "4",
            title: lang === "en" ? "Merchant Responsibility" : "Responsabilidad del Negocio",
            body: lang === "en"
              ? "NXT Reserve is not responsible for the quality of service provided by merchant partners. Disputes with merchants should be directed to hello@nxtreserve.com."
              : "NXT Reserve no es responsable por la calidad del servicio provisto por los negocios socios. Las disputas con negocios deben dirigirse a hello@nxtreserve.com."
          },
          {
            num: "5",
            title: lang === "en" ? "Prohibited Conduct" : "Conducta Prohibida",
            body: lang === "en"
              ? "It is prohibited to share, sell, or transfer coupons to third parties. Creating multiple accounts to circumvent LITE limits is prohibited and will result in account termination."
              : "Está prohibido compartir, vender o transferir cupones a terceros. Crear múltiples cuentas para eludir los límites LITE está prohibido y resultará en la terminación de la cuenta."
          },
          {
            num: "6",
            title: lang === "en" ? "Contact" : "Contacto",
            body: "hello@nxtreserve.com · NXT Reserve USA Corp · Miami, FL"
          },
        ].map((s, i) => (
          <div key={i} style={{ marginBottom: 32, paddingBottom: 32, borderBottom: i < 5 ? `1px solid ${C.border}` : "none" }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: C.black, marginBottom: 10, letterSpacing: "0.05em" }}>
              {s.num}. {s.title}
            </div>
            <p style={{ fontSize: 14, color: C.gray, lineHeight: 1.8 }}>{s.body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

// ============================================
// PROTECTED ROUTE
// ============================================
// ============================================
// PAGE: /i/:codigo — LA PUERTA DEL CANAL INFLUENCER (s186)
// ============================================
// Diseño: `claude/SPEC_s185_flujo_enganche.md`. Es la ÚNICA puerta del canal:
// la influencer reparte este link, no un código suelto. Precarga el código,
// lo deja editable (el link se comparte por captura y a veces se retipea), y
// lo arrastra hasta la puerta del código con `guardarCodigoInvitacion`.
//
// 🔴 ES PÚBLICA, y eso decide todo lo demás. Un anónimo NO puede leer nada de
// Bubble: la regla `everyone` de MembershipPlan está toda apagada — verificado
// con `curl /obj/membershipplan?limit=5` sin token → `count: 0`. Tampoco puede
// validar el código: `apply_access_code` y `validate_discount_code` exigen
// token. Así que esta pantalla no valida nada y no inventa nada:
//   · el ancla de valor ($135 tachado contra el precio del enganche) se dibuja
//     SOLO si el dato existe de verdad — hoy, únicamente para quien ya tiene
//     sesión abierta. Anónimo ve la promesa en palabras, sin cifras;
//   · el código se valida donde siempre se validó: en /onboarding.
// Para que el ancla exista para el visitante anónimo —que es el 100% del
// tráfico real de este canal— hace falta abrir la regla `everyone` de
// MembershipPlan a tres campos de lectura (label, price_usd, duration_months).
// Es zona de Ali; queda pedido en el reporte, y el día que se abra, esta
// pantalla lo muestra sin tocar una línea de React.
function InfluencerLandingPage() {
  const { codigo } = useParams();
  const lang = useLang();
  const cambiarIdioma = useSetLang();
  const navigate = useNavigate();
  const en = lang === "en";

  const [code, setCode] = useState(normalizarCodigo(codigo));
  const [plan, setPlan] = useState(null);                      // plan de 6 meses, si se pudo leer
  const [precioEnganche, setPrecioEnganche] = useState(null);  // number | null

  // El código se guarda apenas se abre la landing, no al tocar el botón: si la
  // persona se va a leer los términos y vuelve por otro camino, el código ya
  // viajó. Se vuelve a guardar al continuar, por si lo editó a mano.
  useEffect(() => { guardarCodigoInvitacion(codigo); }, [codigo]);

  // El ancla de valor, cuando el dato se puede leer. Nunca hardcodeada: el
  // precio de lista sale del plan y el del enganche del DiscountCode.
  useEffect(() => {
    if (!PLANES_VIP_VIEJOS || !auth.isLoggedIn()) return undefined;   // s252 · sin plan viejo no hay ancla
    let vivo = true;
    (async () => {
      let planes = [];
      try { planes = await getMembershipPlans({ activeOnly: true }); } catch (e) { return; }
      if (!vivo) return;
      const eng = leerEnganche();
      const elegido = elegirPlanEnganche(planes, eng && eng.planId);
      if (!elegido) return;
      setPlan(elegido);
      if (!eng || !eng.code) return;
      try {
        const r = await validateDiscountCode({ plan_id: elegido._id, code: eng.code });
        if (!vivo) return;
        const fp = Number(r && r.fixed_price) || 0;
        if (fp > 0) setPrecioEnganche(fp);
      } catch (e) { /* sin precio: el ancla no se dibuja, la pantalla sigue entera */ }
    })();
    return () => { vivo = false; };
  }, []);

  const continuar = () => {
    guardarCodigoInvitacion(code);
    navigate(auth.isLoggedIn() ? "/onboarding" : "/signup");
  };

  const listaPrecio = Number(plan && plan.price_usd) || 0;
  const meses = Number(plan && plan.duration_months) || MESES_ENGANCHE;
  const hayAncla = listaPrecio > 0 && precioEnganche != null && precioEnganche < listaPrecio;

  return (
    <div className="auth">
      <div className="auth__barra">
        <Logo size="md" tono="oscuro" />
        <button
          onClick={() => cambiarIdioma(en ? "es" : "en")}
          style={{ background: "none", border: "1px solid var(--linea)", borderRadius: "var(--radio-boton)",
                   padding: "6px 12px", fontSize: 12, color: "var(--tinta-suave)", cursor: "pointer",
                   fontFamily: "var(--fuente-texto)" }}>
          {en ? "ES" : "EN"}
        </button>
      </div>

      <div className="auth__centro">
        <div className="auth__caja">
          <div className="auth__saludo">
            <h1 className="auth__titulo">
              {en ? "YOUR INVITE IS WAITING" : "TU INVITACIÓN TE ESPERA"}
            </h1>
            <p className="auth__bajada">
              {en
                ? "You were invited to NXT Reserve. Create your account with this code and start using benefits at Miami restaurants, spas and experiences."
                : "Te invitaron a NXT Reserve. Crea tu cuenta con este código y empieza a usar beneficios en restaurantes, spas y experiencias de Miami."}
            </p>
          </div>

          {/* ANCLA DE VALOR — solo con dato real. Ver el encabezado. */}
          {hayAncla && (
            <div className="auth__ancla">
              <div className="auth__ancla-rotulo">
                {en ? `${meses}-month membership` : `Membresía de ${meses} meses`}
              </div>
              <div className="auth__ancla-cifras">
                <span className="auth__ancla-lista">${listaPrecio.toFixed(2)}</span>
                <span className="auth__ancla-precio">${precioEnganche.toFixed(2)}</span>
              </div>
              <div className="auth__ancla-nota">
                {en ? "one-time, with your invite" : "una sola vez, con tu invitación"}
              </div>
            </div>
          )}

          <div className="auth__campo">
            <label className="auth__etiqueta" htmlFor="nxt-i-code">
              {en ? "YOUR CODE" : "TU CÓDIGO"}
            </label>
            <input className="auth__entrada auth__codigo" id="nxt-i-code"
              value={code}
              onChange={(e) => setCode(normalizarCodigo(e.target.value))}
              onKeyDown={(e) => e.key === "Enter" && continuar()}
              placeholder="NXT-2026" />
          </div>

          <button className="auth__boton" onClick={continuar}>
            {auth.isLoggedIn()
              ? (en ? "Apply my code" : "Aplicar mi código")
              : (en ? "Create my account" : "Crear mi cuenta")}
          </button>

          {!auth.isLoggedIn() && (
            <Link className="auth__menor" to="/login">
              {en ? "I already have an account" : "Ya tengo cuenta"}
            </Link>
          )}

          {/* Qué incluye: la misma promesa que el producto ya hace en los planes
              VIP, no una lista nueva escrita para esta pantalla. */}
          <ul className="auth__lista">
            <li>{en ? "The full catalog, from day one" : "El catálogo completo, desde el primer día"}</li>
            <li>{en ? "Your first two activations, free" : "Tus dos primeras activaciones, gratis"}</li>
            <li>{en ? "Coverage for you + 1 companion" : "Cobertura para ti + 1 acompañante"}</li>
          </ul>

          <p className="auth__legal">
            {en ? "By continuing you accept our " : "Al continuar aceptas nuestros "}
            <Link to="/terms">{en ? "Terms" : "Términos"}</Link>
            {en ? " and " : " y la "}
            <Link to="/privacy">{en ? "Privacy Policy" : "Política de Privacidad"}</Link>.
          </p>
        </div>
      </div>

      <div className="auth__pie">
        NXT Reserve · Miami, FL
      </div>
    </div>
  );
}

// ============================================
// PAGE: /viajes — LA LANDING DEL CLUB DE VIAJES (s252)
// ============================================
// Ali, 02/11: el código de invitación sale del registro general y vive aquí. Quien entra es invitado de un evento de
// 1888 Hoteles / NXTravel USA en el hotel (DECISIÓN-A, s48: VIP gratis por evento, con los meses que el admin pone en
// el código; Ali piensa en 2 a 3 años). El enlace lo manda NXTravel USA (nxtravelusa.com) y puede traer el código:
// /viajes?codigo=XXXX. El código se guarda y se aplica en /onboarding, igual que /i/:codigo. La duración NO se promete
// aquí: cada código trae la suya. Estilo de /beneficios (vitrina.css); se pule después.
function ViajesPage() {
  const lang = useLang();
  const cambiarIdioma = useSetLang();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const en = lang === "en";
  const t = (es, enTxt) => (en ? enTxt : es);
  const [code, setCode] = useState(() => normalizarCodigo(searchParams.get("codigo") || leerCodigoInvitacion() || ""));
  const [error, setError] = useState("");
  const conSesion = auth.isLoggedIn();
  const continuar = () => {
    if (!code.trim()) { setError(t("Escribe tu código de invitación.", "Enter your invite code.")); return; }
    guardarCodigoInvitacion(code);
    navigate(conSesion ? "/onboarding" : "/signup");
  };
  const incluye = [
    t("Tu membresía de NXT Reserve, sin costo y sin tarjeta", "Your NXT Reserve membership, free and with no card"),
    t("Beneficios en restaurantes, salones, bares y experiencias de Miami", "Benefits at Miami restaurants, salons, bars and experiences"),
    t("Cada beneficio lo activas en la app, sin pagar nada", "You activate each benefit in the app, at no cost"),
    t("El tiempo de tu membresía viene en tu invitación", "Your invitation says how long your membership lasts"),
  ];
  const pasos = [
    t("Escribe el código de tu invitación.", "Enter your invitation code."),
    t("Crea tu cuenta, o entra si ya tienes una.", "Create your account, or sign in if you already have one."),
    t("Elige un beneficio, muéstralo en el negocio y ahorra.", "Pick a benefit, show it at the business and save."),
  ];
  return (
    <div className="vitrina">
      <header className="vitrina__barra">
        <Logo size="md" />
        <button type="button" className="vitrina__catalogo" onClick={() => cambiarIdioma(en ? "es" : "en")}>{en ? "ES" : "EN"}</button>
      </header>

      <main className="vitrina__ancho">
        <section className="vitrina__hero">
          <span className="vitrina__hero-icono" aria-hidden="true"><Ico name="ico-regalos" size={28} /></span>
          <h1 className="vitrina__titulo">{t("TU MEMBRESÍA DE NXT RESERVE, SIN COSTO.", "YOUR NXT RESERVE MEMBERSHIP, ON US.")}</h1>
          <p className="vitrina__bajada">
            {t("Por asistir a nuestro evento en el hotel con NXTravel USA, tienes acceso a NXT Reserve sin pagar. Solo necesitas el código de tu invitación.",
              "For attending our hotel event with NXTravel USA, you get NXT Reserve at no cost. All you need is your invitation code.")}
          </p>
        </section>

        <section className="vitrina__seccion">
          <h2 className="vitrina__h2">{t("QUÉ ES NXT RESERVE", "WHAT NXT RESERVE IS")}</h2>
          <p className="vitrina__texto">
            {t("Un club de beneficios en Miami. En cada visita ahorras con la oferta del lugar: por ejemplo, $20 cuando gastas $40.",
              "A benefits club in Miami. Every visit, you save with the place's offer: for example, $20 off when you spend $40.")}
          </p>
          <ul className="vitrina__texto" style={{ paddingLeft: 20 }}>
            {incluye.map(x => <li key={x}>{x}</li>)}
          </ul>
        </section>

        <section className="vitrina__seccion">
          <h2 className="vitrina__h2">{t("CÓMO FUNCIONA", "HOW IT WORKS")}</h2>
          <ol className="vitrina__pasos">
            {pasos.map((p, i) => (
              <li key={p} className="vitrina__paso">
                <span className="vitrina__paso-num">{i + 1}</span>
                <span className="vitrina__paso-texto">{p}</span>
              </li>
            ))}
          </ol>
        </section>

        <section className="vitrina__cierre">
          <h2 className="vitrina__cierre-titulo">{t("ENTRA CON TU CÓDIGO", "GET IN WITH YOUR CODE")}</h2>
          <div className="auth__campo" style={{ textAlign: "left" }}>
            <label className="auth__etiqueta" htmlFor="nxt-viajes-code">{t("TU CÓDIGO", "YOUR CODE")}</label>
            <input className="auth__entrada auth__codigo" id="nxt-viajes-code"
              value={code}
              onChange={(e) => { setCode(normalizarCodigo(e.target.value)); setError(""); }}
              onKeyDown={(e) => e.key === "Enter" && continuar()}
              placeholder="NXT-2026" />
          </div>
          {error && <div className="auth__error" role="alert">{error}</div>}
          <button className="auth__boton" onClick={continuar}>
            {conSesion ? t("Aplicar mi código", "Apply my code") : t("Crear mi cuenta", "Create my account")}
          </button>
          {!conSesion && (
            <p className="vitrina__nota"><Link to="/login">{t("Ya tengo cuenta", "I already have an account")}</Link></p>
          )}
          <p className="vitrina__nota">
            {t("El club abre pronto: con tu cuenta lista, eres de los primeros en usarlo. ¿No tienes código? Pídelo en ",
              "The club opens soon: with your account ready, you're among the first to use it. No code? Ask for it at ")}
            <a href="https://nxtravelusa.com/" target="_blank" rel="noreferrer">nxtravelusa.com</a>.
          </p>
        </section>
      </main>
    </div>
  );
}

// ============================================
// PAGE: ONBOARDING — LA PUERTA post-login (ETAPA-0 s97)
// ============================================
// ONB-1 telefono (obligatorio para TODOS) → "¿Tienes código?" (apply_access_code)
// → SÍ: entra directo con lo que el código otorgue · NO: contacto (WhatsApp).
// El código es la llave universal (influencer / regalo / LITE de prueba / VIP).
// Si el usuario YA tiene teléfono, la página arranca directo en el paso del
// código (es la misma puerta a la que vuelve cuando la operadora le da uno).
// Numero de WhatsApp de la operadora para "pedi tu codigo" (ONB-4).
// Formato internacional SOLO digitos (pais+numero), sin + ni espacios. CAMBIAR por el real.
const WHATSAPP_NUMBER = "17865487819"; // ONB-4 default; editable desde admin via PricingConfig.support_whatsapp (lo lee get_user_profile)

function OnboardingPage() {
  const lang = useLang();
  const cambiarIdioma = useSetLang();
  const navigate = useNavigate();
  // steps: 1=telefono · 2=¿tienes código? (sin código = entra al catálogo directo) · 4=código aplicado
  //        5=código guardado sin plan (s220 · el código del aliado, mientras no hay Checkout en main)
  const [step, setStep] = useState(1);
  const [phone, setPhone] = useState("");
  // s186 - el codigo llega precargado cuando la persona entro por /i/:codigo. No
  // se le pide dos veces lo mismo: la landing ya se lo mostro y el link lo traia.
  // Sigue editable — si vino por otro lado, el campo arranca vacio como siempre.
  const [code, setCode] = useState(() => leerCodigoInvitacion());
  const [granted, setGranted] = useState(null); // { tier, vip_expires_at } del apply
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [checking, setChecking] = useState(true);
  const [sinPlan, setSinPlan] = useState(false);   // s203-D6

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const prof = await getUserProfile();
        if (!alive) return;
        // s184 - esta era la CUARTA copia de la lista de roles (login, signup,
        // aca, y el helper). Ahora usa `routeByRole`: quien tiene panel propio no
        // pasa por la puerta del miembro, y la regla vive en un solo lugar.
        const destino = routeByRole(prof?.role);
        if (destino !== "/") { navigate(destino, { replace: true }); return; }
        // Teléfono ya capturado → directo a la puerta del código (no re-pedir).
        // s220 · y si el código ya está aplicado pero no dio plan, al paso «quedó guardado».
        // s252 · el código ya no se pide en el registro general: se pide solo a quien llega con uno (/viajes o /i/:codigo).
        if (prof?.phone) {
          if (codigoGuardadoSinPlan(prof)) setStep(5);
          else if (leerCodigoInvitacion()) setStep(2);
          else { navigate("/", { replace: true }); return; }
        }
        setSinPlan(socioSinPlan(prof));
      } catch (e) { /* mostrar onboarding igual */ }
      if (alive) setChecking(false);
    })();
    return () => { alive = false; };
  }, [navigate]);

  const savePhone = async () => {
    const clean = phone.trim();
    if (clean.replace(/[^0-9]/g, "").length < 7) {
      setError(lang === "en" ? "Enter a valid phone number" : "Ingresa un tel\u00e9fono v\u00e1lido");
      return;
    }
    setLoading(true); setError("");
    try {
      await updateUserProfile({ phone: clean });
      setError("");
      if (leerCodigoInvitacion() || code.trim()) setStep(2); else navigate("/");   // s252 · sin código, directo al catálogo
    } catch (e) {
      setError(e.message || (lang === "en" ? "Could not save your phone" : "No se pudo guardar el tel\u00e9fono"));
    } finally { setLoading(false); }
  };

  // Contrato apply_access_code: success "yes"/"no" + error (key única). Ver api.js.
  const applyCodeErrorMsg = (errCode) => {
    const en = lang === "en";
    const map = {
      CODE_ALREADY_APPLIED: en ? "This account already used an invite code. Message us if you need help." : "Esta cuenta ya usó un código de invitación. Escríbenos si necesitas ayuda.",
      INVALID_CODE: en ? "Invalid or already-used code. Check it and try again." : "Código inválido o ya usado. Revísalo e inténtalo de nuevo.",
      CODE_MISCONFIGURED: en ? "There's a problem with this code — message us and we'll fix it." : "Este código tiene un problema — escríbenos y lo resolvemos.",
      CODE_FULL: en ? "This code reached its usage limit." : "Este código ya alcanzó su límite de usos.",
      CODE_EXPIRED: en ? "This code expired." : "Este código venció.",
    };
    return map[errCode] || (en ? "Could not apply the code. Try again." : "No se pudo aplicar el código. Inténtalo de nuevo.");
  };

  const handleApplyCode = async () => {
    const clean = code.trim().toUpperCase();
    if (!clean) {
      setError(lang === "en" ? "Enter your code" : "Ingresa tu código");
      return;
    }
    setLoading(true); setError("");
    try {
      const resp = await applyAccessCode(clean);
      // s186 - el enganche del canal influencer. `apply_access_code` es el UNICO
      // momento en que el front puede saber que codigo de descuento le toca a esta
      // persona; despues de esto el AccessCode ya no se vuelve a leer. Se guarda y
      // NO se muestra paywall: la persona entra y navega (s185-D4). La oferta
      // aparece recien cuando se le acaban las activaciones gratis.
      // ⚠️ Hoy esto no guarda nada: el Return del WF todavia no trae los campos
      // (ver enganche.js). Cuando los traiga, el canal se enciende solo.
      guardarEngancheDesdeRespuesta(resp);
      limpiarCodigoInvitacion();
      setGranted(resp || {});
      // s220 · un código sin tier (el del aliado) no activa nada todavía: «ACCESO ACTIVADO» sería mentira.
      setStep(resp?.tier ? 4 : 5);
    } catch (e) {
      setError(applyCodeErrorMsg(e.code));
    } finally { setLoading(false); }
  };

  if (checking) {
    return (
      <div className="auth">
        <div className="auth__centro" style={{ color: "var(--tinta-tenue)", fontSize: 13 }}>
          {lang === "en" ? "Loading\u2026" : "Cargando\u2026"}
        </div>
      </div>
    );
  }

  return (
    <div className="auth">
      <div className="auth__barra">
        <Logo size="md" tono="oscuro" />
        <button
          onClick={() => cambiarIdioma(lang === "en" ? "es" : "en")}
          style={{ background: "none", border: "1px solid var(--linea)", borderRadius: "var(--radio-boton)",
                   padding: "6px 12px", fontSize: 12, color: "var(--tinta-suave)", cursor: "pointer",
                   fontFamily: "var(--fuente-texto)" }}>
          {lang === "en" ? "ES" : "EN"}
        </button>
      </div>

      <div className="auth__centro">
        <div className="auth__caja">

          {step === 1 && (
            <>
              {/* s184 - decia «UN ULTIMO PASO» y despues venia otro paso. Es una
                  mentira chica, pero es la primera que este producto le dice a
                  alguien que se acaba de registrar. «CASI LISTO» no promete un
                  final que no es. */}
              <div className="auth__saludo">
                <h1 className="auth__titulo">{lang === "en" ? "ALMOST THERE" : "CASI LISTO"}</h1>
                <p className="auth__bajada">
                  {lang === "en"
                    ? "Leave your phone so we can reach you about your access and benefits."
                    : "D\u00e9janos tu tel\u00e9fono para avisarte sobre tu acceso y tus beneficios."}
                </p>
              </div>

              <div className="auth__campo">
                <label className="auth__etiqueta" htmlFor="nxt-onb-phone">
                  {lang === "en" ? "PHONE" : "TEL\u00c9FONO"}
                </label>
                <input className="auth__entrada" id="nxt-onb-phone" type="tel" autoComplete="tel"
                  value={phone}
                  onChange={e => { setPhone(e.target.value); setError(""); }}
                  onKeyDown={e => e.key === "Enter" && savePhone()}
                  placeholder="305-555-1234" />
              </div>

              {error && <div className="auth__error" role="alert">{error}</div>}

              <button className="auth__boton" onClick={savePhone} disabled={loading}>
                {loading
                  ? (lang === "en" ? "Saving\u2026" : "Guardando\u2026")
                  : (lang === "en" ? "Continue" : "Continuar")}
              </button>
            </>
          )}

          {step === 2 && (
            <>
              <div className="auth__saludo">
                <h1 className="auth__titulo">
                  {lang === "en" ? "GOT AN INVITE CODE?" : "\u00bfTIENES C\u00d3DIGO DE INVITACI\u00d3N?"}
                </h1>
                <p className="auth__bajada">
                  {/* s252 · el paso del código solo lo ve quien llega con uno (/viajes, /i/:codigo); la ventana «solo por
                      invitación» se quitó en s247. */}
                  {lang === "en"
                    ? "Enter your invitation code and we'll apply it to your account."
                    : "Escribe el código de tu invitación y lo aplicamos a tu cuenta."}
                </p>
              </div>

              <div className="auth__campo">
                <label className="auth__etiqueta" htmlFor="nxt-onb-code">
                  {lang === "en" ? "YOUR CODE" : "TU C\u00d3DIGO"}
                </label>
                <input className="auth__entrada auth__codigo" id="nxt-onb-code"
                  value={code}
                  onChange={e => { setCode(e.target.value); setError(""); }}
                  onKeyDown={e => e.key === "Enter" && handleApplyCode()}
                  placeholder="NXT-2026" />
              </div>

              {error && <div className="auth__error" role="alert">{error}</div>}

              <button className="auth__boton" onClick={handleApplyCode} disabled={loading}>
                {loading
                  ? (lang === "en" ? "Applying\u2026" : "Aplicando\u2026")
                  : (lang === "en" ? "Apply my code" : "Aplicar mi c\u00f3digo")}
              </button>

              {/* ETAPA-1 (s98): «No tengo codigo» -> /beneficios (el «empujon»): value
                  stack real + por-que-invitacion + CTA WhatsApp/callback. El research
                  (s96/s97) manda: el preview ES el vendedor. */}
              <button className="auth__secundario" onClick={() => navigate("/")}>
                {lang === "en" ? "Continue without a code" : "Seguir sin código"}
              </button>
            </>
          )}

          {step === 4 && (
            <div className="auth__saludo" style={{ marginBottom: 0 }}>
              <h1 className="auth__titulo">
                {String(granted?.tier || "").toUpperCase() === "VIP"
                  ? (lang === "en" ? "VIP ACCESS ACTIVATED" : "ACCESO VIP ACTIVADO")
                  : (lang === "en" ? "ACCESS ACTIVATED" : "ACCESO ACTIVADO")}
              </h1>
              <p className="auth__bajada" style={{ marginBottom: 24 }}>
                {lang === "en"
                  ? "Your invite code was applied. Welcome to the club."
                  : "Tu c\u00f3digo de invitaci\u00f3n fue aplicado. Bienvenido al club."}
              </p>
              <button className="auth__boton" onClick={() => navigate("/")}>
                {lang === "en" ? "See my benefits" : "Ver mis beneficios"}
              </button>
            </div>
          )}

          {step === 5 && (
            <div className="auth__saludo" style={{ marginBottom: 0 }}>
              <h1 className="auth__titulo">
                {lang === "en" ? "YOUR CODE IS SAVED" : "TU CÓDIGO QUEDÓ GUARDADO"}
              </h1>
              <p className="auth__bajada" style={{ marginBottom: 24 }}>
                {lang === "en"
                  ? "Your NXT partner's code is on your account, with their founder discount. Very soon you'll be able to start your membership with a 7-day trial — we'll let you know by WhatsApp."
                  : "El código de tu aliado de NXT ya está en tu cuenta, con su descuento de fundador. Muy pronto vas a poder activar tu membresía con 7 días de prueba; te avisamos por WhatsApp."}
              </p>
              {/* Al catálogo, no a /beneficios: esa página abre con «estás a un código de distancia». */}
              <button className="auth__boton" onClick={() => navigate("/")}>
                {lang === "en" ? "Browse the club" : "Ver el catálogo"}
              </button>
            </div>
          )}

        </div>
      </div>

      <div className="auth__pie">
        NXT Reserve · Miami, FL
      </div>
    </div>
  );
}

// ============================================
// PAGE: BENEFICIOS — el "empujón" (ETAPA-1, s98)
// La página que ve quien NO tiene código (desde la puerta /onboarding o el modal
// codeGate). Objetivo: pitch de club → que PIDA su acceso (WhatsApp o callback).
// Copy base: COPY_empujon_etapa3_s97.md. Regla FTC "bona fide": el value stack
// sale del catálogo REAL (nada inventado). Los datos de la Etapa 3 que faltan
// (precio VIP, testimonios, ciudad, cupo influencer, evento) están marcados
// TODO-ETAPA-3 y NO se muestran hasta que Ali los provea.
// ============================================
function BenefitsPreviewPage() {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  const [offers, setOffers] = useState([]);
  const [profile, setProfile] = useState(null);
  const [loadingOffers, setLoadingOffers] = useState(true);
  // Callback ("prefiero que me llamen") — ConsumerWaitlist
  const [showCallback, setShowCallback] = useState(false);
  const [cbPhone, setCbPhone] = useState("");
  const [cbState, setCbState] = useState("idle"); // idle | sending | done
  const [cbError, setCbError] = useState("");

  useEffect(() => {
    let on = true;
    getOffers()
      .then(list => { if (on) { setOffers(Array.isArray(list) ? list : []); setLoadingOffers(false); } })
      .catch(() => { if (on) setLoadingOffers(false); });
    getUserProfile()
      .then(p => { if (on && p) { setProfile(p); if (p.phone && !cbPhone) setCbPhone(String(p.phone)); } })
      .catch(() => {});
    return () => { on = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const wa = profile?.support_whatsapp ? String(profile.support_whatsapp).replace(/[^0-9]/g, "") : WHATSAPP_NUMBER;
  const waText = en
    ? "Hi! I saw the NXT Reserve benefits and I want my access code."
    : "Hola! Vi los beneficios de NXT Reserve y quiero mi código de acceso.";

  // Value stack REAL: top ofertas del catálogo por valor (destacadas primero).
  // s204 · el titulo de cada oferta lo pone OfferCard (title_es/title_en, criterio del catalogo).
  const top = offers
    .filter(o => valorDeOferta(o) > 0)
    .sort((a, b) => (b.featured === a.featured
      ? valorDeOferta(b) - valorDeOferta(a)
      : (b.featured ? 1 : -1)))
    .slice(0, 6);   // s204: 6 = dos filas de tres tarjetas (eran 5 filas de tabla)
  // s221-D1: un % no suma su tope al total (es «hasta», no lo que se lleva el miembro).
  const stackTotal = top.reduce((s, o) => s + (esPorcentaje(o) ? 0 : Number(o.benefit_value_usd || 0)), 0);

  const submitCallback = async () => {
    const clean = cbPhone.trim();
    if (clean.replace(/[^0-9]/g, "").length < 7) {
      setCbError(en ? "Enter a valid phone number" : "Ingresa un teléfono válido");
      return;
    }
    setCbState("sending"); setCbError("");
    try {
      // FIX smoke s98 (issue identidad): la identidad se resuelve AL MOMENTO del envío,
      // re-fetcheando el perfil — no se confía en el estado del mount (una sesión que
      // cambió entre pestañas mandaba el email de OTRO usuario al buzón).
      let who = null;
      try { who = await getUserProfile(); } catch (e) { who = null; }
      if (!who?.email) {
        setCbState("idle");
        setCbError(en
          ? "We couldn't confirm your account. Please use the WhatsApp button instead."
          : "No pudimos confirmar tu cuenta. Usa el botón de WhatsApp de arriba.");
        return;
      }
      if (who.email !== profile?.email) setProfile(who);
      await createConsumerWaitlist({
        name: who.name || who.email,
        email: who.email,
        whatsapp: clean,
        source: "preview_beneficios",
      });
      setCbState("done");
    } catch (e) {
      setCbState("idle");
      setCbError(en
        ? "We couldn't save your number. Try again or message us on WhatsApp."
        : "No pudimos guardar tu número. Prueba de nuevo o escríbenos por WhatsApp.");
    }
  };

  // s204 · la vitrina con lo que hay DE VERDAD (FTC bona fide): cuantos comercios y
  // beneficios activos hay hoy, de que rubros, y los mejores como tarjetas del catalogo.
  // Todo sale de getOffers(); nada se inventa. Lo que falta (precio, testimonios, ciudad)
  // espera al ticket `vitrina-beneficios-completa`.
  const nComercios = new Set(offers.map(o => o.merchant_id).filter(Boolean)).size;
  const nBeneficios = offers.length;
  const rubros = [...new Set(offers.map(o => o.category).filter(c => CAT_DISPLAY[c]))];

  return (
    <div className="vitrina">
      <header className="vitrina__barra">
        <Logo size="md" />
        {/* s218 · solo con invitación: sin código no se entra al catálogo; la vitrina ya muestra lo que hay adentro. */}
        {!soloConInvitacion() && (
          <button type="button" className="vitrina__catalogo" onClick={() => navigate("/")}>
            {en ? "Browse catalog →" : "Ver el catálogo →"}
          </button>
        )}
      </header>

      <main className="vitrina__ancho">
        {/* HERO */}
        <section className="vitrina__hero">
          <span className="vitrina__hero-icono" aria-hidden="true"><Ico name="ico-estrella" size={28} /></span>
          <h1 className="vitrina__titulo">{en ? "YOU'RE ONE CODE AWAY FROM THE CLUB." : "ESTÁS A UN CÓDIGO DE DISTANCIA DEL CLUB."}</h1>
          {/* TODO-ETAPA-3: reemplazar "la ciudad" por la ciudad real ([CIUDAD]) cuando Ali la confirme */}
          {/* s236 · «¿Quiénes somos?» en tres partes (Ali, s236), el mismo texto en landing, invitación y app. Vuelve
              «exclusivos» a propósito (s232 lo había sacado). Reusa .vitrina__bajada (margin 0 auto); el aire entre párrafos va inline. */}
          {(en
            ? ["We're an exclusive benefits and discounts club in Miami. We connect our members with the city's local restaurants and businesses.",
               "Our members discover new places, enjoy themselves and save.",
               "And our partner businesses get known, attract new customers and grow their sales, without paying for advertising."]
            : ["Somos un club de beneficios y descuentos exclusivos en Miami. Conectamos a nuestros miembros con los restaurantes y negocios locales de la ciudad.",
               "Nuestros miembros descubren nuevos lugares, disfrutan y ahorran.",
               "Y nuestros negocios aliados se dan a conocer, atraen clientes nuevos y aumentan sus ventas, sin pagar publicidad."]
          ).map((t, i) => (
            <p key={i} className="vitrina__bajada" style={i ? { marginTop: 10 } : undefined}>{t}</p>
          ))}
          {/* s204 · las cifras del club, contadas del catalogo publico en este momento. */}
          {!loadingOffers && nBeneficios > 0 && (
            <dl className="vitrina__cifras">
              <div className="vitrina__cifra">
                <dt>{en ? "Businesses" : "Comercios"}</dt>
                <dd>{nComercios}</dd>
              </div>
              <div className="vitrina__cifra">
                <dt>{en ? "Active benefits" : "Beneficios activos"}</dt>
                <dd>{nBeneficios}</dd>
              </div>
              {/* un solo rubro no dice nada del club: la cifra aparece desde dos */}
              {rubros.length > 1 && (
                <div className="vitrina__cifra">
                  <dt>{en ? "Categories" : "Rubros"}</dt>
                  <dd>{rubros.length}</dd>
                </div>
              )}
            </dl>
          )}
        </section>

        {/* VALUE STACK — con datos reales del catálogo (FTC bona fide, sin inventar) */}
        {loadingOffers && (
          <div className="vitrina__cargando">{en ? "Loading benefits..." : "Cargando beneficios..."}</div>
        )}
        {!loadingOffers && top.length > 0 && (
          <section className="vitrina__seccion">
            <h2 className="vitrina__h2">{en ? "WHAT'S INSIDE RIGHT NOW:" : "LO QUE HAY ADENTRO AHORA MISMO:"}</h2>
            {rubros.length > 1 && (
              <ul className="vitrina__rubros" aria-label={en ? "Categories" : "Rubros"}>
                {rubros.map(c => (
                  <li key={c} className="vitrina__rubro"><CategoryIcon category={c} />{CAT_DISPLAY[c]}</li>
                ))}
              </ul>
            )}
            {/* s204 · las mismas tarjetas del catalogo (foto, comercio, ahorro): el socio ve
                lo que va a encontrar adentro, no una tabla. Tocar una abre su ficha. */}
            <div className="vitrina__tarjetas">
              {top.map((o, i) => (
                <OfferCard key={o._id || i} offer={o} sinGuardar onClick={() => navigate(`/offer/${o._id}`)} />
              ))}
            </div>
            <div className="vitrina__total">
              <span className="vitrina__total-rotulo">{en ? "SAVINGS FROM JUST THESE BENEFITS" : "AHORRO DE SOLO ESTOS BENEFICIOS"}</span>
              <span className="vitrina__total-cifra">${stackTotal.toFixed(0)}</span>
            </div>
            <p className="vitrina__nota">
              {en ? "And this is only part of the catalog — members see it all." : "Y esto es solo una parte del catálogo — los miembros lo ven todo."}
            </p>
          </section>
        )}
        {/* TODO-ETAPA-3 / ticket vitrina-beneficios-completa: value stack curado (precio
            membresía + "con N beneficios ya la recuperas") cuando haya precios de B0.
            Testimonios REALES (FTC: nunca inventar — por eso hoy no se renderiza). */}

        {/* s204 · COMO FUNCIONA: los mismos pasos que la ficha de cada oferta, empezando
            por el que le falta a quien esta en esta pantalla: el codigo. */}
        <section className="vitrina__seccion">
          <h2 className="vitrina__h2">{en ? "HOW IT WORKS" : "CÓMO FUNCIONA"}</h2>
          <ol className="vitrina__pasos">
            {(en
              ? ["Get your access code", "Activate the benefit you want in the app", "Show your code at the business — done"]
              : ["Consigue tu código de acceso", "Activa en la app el beneficio que quieras", "Muestra tu código en el negocio — listo"]
            ).map((t, i) => (
              <li key={i} className="vitrina__paso">
                <span className="vitrina__paso-num">{i + 1}</span>
                <span className="vitrina__paso-texto">{t}</span>
              </li>
            ))}
          </ol>
        </section>

        {/* POR QUÉ POR INVITACIÓN */}
        <section className="vitrina__seccion">
          <h2 className="vitrina__h2">{en ? "WHY INVITATION-ONLY?" : "¿POR QUÉ POR INVITACIÓN?"}</h2>
          <p className="vitrina__texto">
            {en
              ? "Because a club stops being one when anyone can walk in. We keep membership limited so the benefits stay worth it — for you and for the restaurants."
              : "Porque un club deja de serlo cuando entra cualquiera. Mantenemos el cupo limitado para que los beneficios sigan valiendo la pena — para ti y para los restaurantes."}
          </p>
          <p className="vitrina__texto">
            {en
              ? "Your code can come from an NXT partner or a friend who's already in, from one of our events, or straight from our team. Any of the three gets you in through the same door."
              : "El acceso llega de tres formas: te lo pasa un aliado de NXT o un amigo que ya está adentro, te lo damos en un evento, o lo pides directo a nuestro equipo. Cualquiera de las tres, entras con tu código por la misma puerta."}
          </p>
        </section>

        {/* CTA — cierre humano */}
        <section className="vitrina__cierre">
          <h2 className="vitrina__cierre-titulo">{en ? "LIKE IT? ASK FOR YOUR ACCESS." : "¿TE GUSTÓ? PIDE TU ACCESO."}</h2>
          <p className="vitrina__cierre-texto">
            {en
              ? "A real person from our team will message you, explain how it works and give you your code. No hoops."
              : "Te escribe una persona de nuestro equipo, te cuenta cómo entrar y te da tu código. Sin vueltas."}
          </p>
          <a className="vitrina__wa" href={`https://wa.me/${wa}?text=${encodeURIComponent(waText)}`} target="_blank" rel="noreferrer">
            <IcoFicha name="chat" size={20} /> {en ? "I want my code" : "Quiero mi código"}
          </a>

          {/* Callback: cola ConsumerWaitlist (R5) */}
          {cbState === "done" ? (
            <div className="vitrina__listo" role="status">
              {en ? "✅ Done — we'll reach out shortly." : "✅ Listo — te contactamos en breve."}
            </div>
          ) : showCallback ? (
            <div className="vitrina__llamada">
              <input
                className={"vitrina__telefono" + (cbError ? " vitrina__telefono--error" : "")}
                value={cbPhone}
                onChange={e => { setCbPhone(e.target.value); setCbError(""); }}
                onKeyDown={e => e.key === "Enter" && cbState !== "sending" && submitCallback()}
                type="tel"
                autoComplete="tel"
                aria-label={en ? "Your phone / WhatsApp" : "Tu teléfono / WhatsApp"}
                placeholder={en ? "Your phone / WhatsApp" : "Tu teléfono / WhatsApp"}
              />
              {cbError && <div className="vitrina__error" role="alert">{cbError}</div>}
              {profile?.email && (
                <div className="vitrina__cuenta">
                  {en ? "For your account: " : "Para tu cuenta: "}{profile.email}
                </div>
              )}
              <button type="button" className="vitrina__llamar" onClick={submitCallback} disabled={cbState === "sending"}>
                {cbState === "sending"
                  ? (en ? "Sending..." : "Enviando...")
                  : (en ? "Call me →" : "Pedir que me llamen →")}
              </button>
            </div>
          ) : (
            <button type="button" className="vitrina__enlace" onClick={() => setShowCallback(true)}>
              {en ? "I'd rather get a call →" : "Prefiero que me llamen →"}
            </button>
          )}

          <button type="button" className="vitrina__enlace vitrina__enlace--suave" onClick={() => navigate("/viajes")}>
            {en ? "I already have a code →" : "Ya tengo un código →"}
          </button>
        </section>
      </main>
    </div>
  );
}

// ============================================
// VITRINA BETA (s195 · s194-D21/D22)
// ============================================
// Un link por comercio (/beta?t=<token>), SIN login, que muestra «así se vería tu
// negocio» y los demás de la lista. Los tres estados los decide el SERVIDOR (sala
// get_beta_catalog): `demo` solo lo ve su dueño, `borroso` llega sin nombre ni logo (no
// hay nada que ocultar acá: el difuminado no es CSS), `visible` = «Coming soon» con nombre
// y logo. Canjear apagado: ninguna tarjeta navega ni tiene CTA. Token inválido, ausente o
// WF caído = pantalla neutra sin pistas. El contrato (provisional) vive en api.js.

const BETA_ESTADOS = ["demo", "borroso", "visible"];

// Lo que get_beta_catalog llama «negocio» se convierte en la forma que OfferCard ya
// entiende: la tarjeta no cambia, solo se le da de comer. Sin foto (el WF hoy no la
// manda; PEDIDO en PLAN_s195 §4) la tarjeta declara el hueco con la trama, como siempre.
// s237 · beta-vitrina-porcentaje-como-monto: desde s236-D6 `own_json` trae `offer_type` y `discount_pct`
// (_NOTAS/get_beta_catalog.md). Una oferta sembrada en porcentaje se muestra como porcentaje; en porcentaje
// `benefit_value_usd` es el TOPE (TOPE_SIN_LIMITE o más = sin tope), no un monto que se descuenta.
const pctDeBeta = (m) => (String(m?.offer_type || "").toLowerCase() === "percent" && Number(m?.discount_pct) > 0 ? Number(m.discount_pct) : 0);
const topeDeBeta = (m) => { const t = Number(m?.benefit_value_usd) || 0; return t > 0 && t < TOPE_SIN_LIMITE ? t : 0; };
function ofertaDesdeBeta(m) {
  if (!m) return null;
  const pct = pctDeBeta(m);
  if (pct) {
    const tope = topeDeBeta(m);
    return {
      _id: m.merchant_id || "",
      offer_type: "percent",
      discount_pct: pct,
      title_es: m.offer_title || (tope ? `${pct} % en tu cuenta, hasta $${fmtUsd(tope)}` : `${pct} % en tu cuenta`),
      benefit_value_usd: tope || TOPE_SIN_LIMITE,
      min_consumption: 0,
      category: m.category || "",
      merchant_name: m.business_name || "",
      neighborhood: m.neighborhood || m.zone || "",
      image: m.photo || null,
      merchant_logo: m.logo || "",
    };
  }
  return {
    _id: m.merchant_id || "",
    offer_type: UMBRAL_TIPO,
    title_es: m.offer_title || fraseUmbral(m.benefit_value_usd, m.min_consumption, false),
    benefit_value_usd: m.benefit_value_usd,
    min_consumption: m.min_consumption,
    regular_price: m.min_consumption,
    category: m.category || "",
    merchant_name: m.business_name || "",
    neighborhood: m.neighborhood || m.zone || "",
    image: m.photo || null,
    merchant_logo: m.logo || "",
  };
}

// Un mensaje por cada error_code de invite_merchant (sala s195) + los dos del canal.
function mensajeInvite(code, en) {
  const M = {
    INVALID_TOKEN: [
      "Este enlace ya no es válido. Pídele uno nuevo a quien te lo compartió.",
      "This link is no longer valid. Ask the person who shared it for a new one."],
    INVALID_EMAIL: ["Escribe un correo válido.", "Enter a valid email."],
    ALREADY_INVITED: [
      "Este negocio ya tiene un dueño registrado con otro correo. Si eres tú, escríbele a quien te compartió el enlace.",
      "This business already has an owner registered with another email. If that's you, write to the person who shared the link."],
    EMAIL_ALREADY_EXISTS: [
      "Ya existe una cuenta con ese correo. Entra con tu contraseña o recupérala desde «¿Olvidaste tu contraseña?».",
      "There's already an account with that email. Sign in, or recover your password from “Forgot your password?”."],
    TOO_MANY_INVITES: [
      "Ya enviamos el máximo de correos para este negocio. Escríbele a quien te compartió el enlace y lo resolvemos.",
      "We've already sent the maximum number of emails for this business. Write to the person who shared the link."],
    WF_NOT_DEPLOYED: [
      "El envío todavía no está disponible. Inténtalo más tarde.",
      "Sending isn't available yet. Try again later."],
    NO_SESSION: ["Tu sesión venció. Entra de nuevo.", "Your session expired. Sign in again."],
  };
  const par = M[code] || [
    "No pudimos enviar el correo ahora. Inténtalo de nuevo en unos minutos.",
    "We couldn't send the email right now. Try again in a few minutes."];
  return par[en ? 1 : 0];
}

function BetaNeutra({ cargando }) {
  const lang = useLang();
  const en = lang === "en";
  return (
    <div className="beta-neutra">
      <Logo size="lg" />
      <p className="beta-neutra__texto">
        {cargando ? (en ? "Loading…" : "Cargando…") : (en ? "This link isn't available." : "Este enlace no está disponible.")}
      </p>
    </div>
  );
}

// «Quiero estar» (s194-D22, puerta «comercio»): correo + nombre → invite_merchant →
// «Revisa tu correo» con «Reenviar» (la misma llamada, el mismo correo). El botón no
// aprueba la oferta ni obliga a nada, y la pantalla lo dice.
// s213 · `abrir` es un contador: el botón fijo de la vitrina lo sube y el formulario se abre.
function BetaQuieroEstar({ token, abrir = 0 }) {
  const lang = useLang();
  const en = lang === "en";
  const [abierto, setAbierto] = useState(false);
  useEffect(() => { if (abrir > 0) setAbierto(true); }, [abrir]);
  const [correo, setCorreo] = useState("");
  const [nombre, setNombre] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState("");
  const [enviado, setEnviado] = useState(null);   // { correo, email_step, veces }

  const enviar = async () => {
    const c = (enviado ? enviado.correo : correo).trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c)) { setError(mensajeInvite("INVALID_EMAIL", en)); return; }
    setEnviando(true); setError("");
    try {
      const r = await inviteMerchant({ t: token, owner_email: c, owner_name: nombre.trim() });
      setEnviado(prev => ({ correo: c, email_step: r?.email_step, veces: (prev?.veces || 0) + 1 }));
    } catch (e) {
      setError(mensajeInvite(e?.code, en));
    } finally {
      setEnviando(false);
    }
  };

  const nota = (
    <p className="beta__nota">
      {en
        ? "This doesn't approve your offer or commit you to anything: we only email you a link to create your password. You confirm the offer yourself, whenever you want."
        : "Esto no aprueba tu oferta ni te compromete a nada: solo te enviamos un link para crear tu contraseña. La oferta la confirmas tú, cuando quieras."}
    </p>
  );

  if (enviado) {
    return (
      <div>
        <div className="beta__listo" role="status">
          <b>{en ? "Check your email" : "Revisa tu correo"}</b>
          {enviado.email_step === "no"
            ? (en
              ? `Your account is created, but the email didn't go out. Write to the person who shared this link and they'll send you the link to create your password.`
              : `Tu cuenta quedó creada, pero el correo no salió. Escríbele a quien te compartió este enlace y te manda el link para crear tu contraseña.`)
            : (en
              ? `We sent ${enviado.correo} the link to create your password. It expires in 24 hours. If you don't see it, check spam.`
              : `Te enviamos a ${enviado.correo} el link para crear tu contraseña. Vence en 24 horas. Si no lo ves, revisa spam.`)}
        </div>
        <button type="button" className="beta__cta beta__cta--secundario" onClick={enviar} disabled={enviando}>
          {enviando ? "…" : (en ? "Resend" : "Reenviar")}
        </button>
        {error && <div className="beta__error" role="alert">{error}</div>}
        {nota}
      </div>
    );
  }

  return (
    <div>
      {!abierto ? (
        <button type="button" className="beta__cta" onClick={() => setAbierto(true)}>
          {en ? "Activate my offer" : "Activar mi oferta"}
        </button>
      ) : (
        <form onSubmit={e => { e.preventDefault(); enviar(); }}>
          <div className="beta__campo">
            <label className="beta__etiqueta" htmlFor="beta-correo">{en ? "Your email" : "Tu correo"}</label>
            <input id="beta-correo" className="beta__entrada" type="email" autoComplete="email" required
              value={correo} onChange={e => setCorreo(e.target.value)} placeholder={en ? "you@yourbusiness.com" : "tu@negocio.com"} />
          </div>
          <div className="beta__campo">
            <label className="beta__etiqueta" htmlFor="beta-nombre">{en ? "Your name (optional)" : "Tu nombre (opcional)"}</label>
            <input id="beta-nombre" className="beta__entrada" type="text" autoComplete="name"
              value={nombre} onChange={e => setNombre(e.target.value)} />
          </div>
          <button type="submit" className="beta__cta" disabled={enviando}>
            {enviando ? (en ? "Sending…" : "Enviando…") : (en ? "Send me the link" : "Enviarme el link")}
          </button>
          {error && <div className="beta__error" role="alert">{error}</div>}
        </form>
      )}
      {nota}
    </div>
  );
}

// s213 · LA VITRINA QUE VENDE. Antes le mostraba al dueño su tarjeta y la frase del miembro
// («Ahorra $30 cuando gastas $60»), que el dueño lee como «pierdo $30»: no decía qué es el club,
// quién paga, qué gana ni quién está detrás (recorrido s213; ronda 11: claridad 3/10, 4/4 «otro
// Groupon»). Ahora habla en su idioma, en tres pantallas: la idea · lo que gana (la cuenta con SUS
// números, como resta) · quiénes somos. Otto va arriba con su WhatsApp: «yo hablé con una
// persona, no con una página» (ronda 11). Maqueta aprobada: claude/maquetas_s213/ (v3).
// Los «otros de la lista» ya no se pintan: con pocos sembrados restaban (s213); get_beta_catalog
// los sigue mandando.
const OTTO_WHATSAPP = "17862107847";   // s213 · Ali: el número de Otto (landing-numero-whatsapp-otto)
// Las fotos son de nxt-landing/merchants/img, achicadas a 240 px: van difuminadas, no se distinguen.
const BETA_CATEGORIAS = [
  { cat: "Restaurant",   img: "/img-vitrina-beta/cat_restaurante.webp",  es: "Restaurantes",  en: "Restaurants" },
  { cat: "Salon_Spa",    img: "/img-vitrina-beta/cat_salon.webp",        es: "Salones y spa", en: "Salons & spa" },
  { cat: "Bar_Rooftop",  img: "/img-vitrina-beta/cat_bares.webp",        es: "Bares",         en: "Bars" },
  { cat: "Experience",   img: "/img-vitrina-beta/cat_experiencias.webp", es: "Experiencias",  en: "Experiences" },
  { cat: "Sweets",       img: "/img-vitrina-beta/cat_dulces.webp",       es: "Dulces",        en: "Sweets" },
  { cat: "Gift_Moments", img: "/img-vitrina-beta/cat_regalos.webp",      es: "Celebraciones", en: "Celebrations" },
];
// La página de /merchants de cada rubro (bar y experiencias redirigen a /merchants).
// s235 · invitacion-slug-bares-y-qsr (Ali): los bares (y la comida rápida, si llega con la clave compuesta) usan la de
// restaurantes: invitacion.js ya les da los textos de «mesa», su rubro y sus tamaños. Sin esto caían en /beta, la
// vitrina vieja (sin calculadora del ticket ni casilla de términos). Experiencias sigue en /beta hasta tener landing.
const BETA_MERCHANTS_SLUG = { Restaurant: "restaurantes", "Restaurant:comida_rapida_qsr": "restaurantes", Bar_Rooftop: "restaurantes",
  Salon_Spa: "belleza", Nail_Lash: "belleza", Sweets: "dulces", Gift_Moments: "regalos" };
const BETA_RUBRO_MESA = ["Restaurant", "Bar_Rooftop"];
// La cuenta «normal» del ejemplo: 5/3 del mínimo, redondeada a $10 ($60 → $100 · $40 → $70 ·
// $30 → $50). Siempre se muestra al lado el caso mínimo (ronda 11: «el $100 se ve maquillado»).
const cuentaEjemploBeta = (minimo) => Math.max(minimo, Math.round((minimo * 5) / 3 / 10) * 10);
// «El monto va con tu ticket»: el primer y el último tamaño del rubro que cumplen «el doble»
// (sin la S, que es $10/$10, ni la Destacada mientras siga bloqueada).
const rangoTamanosBeta = (categoria) => {
  const ids = UMBRAL_TAMANOS_POR_RUBRO[categoria] || [];
  const t = UMBRAL_TAMANOS.filter(x => ids.includes(x.id) && x.minimo > x.monto && (x.id !== "D" || DESTACADA_HABILITADA));
  return t.length > 1 ? [t[0], t[t.length - 1]] : null;
};

// La cuenta como resta, igual en el caso normal y en el mínimo (Ali, s213: «resta antes de sumar»).
function BetaResta({ titulo, cuenta, beneficio, nota, en }) {
  const usd = (n) => `$${fmtUsd(n)}`;
  return (
    <div className="beta-resta">
      <div className="beta-resta__tit">{titulo}</div>
      <div className="beta-resta__fila"><span>{en ? "The bill" : "La cuenta"}</span><b>{usd(cuenta)}</b></div>
      <div className="beta-resta__fila beta-resta__fila--menos"><span>{en ? "Member benefit" : "Beneficio del miembro"}</span><b>−{usd(beneficio)}</b></div>
      <div className="beta-resta__fila beta-resta__fila--total"><span>{en ? "You collect" : "Tú cobras"}</span><b>{usd(cuenta - beneficio)}</b></div>
      {nota && <p className="beta-resta__nota">{nota}</p>}
    </div>
  );
}

// ============================================================================================
// s227 · PREINAUGURACIÓN: TODO BORROSO (`preinauguracion-todo-borroso`, spec claude/SPEC_s227_preinauguracion_todo_borroso.md
// §5 y §11). Hasta que Ali abra el club (PricingConfig.catalogo_abierto en Live + quitar el candado de privacy):
// · el catálogo sale de `get_catalogo_preapertura` (rubro · zona · tipo · monto · % · mínimo; sin nombre, foto ni título),
//   en tarjetas difuminadas con un fondo GENÉRICO por rubro (nunca la foto del comercio, §11) que no se pueden tocar;
// · Admin y Operator ven todo claro (leen con su token: «Admin sees all» y la regla con candado);
// · el dueño ve sus ofertas aprobadas claras («Tu oferta») y su propia /m/:id; las demás, borrosas;
// · /offer/:id y /m/:id muestran «Se abre el día de la inauguración».
// Si el WF falla, el club se toma como CERRADO. Con `abierto: true` todo sigue como antes, sin otro deploy.
// ============================================================================================
const ClubContext = createContext({ cargado: false, abierto: false, tarjetas: [], count: 0 });
function ProveedorClub({ children }) {
  const [club, setClub] = useState({ cargado: false, abierto: false, tarjetas: [], count: 0 });
  useEffect(() => {
    let vivo = true;
    getCatalogoPreapertura()
      .then(r => { if (vivo) setClub({ cargado: true, abierto: !!r.abierto, tarjetas: r.tarjetas || [], count: r.count || 0 }); })
      .catch(() => { if (vivo) setClub({ cargado: true, abierto: false, tarjetas: [], count: 0 }); });
    return () => { vivo = false; };
  }, []);
  return <ClubContext.Provider value={club}>{children}</ClubContext.Provider>;
}
const useClub = () => useContext(ClubContext);

// El rol de la sesión, leído del servidor (get_user_profile) una vez por token. `nxt_role` del navegador puede quedar
// viejo; para decidir quién ve claro manda el servidor.
let rolCache = { token: null, promesa: null };
function rolDeLaSesion() {
  const t = auth.getToken();
  if (!t) return Promise.resolve("");
  if (rolCache.token !== t) {
    rolCache = { token: t, promesa: getUserProfile().then(p => String(p?.role || "")).catch(() => "") };
  }
  return rolCache.promesa;
}
const ROLES_VEN_TODO = ["Admin", "Operator"];
// null = todavía no se sabe · string = el rol
function useRolSesion() {
  const [rol, setRol] = useState(null);
  useEffect(() => { let vivo = true; rolDeLaSesion().then(r => { if (vivo) setRol(r); }); return () => { vivo = false; }; }, []);
  return rol;
}

const TEXTO_CLUB_CERRADO = {
  aviso: ["El club abre pronto.", "The club opens soon."],
  avisoCuerpo: ["Estos son algunos de los beneficios que ya te esperan. Los nombres se revelan el día de la inauguración.",
    "Here are some of the perks already waiting for you. Names are revealed on opening day."],
  ficha: ["Se abre el día de la inauguración.", "Opens on launch day."],
  fichaCuerpo: ["Mientras tanto, mira lo que ya hay en el club.", "In the meantime, see what's already in the club."],
  candado: ["Se revela en la inauguración", "Revealed on opening day"],
  // s229 · «N comercios en camino»: `count_comercios` del 141 = comercios distintos con una oferta Pending o Approved
  // (sembrados que todavía no confirmaron incluidos). Con 0 no se dice nada.
  enCamino: (n, en) => (n === 1
    ? (en ? "1 business on the way." : "1 comercio en camino.")
    : (en ? `${n} businesses on the way.` : `${n} comercios en camino.`)),
};
const FONDO_RUBRO = (rubro) => {
  const c = BETA_CATEGORIAS.find(x => x.cat === rubro);
  return (c || BETA_CATEGORIAS[0]).img;
};
const RUBRO_CERRADO = { Restaurant: ["Restaurante", "Restaurant"], Bar_Rooftop: ["Bar", "Bar"], Salon_Spa: ["Salón / Spa", "Salon / Spa"],
  Experience: ["Experiencia", "Experience"], Sweets: ["Dulces", "Sweets"], Gift_Moments: ["Celebraciones", "Celebrations"], Nail_Lash: ["Uñas y pestañas", "Nails & lashes"] };
// El monto de una tarjeta borrosa, según el tipo (lo único que dice qué se gana).
function montoCerrado(tj, en) {
  const m = fmtUsd(tj.monto), n = fmtUsd(tj.minimo);
  const t = String(tj.tipo || "").toLowerCase();
  // s241 · «en tu cuenta» / «en tu pedido» según el rubro (perfil-por-rubro; lo encontró el recorrido manual).
  if (t === "percent" && tj.pct > 0) return en ? `${tj.pct}% off ${enTuCuenta(true, tj.rubro).replace(/^on /, "")}` : `${tj.pct} % de descuento ${enTuCuenta(false, tj.rubro)}`;
  if (t === "bogo") return en ? "2-for-1: order two, pay for one" : "2×1: pides dos y pagas uno";
  if (t === "free") return en ? "On the house" : "Cortesía";
  if (tj.minimo > tj.monto) return en ? `$${m} off when you spend $${n}` : `$${m} de descuento si gastas $${n}`;
  return tj.monto > 0 ? (en ? `$${m} off` : `$${m} de descuento`) : "";
}
const tarjetaComoOferta = (tj) => ({ offer_type: tj.tipo, discount_pct: tj.pct, benefit_value_usd: tj.monto, min_consumption: tj.minimo });

// La tarjeta borrosa. No es botón ni enlace: no se puede tocar.
function TarjetaCerrada({ tj, en }) {
  const rubro = (RUBRO_CERRADO[tj.rubro] || [CAT_DISPLAY[tj.rubro] || tj.rubro || "", CAT_DISPLAY[tj.rubro] || tj.rubro || ""])[en ? 1 : 0];
  const monto = montoCerrado(tj, en);
  const lugar = [rubro, tj.zona].filter(Boolean).join(" · ");
  return (
    <article className="mq-tarjeta" aria-label={[lugar, monto].filter(Boolean).join(" · ")}>
      <div className="mq-tarjeta__foto" aria-hidden="true">
        <div className="mq-tarjeta__img" style={{ backgroundImage: `url(${FONDO_RUBRO(tj.rubro)})` }} />
        <span className="mq-tarjeta__candado">🔒 {TEXTO_CLUB_CERRADO.candado[en ? 1 : 0]}</span>
        {isBestDealOffer(tarjetaComoOferta(tj)) && <span className="mq-tarjeta__imperdible">{en ? "Can't-miss" : "Imperdible"}</span>}
      </div>
      <div className="mq-tarjeta__cuerpo">
        {lugar && <div className="mq-tarjeta__rubro">{lugar}</div>}
        {monto && <div className="mq-tarjeta__monto">{monto}</div>}
        <div className="mq-tarjeta__nombre" aria-hidden="true" />
      </div>
    </article>
  );
}

// El catálogo cerrado: Home, /merchants, Mi lista y /beneficios. El dueño ve sus ofertas aprobadas claras y primero.
function CatalogoCerrado({ rol }) {
  const lang = useLang();
  const en = lang === "en";
  const club = useClub();
  const navigate = useNavigate();
  const [propias, setPropias] = useState([]);
  useEffect(() => {
    if (rol !== "Merchant") return undefined;
    let vivo = true;
    (async () => {
      try {
        const [perfil, todas] = await Promise.all([getMerchantProfile(), getAllOffers()]);
        const mias = misOfertasDelComercio(todas, perfil)
          .filter(o => (o.status || "").toLowerCase() === "approved")
          // s233 · dueno-ve-su-ficha: la galería y el logo del perfil, para que «Tu oferta» se deslice como en el catálogo.
          .map(o => {
            const g = perfil?.gallery;
            const https = (u) => { const s = String(u || "").trim(); return s.startsWith("//") ? "https:" + s : s; };
            return { ...o, merchant_name: o.merchant_name || perfil?.business_name || "",
              merchant_logo: o.merchant_logo || https(perfil?.logo),
              merchant_gallery: (Array.isArray(g) ? g : (g ? [g] : [])).map(https).filter(Boolean) };
          });
        if (vivo) setPropias(mias);
      } catch (_) { /* sin lo propio, igual se ve el borroso */ }
    })();
    return () => { vivo = false; };
  }, [rol]);
  const idsPropias = new Set(propias.map(o => o._id || o.id));
  const borrosas = club.tarjetas.filter(tj => !idsPropias.has(tj.offer_id));
  return (
    <div className="catalogo">
      <Navbar activePage="home" />
      <div className="catalogo__banda"><div className="catalogo__ancho">
        <div className="catalogo__cabecera">
          <div>
            <h1 className="catalogo__titulo">{en ? <>Miami's <em>best</em></> : <>Lo mejor de <em>Miami</em></>}</h1>
            <div className="catalogo__bajada">{en ? "curated benefits · 6 categories" : "beneficios elegidos a mano · 6 categorías"}</div>
          </div>
        </div>
      </div></div>
      <div className="catalogo__ancho mq-cuerpo">
        <div className="catalogo__construyendo" role="status">
          <b>{TEXTO_CLUB_CERRADO.aviso[en ? 1 : 0]}</b>
          {club.cargado && club.count > 0 && <>{" "}<b>{TEXTO_CLUB_CERRADO.enCamino(club.count, en)}</b></>}
          {" "}{TEXTO_CLUB_CERRADO.avisoCuerpo[en ? 1 : 0]}
        </div>
        {!club.cargado ? (
          <p className="pv-nota" style={{ marginTop: 16 }}>{en ? "Loading…" : "Cargando…"}</p>
        ) : (
          <div className="catalogo__tarjetas mq-tarjetas">
            {propias.map(o => (
              <div key={o._id || o.id} className="mq-propia">
                <span className="mq-propia__marca">{en ? "Your offer" : "Tu oferta"}</span>
                {/* s233 · dueno-ve-su-ficha: «Tu oferta» abre SU ficha (PuertaFicha deja pasar al dueño a lo suyo). */}
                <OfferCard sinGuardar variante="catalogo" offer={o} nombreComercio={o.merchant_name}
                  onClick={() => navigate(`/offer/${o._id || o.id}`, { state: { offer: o } })} />
              </div>
            ))}
            {borrosas.map(tj => <TarjetaCerrada key={tj.offer_id} tj={tj} en={en} />)}
          </div>
        )}
      </div>
    </div>
  );
}

// La ficha cerrada (/offer/:id y /m/:id).
function FichaCerrada() {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  return (
    <div className="catalogo">
      <Navbar activePage="home" />
      <div className="mq-ficha">
        <div className="mq-ficha__fondo" aria-hidden="true">
          {BETA_CATEGORIAS.map(c => <div key={c.cat} className="mq-ficha__foto" style={{ backgroundImage: `url(${c.img})` }} />)}
        </div>
        <section className="mq-ficha__caja" aria-labelledby="ficha-cerrada-titulo">
          <div className="mq-ficha__candado" aria-hidden="true">🔒</div>
          <h1 id="ficha-cerrada-titulo" className="mq-ficha__titulo">{TEXTO_CLUB_CERRADO.ficha[en ? 1 : 0]}</h1>
          <p className="mq-ficha__texto">{TEXTO_CLUB_CERRADO.fichaCuerpo[en ? 1 : 0]}</p>
          <button type="button" className="mrc-boton" onClick={() => navigate("/")}>{en ? "See the club" : "Ver el club"}</button>
        </section>
      </div>
    </div>
  );
}

// Las compuertas. Con el club abierto o para Admin/Operator, la pantalla de siempre.
function PuertaCatalogo({ children }) {
  const club = useClub();
  const rol = useRolSesion();
  if (!club.cargado || rol === null) return <div style={S.page} aria-busy="true" />;
  if (club.abierto || ROLES_VEN_TODO.includes(rol)) return children;
  return <CatalogoCerrado rol={rol} />;
}
// `propioId`: en /m/:id el dueño abre SU ficha (se compara con su merchant_id).
// s233 · dueno-ve-su-ficha: en /offer/:id también pasa el dueño, pero solo si la oferta es de SU comercio (Ali).
function PuertaFicha({ children, esComercio = false }) {
  const club = useClub();
  const rol = useRolSesion();
  const { id } = useParams();
  const [esPropia, setEsPropia] = useState(null);
  useEffect(() => {
    if (rol !== "Merchant") { setEsPropia(false); return undefined; }
    let vivo = true;
    (async () => {
      try {
        const p = await getMerchantProfile();
        const mio = String(p?.merchant_id || "");
        if (!mio) { if (vivo) setEsPropia(false); return; }
        if (esComercio) { if (vivo) setEsPropia(mio === id); return; }
        const o = await getOfferById(id);
        if (vivo) setEsPropia(!!o && o.merchant_id === mio);
      } catch (_) { if (vivo) setEsPropia(false); }
    })();
    return () => { vivo = false; };
  }, [esComercio, rol, id]);
  if (!club.cargado || rol === null) return <div style={S.page} aria-busy="true" />;
  if (club.abierto || ROLES_VEN_TODO.includes(rol)) return children;
  if (rol === "Merchant") {
    if (esPropia === null) return <div style={S.page} aria-busy="true" />;
    if (esPropia) return children;
  }
  return <FichaCerrada />;
}

function BetaVitrinaPage() {
  const lang = useLang();
  const en = lang === "en";
  const cambiarIdioma = useSetLang();
  const [searchParams] = useSearchParams();
  const t = (searchParams.get("t") || "").trim();
  const [estado, setEstado] = useState("cargando");   // cargando | ok | neutra
  const [data, setData] = useState(null);
  const [abrirForm, setAbrirForm] = useState(0);
  const [finalAlaVista, setFinalAlaVista] = useState(false);
  const finalRef = useRef(null);

  useEffect(() => {
    let on = true;
    if (!t) { setEstado("neutra"); return undefined; }
    getBetaCatalog(t)
      // s237 · descartado-invitacion-sigue-viva: get_beta_catalog devuelve también a los descartados (status Rejected) e
      // invite_merchant los dejaba confirmar. Un descartado se trata como enlace que no sirve: pantalla neutra.
      .then(d => { if (!on) return; if (!d || !d.own || d.own.status === "Rejected") { setEstado("neutra"); return; } setData(d); setEstado("ok"); })
      .catch(() => { if (on) setEstado("neutra"); });
    return () => { on = false; };
  }, [t]);

  // El botón fijo se esconde cuando el «Quiero estar» del final está a la vista: nunca dos seguidos.
  useEffect(() => {
    if (estado !== "ok" || !finalRef.current || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver(([e]) => setFinalAlaVista(e.isIntersecting));
    io.observe(finalRef.current);
    return () => io.disconnect();
  }, [estado]);

  if (estado === "cargando") return <BetaNeutra cargando />;
  if (estado === "neutra" || !data) return <BetaNeutra />;

  const own = data.own;
  const propia = ofertaDesdeBeta(own);
  const cat = own.category || "";
  // s237 · en porcentaje no hay monto ni mínimo: sin recibo de umbral, y el paso 3 dice el porcentaje.
  const pctBeta = pctDeBeta(own);
  const topeBeta = topeDeBeta(own);
  const beneficio = pctBeta ? 0 : (Number(own.benefit_value_usd) || 0);
  const minimo = pctBeta ? 0 : (Number(own.min_consumption) || 0);
  const conCuenta = beneficio > 0 && minimo > beneficio;
  const esMesa = BETA_RUBRO_MESA.includes(cat);
  const cuenta = conCuenta ? cuentaEjemploBeta(minimo) : 0;
  // s255 · `primera-oferta-solo-porcentaje`: «El monto va con tu ticket: de $15 si gastan $30…» es del monto fijo.
  const rango = pctBeta ? null : rangoTamanosBeta(cat);
  const usd = (n) => `$${fmtUsd(n)}`;
  const slug = BETA_MERCHANTS_SLUG[cat];
  const urlRubro = `https://nxtreserve.com/merchants/${slug ? `${slug}/` : ""}`;
  const otras = BETA_CATEGORIAS.filter(c => c.cat !== cat).slice(0, 4);
  const wa = `https://wa.me/${OTTO_WHATSAPP}?text=${encodeURIComponent(en
    ? `Hi Otto, I saw the NXT Reserve preview for ${own.business_name}.`
    : `Hola Otto, vi la vista previa de ${own.business_name} en NXT Reserve.`)}`;
  const quieroEstar = () => {
    setAbrirForm(n => n + 1);
    if (finalRef.current) finalRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  return (
    <div className="beta">
      <div className="beta__banda" role="status">
        {en ? "Private preview · not published yet" : "Vista previa privada · todavía no está publicada"}
      </div>
      <div className="beta__columna">
        <div className="beta__tope">
          <Logo size="md" />
          <button type="button" className="beta__idioma" onClick={() => cambiarIdioma(en ? "es" : "en")}>{en ? "ES" : "EN"}</button>
        </div>

        <div className="beta-otto">
          {/* s214 · la foto de Otto (Ali), recortada a la cara y achicada: 144 px WebP, ~5 KB. El nombre
              ya lo dice el texto de al lado: la foto es decorativa. Cuando get_beta_catalog traiga quién
              sembró (ticket vitrina-beta-sembrador-y-foto), sale de ahí. */}
          <img className="beta-otto__foto" src="/img-vitrina-beta/otto.webp" alt="" width="44" height="44" />
          <div className="beta-otto__txt"><b>{en ? "Prepared for you by Otto" : "Te la preparó Otto"}</b>{en ? "from NXT Reserve" : "de NXT Reserve"}</div>
          <a className="beta-otto__wa" href={wa} target="_blank" rel="noopener noreferrer">WhatsApp</a>
        </div>

        {/* ---------- 1 · LA IDEA ---------- */}
        <section className="beta-pant" aria-label={en ? "The idea" : "La idea"}>
          <h1 className="beta__titulo">
            {esMesa
              ? (en ? "New customers at your tables. Being here costs you nothing." : "Clientes nuevos en tus mesas. Estar no te cuesta nada.")
              : (en ? "New customers for your business. Being here costs you nothing." : "Clientes nuevos para tu negocio. Estar no te cuesta nada.")}
          </h1>
          <p className="beta__bajada">
            <b>{en ? "NXT Reserve is a membership club in Miami." : "NXT Reserve es un club de membresía de Miami."}</b>{" "}
            {en
              ? "People pay a fee to discover restaurants, spas and experiences, with a benefit at each place."
              : "La gente paga una cuota para descubrir restaurantes, spas y experiencias, con un beneficio en cada lugar."}
          </p>
          <div className="beta-propia">
            <OfferCard variante="catalogo" offer={propia} etiqueta={en ? "How members would see you" : "Así te verían los miembros"} />
            <p className="beta-propia__cambia">
              {pctBeta
                ? (en ? "Another dish, photo or percentage? You change it before confirming." : "¿Otro plato, otra foto u otro porcentaje? Lo cambias antes de confirmar.")
                : (en ? "Another dish, photo or amount? You change it before confirming." : "¿Otro plato, otra foto u otro monto? Lo cambias antes de confirmar.")}
            </p>
          </div>
          <p className="beta-primeros">
            <b>{en ? "We're bringing in the first places in Miami." : "Estamos sumando los primeros lugares de Miami."}</b>{" "}
            {en ? "Your offer will be ready the day we open the membership." : "Tu oferta queda lista para el día que abramos la membresía."}
          </p>
          <div className="beta-club" aria-hidden="true">
            {otras.map(c => (
              <div key={c.cat} className="beta-club__item">
                <div className="beta-club__foto" style={{ backgroundImage: `url(${c.img})` }} />
                <div className="beta-club__cat">{en ? c.en : c.es}</div>
              </div>
            ))}
          </div>
        </section>

        {/* ---------- 2 · LO QUE GANAS ---------- */}
        <section className="beta-pant" aria-label={en ? "What you gain" : "Lo que ganas"}>
          <div className="beta-pant__rotulo">{en ? "What you gain" : "Lo que ganas"}</div>
          <h2 className="beta-pant__titulo">
            {esMesa ? (en ? "A table that was going to be empty" : "Una mesa que iba a estar vacía") : (en ? "A customer you didn't have" : "Un cliente que no tenías")}
          </h2>
          {conCuenta && (
            <div className="beta-cuenta">
              {esMesa && <div className="beta-cuenta__foto" aria-hidden="true" style={{ backgroundImage: "url(/img-vitrina-beta/mesa_dos.webp)" }} />}
              <div className="beta-cuenta__cuerpo">
                <BetaResta en={en} cuenta={cuenta} beneficio={beneficio}
                  titulo={esMesa ? (en ? "Table for two · a Tuesday" : "Mesa de dos · un martes") : (en ? "One visit · a Tuesday" : "Una visita · un martes")}
                  nota={esMesa
                    ? (en ? "From two customers you didn't have, who came through the club." : "Por dos clientes que no tenías y que llegaron por el club.")
                    : (en ? "From a customer you didn't have, who came through the club." : "Por un cliente que no tenías y que llegó por el club.")} />
                {cuenta > minimo && (
                  <>
                    <div className="beta-cuenta__sep" />
                    <BetaResta en={en} cuenta={minimo} beneficio={beneficio} titulo={en ? "The minimum" : "Lo mínimo"} />
                  </>
                )}
              </div>
            </div>
          )}
          {conCuenta && (
            <p className="beta-pant__chica">
              {en
                ? `Below ${usd(minimo)} it doesn't apply. The minimum is counted before taxes and tip.`
                : `Con menos de ${usd(minimo)} no aplica. El mínimo se cuenta antes de impuestos y propina.`}
              {esMesa && (en
                ? ` Alcohol counts toward the ${usd(minimo)}, but it doesn't get the discount.`
                : ` El alcohol cuenta para llegar a los ${usd(minimo)}, pero no lleva descuento.`)}
            </p>
          )}
          {rango && (
            <p className="beta-pant__chica">
              <b>{en ? "The amount follows your ticket:" : "El monto va con tu ticket:"}</b>{" "}
              {en
                ? `from ${usd(rango[0].monto)} when they spend ${usd(rango[0].minimo)} to ${usd(rango[1].monto)} when they spend ${usd(rango[1].minimo)}. You choose it with Otto.`
                : `de ${usd(rango[0].monto)} si gastan ${usd(rango[0].minimo)} a ${usd(rango[1].monto)} si gastan ${usd(rango[1].minimo)}. Lo eliges con Otto.`}
            </p>
          )}

          {/* Ronda 11 (4/4): eran sus primeras preguntas y estaban plegadas. Van abiertas. */}
          <div className="beta-abierta">
            <b>{en ? "What if they come with someone?" : "¿Y si viene con alguien?"}</b>
            <p>{en
              ? "One benefit per membership: with their companion, it's one for both. If more members come, each one brings their own."
              : "Un beneficio por membresía: si viene con su acompañante, es uno para los dos. Si llegan más miembros, cada uno trae el suyo."}</p>
          </div>
          <div className="beta-abierta">
            <b>{en ? "Is this Groupon?" : "¿Esto es Groupon?"}</b>
            {/* s255 · en un % no hay «el doble del beneficio»: el miembro paga su cuenta con el descuento. */}
            <p>{pctBeta
              ? (en ? "No. Nobody buys a discounted coupon from you: the member pays a membership to be part of the club and pays their bill at your place, with the discount."
                : "No. Nadie te compra un cupón rebajado: el miembro paga una membresía para ser parte del club y paga su cuenta en tu local, con el descuento.")
              : (en ? "No. Nobody buys a discounted coupon from you: the member pays a membership to be part of the club and spends at least double the benefit."
                : "No. Nadie te compra un cupón rebajado: el miembro paga una membresía para ser parte del club y consume al menos el doble del beneficio.")}</p>
          </div>
          <div className="beta-abierta">
            <b>{en ? "If it's free for me, how do you make money?" : "Si para mí es gratis, ¿cómo ganan ustedes?"}</b>
            <p>{en ? "With the membership members pay. That's why we don't charge you anything." : "Con la membresía que pagan los miembros. Por eso a ti no te cobramos nada."}</p>
          </div>

          <ul className="beta-puntos">
            <li><i aria-hidden="true">$0</i><span>
              <b>{en ? "No sign-up fee, no monthly fee, no commission." : "Sin inscripción, sin mensualidad, sin comisión."}</b>
              {en ? "You give the benefit only when the customer is already spending. If nobody comes, it didn't cost you a dollar." : "Das el beneficio solo cuando el cliente ya está consumiendo. Si no viene nadie, no te costó un dólar."}
            </span></li>
            <li><i aria-hidden="true">⚙</i><span>
              <b>{en ? "You control when." : "Tú controlas cuándo."}</b>
              {en
                ? "Put it on your slow hours and choose how often the same member can come back. And if they were already your customer, this keeps them: they don't go elsewhere. Full? You pause it with a button in your dashboard."
                : "Ponla en tus horas lentas y elige cada cuánto vuelve el mismo miembro. Y si ya era tu cliente, así lo retienes: no se va a otro lugar. ¿Estás lleno? La pausas con un botón en tu panel."}
            </span></li>
            <li><i aria-hidden="true">★</i><span>
              <b>{en ? "You join the club too, for free." : "Tú también entras al club, gratis."}</b>
              {en ? "While you're in, you're a member and use the benefits at the other places." : "Mientras estés adentro, eres miembro y usas los beneficios de los otros lugares."}
            </span></li>
          </ul>

          <h3 className="beta-pant__h3">{en ? "How it works at your place" : "Así funciona en tu local"}</h3>
          <ol className="beta-pasos">
            <li>{en ? "The member shows you their code on their phone." : "El miembro te muestra su código en el teléfono."}</li>
            <li>{en ? "You validate it in your dashboard. It takes seconds." : "Lo validas en tu panel. Toma segundos."}</li>
            <li>{pctBeta
              ? (en ? `You take ${pctBeta}% off the bill${topeBeta ? `, up to ${usd(topeBeta)}` : ""}. Done.` : `Le descuentas el ${pctBeta} % de la cuenta${topeBeta ? `, hasta ${usd(topeBeta)}` : ""}. Listo.`)
              : beneficio > 0
              ? (en ? `You take ${usd(beneficio)} off the bill. Done.` : `Le descuentas ${usd(beneficio)} de la cuenta. Listo.`)
              : (en ? "You apply the benefit. Done." : "Le aplicas el beneficio. Listo.")}</li>
          </ol>
        </section>

        {/* ---------- 3 · QUIÉNES SOMOS ---------- */}
        {/* s232 · beta-quienes-somos-dueno-s231: el texto final de Ali (s231-D1, versión dueño), el mismo bloque y título que
            la invitación en nxt-landing/merchants/invitacion.js. Antes: «Un equipo de Miami, no una app de cupones» + los
            8 años (s213). El rótulo pasa a la marca porque el título ya es «¿Quiénes somos?». EN: traducción sin aprobar. */}
        <section className="beta-pant" aria-label={en ? "Who we are" : "¿Quiénes somos?"}>
          <div className="beta-pant__rotulo">NXT Reserve</div>
          <h2 className="beta-pant__titulo">{en ? "Who we are" : "¿Quiénes somos?"}</h2>
          {/* s236 · el texto en tres partes de Ali, igual que la invitación (antes: cuatro párrafos de s231-D1). */}
          <p className="beta__bajada">
            {en
              ? <>We're an <b>exclusive benefits and discounts club in Miami</b>. We connect our members with the city's local restaurants and businesses.</>
              : <>Somos un <b>club de beneficios y descuentos exclusivos en Miami</b>. Conectamos a nuestros miembros con los restaurantes y negocios locales de la ciudad.</>}
          </p>
          <p className="beta__bajada">
            {en ? "Our members discover new places, enjoy themselves and save." : "Nuestros miembros descubren nuevos lugares, disfrutan y ahorran."}
          </p>
          <p className="beta__bajada">
            {en
              ? <>And our partner businesses get known, <b>attract new customers and grow their sales</b>, without paying for advertising.</>
              : <>Y nuestros negocios aliados se dan a conocer, <b>atraen clientes nuevos y aumentan sus ventas</b>, sin pagar publicidad.</>}
          </p>

          <h3 className="beta-pant__h3">{esMesa ? (en ? "Who comes to your table?" : "¿Quién llega a tu mesa?") : (en ? "Who comes in?" : "¿Quién llega?")}</h3>
          <div className="beta-quien">
            <div><b>{en ? "Members" : "Miembros"}</b>{en ? "They pay a membership. Not coupon hunters." : "Pagan una membresía. No buscan cupones."}</div>
            <div><b>{en ? "Locals" : "Locales"}</b>{en ? "Looking for their next favorite place." : "Buscan su próximo lugar favorito."}</div>
            <div><b>{en ? "Tourists" : "Turistas"}</b>{en ? "Visiting Miami, looking for where to go." : "De visita en Miami, buscando a dónde ir."}</div>
          </div>

          <h3 className="beta-pant__h3">{en ? "How do they find you?" : "¿Cómo te encuentran?"}</h3>
          <p className="beta-pant__chica">
            {en
              ? "You show up in the club's app with your photo and your offer. And we introduce you to hotels, tourism companies, influencers and content creators in Miami."
              : "Sales en la app del club con tu foto y tu oferta. Y te presentamos con hoteles, empresas de turismo, influencers y creadores de contenido de Miami."}
          </p>

          <div className="beta-final" ref={finalRef}>
            <BetaQuieroEstar token={t} abrir={abrirForm} />
            <a className="beta__cta beta__cta--wa" href={wa} target="_blank" rel="noopener noreferrer">
              {en ? "Questions? Message Otto on WhatsApp" : "¿Dudas? Escríbele a Otto por WhatsApp"}
            </a>
            <a className="beta-final__enlace" href={urlRubro} target="_blank" rel="noopener noreferrer">
              {en ? "See everything explained →" : "Ver todo explicado →"}
            </a>
          </div>
          {/* s214 · la empresa que opera es NXT Reserve USA Corp (s213-D6); NovaAI Marketing LLC es otra. */}
          <p className="beta-pie">NXT Reserve USA Corp · Miami, FL</p>
        </section>
      </div>

      {!finalAlaVista && (
        <div className="beta-fijo">
          <button type="button" className="beta__cta" onClick={quieroEstar}>{en ? "Activate my offer" : "Activar mi oferta"}</button>
        </div>
      )}
    </div>
  );
}

// ---- PANEL DE OTTO · /operator/vitrina (rol Operator o Admin) ----
// Sembrar (form = params de seed_merchant, con el tamaño SUGERIDO por gasto por persona),
// generar y copiar el link, ver aperturas, «Aprobó» (correo del dueño → invite_merchant con
// sesión = puerta «operador») y «Reenviar». La lista viene de get_seeded_merchants (WF
// PEDIDO); hasta que exista, se muestra lo sembrado desde ESTE navegador (localStorage), que
// no es fuente de verdad y la pantalla lo dice.
const BETA_CACHE_KEY = "nxt_beta_sembrados";
const leerCacheBeta = () => {
  try { const v = JSON.parse(localStorage.getItem(BETA_CACHE_KEY) || "[]"); return Array.isArray(v) ? v : []; } catch (e) { return []; }
};
const guardarCacheBeta = (lista) => { try { localStorage.setItem(BETA_CACHE_KEY, JSON.stringify(lista.slice(0, 200))); } catch (e) { /* sin localStorage no persiste */ } };
// s215 · ensayo en vivo (Ali): el enlace del sembrado abre LA LANDING DE SU RUBRO con su oferta adentro
// (nxtreserve.com/merchants/{rubro}/?t=…, script merchants/sembrado.js de nxt-landing), que vende mejor
// que la vitrina. Bar y experiencias todavía no tienen landing, y fuera de producción el token no existe
// en Live: esos siguen en /beta de esta app.
// `&n=` lleva el nombre del negocio para la tarjeta de WhatsApp (función de borde sembrado-og de
// nxt-landing): WhatsApp lee la página sin correr el script y get_beta_catalog no se puede llamar
// ahí (suma una apertura por cada vista previa que arma). Es el nombre del propio negocio.
const linkBeta = (token, category, negocio) => {
  const t = encodeURIComponent(token || "");
  const slug = BETA_MERCHANTS_SLUG[category];
  const n = String(negocio || "").trim().slice(0, 80);
  return slug && window.location.hostname === "app.nxtreserve.com"
    ? `https://nxtreserve.com/merchants/${slug}/?t=${t}${n ? `&n=${encodeURIComponent(n)}` : ""}`
    : `${window.location.origin}/beta?t=${t}`;
};
// s214 · mensaje-enlace-beta-otto (recorrido s213, P1-5): el enlace no viaja solo. Lo que Otto escribía
// alrededor dependía de él, y el guion de s201 estaba vencido («socios», «Recibe $X si gastas $2X»).
// Firma quien siembra (su primer nombre del perfil); sin nombre, Otto.
const mensajeEnlaceBeta = (negocio, token, quien, en, category) => {
  const yo = String(quien || "").trim().split(/\s+/)[0] || "Otto";
  const n = String(negocio || "").trim() || (en ? "your business" : "tu negocio");
  return en
    ? `Hi, this is ${yo} from NXT Reserve. I put together how ${n} would look in the club:\n${linkBeta(token, category, negocio)}\n\nBeing in costs you nothing and doesn't commit you to anything. If you like it, you confirm it yourself from there. If you want to change something, just message me here.`
    : `Hola, soy ${yo}, de NXT Reserve. Te preparé cómo se vería ${n} en el club:\n${linkBeta(token, category, negocio)}\n\nEstar no te cuesta nada y no te compromete a nada. Si te gusta, lo confirmas tú desde ahí. Si quieres cambiar algo, me escribes por aquí.`;
};
const BETA_ESTADO_ROTULO = {
  demo:    ["Demo (solo lo ve su dueño)", "Demo (only the owner sees it)"],
  borroso: ["Difuminado (sin nombre ni logo)", "Blurred (no name or logo)"],
  visible: ["Visible («Coming soon» con nombre y logo)", "Visible (“Coming soon” with name and logo)"],
};

// ---- SIEMBRA EN LOTE (s195 tanda 2): Otto pega ~60 filas desde su hoja ----
// Columnas posicionales, en este orden (la primera fila puede ser un encabezado):
//   nombre · rubro · zona · barrio · ticket por persona · teléfono · instagram · place_id · google_maps_url
// Estos helpers son puros a propósito: se evalúan con node sobre el texto real de este archivo (#710).
const LOTE_COLUMNAS = ["business_name", "category", "zone", "neighborhood", "avg_ticket_usd", "phone", "instagram", "place_id", "google_maps_url"];

// Sin acentos, en minúsculas y sin espacios sobrantes, para comparar rubros y nombres.
const sinAcentos = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase().trim().replace(/\s+/g, " ");

// Rubro escrito a mano → clave de OfferCategory. Acepta la clave, el rótulo del catálogo y alias
// comunes. Fuera de eso devuelve null: la fila queda inválida, no se adivina.
const RUBRO_ALIAS = {
  Restaurant:   ["restaurant", "restaurante", "restaurantes", "comida", "food", "cocina"],
  Salon_Spa:    ["salon_spa", "salon", "salones", "salones/spa", "salon/spa", "spa", "unas", "nails", "nail", "barberia", "barber", "belleza", "beauty", "lashes", "pestanas", "estetica",
                 // s217 · Ali: así viene en las hojas y en Google Maps.
                 "peluqueria", "peluquerias", "hair", "hair salon", "hair studio", "barberias", "barbershop", "barber shop",
                 "salon de belleza", "beauty salon", "manicure", "pedicure", "cejas", "masajes", "massage", "day spa"],
  Bar_Rooftop:  ["bar_rooftop", "bar", "bares", "rooftop", "rooftops", "bares & rooftops", "bares y rooftops", "cocteles", "lounge", "cerveceria"],
  Experience:   ["experience", "experiencia", "experiencias", "tour", "tours", "actividad", "actividades", "paseo"],
  Sweets:       ["sweets", "dulce", "dulces", "heladeria", "heladerias", "dulces & heladerias", "dulces y heladerias", "pasteleria", "cafe", "cafeteria", "postres", "bakery", "panaderia", "reposteria"],
  Gift_Moments: ["gift_moments", "gift", "gifts", "regalo", "regalos", "regalos & momentos", "regalos y momentos", "flores", "floreria", "momentos", "detalles",
    "celebraciones", "celebracion", "hecho a pedido", "tortas", "torta", "globos", "arreglos", "cake shop", "cake_shop"],   // s241 · Celebraciones (+ cake shop, Ali)
};
function normalizarRubro(raw) {
  const k = sinAcentos(raw);
  if (!k) return null;
  for (const [clave, alias] of Object.entries(RUBRO_ALIAS)) {
    if (sinAcentos(clave) === k || sinAcentos(CAT_DISPLAY[clave]) === k || alias.includes(k)) return clave;
  }
  return null;
}

// Texto pegado (TSV, o CSV con «,» o «;») → filas posicionales. Comillas dobles con «""»
// escapadas, delimitadores y saltos de línea dentro de comillas, BOM al inicio, \r\n, filas
// vacías y una primera fila de encabezado: todo se tolera. Un tab en la primera línea con
// contenido decide TSV; si no, gana el más frecuente entre «;» y «,».
function parsearFilasSiembra(texto) {
  let t = String(texto || "");
  if (t.charCodeAt(0) === 0xFEFF) t = t.slice(1);
  t = t.replace(/\r\n?/g, "\n");
  const primera = t.split("\n").find(l => l.trim()) || "";
  const delim = primera.includes("\t") ? "\t"
    : ((primera.split(";").length - 1) > (primera.split(",").length - 1) ? ";" : ",");
  const filas = [];
  let fila = [], celda = "", enComillas = false;
  for (let i = 0; i < t.length; i++) {
    const c = t[i];
    if (enComillas) {
      if (c === '"') { if (t[i + 1] === '"') { celda += '"'; i++; } else enComillas = false; }
      else celda += c;
    } else if (c === '"' && celda === "") {
      enComillas = true;
    } else if (c === delim) {
      fila.push(celda); celda = "";
    } else if (c === "\n") {
      fila.push(celda); filas.push(fila); fila = []; celda = "";
    } else {
      celda += c;
    }
  }
  fila.push(celda); filas.push(fila);
  const limpias = filas.map(f => f.map(x => x.trim())).filter(f => f.some(x => x !== ""));
  if (limpias.length && esEncabezadoOutscraper(limpias[0])) return filasDeOutscraper(limpias);
  const esEncabezado = (f) => /^(nombre|negocio|comercio|business|name)/.test(sinAcentos(f[0]))
    || /^(rubro|categor|category)/.test(sinAcentos(f[1]));
  const datos = limpias.length && esEncabezado(limpias[0]) ? limpias.slice(1) : limpias;
  return datos.map((f, i) => {
    const o = { fila: i + 1 };
    LOTE_COLUMNAS.forEach((k, j) => { o[k] = f[j] || ""; });
    return o;
  });
}

// s217 · el CSV de Outscraper («Raspador de mapas de Google») se pega o se sube TAL CUAL: se reconoce por sus
// encabezados y cada columna se toma por nombre, no por posición. Medido sobre una exportación real (65 columnas,
// 10 peluquerías de Doral): `category` viene en inglés («Hair salon»), `type` en el idioma de la búsqueda,
// `range` vacío en salones, `website` a veces es un Instagram.
const esEncabezadoOutscraper = (f) => {
  const h = f.map(x => sinAcentos(x));
  return h.includes("place_id") && h.includes("name") && (h.includes("business_status") || h.includes("location_link"));
};
// Rubro desde las columnas de Google: primero el alias exacto (category, después type), y si no, por palabra.
// El orden importa: «Bar & grill» y «Restaurant & cafe» son restaurantes.
const RUBRO_POR_PALABRA = [
  ["Restaurant", /\b(restaurant|restaurante|grill|steakhouse|pizzeria|taqueria|diner|food)\b/],
  ["Bar_Rooftop", /\b(bar|pub|lounge|rooftop|brewery|cocktail|cerveceria|cocteleria)\b/],
  ["Sweets", /\b(bakery|ice cream|dessert|pastry|donut|cafe|coffee|heladeria|panaderia|pasteleria|reposteria|cafeteria)\b/],
  ["Salon_Spa", /\b(salon|spa|barber|nail|beauty|hair|lash|brow|esthetic|estetica|peluqueria|barberia|manicura|masaje|massage)\b/],
  // s241 · + globos y fiestas; + «cake shop» / «custom cakes» (Ali: la tienda de tortas es de encargos). Va después de Dulces:
  // «Bakery & cake shop» sigue en Dulces por «bakery»; «cheesecake» no entra (no es «cake shop»).
  ["Gift_Moments", /\b(florist|flower|gift|floreria|regalos?|balloons?|globos?|party|celebrations?|celebraciones?|cake shop|custom cakes?)\b/],
  ["Experience", /\b(tour|escape room|attraction|experience|experiencia)\b/],
];
const rubroDeOutscraper = (category, type) => {
  const exacto = normalizarRubro(category) || normalizarRubro(type);
  if (exacto) return exacto;
  const texto = sinAcentos(`${category} ${type}`);
  const hallado = RUBRO_POR_PALABRA.find(([, re]) => re.test(texto));
  return hallado ? hallado[0] : null;
};
// `range` de Google: «$20–30» / «$100+» → gasto por persona (el ticket del lote es por persona en todos los rubros
// desde s236). «$$» no dice cuánto: queda vacío y se muestra como pista.
const ticketDeRango = (rango, categoria) => {
  const s = String(rango || "").replace(/\s/g, "");
  const m = s.match(/\$?(\d+(?:[.,]\d+)?)[–—-]\$?(\d+(?:[.,]\d+)?)/) || s.match(/\$?(\d+(?:[.,]\d+)?)\+/);
  if (!m) return "";
  const a = Number(m[1].replace(",", ".")), b = m[2] ? Number(m[2].replace(",", ".")) : a;
  const porPersona = (a + b) / 2;
  if (!(porPersona > 0)) return "";
  // s236 · por persona en todos los rubros (antes ×2 en restaurantes y bares). De paso deja de guardarse el ticket al
  // doble en la siembra por lote (`lote-siembra-ticket-por-persona`).
  return String(Math.round(porPersona));
};
const instagramDeWeb = (web) => {
  const m = String(web || "").match(/instagram\.com\/([A-Za-z0-9._]+)/i);
  return m ? "@" + m[1] : "";
};
function filasDeOutscraper(limpias) {
  const h = limpias[0].map(x => sinAcentos(x));
  const col = (f, nombre) => { const j = h.indexOf(nombre); return j >= 0 ? (f[j] || "").trim() : ""; };
  return limpias.slice(1).map((f, i) => {
    const categoria = rubroDeOutscraper(col(f, "category"), col(f, "type"));
    const estado = col(f, "business_status");
    const ciudad = col(f, "city");
    const rango = col(f, "range");
    // s218 · siembra v2: el barrio si Outscraper lo trae (`borough`); si no, la ciudad, como antes.
    const barrio = col(f, "borough");
    const web = col(f, "website") || col(f, "site");
    return {
      fila: i + 1,
      business_name: col(f, "name"),
      // El canónico si se reconoció (la validación lo vuelve a normalizar); si no, lo que dijo Google, para el error.
      category: categoria ? (CAT_DISPLAY[categoria] || categoria) : (col(f, "category") || col(f, "type")),
      zone: barrio || ciudad, neighborhood: barrio || ciudad,
      avg_ticket_usd: ticketDeRango(rango, categoria),
      phone: col(f, "phone"),
      instagram: instagramDeWeb(web),
      // s218 · los 4 de N3. `website` a veces es un Instagram (medido s217): ese va a instagram, no aquí.
      zip: col(f, "postal_code"), city: ciudad,
      address_full: sinPais(col(f, "full_address") || col(f, "address")),
      website: /instagram\.com/i.test(web) ? "" : web,
      place_id: col(f, "place_id"),
      google_maps_url: col(f, "location_link"),
      // Solo para la vista previa:
      outscraper: true, rating: col(f, "rating"), reviews: col(f, "reviews"),
      rango: ticketDeRango(rango, categoria) ? "" : rango,
      cerrado: estado && estado !== "OPERATIONAL" ? estado : "",
    };
  });
}

// Validación por fila: nombre vacío · rubro fuera del option set · ticket no numérico ·
// duplicado dentro del lote (mismo nombre sin acentos, o mismo place_id). Suma el tamaño
// SUGERIDO (A1: gasto por persona; el rubro desempata). El ticket acepta «$», espacios y la
// coma decimal («35,50» → 35.5).
// s217 (Ali) · TRES OPCIONES POR COMERCIO: Prudente · Recomendado · Destacado. Nos conviene que el ticket sea
// relativamente alto (el comercio resalta y el miembro sale ganando), así que el Destacado se muestra como la
// apuesta; Otto elige. Recomendado = el tamaño del gasto por persona (punto medio del rango de Google, si hay);
// Prudente = el del extremo bajo, o un escalón menos; Destacado = un escalón más. Todo dentro de los tamaños del
// rubro y sin la ★ mientras siga bloqueada.
const tamanosDelRubro = (categoria, tipoNegocio) => UMBRAL_TAMANOS
  .filter(t => idsDeTamano(categoria, tipoNegocio).includes(t.id))
  .filter(t => DESTACADA_HABILITADA || t.id !== "D");
// s236 · `tipoNegocio`: comida rápida, café y pizza con los tamaños chicos (idsDeTamano).
function opcionesDeTamano(categoria, porPersona, porPersonaBajo, tipoNegocio) {
  const lista = tamanosDelRubro(categoria, tipoNegocio);
  if (!lista.length) return null;
  const rec = sinDestacada(sugerirTamanoUmbral(categoria, porPersona || 0, tipoNegocio));
  if (!rec) return null;
  const i = lista.findIndex(t => t.id === rec.id);
  const bajo = porPersonaBajo > 0 ? sinDestacada(sugerirTamanoUmbral(categoria, porPersonaBajo, tipoNegocio)) : null;
  const prudente = bajo && bajo.id !== rec.id ? bajo : (i > 0 ? lista[i - 1] : rec);
  const destacado = i >= 0 && i < lista.length - 1 ? lista[i + 1] : rec;
  return { prudente: prudente.id, recomendado: rec.id, destacado: destacado.id };
}
// s250 · cuánto se aparta el tamaño elegido de la tabla para ese ticket. El guion deja un escalón si el dueño lo pide.
// `pasos` > 0: más grande que lo recomendado. `enRubro` false: ese tamaño no existe en el rubro.
const desvioDeTabla = (categoria, porPersona, tipoNegocio, idElegido) => {
  const lista = tamanosDelRubro(categoria, tipoNegocio);
  const rec = sinDestacada(sugerirTamanoUmbral(categoria, porPersona, tipoNegocio));
  const i = lista.findIndex(t => t.id === idElegido);
  return { rec, enRubro: i >= 0, pasos: i - lista.findIndex(t => t.id === rec?.id) };
};
// Sin rango, el nivel de precio de Google da un gasto por persona APROXIMADO. La tabla es nuestra (Google no
// trae montos con el nivel): punto de partida para que Otto confirme, y se rotula «aproximado».
const NIVEL_PRECIO_POR_PERSONA = {
  PRICE_LEVEL_INEXPENSIVE: 15, PRICE_LEVEL_MODERATE: 30, PRICE_LEVEL_EXPENSIVE: 60, PRICE_LEVEL_VERY_EXPENSIVE: 100,
};
// Respuesta de placePrecio → { porPersona, porPersonaBajo, fuente, rangoTexto } o null si Google no dio precio.
function precioDeGoogle(p) {
  if (!p) return null;
  if (p.desde > 0) {
    const hasta = p.hasta > 0 ? p.hasta : p.desde;
    return { porPersona: (p.desde + hasta) / 2, porPersonaBajo: p.desde, fuente: "google_rango",
      rangoTexto: p.hasta > 0 ? `$${p.desde}–${p.hasta}` : `$${p.desde}+` };
  }
  const aprox = NIVEL_PRECIO_POR_PERSONA[p.nivel];
  if (aprox) return { porPersona: aprox, porPersonaBajo: 0, fuente: "google_nivel", rangoTexto: "" };
  return null;
}

function validarFilasSiembra(filas) {
  const vistosNombre = new Map();
  const vistosPlace = new Map();
  return filas.map(f => {
    const errores = [];
    const nombre = String(f.business_name || "").trim();
    if (!nombre) errores.push("nombre vacío");
    // s217 · Outscraper: solo los abiertos (Ali). Los demás quedan a la vista como omitidos, con el motivo.
    if (f.cerrado) errores.push(f.cerrado === "CLOSED_TEMPORARILY" ? "cerrado temporalmente en Google"
      : f.cerrado === "CLOSED_PERMANENTLY" ? "cerrado en Google" : `en Google: ${f.cerrado}`);
    const category = normalizarRubro(f.category);
    if (!category) errores.push(f.category ? `rubro «${f.category}» fuera del catálogo` : "rubro vacío");
    const ticketRaw = String(f.avg_ticket_usd || "").replace(/[$\s]/g, "").replace(",", ".");
    const ticket = ticketRaw === "" ? 0 : Number(ticketRaw);
    if (ticketRaw !== "" && !(ticket > 0)) errores.push(`ticket «${f.avg_ticket_usd}» no es un número`);
    const kNombre = sinAcentos(nombre);
    if (kNombre) {
      if (vistosNombre.has(kNombre)) errores.push(`duplicado de la fila ${vistosNombre.get(kNombre)} (mismo nombre)`);
      else vistosNombre.set(kNombre, f.fila);
    }
    const place = String(f.place_id || "").trim();
    if (place) {
      if (vistosPlace.has(place)) errores.push(`duplicado de la fila ${vistosPlace.get(place)} (mismo place_id)`);
      else vistosPlace.set(place, f.fila);
    }
    // s199-D2: en el lote, igual que en la siembra de a una, la ★ se propone como XL.
    // s216 · el ticket de la hoja de Otto es POR MESA DE DOS en restaurantes y bares (HOJA_OTTO s212 §4,
    // s215): se divide igual que en la siembra de a uno. Antes el lote lo tomaba por persona y proponía
    // el tamaño del doble.
    const sugerido = category ? sinDestacada(sugerirTamanoUmbral(category, ticketPorPersona(category, ticket))) : null;
    const opciones = category ? opcionesDeTamano(category, ticketPorPersona(category, ticket), 0) : null;
    return { ...f, business_name: nombre, categoryRaw: String(f.category || ""), category, ticket, tamano: sugerido ? sugerido.id : "",
      opciones, fuenteTicket: ticket > 0 ? "hoja" : "sin_dato", errores };
  });
}
// El título genérico sale del tamaño («Ahorra $X cuando gastas $2X»; desde s214 también la Chica).
const tituloDeTamano = (id) => { const t = UMBRAL_TAMANOS.find(x => x.id === id); return t ? fraseUmbral(t.monto, t.minimo, false) : ""; };
// s238 · lote-salones-en-porcentaje: en el lote, salones y «Hecho a pedido» siembran como la siembra de a uno (s237-D3):
// porcentaje del rubro, sin tope. El tamaño de la fila se ignora en esas filas.
const filaEnPorcentaje = (f) => RUBROS_PCT_RECOMENDADO.includes(f?.category);
const tituloFilaPct = (categoria) => tituloPorcentaje(PCT_SALON.pct, TOPE_SIN_LIMITE, false, categoria);

// s213 · lote B+C · los dos selectores, iguales en la siembra, en la corrección de Otto y en la
// edición del comercio. `vacio` = la etiqueta del chip sin valor («Ninguno» al sembrar, «Sin cambio»
// al corregir: en operator_update_offer lo que no viene no cambia). Chips del alta (alta.css).
// s252-D2 · `tipoNegocio`: con él (alta del dueño) «una vez al día» sale solo en TIPOS_DIARIOS, salvo que la oferta ya lo tenga.
// Sin él (consola de Otto) se ofrecen todos los plazos, como antes.
function SelectorPlazo({ id, valor, onCambio, en, vacio, tipoNegocio }) {
  const chip = (on) => ["alta-chip", on && "alta-chip--on"].filter(Boolean).join(" ");
  return (
    <div className="alta-campo">
      <AltaEtiqueta para={id} texto={en ? "How often the same member can come back" : "Cada cuánto vuelve el mismo miembro"}
        pista={en ? "It counts from midnight Miami time. If they come back sooner, they pay full price." : "Se cuenta desde la medianoche de Miami. Si vuelve antes, paga completo."} />
      <div id={id} role="group" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {vacio && <button type="button" className={chip(!valor)} aria-pressed={!valor} onClick={() => onCambio("")}>{vacio}</button>}
        {PLAZOS_COOLDOWN.filter(d => d !== 1 || tipoNegocio === undefined || TIPOS_DIARIOS.includes(tipoNegocio) || Number(valor) === 1).map(d => (
          <button key={d} type="button" className={chip(Number(valor) === d)} aria-pressed={Number(valor) === d} onClick={() => onCambio(String(d))}>
            {etiquetaPlazo(d, en)}
          </button>
        ))}
      </div>
    </div>
  );
}
// s222 · lote 2a · el canal de canje, con los mismos chips. Solo manda los tres valores de CANALES_CANJE.
function SelectorCanal({ id, valor, onCambio, en }) {
  const chip = (on) => ["alta-chip", on && "alta-chip--on"].filter(Boolean).join(" ");
  return (
    <div className="alta-campo">
      <AltaEtiqueta para={id} texto={en ? "Where the offer is valid" : "Dónde vale la oferta"}
        pista={en ? "Members read it in the rules before they go." : "El miembro lo lee en las reglas antes de ir."} />
      <div id={id} role="group" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {CANALES_CANJE.map(c => (
          <button key={c.id} type="button" className={chip(valor === c.id)} aria-pressed={valor === c.id} onClick={() => onCambio(c.id)}>
            {en ? c.en : c.es}
          </button>
        ))}
      </div>
    </div>
  );
}
function SelectorPlan({ id, valor, onCambio, en, vacio, categoria }) {
  const chip = (on) => ["alta-chip", on && "alta-chip--on"].filter(Boolean).join(" ");
  return (
    <div className="alta-campo">
      <AltaEtiqueta para={id} texto={en ? "Plan (optional)" : "Plan (opcional)"}
        pista={en ? "The label above the name on the card: what the outing is for." : "La etiqueta arriba del nombre en la tarjeta: para qué salida es."} />
      <div id={id} role="group" style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
        {vacio && <button type="button" className={chip(!valor)} aria-pressed={!valor} onClick={() => onCambio("")}>{vacio}</button>}
        {planesDelRubro(categoria).map(p => (
          <button key={p.id} type="button" className={chip(valor === p.id)} aria-pressed={valor === p.id} onClick={() => onCambio(p.id)}>
            {en ? p.en : p.es}
          </button>
        ))}
      </div>
    </div>
  );
}
// s213 · lote B+C · CORREGIR UNA OFERTA SEMBRADA (operator_update_offer). Para lo que Otto sembró
// antes del deploy, lo que adoptó con una oferta previa (adopt no escribe nada ahí) y lo propio del
// lugar que va en «Lo que incluye». Lo que queda en «Sin cambio» / vacío NO viaja y no cambia:
// get_seeded_merchants no devuelve plan, plazo ni destacados, así que no hay valor actual que mostrar.
function CorregirOfertaSembrada({ fila, en, onCerrar }) {
  const [plazo, setPlazo] = useState("");
  const [plan, setPlan] = useState("");
  const [destacados, setDestacados] = useState(["", "", ""]);
  const [tamano, setTamano] = useState("");   // s217 · 2bis: «» = sin cambio
  const [franja, setFranja] = useState(null); // s217 · 2bis: null = sin cambio
  // s227 · `operator-update-offer-foto` (export 138, param #13 `image`): la foto de la oferta. null = sin cambio ·
  // { url } = una de la galería del comercio · { file } = una nueva, ya encuadrada (WebP, s206).
  const [foto, setFoto] = useState(null);
  const [porEncuadrar, setPorEncuadrar] = useState(null);
  const galeria = (fila.gallery_urls || []).map(u => (String(u).startsWith("//") ? "https:" + u : String(u))).filter(Boolean);
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState(null);   // { ok, texto }
  const nada = !plazo && !plan && !destacados.some(d => d.trim()) && !tamano && !franja && !foto;
  const guardar = async () => {
    setEnviando(true); setMsg(null);
    try {
      // s217 · tamaño y horario solo con la oferta en Pending (si no, OFFER_NOT_PENDING). El título sigue al tamaño.
      const t = UMBRAL_TAMANOS.find(x => x.id === tamano);
      // La de la galería viaja como URL (Bubble acepta una URL en un param de archivo); la nueva, como { filename, contents }.
      let image = null;
      if (foto && foto.file) {
        image = await imagenParaCrearOferta(foto.file).catch(() => null);
        if (!image) throw Object.assign(new Error(en ? "We couldn't read the photo. Pick another one." : "No pudimos leer la foto. Elige otra."), { code: "FOTO_ILEGIBLE" });
      } else if (foto && foto.url) image = foto.url;
      await operatorUpdateOffer({ offer_id: fila.offer_id, plan, cooldown_days: plazo, image,
        highlight_1_es: destacados[0], highlight_2_es: destacados[1], highlight_3_es: destacados[2],
        ...(t ? { offer_title_es: fraseUmbral(t.monto, t.minimo, false), benefit_value_usd: t.monto, min_consumption: t.minimo } : {}),
        ...(franja || {}) });
      setMsg({ ok: true, texto: en ? "Saved. The listing shows it once the offer is approved." : "Guardado. La ficha lo muestra cuando la oferta esté aprobada." });
    } catch (e) {
      setMsg({ ok: false, texto: mensajeLoteBC(e?.code, en) || (e?.code === "WF_NOT_DEPLOYED"
        ? (en ? "That workflow isn't in Live yet (pending deploy)." : "Ese workflow todavía no está en Live (falta el deploy).")
        : (e?.message || (en ? "Something failed." : "Algo falló."))) });
    } finally {
      setEnviando(false);
    }
  };
  return (
    <section style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: 16, background: "var(--superficie-tarjeta)" }} aria-label={en ? "Fix the offer" : "Corregir la oferta"}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline", flexWrap: "wrap" }}>
        <div>
          <div style={{ ...S.display, fontSize: 18, color: C.black }}>{en ? "FIX THE OFFER" : "CORREGIR LA OFERTA"} · {fila.business_name}</div>
          <div style={{ fontSize: 12, color: C.muted }}>{en ? "Only what you change is saved. The rest stays as it is." : "Se guarda solo lo que cambies. Lo demás queda como está."}</div>
        </div>
        <button type="button" onClick={onCerrar} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>✕</button>
      </div>
      {!fila.offer_id ? (
        <p style={{ fontSize: 13, color: C.gray, marginTop: 12 }}>
          {en ? "This row has no offer id (it comes from this browser's local list). Refresh the list." : "Esta fila no tiene el id de la oferta (viene de la lista local de este navegador). Actualiza la lista."}
        </p>
      ) : (
        <>
          {/* s217 · 2bis (export 114): mientras el dueño no confirma, Otto corrige el tamaño y el horario. */}
          <SelectorTamanoOferta id={`corr-tam-${fila.offer_id}`} en={en} categoria={fila.category} valor={tamano} onCambio={setTamano}
            vacio={en ? `No change (now: ${fila.offer_title || "—"})` : `Sin cambio (hoy: ${fila.offer_title || "—"})`} />
          {!esEncargo(fila.category) && <SelectorFranja id={`corr-franja-${fila.offer_id}`} en={en} valor={franja} onCambio={setFranja} conSinCambio />}
          <SelectorPlazo id={`corr-plazo-${fila.offer_id}`} en={en} valor={plazo} vacio={en ? "No change" : "Sin cambio"} onCambio={setPlazo} />
          <SelectorPlan id={`corr-plan-${fila.offer_id}`} en={en} categoria={fila.category} valor={plan} vacio={en ? "No change" : "Sin cambio"} onCambio={setPlan} />
          {/* s227 · la foto de la oferta: las sembradas sin foto salen con el logo. Una de la galería o una nueva. */}
          <div className="alta-campo">
            <AltaEtiqueta para={`corr-foto-${fila.offer_id}`} texto={en ? "Offer photo" : "Foto de la oferta"}
              pista={en ? "Without its own photo, the offer shows the logo. Pick one from the gallery or upload a new one." : "Sin foto propia, la oferta sale con el logo. Elige una de la galería o sube una nueva."} />
            <div className="alta-wiz__foto-oferta-lista" role="group" aria-label={en ? "Offer photo" : "Foto de la oferta"}>
              <button type="button" className={["alta-chip", !foto && "alta-chip--on"].filter(Boolean).join(" ")} onClick={() => setFoto(null)}>
                {en ? "No change" : "Sin cambio"}
              </button>
              {galeria.map((u, i) => (
                <button key={u} type="button" className="alta-wiz__foto-oferta-opcion" aria-pressed={!!foto && foto.url === u}
                  aria-label={en ? `Gallery photo ${i + 1}` : `Foto ${i + 1} de la galería`} onClick={() => setFoto({ url: u })}>
                  <img src={u} alt="" />
                </button>
              ))}
              {foto && foto.file && <span className="alta-ayuda" style={{ alignSelf: "center" }}>📷 {foto.file.name || (en ? "New photo" : "Foto nueva")}</span>}
            </div>
            <input id={`corr-foto-${fila.offer_id}`} className="alta-input alta-input--archivo" type="file" accept="image/*" style={{ marginTop: 8 }}
              aria-label={en ? "Upload a new photo" : "Subir una foto nueva"}
              onChange={e => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setPorEncuadrar(f); }} />
            {porEncuadrar && (
              <EncuadrarFoto key={`corr-${porEncuadrar.name}-${porEncuadrar.size}`} file={porEncuadrar} proporcion={1} en={en}
                titulo={en ? "Frame the photo" : "Encuadra la foto"}
                onListo={(f) => { setFoto({ file: f }); setPorEncuadrar(null); }}
                onCancelar={() => setPorEncuadrar(null)} />
            )}
          </div>
          <div className="alta-campo">
            <AltaEtiqueta para={`corr-dest-${fila.offer_id}`} texto={en ? "What's included (optional)" : "Lo que incluye (opcional)"}
              pista={en ? "Only what is special about the place: award-winning chef, bay view. Not the dish or the hours: those are already in «About this offer»." : "Solo lo propio del lugar: chef premiado, vista a la bahía. No el plato ni el horario: eso ya está en «Sobre esta oferta»."} />
            {destacados.map((d, i) => (
              <input key={i} id={i === 0 ? `corr-dest-${fila.offer_id}` : undefined} className="alta-input" style={{ marginTop: i ? 6 : 0 }}
                value={d} placeholder={en ? "No change" : "Sin cambio"}
                onChange={e => setDestacados(ds => ds.map((x, j) => (j === i ? e.target.value : x)))} />
            ))}
          </div>
          <button type="button" onClick={guardar} disabled={enviando || nada} style={{ ...S.btnPrimary, width: "auto", padding: "10px 16px", fontSize: 13, marginTop: 12 }}>
            {enviando ? "…" : (en ? "Save" : "Guardar")}
          </button>
          {msg && <div role="status" style={{ fontSize: 13, marginTop: 10, color: msg.ok ? "var(--exito)" : "var(--error)" }}>{msg.texto}</div>}
        </>
      )}
    </section>
  );
}

// Un mensaje por cada error del lote B+C (salas S1-S3) y de 2bis (s217, export 114).
const mensajeLoteBC = (code, en) => ({
  INVALID_COOLDOWN: en ? "Pick how often the same member can come back: once a day, or every 7, 15, 30, 60 or 90 days." : "Elige cada cuánto puede volver el mismo miembro: una vez al día, o cada 7, 15, 30, 60 o 90 días.",
  OFFER_NOT_FOUND: en ? "We can't find that offer anymore. Reload the list." : "Ya no encontramos esa oferta. Recarga la lista.",
  NOT_OPERATOR: en ? "Your user isn't an operator or admin." : "Tu usuario no es operador ni admin.",
  OFFER_NOT_PENDING: en ? "The owner already confirmed this offer: the size and hours can no longer be changed from here. Ask the owner (Change something)." : "El dueño ya confirmó esta oferta: el tamaño y el horario ya no se cambian desde aquí. Que lo cambie el dueño («Quiero cambiar algo»).",
  OFFER_BENEFIT_INVALID: en ? "The amount has to be more than $0." : "El monto tiene que ser mayor a $0.",
  OFFER_SIZE_INVALID: en ? "The savings and the minimum don't match the size table. Pick a size from the list." : "El ahorro y el mínimo no coinciden con la tabla de tamaños. Elige un tamaño de la lista.",
  TOO_MANY_OFFERS: en ? "This business already has 4 offers. Archive one first." : "Este comercio ya tiene 4 ofertas. Archiva una primero.",
  MERCHANT_NOT_FOUND: en ? "We can't find this business. Reload the list." : "No encontramos este comercio. Recarga la lista.",
  NOT_SEEDED: en ? "This business wasn't seeded from the console." : "Este comercio no se sembró desde la consola.",
  MERCHANT_REJECTED: en ? "This business was rejected." : "Este comercio está rechazado.",
  // s221 · export 125: el piso del % (create_offer, update_offer, operator_add_offer) y el tipo de la siembra.
  OFFER_PCT_TOO_LOW: en ? "The club minimum is 20%." : "El mínimo del club es 20 %.",
  OFFER_TYPE_INVALID: en ? "The offer type has to be Standard or Percentage." : "El tipo de oferta tiene que ser «Estándar» o «Porcentaje».",
  PLAN_NAME_INVALID: en ? "Pick a plan name from the list: Aliado NXT, Invitado VIP or Travel Guest." : "Elige un nombre de plan de la lista: Aliado NXT, Invitado VIP o Travel Guest.",
  // s230 · adopt-visible-sin-foto (export 142): adopt_merchant frena «visible» sin foto, como operator_set_beta_state.
  PHOTO_REQUIRED: en ? "To make it Visible it needs a photo first (Photos → + Add photo)." : "Para dejarlo Visible primero necesita una foto (Fotos → + Agregar foto).",
}[String(code || "")] || "");
// s230 · adopt-visible-sin-foto: lo que ve Otto cuando pidió «visible» y el comercio quedó en Demo por no tener foto.
const NOTA_SIN_FOTO = (en) => en
  ? "Left in Demo: it has no photo, and without one it doesn't show in the catalog. Add one from the list (Photos → + Add photo) and switch it to Visible."
  : "Quedó en Demo: no tiene foto y sin foto no sale en el catálogo. Súbele una desde la lista (Fotos → + Agregar foto) y pásalo a Visible.";
// s232 · siembra-foto-obligatoria-con-invitacion (versión blanda, Ali): un sembrado en Demo/Difuminado sin foto no se frena,
// pero se avisa. La foto es lo primero que ve el dueño en su panel (tarjeta «Fotos en camino») y la invitación sale con la
// genérica del rubro. Misma nota en el resultado del sembrado y, como marca, junto al enlace de la fila.
const NOTA_INVITACION_SIN_FOTO = (en) => en
  ? "No photo yet: the owner will see «Photos on the way» in their panel, and the invitation shows the generic photo for the category. Add one from the list (Photos → + Add photo) before sending the link."
  : "Sin foto: el dueño verá «Fotos en camino» en su panel y la invitación sale con la foto genérica del rubro. Súbela desde la lista (Fotos → + Agregar foto) antes de mandarle el enlace.";
// Fila de Sembrados sin foto: con get_seeded_merchants manda la galería; un sembrado recién hecho (solo en caché) lleva `sin_foto`.
const filaSinFoto = (r) => (Array.isArray(r?.gallery_urls) ? r.gallery_urls.length === 0 : r?.sin_foto === true);

// s217 · 2bis · LA FRANJA DE UNA OFERTA (días + horario) para «+ Otra franja» y «Corregir oferta». Mismo
// formato que create_offer: días «Lun,Mar,…» y horas «HH:MM». Los atajos son los del alta del dueño (s215,
// nota 7 de Otto). `valor` = { valid_days, valid_time_start, valid_time_end } o null (sin cambio).
// s239 · auditoría s237-D4: sin «Happy hour» (el descuento no toca el alcohol). Una oferta vieja de 16:00–19:00 se sigue
// mostrando con su hora; solo deja de ofrecerse como atajo.
const FRANJAS_OFERTA = [
  { key: "almuerzo", es: "Almuerzo", en: "Lunch", ini: "11:30", fin: "15:00" },
  { key: "cena", es: "Cena", en: "Dinner", ini: "18:00", fin: "23:00" },
];
// s233 · los días de una franja, cortos: «Lun–Mar», «Mié–Vie», «Sáb, Dom», «Lun–Mié, Vie»; vacío = todos los días.
// Tramos seguidos de 3+ días van con guion; de 1 o 2, por nombre.
// s239 · E4 · «Lun–Vie · 18:00–23:00» para «Mis ofertas». Días vacíos = todos (como create_offer); sin horas, solo los días.
function cuandoValeCorto(offer, en) {
  // Pueden llegar en lista o por comas, y con restos de la era texto libre («Lun - Jue»): normalizeValidDays los lee.
  // Si llegó algo y no se reconoció ningún día, se muestra tal cual (no se inventa «todos los días»).
  const crudos = (Array.isArray(offer?.valid_days) ? offer.valid_days : String(offer?.valid_days || "").split(","))
    .map(t => String(t || "").trim()).filter(Boolean);
  const dias = normalizeValidDays(crudos);
  const ini = normalizeValidTime(offer?.valid_time_start), fin = normalizeValidTime(offer?.valid_time_end);
  const etiquetas = en ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES;
  const d = !dias && crudos.length ? crudos.join(" · ") : diasCortos(dias, etiquetas, en);
  const textoDias = d === "Todos los días" ? "todos los días" : d === "Every day" ? "every day" : d;
  return ini && fin ? `${textoDias} · ${ini}–${fin}` : textoDias;
}
function diasCortos(dias, etiquetas, en) {
  const idx = String(dias || "").split(",").map(t => FEED_DAY_TOKENS.indexOf(t.trim())).filter(i => i >= 0).sort((a, b) => a - b);
  if (!idx.length || idx.length === 7) return en ? "Every day" : "Todos los días";
  const tramos = [];
  idx.forEach(i => { const t = tramos[tramos.length - 1]; if (t && i === t[1] + 1) t[1] = i; else tramos.push([i, i]); });
  return tramos.map(([a, b]) => (b - a >= 2 ? `${etiquetas[a]}–${etiquetas[b]}` : b > a ? `${etiquetas[a]}, ${etiquetas[b]}` : etiquetas[a])).join(", ");
}
// s235 · franja-dias-cerrados (Ali: «el martes marcado y Google dice cerrado»): los días de una franja recortados a los
// que abre el negocio según Google (`abiertos` = «Lun,Mie,…»). Sin Google, o si el recorte deja la franja sin días, quedan
// como venían. "" (todos los días) pasa a los días que abre.
function soloDiasAbiertos(dias, abiertos) {
  const ab = String(abiertos || "").split(",").filter(Boolean);
  if (!ab.length || ab.length === 7) return dias || "";
  if (!dias) return ab.join(",");
  const r = String(dias).split(",").filter(d => ab.includes(d));
  return r.length ? r.join(",") : dias;
}
const mismaFranja = (a, b) => !!a && !!b && String(a.valid_days || "") === String(b.valid_days || "")
  && a.valid_time_start === b.valid_time_start && a.valid_time_end === b.valid_time_end;
// s233 · `franjas` (opcional): las del NEGOCIO que leyó la IA ({ key, nombre, ini, fin, dias, sugerida }). Si vienen,
// reemplazan a las fijas (que eran iguales para todos) y al tocarlas ponen también sus días; la sugerida va marcada.
// s235 · `abiertos` (opcional, los días que abre según Google): los chips de esas franjas ponen solo días abiertos, el día
// cerrado se ve tachado y, si Otto lo marca igual, un aviso con «Quitar».
function SelectorFranja({ id, en, valor, onCambio, conSinCambio = false, franjas = null, abiertos = "", rangos = null }) {
  const v = valor || { valid_days: "", valid_time_start: "", valid_time_end: "" };
  const dias = new Set(String(v.valid_days || "").split(",").filter(Boolean));
  const etiquetas = en ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES;
  const chip = (on) => ["alta-chip", on && "alta-chip--on"].filter(Boolean).join(" ");
  const poner = (parche) => onCambio({ ...v, ...parche });
  const listaAbiertos = String(abiertos || "").split(",").filter(Boolean);
  const cerrados = listaAbiertos.length ? FEED_DAY_TOKENS.filter(t => !listaAbiertos.includes(t)) : [];
  const marcadosCerrados = cerrados.filter(t => dias.has(t));
  const nombresDe = (lista) => lista.map(t => etiquetas[FEED_DAY_TOKENS.indexOf(t)]).join(", ");
  const toggleDia = (t) => { const n = new Set(dias); n.has(t) ? n.delete(t) : n.add(t); poner({ valid_days: FEED_DAY_TOKENS.filter(x => n.has(x)).join(",") }); };
  return (
    <div className="alta-campo">
      <AltaEtiqueta para={id} texto={en ? "When it applies" : "Cuándo vale"} />
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {conSinCambio && (
          <button type="button" className={chip(!valor)} onClick={() => onCambio(null)}>{en ? "No change" : "Sin cambio"}</button>
        )}
        {franjas && franjas.length > 0
          ? franjas.map(f => {
            // s233 · Pera Soho: la IA partió la cena por grupos de días y salían tres chips «Cena» sin decir cuál era cuál.
            // Si el nombre se repite, el chip lleva también los días («Cena · Lun–Mar»). Activo = horas Y días iguales.
            const repetido = franjas.filter(x => x.nombre === f.nombre).length > 1;
            const dias = repetido ? diasCortos(f.dias, etiquetas, en) : "";
            return (
            <button key={f.key} type="button" className={chip(valor && v.valid_time_start === f.ini && v.valid_time_end === f.fin && (!repetido || String(v.valid_days || "") === soloDiasAbiertos(f.dias, abiertos)))}
              onClick={() => poner({ valid_time_start: f.ini, valid_time_end: f.fin, valid_days: soloDiasAbiertos(f.dias, abiertos) })}
              title={f.dias ? f.dias.split(",").map(t => etiquetas[FEED_DAY_TOKENS.indexOf(t)] || t).join(" ") : (en ? "Every day" : "Todos los días")}
              aria-label={`${f.nombre}${dias ? ` ${dias}` : ""} ${f.ini}–${f.fin}${f.sugerida ? (en ? ", suggested" : ", sugerida") : ""}`}>
              {f.sugerida && <span aria-hidden="true">★ </span>}{f.nombre}{dias && <> · {dias}</>} <span style={{ opacity: 0.7, fontWeight: 400 }}>{f.ini}–{f.fin}</span>
            </button>
            );
          })
          : FRANJAS_OFERTA.map(f => franjaDentroDelHorario(f, rangos)).filter(Boolean).map(f => (
          <button key={f.key} type="button" className={chip(valor && v.valid_time_start === f.ini && v.valid_time_end === f.fin)}
            onClick={() => poner(f.dias !== undefined ? { valid_time_start: f.ini, valid_time_end: f.fin, valid_days: f.dias } : { valid_time_start: f.ini, valid_time_end: f.fin })}>
            {en ? f.en : f.es} <span style={{ opacity: 0.7, fontWeight: 400 }}>{f.ini}–{f.fin}</span>
          </button>
        ))}
      </div>
      {valor && (
        <>
          <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 8, fontSize: 13, flexWrap: "wrap" }}>
            <input id={id} type="time" className="alta-input" style={{ width: "auto" }} value={v.valid_time_start}
              onChange={e => poner({ valid_time_start: e.target.value })} aria-label={en ? "From" : "Desde"} />
            <span>–</span>
            <input type="time" className="alta-input" style={{ width: "auto" }} value={v.valid_time_end}
              onChange={e => poner({ valid_time_end: e.target.value })} aria-label={en ? "To" : "Hasta"} />
          </div>
          <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginTop: 8 }}>
            {FEED_DAY_TOKENS.map((t, i) => {
              const cerrado = cerrados.includes(t);
              return (
                <button key={t} type="button" className={chip(dias.has(t))} onClick={() => toggleDia(t)}
                  title={cerrado ? (en ? "Closed according to Google" : "Cerrado según Google") : undefined}
                  aria-label={cerrado ? `${etiquetas[i]}, ${en ? "closed according to Google" : "cerrado según Google"}` : undefined}
                  style={cerrado ? { textDecoration: "line-through" } : undefined}>{etiquetas[i]}</button>
              );
            })}
          </div>
          <div style={{ fontSize: 11, color: C.muted, marginTop: 4 }}>
            {en ? "No days marked = every day." : "Sin días marcados = todos los días."}
            {cerrados.length > 0 && (en ? ` Crossed out = closed according to Google.` : ` Tachado = cerrado según Google.`)}
          </div>
          {marcadosCerrados.length > 0 && (
            <div role="status" style={{ fontSize: 12, color: "var(--error)", marginTop: 6, display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <span>{en ? `Google says it's closed on ${nombresDe(marcadosCerrados)}: the offer shouldn't apply that day.` : `Google dice que cierra el ${nombresDe(marcadosCerrados)}: la oferta no debería valer ese día.`}</span>
              {/* Si solo quedaban días cerrados, pasa a los días que abre (vacío sería «todos los días»). */}
              <button type="button" className="alta-chip" onClick={() => poner({ valid_days: FEED_DAY_TOKENS.filter(x => dias.has(x) && !cerrados.includes(x)).join(",") || listaAbiertos.join(",") })}>
                {en ? "Remove" : "Quitar"}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
// s218 · siembra v2: el horario de Google (regularOpeningHours) → los días que abre, en el formato de valid_days
// («Lun,Mar,…»), y un texto corto para mostrarlo («Lun–Vie 11:00–22:00 · Sáb 12:00–23:00 · Dom cerrado»).
// Google numera los días desde el domingo (0); FEED_DAY_TOKENS empieza el lunes. null si Google no da horario.
function horarioDeGoogle(regular, en) {
  const periods = periodosDeGoogle(regular);
  if (!periods.length) return null;
  const hhmm = (pt) => (pt == null) ? "" : `${String(pt.hour ?? 0).padStart(2, "0")}:${String(pt.minute ?? 0).padStart(2, "0")}`;
  const porDia = FEED_DAY_TOKENS.map(() => []);
  // s235 · franjas-dentro-del-horario: los mismos tramos en minutos ([abre, cierra], cierre pasada la medianoche = +1440).
  const rangos = FEED_DAY_TOKENS.map(() => []);
  const mins = (pt) => (pt == null ? 0 : (pt.hour ?? 0) * 60 + (pt.minute ?? 0));
  periods.forEach(p => {
    const g = p?.open?.day;
    if (g == null) return;
    const i = (g + 6) % 7;   // domingo 0 → posición 6
    // Abierto las 24 horas: Google manda solo `open` (00:00) sin `close`.
    // s241 (banco de casos, Hibachi Miami): un tramo también puede cruzar días enteros — «viernes 11:30 → domingo 00:00» es como
    // Google dice «sábado: Abierto las 24 horas». Antes todo caía en el viernes y el sábado salía «cerrado» (y sin día en la
    // oferta). Ahora el día de apertura va hasta la medianoche, los días del medio son 24 horas y el de cierre, desde las 00:00.
    const cruza = p.close && p.close.day != null ? (p.close.day - g + 7) % 7 : 0;
    if (cruza >= 2) {
      const o0 = mins(p.open);
      porDia[i].push(`${hhmm(p.open)}–00:00`); rangos[i].push([o0, 1440]);
      for (let k = 1; k < cruza; k++) { const j = (i + k) % 7; porDia[j].push(en ? "24 h" : "24 horas"); rangos[j].push([0, 1440]); }
      const jc = (i + cruza) % 7, c0 = mins(p.close);
      if (c0 > 0) { porDia[jc].push(`00:00–${hhmm(p.close)}`); rangos[jc].push([0, c0]); }
      return;
    }
    porDia[i].push(p.close ? `${hhmm(p.open)}–${hhmm(p.close)}` : (en ? "24 h" : "24 horas"));
    const o = mins(p.open), c = p.close ? mins(p.close) : 1440;
    rangos[i].push([o, c <= o ? c + 1440 : c]);
  });
  const dias = FEED_DAY_TOKENS.filter((_, i) => porDia[i].length).join(",");
  const etiquetas = en ? FEED_DAY_LABELS_EN : FEED_DAY_LABELS_ES;
  const grupos = [];
  porDia.forEach((rangos, i) => {
    const texto = rangos.length ? rangos.join(", ") : (en ? "closed" : "cerrado");
    const ult = grupos[grupos.length - 1];
    if (ult && ult.texto === texto && ult.hasta === i - 1) ult.hasta = i;
    else grupos.push({ desde: i, hasta: i, texto });
  });
  const texto = grupos.map(g => `${etiquetas[g.desde]}${g.hasta > g.desde ? `–${etiquetas[g.hasta]}` : ""} ${g.texto}`).join(" · ");
  return { dias, texto, rangos };
}

// s235 · franjas-dentro-del-horario (Graze Craze: «Cena 18:00–23:00» con Google cerrando a las 17:00). Sin IA, las franjas
// fijas de la siembra (almuerzo, happy hour, cena) se ajustan al horario de Google: en cada día, lo que la franja pisa del
// horario; vale el día si son 60 minutos o más. Sin ningún día así, la franja no se ofrece. La hora sale del día que más
// cubre (recortada a ese día) y los días, de los que alcanzan. Sin horario de Google, las franjas quedan como siempre.
const minutosAHora = (m) => { const x = ((m % 1440) + 1440) % 1440; return `${String(Math.floor(x / 60)).padStart(2, "0")}:${String(x % 60).padStart(2, "0")}`; };
function franjaDentroDelHorario(f, rangos) {
  if (!Array.isArray(rangos) || !rangos.some(r => r && r.length)) return f;
  const ini = minutosDe(f.ini), fin = minutosDe(f.fin);
  if (ini === null || fin === null) return f;
  // Cada día propone su tramo (lo que la franja pisa de su horario, 60 min o más). Para cada tramo, los días que lo tienen
  // abierto ENTERO (Brasas abre a las 18 el lunes: el happy hour 16–19 no va ese día). Gana el que cubre más horas × días
  // (una pizzería: cena 18–21 los siete días antes que 18–22 solo viernes y sábado); empate, el más largo.
  const diasDe = (t) => FEED_DAY_TOKENS.filter((_, i) => (rangos[i] || []).some(([o, c]) => o <= t[0] && c >= t[1]));
  let mejor = null, dias = [];
  rangos.forEach(r => (r || []).forEach(([o, c]) => {
    const t = [Math.max(ini, o), Math.min(fin, c)];
    if (t[1] - t[0] < 60) return;
    const d = diasDe(t), puntos = (t[1] - t[0]) * d.length, puntosMejor = mejor ? (mejor[1] - mejor[0]) * dias.length : -1;
    if (puntos > puntosMejor || (puntos === puntosMejor && t[1] - t[0] > mejor[1] - mejor[0])) { mejor = t; dias = d; }
  }));
  if (!mejor || !dias.length) return null;
  return { ...f, ini: minutosAHora(mejor[0]), fin: minutosAHora(mejor[1]), dias: dias.length === 7 ? "" : dias.join(",") };
}

// El tamaño de la oferta en la consola: los del rubro (sin la ★ bloqueada). `vacio` = «Sin cambio».
function SelectorTamanoOferta({ id, en, categoria, valor, onCambio, vacio }) {
  return (
    <div className="alta-campo">
      <AltaEtiqueta para={id} texto={en ? "Size" : "Tamaño"} />
      <select id={id} className="alta-input" value={valor} onChange={e => onCambio(e.target.value)}>
        {vacio && <option value="">{vacio}</option>}
        {tamanosDelRubro(categoria).map(t => (
          <option key={t.id} value={t.id}>{t.id} · {fraseUmbral(t.monto, t.minimo, false)}</option>
        ))}
      </select>
    </div>
  );
}

// s217 · 2bis · «+ OTRA FRANJA»: una segunda (tercera, cuarta) oferta para un comercio sembrado, con su
// horario. operator_add_offer (export 114): nace Pending y la confirma el dueño, como la primera.
function OtraFranjaSembrado({ fila, en, onCerrar, onCreada }) {
  const categoria = fila.category;
  const [tamano, setTamano] = useState(() => {
    const opc = opcionesDeTamano(categoria, 0, 0);
    return opc ? opc.destacado : "";
  });
  const [franja, setFranja] = useState({ valid_days: "", valid_time_start: "18:00", valid_time_end: "23:00" });
  const [plazo, setPlazo] = useState(String(plazoDelRubro(categoria)));   // s233 · el del rubro
  const [canal, setCanal] = useState(() => canalDelRubro(categoria));   // s222 · operator_add_offer lo recibe (export 127)
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState(null);
  // s221-D1 · la siembra también ofrece «Porcentaje» (operator_add_offer, export 125): desde 20 %, con tope o sin tope.
  // La estándar sigue siendo lo primero que propone Otto. s236 (Ali) · en salones, spa y barberías arranca en porcentaje,
  // 25 % (RUBROS_PCT_RECOMENDADO / PCT_SALON); s237-D3 · sin tope.
  const esSalonPct = RUBROS_PCT_RECOMENDADO.includes(categoria);
  const [tipo, setTipo] = useState(esSalonPct ? "percent" : UMBRAL_TIPO);
  const [pct, setPct] = useState(esSalonPct ? String(PCT_SALON.pct) : String(PCT_DEFECTO));   // s236 · 25 % sin tope fuera de salones
  const [tope, setTope] = useState(esSalonPct ? String(PCT_SALON.tope) : "25");
  const [sinTope, setSinTope] = useState(true);   // s236 · sin tope; s237-D3 · salones también
  const [pidiendoSinTope, setPidiendoSinTope] = useState(false);   // s221 · «Sin tope» pide confirmación
  const esPct = tipo === "percent";
  const pctNum = Number(pct) || 0;
  const topeNum = sinTope ? TOPE_SIN_LIMITE : (Number(tope) || 0);
  const errorPct = !esPct ? "" : pctNum < PCT_MINIMO ? mensajeLoteBC("OFFER_PCT_TOO_LOW", en)
    : pctNum > 100 ? (en ? "The percentage can't be more than 100." : "El porcentaje no puede pasar de 100.")
    : !(topeNum > 0) ? (en ? "Write the cap per visit, or tick “No cap”." : "Escribe el tope por visita, o marca «Sin tope».") : "";
  const nombreFranja = (FRANJAS_OFERTA.find(f => f.ini === franja.valid_time_start && f.fin === franja.valid_time_end) || {})[en ? "en" : "es"]
    || `${franja.valid_time_start}–${franja.valid_time_end}`;
  const crear = async () => {
    const t = UMBRAL_TAMANOS.find(x => x.id === tamano);
    if (!esPct && !t) return;
    if (!franja.valid_time_start || !franja.valid_time_end) { setMsg({ ok: false, texto: en ? "Pick the hours." : "Elige el horario." }); return; }
    if (errorPct) { setMsg({ ok: false, texto: errorPct }); return; }
    setEnviando(true); setMsg(null);
    try {
      await operatorAddOffer(esPct
        ? { merchant_id: fila.merchant_id, offer_title_es: `${tituloPorcentaje(pctNum, topeNum, false, fila.category)} · ${nombreFranja}`,
            offer_type: "percent", discount_pct: pctNum, benefit_value_usd: topeNum, cooldown_days: plazo, redemption_channel: canal, ...franja }
        : { merchant_id: fila.merchant_id, offer_title_es: `${fraseUmbral(t.monto, t.minimo, false)} · ${nombreFranja}`,
            benefit_value_usd: t.monto, min_consumption: t.minimo, cooldown_days: plazo, redemption_channel: canal, ...franja });
      setMsg({ ok: true, texto: en ? "Added. The owner confirms it like the first one." : "Agregada. El dueño la confirma igual que la primera." });
      if (onCreada) onCreada();
    } catch (e) {
      setMsg({ ok: false, texto: mensajeLoteBC(e?.code, en) || (e?.code === "WF_NOT_DEPLOYED"
        ? (en ? "That workflow isn't in Live yet (pending deploy)." : "Ese workflow todavía no está en Live (falta el deploy).")
        : (e?.message || (en ? "Something failed." : "Algo falló."))) });
    } finally {
      setEnviando(false);
    }
  };
  return (
    <section style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: 16, background: "var(--superficie-tarjeta)" }} aria-label={en ? "Another time slot" : "Otra franja"}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline", flexWrap: "wrap" }}>
        <div>
          <div style={{ ...S.display, fontSize: 18, color: C.black }}>{en ? "ANOTHER TIME SLOT" : "OTRA FRANJA"} · {fila.business_name}</div>
          <div style={{ fontSize: 12, color: C.muted }}>
            {en ? "Another offer for another time (lunch, dinner). Up to 4 per business." : "Otra oferta para otro horario (almuerzo, cena). Hasta 4 por comercio."}
          </div>
        </div>
        <button type="button" onClick={onCerrar} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>✕</button>
      </div>
      <SelectorFranja id={`franja-${fila.merchant_id}`} en={en} valor={franja} onCambio={v => setFranja(v || franja)} />
      <fieldset style={{ border: "none", padding: 0, margin: "10px 0 0" }}>
        <legend style={{ fontSize: 12, color: C.muted, marginBottom: 4 }}>{en ? "Offer type" : "Tipo de oferta"}</legend>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", fontSize: 13 }}>
          <label style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
            <input type="radio" name={`franja-tipo-${fila.merchant_id}`} checked={!esPct} onChange={() => setTipo(UMBRAL_TIPO)} />
            {en ? "Standard" : "Estándar"}
          </label>
          <label style={{ display: "flex", gap: 6, alignItems: "center", cursor: "pointer" }}>
            <input type="radio" name={`franja-tipo-${fila.merchant_id}`} checked={esPct} onChange={() => setTipo("percent")} />
            {en ? "Percentage" : "Porcentaje"}
          </label>
        </div>
      </fieldset>
      {!esPct && <SelectorTamanoOferta id={`franja-tam-${fila.merchant_id}`} en={en} categoria={categoria} valor={tamano} onCambio={setTamano} />}
      {esPct && (
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap", alignItems: "flex-end", marginTop: 10 }}>
          <label style={{ fontSize: 12, color: C.muted }}>
            {en ? "% off (min. 20)" : "% de descuento (mín. 20)"}
            <input type="number" min={PCT_MINIMO} max="100" step="1" inputMode="numeric" value={pct} onChange={e => setPct(e.target.value)}
              style={{ ...S.input, display: "block", width: 90, fontSize: 13, padding: "6px 8px", marginTop: 2 }} />
          </label>
          {!sinTope && (
            <label style={{ fontSize: 12, color: C.muted }}>
              {en ? `Cap per ${perfilDelRubro(fila.category).visita.en} ($)` : `Tope por ${perfilDelRubro(fila.category).visita.es} ($)`}
              <input type="number" min="1" inputMode="decimal" value={tope} onChange={e => setTope(e.target.value)}
                style={{ ...S.input, display: "block", width: 100, fontSize: 13, padding: "6px 8px", marginTop: 2 }} />
            </label>
          )}
          <label style={{ display: "flex", gap: 6, alignItems: "center", fontSize: 13, cursor: "pointer", paddingBottom: 6 }}>
            <input type="checkbox" checked={sinTope}
              onChange={e => { if (e.target.checked) { setPidiendoSinTope(true); return; } setPidiendoSinTope(false); setSinTope(false); }} />
            {en ? "No cap" : "Sin tope"}
          </label>
        </div>
      )}
      {esPct && pidiendoSinTope && !sinTope && (
        <div role="alertdialog" style={{ fontSize: 13, marginTop: 8, padding: 10, border: `1px solid ${C.border}`, borderRadius: 6 }}>
          <div style={{ marginBottom: 8 }}>{avisoSinTope(en)}</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <button type="button" onClick={() => { setPidiendoSinTope(false); setSinTope(true); }}
              style={{ ...S.btnPrimary, width: "auto", padding: "6px 12px", fontSize: 12 }}>{en ? "Yes" : "Sí"}</button>
            <button type="button" onClick={() => setPidiendoSinTope(false)}
              style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 12px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
              {en ? "I'll set a cap" : "Mejor pongo un tope"}
            </button>
          </div>
        </div>
      )}
      <SelectorPlazo id={`franja-plazo-${fila.merchant_id}`} en={en} valor={plazo} onCambio={setPlazo} />
      {!esEncargo(categoria) && <SelectorCanal id={`franja-canal-${fila.merchant_id}`} en={en} valor={canal} onCambio={setCanal} />}
      {(esPct ? pctNum > 0 : tamano) && (
        <div style={{ fontSize: 13, color: C.gray, marginTop: 8 }}>
          {en ? "Title:" : "Título:"} <b style={{ color: C.black }}>{esPct ? tituloPorcentaje(pctNum, topeNum, false, fila.category) : tituloDeTamano(tamano)} · {nombreFranja}</b>
        </div>
      )}
      {esPct && errorPct && <div role="status" style={{ fontSize: 13, marginTop: 6, color: "var(--error)" }}>{errorPct}</div>}
      <button type="button" onClick={crear} disabled={enviando || (esPct ? !!errorPct : !tamano)} style={{ ...S.btnPrimary, width: "auto", padding: "10px 16px", fontSize: 13, marginTop: 12 }}>
        {enviando ? "…" : (en ? "Add offer" : "Agregar oferta")}
      </button>
      {msg && <div role="status" style={{ fontSize: 13, marginTop: 10, color: msg.ok ? "var(--exito)" : "var(--error)" }}>{msg.texto}</div>}
    </section>
  );
}

// ---- s218 · MINI CRM DE LLAMADAS (export 117, salas N4/N5) ----
// Pedido: claude/siembra/PEDIDO_CODE_s217_siembra_v2.md §3 (llamada de Ali con Otto, s217). Bubble guarda
// `outcome` y `pipeline_stage` como texto: aquí viajan los códigos y se muestran las etiquetas.
// `etapa` = la etapa que se propone al elegir ese resultado ("" = no la cambia).
const OUTCOMES_LLAMADA = [
  { id: "no_contesto", es: "No contestó", en: "No answer", etapa: "" },
  { id: "buzon", es: "Buzón de voz", en: "Voicemail", etapa: "" },
  { id: "hablo_empleado", es: "Habló con un empleado", en: "Spoke with staff", etapa: "contactado" },
  { id: "hablo_decisor", es: "Habló con quien decide", en: "Spoke with the decision maker", etapa: "contactado" },
  { id: "volver_a_llamar", es: "Pidió que lo llamen después", en: "Asked for a call back", etapa: "contactado" },
  { id: "interesado", es: "Está interesado", en: "Interested", etapa: "interesado" },
  { id: "reunion_agendada", es: "Reunión agendada", en: "Meeting booked", etapa: "reunion" },
  { id: "aprobo", es: "Aprobó", en: "Approved", etapa: "aprobado" },
  { id: "no_interesa", es: "No le interesa", en: "Not interested", etapa: "" },
];
const ETAPAS_CRM = [
  { id: "nuevo", es: "Nuevo", en: "New" },
  { id: "contactado", es: "Contactado", en: "Contacted" },
  { id: "interesado", es: "Interesado", en: "Interested" },
  { id: "reunion", es: "Reunión", en: "Meeting" },
  { id: "aprobado", es: "Aprobado", en: "Approved" },
  { id: "descartado", es: "Descartado", en: "Discarded" },
];
const MOTIVOS_DESCARTE = [
  { es: "No le interesa", en: "Not interested" },
  { es: "Cerró o no existe", en: "Closed or doesn't exist" },
  { es: "No es el perfil del club", en: "Not a fit for the club" },
  { es: "Nunca contesta", en: "Never answers" },
  { es: "Está duplicado", en: "Duplicate" },
];
const etiquetaOutcome = (id, en) => { const o = [...OUTCOMES_LLAMADA, ...OUTCOMES_VERIFICAR].find(x => x.id === id); return o ? o[en ? "en" : "es"] : (id || ""); };
const etiquetaEtapa = (id, en) => { const e = ETAPAS_CRM.find(x => x.id === (id || "nuevo")); return e ? e[en ? "en" : "es"] : id; };
// Fin del día de hoy en la hora del navegador (Otto está en Miami): «Hoy toca llamar» = próxima ≤ esto.
const finDeHoy = () => { const d = new Date(); d.setHours(23, 59, 59, 999); return d.getTime(); };
// «YYYY-MM-DD» de dentro de N días, en hora local (lo que pide un <input type="date">).
const fechaInputEn = (dias) => {
  const d = new Date(); d.setDate(d.getDate() + dias);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const fechaCorta = (ms, en) => ms
  ? new Date(ms).toLocaleDateString(en ? "en-US" : "es-US", { weekday: "short", day: "numeric", month: "short" })
  : "";
// Teléfono para el enlace tel: en formato +1… (E.164). Un número de 10 dígitos es de EE. UU.
function telE164(t) {
  const s = String(t || "").trim();
  if (!s) return "";
  const dig = s.replace(/\D/g, "");
  if (s.startsWith("+")) return `+${dig}`;
  if (dig.length === 10) return `+1${dig}`;
  if (dig.length === 11 && dig.startsWith("1")) return `+${dig}`;
  return dig;
}
const mensajeCrm = (code, en) => ({
  NOT_OPERATOR: en ? "Only an operator can do this." : "Esto solo lo puede hacer un operador.",
  MERCHANT_NOT_FOUND: en ? "We can't find this business anymore. Refresh the list." : "Ya no encontramos este comercio. Actualiza la lista.",
  HAS_OWNER: en ? "This business already has an owner: it can't be discarded from here." : "Este comercio ya tiene dueño: no se descarta desde aquí.",
  NOT_YOURS: en ? "You can only discard the businesses you seeded." : "Solo puedes descartar los comercios que sembraste tú.",
  WF_NOT_DEPLOYED: en ? "That workflow isn't in Live yet." : "Ese workflow todavía no está en Live.",
  NO_SESSION: en ? "Your session expired. Sign in again." : "Tu sesión venció. Entra de nuevo.",
}[code] || "");

// s227 · `outcomes`: la lista «Por verificar» trae sus propios resultados (OUTCOMES_VERIFICAR); onGuardada(outcome).
function RegistrarLlamada({ fila, en, onCerrar, onGuardada, outcomes = OUTCOMES_LLAMADA }) {
  const [outcome, setOutcome] = useState("");
  const [etapa, setEtapa] = useState(fila.pipeline_stage || "");
  const [etapaTocada, setEtapaTocada] = useState(false);
  const [campos, setCampos] = useState({ spoke_with: "", decision_maker: "", approved_by: "", notes: "" });
  const [proxima, setProxima] = useState("");
  const [historial, setHistorial] = useState(undefined);   // undefined = cargando · null = no se pudo
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState(null);
  const tel = telE164(fila.phone);

  const cargarHistorial = useCallback(async () => {
    try { setHistorial(await getCallLog(fila.merchant_id)); } catch (e) { setHistorial(null); }
  }, [fila.merchant_id]);
  useEffect(() => { cargarHistorial(); }, [cargarHistorial]);

  const elegirOutcome = (id) => {
    setOutcome(id);
    const o = outcomes.find(x => x.id === id);
    if (!etapaTocada && o && o.etapa) setEtapa(o.etapa);
  };
  const guardar = async () => {
    if (!outcome) { setMsg({ ok: false, texto: en ? "Pick how the call went." : "Elige cómo fue la llamada." }); return; }
    setEnviando(true); setMsg(null);
    try {
      await operatorLogCall({
        merchant_id: fila.merchant_id, outcome, ...campos,
        approved_by: outcome === "aprobo" ? campos.approved_by : "",
        pipeline_stage: etapa && etapa !== (fila.pipeline_stage || "") ? etapa : "",
        // La hora es lo de menos: 9:00 de ese día, en la hora de Otto.
        next_call_at: proxima ? new Date(`${proxima}T09:00:00`).toISOString() : "",
      });
      setMsg({ ok: true, texto: en ? "Call saved." : "Llamada guardada." });
      const guardado = outcome;
      setOutcome(""); setCampos({ spoke_with: "", decision_maker: "", approved_by: "", notes: "" }); setProxima(""); setEtapaTocada(false);
      cargarHistorial();
      if (onGuardada) onGuardada(guardado);
    } catch (e) {
      setMsg({ ok: false, texto: mensajeCrm(e?.code, en) || e?.message || (en ? "Something failed." : "Algo falló.") });
    } finally {
      setEnviando(false);
    }
  };
  const campo = (k, es, enLabel, ph) => (
    <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12, color: C.gray, flex: "1 1 180px" }}>
      {en ? enLabel : es}
      <input className="alta-input" value={campos[k]} placeholder={ph} onChange={e => setCampos({ ...campos, [k]: e.target.value })} style={{ padding: "8px 10px", fontSize: 13 }} />
    </label>
  );
  const btnChico = { background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 };

  return (
    <section style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: 16, background: "var(--superficie-tarjeta)" }} aria-label={en ? "Log a call" : "Registrar llamada"}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline", flexWrap: "wrap" }}>
        <div>
          <div style={{ ...S.display, fontSize: 18, color: C.black }}>{en ? "LOG A CALL" : "REGISTRAR LLAMADA"} · {fila.business_name}</div>
          <div style={{ fontSize: 12, color: C.muted }}>
            {etiquetaEtapa(fila.pipeline_stage, en)}
            {tel ? <> · <a href={`tel:${tel}`} style={{ color: "var(--exito)", fontWeight: 600 }}>{en ? "Call" : "Llamar"} {fila.phone}</a></> : (en ? " · no phone" : " · sin teléfono")}
          </div>
        </div>
        <button type="button" onClick={onCerrar} style={btnChico}>✕</button>
      </div>

      <div style={{ fontSize: 12, color: C.gray, margin: "14px 0 6px" }}>{en ? "How did it go?" : "¿Cómo fue?"}</div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }} role="radiogroup" aria-label={en ? "Call result" : "Resultado de la llamada"}>
        {outcomes.map(o => (
          <button key={o.id} type="button" role="radio" aria-checked={outcome === o.id} onClick={() => elegirOutcome(o.id)}
            style={{ ...btnChico, color: outcome === o.id ? C.white : C.gray, background: outcome === o.id ? C.black : "none", borderColor: outcome === o.id ? C.black : C.border }}>
            {o[en ? "en" : "es"]}
          </button>
        ))}
      </div>
      {outcome === "no_interesa" && (
        <div style={{ fontSize: 12, color: C.muted, marginTop: 8 }}>
          {en ? "If it's a no for good, use «Discard» after saving." : "Si es un no definitivo, después de guardar usa «Descartar»."}
        </div>
      )}

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 14 }}>
        {campo("spoke_with", "Habló con", "Spoke with", en ? "Name and role" : "Nombre y cargo")}
        {campo("decision_maker", "Quién decide", "Decision maker", en ? "Name and role" : "Nombre y cargo")}
        {outcome === "aprobo" && campo("approved_by", "Aprobó", "Approved by", en ? "Who said yes" : "Quién dijo que sí")}
      </div>
      <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12, color: C.gray, marginTop: 10 }}>
        {en ? "Notes" : "Notas"}
        <textarea className="alta-input" rows={2} value={campos.notes} onChange={e => setCampos({ ...campos, notes: e.target.value })} style={{ padding: "8px 10px", fontSize: 13, resize: "vertical" }} />
      </label>

      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 10, alignItems: "flex-end" }}>
        <label style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12, color: C.gray }}>
          {en ? "Next call" : "Próxima llamada"}
          <input className="alta-input" type="date" value={proxima} min={fechaInputEn(0)} onChange={e => setProxima(e.target.value)} style={{ padding: "7px 10px", fontSize: 13 }} />
        </label>
        {[[1, en ? "Tomorrow" : "Mañana"], [3, en ? "In 3 days" : "En 3 días"], [7, en ? "In a week" : "En una semana"]].map(([d, t]) => (
          <button key={d} type="button" onClick={() => setProxima(fechaInputEn(d))} style={{ ...btnChico, color: proxima === fechaInputEn(d) ? "var(--exito)" : C.gray }}>{t}</button>
        ))}
        {proxima && <button type="button" onClick={() => setProxima("")} style={{ ...btnChico, color: C.muted }}>{en ? "No date" : "Sin fecha"}</button>}
        {/* s238 · ayudas V51: la etapa es de Otto (la mueve el resultado); el estado Aprobado lo da el panel. Sin <label> envolvente:
            un botón de pista dentro de una etiqueta se dispara al tocarla (ver AltaEtiqueta). */}
        <div style={{ display: "flex", flexDirection: "column", gap: 4, fontSize: 12, color: C.gray, marginLeft: "auto" }}>
          <span>{en ? "Stage" : "Etapa"} <AltaPista texto={en ? "It moves on its own with the outcome you pick. Change it by hand only if the outcome doesn't describe it. \"Approved\" here is a yes on the phone: the business becomes Approved when it confirms from its panel." : "Se mueve sola con el resultado que elijas. Cámbiala a mano solo si el resultado no la describe. «Aprobó» aquí es un sí por teléfono: el comercio queda Aprobado cuando confirma desde su panel."} /></span>
          <select aria-label={en ? "Stage" : "Etapa"} value={etapa || "nuevo"} onChange={e => { setEtapa(e.target.value); setEtapaTocada(true); }}
            style={{ padding: "7px 10px", fontSize: 13, border: `1px solid ${C.border}`, borderRadius: 2, color: C.gray, background: C.white }}>
            {ETAPAS_CRM.filter(x => x.id !== "descartado").map(x => <option key={x.id} value={x.id}>{x[en ? "en" : "es"]}</option>)}
          </select>
        </div>
      </div>

      <button type="button" onClick={guardar} disabled={enviando || !outcome} style={{ ...S.btnPrimary, width: "auto", padding: "10px 16px", fontSize: 13, marginTop: 14 }}>
        {enviando ? "…" : (en ? "Save call" : "Guardar llamada")}
      </button>
      {msg && <div role="status" style={{ fontSize: 13, marginTop: 10, color: msg.ok ? "var(--exito)" : "var(--error)" }}>{msg.texto}</div>}

      <div style={{ borderTop: `1px solid ${C.border}`, marginTop: 16, paddingTop: 12 }}>
        <div style={{ fontSize: 12, fontWeight: 700, color: C.black, marginBottom: 8 }}>
          {en ? "History" : "Historial"}{Array.isArray(historial) ? ` · ${historial.length}` : ""}
        </div>
        {historial === undefined && <div style={{ fontSize: 12, color: C.muted }}>{en ? "Loading…" : "Cargando…"}</div>}
        {historial === null && <div style={{ fontSize: 12, color: "var(--error)" }}>{en ? "We couldn't load the history." : "No se pudo cargar el historial."}</div>}
        {Array.isArray(historial) && historial.length === 0 && <div style={{ fontSize: 12, color: C.muted }}>{en ? "No calls yet." : "Todavía no hay llamadas."}</div>}
        {Array.isArray(historial) && historial.length > 0 && (
          <ol style={{ listStyle: "none", margin: 0, padding: 0, display: "flex", flexDirection: "column", gap: 10 }}>
            {historial.map((c, i) => (
              <li key={i} style={{ fontSize: 12, color: C.gray, lineHeight: 1.5 }}>
                <b style={{ color: C.black }}>{etiquetaOutcome(c.outcome, en)}</b>
                <span style={{ color: C.muted }}> · {c.called_at ? new Date(c.called_at).toLocaleString(en ? "en-US" : "es-US", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" }) : ""}{c.by ? ` · ${c.by}` : ""}</span>
                {(c.spoke_with || c.decision_maker || c.approved_by) && (
                  <div>
                    {c.spoke_with && <>{en ? "Spoke with" : "Habló con"} {c.spoke_with}. </>}
                    {c.decision_maker && <>{en ? "Decides:" : "Decide:"} {c.decision_maker}. </>}
                    {c.approved_by && <>{en ? "Approved:" : "Aprobó:"} {c.approved_by}.</>}
                  </div>
                )}
                {c.notes && <div style={{ whiteSpace: "pre-wrap" }}>{c.notes}</div>}
                {c.next_call_at > 0 && <div style={{ color: C.muted }}>{en ? "Next call:" : "Próxima llamada:"} {fechaCorta(c.next_call_at, en)}</div>}
              </li>
            ))}
          </ol>
        )}
      </div>
    </section>
  );
}

function DescartarSembrado({ fila, en, onCerrar, onHecho, esAdmin }) {
  const [motivo, setMotivo] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState(null);
  const descartar = async () => {
    if (!motivo.trim()) { setMsg({ ok: false, texto: en ? "Write the reason." : "Escribe el motivo." }); return; }
    setEnviando(true); setMsg(null);
    try {
      await operatorDiscardMerchant(fila.merchant_id, motivo);
      setMsg({ ok: true, texto: en ? "Discarded." : "Descartado." });
      if (onHecho) onHecho();
    } catch (e) {
      setMsg({ ok: false, codigo: e?.code || "", texto: mensajeCrm(e?.code, en) || e?.message || (en ? "Something failed." : "Algo falló.") });
    } finally {
      setEnviando(false);
    }
  };
  const btnChico = { background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 };
  return (
    <section style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: 16, background: "var(--superficie-tarjeta)" }} aria-label={en ? "Discard" : "Descartar"}>
      <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "baseline", flexWrap: "wrap" }}>
        <div>
          <div style={{ ...S.display, fontSize: 18, color: C.black }}>{en ? "DISCARD" : "DESCARTAR"} · {fila.business_name}</div>
          <div style={{ fontSize: 12, color: C.muted }}>
            {en ? "It leaves the showcase, its pending offers are archived and it stays as «Discarded» with the reason."
                : "Sale de la vitrina, sus ofertas pendientes se archivan y queda como «Descartado» con el motivo."}
          </div>
        </div>
        <button type="button" onClick={onCerrar} style={btnChico}>✕</button>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 }}>
        {MOTIVOS_DESCARTE.map(m => (
          <button key={m.es} type="button" onClick={() => setMotivo(m[en ? "en" : "es"])}
            style={{ ...btnChico, color: motivo === m[en ? "en" : "es"] ? C.white : C.gray, background: motivo === m[en ? "en" : "es"] ? C.black : "none" }}>
            {m[en ? "en" : "es"]}
          </button>
        ))}
      </div>
      <input className="alta-input" value={motivo} onChange={e => setMotivo(e.target.value)} placeholder={en ? "Or write it" : "O escríbelo"}
        aria-label={en ? "Reason" : "Motivo"} style={{ marginTop: 10, padding: "8px 10px", fontSize: 13, width: "100%", boxSizing: "border-box" }} />
      <button type="button" onClick={descartar} disabled={enviando || !motivo.trim() || msg?.ok}
        style={{ ...S.btnPrimary, width: "auto", padding: "10px 16px", fontSize: 13, marginTop: 12, background: "var(--error)", borderColor: "var(--error)" }}>
        {enviando ? "…" : (en ? "Discard" : "Descartar")}
      </button>
      {msg && <div role="status" style={{ fontSize: 13, marginTop: 10, color: msg.ok ? "var(--exito)" : "var(--error)" }}>{msg.texto}</div>}
      {/* s238 · con dueño se rechaza en Admin (s237-D4): el Admin va directo a ese comercio; el operador sabe a quién pedírselo. */}
      {msg && msg.codigo === "HAS_OWNER" && (esAdmin
        ? <a href={`/admin/merchants?q=${encodeURIComponent(fila.business_name || "")}`} style={{ display: "inline-block", fontSize: 13, marginTop: 6, color: C.red, fontWeight: 700 }}>
            {en ? "Reject it from Admin →" : "Rechazar desde Admin →"}
          </a>
        : <div style={{ fontSize: 12, marginTop: 6, color: C.gray }}>
            {en ? "Ask an Admin to reject it (Admin → Merchants → Reject)." : "Pídele a un Admin que lo rechace (Admin → Comercios → Rechazar)."}
          </div>)}
    </section>
  );
}

// ============================================================================================
// s227 · `lista-por-verificar` (pase s227, PEDIDO de Cowork 14:27 UTC): «se registran 20 hoy y hay que llamar a 15».
// Los self-serve sin aprobar (get_signups_to_verify · bTJsz, export 137), alta más vieja primero. La llamada usa el
// MISMO panel de los sembrados (RegistrarLlamada → getCallLog + operator_log_call), con los resultados de esta lista.
// Aprobar sigue siendo de Ali en Admin → Merchants.
// ============================================================================================
const OUTCOMES_VERIFICAR = [
  { id: "verificado", es: "Verificado: es del negocio", en: "Verified: it's the business", etapa: "contactado" },
  { id: "no_contesto", es: "No contesta", en: "No answer", etapa: "" },
  { id: "buzon", es: "Buzón de voz", en: "Voicemail", etapa: "" },
  { id: "volver_a_llamar", es: "Pidió que lo llamen después", en: "Asked for a call back", etapa: "contactado" },
  { id: "no_es_del_negocio", es: "No es del negocio", en: "Not the business", etapa: "" },
];
const diasDesde = (ms) => (ms ? Math.max(0, Math.floor((Date.now() - ms) / 86400000)) : null);
const textoAltaHace = (ms, en) => {
  const d = diasDesde(ms);
  if (d === null) return "";
  if (d === 0) return en ? "signed up today" : "se registró hoy";
  if (d === 1) return en ? "signed up yesterday" : "se registró ayer";
  return en ? `signed up ${d} days ago` : `se registró hace ${d} días`;
};
const TEXTO_CANAL = { llamada: ["Llamada", "Call"], whatsapp: ["WhatsApp", "WhatsApp"], correo: ["Correo", "Email"], email: ["Correo", "Email"], sms: ["SMS", "SMS"] };

function TarjetaPorVerificar({ r, en, abierta, listo, onLlamar, onGuardada }) {
  const t = (es, ing) => (en ? ing : es);
  const telG = telE164(r.phone);
  const telD = telE164(r.decision_maker_phone || r.contact_phone);
  const canal = TEXTO_CANAL[String(r.contact_channel || "").toLowerCase()];
  return (
    <article className="pv-tarjeta">
      <div className="pv-tarjeta__cabeza">
        <div>
          <div className="pv-tarjeta__nombre">{r.business_name || t("(sin nombre)", "(no name)")}</div>
          <div className="pv-tarjeta__meta">
            {[textoAltaHace(r.created_at, en), etiquetaEtapa(r.pipeline_stage, en), r.status].filter(Boolean).join(" · ")}
          </div>
        </div>
        {listo && <span className="pv-tarjeta__listo">{t("Listo para aprobar", "Ready to approve")}</span>}
      </div>
      <dl className="pv-tarjeta__datos">
        <div><dt>{t("Dueño", "Owner")}</dt><dd>
          {r.owner_name || "—"}{r.owner_email ? <> · <a href={`mailto:${r.owner_email}`}>{r.owner_email}</a></> : null}{" "}
          <span className={r.email_verified ? "pv-correo pv-correo--ok" : "pv-correo"}>
            {r.email_verified ? t("correo confirmado ✓", "email confirmed ✓") : t("correo sin confirmar", "email not confirmed")}
          </span>
        </dd></div>
        {/* Sin place_id (alta manual) el teléfono es el que escribió en el alta, no el de Google: se dice. */}
        <div><dt>{r.place_id ? t("Teléfono de Google", "Google phone") : t("Teléfono del negocio (del alta, sin Google)", "Business phone (from sign-up, no Google)")}</dt><dd>
          {telG ? <a href={`tel:${telG}`} className="pv-tel">{r.phone}</a> : t("sin teléfono", "no phone")}
        </dd></div>
        {(telD || r.decision_maker_name || r.contact_role) && (
          <div><dt>{t("Directo", "Direct")}</dt><dd>
            {[r.decision_maker_name, r.contact_role].filter(Boolean).join(" · ")}
            {telD ? <> {r.decision_maker_name || r.contact_role ? "· " : ""}<a href={`tel:${telD}`} className="pv-tel">{r.decision_maker_phone || r.contact_phone}</a></> : null}
          </dd></div>
        )}
        {(r.contact_best_time || canal) && (
          <div><dt>{t("Prefiere", "Prefers")}</dt><dd>{[r.contact_best_time, canal && canal[en ? 1 : 0]].filter(Boolean).join(" · ")}</dd></div>
        )}
        <div><dt>{t("1.ª oferta", "1st offer")}</dt><dd>
          {r.offer_title ? <>{r.offer_title}{r.offer_status ? ` · ${r.offer_status}` : ""}{r.offers_count > 1 ? t(` (+${r.offers_count - 1} más)`, ` (+${r.offers_count - 1} more)`) : ""}</> : t("todavía sin oferta", "no offer yet")}
        </dd></div>
        {(r.google_maps_url || r.google_website || r.website) && (
          <div><dt>{t("Enlaces", "Links")}</dt><dd className="pv-enlaces">
            {r.google_maps_url && <a href={r.google_maps_url} target="_blank" rel="noopener noreferrer">Google Maps ↗</a>}
            {(r.google_website || r.website) && <a href={extUrlPv(r.google_website || r.website)} target="_blank" rel="noopener noreferrer">{t("Su web", "Website")} ↗</a>}
          </dd></div>
        )}
        {r.discard_reason && <div><dt>{t("Descartado", "Discarded")}</dt><dd>{r.discard_reason}</dd></div>}
        {r.last_call_at > 0 && <div><dt>{t("Última llamada", "Last call")}</dt><dd>{fechaCorta(r.last_call_at, en)}</dd></div>}
      </dl>
      <div className="pv-tarjeta__acciones">
        <button type="button" className="mrc-boton" onClick={onLlamar} aria-expanded={abierta}>
          {abierta ? t("Cerrar", "Close") : t("Registrar llamada", "Log a call")}
        </button>
      </div>
      {abierta && (<>
        {/* s238 · ayudas V55: el guion antes de marcar «Verificado» (único filtro contra comercios falsos). Visible, no en un globo:
            son cuatro pasos para leer mientras se llama. */}
        <div className="alta-ayuda" style={{ marginTop: 10, lineHeight: 1.5 }}>{en
          ? "Before marking \"Verified\", confirm by phone: 1) the number is the business's (call the one on Google, not the one they typed); 2) who you're talking to and whether they're the owner or the decision-maker; 3) they asked to join the club and recognize the sign-up email; 4) the address and name match Google. If anything is off: \"Not the business\"."
          : "Antes de marcar «Verificado», confirma por teléfono: 1) que el número es el del negocio (llama al que está en Google, no al que escribieron); 2) quién te atiende y si es el dueño o quien decide; 3) que ellos pidieron entrar al club y reconocen el correo del alta; 4) que la dirección y el nombre coinciden con Google. Si algo no cuadra: «No es del negocio»."}</div>
        <RegistrarLlamada key={r.merchant_id} fila={r} en={en} outcomes={OUTCOMES_VERIFICAR} onCerrar={onLlamar} onGuardada={onGuardada} />
      </>)}
    </article>
  );
}
const extUrlPv = (u) => (/^https?:\/\//i.test(String(u)) ? u : `https://${u}`);

function PorVerificar({ en }) {
  const t = (es, ing) => (en ? ing : es);
  const [lista, setLista] = useState(undefined);   // undefined cargando · null error
  const [error, setError] = useState("");
  const [verDescartados, setVerDescartados] = useState(false);
  const [abierta, setAbierta] = useState("");
  const [verificadosAhora, setVerificadosAhora] = useState({});   // merchant_id → true, en esta sesión
  const cargar = useCallback(async () => {
    setError("");
    try { setLista(await getSignupsToVerify()); }
    catch (e) { setLista(null); setError(mensajeCrm(e?.code, en) || e?.message || t("No pudimos traer la lista.", "We couldn't load the list.")); }
  }, [en]);   // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { cargar(); }, [cargar]);

  const todos = lista || [];
  const descartados = todos.filter(r => r.discard_reason);
  const vista = verDescartados ? todos : todos.filter(r => !r.discard_reason);
  const pendientes = todos.length - descartados.length;
  // «Listo para aprobar»: la última llamada fue «verificado». `last_outcome` viene en la lista desde el export 138
  // (bTJsz, «» sin llamadas); lo de esta sesión cubre el rato entre guardar y recargar.
  const esListo = (r) => r.last_outcome === "verificado" || !!verificadosAhora[r.merchant_id];

  return (
    <section aria-label={t("Por verificar", "To verify")}>
      <div className="pv-cabeza">
        <div className="pv-cabeza__cuenta">{lista === undefined ? t("Cargando…", "Loading…") : t(`${pendientes} por verificar`, `${pendientes} to verify`)}</div>
        <div className="pv-cabeza__botones">
          {descartados.length > 0 && (
            <button type="button" className="alta-chip" aria-pressed={verDescartados} onClick={() => setVerDescartados(v => !v)}>
              {t(`Ver descartados · ${descartados.length}`, `Show discarded · ${descartados.length}`)}
            </button>
          )}
          <button type="button" className="alta-chip" onClick={cargar}>{t("Actualizar", "Refresh")}</button>
        </div>
      </div>
      <p className="pv-nota">{t("Altas propias sin aprobar, la más vieja primero. Llama al teléfono de Google para confirmar que quien se registró es del negocio. Aprobar es de Ali en Admin → Merchants.",
        "Self sign-ups not yet approved, oldest first. Call the Google phone to confirm the person who signed up belongs to the business. Approving is Ali's, in Admin → Merchants.")}</p>
      {error && <div className="beta__error" role="alert">{error}</div>}
      {lista && vista.length === 0 && <p className="pv-nota">{t("No hay nadie por verificar.", "Nobody to verify.")}</p>}
      <div className="pv-lista">
        {vista.map(r => (
          <TarjetaPorVerificar key={r.merchant_id} r={r} en={en} abierta={abierta === r.merchant_id} listo={esListo(r)}
            onLlamar={() => setAbierta(a => (a === r.merchant_id ? "" : r.merchant_id))}
            onGuardada={(outcome) => { if (outcome === "verificado") setVerificadosAhora(m => ({ ...m, [r.merchant_id]: true })); cargar(); }} />
        ))}
      </div>
    </section>
  );
}

// ---- s237 · SEGUIMIENTO · el micro-CRM (`crm-historial-general`) ----
// Ali (21/10): «verlo como un micro CRM: su estado, las notas, y que mañana pueda ver fácilmente qué está y qué no».
// Una fila por comercio sembrado: la segunda tabla del script §4 de METRICA_s234_semana_1_otto.md puesta en pantalla.
// React puro: la lista que ya trae get_seeded_merchants + get_call_log por comercio (con ~40 aguanta; si pasa de ~50,
// hace falta un get_call_log_all en Bubble). La etapa se DERIVA de status + pipeline_stage + llamadas: no hay estados
// nuevos y no se edita a mano. list_json no trae terms_accepted_at ni approved_at: «Términos» queda en «—».
const SEGUIMIENTO_DESDE = new Date("2026-10-19T04:00:00Z").getTime();   // lunes 19/10, 00:00 EDT (semana 1 de Otto)
const ETAPAS_SEGUIMIENTO = [
  { id: "sin_llamar", es: "Sin llamar", en: "Not called" },
  { id: "contactado", es: "Contactado", en: "Contacted" },
  { id: "interesado", es: "Interesado", en: "Interested" },
  { id: "reunion", es: "Reunión", en: "Meeting" },
  { id: "aprobado", es: "Aprobó por teléfono", en: "Said yes on the phone" },
  { id: "invitado", es: "Invitado", en: "Invited" },
  { id: "confirmado", es: "Confirmado", en: "Confirmed" },
  { id: "descartado", es: "Descartado", en: "Discarded" },
];
const etapaSeguimiento = (r, llamadas) => {
  if (r.status === "Rejected" || r.pipeline_stage === "descartado") return "descartado";
  if (r.status === "Approved") return "confirmado";
  if (r.status === "Invitado") return "invitado";
  if (["contactado", "interesado", "reunion", "aprobado"].includes(r.pipeline_stage)) return r.pipeline_stage;
  if ((llamadas && llamadas.length) || r.last_call_at > 0) return "contactado";
  return "sin_llamar";
};
const esZZ = (r) => /^\s*zz\b/i.test(r.business_name || "");
// s238 · buscador de «Negocios» (pedido de Otto): nombre, rubro, zona, quién sembró, correo del dueño o
// teléfono, sin importar tildes ni mayúsculas. Con 3+ dígitos también compara solo los dígitos del teléfono.
const sinTildes = (s) => String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
const coincideBusqueda = (r, q) => {
  const busca = sinTildes(q).trim();
  if (!busca) return true;
  const texto = sinTildes([r.business_name, CAT_DISPLAY[r.category], r.category, r.zone, r.neighborhood,
    r.seeded_by_name, r.owner_email, r.phone].filter(Boolean).join(" "));
  if (busca.split(/\s+/).every(p => texto.includes(p))) return true;
  const digitos = busca.replace(/\D/g, "");
  return digitos.length >= 3 && String(r.phone || "").replace(/\D/g, "").includes(digitos);
};
const fechaHoraCorta = (ms, en) => ms
  ? new Date(ms).toLocaleString(en ? "en-US" : "es-US", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit" })
  : "";
const fechaDeTexto = (v) => { if (!v) return 0; if (/^\d+$/.test(String(v))) return Number(v); const t = new Date(v).getTime(); return isFinite(t) ? t : 0; };

function SeguimientoCrm({ en, lista, cargando, onRecargar, busqueda = "" }) {
  const [llamadas, setLlamadas] = useState({});            // merchant_id → [llamadas] · null = no se pudo leer
  const [ocultarZZ, setOcultarZZ] = useState(true);
  const [ocultarDescartados, setOcultarDescartados] = useState(true);
  const [verHistoricos, setVerHistoricos] = useState(false);
  const [filtroLlamo, setFiltroLlamo] = useState("");
  const [filtroEtapa, setFiltroEtapa] = useState("");
  const [filtroRubro, setFiltroRubro] = useState("");
  const [llamadaDe, setLlamadaDe] = useState("");
  const t = (es, enTxt) => (en ? enTxt : es);

  // Las llamadas de los comercios del período (de a 6 en paralelo). Se vuelven a pedir con «Actualizar».
  const delPeriodo = lista.filter(r => r.merchant_id && (verHistoricos || fechaDeTexto(r.seeded_at) >= SEGUIMIENTO_DESDE));
  const ids = delPeriodo.map(r => r.merchant_id).join(",");
  const cargarLlamadas = useCallback(async (soloId) => {
    const pendientes = soloId ? [soloId] : ids.split(",").filter(Boolean);
    for (let i = 0; i < pendientes.length; i += 6) {
      const tanda = pendientes.slice(i, i + 6);
      const res = await Promise.all(tanda.map(id => getCallLog(id).then(x => [id, x]).catch(() => [id, null])));
      setLlamadas(m => ({ ...m, ...Object.fromEntries(res) }));
    }
  }, [ids]);
  useEffect(() => { cargarLlamadas(); }, [cargarLlamadas]);

  const filas = delPeriodo.map(r => {
    const ls = llamadas[r.merchant_id];
    const ultima = Array.isArray(ls) && ls.length ? ls[0] : null;
    const noInteresa = Array.isArray(ls) ? ls.find(c => c.outcome === "no_interesa") : null;
    return {
      ...r, _llamadas: ls, _ultima: ultima, _etapa: etapaSeguimiento(r, ls),
      _llamo: Array.isArray(ls) ? [...new Set(ls.map(c => c.by).filter(Boolean))] : [],
      _proxima: (ultima && ultima.next_call_at) || r.next_call_at || 0,
      _motivo: r.discard_reason || (noInteresa && noInteresa.notes) || "",
    };
  });
  const quienes = [...new Set(filas.flatMap(f => f._llamo))].sort();
  const rubros = [...new Set(filas.map(f => f.category).filter(Boolean))].sort();
  const vista = filas.filter(f =>
    (!ocultarZZ || !esZZ(f))
    && (!ocultarDescartados || f._etapa !== "descartado")
    && (!filtroLlamo || f._llamo.includes(filtroLlamo))
    && (!filtroEtapa || f._etapa === filtroEtapa)
    && (!filtroRubro || f.category === filtroRubro)
    && coincideBusqueda(f, busqueda));
  // Orden (pedido de Ali/Cowork): próxima llamada más cercana primero; después los sin llamar; el resto por siembra
  // más reciente; los descartados al final.
  const peso = f => (f._etapa === "descartado" ? 3 : f._proxima > 0 ? 0 : f._etapa === "sin_llamar" ? 1 : 2);
  vista.sort((a, b) => peso(a) - peso(b)
    || (peso(a) === 0 ? a._proxima - b._proxima : fechaDeTexto(b.seeded_at) - fechaDeTexto(a.seeded_at)));

  const hoyFin = finDeHoy();
  const etiquetaSeg = id => { const e = ETAPAS_SEGUIMIENTO.find(x => x.id === id); return e ? e[en ? "en" : "es"] : id; };
  const tipoSeg = id => (id === "descartado" ? "rejected" : id === "confirmado" ? "approved" : id === "invitado" || id === "aprobado" ? "active" : "pending");
  const sel = { fontSize: 12, padding: "5px 8px", border: `1px solid ${C.border}`, borderRadius: 2, color: C.gray, background: C.white };
  const chip = (on, onClick, texto) => (
    <button type="button" aria-pressed={on} onClick={onClick}
      style={{ border: `1px solid ${on ? C.black : C.border}`, background: on ? C.black : "none", color: on ? C.white : C.gray, padding: "5px 10px", fontSize: 12, cursor: "pointer", borderRadius: 999 }}>
      {texto}
    </button>
  );
  const fmtFecha = (ms, enTxt) => new Date(ms).toLocaleDateString(enTxt ? "en-US" : "es-US", { day: "numeric", month: "short" });
  const marca = (ms, txt) => (ms ? <span title={fmtFecha(ms, en)}>✓ {txt}</span> : <span style={{ color: C.muted }}>— {txt}</span>);

  const cols = [
    { label: t("Comercio", "Business"), width: "1.6fr", render: f => (
      <div>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.black }}>{f.business_name || "—"}</div>
        <div style={{ fontSize: 11, color: C.muted }}>{CAT_DISPLAY[f.category] || f.category || ""}{f.zone || f.neighborhood ? ` · ${f.zone || f.neighborhood}` : ""}</div>
        <div style={{ fontSize: 11, color: C.muted }}>
          {t("Sembrado", "Seeded")} {f.seeded_at ? fmtFecha(fechaDeTexto(f.seeded_at), en) : "—"}{f.seeded_by_name ? ` · ${f.seeded_by_name}` : ""}
        </div>
        {telE164(f.phone) && <a href={`tel:${telE164(f.phone)}`} style={{ fontSize: 12, color: "var(--exito)", fontWeight: 600 }}>{f.phone}</a>}
      </div>
    )},
    { label: t("Etapa", "Stage"), width: "1fr", render: f => (
      <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
        <AdminBadge label={etiquetaSeg(f._etapa)} type={tipoSeg(f._etapa)} />
        {f._motivo && <span style={{ fontSize: 11, color: C.muted }}>{t("No:", "No:")} {f._motivo}</span>}
      </div>
    )},
    { label: t("Última llamada", "Last call"), width: "1.7fr", render: f => {
      if (f._llamadas === undefined) return <span style={{ fontSize: 12, color: C.muted }}>{t("Cargando…", "Loading…")}</span>;
      if (f._llamadas === null) return <span style={{ fontSize: 12, color: "var(--error)" }}>{t("No se pudo leer", "Couldn't load")}</span>;
      const u = f._ultima;
      if (!u) return <span style={{ fontSize: 12, color: C.muted }}>{t("Sin llamadas", "No calls")}</span>;
      return (
        <div style={{ fontSize: 12, color: C.gray, lineHeight: 1.45 }}>
          <div style={{ fontWeight: 600, color: C.black }}>{etiquetaOutcome(u.outcome, en)}</div>
          <div>{fechaHoraCorta(u.called_at, en)}{u.by ? ` · ${t("registró", "logged by")} ${u.by}` : ""}</div>
          {u.spoke_with && <div>{t("Habló con", "Spoke with")}: {u.spoke_with}</div>}
          {u.decision_maker && <div>{t("Decide", "Decides")}: {u.decision_maker}</div>}
          {u.notes && <div style={{ color: C.muted }}>{u.notes}</div>}
          {f._llamadas.length > 1 && <div style={{ color: C.muted }}>{f._llamadas.length} {t("llamadas", "calls")}</div>}
        </div>
      );
    }},
    { label: t("Próxima llamada", "Next call"), width: "1fr", render: f => (
      f._etapa === "descartado" || !f._proxima
        ? <span style={{ fontSize: 12, color: C.muted }}>—</span>
        : <span style={{ fontSize: 12, fontWeight: f._proxima <= hoyFin ? 700 : 400, color: f._proxima <= hoyFin ? "var(--error)" : C.gray }}>
            {f._proxima <= hoyFin ? t("Toca hoy · ", "Due today · ") : ""}{fechaCorta(f._proxima, en)}
          </span>
    )},
    { label: t("Embudo", "Funnel"), width: "1.1fr", render: f => (
      <div style={{ fontSize: 11, color: C.gray, display: "flex", flexDirection: "column", gap: 2 }}>
        {marca(fechaDeTexto(f.beta_first_open_at), t("abrió el enlace", "opened the link"))}
        {marca(fechaDeTexto(f.invited_at), t("invitado", "invited"))}
        {/* s239 · seeded-merchants-terminos-y-aprobado: con las claves nuevas de list_json, fechas reales; sin ellas, como antes. */}
        {"terms_accepted_at" in f
          ? marca(fechaDeTexto(f.terms_accepted_at), t("términos", "terms"))
          : <span style={{ color: C.muted }} title={t("Bubble todavía no manda esta fecha en la lista", "Bubble doesn't send this date in the list yet")}>— {t("términos", "terms")}</span>}
        {fechaDeTexto(f.approved_at)
          ? marca(fechaDeTexto(f.approved_at), t("confirmado", "confirmed"))
          : f.status === "Approved" ? <span>✓ {t("confirmado", "confirmed")}</span> : <span style={{ color: C.muted }}>— {t("confirmado", "confirmed")}</span>}
      </div>
    )},
    { label: "", width: "0.9fr", render: f => (
      f._etapa === "descartado" ? null
        : <button type="button" onClick={() => setLlamadaDe(d => (d === f.merchant_id ? "" : f.merchant_id))}
            style={{ background: "none", border: `1px solid ${C.border}`, color: llamadaDe === f.merchant_id ? "var(--exito)" : C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
            {t("Registrar llamada", "Log a call")}
          </button>
    )},
  ];

  return (
    <section aria-label={t("Seguimiento", "Follow-up")}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
        <div style={{ ...S.display, fontSize: 20, color: C.black }}>{t("SEGUIMIENTO", "FOLLOW-UP")} · {vista.length}</div>
        <button type="button" onClick={() => { onRecargar(); cargarLlamadas(); }} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "6px 12px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
          {t("Actualizar", "Refresh")}
        </button>
      </div>
      <div style={{ fontSize: 12, color: C.muted, marginBottom: 10, lineHeight: 1.5 }}>
        {verHistoricos
          ? t("Todos los comercios sembrados.", "Every seeded business.")
          : t("Los sembrados desde el lunes 19/10.", "Seeded since Monday 10/19.")}{" "}
        {t("Primero la próxima llamada más cercana; después los que nadie llamó; los descartados al final.", "Nearest next call first; then the ones nobody called; discarded last.")}
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", marginBottom: 12 }} role="group" aria-label={t("Filtrar el seguimiento", "Filter the follow-up")}>
        {chip(ocultarZZ, () => setOcultarZZ(v => !v), t("Ocultar ZZ", "Hide ZZ"))}
        {chip(ocultarDescartados, () => setOcultarDescartados(v => !v), t("Ocultar descartados", "Hide discarded"))}
        {chip(verHistoricos, () => setVerHistoricos(v => !v), t("Ver históricos", "Show older"))}
        <select aria-label={t("Quién llamó", "Who called")} value={filtroLlamo} onChange={e => setFiltroLlamo(e.target.value)} style={sel}>
          <option value="">{t("Llamó cualquiera", "Called by anyone")}</option>
          {quienes.map(q => <option key={q} value={q}>{q}</option>)}
        </select>
        <select aria-label={t("Etapa", "Stage")} value={filtroEtapa} onChange={e => setFiltroEtapa(e.target.value)} style={sel}>
          <option value="">{t("Todas las etapas", "All stages")}</option>
          {ETAPAS_SEGUIMIENTO.map(e => <option key={e.id} value={e.id}>{e[en ? "en" : "es"]} · {filas.filter(f => f._etapa === e.id).length}</option>)}
        </select>
        <select aria-label={t("Rubro", "Category")} value={filtroRubro} onChange={e => setFiltroRubro(e.target.value)} style={sel}>
          <option value="">{t("Todos los rubros", "All categories")}</option>
          {rubros.map(c => <option key={c} value={c}>{CAT_DISPLAY[c] || c}</option>)}
        </select>
      </div>
      <AdminTable columns={cols} rows={vista} loading={cargando} apilarEnTelefono
        empty={filas.length ? t("Nada con estos filtros", "Nothing matches these filters") : t("No hay comercios sembrados en este período", "No businesses seeded in this period")}
        debajo={f => (llamadaDe && f.merchant_id === llamadaDe
          ? <RegistrarLlamada key={f.merchant_id} fila={f} en={en} onCerrar={() => setLlamadaDe("")}
              onGuardada={() => { onRecargar(); cargarLlamadas(f.merchant_id); }} />
          : null)} />
    </section>
  );
}

// s233 · la siembra va solo con la oferta genérica (Ali). En true vuelve el botón «Wizard de la oferta».
const SIEMBRA_CON_WIZARD = false;

// s238 (Otto/Ali): dos páginas con la misma pantalla. `vista` = "sembrar" (/operator/vitrina: solo el formulario
// y el lote) o "negocios" (/operator/negocios: Sembrados · Seguimiento · Por verificar + buscador).
// s241 · T1 · el aviso de web faltante (texto A, elegido por Ali el 25/10) y el atajo para buscarla en Google (pestaña nueva).
const AVISO_SIN_WEB = {
  es: "Google no trae la web de este negocio. Sin web, la IA solo puede describir el tipo de lugar. Búscala y pégala aquí: su página propia, Booksy, Toast, Square, Wix o Linktree sirven. Instagram y Yelp no se pueden leer (el Instagram va en su campo). Si no tiene, marca «No tiene web».",
  en: "Google doesn't have this business's website. Without one, the AI can only describe the type of place. Look it up and paste it here: their own site, Booksy, Toast, Square, Wix or Linktree work. Instagram and Yelp can't be read (Instagram goes in its own field). If they have none, check «No website».",
};
// s241 · T2 · los tipos de Google para la IA, con el formato del SPEC: separados por coma, sin los genéricos.
const tiposGoogleParaIa = (types) => (types || []).filter(x => !["point_of_interest", "establishment"].includes(x)).join(", ");
const busquedaWebNegocio = (nombre, zona) => `https://www.google.com/search?q=${encodeURIComponent([nombre, zona, "Miami"].filter(x => String(x || "").trim()).join(" ") + " sitio web")}`;

function OperatorVitrina({ vista = "sembrar" }) {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  const FORM0 = { business_name: "", category: "Restaurant", beta_state: "demo", neighborhood: "", zone: "", address: "",
                  phone: "", instagram: "", place_id: "", google_maps_url: "", avg_ticket_usd: "", description_es: "",
                  tags_json: "",   // s251 · lo devuelve «Sugerir con IA»; viaja a seed_merchant sin mostrarse
                  lat: "", lng: "",   // s216 · de Google (location); seed_merchant los guarda desde el deploy A
                  zip: "", city: "", address_full: "", website: "",   // s218 · siembra v2 (N3, export 117)
                  sin_web: false, texto_negocio: "",   // s241 · T1 («No tiene web») y T4 (lo que dio el dueño), export 157
                  tamano: "", offer_title_es: "", que_pedir: "", cuando_ir: "",
                  // s213 · lote B+C: plan opcional; lo elige el comercio en la llamada. s233 · el plazo nace del rubro
                  // (Restaurant → 15) y sigue al rubro mientras Otto no lo toque (efecto `plazoTocado`, abajo).
                  plan: "", cooldown_days: String(plazoDelRubro("Restaurant")),
                  // s218 · el horario de la oferta (export 114, S1). null = todo el horario del comercio.
                  franja: null,
                  // s222 · el canal elegido; vacío = el del rubro (canalSiembra). No viaja en seed_merchant.
                  redemption_channel: "",
                  // s224 · el tipo de negocio (eje del asesor): lo fija Google o «Comida rápida» del selector de rubro, y viaja
                  // en seed_merchant (export 132) y en wizard_json.
                  business_type: "" };
  const [profile, setProfile] = useState(null);
  const [form, setForm] = useState(FORM0);
  const [logo, setLogo] = useState(null);
  // s233 · varias fotos también en la genérica: la primera es la portada (viaja en seed_merchant, como siempre) y las
  // demás se suben justo después con operatorAddPhoto. `photo` sigue siendo «la foto» para todo lo que ya la usaba.
  const [fotosGen, setFotosGen] = useState([]);
  const photo = fotosGen[0] || null;
  // s233 · plazo-default-por-rubro: al cambiar el rubro (a mano o por Google) el plazo pasa al del rubro, salvo que
  // Otto ya lo haya elegido en la llamada.
  const plazoTocado = useRef(false);
  // s235 · franja-dias-cerrados: la última franja que puso la IA. Si Otto vuelve a tocar «Sugerir con IA» y no la cambió,
  // la nueva la reemplaza (antes quedaba la de la primera corrida, que podía traer un día cerrado).
  const franjaDeIa = useRef(null);
  useEffect(() => {
    if (!plazoTocado.current) setForm(f => ({ ...f, cooldown_days: String(plazoDelRubro(f.category)) }));
  }, [form.category]);
  // s236-D6 · siembra-porcentaje: seed_merchant ya crea la oferta en porcentaje (Live 21/10, Cowork). En salones, spa y
  // barberías la oferta genérica arranca en porcentaje (25 %; s237-D3 · sin tope); el monto fijo queda como opción.
  // Al cambiar el rubro vuelve al del rubro, salvo que Otto ya lo haya elegido.
  const [formatoSiembra, setFormatoSiembra] = useState(PRIMERA_CON_MONTO_FIJO ? "std" : "pct");   // "std" | "pct" · s255 · solo % en la primera
  const [pctSiembra, setPctSiembra] = useState(String(PCT_SALON.pct));
  const [topeSiembra, setTopeSiembra] = useState(String(PCT_SALON.tope));
  const [sinTopeSiembra, setSinTopeSiembra] = useState(true);   // s236 · sin tope por defecto; s237-D3 · salones también
  const formatoTocado = useRef(false);
  // s237 · consola-limpiar-pct-con-tope: «Limpiar» usa la misma regla que el cambio de rubro (antes dejaba «tope $30»
  // fuera de salones si el rubro no cambiaba y el efecto no volvía a correr).
  const formatoDelRubro = (cat) => {
    const salon = RUBROS_PCT_RECOMENDADO.includes(cat);
    // s255 · `primera-oferta-solo-porcentaje`: la siembra es la primera oferta del comercio: solo porcentaje, desde 20 %.
    setFormatoSiembra(salon || !PRIMERA_CON_MONTO_FIJO ? "pct" : "std");
    setPctSiembra(String(salon ? PCT_SALON.pct : PRIMERA_CON_MONTO_FIJO ? PCT_DEFECTO : PCT_PRIMERA)); setTopeSiembra(String(PCT_SALON.tope)); setSinTopeSiembra(true);   // s237-D3
  };
  useEffect(() => {
    if (formatoTocado.current) return;
    formatoDelRubro(form.category);
  }, [form.category]);
  const siembraPct = formatoSiembra === "pct";
  const pctSiembraNum = Number(pctSiembra) || 0;
  const topeSiembraNum = sinTopeSiembra ? TOPE_SIN_LIMITE : (Number(topeSiembra) || 0);   // s236 · «Sin tope» = TOPE_SIN_LIMITE (convención del club)
  const setPhoto = (f) => setFotosGen(f ? [f] : []);
  // s224 · `wizard-en-consola-otto`: la oferta sale del mismo wizard del alta (WizardPrimeraOferta con `operador`).
  // «clasica» = la oferta genérica de siempre; adoptar sigue por ahí (adopt_merchant pide la estándar).
  // s233 · Ali: «en la siembra solamente vamos a dejar ofertas genéricas». El wizard queda en el código, escondido
  // (SIEMBRA_CON_WIZARD), por si vuelve; adoptar y sembrar van por la genérica.
  const [modoOferta, setModoOferta] = useState(SIEMBRA_CON_WIZARD ? "wizard" : "clasica");
  const conWizard = modoOferta === "wizard";
  const [wizKey, setWizKey] = useState(0);
  const [horasG, setHorasG] = useState("");             // el horario de Google en el formato de business_hours_json
  // s233 · siembra-horario-negocio: el texto de Google («lunes: 11:30–22:00…»), como lo guarda el alta del dueño en
  // `business_hours`. Viaja en seed_merchant cuando SEED_CON_HORARIO esté prendido (ver api.js).
  const [horasTextoG, setHorasTextoG] = useState("");
  // s200-D1 · lo que Otto elige pasa por el encuadrador antes de entrar al formulario: la
  // foto sembrada termina en la vitrina, en la tarjeta y en «Confirma tu oferta», y si
  // entra con la proporcion que traiga, las tres la recortan distinto.
  const [porEncuadrar, setPorEncuadrar] = useState(null);   // { file, campo: "logo" | "photo" }
  // s233 · con el wizard entran varias: se eligen juntas, se encuadran de a una (cola) y se suman a `fotosWizard`.
  const [fotosWizard, setFotosWizard] = useState([]);
  const [colaFotos, setColaFotos] = useState([]);
  const [fotosEnWizard, setFotosEnWizard] = useState([]);   // s233 · la lista real del wizard (orden = portada primero)
  const [pedidoFotos, setPedidoFotos] = useState(null);     // s233 · «Hacer portada» / «Quitar» pedidos desde arriba
  const pedirAlWizard = (tipo, file) => setPedidoFotos(p => ({ tipo, file, n: (p?.n || 0) + 1 }));
  const encuadrarFotos = (files) => {
    const [primera, ...resto] = files;
    if (!primera) return;
    setPorEncuadrar({ file: primera, campo: "photo" });
    setColaFotos(resto);
  };
  const siguienteFoto = () => {
    const [f, ...resto] = colaFotos;
    setColaFotos(resto);
    setPorEncuadrar(f ? { file: f, campo: "photo" } : null);
  };
  const [sugerido, setSugerido] = useState(null);
  // s238 · sugerencia-pct (Ali): en porcentaje, «Sugerir» y «Completar con Google» proponen el % del rubro sin tope
  // (s237-D3), no un monto fijo de la tabla. { pct }; el ahorro en el precio típico se calcula al mostrarlo.
  const [sugeridoPct, setSugeridoPct] = useState(null);
  const [destacadaSugerida, setDestacadaSugerida] = useState(false);   // s199-D2: la tabla pedía ★
  const [enviando, setEnviando] = useState(false);
  const [resultado, setResultado] = useState(null);     // lo último sembrado/adoptado
  const [existente, setExistente] = useState(null);     // merchant_id de ALREADY_SEEDED
  const [error, setError] = useState("");
  const [lista, setLista] = useState([]);
  const [pestanaLista, setPestanaLista] = useState("sembrados");   // s227 · sembrados | verificar
  const [buscarNegocio, setBuscarNegocio] = useState("");   // s238 · buscador de «Negocios»
  const [origenLista, setOrigenLista] = useState("cargando");   // wf | cache | cargando
  const [copiado, setCopiado] = useState("");
  const [aprobando, setAprobando] = useState(null);     // merchant_id con el campo de correo abierto
  const [fotosDe, setFotosDe] = useState(null);         // s203 · { merchant_id, business_name } con «Quitar foto» abierto
  const [corrigiendo, setCorrigiendo] = useState(null); // s213 · la fila con «Corregir oferta» abierto
  const [franjaDe, setFranjaDe] = useState(null);       // s217 · la fila con «+ Otra franja» abierto
  const [llamadaDe, setLlamadaDe] = useState(null);     // s218 · mini CRM: la fila con «Registrar llamada» abierto
  const [descarteDe, setDescarteDe] = useState(null);   // s218 · la fila con «Descartar» abierto
  const [filtroCrm, setFiltroCrm] = useState("activos"); // activos · hoy · Lead · Invitado · Approved · Rejected · todos
  const [filtroZona, setFiltroZona] = useState("");
  const [filtroSembro, setFiltroSembro] = useState("");
  const [avisoCrm, setAvisoCrm] = useState("");         // s218 · «X quedó descartado» (la fila sale de «Activos»)
  const [correoAprobar, setCorreoAprobar] = useState("");
  const [filaOcupada, setFilaOcupada] = useState(null);
  const [msgFila, setMsgFila] = useState({});
  // s216 · deploy D · operator_set_beta_state: Demo / Difuminado / Visible de un sembrado, después de sembrar.
  const [estadoOcupado, setEstadoOcupado] = useState("");
  const cambiarEstado = async (r, nuevo) => {
    if (!r?.merchant_id || estadoOcupado || r.beta_state === nuevo) return;
    setEstadoOcupado(r.merchant_id);
    setMsgFila(m => ({ ...m, [r.merchant_id]: "" }));
    try {
      const resp = await operatorSetBetaState(r.merchant_id, nuevo);
      const quedo = resp?.beta_state || nuevo;
      setLista(prev => prev.map(x => (x.merchant_id === r.merchant_id ? { ...x, beta_state: quedo } : x)));
      setMsgFila(m => ({ ...m, [r.merchant_id]: en ? `✅ Now: ${quedo}` : `✅ Ahora: ${quedo === "borroso" ? "difuminado" : quedo}` }));
    } catch (e) {
      const texto = {
        PHOTO_REQUIRED: en ? "To make it Visible it needs a photo first (Photos → + Add photo)." : "Para dejarlo Visible primero necesita una foto (Fotos → + Agregar foto).",
        NOT_SEEDED: en ? "This merchant wasn't seeded from the console." : "Este comercio no se sembró desde la consola.",
        NOT_OPERATOR: en ? "Only an operator or an admin can change this." : "Solo un operador o un admin puede cambiar esto.",
        MERCHANT_NOT_FOUND: en ? "We couldn't find this merchant. Reload." : "No encontramos este comercio. Recarga.",
      }[e.code] || e.message || (en ? "It couldn't be changed." : "No se pudo cambiar.");
      setMsgFila(m => ({ ...m, [r.merchant_id]: "⚠️ " + texto }));
    } finally {
      setEstadoOcupado("");
    }
  };
  // Siembra en lote (tanda 2). `loteFilas === null` = todavía no hay vista previa: el botón
  // «Sembrar» no existe hasta que Otto la vio (nada de sembrar a ciegas).
  const [loteTexto, setLoteTexto] = useState("");
  const [loteGoogle, setLoteGoogle] = useState(null);   // s217 · progreso de «Completar con Google»: { hechas, total, con }
  const [loteEstado, setLoteEstado] = useState("demo");
  const [loteFilas, setLoteFilas] = useState(null);
  const [loteCorriendo, setLoteCorriendo] = useState(false);
  const [loteCopiado, setLoteCopiado] = useState(false);
  // s202 · `vitrina-siembra-con-places`. Sin place_id el Step 2 de seed_merchant
  // (ALREADY_SEEDED) no corre y el mismo negocio se siembra dos veces; y la ficha no tiene
  // de dónde sacar el rating en vivo. Otto busca, elige, y la siembra se llena como el alta
  // (decisión de Ali, s202). `deGoogle.campos` = lo que llenó la última elección: si Otto
  // elige otro negocio, esos campos se reemplazan o se vacían, y lo que él escribió a mano
  // en los demás se queda.
  const [busqueda, setBusqueda] = useState("");
  const [sugerencias, setSugerencias] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [deGoogle, setDeGoogle] = useState(null);       // { nombre, direccion, campos: [...] }
  const [errorGoogle, setErrorGoogle] = useState("");
  const tokenPlaces = useRef("");
  // s218 · siembra v2: el horario que dio Google (para mostrarlo y prellenar los días), el precio de
  // «Completar con Google» y la foto traída desde un enlace.
  const [horarioG, setHorarioG] = useState(null);       // { dias, texto } | null
  // s241 · suggest-seed-offer-google-type-desde-react: el primaryType de Places viaja a la IA de la siembra (v4.7.2 lo usa
  // para no inventar servicios, s239-D10). Se borra con el resto de lo que trajo Google.
  const [tipoGoogle, setTipoGoogle] = useState("");
  // s241 · T2 (solo lo de bajo riesgo): la lista de tipos de Google, como la usa ya `guessTaxonomyFromPlaceTypes`. Reseñas,
  // resúmenes, rating, precio y «qué sirve» quedan fuera hasta que Ali decida (condiciones de Google: no guardar su contenido).
  const [tiposGoogle, setTiposGoogle] = useState("");
  // s241 · T2 (Ali): lo que dice Google del lugar, SOLO para que Otto lo lea en la llamada (no va a la IA ni se guarda).
  const [vistaGoogle, setVistaGoogle] = useState(null);   // { resumen, rating, count, mapsUri, reviews } | null
  const [precioG, setPrecioG] = useState(null);         // { estado: "buscando" | "ok" | "sin_dato" | "fallo", texto }
  const [urlFoto, setUrlFoto] = useState("");
  const [trayendoFoto, setTrayendoFoto] = useState(false);
  // s234 · siembra-logo-desde-web: qué candidato de la IA se muestra (si la miniatura no carga, pasa al siguiente) y el
  // aviso cuando el sitio no deja bajar la imagen.
  const [logoWebIdx, setLogoWebIdx] = useState(0);
  const [logoWebMsg, setLogoWebMsg] = useState("");
  const [trayendoLogo, setTrayendoLogo] = useState(false);
  const [errorUrlFoto, setErrorUrlFoto] = useState("");
  // s218 · duplicado por place_id ANTES de sembrar (como el lote): la lista ya trae los descartados.
  const yaSembrado = form.place_id.trim() ? lista.find(r => r.place_id && r.place_id === form.place_id.trim()) : null;
  // s219 · check_place_id: lo mismo contra TODA la base (altas propias incluidas), no solo los sembrados de la lista.
  // Vale mientras el place_id del formulario sea el consultado (si Otto lo cambia a mano, el aviso se va).
  const [enBase, setEnBase] = useState(null);
  const avisoBase = enBase && enBase.exists && enBase.place_id === form.place_id.trim() ? enBase : null;
  const consultarBase = (pid) => {
    const p = String(pid || "").trim();
    setEnBase(null);
    if (!p) return;
    checkPlaceId(p).then(r => {
      setEnBase(r);
      if (r && r.exists && r.merchant_id) setExistente(r.merchant_id);
    });
  };
  useEffect(() => {
    if (enBase && enBase.place_id !== form.place_id.trim()) {
      if (enBase.merchant_id) setExistente(x => (x === enBase.merchant_id ? null : x));
      setEnBase(null);
    }
  }, [enBase, form.place_id]);

  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));
  const tamanoElegido = UMBRAL_TAMANOS.find(t => t.id === form.tamano) || null;

  const cargarLista = useCallback(async () => {
    try {
      const l = await getSeededMerchants();
      setLista(l);
      setOrigenLista("wf");
    } catch (e) {
      setLista(leerCacheBeta());
      setOrigenLista("cache");
    }
  }, []);
  useEffect(() => {
    getUserProfile().then(setProfile).catch(() => {});
    cargarLista();
  }, [cargarLista]);

  // El mismo ritmo que el alta: 300 ms de pausa, desde 3 letras, un token de sesión que
  // cierra placeDetails (Places factura por sesión).
  useEffect(() => {
    if (!placesEnabled()) return;
    const q = busqueda.trim();
    if (q.length < 3) { setSugerencias([]); return; }
    const h = setTimeout(async () => {
      try {
        if (!tokenPlaces.current) {
          tokenPlaces.current = (window.crypto && window.crypto.randomUUID)
            ? window.crypto.randomUUID()
            : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
        }
        setBuscando(true);
        setSugerencias(await placesAutocomplete(q, tokenPlaces.current));
      } catch (e) { setSugerencias([]); }
      finally { setBuscando(false); }
    }, 300);
    return () => clearTimeout(h);
  }, [busqueda]);

  // s215 · Ali: Otto copia la foto en Maps/Instagram («Copiar imagen») y la PEGA aquí con Ctrl+V,
  // sin guardarla en la computadora. Solo actúa si lo pegado trae una imagen: el texto pegado en un
  // campo sigue funcionando igual. La imagen pasa por el mismo encuadrador que el archivo.
  useEffect(() => {
    const alPegar = (e) => {
      if (panelesFotosAbiertos > 0) return;   // s216 · el pegado es del panel «Fotos» abierto
      const items = Array.from(e.clipboardData?.items || []);
      const img = items.find(it => it.kind === "file" && /^image\//.test(it.type));
      const f = img && img.getAsFile();
      if (!f) return;
      e.preventDefault();
      const ext = (f.type.split("/")[1] || "png").replace("jpeg", "jpg");
      setPorEncuadrar({ file: new File([f], `foto-pegada.${ext}`, { type: f.type }), campo: "photo" });
    };
    window.addEventListener("paste", alPegar);
    return () => window.removeEventListener("paste", alPegar);
  }, []);
  const soltarFoto = (e) => {
    e.preventDefault();
    const imgs = Array.from(e.dataTransfer?.files || []).filter(x => /^image\//.test(x.type));
    encuadrarFotos(imgs);
  };
  // s218 · siembra v2: pegar el ENLACE de una imagen. Se descarga en el navegador y pasa por el mismo
  // encuadrador (regla s206: sale en WebP). Muchos sitios (Instagram, la mayoría de las páginas) no dejan
  // descargar sus imágenes desde otra web (CORS): ahí se avisa y queda el camino de Ctrl+V.
  // s234 · siembra-logo-desde-web: el logo que trae la IA de la web se baja y pasa por el mismo encuadrador que el de
  // archivo (1:1, 512 px). No se pone solo: Otto lo ve en miniatura y toca «Usar este logo». Si el sitio no deja bajarlo
  // (CORS), se dice cómo pegarlo a mano.
  const usarLogoWeb = async (u) => {
    setTrayendoLogo(true); setLogoWebMsg("");
    try {
      setPorEncuadrar({ file: await bajarLogoDeLaWeb(u), campo: "logo" });
    } catch (e) {
      setLogoWebMsg(String(e?.message || "") === "no_imagen"
        ? (en ? "That logo isn't a PNG/JPG/WebP image (it may be an SVG). Save it and upload it with «Choose file»." : "Ese logo no es una imagen PNG/JPG/WebP (puede ser un SVG). Guárdalo y súbelo con «Seleccionar archivo».")
        : (en ? "The site doesn't let us download it. Open it, copy the image and upload it with «Choose file»." : "El sitio no deja bajarlo. Ábrelo, guarda la imagen y súbela con «Seleccionar archivo»."));
    } finally {
      setTrayendoLogo(false);
    }
  };
  const traerFotoDeEnlace = async () => {
    const u = urlFoto.trim();
    if (!/^https?:\/\//i.test(u)) { setErrorUrlFoto(en ? "Paste a link that starts with http." : "Pega un enlace que empiece con http."); return; }
    setTrayendoFoto(true); setErrorUrlFoto("");
    try {
      const res = await fetch(u, { mode: "cors" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const blob = await res.blob();
      if (!/^image\//.test(blob.type)) throw new Error("no_imagen");
      const ext = (blob.type.split("/")[1] || "jpg").replace("jpeg", "jpg");
      setPorEncuadrar({ file: new File([blob], `foto-enlace.${ext}`, { type: blob.type }), campo: "photo" });
      setUrlFoto("");
    } catch (e) {
      const m = String(e?.message || "");
      setErrorUrlFoto(m === "no_imagen"
        ? (en ? "That link isn't an image. Open the image itself and copy its address." : "Ese enlace no es una imagen. Abre la imagen sola y copia su dirección.")
        : m.startsWith("HTTP ")
        ? (en ? `That link didn't open (${m}). Check it, or copy the image and paste it here with Ctrl+V.`
              : `Ese enlace no abrió (${m}). Revísalo, o copia la imagen y pégala aquí con Ctrl+V.`)
        : (en ? "That site doesn't let us download the image. Copy the image itself and paste it here with Ctrl+V."
              : "Ese sitio no deja descargar la imagen. Copia la imagen y pégala aquí con Ctrl+V."));
    } finally {
      setTrayendoFoto(false);
    }
  };

  const elegirDeGoogle = async (s) => {
    setBuscando(true); setErrorGoogle("");
    try {
      const det = await placeDetails(s.place_id, tokenPlaces.current);
      tokenPlaces.current = "";
      if (!det) throw new Error("no_details");
      // s234 · siembra-formulario-limpio: OTRO lugar que el que ya estaba en el formulario → se vacía primero (fotos, logo,
      // Instagram, «Qué pedir», «Lo esencial»…) y se cierra el «Sembrado: …» del anterior. Sin lugar previo (Otto escribió
      // a mano y después busca en Google), lo escrito se respeta como siempre.
      if (form.place_id && (det.id || s.place_id) !== form.place_id) {
        vaciarFormulario(true); setResultado(null); setExistente(null); setError("");
      }
      const dir = parsePlaceAddress(det);
      const nombre = (det.displayName && det.displayName.text) || s.main || "";
      const g = {
        business_name: nombre,
        address: dir.address,
        neighborhood: dir.neighborhood,
        // s218 · siembra v2: sin barrio, la zona es la ciudad (el contador «N en tu zona» cuenta por zone).
        zone: dir.neighborhood || dir.city,
        zip: dir.zip,
        city: dir.city,
        address_full: sinPais(det.formattedAddress),
        website: det.websiteUri || "",
        // s218 · en +1… (E.164), para usarlo después por WhatsApp.
        phone: telE164(det.nationalPhoneNumber),
        place_id: det.id || s.place_id,
        google_maps_url: det.googleMapsUri || "",
      };
      // s218 · el horario de Google prellena los DÍAS de la oferta (la hora la elige Otto con las franjas).
      const h = horarioDeGoogle(det.regularOpeningHours, en);
      setHorarioG(h);
      setTipoGoogle(String(det.primaryType || ""));
      setTiposGoogle(tiposGoogleParaIa(det.types));
      setVistaGoogle(null);
      placeVistaParaOtto(det.id || s.place_id, en ? "en" : "es").then(v => setVistaGoogle(v && (v.resumen || v.reviews.length) ? v : null)).catch(() => setVistaGoogle(null));
      // s224 · el wizard prellena los horarios (desayuno, almuerzo…) con el mismo horario, como en el alta.
      const appHours = placeHoursToAppHours(det.regularOpeningHours);
      setHorasG(appHours ? serializeHours(appHours) : "");
      setHorasTextoG(((det.regularOpeningHours && det.regularOpeningHours.weekdayDescriptions) || []).join("\n"));
      setPrecioG(null);
      // El rubro solo si Google da señal y cae en una de las seis; si no, queda el que estaba.
      const { category, business_type: tipoGoogle } = guessTaxonomyFromPlaceTypes(det.types, det.primaryType, det.priceLevel);
      const previos = (deGoogle && deGoogle.campos) || [];
      setForm(f => {
        const next = { ...f, tags_json: "" };   // s251 · las etiquetas eran del lugar anterior
        Object.entries(g).forEach(([k, v]) => {
          if (v) next[k] = v;
          else if (previos.includes(k)) next[k] = "";
        });
        if (category && Object.values(CAT_MAP).includes(category)) {
          next.category = category;
          // s224 · el tipo de Google viaja a seed_merchant (export 132). Si es comida rápida, el selector lo muestra así;
          // con café o pizzería el wizard también pregunta por persona.
          next.business_type = tipoGoogle || "";
        }
        // s216 · las coordenadas son del lugar elegido: se pisan siempre (vacías si Google no las da).
        next.lat = det.location && Number.isFinite(det.location.latitude) ? det.location.latitude : "";
        next.lng = det.location && Number.isFinite(det.location.longitude) ? det.location.longitude : "";
        // s218 · los días que abre (sin hora: todo el horario de esos días). Otto la ajusta con las franjas.
        next.franja = h && h.dias ? { valid_days: h.dias, valid_time_start: "", valid_time_end: "" } : null;
        next.sin_web = false;   // s241 · T1: «No tiene web» es de ESTE lugar; otro lugar de Google arranca sin marcar
        return next;
      });
      const lleno = { ...g, category: category && Object.values(CAT_MAP).includes(category) ? category : "" };
      setDeGoogle({ nombre, direccion: sinPais(det.formattedAddress) || dir.address,
                    campos: ["business_name", "category", "address", "neighborhood", "zone", "zip", "city", "website", "phone", "place_id", "google_maps_url"].filter(k => lleno[k]) });
      setBusqueda(""); setSugerencias([]); setExistente(null);
      // s219 · si ya está en la base, se avisa ya y se ofrece adoptarlo (el mismo camino que ALREADY_SEEDED).
      consultarBase(g.place_id);
    } catch (e) {
      setErrorGoogle(en ? "Google didn't answer. Try again or fill it in by hand." : "Google no respondió. Prueba otra vez o llénalo a mano.");
    } finally {
      setBuscando(false);
    }
  };

  const elegirTamano = (id) => setForm(f => {
    const t = UMBRAL_TAMANOS.find(x => x.id === id);
    if (!t) return f;
    const next = { ...f, tamano: id };
    if (esTituloUmbralGenerado(f.offer_title_es)) next.offer_title_es = fraseUmbral(t.monto, t.minimo, false);
    return next;
  });
  // s238 · en porcentaje se aplica el % del rubro sin tope (como el monto fijo aplica el tamaño recomendado).
  const sugerirPct = () => {
    const pct = RUBROS_PCT_RECOMENDADO.includes(form.category) ? PCT_SALON.pct : PRIMERA_CON_MONTO_FIJO ? PCT_DEFECTO : PCT_PRIMERA;   // s255
    setPctSiembra(String(pct)); setSinTopeSiembra(true); setSugeridoPct({ pct });
  };
  const sugerir = () => {
    if (siembraPct) { sugerirPct(); return; }
    const bruto = sugerirTamanoUmbral(form.category, ticketPorPersona(form.category, form.avg_ticket_usd), form.business_type);   // s236 · comida rápida: tamaños chicos
    if (!bruto) return;
    // s199-D2: si la tabla pide Destacada, se propone la XL y se dice por qué.
    const s = sinDestacada(bruto);
    if (!s) return;
    setSugerido(s);
    setDestacadaSugerida(bruto.id === "D" && s.id !== "D");
    elegirTamano(s.id);
  };
  // s218 · siembra v2: «Completar con Google» también aquí (el lote lo tiene desde s217). Con precio: el ticket en la
  // unidad de la pregunta (mesa de dos en restaurantes y bares) y el Recomendado elegido; de paso el teléfono y la
  // web si faltaban. «No se pudo consultar» ≠ «Google no tiene precio» (#942).
  const completarPrecio = async () => {
    const pid = form.place_id.trim();
    if (!pid) return;
    setPrecioG({ estado: "buscando", texto: "" });
    const p = await placePrecio(pid);
    const precio = precioDeGoogle(p);
    if (p) setForm(f => ({ ...f,
      phone: f.phone.trim() ? f.phone : telE164(p.telefono),
      website: f.website.trim() ? f.website : (p.web || "") }));
    if (!p) { setPrecioG({ estado: "fallo", texto: en ? "We couldn't reach Google. Try again." : "No se pudo consultar a Google. Prueba otra vez." }); return; }
    if (!precio) { setPrecioG({ estado: "sin_dato", texto: en ? "Google has no price for this place: ask the owner." : "Google no tiene precio de este lugar: pregúntaselo al dueño." }); return; }
    const divisor = preguntaTicket(form.category, en).divisor;
    const opciones = opcionesDeTamano(form.category, precio.porPersona, precio.porPersonaBajo, form.business_type);   // s236
    setForm(f => ({ ...f, avg_ticket_usd: String(Math.round(precio.porPersona * divisor)) }));
    if (siembraPct) sugerirPct();
    else if (opciones) { elegirTamano(opciones.recomendado); setSugerido(UMBRAL_TAMANOS.find(t => t.id === opciones.recomendado) || null); setDestacadaSugerida(false); }
    setPrecioG({ estado: "ok", texto: precio.fuente === "google_rango"
      ? (en ? `Google: ${precio.rangoTexto} per person (midpoint $${Math.round(precio.porPersona)}).` : `Google: ${precio.rangoTexto} por persona (punto medio $${Math.round(precio.porPersona)}).`)
      : (en ? `Google only gives the price level: about $${precio.porPersona} per person (approximate).` : `Google solo da el nivel de precio: unos $${precio.porPersona} por persona (aproximado).`) });
  };
  // s212 · «Qué pedir» y «Cuándo conviene ir» arman el título y «Lo esencial» (ronda 10). Los dos campos de la
  // base ya existen (title_es, description_es); los destacados y el plan esperan el lote B (Bubble).
  const tituloArmado = () => {
    const escrito = form.offer_title_es.trim();
    if (escrito && !esTituloUmbralGenerado(escrito)) return escrito;
    if (form.que_pedir.trim()) return form.que_pedir.trim();
    if (siembraPct) return pctSiembraNum > 0 ? tituloPorcentaje(pctSiembraNum, topeSiembraNum, false, form.category) : "";
    return tamanoElegido ? fraseUmbral(tamanoElegido.monto, tamanoElegido.minimo, false) : "";
  };
  // s233 · «Sugerir con IA»: propone «Qué pedir» y «Lo esencial» antes de sembrar (suggest_seed_offer, pedido a Cowork).
  // Escribe en el formulario y lo marca como sugerido: Otto lo confirma o corrige en la llamada.
  const [ia, setIa] = useState({ estado: "", texto: "" });   // "" | "pidiendo" | "ok" | "error"
  const sugerirConIa = async () => {
    setIa({ estado: "pidiendo", texto: "" });
    try {
      const s = await suggestSeedOffer({ business_name: form.business_name, category: form.category, business_type: form.business_type,
        neighborhood: form.neighborhood || form.zone, website: form.website, place_id: form.place_id, horario_google: horarioG?.texto || "", google_type: tipoGoogle, google_types: tiposGoogle,
        sin_web: form.sin_web === true, texto_negocio: form.texto_negocio });
      if (!s.que_pedir_es && !s.esencial_es && !s.servicios.length && !s.tip_es) throw Object.assign(new Error("vacío"), { code: "EMPTY" });
      // s233 · siembra-ia-mapear-instagram: el Instagram de la web solo llena el campo si está vacío (no pisa el de Otto).
      // s233 · franja-sugerida-aplicada (Ali: «no se marcó»): la franja ★ de la IA se APLICA (horas + días), siempre que
      // Otto no haya elegido una: franja vacía o solo con los días que prellenó Google (sin horas). Si ya eligió, no se toca.
      // s235 · franja-dias-cerrados (Ali): los días de la ★ se recortan a los que abre según Google, y una franja que puso
      // la IA antes (sin que Otto la tocara) se reemplaza con la nueva.
      const sug = s.servicios.find(x => x.sugerida);
      const franjaSug = sug ? { valid_days: soloDiasAbiertos(sug.dias, horarioG?.dias), valid_time_start: sug.ini, valid_time_end: sug.fin } : null;
      setForm(f => {
        const libre = !(f.franja && (f.franja.valid_time_start || f.franja.valid_time_end)) || mismaFranja(f.franja, franjaDeIa.current);
        const aplicar = franjaSug && libre;
        if (aplicar) franjaDeIa.current = franjaSug;
        return { ...f, que_pedir: s.que_pedir_es || f.que_pedir, description_es: conFraseAlcance(s.esencial_es, f.category) || f.description_es,
          instagram: f.instagram.trim() ? f.instagram : (s.instagram ? `@${s.instagram}` : f.instagram),
          tags_json: s.tags_json || "",
          franja: aplicar ? franjaSug : f.franja };
      });
      // s233 · v4: los servicios del negocio pasan a «Cuándo vale» (la ★ ya viene aplicada si Otto no había elegido) y el
      // tip se muestra debajo. Sin v4 llegan vacíos y queda todo como en v3.
      setIa({ estado: "ok", texto: en ? "Suggested by AI: check it with the owner on the call." : "Sugerido por la IA: confírmalo con el dueño en la llamada.",
        servicios: s.servicios, tip: s.tip_es, logos: s.logos || [] });
      setLogoWebIdx(0); setLogoWebMsg("");
    } catch (e) {
      const c = e?.code || "";
      setIa({ estado: "error", texto: c === "WF_NOT_DEPLOYED"
        ? (en ? "The seeding AI isn't connected yet (suggest_seed_offer, pending in Bubble)." : "La IA de la siembra todavía no está conectada (suggest_seed_offer, pendiente en Bubble).")
        : c === "GENERATION_LIMIT" ? (en ? "The AI limit for today was reached." : "Se llegó al límite de la IA por hoy.")
        : (en ? `The AI couldn't suggest anything (${c || e?.message || "error"}). Fill it in by hand.` : `La IA no pudo sugerir nada (${c || e?.message || "error"}). Llénalo a mano.`) });
    }
  };
  const esencialArmado = () => {
    if (form.description_es.trim()) return form.description_es.trim();
    // s233 · sin «Cuándo conviene ir» (se quitó: «Cuándo vale» ya lo dice).
    const que = form.que_pedir.trim();
    if (!que) return "";
    // s212 · sin «Vale todos los días que abre» (se desactualiza si el comercio limita días; «Cuándo vale» dice los
    // reales) ni la regla del beneficio por membresía (ya está en las reglas: salía dos veces en la ficha).
    return `${fraseAlcance(form.category, false)} Lo que más piden: ${que}.`;   // s239 · D6
  };
  const datosOferta = () => ({
    offer_title_es: tituloArmado(),
    // s236-D6 · en porcentaje: `benefit_value_usd` = el tope (convención del club) y sin mínimo.
    ...(siembraPct
      ? { offer_type: "percent", discount_pct: pctSiembraNum, benefit_value_usd: topeSiembraNum, min_consumption: 0 }
      : { benefit_value_usd: tamanoElegido ? tamanoElegido.monto : 0, min_consumption: tamanoElegido ? tamanoElegido.minimo : 0 }),
    // s215 · en la base sigue siendo POR PERSONA (la unidad de la tabla y del lote); la mesa de dos se divide.
    avg_ticket_usd: ticketPorPersona(form.category, form.avg_ticket_usd) || "",
    description_es: esencialArmado(),
    // s213 · lote B+C. Sin destacados al sembrar (Ali, s213): «Sobre esta oferta» ya dice qué pedir y
    // cuándo ir; «Lo que incluye» queda para lo propio del lugar, que Otto carga al corregir.
    plan: form.plan,
    cooldown_days: form.cooldown_days,
  });
  const faltante = () => {
    if (!form.business_name.trim()) return en ? "The business name is required." : "Falta el nombre del negocio.";
    if (!form.category) return en ? "Pick a category." : "Elige un rubro.";
    if (!BETA_ESTADOS.includes(form.beta_state)) return en ? "Pick a state." : "Elige un estado.";
    if (!conWizard && siembraPct) {
      if (pctSiembraNum < PCT_MINIMO) return mensajeLoteBC("OFFER_PCT_TOO_LOW", en);
      if (pctSiembraNum > 100) return en ? "The percentage can't be more than 100." : "El porcentaje no puede pasar de 100.";
      if (!(topeSiembraNum > 0)) return en ? `Write the cap per ${perfilDelRubro(form.category).visita.en}.` : `Escribe el tope por ${perfilDelRubro(form.category).visita.es}.`;
    } else if (!conWizard && !tamanoElegido) return en ? "Pick the offer size." : "Elige el tamaño de la oferta.";
    if (!conWizard && !siembraPct && tamanoElegido) {
      // s250 · la tabla manda: sin ticket no hay cómo saber el tamaño (por eso 3 ofertas quedaron sin dato).
      const ticket = ticketPorPersona(form.category, form.avg_ticket_usd);
      if (!(ticket > 0)) return en ? "Write what one person spends: the size comes from it." : "Escribe cuánto gasta una persona: de ahí sale el tamaño.";
      const d = desvioDeTabla(form.category, ticket, form.business_type, tamanoElegido.id);
      if (!d.enRubro) return en ? "That size doesn't exist for this category. Pick another." : "Ese tamaño no existe en este rubro. Elige otro.";
      if (Math.abs(d.pasos) > 1) return en
        ? `With $${ticket} per person the table says ${fraseUmbral(d.rec.monto, d.rec.minimo, true)}. You can only move one size away.`
        : `Con $${ticket} por persona la tabla dice ${fraseUmbral(d.rec.monto, d.rec.minimo, false)}. Solo puedes apartarte un escalón.`;
      if (tituloContradiceMonto(tituloArmado(), tamanoElegido.monto, tamanoElegido.minimo))
        return en ? "The title and the size show different amounts: change one." : "El título y el tamaño dicen montos distintos: cambia uno.";
    }
    return "";
  };
  // s250 · un escalón fuera de la tabla se puede (el guion lo permite si el dueño lo pide), pero se confirma.
  const confirmaDesvioTabla = () => {
    if (conWizard || siembraPct || !tamanoElegido) return true;
    const ticket = ticketPorPersona(form.category, form.avg_ticket_usd);
    const d = desvioDeTabla(form.category, ticket, form.business_type, tamanoElegido.id);
    if (d.pasos === 0) return true;
    return window.confirm(en
      ? `With $${ticket} per person the table says ${fraseUmbral(d.rec.monto, d.rec.minimo, true)}, and you picked ${fraseUmbral(tamanoElegido.monto, tamanoElegido.minimo, true)}. Did the owner ask for it?`
      : `Con $${ticket} por persona la tabla dice ${fraseUmbral(d.rec.monto, d.rec.minimo, false)} y elegiste ${fraseUmbral(tamanoElegido.monto, tamanoElegido.minimo, false)}. ¿Lo pidió el dueño?`);
  };
  // Un sembrado (del formulario o del lote) entra a la caché local y a la lista. Lo que sabe
  // el front en ese momento; el WF get_seeded_merchants lo pisa cuando exista.
  const registrarSembrado = (d, r) => {
    const item = {
      merchant_id: r.merchant_id, business_name: d.business_name, category: d.category,
      neighborhood: d.neighborhood || "", zone: d.zone || "", beta_state: d.beta_state, status: "Lead",
      beta_token: r.beta_token, seeded_at: new Date().toISOString(), seeded_by_name: profile?.name || "",
      beta_opens_count: 0, beta_last_open_at: "", invited_at: "", invite_door: "", invite_sent_count: 0, owner_email: "",
      offer_id: r.offer_id || "", offer_title: d.offer_title_es, benefit_value_usd: d.benefit_value_usd,
      min_consumption: d.min_consumption, offer_status: "Pending", offer_is_active: false, local: true,
      sin_foto: d.sin_foto === true,   // s232 · hasta que get_seeded_merchants traiga la galería
    };
    const cache = [item, ...leerCacheBeta().filter(x => x.merchant_id !== item.merchant_id)];
    guardarCacheBeta(cache);
    if (origenLista === "wf") cargarLista(); else setLista(cache);
    return item;
  };
  // s230 · `extra.beta_state` = el estado con el que quedó de verdad (adoptar puede bajar visible → demo); `extra.nota`, lo que se le dice a Otto.
  const registrar = (r, adoptado, extra = {}) => {
    const item = registrarSembrado({ ...datosOferta(), business_name: form.business_name.trim(), category: form.category,
      neighborhood: form.neighborhood, zone: form.zone, beta_state: extra.beta_state || form.beta_state, sin_foto: extra.sin_foto === true }, r);
    setResultado({ ...item, adoptado, nota: extra.nota || "" });
    setExistente(null);
  };
  const mensajeSeed = (e) => {
    const c = String(e?.code || "");
    if (c === "NOT_OPERATOR") return en ? "Your user isn't an operator or admin." : "Tu usuario no es operador ni admin.";
    if (c === "NO_SESSION") return en ? "Your session expired. Sign in again." : "Tu sesión venció. Entra de nuevo.";
    if (c === "WF_NOT_DEPLOYED") return en ? "That workflow isn't in Live yet (pending deploy)." : "Ese workflow todavía no está en Live (falta el deploy).";
    if (c === "MERCHANT_NOT_FOUND") return en ? "That business no longer exists." : "Ese comercio ya no existe.";
    return mensajeLoteBC(c, en) || e?.message || (en ? "Something failed." : "Algo falló.");
  };
  // s222 · lote 2a · seed_merchant / adopt_merchant no reciben el canal: va después, sobre la oferta recién creada
  // (sigue Pending), con operator_update_offer. Si falla, el comercio ya quedó sembrado: se avisa y el canal queda
  // vacío (= el del rubro, como hasta hoy). adopt sin offer_id = el comercio ya tenía oferta: no se toca.
  const canalSiembra = canalValido(form.redemption_channel) || canalDelRubro(form.category);
  const ponerCanalSembrado = async (r) => {
    if (!r?.offer_id) return;
    try {
      await operatorUpdateOffer({ offer_id: r.offer_id, redemption_channel: canalSiembra });
    } catch (e) {
      setError(en
        ? `It was seeded, but the channel wasn't saved (${e?.code || e?.message || "error"}). Fix it from the list.`
        : `Quedó sembrado, pero el canal no se guardó (${e?.code || e?.message || "error"}). Corrígelo desde la lista.`);
    }
  };
  const sembrar = async () => {
    const f = faltante();
    if (f) { setError(f); return; }
    if (!confirmaDesvioTabla()) return;
    // s212 · Ali: sin foto no sale en el catálogo. «Fotos en camino» fue el 🔴 de las 4 personas de la ronda 10.
    if (form.beta_state === "visible" && !photo) {
      setError(en ? "To publish as visible, add a photo first." : "Para dejarlo visible, primero sube una foto."); return;
    }
    setEnviando(true); setError(""); setResultado(null); setExistente(null);
    try {
      // s218 · siembra v2: el teléfono en +1… y el horario elegido (sin franja = todo el horario del comercio).
      const r = await seedMerchant({ ...form, phone: telE164(form.phone) || form.phone.trim(), logo, photo, ...datosOferta(), ...(esEncargo(form.category) ? {} : (form.franja || {})),
        business_hours: horasTextoG, business_hours_json: horasG });   // s233 · solo viajan con SEED_CON_HORARIO (api.js)
      // s232 · siembra-foto-obligatoria-con-invitacion (blanda): sin foto se siembra igual, con la nota para Otto.
      registrar(r, false, photo ? {} : { nota: NOTA_INVITACION_SIN_FOTO(en), sin_foto: true });
      await ponerCanalSembrado(r);
      // s233 · las demás fotos (la portada ya viajó en seed_merchant). Si alguna falla, el comercio ya quedó sembrado:
      // se avisa cuántas faltan y se agregan desde la lista («Fotos»), igual que el lote.
      const extra = fotosGen.slice(1);
      if (extra.length && r?.merchant_id) {
        let subidas = 0;
        try {
          for (const f of extra) { await operatorAddPhoto(r.merchant_id, f); subidas += 1; }
        } catch (e) {
          setError(en
            ? `It was seeded, but ${extra.length - subidas} of the extra photos didn't upload (${e?.code || e?.message || "error"}). Add them from the list («Photos»).`
            : `Quedó sembrado, pero ${extra.length - subidas} de las fotos extra no subieron (${e?.code || e?.message || "error"}). Agrégalas desde la lista («Fotos»).`);
        }
      }
      vaciarFormulario(true);   // s234 · siembra-formulario-limpio
    } catch (e) {
      if (e?.code === "ALREADY_SEEDED") setExistente(e.merchant_id || "?");
      else setError(mensajeSeed(e));
    } finally {
      setEnviando(false);
    }
  };
  // s224 · lo que el wizard llama al final: seed_merchant SIN oferta (export 131). Lo de la oferta lo crea el wizard
  // después, con operatorAddOffer. Sin foto ni logo: las fotos van con operatorAddPhoto, DESPUÉS de las ofertas, para
  // que la portada caiga en ellas. Visible pide foto: se siembra en Demo y el wizard lo pasa a Visible al final.
  // Los errores salen con `mensaje` ya escrito (el wizard lo muestra tal cual).
  const sembrarSinOferta = async (resumen) => {
    const f = faltante();
    if (f) throw Object.assign(new Error(f), { mensaje: f });
    setError(""); setResultado(null); setExistente(null);
    const d = {
      ...form, phone: telE164(form.phone) || form.phone.trim(), logo: null, photo: null,
      beta_state: form.beta_state === "visible" ? "demo" : form.beta_state,
      description_es: esencialArmado(), avg_ticket_usd: "", offer_title_es: "", benefit_value_usd: 0, min_consumption: 0,
    };
    try {
      const r = await seedMerchant(d);
      const item = registrarSembrado({ ...d, business_name: form.business_name.trim(),
        offer_title_es: resumen.offer_title_es, benefit_value_usd: resumen.benefit_value_usd, min_consumption: resumen.min_consumption }, r);
      setResultado({ ...item, adoptado: false });
      return r;
    } catch (e) {
      if (e?.code === "ALREADY_SEEDED") {
        setExistente(e.merchant_id || "?");
        throw Object.assign(new Error("ALREADY_SEEDED"), { code: e.code, mensaje: en ? "That place is already seeded: adopt it below with the generic offer." : "Ese lugar ya está sembrado: adóptalo abajo con la oferta genérica." });
      }
      throw Object.assign(e, { mensaje: mensajeSeed(e) });
    }
  };
  const alTerminarWizard = () => {
    // La foto del formulario ya subió: si quedara, el wizard nuevo la tomaría otra vez como portada.
    setPhoto(null); setFotosWizard([]); setFotosEnWizard([]);
    setWizKey(k => k + 1);
    cargarLista();
  };
  const adoptar = async () => {
    if (!existente) return;
    // s224 · adopt_merchant crea la estándar: con el wizard, se pasa a la oferta genérica para elegir el tamaño.
    if (conWizard) {
      setModoOferta("clasica");
      setError(en ? "To adopt it, pick the size in the generic offer below." : "Para adoptarlo, elige el tamaño en la oferta genérica de abajo.");
      return;
    }
    // s255 · adopt_merchant (Bubble) solo crea monto fijo: con porcentaje no se llama (crearía otra cosa o fallaría).
    // Ticket `adopt-merchant-porcentaje` (Cowork). Casi no pasa: hoy ningún comercio se registró solo (Ali, s255).
    if (siembraPct) {
      setError(en ? "Adopting with a percentage isn't available yet (the backend only creates a fixed amount). Tell Ali: we set it by hand."
                  : "Adoptar con porcentaje todavía no está (el backend solo crea monto fijo). Avísale a Ali: lo dejamos a mano.");
      return;
    }
    const f = faltante();
    if (f) { setError(f); return; }
    if (!confirmaDesvioTabla()) return;
    setEnviando(true); setError("");
    // s230 · adopt-visible-sin-foto: sin foto no sale en el catálogo (s212-D13) y adopt_merchant frena «visible» con
    // PHOTO_REQUIRED (export 142). Si el comercio está en Sembrados, su fila ya dice si tiene fotos y se adopta en Demo
    // sin llamar; si no está (un alta normal: check_place_id no trae galería), se pide Visible y, si Bubble frena, se
    // reintenta en Demo. Igual que sembrarSinOferta: Visible se da después, desde la lista, con la foto puesta.
    const fila = lista.find(x => x.merchant_id === existente);
    const sinFoto = fila ? !(Array.isArray(fila.gallery_urls) && fila.gallery_urls.length > 0) : null;   // null = no se sabe
    let estado = form.beta_state === "visible" && sinFoto === true ? "demo" : form.beta_state;
    try {
      const pedir = (beta) => adoptMerchant({ merchant_id: existente, beta_state: beta, business_name: form.business_name, ...datosOferta() });
      let r;
      try {
        r = await pedir(estado);
      } catch (e) {
        if (estado !== "visible" || e?.code !== "PHOTO_REQUIRED") throw e;
        estado = "demo";
        r = await pedir("demo");
      }
      const bajado = form.beta_state === "visible" && estado === "demo";
      registrar(r, true, bajado
        ? { beta_state: "demo", nota: NOTA_SIN_FOTO(en), sin_foto: true }
        : (sinFoto === true ? { nota: NOTA_INVITACION_SIN_FOTO(en), sin_foto: true } : {}));   // s232 · blanda: avisa, no frena
      await ponerCanalSembrado(r);
      // s233 · adopt_merchant no recibe el logo: va después, como en «Fotos → + Agregar logo». Si falla, ya quedó adoptado.
      if (logo) {
        try { await operatorAddLogo(existente, logo); }
        catch (e) {
          setError(en ? `It was adopted, but the logo didn't upload (${e?.code || e?.message || "error"}). Add it from the list («Photos»).`
                      : `Quedó adoptado, pero el logo no subió (${e?.code || e?.message || "error"}). Agrégalo desde la lista («Fotos»).`);
        }
      }
      vaciarFormulario(true);   // s234 · siembra-formulario-limpio
    } catch (e) {
      setError(mensajeSeed(e));
    } finally {
      setEnviando(false);
    }
  };
  // s234 · siembra-formulario-limpio (Ali): el formulario no se vaciaba después de sembrar, y elegir otro lugar en Google
  // solo pisaba lo de Google: el comercio siguiente se llevaba las fotos, el logo, el Instagram, «Qué pedir» y «Lo
  // esencial» del anterior (Pattern 10). `vaciarFormulario` es «Limpiar» sin tocar el resultado ni el error (el recuadro
  // «Sembrado: …» con el link queda a la vista). `conservarEstado` deja el Demo/Visible que eligió Otto.
  const vaciarFormulario = (conservarEstado = false) => {
    plazoTocado.current = false; franjaDeIa.current = null;
    formatoTocado.current = false; formatoDelRubro(FORM0.category);   // s236-D6 · s237: la regla del rubro, no salón fijo
    setForm(f => (conservarEstado ? { ...FORM0, beta_state: f.beta_state } : FORM0));
    setLogo(null); setPhoto(null); setFotosWizard([]); setFotosEnWizard([]); setIa({ estado: "", texto: "" }); setSugerido(null); setSugeridoPct(null);
    setBusqueda(""); setSugerencias([]); setDeGoogle(null); setErrorGoogle(""); tokenPlaces.current = "";
    setHorarioG(null); setTipoGoogle(""); setTiposGoogle(""); setVistaGoogle(null); setPrecioG(null); setUrlFoto(""); setErrorUrlFoto("");   // s218 · siembra v2
    setEnBase(null);   // s219
    setHorasG(""); setHorasTextoG(""); setWizKey(k => k + 1);   // s224 · s233 horario de texto
    setLogoWebIdx(0); setLogoWebMsg("");   // s234 · siembra-logo-desde-web
  };
  const limpiar = () => {
    vaciarFormulario(false); setResultado(null); setExistente(null); setError("");
  };
  // s214 · writeText devuelve una promesa: si el navegador no deja copiar, el rechazo no lo atrapa el try
  // (salía «Uncaught … NotAllowedError»). Se ataja con .catch.
  const alPortapapeles = (texto) => {
    try { navigator.clipboard?.writeText(texto)?.catch(() => {}); } catch (e) { /* sin clipboard */ }
  };
  const copiar = (token, category, negocio) => {
    alPortapapeles(linkBeta(token, category, negocio));   // sin clipboard: el link está a la vista
    setCopiado(token); setTimeout(() => setCopiado(""), 1500);
  };
  // s214 · el mensaje entero (ver mensajeEnlaceBeta). `copiado` lleva «msg:» para no confundirse con el del link.
  const mensajeDe = (negocio, token, category) => mensajeEnlaceBeta(negocio, token, profile?.name, en, category);
  const copiarMensaje = (negocio, token, category) => {
    alPortapapeles(mensajeDe(negocio, token, category));   // sin clipboard: queda WhatsApp
    setCopiado(`msg:${token}`); setTimeout(() => setCopiado(""), 1500);
  };
  const waMensaje = (negocio, token, category) => `https://wa.me/?text=${encodeURIComponent(mensajeDe(negocio, token, category))}`;
  const fmtF = (v) => { if (!v) return "—"; const d = new Date(v); return isNaN(d.getTime()) ? "—" : d.toLocaleString(); };

  // «Aprobó» y «Reenviar»: la misma llamada, con sesión (puerta «operador»).
  const invitar = async (fila, correo) => {
    const c = String(correo || "").trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(c)) { setMsgFila(m => ({ ...m, [fila.merchant_id]: mensajeInvite("INVALID_EMAIL", en) })); return; }
    setFilaOcupada(fila.merchant_id);
    try {
      const r = await inviteMerchant({ t: fila.beta_token, owner_email: c, comoOperador: true });
      const texto = r?.email_step === "no"
        ? (en ? `Account created for ${c}, but the email didn't go out (email_step = no).` : `Cuenta creada para ${c}, pero el correo no salió (email_step = no).`)
        : (en ? `Email sent to ${c} (door: ${r?.door || "?"}).` : `Correo enviado a ${c} (puerta: ${r?.door || "?"}).`);
      setMsgFila(m => ({ ...m, [fila.merchant_id]: texto }));
      const parche = (x) => x.merchant_id === fila.merchant_id
        ? { ...x, invited_at: x.invited_at || new Date().toISOString(), invite_door: r?.door || x.invite_door,
            invite_sent_count: (Number(x.invite_sent_count) || 0) + 1, owner_email: c,
            status: x.status === "Lead" ? "Invitado" : x.status }
        : x;
      setLista(l => l.map(parche));
      guardarCacheBeta(leerCacheBeta().map(parche));
      // s218 · invite_merchant pasa a Visible SOLO si el comercio tiene foto (decisión de Ali, export 118):
      // la fila ya no se pinta «visible» por su cuenta. El estado real lo trae la lista.
      if (origenLista === "wf") cargarLista();
      setAprobando(null); setCorreoAprobar("");
    } catch (e) {
      setMsgFila(m => ({ ...m, [fila.merchant_id]: mensajeInvite(e?.code, en) }));
    } finally {
      setFilaOcupada(null);
    }
  };

  // ---- el lote ----
  const setFila = (i, parche) => setLoteFilas(prev => prev.map((f, j) => (j === i ? { ...f, ...parche } : f)));
  const previsualizar = () => {
    const filas = validarFilasSiembra(parsearFilasSiembra(loteTexto))
      .map(f => ({ ...f, estado: f.errores.length ? "omitida" : "pendiente", mensaje: "", merchant_id: "", beta_token: "", offer_id: "", adoptado: false }));
    setLoteFilas(filas);
    setLoteCopiado(false);
    setLoteGoogle(null);
  };
  const limpiarLote = () => { setLoteTexto(""); setLoteFilas(null); setLoteCopiado(false); setLoteGoogle(null); };
  const datosDeFila = (f) => {
    const t = UMBRAL_TAMANOS.find(x => x.id === f.tamano);
    return {
      business_name: f.business_name, category: f.category, beta_state: loteEstado,
      // s218 · siembra v2: sin zona, la ciudad (el contador cuenta por zone); teléfono en +1…; y los 4 de N3.
      neighborhood: f.neighborhood, zone: f.zone || f.city || "", phone: telE164(f.phone) || f.phone, instagram: f.instagram,
      zip: f.zip || "", city: f.city || "", address_full: f.address_full || "", website: f.website || "",
      // s217 · sin link en la hoja pero con place_id: el link se arma con el formato oficial de Maps URLs
      // (sin llamar a Google), para que la ficha tenga «Cómo llegar».
      place_id: f.place_id, avg_ticket_usd: f.ticket,
      google_maps_url: f.google_maps_url || (f.place_id
        ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(f.business_name)}&query_place_id=${encodeURIComponent(f.place_id)}`
        : ""),
      ...(filaEnPorcentaje(f)
        // s238 · lote-salones-en-porcentaje: 25 % sin tope (benefit_value_usd = el tope, convención del club).
        ? { offer_title_es: tituloFilaPct(f.category), offer_type: "percent", discount_pct: PCT_SALON.pct, benefit_value_usd: TOPE_SIN_LIMITE, min_consumption: 0 }
        : { offer_title_es: t ? fraseUmbral(t.monto, t.minimo, false) : "", benefit_value_usd: t ? t.monto : 0, min_consumption: t ? t.minimo : 0 }),
      // s233 · el lote no mandaba plazo (Bubble ponía 30): ahora va el del rubro. Solo viaja con oferta (sumarParamsLoteBC).
      cooldown_days: plazoDelRubro(f.category),
    };
  };
  // SECUENCIAL a propósito: una llamada a la vez, con estado por fila. `soloFallidas` reintenta
  // únicamente las que terminaron en error; las ok y las «ya existía» no se vuelven a tocar.
  const sembrarLote = async (soloFallidas) => {
    if (!loteFilas || loteCorriendo) return;
    setLoteCorriendo(true);
    const filas = loteFilas;
    for (let i = 0; i < filas.length; i++) {
      const f = filas[i];
      if (f.errores.length || !f.tamano) continue;
      if (soloFallidas ? f.estado !== "error" : f.estado !== "pendiente") continue;
      setFila(i, { estado: "corriendo", mensaje: "" });
      const d = datosDeFila(f);
      // s216 · con place_id, la dirección y el pin del mapa salen de Google (si no responde, se siembra igual).
      if (f.place_id) {
        const u = await placeUbicacion(f.place_id);
        if (u) {
          d.lat = u.lat; d.lng = u.lng; if (u.address) d.address = u.address;
          // s218 · siembra v2: lo que la hoja no trae, de Google. Lo que Otto escribió no se pisa.
          if (u.address && !d.address_full) d.address_full = u.address;
          if (u.zip && !d.zip) d.zip = u.zip;
          if (u.city && !d.city) d.city = u.city;
          if (u.neighborhood && !f.neighborhood) d.neighborhood = u.neighborhood;
          if (!f.zone) d.zone = u.neighborhood || u.city || d.zone;
        }
      }
      try {
        const r = await seedMerchant(d);
        setFila(i, { estado: "ok", merchant_id: r.merchant_id, beta_token: r.beta_token, offer_id: r.offer_id || "" });
        registrarSembrado(d, r);
      } catch (e) {
        if (e?.code === "ALREADY_SEEDED") setFila(i, { estado: "already", merchant_id: e.merchant_id || "", mensaje: en ? "Already in the base" : "Ya estaba en la base" });
        else setFila(i, { estado: "error", mensaje: mensajeSeed(e) });
      }
    }
    setLoteCorriendo(false);
  };
  // s217 · «Completar con Google»: solo las filas pendientes SIN ticket y con place_id (lo que Otto escribió no se
  // pisa). Una consulta a la vez. Con precio: ticket (en la unidad de la hoja: mesa de dos en restaurantes y
  // bares), las tres opciones y el Recomendado elegido; de paso el teléfono si faltaba. Sin precio: queda igual.
  const filasParaGoogle = () => (loteFilas || []).map((f, i) => [f, i])
    .filter(([f]) => f.estado === "pendiente" && f.category && f.place_id && !(f.ticket > 0) && !f.consultadaGoogle);
  const completarConGoogle = async () => {
    const pendientes = filasParaGoogle();
    if (!pendientes.length || loteCorriendo) return;
    setLoteCorriendo(true);
    let con = 0, fallos = 0;
    setLoteGoogle({ hechas: 0, total: pendientes.length, con: 0, fallos: 0 });
    for (let k = 0; k < pendientes.length; k++) {
      const [f, i] = pendientes[k];
      const p = await placePrecio(f.place_id);
      const precio = precioDeGoogle(p);
      const parche = { consultadaGoogle: true };
      if (p && p.telefono && !f.phone) parche.phone = telE164(p.telefono);
      if (p && p.web && !f.website && !/instagram\.com/i.test(p.web)) parche.website = p.web;   // s218 · siembra v2
      if (precio) {
        con++;
        const divisor = preguntaTicket(f.category, false).divisor;
        const opciones = opcionesDeTamano(f.category, precio.porPersona, precio.porPersonaBajo);
        Object.assign(parche, {
          ticket: Math.round(precio.porPersona * divisor), fuenteTicket: precio.fuente, rangoGoogle: precio.rangoTexto,
          opciones, tamano: opciones ? opciones.recomendado : f.tamano,
        });
      } else {
        // null = no hubo respuesta (sin clave, red, cuota); objeto vacío = Google respondió sin precio.
        parche.fuenteTicket = p ? "sin_dato_google" : "google_fallo";
      }
      if (!p) fallos++;
      setFila(i, parche);
      setLoteGoogle({ hechas: k + 1, total: pendientes.length, con, fallos });
    }
    setLoteCorriendo(false);
  };
  const adoptarFila = async (i) => {
    const f = loteFilas[i];
    if (!f || !f.merchant_id || loteCorriendo) return;
    setFila(i, { estado: "corriendo", mensaje: "" });
    const d = datosDeFila(f);
    try {
      const pedir = (beta) => adoptMerchant({ merchant_id: f.merchant_id, beta_state: beta, business_name: d.business_name,
        offer_title_es: d.offer_title_es, benefit_value_usd: d.benefit_value_usd, min_consumption: d.min_consumption, avg_ticket_usd: d.avg_ticket_usd });
      // s230 · adopt-visible-sin-foto: la fila del lote no sabe si el comercio tiene foto; si Bubble frena «visible», va en Demo y se dice.
      let r, nota = "";
      try { r = await pedir(loteEstado); }
      catch (e) { if (loteEstado !== "visible" || e?.code !== "PHOTO_REQUIRED") throw e; r = await pedir("demo"); nota = NOTA_SIN_FOTO(en); }
      setFila(i, { estado: "ok", adoptado: true, beta_token: r.beta_token, offer_id: r.offer_id || "", mensaje: nota });
      registrarSembrado(nota ? { ...d, beta_state: "demo" } : d, r);
    } catch (e) {
      setFila(i, { estado: "already", mensaje: mensajeSeed(e) });
    }
  };
  const copiarTodosLosLinks = () => {
    const lineas = (loteFilas || []).filter(f => f.estado === "ok" && f.beta_token).map(f => `${f.business_name}\t${linkBeta(f.beta_token, f.category, f.business_name)}`);
    if (!lineas.length) return;
    alPortapapeles(lineas.join("\n"));   // sin clipboard: los links están en la tabla
    setLoteCopiado(true); setTimeout(() => setLoteCopiado(false), 2000);
  };
  const cuenta = (estado) => (loteFilas || []).filter(f => f.estado === estado).length;
  const LOTE_ROTULO = {
    omitida: [en ? "Skipped" : "Omitida", "var(--superficie-hundida)", "var(--tinta-suave)"],
    pendiente: [en ? "Pending" : "Pendiente", "var(--superficie-hundida)", "var(--tinta-suave)"],
    corriendo: ["…", "var(--info-tinte)", "var(--info)"],
    ok: ["OK", "var(--exito-tinte)", "var(--exito)"],
    already: [en ? "Exists" : "Ya existe", "var(--aviso-tinte)", "var(--aviso)"],
    error: ["Error", "var(--error-tinte)", "var(--error)"],
  };

  const campo = (k, rotulo, props = {}) => (
    <div className="alta-campo">
      <AltaEtiqueta para={`vit-${k}`} texto={rotulo} requerido={props.requerido} />
      <input id={`vit-${k}`} className="alta-input" value={form[k]} onChange={set(k)} {...(props.input || {})} />
    </div>
  );

  // s218 · mini CRM: filtros de la lista. «Activos» esconde los descartados; «Hoy toca llamar» = próxima
  // llamada hoy o vencida (nunca un descartado).
  const hoyFin = finDeHoy();
  const tocaHoy = r => r.status !== "Rejected" && r.next_call_at > 0 && r.next_call_at <= hoyFin;
  const zonas = [...new Set(lista.map(r => r.zone).filter(Boolean))].sort();
  const sembradores = [...new Set(lista.map(r => r.seeded_by_name).filter(Boolean))].sort();
  const listaVista = lista.filter(r =>
    (filtroCrm === "todos" ? true
      : filtroCrm === "activos" ? r.status !== "Rejected"
      : filtroCrm === "hoy" ? tocaHoy(r)
      : r.status === filtroCrm)
    && (!filtroZona || r.zone === filtroZona)
    && (!filtroSembro || r.seeded_by_name === filtroSembro)
    && coincideBusqueda(r, buscarNegocio));
  const filtrosCrm = [
    ["activos", en ? "Active" : "Activos", lista.filter(r => r.status !== "Rejected").length],
    ["hoy", en ? "Call today" : "Hoy toca llamar", lista.filter(tocaHoy).length],
    ["Lead", "Lead", lista.filter(r => r.status === "Lead").length],
    ["Invitado", en ? "Invited" : "Invitado", lista.filter(r => r.status === "Invitado").length],
    ["Approved", en ? "Approved" : "Aprobado", lista.filter(r => r.status === "Approved").length],
    ["Rejected", en ? "Discarded" : "Descartado", lista.filter(r => r.status === "Rejected").length],
    ["todos", en ? "All" : "Todos", lista.length],
  ];

  const cols = [
    { label: en ? "Business" : "Comercio", width: "2fr", render: r => (
      <div>
        <div style={{ fontSize: 14, fontWeight: 700, color: C.black }}>{r.business_name || "—"}</div>
        <div style={{ fontSize: 11, color: C.muted }}>{CAT_DISPLAY[r.category] || r.category || ""}{r.zone || r.neighborhood ? ` · ${r.zone || r.neighborhood}` : ""}</div>
        {/* s239 · seeded-merchants-offer-type-pct: con `offer_type`/`discount_pct` en list_json el % se dice tal cual
            (textoValorOferta); sin esas claves, como antes (la frase de monto fijo). */}
        <div style={{ fontSize: 11, color: C.muted }}>{r.offer_type
          ? [(r.offer_title && !esTituloUmbralGenerado(r.offer_title) && !esTituloPorcentajeGenerado(r.offer_title)) ? r.offer_title : "", textoValorOferta(r, en)].filter(Boolean).join(" · ")
          : (r.offer_title && !esTituloUmbralGenerado(r.offer_title)) ? r.offer_title : (r.benefit_value_usd > 0 ? fraseUmbral(r.benefit_value_usd, r.min_consumption, false) : (r.offer_title || ""))}</div>
        {/* s218 · el teléfono para llamar desde la fila (en el teléfono de Otto, un toque marca). */}
        {telE164(r.phone) && <a href={`tel:${telE164(r.phone)}`} style={{ fontSize: 12, color: "var(--exito)", fontWeight: 600 }}>{r.phone}</a>}
      </div>
    )},
    { label: en ? "Calls" : "Llamadas", width: "1.1fr", render: r => (
      <div style={{ display: "flex", flexDirection: "column", gap: 3, alignItems: "flex-start" }}>
        <AdminBadge label={etiquetaEtapa(r.status === "Rejected" ? "descartado" : r.pipeline_stage, en)}
          type={r.status === "Rejected" ? "rejected" : (r.pipeline_stage === "aprobado" ? "approved" : "pending")} />
        {r.status === "Rejected" && r.discard_reason && <span style={{ fontSize: 11, color: C.muted }}>{r.discard_reason}</span>}
        {r.status !== "Rejected" && r.next_call_at > 0 && (
          <span style={{ fontSize: 11, fontWeight: tocaHoy(r) ? 700 : 400, color: tocaHoy(r) ? "var(--error)" : C.gray }}>
            {tocaHoy(r) ? (en ? "Call today" : "Toca hoy") : (en ? "Next:" : "Próxima:")} {fechaCorta(r.next_call_at, en)}
          </span>
        )}
        <span style={{ fontSize: 11, color: C.muted }}>{r.last_call_at > 0 ? `${en ? "Last:" : "Última:"} ${fechaCorta(r.last_call_at, en)}` : (en ? "Not called yet" : "Sin llamadas")}</span>
      </div>
    )},
    { label: en ? "State" : "Estado", width: "1.1fr", render: r => (
      <div style={{ display: "flex", flexDirection: "column", gap: 4, alignItems: "flex-start" }}>
        <AdminBadge label={r.beta_state || "—"} type={r.beta_state === "visible" ? "active" : "pending"} />
        {/* s216 · deploy D: el estado se cambia aquí (antes, solo al sembrar o con «Adoptar»). */}
        {r.merchant_id && r.beta_state && (
          <select aria-label={en ? "Change showcase state" : "Cambiar el estado en la vitrina"} value={r.beta_state}
            disabled={estadoOcupado === r.merchant_id} onChange={e => cambiarEstado(r, e.target.value)}
            style={{ fontSize: 11, padding: "2px 4px", border: `1px solid ${C.border}`, borderRadius: 2, color: C.gray, background: C.white }}>
            <option value="demo">{en ? "Demo" : "Demo"}</option>
            <option value="borroso">{en ? "Blurred" : "Difuminado"}</option>
            <option value="visible">{en ? "Visible" : "Visible"}</option>
          </select>
        )}
        <span style={{ fontSize: 11, color: C.muted }}>{r.status || "—"}{r.offer_status ? ` · ${en ? "offer" : "oferta"} ${r.offer_status}` : ""}</span>
      </div>
    )},
    { label: en ? "Opens" : "Aperturas", width: "1fr", render: r => (
      <div>
        <div style={{ ...S.display, fontSize: 20, color: C.black }}>{Number(r.beta_opens_count) || 0}</div>
        <div style={{ fontSize: 11, color: C.muted }}>{r.beta_last_open_at ? fmtF(r.beta_last_open_at) : (en ? "never" : "nunca")}</div>
      </div>
    )},
    { label: en ? "Invitation" : "Invitación", width: "1.4fr", render: r => (
      r.invited_at
        ? <div style={{ fontSize: 12, color: C.gray }}>
            <div>{r.owner_email || "—"}</div>
            <div style={{ color: C.muted }}>{r.invite_door || "?"} · {fmtF(r.invited_at)} · ×{Number(r.invite_sent_count) || 0}</div>
          </div>
        : <span style={{ fontSize: 12, color: C.muted }}>—</span>
    )},
    { label: "Link", width: "0.9fr", render: r => (
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {/* s232 · siembra-foto-obligatoria-con-invitacion (blanda): marca junto al enlace cuando el sembrado no tiene foto. */}
        {r.beta_token && filaSinFoto(r) && (
          <span title={NOTA_INVITACION_SIN_FOTO(en)} aria-label={NOTA_INVITACION_SIN_FOTO(en)}
            style={{ fontSize: 11, color: "var(--aviso-tinta)", fontWeight: 600, alignSelf: "center", flexBasis: "100%" }}>
            ⚠ {en ? "No photo: add one before sending" : "Sin foto: súbela antes de mandar el enlace"}
          </span>
        )}
        <button onClick={() => copiarMensaje(r.business_name, r.beta_token, r.category)} disabled={!r.beta_token} style={{ background: "none", border: `1px solid ${C.border}`, color: copiado === `msg:${r.beta_token}` ? "var(--exito)" : C.gray, padding: "4px 8px", fontSize: 11, cursor: "pointer", borderRadius: 2 }}>
          {copiado === `msg:${r.beta_token}` ? "✓" : (en ? "Message" : "Mensaje")}
        </button>
        {r.beta_token && <a href={waMensaje(r.business_name, r.beta_token, r.category)} target="_blank" rel="noopener noreferrer" style={{ fontSize: 11, color: "var(--exito)", alignSelf: "center", fontWeight: 600 }}>WhatsApp</a>}
        <button onClick={() => copiar(r.beta_token, r.category, r.business_name)} disabled={!r.beta_token} style={{ background: "none", border: `1px solid ${C.border}`, color: copiado === r.beta_token ? "var(--exito)" : C.muted, padding: "4px 8px", fontSize: 11, cursor: "pointer", borderRadius: 2 }}>
          {copiado === r.beta_token ? "✓" : (en ? "Copy" : "Copiar")}
        </button>
        <a href={linkBeta(r.beta_token, r.category, r.business_name)} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: C.muted, alignSelf: "center" }}>{en ? "Open" : "Abrir"}</a>
      </div>
    )},
    { label: en ? "Actions" : "Acciones", width: "1.6fr", render: r => (
      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
        {aprobando === r.merchant_id ? (<>
          <form onSubmit={e => { e.preventDefault(); invitar(r, correoAprobar); }} style={{ display: "flex", gap: 6 }}>
            <input className="alta-input" type="email" autoFocus placeholder={en ? "owner@email.com" : "dueno@correo.com"} value={correoAprobar} onChange={e => setCorreoAprobar(e.target.value)} style={{ flex: 1, padding: "6px 8px", fontSize: 12 }} />
            <button type="submit" disabled={filaOcupada === r.merchant_id} style={{ ...S.btnPrimary, width: "auto", padding: "6px 10px", fontSize: 12 }}>{filaOcupada === r.merchant_id ? "…" : (en ? "Send" : "Enviar")}</button>
            <button type="button" onClick={() => { setAprobando(null); setCorreoAprobar(""); }} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "6px 8px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>✕</button>
          </form>
          {/* s238 · ayudas V39: qué hace «Enviar» (invite_merchant, export 150). */}
          <div style={{ fontSize: 11, color: C.gray, lineHeight: 1.4 }}>{en
            ? "When you send, we create the account with this email and they get two messages: one to set a password and the invitation with their offer. The business becomes Invited; it's Approved once they confirm from their panel. You can resend up to 5 times."
            : "Al enviar, le creamos la cuenta con este correo y le llegan dos mensajes: uno para crear su contraseña y la invitación con su oferta. El comercio pasa a Invitado; queda Aprobado cuando él confirma desde su panel. Puedes reenviar hasta 5 veces."}</div>
          </>
        ) : (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            <button onClick={() => { setAprobando(r.merchant_id); setCorreoAprobar(r.owner_email || ""); }} disabled={!r.beta_token || filaOcupada === r.merchant_id}
              style={{ ...S.btnPrimary, width: "auto", padding: "6px 10px", fontSize: 12 }}>
              {en ? "Approved" : "Aprobó"}
            </button>
            {r.owner_email && (
              <button onClick={() => invitar(r, r.owner_email)} disabled={filaOcupada === r.merchant_id}
                style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
                {filaOcupada === r.merchant_id ? "…" : (en ? "Resend" : "Reenviar")}
              </button>
            )}
          </div>
        )}
        {msgFila[r.merchant_id] && <div style={{ fontSize: 11, color: C.gray, lineHeight: 1.4 }}>{msgFila[r.merchant_id]}</div>}
        {/* s203 · «Fotos»: abre el panel de fotos de ESTE comercio debajo de su fila (s216; antes, debajo de la tabla). */}
        {r.merchant_id && (
          <button type="button" onClick={() => setFotosDe(fotosDe?.merchant_id === r.merchant_id ? null : { merchant_id: r.merchant_id, business_name: r.business_name, gallery_urls: r.gallery_urls || [], logo: r.logo || "", enlaces: enlacesDeSembrado(r) })}
            aria-expanded={fotosDe?.merchant_id === r.merchant_id}
            style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2, alignSelf: "flex-start" }}>
            {en ? "Photos" : "Fotos"}
          </button>
        )}
        {/* s213 · lote B+C: plan, plazo y «Lo que incluye» de una oferta ya sembrada. */}
        {r.merchant_id && (
          <button type="button" onClick={() => setCorrigiendo(corrigiendo?.merchant_id === r.merchant_id ? null : r)}
            aria-expanded={corrigiendo?.merchant_id === r.merchant_id}
            style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2, alignSelf: "flex-start" }}>
            {en ? "Fix offer" : "Corregir oferta"}
          </button>
        )}
        {/* s217 · 2bis (export 114): otra oferta con su horario (almuerzo, happy hour, cena). */}
        {r.merchant_id && !esEncargo(r.category) && (
          <button type="button" onClick={() => setFranjaDe(franjaDe?.merchant_id === r.merchant_id ? null : r)}
            aria-expanded={franjaDe?.merchant_id === r.merchant_id}
            style={{ background: "none", border: `1px solid ${C.border}`, color: C.gray, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2, alignSelf: "flex-start" }}>
            {en ? "+ Another time slot" : "+ Otra franja"}
          </button>
        )}
        {/* s218 · mini CRM (export 117). */}
        {r.merchant_id && r.status !== "Rejected" && (
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            <button type="button" onClick={() => setLlamadaDe(llamadaDe?.merchant_id === r.merchant_id ? null : r)}
              aria-expanded={llamadaDe?.merchant_id === r.merchant_id}
              style={{ background: "none", border: `1px solid ${C.black}`, color: C.black, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2, fontWeight: 600 }}>
              {en ? "Log call" : "Registrar llamada"}
            </button>
            <button type="button" onClick={() => setDescarteDe(descarteDe?.merchant_id === r.merchant_id ? null : r)}
              aria-expanded={descarteDe?.merchant_id === r.merchant_id}
              style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "6px 10px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
              {en ? "Discard" : "Descartar"}
            </button>
          </div>
        )}
      </div>
    )},
  ];

  return (
    <div style={{ ...S.page, minHeight: "100vh", padding: "24px 16px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20, flexWrap: "wrap", gap: 10 }}>
          <div>
            <div style={{ ...S.display, fontSize: 26, color: C.black }}>
              {vista === "negocios" ? (en ? "BUSINESSES" : "NEGOCIOS") : (en ? "SEED" : "SEMBRAR")}
            </div>
            <div style={{ fontSize: 12, color: C.muted }}>
              {profile?.name || profile?.email || ""} · {vista === "negocios"
                ? (en ? "find a business, call it, register the yes" : "buscar un comercio, llamarlo, registrar el sí")
                : (en ? "seed businesses and share the link" : "sembrar comercios y compartir el link")}
            </div>
            {/* s238 · una página para sembrar y otra para los negocios ya sembrados. */}
            <div className="alta-chips" role="navigation" aria-label={en ? "Operator pages" : "Páginas de la consola"} style={{ marginTop: 10 }}>
              {[["negocios", "/operator/negocios", en ? `Businesses · ${lista.length}` : `Negocios · ${lista.length}`],
                ["sembrar", "/operator/vitrina", en ? "Seed" : "Sembrar"]].map(([id, ruta, texto]) => (
                <button key={id} type="button" aria-current={vista === id ? "page" : undefined}
                  className={["alta-chip", vista === id && "alta-chip--on"].filter(Boolean).join(" ")}
                  onClick={() => { if (vista !== id) navigate(ruta); }}>{texto}</button>
              ))}
            </div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => navigate("/operator")} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "8px 14px", fontSize: 12, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
              {en ? "← Console" : "← Consola"}
            </button>
            <button onClick={() => { auth.logout(); navigate("/login"); }} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "8px 14px", fontSize: 12, cursor: "pointer", borderRadius: 2, fontFamily: "'DM Sans', sans-serif" }}>
              {en ? "Log out" : "Salir"}
            </button>
          </div>
        </div>

        {BETA_FIXTURES && (
          <div style={{ background: "var(--aviso-tinte)", color: "var(--aviso-tinta)", fontSize: 12, padding: "8px 12px", borderRadius: 4, marginBottom: 16 }}>
            DEV · fixtures activos: si un WF responde 404 se simula. Link de prueba: {linkBeta(BETA_FIXTURE_TOKEN)}
          </div>
        )}

        {/* ---------- SEMBRAR ---------- */}
        {vista === "sembrar" && (<>
        <section style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 8, padding: 20, marginBottom: 24 }}>
          <div style={{ ...S.display, fontSize: 20, color: C.black, marginBottom: 4 }}>{en ? "SEED A BUSINESS" : "SEMBRAR UN COMERCIO"}</div>
          <div style={{ fontSize: 12, color: C.muted, marginBottom: 16 }}>
            {en ? "Before the call: name, category, photos, the gist and a generic offer by spend per person. The owner's account is created later, when they say yes."
                : "Antes de la llamada: nombre, rubro, fotos, lo esencial y una oferta genérica por gasto por persona. La cuenta del dueño nace después, cuando dice que sí."}
          </div>

          {placesEnabled() && (
            <div className="alta-campo vit-google">
              <AltaEtiqueta para="vit-google" texto={en ? "Find it on Google" : "Búscalo en Google"}
                pista={en ? "Fills in name, category, address, phone, neighborhood and the place_id. With the place_id, if the business is already seeded, you'll be told before a duplicate is created."
                          : "Llena nombre, rubro, dirección, teléfono, barrio y el place_id. Con el place_id, si el negocio ya está sembrado, te avisa antes de duplicarlo."} />
              <input id="vit-google" className="alta-input" value={busqueda} autoComplete="off"
                onChange={e => { setBusqueda(e.target.value); setErrorGoogle(""); }}
                placeholder={en ? "E.g.: STATUS Hair Studio Brickell" : "Ej: STATUS Hair Studio Brickell"} />
              {buscando && <div className="alta-ayuda">{en ? "Searching…" : "Buscando…"}</div>}
              {errorGoogle && <div className="alta-aviso alta-aviso--error alta-aviso--campo">{errorGoogle}</div>}
              {sugerencias.length > 0 && (
                <div className="vit-google__lista">
                  <ul>
                    {sugerencias.slice(0, 5).map(s => (
                      <li key={s.place_id}>
                        <button type="button" className="vit-google__opcion" onClick={() => elegirDeGoogle(s)} disabled={buscando}>
                          <span className="vit-google__nombre">{s.main}</span>
                          {s.secondary && <span className="vit-google__dir">{s.secondary}</span>}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div className="vit-google__pie"><AtribucionGoogleMaps /></div>
                </div>
              )}
              {deGoogle && sugerencias.length === 0 && (
                <div className="vit-google__elegido">
                  <div className="vit-google__nombre">{deGoogle.nombre}</div>
                  {deGoogle.direccion && <div className="vit-google__dir">{deGoogle.direccion}</div>}
                  <div className="vit-google__pie">
                    <span className="vit-google__lleno">
                      {(en ? "Filled in: " : "Llenamos: ") + deGoogle.campos.map(k => ({
                        business_name: en ? "name" : "nombre", category: en ? "category" : "rubro",
                        address: en ? "address" : "dirección", neighborhood: en ? "neighborhood" : "barrio",
                        phone: en ? "phone" : "teléfono", place_id: "place_id", google_maps_url: en ? "Maps link" : "link de Maps",
                        zone: en ? "zone" : "zona", zip: en ? "ZIP" : "código postal", city: en ? "city" : "ciudad", website: en ? "website" : "sitio web",
                      }[k])).join(" · ") + (en ? ". Check them below." : ". Revísalos abajo.")}
                    </span>
                    <AtribucionGoogleMaps />
                  </div>
                  {horarioG && <div className="vit-google__dir" style={{ marginTop: 6 }}>{en ? "Hours on Google: " : "Horario en Google: "}{horarioG.texto}</div>}
                </div>
              )}
            </div>
          )}
          {/* s218 · siembra v2: el duplicado se avisa ANTES de sembrar, como en el lote (la lista trae los descartados). */}
          {/* s219 · si ya se propone adoptarlo (abajo), este aviso sobra: dirían lo mismo dos veces. */}
          {yaSembrado && !resultado && existente !== yaSembrado.merchant_id && (
            <div className="beta__error" role="alert" style={{ background: "var(--aviso-tinte)", color: "var(--aviso-tinta)", marginBottom: 14 }}>
              {yaSembrado.status === "Rejected"
                ? (en ? `Already discarded: ${yaSembrado.discard_reason || "no reason"} («${yaSembrado.business_name}»).`
                      : `Ya descartado: ${yaSembrado.discard_reason || "sin motivo"} («${yaSembrado.business_name}»).`)
                : (en ? `Already seeded: «${yaSembrado.business_name}» (${yaSembrado.status}, seeded by ${yaSembrado.seeded_by_name || "?"}). Look for it in the list below.`
                      : `Ya está sembrado: «${yaSembrado.business_name}» (${yaSembrado.status}, lo sembró ${yaSembrado.seeded_by_name || "?"}). Búscalo en la lista de abajo.`)}
            </div>
          )}

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 14 }}>
            {campo("business_name", en ? "Business name" : "Nombre del negocio", { requerido: true, input: { placeholder: "Ej: La Ventana Brickell" } })}
            <div className="alta-campo">
              <AltaEtiqueta para="vit-category" texto={en ? "Category" : "Rubro"} requerido />
              {/* s224 · «Comida rápida» se ve como un rubro más; por dentro es Restaurante + business_type comida_rapida_qsr. */}
              <select id="vit-category" className="alta-input"
                value={form.category === "Restaurant" && form.business_type === "comida_rapida_qsr" ? "Restaurant:comida_rapida_qsr"
                  : form.category === "Gift_Moments" ? `Gift_Moments:${form.business_type === "globos_arreglos_flores" ? "globos_arreglos_flores" : "tortas_reposteria"}`
                  : form.category}
                onChange={e => {
                  const v = e.target.value;
                  const [category, business_type = ""] = v.split(":");
                  setForm(f => ({ ...f, category, business_type }));
                }}>
                {/* s241 · Celebraciones se ve como dos rubros (tortas · globos y arreglos); por dentro es Gift_Moments + business_type. */}
                {Object.entries(CAT_MAP).flatMap(([rotulo, clave]) => clave === "Gift_Moments" ? [
                  <option key="cel-tortas" value="Gift_Moments:tortas_reposteria">{en ? "Celebrations · cakes" : "Celebraciones · tortas"}</option>,
                  <option key="cel-globos" value="Gift_Moments:globos_arreglos_flores">{en ? "Celebrations · balloons & arrangements" : "Celebraciones · globos y arreglos"}</option>,
                ] : [
                  <option key={clave} value={clave}>{rotulo}</option>,
                  ...(clave === "Restaurant" ? [<option key="qsr" value="Restaurant:comida_rapida_qsr">{en ? "Fast food" : "Comida rápida"}</option>] : []),
                ])}
              </select>
              {form.category === "Gift_Moments" && <AltaAyuda texto={LINEA_HECHO_A_PEDIDO[en ? "en" : "es"]} />}
            </div>
            <div className="alta-campo">
              <AltaEtiqueta para="vit-beta_state" texto={en ? "Showcase state" : "Estado en la vitrina"} requerido />
              <select id="vit-beta_state" className="alta-input" value={form.beta_state} onChange={set("beta_state")}>
                {BETA_ESTADOS.map(s => <option key={s} value={s}>{BETA_ESTADO_ROTULO[s][en ? 1 : 0]}</option>)}
              </select>
            </div>
            {campo("neighborhood", en ? "Neighborhood" : "Barrio", { input: { placeholder: "Brickell" } })}
            {campo("zone", en ? "Zone (for the counter)" : "Zona (para el contador)", { input: { placeholder: "Brickell" } })}
            {campo("address", en ? "Address" : "Dirección")}
            {/* s218 · siembra v2 (N3): los llena Google; se pueden corregir a mano. */}
            {campo("zip", en ? "ZIP code" : "Código postal", { input: { inputMode: "numeric", placeholder: "33131" } })}
            {campo("city", en ? "City" : "Ciudad", { input: { placeholder: "Miami" } })}
            <div>
              {campo("website", en ? "Website" : "Sitio web", { input: { type: "url", placeholder: "https://…" } })}
              {/* s238 · webs-de-terceros: sin web propia, va su página de Booksy/Toast (la IA de «Sugerir» lee ese enlace). */}
              {form.website.trim()
                ? <AvisoPlataforma url={form.website} en={en} deQuien="su" />
                : <div style={{ fontSize: 12, marginTop: 6, color: C.gray }}>{en
                  ? "No website? Paste its page on Booksy, Vagaro, Fresha, Phorest, Toast or its online store."
                  : "¿Sin web propia? Pega su página de Booksy, Vagaro, Fresha, Phorest, Toast o su tienda online."}</div>}
            </div>
            {campo("phone", en ? "Phone" : "Teléfono", { input: { type: "tel", placeholder: "+1 305…" } })}
            {campo("instagram", "Instagram", { input: { placeholder: "@negocio" } })}
            {/* s219 · pegado a mano también se consulta contra la base, al salir del campo. */}
            {campo("place_id", "Google place_id", { input: { placeholder: "ChIJ…",
              onBlur: (e) => { const p = e.target.value.trim(); if (p && !(enBase && enBase.place_id === p)) consultarBase(p); } } })}
            {campo("google_maps_url", "Google Maps URL", { input: { type: "url" } })}
            {/* s233 · Ali: «el logo no está en ningún lado y hay que subirlo» (revierte s215: lo subía solo el dueño desde su
                panel). Mismo encuadrador que Perfil (1:1, 512 px, el PNG queda PNG). Viaja en seed_merchant (`logo`); al
                adoptar, con operatorAddLogo. Opcional: sin logo se siembra igual y el dueño lo sube después. */}
            <div className="alta-campo">
              <AltaEtiqueta para="vit-logo" texto="Logo"
                pista={en ? "Square, you frame it. If you don't have it, the owner uploads it later from their panel." : "Cuadrado, lo encuadras tú. Si no lo tienes, lo sube el dueño después desde su panel."} />
              <div className="alta-logo">
                {logo && <div className="alta-logo__mini"><MiniaturaFotoWizard file={logo} en={en} fija /></div>}
                <input id="vit-logo" className="alta-input alta-input--archivo" type="file" accept={OK_LOGO_TYPES.join(",")}
                  onChange={async e => { const f = e.target.files?.[0]; e.target.value = ""; if (f) setPorEncuadrar({ file: await logoEnCuadrado(f), campo: "logo" }); }} />
                {logo && <button type="button" className="alta-foto__traer" onClick={() => setLogo(null)}>{en ? "Remove" : "Quitar"}</button>}
              </div>
              {/* s234 · siembra-logo-desde-web: el candidato de la web, solo si todavía no hay logo puesto. */}
              {!logo && ia.logos && ia.logos[logoWebIdx] && (
                <div className="alta-logo" style={{ marginTop: 8, alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                  <img src={ia.logos[logoWebIdx]} alt={en ? "Logo from the website" : "Logo de la web"} referrerPolicy="no-referrer"
                    onError={() => setLogoWebIdx(i => i + 1)}
                    style={{ width: 48, height: 48, objectFit: "contain", border: "1px solid var(--linea)", borderRadius: 6, background: "#fff" }} />
                  <button type="button" className="alta-foto__traer" disabled={trayendoLogo} onClick={() => usarLogoWeb(ia.logos[logoWebIdx])}>
                    {trayendoLogo ? "…" : (en ? "Use this logo" : "Usar este logo")}
                  </button>
                  <a href={ia.logos[logoWebIdx]} target="_blank" rel="noopener noreferrer" style={{ fontSize: 12 }}>{en ? "Open" : "Abrir"} ↗</a>
                  <small style={{ flexBasis: "100%", color: "var(--tinta-suave)" }}>{en ? "From their website. Check it's the logo and not a photo." : "De su página web. Revisa que sea el logo y no una foto."}</small>
                  {logoWebMsg && <small role="alert" style={{ flexBasis: "100%", color: "var(--aviso-tinta)" }}>{logoWebMsg}</small>}
                </div>
              )}
            </div>
            {/* s233 · la foto ocupa la fila entera y va en un recuadro: en una celda de 240px el archivo, el enlace
                y la ayuda quedaban apretados (y la ayuda usaba .alta-pista, la clase del globo, que es inline-flex). */}
            <div className="alta-campo" style={{ gridColumn: "1 / -1" }} onDragOver={e => e.preventDefault()} onDrop={soltarFoto}>
              {/* s200-D1 · ya no se pide «mejor 3:2»: la proporcion la fija el encuadrador. */}
              <AltaEtiqueta para="vit-photo" texto={en ? "Photos" : "Fotos"}
                pista={conWizard
                  ? (en ? "Square. You frame it. Each one you add here goes to the wizard's photos (the first is the cover)." : "Cuadrada. La encuadras tú. Cada una que agregas aquí pasa a las fotos del wizard (la primera es la portada).")
                  : (en ? `Square. You frame them. Up to ${GALERIA_TOPE}; the first one is the cover.` : `Cuadradas. Las encuadras tú. Hasta ${GALERIA_TOPE}; la primera es la portada.`)} />
              <div className="alta-foto">
              <div className="alta-foto__fila">
                <input id="vit-photo" className="alta-input alta-input--archivo" type="file" accept="image/*" multiple
                  onChange={e => { const fs = Array.from(e.target.files || []); e.target.value = ""; encuadrarFotos(fs); }} />
                {/* s218 · siembra v2: también el enlace de una imagen. */}
                {(
                  <div className="alta-foto__enlace">
                    <input className="alta-input" type="url" value={urlFoto} onChange={e => { setUrlFoto(e.target.value); setErrorUrlFoto(""); }}
                      onKeyDown={e => { if (e.key === "Enter") { e.preventDefault(); traerFotoDeEnlace(); } }}
                      placeholder={en ? "…or paste the image link" : "…o pega el enlace de la imagen"} aria-label={en ? "Image link" : "Enlace de la imagen"} />
                    <button type="button" className="alta-foto__traer" onClick={traerFotoDeEnlace} disabled={trayendoFoto || !urlFoto.trim()}>
                      {trayendoFoto ? "…" : (en ? "Bring it" : "Traer")}
                    </button>
                  </div>
                )}
              </div>
              {/* s233 · Ali: «subo la imagen y no hay nada que me indique que subió». Con el wizard las fotos se van a su
                  galería (fotosExternas), muy abajo; aquí se ven todas las que entraron y a dónde fueron. */}
              {/* s233 · se ve la lista REAL del wizard (fotosEnWizard): la primera es la portada, y «Hacer portada» /
                  «Quitar» se piden al wizard, que es donde vive el orden. */}
              {conWizard && fotosEnWizard.length > 0 && (
                <div className="alta-foto__lista alta-foto__lista--varias">
                  <div className="alta-wiz__fotos">
                    {fotosEnWizard.map((f, i) => (
                      <MiniaturaFotoWizard key={`${f.name}-${f.size}-${i}`} file={f} portada={i === 0} en={en}
                        onPortada={() => pedirAlWizard("portada", f)} onQuitar={() => pedirAlWizard("quitar", f)} />
                    ))}
                  </div>
                  <div className="alta-ayuda alta-foto__ayuda">
                    <b>{en ? `✓ ${fotosEnWizard.length} photo${fotosEnWizard.length === 1 ? "" : "s"} ready` : `✓ ${fotosEnWizard.length} foto${fotosEnWizard.length === 1 ? "" : "s"} lista${fotosEnWizard.length === 1 ? "" : "s"}`}</b>
                    {colaFotos.length > 0 && (en ? ` · ${colaFotos.length} left to frame` : ` · faltan ${colaFotos.length} por encuadrar`)}<br />
                    {fotosEnWizard.length >= GALERIA_TOPE
                      ? (en ? `That's the limit (${GALERIA_TOPE}). ` : `Llegaste al tope (${GALERIA_TOPE}). `)
                      : (en ? `You can choose several at once (up to ${GALERIA_TOPE}). ` : `Puedes elegir varias a la vez (hasta ${GALERIA_TOPE}). `)}
                    {en ? "The first one is the cover: «Make cover» moves another one to the front."
                        : "La primera es la portada: «Hacer portada» pone otra adelante."}
                  </div>
                </div>
              )}
              {/* s233 · genérica con varias: la primera es la portada (va en seed_merchant); las demás, con operatorAddPhoto. */}
              {!conWizard && fotosGen.length > 0 && (
                <div className="alta-foto__lista alta-foto__lista--varias">
                  <div className="alta-wiz__fotos">
                    {fotosGen.map((f, i) => (
                      <MiniaturaFotoWizard key={`${f.name}-${f.size}-${i}`} file={f} portada={i === 0} en={en}
                        onPortada={() => setFotosGen(fs => [fs[i], ...fs.filter((_, j) => j !== i)])}
                        onQuitar={() => setFotosGen(fs => fs.filter((_, j) => j !== i))} />
                    ))}
                  </div>
                  <div className="alta-ayuda alta-foto__ayuda">
                    <b>{en ? `✓ ${fotosGen.length} photo${fotosGen.length === 1 ? "" : "s"} ready` : `✓ ${fotosGen.length} foto${fotosGen.length === 1 ? "" : "s"} lista${fotosGen.length === 1 ? "" : "s"}`}</b>
                    {colaFotos.length > 0 && (en ? ` · ${colaFotos.length} left to frame` : ` · faltan ${colaFotos.length} por encuadrar`)}<br />
                    {fotosGen.length >= GALERIA_TOPE
                      ? (en ? `That's the limit (${GALERIA_TOPE}). ` : `Llegaste al tope (${GALERIA_TOPE}). `)
                      : (en ? `You can choose several at once (up to ${GALERIA_TOPE}). ` : `Puedes elegir varias a la vez (hasta ${GALERIA_TOPE}). `)}
                    {en ? "The first one is the cover: «Make cover» moves another one to the front."
                        : "La primera es la portada: «Hacer portada» pone otra adelante."}
                  </div>
                </div>
              )}
              {errorUrlFoto && <div className="alta-aviso alta-aviso--error alta-aviso--campo">{errorUrlFoto}</div>}
              {/* s215 · Ali: que Otto no tenga que buscar la foto. Google no da fotos por la API (TOS), pero el
                  enlace del negocio en Maps lo trae la búsqueda; sin él, una búsqueda en Maps por nombre y barrio.
                  No hay enlace fijo a la pestaña «Fotos»: Otto la toca al abrir. */}
              {(form.google_maps_url.trim() || form.business_name.trim() || form.instagram.trim()) && (() => {
                const maps = form.google_maps_url.trim()
                  || `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent([form.business_name, form.neighborhood || form.zone, "Miami"].map(x => String(x || "").trim()).filter(Boolean).join(" "))}`;
                const ig = form.instagram.trim().replace(/^@/, "").replace(/^https?:\/\/(www\.)?instagram\.com\//i, "").replace(/\/.*$/, "");
                const enlace = { color: "var(--accion)", fontWeight: 700 };
                return (
                  <div className="alta-ayuda alta-foto__ayuda">
                    <b>{en ? "Tip: copy the image and paste it here with Ctrl+V (or drag it). " : "Truco: copia la imagen y pégala aquí con Ctrl+V (o arrástrala). "}</b><br />
                    {en ? "Don't have the photo? " : "¿No tienes la foto? "}
                    {(form.google_maps_url.trim() || form.business_name.trim()) && (
                      <a href={maps} target="_blank" rel="noopener noreferrer" style={enlace}>{en ? "Open it in Google Maps ↗" : "Ábrela en Google Maps ↗"}</a>
                    )}
                    {ig && <>{" · "}<a href={`https://www.instagram.com/${encodeURIComponent(ig)}/`} target="_blank" rel="noopener noreferrer" style={enlace}>Instagram ↗</a></>}
                    {/* s218 · siembra v2: la web del negocio (websiteUri de Google), al lado de Maps. */}
                    {/^https?:\/\//i.test(form.website.trim()) && <>{" · "}<a href={form.website.trim()} target="_blank" rel="noopener noreferrer" style={enlace}>{en ? "Open website ↗" : "Abrir sitio web ↗"}</a></>}
                    <br />
                    {en
                      ? "In Maps, tap «Photos», right-click the best one → «Copy image», and paste it here."
                      : "En Maps toca «Fotos», clic derecho en la mejor → «Copiar imagen», y pégala aquí."}
                  </div>
                );
              })()}
              </div>
            </div>

            {porEncuadrar && (
              <EncuadrarFoto
                key={`${porEncuadrar.campo}-${porEncuadrar.file.name}-${porEncuadrar.file.size}`}
                file={porEncuadrar.file}
                proporcion={1}
                ladoMax={porEncuadrar.campo === "logo" ? 512 : undefined}
                ladoMin={porEncuadrar.campo === "logo" ? LOGO_LADO_MIN : FOTO_LADO_MIN}
                tipoSalida={porEncuadrar.campo === "logo" && porEncuadrar.file.type === "image/png" ? "image/png" : "image/jpeg"}
                en={en}
                textoListo={porEncuadrar.campo === "logo" ? (en ? "Use logo" : "Usar logo") : undefined}
                titulo={porEncuadrar.campo === "logo"
                  ? (en ? "Frame the logo" : "Encuadra el logo")
                  : (en ? "Frame the photo" : "Encuadra la foto")}
                onListo={(f) => {
                  if (porEncuadrar.campo === "logo") { setLogo(f); setPorEncuadrar(null); return; }
                  // s233 · se suman (hasta GALERIA_TOPE): con el wizard, a su galería; en la genérica, a `fotosGen`.
                  if (conWizard) { if (fotosEnWizard.length < GALERIA_TOPE) setFotosWizard(fs => [...fs, f]); }
                  else setFotosGen(fs => (fs.length >= GALERIA_TOPE ? fs : [...fs, f]));
                  siguienteFoto();
                }}
                onCancelar={() => (porEncuadrar.campo === "photo" ? siguienteFoto() : setPorEncuadrar(null))}
              />
            )}
          </div>

          {/* s212 · lo que vende la oferta: con esto se arman el título y «Lo esencial» (ronda 10). */}
          {/* s241 · T1 · Google no trajo web (y Otto no pegó una): el aviso decidido por Ali (texto A), el atajo para buscarla y
              «No tiene web» (sin_web → la IA no gasta Firecrawl y no adivina). D2: si después se pega una web, la web gana. */}
          {deGoogle && !(deGoogle.campos || []).includes("website") && !form.website.trim() && (
            <div className="alta-aviso" role="status" style={{ marginTop: 14 }}>
              <div>{en ? AVISO_SIN_WEB.en : AVISO_SIN_WEB.es}</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 14, alignItems: "center", marginTop: 8 }}>
                <a href={busquedaWebNegocio(form.business_name, form.zone || form.neighborhood || form.city)} target="_blank" rel="noopener noreferrer">
                  {en ? "Search on Google ↗" : "Buscar en Google ↗"}
                </a>
                <label style={{ display: "flex", alignItems: "center", gap: 6, cursor: "pointer" }}>
                  <input type="checkbox" checked={form.sin_web === true} onChange={e => setForm(f => ({ ...f, sin_web: e.target.checked }))} />
                  {en ? "No website" : "No tiene web"}
                </label>
              </div>
            </div>
          )}
          {/* s241 · T2 (Ali, 25/10) · lo que dice Google del lugar, para la llamada: resumen, rating y hasta 3 reseñas con su autor
              (atribución obligatoria). No se guarda ni se le pasa a la IA (condiciones de Google; s172-D1). */}
          {vistaGoogle && (
            <details className="alta-campo" style={{ marginTop: 14 }} open>
              <summary style={{ cursor: "pointer", fontWeight: 600 }}>{en ? "On Google (for the call only)" : "En Google (solo para la llamada)"}
                {vistaGoogle.rating ? ` · ${vistaGoogle.rating.toFixed(1)} ★ (${vistaGoogle.count})` : ""}</summary>
              {vistaGoogle.resumen && <p className="alta-ayuda" style={{ marginTop: 6 }}>{vistaGoogle.resumen}</p>}
              {vistaGoogle.reviews.slice(0, 3).map((r, i) => (
                <div key={i} style={{ fontSize: 13, marginTop: 8 }}>
                  <div>«{r.texto.length > 220 ? `${r.texto.slice(0, 220)}…` : r.texto}»</div>
                  <div style={{ color: C.gray, fontSize: 12 }}>{r.rating ? `${r.rating} ★ · ` : ""}
                    {r.autorUri ? <a href={r.autorUri} target="_blank" rel="noopener noreferrer">{r.autor}</a> : r.autor}{r.cuando ? ` · ${r.cuando}` : ""}</div>
                </div>
              ))}
              <div style={{ color: C.gray, fontSize: 12, marginTop: 8 }}>
                {vistaGoogle.mapsUri && <a href={vistaGoogle.mapsUri} target="_blank" rel="noopener noreferrer">{en ? "See on Google Maps ↗" : "Ver en Google Maps ↗"}</a>}
                {" · "}{en ? "From Google. Not saved and not used for the offer." : "De Google. No se guarda ni se usa en la oferta."}
              </div>
            </details>
          )}
          {/* s241 · T4 · lo que tenga el negocio (menú del Word, lista de servicios, lo que dicte por teléfono): vale como la web. */}
          <div className="alta-campo" style={{ marginTop: 14 }}>
            <AltaEtiqueta para="vit-texto-negocio" texto={en ? "What the business gave you" : "Lo que te dio el negocio"} />
            <textarea id="vit-texto-negocio" className="alta-input" rows={4} maxLength={TEXTO_NEGOCIO_MAX} value={form.texto_negocio}
              onChange={e => setForm(f => ({ ...f, texto_negocio: e.target.value }))}
              placeholder={en ? "Paste whatever the business has: menu, list of services, what they tell you" : "Pega lo que tengas del negocio: menú, lista de servicios, lo que te dicte"} />
          </div>
          {/* s233 · la IA propone «Qué pedir» y «Lo esencial» con lo que ya se sabe del lugar. */}
          <div className="alta-ia" style={{ marginTop: 14 }}>
            <button type="button" className="alta-foto__traer alta-ia__boton" onClick={sugerirConIa}
              disabled={ia.estado === "pidiendo" || !form.business_name.trim()}>
              {ia.estado === "pidiendo" ? (en ? "Thinking…" : "Pensando…") : (en ? "Suggest with AI" : "Sugerir con IA")}
            </button>
            <span className="alta-ayuda alta-ia__texto" role="status"
              style={ia.estado === "error" ? { color: "var(--aviso-tinta)" } : undefined}>
              {ia.texto || (en ? "Fills «What to order» and «The gist» from what we know of the place. You confirm it."
                                : "Llena «Qué pedir» y «Lo esencial» con lo que sabemos del lugar. Tú lo confirmas.")}
            </span>
          </div>
          <div className="alta-campo" style={{ marginTop: 10 }}>
            <AltaEtiqueta para="vit-que_pedir" texto={en ? "What to order or get done" : "Qué pedir o qué hacerse"} pista={en ? "What people order most. One thing, by name. It becomes the title." : "Lo que más piden. Una sola cosa, con nombre. Pasa a ser el título."} />
            <input id="vit-que_pedir" className="alta-input" value={form.que_pedir} onChange={set("que_pedir")} placeholder={en ? "E.g.: Churrasco with chimichurri for two" : "Ej: Churrasco con chimichurri para dos"} />
          </div>
          {/* s233 · Ali: «Cuándo conviene ir» sobraba: «Cuándo vale» (abajo) ya pide días y horas. Se quitó el campo. */}
          {form.que_pedir.trim() && !form.description_es.trim() && (
            <AltaAyuda texto={(en ? "«The gist» will read: " : "«Lo esencial» va a decir: ") + esencialArmado()} />
          )}
          {/* s224 · con el wizard, plazo, canal, horarios y oferta salen de sus preguntas (abajo). */}
          {!conWizard && <>
          {/* s213 · lote B+C: lo que el comercio eligió en la llamada (hoja de Otto, punto 5). */}
          <SelectorPlazo id="vit-cooldown" en={en} valor={form.cooldown_days} onCambio={v => { plazoTocado.current = true; setForm(f => ({ ...f, cooldown_days: v })); }} />
          {/* s222 · lote 2a · nace con el del rubro; se guarda después de sembrar (operator_update_offer). */}
          {!esEncargo(form.category) && <SelectorCanal id="vit-canal" en={en} valor={canalSiembra} onCambio={v => setForm(f => ({ ...f, redemption_channel: v }))} />}
          {/* s218 · siembra v2: el horario de la oferta (seed_merchant lo recibe desde el export 114). Google prellena
              los días que abre; la hora se elige con las franjas. «Todo el horario» = sin restricción. */}
          {!esEncargo(form.category) && <>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap", alignItems: "center", marginTop: 4 }}>
            <button type="button" className={["alta-chip", !form.franja && "alta-chip--on"].filter(Boolean).join(" ")} aria-pressed={!form.franja}
              onClick={() => setForm(f => ({ ...f, franja: null }))}>
              {en ? "All opening hours" : "Todo el horario"}
            </button>
            {horarioG && <span style={{ fontSize: 12, color: C.muted }}>{en ? "Google: " : "Google: "}{horarioG.texto}</span>}
          </div>
          <SelectorFranja id="vit-franja" en={en} valor={form.franja} onCambio={v => setForm(f => ({ ...f, franja: v }))} franjas={ia.servicios} abiertos={horarioG?.dias || ""} rangos={horarioG?.rangos || null} />
          </>}
          {/* s233 · el tip de la IA para elegir la franja (v4 de suggest_seed_offer). */}
          {(ia.tip || (ia.servicios && ia.servicios.length > 0)) && (
            <div className="alta-ia-tip">
              <b>{en ? "AI tip" : "Tip de la IA"}</b>
              {ia.tip ? ` · ${ia.tip}` : (en ? " · These are the business's own hours (from its website). ★ = suggested." : " · Son los horarios del propio negocio (de su web). ★ = sugerida.")}
            </div>
          )}
          <SelectorPlan id="vit-plan" en={en} categoria={form.category} valor={form.plan} vacio={en ? "None" : "Ninguno"} onCambio={v => setForm(f => ({ ...f, plan: v }))} />
          </>}

          <div className="alta-campo" style={{ marginTop: 14 }}>
            <AltaEtiqueta para="vit-description_es" texto={en ? "The gist (Spanish)" : "Lo esencial (en español)"} pista={en ? "Optional: if you write it, it replaces the one built from the fields above." : "Opcional: si lo escribes, reemplaza al que se arma con los campos de arriba."} />
            <textarea id="vit-description_es" className="alta-textarea" rows={3} value={form.description_es} onChange={set("description_es")} />
          </div>

          {/* s224 · la oferta: el wizard del alta (por defecto) o la genérica de siempre. */}
          <div style={{ marginTop: 18, paddingTop: 16, borderTop: `1px solid ${C.border}` }}>
            {SIEMBRA_CON_WIZARD && (
            <div className="alta-chips" role="group" aria-label={en ? "How to build the offer" : "Cómo armar la oferta"} style={{ marginBottom: 12 }}>
              {[["wizard", en ? "Offer wizard" : "Wizard de la oferta"], ["clasica", en ? "Generic offer" : "Oferta genérica"]].map(([v, l]) => (
                <button key={v} type="button" className={["alta-chip", modoOferta === v && "alta-chip--on"].filter(Boolean).join(" ")}
                  aria-pressed={modoOferta === v} disabled={enviando} onClick={() => { setModoOferta(v); setError(""); }}>{l}</button>
              ))}
            </div>
            )}
            {conWizard && (
              <>
                <div style={{ fontSize: 12, color: C.muted, marginBottom: 10 }}>
                  {en ? "The same questions the owner sees. Ask them on the call; at the end, «Seed» creates the business and its offers."
                      : "Las mismas preguntas que ve el dueño. Házselas en la llamada; al final, «Sembrar» crea el comercio y sus ofertas."}
                </div>
                <WizardPrimeraOferta key={`${wizKey}-${form.category}-${form.business_type}`} lang={lang}
                  perfil={{ category: form.category, business_name: form.business_name.trim(), business_hours_json: horasG, neighborhood: form.neighborhood, website: form.website }}
                  operador={{ placeId: form.place_id, visible: form.beta_state === "visible", fotosExternas: fotosWizard,
                    alCambiarFotos: setFotosEnWizard, pedidoFotos,
                    businessType: form.business_type, sembrar: sembrarSinOferta, alTerminar: alTerminarWizard }} />
              </>
            )}
          </div>
          {!conWizard && (
          <div style={{ marginTop: 18 }}>
            <div style={{ ...S.display, fontSize: 16, color: C.black, marginBottom: 10 }}>{en ? "GENERIC OFFER" : "OFERTA GENÉRICA"}</div>
            <div className="alta-campo">
              {/* s215 · la misma pregunta que ve el dueño: mesa de dos en restaurantes y bares (÷2 por dentro). */}
              <AltaEtiqueta para="vit-avg_ticket_usd" texto={preguntaTicket(form.category, en).texto}
                pista={(en ? "Ask the owner, or check the menu. " : "Pregúntaselo al dueño o mira el menú. ") + preguntaTicket(form.category, en).pista} />
              <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                <input id="vit-avg_ticket_usd" className="alta-input" type="number" min="0" inputMode="decimal" style={{ flex: 1, minWidth: 120 }} value={form.avg_ticket_usd} onChange={set("avg_ticket_usd")} placeholder={`${en ? "E.g.:" : "Ej:"} ${preguntaTicket(form.category, en).ej}`} />
                <button type="button" className="alta-chip alta-chip--fuerte" onClick={sugerir} style={{ borderRadius: "var(--radio-boton)", padding: "12px 16px", fontSize: 14 }}>
                  {en ? "Suggest a size" : "Sugerir tamaño"}
                </button>
                {/* s218 · siembra v2: el precio de Google también en la carga de a uno (necesita el place_id). */}
                {placesEnabled() && form.place_id.trim() && (
                  <button type="button" className="alta-chip" onClick={completarPrecio} disabled={precioG?.estado === "buscando"}
                    style={{ borderRadius: "var(--radio-boton)", padding: "12px 16px", fontSize: 14 }}>
                    {precioG?.estado === "buscando" ? "…" : (en ? "Fill in with Google" : "Completar con Google")}
                  </button>
                )}
              </div>
              {precioG && precioG.texto && (
                <div className={precioG.estado === "fallo" ? "alta-aviso alta-aviso--error alta-aviso--campo" : "alta-pista"} style={{ marginTop: 6 }}>{precioG.texto}</div>
              )}
              {sugerido && !siembraPct && <AltaAyuda texto={(en ? "Suggested: " : "Sugerido: ") + fraseUmbral(sugerido.monto, sugerido.minimo, en)} />}
              {sugeridoPct && siembraPct && (() => {
                const ticket = Math.round(ticketPorPersona(form.category, form.avg_ticket_usd));
                const ahorro = Math.round(ticket * sugeridoPct.pct / 100);
                const servicio = RUBROS_PCT_RECOMENDADO.includes(form.category);   // salones: un servicio; el resto: por persona
                // s241 · en Celebraciones el ejemplo es un pedido, no un servicio; y el % es «del pedido» (perfil por rubro).
                const enc = esEncargo(form.category), la = perfilDelRubro(form.category).la;
                const base = en ? (servicio ? `on a $${ticket} ${enc ? "order" : "service"}` : `on $${ticket} per person`)
                  : (servicio ? `en un ${enc ? "pedido" : "servicio"} de $${ticket}` : `en $${ticket} por persona`);
                return <AltaAyuda texto={en
                  ? `Suggested: ${sugeridoPct.pct}% of ${la.en}, no cap${ahorro > 0 ? ` (${base} the member saves about $${ahorro})` : ""}.`
                  : `Sugerido: ${sugeridoPct.pct} % de ${la.es}, sin tope${ahorro > 0 ? ` (${base}, el socio ahorra unos $${ahorro})` : ""}.`} />;
              })()}
              {destacadaSugerida && !siembraPct && <AltaAyuda texto={en
                ? "Featured is available once the subscription exists."
                : "Destacada disponible cuando exista la suscripción."} />}
            </div>
            {/* s236-D6 · siembra-porcentaje: el formato de la oferta. En salones arranca en porcentaje (s236-D5). */}
            <div className="alta-campo">
              <AltaEtiqueta grupo="vit-formato" texto={en ? "Offer type" : "Tipo de oferta"} requerido />
              <div className="alta-chips" role="group" aria-labelledby="vit-formato">
                {/* s255 · `primera-oferta-solo-porcentaje`: sin monto fijo en la siembra (vuelve con PRIMERA_CON_MONTO_FIJO). */}
                {[["pct", en ? "Percentage" : "Porcentaje"], ...(PRIMERA_CON_MONTO_FIJO ? [["std", en ? "Fixed amount" : "Monto fijo"]] : [])].map(([v, l]) => (
                  <button key={v} type="button" className={["alta-chip", formatoSiembra === v && "alta-chip--on"].filter(Boolean).join(" ")}
                    aria-pressed={formatoSiembra === v} disabled={enviando}
                    onClick={() => {
                      formatoTocado.current = true; setFormatoSiembra(v); setError("");
                      // s238 · un título de monto fijo generado no se queda a la vista en porcentaje (al sembrar ya se ignoraba).
                      if (v === "pct") setForm(f => (esTituloUmbralGenerado(f.offer_title_es) ? { ...f, offer_title_es: "" } : f));
                    }}>
                    {l}{PRIMERA_CON_MONTO_FIJO && RUBROS_PCT_RECOMENDADO.includes(form.category) === (v === "pct") ? (en ? " · recommended" : " · recomendado") : ""}
                  </button>
                ))}
              </div>
              {siembraPct && RUBROS_PCT_RECOMENDADO.includes(form.category) && <AltaAyuda texto={en
                ? `For this category we recommend 25% of ${perfilDelRubro(form.category).la.en}, no cap. If the owner wants a cap, they set it.`
                : `Para este rubro recomendamos 25 % de ${perfilDelRubro(form.category).la.es}, sin tope. Si el dueño quiere un tope, lo pone él.`} />}
            </div>
            {siembraPct && (
            <div className="alta-campo" style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
              <label htmlFor="vit-pct" style={{ display: "flex", flexDirection: "column", gap: 4, flex: "1 1 140px" }}>
                <span className="alta-etiqueta">{en ? "Percentage" : "Porcentaje"}</span>
                <input id="vit-pct" className="alta-input" type="number" min={PCT_MINIMO} max="100" step="1" inputMode="numeric"
                  value={pctSiembra} onChange={e => { formatoTocado.current = true; setPctSiembra(e.target.value); }} />
              </label>
              <div style={{ display: "flex", flexDirection: "column", gap: 4, flex: "1 1 140px" }}>
                <label htmlFor="vit-tope" className="alta-etiqueta">{en ? `Cap per ${perfilDelRubro(form.category).visita.en} ($)` : `Tope por ${perfilDelRubro(form.category).visita.es} ($)`}</label>
                <input id="vit-tope" className="alta-input" type="number" min="1" step="1" inputMode="numeric" disabled={sinTopeSiembra}
                  value={sinTopeSiembra ? "" : topeSiembra} placeholder={sinTopeSiembra ? (en ? "No cap" : "Sin tope") : ""}
                  onChange={e => { formatoTocado.current = true; setTopeSiembra(e.target.value); }} />
                <label htmlFor="vit-sin-tope" style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, color: C.gray, cursor: "pointer" }}>
                  <input id="vit-sin-tope" type="checkbox" checked={sinTopeSiembra} onChange={e => { formatoTocado.current = true; setSinTopeSiembra(e.target.checked); }} />
                  {en ? "No cap (the owner can add one later)" : "Sin tope (el dueño puede ponerle uno después)"}
                </label>
              </div>
              {pctSiembraNum > 0 && topeSiembraNum > 0 && <AltaAyuda texto={(en ? "Members read: " : "Los miembros leen: ") + frasePorcentaje(pctSiembraNum, topeSiembraNum, en, form.category)} />}
            </div>
            )}
            {!siembraPct && (
            <div className="alta-campo">
              <AltaEtiqueta grupo="vit-tamano" texto={en ? "Size" : "Tamaño"} requerido />
              <div className="alta-opciones" role="group" aria-labelledby="vit-tamano" style={{ flexDirection: "row", flexWrap: "wrap" }}>
                {/* s250 · solo los tamaños del rubro: mostraba todos y un bar quedó en $50/$100 (su tope es $30/$60). */}
                {tamanosDelRubro(form.category, form.business_type).map(t => {
                  const on = form.tamano === t.id;
                  // s199-D2: la Destacada no se puede sembrar hasta que exista la suscripción.
                  const bloqueada = t.id === "D" && !DESTACADA_HABILITADA;
                  return (
                    <button key={t.id} type="button" aria-pressed={on} disabled={bloqueada}
                      className={on ? "alta-opcion alta-opcion--elegida" : "alta-opcion"}
                      onClick={() => elegirTamano(t.id)}
                      style={bloqueada ? { flex: "1 1 180px", opacity: 0.55, cursor: "not-allowed" } : { flex: "1 1 180px" }}>
                      <div className="alta-opcion__icono">{t.id === "D" ? "★" : t.id}</div>
                      <div className="alta-opcion__texto">
                        <div className="alta-opcion__nombre">{fraseUmbral(t.monto, t.minimo, en)}</div>
                        <div className="alta-opcion__nota">{bloqueada
                          ? (en ? "Only for members with an active subscription" : "Solo para miembros con suscripción activa")
                          : (sugerido && sugerido.id === t.id ? (en ? "Suggested" : "Sugerido") : (en ? t.en : t.es))}</div>
                      </div>
                    </button>
                  );
                })}
              </div>
            </div>
            )}
            {campo("offer_title_es", en ? "Offer title (Spanish)" : "Título de la oferta (español)", { input: { placeholder: tituloArmado() } })}
          </div>
          )}

          {error && <div className="beta__error" role="alert">{error}</div>}

          {existente && (() => {
            // s218 · si es uno de los sembrados de la lista, se dice cuál y, si se descartó, por qué.
            const ex = lista.find(r => r.merchant_id === existente);
            if (ex && ex.status === "Rejected") return (
              <div className="beta__error" role="alert" style={{ background: "var(--aviso-tinte)", color: "var(--aviso-tinta)" }}>
                {en ? `Already discarded: ${ex.discard_reason || "no reason"} («${ex.business_name}»). It isn't seeded again.`
                    : `Ya descartado: ${ex.discard_reason || "sin motivo"} («${ex.business_name}»). No se vuelve a sembrar.`}
              </div>
            );
            // s219 · descartado pero fuera de la lista (check_place_id lo encontró en la base).
            if (!ex && avisoBase && avisoBase.merchant_id === existente && avisoBase.discarded) return (
              <div className="beta__error" role="alert" style={{ background: "var(--aviso-tinte)", color: "var(--aviso-tinta)" }}>
                {en ? `Already discarded: «${avisoBase.business_name}». It isn't seeded again.`
                    : `Ya se descartó: «${avisoBase.business_name}». No se vuelve a sembrar.`}
              </div>
            );
            return null;
          })()}
          {existente && lista.find(r => r.merchant_id === existente)?.status !== "Rejected"
            && !(avisoBase && avisoBase.merchant_id === existente && avisoBase.discarded) && (
            <div className="beta__error" role="alert" style={{ background: "var(--aviso-tinte)", color: "var(--aviso-tinta)" }}>
              {(() => { const ex = lista.find(r => r.merchant_id === existente); return ex
                ? (en ? `«${ex.business_name}» is already seeded (${ex.status}, seeded by ${ex.seeded_by_name || "?"}). Adopt it with this state and this offer?`
                      : `«${ex.business_name}» ya está sembrado (${ex.status}, lo sembró ${ex.seeded_by_name || "?"}). ¿Adoptarlo con este estado y esta oferta?`)
                : avisoBase && avisoBase.merchant_id === existente
                ? (en ? `Already in NXT: «${avisoBase.business_name}» (${avisoBase.status || "no status"}). It isn't seeded again: adopt it with this state and this offer?`
                      : `Ya está en NXT: «${avisoBase.business_name}» (${avisoBase.status || "sin estado"}). No se siembra de nuevo: ¿adoptarlo con este estado y esta oferta?`)
                : (en ? `That place_id already exists in the base (merchant ${existente}). Adopt it with this state and this offer?`
                      : `Ese place_id ya está en la base (comercio ${existente}). ¿Adoptarlo con este estado y esta oferta?`); })()}
              <div style={{ marginTop: 8 }}>
                <button type="button" onClick={adoptar} disabled={enviando} style={{ ...S.btnPrimary, width: "auto", padding: "8px 14px", fontSize: 13 }}>
                  {enviando ? "…" : (en ? "Adopt this business" : "Adoptar este comercio")}
                </button>
              </div>
            </div>
          )}

          {resultado && (
            <div className="beta__listo" role="status">
              <b>{resultado.adoptado ? (en ? "Adopted" : "Adoptado") : (en ? "Seeded" : "Sembrado")}: {resultado.business_name}</b>
              {resultado.nota && <div style={{ fontSize: 13, color: "var(--realce-tinta)", marginTop: 4, lineHeight: 1.4 }}>{resultado.nota}</div>}
              <div style={{ fontSize: 13, wordBreak: "break-all" }}>{linkBeta(resultado.beta_token, resultado.category, resultado.business_name)}</div>
              <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
                {/* s214 · lo primero es el mensaje entero: es lo que Otto manda. El link solo queda al lado. */}
                <button type="button" onClick={() => copiarMensaje(resultado.business_name, resultado.beta_token, resultado.category)} style={{ ...S.btnPrimary, width: "auto", padding: "8px 14px", fontSize: 13 }}>
                  {copiado === `msg:${resultado.beta_token}` ? "✓" : (en ? "Copy message" : "Copiar mensaje")}
                </button>
                <a href={waMensaje(resultado.business_name, resultado.beta_token, resultado.category)} target="_blank" rel="noopener noreferrer"
                  style={{ alignSelf: "center", fontSize: 13, fontWeight: 600, color: "var(--exito)" }}>WhatsApp</a>
                <button type="button" onClick={() => copiar(resultado.beta_token, resultado.category, resultado.business_name)} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "8px 12px", fontSize: 13, cursor: "pointer", borderRadius: 2 }}>
                  {copiado === resultado.beta_token ? "✓" : (en ? "Copy link" : "Copiar link")}
                </button>
                <a href={linkBeta(resultado.beta_token, resultado.category, resultado.business_name)} target="_blank" rel="noreferrer" style={{ alignSelf: "center", fontSize: 13, color: "var(--exito)" }}>{en ? "Open" : "Abrir"}</a>
              </div>
            </div>
          )}

          <div style={{ display: "flex", gap: 10, marginTop: 16, flexWrap: "wrap" }}>
            {/* s219 · si el lugar ya está en la base, no se siembra otra vez (se adopta, arriba). */}
            {/* s224 · con el wizard, se siembra desde su última pantalla. */}
            {!conWizard && (
            <button type="button" onClick={sembrar} disabled={enviando || !!avisoBase}
              style={{ ...S.btnPrimary, width: "auto", padding: "12px 20px", ...(avisoBase ? { opacity: 0.45, cursor: "not-allowed" } : {}) }}>
              {enviando ? (en ? "Seeding…" : "Sembrando…") : (en ? "Seed and generate the link" : "Sembrar y generar el link")}
            </button>
            )}
            <button type="button" onClick={limpiar} disabled={enviando} style={{ ...S.btnSecondary, width: "auto", padding: "12px 20px" }}>
              {en ? "Clear" : "Limpiar"}
            </button>
          </div>
        </section>

        {/* ---------- SIEMBRA EN LOTE (tanda 2) ---------- */}
        <section style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 8, padding: 20, marginBottom: 24 }}>
          <div style={{ ...S.display, fontSize: 20, color: C.black, marginBottom: 4 }}>{en ? "SEED IN BULK" : "SEMBRAR EN LOTE"}</div>
          <div style={{ fontSize: 12, color: C.muted, marginBottom: 12, lineHeight: 1.5 }}>
            {en
              ? "Paste rows from your sheet (tab- or comma-separated), one business per line, in this order: name · category · zone · neighborhood · average bill per person · phone · instagram · place_id · google_maps_url. A header row is fine. With a place_id we bring the address and the map pin from Google. The batch seeds with no photo or logo. Add the photo and the logo afterwards with «Photos» on each row. You can also upload (or paste) an Outscraper Google Maps CSV as is: columns are read by name and businesses that aren't open are skipped. Google rarely gives a price, so check the bill on each row."
              : "Pega filas desde tu hoja (separadas por tab o coma), un negocio por línea, en este orden: nombre · rubro · zona · barrio · ticket promedio por persona · teléfono · instagram · place_id · google_maps_url. Puede venir con encabezado. Con el place_id traemos de Google la dirección y el punto en el mapa. El lote siembra sin foto ni logo. La foto y el logo se agregan después con «Fotos» en cada fila. También puedes subir (o pegar) tal cual el CSV de Outscraper («Raspador de mapas de Google»): las columnas se leen por nombre y los negocios que no están abiertos quedan afuera. Google casi nunca trae el precio: revisa el ticket de cada fila."}
            {!DESTACADA_HABILITADA && (
              <div style={{ marginTop: 6 }}>{en
                ? "Featured is available once the subscription exists: where the table asks for it, X-Large is proposed."
                : "Destacada disponible cuando exista la suscripción: donde la tabla la pide, se propone la Muy grande."}</div>
            )}
          </div>
          <textarea className="alta-textarea" rows={6} value={loteTexto} onChange={e => { setLoteTexto(e.target.value); setLoteFilas(null); }}
            placeholder={"La Ventana Brickell\tRestaurantes\tBrickell\tBrickell\t35\t305…\t@laventana\tChIJ…\thttps://maps…"}
            style={{ fontFamily: "ui-monospace, monospace", fontSize: 12 }} disabled={loteCorriendo} />
          <div style={{ display: "flex", gap: 10, marginTop: 10, flexWrap: "wrap", alignItems: "center" }}>
            <label style={{ fontSize: 12, color: C.gray, display: "flex", alignItems: "center", gap: 6 }}>
              {en ? "State for the whole batch" : "Estado para todo el lote"}
              <select className="alta-input" value={loteEstado} onChange={e => setLoteEstado(e.target.value)} disabled={loteCorriendo} style={{ padding: "6px 8px", fontSize: 12, width: "auto" }}>
                {BETA_ESTADOS.filter(s => s !== "visible").map(s => <option key={s} value={s}>{BETA_ESTADO_ROTULO[s][en ? 1 : 0]}</option>)}
              </select>
              <span style={{ fontSize: 11, color: C.muted }}>{en ? "Visible needs a photo: publish those one by one." : "«Visible» pide foto: esos se siembran de a uno."}</span>
            </label>
            {/* s217 · el CSV de Outscraper entero (65 columnas) se sube mejor que pegado. Es texto, no imagen. */}
            <label style={{ ...S.btnSecondary, width: "auto", padding: "8px 14px", fontSize: 13, cursor: loteCorriendo ? "default" : "pointer", display: "inline-block" }}>
              {en ? "Upload Outscraper CSV" : "Subir CSV de Outscraper"}
              <input type="file" accept=".csv,text/csv" disabled={loteCorriendo} style={{ display: "none" }}
                onChange={e => {
                  const archivo = e.target.files && e.target.files[0];
                  e.target.value = "";
                  if (!archivo) return;
                  const lector = new FileReader();
                  lector.onload = () => { setLoteTexto(String(lector.result || "")); setLoteFilas(null); };
                  lector.readAsText(archivo, "utf-8");
                }} />
            </label>
            <button type="button" onClick={previsualizar} disabled={!loteTexto.trim() || loteCorriendo} style={{ ...S.btnSecondary, width: "auto", padding: "8px 14px", fontSize: 13 }}>
              {en ? "Preview" : "Previsualizar"}
            </button>
            <button type="button" onClick={limpiarLote} disabled={loteCorriendo} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "8px 12px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
              {en ? "Clear batch" : "Limpiar lote"}
            </button>
          </div>

          {loteFilas && (
            <div style={{ marginTop: 16 }}>
              <div style={{ fontSize: 12, color: C.gray, marginBottom: 8 }}>
                {loteFilas.length} {en ? "rows" : "filas"} · {cuenta("omitida")} {en ? "with errors (skipped)" : "con errores (omitidas)"} · {cuenta("pendiente")} {en ? "pending" : "pendientes"} · {cuenta("ok")} OK · {cuenta("already")} {en ? "existed" : "ya existían"} · {cuenta("error")} {en ? "failed" : "fallidas"}
              </div>
              <div style={{ overflowX: "auto", border: `1px solid ${C.border}` }}>
                <table style={{ borderCollapse: "collapse", width: "100%", fontSize: 12, minWidth: 900 }}>
                  <thead>
                    <tr style={{ background: C.light }}>
                      {["#", en ? "Business" : "Comercio", en ? "Category" : "Rubro", en ? "Zone · Neighborhood" : "Zona · Barrio", en ? "Per person" : "Por persona", en ? "Size" : "Tamaño", en ? "Offer title" : "Título", en ? "Status" : "Estado"].map(h => (
                        <th key={h} style={{ textAlign: "left", padding: "8px 10px", fontSize: 10, letterSpacing: "0.12em", textTransform: "uppercase", color: C.muted, fontWeight: 500, borderBottom: `1px solid ${C.border}` }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {loteFilas.map((f, i) => {
                      const [rot, bg, color] = LOTE_ROTULO[f.estado] || LOTE_ROTULO.pendiente;
                      const editable = f.estado === "pendiente" || f.estado === "error";
                      return (
                        <tr key={i} style={{ borderBottom: `1px solid ${C.border}`, verticalAlign: "top", opacity: f.estado === "omitida" ? 0.7 : 1 }}>
                          <td style={{ padding: "8px 10px", color: C.muted }}>{f.fila}</td>
                          <td style={{ padding: "8px 10px" }}>
                            <div style={{ fontWeight: 700, color: C.black }}>{f.business_name || <span style={{ color: "var(--error)" }}>{en ? "(no name)" : "(sin nombre)"}</span>}</div>
                            {(f.phone || f.instagram) && <div style={{ color: C.muted }}>{[f.phone, f.instagram].filter(Boolean).join(" · ")}</div>}
                            {f.place_id && <div style={{ color: C.muted, fontSize: 10 }}>{f.place_id}</div>}
                            {f.outscraper && (f.rating || f.rango) && (
                              <div style={{ color: C.muted, fontSize: 10 }}>
                                {[f.rating && `★ ${f.rating}${f.reviews ? ` · ${f.reviews} ${en ? "reviews" : "reseñas"}` : ""}`,
                                  f.rango && `${en ? "Google price" : "precio en Google"}: ${f.rango}`].filter(Boolean).join(" · ")}
                              </div>
                            )}
                          </td>
                          {/* s217 · color explícito: el body hereda blanco y la celda se veía vacía. */}
                          <td style={{ padding: "8px 10px", color: C.black }}>{f.category ? (CAT_DISPLAY[f.category] || f.category) : <span style={{ color: "var(--error)" }}>{f.categoryRaw || "—"}</span>}</td>
                          <td style={{ padding: "8px 10px", color: C.gray }}>{[f.zone, f.neighborhood].filter(Boolean).join(" · ") || "—"}</td>
                          {/* s217 · en restaurantes y bares la hoja trae la mesa de dos: se muestra lo que usa el tamaño (por persona) y, al lado, lo pegado. */}
                          <td style={{ padding: "8px 10px", color: C.gray }}>{!(f.ticket > 0) ? "—" : (f.category && preguntaTicket(f.category, en).divisor === 2)
                            ? <>${fmtUsd(ticketPorPersona(f.category, f.ticket))}<div style={{ fontSize: 10, color: C.muted }}>{en ? `$${fmtUsd(f.ticket)} table of two` : `$${fmtUsd(f.ticket)} mesa de dos`}</div></>
                            : `$${fmtUsd(f.ticket)}`}
                            {/* s217 · de dónde salió el ticket: lo tiene que ver Otto y, después, el comercio. */}
                            <div style={{ fontSize: 10, color: f.fuenteTicket === "google_nivel" ? "var(--warning, #B45309)" : C.muted, marginTop: 2 }}>
                              {{
                                hoja: en ? "from the sheet" : "de la hoja",
                                google_rango: en ? `Google: ${f.rangoGoogle} per person` : `Google: ${f.rangoGoogle} por persona`,
                                google_nivel: en ? "approx. from Google's price level" : "aproximado por el nivel de precio de Google",
                                sin_dato_google: en ? "Google has no price: ask" : "Google no tiene precio: preguntar",
                                google_fallo: en ? "Couldn't reach Google" : "No se pudo consultar a Google",
                                sin_dato: en ? "no data: entry size" : "sin dato: tamaño de entrada",
                              }[f.fuenteTicket] || ""}
                            </div></td>
                          <td style={{ padding: "8px 10px" }}>
                            {filaEnPorcentaje(f) ? <span style={{ color: C.gray }}>{en ? "25% · no cap" : "25 % · sin tope"}</span>
                            : editable && f.category ? (<>
                              <select className="alta-input" value={f.tamano} onChange={e => setFila(i, { tamano: e.target.value })} disabled={loteCorriendo} style={{ padding: "4px 6px", fontSize: 12, width: "auto" }}>
                                {UMBRAL_TAMANOS.filter(t => ((UMBRAL_TAMANOS_POR_RUBRO[f.category] || ["M", "L", "L+", "XL"]).includes(t.id) || t.id === f.tamano)
                                  && (DESTACADA_HABILITADA || t.id !== "D")).map(t => (
                                  <option key={t.id} value={t.id}>{t.id === "D" ? "★" : t.id} · {fraseUmbral(t.monto, t.minimo, false)}</option>
                                ))}
                              </select>
                              {/* s217 · Prudente · Recomendado · Destacado: un toque elige el tamaño. */}
                              {f.opciones && (
                                <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginTop: 4 }}>
                                  {[["prudente", en ? "Cautious" : "Prudente"], ["recomendado", en ? "Recommended" : "Recomendado"], ["destacado", en ? "Stand out" : "Destacado"]]
                                    .filter(([k]) => k === "recomendado" || f.opciones[k] !== f.opciones.recomendado)   // sin chips repetidos
                                    .map(([k, rot]) => {
                                    const id = f.opciones[k];
                                    const on = f.tamano === id;
                                    return (
                                      <button key={k} type="button" disabled={loteCorriendo} onClick={() => setFila(i, { tamano: id })}
                                        title={tituloDeTamano(id)}
                                        style={{ fontSize: 10, padding: "2px 6px", borderRadius: 999, cursor: "pointer",
                                          border: `1px solid ${on ? (k === "destacado" ? "var(--accent, #C8460F)" : C.black) : C.border}`,
                                          background: on ? (k === "destacado" ? "var(--accent, #C8460F)" : C.black) : C.white,
                                          color: on ? C.white : (k === "destacado" ? "var(--accent, #C8460F)" : C.gray), fontWeight: k === "destacado" ? 700 : 500 }}>
                                        {rot} {id === "D" ? "★" : id}
                                      </button>
                                    );
                                  })}
                                </div>
                              )}
                            </>) : <span style={{ color: C.gray }}>{f.tamano || "—"}</span>}
                          </td>
                          <td style={{ padding: "8px 10px", color: C.gray }}>{(filaEnPorcentaje(f) ? tituloFilaPct(f.category) : tituloDeTamano(f.tamano)) || "—"}</td>
                          <td style={{ padding: "8px 10px" }}>
                            <span style={{ display: "inline-block", background: bg, color, fontSize: 10, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", padding: "3px 8px", borderRadius: 4 }}>{rot}</span>
                            {f.errores.length > 0 && <div style={{ color: "var(--error)", marginTop: 4, lineHeight: 1.4 }}>{f.errores.join(" · ")}</div>}
                            {f.mensaje && <div style={{ color: C.gray, marginTop: 4, lineHeight: 1.4 }}>{f.mensaje}</div>}
                            {f.estado === "ok" && f.beta_token && (
                              <div style={{ display: "flex", gap: 6, marginTop: 6, alignItems: "center", flexWrap: "wrap" }}>
                                <button onClick={() => copiar(f.beta_token, f.category, f.business_name)} style={{ background: "none", border: `1px solid ${C.border}`, color: copiado === f.beta_token ? "var(--exito)" : C.muted, padding: "3px 8px", fontSize: 11, cursor: "pointer", borderRadius: 2 }}>
                                  {copiado === f.beta_token ? "✓" : (en ? "Copy link" : "Copiar link")}
                                </button>
                                <a href={linkBeta(f.beta_token, f.category, f.business_name)} target="_blank" rel="noreferrer" style={{ fontSize: 11, color: C.muted }}>{en ? "Open" : "Abrir"}</a>
                                {f.adoptado && <span style={{ fontSize: 10, color: C.muted }}>{en ? "(adopted)" : "(adoptado)"}</span>}
                              </div>
                            )}
                            {f.estado === "already" && f.merchant_id && (
                              <button onClick={() => adoptarFila(i)} disabled={loteCorriendo} style={{ ...S.btnPrimary, width: "auto", padding: "4px 10px", fontSize: 11, marginTop: 6 }}>
                                {en ? "Adopt" : "Adoptar"}
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <div style={{ display: "flex", gap: 10, marginTop: 12, flexWrap: "wrap", alignItems: "center" }}>
                {/* s217 · antes de sembrar: precio de Google para las filas sin ticket que tienen place_id. */}
                {(filasParaGoogle().length > 0 || loteGoogle) && (
                  <button type="button" onClick={completarConGoogle} disabled={loteCorriendo || filasParaGoogle().length === 0}
                    style={{ ...S.btnSecondary, width: "auto", padding: "10px 18px", fontSize: 14 }}>
                    {loteGoogle && loteGoogle.hechas < loteGoogle.total
                      ? (en ? `Asking Google… ${loteGoogle.hechas}/${loteGoogle.total}` : `Consultando Google… ${loteGoogle.hechas}/${loteGoogle.total}`)
                      : filasParaGoogle().length > 0
                        ? (en ? `Complete with Google (${filasParaGoogle().length})` : `Completar con Google (${filasParaGoogle().length})`)
                        : loteGoogle.fallos === loteGoogle.total
                          ? (en ? "Couldn't reach Google" : "No se pudo consultar a Google")
                          : (en ? `Google gave a price for ${loteGoogle.con} of ${loteGoogle.total}` : `Google dio precio en ${loteGoogle.con} de ${loteGoogle.total}`)}
                  </button>
                )}
                <button type="button" onClick={() => sembrarLote(false)} disabled={loteCorriendo || cuenta("pendiente") === 0} style={{ ...S.btnPrimary, width: "auto", padding: "10px 18px", fontSize: 14 }}>
                  {loteCorriendo ? (loteGoogle && loteGoogle.hechas < loteGoogle.total ? (en ? "Wait…" : "Espera…") : (en ? "Seeding…" : "Sembrando…"))
                    : cuenta("pendiente") === 0 ? (en ? "Nothing left to seed" : "Nada pendiente")
                    : cuenta("pendiente") === 1 ? (en ? "Seed 1 valid row" : "Sembrar 1 válida")
                    : (en ? `Seed ${cuenta("pendiente")} valid rows` : `Sembrar ${cuenta("pendiente")} válidas`)}
                </button>
                {cuenta("error") > 0 && (
                  <button type="button" onClick={() => sembrarLote(true)} disabled={loteCorriendo} style={{ ...S.btnSecondary, width: "auto", padding: "10px 18px", fontSize: 14 }}>
                    {en ? `Retry ${cuenta("error")} failed` : `Reintentar ${cuenta("error")} fallidas`}
                  </button>
                )}
                {cuenta("ok") > 0 && (
                  <button type="button" onClick={copiarTodosLosLinks} disabled={loteCorriendo} style={{ background: "none", border: `1px solid ${C.border}`, color: loteCopiado ? "var(--exito)" : C.gray, padding: "10px 14px", fontSize: 13, cursor: "pointer", borderRadius: 2 }}>
                    {loteCopiado ? "✓" : cuenta("ok") === 1 ? (en ? "Copy the link" : "Copiar el link")
                      : (en ? `Copy all ${cuenta("ok")} links` : `Copiar los ${cuenta("ok")} links`)}
                  </button>
                )}
              </div>
            </div>
          )}
        </section>
        {/* s238 · lo sembrado se gestiona en «Negocios». */}
        {lista.length > 0 && (
          <button type="button" onClick={() => navigate("/operator/negocios")}
            style={{ marginBottom: 24, background: "none", border: "none", padding: 0, color: C.red, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
            {en ? `See the ${lista.length} seeded businesses in Businesses →` : `Ver los ${lista.length} sembrados en Negocios →`}
          </button>
        )}
        </>)}

        {vista === "negocios" && (<>
        {/* s238 · buscador (pedido de Otto): filtra «Sembrados» y «Seguimiento» junto con sus filtros. */}
        <div className="alta-campo" style={{ marginBottom: 12 }}>
          <label htmlFor="neg-buscar" className="alta-etiqueta">{en ? "Search" : "Buscar"}</label>
          <input id="neg-buscar" className="alta-input" type="search" value={buscarNegocio} onChange={e => setBuscarNegocio(e.target.value)}
            placeholder={en ? "Name, phone, area, category or who seeded it" : "Nombre, teléfono, zona, rubro o quién sembró"} autoComplete="off" />
        </div>

        {/* ---------- s227 · SEMBRADOS | POR VERIFICAR ---------- */}
        <div className="alta-chips pv-pestanas" role="tablist" aria-label={en ? "Lists" : "Listas"}>
          {[["sembrados", en ? `Seeded · ${lista.length}` : `Sembrados · ${lista.length}`], ["seguimiento", en ? "Follow-up" : "Seguimiento"], ["verificar", en ? "To verify" : "Por verificar"]].map(([id, texto]) => (
            <button key={id} type="button" role="tab" aria-selected={pestanaLista === id}
              className={["alta-chip", pestanaLista === id && "alta-chip--on"].filter(Boolean).join(" ")} onClick={() => setPestanaLista(id)}>{texto}</button>
          ))}
        </div>
        {pestanaLista === "verificar" && <PorVerificar en={en} />}
        {/* s237 · micro-CRM: una fila por comercio con la última llamada, la próxima y el embudo. */}
        {pestanaLista === "seguimiento" && <SeguimientoCrm en={en} lista={lista} cargando={origenLista === "cargando"} onRecargar={cargarLista} busqueda={buscarNegocio} />}

        {/* ---------- SEMBRADOS ---------- */}
        {pestanaLista === "sembrados" && (
        <section>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
            <div style={{ ...S.display, fontSize: 20, color: C.black }}>{en ? "SEEDED" : "SEMBRADOS"} · {lista.length}</div>
            <button onClick={cargarLista} style={{ background: "none", border: `1px solid ${C.border}`, color: C.muted, padding: "6px 12px", fontSize: 12, cursor: "pointer", borderRadius: 2 }}>
              {en ? "Refresh" : "Actualizar"}
            </button>
          </div>
          {origenLista === "cache" && (
            <div style={{ background: "var(--aviso-tinte)", color: "var(--aviso-tinta)", fontSize: 12, padding: "8px 12px", borderRadius: 4, marginBottom: 10, lineHeight: 1.5 }}>
              {en ? "Local list: only what was seeded from THIS browser. Opens and invitations come from the get_seeded_merchants workflow, which doesn't exist yet (requested)."
                  : "Lista local: solo lo sembrado desde ESTE navegador. Las aperturas y las invitaciones salen del workflow get_seeded_merchants, que todavía no existe (pedido)."}
            </div>
          )}
          {avisoCrm && (
            <div role="status" style={{ display: "flex", justifyContent: "space-between", gap: 10, background: "var(--exito-tinte)", color: "var(--exito)", fontSize: 12, padding: "8px 12px", borderRadius: 4, marginBottom: 10 }}>
              <span>{avisoCrm}</span>
              <button type="button" onClick={() => setAvisoCrm("")} aria-label={en ? "Close" : "Cerrar"} style={{ background: "none", border: "none", color: "inherit", cursor: "pointer", fontSize: 12 }}>✕</button>
            </div>
          )}
          {/* s218 · mini CRM: filtros por estado, «Hoy toca llamar», zona y quién sembró. */}
          {origenLista === "wf" && lista.length > 0 && (
            <div style={{ display: "flex", flexWrap: "wrap", gap: 6, alignItems: "center", marginBottom: 12 }} role="group" aria-label={en ? "Filter the list" : "Filtrar la lista"}>
              {/* s238 · ayudas V34: estado (lo mueve el sistema) vs etapa (lo que registra Otto, en «Seguimiento»). */}
              <AltaPista texto={en ? "Lead, Invited and Approved are set by the system: Invited when the invitation is sent, Approved when the owner confirms from their panel. What you log on calls is the stage, shown under \"Follow-up\"." : "Lead, Invitado y Aprobado los mueve el sistema: Invitado al enviar la invitación, Aprobado cuando el dueño confirma desde su panel. Lo que tú registras en las llamadas es la etapa, y se ve en «Seguimiento»."} />
              {filtrosCrm.map(([id, texto, n]) => (
                <button key={id} type="button" aria-pressed={filtroCrm === id} onClick={() => setFiltroCrm(id)}
                  style={{ border: `1px solid ${filtroCrm === id ? C.black : C.border}`, background: filtroCrm === id ? C.black : "none",
                    color: filtroCrm === id ? C.white : (id === "hoy" && n > 0 ? "var(--error)" : C.gray),
                    fontWeight: id === "hoy" && n > 0 ? 700 : 400, padding: "5px 10px", fontSize: 12, cursor: "pointer", borderRadius: 999 }}>
                  {texto} · {n}
                </button>
              ))}
              {zonas.length > 1 && (
                <select aria-label={en ? "Zone" : "Zona"} value={filtroZona} onChange={e => setFiltroZona(e.target.value)}
                  style={{ fontSize: 12, padding: "5px 8px", border: `1px solid ${C.border}`, borderRadius: 2, color: C.gray, background: C.white }}>
                  <option value="">{en ? "All zones" : "Todas las zonas"}</option>
                  {zonas.map(z => <option key={z} value={z}>{z}</option>)}
                </select>
              )}
              {sembradores.length > 1 && (
                <select aria-label={en ? "Seeded by" : "Sembró"} value={filtroSembro} onChange={e => setFiltroSembro(e.target.value)}
                  style={{ fontSize: 12, padding: "5px 8px", border: `1px solid ${C.border}`, borderRadius: 2, color: C.gray, background: C.white }}>
                  <option value="">{en ? "Seeded by anyone" : "Sembró cualquiera"}</option>
                  {sembradores.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              )}
            </div>
          )}
          {/* s216 · «Fotos» y «Corregir oferta» se abren debajo de SU fila (`consola-paneles-al-final-de-la-lista`). */}
          <AdminTable columns={cols} rows={listaVista} loading={origenLista === "cargando"}
            empty={lista.length ? (en ? "Nothing matches this filter" : "Nada con este filtro") : (en ? "Nothing seeded yet" : "Todavía no hay comercios sembrados")} apilarEnTelefono
            debajo={r => {
              const fotos = fotosDe && r.merchant_id && fotosDe.merchant_id === r.merchant_id;
              const corregir = corrigiendo && r.merchant_id && corrigiendo.merchant_id === r.merchant_id;
              const franja = franjaDe && r.merchant_id && franjaDe.merchant_id === r.merchant_id;
              const llamada = llamadaDe && r.merchant_id && llamadaDe.merchant_id === r.merchant_id;
              const descarte = descarteDe && r.merchant_id && descarteDe.merchant_id === r.merchant_id;
              if (!fotos && !corregir && !franja && !llamada && !descarte) return null;
              return (
                <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
                  {llamada && <RegistrarLlamada key={llamadaDe.merchant_id} fila={r} en={en} onCerrar={() => setLlamadaDe(null)} onGuardada={cargarLista} />}
                  {descarte && <DescartarSembrado key={descarteDe.merchant_id} fila={r} en={en} esAdmin={profile?.role === "Admin"} onCerrar={() => setDescarteDe(null)}
                    onHecho={() => {
                      setAvisoCrm(en ? `«${r.business_name}» was discarded. You'll find it under «Discarded».` : `«${r.business_name}» quedó descartado. Lo ves en «Descartado».`);
                      setDescarteDe(null); setLlamadaDe(null); cargarLista();
                    }} />}
                  {fotos && <QuitarFotosComercio key={fotosDe.merchant_id} merchantId={fotosDe.merchant_id} nombre={fotosDe.business_name} en={en} abrir onCerrar={() => setFotosDe(null)}
                    galeriaInicial={fotosDe.gallery_urls} logoInicial={fotosDe.logo} conLogo onCambio={cargarLista} enlaces={fotosDe.enlaces} />}
                  {corregir && <CorregirOfertaSembrada key={corrigiendo.merchant_id} fila={corrigiendo} en={en} onCerrar={() => setCorrigiendo(null)} />}
                  {franja && <OtraFranjaSembrado key={franjaDe.merchant_id} fila={franjaDe} en={en} onCerrar={() => setFranjaDe(null)} onCreada={cargarLista} />}
                </div>
              );
            }} />
        </section>
        )}
        </>)}
      </div>
    </div>
  );
}

// ---- «CONFIRMAR MI OFERTA» · panel del comercio en estado Invitado (s194-D22) ----
// El comercio entró por el link, creó su clave y cayó acá. Su oferta sembrada está en
// Pending; un toque la activa vía confirm_offer (WF PEDIDO en PLAN_s195 §4). Mientras el
// WF no exista, el botón lo dice; en Live el estado Invitado tampoco existe todavía, así
// que este bloque no se ve hasta el deploy de las salas.
// Decisión de Ali (17/09): confirm_offer aprueba solo con el comercio en Invitado o ya Approved.
// Para un comercio Approved (los ~10 amigos de Otto que ya tenían cuenta y se ADOPTAN) el
// bloque aparece solo si hay una umbral Pending que NO creó él mismo (la sembró un operador:
// `Created By` ≠ el dueño). Las ofertas que el comercio crea desde el alta siguen su camino de
// siempre (approve_offer, revisión de Ali): este bloque no las toca.
// s213 · ¿Ya hay miembros que pagan? Mientras la membresía no se cobre (vitrina con COBRO_ABIERTO =
// false, D19 de s211), «Los miembros ya te ven» era falso y contradecía a Otto («te avisamos antes de
// abrir», s212-D20). El día que se abra la membresía, esto pasa a `true` y vuelve el mensaje de siempre.
const MEMBRESIA_ABIERTA = false;

// s215 · el aviso de Explorar mientras la membresía está cerrada. El comercio lee que el suyo ya es
// parte y que esto crece cada semana; el resto, que vuelva pronto.
function CatalogoConstruyendo({ en }) {
  // El rol no siempre queda en localStorage (el login lo guarda solo si la respuesta lo trae: medido con
  // +s215, nxt_role vacío). Se arranca con lo guardado y se confirma con el perfil.
  const [rol, setRol] = useState(() => { try { return localStorage.getItem("nxt_role") || ""; } catch (e) { return ""; } });
  useEffect(() => {
    let vivo = true;
    if (auth.isLoggedIn()) getUserProfile().then(p => { if (vivo && p?.role) setRol(p.role); }).catch(() => {});
    return () => { vivo = false; };
  }, []);
  const esComercio = rol === "Merchant";
  return (
    <div className="catalogo__construyendo" role="status">
      <b>{esComercio
        ? (en ? "We're building the club, place by place." : "Estamos armando el club, lugar por lugar.")
        : (en ? "We're bringing in the first places in Miami." : "Estamos sumando los primeros lugares de Miami.")}</b>{" "}
      {esComercio
        ? (en
          ? "Every week new Miami businesses join, and yours is already in. When we open the membership, members will find all these places here — yours included. Check back: this grows every week."
          : "Cada semana sumamos negocios nuevos de Miami, y el tuyo ya es parte. Cuando abramos la membresía, los miembros van a encontrar aquí todos estos lugares, incluido el tuyo. Vuelve a mirar: esto crece todas las semanas.")
        : (en
          ? "New places join every week. Check back soon."
          : "Cada semana entran negocios nuevos. Vuelve a mirar pronto.")}
    </div>
  );
}

// s215 · notas 8 + 6 (Ali, ensayo con Otto): el comercio aprobado no puede quedar «en el aire» mientras
// la membresía está cerrada, y todavía no se le muestra el catálogo (está casi vacío). Bienvenida arriba
// del panel: cuántos lugares van, qué sigue, y la promesa de entrar al club cuando seamos ~30.
const LUGARES_PARA_ABRIR = 30;
// s215 · Ali (B): con pocos lugares el número resta («2 lugares en Miami»): se muestra desde 10.
const LUGARES_PARA_MOSTRAR = 10;
function MerchantBienvenidaClub() {
  const en = useLang() === "en";
  const [lugares, setLugares] = useState(null);
  useEffect(() => {
    let vivo = true;
    getPublicMerchants().then(l => { if (vivo) setLugares(Array.isArray(l) ? l.length : null); }).catch(() => {});
    return () => { vivo = false; };
  }, []);
  return (
    <section className="mrc-bienvenida" aria-label={en ? "You're in the club" : "Ya estás en el club"}>
      <p className="mrc-bienvenida__ceja">{en ? "NXT RESERVE · MIAMI" : "NXT RESERVE · MIAMI"}</p>
      <h2 className="mrc-bienvenida__titulo">{en ? "You're in the club." : "Ya estás en el club."}</h2>
      <p className="mrc-bienvenida__texto">
        {en
          ? "Your offer is ready. Members will see you the day we open the membership — we'll email you before."
          : "Tu oferta está lista. Los miembros te van a ver el día que abramos la membresía: te avisamos por correo antes."}
      </p>
      {lugares !== null && lugares < LUGARES_PARA_MOSTRAR && (
        <p className="mrc-bienvenida__contador">{en ? "We're bringing in the first places in Miami." : "Estamos sumando los primeros lugares de Miami."}</p>
      )}
      {lugares !== null && lugares >= LUGARES_PARA_MOSTRAR && (
        <div className="mrc-bienvenida__contador">
          <b>{lugares}</b> {en ? (lugares === 1 ? "place in Miami so far" : "places in Miami so far") : (lugares === 1 ? "lugar en Miami hasta hoy" : "lugares en Miami hasta hoy")}
          <div className="mrc-bienvenida__barra" aria-hidden="true"><span style={{ width: `${Math.min(100, Math.round((lugares / LUGARES_PARA_ABRIR) * 100))}%` }} /></div>
        </div>
      )}
      {/* s215 · Ali (B): el comercio ya puede mirar el catálogo; se le invita a entrar y se le dice cuándo valen los beneficios. */}
      <p className="mrc-bienvenida__nota">
        {en
          ? <>You can already see the club's places in <Link to="/">Explore</Link>. The benefits switch on the day we open the membership.</>
          : <>Ya puedes ver los lugares del club en <Link to="/">Explorar</Link>. Los beneficios se activan el día que abramos la membresía.</>}
      </p>
      <ol className="mrc-bienvenida__pasos">
        <li><b>{en ? "A member arrives:" : "Llega un miembro:"}</b> {en ? "they show you their code and you validate it below. It takes seconds." : "te muestra su código y lo validas aquí abajo. Toma segundos."}</li>
        <li><b>{en ? "Are you full?" : "¿Estás lleno?"}</b> {en ? <>Pause your offer in <Link to="/merchant/offers">My offers</Link>.</> : <>Pausas tu oferta en <Link to="/merchant/offers">Mis ofertas</Link>.</>}</li>
        <li><b>{en ? "Complete your profile:" : "Completa tu perfil:"}</b> {en ? <>your logo and photos in <Link to="/merchant/profile">Profile</Link>.</> : <>tu logo y tus fotos en <Link to="/merchant/profile">Perfil</Link>.</>}</li>
      </ol>
    </section>
  );
}

// ---- s222 · lote 2a · EL MENÚ DEL COMERCIO (link o foto/PDF) ----
// Uno solo para el dueño (confirmar la oferta sembrada) y para el admin (detalle del comercio, aprobar):
// guarda con guardarFicha, que lee la ficha y manda el juego completo. Con `merchantId` + `comoAdmin` escribe
// en ese comercio (Admin/Operator); sin eso, en el del usuario. Si `confirm_offer`/`approve_offer` devolvió
// MENU_REQUIRED, `mensaje` trae el texto de Bubble y va arriba.
// Restaurantes, bares y cafés (los cafés son Restaurant) dicen «Menú»; el resto, «Menú o lista de precios».
const etiquetaMenu = (categoria, en) => (["Restaurant", "Bar_Rooftop"].includes(categoria)
  ? (en ? "Menu" : "Menú")
  : (en ? "Menu or price list" : "Menú o lista de precios"));

// s238 · webs-de-terceros (INVESTIGACION_s238_plataformas_terceros.md): muchos salones y restaurantes chicos no tienen web
// propia; su «web» es la página del negocio en una plataforma. `tipo`: reservas | menu (pedidos/tienda) | enlaces | redes.
// `sub`: el negocio vive en un subdominio (salon.glossgenius.com), así que solo el dominio pelado es «sin negocio».
const PLATAFORMAS_WEB = [
  { d: "booksy.com", n: "Booksy", tipo: "reservas" }, { d: "vagaro.com", n: "Vagaro", tipo: "reservas" },
  { d: "fresha.com", n: "Fresha", tipo: "reservas" }, { d: "styleseat.com", n: "StyleSeat", tipo: "reservas" },
  { d: "phorest.com", n: "Phorest", tipo: "reservas" }, { d: "glossgenius.com", n: "GlossGenius", tipo: "reservas", sub: true },
  { d: "schedulicity.com", n: "Schedulicity", tipo: "reservas" }, { d: "mindbodyonline.com", n: "Mindbody", tipo: "reservas" },
  { d: "joinblvd.com", n: "Boulevard", tipo: "reservas" }, { d: "squareup.com", n: "Square", tipo: "reservas" },
  { d: "opentable.com", n: "OpenTable", tipo: "reservas" }, { d: "resy.com", n: "Resy", tipo: "reservas" },
  { d: "exploretock.com", n: "Tock", tipo: "reservas" }, { d: "sevenrooms.com", n: "SevenRooms", tipo: "reservas" },
  { d: "toasttab.com", n: "Toast", tipo: "menu" }, { d: "square.site", n: "Square", tipo: "menu", sub: true },
  { d: "clover.com", n: "Clover", tipo: "menu" }, { d: "order.online", n: "DoorDash", tipo: "menu" },
  { d: "chownow.com", n: "ChowNow", tipo: "menu" }, { d: "menufy.com", n: "Menufy", tipo: "menu", sub: true },
  { d: "slicelife.com", n: "Slice", tipo: "menu" },
  { d: "linktr.ee", n: "Linktree", tipo: "enlaces" }, { d: "beacons.ai", n: "Beacons", tipo: "enlaces" },
  { d: "instagram.com", n: "Instagram", tipo: "redes" }, { d: "facebook.com", n: "Facebook", tipo: "redes" },
  { d: "tiktok.com", n: "TikTok", tipo: "redes" },
];
// { n, tipo, pelada } si la dirección es de una plataforma; null si es una web propia (o no se entiende).
const plataformaDeWeb = (url) => {
  const s = String(url || "").trim();
  if (!s) return null;
  let host = "", path = "";
  try { const u = new URL(/^https?:\/\//i.test(s) ? s : `https://${s}`); host = u.hostname.toLowerCase().replace(/^www\./, ""); path = u.pathname.replace(/\/+$/, ""); }
  catch (_) { return null; }
  const p = PLATAFORMAS_WEB.find(x => host === x.d || host.endsWith("." + x.d));
  if (!p) return null;
  const pelada = p.sub ? host === p.d && !path : !path;
  return { n: p.n, tipo: p.tipo, pelada };
};
// La nota debajo del campo del enlace (siembra de Otto y alta del comercio). `deQuien`: "su" (Otto) o "tu" (el dueño).
function AvisoPlataforma({ url, en, deQuien = "tu" }) {
  const p = plataformaDeWeb(url);
  const su = deQuien === "su";
  if (!p) return null;
  const estilo = { fontSize: 12, marginTop: 6, lineHeight: 1.4, color: p.pelada ? "var(--error)" : C.gray };
  if (p.pelada) return (
    <div role="status" style={estilo}>{en
      ? `That's ${p.n}'s address, not the business's. Open ${su ? "its" : "your"} page on ${p.n} and copy the full address.`
      : `Ese es el enlace de ${p.n}, no el del negocio. Abre ${su ? "su" : "tu"} página en ${p.n} y copia la dirección completa.`}</div>
  );
  if (p.tipo === "redes" || p.tipo === "enlaces") return (
    <div style={estilo}>{en
      ? `A ${p.n} link can't show prices. If ${su ? "it has" : "you have"} Booksy, Toast, an online store or a website, paste that one.`
      : `En ${p.n} no se ven precios. Si ${su ? "tiene" : "tienes"} Booksy, Toast, una tienda online o una web, pega ese enlace.`}</div>
  );
  const es = p.tipo === "menu" ? `ahí está ${su ? "su" : "tu"} menú con precios` : `ahí están ${su ? "sus" : "tus"} servicios y precios`;
  const enTxt = p.tipo === "menu" ? `that's where ${su ? "its" : "your"} menu and prices are` : `that's where ${su ? "its" : "your"} services and prices are`;
  return <div style={estilo}>{en ? `${p.n} page: good, ${enTxt}.` : `Página de ${p.n}: sirve, ${es}.`}</div>;
}
const mensajeMenu = (code, en) => ({
  MENU_URL_INVALID: en ? "The link has to start with https://" : "El link tiene que empezar con https://",
  MENU_FILE_TOO_BIG: en ? `The file weighs more than ${Math.round(MENU_PDF_PESO_MAX / 1048576)} MB. Upload a lighter one or paste the link.` : `El archivo pesa más de ${Math.round(MENU_PDF_PESO_MAX / 1048576)} MB. Sube uno más liviano o pega el link.`,
  MENU_FILE_TYPE: en ? "Upload a photo or a PDF." : "Sube una foto o un PDF.",
  MENU_FILE_UNREADABLE: en ? "We couldn't open that photo. Try another one or a PDF." : "No pudimos abrir esa foto. Prueba con otra o con un PDF.",
  FICHA_NO_LEIDA: en ? "We couldn't read your business details, so nothing was saved. Reload and try again." : "No pudimos leer los datos de tu negocio y no guardamos nada, para no borrar lo que ya tienes. Recarga e intenta de nuevo.",
  NOT_OPERATOR: en ? "Your session can't edit this business." : "Tu sesión no puede editar este comercio.",
  MERCHANT_NOT_FOUND: en ? "That business no longer exists." : "Ese comercio ya no existe.",
  NO_MERCHANT: en ? "Your user has no business." : "Tu usuario no tiene comercio.",
}[code] || "");
// s227 · `wizard-menu-desde-web`: la página del comercio (`website`, viene de Places) lista para el link del menú:
// { url, dominio } o null. El dominio va en el botón para que el dueño vea QUÉ página es: muchas webs no son el menú,
// por eso es un botón y no se llena solo.
function sitioDelComercio(website) {
  const w = String(website || "").trim();
  if (!w) return null;
  // s233 · menu-http-a-https: la web de Google suele venir «http://…» y el menú exige https: se pega ya en https.
  const url = /^https?:\/\//i.test(w) ? w.replace(/^http:\/\//i, "https://") : `https://${w}`;
  try { return { url, dominio: new URL(url).hostname.replace(/^www\./i, "") }; } catch (_) { return null; }
}
// s233 · menu-web-clara (Ali: «está muy chiquito, cualquiera confirma sin saber qué es; yo me confundí»): el chip
// «Usar mi página: dominio» pasa a un recuadro que pregunta si el menú está en la web, muestra la dirección COMPLETA
// (se abre para revisarla) y un botón grande. `guardaDeUnaVez`: en «Confirma tu oferta» el botón guarda (antes había que
// tocar el chip y después «Guardar menú»); en el wizard solo llena el campo, porque ahí todo se guarda al sembrar.
function BotonUsarMiPagina({ sitio, en, onUsar, onNo = null, disabled = false, guardaDeUnaVez = false }) {
  if (!sitio) return null;
  return (
    <div className="alta-menu-web">
      <div className="alta-menu-web__titulo">{en ? "Is your menu on your website?" : "¿Tu menú está en tu página web?"}</div>
      <a className="alta-menu-web__url" href={sitio.url} target="_blank" rel="noopener noreferrer">{sitio.url} ↗</a>
      <div className="alta-menu-web__ayuda">
        {en ? "Open it and check your menu is there. If it is, tap:" : "Ábrela y revisa que ahí esté tu menú. Si está, toca:"}
      </div>
      <button type="button" className="alta-btn alta-btn--seguir alta-menu-web__boton" disabled={disabled} onClick={() => onUsar(sitio.url)}>
        {guardaDeUnaVez
          ? (en ? "Yes, use my website as the menu" : "Sí, usar mi web como menú")
          : (en ? "Yes, my menu is on my website" : "Sí, mi menú está en mi web")}
      </button>
      {onNo && (
        <button type="button" className="alta-menu-web__no" disabled={disabled} onClick={onNo}>
          {en ? "No, it's somewhere else" : "No, está en otro lado"}
        </button>
      )}
    </div>
  );
}

function MenuDelComercio({ categoria, ficha, mensaje, en, onGuardado, merchantId, comoAdmin = false, idBase = "menu", sitioWeb = "" }) {
  const [link, setLink] = useState("");
  const sitio = sitioDelComercio(sitioWeb);
  // s255 · menu-desde-la-web (Ali): con la web conocida, primero solo la pregunta Sí / No. El link y el archivo aparecen con «No».
  const [otroLado, setOtroLado] = useState(false);
  const [archivo, setArchivo] = useState(null);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");
  const etiqueta = etiquetaMenu(categoria, en);
  const actualLink = String(ficha?.menu_url || "").trim();
  const actualArchivo = String(ficha?.menu_file || "").trim();
  // s233 · `linkDirecto`: «Sí, usar mi web como menú» guarda de una vez con la web, sin pasar por el campo.
  const guardar = async (linkDirecto) => {
    const l = typeof linkDirecto === "string" ? linkDirecto : link.trim();
    if (!l && !archivo) { setError(en ? "Paste a link or pick a file." : "Pega un link o elige un archivo."); return; }
    setGuardando(true); setError("");
    try {
      const cambios = {};
      if (l) cambios.menu_url = /^https?:\/\//i.test(l) ? l : `https://${l}`;
      if (archivo) cambios.menu_file = archivo;
      const nueva = await guardarFicha(cambios, comoAdmin ? merchantId : undefined);
      setLink(""); setArchivo(null);
      if (onGuardado) await onGuardado(nueva);
    } catch (e) {
      setError(mensajeMenu(e?.code, en) || e?.message || (en ? "We couldn't save it." : "No pudimos guardarlo."));
    } finally {
      setGuardando(false);
    }
  };
  return (
    <div className="mrc-confirmar__esencial" style={{ marginTop: 12 }} aria-label={etiqueta}>
      <b>{etiqueta}</b>
      {mensaje && <p role="alert" style={{ margin: "6px 0", color: "var(--aviso-tinta)" }}>{mensaje}</p>}
      {(actualLink || actualArchivo) ? (
        <p style={{ margin: "6px 0" }}>
          {actualLink && <a href={actualLink} target="_blank" rel="noopener noreferrer">{en ? "See the link" : "Ver el link"}</a>}
          {actualLink && actualArchivo && " · "}
          {actualArchivo && <a href={urlMenu(actualArchivo)} target="_blank" rel="noopener noreferrer">{en ? "See the file" : "Ver el archivo"}</a>}
          <small style={{ display: "block" }}>{en ? "You can replace it below." : "Puedes cambiarlo aquí abajo."}</small>
        </p>
      ) : (
        !mensaje && <small style={{ display: "block", margin: "4px 0 6px" }}>{en ? "Members check it before they go. A link or a photo/PDF." : "El miembro lo mira antes de ir. Un link o una foto/PDF."}</small>
      )}
      {/* s254 · P2 (Ali): si ya tenemos su web, esa opción va PRIMERO. Debajo de un campo vacío parecía que había que
          volver a escribir la web. El campo queda como alternativa. */}
      {(() => {
        const ofreceWeb = sitio && link.trim() !== sitio.url && actualLink !== sitio.url;
        const soloPregunta = ofreceWeb && !otroLado;
        return (<>
          {soloPregunta && <BotonUsarMiPagina sitio={sitio} en={en} guardaDeUnaVez disabled={guardando} onUsar={(u) => guardar(u)} onNo={() => setOtroLado(true)} />}
          {!soloPregunta && (<>
            <label htmlFor={`${idBase}-link`} className="alta-etiqueta" style={{ display: "block", marginTop: 6 }}>
              {ofreceWeb ? (en ? "Paste the link to your menu" : "Pega el link de tu menú") : "Link"}
            </label>
            <input id={`${idBase}-link`} className="alta-input" type="url" inputMode="url" placeholder="https://"
              value={link} onChange={e => setLink(e.target.value)} />
            <label htmlFor={`${idBase}-archivo`} className="alta-etiqueta" style={{ display: "block", marginTop: 8 }}>{en ? "Or a photo / PDF" : "O una foto / PDF"}</label>
            <input id={`${idBase}-archivo`} type="file" accept="image/*,application/pdf"
              onChange={e => setArchivo((e.target.files && e.target.files[0]) || null)} />
            <div style={{ marginTop: 10, display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
              {/* s234 · menu-en-dos-pasos (Ali: «cualquiera le da a guardar y no sube el menú»): apagado hasta que haya link o archivo. */}
              <button type="button" className="alta-btn alta-btn--seguir" onClick={guardar} disabled={guardando || (!link.trim() && !archivo)}>
                {guardando ? (en ? "Saving…" : "Guardando…") : (en ? `Save ${etiqueta.toLowerCase()}` : `Guardar ${etiqueta.toLowerCase()}`)}
              </button>
              {ofreceWeb && (
                <button type="button" className="alta-menu-web__no" onClick={() => { setOtroLado(false); setLink(""); setArchivo(null); }}>
                  {en ? "← It's on my website after all" : "← Sí está en mi web"}
                </button>
              )}
            </div>
          </>)}
        </>);
      })()}
      {error && <div className="beta__error" role="alert" style={{ marginTop: 8 }}>{error}</div>}
    </div>
  );
}

function MerchantConfirmarOferta({ profile, esInvitado }) {
  const lang = useLang();
  const en = lang === "en";
  const navigate = useNavigate();
  const [oferta, setOferta] = useState(undefined);   // undefined = cargando · null = no hay
  const [otras, setOtras] = useState([]);            // s217 · 2bis: las demás Pending (otras franjas)
  const [estado, setEstado] = useState("");          // "" | confirmando | listo
  const [error, setError] = useState("");
  const [aviso, setAviso] = useState("");            // NOT_INVITED no es un error: es «te avisamos»
  // s222 · lote 2a · el menú. ficha: undefined = cargando · null = no se pudo leer · objeto = los 8 campos.
  // pideMenu: el texto de MENU_REQUIRED (Bubble) cuando confirm_offer cortó por falta de menú.
  const [ficha, setFicha] = useState(undefined);
  const [pideMenu, setPideMenu] = useState("");
  const [menuDespues, setMenuDespues] = useState(false);   // s234 · «Lo subo después»
  // s229 · X8: cuántas ofertas propias (creadas por el dueño) se saltaron al confirmar; siguen Pending.
  const [propiasSaltadas, setPropiasSaltadas] = useState(0);
  const [aceptaTerminos, setAceptaTerminos] = useState(false);   // s232 · Términos para negocios aliados

  useEffect(() => {
    let on = true;
    const mid = profile?.merchant_id || profile?._id || profile?.id || "";
    if (mid) leerFicha(mid).then(f => { if (on) setFicha(f); }).catch(() => { if (on) setFicha(null); });
    return () => { on = false; };
  }, [profile]);

  useEffect(() => {
    let on = true;
    (async () => {
      try {
        const todas = await getAllOffers();
        const mid = profile?.merchant_id || profile?._id || profile?.id || "";
        const yo = auth.getUserId();
        // La Data API expone «Created By» con espacio (ver AdminCodes: c["Created By"]).
        const creadaPorOtro = (o) => { const c = o["Created By"]; return !!c && c !== yo; };
        const mias = todas.filter(o => mid && o.merchant_id === mid);
        const pendientes = mias
          // s238 · confirmar-oferta-pct (prueba A): las sembradas en porcentaje (salones y «Hecho a pedido» desde s236-D5 /
          // s237-D3) también se confirman aquí; antes solo pasaba el monto fijo y el panel decía «No vemos una oferta pendiente».
          .filter(o => String(o.status || "").toLowerCase() === "pending" && esFormatoClub(o))
          .filter(o => esInvitado || creadaPorOtro(o))
          .sort((a, b) => new Date(a["Created Date"] || 0) - new Date(b["Created Date"] || 0));
        if (on) { setOferta(pendientes[0] || null); setOtras(pendientes.slice(1)); }
      } catch (e) {
        if (on) setOferta(null);
      }
    })();
    return () => { on = false; };
  }, [profile, esInvitado]);

  const confirmar = async () => {
    if (!oferta) return;
    setEstado("confirmando"); setError("");
    try {
      // s217 · 2bis (export 114): con varias franjas, confirm_offer es una por una y los dos correos salen una
      // sola vez (una llamada SIN skip_emails, las demás con él).
      // s229 · X8 (chequeo de los dos flujos): la Data API no expone «Created By» en Offer (ni al Admin), así
      // que `creadaPorOtro` no distingue nada y, para el Invitado, la lista trae también las ofertas que creó
      // él mismo desde «Crear una oferta». confirm_offer las corta con NOT_SEEDED_OFFER (step 14): antes esa
      // llamada tiraba el error crudo y la sembrada quedaba sin confirmar. Ahora se recorren todas en orden: la
      // primera que pasa va sin skip_emails, las demás con él, y las propias se saltan (siguen Pending y las
      // publica el equipo con approve_offer). Cualquier otro error (MENU_REQUIRED, NOT_INVITED…) corta en la
      // primera llamada como siempre: el catch muestra lo de siempre.
      const confirmadas = [];
      let saltadas = 0;
      for (const o of [oferta, ...otras]) {
        try {
          await confirmOffer(o._id || o.id, { skipEmails: confirmadas.length > 0, termsVersion: TERMINOS_ALIADOS.enviarParam ? TERMINOS_ALIADOS.version : "" });
          confirmadas.push(o);
        } catch (e2) {
          if (String(e2?.code || "") !== "NOT_SEEDED_OFFER") throw e2;
          saltadas += 1;
        }
      }
      if (!confirmadas.length) {
        // Todas son suyas: desde aquí no hay nada sembrado que confirmar.
        setError(en
          ? "You created this offer yourself, so our team publishes it after reviewing your business. Only the offer your advisor prepared is confirmed here."
          : "Esta oferta la creaste tú: la publica el equipo cuando revise tu negocio. Aquí solo se confirma la que te preparó tu asesor.");
        setEstado("");
        return;
      }
      // La tarjeta y la lista de «listo» muestran solo lo confirmado (si la principal era propia, pasa la primera sembrada).
      setOferta(confirmadas[0]);
      setOtras(confirmadas.slice(1));
      setPropiasSaltadas(saltadas);
      setEstado("listo");
    } catch (e) {
      const c = String(e?.code || "");
      // Un mensaje por cada error_code de la sala confirm_offer (+ los dos del canal).
      if (c === "MENU_REQUIRED") {
        // s222 · el interruptor PricingConfig.menu_required está encendido y el comercio no tiene menú. El menú es
        // por comercio: corta en la primera llamada, antes de confirmar ninguna franja. Se abre el paso ahí mismo.
        setPideMenu(e?.message && e.message !== "MENU_REQUIRED" ? e.message
          : (en ? "Before publishing, upload your menu (photo or PDF) or paste the link." : "Antes de publicar, súbenos tu menú (foto o PDF) o pega el link."));
      } else if (c === "NOT_INVITED") {
        // No es un error: Lead / PendingReview siguen por la revisión manual (decisión de Ali, 17/09).
        setAviso(en
          ? "Our team is reviewing your business. We'll email you as soon as it's approved, and your offer goes live then."
          : "El equipo está revisando tu comercio. Te avisamos por correo en cuanto quede aprobado, y ahí tu oferta queda activa.");
      } else {
        const M = {
          // s232 · terminos-condiciones-merchant: cuando Cowork encienda PricingConfig.terms_required (SPEC_s232 §2).
          TERMS_REQUIRED: [en ? "Before publishing, accept the Terms for partner businesses (check the box above)." : "Antes de publicar, acepta los Términos para negocios aliados (marca la casilla de arriba)."],
          OFFER_NOT_FOUND: [en ? "We can't find this offer anymore. Reload the page." : "Ya no encontramos esta oferta. Recarga la página."],
          NOT_OWNER: [en ? "This offer isn't yours." : "Esta oferta no es tuya."],
          OFFER_NOT_PENDING: [en ? "This offer is no longer pending." : "Esta oferta ya no está pendiente."],
          OFFER_BENEFIT_INVALID: [en ? "The offer has no amount. Edit it first." : "La oferta no tiene monto. Edítala primero."],
          OFFER_SIZE_INVALID: [en ? "This offer's amounts don't match our size table. Write to us and we'll fix it with you." : "Los montos de esta oferta no coinciden con nuestra tabla de tamaños. Escríbenos y la ajustamos contigo."],
          NOT_SEEDED_OFFER: [en ? "You created this offer yourself: our team publishes it after reviewing your business." : "Esta oferta la creaste tú: la publica el equipo cuando revise tu negocio."],
          WF_NOT_DEPLOYED: [en ? "Confirming from here isn't available yet. Write to us and we'll activate it." : "Confirmar desde aquí todavía no está disponible. Escríbenos y la activamos."],
          NO_SESSION: [en ? "Your session expired. Sign in again." : "Tu sesión venció. Entra de nuevo."],
        };
        setError((M[c] || [])[0] || e?.message || (en ? "We couldn't confirm it." : "No pudimos confirmarla."));
      }
      setEstado("");
    }
  };

  // Comercio Approved sin una umbral sembrada por otro: el bloque no existe (ni «cargando»).
  if (!esInvitado && !oferta) return null;
  // s238 · pct-barrido: en un % van las reglas del % (sin «el mínimo», con «antes de impuestos y propina»), como en la ficha.
  const reglasConfirmar = oferta
    ? [...(esPorcentaje(oferta) ? reglasPorcentaje : reglasDelRubro)(oferta.category || profile?.category, en, oferta.redemption_channel), reglaPlazo(diasPlazo(oferta), en, oferta.category || profile?.category)]
    : [];
  // s234 · menu-en-dos-pasos: ficha leída y sin menú, o Bubble devolvió MENU_REQUIRED.
  const faltaMenu = !!pideMenu || !!(ficha && !tieneMenu(ficha));
  const esencialConfirmar = oferta
    ? ((en ? (oferta.description_en || oferta.description_es) : (oferta.description_es || oferta.description_en))
      || (en ? (profile?.description_en || profile?.description_es) : (profile?.description_es || profile?.description_en)) || "")
    : "";

  return (
    <section className="mrc-seccion" aria-label={en ? "Confirm your offer" : "Confirma tu oferta"}>
      <div className="mrc-seccion__encabezado">
        <h2 className="mrc-seccion__titulo">{en ? "CONFIRM YOUR OFFER" : "CONFIRMA TU OFERTA"}</h2>
        <span className="mrc-seccion__nota">
          {MEMBRESIA_ABIERTA ? (en ? "One tap and you're live" : "Un toque y quedas activo") : (en ? "One tap and it's ready" : "Un toque y queda lista")}
        </span>
      </div>
      {oferta === undefined ? (
        <p style={{ color: C.muted, fontSize: 14 }}>{en ? "Loading…" : "Cargando…"}</p>
      ) : !oferta ? (
        <p style={{ color: C.gray, fontSize: 14 }}>
          {en ? "We don't see a pending offer for your business. Create one from My Offers." : "No vemos una oferta pendiente para tu negocio. Crea una desde Mis Ofertas."}
        </p>
      ) : (
        <>
        {/* s214 · una línea que le dice qué es esto (ronda 12: «¿confirmo yo o aprueban ustedes?»). */}
        {esInvitado && estado !== "listo" && (
          <p className="mrc-confirmar__bienvenida">
            {en
              ? "We prepared this offer for your business. Review it: you confirm it, or change anything you want."
              : "Te preparamos esta oferta para tu negocio. Revísala: la confirmas tú, o cambias lo que quieras."}
          </p>
        )}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: 20, alignItems: "start" }}>
          <div>
            {/* s214 · con la membresía cerrada, confirmada no es «Activa»: nadie la ve todavía (ronda 12). */}
            {/* s233 · confirmar-nombre-comercio (prueba con Pera Soho): getAllOffers no trae el comercio, así que la
                tarjeta salía con el título («BRUNCH») donde va el nombre del negocio. El nombre y el logo salen del perfil. */}
            <OfferCard variante="catalogo" offer={{ ...oferta, merchant_name: oferta.merchant_name || profile?.business_name || "",
              merchant_logo: oferta.merchant_logo || profile?.logo || "" }} nombreComercio={profile?.business_name} etiqueta={estado === "listo"
              ? (MEMBRESIA_ABIERTA ? (en ? "Active" : "Activa") : (en ? "Ready" : "Lista"))
              : (en ? "Pending" : "Pendiente")} />
            {/* s217 · 2bis: las otras franjas que Otto sembró. El mismo botón las confirma todas. */}
            {otras.length > 0 && (
              <div className="mrc-confirmar__esencial" style={{ marginTop: 12 }}>
                <b>{en ? `And ${otras.length} more for other times` : `Y ${otras.length === 1 ? "1 oferta más" : `${otras.length} ofertas más`} para otros horarios`}</b>
                <ul style={{ margin: "6px 0 0", paddingLeft: 18 }}>
                  {otras.map(o => (
                    <li key={o._id || o.id}>
                      {tituloOfertaVisible({ ...o, title_es: o.title_es || o.title }, false)}
                      {o.valid_time_start && o.valid_time_end ? ` · ${o.valid_time_start}–${o.valid_time_end}` : ""}
                    </li>
                  ))}
                </ul>
                {estado !== "listo" && <small>{en ? "«Confirm my offer» confirms all of them." : "«Confirmar mi oferta» las confirma todas."}</small>}
              </div>
            )}
          </div>
          {/* s201 · C2: la accion va primero y las reglas se pliegan. Antes eran parrafo
              + 7 reglas + boton, y el boton caia fuera de la primera pantalla del telefono en
              cualquier orden del tablero (medido: 1204 / 916 / 1024 de 812).
              s214 · y «Así te presentamos» también baja (order 1): en la columna de la tarjeta empujaba
              «Confirmar mi oferta» al px 777 de 812, detrás de la barra de abajo. */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            {/* s212 · el dueño ve, antes de firmar, lo que se dice de su negocio en la ficha. Se cambia en
                «Quiero cambiar algo» → paso 4 (descripción y destacados). */}
            {/* s213 · la siembra deja la descripción en el comercio, no en la oferta: se cae a esa
                (la misma que muestra la ficha del miembro, ver OfferDetailPage). */}
            {esencialConfirmar && (
              <div className="mrc-confirmar__esencial" style={{ order: 1 }}>
                <b>{en ? "How members will read it" : "Así te presentamos a los miembros"}</b>
                <p>{esencialConfirmar}</p>
                {estado !== "listo" && <small>{en ? "Something not right? Change it in «I want to change something»." : "¿Algo no es así? Cámbialo en «Quiero cambiar algo»."}</small>}
              </div>
            )}
            <details className="mrc-confirmar__reglas" style={{ order: 2 }}>
              {/* s214 · las de SU rubro + la del plazo armada con el de ESTA oferta (ya no son siete para todos). */}
              <summary>{en ? `See the ${reglasConfirmar.length} rules of your offer` : `Ver las ${reglasConfirmar.length} reglas de tu oferta`}</summary>
              <ul>{reglasConfirmar.map((r, i) => <li key={i}>{r}</li>)}</ul>
            </details>
            {estado === "listo" ? (
              <div className="beta__listo" role="status">
                {MEMBRESIA_ABIERTA ? (
                  <>
                    <b>{en ? "Your offer is active" : "Tu oferta está activa"}</b>
                    {en ? "Members can already see you in the catalog." : "Los miembros ya te ven en el catálogo."}
                  </>
                ) : (
                  <>
                    <b>{en ? "Your offer is ready" : "Tu oferta quedó lista"}</b>
                    {en
                      ? "You're in the club. Members will see you the day we open the membership, and we'll let you know before."
                      : "Ya estás en el club. Los miembros te van a ver el día que abramos la membresía, y te avisamos antes."}
                  </>
                )}
                {/* s229 · X8: las que creó el dueño no se confirman aquí; que no crea que quedaron listas. */}
                {propiasSaltadas > 0 && (
                  <small style={{ display: "block", marginTop: 6 }}>
                    {en
                      ? (propiasSaltadas === 1 ? "The offer you created yourself is still under review: our team publishes it." : `The ${propiasSaltadas} offers you created yourself are still under review: our team publishes them.`)
                      : (propiasSaltadas === 1 ? "La oferta que creaste tú sigue en revisión: la publica el equipo." : `Las ${propiasSaltadas} ofertas que creaste tú siguen en revisión: las publica el equipo.`)}
                  </small>
                )}
              </div>
            ) : aviso ? (
              <div className="mrc-aviso" role="status" style={{ borderRadius: 8, border: "1px solid var(--linea)", textAlign: "left" }}>{aviso}</div>
            ) : (
              <>
              {/* s222 · lote 2a · el menú: a la vista si el comercio no tiene (no bloquea mientras el interruptor esté
                  apagado: eso lo decide confirm_offer), y abierto con el texto de Bubble si devolvió MENU_REQUIRED.
                  Al guardarlo después de un MENU_REQUIRED, se reintenta la confirmación.
                  s232 · puerta-menu-usar-mi-pagina: lleva sitioWeb (la web que trajo la consola al sembrar) para el atajo
                  «Usar mi página: dominio», igual que el wizard; sin él, el campo LINK salía vacío y sin atajo. */}
              {/* s234 · menu-en-dos-pasos (Ali): sin menú, la pantalla va en dos pasos. Paso 1 el menú; «Confirmar mi oferta»
                  queda apagado (confirm_offer igual corta con MENU_REQUIRED: PricingConfig.menu_required = sí en Live) y
                  «Lo subo después» dice qué pasa en vez de dejar al dueño trancado. Sin ficha leída no se apaga nada: decide Bubble. */}
              {faltaMenu && menuDespues && (
                <div className="mrc-aviso" role="status" style={{ borderRadius: 8, border: "1px solid var(--linea)", textAlign: "left", marginTop: 12 }}>
                  {en
                    ? "Done: your offer stays saved as it is. It goes live for members once you upload your menu. Come back to this screen (Home) when you have it."
                    : "Listo: tu oferta queda guardada tal como está. Sale a los miembros cuando subas tu menú. Vuelve a esta pantalla (Inicio) cuando lo tengas."}
                  <div style={{ marginTop: 8 }}>
                    <button type="button" className="alta-btn alta-btn--atras" onClick={() => setMenuDespues(false)}>
                      {en ? "Upload it now" : "Subirlo ahora"}
                    </button>
                  </div>
                </div>
              )}
              {faltaMenu && !menuDespues && (
                <div className="alta-etiqueta" style={{ marginTop: 12 }}>{en ? "Step 1 · Your menu" : "Paso 1 · Tu menú"}</div>
              )}
              {faltaMenu && !menuDespues && (
                <MenuDelComercio idBase="confirmar-menu" en={en} categoria={oferta.category || profile?.category} ficha={ficha} sitioWeb={profile?.website}
                  mensaje={pideMenu}
                  onGuardado={async (nueva) => {
                    setFicha(nueva || ficha);
                    if (pideMenu) { setPideMenu(""); await confirmar(); }
                  }} />
              )}
              {/* s233 · menu-web-clara: con menú guardado el bloque se iba sin aviso y el dueño no sabía qué quedó. */}
              {!pideMenu && ficha && tieneMenu(ficha) && (() => {
                const url = String(ficha.menu_url || "").trim();
                const archivo = String(ficha.menu_file || "").trim();
                let dominio = "";
                try { dominio = url ? new URL(url).hostname.replace(/^www\./i, "") : ""; } catch (_) { dominio = url; }
                return (
                  <p className="alta-menu-guardado">
                    <span aria-hidden="true">✓ </span>{etiquetaMenu(oferta.category || profile?.category, en)} {en ? "saved" : "guardado"}:{" "}
                    {url && <a href={url} target="_blank" rel="noopener noreferrer">{dominio} ↗</a>}
                    {url && archivo && " · "}
                    {archivo && <a href={urlMenu(archivo)} target="_blank" rel="noopener noreferrer">{en ? "file" : "archivo"} ↗</a>}
                  </p>
                );
              })()}
              {faltaMenu && (
                <div className="alta-etiqueta" style={{ marginTop: 12 }}>{en ? "Step 2 · Confirm your offer" : "Paso 2 · Confirma tu oferta"}</div>
              )}
              {/* s232 · terminos-condiciones-merchant: la casilla solo si el comercio no aceptó ya la versión vigente
                  (campos terms_version / terms_accepted_at del perfil, SPEC_s232 §1; hasta que existan, siempre se muestra). */}
              {TERMINOS_ALIADOS.exigir && !terminosAceptadosAlDia(profile) && (
                <label className="mrc-confirmar__terminos" style={{ display: "flex", gap: 10, alignItems: "flex-start", margin: "16px 0 4px", fontSize: 14, color: "var(--tinta)", cursor: "pointer", lineHeight: 1.45 }}>
                  <input type="checkbox" checked={aceptaTerminos} onChange={e => setAceptaTerminos(e.target.checked)} style={{ marginTop: 3, width: 18, height: 18 }} />
                  <span>
                    {en ? "I accept the " : "Acepto los "}
                    <a href={TERMINOS_ALIADOS.url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--accion)", fontWeight: 700 }}>
                      {en ? "Terms for partner businesses" : "Términos para negocios aliados"}
                    </a>
                    {en ? " of NXT Reserve. By confirming my offer I accept them on behalf of my business." : " de NXT Reserve. Al confirmar mi oferta los acepto en nombre de mi negocio."}
                  </span>
                </label>
              )}
              <div className="mrc-confirmar__acciones">
                <button type="button" className="alta-btn alta-btn--seguir" onClick={confirmar} disabled={estado === "confirmando" || faltaMenu || (TERMINOS_ALIADOS.exigir && !terminosAceptadosAlDia(profile) && !aceptaTerminos)}>
                  {estado === "confirmando" ? (en ? "Confirming…" : "Confirmando…") : (en ? "Confirm my offer" : "Confirmar mi oferta")}
                </button>
                {/* s199-D9: el dueño no tiene por qué saber que «editar» es lo que quiere; lo
                    que quiere es cambiar algo. La edición que abre va limitada (tamaño estándar
                    sin Destacada, título y fotos) y al guardar vuelve acá. */}
                <button type="button" className="alta-btn alta-btn--atras" onClick={() => navigate(`/merchant/offers/edit/${oferta._id || oferta.id}`)}>
                  {en ? "I want to change something" : "Quiero cambiar algo"}
                </button>
              </div>
              {faltaMenu && !menuDespues && (
                <p style={{ margin: "8px 0 0", fontSize: 13 }}>
                  {en ? "Save your menu first: without it, your offer doesn't go live. " : "Primero guarda tu menú: sin él, tu oferta no sale a los miembros. "}
                  <button type="button" onClick={() => setMenuDespues(true)}
                    style={{ background: "none", border: 0, padding: 0, color: "var(--accion)", textDecoration: "underline", cursor: "pointer", font: "inherit" }}>
                    {en ? "Don't have it at hand? Upload it later" : "¿No lo tienes a mano? Lo subo después"}
                  </button>
                </p>
              )}
              </>
            )}
            {error && <div className="beta__error" role="alert">{error}</div>}
          </div>
        </div>
        </>
      )}
    </section>
  );
}

function ProtectedRoute({ children }) {
  if (!auth.isLoggedIn()) return <Navigate to="/login" replace />;
  // s216 · el empleado no es miembro: sin cuenta, sin cupones, sin «VIP» (lo guarda StaffRoute / el login).
  let rol = "";
  try { rol = localStorage.getItem("nxt_role") || ""; } catch (_) {}
  if (rol === "MerchantStaff") return <Navigate to="/merchant/validar" replace />;
  return <><VolverAConsola />{children}</>;
}

// s217 (Ali) · el operador (y el admin) entra a las vistas de miembro — «Ver el club», «Mi cuenta» — y desde
// ahí no tenía cómo volver a su consola. Franja angosta ARRIBA, en el flujo (abajo, en el teléfono, ya están
// la barra de navegación y la de «Activar oferta»). El rol no siempre queda en localStorage: se confirma con el perfil.
function VolverAConsola() {
  const navigate = useNavigate();
  const en = useLang() === "en";
  const [rol, setRol] = useState(() => { try { return localStorage.getItem("nxt_role") || ""; } catch (e) { return ""; } });
  useEffect(() => {
    let vivo = true;
    if (!rol && auth.isLoggedIn()) getUserProfile().then(p => { if (vivo && p?.role) setRol(p.role); }).catch(() => {});
    return () => { vivo = false; };
  }, [rol]);
  if (rol !== "Operator" && rol !== "Admin") return null;
  const destino = rol === "Admin" ? "/admin" : "/operator/negocios";
  return (
    <div role="navigation" aria-label={en ? "Back to your console" : "Volver a tu consola"}
      style={{ background: C.black, color: C.white, fontSize: 12, padding: "6px 16px", display: "flex", gap: 10, alignItems: "center", justifyContent: "center", flexWrap: "wrap" }}>
      <span style={{ opacity: 0.8 }}>{en ? "You're viewing the club as a member" : "Estás viendo el club como miembro"}</span>
      <button type="button" onClick={() => navigate(destino)}
        style={{ background: "none", border: `1px solid ${C.white}`, color: C.white, borderRadius: 999, padding: "3px 12px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>
        {rol === "Admin" ? (en ? "← Admin panel" : "← Panel de admin") : (en ? "← Sales console" : "← Consola de ventas")}
      </button>
    </div>
  );
}

// ============================================
// EXTERNAL REDIRECT (full-page nav fuera de React Router)
// ============================================
function ExternalRedirect({ to }) {
  useEffect(() => { window.location.replace(to); }, [to]);
  return (
    <div style={{ ...S.page, display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}>
      <div style={{ textAlign: "center" }}>
        <div style={{ ...S.display, fontSize: 24, color: C.red }}>NXT RESERVE</div>
        <div style={{ color: C.muted, marginTop: 8, fontSize: 13 }}>Redirigiendo...</div>
      </div>
    </div>
  );
}

// s201 · front-sin-entorno-dev — DONDE ESTAS ESCRIBIENDO, A LA VISTA. Con dos bases, el
// error caro es creer que estas en una y estar en la otra. Produccion en Live no dibuja
// nada; pruebas (npm start, vistas previas) lleva la etiqueta oscura; Live desde una
// maquina (`npm run start:live`) lleva la roja, porque ahi cada alta es real.
// `pointerEvents: none`: una etiqueta de aviso jamas puede tapar un boton.
function EtiquetaEntorno() {
  const enLiveLocal = BUBBLE_VERSION === "live" && process.env.NODE_ENV !== "production";
  if (BUBBLE_VERSION !== "test" && !enLiveLocal) return null;
  return (
    <div role="note" style={{
      position: "fixed", top: 0, left: "50%", transform: "translateX(-50%)", zIndex: 2147483000,
      pointerEvents: "none", padding: "2px 10px", borderRadius: "0 0 6px 6px",
      fontSize: "var(--t-micro)", fontWeight: 700, letterSpacing: "0.06em", whiteSpace: "nowrap",
      background: enLiveLocal ? "var(--error)" : "var(--tinta)",
      color: enLiveLocal ? "var(--superficie-tarjeta)" : "var(--realce)",
    }}>
      {enLiveLocal ? "LIVE DESDE LOCAL · ESCRIBE EN LA BASE REAL" : "PRUEBAS · version-test"}
    </div>
  );
}

// ============================================
// APP ROOT
// ============================================
export default function App() {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("nxt-lang");
    // Default to Spanish for Miami audience
    return saved || "es";
  });
  const cambiarIdioma = (next) => {
    if (next !== "es" && next !== "en") return;
    setLang(next);
    try { localStorage.setItem("nxt-lang", next); } catch (e) { /* sin localStorage no persiste, pero cambia */ }
  };
  return (
    <LangContext.Provider value={lang}>
      <LangSetContext.Provider value={cambiarIdioma}>
      <ProveedorCupones>
      <ProveedorGuardados>
      <ProveedorClub>
      {/* s183 · acá vivía el selector de idioma: una píldora fija abajo a la derecha
          que flotaba sobre el contenido en las 35 rutas y usaba un gris de la paleta
          vieja. Se mudó a la franja superior, que es donde va una utilidad de este
          tipo. En teléfono, donde no hay franja, vive en Mi Cuenta. */}
      <EtiquetaEntorno />
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/merchant/login" element={<MerchantLoginPage />} />
        <Route path="/merchant/validar" element={<StaffRoute><StaffValidarPage /></StaffRoute>} />
        <Route path="/merchant/signup" element={<MerchantSignupPage />} />
        <Route path="/merchant/dashboard" element={<MerchantRoute><MerchantDashboard /></MerchantRoute>} />
        {/* s186 - el aterrizaje post-alta. Gateado por ATERRIZAJE_HABILITADO: con el
            flag apagado el alta no navega aca y la ruta queda inalcanzable de hecho. */}
        <Route path="/merchant/bienvenida" element={<MerchantRoute><MerchantBienvenida /></MerchantRoute>} />
        {/* s189-D - la pantalla de fuentes, entre el alta y la generacion. Gateada por
            FUENTES_HABILITADA: con el flag apagado el alta no navega aca. */}
        <Route path="/merchant/tu-negocio" element={<MerchantRoute><MerchantTuNegocio /></MerchantRoute>} />
        <Route path="/merchant/offers" element={<MerchantRoute><MerchantOffers /></MerchantRoute>} />
        <Route path="/merchant/offers/new" element={<MerchantRoute><MerchantCreateOffer /></MerchantRoute>} />
        <Route path="/merchant/offers/edit/:id" element={<MerchantRoute><MerchantCreateOffer /></MerchantRoute>} />
        <Route path="/merchant/profile" element={<MerchantRoute><MerchantProfileEdit /></MerchantRoute>} />
        <Route path="/merchant" element={<MerchantRoute><MerchantDashboard /></MerchantRoute>} />
        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/offers" element={<AdminRoute><AdminOffers /></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route path="/admin/merchants" element={<AdminRoute><AdminMerchants /></AdminRoute>} />
        <Route path="/admin/codes" element={<AdminRoute><AdminCodes /></AdminRoute>} />
        <Route path="/admin/influencers" element={<AdminRoute><AdminInfluencers /></AdminRoute>} />
        <Route path="/admin/coupons" element={<AdminRoute><AdminCoupons /></AdminRoute>} />
        <Route path="/admin/descuentos" element={<AdminRoute><AdminDiscounts /></AdminRoute>} />
        <Route path="/admin/assistant" element={<AdminRoute><AdminAssistant /></AdminRoute>} />
        <Route path="/admin/tools" element={<AdminRoute><AdminTools /></AdminRoute>} />
        <Route path="/operator" element={<OperatorRoute><OperatorConsole /></OperatorRoute>} />
        {/* s195 · panel de siembra de la vitrina beta (Otto): rol Operator o Admin */}
        <Route path="/operator/vitrina" element={<OperatorRoute><OperatorVitrina /></OperatorRoute>} />
        <Route path="/operator/negocios" element={<OperatorRoute><OperatorVitrina vista="negocios" /></OperatorRoute>} />
        {/* s219 · /aliados en vez de /influencer (Ali): quien trae socios no siempre es influencer.
            Las rutas viejas redirigen para no romper enlaces ya compartidos. */}
        <Route path="/aliados" element={<InfluencerRoute><AliadoPanel /></InfluencerRoute>} />
        {/* s218 · el prototipo con datos de ejemplo: SIN login a propósito, Otto lo muestra en su teléfono. */}
        <Route path="/aliados/demo" element={<InfluencerDemo />} />
        <Route path="/influencer" element={<Navigate to="/aliados" replace />} />
        <Route path="/influencer/demo" element={<Navigate to="/aliados/demo" replace />} />
        {/* s195 · la vitrina beta: SIN login a propósito (s194-D21). El token en la URL es la llave. */}
        <Route path="/beta" element={<BetaVitrinaPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/" element={<ProtectedRoute><PuertaCatalogo><HomePage /></PuertaCatalogo></ProtectedRoute>} />
        <Route path="/offer/:id" element={<ProtectedRoute><PuertaFicha><OfferDetailPage /></PuertaFicha></ProtectedRoute>} />
        <Route path="/merchants" element={<ProtectedRoute><PuertaCatalogo><MerchantsDirectoryPage /></PuertaCatalogo></ProtectedRoute>} />
        {/* s120 F1 vitrina (dictamen Fable): /m/:id PUBLICO noindex link-only; fase 2 al trigger de 8 merchants */}
        <Route path="/m/:id" element={<PuertaFicha esComercio><MerchantPublicPage /></PuertaFicha>} />
        {/* s186 - la puerta del canal influencer. PUBLICA a proposito: la persona
            llega desde el link de la influencer sin cuenta y sin sesion. Va antes
            del catch-all, y no la envuelve ProtectedRoute. */}
        <Route path="/i/:codigo" element={<InfluencerLandingPage />} />
        <Route path="/my-coupons" element={<ProtectedRoute><MyCouponsPage /></ProtectedRoute>} />
        <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
        <Route path="/mi-lista" element={<ProtectedRoute><PuertaCatalogo><MiListaPage /></PuertaCatalogo></ProtectedRoute>} />
        <Route path="/join/:token" element={<ProtectedRoute><MembershipJoinPage /></ProtectedRoute>} />
        <Route path="/viajes" element={<ViajesPage />} />
        <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
        <Route path="/beneficios" element={<ProtectedRoute><PuertaCatalogo><BenefitsPreviewPage /></PuertaCatalogo></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </ProveedorClub>
      </ProveedorGuardados>
      </ProveedorCupones>
      </LangSetContext.Provider>
    </LangContext.Provider>
  );
}

// s239 · verificacion-interna-capa-1 (PROPUESTA_s238_verificacion_interna.md): las reglas puras se exportan SOLO para
// las pruebas de src/reglasOferta.test.js (rubro × formato). No cambia nada en la app: nadie más las importa.
export {
  esUmbral, esPorcentaje, esFormatoClub, tituloOfertaVisible, textoValorOferta, tituloPorcentaje, fraseUmbral,
  reglasDelRubro, reglasPorcentaje, REGLA_MINIMO, REGLA_PCT_BASE, etiquetaMenu, plataformaDeWeb, filaEnPorcentaje,
  coincideBusqueda, RUBROS_PCT_RECOMENDADO, CAT_DISPLAY, TOPE_SIN_LIMITE, UMBRAL_TAMANOS, esTituloUmbralGenerado, tituloContradiceMonto,
  sugerirTamanoUmbral, desvioDeTabla, tamanosDelRubro,
  esTituloPorcentajeGenerado,
  // s239 · lote D (auditoría s237 D1–D7)
  recomendarFormato, formatoPrimeraOferta, PRIMERA_CON_MONTO_FIJO, PCT_PRIMERA, ALCANCE_SOLO_COMIDA, logoEsClaro, primerLogoQueBaja, ciudadDeDireccionEscrita, alcanceDeLaOferta, serviciosDeLaWeb, etiquetaPlazo, reglaPlazo, esReglaPlazoArmada, fraseAlcance, corregirAlcance, conFraseAlcance, momentosDelRubro,
  franjaEnHorario, ticketAlRecomendar, SignupPage, AccountPage, ViajesPage, OnboardingPage, MembershipJoinPage, momentoEnTitulo, MOMENTOS_OTROS,   // s252
  FRANJAS_OFERTA, isBestDealOffer, REGLA_ALCOHOL, ALCANCE_SIN_ALCOHOL,
  cuandoValeCorto, contarPendientes, UMBRAL_FRANJAS, MOMENTOS_POR_RUBRO,
  CUPON_DIAS_POR_RUBRO, CUPON_DIAS_SIN_RUBRO, cuponDuraDias, TERMINOS_SOCIO_CUPONES, avisoDelCupon, MOTIVOS_AVISO_CUPON, CouponCard,
  ofertaDeIntro, linkLeible, respuestasWizard, borradorTrabajado, advisorErrorMessage, esEncargo, planesDelRubro,
  OfferDetailPage, MerchantOffers, MerchantConfirmarOferta, MerchantCreateOffer, OperatorVitrina, MerchantDashboard,
  WizardPrimeraOferta, horarioDeGoogle, placeHoursToAppHours, tiposGoogleParaIa, busquedaWebNegocio, AVISO_SIN_WEB, OfferCard, TarjetaCerrada, MerchantPublicPage, guessTaxonomyFromPlaceTypes, rubroDeOutscraper, esPlataforma, nombrePlataforma, correoEsCorporativoDe, PERFIL_POR_FAMILIA, EXCLUSIONES_WIZARD, OBJETIVOS_WIZARD,
  tamanosDelAsesor, esRubroPctAsesor,   // s244-D7 · los números del asesor (pruebas)
  VerificarCorreo,   // s254 · I7: el código en casillas (pruebas)
};
